module.exports =
/******/
function (modules) {
  // webpackBootstrap

  /******/
  // The module cache

  /******/
  var installedModules = {};
  /******/

  /******/
  // The require function

  /******/

  function __webpack_require__(moduleId) {
    /******/

    /******/
    // Check if module is in cache

    /******/
    if (installedModules[moduleId]) {
      /******/
      return installedModules[moduleId].exports;
      /******/
    }
    /******/
    // Create a new module (and put it into the cache)

    /******/


    var module = installedModules[moduleId] = {
      /******/
      i: moduleId,

      /******/
      l: false,

      /******/
      exports: {}
      /******/

    };
    /******/

    /******/
    // Execute the module function

    /******/

    modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/

    /******/
    // Flag the module as loaded

    /******/

    module.l = true;
    /******/

    /******/
    // Return the exports of the module

    /******/

    return module.exports;
    /******/
  }
  /******/

  /******/

  /******/
  // expose the modules object (__webpack_modules__)

  /******/


  __webpack_require__.m = modules;
  /******/

  /******/
  // expose the module cache

  /******/

  __webpack_require__.c = installedModules;
  /******/

  /******/
  // identity function for calling harmony imports with the correct context

  /******/

  __webpack_require__.i = function (value) {
    return value;
  };
  /******/

  /******/
  // define getter function for harmony exports

  /******/


  __webpack_require__.d = function (exports, name, getter) {
    /******/
    if (!__webpack_require__.o(exports, name)) {
      /******/
      Object.defineProperty(exports, name, {
        /******/
        configurable: false,

        /******/
        enumerable: true,

        /******/
        get: getter
        /******/

      });
      /******/
    }
    /******/

  };
  /******/

  /******/
  // getDefaultExport function for compatibility with non-harmony modules

  /******/


  __webpack_require__.n = function (module) {
    /******/
    var getter = module && module.__esModule ?
    /******/
    function getDefault() {
      return module['default'];
    } :
    /******/
    function getModuleExports() {
      return module;
    };
    /******/

    __webpack_require__.d(getter, 'a', getter);
    /******/


    return getter;
    /******/
  };
  /******/

  /******/
  // Object.prototype.hasOwnProperty.call

  /******/


  __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/

  /******/
  // __webpack_public_path__

  /******/


  __webpack_require__.p = "";
  /******/

  /******/
  // Load entry module and return exports

  /******/

  return __webpack_require__(__webpack_require__.s = 307);
  /******/
}
/************************************************************************/

/******/
([
/* 0 */

/***/
function (module, exports, __webpack_require__) {
  var global = __webpack_require__(1);

  var getOwnPropertyDescriptor = __webpack_require__(32).f;

  var createNonEnumerableProperty = __webpack_require__(35);

  var redefine = __webpack_require__(24);

  var setGlobal = __webpack_require__(163);

  var copyConstructorProperties = __webpack_require__(113);

  var isForced = __webpack_require__(93);
  /*
    options.target      - name of the target object
    options.global      - target is the global object
    options.stat        - export as static methods of target
    options.proto       - export as prototype methods of target
    options.real        - real prototype method for the `pure` version
    options.forced      - export even if the native feature is available
    options.bind        - bind methods to the target, required for the `pure` version
    options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
    options.unsafe      - use the simple assignment of property instead of delete + defineProperty
    options.sham        - add a flag to not completely full polyfills
    options.enumerable  - export as enumerable property
    options.noTargetGet - prevent calling a getter on target
    options.name        - the .name of the function if it does not match the key
  */


  module.exports = function (options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;

    if (GLOBAL) {
      target = global;
    } else if (STATIC) {
      target = global[TARGET] || setGlobal(TARGET, {});
    } else {
      target = (global[TARGET] || {}).prototype;
    }

    if (target) for (key in source) {
      sourceProperty = source[key];

      if (options.noTargetGet) {
        descriptor = getOwnPropertyDescriptor(target, key);
        targetProperty = descriptor && descriptor.value;
      } else targetProperty = target[key];

      FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced); // contained in target

      if (!FORCED && targetProperty !== undefined) {
        if (typeof sourceProperty == typeof targetProperty) continue;
        copyConstructorProperties(sourceProperty, targetProperty);
      } // add a flag to not completely full polyfills


      if (options.sham || targetProperty && targetProperty.sham) {
        createNonEnumerableProperty(sourceProperty, 'sham', true);
      } // extend global


      redefine(target, key, sourceProperty, options);
    }
  };
  /***/

},
/* 1 */

/***/
function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */
  (function (global) {
    var check = function check(it) {
      return it && it.Math == Math && it;
    }; // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028


    module.exports = // eslint-disable-next-line es/no-global-this -- safe
    check(typeof globalThis == 'object' && globalThis) || check(typeof window == 'object' && window) || // eslint-disable-next-line no-restricted-globals -- safe
    check(typeof self == 'object' && self) || check(typeof global == 'object' && global) || // eslint-disable-next-line no-new-func -- fallback
    function () {
      return this;
    }() || Function('return this')();
    /* WEBPACK VAR INJECTION */

  }).call(exports, __webpack_require__(342));
  /***/
},
/* 2 */

/***/
function (module, exports) {
  module.exports = function (exec) {
    try {
      return !!exec();
    } catch (error) {
      return true;
    }
  };
  /***/

},
/* 3 */

/***/
function (module, exports, __webpack_require__) {
  var NATIVE_BIND = __webpack_require__(89);

  var FunctionPrototype = Function.prototype;
  var bind = FunctionPrototype.bind;
  var call = FunctionPrototype.call;
  var uncurryThis = NATIVE_BIND && bind.bind(call, call);
  module.exports = NATIVE_BIND ? function (fn) {
    return fn && uncurryThis(fn);
  } : function (fn) {
    return fn && function () {
      return call.apply(fn, arguments);
    };
  };
  /***/
},
/* 4 */

/***/
function (module, exports) {
  module.exports = require("react");
  /***/
},
/* 5 */

/***/
function (module, exports) {
  function _extends() {
    module.exports = _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    module.exports["default"] = module.exports, module.exports.__esModule = true;
    return _extends.apply(this, arguments);
  }

  module.exports = _extends;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
  /***/
},
/* 6 */

/***/
function (module, exports, __webpack_require__) {
  var objectWithoutPropertiesLoose = __webpack_require__(282);

  function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = objectWithoutPropertiesLoose(source, excluded);
    var key, i;

    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }

    return target;
  }

  module.exports = _objectWithoutProperties;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
  /***/
},
/* 7 */

/***/
function (module, exports) {
  module.exports = require("@tal-gel/core");
  /***/
},
/* 8 */

/***/
function (module, exports) {
  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  module.exports = _defineProperty;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
  /***/
},
/* 9 */

/***/
function (module, exports, __webpack_require__) {
  var arrayWithHoles = __webpack_require__(276);

  var iterableToArrayLimit = __webpack_require__(279);

  var unsupportedIterableToArray = __webpack_require__(183);

  var nonIterableRest = __webpack_require__(280);

  function _slicedToArray(arr, i) {
    return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
  }

  module.exports = _slicedToArray;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
  /***/
},
/* 10 */

/***/
function (module, exports, __webpack_require__) {
  var global = __webpack_require__(1);

  var isObject = __webpack_require__(13);

  var String = global.String;
  var TypeError = global.TypeError; // `Assert: Type(argument) is Object`

  module.exports = function (argument) {
    if (isObject(argument)) return argument;
    throw TypeError(String(argument) + ' is not an object');
  };
  /***/

},
/* 11 */

/***/
function (module, exports) {
  module.exports = require("@tal-gel/theming");
  /***/
},
/* 12 */

/***/
function (module, exports, __webpack_require__) {
  var fails = __webpack_require__(2); // Detect IE8's incomplete defineProperty implementation


  module.exports = !fails(function () {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
      get: function get() {
        return 7;
      }
    })[1] != 7;
  });
  /***/
},
/* 13 */

/***/
function (module, exports, __webpack_require__) {
  var isCallable = __webpack_require__(17);

  module.exports = function (it) {
    return typeof it == 'object' ? it !== null : isCallable(it);
  };
  /***/

},
/* 14 */

/***/
function (module, exports) {
  module.exports = require("@emotion/styled");
  /***/
},
/* 15 */

/***/
function (module, exports, __webpack_require__) {
  var global = __webpack_require__(1);

  var shared = __webpack_require__(126);

  var hasOwn = __webpack_require__(21);

  var uid = __webpack_require__(82);

  var NATIVE_SYMBOL = __webpack_require__(156);

  var USE_SYMBOL_AS_UID = __webpack_require__(235);

  var WellKnownSymbolsStore = shared('wks');
  var Symbol = global.Symbol;
  var symbolFor = Symbol && Symbol['for'];
  var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol : Symbol && Symbol.withoutSetter || uid;

  module.exports = function (name) {
    if (!hasOwn(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == 'string')) {
      var description = 'Symbol.' + name;

      if (NATIVE_SYMBOL && hasOwn(Symbol, name)) {
        WellKnownSymbolsStore[name] = Symbol[name];
      } else if (USE_SYMBOL_AS_UID && symbolFor) {
        WellKnownSymbolsStore[name] = symbolFor(description);
      } else {
        WellKnownSymbolsStore[name] = createWellKnownSymbol(description);
      }
    }

    return WellKnownSymbolsStore[name];
  };
  /***/

},
/* 16 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var NATIVE_ARRAY_BUFFER = __webpack_require__(142);

  var DESCRIPTORS = __webpack_require__(12);

  var global = __webpack_require__(1);

  var isCallable = __webpack_require__(17);

  var isObject = __webpack_require__(13);

  var hasOwn = __webpack_require__(21);

  var classof = __webpack_require__(63);

  var tryToString = __webpack_require__(100);

  var createNonEnumerableProperty = __webpack_require__(35);

  var redefine = __webpack_require__(24);

  var defineProperty = __webpack_require__(20).f;

  var isPrototypeOf = __webpack_require__(42);

  var getPrototypeOf = __webpack_require__(48);

  var setPrototypeOf = __webpack_require__(52);

  var wellKnownSymbol = __webpack_require__(15);

  var uid = __webpack_require__(82);

  var Int8Array = global.Int8Array;
  var Int8ArrayPrototype = Int8Array && Int8Array.prototype;
  var Uint8ClampedArray = global.Uint8ClampedArray;
  var Uint8ClampedArrayPrototype = Uint8ClampedArray && Uint8ClampedArray.prototype;
  var TypedArray = Int8Array && getPrototypeOf(Int8Array);
  var TypedArrayPrototype = Int8ArrayPrototype && getPrototypeOf(Int8ArrayPrototype);
  var ObjectPrototype = Object.prototype;
  var TypeError = global.TypeError;
  var TO_STRING_TAG = wellKnownSymbol('toStringTag');
  var TYPED_ARRAY_TAG = uid('TYPED_ARRAY_TAG');
  var TYPED_ARRAY_CONSTRUCTOR = uid('TYPED_ARRAY_CONSTRUCTOR'); // Fixing native typed arrays in Opera Presto crashes the browser, see #595

  var NATIVE_ARRAY_BUFFER_VIEWS = NATIVE_ARRAY_BUFFER && !!setPrototypeOf && classof(global.opera) !== 'Opera';
  var TYPED_ARRAY_TAG_REQUIRED = false;
  var NAME, Constructor, Prototype;
  var TypedArrayConstructorsList = {
    Int8Array: 1,
    Uint8Array: 1,
    Uint8ClampedArray: 1,
    Int16Array: 2,
    Uint16Array: 2,
    Int32Array: 4,
    Uint32Array: 4,
    Float32Array: 4,
    Float64Array: 8
  };
  var BigIntArrayConstructorsList = {
    BigInt64Array: 8,
    BigUint64Array: 8
  };

  var isView = function isView(it) {
    if (!isObject(it)) return false;
    var klass = classof(it);
    return klass === 'DataView' || hasOwn(TypedArrayConstructorsList, klass) || hasOwn(BigIntArrayConstructorsList, klass);
  };

  var isTypedArray = function isTypedArray(it) {
    if (!isObject(it)) return false;
    var klass = classof(it);
    return hasOwn(TypedArrayConstructorsList, klass) || hasOwn(BigIntArrayConstructorsList, klass);
  };

  var aTypedArray = function aTypedArray(it) {
    if (isTypedArray(it)) return it;
    throw TypeError('Target is not a typed array');
  };

  var aTypedArrayConstructor = function aTypedArrayConstructor(C) {
    if (isCallable(C) && (!setPrototypeOf || isPrototypeOf(TypedArray, C))) return C;
    throw TypeError(tryToString(C) + ' is not a typed array constructor');
  };

  var exportTypedArrayMethod = function exportTypedArrayMethod(KEY, property, forced, options) {
    if (!DESCRIPTORS) return;
    if (forced) for (var ARRAY in TypedArrayConstructorsList) {
      var TypedArrayConstructor = global[ARRAY];
      if (TypedArrayConstructor && hasOwn(TypedArrayConstructor.prototype, KEY)) try {
        delete TypedArrayConstructor.prototype[KEY];
      } catch (error) {
        // old WebKit bug - some methods are non-configurable
        try {
          TypedArrayConstructor.prototype[KEY] = property;
        } catch (error2) {
          /* empty */
        }
      }
    }

    if (!TypedArrayPrototype[KEY] || forced) {
      redefine(TypedArrayPrototype, KEY, forced ? property : NATIVE_ARRAY_BUFFER_VIEWS && Int8ArrayPrototype[KEY] || property, options);
    }
  };

  var exportTypedArrayStaticMethod = function exportTypedArrayStaticMethod(KEY, property, forced) {
    var ARRAY, TypedArrayConstructor;
    if (!DESCRIPTORS) return;

    if (setPrototypeOf) {
      if (forced) for (ARRAY in TypedArrayConstructorsList) {
        TypedArrayConstructor = global[ARRAY];
        if (TypedArrayConstructor && hasOwn(TypedArrayConstructor, KEY)) try {
          delete TypedArrayConstructor[KEY];
        } catch (error) {
          /* empty */
        }
      }

      if (!TypedArray[KEY] || forced) {
        // V8 ~ Chrome 49-50 `%TypedArray%` methods are non-writable non-configurable
        try {
          return redefine(TypedArray, KEY, forced ? property : NATIVE_ARRAY_BUFFER_VIEWS && TypedArray[KEY] || property);
        } catch (error) {
          /* empty */
        }
      } else return;
    }

    for (ARRAY in TypedArrayConstructorsList) {
      TypedArrayConstructor = global[ARRAY];

      if (TypedArrayConstructor && (!TypedArrayConstructor[KEY] || forced)) {
        redefine(TypedArrayConstructor, KEY, property);
      }
    }
  };

  for (NAME in TypedArrayConstructorsList) {
    Constructor = global[NAME];
    Prototype = Constructor && Constructor.prototype;
    if (Prototype) createNonEnumerableProperty(Prototype, TYPED_ARRAY_CONSTRUCTOR, Constructor);else NATIVE_ARRAY_BUFFER_VIEWS = false;
  }

  for (NAME in BigIntArrayConstructorsList) {
    Constructor = global[NAME];
    Prototype = Constructor && Constructor.prototype;
    if (Prototype) createNonEnumerableProperty(Prototype, TYPED_ARRAY_CONSTRUCTOR, Constructor);
  } // WebKit bug - typed arrays constructors prototype is Object.prototype


  if (!NATIVE_ARRAY_BUFFER_VIEWS || !isCallable(TypedArray) || TypedArray === Function.prototype) {
    // eslint-disable-next-line no-shadow -- safe
    TypedArray = function TypedArray() {
      throw TypeError('Incorrect invocation');
    };

    if (NATIVE_ARRAY_BUFFER_VIEWS) for (NAME in TypedArrayConstructorsList) {
      if (global[NAME]) setPrototypeOf(global[NAME], TypedArray);
    }
  }

  if (!NATIVE_ARRAY_BUFFER_VIEWS || !TypedArrayPrototype || TypedArrayPrototype === ObjectPrototype) {
    TypedArrayPrototype = TypedArray.prototype;
    if (NATIVE_ARRAY_BUFFER_VIEWS) for (NAME in TypedArrayConstructorsList) {
      if (global[NAME]) setPrototypeOf(global[NAME].prototype, TypedArrayPrototype);
    }
  } // WebKit bug - one more object in Uint8ClampedArray prototype chain


  if (NATIVE_ARRAY_BUFFER_VIEWS && getPrototypeOf(Uint8ClampedArrayPrototype) !== TypedArrayPrototype) {
    setPrototypeOf(Uint8ClampedArrayPrototype, TypedArrayPrototype);
  }

  if (DESCRIPTORS && !hasOwn(TypedArrayPrototype, TO_STRING_TAG)) {
    TYPED_ARRAY_TAG_REQUIRED = true;
    defineProperty(TypedArrayPrototype, TO_STRING_TAG, {
      get: function get() {
        return isObject(this) ? this[TYPED_ARRAY_TAG] : undefined;
      }
    });

    for (NAME in TypedArrayConstructorsList) {
      if (global[NAME]) {
        createNonEnumerableProperty(global[NAME], TYPED_ARRAY_TAG, NAME);
      }
    }
  }

  module.exports = {
    NATIVE_ARRAY_BUFFER_VIEWS: NATIVE_ARRAY_BUFFER_VIEWS,
    TYPED_ARRAY_CONSTRUCTOR: TYPED_ARRAY_CONSTRUCTOR,
    TYPED_ARRAY_TAG: TYPED_ARRAY_TAG_REQUIRED && TYPED_ARRAY_TAG,
    aTypedArray: aTypedArray,
    aTypedArrayConstructor: aTypedArrayConstructor,
    exportTypedArrayMethod: exportTypedArrayMethod,
    exportTypedArrayStaticMethod: exportTypedArrayStaticMethod,
    isView: isView,
    isTypedArray: isTypedArray,
    TypedArray: TypedArray,
    TypedArrayPrototype: TypedArrayPrototype
  };
  /***/
},
/* 17 */

/***/
function (module, exports) {
  // `IsCallable` abstract operation
  // https://tc39.es/ecma262/#sec-iscallable
  module.exports = function (argument) {
    return typeof argument == 'function';
  };
  /***/

},
/* 18 */

/***/
function (module, exports, __webpack_require__) {
  var global = __webpack_require__(1);

  var classof = __webpack_require__(63);

  var String = global.String;

  module.exports = function (argument) {
    if (classof(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
    return String(argument);
  };
  /***/

},
/* 19 */

/***/
function (module, exports, __webpack_require__) {
  var NATIVE_BIND = __webpack_require__(89);

  var call = Function.prototype.call;
  module.exports = NATIVE_BIND ? call.bind(call) : function () {
    return call.apply(call, arguments);
  };
  /***/
},
/* 20 */

/***/
function (module, exports, __webpack_require__) {
  var global = __webpack_require__(1);

  var DESCRIPTORS = __webpack_require__(12);

  var IE8_DOM_DEFINE = __webpack_require__(210);

  var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__(236);

  var anObject = __webpack_require__(10);

  var toPropertyKey = __webpack_require__(66);

  var TypeError = global.TypeError; // eslint-disable-next-line es/no-object-defineproperty -- safe

  var $defineProperty = Object.defineProperty; // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe

  var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
  var ENUMERABLE = 'enumerable';
  var CONFIGURABLE = 'configurable';
  var WRITABLE = 'writable'; // `Object.defineProperty` method
  // https://tc39.es/ecma262/#sec-object.defineproperty

  exports.f = DESCRIPTORS ? V8_PROTOTYPE_DEFINE_BUG ? function defineProperty(O, P, Attributes) {
    anObject(O);
    P = toPropertyKey(P);
    anObject(Attributes);

    if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
      var current = $getOwnPropertyDescriptor(O, P);

      if (current && current[WRITABLE]) {
        O[P] = Attributes.value;
        Attributes = {
          configurable: CONFIGURABLE in Attributes ? Attributes[CONFIGURABLE] : current[CONFIGURABLE],
          enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
          writable: false
        };
      }
    }

    return $defineProperty(O, P, Attributes);
  } : $defineProperty : function defineProperty(O, P, Attributes) {
    anObject(O);
    P = toPropertyKey(P);
    anObject(Attributes);
    if (IE8_DOM_DEFINE) try {
      return $defineProperty(O, P, Attributes);
    } catch (error) {
      /* empty */
    }
    if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
    if ('value' in Attributes) O[P] = Attributes.value;
    return O;
  };
  /***/
},
/* 21 */

/***/
function (module, exports, __webpack_require__) {
  var uncurryThis = __webpack_require__(3);

  var toObject = __webpack_require__(22);

  var hasOwnProperty = uncurryThis({}.hasOwnProperty); // `HasOwnProperty` abstract operation
  // https://tc39.es/ecma262/#sec-hasownproperty

  module.exports = Object.hasOwn || function hasOwn(it, key) {
    return hasOwnProperty(toObject(it), key);
  };
  /***/

},
/* 22 */

/***/
function (module, exports, __webpack_require__) {
  var global = __webpack_require__(1);

  var requireObjectCoercible = __webpack_require__(28);

  var Object = global.Object; // `ToObject` abstract operation
  // https://tc39.es/ecma262/#sec-toobject

  module.exports = function (argument) {
    return Object(requireObjectCoercible(argument));
  };
  /***/

},
/* 23 */

/***/
function (module, exports, __webpack_require__) {
  var toLength = __webpack_require__(44); // `LengthOfArrayLike` abstract operation
  // https://tc39.es/ecma262/#sec-lengthofarraylike


  module.exports = function (obj) {
    return toLength(obj.length);
  };
  /***/

},
/* 24 */

/***/
function (module, exports, __webpack_require__) {
  var global = __webpack_require__(1);

  var isCallable = __webpack_require__(17);

  var hasOwn = __webpack_require__(21);

  var createNonEnumerableProperty = __webpack_require__(35);

  var setGlobal = __webpack_require__(163);

  var inspectSource = __webpack_require__(117);

  var InternalStateModule = __webpack_require__(27);

  var CONFIGURABLE_FUNCTION_NAME = __webpack_require__(74).CONFIGURABLE;

  var getInternalState = InternalStateModule.get;
  var enforceInternalState = InternalStateModule.enforce;
  var TEMPLATE = String(String).split('String');
  (module.exports = function (O, key, value, options) {
    var unsafe = options ? !!options.unsafe : false;
    var simple = options ? !!options.enumerable : false;
    var noTargetGet = options ? !!options.noTargetGet : false;
    var name = options && options.name !== undefined ? options.name : key;
    var state;

    if (isCallable(value)) {
      if (String(name).slice(0, 7) === 'Symbol(') {
        name = '[' + String(name).replace(/^Symbol\(([^)]*)\)/, '$1') + ']';
      }

      if (!hasOwn(value, 'name') || CONFIGURABLE_FUNCTION_NAME && value.name !== name) {
        createNonEnumerableProperty(value, 'name', name);
      }

      state = enforceInternalState(value);

      if (!state.source) {
        state.source = TEMPLATE.join(typeof name == 'string' ? name : '');
      }
    }

    if (O === global) {
      if (simple) O[key] = value;else setGlobal(key, value);
      return;
    } else if (!unsafe) {
      delete O[key];
    } else if (!noTargetGet && O[key]) {
      simple = true;
    }

    if (simple) O[key] = value;else createNonEnumerableProperty(O, key, value); // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
  })(Function.prototype, 'toString', function toString() {
    return isCallable(this) && getInternalState(this).source || inspectSource(this);
  });
  /***/
},
/* 25 */

/***/
function (module, exports) {
  // shim for using process in browser
  var process = module.exports = {}; // cached from whatever global is present so that test runners that stub it
  // don't break things.  But we need to wrap it in a try catch in case it is
  // wrapped in strict mode code which doesn't define any globals.  It's inside a
  // function because try/catches deoptimize in certain engines.

  var cachedSetTimeout;
  var cachedClearTimeout;

  function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
  }

  function defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
  }

  (function () {
    try {
      if (typeof setTimeout === 'function') {
        cachedSetTimeout = setTimeout;
      } else {
        cachedSetTimeout = defaultSetTimout;
      }
    } catch (e) {
      cachedSetTimeout = defaultSetTimout;
    }

    try {
      if (typeof clearTimeout === 'function') {
        cachedClearTimeout = clearTimeout;
      } else {
        cachedClearTimeout = defaultClearTimeout;
      }
    } catch (e) {
      cachedClearTimeout = defaultClearTimeout;
    }
  })();

  function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
      //normal enviroments in sane situations
      return setTimeout(fun, 0);
    } // if setTimeout wasn't available but was latter defined


    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
      cachedSetTimeout = setTimeout;
      return setTimeout(fun, 0);
    }

    try {
      // when when somebody has screwed with setTimeout but no I.E. maddness
      return cachedSetTimeout(fun, 0);
    } catch (e) {
      try {
        // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
        return cachedSetTimeout.call(null, fun, 0);
      } catch (e) {
        // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
        return cachedSetTimeout.call(this, fun, 0);
      }
    }
  }

  function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
      //normal enviroments in sane situations
      return clearTimeout(marker);
    } // if clearTimeout wasn't available but was latter defined


    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
      cachedClearTimeout = clearTimeout;
      return clearTimeout(marker);
    }

    try {
      // when when somebody has screwed with setTimeout but no I.E. maddness
      return cachedClearTimeout(marker);
    } catch (e) {
      try {
        // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
        return cachedClearTimeout.call(null, marker);
      } catch (e) {
        // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
        // Some versions of I.E. have different rules for clearTimeout vs setTimeout
        return cachedClearTimeout.call(this, marker);
      }
    }
  }

  var queue = [];
  var draining = false;
  var currentQueue;
  var queueIndex = -1;

  function cleanUpNextTick() {
    if (!draining || !currentQueue) {
      return;
    }

    draining = false;

    if (currentQueue.length) {
      queue = currentQueue.concat(queue);
    } else {
      queueIndex = -1;
    }

    if (queue.length) {
      drainQueue();
    }
  }

  function drainQueue() {
    if (draining) {
      return;
    }

    var timeout = runTimeout(cleanUpNextTick);
    draining = true;
    var len = queue.length;

    while (len) {
      currentQueue = queue;
      queue = [];

      while (++queueIndex < len) {
        if (currentQueue) {
          currentQueue[queueIndex].run();
        }
      }

      queueIndex = -1;
      len = queue.length;
    }

    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
  }

  process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);

    if (arguments.length > 1) {
      for (var i = 1; i < arguments.length; i++) {
        args[i - 1] = arguments[i];
      }
    }

    queue.push(new Item(fun, args));

    if (queue.length === 1 && !draining) {
      runTimeout(drainQueue);
    }
  }; // v8 likes predictible objects


  function Item(fun, array) {
    this.fun = fun;
    this.array = array;
  }

  Item.prototype.run = function () {
    this.fun.apply(null, this.array);
  };

  process.title = 'browser';
  process.browser = true;
  process.env = {};
  process.argv = [];
  process.version = ''; // empty string to avoid regexp issues

  process.versions = {};

  function noop() {}

  process.on = noop;
  process.addListener = noop;
  process.once = noop;
  process.off = noop;
  process.removeListener = noop;
  process.removeAllListeners = noop;
  process.emit = noop;
  process.prependListener = noop;
  process.prependOnceListener = noop;

  process.listeners = function (name) {
    return [];
  };

  process.binding = function (name) {
    throw new Error('process.binding is not supported');
  };

  process.cwd = function () {
    return '/';
  };

  process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
  };

  process.umask = function () {
    return 0;
  };
  /***/

},
/* 26 */

/***/
function (module, exports, __webpack_require__) {
  var global = __webpack_require__(1);

  var isCallable = __webpack_require__(17);

  var aFunction = function aFunction(argument) {
    return isCallable(argument) ? argument : undefined;
  };

  module.exports = function (namespace, method) {
    return arguments.length < 2 ? aFunction(global[namespace]) : global[namespace] && global[namespace][method];
  };
  /***/

},
/* 27 */

/***/
function (module, exports, __webpack_require__) {
  var NATIVE_WEAK_MAP = __webpack_require__(220);

  var global = __webpack_require__(1);

  var uncurryThis = __webpack_require__(3);

  var isObject = __webpack_require__(13);

  var createNonEnumerableProperty = __webpack_require__(35);

  var hasOwn = __webpack_require__(21);

  var shared = __webpack_require__(164);

  var sharedKey = __webpack_require__(125);

  var hiddenKeys = __webpack_require__(91);

  var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
  var TypeError = global.TypeError;
  var WeakMap = global.WeakMap;
  var set, get, has;

  var enforce = function enforce(it) {
    return has(it) ? get(it) : set(it, {});
  };

  var getterFor = function getterFor(TYPE) {
    return function (it) {
      var state;

      if (!isObject(it) || (state = get(it)).type !== TYPE) {
        throw TypeError('Incompatible receiver, ' + TYPE + ' required');
      }

      return state;
    };
  };

  if (NATIVE_WEAK_MAP || shared.state) {
    var store = shared.state || (shared.state = new WeakMap());
    var wmget = uncurryThis(store.get);
    var wmhas = uncurryThis(store.has);
    var wmset = uncurryThis(store.set);

    set = function set(it, metadata) {
      if (wmhas(store, it)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
      metadata.facade = it;
      wmset(store, it, metadata);
      return metadata;
    };

    get = function get(it) {
      return wmget(store, it) || {};
    };

    has = function has(it) {
      return wmhas(store, it);
    };
  } else {
    var STATE = sharedKey('state');
    hiddenKeys[STATE] = true;

    set = function set(it, metadata) {
      if (hasOwn(it, STATE)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
      metadata.facade = it;
      createNonEnumerableProperty(it, STATE, metadata);
      return metadata;
    };

    get = function get(it) {
      return hasOwn(it, STATE) ? it[STATE] : {};
    };

    has = function has(it) {
      return hasOwn(it, STATE);
    };
  }

  module.exports = {
    set: set,
    get: get,
    has: has,
    enforce: enforce,
    getterFor: getterFor
  };
  /***/
},
/* 28 */

/***/
function (module, exports, __webpack_require__) {
  var global = __webpack_require__(1);

  var TypeError = global.TypeError; // `RequireObjectCoercible` abstract operation
  // https://tc39.es/ecma262/#sec-requireobjectcoercible

  module.exports = function (it) {
    if (it == undefined) throw TypeError("Can't call method on " + it);
    return it;
  };
  /***/

},
/* 29 */

/***/
function (module, exports) {
  var ceil = Math.ceil;
  var floor = Math.floor; // `ToIntegerOrInfinity` abstract operation
  // https://tc39.es/ecma262/#sec-tointegerorinfinity

  module.exports = function (argument) {
    var number = +argument; // eslint-disable-next-line no-self-compare -- safe

    return number !== number || number === 0 ? 0 : (number > 0 ? floor : ceil)(number);
  };
  /***/

},
/* 30 */

/***/
function (module, exports, __webpack_require__) {
  var bind = __webpack_require__(51);

  var uncurryThis = __webpack_require__(3);

  var IndexedObject = __webpack_require__(92);

  var toObject = __webpack_require__(22);

  var lengthOfArrayLike = __webpack_require__(23);

  var arraySpeciesCreate = __webpack_require__(87);

  var push = uncurryThis([].push); // `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation

  var createMethod = function createMethod(TYPE) {
    var IS_MAP = TYPE == 1;
    var IS_FILTER = TYPE == 2;
    var IS_SOME = TYPE == 3;
    var IS_EVERY = TYPE == 4;
    var IS_FIND_INDEX = TYPE == 6;
    var IS_FILTER_REJECT = TYPE == 7;
    var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
    return function ($this, callbackfn, that, specificCreate) {
      var O = toObject($this);
      var self = IndexedObject(O);
      var boundFunction = bind(callbackfn, that);
      var length = lengthOfArrayLike(self);
      var index = 0;
      var create = specificCreate || arraySpeciesCreate;
      var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
      var value, result;

      for (; length > index; index++) {
        if (NO_HOLES || index in self) {
          value = self[index];
          result = boundFunction(value, index, O);

          if (TYPE) {
            if (IS_MAP) target[index] = result; // map
            else if (result) switch (TYPE) {
              case 3:
                return true;
              // some

              case 5:
                return value;
              // find

              case 6:
                return index;
              // findIndex

              case 2:
                push(target, value);
              // filter
            } else switch (TYPE) {
              case 4:
                return false;
              // every

              case 7:
                push(target, value);
              // filterReject
            }
          }
        }
      }

      return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
    };
  };

  module.exports = {
    // `Array.prototype.forEach` method
    // https://tc39.es/ecma262/#sec-array.prototype.foreach
    forEach: createMethod(0),
    // `Array.prototype.map` method
    // https://tc39.es/ecma262/#sec-array.prototype.map
    map: createMethod(1),
    // `Array.prototype.filter` method
    // https://tc39.es/ecma262/#sec-array.prototype.filter
    filter: createMethod(2),
    // `Array.prototype.some` method
    // https://tc39.es/ecma262/#sec-array.prototype.some
    some: createMethod(3),
    // `Array.prototype.every` method
    // https://tc39.es/ecma262/#sec-array.prototype.every
    every: createMethod(4),
    // `Array.prototype.find` method
    // https://tc39.es/ecma262/#sec-array.prototype.find
    find: createMethod(5),
    // `Array.prototype.findIndex` method
    // https://tc39.es/ecma262/#sec-array.prototype.findIndex
    findIndex: createMethod(6),
    // `Array.prototype.filterReject` method
    // https://github.com/tc39/proposal-array-filtering
    filterReject: createMethod(7)
  };
  /***/
},
/* 31 */

/***/
function (module, exports) {
  module.exports = false;
  /***/
},
/* 32 */

/***/
function (module, exports, __webpack_require__) {
  var DESCRIPTORS = __webpack_require__(12);

  var call = __webpack_require__(19);

  var propertyIsEnumerableModule = __webpack_require__(121);

  var createPropertyDescriptor = __webpack_require__(47);

  var toIndexedObject = __webpack_require__(37);

  var toPropertyKey = __webpack_require__(66);

  var hasOwn = __webpack_require__(21);

  var IE8_DOM_DEFINE = __webpack_require__(210); // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe


  var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor; // `Object.getOwnPropertyDescriptor` method
  // https://tc39.es/ecma262/#sec-object.getownpropertydescriptor

  exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
    O = toIndexedObject(O);
    P = toPropertyKey(P);
    if (IE8_DOM_DEFINE) try {
      return $getOwnPropertyDescriptor(O, P);
    } catch (error) {
      /* empty */
    }
    if (hasOwn(O, P)) return createPropertyDescriptor(!call(propertyIsEnumerableModule.f, O, P), O[P]);
  };
  /***/
},
/* 33 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony export (binding) */

  __webpack_require__.d(__webpack_exports__, "a", function () {
    return ScreenDetectorContext;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "c", function () {
    return withScreenDetector;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "b", function () {
    return ScreenDetector;
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(5);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4__tal_gel_theming__ = __webpack_require__(11);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4__tal_gel_theming___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__tal_gel_theming__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__use_screen__ = __webpack_require__(304);

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);

      if (enumerableOnly) {
        symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
      }

      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  var ScreenDetectorContext = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createContext(); // Angular wrapper: In angular, this can't be applied at top level 
  // as react context doesn't work across angular components


  var ScreenDetectorComponent = function ScreenDetectorComponent(_ref) {
    var theme = _ref.theme,
        debounceTime = _ref.debounceTime,
        requireHydration = _ref.requireHydration,
        children = _ref.children;

    var screen = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__use_screen__["a"
    /* default */
    ])({
      debounceTime: debounceTime,
      requireHydration: requireHydration // See comments in use-screen.js

    });

    var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react__["useState"])({
      screen: screen,
      // current screen
      gridColumns: theme.Grid.gridColumns,
      // amount of columns in grid
      gridGutterWidth: theme.Grid.gridGutterWidth,
      // default gutter in between columns
      gridGutters: theme.Grid.gridGutters,
      // predefined gutters to choose from
      isXsScreen: function isXsScreen(screenName) {
        // This function cannot be written as `() => screen === theme.Grid.screens[0].name`,
        // as the function `isXsScreen` in the state is only going to be the first 
        // (when state gets initialised) `isXsScreen` definition whose closure 
        // contains the initial value of `screen`
        return screenName === theme.Grid.screens[0].name;
      },
      isSmScreen: function isSmScreen(screenName) {
        return screenName === theme.Grid.screens[1].name;
      },
      isMdScreen: function isMdScreen(screenName) {
        return screenName === theme.Grid.screens[2].name;
      },
      isLgScreen: function isLgScreen(screenName) {
        return screenName === theme.Grid.screens[3].name;
      },
      isXlScreen: function isXlScreen(screenName) {
        return screenName === theme.Grid.screens[4].name;
      },
      isLargerThanXsScreen: function isLargerThanXsScreen(screenName) {
        return screenName === theme.Grid.screens[1].name || screenName === theme.Grid.screens[2].name || screenName === theme.Grid.screens[3].name || screenName === theme.Grid.screens[4].name;
      },
      isLargerThanSmScreen: function isLargerThanSmScreen(screenName) {
        return screenName === theme.Grid.screens[2].name || screenName === theme.Grid.screens[3].name || screenName === theme.Grid.screens[4].name;
      },
      isLargerThanMdScreen: function isLargerThanMdScreen(screenName) {
        return screenName === theme.Grid.screens[3].name || screenName === theme.Grid.screens[4].name;
      },
      isLargerThanLgScreen: function isLargerThanLgScreen(screenName) {
        return screenName === theme.Grid.screens[4].name;
      },
      getScreenByIndex: function getScreenByIndex(index) {
        // all available screens are listed by size
        return theme.Grid.screens[index].name;
      },
      hasAnyScreenProps: function hasAnyScreenProps(props) {
        // Checks if there's any screen props in the props object
        // (the actual screen prop names to look for are as per `theme.Grid.screens`)
        return theme.Grid.screens.some(function (screen) {
          return !!props[screen.name];
        });
      },
      // Given current screen, find the corresponding screen prop.
      // The screen prop can be for the exact current screen, or can be
      // for screens that are smaller than the current screen
      // (similar to how the responsivenss in Bootstrap grid works)
      findScreenPropByScreen: function findScreenPropByScreen(screenName, props) {
        if (!props) return null;
        var index = theme.Grid.screens.findIndex(function (screen) {
          return screen.name === screenName;
        }); // First check if screen prop for the exact current screen exists. 
        // If not, traverse through smaller screens.
        // First check if screen prop for the exact current screen exists. 
        // If not, traverse through smaller screens.

        while (index >= 0) {
          if (props[theme.Grid.screens[index].name]) {
            return theme.Grid.screens[index].name;
          }

          index--;
        }

        return null; // not finding any screen prop suitable for the current screen 
      },
      animation: theme.Grid.animation,
      requireHydration: requireHydration
    }),
        _useState2 = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray___default()(_useState, 2),
        context = _useState2[0],
        setContext = _useState2[1];

    if (screen !== context.screen) {
      setContext(_objectSpread(_objectSpread({}, context), {}, {
        screen: screen
      }));
    }

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ScreenDetectorContext.Provider, {
      value: context
    }, children);
  };

  var withScreenDetector = function withScreenDetector(Component) {
    return function (props) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ScreenDetectorContext.Consumer, null, function (context) {
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
          gelScreenDetectorContext: context
        }, props));
      });
    };
  };

  var ScreenDetector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__tal_gel_theming__["withTheme"])(ScreenDetectorComponent);
  /***/

},
/* 34 */

/***/
function (module, exports, __webpack_require__) {
  var global = __webpack_require__(1);

  var isCallable = __webpack_require__(17);

  var tryToString = __webpack_require__(100);

  var TypeError = global.TypeError; // `Assert: IsCallable(argument) is true`

  module.exports = function (argument) {
    if (isCallable(argument)) return argument;
    throw TypeError(tryToString(argument) + ' is not a function');
  };
  /***/

},
/* 35 */

/***/
function (module, exports, __webpack_require__) {
  var DESCRIPTORS = __webpack_require__(12);

  var definePropertyModule = __webpack_require__(20);

  var createPropertyDescriptor = __webpack_require__(47);

  module.exports = DESCRIPTORS ? function (object, key, value) {
    return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
  } : function (object, key, value) {
    object[key] = value;
    return object;
  };
  /***/
},
/* 36 */

/***/
function (module, exports, __webpack_require__) {
  var path = __webpack_require__(227);

  var hasOwn = __webpack_require__(21);

  var wrappedWellKnownSymbolModule = __webpack_require__(238);

  var defineProperty = __webpack_require__(20).f;

  module.exports = function (NAME) {
    var Symbol = path.Symbol || (path.Symbol = {});
    if (!hasOwn(Symbol, NAME)) defineProperty(Symbol, NAME, {
      value: wrappedWellKnownSymbolModule.f(NAME)
    });
  };
  /***/

},
/* 37 */

/***/
function (module, exports, __webpack_require__) {
  // toObject with fallback for non-array-like ES3 strings
  var IndexedObject = __webpack_require__(92);

  var requireObjectCoercible = __webpack_require__(28);

  module.exports = function (it) {
    return IndexedObject(requireObjectCoercible(it));
  };
  /***/

},
/* 38 */

/***/
function (module, exports, __webpack_require__) {
  var uncurryThis = __webpack_require__(3);

  var toString = uncurryThis({}.toString);
  var stringSlice = uncurryThis(''.slice);

  module.exports = function (it) {
    return stringSlice(toString(it), 8, -1);
  };
  /***/

},
/* 39 */

/***/
function (module, exports, __webpack_require__) {
  var uncurryThis = __webpack_require__(3);

  var requireObjectCoercible = __webpack_require__(28);

  var toString = __webpack_require__(18);

  var quot = /"/g;
  var replace = uncurryThis(''.replace); // `CreateHTML` abstract operation
  // https://tc39.es/ecma262/#sec-createhtml

  module.exports = function (string, tag, attribute, value) {
    var S = toString(requireObjectCoercible(string));
    var p1 = '<' + tag;
    if (attribute !== '') p1 += ' ' + attribute + '="' + replace(toString(value), quot, '&quot;') + '"';
    return p1 + '>' + S + '</' + tag + '>';
  };
  /***/

},
/* 40 */

/***/
function (module, exports, __webpack_require__) {
  var NATIVE_BIND = __webpack_require__(89);

  var FunctionPrototype = Function.prototype;
  var apply = FunctionPrototype.apply;
  var call = FunctionPrototype.call; // eslint-disable-next-line es/no-reflect -- safe

  module.exports = typeof Reflect == 'object' && Reflect.apply || (NATIVE_BIND ? call.bind(apply) : function () {
    return call.apply(apply, arguments);
  });
  /***/
},
/* 41 */

/***/
function (module, exports, __webpack_require__) {
  /* global ActiveXObject -- old IE, WSH */
  var anObject = __webpack_require__(10);

  var definePropertiesModule = __webpack_require__(97);

  var enumBugKeys = __webpack_require__(151);

  var hiddenKeys = __webpack_require__(91);

  var html = __webpack_require__(209);

  var documentCreateElement = __webpack_require__(114);

  var sharedKey = __webpack_require__(125);

  var GT = '>';
  var LT = '<';
  var PROTOTYPE = 'prototype';
  var SCRIPT = 'script';
  var IE_PROTO = sharedKey('IE_PROTO');

  var EmptyConstructor = function EmptyConstructor() {
    /* empty */
  };

  var scriptTag = function scriptTag(content) {
    return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
  }; // Create object with fake `null` prototype: use ActiveX Object with cleared prototype


  var NullProtoObjectViaActiveX = function NullProtoObjectViaActiveX(activeXDocument) {
    activeXDocument.write(scriptTag(''));
    activeXDocument.close();
    var temp = activeXDocument.parentWindow.Object;
    activeXDocument = null; // avoid memory leak

    return temp;
  }; // Create object with fake `null` prototype: use iframe Object with cleared prototype


  var NullProtoObjectViaIFrame = function NullProtoObjectViaIFrame() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = documentCreateElement('iframe');
    var JS = 'java' + SCRIPT + ':';
    var iframeDocument;
    iframe.style.display = 'none';
    html.appendChild(iframe); // https://github.com/zloirock/core-js/issues/475

    iframe.src = String(JS);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write(scriptTag('document.F=Object'));
    iframeDocument.close();
    return iframeDocument.F;
  }; // Check for document.domain and active x support
  // No need to use active x approach when document.domain is not set
  // see https://github.com/es-shims/es5-shim/issues/150
  // variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
  // avoid IE GC bug


  var activeXDocument;

  var _NullProtoObject = function NullProtoObject() {
    try {
      activeXDocument = new ActiveXObject('htmlfile');
    } catch (error) {
      /* ignore */
    }

    _NullProtoObject = typeof document != 'undefined' ? document.domain && activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) // old IE
    : NullProtoObjectViaIFrame() : NullProtoObjectViaActiveX(activeXDocument); // WSH

    var length = enumBugKeys.length;

    while (length--) {
      delete _NullProtoObject[PROTOTYPE][enumBugKeys[length]];
    }

    return _NullProtoObject();
  };

  hiddenKeys[IE_PROTO] = true; // `Object.create` method
  // https://tc39.es/ecma262/#sec-object.create

  module.exports = Object.create || function create(O, Properties) {
    var result;

    if (O !== null) {
      EmptyConstructor[PROTOTYPE] = anObject(O);
      result = new EmptyConstructor();
      EmptyConstructor[PROTOTYPE] = null; // add "__proto__" for Object.getPrototypeOf polyfill

      result[IE_PROTO] = O;
    } else result = _NullProtoObject();

    return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
  };
  /***/

},
/* 42 */

/***/
function (module, exports, __webpack_require__) {
  var uncurryThis = __webpack_require__(3);

  module.exports = uncurryThis({}.isPrototypeOf);
  /***/
},
/* 43 */

/***/
function (module, exports, __webpack_require__) {
  var fails = __webpack_require__(2); // check the existence of a method, lowercase
  // of a tag and escaping quotes in arguments


  module.exports = function (METHOD_NAME) {
    return fails(function () {
      var test = ''[METHOD_NAME]('"');
      return test !== test.toLowerCase() || test.split('"').length > 3;
    });
  };
  /***/

},
/* 44 */

/***/
function (module, exports, __webpack_require__) {
  var toIntegerOrInfinity = __webpack_require__(29);

  var min = Math.min; // `ToLength` abstract operation
  // https://tc39.es/ecma262/#sec-tolength

  module.exports = function (argument) {
    return argument > 0 ? min(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
  };
  /***/

},
/* 45 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__icon__ = __webpack_require__(188);
  /* harmony namespace reexport (by used) */


  __webpack_require__.d(__webpack_exports__, "a", function () {
    return __WEBPACK_IMPORTED_MODULE_0__icon__["a"];
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__icon_iterator__ = __webpack_require__(306);
  /* harmony namespace reexport (by used) */


  __webpack_require__.d(__webpack_exports__, "b", function () {
    return __WEBPACK_IMPORTED_MODULE_1__icon_iterator__["a"];
  });
  /***/

},
/* 46 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__text_input__ = __webpack_require__(329);
  /* harmony default export */


  __webpack_exports__["a"] = __WEBPACK_IMPORTED_MODULE_0__text_input__["a"
  /* TextInput */
  ];
  /***/
},
/* 47 */

/***/
function (module, exports) {
  module.exports = function (bitmap, value) {
    return {
      enumerable: !(bitmap & 1),
      configurable: !(bitmap & 2),
      writable: !(bitmap & 4),
      value: value
    };
  };
  /***/

},
/* 48 */

/***/
function (module, exports, __webpack_require__) {
  var global = __webpack_require__(1);

  var hasOwn = __webpack_require__(21);

  var isCallable = __webpack_require__(17);

  var toObject = __webpack_require__(22);

  var sharedKey = __webpack_require__(125);

  var CORRECT_PROTOTYPE_GETTER = __webpack_require__(147);

  var IE_PROTO = sharedKey('IE_PROTO');
  var Object = global.Object;
  var ObjectPrototype = Object.prototype; // `Object.getPrototypeOf` method
  // https://tc39.es/ecma262/#sec-object.getprototypeof

  module.exports = CORRECT_PROTOTYPE_GETTER ? Object.getPrototypeOf : function (O) {
    var object = toObject(O);
    if (hasOwn(object, IE_PROTO)) return object[IE_PROTO];
    var constructor = object.constructor;

    if (isCallable(constructor) && object instanceof constructor) {
      return constructor.prototype;
    }

    return object instanceof Object ? ObjectPrototype : null;
  };
  /***/
},
/* 49 */

/***/
function (module, exports, __webpack_require__) {
  var defineProperty = __webpack_require__(20).f;

  var hasOwn = __webpack_require__(21);

  var wellKnownSymbol = __webpack_require__(15);

  var TO_STRING_TAG = wellKnownSymbol('toStringTag');

  module.exports = function (target, TAG, STATIC) {
    if (target && !STATIC) target = target.prototype;

    if (target && !hasOwn(target, TO_STRING_TAG)) {
      defineProperty(target, TO_STRING_TAG, {
        configurable: true,
        value: TAG
      });
    }
  };
  /***/

},
/* 50 */

/***/
function (module, exports, __webpack_require__) {
  var global = __webpack_require__(1);

  var isPrototypeOf = __webpack_require__(42);

  var TypeError = global.TypeError;

  module.exports = function (it, Prototype) {
    if (isPrototypeOf(Prototype, it)) return it;
    throw TypeError('Incorrect invocation');
  };
  /***/

},
/* 51 */

/***/
function (module, exports, __webpack_require__) {
  var uncurryThis = __webpack_require__(3);

  var aCallable = __webpack_require__(34);

  var NATIVE_BIND = __webpack_require__(89);

  var bind = uncurryThis(uncurryThis.bind); // optional / simple context binding

  module.exports = function (fn, that) {
    aCallable(fn);
    return that === undefined ? fn : NATIVE_BIND ? bind(fn, that) : function
      /* ...args */
    () {
      return fn.apply(that, arguments);
    };
  };
  /***/

},
/* 52 */

/***/
function (module, exports, __webpack_require__) {
  /* eslint-disable no-proto -- safe */
  var uncurryThis = __webpack_require__(3);

  var anObject = __webpack_require__(10);

  var aPossiblePrototype = __webpack_require__(192); // `Object.setPrototypeOf` method
  // https://tc39.es/ecma262/#sec-object.setprototypeof
  // Works with __proto__ only. Old v8 can't work with null proto objects.
  // eslint-disable-next-line es/no-object-setprototypeof -- safe


  module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
    var CORRECT_SETTER = false;
    var test = {};
    var setter;

    try {
      // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
      setter = uncurryThis(Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set);
      setter(test, []);
      CORRECT_SETTER = test instanceof Array;
    } catch (error) {
      /* empty */
    }

    return function setPrototypeOf(O, proto) {
      anObject(O);
      aPossiblePrototype(proto);
      if (CORRECT_SETTER) setter(O, proto);else O.__proto__ = proto;
      return O;
    };
  }() : undefined);
  /***/
},
/* 53 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony export (binding) */

  __webpack_require__.d(__webpack_exports__, "a", function () {
    return MultiStepFormContext;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "b", function () {
    return MultiStepForm;
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__tal_gel_core__ = __webpack_require__(7);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__tal_gel_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__tal_gel_core__);

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);

      if (enumerableOnly) {
        symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
      }

      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  var MultiStepFormContext = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createContext(); // TODO: use TS enum


  var FormStepStatus = {
    Active: 1,
    Complete: 2,
    Error: 3,
    Todo: 4
  };

  var MultiStepForm = function MultiStepForm(_ref) {
    var name = _ref.name,
        render = _ref.render,
        useSession = _ref.useSession,
        children = _ref.children;

    var _hasFormStepper = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(false);

    var initialStepStatuses = {
      1: FormStepStatus.Active
    }; // Use useRef instead of useState to avoid closure issues

    var stepStatuses = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(initialStepStatuses); // Use useRef instead of useState to avoid closure issues


    var multiStepFormData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])({});

    var addMultiStepFormData = function addMultiStepFormData(stepData) {
      multiStepFormData.current = _objectSpread(_objectSpread({}, multiStepFormData.current), stepData);
    }; // Even after route change, if a component still remains at 
    // the same location of the virtual DOM tree, React might 
    // still not unmount it but continue using the current 
    // instance (created by hooks, as component itself is 
    // functional component) of this component (possibly with 
    // different prop values) to render to the DOM. 
    //
    // Effectively, this same instance of the component only 
    // experiences prop changes, so we cannot always rely on 
    // mount to initialise statues, as those states or refs 
    // could still retain their values due to the same instance 
    // of the component reused by React (performance optimisation
    // or bugs?)
    //
    // Also check out comments on `Content` in `page-layout.js`.
    // 
    // Side note: States and refs won't retain values after
    // the component is unmounted, as the instance created
    // by hooks will also be removed.


    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__tal_gel_core__["useLayoutEffect"])(function () {
      if (name !== undefined) {
        multiStepFormContext.current = _objectSpread(_objectSpread({}, multiStepFormContext.current), {}, {
          name: name,
          useSession: useSession
        });
        onReset();
      }
    }, [name, useSession]);

    var getMultiStepFormData = function getMultiStepFormData(entry) {
      if (!entry) {
        return multiStepFormData.current;
      }

      return multiStepFormData.current[entry];
    };

    var setStepStatus = function setStepStatus(stepNum, status) {
      stepStatuses.current = _objectSpread(_objectSpread({}, stepStatuses.current), {}, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()({}, stepNum, status));
    };

    var getStepStatus = function getStepStatus(stepNum) {
      return stepStatuses.current[stepNum] || FormStepStatus.Todo;
    };

    var areAllStepsComplete = function areAllStepsComplete() {
      return Object.keys(stepStatuses.current).reduce(function (acc, stepNum) {
        if (acc && getStepStatus(stepNum) !== FormStepStatus.Complete) {
          acc = false;
        }

        return acc;
      }, true);
    };

    var onReset = function onReset() {
      multiStepFormData.current = {};

      if (_hasFormStepper.current) {
        // If with form stepper, we reset statuses of all form steps
        stepStatuses.current = initialStepStatuses;
      }

      currentStep.current = 1; // start over from step 1 again

      forceUpdate();
    };
    /**
     * With form stepper, the submit button could be clicked when
     * not all steps are complete, in which case we want to mark 
     * all incomplete steps as error to notify the user
     */


    var setAllIncompleteStepsAsError = function setAllIncompleteStepsAsError() {
      Object.keys(stepStatuses.current).forEach(function (stepNum) {
        if (getStepStatus(stepNum) !== FormStepStatus.Complete) {
          setStepStatus(stepNum, FormStepStatus.Error);
        }
      });
      forceUpdate();
    }; // Use useRef instead of useState to avoid closure issues


    var currentStep = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(1); // starting from 1 instead of 0


    var forceUpdate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__tal_gel_core__["useForceUpdate"])();

    var multiStepFormContext = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])({
      name: name,
      useSession: useSession,
      addMultiStepFormData: addMultiStepFormData,
      getMultiStepFormData: getMultiStepFormData,
      getCurrentStep: function getCurrentStep() {
        return currentStep.current;
      },
      onPrevStep: function onPrevStep() {
        if (currentStep.current > 1) {
          // 1 based, not 0 based
          if (_hasFormStepper.current && getStepStatus(currentStep.current) === FormStepStatus.Active) {
            // if current step is Active, change it to Todo
            setStepStatus(currentStep.current, FormStepStatus.Todo);
          }

          currentStep.current -= 1; // goes to the prev step

          if (_hasFormStepper.current && getStepStatus(currentStep.current) === FormStepStatus.Todo) {
            // if prev step is Todo, change it to Active
            setStepStatus(currentStep.current, FormStepStatus.Active);
          }

          forceUpdate();
        }
      },
      onNextStep: function onNextStep() {
        if (_hasFormStepper.current) {
          // Set the current step as Complete before moving on to the next step
          // (because otherwise onNextStep would have been disabled)
          setStepStatus(currentStep.current, FormStepStatus.Complete);
        }

        currentStep.current += 1; // goes to the next step

        if (_hasFormStepper.current && getStepStatus(currentStep.current) === FormStepStatus.Todo) {
          // if the next step is Todo, change it to Active
          setStepStatus(currentStep.current, FormStepStatus.Active);
        }

        forceUpdate();
      },
      onStep: function onStep(stepNum) {
        // Jumps to the step specified (step with `Review` capability)
        if (getStepStatus(currentStep.current) === FormStepStatus.Active) {
          // Before jumping to another step, if the current step is Active,
          // change it to Todo
          setStepStatus(currentStep.current, FormStepStatus.Todo);
        }

        currentStep.current = stepNum; // Jump to that step

        forceUpdate();
      },
      onReset: onReset,
      onIndividualFormDataReset: function onIndividualFormDataReset() {
        // If with form stepper, we change the status of that step to active
        // when the individual form of that step is reset
        if (_hasFormStepper.current) {
          setStepStatus(currentStep.current, FormStepStatus.Active);
          forceUpdate();
        }
      },
      onSubmit: function onSubmit() {
        // If with form stepper, we change the status of current step 
        // (typically last step) to Complete when this multi-step form
        // is supposed to be submitted.
        if (_hasFormStepper.current) {
          setStepStatus(currentStep.current, FormStepStatus.Complete);

          if (!areAllStepsComplete()) {
            setAllIncompleteStepsAsError();
            throw 'Incomplete step(s)';
          }

          forceUpdate();
        }
      },
      onStepError: function onStepError() {
        var hasError = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

        if (_hasFormStepper.current) {
          if (hasError && getStepStatus(currentStep.current) !== FormStepStatus.Error) {
            // If error has happened and the current step is not marked as Error,
            // change the status of this step to Error
            setStepStatus(currentStep.current, FormStepStatus.Error);
            forceUpdate();
          } else if (!hasError && getStepStatus(currentStep.current) !== FormStepStatus.Complete) {
            // If error has disappeared and the current step is not marked as Complete,
            // change the status of this step to Active
            setStepStatus(currentStep.current, FormStepStatus.Active);
            forceUpdate();
          }
        }
      },
      setHasFormStepper: function setHasFormStepper(value) {
        return _hasFormStepper.current = value;
      },
      hasFormStepper: function hasFormStepper() {
        return _hasFormStepper.current;
      },
      isStepActive: function isStepActive(stepNum) {
        return getStepStatus(stepNum) === FormStepStatus.Active;
      },
      isStepComplete: function isStepComplete(stepNum) {
        return getStepStatus(stepNum) === FormStepStatus.Complete;
      },
      isStepOnError: function isStepOnError(stepNum) {
        return getStepStatus(stepNum) === FormStepStatus.Error;
      },
      isStepTodo: function isStepTodo(stepNum) {
        return getStepStatus(stepNum) === FormStepStatus.Todo;
      },
      areAllStepsComplete: areAllStepsComplete,
      setAllIncompleteStepsAsError: setAllIncompleteStepsAsError
    });

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(MultiStepFormContext.Provider, {
      value: multiStepFormContext.current
    }, render ? render(currentStep.current) : children);
  };
  /***/

},
/* 54 */

/***/
function (module, exports, __webpack_require__) {
  var wellKnownSymbol = __webpack_require__(15);

  var create = __webpack_require__(41);

  var definePropertyModule = __webpack_require__(20);

  var UNSCOPABLES = wellKnownSymbol('unscopables');
  var ArrayPrototype = Array.prototype; // Array.prototype[@@unscopables]
  // https://tc39.es/ecma262/#sec-array.prototype-@@unscopables

  if (ArrayPrototype[UNSCOPABLES] == undefined) {
    definePropertyModule.f(ArrayPrototype, UNSCOPABLES, {
      configurable: true,
      value: create(null)
    });
  } // add a key to Array.prototype[@@unscopables]


  module.exports = function (key) {
    ArrayPrototype[UNSCOPABLES][key] = true;
  };
  /***/

},
/* 55 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var fails = __webpack_require__(2);

  module.exports = function (METHOD_NAME, argument) {
    var method = [][METHOD_NAME];
    return !!method && fails(function () {
      // eslint-disable-next-line no-useless-call,no-throw-literal -- required for testing
      method.call(null, argument || function () {
        throw 1;
      }, 1);
    });
  };
  /***/

},
/* 56 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var toPropertyKey = __webpack_require__(66);

  var definePropertyModule = __webpack_require__(20);

  var createPropertyDescriptor = __webpack_require__(47);

  module.exports = function (object, key, value) {
    var propertyKey = toPropertyKey(key);
    if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));else object[propertyKey] = value;
  };
  /***/

},
/* 57 */

/***/
function (module, exports, __webpack_require__) {
  var getBuiltIn = __webpack_require__(26);

  module.exports = getBuiltIn('navigator', 'userAgent') || '';
  /***/
},
/* 58 */

/***/
function (module, exports, __webpack_require__) {
  var aCallable = __webpack_require__(34); // `GetMethod` abstract operation
  // https://tc39.es/ecma262/#sec-getmethod


  module.exports = function (V, P) {
    var func = V[P];
    return func == null ? undefined : aCallable(func);
  };
  /***/

},
/* 59 */

/***/
function (module, exports, __webpack_require__) {
  var global = __webpack_require__(1);

  var bind = __webpack_require__(51);

  var call = __webpack_require__(19);

  var anObject = __webpack_require__(10);

  var tryToString = __webpack_require__(100);

  var isArrayIteratorMethod = __webpack_require__(153);

  var lengthOfArrayLike = __webpack_require__(23);

  var isPrototypeOf = __webpack_require__(42);

  var getIterator = __webpack_require__(116);

  var getIteratorMethod = __webpack_require__(90);

  var iteratorClose = __webpack_require__(213);

  var TypeError = global.TypeError;

  var Result = function Result(stopped, result) {
    this.stopped = stopped;
    this.result = result;
  };

  var ResultPrototype = Result.prototype;

  module.exports = function (iterable, unboundFunction, options) {
    var that = options && options.that;
    var AS_ENTRIES = !!(options && options.AS_ENTRIES);
    var IS_ITERATOR = !!(options && options.IS_ITERATOR);
    var INTERRUPTED = !!(options && options.INTERRUPTED);
    var fn = bind(unboundFunction, that);
    var iterator, iterFn, index, length, result, next, step;

    var stop = function stop(condition) {
      if (iterator) iteratorClose(iterator, 'normal', condition);
      return new Result(true, condition);
    };

    var callFn = function callFn(value) {
      if (AS_ENTRIES) {
        anObject(value);
        return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
      }

      return INTERRUPTED ? fn(value, stop) : fn(value);
    };

    if (IS_ITERATOR) {
      iterator = iterable;
    } else {
      iterFn = getIteratorMethod(iterable);
      if (!iterFn) throw TypeError(tryToString(iterable) + ' is not iterable'); // optimisation for array iterators

      if (isArrayIteratorMethod(iterFn)) {
        for (index = 0, length = lengthOfArrayLike(iterable); length > index; index++) {
          result = callFn(iterable[index]);
          if (result && isPrototypeOf(ResultPrototype, result)) return result;
        }

        return new Result(false);
      }

      iterator = getIterator(iterable, iterFn);
    }

    next = iterator.next;

    while (!(step = call(next, iterator)).done) {
      try {
        result = callFn(step.value);
      } catch (error) {
        iteratorClose(iterator, 'throw', error);
      }

      if (typeof result == 'object' && result && isPrototypeOf(ResultPrototype, result)) return result;
    }

    return new Result(false);
  };
  /***/

},
/* 60 */

/***/
function (module, exports, __webpack_require__) {
  var toIntegerOrInfinity = __webpack_require__(29);

  var max = Math.max;
  var min = Math.min; // Helper for a popular repeating case of the spec:
  // Let integer be ? ToInteger(index).
  // If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).

  module.exports = function (index, length) {
    var integer = toIntegerOrInfinity(index);
    return integer < 0 ? max(integer + length, 0) : min(integer, length);
  };
  /***/

},
/* 61 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $ = __webpack_require__(0);

  var global = __webpack_require__(1);

  var call = __webpack_require__(19);

  var DESCRIPTORS = __webpack_require__(12);

  var TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS = __webpack_require__(170);

  var ArrayBufferViewCore = __webpack_require__(16);

  var ArrayBufferModule = __webpack_require__(108);

  var anInstance = __webpack_require__(50);

  var createPropertyDescriptor = __webpack_require__(47);

  var createNonEnumerableProperty = __webpack_require__(35);

  var isIntegralNumber = __webpack_require__(154);

  var toLength = __webpack_require__(44);

  var toIndex = __webpack_require__(232);

  var toOffset = __webpack_require__(233);

  var toPropertyKey = __webpack_require__(66);

  var hasOwn = __webpack_require__(21);

  var classof = __webpack_require__(63);

  var isObject = __webpack_require__(13);

  var isSymbol = __webpack_require__(77);

  var create = __webpack_require__(41);

  var isPrototypeOf = __webpack_require__(42);

  var setPrototypeOf = __webpack_require__(52);

  var getOwnPropertyNames = __webpack_require__(65).f;

  var typedArrayFrom = __webpack_require__(234);

  var forEach = __webpack_require__(30).forEach;

  var setSpecies = __webpack_require__(79);

  var definePropertyModule = __webpack_require__(20);

  var getOwnPropertyDescriptorModule = __webpack_require__(32);

  var InternalStateModule = __webpack_require__(27);

  var inheritIfRequired = __webpack_require__(75);

  var getInternalState = InternalStateModule.get;
  var setInternalState = InternalStateModule.set;
  var nativeDefineProperty = definePropertyModule.f;
  var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  var round = Math.round;
  var RangeError = global.RangeError;
  var ArrayBuffer = ArrayBufferModule.ArrayBuffer;
  var ArrayBufferPrototype = ArrayBuffer.prototype;
  var DataView = ArrayBufferModule.DataView;
  var NATIVE_ARRAY_BUFFER_VIEWS = ArrayBufferViewCore.NATIVE_ARRAY_BUFFER_VIEWS;
  var TYPED_ARRAY_CONSTRUCTOR = ArrayBufferViewCore.TYPED_ARRAY_CONSTRUCTOR;
  var TYPED_ARRAY_TAG = ArrayBufferViewCore.TYPED_ARRAY_TAG;
  var TypedArray = ArrayBufferViewCore.TypedArray;
  var TypedArrayPrototype = ArrayBufferViewCore.TypedArrayPrototype;
  var aTypedArrayConstructor = ArrayBufferViewCore.aTypedArrayConstructor;
  var isTypedArray = ArrayBufferViewCore.isTypedArray;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var WRONG_LENGTH = 'Wrong length';

  var fromList = function fromList(C, list) {
    aTypedArrayConstructor(C);
    var index = 0;
    var length = list.length;
    var result = new C(length);

    while (length > index) {
      result[index] = list[index++];
    }

    return result;
  };

  var addGetter = function addGetter(it, key) {
    nativeDefineProperty(it, key, {
      get: function get() {
        return getInternalState(this)[key];
      }
    });
  };

  var isArrayBuffer = function isArrayBuffer(it) {
    var klass;
    return isPrototypeOf(ArrayBufferPrototype, it) || (klass = classof(it)) == 'ArrayBuffer' || klass == 'SharedArrayBuffer';
  };

  var isTypedArrayIndex = function isTypedArrayIndex(target, key) {
    return isTypedArray(target) && !isSymbol(key) && key in target && isIntegralNumber(+key) && key >= 0;
  };

  var wrappedGetOwnPropertyDescriptor = function getOwnPropertyDescriptor(target, key) {
    key = toPropertyKey(key);
    return isTypedArrayIndex(target, key) ? createPropertyDescriptor(2, target[key]) : nativeGetOwnPropertyDescriptor(target, key);
  };

  var wrappedDefineProperty = function defineProperty(target, key, descriptor) {
    key = toPropertyKey(key);

    if (isTypedArrayIndex(target, key) && isObject(descriptor) && hasOwn(descriptor, 'value') && !hasOwn(descriptor, 'get') && !hasOwn(descriptor, 'set') // TODO: add validation descriptor w/o calling accessors
    && !descriptor.configurable && (!hasOwn(descriptor, 'writable') || descriptor.writable) && (!hasOwn(descriptor, 'enumerable') || descriptor.enumerable)) {
      target[key] = descriptor.value;
      return target;
    }

    return nativeDefineProperty(target, key, descriptor);
  };

  if (DESCRIPTORS) {
    if (!NATIVE_ARRAY_BUFFER_VIEWS) {
      getOwnPropertyDescriptorModule.f = wrappedGetOwnPropertyDescriptor;
      definePropertyModule.f = wrappedDefineProperty;
      addGetter(TypedArrayPrototype, 'buffer');
      addGetter(TypedArrayPrototype, 'byteOffset');
      addGetter(TypedArrayPrototype, 'byteLength');
      addGetter(TypedArrayPrototype, 'length');
    }

    $({
      target: 'Object',
      stat: true,
      forced: !NATIVE_ARRAY_BUFFER_VIEWS
    }, {
      getOwnPropertyDescriptor: wrappedGetOwnPropertyDescriptor,
      defineProperty: wrappedDefineProperty
    });

    module.exports = function (TYPE, wrapper, CLAMPED) {
      var BYTES = TYPE.match(/\d+$/)[0] / 8;
      var CONSTRUCTOR_NAME = TYPE + (CLAMPED ? 'Clamped' : '') + 'Array';
      var GETTER = 'get' + TYPE;
      var SETTER = 'set' + TYPE;
      var NativeTypedArrayConstructor = global[CONSTRUCTOR_NAME];
      var TypedArrayConstructor = NativeTypedArrayConstructor;
      var TypedArrayConstructorPrototype = TypedArrayConstructor && TypedArrayConstructor.prototype;
      var exported = {};

      var getter = function getter(that, index) {
        var data = getInternalState(that);
        return data.view[GETTER](index * BYTES + data.byteOffset, true);
      };

      var setter = function setter(that, index, value) {
        var data = getInternalState(that);
        if (CLAMPED) value = (value = round(value)) < 0 ? 0 : value > 0xFF ? 0xFF : value & 0xFF;
        data.view[SETTER](index * BYTES + data.byteOffset, value, true);
      };

      var addElement = function addElement(that, index) {
        nativeDefineProperty(that, index, {
          get: function get() {
            return getter(this, index);
          },
          set: function set(value) {
            return setter(this, index, value);
          },
          enumerable: true
        });
      };

      if (!NATIVE_ARRAY_BUFFER_VIEWS) {
        TypedArrayConstructor = wrapper(function (that, data, offset, $length) {
          anInstance(that, TypedArrayConstructorPrototype);
          var index = 0;
          var byteOffset = 0;
          var buffer, byteLength, length;

          if (!isObject(data)) {
            length = toIndex(data);
            byteLength = length * BYTES;
            buffer = new ArrayBuffer(byteLength);
          } else if (isArrayBuffer(data)) {
            buffer = data;
            byteOffset = toOffset(offset, BYTES);
            var $len = data.byteLength;

            if ($length === undefined) {
              if ($len % BYTES) throw RangeError(WRONG_LENGTH);
              byteLength = $len - byteOffset;
              if (byteLength < 0) throw RangeError(WRONG_LENGTH);
            } else {
              byteLength = toLength($length) * BYTES;
              if (byteLength + byteOffset > $len) throw RangeError(WRONG_LENGTH);
            }

            length = byteLength / BYTES;
          } else if (isTypedArray(data)) {
            return fromList(TypedArrayConstructor, data);
          } else {
            return call(typedArrayFrom, TypedArrayConstructor, data);
          }

          setInternalState(that, {
            buffer: buffer,
            byteOffset: byteOffset,
            byteLength: byteLength,
            length: length,
            view: new DataView(buffer)
          });

          while (index < length) {
            addElement(that, index++);
          }
        });
        if (setPrototypeOf) setPrototypeOf(TypedArrayConstructor, TypedArray);
        TypedArrayConstructorPrototype = TypedArrayConstructor.prototype = create(TypedArrayPrototype);
      } else if (TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS) {
        TypedArrayConstructor = wrapper(function (dummy, data, typedArrayOffset, $length) {
          anInstance(dummy, TypedArrayConstructorPrototype);
          return inheritIfRequired(function () {
            if (!isObject(data)) return new NativeTypedArrayConstructor(toIndex(data));
            if (isArrayBuffer(data)) return $length !== undefined ? new NativeTypedArrayConstructor(data, toOffset(typedArrayOffset, BYTES), $length) : typedArrayOffset !== undefined ? new NativeTypedArrayConstructor(data, toOffset(typedArrayOffset, BYTES)) : new NativeTypedArrayConstructor(data);
            if (isTypedArray(data)) return fromList(TypedArrayConstructor, data);
            return call(typedArrayFrom, TypedArrayConstructor, data);
          }(), dummy, TypedArrayConstructor);
        });
        if (setPrototypeOf) setPrototypeOf(TypedArrayConstructor, TypedArray);
        forEach(getOwnPropertyNames(NativeTypedArrayConstructor), function (key) {
          if (!(key in TypedArrayConstructor)) {
            createNonEnumerableProperty(TypedArrayConstructor, key, NativeTypedArrayConstructor[key]);
          }
        });
        TypedArrayConstructor.prototype = TypedArrayConstructorPrototype;
      }

      if (TypedArrayConstructorPrototype.constructor !== TypedArrayConstructor) {
        createNonEnumerableProperty(TypedArrayConstructorPrototype, 'constructor', TypedArrayConstructor);
      }

      createNonEnumerableProperty(TypedArrayConstructorPrototype, TYPED_ARRAY_CONSTRUCTOR, TypedArrayConstructor);

      if (TYPED_ARRAY_TAG) {
        createNonEnumerableProperty(TypedArrayConstructorPrototype, TYPED_ARRAY_TAG, CONSTRUCTOR_NAME);
      }

      exported[CONSTRUCTOR_NAME] = TypedArrayConstructor;
      $({
        global: true,
        forced: TypedArrayConstructor != NativeTypedArrayConstructor,
        sham: !NATIVE_ARRAY_BUFFER_VIEWS
      }, exported);

      if (!(BYTES_PER_ELEMENT in TypedArrayConstructor)) {
        createNonEnumerableProperty(TypedArrayConstructor, BYTES_PER_ELEMENT, BYTES);
      }

      if (!(BYTES_PER_ELEMENT in TypedArrayConstructorPrototype)) {
        createNonEnumerableProperty(TypedArrayConstructorPrototype, BYTES_PER_ELEMENT, BYTES);
      }

      setSpecies(CONSTRUCTOR_NAME);
    };
  } else module.exports = function () {
    /* empty */
  };
  /***/

},
/* 62 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony export (binding) */

  __webpack_require__.d(__webpack_exports__, "a", function () {
    return getGutter;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "b", function () {
    return ContainerLite;
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof__ = __webpack_require__(103);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends__ = __webpack_require__(5);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4__emotion_styled__ = __webpack_require__(14);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4__emotion_styled___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__emotion_styled__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__tal_gel_theming__ = __webpack_require__(11);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__tal_gel_theming___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__tal_gel_theming__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6__grid_screen_detector__ = __webpack_require__(33);

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);

      if (enumerableOnly) {
        symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
      }

      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }
  /**
   * It is recommended that all layout components sit inside a ContainerLite
   * component. Make sure that the horizontal paddings are larger than the 
   * negative horizontal margins of the layout components, to avoid horizontal
   * scroll bar.
   * 
   * <GelContainerLite>
   *   <GelRowLayout></GelRowLayout>
   * </GelContainerLite>
   * 
   * <GelContainerLite>
   *   <GelBoxLayout></GelBoxLayout>
   * </GelContainerLite>
   * 
   * <GelContainerLite>
   *   <GelColumnLayout></GelColumnLayout>
   * </GelContainerLite>
   * 
   * ...
   * 
   * All layout components have negative horizontal margins, and the items inside
   * the layout component have horizontal paddings to compensate for negative margins
   * and creare gaps in between items.
   * 
   * Default horizontal paddings of ContainerLite: gridGutterWidth / 2
   * Default horizontal negative margins of RowLayout: -gridGutterLarge / 2
   * Default horizontal negative margins of BoxLayout: -gridGutterMedium / 2
   * ...
   * (gridGutterWidth, gridGutterLarge, etc. are from global design tokens)
   */


  var ContainerLiteComponent = function ContainerLiteComponent(props) {
    var _useContext = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_6__grid_screen_detector__["a"
    /* ScreenDetectorContext */
    ]),
        screen = _useContext.screen,
        gridGutters = _useContext.gridGutters,
        gridGutterWidth = _useContext.gridGutterWidth;

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(StyledDiv, __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
      gridGutters: gridGutters,
      screen: screen,
      gridGutterWidth: gridGutterWidth
    }, props));
  };

  var StyledDiv = __WEBPACK_IMPORTED_MODULE_4__emotion_styled___default.a.div({
    position: 'relative',
    // In case this container lite is put inside a flexbox
    // In flexbox, div won't take up full width by default
    width: '100%'
  }, function (_ref) {
    var theme = _ref.theme,
        screen = _ref.screen,
        fixed = _ref.fixed,
        gridGutters = _ref.gridGutters,
        gridGutterWidth = _ref.gridGutterWidth,
        gutter = _ref.gutter; // Apply gutter if container not fixed

    if (!fixed) {
      if (gutter === undefined) {
        return {
          padding: "0 ".concat(gridGutterWidth / 2, "px")
        };
      }

      if (__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof___default()(gutter) !== 'object') {
        return {
          // If not object, apply the same gutter to paddings all around
          padding: getGutter(gridGutters, gutter)
        };
      }

      var _gutter$left = gutter.left,
          left = _gutter$left === void 0 ? gridGutterWidth / 2 : _gutter$left,
          _gutter$right = gutter.right,
          right = _gutter$right === void 0 ? gridGutterWidth / 2 : _gutter$right,
          _gutter$top = gutter.top,
          top = _gutter$top === void 0 ? 0 : _gutter$top,
          _gutter$bottom = gutter.bottom,
          bottom = _gutter$bottom === void 0 ? 0 : _gutter$bottom,
          _gutter$horizontal = gutter.horizontal,
          horizontal = _gutter$horizontal === void 0 ? -1 : _gutter$horizontal,
          _gutter$vertical = gutter.vertical,
          vertical = _gutter$vertical === void 0 ? -1 : _gutter$vertical;

      if (horizontal !== -1 && vertical === -1) {
        // If `horizontal` is specified, but `vertical` is not
        var _paddingTop = getGutter(gridGutters, top);

        var _paddingBottom = getGutter(gridGutters, bottom);

        var paddingHorizontal = getGutter(gridGutters, horizontal);
        return {
          padding: "".concat(_paddingTop, "px ").concat(paddingHorizontal, "px ").concat(_paddingBottom, "px")
        };
      } else if (horizontal === -1 && vertical !== -1) {
        // If `vertical` is specified, but `horizontal` is not
        var _paddingLeft = getGutter(gridGutters, left);

        var _paddingRight = getGutter(gridGutters, right);

        var paddingVertical = getGutter(gridGutters, vertical);
        return {
          padding: "".concat(paddingVertical, "px ").concat(_paddingRight, "px ").concat(paddingVertical, "px ").concat(_paddingLeft, "px")
        };
      } else if (horizontal !== -1 && vertical !== -1) {
        // If both `horizontal` and `vertical` are specified
        var _paddingHorizontal = getGutter(gridGutters, horizontal);

        var _paddingVertical = getGutter(gridGutters, vertical);

        return {
          padding: "".concat(_paddingVertical, "px ").concat(_paddingHorizontal, "px")
        };
      } // If neither `horizontal` nor `vertical` is specified


      var paddingLeft = getGutter(gridGutters, left);
      var paddingRight = getGutter(gridGutters, right);
      var paddingTop = getGutter(gridGutters, top);
      var paddingBottom = getGutter(gridGutters, bottom);
      return {
        padding: "".concat(paddingTop, "px ").concat(paddingRight, "px ").concat(paddingBottom, "px ").concat(paddingLeft, "px")
      };
    }

    var verticalPaddingWhenFixed = {};

    if (__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof___default()(gutter) === 'object') {
      var _top = gutter.top,
          _bottom = gutter.bottom,
          _vertical = gutter.vertical;
      verticalPaddingWhenFixed = _objectSpread(_objectSpread(_objectSpread({}, (_top || _top === 0) && {
        paddingTop: getGutter(gridGutters, _top)
      }), (_bottom || _bottom === 0) && {
        paddingBottom: getGutter(gridGutters, _bottom)
      }), (_vertical || _vertical === 0) && {
        paddingTop: getGutter(gridGutters, _vertical),
        paddingBottom: getGutter(gridGutters, _vertical)
      });
    }

    return _objectSpread({
      // If `fixed`, ignore horizontal gutter
      maxWidth: theme.Grid.containerMaxWidth[screen],
      marginLeft: 'auto',
      // centered
      marginRight: 'auto',
      padding: theme.Grid.containerPadding[screen]
    }, verticalPaddingWhenFixed);
  });
  /**
   * Gets the amount of gutter by either looking in the 
   * predefined gutters or by the numeric value
   * 
   * @param gridGutters - Predefined gutters
   * @param gutter - can be either string (used as gutter type) 
   *                 or number (px value for the gutter)
   */


  var getGutter = function getGutter(gridGutters, gutter) {
    if (typeof gutter !== 'number') {
      // If not number, it's gutter type.
      // Get the predefined gutter by gutter type. 
      // If not found, set 0
      return gridGutters[gutter] || 0;
    } // If number, use the number directly as px value for the gutter


    return gutter;
  };

  var ContainerLite = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__tal_gel_theming__["withTheme"])(ContainerLiteComponent);
  /***/

},
/* 63 */

/***/
function (module, exports, __webpack_require__) {
  var global = __webpack_require__(1);

  var TO_STRING_TAG_SUPPORT = __webpack_require__(169);

  var isCallable = __webpack_require__(17);

  var classofRaw = __webpack_require__(38);

  var wellKnownSymbol = __webpack_require__(15);

  var TO_STRING_TAG = wellKnownSymbol('toStringTag');
  var Object = global.Object; // ES3 wrong here

  var CORRECT_ARGUMENTS = classofRaw(function () {
    return arguments;
  }()) == 'Arguments'; // fallback for IE11 Script Access Denied error

  var tryGet = function tryGet(it, key) {
    try {
      return it[key];
    } catch (error) {
      /* empty */
    }
  }; // getting tag from ES6+ `Object.prototype.toString`


  module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
    var O, tag, result;
    return it === undefined ? 'Undefined' : it === null ? 'Null' // @@toStringTag case
    : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG)) == 'string' ? tag // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O) // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && isCallable(O.callee) ? 'Arguments' : result;
  };
  /***/
},
/* 64 */

/***/
function (module, exports, __webpack_require__) {
  var global = __webpack_require__(1);

  var userAgent = __webpack_require__(57);

  var process = global.process;
  var Deno = global.Deno;
  var versions = process && process.versions || Deno && Deno.version;
  var v8 = versions && versions.v8;
  var match, version;

  if (v8) {
    match = v8.split('.'); // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us

    version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
  } // BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
  // so check `userAgent` even if `.v8` exists, but 0


  if (!version && userAgent) {
    match = userAgent.match(/Edge\/(\d+)/);

    if (!match || match[1] >= 74) {
      match = userAgent.match(/Chrome\/(\d+)/);
      if (match) version = +match[1];
    }
  }

  module.exports = version;
  /***/
},
/* 65 */

/***/
function (module, exports, __webpack_require__) {
  var internalObjectKeys = __webpack_require__(224);

  var enumBugKeys = __webpack_require__(151);

  var hiddenKeys = enumBugKeys.concat('length', 'prototype'); // `Object.getOwnPropertyNames` method
  // https://tc39.es/ecma262/#sec-object.getownpropertynames
  // eslint-disable-next-line es/no-object-getownpropertynames -- safe

  exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return internalObjectKeys(O, hiddenKeys);
  };
  /***/

},
/* 66 */

/***/
function (module, exports, __webpack_require__) {
  var toPrimitive = __webpack_require__(168);

  var isSymbol = __webpack_require__(77); // `ToPropertyKey` abstract operation
  // https://tc39.es/ecma262/#sec-topropertykey


  module.exports = function (argument) {
    var key = toPrimitive(argument, 'string');
    return isSymbol(key) ? key : key + '';
  };
  /***/

},
/* 67 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony export (binding) */

  __webpack_require__.d(__webpack_exports__, "e", function () {
    return CrInput;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "d", function () {
    return CrContainer;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "f", function () {
    return CrLabel;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "g", function () {
    return CrButton;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "i", function () {
    return inButtonGroup;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "a", function () {
    return isControlledState;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "c", function () {
    return useCrCommon;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "h", function () {
    return useCrContext;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "b", function () {
    return useButtonLocationInGroup;
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends__ = __webpack_require__(5);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__emotion_styled__ = __webpack_require__(14);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__emotion_styled___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__emotion_styled__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6__tal_gel_core__ = __webpack_require__(7);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6__tal_gel_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__tal_gel_core__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7__tal_gel_theming__ = __webpack_require__(11);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7__tal_gel_theming___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__tal_gel_theming__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_8__icon__ = __webpack_require__(45);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_9__button__ = __webpack_require__(133);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_10__layout__ = __webpack_require__(73);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_11__grid_screen_detector__ = __webpack_require__(33);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_12__layout_container_lite__ = __webpack_require__(62);

  var _excluded = ["id", "checkbox", "groupContext", "onClick", "error"];

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);

      if (enumerableOnly) {
        symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
      }

      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }
  /**
   * The input element used by checkbox and radio box for accessibility
   */


  var CrInput = __WEBPACK_IMPORTED_MODULE_5__emotion_styled___default.a.input({
    // consistent checkbox and radio box 'input' styles across all brands
    ':disabled + * > label': {
      cursor: 'not-allowed'
    }
  }, function (_ref) {
    var theme = _ref.theme,
        type = _ref.type,
        button = _ref.button,
        error = _ref.error,
        inverse = _ref.inverse,
        focusByClick = _ref.focusByClick,
        alternativeButton = _ref.alternativeButton,
        labelLeft = _ref.labelLeft;
    var target = type.charAt(0).toUpperCase() + type.slice(1); // 'Checkbox' or 'Radio'

    var _getStylesForStates = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__tal_gel_theming__["getStylesForStates"])({
      theme: theme,
      target: target,
      subTarget: 'Label',
      danger: error,
      inverse: inverse
    }),
        labelFocusStyle = _getStylesForStates.focusStyles,
        labelDisabledStyle = _getStylesForStates.disabledStyles,
        labelCheckedStyle = _getStylesForStates.checkedStyles;

    var _getStylesForStates2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__tal_gel_theming__["getStylesForStates"])({
      theme: theme,
      target: target,
      subTarget: 'TickBox',
      danger: error,
      inverse: inverse,
      otherProps: {
        labelLeft: labelLeft
      }
    }),
        tickBoxFocusStyle = _getStylesForStates2.focusStyles,
        tickBoxDisabledStyle = _getStylesForStates2.disabledStyles,
        tickBoxCheckedStyle = _getStylesForStates2.checkedStyles,
        tickBoxIndeterminateStyle = _getStylesForStates2.indeterminateStyles;

    var _getStylesForStates3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__tal_gel_theming__["getStylesForStates"])({
      theme: theme,
      target: target,
      subTarget: 'TickButton',
      danger: error,
      inverse: inverse
    }),
        tickButtonDisabledStyle = _getStylesForStates3.disabledStyles,
        tickButtonCheckedStyle = _getStylesForStates3.checkedStyles;

    var _getStylesForStates4 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__tal_gel_theming__["getStylesForStates"])({
      theme: theme,
      target: 'Button',
      subTarget: 'Toggle',
      danger: error,
      inverse: inverse
    }),
        buttonActiveStyle = _getStylesForStates4.activeStyles;

    return _objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_6__tal_gel_core__["accessibleHiddenStyle"]), !button ? {
      // if the checkbox or radio box is non-button looking  
      ':checked + * > label svg': {
        // show the checked icon when checked
        opacity: '1 !important'
      },
      ':checked + * > label': labelCheckedStyle,
      ':checked + *': alternativeButton && tickButtonCheckedStyle,
      ':checked + * > label::before': tickBoxCheckedStyle,
      ':indeterminate + * > label svg': target === 'Checkbox' ? {
        opacity: '1 !important' // show the indeterminate icon when indeterminate

      } : null,
      // ignore for radio boxes, as radio boxes will also be in indeterminate state if no radio in the group is selected
      ':indeterminate + * > label::before': target === 'Checkbox' ? tickBoxIndeterminateStyle : null,
      ':focus + * > label': !focusByClick ? _objectSpread({}, labelFocusStyle) : null,
      // ignore the focus style if focused by mouse click
      ':focus + * > label::before': !focusByClick ? _objectSpread({}, tickBoxFocusStyle) : null,
      // ignore the focus style if focused by mouse click
      ':disabled + * > label': labelDisabledStyle,
      ':disabled + *': alternativeButton && tickButtonDisabledStyle,
      ':disabled + * > label::before': tickBoxDisabledStyle,
      ':checked:disabled + * > label::before': alternativeButton && _objectSpread(_objectSpread({}, tickBoxCheckedStyle), tickBoxDisabledStyle.Disabled),
      ':checked:disabled + *': alternativeButton && _objectSpread(_objectSpread({}, tickButtonCheckedStyle), tickButtonCheckedStyle.Disabled)
    } : {
      // if the checkbox or radio box is button looking
      ':checked + button': buttonActiveStyle
      /**
       * ignore `:indeterminate` as button looking checkboxes do not support indeterminate state
       * ignore `:focus` as the button component in button looking checkboxes or radio boxes can handle focus state by itself
       * ignore `:disabled` as the button component in button looking checkboxes or radio boxes can handle disabled state by itself,
       *        and `disabled` will be passed into the button component as a prop 
       */

    });
  });
  /**
   * Container to wrap up elements/components that make up a checkbox or radio box
   */


  var CrContainer = __WEBPACK_IMPORTED_MODULE_5__emotion_styled___default.a.div({
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0
  }, function (_ref2) {
    var groupContext = _ref2.groupContext,
        style = _ref2.style,
        buttonsPerRow = _ref2.buttonsPerRow,
        isOnLastRow = _ref2.isOnLastRow,
        isOnRightMostCol = _ref2.isOnRightMostCol; // buttons in the button group should be adjacent to each other with no gaps in between

    if (inButtonGroup(groupContext)) {
      return !groupContext.vertical ? _objectSpread({
        // horizontal button group
        flexGrow: 1,
        // allow no gaps in between buttons
        ':first-of-type button': {
          borderRight: 'none !important',
          borderTopRightRadius: '0 !important',
          borderBottomRightRadius: '0 !important'
        },
        ':not(:first-of-type):not(:last-of-type) button': {
          borderRight: 'none !important',
          borderRadius: '0 !important'
        },
        ':last-of-type button': {
          borderTopLeftRadius: '0 !important',
          borderBottomLeftRadius: '0 !important'
        }
      }, style) : _objectSpread({
        // vertical button group
        flexGrow: 1,
        // allow no gaps in between buttons
        ':first-of-type button': {
          borderBottom: 'none !important',
          borderBottomRightRadius: '0 !important',
          borderBottomLeftRadius: '0 !important',
          height: '100%'
        },
        ':not(:first-of-type):not(:last-of-type) button': {
          borderBottom: 'none !important',
          borderRadius: '0 !important',
          height: '100%'
        },
        ':last-of-type button': {
          borderTopLeftRadius: '0 !important',
          borderTopRightRadius: '0 !important',
          height: '100%'
        }
      }, style);
    } else if (groupContext.gutterWidth) {
      return _objectSpread({}, buttonsPerRow ? _objectSpread(_objectSpread({
        // new button style
        flexBasis: "calc((100% - ".concat((buttonsPerRow - 1) * groupContext.gutterWidth, "px) / ").concat(buttonsPerRow, ")")
      }, !isOnLastRow && {
        marginBottom: groupContext.gutterWidth
      }), !isOnRightMostCol && {
        marginRight: groupContext.gutterWidth
      }) : _objectSpread({
        ':not(:last-child)': __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()({}, "margin".concat(groupContext.vertical ? 'Bottom' : 'Right'), groupContext.gutterWidth)
      }, style));
    }
  });
  /**
   * Checks if a checkbox or radio box is in a button group
   * 
   * A button group can either be a <CheckboxGroup buttonGroup> or a <RadioGroup buttonGroup>
   * All checkboxes in <CheckboxGroup buttonGroup> and all radio boxes in <RadioGroup buttonGroup> 
   * should be button looking AND they should be adjacent to each other either horizontally or vertically
   * 
   * @param groupContext can either be a checkbox group context or radio group context
   */


  var inButtonGroup = function inButtonGroup(groupContext) {
    return Object.entries(groupContext).length > 0 && groupContext.buttonGroup;
  };
  /**
   * Label component consisting of label and icon (checked or indeterminate state), 
   * for a non-button looking checkbox or radio box
   */


  var CrLabel = function CrLabel(_ref3) {
    var id = _ref3.id,
        theme = _ref3.theme,
        target = _ref3.target,
        inverse = _ref3.inverse,
        error = _ref3.error,
        disabled = _ref3.disabled,
        indeterminate = _ref3.indeterminate,
        alternativeButton = _ref3.alternativeButton,
        labelLeft = _ref3.labelLeft,
        caption = _ref3.caption,
        children = _ref3.children,
        onClick = _ref3.onClick;
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(LabelWrapper // for the new button style
    , {
      alternativeButton: alternativeButton,
      theme: theme,
      target: target,
      error: error,
      inverse: inverse
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(StyledLabel, {
      "data-cy": "gel-cr-label",
      htmlFor: id,
      theme: theme,
      target: target,
      onClick: onClick,
      error: error,
      disabled: disabled,
      inverse: inverse,
      alternativeButton: alternativeButton,
      labelLeft: labelLeft
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__icon__["a"
    /* Icon */
    ], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({}, getIconProps({
      theme: theme,
      target: target,
      inverse: inverse,
      error: error,
      indeterminate: indeterminate,
      disabled: disabled,
      labelLeft: labelLeft
    }), {
      "float": true,
      hide: true,
      transitionDuration: theme[target].transitionDuration
    })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__layout__["c"
    /* RowLayout */
    ], null, children, caption && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(StyledIndividualCaption, {
      theme: theme,
      target: target,
      error: error,
      inverse: inverse
    }, caption)))));
  };

  var StyledIndividualCaption = __WEBPACK_IMPORTED_MODULE_5__emotion_styled___default.a.div(function (_ref4) {
    var theme = _ref4.theme,
        target = _ref4.target,
        error = _ref4.error,
        inverse = _ref4.inverse;

    var _getStylesForStates5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__tal_gel_theming__["getStylesForStates"])({
      theme: theme,
      target: target,
      subTarget: 'Caption',
      danger: error,
      inverse: inverse
    }),
        normalStyles = _getStylesForStates5.normalStyles;

    return _objectSpread(_objectSpread({}, normalStyles), {}, {
      marginTop: 0
    });
  });

  var LabelWrapper = __WEBPACK_IMPORTED_MODULE_5__emotion_styled___default.a.div(function (_ref5) {
    var theme = _ref5.theme,
        target = _ref5.target,
        error = _ref5.error,
        inverse = _ref5.inverse,
        alternativeButton = _ref5.alternativeButton;

    if (alternativeButton) {
      var _getStylesForStates6 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__tal_gel_theming__["getStylesForStates"])({
        theme: theme,
        target: target,
        subTarget: 'TickButton',
        danger: error,
        inverse: inverse
      }),
          tickButtonNormalStyle = _getStylesForStates6.normalStyles;

      return tickButtonNormalStyle;
    }
  });
  /**
   * The label element used by non-button looking checkboxes and radio boxes
   */


  var StyledLabel = __WEBPACK_IMPORTED_MODULE_5__emotion_styled___default.a.label({
    // consistent checkbox and radio box label styles across all brands
    position: 'relative',
    display: 'flex !important',
    // Resolves issues in some existing applications with `.tac-css label`
    outline: 'none',
    cursor: 'pointer',
    '::before': {
      content: '""',
      flexShrink: 0 // do not squeeze the tick box even if space is not enough

    }
  }, function (_ref6) {
    var theme = _ref6.theme,
        target = _ref6.target,
        error = _ref6.error,
        inverse = _ref6.inverse,
        alternativeButton = _ref6.alternativeButton,
        labelLeft = _ref6.labelLeft;

    var _getStylesForStates7 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__tal_gel_theming__["getStylesForStates"])({
      theme: theme,
      target: target,
      subTarget: 'Label',
      danger: error,
      inverse: inverse
    }),
        labelNormalStyle = _getStylesForStates7.normalStyles,
        labelHoverStyle = _getStylesForStates7.hoverStyles,
        labelActiveStyle = _getStylesForStates7.activeStyles;

    var _getStylesForStates8 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__tal_gel_theming__["getStylesForStates"])({
      theme: theme,
      target: target,
      subTarget: 'TickBox',
      danger: error,
      inverse: inverse,
      otherProps: {
        labelLeft: labelLeft
      }
    }),
        tickBoxNormalStyle = _getStylesForStates8.normalStyles,
        tickBoxHoverStyle = _getStylesForStates8.hoverStyles,
        tickBoxActiveStyle = _getStylesForStates8.activeStyles;

    return _objectSpread(_objectSpread(_objectSpread(_objectSpread({
      alignItems: 'flex-start'
    }, alternativeButton && {
      // enlarge the clickable area
      width: '100%',
      height: '100%'
    }), labelLeft && {
      flexDirection: 'row-reverse',
      justifyContent: 'space-between'
    }), labelNormalStyle), {}, {
      '::before': tickBoxNormalStyle,
      ':hover': _objectSpread(_objectSpread({}, labelHoverStyle), {}, {
        '::before': tickBoxHoverStyle
      }),
      ':active': _objectSpread(_objectSpread({}, labelActiveStyle), {}, {
        '::before': tickBoxActiveStyle
      })
    });
  });
  /**
   * `error`, `inverse` and `disabled` statues can be at the group level
   * If such a status is at the group level, it will apply to all the checkboxes or radio boxes in that group
   * If the status is not at the group level but on a checkbox or radio box in that group, that status is applied
   * to that individual checkbox or radio box
   */


  var getGroupRelatedProps = function getGroupRelatedProps(_ref7) {
    var error = _ref7.error,
        inverse = _ref7.inverse,
        disabled = _ref7.disabled,
        groupContext = _ref7.groupContext;
    return _objectSpread(_objectSpread(_objectSpread({}, (error || groupContext && groupContext.error) && {
      error: true
    }), (inverse || groupContext && groupContext.inverse) && {
      inverse: true
    }), (disabled || groupContext && groupContext.disabled) && {
      disabled: true
    });
  };
  /**
   * Gets the icon props such as name, width, height, color, left, top, etc.
   * For a radio box, indeterminate will always be falsy
   */


  var getIconProps = function getIconProps(_ref8) {
    var theme = _ref8.theme,
        target = _ref8.target,
        inverse = _ref8.inverse,
        error = _ref8.error,
        indeterminate = _ref8.indeterminate,
        disabled = _ref8.disabled,
        labelLeft = _ref8.labelLeft;

    var _getStylesForStates9 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__tal_gel_theming__["getStylesForStates"])({
      theme: theme,
      target: target,
      subTarget: 'TickMark',
      danger: error,
      inverse: inverse,
      otherProps: {
        labelLeft: labelLeft
      }
    }),
        iconNormalStyle = _getStylesForStates9.normalStyles,
        iconDisabledStyle = _getStylesForStates9.disabledStyles,
        iconIndeterminateStyle = _getStylesForStates9.indeterminateStyles;

    if (disabled) {
      return iconDisabledStyle;
    } else if (indeterminate) {
      return iconIndeterminateStyle;
    }

    return iconNormalStyle;
  };
  /**
   * Button component for a button-looking checkbox or radio box
   */


  var CrButton = function CrButton(_ref9) {
    var id = _ref9.id,
        checkbox = _ref9.checkbox,
        groupContext = _ref9.groupContext,
        onClick = _ref9.onClick,
        error = _ref9.error,
        props = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default()(_ref9, _excluded);

    var labelRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useRef"])();

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__button__["a"
    /* default */
    ], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
      "data-cy": "gel-cr-button",
      tabIndex: "-1"
    }, checkbox ? {
      checkbox: true
    } : {
      radio: true
    }, {
      // button type: checkbox or radio
      medium: true // button size

    }, inButtonGroup(groupContext) && {
      stretch: true
    }, {
      onClick: function onClick() {
        return labelRef.current.click();
      } // click the hidden label (for accessibility)
      ,
      danger: error
    }, props)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("label", {
      // hidden label to mimic a tranditional label styled checkbox or radio box
      htmlFor: id,
      style: _objectSpread({}, __WEBPACK_IMPORTED_MODULE_6__tal_gel_core__["accessibleHiddenStyle"]) // hide the label
      ,
      ref: labelRef,
      onClick: onClick
    }));
  };
  /**
   * Provides some common states, event hanlders, etc. for checkbox and radio box
   */


  var useCrCommon = function useCrCommon(_ref10) {
    var groupContext = _ref10.groupContext,
        error = _ref10.error,
        inverse = _ref10.inverse,
        disabled = _ref10.disabled,
        onFocus = _ref10.onFocus,
        onBlur = _ref10.onBlur,
        buttonLooking = _ref10.buttonLooking,
        forwardedRef = _ref10.forwardedRef;

    var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useState"])(false),
        _useState2 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default()(_useState, 2),
        focusByClick = _useState2[0],
        setFocusByClick = _useState2[1];

    var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useState"])(false),
        _useState4 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default()(_useState3, 2),
        buttonCosmeticFocus = _useState4[0],
        setButtonCosmeticFocus = _useState4[1];

    var ignoreCosmeticFocus = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useRef"])(false);

    var inputRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useRef"])();

    var getInputRef = function getInputRef() {
      return forwardedRef || inputRef;
    };
    /**
     * Get group related props such as error, inverse, disabled, etc.
     * These props can either be set at the individual level or at the group level
     */


    var groupRelatedProps = getGroupRelatedProps({
      groupContext: groupContext,
      error: error,
      inverse: inverse,
      disabled: disabled
    });

    var _onFocus = function _onFocus(event) {
      /**
       * If the hidden input is on focus, and if this checkbox or radio box is button looking,
       * we set whether or not we want to have the button in the cosmetic focus state
       * We typically ignore button cosmetic focus if the hidden input is on focus by mouse click 
       * (As there is a hidden label inside the button, clicking the button will ultimately cause the hidden input to be clicked)
       * If the hidden input is on focus by keyboard (TAB), we will have the button in the cosmetic focus state
       * to display the focus style
       * 
       * The cosmetic focus state is when the button shows focus style while not in the actual focus state
       * The actual focus state will be on the hidden input for the checkbox or radio box, for better accessibility
       */
      buttonLooking && setButtonCosmeticFocus(!ignoreCosmeticFocus.current);
      onFocus && onFocus(event); // call onFocus handler provided by the parent component
    };

    var _onBlur = function _onBlur(event) {
      setFocusByClick(false); // indicate that the checkbox is not focused by mouse click

      setButtonCosmeticFocus(false); // indicate that the button is not in the cosmetic focus state

      setIgnoreCosmeticFocus(false); // indicate that we do not ignore cosmetic focus on button

      onBlur && onBlur(event); // call onBlur handler provided by the parent component
    };

    var setIgnoreCosmeticFocus = function setIgnoreCosmeticFocus(ignore) {
      ignoreCosmeticFocus.current = ignore;
    };

    return {
      focusByClick: focusByClick,
      setFocusByClick: setFocusByClick,
      buttonCosmeticFocus: buttonCosmeticFocus,
      setIgnoreCosmeticFocus: setIgnoreCosmeticFocus,
      getInputRef: getInputRef,
      groupRelatedProps: groupRelatedProps,
      _onFocus: _onFocus,
      _onBlur: _onBlur
    };
  };
  /**
   * Checks if a (boolean) state of checkbox or radio box is controlled by the parent component
   * Typical use of it would be to check if states such as `checked`, `indeterminate` are controlled
   */


  var isControlledState = function isControlledState(prop) {
    return prop === true || prop === false;
  };

  var GROUP_ON_BLUR_TIMEOUT = 300;

  var useCrContext = function useCrContext(_ref11) {
    var theme = _ref11.theme,
        vertical = _ref11.vertical,
        width = _ref11.width,
        height = _ref11.height,
        gap = _ref11.gap,
        alternativeButtons = _ref11.alternativeButtons; // Indicates whether all checkboxes/radioboxes in the group have lost focus
    // Note that if the focus shifts from one checkbox/radiobox to another in the same group, 
    // this group is still considered on focus

    var groupOnBlur = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useRef"])(false);

    var isUnmountedRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__tal_gel_core__["useIsUnmounted"])();

    var shouldIgnoreGutterWidth = function shouldIgnoreGutterWidth() {
      return !alternativeButtons && (!vertical && width || vertical && height);
    };

    var _useContext = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_11__grid_screen_detector__["a"
    /* ScreenDetectorContext */
    ]),
        gridGutters = _useContext.gridGutters;

    var gutterWidth = null;

    if (!shouldIgnoreGutterWidth()) {
      if (vertical && gap === undefined) {
        // If gap is not specified in vertical group, use the default
        gutterWidth = theme.Checkbox.defaultGapInVerticalGroup;
      } else {
        gutterWidth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__layout_container_lite__["a"
        /* getGutter */
        ])(gridGutters, gap);
      }
    }
    /**
     * callback when individual checkbox/radiobox loses focus
     */


    var onBlurGenerator = function onBlurGenerator(onBlurFromValidator) {
      return function () {
        groupOnBlur.current = true; // assume the entire group has lost focus
        // Wait and check if another checkbox/radiobox in the same group gets focus 
        // as a result of this `onBlur`, see `onFocus`.

        var timer = setTimeout(function () {
          if (!isUnmountedRef.current && groupOnBlur.current) {
            onBlurFromValidator(); // call `onBlur` from validator, if the entire group has lost focus
          }

          clearTimeout(timer);
        }, GROUP_ON_BLUR_TIMEOUT);
      };
    };
    /**
     * callback when individual checkbox/radiobox gets focus
     */


    var onFocus = function onFocus() {
      // The group is considered on focus if any of its contained 
      // checkboxes/radioboxes gets focus
      groupOnBlur.current = false;
    };
    /**
     * Generator to generate callback for when the `checked` status of 
     * individual checkbox/radiobox changes
     */


    var onChangeGenerator = function onChangeGenerator(groupChecked, onChangeFromValidator, onChange) {
      return (// this `index` is index of the individual checkbox/radiobox inside the group
        function (index, checked) {
          var skipOnChange = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
          var event = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
          groupChecked.current[index] = checked; // store its `checked` status 

          if (!skipOnChange) {
            onChangeFromValidator(null, true);
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__tal_gel_core__["isFunction"])(onChange) && onChange(event); // TODO: not used? onChange always null
          }
        }
      );
    };

    return {
      onBlurGenerator: onBlurGenerator,
      onFocus: onFocus,
      onChangeGenerator: onChangeGenerator,
      gutterWidth: gutterWidth,
      shouldIgnoreGutterWidth: shouldIgnoreGutterWidth
    };
  }; // for non-adjacent checkbox or radio buttons (new button style)


  var useButtonLocationInGroup = function useButtonLocationInGroup(buttonsPerRow, children) {
    var totalNumOfButtons = __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.count(children);

    var buttonsOnLastRow = totalNumOfButtons % buttonsPerRow || buttonsPerRow;

    var isOnLastRow = function isOnLastRow(index) {
      return totalNumOfButtons - index <= buttonsOnLastRow;
    };

    var isOnRightMostCol = function isOnRightMostCol(index) {
      return (index + 1) % buttonsPerRow === 0;
    };

    return {
      isOnLastRow: isOnLastRow,
      isOnRightMostCol: isOnRightMostCol
    };
  };
  /***/

},
/* 68 */

/***/
function (module, exports, __webpack_require__) {
  var uncurryThis = __webpack_require__(3);

  module.exports = uncurryThis([].slice);
  /***/
},
/* 69 */

/***/
function (module, exports, __webpack_require__) {
  var classof = __webpack_require__(38);

  var global = __webpack_require__(1);

  module.exports = classof(global.process) == 'process';
  /***/
},
/* 70 */

/***/
function (module, exports, __webpack_require__) {
  var $ = __webpack_require__(0);

  var uncurryThis = __webpack_require__(3);

  var hiddenKeys = __webpack_require__(91);

  var isObject = __webpack_require__(13);

  var hasOwn = __webpack_require__(21);

  var defineProperty = __webpack_require__(20).f;

  var getOwnPropertyNamesModule = __webpack_require__(65);

  var getOwnPropertyNamesExternalModule = __webpack_require__(158);

  var isExtensible = __webpack_require__(120);

  var uid = __webpack_require__(82);

  var FREEZING = __webpack_require__(88);

  var REQUIRED = false;
  var METADATA = uid('meta');
  var id = 0;

  var setMetadata = function setMetadata(it) {
    defineProperty(it, METADATA, {
      value: {
        objectID: 'O' + id++,
        // object ID
        weakData: {} // weak collections IDs

      }
    });
  };

  var fastKey = function fastKey(it, create) {
    // return a primitive with prefix
    if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;

    if (!hasOwn(it, METADATA)) {
      // can't set metadata to uncaught frozen object
      if (!isExtensible(it)) return 'F'; // not necessary to add metadata

      if (!create) return 'E'; // add missing metadata

      setMetadata(it); // return object ID
    }

    return it[METADATA].objectID;
  };

  var getWeakData = function getWeakData(it, create) {
    if (!hasOwn(it, METADATA)) {
      // can't set metadata to uncaught frozen object
      if (!isExtensible(it)) return true; // not necessary to add metadata

      if (!create) return false; // add missing metadata

      setMetadata(it); // return the store of weak collections IDs
    }

    return it[METADATA].weakData;
  }; // add metadata on freeze-family methods calling


  var onFreeze = function onFreeze(it) {
    if (FREEZING && REQUIRED && isExtensible(it) && !hasOwn(it, METADATA)) setMetadata(it);
    return it;
  };

  var enable = function enable() {
    meta.enable = function () {
      /* empty */
    };

    REQUIRED = true;
    var getOwnPropertyNames = getOwnPropertyNamesModule.f;
    var splice = uncurryThis([].splice);
    var test = {};
    test[METADATA] = 1; // prevent exposing of metadata key

    if (getOwnPropertyNames(test).length) {
      getOwnPropertyNamesModule.f = function (it) {
        var result = getOwnPropertyNames(it);

        for (var i = 0, length = result.length; i < length; i++) {
          if (result[i] === METADATA) {
            splice(result, i, 1);
            break;
          }
        }

        return result;
      };

      $({
        target: 'Object',
        stat: true,
        forced: true
      }, {
        getOwnPropertyNames: getOwnPropertyNamesExternalModule.f
      });
    }
  };

  var meta = module.exports = {
    enable: enable,
    fastKey: fastKey,
    getWeakData: getWeakData,
    onFreeze: onFreeze
  };
  hiddenKeys[METADATA] = true;
  /***/
},
/* 71 */

/***/
function (module, exports, __webpack_require__) {
  var classof = __webpack_require__(38); // `IsArray` abstract operation
  // https://tc39.es/ecma262/#sec-isarray
  // eslint-disable-next-line es/no-array-isarray -- safe


  module.exports = Array.isArray || function isArray(argument) {
    return classof(argument) == 'Array';
  };
  /***/

},
/* 72 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var anObject = __webpack_require__(10); // `RegExp.prototype.flags` getter implementation
  // https://tc39.es/ecma262/#sec-get-regexp.prototype.flags


  module.exports = function () {
    var that = anObject(this);
    var result = '';
    if (that.global) result += 'g';
    if (that.ignoreCase) result += 'i';
    if (that.multiline) result += 'm';
    if (that.dotAll) result += 's';
    if (that.unicode) result += 'u';
    if (that.sticky) result += 'y';
    return result;
  };
  /***/

},
/* 73 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__column_layout__ = __webpack_require__(309);
  /* harmony namespace reexport (by used) */


  __webpack_require__.d(__webpack_exports__, "a", function () {
    return __WEBPACK_IMPORTED_MODULE_0__column_layout__["a"];
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__box_layout__ = __webpack_require__(137);
  /* harmony namespace reexport (by used) */


  __webpack_require__.d(__webpack_exports__, "b", function () {
    return __WEBPACK_IMPORTED_MODULE_1__box_layout__["a"];
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__row_layout__ = __webpack_require__(189);
  /* harmony namespace reexport (by used) */


  __webpack_require__.d(__webpack_exports__, "c", function () {
    return __WEBPACK_IMPORTED_MODULE_2__row_layout__["a"];
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__page_layout__ = __webpack_require__(134);
  /* harmony namespace reexport (by used) */


  __webpack_require__.d(__webpack_exports__, "f", function () {
    return __WEBPACK_IMPORTED_MODULE_3__page_layout__["b"];
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4__container_lite__ = __webpack_require__(62);
  /* harmony namespace reexport (by used) */


  __webpack_require__.d(__webpack_exports__, "d", function () {
    return __WEBPACK_IMPORTED_MODULE_4__container_lite__["b"];
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__card_layout__ = __webpack_require__(308);
  /* harmony namespace reexport (by used) */


  __webpack_require__.d(__webpack_exports__, "e", function () {
    return __WEBPACK_IMPORTED_MODULE_5__card_layout__["a"];
  });
  /***/

},
/* 74 */

/***/
function (module, exports, __webpack_require__) {
  var DESCRIPTORS = __webpack_require__(12);

  var hasOwn = __webpack_require__(21);

  var FunctionPrototype = Function.prototype; // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe

  var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;
  var EXISTS = hasOwn(FunctionPrototype, 'name'); // additional protection from minified / mangled / dropped function names

  var PROPER = EXISTS && function something() {
    /* empty */
  }.name === 'something';

  var CONFIGURABLE = EXISTS && (!DESCRIPTORS || DESCRIPTORS && getDescriptor(FunctionPrototype, 'name').configurable);
  module.exports = {
    EXISTS: EXISTS,
    PROPER: PROPER,
    CONFIGURABLE: CONFIGURABLE
  };
  /***/
},
/* 75 */

/***/
function (module, exports, __webpack_require__) {
  var isCallable = __webpack_require__(17);

  var isObject = __webpack_require__(13);

  var setPrototypeOf = __webpack_require__(52); // makes subclassing work correct for wrapped built-ins


  module.exports = function ($this, dummy, Wrapper) {
    var NewTarget, NewTargetPrototype;
    if ( // it can work only with native `setPrototypeOf`
    setPrototypeOf && // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    isCallable(NewTarget = dummy.constructor) && NewTarget !== Wrapper && isObject(NewTargetPrototype = NewTarget.prototype) && NewTargetPrototype !== Wrapper.prototype) setPrototypeOf($this, NewTargetPrototype);
    return $this;
  };
  /***/

},
/* 76 */

/***/
function (module, exports, __webpack_require__) {
  var uncurryThis = __webpack_require__(3);

  var fails = __webpack_require__(2);

  var isCallable = __webpack_require__(17);

  var classof = __webpack_require__(63);

  var getBuiltIn = __webpack_require__(26);

  var inspectSource = __webpack_require__(117);

  var noop = function noop() {
    /* empty */
  };

  var empty = [];
  var construct = getBuiltIn('Reflect', 'construct');
  var constructorRegExp = /^\s*(?:class|function)\b/;
  var exec = uncurryThis(constructorRegExp.exec);
  var INCORRECT_TO_STRING = !constructorRegExp.exec(noop);

  var isConstructorModern = function isConstructor(argument) {
    if (!isCallable(argument)) return false;

    try {
      construct(noop, empty, argument);
      return true;
    } catch (error) {
      return false;
    }
  };

  var isConstructorLegacy = function isConstructor(argument) {
    if (!isCallable(argument)) return false;

    switch (classof(argument)) {
      case 'AsyncFunction':
      case 'GeneratorFunction':
      case 'AsyncGeneratorFunction':
        return false;
    }

    try {
      // we can't check .prototype since constructors produced by .bind haven't it
      // `Function#toString` throws on some built-it function in some legacy engines
      // (for example, `DOMQuad` and similar in FF41-)
      return INCORRECT_TO_STRING || !!exec(constructorRegExp, inspectSource(argument));
    } catch (error) {
      return true;
    }
  };

  isConstructorLegacy.sham = true; // `IsConstructor` abstract operation
  // https://tc39.es/ecma262/#sec-isconstructor

  module.exports = !construct || fails(function () {
    var called;
    return isConstructorModern(isConstructorModern.call) || !isConstructorModern(Object) || !isConstructorModern(function () {
      called = true;
    }) || called;
  }) ? isConstructorLegacy : isConstructorModern;
  /***/
},
/* 77 */

/***/
function (module, exports, __webpack_require__) {
  var global = __webpack_require__(1);

  var getBuiltIn = __webpack_require__(26);

  var isCallable = __webpack_require__(17);

  var isPrototypeOf = __webpack_require__(42);

  var USE_SYMBOL_AS_UID = __webpack_require__(235);

  var Object = global.Object;
  module.exports = USE_SYMBOL_AS_UID ? function (it) {
    return typeof it == 'symbol';
  } : function (it) {
    var $Symbol = getBuiltIn('Symbol');
    return isCallable($Symbol) && isPrototypeOf($Symbol.prototype, Object(it));
  };
  /***/
},
/* 78 */

/***/
function (module, exports, __webpack_require__) {
  var redefine = __webpack_require__(24);

  module.exports = function (target, src, options) {
    for (var key in src) {
      redefine(target, key, src[key], options);
    }

    return target;
  };
  /***/

},
/* 79 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var getBuiltIn = __webpack_require__(26);

  var definePropertyModule = __webpack_require__(20);

  var wellKnownSymbol = __webpack_require__(15);

  var DESCRIPTORS = __webpack_require__(12);

  var SPECIES = wellKnownSymbol('species');

  module.exports = function (CONSTRUCTOR_NAME) {
    var Constructor = getBuiltIn(CONSTRUCTOR_NAME);
    var defineProperty = definePropertyModule.f;

    if (DESCRIPTORS && Constructor && !Constructor[SPECIES]) {
      defineProperty(Constructor, SPECIES, {
        configurable: true,
        get: function get() {
          return this;
        }
      });
    }
  };
  /***/

},
/* 80 */

/***/
function (module, exports, __webpack_require__) {
  var anObject = __webpack_require__(10);

  var aConstructor = __webpack_require__(141);

  var wellKnownSymbol = __webpack_require__(15);

  var SPECIES = wellKnownSymbol('species'); // `SpeciesConstructor` abstract operation
  // https://tc39.es/ecma262/#sec-speciesconstructor

  module.exports = function (O, defaultConstructor) {
    var C = anObject(O).constructor;
    var S;
    return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? defaultConstructor : aConstructor(S);
  };
  /***/

},
/* 81 */

/***/
function (module, exports, __webpack_require__) {
  var uncurryThis = __webpack_require__(3);

  var requireObjectCoercible = __webpack_require__(28);

  var toString = __webpack_require__(18);

  var whitespaces = __webpack_require__(131);

  var replace = uncurryThis(''.replace);
  var whitespace = '[' + whitespaces + ']';
  var ltrim = RegExp('^' + whitespace + whitespace + '*');
  var rtrim = RegExp(whitespace + whitespace + '*$'); // `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation

  var createMethod = function createMethod(TYPE) {
    return function ($this) {
      var string = toString(requireObjectCoercible($this));
      if (TYPE & 1) string = replace(string, ltrim, '');
      if (TYPE & 2) string = replace(string, rtrim, '');
      return string;
    };
  };

  module.exports = {
    // `String.prototype.{ trimLeft, trimStart }` methods
    // https://tc39.es/ecma262/#sec-string.prototype.trimstart
    start: createMethod(1),
    // `String.prototype.{ trimRight, trimEnd }` methods
    // https://tc39.es/ecma262/#sec-string.prototype.trimend
    end: createMethod(2),
    // `String.prototype.trim` method
    // https://tc39.es/ecma262/#sec-string.prototype.trim
    trim: createMethod(3)
  };
  /***/
},
/* 82 */

/***/
function (module, exports, __webpack_require__) {
  var uncurryThis = __webpack_require__(3);

  var id = 0;
  var postfix = Math.random();
  var toString = uncurryThis(1.0.toString);

  module.exports = function (key) {
    return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
  };
  /***/

},
/* 83 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
  /* harmony default export */


  __webpack_exports__["a"] = function (getCaption) {
    var caption = getCaption();
    return caption && caption.length > 0 && caption.map(function (line, index) {
      return line && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "caption",
        key: index
      }, line);
    });
  };
  /***/

},
/* 84 */

/***/
function (module, exports, __webpack_require__) {
  var toIndexedObject = __webpack_require__(37);

  var toAbsoluteIndex = __webpack_require__(60);

  var lengthOfArrayLike = __webpack_require__(23); // `Array.prototype.{ indexOf, includes }` methods implementation


  var createMethod = function createMethod(IS_INCLUDES) {
    return function ($this, el, fromIndex) {
      var O = toIndexedObject($this);
      var length = lengthOfArrayLike(O);
      var index = toAbsoluteIndex(fromIndex, length);
      var value; // Array#includes uses SameValueZero equality algorithm
      // eslint-disable-next-line no-self-compare -- NaN check

      if (IS_INCLUDES && el != el) while (length > index) {
        value = O[index++]; // eslint-disable-next-line no-self-compare -- NaN check

        if (value != value) return true; // Array#indexOf ignores holes, Array#includes - not
      } else for (; length > index; index++) {
        if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
      }
      return !IS_INCLUDES && -1;
    };
  };

  module.exports = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: createMethod(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: createMethod(false)
  };
  /***/
},
/* 85 */

/***/
function (module, exports, __webpack_require__) {
  var fails = __webpack_require__(2);

  var wellKnownSymbol = __webpack_require__(15);

  var V8_VERSION = __webpack_require__(64);

  var SPECIES = wellKnownSymbol('species');

  module.exports = function (METHOD_NAME) {
    // We can't use this feature detection in V8 since it causes
    // deoptimization and serious performance degradation
    // https://github.com/zloirock/core-js/issues/677
    return V8_VERSION >= 51 || !fails(function () {
      var array = [];
      var constructor = array.constructor = {};

      constructor[SPECIES] = function () {
        return {
          foo: 1
        };
      };

      return array[METHOD_NAME](Boolean).foo !== 1;
    });
  };
  /***/

},
/* 86 */

/***/
function (module, exports, __webpack_require__) {
  var global = __webpack_require__(1);

  var toAbsoluteIndex = __webpack_require__(60);

  var lengthOfArrayLike = __webpack_require__(23);

  var createProperty = __webpack_require__(56);

  var Array = global.Array;
  var max = Math.max;

  module.exports = function (O, start, end) {
    var length = lengthOfArrayLike(O);
    var k = toAbsoluteIndex(start, length);
    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
    var result = Array(max(fin - k, 0));

    for (var n = 0; k < fin; k++, n++) {
      createProperty(result, n, O[k]);
    }

    result.length = n;
    return result;
  };
  /***/

},
/* 87 */

/***/
function (module, exports, __webpack_require__) {
  var arraySpeciesConstructor = __webpack_require__(344); // `ArraySpeciesCreate` abstract operation
  // https://tc39.es/ecma262/#sec-arrayspeciescreate


  module.exports = function (originalArray, length) {
    return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
  };
  /***/

},
/* 88 */

/***/
function (module, exports, __webpack_require__) {
  var fails = __webpack_require__(2);

  module.exports = !fails(function () {
    // eslint-disable-next-line es/no-object-isextensible, es/no-object-preventextensions -- required for testing
    return Object.isExtensible(Object.preventExtensions({}));
  });
  /***/
},
/* 89 */

/***/
function (module, exports, __webpack_require__) {
  var fails = __webpack_require__(2);

  module.exports = !fails(function () {
    var test = function () {
      /* empty */
    }.bind(); // eslint-disable-next-line no-prototype-builtins -- safe


    return typeof test != 'function' || test.hasOwnProperty('prototype');
  });
  /***/
},
/* 90 */

/***/
function (module, exports, __webpack_require__) {
  var classof = __webpack_require__(63);

  var getMethod = __webpack_require__(58);

  var Iterators = __webpack_require__(95);

  var wellKnownSymbol = __webpack_require__(15);

  var ITERATOR = wellKnownSymbol('iterator');

  module.exports = function (it) {
    if (it != undefined) return getMethod(it, ITERATOR) || getMethod(it, '@@iterator') || Iterators[classof(it)];
  };
  /***/

},
/* 91 */

/***/
function (module, exports) {
  module.exports = {};
  /***/
},
/* 92 */

/***/
function (module, exports, __webpack_require__) {
  var global = __webpack_require__(1);

  var uncurryThis = __webpack_require__(3);

  var fails = __webpack_require__(2);

  var classof = __webpack_require__(38);

  var Object = global.Object;
  var split = uncurryThis(''.split); // fallback for non-array-like ES3 and non-enumerable old V8 strings

  module.exports = fails(function () {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !Object('z').propertyIsEnumerable(0);
  }) ? function (it) {
    return classof(it) == 'String' ? split(it, '') : Object(it);
  } : Object;
  /***/
},
/* 93 */

/***/
function (module, exports, __webpack_require__) {
  var fails = __webpack_require__(2);

  var isCallable = __webpack_require__(17);

  var replacement = /#|\.prototype\./;

  var isForced = function isForced(feature, detection) {
    var value = data[normalize(feature)];
    return value == POLYFILL ? true : value == NATIVE ? false : isCallable(detection) ? fails(detection) : !!detection;
  };

  var normalize = isForced.normalize = function (string) {
    return String(string).replace(replacement, '.').toLowerCase();
  };

  var data = isForced.data = {};
  var NATIVE = isForced.NATIVE = 'N';
  var POLYFILL = isForced.POLYFILL = 'P';
  module.exports = isForced;
  /***/
},
/* 94 */

/***/
function (module, exports, __webpack_require__) {
  var isObject = __webpack_require__(13);

  var classof = __webpack_require__(38);

  var wellKnownSymbol = __webpack_require__(15);

  var MATCH = wellKnownSymbol('match'); // `IsRegExp` abstract operation
  // https://tc39.es/ecma262/#sec-isregexp

  module.exports = function (it) {
    var isRegExp;
    return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classof(it) == 'RegExp');
  };
  /***/

},
/* 95 */

/***/
function (module, exports) {
  module.exports = {};
  /***/
},
/* 96 */

/***/
function (module, exports, __webpack_require__) {
  var toString = __webpack_require__(18);

  module.exports = function (argument, $default) {
    return argument === undefined ? arguments.length < 2 ? '' : $default : toString(argument);
  };
  /***/

},
/* 97 */

/***/
function (module, exports, __webpack_require__) {
  var DESCRIPTORS = __webpack_require__(12);

  var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__(236);

  var definePropertyModule = __webpack_require__(20);

  var anObject = __webpack_require__(10);

  var toIndexedObject = __webpack_require__(37);

  var objectKeys = __webpack_require__(98); // `Object.defineProperties` method
  // https://tc39.es/ecma262/#sec-object.defineproperties
  // eslint-disable-next-line es/no-object-defineproperties -- safe


  exports.f = DESCRIPTORS && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
    anObject(O);
    var props = toIndexedObject(Properties);
    var keys = objectKeys(Properties);
    var length = keys.length;
    var index = 0;
    var key;

    while (length > index) {
      definePropertyModule.f(O, key = keys[index++], props[key]);
    }

    return O;
  };
  /***/
},
/* 98 */

/***/
function (module, exports, __webpack_require__) {
  var internalObjectKeys = __webpack_require__(224);

  var enumBugKeys = __webpack_require__(151); // `Object.keys` method
  // https://tc39.es/ecma262/#sec-object.keys
  // eslint-disable-next-line es/no-object-keys -- safe


  module.exports = Object.keys || function keys(O) {
    return internalObjectKeys(O, enumBugKeys);
  };
  /***/

},
/* 99 */

/***/
function (module, exports, __webpack_require__) {
  var global = __webpack_require__(1);

  var call = __webpack_require__(19);

  var anObject = __webpack_require__(10);

  var isCallable = __webpack_require__(17);

  var classof = __webpack_require__(38);

  var regexpExec = __webpack_require__(123);

  var TypeError = global.TypeError; // `RegExpExec` abstract operation
  // https://tc39.es/ecma262/#sec-regexpexec

  module.exports = function (R, S) {
    var exec = R.exec;

    if (isCallable(exec)) {
      var result = call(exec, R, S);
      if (result !== null) anObject(result);
      return result;
    }

    if (classof(R) === 'RegExp') return call(regexpExec, R, S);
    throw TypeError('RegExp#exec called on incompatible receiver');
  };
  /***/

},
/* 100 */

/***/
function (module, exports, __webpack_require__) {
  var global = __webpack_require__(1);

  var String = global.String;

  module.exports = function (argument) {
    try {
      return String(argument);
    } catch (error) {
      return 'Object';
    }
  };
  /***/

},
/* 101 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__screen_detector__ = __webpack_require__(33);
  /* harmony namespace reexport (by used) */


  __webpack_require__.d(__webpack_exports__, "a", function () {
    return __WEBPACK_IMPORTED_MODULE_0__screen_detector__["b"];
  });
  /* harmony namespace reexport (by used) */


  __webpack_require__.d(__webpack_exports__, "d", function () {
    return __WEBPACK_IMPORTED_MODULE_0__screen_detector__["a"];
  });
  /* harmony namespace reexport (by used) */


  __webpack_require__.d(__webpack_exports__, "e", function () {
    return __WEBPACK_IMPORTED_MODULE_0__screen_detector__["c"];
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__container__ = __webpack_require__(187);
  /* harmony namespace reexport (by used) */


  __webpack_require__.d(__webpack_exports__, "b", function () {
    return __WEBPACK_IMPORTED_MODULE_1__container__["a"];
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__row__ = __webpack_require__(106);
  /* harmony namespace reexport (by used) */


  __webpack_require__.d(__webpack_exports__, "c", function () {
    return __WEBPACK_IMPORTED_MODULE_2__row__["a"];
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__col__ = __webpack_require__(105);
  /* harmony namespace reexport (by used) */


  __webpack_require__.d(__webpack_exports__, "f", function () {
    return __WEBPACK_IMPORTED_MODULE_3__col__["a"];
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4__visible__ = __webpack_require__(305);
  /* harmony namespace reexport (by used) */


  __webpack_require__.d(__webpack_exports__, "g", function () {
    return __WEBPACK_IMPORTED_MODULE_4__visible__["a"];
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__hidden__ = __webpack_require__(303);
  /* harmony namespace reexport (by used) */


  __webpack_require__.d(__webpack_exports__, "h", function () {
    return __WEBPACK_IMPORTED_MODULE_5__hidden__["a"];
  });
  /***/

},
/* 102 */

/***/
function (module, exports, __webpack_require__) {
  var arrayWithoutHoles = __webpack_require__(277);

  var iterableToArray = __webpack_require__(278);

  var unsupportedIterableToArray = __webpack_require__(183);

  var nonIterableSpread = __webpack_require__(281);

  function _toConsumableArray(arr) {
    return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
  }

  module.exports = _toConsumableArray;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
  /***/
},
/* 103 */

/***/
function (module, exports) {
  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      module.exports = _typeof = function _typeof(obj) {
        return typeof obj;
      };

      module.exports["default"] = module.exports, module.exports.__esModule = true;
    } else {
      module.exports = _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };

      module.exports["default"] = module.exports, module.exports.__esModule = true;
    }

    return _typeof(obj);
  }

  module.exports = _typeof;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
  /***/
},
/* 104 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony export (binding) */

  __webpack_require__.d(__webpack_exports__, "b", function () {
    return withButtonGroupContext;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "a", function () {
    return ButtonGroup;
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(5);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__emotion_styled__ = __webpack_require__(14);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__emotion_styled___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__emotion_styled__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6__tal_gel_core__ = __webpack_require__(7);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6__tal_gel_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__tal_gel_core__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7__tal_gel_theming__ = __webpack_require__(11);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7__tal_gel_theming___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__tal_gel_theming__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_8__utils_get_caption_elements__ = __webpack_require__(83);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_9__utils_checkbox_radio_utils__ = __webpack_require__(67);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_10__form_multi_step_form__ = __webpack_require__(53);

  var _excluded = ["vertical", "disabled", "inverse", "error", "caption", "theme", "width", "height", "buttonGroup", "gap", "submitCheck", "index", "setValidity", "resetValidator", "required", "min", "max", "requiredErrorMsg", "errorMsg", "onError", "alternativeButtons", "children"];

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);

      if (enumerableOnly) {
        symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
      }

      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  } // Due to the fact that each file only runs once (when it first gets imported),
  // this instance of `ButtonGroupContext` is shared by all ButtonGroups, 
  // and the functional component `ButtonGroupComponent` is also shared 
  // (no instance as opposed to Class components),
  // but `useState` makes the actual context value different for different ButtonGroups


  var ButtonGroupContext = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createContext();
  /**
   * Note that the direct use of ButtonGroup is deprecated, use CheckboxGroup instead. 
   * CheckboxGroup refers to ButtonGroup under the hood.
   */


  var ButtonGroupComponent = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.forwardRef(function (_ref, forwardedRef) {
    var vertical = _ref.vertical,
        disabled = _ref.disabled,
        inverse = _ref.inverse,
        error = _ref.error,
        caption = _ref.caption,
        theme = _ref.theme,
        width = _ref.width,
        height = _ref.height,
        buttonGroup = _ref.buttonGroup,
        gap = _ref.gap,
        submitCheck = _ref.submitCheck,
        index = _ref.index,
        setValidity = _ref.setValidity,
        resetValidator = _ref.resetValidator,
        required = _ref.required,
        min = _ref.min,
        max = _ref.max,
        requiredErrorMsg = _ref.requiredErrorMsg,
        errorMsg = _ref.errorMsg,
        onError = _ref.onError,
        alternativeButtons = _ref.alternativeButtons,
        children = _ref.children,
        props = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties___default()(_ref, _excluded); // Stores the `checked` status of each contained individual checkbox


    var groupChecked = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useRef"])({});

    var _useCrContext = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_checkbox_radio_utils__["h"
    /* useCrContext */
    ])({
      theme: theme,
      vertical: vertical,
      width: width,
      height: height,
      gap: gap,
      alternativeButtons: alternativeButtons
    }),
        crContextOnBlurGenerator = _useCrContext.onBlurGenerator,
        crContextOnFocus = _useCrContext.onFocus,
        crContextOnChangeGenerator = _useCrContext.onChangeGenerator,
        gutterWidth = _useCrContext.gutterWidth,
        shouldIgnoreGutterWidth = _useCrContext.shouldIgnoreGutterWidth; // Constructs a group context object to be shared by checkboxes in the group


    var buildGroupContext = function buildGroupContext() {
      return {
        vertical: vertical,
        disabled: disabled,
        inverse: inverse,
        error: error,
        buttonGroup: buttonGroup,
        gutterWidth: shouldIgnoreGutterWidth() ? null : gutterWidth,
        onBlur: crContextOnBlurGenerator(onBlurFromValidator),
        // see comment on `useCrContext`
        onFocus: crContextOnFocus,
        // see comment on `useCrContext`
        onChange: crContextOnChangeGenerator( // see comment on `useCrContext`
        groupChecked, onChangeFromValidator),
        submitCheck: submitCheck,
        shouldShowError: shouldShowError,
        required: required
      };
    };

    var isInitialMount = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useRef"])(true);

    var _useValidator = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__tal_gel_core__["useValidator"])({
      index: index,
      // index assigned by the form
      setValidity: setValidity,
      // function to report validity of this checkbox group to the form
      reset: resetValidator,
      // whether to reset the validator
      error: error,
      // controlled `error` prop, directly telling validator if there is error (without needing to check for error by itself)
      caption: caption,
      // initial caption underneath the group, can also be used to display error message if the controlled `error` is true
      checkError: true,
      // tells validator whether to check for error
      hasError: function hasError() {
        // tells validator HOW to check for error
        // calculate how many contained checkboxes are checked
        var numOfChecked = Object.keys(groupChecked.current).reduce(function (result, key) {
          return groupChecked.current[key] ? ++result : result;
        }, 0);

        if (required && numOfChecked === 0) {
          return 'required';
        }

        if (numOfChecked !== 0 && (min !== undefined && numOfChecked < min || max !== undefined && numOfChecked > max)) {
          return 'count';
        }

        return false;
      },
      onError: onError,
      // tells validator the callback to invoke if error occurs or disappears
      errorMsg: _objectSpread({
        // tells validator the error message to include in caption if error occurs
        'required': requiredErrorMsg
      }, errorMsg),
      hideErrorInitially: true,
      // tells validator to hide error initially
      group: true,
      // tells validator if it is group being validated
      submitCheck: {
        shouldTrigger: submitCheck // empty object

      },
      MultiStepFormContext: __WEBPACK_IMPORTED_MODULE_10__form_multi_step_form__["a"
      /* MultiStepFormContext */
      ]
    }),
        _useValidator2 = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray___default()(_useValidator, 4),
        onBlurFromValidator = _useValidator2[0],
        onChangeFromValidator = _useValidator2[1],
        getCaption = _useValidator2[2],
        shouldShowError = _useValidator2[3]; // initialise a group context


    var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useState"])(buildGroupContext()),
        _useState2 = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray___default()(_useState, 2),
        context = _useState2[0],
        setContext = _useState2[1];

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useEffect"])(function () {
      if (isInitialMount.current) {
        // skip if it is after initial mount/first rendering
        isInitialMount.current = false;
      } else {
        // Build a new group context each time any group related prop receives a new value FROM PARENT
        // The new group context object will make the context provider re-render context consumers
        setContext(buildGroupContext());
      }
    }, [vertical, disabled, inverse, error, required]);

    var checkboxIndex = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useRef"])();

    var indexAssignmentDone = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useRef"])();

    checkboxIndex.current = 0;
    indexAssignmentDone.current = false;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useEffect"])(function () {
      indexAssignmentDone.current = true;
    });

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ButtonGroupContext.Provider, {
      value: _objectSpread(_objectSpread({}, context), {}, {
        index: checkboxIndex,
        submitCheck: submitCheck,
        error: shouldShowError(),
        indexAssignmentDone: indexAssignmentDone
      })
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ButtonGroupContainer, {
      "data-cy": "gel-button-group",
      ref: forwardedRef
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(StyledFlexContainer, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
      justifyContent: "space-between",
      alignItems: "stretch",
      alternativeButtons: alternativeButtons
    }, alternativeButtons && {
      flexWrap: true
    }, vertical && {
      flexDirection: 'column'
    }, {
      theme: theme,
      width: width,
      height: height,
      gutterWidth: gutterWidth,
      error: shouldShowError(),
      inverse: inverse,
      vertical: vertical
    }, props), children), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_get_caption_elements__["a"
    /* default */
    ])(getCaption)));
  });

  var ButtonGroupContainer = __WEBPACK_IMPORTED_MODULE_5__emotion_styled___default.a.div({
    width: '100%'
  });

  var StyledFlexContainer = __WEBPACK_IMPORTED_MODULE_5__emotion_styled___default()(__WEBPACK_IMPORTED_MODULE_6__tal_gel_core__["GelFlexContainer"])({
    margin: 0
  }, function (_ref2) {
    var style = _ref2.style,
        theme = _ref2.theme,
        error = _ref2.error,
        inverse = _ref2.inverse,
        width = _ref2.width,
        height = _ref2.height,
        gutterWidth = _ref2.gutterWidth,
        vertical = _ref2.vertical,
        alternativeButtons = _ref2.alternativeButtons;

    var _getStylesForStates = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__tal_gel_theming__["getStylesForStates"])({
      theme: theme,
      target: 'Checkbox',
      subTarget: 'Caption',
      danger: error,
      inverse: inverse
    }),
        normalStyles = _getStylesForStates.normalStyles;

    return _objectSpread(_objectSpread(_objectSpread({}, style), gutterWidth ? _objectSpread(_objectSpread({
      justifyContent: 'flex-start'
    }, !vertical ? {
      height: height
    } : {
      width: width
    }), alternativeButtons && {
      width: width
    }) : {
      width: width,
      height: height
    }), {}, {
      '~ .caption': normalStyles
    });
  });
  /**
   * HOC to provide button group context to the contained checkbox
   */


  var withButtonGroupContext = function withButtonGroupContext(Component) {
    return function (props) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ButtonGroupContext.Consumer, null, function (context) {
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
          groupContext: context
        }, props));
      });
    };
  };

  var ButtonGroup = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__tal_gel_theming__["withTheme"])(ButtonGroupComponent);

  ButtonGroup.displayName = 'ButtonGroup';
  /***/
},
/* 105 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony export (binding) */

  __webpack_require__.d(__webpack_exports__, "a", function () {
    return Col;
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__ = __webpack_require__(5);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4__emotion_styled__ = __webpack_require__(14);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4__emotion_styled___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__emotion_styled__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__tal_gel_core__ = __webpack_require__(7);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__tal_gel_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__tal_gel_core__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6__screen_detector__ = __webpack_require__(33);

  var _excluded = ["children", "style", "gutterWidth", "width", "animated", "animatedWidth", "animatedWidthClosed", "alignment", "shrinkable", "vertical", "order"];

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);

      if (enumerableOnly) {
        symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
      }

      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }
  /**
   * Col compoment is effectively flex item, and is used in 2 ways:
   *  (1) In grid - flexBasis, marginLeft, left, right
   *  (2) Not in grid - flexGrow 
   *      (can be used in both flex-direction: row and flex-direction: column)
   */


  var Col = function Col(_ref) {
    var children = _ref.children,
        style = _ref.style,
        gutterWidth = _ref.gutterWidth,
        width = _ref.width,
        animated = _ref.animated,
        animatedWidth = _ref.animatedWidth,
        animatedWidthClosed = _ref.animatedWidthClosed,
        alignment = _ref.alignment,
        shrinkable = _ref.shrinkable,
        vertical = _ref.vertical,
        order = _ref.order,
        props = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties___default()(_ref, _excluded);

    var _useContext = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_6__screen_detector__["a"
    /* ScreenDetectorContext */
    ]),
        currScreen = _useContext.screen,
        gridColumns = _useContext.gridColumns,
        hasAnyScreenProps = _useContext.hasAnyScreenProps,
        findScreenPropByScreen = _useContext.findScreenPropByScreen,
        animation = _useContext.animation; // `flexBasis` will have an impact on `flexGrow`.
    // In the case of `flexBasis: 0`, the width of the flex item won't be considered
    // when calculating how much remaining space is available for allocation.
    // If all flex items have `flexBasis: 0`, the remaining space will be the full width of flexbox


    var flexGrow = 0,
        flexBasis = 0,
        marginLeft = 0,
        left = 'auto',
        right = 'auto',
        showCol = true;

    if (width === undefined) {
      if (!hasAnyScreenProps(props)) {
        // When no width specified and no screen props specified,
        // Eg: 
        //  <Row> /** flexbox */
        //    <Col></Col> /** flex item */
        //    <Col></Col> /** flex item */
        //  </Row>
        flexGrow = 1;
      } else {
        // Use `flexBasis` to specify column width
        var screenProp = findScreenPropByScreen(currScreen, props);

        if (screenProp) {
          if (props[screenProp] === 'content') {
            flexBasis = 'auto'; // width to follow the actual column content
          } else {
            if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__tal_gel_core__["isInIE"])()) {
              flexBasis = "".concat(props[screenProp] / gridColumns * 100, "%");
            } else {
              flexBasis = "calc(".concat(props[screenProp] / gridColumns * 100, "% - ").concat(gutterWidth, "px)");
            }
          }
        } else {
          // Take up the full row if there are screen props but 
          // none of them is suitable for the current screen
          // Eg: If current screen is xs
          //  <Row>
          //    <Col sm={4}></Col> /** will take up the full row */
          //    <Col sm={8}></Col> /** will take up the full row */
          //  </Row>
          flexBasis = '100%';
        } // Use `marginLeft` to specify column offset. 
        // Margins will affect the remaining space in flexbox, and
        // the flex item with marginLeft will push the other flex items.


        screenProp = findScreenPropByScreen(currScreen, props.offset);

        if (screenProp) {
          marginLeft = "".concat(props.offset[screenProp] / gridColumns * 100, "%");
        } // Use `left` or `right` to specify column position (can be pushed or pulled)
        // Positions will not affect the remaining space in flexbox, and
        // the flex item with specified position will not affect positions of
        // other flex items.


        screenProp = findScreenPropByScreen(currScreen, props.push);

        if (screenProp) {
          left = "".concat(props.push[screenProp] / gridColumns * 100, "%");
        }

        screenProp = findScreenPropByScreen(currScreen, props.pull);

        if (screenProp) {
          right = "".concat(props.pull[screenProp] / gridColumns * 100, "%");
        }
      }
    } else if (Number.isInteger(width) && width !== 0) {
      // not directly used by grid
      flexGrow = width; // flexBasis === 0
    } else {
      // not directly used by grid
      if (typeof width === 'string') {
        flexBasis = width;
      } else {
        flexBasis = 'auto';

        if (width === 0) {
          // hide the column (with animation) if width is 0
          showCol = false;
        }
      }
    }

    var colRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react__["useRef"])();

    var colWidthForAnimation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react__["useRef"])();

    var forceUpdate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__tal_gel_core__["useForceUpdate"])(); // TODO: This may still be required if side nav width can be flexible
    // Right now we are restricting the width to be one of the predefined width options 


    var getColWidthForAnimation = function getColWidthForAnimation() {
      // only calc width for `animated`
      if (!animated) return;
      if (!colRef.current) return;

      if (showCol && colRef.current.offsetWidth) {
        colWidthForAnimation.current = colRef.current.offsetWidth;
      }

      return colWidthForAnimation.current; // if (colWidthForAnimation.current) return colWidthForAnimation.current;
      // if (showCol) { 
      //   colWidthForAnimation.current = colRef.current.offsetWidth/* + 1*/;
      // }
      // return colWidthForAnimation.current;
    };

    var isUnmountedRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__tal_gel_core__["useIsUnmounted"])();

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react__["useEffect"])(function () {
      // only for when shown and `flexBasis`: auto
      if (animated && colRef.current && showCol && colWidthForAnimation.current === undefined) {
        // Assuming width does not change anymore
        // Only initilise colWidthForAnimation once when appropriate
        var timer = setTimeout(function () {
          if (!isUnmountedRef.current) {
            forceUpdate();
          }

          clearTimeout(timer);
        }, 100); // Somehow we need to wait a bit even after render, to get the accurate offsetWidth
      }
    }, []);

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(StyledCol, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({
      ref: colRef,
      flexGrow: flexGrow,
      flexBasis: flexBasis,
      order: order,
      alignment: alignment,
      marginLeft: marginLeft,
      left: left,
      right: right,
      style: style,
      gutterWidth: gutterWidth,
      vertical: vertical,
      show: showCol,
      _width: width // Use _width so it won't come up in the DOM
      ,
      animated: animated,
      widthForAnimation: animatedWidth,
      animation: animation,
      shrinkable: shrinkable,
      animatedWidthClosed: animatedWidthClosed
    }, props), children);
  };

  var StyledCol = __WEBPACK_IMPORTED_MODULE_4__emotion_styled___default.a.div({
    position: 'relative'
  }, function (_ref2) {
    var flexGrow = _ref2.flexGrow,
        flexBasis = _ref2.flexBasis,
        marginLeft = _ref2.marginLeft,
        left = _ref2.left,
        right = _ref2.right,
        _width = _ref2._width,
        gutterWidth = _ref2.gutterWidth,
        vertical = _ref2.vertical,
        order = _ref2.order,
        alignment = _ref2.alignment,
        show = _ref2.show,
        animated = _ref2.animated,
        widthForAnimation = _ref2.widthForAnimation,
        animation = _ref2.animation,
        shrinkable = _ref2.shrinkable,
        animatedWidthClosed = _ref2.animatedWidthClosed;
    return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
      flexGrow: flexGrow,
      flexShrink: 1,
      flexBasis: flexBasis
    }, shrinkable && !vertical && {
      minWidth: 0 // See comments on `shrinkable` in BoxLayout,

    }), shrinkable && vertical && {
      minHeight: 0 // See comments on `shrinkable` in BoxLayout

    }), {}, {
      order: order,
      alignSelf: alignment,
      marginLeft: marginLeft,
      left: left,
      right: right,
      paddingLeft: gutterWidth / 2,
      // horizontal gutter
      paddingRight: gutterWidth / 2
    }, vertical && {
      // used by BoxLayout, vertical gutter
      ':not(:last-of-type)': {
        marginBottom: gutterWidth
      }
    }), animated && {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      transition: "width ".concat(animation.duration, " ").concat(animation.speedCurve)
    }), animated && show && _width === 'auto' && {
      // only width 'auto' can suppport `animated`
      width: widthForAnimation
    }), !show && widthForAnimation && {
      // width 0 
      width: animatedWidthClosed
    }), !show && !widthForAnimation && __WEBPACK_IMPORTED_MODULE_5__tal_gel_core__["accessibleHiddenStyle"]);
  });
  /***/

},
/* 106 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony export (binding) */

  __webpack_require__.d(__webpack_exports__, "a", function () {
    return Row;
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__ = __webpack_require__(5);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4__emotion_styled__ = __webpack_require__(14);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4__emotion_styled___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__emotion_styled__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__screen_detector__ = __webpack_require__(33);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6__layout_container_lite__ = __webpack_require__(62);

  var _excluded = ["align", "justify", "gutter", "nogutter", "wrap", "vertical", "verticalGutterWidth", "style", "children"];

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);

      if (enumerableOnly) {
        symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
      }

      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  } // TODO: typescript to enum the options


  var Row = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef(function (_ref, forwardedRef) {
    var align = _ref.align,
        justify = _ref.justify,
        gutter = _ref.gutter,
        nogutter = _ref.nogutter,
        _ref$wrap = _ref.wrap,
        wrap = _ref$wrap === void 0 ? true : _ref$wrap,
        _ref$vertical = _ref.vertical,
        vertical = _ref$vertical === void 0 ? false : _ref$vertical,
        verticalGutterWidth = _ref.verticalGutterWidth,
        style = _ref.style,
        children = _ref.children,
        props = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties___default()(_ref, _excluded);

    var _useContext = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_5__screen_detector__["a"
    /* ScreenDetectorContext */
    ]),
        gridGutters = _useContext.gridGutters,
        gridGutterWidth = _useContext.gridGutterWidth;

    if (align === 'start') align = 'flex-start';
    if (align === 'end') align = 'flex-end';
    if (justify === 'start') justify = 'flex-start';
    if (justify === 'end') justify = 'flex-end';
    if (justify === 'spaceBetween') justify = 'space-between';
    if (justify === 'spaceAround') justify = 'space-around';
    if (justify === 'spaceEvenly') justify = 'space-evenly';
    wrap = wrap ? 'wrap' : 'nowrap';
    var gutterWidth; // `gutterWidth` is the horizontal gutterWidth in between two columns

    if (nogutter) {
      gutterWidth = 0; // Set gutterWidth as 0 if specified as no gutter
    } else {
      // Use `gutterWidth` if `gutterWidth` is specified
      // otherwise use the default grid gutterWidth
      gutterWidth = gutter !== undefined ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__layout_container_lite__["a"
      /* getGutter */
      ])(gridGutters, gutter) : gridGutterWidth;
    }

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(StyledRow, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({
      ref: forwardedRef,
      align: align,
      justify: justify,
      gutterWidth: gutterWidth,
      flexWrap: wrap,
      vertical: vertical,
      verticalGutterWidth: verticalGutterWidth,
      style: style
    }, props), __WEBPACK_IMPORTED_MODULE_3_react___default.a.Children.map(children, function (child) {
      // Cols
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.cloneElement(child, {
        // pass extra info to `Col`
        gutterWidth: gutterWidth,
        vertical: vertical
      });
    }));
  });

  var StyledRow = __WEBPACK_IMPORTED_MODULE_4__emotion_styled___default.a.div({
    display: 'flex',
    flexWrap: 'wrap'
  }, function (_ref2) {
    var align = _ref2.align,
        justify = _ref2.justify,
        gutterWidth = _ref2.gutterWidth,
        flexWrap = _ref2.flexWrap,
        vertical = _ref2.vertical,
        verticalGutterWidth = _ref2.verticalGutterWidth;
    return _objectSpread(_objectSpread({
      alignItems: align,
      justifyContent: justify,
      marginLeft: -gutterWidth / 2,
      marginRight: -gutterWidth / 2,
      flexWrap: flexWrap
    }, verticalGutterWidth && {
      // used by RowLayout
      ':not(:last-of-type)': {
        marginBottom: verticalGutterWidth
      }
    }), {}, {
      flexDirection: !vertical ? 'row' : 'column' // used by BoxLayout

    });
  });
  /***/

},
/* 107 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var charAt = __webpack_require__(127).charAt; // `AdvanceStringIndex` abstract operation
  // https://tc39.es/ecma262/#sec-advancestringindex


  module.exports = function (S, index, unicode) {
    return index + (unicode ? charAt(S, index).length : 1);
  };
  /***/

},
/* 108 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var global = __webpack_require__(1);

  var uncurryThis = __webpack_require__(3);

  var DESCRIPTORS = __webpack_require__(12);

  var NATIVE_ARRAY_BUFFER = __webpack_require__(142);

  var FunctionName = __webpack_require__(74);

  var createNonEnumerableProperty = __webpack_require__(35);

  var redefineAll = __webpack_require__(78);

  var fails = __webpack_require__(2);

  var anInstance = __webpack_require__(50);

  var toIntegerOrInfinity = __webpack_require__(29);

  var toLength = __webpack_require__(44);

  var toIndex = __webpack_require__(232);

  var IEEE754 = __webpack_require__(352);

  var getPrototypeOf = __webpack_require__(48);

  var setPrototypeOf = __webpack_require__(52);

  var getOwnPropertyNames = __webpack_require__(65).f;

  var defineProperty = __webpack_require__(20).f;

  var arrayFill = __webpack_require__(144);

  var arraySlice = __webpack_require__(86);

  var setToStringTag = __webpack_require__(49);

  var InternalStateModule = __webpack_require__(27);

  var PROPER_FUNCTION_NAME = FunctionName.PROPER;
  var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
  var getInternalState = InternalStateModule.get;
  var setInternalState = InternalStateModule.set;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var DATA_VIEW = 'DataView';
  var PROTOTYPE = 'prototype';
  var WRONG_LENGTH = 'Wrong length';
  var WRONG_INDEX = 'Wrong index';
  var NativeArrayBuffer = global[ARRAY_BUFFER];
  var $ArrayBuffer = NativeArrayBuffer;
  var ArrayBufferPrototype = $ArrayBuffer && $ArrayBuffer[PROTOTYPE];
  var $DataView = global[DATA_VIEW];
  var DataViewPrototype = $DataView && $DataView[PROTOTYPE];
  var ObjectPrototype = Object.prototype;
  var Array = global.Array;
  var RangeError = global.RangeError;
  var fill = uncurryThis(arrayFill);
  var reverse = uncurryThis([].reverse);
  var packIEEE754 = IEEE754.pack;
  var unpackIEEE754 = IEEE754.unpack;

  var packInt8 = function packInt8(number) {
    return [number & 0xFF];
  };

  var packInt16 = function packInt16(number) {
    return [number & 0xFF, number >> 8 & 0xFF];
  };

  var packInt32 = function packInt32(number) {
    return [number & 0xFF, number >> 8 & 0xFF, number >> 16 & 0xFF, number >> 24 & 0xFF];
  };

  var unpackInt32 = function unpackInt32(buffer) {
    return buffer[3] << 24 | buffer[2] << 16 | buffer[1] << 8 | buffer[0];
  };

  var packFloat32 = function packFloat32(number) {
    return packIEEE754(number, 23, 4);
  };

  var packFloat64 = function packFloat64(number) {
    return packIEEE754(number, 52, 8);
  };

  var addGetter = function addGetter(Constructor, key) {
    defineProperty(Constructor[PROTOTYPE], key, {
      get: function get() {
        return getInternalState(this)[key];
      }
    });
  };

  var get = function get(view, count, index, isLittleEndian) {
    var intIndex = toIndex(index);
    var store = getInternalState(view);
    if (intIndex + count > store.byteLength) throw RangeError(WRONG_INDEX);
    var bytes = getInternalState(store.buffer).bytes;
    var start = intIndex + store.byteOffset;
    var pack = arraySlice(bytes, start, start + count);
    return isLittleEndian ? pack : reverse(pack);
  };

  var set = function set(view, count, index, conversion, value, isLittleEndian) {
    var intIndex = toIndex(index);
    var store = getInternalState(view);
    if (intIndex + count > store.byteLength) throw RangeError(WRONG_INDEX);
    var bytes = getInternalState(store.buffer).bytes;
    var start = intIndex + store.byteOffset;
    var pack = conversion(+value);

    for (var i = 0; i < count; i++) {
      bytes[start + i] = pack[isLittleEndian ? i : count - i - 1];
    }
  };

  if (!NATIVE_ARRAY_BUFFER) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, ArrayBufferPrototype);
      var byteLength = toIndex(length);
      setInternalState(this, {
        bytes: fill(Array(byteLength), 0),
        byteLength: byteLength
      });
      if (!DESCRIPTORS) this.byteLength = byteLength;
    };

    ArrayBufferPrototype = $ArrayBuffer[PROTOTYPE];

    $DataView = function DataView(buffer, byteOffset, byteLength) {
      anInstance(this, DataViewPrototype);
      anInstance(buffer, ArrayBufferPrototype);
      var bufferLength = getInternalState(buffer).byteLength;
      var offset = toIntegerOrInfinity(byteOffset);
      if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset');
      byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
      if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
      setInternalState(this, {
        buffer: buffer,
        byteLength: byteLength,
        byteOffset: offset
      });

      if (!DESCRIPTORS) {
        this.buffer = buffer;
        this.byteLength = byteLength;
        this.byteOffset = offset;
      }
    };

    DataViewPrototype = $DataView[PROTOTYPE];

    if (DESCRIPTORS) {
      addGetter($ArrayBuffer, 'byteLength');
      addGetter($DataView, 'buffer');
      addGetter($DataView, 'byteLength');
      addGetter($DataView, 'byteOffset');
    }

    redefineAll(DataViewPrototype, {
      getInt8: function getInt8(byteOffset) {
        return get(this, 1, byteOffset)[0] << 24 >> 24;
      },
      getUint8: function getUint8(byteOffset) {
        return get(this, 1, byteOffset)[0];
      },
      getInt16: function getInt16(byteOffset
      /* , littleEndian */
      ) {
        var bytes = get(this, 2, byteOffset, arguments.length > 1 ? arguments[1] : undefined);
        return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
      },
      getUint16: function getUint16(byteOffset
      /* , littleEndian */
      ) {
        var bytes = get(this, 2, byteOffset, arguments.length > 1 ? arguments[1] : undefined);
        return bytes[1] << 8 | bytes[0];
      },
      getInt32: function getInt32(byteOffset
      /* , littleEndian */
      ) {
        return unpackInt32(get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : undefined));
      },
      getUint32: function getUint32(byteOffset
      /* , littleEndian */
      ) {
        return unpackInt32(get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : undefined)) >>> 0;
      },
      getFloat32: function getFloat32(byteOffset
      /* , littleEndian */
      ) {
        return unpackIEEE754(get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : undefined), 23);
      },
      getFloat64: function getFloat64(byteOffset
      /* , littleEndian */
      ) {
        return unpackIEEE754(get(this, 8, byteOffset, arguments.length > 1 ? arguments[1] : undefined), 52);
      },
      setInt8: function setInt8(byteOffset, value) {
        set(this, 1, byteOffset, packInt8, value);
      },
      setUint8: function setUint8(byteOffset, value) {
        set(this, 1, byteOffset, packInt8, value);
      },
      setInt16: function setInt16(byteOffset, value
      /* , littleEndian */
      ) {
        set(this, 2, byteOffset, packInt16, value, arguments.length > 2 ? arguments[2] : undefined);
      },
      setUint16: function setUint16(byteOffset, value
      /* , littleEndian */
      ) {
        set(this, 2, byteOffset, packInt16, value, arguments.length > 2 ? arguments[2] : undefined);
      },
      setInt32: function setInt32(byteOffset, value
      /* , littleEndian */
      ) {
        set(this, 4, byteOffset, packInt32, value, arguments.length > 2 ? arguments[2] : undefined);
      },
      setUint32: function setUint32(byteOffset, value
      /* , littleEndian */
      ) {
        set(this, 4, byteOffset, packInt32, value, arguments.length > 2 ? arguments[2] : undefined);
      },
      setFloat32: function setFloat32(byteOffset, value
      /* , littleEndian */
      ) {
        set(this, 4, byteOffset, packFloat32, value, arguments.length > 2 ? arguments[2] : undefined);
      },
      setFloat64: function setFloat64(byteOffset, value
      /* , littleEndian */
      ) {
        set(this, 8, byteOffset, packFloat64, value, arguments.length > 2 ? arguments[2] : undefined);
      }
    });
  } else {
    var INCORRECT_ARRAY_BUFFER_NAME = PROPER_FUNCTION_NAME && NativeArrayBuffer.name !== ARRAY_BUFFER;
    /* eslint-disable no-new -- required for testing */

    if (!fails(function () {
      NativeArrayBuffer(1);
    }) || !fails(function () {
      new NativeArrayBuffer(-1);
    }) || fails(function () {
      new NativeArrayBuffer();
      new NativeArrayBuffer(1.5);
      new NativeArrayBuffer(NaN);
      return INCORRECT_ARRAY_BUFFER_NAME && !CONFIGURABLE_FUNCTION_NAME;
    })) {
      /* eslint-enable no-new -- required for testing */
      $ArrayBuffer = function ArrayBuffer(length) {
        anInstance(this, ArrayBufferPrototype);
        return new NativeArrayBuffer(toIndex(length));
      };

      $ArrayBuffer[PROTOTYPE] = ArrayBufferPrototype;

      for (var keys = getOwnPropertyNames(NativeArrayBuffer), j = 0, key; keys.length > j;) {
        if (!((key = keys[j++]) in $ArrayBuffer)) {
          createNonEnumerableProperty($ArrayBuffer, key, NativeArrayBuffer[key]);
        }
      }

      ArrayBufferPrototype.constructor = $ArrayBuffer;
    } else if (INCORRECT_ARRAY_BUFFER_NAME && CONFIGURABLE_FUNCTION_NAME) {
      createNonEnumerableProperty(NativeArrayBuffer, 'name', ARRAY_BUFFER);
    } // WebKit bug - the same parent prototype for typed arrays and data view


    if (setPrototypeOf && getPrototypeOf(DataViewPrototype) !== ObjectPrototype) {
      setPrototypeOf(DataViewPrototype, ObjectPrototype);
    } // iOS Safari 7.x bug


    var testView = new $DataView(new $ArrayBuffer(2));
    var $setInt8 = uncurryThis(DataViewPrototype.setInt8);
    testView.setInt8(0, 2147483648);
    testView.setInt8(1, 2147483649);
    if (testView.getInt8(0) || !testView.getInt8(1)) redefineAll(DataViewPrototype, {
      setInt8: function setInt8(byteOffset, value) {
        $setInt8(this, byteOffset, value << 24 >> 24);
      },
      setUint8: function setUint8(byteOffset, value) {
        $setInt8(this, byteOffset, value << 24 >> 24);
      }
    }, {
      unsafe: true
    });
  }

  setToStringTag($ArrayBuffer, ARRAY_BUFFER);
  setToStringTag($DataView, DATA_VIEW);
  module.exports = {
    ArrayBuffer: $ArrayBuffer,
    DataView: $DataView
  };
  /***/
},
/* 109 */

/***/
function (module, exports, __webpack_require__) {
  var global = __webpack_require__(1);

  var aCallable = __webpack_require__(34);

  var toObject = __webpack_require__(22);

  var IndexedObject = __webpack_require__(92);

  var lengthOfArrayLike = __webpack_require__(23);

  var TypeError = global.TypeError; // `Array.prototype.{ reduce, reduceRight }` methods implementation

  var createMethod = function createMethod(IS_RIGHT) {
    return function (that, callbackfn, argumentsLength, memo) {
      aCallable(callbackfn);
      var O = toObject(that);
      var self = IndexedObject(O);
      var length = lengthOfArrayLike(O);
      var index = IS_RIGHT ? length - 1 : 0;
      var i = IS_RIGHT ? -1 : 1;
      if (argumentsLength < 2) while (true) {
        if (index in self) {
          memo = self[index];
          index += i;
          break;
        }

        index += i;

        if (IS_RIGHT ? index < 0 : length <= index) {
          throw TypeError('Reduce of empty array with no initial value');
        }
      }

      for (; IS_RIGHT ? index >= 0 : length > index; index += i) {
        if (index in self) {
          memo = callbackfn(memo, self[index], index, O);
        }
      }

      return memo;
    };
  };

  module.exports = {
    // `Array.prototype.reduce` method
    // https://tc39.es/ecma262/#sec-array.prototype.reduce
    left: createMethod(false),
    // `Array.prototype.reduceRight` method
    // https://tc39.es/ecma262/#sec-array.prototype.reduceright
    right: createMethod(true)
  };
  /***/
},
/* 110 */

/***/
function (module, exports, __webpack_require__) {
  var wellKnownSymbol = __webpack_require__(15);

  var ITERATOR = wellKnownSymbol('iterator');
  var SAFE_CLOSING = false;

  try {
    var called = 0;
    var iteratorWithReturn = {
      next: function next() {
        return {
          done: !!called++
        };
      },
      'return': function _return() {
        SAFE_CLOSING = true;
      }
    };

    iteratorWithReturn[ITERATOR] = function () {
      return this;
    }; // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing


    Array.from(iteratorWithReturn, function () {
      throw 2;
    });
  } catch (error) {
    /* empty */
  }

  module.exports = function (exec, SKIP_CLOSING) {
    if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
    var ITERATION_SUPPORT = false;

    try {
      var object = {};

      object[ITERATOR] = function () {
        return {
          next: function next() {
            return {
              done: ITERATION_SUPPORT = true
            };
          }
        };
      };

      exec(object);
    } catch (error) {
      /* empty */
    }

    return ITERATION_SUPPORT;
  };
  /***/

},
/* 111 */

/***/
function (module, exports, __webpack_require__) {
  var uncurryThis = __webpack_require__(3);

  var replace = uncurryThis(''.replace);

  var TEST = function (arg) {
    return String(Error(arg).stack);
  }('zxcasd');

  var V8_OR_CHAKRA_STACK_ENTRY = /\n\s*at [^:]*:[^\n]*/;
  var IS_V8_OR_CHAKRA_STACK = V8_OR_CHAKRA_STACK_ENTRY.test(TEST);

  module.exports = function (stack, dropEntries) {
    if (IS_V8_OR_CHAKRA_STACK && typeof stack == 'string') {
      while (dropEntries--) {
        stack = replace(stack, V8_OR_CHAKRA_STACK_ENTRY, '');
      }
    }

    return stack;
  };
  /***/

},
/* 112 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $ = __webpack_require__(0);

  var global = __webpack_require__(1);

  var uncurryThis = __webpack_require__(3);

  var isForced = __webpack_require__(93);

  var redefine = __webpack_require__(24);

  var InternalMetadataModule = __webpack_require__(70);

  var iterate = __webpack_require__(59);

  var anInstance = __webpack_require__(50);

  var isCallable = __webpack_require__(17);

  var isObject = __webpack_require__(13);

  var fails = __webpack_require__(2);

  var checkCorrectnessOfIteration = __webpack_require__(110);

  var setToStringTag = __webpack_require__(49);

  var inheritIfRequired = __webpack_require__(75);

  module.exports = function (CONSTRUCTOR_NAME, wrapper, common) {
    var IS_MAP = CONSTRUCTOR_NAME.indexOf('Map') !== -1;
    var IS_WEAK = CONSTRUCTOR_NAME.indexOf('Weak') !== -1;
    var ADDER = IS_MAP ? 'set' : 'add';
    var NativeConstructor = global[CONSTRUCTOR_NAME];
    var NativePrototype = NativeConstructor && NativeConstructor.prototype;
    var Constructor = NativeConstructor;
    var exported = {};

    var fixMethod = function fixMethod(KEY) {
      var uncurriedNativeMethod = uncurryThis(NativePrototype[KEY]);
      redefine(NativePrototype, KEY, KEY == 'add' ? function add(value) {
        uncurriedNativeMethod(this, value === 0 ? 0 : value);
        return this;
      } : KEY == 'delete' ? function (key) {
        return IS_WEAK && !isObject(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
      } : KEY == 'get' ? function get(key) {
        return IS_WEAK && !isObject(key) ? undefined : uncurriedNativeMethod(this, key === 0 ? 0 : key);
      } : KEY == 'has' ? function has(key) {
        return IS_WEAK && !isObject(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
      } : function set(key, value) {
        uncurriedNativeMethod(this, key === 0 ? 0 : key, value);
        return this;
      });
    };

    var REPLACE = isForced(CONSTRUCTOR_NAME, !isCallable(NativeConstructor) || !(IS_WEAK || NativePrototype.forEach && !fails(function () {
      new NativeConstructor().entries().next();
    })));

    if (REPLACE) {
      // create collection constructor
      Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
      InternalMetadataModule.enable();
    } else if (isForced(CONSTRUCTOR_NAME, true)) {
      var instance = new Constructor(); // early implementations not supports chaining

      var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance; // V8 ~ Chromium 40- weak-collections throws on primitives, but should return false

      var THROWS_ON_PRIMITIVES = fails(function () {
        instance.has(1);
      }); // most early implementations doesn't supports iterables, most modern - not close it correctly
      // eslint-disable-next-line no-new -- required for testing

      var ACCEPT_ITERABLES = checkCorrectnessOfIteration(function (iterable) {
        new NativeConstructor(iterable);
      }); // for early implementations -0 and +0 not the same

      var BUGGY_ZERO = !IS_WEAK && fails(function () {
        // V8 ~ Chromium 42- fails only with 5+ elements
        var $instance = new NativeConstructor();
        var index = 5;

        while (index--) {
          $instance[ADDER](index, index);
        }

        return !$instance.has(-0);
      });

      if (!ACCEPT_ITERABLES) {
        Constructor = wrapper(function (dummy, iterable) {
          anInstance(dummy, NativePrototype);
          var that = inheritIfRequired(new NativeConstructor(), dummy, Constructor);
          if (iterable != undefined) iterate(iterable, that[ADDER], {
            that: that,
            AS_ENTRIES: IS_MAP
          });
          return that;
        });
        Constructor.prototype = NativePrototype;
        NativePrototype.constructor = Constructor;
      }

      if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
        fixMethod('delete');
        fixMethod('has');
        IS_MAP && fixMethod('get');
      }

      if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER); // weak collections should not contains .clear method

      if (IS_WEAK && NativePrototype.clear) delete NativePrototype.clear;
    }

    exported[CONSTRUCTOR_NAME] = Constructor;
    $({
      global: true,
      forced: Constructor != NativeConstructor
    }, exported);
    setToStringTag(Constructor, CONSTRUCTOR_NAME);
    if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);
    return Constructor;
  };
  /***/

},
/* 113 */

/***/
function (module, exports, __webpack_require__) {
  var hasOwn = __webpack_require__(21);

  var ownKeys = __webpack_require__(160);

  var getOwnPropertyDescriptorModule = __webpack_require__(32);

  var definePropertyModule = __webpack_require__(20);

  module.exports = function (target, source, exceptions) {
    var keys = ownKeys(source);
    var defineProperty = definePropertyModule.f;
    var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];

      if (!hasOwn(target, key) && !(exceptions && hasOwn(exceptions, key))) {
        defineProperty(target, key, getOwnPropertyDescriptor(source, key));
      }
    }
  };
  /***/

},
/* 114 */

/***/
function (module, exports, __webpack_require__) {
  var global = __webpack_require__(1);

  var isObject = __webpack_require__(13);

  var document = global.document; // typeof document.createElement is 'object' in old IE

  var EXISTS = isObject(document) && isObject(document.createElement);

  module.exports = function (it) {
    return EXISTS ? document.createElement(it) : {};
  };
  /***/

},
/* 115 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // TODO: Remove from `core-js@4` since it's moved to entry points

  __webpack_require__(171);

  var uncurryThis = __webpack_require__(3);

  var redefine = __webpack_require__(24);

  var regexpExec = __webpack_require__(123);

  var fails = __webpack_require__(2);

  var wellKnownSymbol = __webpack_require__(15);

  var createNonEnumerableProperty = __webpack_require__(35);

  var SPECIES = wellKnownSymbol('species');
  var RegExpPrototype = RegExp.prototype;

  module.exports = function (KEY, exec, FORCED, SHAM) {
    var SYMBOL = wellKnownSymbol(KEY);
    var DELEGATES_TO_SYMBOL = !fails(function () {
      // String methods call symbol-named RegEp methods
      var O = {};

      O[SYMBOL] = function () {
        return 7;
      };

      return ''[KEY](O) != 7;
    });
    var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function () {
      // Symbol-named RegExp methods call .exec
      var execCalled = false;
      var re = /a/;

      if (KEY === 'split') {
        // We can't use real regex here since it causes deoptimization
        // and serious performance degradation in V8
        // https://github.com/zloirock/core-js/issues/306
        re = {}; // RegExp[@@split] doesn't call the regex's exec method, but first creates
        // a new one. We need to return the patched regex when creating the new one.

        re.constructor = {};

        re.constructor[SPECIES] = function () {
          return re;
        };

        re.flags = '';
        re[SYMBOL] = /./[SYMBOL];
      }

      re.exec = function () {
        execCalled = true;
        return null;
      };

      re[SYMBOL]('');
      return !execCalled;
    });

    if (!DELEGATES_TO_SYMBOL || !DELEGATES_TO_EXEC || FORCED) {
      var uncurriedNativeRegExpMethod = uncurryThis(/./[SYMBOL]);
      var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
        var uncurriedNativeMethod = uncurryThis(nativeMethod);
        var $exec = regexp.exec;

        if ($exec === regexpExec || $exec === RegExpPrototype.exec) {
          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
            // The native String method already delegates to @@method (this
            // polyfilled function), leasing to infinite recursion.
            // We avoid it by directly calling the native @@method method.
            return {
              done: true,
              value: uncurriedNativeRegExpMethod(regexp, str, arg2)
            };
          }

          return {
            done: true,
            value: uncurriedNativeMethod(str, regexp, arg2)
          };
        }

        return {
          done: false
        };
      });
      redefine(String.prototype, KEY, methods[0]);
      redefine(RegExpPrototype, SYMBOL, methods[1]);
    }

    if (SHAM) createNonEnumerableProperty(RegExpPrototype[SYMBOL], 'sham', true);
  };
  /***/

},
/* 116 */

/***/
function (module, exports, __webpack_require__) {
  var global = __webpack_require__(1);

  var call = __webpack_require__(19);

  var aCallable = __webpack_require__(34);

  var anObject = __webpack_require__(10);

  var tryToString = __webpack_require__(100);

  var getIteratorMethod = __webpack_require__(90);

  var TypeError = global.TypeError;

  module.exports = function (argument, usingIterator) {
    var iteratorMethod = arguments.length < 2 ? getIteratorMethod(argument) : usingIterator;
    if (aCallable(iteratorMethod)) return anObject(call(iteratorMethod, argument));
    throw TypeError(tryToString(argument) + ' is not iterable');
  };
  /***/

},
/* 117 */

/***/
function (module, exports, __webpack_require__) {
  var uncurryThis = __webpack_require__(3);

  var isCallable = __webpack_require__(17);

  var store = __webpack_require__(164);

  var functionToString = uncurryThis(Function.toString); // this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper

  if (!isCallable(store.inspectSource)) {
    store.inspectSource = function (it) {
      return functionToString(it);
    };
  }

  module.exports = store.inspectSource;
  /***/
},
/* 118 */

/***/
function (module, exports) {
  // eslint-disable-next-line es/no-math-expm1 -- safe
  var $expm1 = Math.expm1;
  var exp = Math.exp; // `Math.expm1` method implementation
  // https://tc39.es/ecma262/#sec-math.expm1

  module.exports = !$expm1 // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168 // Tor Browser bug
  || $expm1(-2e-17) != -2e-17 ? function expm1(x) {
    return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : exp(x) - 1;
  } : $expm1;
  /***/
},
/* 119 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var aCallable = __webpack_require__(34);

  var PromiseCapability = function PromiseCapability(C) {
    var resolve, reject;
    this.promise = new C(function ($$resolve, $$reject) {
      if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
      resolve = $$resolve;
      reject = $$reject;
    });
    this.resolve = aCallable(resolve);
    this.reject = aCallable(reject);
  }; // `NewPromiseCapability` abstract operation
  // https://tc39.es/ecma262/#sec-newpromisecapability


  module.exports.f = function (C) {
    return new PromiseCapability(C);
  };
  /***/

},
/* 120 */

/***/
function (module, exports, __webpack_require__) {
  var fails = __webpack_require__(2);

  var isObject = __webpack_require__(13);

  var classof = __webpack_require__(38);

  var ARRAY_BUFFER_NON_EXTENSIBLE = __webpack_require__(143); // eslint-disable-next-line es/no-object-isextensible -- safe


  var $isExtensible = Object.isExtensible;
  var FAILS_ON_PRIMITIVES = fails(function () {
    $isExtensible(1);
  }); // `Object.isExtensible` method
  // https://tc39.es/ecma262/#sec-object.isextensible

  module.exports = FAILS_ON_PRIMITIVES || ARRAY_BUFFER_NON_EXTENSIBLE ? function isExtensible(it) {
    if (!isObject(it)) return false;
    if (ARRAY_BUFFER_NON_EXTENSIBLE && classof(it) == 'ArrayBuffer') return false;
    return $isExtensible ? $isExtensible(it) : true;
  } : $isExtensible;
  /***/
},
/* 121 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $propertyIsEnumerable = {}.propertyIsEnumerable; // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe

  var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor; // Nashorn ~ JDK8 bug

  var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({
    1: 2
  }, 1); // `Object.prototype.propertyIsEnumerable` method implementation
  // https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable

  exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = getOwnPropertyDescriptor(this, V);
    return !!descriptor && descriptor.enumerable;
  } : $propertyIsEnumerable;
  /***/
},
/* 122 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var IS_PURE = __webpack_require__(31);

  var global = __webpack_require__(1);

  var fails = __webpack_require__(2);

  var WEBKIT = __webpack_require__(150); // Forced replacement object prototype accessors methods


  module.exports = IS_PURE || !fails(function () {
    // This feature detection crashes old WebKit
    // https://github.com/zloirock/core-js/issues/232
    if (WEBKIT && WEBKIT < 535) return;
    var key = Math.random(); // In FF throws only define methods
    // eslint-disable-next-line no-undef, no-useless-call -- required for testing

    __defineSetter__.call(null, key, function () {
      /* empty */
    });

    delete global[key];
  });
  /***/
},
/* 123 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */

  /* eslint-disable regexp/no-useless-quantifier -- testing */

  var call = __webpack_require__(19);

  var uncurryThis = __webpack_require__(3);

  var toString = __webpack_require__(18);

  var regexpFlags = __webpack_require__(72);

  var stickyHelpers = __webpack_require__(124);

  var shared = __webpack_require__(126);

  var create = __webpack_require__(41);

  var getInternalState = __webpack_require__(27).get;

  var UNSUPPORTED_DOT_ALL = __webpack_require__(162);

  var UNSUPPORTED_NCG = __webpack_require__(229);

  var nativeReplace = shared('native-string-replace', String.prototype.replace);
  var nativeExec = RegExp.prototype.exec;
  var patchedExec = nativeExec;
  var charAt = uncurryThis(''.charAt);
  var indexOf = uncurryThis(''.indexOf);
  var replace = uncurryThis(''.replace);
  var stringSlice = uncurryThis(''.slice);

  var UPDATES_LAST_INDEX_WRONG = function () {
    var re1 = /a/;
    var re2 = /b*/g;
    call(nativeExec, re1, 'a');
    call(nativeExec, re2, 'a');
    return re1.lastIndex !== 0 || re2.lastIndex !== 0;
  }();

  var UNSUPPORTED_Y = stickyHelpers.BROKEN_CARET; // nonparticipating capturing group, copied from es5-shim's String#split patch.

  var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;
  var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG;

  if (PATCH) {
    patchedExec = function exec(string) {
      var re = this;
      var state = getInternalState(re);
      var str = toString(string);
      var raw = state.raw;
      var result, reCopy, lastIndex, match, i, object, group;

      if (raw) {
        raw.lastIndex = re.lastIndex;
        result = call(patchedExec, raw, str);
        re.lastIndex = raw.lastIndex;
        return result;
      }

      var groups = state.groups;
      var sticky = UNSUPPORTED_Y && re.sticky;
      var flags = call(regexpFlags, re);
      var source = re.source;
      var charsAdded = 0;
      var strCopy = str;

      if (sticky) {
        flags = replace(flags, 'y', '');

        if (indexOf(flags, 'g') === -1) {
          flags += 'g';
        }

        strCopy = stringSlice(str, re.lastIndex); // Support anchored sticky behavior.

        if (re.lastIndex > 0 && (!re.multiline || re.multiline && charAt(str, re.lastIndex - 1) !== '\n')) {
          source = '(?: ' + source + ')';
          strCopy = ' ' + strCopy;
          charsAdded++;
        } // ^(? + rx + ) is needed, in combination with some str slicing, to
        // simulate the 'y' flag.


        reCopy = new RegExp('^(?:' + source + ')', flags);
      }

      if (NPCG_INCLUDED) {
        reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
      }

      if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;
      match = call(nativeExec, sticky ? reCopy : re, strCopy);

      if (sticky) {
        if (match) {
          match.input = stringSlice(match.input, charsAdded);
          match[0] = stringSlice(match[0], charsAdded);
          match.index = re.lastIndex;
          re.lastIndex += match[0].length;
        } else re.lastIndex = 0;
      } else if (UPDATES_LAST_INDEX_WRONG && match) {
        re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
      }

      if (NPCG_INCLUDED && match && match.length > 1) {
        // Fix browsers whose `exec` methods don't consistently return `undefined`
        // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
        call(nativeReplace, match[0], reCopy, function () {
          for (i = 1; i < arguments.length - 2; i++) {
            if (arguments[i] === undefined) match[i] = undefined;
          }
        });
      }

      if (match && groups) {
        match.groups = object = create(null);

        for (i = 0; i < groups.length; i++) {
          group = groups[i];
          object[group[0]] = match[group[1]];
        }
      }

      return match;
    };
  }

  module.exports = patchedExec;
  /***/
},
/* 124 */

/***/
function (module, exports, __webpack_require__) {
  var fails = __webpack_require__(2);

  var global = __webpack_require__(1); // babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError


  var $RegExp = global.RegExp;
  var UNSUPPORTED_Y = fails(function () {
    var re = $RegExp('a', 'y');
    re.lastIndex = 2;
    return re.exec('abcd') != null;
  }); // UC Browser bug
  // https://github.com/zloirock/core-js/issues/1008

  var MISSED_STICKY = UNSUPPORTED_Y || fails(function () {
    return !$RegExp('a', 'y').sticky;
  });
  var BROKEN_CARET = UNSUPPORTED_Y || fails(function () {
    // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
    var re = $RegExp('^r', 'gy');
    re.lastIndex = 2;
    return re.exec('str') != null;
  });
  module.exports = {
    BROKEN_CARET: BROKEN_CARET,
    MISSED_STICKY: MISSED_STICKY,
    UNSUPPORTED_Y: UNSUPPORTED_Y
  };
  /***/
},
/* 125 */

/***/
function (module, exports, __webpack_require__) {
  var shared = __webpack_require__(126);

  var uid = __webpack_require__(82);

  var keys = shared('keys');

  module.exports = function (key) {
    return keys[key] || (keys[key] = uid(key));
  };
  /***/

},
/* 126 */

/***/
function (module, exports, __webpack_require__) {
  var IS_PURE = __webpack_require__(31);

  var store = __webpack_require__(164);

  (module.exports = function (key, value) {
    return store[key] || (store[key] = value !== undefined ? value : {});
  })('versions', []).push({
    version: '3.20.3',
    mode: IS_PURE ? 'pure' : 'global',
    copyright: '© 2014-2022 Denis Pushkarev (zloirock.ru)',
    license: 'https://github.com/zloirock/core-js/blob/v3.20.3/LICENSE',
    source: 'https://github.com/zloirock/core-js'
  });
  /***/
},
/* 127 */

/***/
function (module, exports, __webpack_require__) {
  var uncurryThis = __webpack_require__(3);

  var toIntegerOrInfinity = __webpack_require__(29);

  var toString = __webpack_require__(18);

  var requireObjectCoercible = __webpack_require__(28);

  var charAt = uncurryThis(''.charAt);
  var charCodeAt = uncurryThis(''.charCodeAt);
  var stringSlice = uncurryThis(''.slice);

  var createMethod = function createMethod(CONVERT_TO_STRING) {
    return function ($this, pos) {
      var S = toString(requireObjectCoercible($this));
      var position = toIntegerOrInfinity(pos);
      var size = S.length;
      var first, second;
      if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
      first = charCodeAt(S, position);
      return first < 0xD800 || first > 0xDBFF || position + 1 === size || (second = charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF ? CONVERT_TO_STRING ? charAt(S, position) : first : CONVERT_TO_STRING ? stringSlice(S, position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
    };
  };

  module.exports = {
    // `String.prototype.codePointAt` method
    // https://tc39.es/ecma262/#sec-string.prototype.codepointat
    codeAt: createMethod(false),
    // `String.prototype.at` method
    // https://github.com/mathiasbynens/String.prototype.at
    charAt: createMethod(true)
  };
  /***/
},
/* 128 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var global = __webpack_require__(1);

  var toIntegerOrInfinity = __webpack_require__(29);

  var toString = __webpack_require__(18);

  var requireObjectCoercible = __webpack_require__(28);

  var RangeError = global.RangeError; // `String.prototype.repeat` method implementation
  // https://tc39.es/ecma262/#sec-string.prototype.repeat

  module.exports = function repeat(count) {
    var str = toString(requireObjectCoercible(this));
    var result = '';
    var n = toIntegerOrInfinity(count);
    if (n < 0 || n == Infinity) throw RangeError('Wrong number of repetitions');

    for (; n > 0; (n >>>= 1) && (str += str)) {
      if (n & 1) result += str;
    }

    return result;
  };
  /***/

},
/* 129 */

/***/
function (module, exports, __webpack_require__) {
  var uncurryThis = __webpack_require__(3); // `thisNumberValue` abstract operation
  // https://tc39.es/ecma262/#sec-thisnumbervalue


  module.exports = uncurryThis(1.0.valueOf);
  /***/
},
/* 130 */

/***/
function (module, exports, __webpack_require__) {
  var ArrayBufferViewCore = __webpack_require__(16);

  var speciesConstructor = __webpack_require__(80);

  var TYPED_ARRAY_CONSTRUCTOR = ArrayBufferViewCore.TYPED_ARRAY_CONSTRUCTOR;
  var aTypedArrayConstructor = ArrayBufferViewCore.aTypedArrayConstructor; // a part of `TypedArraySpeciesCreate` abstract operation
  // https://tc39.es/ecma262/#typedarray-species-create

  module.exports = function (originalArray) {
    return aTypedArrayConstructor(speciesConstructor(originalArray, originalArray[TYPED_ARRAY_CONSTRUCTOR]));
  };
  /***/

},
/* 131 */

/***/
function (module, exports) {
  // a string of all valid unicode whitespaces
  module.exports = "\t\n\x0B\f\r \xA0\u1680\u2000\u2001\u2002" + "\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF";
  /***/
},
/* 132 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var toIndexedObject = __webpack_require__(37);

  var addToUnscopables = __webpack_require__(54);

  var Iterators = __webpack_require__(95);

  var InternalStateModule = __webpack_require__(27);

  var defineProperty = __webpack_require__(20).f;

  var defineIterator = __webpack_require__(149);

  var IS_PURE = __webpack_require__(31);

  var DESCRIPTORS = __webpack_require__(12);

  var ARRAY_ITERATOR = 'Array Iterator';
  var setInternalState = InternalStateModule.set;
  var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR); // `Array.prototype.entries` method
  // https://tc39.es/ecma262/#sec-array.prototype.entries
  // `Array.prototype.keys` method
  // https://tc39.es/ecma262/#sec-array.prototype.keys
  // `Array.prototype.values` method
  // https://tc39.es/ecma262/#sec-array.prototype.values
  // `Array.prototype[@@iterator]` method
  // https://tc39.es/ecma262/#sec-array.prototype-@@iterator
  // `CreateArrayIterator` internal method
  // https://tc39.es/ecma262/#sec-createarrayiterator

  module.exports = defineIterator(Array, 'Array', function (iterated, kind) {
    setInternalState(this, {
      type: ARRAY_ITERATOR,
      target: toIndexedObject(iterated),
      // target
      index: 0,
      // next index
      kind: kind // kind

    }); // `%ArrayIteratorPrototype%.next` method
    // https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
  }, function () {
    var state = getInternalState(this);
    var target = state.target;
    var kind = state.kind;
    var index = state.index++;

    if (!target || index >= target.length) {
      state.target = undefined;
      return {
        value: undefined,
        done: true
      };
    }

    if (kind == 'keys') return {
      value: index,
      done: false
    };
    if (kind == 'values') return {
      value: target[index],
      done: false
    };
    return {
      value: [index, target[index]],
      done: false
    };
  }, 'values'); // argumentsList[@@iterator] is %ArrayProto_values%
  // https://tc39.es/ecma262/#sec-createunmappedargumentsobject
  // https://tc39.es/ecma262/#sec-createmappedargumentsobject

  var values = Iterators.Arguments = Iterators.Array; // https://tc39.es/ecma262/#sec-array.prototype-@@unscopables

  addToUnscopables('keys');
  addToUnscopables('values');
  addToUnscopables('entries'); // V8 ~ Chrome 45- bug

  if (!IS_PURE && DESCRIPTORS && values.name !== 'values') try {
    defineProperty(values, 'name', {
      value: 'values'
    });
  } catch (error) {
    /* empty */
  }
  /***/
},
/* 133 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__button__ = __webpack_require__(288);
  /* unused harmony reexport getFullState */

  /* harmony default export */


  __webpack_exports__["a"] = __WEBPACK_IMPORTED_MODULE_0__button__["a"
  /* Button */
  ];
  /***/
},
/* 134 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony export (binding) */

  __webpack_require__.d(__webpack_exports__, "b", function () {
    return PageLayoutContext;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "d", function () {
    return Header;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "e", function () {
    return Footer;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "f", function () {
    return SideNav;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "h", function () {
    return ContentContainer;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "g", function () {
    return Content;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "c", function () {
    return useScrollContentToTop;
  });
  /* unused harmony export ContentWrapper */

  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "a", function () {
    return PageLayout;
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(5);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(102);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_slicedToArray__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__emotion_styled__ = __webpack_require__(14);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__emotion_styled___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__emotion_styled__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6__tal_gel_theming__ = __webpack_require__(11);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6__tal_gel_theming___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__tal_gel_theming__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7__tal_gel_core__ = __webpack_require__(7);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7__tal_gel_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__tal_gel_core__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_8__grid_container__ = __webpack_require__(187);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_9__box_layout__ = __webpack_require__(137);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_10__grid__ = __webpack_require__(101);

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);

      if (enumerableOnly) {
        symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
      }

      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  var PageLayoutContext = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createContext();

  var Header = function Header() {};

  Header.displayName = 'Header';

  var Footer = function Footer() {};

  Footer.displayName = 'Footer';

  var SideNav = function SideNav() {};

  SideNav.displayName = 'SideNav'; // Used in case of GelPageContent not being direct child of GelPageLayout
  // See comments in ContentAndFooter

  var ContentContainer = function ContentContainer() {};

  ContentContainer.displayName = 'ContentContainer';

  var Content = function Content(props) {
    var addedToPageLayout = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useRef"])(false);

    var _useContext = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useContext"])(PageLayoutContext),
        addContent = _useContext.addContent,
        removeAllContent = _useContext.removeAllContent; // With React-Router 
    // (or maybe in general with React? likely yes, as similar things 
    // have been observed with NextJS router)
    // 
    // React appears to not unmount a component if the location of 
    // that component in the virtual DOM tree has not changed.
    //
    // <Switch>
    //   <Route path="/about">
    //     <GelPageContent 
    //       fixed
    //       height={getGelTokens().global.sizeBaseUnit * 100} 
    //     >
    //       <MyPageContent />
    //     </GelPageContent>
    //   </Route>
    //   <Route path="/users">
    //     <GelPageContent 
    //       fixed 
    //       height={getGelTokens().global.sizeBaseUnit * 200}
    //     >
    //       <MyPageContent />
    //     </GelPageContent>
    //   </Route>
    // </Switch>
    // 
    // On route change, React does NOT unmount GelPageContent,
    // so the useEffect below cannot use [] as second param.
    // As a result, every time PageLayout re-renders, content
    // will be removed and then added.
    //
    // TODO: Would this be a performance issue? Or would this issue
    // be mitigated by VirtualDOM?


    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useEffect"])(function () {
      if (!addedToPageLayout.current) {
        addContent({
          props: props
        });
        addedToPageLayout.current = true;
      }

      return function () {
        // called before next render
        addedToPageLayout.current = false;
        removeAllContent();
      };
    });

    return null;
  };

  Content.displayName = 'Content'; // only used in case of direct child of GelPageLayout

  var useScrollContentToTop = function useScrollContentToTop() {
    var _useContext2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useContext"])(PageLayoutContext),
        scrollContentToTop = _useContext2.scrollContentToTop;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useEffect"])(function () {
      scrollContentToTop();
    }, []);
  };

  var PageLayoutComponent = function PageLayoutComponent(_ref) {
    var theme = _ref.theme,
        onContextReady = _ref.onContextReady,
        fixed = _ref.fixed,
        children = _ref.children;
    var header = {
      props: {}
    };
    var footer = {
      props: {}
    };
    var sideNav = {
      props: {}
    }; // Must be direct child of GelPageLayout

    var indirectContentContainer; // `indirectContentChildren` are GelPageContent components 
    // nested or rendered inside other components. `directContentChildren` 
    // are GelPageContent components being directly children of GelPageLayout. 
    // `indirectContentChildren` and `directContentChildren` can *not* coexist 
    // in the same GelPageLayout

    var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useState"])([]),
        _useState2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_slicedToArray___default()(_useState, 2),
        indirectContentChildren = _useState2[0],
        setIndirectContentChildren = _useState2[1];

    var directContentChildren = [];

    var childArray = __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.toArray(children);

    childArray.forEach(function (child) {
      if (child.type.displayName === 'Header') {
        if (!header.type) {
          header = child.props.sticky === undefined ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(child, {
            sticky: true // Default sticky to true if not specified

          }) : child;
        } else {
          throw 'Only one header container is allowed';
        }
      }

      if (child.type.displayName === 'Footer') {
        if (!footer.type) {
          footer = child;
        } else {
          throw 'Only one footer container is allowed';
        }
      }

      if (child.type.displayName === 'SideNav') {
        if (!sideNav.type) {
          sideNav = child;
        } else {
          throw 'Only one side nav container is allowed';
        }
      }

      if (child.type.displayName === 'ContentContainer') {
        if (!indirectContentContainer) {
          indirectContentContainer = child;
        } else {
          throw 'Only one content container is allowed';
        }
      }

      if (child.type.displayName === 'Content') {
        // direct child
        directContentChildren.push(child);
      }
    });

    var _useContext3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_10__grid__["d"
    /* ScreenDetectorContext */
    ]),
        screen = _useContext3.screen,
        isXsScreen = _useContext3.isXsScreen;

    var contentWrapperRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useRef"])();

    var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useState"])({
      // Default to closed, if on mobile screen or side nav should be on overlay
      isSideNavOpen: !sideNav.props.overlay && !isXsScreen(screen),
      shouldSwitchToMiniSideNav: false,
      openSideNav: function openSideNav(open) {
        if (open) {
          setContext(_objectSpread(_objectSpread({}, context), {}, {
            isSideNavOpen: true,
            shouldSwitchToMiniSideNav: false
          }));
        } else {
          setContext(_objectSpread(_objectSpread({}, context), {}, {
            isSideNavOpen: false,
            shouldSwitchToMiniSideNav: false
          }));
          var timer = setTimeout(function () {
            // Do not switch to mini side nav until normal 
            // side nav has finished closing (animation)
            setContext(function (context) {
              return _objectSpread(_objectSpread({}, context), {}, {
                shouldSwitchToMiniSideNav: true
              });
            });
            clearTimeout(timer);
          }, theme.Grid.animation.duration.slice( // strip out `ms`
          0, theme.Grid.animation.duration.length - 2));
        }
      },
      scrollContentToTop: function scrollContentToTop() {
        if (contentWrapperRef.current) {
          contentWrapperRef.current.scrollTop = 0;
        }
      },
      addContent: function addContent(_content) {
        // `_content` being { props }
        setIndirectContentChildren(function (__content) {
          return [].concat(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default()(__content), [_content]);
        });
      },
      removeAllContent: function removeAllContent() {
        return setIndirectContentChildren([]);
      },
      getFooterHeightAsBoundary: function getFooterHeightAsBoundary() {
        // Only full width and sticky footers will be considered as boundary.
        // Footer that scrolls with the content can be skipped
        return footerRef.current ? footerRef.current.offsetHeight : 0;
      }
    }),
        _useState4 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_slicedToArray___default()(_useState3, 2),
        context = _useState4[0],
        setContext = _useState4[1];

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__tal_gel_core__["isFunction"])(onContextReady) && onContextReady({
      context: context
    }); // only for angular wrappers

    var isOnMobilePreviously = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useRef"])(isXsScreen(screen));

    var isOnMobile = isXsScreen(screen);

    if (isOnMobile && !isOnMobilePreviously.current) {
      // Force the side nav to be closed initially
      // if screen changes from non-mobile to mobile
      context.openSideNav(false);
    } else if (!isOnMobile && isOnMobilePreviously.current) {
      if (sideNav.props.alwaysOpenExceptOnMobile) {
        context.openSideNav(true);
      }
    }

    isOnMobilePreviously.current = isOnMobile;

    var getWidthForLayout = function getWidthForLayout() {
      var outer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false; // `outer` means the outer layout that 
      //
      // EITHER wraps the full height side nav and the layout that wraps header, content and footer,
      //
      // OR wraps the layout that wraps header, side nav (non full height), content, and footer
      // 
      // In the case of the latter, we do not need to set width of that outer layout

      if (!outer || sideNav.props.fullHeight) {
        // `0` hides the side nav (whether in the outer or inner layout)
        // and as we have set side nav container animatable, it will slide open/closed
        return context.isSideNavOpen ? ['auto', 1] : [0, 1];
      }

      return; // not setting `width`
    };

    var shouldShowOverlay = function shouldShowOverlay() {
      // Shows overlay only if 
      //   side nav is not empty AND
      //   side nav is not supposed to be at the top of mobile screen AND
      //   side nav is open on mobile screen OR
      //   side nav is open and is specified to be on overlay
      return sideNav.props.children && !sideNav.props.topOnMobile && context.isSideNavOpen && (isXsScreen(screen) || sideNav.props.overlay);
    };

    var isFullHeightSideNav = function isFullHeightSideNav() {
      // When overlay is not shown
      return !shouldShowOverlay() && sideNav.props.fullHeight;
    };

    var isNonFullHeightSideNav = function isNonFullHeightSideNav() {
      // When overlay is not shown
      return !shouldShowOverlay() && !sideNav.props.fullHeight;
    };

    var isFullWidthFooter = function isFullWidthFooter() {
      return footer.props.fullWidth;
    };

    var isStickyFooter = function isStickyFooter() {
      return footer.props.sticky;
    };

    var getSideNavWidth = function getSideNavWidth() {
      if (sideNav.props.flexWidth || // TODO: flexWidth not used anymore?
      Object.keys(sideNav.props).length === 0 // if side nav is not provided
      ) {
        return null;
      }

      return (// returns fixed width (including vertical scrollbar if applicable)
        !sideNav.props.large ? theme.Grid.sideNavWidth.regular : theme.Grid.sideNavWidth.large
      );
    };

    var shouldShowNavAtTop = function shouldShowNavAtTop() {
      // `topOnMobile` is only effective when on mobile screen
      return sideNav.props.topOnMobile && isXsScreen(screen);
    };

    var headerRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useRef"])();

    var footerRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useRef"])();

    var _useState5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useState"])(0),
        _useState6 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_slicedToArray___default()(_useState5, 2),
        headerHeight = _useState6[0],
        setHeaderHeight = _useState6[1]; // for header


    var _useState7 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useState"])(0),
        _useState8 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_slicedToArray___default()(_useState7, 2),
        footerHeight = _useState8[0],
        setFooterHeight = _useState8[1]; // for full-width or sticky footer


    var isUnmountedRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__tal_gel_core__["useIsUnmounted"])();

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useEffect"])(function () {
      // Get the height of header
      if (headerRef.current) {
        var timer = setTimeout(function () {
          if (!isUnmountedRef.current) {
            setHeaderHeight(headerRef.current.offsetHeight);
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__tal_gel_core__["isFunction"])(header.props.onHeaderHeight) && header.props.onHeaderHeight(headerRef.current.offsetHeight); // Notify parent of the change of header height
          }

          clearTimeout(timer);
        }, 100); // Somehow we need to wait a bit even after render, to get the accurate offsetHeight
      }

      if (footerRef.current) {
        var _timer = setTimeout(function () {
          if (!isUnmountedRef.current) {
            setFooterHeight(footerRef.current.offsetHeight);
          }

          clearTimeout(_timer);
        }, 100); // Somehow we need to wait a bit even after render, to get the accurate offsetHeight

      }
    });

    var navAtTopRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useRef"])();

    var _useState9 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useState"])(0),
        _useState10 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_slicedToArray___default()(_useState9, 2),
        navAtTopHeight = _useState10[0],
        setNavAtTopHeight = _useState10[1];

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__tal_gel_core__["useLayoutEffect"])(function () {
      // Get the nav height for animation of sliding
      // Skips when offsetHeight is 0 (See NavWrapperAtTop)
      if (navAtTopRef.current && navAtTopRef.current.offsetHeight) {
        setNavAtTopHeight(navAtTopRef.current.offsetHeight);
      }
    });

    var getHeightExludingFullWidthHeaderAndFooter = function getHeightExludingFullWidthHeaderAndFooter() {
      // full width footer is considered sticky, but isStickyFooter()
      // will return false for full width footer. isStickyFooter() returns
      // true if the footer is not full width but still sticky.
      return !isStickyFooter() ? "calc(100vh - ".concat(headerHeight, "px - ").concat(footerHeight, "px)") : "calc(100vh - ".concat(headerHeight, "px)");
    };

    var ContentAndFooter = function ContentAndFooter() {
      var content = !indirectContentContainer ? directContentChildren : indirectContentChildren;
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Fragment, null, indirectContentContainer &&
      /*#__PURE__*/
      // Gives the nested GelPageContent component(s) an opportunity
      // to render itself. Note that `GelPageContent` will render nothing,
      // but in useEffect it will register its props to GelPageLayout which
      // will in turn render the `content` of the registered `GelPageContent`
      //
      // Noramally, components that nest GelPageContent start with GelPageContent
      // at a higher level as anything other than children of GelPageContent won't
      // appear on the screen anyway.
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
        style: __WEBPACK_IMPORTED_MODULE_7__tal_gel_core__["accessibleHiddenStyle"]
      }, indirectContentContainer.props.children), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__box_layout__["a"
      /* BoxLayout */
      ], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
        vertical: true,
        wrap: false // Height wise, makes content expandable but footer as is
        // Note that by default flex items have 'min-height: auto' when
        // flex-direction is `column`. So if the content is too long,
        // it is not shrinkable unless we set min-height to 0
        // https://stackoverflow.com/a/36247448
        ,
        space: [1, 'auto'],
        shrinkable: footer.props.sticky ? [true, false] : false,
        gap: "none",
        alignment: "stretch",
        distribution: "start"
      }, !shouldNotFixHeader() && {
        height: getHeightExludingFullWidthHeaderAndFooter(),
        style: {
          overflow: 'auto'
        }
      }, {
        ref: contentWrapperRef
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(TopLevelContentWrapper, {
        autoOverflow: isFullWidthFooter() || isStickyFooter()
      }, content.map(function (_content, index) {
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(OuterContentWrapper, {
          key: index,
          customStyle: _content.props.style,
          height: _content.props.height,
          last: index === content.length - 1
        }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ContentWrapper, {
          theme: theme,
          fixed: _content.props.fixed,
          screen: screen,
          sideNavOpen: context.isSideNavOpen,
          sideNavWidth: getSideNavWidth(),
          autoOverflow: isFullWidthFooter() || isStickyFooter()
        }, _content.props.children));
      })), !isFullWidthFooter() && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(FooterWrapper, isStickyFooter() && {
        ref: footerRef
      }, footer.props.children)));
    };

    var shouldNotFixHeader = function shouldNotFixHeader() {
      // Header can only be made non-sticky if side nav does not exist 
      // (regardless of whether side nav is closed or open)
      return sideNav.props.children === undefined && !header.props.sticky;
    };

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(PageLayoutContext.Provider, {
      value: context
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__grid_container__["a"
    /* Container */
    ], {
      noGutter: true,
      fixed: fixed,
      showOverlay: shouldShowOverlay(),
      overlayContent:
      /*#__PURE__*/
      // side nav is the content
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(SideNavWrapper, {
        customStyle: sideNav.props.style,
        width: getSideNavWidth()
      }, sideNav.props.children),
      onOverlayClick: function onOverlayClick() {
        return context.openSideNav(!context.isSideNavOpen);
      }
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__box_layout__["a"
    /* BoxLayout */
    ], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
      space: getWidthForLayout(true) // Set the side nav container as animatable
      // if side nav takes up full height of the screen 
      // and is set to be sliding open/closed
      ,
      animated: isFullHeightSideNav() && sideNav.props.sliding && [true, false],
      animatedWidth: getSideNavWidth(),
      animatedWidthClosed: sideNav.props.miniOnClose ? theme.Grid.sideNavWidth.mini : 0,
      alignment: "stretch",
      gap: "none",
      distribution: "start" // Take up full height of the screen

    }, isFullHeightSideNav() && {
      height: '100vh'
    }), isFullHeightSideNav() && !shouldShowNavAtTop() &&
    /*#__PURE__*/
    // Side Nav
    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__box_layout__["a"
    /* BoxLayout */
    ], {
      vertical: true,
      wrap: false,
      gap: "none",
      alignment: "stretch",
      distribution: "start",
      height: "100vh" // Take up full height of the screen
      ,
      style: {
        overflowY: 'auto',
        overflowX: 'hidden'
      }
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(SideNavWrapper, {
      customStyle: sideNav.props.style //  width={getSideNavWidth()}

    }, sideNav.props.children)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__box_layout__["a"
    /* BoxLayout */
    ], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
      vertical: true,
      alignment: "stretch",
      gap: "none"
    }, shouldNotFixHeader() && {
      style: {
        height: '100%',
        overflow: 'auto'
      }
    }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(HeaderWrapper, {
      ref: headerRef
    }, header.props.children), shouldShowNavAtTop() && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(NavWrapperAtTop, {
      ref: navAtTopRef,
      theme: theme,
      navHeight: navAtTopHeight,
      navMaxHeight: sideNav.props.maxHeightAtTop,
      isNavOpen: context.isSideNavOpen,
      customStyle: sideNav.props.style
    }, sideNav.props.children), isNonFullHeightSideNav() ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__box_layout__["a"
    /* BoxLayout */
    ], {
      space: !shouldShowNavAtTop() ? getWidthForLayout() : 1 // Set side nav container animatable 
      // if side nav is below header and
      // is set to be sliding open/closed
      ,
      animated: !shouldShowNavAtTop() && sideNav.props.sliding && [true, false],
      animatedWidth: getSideNavWidth(),
      animatedWidthClosed: sideNav.props.miniOnClose ? theme.Grid.sideNavWidth.mini : 0,
      alignment: "stretch",
      gap: "none",
      wrap: false,
      height: getHeightExludingFullWidthHeaderAndFooter()
    }, !shouldShowNavAtTop() && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__box_layout__["a"
    /* BoxLayout */
    ], {
      vertical: true,
      wrap: false,
      gap: "none",
      alignment: "stretch",
      distribution: "start",
      height: getHeightExludingFullWidthHeaderAndFooter(),
      style: {
        overflowY: 'auto',
        overflowX: 'hidden'
      }
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(SideNavWrapper, {
      customStyle: sideNav.props.style //  width={getSideNavWidth()}

    }, sideNav.props.children)), ContentAndFooter()) : // If side nav takes up full height of the screen,
    // we can skip the side nav here
    ContentAndFooter(), isFullWidthFooter() && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(FooterWrapper, {
      ref: footerRef
    }, footer.props.children)))));
  };

  var HeaderWrapper = __WEBPACK_IMPORTED_MODULE_5__emotion_styled___default.a.header({
    zIndex: 10
  });

  var FooterWrapper = __WEBPACK_IMPORTED_MODULE_5__emotion_styled___default.a.footer({
    zIndex: 10
  });

  var ContentWrapper = __WEBPACK_IMPORTED_MODULE_5__emotion_styled___default.a.div({
    height: '100%'
  }, function (_ref2) {
    var theme = _ref2.theme,
        fixed = _ref2.fixed,
        screen = _ref2.screen,
        autoOverflow = _ref2.autoOverflow; // Similar to the `fixed` prop in `GelContainer` and `GelContainerLite`

    return _objectSpread(_objectSpread({
      maxWidth: !fixed ? '100%' : theme.Grid.containerMaxWidth[screen],
      transition: "max-width ".concat(theme.Grid.animation.duration, " ").concat(theme.Grid.animation.speedCurve)
    }, fixed && {
      // centered
      marginLeft: 'auto',
      marginRight: 'auto',
      padding: theme.Grid.containerPadding[screen]
    }), autoOverflow && {
      overflow: 'auto'
    });
  });

  var TopLevelContentWrapper = __WEBPACK_IMPORTED_MODULE_5__emotion_styled___default.a.main({
    display: 'flex',
    flexDirection: 'column',
    height: '100%'
  }, function (_ref3) {
    var autoOverflow = _ref3.autoOverflow;
    return _objectSpread({}, autoOverflow && {
      overflow: 'auto'
    });
  });

  var OuterContentWrapper = __WEBPACK_IMPORTED_MODULE_5__emotion_styled___default.a.div(function (_ref4) {
    var customStyle = _ref4.customStyle,
        height = _ref4.height,
        last = _ref4.last;
    return _objectSpread(_objectSpread({}, customStyle), {}, {
      // `height` can be specified for each GelPageContent 
      // when there are multiple GelPageContent components
      height: height === undefined ? 'auto' : height
    }, last && {
      flex: '1 0 auto'
    });
  });

  var SideNavWrapper = __WEBPACK_IMPORTED_MODULE_5__emotion_styled___default.a.aside({
    height: '100%',
    overflowY: 'auto',
    overflowX: 'hidden'
  }, function (_ref5) {
    var customStyle = _ref5.customStyle,
        width = _ref5.width;
    return _objectSpread(_objectSpread({}, customStyle), {}, {
      // Only used when side nav is on overlay
      // otherwise we do not specify width here 
      // (width: undefined), but let the animated
      // BoxLayout set the width
      width: width
    });
  });

  var NavWrapperAtTop = __WEBPACK_IMPORTED_MODULE_5__emotion_styled___default.a.nav(function (_ref6) {
    var theme = _ref6.theme,
        navHeight = _ref6.navHeight,
        navMaxHeight = _ref6.navMaxHeight,
        isNavOpen = _ref6.isNavOpen,
        customStyle = _ref6.customStyle;
    return _objectSpread(_objectSpread({}, !navHeight ? __WEBPACK_IMPORTED_MODULE_7__tal_gel_core__["accessibleHiddenStyle"] : {
      // If nav height already determined, set max height as per the nav's open/closed status
      maxHeight: !isNavOpen ? 0 : navMaxHeight || navHeight
    }), {}, {
      // There won't be scrolling if navMaxHeight is not specified
      // because navHeight (the actual height) will be the maxHeight
      overflow: !navMaxHeight ? 'hidden' : 'auto',
      transition: "max-height ".concat(theme.Grid.animation.duration, " ").concat(theme.Grid.animation.speedCurve)
    }, customStyle);
  });

  var PageLayout = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__tal_gel_theming__["withTheme"])(PageLayoutComponent);
  /***/

},
/* 135 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony export (binding) */

  __webpack_require__.d(__webpack_exports__, "b", function () {
    return convertEventTargetValueToNumeric;
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__number_input__ = __webpack_require__(313);
  /* harmony default export */


  __webpack_exports__["a"] = __WEBPACK_IMPORTED_MODULE_0__number_input__["a"
  /* NumberInput */
  ];
  var convertEventTargetValueToNumeric = __WEBPACK_IMPORTED_MODULE_0__number_input__["b"
  /* convertEventTargetValueToNumeric */
  ];
  /***/
},
/* 136 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__spinner__ = __webpack_require__(324);
  /* harmony default export */


  __webpack_exports__["a"] = __WEBPACK_IMPORTED_MODULE_0__spinner__["a"
  /* Spinner */
  ];
  /***/
},
/* 137 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony export (binding) */

  __webpack_require__.d(__webpack_exports__, "a", function () {
    return BoxLayout;
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(5);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_typeof__ = __webpack_require__(103);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_typeof__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__grid_row__ = __webpack_require__(106);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6__grid_col__ = __webpack_require__(105);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7__grid_screen_detector__ = __webpack_require__(33);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_8__container_lite__ = __webpack_require__(62);

  var _excluded = ["alignment", "distribution", "gap", "wrap", "space", "order", "alignmentIndividual", "vertical", "width", "height", "animated", "animatedWidth", "animatedWidthClosed", "shrinkable", "style", "childStyle", "children"];

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);

      if (enumerableOnly) {
        symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
      }

      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  } // Illustratively,
  //
  // <GelBoxLayout>
  //   <Block />
  //   <Block />
  //   <Block />
  //   <Block />
  // </GelBoxLayout>
  //
  // will become (props omitted):
  //
  // <Row>
  //   <Col><Block /></Col>
  //   <Col><Block /></Col>
  //   <Col><Block /></Col>
  //   <Col><Block /></Col>
  // </Row>
  //
  // `Row` is flexbox and `Col` is flex item
  // Each `Block` will be wrapped by a flex item (container)
  // whose width can be greater than `Block`
  // Responsive flexbox, based on flexGrow (flexBasis being 0)


  var BoxLayoutComponent = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.forwardRef(function (_ref, forwardedRef) {
    var _ref$alignment = _ref.alignment,
        alignment = _ref$alignment === void 0 ? 'center' : _ref$alignment,
        _ref$distribution = _ref.distribution,
        distribution = _ref$distribution === void 0 ? 'center' : _ref$distribution,
        _ref$gap = _ref.gap,
        gap = _ref$gap === void 0 ? 'medium' : _ref$gap,
        _ref$wrap = _ref.wrap,
        wrap = _ref$wrap === void 0 ? true : _ref$wrap,
        _ref$space = _ref.space,
        space = _ref$space === void 0 ? {} : _ref$space,
        _ref$order = _ref.order,
        order = _ref$order === void 0 ? {} : _ref$order,
        _ref$alignmentIndivid = _ref.alignmentIndividual,
        alignmentIndividual = _ref$alignmentIndivid === void 0 ? {} : _ref$alignmentIndivid,
        _ref$vertical = _ref.vertical,
        vertical = _ref$vertical === void 0 ? false : _ref$vertical,
        width = _ref.width,
        _ref$height = _ref.height,
        height = _ref$height === void 0 ? 'auto' : _ref$height,
        _ref$animated = _ref.animated,
        animated = _ref$animated === void 0 ? [] : _ref$animated,
        animatedWidth = _ref.animatedWidth,
        animatedWidthClosed = _ref.animatedWidthClosed,
        _ref$shrinkable = _ref.shrinkable,
        shrinkable = _ref$shrinkable === void 0 ? [] : _ref$shrinkable,
        style = _ref.style,
        childStyle = _ref.childStyle,
        children = _ref.children,
        props = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties___default()(_ref, _excluded);

    var _useContext = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_7__grid_screen_detector__["a"
    /* ScreenDetectorContext */
    ]),
        currScreen = _useContext.screen,
        gridGutters = _useContext.gridGutters,
        findScreenPropByScreen = _useContext.findScreenPropByScreen;

    var filteredChildren = __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.toArray(children).filter(function (child) {
      // Skip empty child (Eg: can happen with conditional render and commenting)
      return child && child !== ' ';
    });

    var gutterWidth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__container_lite__["a"
    /* getGutter */
    ])(gridGutters, gap);

    var getFrom = function getFrom(prop) {
      // prop could be `space` or `order`
      var result; // can be either an array or single value

      if (Array.isArray(prop)) {
        // Use `space` or `order` directly if it's an array
        result = prop; // array
      } else if (__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_typeof___default()(prop) === 'object') {
        // If an object, it can contain screen props for responsive col widths
        var screenProp = findScreenPropByScreen(currScreen, prop);
        result = screenProp ? prop[screenProp] : []; // can be either an array or single value
      } else {
        // If single value (not array or object), apply that space to all cols
        result = prop; // single value
      }

      return result;
    };
    /**
     * Gets the width (mostly to be used as flexGrow) for column by index 
     * (Note: Can also be used to get `order`)
     * @param index - index of column
     */


    var getFromByIndex = function getFromByIndex(prop, index) {
      // prop can be `colWidths` or `colOrders`
      if (Array.isArray(prop)) {
        // if array
        // If value not defined in the array by index, default to 1 (flexGrow: 1 or order: 1)
        return prop[index] !== undefined ? prop[index] : 1;
      }

      return prop; // If single value, apply the value directly
    };

    var colWidths = getFrom(space);
    var colOrders = getFrom(order);
    var colAlignments = getFrom(alignmentIndividual);
    /**
     * Gets the shrinkability (true or false) for column by index 
     * @param index - index of column
     */

    var getColShrinkability = function getColShrinkability(index) {
      if (Array.isArray(shrinkable)) {
        // if array
        // If value not defined in the array by index, default to false
        return shrinkable[index] !== undefined ? shrinkable[index] : false;
      }

      return shrinkable; // If single value, apply the value directly
    };

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__grid_row__["a"
    /* Row */
    ] // flexbox
    , __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
      align: alignment,
      justify: distribution,
      gutter: gutterWidth,
      wrap: wrap,
      vertical: vertical,
      style: _objectSpread(_objectSpread({}, style), {}, {
        width: width,
        height: height
      }),
      ref: forwardedRef
    }, props), filteredChildren.map(function (child, index) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__grid_col__["a"
      /* Col */
      ] // flex item
      , {
        key: index,
        width: getFromByIndex(colWidths, index),
        order: getFromByIndex(colOrders, index),
        alignment: getFromByIndex(colAlignments, index),
        animated: animated[index] || false,
        animatedWidth: animatedWidth,
        animatedWidthClosed: animatedWidthClosed,
        shrinkable: getColShrinkability(index),
        style: childStyle
      }, child);
    }));
  });

  var BoxLayout = BoxLayoutComponent;
  /***/
},
/* 138 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony export (binding) */

  __webpack_require__.d(__webpack_exports__, "b", function () {
    return withRadioGroupContext;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "a", function () {
    return RadioGroup;
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(5);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__emotion_styled__ = __webpack_require__(14);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__emotion_styled___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__emotion_styled__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6__tal_gel_core__ = __webpack_require__(7);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6__tal_gel_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__tal_gel_core__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7__tal_gel_theming__ = __webpack_require__(11);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7__tal_gel_theming___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__tal_gel_theming__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_8__utils_get_caption_elements__ = __webpack_require__(83);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_9__utils_checkbox_radio_utils__ = __webpack_require__(67);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_10__form_multi_step_form__ = __webpack_require__(53);

  var _excluded = ["name", "value", "defaultValue", "disabled", "inverse", "error", "vertical", "button", "buttonGroup", "theme", "width", "height", "caption", "gap", "submitCheck", "index", "setValidity", "resetValidator", "required", "requiredErrorMsg", "errorMsg", "onError", "alternativeButtons", "children"];

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);

      if (enumerableOnly) {
        symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
      }

      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  var RadioGroupContext = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createContext();
  /**
   * Radio group for radio boxes
   * Any radio box must be in a radio group
   */


  var RadioGroupComponent = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.forwardRef(function (_ref, forwardedRef) {
    var name = _ref.name,
        value = _ref.value,
        defaultValue = _ref.defaultValue,
        disabled = _ref.disabled,
        inverse = _ref.inverse,
        error = _ref.error,
        vertical = _ref.vertical,
        button = _ref.button,
        buttonGroup = _ref.buttonGroup,
        theme = _ref.theme,
        width = _ref.width,
        height = _ref.height,
        caption = _ref.caption,
        gap = _ref.gap,
        submitCheck = _ref.submitCheck,
        index = _ref.index,
        setValidity = _ref.setValidity,
        resetValidator = _ref.resetValidator,
        required = _ref.required,
        requiredErrorMsg = _ref.requiredErrorMsg,
        errorMsg = _ref.errorMsg,
        onError = _ref.onError,
        alternativeButtons = _ref.alternativeButtons,
        children = _ref.children,
        props = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties___default()(_ref, _excluded); // Stores the `checked` status of each contained individual radiobox
    // Note that in the group there can be at most one radiobox checked at a time


    var groupChecked = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useRef"])({});

    var _useCrContext = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_checkbox_radio_utils__["h"
    /* useCrContext */
    ])({
      theme: theme,
      vertical: vertical,
      width: width,
      height: height,
      gap: gap,
      alternativeButtons: alternativeButtons
    }),
        crContextOnBlurGenerator = _useCrContext.onBlurGenerator,
        crContextOnFocus = _useCrContext.onFocus,
        crContextOnChangeGenerator = _useCrContext.onChangeGenerator,
        gutterWidth = _useCrContext.gutterWidth,
        shouldIgnoreGutterWidth = _useCrContext.shouldIgnoreGutterWidth; // Constructs a group context object to be shared by radio boxes in the group


    var buildGroupContext = function buildGroupContext(selectedValue) {
      return _objectSpread(_objectSpread({
        name: name,
        value: value
      }, selectedValue !== undefined && {
        selectedValue: selectedValue
      }), {}, {
        setSelectedValue: setSelectedValue,
        // Note that passing down the function this way can be a source of closure issues 
        vertical: vertical,
        disabled: disabled,
        inverse: inverse,
        error: error,
        button: button,
        buttonGroup: buttonGroup,
        gutterWidth: shouldIgnoreGutterWidth() ? null : gutterWidth,
        onBlur: crContextOnBlurGenerator(onBlurFromValidator),
        // see comment on `useCrContext`
        onFocus: crContextOnFocus,
        // see comment on `useCrContext`
        onChange: crContextOnChangeGenerator( // see comment on `useCrContext`
        groupChecked, onChangeFromValidator),
        submitCheck: submitCheck,
        shouldShowError: shouldShowError,
        required: required
      });
    };
    /**
     * Sets the selected value in the group context
     * 
     * This function will be available in the group context
     * for CONTEXT CONSUMERS to call and set the selected value
     */


    var setSelectedValue = function setSelectedValue(value) {
      // The new group context object will make the context provider re-render context consumers
      setContext(_objectSpread(_objectSpread({}, context), buildGroupContext(value)));
    };

    var isInitialMount = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useRef"])(true);

    var _useValidator = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__tal_gel_core__["useValidator"])({
      index: index,
      // index assigned by the form
      setValidity: setValidity,
      // function to report validity of this radio group to the form
      reset: resetValidator,
      // whether to reset the validator
      error: error,
      // controlled `error` prop, directly telling validator if there is error (without needing to check for error by itself)
      caption: caption,
      // initial caption underneath the group, can also be used to display error message if the controlled `error` is true
      checkError: required,
      // tells validator whether to check for error
      hasError: function hasError() {
        // tells validator HOW to check for error
        if (required) {
          // if required to check `required` error
          return Object.keys(groupChecked.current).reduce(function (result, key) {
            return groupChecked.current[key] ? ++result : result;
          }, 0) === 0 && 'required';
        }

        return false;
      },
      onError: onError,
      // tells validator the callback to invoke if error occurs or disappears 
      errorMsg: _objectSpread({
        // tells validator the error message to include in caption if error occurs
        'required': requiredErrorMsg
      }, errorMsg),
      hideErrorInitially: true,
      // tells validator to hide error initially
      group: true,
      // tells validator if it is group being validated
      submitCheck: {
        shouldTrigger: submitCheck // empty object

      },
      MultiStepFormContext: __WEBPACK_IMPORTED_MODULE_10__form_multi_step_form__["a"
      /* MultiStepFormContext */
      ]
    }),
        _useValidator2 = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default()(_useValidator, 4),
        onBlurFromValidator = _useValidator2[0],
        onChangeFromValidator = _useValidator2[1],
        getCaption = _useValidator2[2],
        shouldShowError = _useValidator2[3]; // initialise a group context


    var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useState"])(buildGroupContext(defaultValue)),
        _useState2 = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default()(_useState, 2),
        context = _useState2[0],
        setContext = _useState2[1];

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useEffect"])(function () {
      // Skip if 'value' of the selected radio in the group is NOT controlled by parent
      // and if it is after initial mount/first rendering
      if (value === undefined && isInitialMount.current) {
        isInitialMount.current = false;
      } else {
        // Build a new group context each time any group related prop receives a new value FROM PARENT
        // The new group context object will make the context provider re-render context consumers
        setContext(_objectSpread(_objectSpread({}, context), buildGroupContext(value)));
      }
    }, [value, vertical, disabled, inverse, error, button, buttonGroup, required]);

    var radioIndex = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useRef"])();

    var indexAssigmentDone = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useRef"])();

    radioIndex.current = 0;
    indexAssigmentDone.current = false;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useEffect"])(function () {
      indexAssigmentDone.current = true;
    });

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(RadioGroupContext.Provider, {
      value: _objectSpread(_objectSpread({}, context), {}, {
        index: radioIndex,
        submitCheck: submitCheck,
        error: shouldShowError(),
        indexAssigmentDone: indexAssigmentDone
      })
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(RadioGroupContainer, {
      "data-cy": "gel-radio-group",
      ref: forwardedRef
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(StyledFlexContainer, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
      justifyContent: "space-between",
      alignItems: "stretch",
      alternativeButtons: alternativeButtons
    }, alternativeButtons && {
      flexWrap: true
    }, vertical && {
      flexDirection: 'column'
    }, {
      theme: theme,
      width: width,
      height: height,
      gutterWidth: gutterWidth,
      error: shouldShowError(),
      inverse: inverse,
      vertical: vertical
    }, props), children), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_get_caption_elements__["a"
    /* default */
    ])(getCaption)));
  });

  var RadioGroupContainer = __WEBPACK_IMPORTED_MODULE_5__emotion_styled___default.a.div({
    width: '100%'
  });

  var StyledFlexContainer = __WEBPACK_IMPORTED_MODULE_5__emotion_styled___default()(__WEBPACK_IMPORTED_MODULE_6__tal_gel_core__["GelFlexContainer"])({
    margin: 0
  }, function (_ref2) {
    var style = _ref2.style,
        theme = _ref2.theme,
        error = _ref2.error,
        inverse = _ref2.inverse,
        width = _ref2.width,
        height = _ref2.height,
        gutterWidth = _ref2.gutterWidth,
        vertical = _ref2.vertical,
        alternativeButtons = _ref2.alternativeButtons;

    var _getStylesForStates = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__tal_gel_theming__["getStylesForStates"])({
      theme: theme,
      target: 'Radio',
      subTarget: 'Caption',
      danger: error,
      inverse: inverse
    }),
        normalStyles = _getStylesForStates.normalStyles;

    return _objectSpread(_objectSpread(_objectSpread({}, style), gutterWidth ? _objectSpread(_objectSpread({
      justifyContent: 'flex-start'
    }, !vertical ? {
      height: height
    } : {
      width: width
    }), alternativeButtons && {
      width: width
    }) : {
      width: width,
      height: height
    }), {}, {
      '~ .caption': normalStyles
    });
  });
  /**
   * HOC to provide radio group context to the contained radio box
   */


  var withRadioGroupContext = function withRadioGroupContext(Component) {
    return function (props) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(RadioGroupContext.Consumer, null, function (context) {
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
          groupContext: context
        }, props));
      });
    };
  };

  var RadioGroup = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__tal_gel_theming__["withTheme"])(RadioGroupComponent);

  RadioGroup.displayName = 'RadioGroup';
  /***/
},
/* 139 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
  module.exports = ReactPropTypesSecret;
  /***/
},
/* 140 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (process) {
    if (process.env.NODE_ENV === 'production') {
      module.exports = __webpack_require__(341);
    } else {
      module.exports = __webpack_require__(340);
    }
    /* WEBPACK VAR INJECTION */

  }).call(exports, __webpack_require__(25));
  /***/
},
/* 141 */

/***/
function (module, exports, __webpack_require__) {
  var global = __webpack_require__(1);

  var isConstructor = __webpack_require__(76);

  var tryToString = __webpack_require__(100);

  var TypeError = global.TypeError; // `Assert: IsConstructor(argument) is true`

  module.exports = function (argument) {
    if (isConstructor(argument)) return argument;
    throw TypeError(tryToString(argument) + ' is not a constructor');
  };
  /***/

},
/* 142 */

/***/
function (module, exports) {
  // eslint-disable-next-line es/no-typed-arrays -- safe
  module.exports = typeof ArrayBuffer != 'undefined' && typeof DataView != 'undefined';
  /***/
},
/* 143 */

/***/
function (module, exports, __webpack_require__) {
  // FF26- bug: ArrayBuffers are non-extensible, but Object.isExtensible does not report it
  var fails = __webpack_require__(2);

  module.exports = fails(function () {
    if (typeof ArrayBuffer == 'function') {
      var buffer = new ArrayBuffer(8); // eslint-disable-next-line es/no-object-isextensible, es/no-object-defineproperty -- safe

      if (Object.isExtensible(buffer)) Object.defineProperty(buffer, 'a', {
        value: 8
      });
    }
  });
  /***/
},
/* 144 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var toObject = __webpack_require__(22);

  var toAbsoluteIndex = __webpack_require__(60);

  var lengthOfArrayLike = __webpack_require__(23); // `Array.prototype.fill` method implementation
  // https://tc39.es/ecma262/#sec-array.prototype.fill


  module.exports = function fill(value
  /* , start = 0, end = @length */
  ) {
    var O = toObject(this);
    var length = lengthOfArrayLike(O);
    var argumentsLength = arguments.length;
    var index = toAbsoluteIndex(argumentsLength > 1 ? arguments[1] : undefined, length);
    var end = argumentsLength > 2 ? arguments[2] : undefined;
    var endPos = end === undefined ? length : toAbsoluteIndex(end, length);

    while (endPos > index) {
      O[index++] = value;
    }

    return O;
  };
  /***/

},
/* 145 */

/***/
function (module, exports, __webpack_require__) {
  var arraySlice = __webpack_require__(86);

  var floor = Math.floor;

  var mergeSort = function mergeSort(array, comparefn) {
    var length = array.length;
    var middle = floor(length / 2);
    return length < 8 ? insertionSort(array, comparefn) : merge(array, mergeSort(arraySlice(array, 0, middle), comparefn), mergeSort(arraySlice(array, middle), comparefn), comparefn);
  };

  var insertionSort = function insertionSort(array, comparefn) {
    var length = array.length;
    var i = 1;
    var element, j;

    while (i < length) {
      j = i;
      element = array[i];

      while (j && comparefn(array[j - 1], element) > 0) {
        array[j] = array[--j];
      }

      if (j !== i++) array[j] = element;
    }

    return array;
  };

  var merge = function merge(array, left, right, comparefn) {
    var llength = left.length;
    var rlength = right.length;
    var lindex = 0;
    var rindex = 0;

    while (lindex < llength || rindex < rlength) {
      array[lindex + rindex] = lindex < llength && rindex < rlength ? comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++] : lindex < llength ? left[lindex++] : right[rindex++];
    }

    return array;
  };

  module.exports = mergeSort;
  /***/
},
/* 146 */

/***/
function (module, exports, __webpack_require__) {
  var wellKnownSymbol = __webpack_require__(15);

  var MATCH = wellKnownSymbol('match');

  module.exports = function (METHOD_NAME) {
    var regexp = /./;

    try {
      '/./'[METHOD_NAME](regexp);
    } catch (error1) {
      try {
        regexp[MATCH] = false;
        return '/./'[METHOD_NAME](regexp);
      } catch (error2) {
        /* empty */
      }
    }

    return false;
  };
  /***/

},
/* 147 */

/***/
function (module, exports, __webpack_require__) {
  var fails = __webpack_require__(2);

  module.exports = !fails(function () {
    function F() {
      /* empty */
    }

    F.prototype.constructor = null; // eslint-disable-next-line es/no-object-getprototypeof -- required for testing

    return Object.getPrototypeOf(new F()) !== F.prototype;
  });
  /***/
},
/* 148 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var IteratorPrototype = __webpack_require__(214).IteratorPrototype;

  var create = __webpack_require__(41);

  var createPropertyDescriptor = __webpack_require__(47);

  var setToStringTag = __webpack_require__(49);

  var Iterators = __webpack_require__(95);

  var returnThis = function returnThis() {
    return this;
  };

  module.exports = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
    var TO_STRING_TAG = NAME + ' Iterator';
    IteratorConstructor.prototype = create(IteratorPrototype, {
      next: createPropertyDescriptor(+!ENUMERABLE_NEXT, next)
    });
    setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
    Iterators[TO_STRING_TAG] = returnThis;
    return IteratorConstructor;
  };
  /***/

},
/* 149 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $ = __webpack_require__(0);

  var call = __webpack_require__(19);

  var IS_PURE = __webpack_require__(31);

  var FunctionName = __webpack_require__(74);

  var isCallable = __webpack_require__(17);

  var createIteratorConstructor = __webpack_require__(148);

  var getPrototypeOf = __webpack_require__(48);

  var setPrototypeOf = __webpack_require__(52);

  var setToStringTag = __webpack_require__(49);

  var createNonEnumerableProperty = __webpack_require__(35);

  var redefine = __webpack_require__(24);

  var wellKnownSymbol = __webpack_require__(15);

  var Iterators = __webpack_require__(95);

  var IteratorsCore = __webpack_require__(214);

  var PROPER_FUNCTION_NAME = FunctionName.PROPER;
  var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
  var IteratorPrototype = IteratorsCore.IteratorPrototype;
  var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
  var ITERATOR = wellKnownSymbol('iterator');
  var KEYS = 'keys';
  var VALUES = 'values';
  var ENTRIES = 'entries';

  var returnThis = function returnThis() {
    return this;
  };

  module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
    createIteratorConstructor(IteratorConstructor, NAME, next);

    var getIterationMethod = function getIterationMethod(KIND) {
      if (KIND === DEFAULT && defaultIterator) return defaultIterator;
      if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];

      switch (KIND) {
        case KEYS:
          return function keys() {
            return new IteratorConstructor(this, KIND);
          };

        case VALUES:
          return function values() {
            return new IteratorConstructor(this, KIND);
          };

        case ENTRIES:
          return function entries() {
            return new IteratorConstructor(this, KIND);
          };
      }

      return function () {
        return new IteratorConstructor(this);
      };
    };

    var TO_STRING_TAG = NAME + ' Iterator';
    var INCORRECT_VALUES_NAME = false;
    var IterablePrototype = Iterable.prototype;
    var nativeIterator = IterablePrototype[ITERATOR] || IterablePrototype['@@iterator'] || DEFAULT && IterablePrototype[DEFAULT];
    var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
    var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
    var CurrentIteratorPrototype, methods, KEY; // fix native

    if (anyNativeIterator) {
      CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));

      if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
        if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
          if (setPrototypeOf) {
            setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
          } else if (!isCallable(CurrentIteratorPrototype[ITERATOR])) {
            redefine(CurrentIteratorPrototype, ITERATOR, returnThis);
          }
        } // Set @@toStringTag to native iterators


        setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
        if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
      }
    } // fix Array.prototype.{ values, @@iterator }.name in V8 / FF


    if (PROPER_FUNCTION_NAME && DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
      if (!IS_PURE && CONFIGURABLE_FUNCTION_NAME) {
        createNonEnumerableProperty(IterablePrototype, 'name', VALUES);
      } else {
        INCORRECT_VALUES_NAME = true;

        defaultIterator = function values() {
          return call(nativeIterator, this);
        };
      }
    } // export additional methods


    if (DEFAULT) {
      methods = {
        values: getIterationMethod(VALUES),
        keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
        entries: getIterationMethod(ENTRIES)
      };
      if (FORCED) for (KEY in methods) {
        if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
          redefine(IterablePrototype, KEY, methods[KEY]);
        }
      } else $({
        target: NAME,
        proto: true,
        forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME
      }, methods);
    } // define iterator


    if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
      redefine(IterablePrototype, ITERATOR, defaultIterator, {
        name: DEFAULT
      });
    }

    Iterators[NAME] = defaultIterator;
    return methods;
  };
  /***/

},
/* 150 */

/***/
function (module, exports, __webpack_require__) {
  var userAgent = __webpack_require__(57);

  var webkit = userAgent.match(/AppleWebKit\/(\d+)\./);
  module.exports = !!webkit && +webkit[1];
  /***/
},
/* 151 */

/***/
function (module, exports) {
  // IE8- don't enum bug keys
  module.exports = ['constructor', 'hasOwnProperty', 'isPrototypeOf', 'propertyIsEnumerable', 'toLocaleString', 'toString', 'valueOf'];
  /***/
},
/* 152 */

/***/
function (module, exports, __webpack_require__) {
  var fails = __webpack_require__(2);

  var createPropertyDescriptor = __webpack_require__(47);

  module.exports = !fails(function () {
    var error = Error('a');
    if (!('stack' in error)) return true; // eslint-disable-next-line es/no-object-defineproperty -- safe

    Object.defineProperty(error, 'stack', createPropertyDescriptor(1, 7));
    return error.stack !== 7;
  });
  /***/
},
/* 153 */

/***/
function (module, exports, __webpack_require__) {
  var wellKnownSymbol = __webpack_require__(15);

  var Iterators = __webpack_require__(95);

  var ITERATOR = wellKnownSymbol('iterator');
  var ArrayPrototype = Array.prototype; // check on default Array iterator

  module.exports = function (it) {
    return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
  };
  /***/

},
/* 154 */

/***/
function (module, exports, __webpack_require__) {
  var isObject = __webpack_require__(13);

  var floor = Math.floor; // `IsIntegralNumber` abstract operation
  // https://tc39.es/ecma262/#sec-isintegralnumber
  // eslint-disable-next-line es/no-number-isinteger -- safe

  module.exports = Number.isInteger || function isInteger(it) {
    return !isObject(it) && isFinite(it) && floor(it) === it;
  };
  /***/

},
/* 155 */

/***/
function (module, exports) {
  // `Math.sign` method implementation
  // https://tc39.es/ecma262/#sec-math.sign
  // eslint-disable-next-line es/no-math-sign -- safe
  module.exports = Math.sign || function sign(x) {
    // eslint-disable-next-line no-self-compare -- NaN check
    return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
  };
  /***/

},
/* 156 */

/***/
function (module, exports, __webpack_require__) {
  /* eslint-disable es/no-symbol -- required for testing */
  var V8_VERSION = __webpack_require__(64);

  var fails = __webpack_require__(2); // eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing


  module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
    var symbol = Symbol(); // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances

    return !String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
  });
  /***/
},
/* 157 */

/***/
function (module, exports, __webpack_require__) {
  var global = __webpack_require__(1);

  var isRegExp = __webpack_require__(94);

  var TypeError = global.TypeError;

  module.exports = function (it) {
    if (isRegExp(it)) {
      throw TypeError("The method doesn't accept regular expressions");
    }

    return it;
  };
  /***/

},
/* 158 */

/***/
function (module, exports, __webpack_require__) {
  /* eslint-disable es/no-object-getownpropertynames -- safe */
  var classof = __webpack_require__(38);

  var toIndexedObject = __webpack_require__(37);

  var $getOwnPropertyNames = __webpack_require__(65).f;

  var arraySlice = __webpack_require__(86);

  var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];

  var getWindowNames = function getWindowNames(it) {
    try {
      return $getOwnPropertyNames(it);
    } catch (error) {
      return arraySlice(windowNames);
    }
  }; // fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window


  module.exports.f = function getOwnPropertyNames(it) {
    return windowNames && classof(it) == 'Window' ? getWindowNames(it) : $getOwnPropertyNames(toIndexedObject(it));
  };
  /***/

},
/* 159 */

/***/
function (module, exports) {
  // eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
  exports.f = Object.getOwnPropertySymbols;
  /***/
},
/* 160 */

/***/
function (module, exports, __webpack_require__) {
  var getBuiltIn = __webpack_require__(26);

  var uncurryThis = __webpack_require__(3);

  var getOwnPropertyNamesModule = __webpack_require__(65);

  var getOwnPropertySymbolsModule = __webpack_require__(159);

  var anObject = __webpack_require__(10);

  var concat = uncurryThis([].concat); // all object keys, includes non-enumerable and symbols

  module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
    var keys = getOwnPropertyNamesModule.f(anObject(it));
    var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
    return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
  };
  /***/

},
/* 161 */

/***/
function (module, exports) {
  module.exports = function (exec) {
    try {
      return {
        error: false,
        value: exec()
      };
    } catch (error) {
      return {
        error: true,
        value: error
      };
    }
  };
  /***/

},
/* 162 */

/***/
function (module, exports, __webpack_require__) {
  var fails = __webpack_require__(2);

  var global = __webpack_require__(1); // babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError


  var $RegExp = global.RegExp;
  module.exports = fails(function () {
    var re = $RegExp('.', 's');
    return !(re.dotAll && re.exec('\n') && re.flags === 's');
  });
  /***/
},
/* 163 */

/***/
function (module, exports, __webpack_require__) {
  var global = __webpack_require__(1); // eslint-disable-next-line es/no-object-defineproperty -- safe


  var defineProperty = Object.defineProperty;

  module.exports = function (key, value) {
    try {
      defineProperty(global, key, {
        value: value,
        configurable: true,
        writable: true
      });
    } catch (error) {
      global[key] = value;
    }

    return value;
  };
  /***/

},
/* 164 */

/***/
function (module, exports, __webpack_require__) {
  var global = __webpack_require__(1);

  var setGlobal = __webpack_require__(163);

  var SHARED = '__core-js_shared__';
  var store = global[SHARED] || setGlobal(SHARED, {});
  module.exports = store;
  /***/
},
/* 165 */

/***/
function (module, exports, __webpack_require__) {
  // https://github.com/tc39/proposal-string-pad-start-end
  var uncurryThis = __webpack_require__(3);

  var toLength = __webpack_require__(44);

  var toString = __webpack_require__(18);

  var $repeat = __webpack_require__(128);

  var requireObjectCoercible = __webpack_require__(28);

  var repeat = uncurryThis($repeat);
  var stringSlice = uncurryThis(''.slice);
  var ceil = Math.ceil; // `String.prototype.{ padStart, padEnd }` methods implementation

  var createMethod = function createMethod(IS_END) {
    return function ($this, maxLength, fillString) {
      var S = toString(requireObjectCoercible($this));
      var intMaxLength = toLength(maxLength);
      var stringLength = S.length;
      var fillStr = fillString === undefined ? ' ' : toString(fillString);
      var fillLen, stringFiller;
      if (intMaxLength <= stringLength || fillStr == '') return S;
      fillLen = intMaxLength - stringLength;
      stringFiller = repeat(fillStr, ceil(fillLen / fillStr.length));
      if (stringFiller.length > fillLen) stringFiller = stringSlice(stringFiller, 0, fillLen);
      return IS_END ? S + stringFiller : stringFiller + S;
    };
  };

  module.exports = {
    // `String.prototype.padStart` method
    // https://tc39.es/ecma262/#sec-string.prototype.padstart
    start: createMethod(false),
    // `String.prototype.padEnd` method
    // https://tc39.es/ecma262/#sec-string.prototype.padend
    end: createMethod(true)
  };
  /***/
},
/* 166 */

/***/
function (module, exports, __webpack_require__) {
  var PROPER_FUNCTION_NAME = __webpack_require__(74).PROPER;

  var fails = __webpack_require__(2);

  var whitespaces = __webpack_require__(131);

  var non = "\u200B\x85\u180E"; // check that a method works with the correct list
  // of whitespaces and has a correct name

  module.exports = function (METHOD_NAME) {
    return fails(function () {
      return !!whitespaces[METHOD_NAME]() || non[METHOD_NAME]() !== non || PROPER_FUNCTION_NAME && whitespaces[METHOD_NAME].name !== METHOD_NAME;
    });
  };
  /***/

},
/* 167 */

/***/
function (module, exports, __webpack_require__) {
  var global = __webpack_require__(1);

  var apply = __webpack_require__(40);

  var bind = __webpack_require__(51);

  var isCallable = __webpack_require__(17);

  var hasOwn = __webpack_require__(21);

  var fails = __webpack_require__(2);

  var html = __webpack_require__(209);

  var arraySlice = __webpack_require__(68);

  var createElement = __webpack_require__(114);

  var IS_IOS = __webpack_require__(204);

  var IS_NODE = __webpack_require__(69);

  var set = global.setImmediate;
  var clear = global.clearImmediate;
  var process = global.process;
  var Dispatch = global.Dispatch;
  var Function = global.Function;
  var MessageChannel = global.MessageChannel;
  var String = global.String;
  var counter = 0;
  var queue = {};
  var ONREADYSTATECHANGE = 'onreadystatechange';
  var location, defer, channel, port;

  try {
    // Deno throws a ReferenceError on `location` access without `--location` flag
    location = global.location;
  } catch (error) {
    /* empty */
  }

  var run = function run(id) {
    if (hasOwn(queue, id)) {
      var fn = queue[id];
      delete queue[id];
      fn();
    }
  };

  var runner = function runner(id) {
    return function () {
      run(id);
    };
  };

  var listener = function listener(event) {
    run(event.data);
  };

  var post = function post(id) {
    // old engines have not location.origin
    global.postMessage(String(id), location.protocol + '//' + location.host);
  }; // Node.js 0.9+ & IE10+ has setImmediate, otherwise:


  if (!set || !clear) {
    set = function setImmediate(fn) {
      var args = arraySlice(arguments, 1);

      queue[++counter] = function () {
        apply(isCallable(fn) ? fn : Function(fn), undefined, args);
      };

      defer(counter);
      return counter;
    };

    clear = function clearImmediate(id) {
      delete queue[id];
    }; // Node.js 0.8-


    if (IS_NODE) {
      defer = function defer(id) {
        process.nextTick(runner(id));
      }; // Sphere (JS game engine) Dispatch API

    } else if (Dispatch && Dispatch.now) {
      defer = function defer(id) {
        Dispatch.now(runner(id));
      }; // Browsers with MessageChannel, includes WebWorkers
      // except iOS - https://github.com/zloirock/core-js/issues/624

    } else if (MessageChannel && !IS_IOS) {
      channel = new MessageChannel();
      port = channel.port2;
      channel.port1.onmessage = listener;
      defer = bind(port.postMessage, port); // Browsers with postMessage, skip WebWorkers
      // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
    } else if (global.addEventListener && isCallable(global.postMessage) && !global.importScripts && location && location.protocol !== 'file:' && !fails(post)) {
      defer = post;
      global.addEventListener('message', listener, false); // IE8-
    } else if (ONREADYSTATECHANGE in createElement('script')) {
      defer = function defer(id) {
        html.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function () {
          html.removeChild(this);
          run(id);
        };
      }; // Rest old browsers

    } else {
      defer = function defer(id) {
        setTimeout(runner(id), 0);
      };
    }
  }

  module.exports = {
    set: set,
    clear: clear
  };
  /***/
},
/* 168 */

/***/
function (module, exports, __webpack_require__) {
  var global = __webpack_require__(1);

  var call = __webpack_require__(19);

  var isObject = __webpack_require__(13);

  var isSymbol = __webpack_require__(77);

  var getMethod = __webpack_require__(58);

  var ordinaryToPrimitive = __webpack_require__(226);

  var wellKnownSymbol = __webpack_require__(15);

  var TypeError = global.TypeError;
  var TO_PRIMITIVE = wellKnownSymbol('toPrimitive'); // `ToPrimitive` abstract operation
  // https://tc39.es/ecma262/#sec-toprimitive

  module.exports = function (input, pref) {
    if (!isObject(input) || isSymbol(input)) return input;
    var exoticToPrim = getMethod(input, TO_PRIMITIVE);
    var result;

    if (exoticToPrim) {
      if (pref === undefined) pref = 'default';
      result = call(exoticToPrim, input, pref);
      if (!isObject(result) || isSymbol(result)) return result;
      throw TypeError("Can't convert object to primitive value");
    }

    if (pref === undefined) pref = 'number';
    return ordinaryToPrimitive(input, pref);
  };
  /***/

},
/* 169 */

/***/
function (module, exports, __webpack_require__) {
  var wellKnownSymbol = __webpack_require__(15);

  var TO_STRING_TAG = wellKnownSymbol('toStringTag');
  var test = {};
  test[TO_STRING_TAG] = 'z';
  module.exports = String(test) === '[object z]';
  /***/
},
/* 170 */

/***/
function (module, exports, __webpack_require__) {
  /* eslint-disable no-new -- required for testing */
  var global = __webpack_require__(1);

  var fails = __webpack_require__(2);

  var checkCorrectnessOfIteration = __webpack_require__(110);

  var NATIVE_ARRAY_BUFFER_VIEWS = __webpack_require__(16).NATIVE_ARRAY_BUFFER_VIEWS;

  var ArrayBuffer = global.ArrayBuffer;
  var Int8Array = global.Int8Array;
  module.exports = !NATIVE_ARRAY_BUFFER_VIEWS || !fails(function () {
    Int8Array(1);
  }) || !fails(function () {
    new Int8Array(-1);
  }) || !checkCorrectnessOfIteration(function (iterable) {
    new Int8Array();
    new Int8Array(null);
    new Int8Array(1.5);
    new Int8Array(iterable);
  }, true) || fails(function () {
    // Safari (11+) bug - a reason why even Safari 13 should load a typed array polyfill
    return new Int8Array(new ArrayBuffer(2), 1, undefined).length !== 1;
  });
  /***/
},
/* 171 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $ = __webpack_require__(0);

  var exec = __webpack_require__(123); // `RegExp.prototype.exec` method
  // https://tc39.es/ecma262/#sec-regexp.prototype.exec


  $({
    target: 'RegExp',
    proto: true,
    forced: /./.exec !== exec
  }, {
    exec: exec
  });
  /***/
},
/* 172 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /*
  object-assign
  (c) Sindre Sorhus
  @license MIT
  */

  /* eslint-disable no-unused-vars */

  var getOwnPropertySymbols = Object.getOwnPropertySymbols;
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var propIsEnumerable = Object.prototype.propertyIsEnumerable;

  function toObject(val) {
    if (val === null || val === undefined) {
      throw new TypeError('Object.assign cannot be called with null or undefined');
    }

    return Object(val);
  }

  function shouldUseNative() {
    try {
      if (!Object.assign) {
        return false;
      } // Detect buggy property enumeration order in older V8 versions.
      // https://bugs.chromium.org/p/v8/issues/detail?id=4118


      var test1 = new String('abc'); // eslint-disable-line no-new-wrappers

      test1[5] = 'de';

      if (Object.getOwnPropertyNames(test1)[0] === '5') {
        return false;
      } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


      var test2 = {};

      for (var i = 0; i < 10; i++) {
        test2['_' + String.fromCharCode(i)] = i;
      }

      var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
        return test2[n];
      });

      if (order2.join('') !== '0123456789') {
        return false;
      } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


      var test3 = {};
      'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
        test3[letter] = letter;
      });

      if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
        return false;
      }

      return true;
    } catch (err) {
      // We don't expect any of the above to throw, but better to be safe.
      return false;
    }
  }

  module.exports = shouldUseNative() ? Object.assign : function (target, source) {
    var from;
    var to = toObject(target);
    var symbols;

    for (var s = 1; s < arguments.length; s++) {
      from = Object(arguments[s]);

      for (var key in from) {
        if (hasOwnProperty.call(from, key)) {
          to[key] = from[key];
        }
      }

      if (getOwnPropertySymbols) {
        symbols = getOwnPropertySymbols(from);

        for (var i = 0; i < symbols.length; i++) {
          if (propIsEnumerable.call(from, symbols[i])) {
            to[symbols[i]] = from[symbols[i]];
          }
        }
      }
    }

    return to;
  };
  /***/
},
/* 173 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
  module.exports = ReactPropTypesSecret;
  /***/
},
/* 174 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__accordion__ = __webpack_require__(284);
  /* harmony default export */


  __webpack_exports__["a"] = __WEBPACK_IMPORTED_MODULE_0__accordion__["a"
  /* Accordion */
  ];
  /***/
},
/* 175 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__checkbox__ = __webpack_require__(291);
  /* harmony namespace reexport (by used) */


  __webpack_require__.d(__webpack_exports__, "a", function () {
    return __WEBPACK_IMPORTED_MODULE_0__checkbox__["a"];
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__button_group__ = __webpack_require__(104);
  /* unused harmony namespace reexport */

  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__checkbox_group__ = __webpack_require__(290);
  /* harmony namespace reexport (by used) */


  __webpack_require__.d(__webpack_exports__, "b", function () {
    return __WEBPACK_IMPORTED_MODULE_2__checkbox_group__["a"];
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__checkbox_button_group__ = __webpack_require__(289);
  /* harmony namespace reexport (by used) */


  __webpack_require__.d(__webpack_exports__, "c", function () {
    return __WEBPACK_IMPORTED_MODULE_3__checkbox_button_group__["a"];
  });
  /***/

},
/* 176 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__form__ = __webpack_require__(186);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__use_form_data__ = __webpack_require__(302);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__multi_step_form__ = __webpack_require__(53);
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "a", function () {
    return __WEBPACK_IMPORTED_MODULE_0__form__["a"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "b", function () {
    return __WEBPACK_IMPORTED_MODULE_1__use_form_data__["a"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "c", function () {
    return __WEBPACK_IMPORTED_MODULE_2__multi_step_form__["b"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "d", function () {
    return __WEBPACK_IMPORTED_MODULE_2__multi_step_form__["a"];
  });
  /***/

},
/* 177 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__progress_status__ = __webpack_require__(319);
  /* harmony default export */


  __webpack_exports__["a"] = __WEBPACK_IMPORTED_MODULE_0__progress_status__["a"
  /* ProgressStatus */
  ];
  /***/
},
/* 178 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__tooltip__ = __webpack_require__(330);
  /* harmony default export */


  __webpack_exports__["a"] = __WEBPACK_IMPORTED_MODULE_0__tooltip__["a"
  /* Tooltip */
  ];
  /***/
},
/* 179 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__typography__ = __webpack_require__(331);
  /* harmony namespace reexport (by used) */


  __webpack_require__.d(__webpack_exports__, "a", function () {
    return __WEBPACK_IMPORTED_MODULE_0__typography__["a"];
  });
  /* harmony namespace reexport (by used) */


  __webpack_require__.d(__webpack_exports__, "b", function () {
    return __WEBPACK_IMPORTED_MODULE_0__typography__["b"];
  });
  /* harmony namespace reexport (by used) */


  __webpack_require__.d(__webpack_exports__, "c", function () {
    return __WEBPACK_IMPORTED_MODULE_0__typography__["c"];
  });
  /* harmony namespace reexport (by used) */


  __webpack_require__.d(__webpack_exports__, "d", function () {
    return __WEBPACK_IMPORTED_MODULE_0__typography__["d"];
  });
  /* harmony namespace reexport (by used) */


  __webpack_require__.d(__webpack_exports__, "e", function () {
    return __WEBPACK_IMPORTED_MODULE_0__typography__["e"];
  });
  /* harmony namespace reexport (by used) */


  __webpack_require__.d(__webpack_exports__, "f", function () {
    return __WEBPACK_IMPORTED_MODULE_0__typography__["f"];
  });
  /* harmony namespace reexport (by used) */


  __webpack_require__.d(__webpack_exports__, "g", function () {
    return __WEBPACK_IMPORTED_MODULE_0__typography__["g"];
  });
  /* harmony namespace reexport (by used) */


  __webpack_require__.d(__webpack_exports__, "h", function () {
    return __WEBPACK_IMPORTED_MODULE_0__typography__["h"];
  });
  /* harmony namespace reexport (by used) */


  __webpack_require__.d(__webpack_exports__, "i", function () {
    return __WEBPACK_IMPORTED_MODULE_0__typography__["i"];
  });
  /* harmony namespace reexport (by used) */


  __webpack_require__.d(__webpack_exports__, "j", function () {
    return __WEBPACK_IMPORTED_MODULE_0__typography__["j"];
  });
  /* harmony namespace reexport (by used) */


  __webpack_require__.d(__webpack_exports__, "k", function () {
    return __WEBPACK_IMPORTED_MODULE_0__typography__["k"];
  });
  /* harmony namespace reexport (by used) */


  __webpack_require__.d(__webpack_exports__, "l", function () {
    return __WEBPACK_IMPORTED_MODULE_0__typography__["l"];
  });
  /* harmony namespace reexport (by used) */


  __webpack_require__.d(__webpack_exports__, "m", function () {
    return __WEBPACK_IMPORTED_MODULE_0__typography__["m"];
  });
  /* harmony namespace reexport (by used) */


  __webpack_require__.d(__webpack_exports__, "n", function () {
    return __WEBPACK_IMPORTED_MODULE_0__typography__["n"];
  });
  /* harmony namespace reexport (by used) */


  __webpack_require__.d(__webpack_exports__, "o", function () {
    return __WEBPACK_IMPORTED_MODULE_0__typography__["o"];
  });
  /***/

},
/* 180 */

/***/
function (module, exports, __webpack_require__) {
  /**
   * Copyright (c) 2014-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  var runtime = function (exports) {
    "use strict";

    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var undefined; // More compressible than void 0.

    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

    function define(obj, key, value) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
      return obj[key];
    }

    try {
      // IE 8 has a broken Object.defineProperty that only works on DOM objects.
      define({}, "");
    } catch (err) {
      define = function define(obj, key, value) {
        return obj[key] = value;
      };
    }

    function wrap(innerFn, outerFn, self, tryLocsList) {
      // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
      var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
      var generator = Object.create(protoGenerator.prototype);
      var context = new Context(tryLocsList || []); // The ._invoke method unifies the implementations of the .next,
      // .throw, and .return methods.

      generator._invoke = makeInvokeMethod(innerFn, self, context);
      return generator;
    }

    exports.wrap = wrap; // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.

    function tryCatch(fn, obj, arg) {
      try {
        return {
          type: "normal",
          arg: fn.call(obj, arg)
        };
      } catch (err) {
        return {
          type: "throw",
          arg: err
        };
      }
    }

    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed"; // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.

    var ContinueSentinel = {}; // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.

    function Generator() {}

    function GeneratorFunction() {}

    function GeneratorFunctionPrototype() {} // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.


    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function () {
      return this;
    });
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));

    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
      // This environment has a native %IteratorPrototype%; use it instead
      // of the polyfill.
      IteratorPrototype = NativeIteratorPrototype;
    }

    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = GeneratorFunctionPrototype;
    define(Gp, "constructor", GeneratorFunctionPrototype);
    define(GeneratorFunctionPrototype, "constructor", GeneratorFunction);
    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"); // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.

    function defineIteratorMethods(prototype) {
      ["next", "throw", "return"].forEach(function (method) {
        define(prototype, method, function (arg) {
          return this._invoke(method, arg);
        });
      });
    }

    exports.isGeneratorFunction = function (genFun) {
      var ctor = typeof genFun === "function" && genFun.constructor;
      return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
      // do is to check its .name property.
      (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };

    exports.mark = function (genFun) {
      if (Object.setPrototypeOf) {
        Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
      } else {
        genFun.__proto__ = GeneratorFunctionPrototype;
        define(genFun, toStringTagSymbol, "GeneratorFunction");
      }

      genFun.prototype = Object.create(Gp);
      return genFun;
    }; // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.


    exports.awrap = function (arg) {
      return {
        __await: arg
      };
    };

    function AsyncIterator(generator, PromiseImpl) {
      function invoke(method, arg, resolve, reject) {
        var record = tryCatch(generator[method], generator, arg);

        if (record.type === "throw") {
          reject(record.arg);
        } else {
          var result = record.arg;
          var value = result.value;

          if (value && typeof value === "object" && hasOwn.call(value, "__await")) {
            return PromiseImpl.resolve(value.__await).then(function (value) {
              invoke("next", value, resolve, reject);
            }, function (err) {
              invoke("throw", err, resolve, reject);
            });
          }

          return PromiseImpl.resolve(value).then(function (unwrapped) {
            // When a yielded Promise is resolved, its final value becomes
            // the .value of the Promise<{value,done}> result for the
            // current iteration.
            result.value = unwrapped;
            resolve(result);
          }, function (error) {
            // If a rejected Promise was yielded, throw the rejection back
            // into the async generator function so it can be handled there.
            return invoke("throw", error, resolve, reject);
          });
        }
      }

      var previousPromise;

      function enqueue(method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }

        return previousPromise = // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
        // invocations of the iterator.
        callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      } // Define the unified helper method that is used to implement .next,
      // .throw, and .return (see defineIteratorMethods).


      this._invoke = enqueue;
    }

    defineIteratorMethods(AsyncIterator.prototype);
    define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
      return this;
    });
    exports.AsyncIterator = AsyncIterator; // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.

    exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
      if (PromiseImpl === void 0) PromiseImpl = Promise;
      var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
      return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function (result) {
        return result.done ? result.value : iter.next();
      });
    };

    function makeInvokeMethod(innerFn, self, context) {
      var state = GenStateSuspendedStart;
      return function invoke(method, arg) {
        if (state === GenStateExecuting) {
          throw new Error("Generator is already running");
        }

        if (state === GenStateCompleted) {
          if (method === "throw") {
            throw arg;
          } // Be forgiving, per 25.3.3.3.3 of the spec:
          // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume


          return doneResult();
        }

        context.method = method;
        context.arg = arg;

        while (true) {
          var delegate = context.delegate;

          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);

            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if (context.method === "next") {
            // Setting context._sent for legacy support of Babel's
            // function.sent implementation.
            context.sent = context._sent = context.arg;
          } else if (context.method === "throw") {
            if (state === GenStateSuspendedStart) {
              state = GenStateCompleted;
              throw context.arg;
            }

            context.dispatchException(context.arg);
          } else if (context.method === "return") {
            context.abrupt("return", context.arg);
          }

          state = GenStateExecuting;
          var record = tryCatch(innerFn, self, context);

          if (record.type === "normal") {
            // If an exception is thrown from innerFn, we leave state ===
            // GenStateExecuting and loop back for another invocation.
            state = context.done ? GenStateCompleted : GenStateSuspendedYield;

            if (record.arg === ContinueSentinel) {
              continue;
            }

            return {
              value: record.arg,
              done: context.done
            };
          } else if (record.type === "throw") {
            state = GenStateCompleted; // Dispatch the exception by looping back around to the
            // context.dispatchException(context.arg) call above.

            context.method = "throw";
            context.arg = record.arg;
          }
        }
      };
    } // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.


    function maybeInvokeDelegate(delegate, context) {
      var method = delegate.iterator[context.method];

      if (method === undefined) {
        // A .throw or .return when the delegate iterator has no .throw
        // method always terminates the yield* loop.
        context.delegate = null;

        if (context.method === "throw") {
          // Note: ["return"] must be used for ES3 parsing compatibility.
          if (delegate.iterator["return"]) {
            // If the delegate iterator has a return method, give it a
            // chance to clean up.
            context.method = "return";
            context.arg = undefined;
            maybeInvokeDelegate(delegate, context);

            if (context.method === "throw") {
              // If maybeInvokeDelegate(context) changed context.method from
              // "return" to "throw", let that override the TypeError below.
              return ContinueSentinel;
            }
          }

          context.method = "throw";
          context.arg = new TypeError("The iterator does not provide a 'throw' method");
        }

        return ContinueSentinel;
      }

      var record = tryCatch(method, delegate.iterator, context.arg);

      if (record.type === "throw") {
        context.method = "throw";
        context.arg = record.arg;
        context.delegate = null;
        return ContinueSentinel;
      }

      var info = record.arg;

      if (!info) {
        context.method = "throw";
        context.arg = new TypeError("iterator result is not an object");
        context.delegate = null;
        return ContinueSentinel;
      }

      if (info.done) {
        // Assign the result of the finished delegate to the temporary
        // variable specified by delegate.resultName (see delegateYield).
        context[delegate.resultName] = info.value; // Resume execution at the desired location (see delegateYield).

        context.next = delegate.nextLoc; // If context.method was "throw" but the delegate handled the
        // exception, let the outer generator proceed normally. If
        // context.method was "next", forget context.arg since it has been
        // "consumed" by the delegate iterator. If context.method was
        // "return", allow the original .return call to continue in the
        // outer generator.

        if (context.method !== "return") {
          context.method = "next";
          context.arg = undefined;
        }
      } else {
        // Re-yield the result returned by the delegate method.
        return info;
      } // The delegate iterator is finished, so forget it and continue with
      // the outer generator.


      context.delegate = null;
      return ContinueSentinel;
    } // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.


    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator"); // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.

    define(Gp, iteratorSymbol, function () {
      return this;
    });
    define(Gp, "toString", function () {
      return "[object Generator]";
    });

    function pushTryEntry(locs) {
      var entry = {
        tryLoc: locs[0]
      };

      if (1 in locs) {
        entry.catchLoc = locs[1];
      }

      if (2 in locs) {
        entry.finallyLoc = locs[2];
        entry.afterLoc = locs[3];
      }

      this.tryEntries.push(entry);
    }

    function resetTryEntry(entry) {
      var record = entry.completion || {};
      record.type = "normal";
      delete record.arg;
      entry.completion = record;
    }

    function Context(tryLocsList) {
      // The root entry object (effectively a try statement without a catch
      // or a finally block) gives us a place to store values thrown from
      // locations where there is no enclosing try statement.
      this.tryEntries = [{
        tryLoc: "root"
      }];
      tryLocsList.forEach(pushTryEntry, this);
      this.reset(true);
    }

    exports.keys = function (object) {
      var keys = [];

      for (var key in object) {
        keys.push(key);
      }

      keys.reverse(); // Rather than returning an object with a next method, we keep
      // things simple and return the next function itself.

      return function next() {
        while (keys.length) {
          var key = keys.pop();

          if (key in object) {
            next.value = key;
            next.done = false;
            return next;
          }
        } // To avoid creating an additional object, we just hang the .value
        // and .done properties off the next function object itself. This
        // also ensures that the minifier will not anonymize the function.


        next.done = true;
        return next;
      };
    };

    function values(iterable) {
      if (iterable) {
        var iteratorMethod = iterable[iteratorSymbol];

        if (iteratorMethod) {
          return iteratorMethod.call(iterable);
        }

        if (typeof iterable.next === "function") {
          return iterable;
        }

        if (!isNaN(iterable.length)) {
          var i = -1,
              next = function next() {
            while (++i < iterable.length) {
              if (hasOwn.call(iterable, i)) {
                next.value = iterable[i];
                next.done = false;
                return next;
              }
            }

            next.value = undefined;
            next.done = true;
            return next;
          };

          return next.next = next;
        }
      } // Return an iterator with no values.


      return {
        next: doneResult
      };
    }

    exports.values = values;

    function doneResult() {
      return {
        value: undefined,
        done: true
      };
    }

    Context.prototype = {
      constructor: Context,
      reset: function reset(skipTempReset) {
        this.prev = 0;
        this.next = 0; // Resetting context._sent for legacy support of Babel's
        // function.sent implementation.

        this.sent = this._sent = undefined;
        this.done = false;
        this.delegate = null;
        this.method = "next";
        this.arg = undefined;
        this.tryEntries.forEach(resetTryEntry);

        if (!skipTempReset) {
          for (var name in this) {
            // Not sure about the optimal order of these conditions:
            if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
              this[name] = undefined;
            }
          }
        }
      },
      stop: function stop() {
        this.done = true;
        var rootEntry = this.tryEntries[0];
        var rootRecord = rootEntry.completion;

        if (rootRecord.type === "throw") {
          throw rootRecord.arg;
        }

        return this.rval;
      },
      dispatchException: function dispatchException(exception) {
        if (this.done) {
          throw exception;
        }

        var context = this;

        function handle(loc, caught) {
          record.type = "throw";
          record.arg = exception;
          context.next = loc;

          if (caught) {
            // If the dispatched exception was caught by a catch block,
            // then let that catch block handle the exception normally.
            context.method = "next";
            context.arg = undefined;
          }

          return !!caught;
        }

        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          var record = entry.completion;

          if (entry.tryLoc === "root") {
            // Exception thrown outside of any try block that could handle
            // it, so set the completion value of the entire function to
            // throw the exception.
            return handle("end");
          }

          if (entry.tryLoc <= this.prev) {
            var hasCatch = hasOwn.call(entry, "catchLoc");
            var hasFinally = hasOwn.call(entry, "finallyLoc");

            if (hasCatch && hasFinally) {
              if (this.prev < entry.catchLoc) {
                return handle(entry.catchLoc, true);
              } else if (this.prev < entry.finallyLoc) {
                return handle(entry.finallyLoc);
              }
            } else if (hasCatch) {
              if (this.prev < entry.catchLoc) {
                return handle(entry.catchLoc, true);
              }
            } else if (hasFinally) {
              if (this.prev < entry.finallyLoc) {
                return handle(entry.finallyLoc);
              }
            } else {
              throw new Error("try statement without catch or finally");
            }
          }
        }
      },
      abrupt: function abrupt(type, arg) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];

          if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
            var finallyEntry = entry;
            break;
          }
        }

        if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
          // Ignore the finally entry if control is not jumping to a
          // location outside the try/catch block.
          finallyEntry = null;
        }

        var record = finallyEntry ? finallyEntry.completion : {};
        record.type = type;
        record.arg = arg;

        if (finallyEntry) {
          this.method = "next";
          this.next = finallyEntry.finallyLoc;
          return ContinueSentinel;
        }

        return this.complete(record);
      },
      complete: function complete(record, afterLoc) {
        if (record.type === "throw") {
          throw record.arg;
        }

        if (record.type === "break" || record.type === "continue") {
          this.next = record.arg;
        } else if (record.type === "return") {
          this.rval = this.arg = record.arg;
          this.method = "return";
          this.next = "end";
        } else if (record.type === "normal" && afterLoc) {
          this.next = afterLoc;
        }

        return ContinueSentinel;
      },
      finish: function finish(finallyLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];

          if (entry.finallyLoc === finallyLoc) {
            this.complete(entry.completion, entry.afterLoc);
            resetTryEntry(entry);
            return ContinueSentinel;
          }
        }
      },
      "catch": function _catch(tryLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];

          if (entry.tryLoc === tryLoc) {
            var record = entry.completion;

            if (record.type === "throw") {
              var thrown = record.arg;
              resetTryEntry(entry);
            }

            return thrown;
          }
        } // The context.catch method must only be called with a location
        // argument that corresponds to a known catch block.


        throw new Error("illegal catch attempt");
      },
      delegateYield: function delegateYield(iterable, resultName, nextLoc) {
        this.delegate = {
          iterator: values(iterable),
          resultName: resultName,
          nextLoc: nextLoc
        };

        if (this.method === "next") {
          // Deliberately forget the last sent value so that we don't
          // accidentally pass it on to the delegate.
          this.arg = undefined;
        }

        return ContinueSentinel;
      }
    }; // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.

    return exports;
  }( // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
  true ? module.exports : {});

  try {
    regeneratorRuntime = runtime;
  } catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, in modern engines
    // we can explicitly access globalThis. In older engines we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    if (typeof globalThis === "object") {
      globalThis.regeneratorRuntime = runtime;
    } else {
      Function("r", "regeneratorRuntime = r")(runtime);
    }
  }
  /***/

},
/* 181 */

/***/
function (module, exports) {
  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }

  module.exports = _arrayLikeToArray;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
  /***/
},
/* 182 */

/***/
function (module, exports) {
  function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
      var info = gen[key](arg);
      var value = info.value;
    } catch (error) {
      reject(error);
      return;
    }

    if (info.done) {
      resolve(value);
    } else {
      Promise.resolve(value).then(_next, _throw);
    }
  }

  function _asyncToGenerator(fn) {
    return function () {
      var self = this,
          args = arguments;
      return new Promise(function (resolve, reject) {
        var gen = fn.apply(self, args);

        function _next(value) {
          asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
        }

        function _throw(err) {
          asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
        }

        _next(undefined);
      });
    };
  }

  module.exports = _asyncToGenerator;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
  /***/
},
/* 183 */

/***/
function (module, exports, __webpack_require__) {
  var arrayLikeToArray = __webpack_require__(181);

  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
  }

  module.exports = _unsupportedIterableToArray;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
  /***/
},
/* 184 */

/***/
function (module, exports, __webpack_require__) {
  module.exports = __webpack_require__(180);
  /***/
},
/* 185 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony export (binding) */

  __webpack_require__.d(__webpack_exports__, "c", function () {
    return checkCompareError;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "b", function () {
    return isValidDate;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "a", function () {
    return isControlled;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "d", function () {
    return DateInputStandard;
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(5);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__tal_gel_core__ = __webpack_require__(7);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__tal_gel_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__tal_gel_core__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6__text_input__ = __webpack_require__(46);

  var _excluded = ["value", "defaultValue", "onFocus", "gt", "gte", "lt", "lte", "onError", "errorMsg", "compareErrorMsg", "index", "resetValidator"];

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);

      if (enumerableOnly) {
        symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
      }

      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  } // `type="date"` triggers native mobile date widget 
  // (Use `DateInput` instead if we want to type rather than pick a date on mobile)


  var DateInputStandardComponent = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.forwardRef(function (_ref, forwardedRef) {
    var value = _ref.value,
        defaultValue = _ref.defaultValue,
        onFocus = _ref.onFocus,
        gt = _ref.gt,
        gte = _ref.gte,
        lt = _ref.lt,
        lte = _ref.lte,
        onError = _ref.onError,
        errorMsg = _ref.errorMsg,
        compareErrorMsg = _ref.compareErrorMsg,
        index = _ref.index,
        resetValidator = _ref.resetValidator,
        props = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties___default()(_ref, _excluded);

    var _useValidator = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__tal_gel_core__["useValidator"])(_objectSpread(_objectSpread({}, props), {}, {
      // includes controlled `error`, `caption`, `setValidity`, etc.
      index: index,
      // index assigned by the form 
      reset: resetValidator,
      // whether to reset the validator (`touched` status, etc.)
      value: value,
      // date in the format of 'yyyy-mm-dd'
      defaultValue: defaultValue,
      // date in the format of 'yyyy-mm-dd'
      checkError: true,
      // tells validator whether to check for error
      hasError: function hasError(value) {
        // tells validator HOW to check for error
        if (!value) {
          // `required` error will be checked by the underlying TextInput
          return false;
        }

        return checkCompareError({
          value: value,
          gt: gt,
          gte: gte,
          lt: lt,
          lte: lte
        });
      },
      hideErrorInitially: true,
      // tells validator to hide error initially
      onError: onError,
      // tells validator the callback to invoke if error occurs or disappears
      errorMsg: _objectSpread({
        // tells validator the error message to include in caption if error occurs
        'compare': compareErrorMsg
      }, errorMsg)
    })),
        _useValidator2 = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray___default()(_useValidator, 4),
        onBlur = _useValidator2[0],
        onChange = _useValidator2[1],
        getCaption = _useValidator2[2],
        shouldShowError = _useValidator2[3];

    var initialInternalValidValue = '';

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__tal_gel_core__["useRunOnce"])(function () {
      if (!isControlled(value) && isControlled(defaultValue) && isValidDate(defaultValue)) {
        // If 'value' is not controlled by the parent, 
        // and if provided with a valid default value,
        // we set it as the 'initialInternalValidValue' for the input box
        initialInternalValidValue = defaultValue;
      }
    }); // 'internalValidValue' is the internal date value if 'value' is not controlled by the parent


    var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useState"])(initialInternalValidValue),
        _useState2 = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray___default()(_useState, 2),
        internalValidValue = _useState2[0],
        setInternalValidValue = _useState2[1];

    if (isControlled(value) && !isValidDate(value)) {
      // If 'value' is controlled by the parent 
      // but if the 'value' provided is not a valid date,
      // reset the controlled 'value' to empty string
      value = '';
    }

    var _onChange = function _onChange(event) {
      if (!isControlled(value)) {
        // If 'value' is not controlled by the parent, 
        // we set the input target value as 'internalValidValue'.
        // Note that with the underlying <input type="date" />, 
        // we can be ensured that when onChange is invoked,
        // the input target value will be either an empty string 
        // (when day, month or year not provided for example, and
        // typing a non-numeric value won't even trigger onChange),
        // or a valid date string (yyyy-mm-dd)
        setInternalValidValue(event.target.value); // Note that empty string won't necessarily reset day, month and year 
        // to empty (Eg: 12/03/yyyy) due to how <input type="date" /> works.
      } // Do not set 'internalValidValue' if 'value' is controlled by the parent


      onChange(event);
    };

    var getValue = function getValue() {
      // Use either value (provided by parent) or internalValidValue to control the underlying TextInput
      return isControlled(value) ? value : internalValidValue;
    }; // Control the value of the TextInput wrapped inside
    // with either the internal valid value managed by DateInput,
    // or with the 'value' of DateInput controlled by the parent of DateInput


    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__text_input__["a"
    /* default */
    ], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
      "data-cy": "gel-date-standard-input",
      type: "date",
      ref: forwardedRef
    }, props, index !== undefined && {
      index: index + '_0'
    }, {
      // assign a sub index (for GelForm) to the underling TextInput
      resetValidator: resetValidator,
      value: getValue(),
      onChange: _onChange,
      onBlur: onBlur,
      caption: getCaption(),
      error: shouldShowError(),
      onError: onError,
      errorMsg: errorMsg
    }));
  });

  var checkCompareError = function checkCompareError(_ref2) {
    var value = _ref2.value,
        gt = _ref2.gt,
        gte = _ref2.gte,
        lt = _ref2.lt,
        lte = _ref2.lte; // gt (greather than), gte (greater than or equal), 
    // lt (less than), lte (less than or equal)

    if (isValidDate(value) && (!gt || gt && isValidDate(gt)) && (!gte || gte && isValidDate(gte)) && (!lt || lt && isValidDate(lt)) && (!lte || lte && isValidDate(lte)) // Ensure lte date is valid if provided
    ) {
      var seconds = Date.parse(value);
      return (gt && seconds <= Date.parse(gt) || gte && seconds < Date.parse(gte) || lt && seconds >= Date.parse(lt) || lte && seconds > Date.parse(lte)) && 'compare';
    }

    return 'format';
  };
  /**
   * Validates the date value
   */


  var isValidDate = function isValidDate(value) {
    if (value.split('-').length === 3) {
      // Valid date if value is of the format of 'yyyy-dd-mm'/
      // and can be converted into seconds (eg: 2020-d3-10 is invalid)
      return !isNaN(Date.parse(value));
    } // Consider it as an invalid date, if the date format isn't 'yyyy-mm-dd' 
    // (because 'yyyy-mm-dd' is the only format we accept internally despite of locales)


    return false;
  };

  var isControlled = function isControlled(prop) {
    return prop !== undefined;
  };

  var DateInputStandard = DateInputStandardComponent;
  /***/
},
/* 186 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony export (binding) */

  __webpack_require__.d(__webpack_exports__, "b", function () {
    return FormContext;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "a", function () {
    return Form;
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(5);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(182);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_slicedToArray__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_objectWithoutProperties__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_regenerator__ = __webpack_require__(184);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_regenerator__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7__emotion_styled__ = __webpack_require__(14);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7__emotion_styled___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__emotion_styled__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_8__tal_gel_theming__ = __webpack_require__(11);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_8__tal_gel_theming___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__tal_gel_theming__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_9__tal_gel_core__ = __webpack_require__(7);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_9__tal_gel_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__tal_gel_core__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_10__multi_step_form__ = __webpack_require__(53);

  var _excluded = ["theme", "width", "labelWidth", "fieldGutter", "labelAtTop", "labelAtTopGutter", "onValid", "onInvalid", "onSubmit", "onReset", "onResponse", "onError", "disabled", "disableOnSubmit", "preventSubmitOnInvalid", "showResultAngular", "showResultInPlayground", "parseResponseBody", "scrollToTopOnDisplay", "reset", "shouldValidateAfterInit", "children"];

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);

      if (enumerableOnly) {
        symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
      }

      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  var FormContext = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createContext();

  var CHECK_FOR_ANGULAR_TIMEOUT = 400;

  var FormComponent = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.forwardRef(function (_ref, forwardedRef) {
    var theme = _ref.theme,
        width = _ref.width,
        labelWidth = _ref.labelWidth,
        fieldGutter = _ref.fieldGutter,
        vertical = _ref.labelAtTop,
        labelVerticalGutter = _ref.labelAtTopGutter,
        onValid = _ref.onValid,
        onInvalid = _ref.onInvalid,
        onSubmit = _ref.onSubmit,
        onReset = _ref.onReset,
        onResponse = _ref.onResponse,
        onError = _ref.onError,
        disabled = _ref.disabled,
        disableOnSubmit = _ref.disableOnSubmit,
        preventSubmitOnInvalid = _ref.preventSubmitOnInvalid,
        showResultAngular = _ref.showResultAngular,
        showResultInPlayground = _ref.showResultInPlayground,
        _ref$parseResponseBod = _ref.parseResponseBody,
        parseResponseBody = _ref$parseResponseBod === void 0 ? true : _ref$parseResponseBod,
        _ref$scrollToTopOnDis = _ref.scrollToTopOnDisplay,
        scrollToTopOnDisplay = _ref$scrollToTopOnDis === void 0 ? false : _ref$scrollToTopOnDis,
        reset = _ref.reset,
        shouldValidateAfterInit = _ref.shouldValidateAfterInit,
        children = _ref.children,
        props = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_objectWithoutProperties___default()(_ref, _excluded); // value fields: the actual fields, each containing exactly one GEL component 
    //              (GelTextInput, GelEmailInput, etc.)
    // submit field: contains the submit button
    // result field: contains the submit result


    var totalNumOfValueFields = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react__["useRef"])(); // Object containing `component index: validity` pairs
    // Note that each value field containing exactly one GEL component does NOT mean that
    // each value field will always result in one pair in this object
    // 
    // Eg. Value field containing `GelEmailInput` will have TWO pairs: 
    // `GelTextInput index: validity`, and `GelEmailInput index: validity`, 
    // as `GelEmailInput` wraps `GelTextInput`. The GelEmailInput index in this case
    // will be the index assigned to its containing value field, and the wrapped GelTextInput index
    // will be '`GelEmailInput index`_`a sub index`', to ensure that each component gets a unique index
    //
    // This design is to work with the validators assigned to those components (whether nested or not)
    // Each component can have at most one validator. 
    // Each validator will have a unique index (passed in from the containing component)
    // and will be configured with at most one kind of validation. 
    // 
    // Eg. `GelTextInput` alone has validation of `required`, 
    // and `GelEmailInput` alone has validation of `format`,
    // so when `GelEmailInput` wraps `GelTextInput` inside, 
    // `GelEmailInput` will have validations of both `required` and `format`.
    // 
    // The validators check validity of components in various circumstances
    // and report back to `GelForm` via `setValidity` function available in the form context
    // `setValidity` will store validity statues in the `componentsValidity` object, and
    // determine validity of the entire form.


    var componentsValidity = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react__["useRef"])({}); // Indicates whether all components have reported their validity statues to `GelForm` for the FIRST time


    var componentsValidityInitialised = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react__["useRef"])(false); // Whether the form is being submitted or not


    var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react__["useState"])(false),
        _useState2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_slicedToArray___default()(_useState, 2),
        isSubmitting = _useState2[0],
        setIsSubmitting = _useState2[1]; // Use `useRef` instead of `useState` to get around the closure issue, 
    // so that the latest value of `formValidity.current` is always accessible from any closures,
    // as `formValidity` will always be the same in any closures.


    var formValidity = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react__["useRef"])(false); // Whether to show the form submit result


    var showResult = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react__["useRef"])(false); // In Angular wrappers, we will have to destory the entire form and create the form again
    // after submit and reset, so the value of `showResult.current` will not retain.
    // We use `showResultAngular` particularly for Angular wrappers, so that the
    // result can still appear and disappear as it does in pure React
    // See `gel-form` Angular wrapper for details.


    var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react__["useState"])(showResultAngular),
        _useState4 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_slicedToArray___default()(_useState3, 2),
        showResultForAngular = _useState4[0],
        setShowResultForAngular = _useState4[1];

    var checkForAngular = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react__["useRef"])(false);

    var forceUpdate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__tal_gel_core__["useForceUpdate"])();

    var isMounted = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__tal_gel_core__["useIsMounted"])();

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react__["useEffect"])(function () {
      if (showResultAngular) {
        // only for Angular wrappers
        var timer = setTimeout(function () {
          // Start to check for Angular, as the result needs to disappear 
          // once any value field validity changes again
          checkForAngular.current = true;
          clearTimeout(timer);
        }, // Wait till the new form is fully rendered 
        // (including the initial collection of value field validity statues)
        CHECK_FOR_ANGULAR_TIMEOUT);
      }
    }, []);

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react__["useEffect"])(function () {
      if (reset) {
        // Explicitly triggers reset; do not call onReset
        resetFormInternally();
      }
    }, [reset]); // value: {}


    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react__["useEffect"])(function () {
      if (scrollToTopOnDisplay) {
        var timer = setTimeout(function () {
          window.scrollTo(0, 0);
          clearTimeout(timer);
        });
      }
    }, []); // Deal with restrictions of playground (cannot have controlled components)


    var forceUpdateToHideResultInPlayground = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react__["useRef"])(false);

    var _showResultInPlayground = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react__["useRef"])(showResultInPlayground);

    var previousAllValueFields = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react__["useRef"])([]);

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react__["useEffect"])(function () {
      totalNumOfValueFields.current = valueFieldNames.current.length; // before setValidity is called?

      if (hasAnyValueFieldChanged(previousAllValueFields.current, valueFieldNames.current)) {
        if (previousAllValueFields.current.length !== 0) {
          // If there is field changed dynamically,
          // we reset the form internally (without notifying the parent) so that
          // Gelform will have a chance to re-assign indexes to the current form fields, 
          // and re-collect validity statuses of those form fields. Note that the field
          // errors currently displayed will still be displayed after this reset.
          resetFormInternally(true);
        }

        previousAllValueFields.current = valueFieldNames.current;
      }
    });

    var getPartOfContext = function getPartOfContext() {
      return {
        width: width,
        labelWidth: labelWidth,
        fieldGutter: fieldGutter || theme.Form.fieldGutter,
        vertical: vertical,
        labelVerticalGutter: labelVerticalGutter || theme.Form.labelVerticalGutter
      };
    };

    var multiStepFormContext = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_10__multi_step_form__["a"
    /* MultiStepFormContext */
    ]);

    var _useState5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react__["useState"])(_objectSpread(_objectSpread({}, getPartOfContext()), {}, {
      reset: null,
      submitCheck: null,
      setValidity: function setValidity(index, valid) {
        // see comments on `componentsValidity`
        componentsValidity.current[index] = valid; // Check if `componentsValidity` has been fully initialised
        // (when all value fields have reported their validity status for the first time)
        // Check if `componentsValidity` has been fully initialised
        // (when all value fields have reported their validity status for the first time)

        if (getTotalNumOfValueFieldsFromComponentsValidity() === totalNumOfValueFields.current) {
          if (componentsValidityInitialised.current) {
            // false when checked first time
            // Hide result upon first change of `componentsValidity`
            // after `componentsValidity` has been fully initialised
            if (checkForAngular.current) {
              // for Angular wrappers only
              setShowResultForAngular(false);
            }

            showResult.current = false; // Deal with restrictions of playground (cannot have controlled components)
            // Deal with restrictions of playground (cannot have controlled components)

            if (forceUpdateToHideResultInPlayground.current) {
              forceUpdate();
              forceUpdateToHideResultInPlayground.current = false;
            }

            if (_showResultInPlayground.current) {
              _showResultInPlayground.current = false;
              var timer = setTimeout(function () {
                forceUpdateToHideResultInPlayground.current = true;
                clearTimeout(timer);
              });
            }
          }

          componentsValidityInitialised.current = true;
          var numOfInvalidComponents = getNumOfInvalidComponentsFromComponentsValidity(); // ignore `invalid -> invalid` and `valid -> valid`
          // ignore `invalid -> invalid` and `valid -> valid`

          if (numOfInvalidComponents === 0 && !formValidity.current) {
            // invalid -> valid
            formValidity.current = true;
            forceUpdate();

            if (multiStepFormContext) {
              // Each form in the context of multi step form can be considered as a step
              // `false` to indicate there is no error for this step
              multiStepFormContext.onStepError(false);
            }

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__tal_gel_core__["isFunction"])(onValid) && onValid(); // notify parent
          } else if (numOfInvalidComponents > 0 && formValidity.current) {
            // valid -> invalid
            formValidity.current = false;
            forceUpdate();
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__tal_gel_core__["isFunction"])(onInvalid) && onInvalid(); // notify parent
            // notify parent

            if (multiStepFormContext) {
              // Notifies the multi step form that error has happened in this step 
              multiStepFormContext.onStepError();
            }
          }
        }
      }
    })),
        _useState6 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_slicedToArray___default()(_useState5, 2),
        context = _useState6[0],
        setContext = _useState6[1];

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__tal_gel_core__["useEffectSkipTick"])(function () {
      // TODO: test useEffect?
      setContext(_objectSpread(_objectSpread({}, context), getPartOfContext()));
    }, [width, labelWidth, fieldGutter, vertical, labelVerticalGutter]); // Supports dynamic changes of form fields


    var hasAnyValueFieldChanged = function hasAnyValueFieldChanged() {
      var previous = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var current = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      if (previous.length !== current.length) {
        return true;
      }

      for (var i = 0; i < previous.length; i++) {
        if (previous[i] !== current[i]) {
          return true;
        }
      }

      return false;
    };
    /**
     * See comments on `componentsValidity`
     * 
     * Each value field can have more than one entry in `componentsValidity`,
     * but only one entry will have index without `_` (sub index) for that value field
     */


    var getTotalNumOfValueFieldsFromComponentsValidity = function getTotalNumOfValueFieldsFromComponentsValidity() {
      return Object.keys(componentsValidity.current).reduce(function (result, key) {
        if (!key.includes('_')) {
          // if not having `_`, it's for a new value field
          result++;
        }

        return result;
      }, 0);
    };
    /**
     * See comments on `componentsValidity`
     */


    var getNumOfInvalidComponentsFromComponentsValidity = function getNumOfInvalidComponentsFromComponentsValidity() {
      return Object.keys(componentsValidity.current).reduce(function (numOfInvalidComponents, key) {
        if (!componentsValidity.current[key]) {
          numOfInvalidComponents++;
        }

        return numOfInvalidComponents;
      }, 0);
    };
    /**
     * We still allow form to be submitted even if `formValidity` 
     * is false but there is actually no invalid fields detected. 
     *
     * This can happen to the last step of the form stepper, where
     * there is no form fields but a submit button.
     */


    var shouldAllowSubmit = function shouldAllowSubmit() {
      return formValidity.current || getNumOfInvalidComponentsFromComponentsValidity() === 0;
    };

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react__["useEffect"])(function () {
      // Parent can specifically request the form to do submit check
      // typically after loading initial data, so that the submit
      // button doesn't need to be clicked twice
      if (shouldValidateAfterInit) {
        setContext(_objectSpread(_objectSpread({}, context), {}, {
          submitCheck: {}
        }));
      }
    }, [shouldValidateAfterInit]);

    var isUnmountedRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__tal_gel_core__["useIsUnmounted"])();
    /**
     * State update(s) after `await` will trigger re-render(s) synchronously
     * Otherwise (normally), re-render(s) will be put into a queue 
     * (async from the current execution of code) for the next tick
     * and batched by React for optimization
     */


    var _onSubmit = /*#__PURE__*/function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5__babel_runtime_regenerator___default.a.mark(function _callee(event) {
        var response, data, text;
        return __WEBPACK_IMPORTED_MODULE_5__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                event.preventDefault();

                if (!(!preventSubmitOnInvalid && !shouldAllowSubmit())) {
                  _context.next = 4;
                  break;
                } // If the submit button is always enabled and if the form is invalid
                // when the submit button is clicked, we show validation errors


                setContext(_objectSpread(_objectSpread({}, context), {}, {
                  submitCheck: {}
                }));
                return _context.abrupt("return");

              case 4:
                if (!(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__tal_gel_core__["isFunction"])(onSubmit) && shouldAllowSubmit())) {
                  _context.next = 35;
                  break;
                }

                _context.prev = 5;
                setIsSubmitting(true); // the `onSubmit` provided by parent must return a promise

                _context.next = 9;
                return onSubmit();

              case 9:
                response = _context.sent;

                if (!parseResponseBody) {
                  _context.next = 24;
                  break;
                }

                _context.prev = 11;
                _context.next = 14;
                return response.text();

              case 14:
                text = _context.sent;
                data = JSON.parse(text);
                _context.next = 21;
                break;

              case 18:
                _context.prev = 18;
                _context.t0 = _context["catch"](11); // this means the response body is text

                data = text;

              case 21:
                // notify parent of the response status code and data
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__tal_gel_core__["isFunction"])(onResponse) && onResponse({
                  status: response.status,
                  data: data
                });
                _context.next = 25;
                break;

              case 24:
                // if response body has already been parsed (eg: by Axios), 
                // or if response body stream is not text or json
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__tal_gel_core__["isFunction"])(onResponse) && onResponse(response);

              case 25:
                _context.next = 30;
                break;

              case 27:
                _context.prev = 27;
                _context.t1 = _context["catch"](5); // notify parent of the error caught

                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__tal_gel_core__["isFunction"])(onError) && onError(_context.t1);

              case 30:
                _context.prev = 30; // Depending on usage, `onSubmit` could cause the GelForm to be 
                // unmounted (See example of form-stepper/use-session), so we want
                // to make sure that this form is still mounted when updating its state

                if (!isUnmountedRef.current) {
                  setIsSubmitting(false); // sync render
                } // Invoke `onReset` if provided by parent
                // This is when parent can reset value field values
                // (components such as GelTextInput are controlled)


                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__tal_gel_core__["isFunction"])(onReset) && onReset(); // Show result field (the actual result message is specified by parent)
                // Note that if in playground we don't show result right after submit
                // because playground will reload with a result to be shown

                if (_showResultInPlayground.current === undefined) {
                  showResult.current = true;
                }

                return _context.finish(30);

              case 35:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[5, 27, 30, 35], [11, 18]]);
      }));

      return function _onSubmit(_x) {
        return _ref2.apply(this, arguments);
      };
    }();
    /**
     * Resets the form internally (without notifying the parent) so that
     * Gelform will have a chance to re-assign indexes to the current form fields, 
     * and re-collect validity statuses of those form fields.
     * 
     * @param {boolean} keepDisplayedFieldErrors - Whether the field errors 
     *                  currently displayed will still be displayed after this reset.
     */


    var resetFormInternally = function resetFormInternally() {
      var keepDisplayedFieldErrors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      componentsValidity.current = {};
      componentsValidityInitialised.current = false;
      formValidity.current = false; // Notify form fields to reset themselves and report their 
      // validity statuses again with their newly assigned indexes

      setContext(_objectSpread(_objectSpread({}, context), {}, {
        // create a new object to ensure `reset` is different 
        // (see `use-validator` for usage)
        reset: {
          keepDisplayedFieldErrors: keepDisplayedFieldErrors
        }
      }));
    }; // Collects names (from `name` props) of all value fields
    // This is a passive collection allowing GelFormField
    // to notify GelForm of a new addition, rather than having
    // GelForm actively searching for GelFormFields. This reduces
    // complexity and increases flexibility in terms of layout,
    // as GelFormFields can be either children, or grandchildren
    // of GelForm, or even rendered by other components which are
    // children or grandchildren of GelForm.


    var valueFieldNames = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react__["useRef"])(); // Starts from [] on each render, as each value field reporting
    // to the form will add its name to the array. It is done
    // on a render-by-render basis to support dynamic fields and more
    // layout flexibility


    valueFieldNames.current = []; // Starts from index 0 on each render, as each value field reporting
    // to the form will get the index and then increment it. It is done
    // on a render-by-render basis to support dynamic fields and more
    // layout flexibility

    var valueFieldIndex = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react__["useRef"])();

    valueFieldIndex.current = 0;

    var addValueFieldName = function addValueFieldName(name) {
      // Only add unique names
      if (valueFieldNames.current.indexOf(name) === -1) {
        valueFieldNames.current.push(name);
      }
    };

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(StyledForm, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
      ref: forwardedRef,
      autoComplete: "off",
      onSubmit: _onSubmit,
      width: width
    }, props), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(FormContext.Provider, {
      value: _objectSpread(_objectSpread({}, context), {}, {
        disabled: disabled,
        disableOnSubmit: disableOnSubmit,
        isSubmitting: isSubmitting,
        preventSubmitOnInvalid: preventSubmitOnInvalid,
        formValidity: formValidity,
        valueFieldIndex: valueFieldIndex,
        addValueFieldName: addValueFieldName,
        isMounted: isMounted
      })
    }, children));
  });

  var StyledForm = __WEBPACK_IMPORTED_MODULE_7__emotion_styled___default.a.form(function (_ref3) {
    var width = _ref3.width;
    return {
      width: width
    };
  });

  var Form = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__tal_gel_theming__["withTheme"])(FormComponent);
  /***/

},
/* 187 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony export (binding) */

  __webpack_require__.d(__webpack_exports__, "a", function () {
    return Container;
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__ = __webpack_require__(5);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4__emotion_styled__ = __webpack_require__(14);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4__emotion_styled___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__emotion_styled__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__tal_gel_core__ = __webpack_require__(7);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__tal_gel_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__tal_gel_core__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6__tal_gel_theming__ = __webpack_require__(11);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6__tal_gel_theming___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__tal_gel_theming__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7__screen_detector__ = __webpack_require__(33);

  var _excluded = ["style", "fixed", "showOverlay", "overlayContent", "onOverlayClick", "noGutter", "children", "theme"];

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);

      if (enumerableOnly) {
        symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
      }

      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  } // Build grid by ourselves instead of using `react-grid-system`, so we will have full control over 
  // how react context is used in grid, making it easier for Angular wrapper implementation.
  // Container, Row and Col will have access to ScreenDetectorContext telling which screen is on.
  // The ScreenDetector employs the useScreen hook to listen for window size changes (debounced)


  var ContainerComponent = function ContainerComponent(_ref) {
    var style = _ref.style,
        fixed = _ref.fixed,
        showOverlay = _ref.showOverlay,
        overlayContent = _ref.overlayContent,
        onOverlayClick = _ref.onOverlayClick,
        noGutter = _ref.noGutter,
        children = _ref.children,
        theme = _ref.theme,
        props = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties___default()(_ref, _excluded);

    var _useContext = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_7__screen_detector__["a"
    /* ScreenDetectorContext */
    ]),
        screen = _useContext.screen;

    var overlayContentRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react__["useRef"])();

    var overlayContentWidth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react__["useRef"])();

    var forceUpdate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__tal_gel_core__["useForceUpdate"])();

    var _onOverlayClick = function _onOverlayClick() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__tal_gel_core__["isFunction"])(onOverlayClick) && onOverlayClick();
    };

    var getOverlayContentWidth = function getOverlayContentWidth() {
      // similar to how we calc width in the `Col` component
      if (overlayContentWidth.current) return overlayContentWidth.current;
      if (!overlayContentRef.current) return;
      overlayContentWidth.current = overlayContentRef.current.offsetWidth + 1;
      return overlayContentWidth.current;
    };

    var isUnmountedRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__tal_gel_core__["useIsUnmounted"])();

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react__["useEffect"])(function () {
      // similar to how we do it in the `Col` component
      if (overlayContentRef.current) {
        var timer = setTimeout(function () {
          if (!isUnmountedRef.current) {
            forceUpdate();
          }

          clearTimeout(timer);
        }, 100); // somehow we need to wait a bit even after render, to get the accurate offsetWidth
      }
    }, []); // assuming content width does not change anymore


    var enableOverlayContentAnimation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react__["useRef"])(false);

    if (showOverlay) {
      enableOverlayContentAnimation.current = true;
    }

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(StyledContainer, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({
      style: style,
      fixed: fixed,
      screen: screen,
      theme: theme,
      noGutter: true
    }, props), overlayContent && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Overlay, {
      show: showOverlay,
      theme: theme,
      onClick: _onOverlayClick
    }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(OverlayContent, {
      ref: overlayContentRef,
      show: showOverlay,
      width: getOverlayContentWidth(),
      theme: theme,
      enableAnimation: enableOverlayContentAnimation.current
    }, overlayContent)), children);
  }; // We may not want to set `fixed` on this container 
  // (but we still provide this feature)
  // Typically `fixed` can be set on ContainerLite or 
  // on the content container of page layout


  var StyledContainer = __WEBPACK_IMPORTED_MODULE_4__emotion_styled___default.a.div({
    position: 'relative',
    marginLeft: 0,
    marginRight: 0,
    overflow: 'hidden'
  }, function (_ref2) {
    var theme = _ref2.theme,
        fixed = _ref2.fixed,
        screen = _ref2.screen,
        noGutter = _ref2.noGutter;
    return _objectSpread(_objectSpread({
      // TODO: Remove this, as we do not allow `fixed` on Container anymore.
      // `fixed` can now only be used on GelPageContent
      maxWidth: !fixed ? '100%' : theme.Grid.containerMaxWidth[screen]
    }, fixed && {
      // centered
      marginLeft: 'auto',
      marginRight: 'auto'
    }), {}, {
      padding: !noGutter ? theme.Grid.containerPadding[screen] : 0
    });
  });

  var Overlay = __WEBPACK_IMPORTED_MODULE_4__emotion_styled___default.a.div(_objectSpread({
    position: 'absolute',
    height: '100%'
  }, __WEBPACK_IMPORTED_MODULE_5__tal_gel_core__["accessibleHiddenStyle"]), function (_ref3) {
    var theme = _ref3.theme,
        show = _ref3.show;
    return _objectSpread({
      transition: "opacity ".concat(theme.Grid.animation.duration, " ").concat(theme.Grid.animation.speedCurve),
      width: '100%',
      left: 0
    }, show && _objectSpread({
      zIndex: 1000
    }, theme.Grid.overlay));
  }); // In the case of PageLayout, OverlayContent is typically the side nav 


  var OverlayContent = __WEBPACK_IMPORTED_MODULE_4__emotion_styled___default.a.div(_objectSpread({
    display: 'inline-block',
    height: '100%'
  }, __WEBPACK_IMPORTED_MODULE_5__tal_gel_core__["accessibleHiddenStyle"]), function (_ref4) {
    var theme = _ref4.theme,
        show = _ref4.show,
        width = _ref4.width,
        enableAnimation = _ref4.enableAnimation;
    return _objectSpread(_objectSpread(_objectSpread({}, width && {
      width: width,
      left: "-".concat(width, "px"),
      overflow: 'hidden',
      opacity: 1,
      zIndex: 1000
    }), enableAnimation && {
      transition: "left ".concat(theme.Grid.animation.duration, " ").concat(theme.Grid.animation.speedCurve)
    }), show && {
      left: 0
    });
  });

  var Container = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__tal_gel_theming__["withTheme"])(ContainerComponent);
  /***/

},
/* 188 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony export (binding) */

  __webpack_require__.d(__webpack_exports__, "a", function () {
    return Icon;
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__ = __webpack_require__(5);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__emotion_styled__ = __webpack_require__(14);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__emotion_styled___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__emotion_styled__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6__tal_gel_core__ = __webpack_require__(7);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6__tal_gel_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__tal_gel_core__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7__tal_gel_theming__ = __webpack_require__(11);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7__tal_gel_theming___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__tal_gel_theming__);

  var _excluded = ["theme", "brand", "name", "width", "height", "color", "hide", "inline", "noInlineGap", "onClick", "float", "onBlur", "onMouseDown", "onKeyDown"];

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);

      if (enumerableOnly) {
        symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
      }

      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  var IconComponent = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.forwardRef(function (_ref, forwardedRef) {
    var theme = _ref.theme,
        brand = _ref.brand,
        name = _ref.name,
        width = _ref.width,
        height = _ref.height,
        color = _ref.color,
        hide = _ref.hide,
        inline = _ref.inline,
        noInlineGap = _ref.noInlineGap,
        onClick = _ref.onClick,
        _float = _ref["float"],
        onBlur = _ref.onBlur,
        onMouseDown = _ref.onMouseDown,
        onKeyDown = _ref.onKeyDown,
        props = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties___default()(_ref, _excluded);

    var SvgComponent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__tal_gel_theming__["getGelIcons"])(brand)[name];

    if (!SvgComponent) {
      console.error("".concat(!brand ? 'UI' : 'Brand', " icon '").concat(name, "' not found"));
      return null;
    }

    var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useState"])(false),
        _useState2 = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray___default()(_useState, 2),
        focusByClick = _useState2[0],
        setFocusByClick = _useState2[1];

    var _onBlur = function _onBlur(event) {
      setFocusByClick(false);
      onBlur && onBlur(event);
    };

    var _onMouseDown = function _onMouseDown(event) {
      setFocusByClick(true);
      onMouseDown && onMouseDown(event);
    };

    var _onKeyDown = function _onKeyDown(event) {
      if (event.keyCode === __WEBPACK_IMPORTED_MODULE_6__tal_gel_core__["SPACE"]) {
        onClick && onClick();
      }

      onKeyDown && onKeyDown(event);
    }; // Fixes an svg issue in Safari by explicitly setting 
    // height to be the same as width, if only width is specified 


    if (width && !height) {
      height = width;
    }

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Fragment, null, inline && !noInlineGap && "\xA0", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(IconWrapper, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({
      "data-cy": "gel-icon",
      theme: theme,
      "float": _float,
      hide: hide
    }, onClick && {
      tabIndex: 0
    }, {
      // Make the icon focusable if clickable
      focusByClick: focusByClick,
      inline: inline,
      onBlur: _onBlur,
      onMouseDown: _onMouseDown,
      onKeyDown: _onKeyDown,
      onClick: onClick
    }, props), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(SvgComponent, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({
      ref: forwardedRef,
      style: {
        fill: color,
        // Svg filters aren't supported by IE
        opacity: hide ? 0 : null
      } // Keep the original size only if neither width nor height is specified
      // (Note that viewBox has already been set in the svg, making it possible
      // for us to just set width or/and height to size the icon)

    }, (width || height) && {
      width: width || null,
      height: height || null
    }))), inline && !noInlineGap && "\xA0");
  }); // https://github.com/facebook/create-react-app/issues/249#issuecomment-235847226


  var IconWrapper = __WEBPACK_IMPORTED_MODULE_5__emotion_styled___default.a.span( // span allows icon to be nested in <p>
  function (_ref2) {
    var theme = _ref2.theme,
        _float2 = _ref2["float"],
        onClick = _ref2.onClick,
        focusByClick = _ref2.focusByClick,
        onMouseEnter = _ref2.onMouseEnter,
        onMouseLeave = _ref2.onMouseLeave,
        left = _ref2.left,
        right = _ref2.right,
        top = _ref2.top,
        bottom = _ref2.bottom,
        marginLeft = _ref2.marginLeft,
        marginRight = _ref2.marginRight,
        width = _ref2.width,
        height = _ref2.height,
        marginBottom = _ref2.marginBottom,
        inline = _ref2.inline;
    return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, onClick && !focusByClick && {
      ':focus': theme.Icon.Focus
    }), {}, {
      display: inline ? 'inline-flex' : 'flex'
    }, inline && {
      verticalAlign: 'middle'
    }), {}, {
      position: _float2 ? 'absolute' : 'relative'
    }, {
      left: left,
      right: right,
      top: top,
      bottom: bottom,
      marginLeft: marginLeft,
      marginRight: marginRight
    }), !onClick && !onMouseEnter && !onMouseLeave ? {
      pointerEvents: 'none' // do not capture any mouse events

    } : {
      cursor: 'pointer'
    }), {}, {
      width: width,
      height: height,
      marginBottom: marginBottom
    });
  });

  var Icon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__tal_gel_theming__["withTheme"])(IconComponent);
  /***/

},
/* 189 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony export (binding) */

  __webpack_require__.d(__webpack_exports__, "a", function () {
    return RowLayout;
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(5);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4__grid_row__ = __webpack_require__(106);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__grid_col__ = __webpack_require__(105);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6__grid_screen_detector__ = __webpack_require__(33);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7__container_lite__ = __webpack_require__(62);

  var _excluded = ["gutter", "style", "alignment", "distribution", "width", "height", "children"];

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);

      if (enumerableOnly) {
        symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
      }

      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  } // Illustratively,
  //
  // <GelRowLayout>
  //   <Block />
  //   <Block />
  //   <Block />
  //   <Block />
  // </GelRowLayout>
  //
  // will become (props omitted):
  //
  // <Row><Col><Block /></Col></Row>
  // <Row><Col><Block /></Col></Row>
  // <Row><Col><Block /></Col></Row>
  // <Row><Col><Block /></Col></Row>
  //
  // `Row` is flexbox and `Col` is flex item
  // Each `Block` will be wrapped by a flex item (container)
  // whose width can be greater than `Block`


  var RowLayoutComponent = function RowLayoutComponent(_ref) {
    var _ref$gutter = _ref.gutter,
        gutter = _ref$gutter === void 0 ? 'none' : _ref$gutter,
        style = _ref.style,
        alignment = _ref.alignment,
        distribution = _ref.distribution,
        width = _ref.width,
        _ref$height = _ref.height,
        height = _ref$height === void 0 ? 'auto' : _ref$height,
        children = _ref.children,
        props = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties___default()(_ref, _excluded);

    var _useContext = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_6__grid_screen_detector__["a"
    /* ScreenDetectorContext */
    ]),
        gridGutters = _useContext.gridGutters,
        getScreenByIndex = _useContext.getScreenByIndex;

    var gutterWidth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__container_lite__["a"
    /* getGutter */
    ])(gridGutters, gutter); // In the context of RowLayout, distribution is an alias for alignment


    alignment = distribution || alignment;
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Fragment, null, // TODO: check the impact of removing the wrapping `div`
    __WEBPACK_IMPORTED_MODULE_3_react___default.a.Children.map(children, function (child) {
      return (// Apply vertical gutter in between rows
        child && child !== ' ' &&
        /*#__PURE__*/
        // Skip empty child (Eg: can happen with conditional render and commenting)
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__grid_row__["a"
        /* Row */
        ], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
          style: _objectSpread(_objectSpread({}, style), {}, {
            width: width,
            height: height
          }),
          verticalGutterWidth: gutterWidth
        }, alignment && {
          justify: alignment
        }, props), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__grid_col__["a"
        /* Col */
        ], alignment && __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()({}, getScreenByIndex(0), 'content'), child))
      );
    }));
  };

  var RowLayout = RowLayoutComponent;
  /***/
},
/* 190 */

/***/
function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */
  (function (process) {
    /**
    * Copyright (c) 2013-present, Facebook, Inc.
    *
    * This source code is licensed under the MIT license found in the
    * LICENSE file in the root directory of this source tree.
    */
    if (process.env.NODE_ENV !== 'production') {
      var ReactIs = __webpack_require__(140); // By explicitly using `prop-types` you are opting into new development behavior.
      // http://fb.me/prop-types-in-prod


      var throwOnDirectAccess = true;
      module.exports = __webpack_require__(336)(ReactIs.isElement, throwOnDirectAccess);
    } else {
      // By explicitly using `prop-types` you are opting into new production behavior.
      // http://fb.me/prop-types-in-prod
      module.exports = __webpack_require__(335)();
    }
    /* WEBPACK VAR INJECTION */

  }).call(exports, __webpack_require__(25));
  /***/
},
/* 191 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony export (binding) */

  __webpack_require__.d(__webpack_exports__, "a", function () {
    return ReCAPTCHA;
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(190);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
  }

  var ReCAPTCHA = /*#__PURE__*/function (_React$Component) {
    _inheritsLoose(ReCAPTCHA, _React$Component);

    function ReCAPTCHA() {
      var _this;

      _this = _React$Component.call(this) || this;
      _this.handleExpired = _this.handleExpired.bind(_assertThisInitialized(_this));
      _this.handleErrored = _this.handleErrored.bind(_assertThisInitialized(_this));
      _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
      _this.handleRecaptchaRef = _this.handleRecaptchaRef.bind(_assertThisInitialized(_this));
      return _this;
    }

    var _proto = ReCAPTCHA.prototype;

    _proto.getValue = function getValue() {
      if (this.props.grecaptcha && this._widgetId !== undefined) {
        return this.props.grecaptcha.getResponse(this._widgetId);
      }

      return null;
    };

    _proto.getWidgetId = function getWidgetId() {
      if (this.props.grecaptcha && this._widgetId !== undefined) {
        return this._widgetId;
      }

      return null;
    };

    _proto.execute = function execute() {
      var grecaptcha = this.props.grecaptcha;

      if (grecaptcha && this._widgetId !== undefined) {
        return grecaptcha.execute(this._widgetId);
      } else {
        this._executeRequested = true;
      }
    };

    _proto.executeAsync = function executeAsync() {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        _this2.executionResolve = resolve;
        _this2.executionReject = reject;

        _this2.execute();
      });
    };

    _proto.reset = function reset() {
      if (this.props.grecaptcha && this._widgetId !== undefined) {
        this.props.grecaptcha.reset(this._widgetId);
      }
    };

    _proto.handleExpired = function handleExpired() {
      if (this.props.onExpired) {
        this.props.onExpired();
      } else {
        this.handleChange(null);
      }
    };

    _proto.handleErrored = function handleErrored() {
      if (this.props.onErrored) {
        this.props.onErrored();
      }

      if (this.executionReject) {
        this.executionReject();
        delete this.executionResolve;
        delete this.executionReject;
      }
    };

    _proto.handleChange = function handleChange(token) {
      if (this.props.onChange) {
        this.props.onChange(token);
      }

      if (this.executionResolve) {
        this.executionResolve(token);
        delete this.executionReject;
        delete this.executionResolve;
      }
    };

    _proto.explicitRender = function explicitRender() {
      if (this.props.grecaptcha && this.props.grecaptcha.render && this._widgetId === undefined) {
        var wrapper = document.createElement("div");
        this._widgetId = this.props.grecaptcha.render(wrapper, {
          sitekey: this.props.sitekey,
          callback: this.handleChange,
          theme: this.props.theme,
          type: this.props.type,
          tabindex: this.props.tabindex,
          "expired-callback": this.handleExpired,
          "error-callback": this.handleErrored,
          size: this.props.size,
          stoken: this.props.stoken,
          hl: this.props.hl,
          badge: this.props.badge
        });
        this.captcha.appendChild(wrapper);
      }

      if (this._executeRequested && this.props.grecaptcha && this._widgetId !== undefined) {
        this._executeRequested = false;
        this.execute();
      }
    };

    _proto.componentDidMount = function componentDidMount() {
      this.explicitRender();
    };

    _proto.componentDidUpdate = function componentDidUpdate() {
      this.explicitRender();
    };

    _proto.componentWillUnmount = function componentWillUnmount() {
      if (this._widgetId !== undefined) {
        this.delayOfCaptchaIframeRemoving();
        this.reset();
      }
    };

    _proto.delayOfCaptchaIframeRemoving = function delayOfCaptchaIframeRemoving() {
      var temporaryNode = document.createElement("div");
      document.body.appendChild(temporaryNode);
      temporaryNode.style.display = "none"; // move of the recaptcha to a temporary node

      while (this.captcha.firstChild) {
        temporaryNode.appendChild(this.captcha.firstChild);
      } // delete the temporary node after reset will be done


      setTimeout(function () {
        document.body.removeChild(temporaryNode);
      }, 5000);
    };

    _proto.handleRecaptchaRef = function handleRecaptchaRef(elem) {
      this.captcha = elem;
    };

    _proto.render = function render() {
      // consume properties owned by the reCATPCHA, pass the rest to the div so the user can style it.

      /* eslint-disable no-unused-vars */
      var _this$props = this.props,
          sitekey = _this$props.sitekey,
          onChange = _this$props.onChange,
          theme = _this$props.theme,
          type = _this$props.type,
          tabindex = _this$props.tabindex,
          onExpired = _this$props.onExpired,
          onErrored = _this$props.onErrored,
          size = _this$props.size,
          stoken = _this$props.stoken,
          grecaptcha = _this$props.grecaptcha,
          badge = _this$props.badge,
          hl = _this$props.hl,
          childProps = _objectWithoutPropertiesLoose(_this$props, ["sitekey", "onChange", "theme", "type", "tabindex", "onExpired", "onErrored", "size", "stoken", "grecaptcha", "badge", "hl"]);
      /* eslint-enable no-unused-vars */


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", _extends({}, childProps, {
        ref: this.handleRecaptchaRef
      }));
    };

    return ReCAPTCHA;
  }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

  ReCAPTCHA.displayName = "ReCAPTCHA";
  ReCAPTCHA.propTypes = {
    sitekey: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    grecaptcha: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
    theme: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["dark", "light"]),
    type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["image", "audio"]),
    tabindex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    onExpired: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    onErrored: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["compact", "normal", "invisible"]),
    stoken: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    hl: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    badge: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["bottomright", "bottomleft", "inline"])
  };
  ReCAPTCHA.defaultProps = {
    onChange: function onChange() {},
    theme: "light",
    type: "image",
    tabindex: 0,
    size: "normal",
    badge: "bottomright"
  };
  /***/
},
/* 192 */

/***/
function (module, exports, __webpack_require__) {
  var global = __webpack_require__(1);

  var isCallable = __webpack_require__(17);

  var String = global.String;
  var TypeError = global.TypeError;

  module.exports = function (argument) {
    if (typeof argument == 'object' || isCallable(argument)) return argument;
    throw TypeError("Can't set " + String(argument) + ' as a prototype');
  };
  /***/

},
/* 193 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var toObject = __webpack_require__(22);

  var toAbsoluteIndex = __webpack_require__(60);

  var lengthOfArrayLike = __webpack_require__(23);

  var min = Math.min; // `Array.prototype.copyWithin` method implementation
  // https://tc39.es/ecma262/#sec-array.prototype.copywithin
  // eslint-disable-next-line es/no-array-prototype-copywithin -- safe

  module.exports = [].copyWithin || function copyWithin(target
  /* = 0 */
  , start
  /* = 0, end = @length */
  ) {
    var O = toObject(this);
    var len = lengthOfArrayLike(O);
    var to = toAbsoluteIndex(target, len);
    var from = toAbsoluteIndex(start, len);
    var end = arguments.length > 2 ? arguments[2] : undefined;
    var count = min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
    var inc = 1;

    if (from < to && to < from + count) {
      inc = -1;
      from += count - 1;
      to += count - 1;
    }

    while (count-- > 0) {
      if (from in O) O[to] = O[from];else delete O[to];
      to += inc;
      from += inc;
    }

    return O;
  };
  /***/

},
/* 194 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $forEach = __webpack_require__(30).forEach;

  var arrayMethodIsStrict = __webpack_require__(55);

  var STRICT_METHOD = arrayMethodIsStrict('forEach'); // `Array.prototype.forEach` method implementation
  // https://tc39.es/ecma262/#sec-array.prototype.foreach

  module.exports = !STRICT_METHOD ? function forEach(callbackfn
  /* , thisArg */
  ) {
    return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined); // eslint-disable-next-line es/no-array-prototype-foreach -- safe
  } : [].forEach;
  /***/
},
/* 195 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var global = __webpack_require__(1);

  var bind = __webpack_require__(51);

  var call = __webpack_require__(19);

  var toObject = __webpack_require__(22);

  var callWithSafeIterationClosing = __webpack_require__(345);

  var isArrayIteratorMethod = __webpack_require__(153);

  var isConstructor = __webpack_require__(76);

  var lengthOfArrayLike = __webpack_require__(23);

  var createProperty = __webpack_require__(56);

  var getIterator = __webpack_require__(116);

  var getIteratorMethod = __webpack_require__(90);

  var Array = global.Array; // `Array.from` method implementation
  // https://tc39.es/ecma262/#sec-array.from

  module.exports = function from(arrayLike
  /* , mapfn = undefined, thisArg = undefined */
  ) {
    var O = toObject(arrayLike);
    var IS_CONSTRUCTOR = isConstructor(this);
    var argumentsLength = arguments.length;
    var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    if (mapping) mapfn = bind(mapfn, argumentsLength > 2 ? arguments[2] : undefined);
    var iteratorMethod = getIteratorMethod(O);
    var index = 0;
    var length, result, step, iterator, next, value; // if the target is not iterable or it's an array with the default iterator - use a simple case

    if (iteratorMethod && !(this == Array && isArrayIteratorMethod(iteratorMethod))) {
      iterator = getIterator(O, iteratorMethod);
      next = iterator.next;
      result = IS_CONSTRUCTOR ? new this() : [];

      for (; !(step = call(next, iterator)).done; index++) {
        value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [step.value, index], true) : step.value;
        createProperty(result, index, value);
      }
    } else {
      length = lengthOfArrayLike(O);
      result = IS_CONSTRUCTOR ? new this(length) : Array(length);

      for (; length > index; index++) {
        value = mapping ? mapfn(O[index], index) : O[index];
        createProperty(result, index, value);
      }
    }

    result.length = index;
    return result;
  };
  /***/

},
/* 196 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* eslint-disable es/no-array-prototype-lastindexof -- safe */

  var apply = __webpack_require__(40);

  var toIndexedObject = __webpack_require__(37);

  var toIntegerOrInfinity = __webpack_require__(29);

  var lengthOfArrayLike = __webpack_require__(23);

  var arrayMethodIsStrict = __webpack_require__(55);

  var min = Math.min;
  var $lastIndexOf = [].lastIndexOf;
  var NEGATIVE_ZERO = !!$lastIndexOf && 1 / [1].lastIndexOf(1, -0) < 0;
  var STRICT_METHOD = arrayMethodIsStrict('lastIndexOf');
  var FORCED = NEGATIVE_ZERO || !STRICT_METHOD; // `Array.prototype.lastIndexOf` method implementation
  // https://tc39.es/ecma262/#sec-array.prototype.lastindexof

  module.exports = FORCED ? function lastIndexOf(searchElement
  /* , fromIndex = @[*-1] */
  ) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return apply($lastIndexOf, this, arguments) || 0;
    var O = toIndexedObject(this);
    var length = lengthOfArrayLike(O);
    var index = length - 1;
    if (arguments.length > 1) index = min(index, toIntegerOrInfinity(arguments[1]));
    if (index < 0) index = length + index;

    for (; index >= 0; index--) {
      if (index in O && O[index] === searchElement) return index || 0;
    }

    return -1;
  } : $lastIndexOf;
  /***/
},
/* 197 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var defineProperty = __webpack_require__(20).f;

  var create = __webpack_require__(41);

  var redefineAll = __webpack_require__(78);

  var bind = __webpack_require__(51);

  var anInstance = __webpack_require__(50);

  var iterate = __webpack_require__(59);

  var defineIterator = __webpack_require__(149);

  var setSpecies = __webpack_require__(79);

  var DESCRIPTORS = __webpack_require__(12);

  var fastKey = __webpack_require__(70).fastKey;

  var InternalStateModule = __webpack_require__(27);

  var setInternalState = InternalStateModule.set;
  var internalStateGetterFor = InternalStateModule.getterFor;
  module.exports = {
    getConstructor: function getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
      var Constructor = wrapper(function (that, iterable) {
        anInstance(that, Prototype);
        setInternalState(that, {
          type: CONSTRUCTOR_NAME,
          index: create(null),
          first: undefined,
          last: undefined,
          size: 0
        });
        if (!DESCRIPTORS) that.size = 0;
        if (iterable != undefined) iterate(iterable, that[ADDER], {
          that: that,
          AS_ENTRIES: IS_MAP
        });
      });
      var Prototype = Constructor.prototype;
      var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);

      var define = function define(that, key, value) {
        var state = getInternalState(that);
        var entry = getEntry(that, key);
        var previous, index; // change existing entry

        if (entry) {
          entry.value = value; // create new entry
        } else {
          state.last = entry = {
            index: index = fastKey(key, true),
            key: key,
            value: value,
            previous: previous = state.last,
            next: undefined,
            removed: false
          };
          if (!state.first) state.first = entry;
          if (previous) previous.next = entry;
          if (DESCRIPTORS) state.size++;else that.size++; // add to index

          if (index !== 'F') state.index[index] = entry;
        }

        return that;
      };

      var getEntry = function getEntry(that, key) {
        var state = getInternalState(that); // fast case

        var index = fastKey(key);
        var entry;
        if (index !== 'F') return state.index[index]; // frozen object case

        for (entry = state.first; entry; entry = entry.next) {
          if (entry.key == key) return entry;
        }
      };

      redefineAll(Prototype, {
        // `{ Map, Set }.prototype.clear()` methods
        // https://tc39.es/ecma262/#sec-map.prototype.clear
        // https://tc39.es/ecma262/#sec-set.prototype.clear
        clear: function clear() {
          var that = this;
          var state = getInternalState(that);
          var data = state.index;
          var entry = state.first;

          while (entry) {
            entry.removed = true;
            if (entry.previous) entry.previous = entry.previous.next = undefined;
            delete data[entry.index];
            entry = entry.next;
          }

          state.first = state.last = undefined;
          if (DESCRIPTORS) state.size = 0;else that.size = 0;
        },
        // `{ Map, Set }.prototype.delete(key)` methods
        // https://tc39.es/ecma262/#sec-map.prototype.delete
        // https://tc39.es/ecma262/#sec-set.prototype.delete
        'delete': function _delete(key) {
          var that = this;
          var state = getInternalState(that);
          var entry = getEntry(that, key);

          if (entry) {
            var next = entry.next;
            var prev = entry.previous;
            delete state.index[entry.index];
            entry.removed = true;
            if (prev) prev.next = next;
            if (next) next.previous = prev;
            if (state.first == entry) state.first = next;
            if (state.last == entry) state.last = prev;
            if (DESCRIPTORS) state.size--;else that.size--;
          }

          return !!entry;
        },
        // `{ Map, Set }.prototype.forEach(callbackfn, thisArg = undefined)` methods
        // https://tc39.es/ecma262/#sec-map.prototype.foreach
        // https://tc39.es/ecma262/#sec-set.prototype.foreach
        forEach: function forEach(callbackfn
        /* , that = undefined */
        ) {
          var state = getInternalState(this);
          var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
          var entry;

          while (entry = entry ? entry.next : state.first) {
            boundFunction(entry.value, entry.key, this); // revert to the last existing entry

            while (entry && entry.removed) {
              entry = entry.previous;
            }
          }
        },
        // `{ Map, Set}.prototype.has(key)` methods
        // https://tc39.es/ecma262/#sec-map.prototype.has
        // https://tc39.es/ecma262/#sec-set.prototype.has
        has: function has(key) {
          return !!getEntry(this, key);
        }
      });
      redefineAll(Prototype, IS_MAP ? {
        // `Map.prototype.get(key)` method
        // https://tc39.es/ecma262/#sec-map.prototype.get
        get: function get(key) {
          var entry = getEntry(this, key);
          return entry && entry.value;
        },
        // `Map.prototype.set(key, value)` method
        // https://tc39.es/ecma262/#sec-map.prototype.set
        set: function set(key, value) {
          return define(this, key === 0 ? 0 : key, value);
        }
      } : {
        // `Set.prototype.add(value)` method
        // https://tc39.es/ecma262/#sec-set.prototype.add
        add: function add(value) {
          return define(this, value = value === 0 ? 0 : value, value);
        }
      });
      if (DESCRIPTORS) defineProperty(Prototype, 'size', {
        get: function get() {
          return getInternalState(this).size;
        }
      });
      return Constructor;
    },
    setStrong: function setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP) {
      var ITERATOR_NAME = CONSTRUCTOR_NAME + ' Iterator';
      var getInternalCollectionState = internalStateGetterFor(CONSTRUCTOR_NAME);
      var getInternalIteratorState = internalStateGetterFor(ITERATOR_NAME); // `{ Map, Set }.prototype.{ keys, values, entries, @@iterator }()` methods
      // https://tc39.es/ecma262/#sec-map.prototype.entries
      // https://tc39.es/ecma262/#sec-map.prototype.keys
      // https://tc39.es/ecma262/#sec-map.prototype.values
      // https://tc39.es/ecma262/#sec-map.prototype-@@iterator
      // https://tc39.es/ecma262/#sec-set.prototype.entries
      // https://tc39.es/ecma262/#sec-set.prototype.keys
      // https://tc39.es/ecma262/#sec-set.prototype.values
      // https://tc39.es/ecma262/#sec-set.prototype-@@iterator

      defineIterator(Constructor, CONSTRUCTOR_NAME, function (iterated, kind) {
        setInternalState(this, {
          type: ITERATOR_NAME,
          target: iterated,
          state: getInternalCollectionState(iterated),
          kind: kind,
          last: undefined
        });
      }, function () {
        var state = getInternalIteratorState(this);
        var kind = state.kind;
        var entry = state.last; // revert to the last existing entry

        while (entry && entry.removed) {
          entry = entry.previous;
        } // get next entry


        if (!state.target || !(state.last = entry = entry ? entry.next : state.state.first)) {
          // or finish the iteration
          state.target = undefined;
          return {
            value: undefined,
            done: true
          };
        } // return step by kind


        if (kind == 'keys') return {
          value: entry.key,
          done: false
        };
        if (kind == 'values') return {
          value: entry.value,
          done: false
        };
        return {
          value: [entry.key, entry.value],
          done: false
        };
      }, IS_MAP ? 'entries' : 'values', !IS_MAP, true); // `{ Map, Set }.prototype[@@species]` accessors
      // https://tc39.es/ecma262/#sec-get-map-@@species
      // https://tc39.es/ecma262/#sec-get-set-@@species

      setSpecies(CONSTRUCTOR_NAME);
    }
  };
  /***/
},
/* 198 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var uncurryThis = __webpack_require__(3);

  var redefineAll = __webpack_require__(78);

  var getWeakData = __webpack_require__(70).getWeakData;

  var anObject = __webpack_require__(10);

  var isObject = __webpack_require__(13);

  var anInstance = __webpack_require__(50);

  var iterate = __webpack_require__(59);

  var ArrayIterationModule = __webpack_require__(30);

  var hasOwn = __webpack_require__(21);

  var InternalStateModule = __webpack_require__(27);

  var setInternalState = InternalStateModule.set;
  var internalStateGetterFor = InternalStateModule.getterFor;
  var find = ArrayIterationModule.find;
  var findIndex = ArrayIterationModule.findIndex;
  var splice = uncurryThis([].splice);
  var id = 0; // fallback for uncaught frozen keys

  var uncaughtFrozenStore = function uncaughtFrozenStore(store) {
    return store.frozen || (store.frozen = new UncaughtFrozenStore());
  };

  var UncaughtFrozenStore = function UncaughtFrozenStore() {
    this.entries = [];
  };

  var findUncaughtFrozen = function findUncaughtFrozen(store, key) {
    return find(store.entries, function (it) {
      return it[0] === key;
    });
  };

  UncaughtFrozenStore.prototype = {
    get: function get(key) {
      var entry = findUncaughtFrozen(this, key);
      if (entry) return entry[1];
    },
    has: function has(key) {
      return !!findUncaughtFrozen(this, key);
    },
    set: function set(key, value) {
      var entry = findUncaughtFrozen(this, key);
      if (entry) entry[1] = value;else this.entries.push([key, value]);
    },
    'delete': function _delete(key) {
      var index = findIndex(this.entries, function (it) {
        return it[0] === key;
      });
      if (~index) splice(this.entries, index, 1);
      return !!~index;
    }
  };
  module.exports = {
    getConstructor: function getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
      var Constructor = wrapper(function (that, iterable) {
        anInstance(that, Prototype);
        setInternalState(that, {
          type: CONSTRUCTOR_NAME,
          id: id++,
          frozen: undefined
        });
        if (iterable != undefined) iterate(iterable, that[ADDER], {
          that: that,
          AS_ENTRIES: IS_MAP
        });
      });
      var Prototype = Constructor.prototype;
      var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);

      var define = function define(that, key, value) {
        var state = getInternalState(that);
        var data = getWeakData(anObject(key), true);
        if (data === true) uncaughtFrozenStore(state).set(key, value);else data[state.id] = value;
        return that;
      };

      redefineAll(Prototype, {
        // `{ WeakMap, WeakSet }.prototype.delete(key)` methods
        // https://tc39.es/ecma262/#sec-weakmap.prototype.delete
        // https://tc39.es/ecma262/#sec-weakset.prototype.delete
        'delete': function _delete(key) {
          var state = getInternalState(this);
          if (!isObject(key)) return false;
          var data = getWeakData(key);
          if (data === true) return uncaughtFrozenStore(state)['delete'](key);
          return data && hasOwn(data, state.id) && delete data[state.id];
        },
        // `{ WeakMap, WeakSet }.prototype.has(key)` methods
        // https://tc39.es/ecma262/#sec-weakmap.prototype.has
        // https://tc39.es/ecma262/#sec-weakset.prototype.has
        has: function has(key) {
          var state = getInternalState(this);
          if (!isObject(key)) return false;
          var data = getWeakData(key);
          if (data === true) return uncaughtFrozenStore(state).has(key);
          return data && hasOwn(data, state.id);
        }
      });
      redefineAll(Prototype, IS_MAP ? {
        // `WeakMap.prototype.get(key)` method
        // https://tc39.es/ecma262/#sec-weakmap.prototype.get
        get: function get(key) {
          var state = getInternalState(this);

          if (isObject(key)) {
            var data = getWeakData(key);
            if (data === true) return uncaughtFrozenStore(state).get(key);
            return data ? data[state.id] : undefined;
          }
        },
        // `WeakMap.prototype.set(key, value)` method
        // https://tc39.es/ecma262/#sec-weakmap.prototype.set
        set: function set(key, value) {
          return define(this, key, value);
        }
      } : {
        // `WeakSet.prototype.add(value)` method
        // https://tc39.es/ecma262/#sec-weakset.prototype.add
        add: function add(value) {
          return define(this, value, true);
        }
      });
      return Constructor;
    }
  };
  /***/
},
/* 199 */

/***/
function (module, exports) {
  module.exports = {
    IndexSizeError: {
      s: 'INDEX_SIZE_ERR',
      c: 1,
      m: 1
    },
    DOMStringSizeError: {
      s: 'DOMSTRING_SIZE_ERR',
      c: 2,
      m: 0
    },
    HierarchyRequestError: {
      s: 'HIERARCHY_REQUEST_ERR',
      c: 3,
      m: 1
    },
    WrongDocumentError: {
      s: 'WRONG_DOCUMENT_ERR',
      c: 4,
      m: 1
    },
    InvalidCharacterError: {
      s: 'INVALID_CHARACTER_ERR',
      c: 5,
      m: 1
    },
    NoDataAllowedError: {
      s: 'NO_DATA_ALLOWED_ERR',
      c: 6,
      m: 0
    },
    NoModificationAllowedError: {
      s: 'NO_MODIFICATION_ALLOWED_ERR',
      c: 7,
      m: 1
    },
    NotFoundError: {
      s: 'NOT_FOUND_ERR',
      c: 8,
      m: 1
    },
    NotSupportedError: {
      s: 'NOT_SUPPORTED_ERR',
      c: 9,
      m: 1
    },
    InUseAttributeError: {
      s: 'INUSE_ATTRIBUTE_ERR',
      c: 10,
      m: 1
    },
    InvalidStateError: {
      s: 'INVALID_STATE_ERR',
      c: 11,
      m: 1
    },
    SyntaxError: {
      s: 'SYNTAX_ERR',
      c: 12,
      m: 1
    },
    InvalidModificationError: {
      s: 'INVALID_MODIFICATION_ERR',
      c: 13,
      m: 1
    },
    NamespaceError: {
      s: 'NAMESPACE_ERR',
      c: 14,
      m: 1
    },
    InvalidAccessError: {
      s: 'INVALID_ACCESS_ERR',
      c: 15,
      m: 1
    },
    ValidationError: {
      s: 'VALIDATION_ERR',
      c: 16,
      m: 0
    },
    TypeMismatchError: {
      s: 'TYPE_MISMATCH_ERR',
      c: 17,
      m: 1
    },
    SecurityError: {
      s: 'SECURITY_ERR',
      c: 18,
      m: 1
    },
    NetworkError: {
      s: 'NETWORK_ERR',
      c: 19,
      m: 1
    },
    AbortError: {
      s: 'ABORT_ERR',
      c: 20,
      m: 1
    },
    URLMismatchError: {
      s: 'URL_MISMATCH_ERR',
      c: 21,
      m: 1
    },
    QuotaExceededError: {
      s: 'QUOTA_EXCEEDED_ERR',
      c: 22,
      m: 1
    },
    TimeoutError: {
      s: 'TIMEOUT_ERR',
      c: 23,
      m: 1
    },
    InvalidNodeTypeError: {
      s: 'INVALID_NODE_TYPE_ERR',
      c: 24,
      m: 1
    },
    DataCloneError: {
      s: 'DATA_CLONE_ERR',
      c: 25,
      m: 1
    }
  };
  /***/
},
/* 200 */

/***/
function (module, exports) {
  // iterable DOM collections
  // flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
  module.exports = {
    CSSRuleList: 0,
    CSSStyleDeclaration: 0,
    CSSValueList: 0,
    ClientRectList: 0,
    DOMRectList: 0,
    DOMStringList: 0,
    DOMTokenList: 1,
    DataTransferItemList: 0,
    FileList: 0,
    HTMLAllCollection: 0,
    HTMLCollection: 0,
    HTMLFormElement: 0,
    HTMLSelectElement: 0,
    MediaList: 0,
    MimeTypeArray: 0,
    NamedNodeMap: 0,
    NodeList: 1,
    PaintRequestList: 0,
    Plugin: 0,
    PluginArray: 0,
    SVGLengthList: 0,
    SVGNumberList: 0,
    SVGPathSegList: 0,
    SVGPointList: 0,
    SVGStringList: 0,
    SVGTransformList: 0,
    SourceBufferList: 0,
    StyleSheetList: 0,
    TextTrackCueList: 0,
    TextTrackList: 0,
    TouchList: 0
  };
  /***/
},
/* 201 */

/***/
function (module, exports, __webpack_require__) {
  // in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
  var documentCreateElement = __webpack_require__(114);

  var classList = documentCreateElement('span').classList;
  var DOMTokenListPrototype = classList && classList.constructor && classList.constructor.prototype;
  module.exports = DOMTokenListPrototype === Object.prototype ? undefined : DOMTokenListPrototype;
  /***/
},
/* 202 */

/***/
function (module, exports, __webpack_require__) {
  var userAgent = __webpack_require__(57);

  var firefox = userAgent.match(/firefox\/(\d+)/i);
  module.exports = !!firefox && +firefox[1];
  /***/
},
/* 203 */

/***/
function (module, exports, __webpack_require__) {
  var UA = __webpack_require__(57);

  module.exports = /MSIE|Trident/.test(UA);
  /***/
},
/* 204 */

/***/
function (module, exports, __webpack_require__) {
  var userAgent = __webpack_require__(57);

  module.exports = /(?:ipad|iphone|ipod).*applewebkit/i.test(userAgent);
  /***/
},
/* 205 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var DESCRIPTORS = __webpack_require__(12);

  var fails = __webpack_require__(2);

  var anObject = __webpack_require__(10);

  var create = __webpack_require__(41);

  var normalizeStringArgument = __webpack_require__(96);

  var nativeErrorToString = Error.prototype.toString;
  var INCORRECT_TO_STRING = fails(function () {
    if (DESCRIPTORS) {
      // Chrome 32- incorrectly call accessor
      // eslint-disable-next-line es/no-object-defineproperty -- safe
      var object = create(Object.defineProperty({}, 'name', {
        get: function get() {
          return this === object;
        }
      }));
      if (nativeErrorToString.call(object) !== 'true') return true;
    } // FF10- does not properly handle non-strings


    return nativeErrorToString.call({
      message: 1,
      name: 2
    }) !== '2: 1' // IE8 does not properly handle defaults
    || nativeErrorToString.call({}) !== 'Error';
  });
  module.exports = INCORRECT_TO_STRING ? function toString() {
    var O = anObject(this);
    var name = normalizeStringArgument(O.name, 'Error');
    var message = normalizeStringArgument(O.message);
    return !name ? message : !message ? name : name + ': ' + message;
  } : nativeErrorToString;
  /***/
},
/* 206 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var global = __webpack_require__(1);

  var isArray = __webpack_require__(71);

  var lengthOfArrayLike = __webpack_require__(23);

  var bind = __webpack_require__(51);

  var TypeError = global.TypeError; // `FlattenIntoArray` abstract operation
  // https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray

  var flattenIntoArray = function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
    var targetIndex = start;
    var sourceIndex = 0;
    var mapFn = mapper ? bind(mapper, thisArg) : false;
    var element, elementLen;

    while (sourceIndex < sourceLen) {
      if (sourceIndex in source) {
        element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

        if (depth > 0 && isArray(element)) {
          elementLen = lengthOfArrayLike(element);
          targetIndex = flattenIntoArray(target, original, element, elementLen, targetIndex, depth - 1) - 1;
        } else {
          if (targetIndex >= 0x1FFFFFFFFFFFFF) throw TypeError('Exceed the acceptable array length');
          target[targetIndex] = element;
        }

        targetIndex++;
      }

      sourceIndex++;
    }

    return targetIndex;
  };

  module.exports = flattenIntoArray;
  /***/
},
/* 207 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var global = __webpack_require__(1);

  var uncurryThis = __webpack_require__(3);

  var aCallable = __webpack_require__(34);

  var isObject = __webpack_require__(13);

  var hasOwn = __webpack_require__(21);

  var arraySlice = __webpack_require__(68);

  var NATIVE_BIND = __webpack_require__(89);

  var Function = global.Function;
  var concat = uncurryThis([].concat);
  var join = uncurryThis([].join);
  var factories = {};

  var construct = function construct(C, argsLength, args) {
    if (!hasOwn(factories, argsLength)) {
      for (var list = [], i = 0; i < argsLength; i++) {
        list[i] = 'a[' + i + ']';
      }

      factories[argsLength] = Function('C,a', 'return new C(' + join(list, ',') + ')');
    }

    return factories[argsLength](C, args);
  }; // `Function.prototype.bind` method implementation
  // https://tc39.es/ecma262/#sec-function.prototype.bind


  module.exports = NATIVE_BIND ? Function.bind : function bind(that
  /* , ...args */
  ) {
    var F = aCallable(this);
    var Prototype = F.prototype;
    var partArgs = arraySlice(arguments, 1);

    var boundFunction = function
      /* args... */
    bound() {
      var args = concat(partArgs, arraySlice(arguments));
      return this instanceof boundFunction ? construct(F, args.length, args) : F.apply(that, args);
    };

    if (isObject(Prototype)) boundFunction.prototype = Prototype;
    return boundFunction;
  };
  /***/
},
/* 208 */

/***/
function (module, exports, __webpack_require__) {
  var uncurryThis = __webpack_require__(3);

  var toObject = __webpack_require__(22);

  var floor = Math.floor;
  var charAt = uncurryThis(''.charAt);
  var replace = uncurryThis(''.replace);
  var stringSlice = uncurryThis(''.slice);
  var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
  var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g; // `GetSubstitution` abstract operation
  // https://tc39.es/ecma262/#sec-getsubstitution

  module.exports = function (matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;

    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }

    return replace(replacement, symbols, function (match, ch) {
      var capture;

      switch (charAt(ch, 0)) {
        case '$':
          return '$';

        case '&':
          return matched;

        case '`':
          return stringSlice(str, 0, position);

        case "'":
          return stringSlice(str, tailPos);

        case '<':
          capture = namedCaptures[stringSlice(ch, 1, -1)];
          break;

        default:
          // \d\d?
          var n = +ch;
          if (n === 0) return match;

          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? charAt(ch, 1) : captures[f - 1] + charAt(ch, 1);
            return match;
          }

          capture = captures[n - 1];
      }

      return capture === undefined ? '' : capture;
    });
  };
  /***/

},
/* 209 */

/***/
function (module, exports, __webpack_require__) {
  var getBuiltIn = __webpack_require__(26);

  module.exports = getBuiltIn('document', 'documentElement');
  /***/
},
/* 210 */

/***/
function (module, exports, __webpack_require__) {
  var DESCRIPTORS = __webpack_require__(12);

  var fails = __webpack_require__(2);

  var createElement = __webpack_require__(114); // Thanks to IE8 for its funny defineProperty


  module.exports = !DESCRIPTORS && !fails(function () {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty(createElement('div'), 'a', {
      get: function get() {
        return 7;
      }
    }).a != 7;
  });
  /***/
},
/* 211 */

/***/
function (module, exports, __webpack_require__) {
  var isObject = __webpack_require__(13);

  var createNonEnumerableProperty = __webpack_require__(35); // `InstallErrorCause` abstract operation
  // https://tc39.es/proposal-error-cause/#sec-errorobjects-install-error-cause


  module.exports = function (O, options) {
    if (isObject(options) && 'cause' in options) {
      createNonEnumerableProperty(O, 'cause', options.cause);
    }
  };
  /***/

},
/* 212 */

/***/
function (module, exports, __webpack_require__) {
  var hasOwn = __webpack_require__(21);

  module.exports = function (descriptor) {
    return descriptor !== undefined && (hasOwn(descriptor, 'value') || hasOwn(descriptor, 'writable'));
  };
  /***/

},
/* 213 */

/***/
function (module, exports, __webpack_require__) {
  var call = __webpack_require__(19);

  var anObject = __webpack_require__(10);

  var getMethod = __webpack_require__(58);

  module.exports = function (iterator, kind, value) {
    var innerResult, innerError;
    anObject(iterator);

    try {
      innerResult = getMethod(iterator, 'return');

      if (!innerResult) {
        if (kind === 'throw') throw value;
        return value;
      }

      innerResult = call(innerResult, iterator);
    } catch (error) {
      innerError = true;
      innerResult = error;
    }

    if (kind === 'throw') throw value;
    if (innerError) throw innerResult;
    anObject(innerResult);
    return value;
  };
  /***/

},
/* 214 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var fails = __webpack_require__(2);

  var isCallable = __webpack_require__(17);

  var create = __webpack_require__(41);

  var getPrototypeOf = __webpack_require__(48);

  var redefine = __webpack_require__(24);

  var wellKnownSymbol = __webpack_require__(15);

  var IS_PURE = __webpack_require__(31);

  var ITERATOR = wellKnownSymbol('iterator');
  var BUGGY_SAFARI_ITERATORS = false; // `%IteratorPrototype%` object
  // https://tc39.es/ecma262/#sec-%iteratorprototype%-object

  var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;
  /* eslint-disable es/no-array-prototype-keys -- safe */

  if ([].keys) {
    arrayIterator = [].keys(); // Safari 8 has buggy iterators w/o `next`

    if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;else {
      PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
      if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
    }
  }

  var NEW_ITERATOR_PROTOTYPE = IteratorPrototype == undefined || fails(function () {
    var test = {}; // FF44- legacy iterators case

    return IteratorPrototype[ITERATOR].call(test) !== test;
  });
  if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype = {};else if (IS_PURE) IteratorPrototype = create(IteratorPrototype); // `%IteratorPrototype%[@@iterator]()` method
  // https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator

  if (!isCallable(IteratorPrototype[ITERATOR])) {
    redefine(IteratorPrototype, ITERATOR, function () {
      return this;
    });
  }

  module.exports = {
    IteratorPrototype: IteratorPrototype,
    BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
  };
  /***/
},
/* 215 */

/***/
function (module, exports) {
  var log = Math.log;
  var LOG10E = Math.LOG10E; // eslint-disable-next-line es/no-math-log10 -- safe

  module.exports = Math.log10 || function log10(x) {
    return log(x) * LOG10E;
  };
  /***/

},
/* 216 */

/***/
function (module, exports) {
  var log = Math.log; // `Math.log1p` method implementation
  // https://tc39.es/ecma262/#sec-math.log1p
  // eslint-disable-next-line es/no-math-log1p -- safe

  module.exports = Math.log1p || function log1p(x) {
    return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : log(1 + x);
  };
  /***/

},
/* 217 */

/***/
function (module, exports, __webpack_require__) {
  var global = __webpack_require__(1);

  var bind = __webpack_require__(51);

  var getOwnPropertyDescriptor = __webpack_require__(32).f;

  var macrotask = __webpack_require__(167).set;

  var IS_IOS = __webpack_require__(204);

  var IS_IOS_PEBBLE = __webpack_require__(349);

  var IS_WEBOS_WEBKIT = __webpack_require__(350);

  var IS_NODE = __webpack_require__(69);

  var MutationObserver = global.MutationObserver || global.WebKitMutationObserver;
  var document = global.document;
  var process = global.process;
  var Promise = global.Promise; // Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`

  var queueMicrotaskDescriptor = getOwnPropertyDescriptor(global, 'queueMicrotask');
  var queueMicrotask = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;
  var flush, head, last, notify, toggle, node, promise, then; // modern engines have queueMicrotask method

  if (!queueMicrotask) {
    flush = function flush() {
      var parent, fn;
      if (IS_NODE && (parent = process.domain)) parent.exit();

      while (head) {
        fn = head.fn;
        head = head.next;

        try {
          fn();
        } catch (error) {
          if (head) notify();else last = undefined;
          throw error;
        }
      }

      last = undefined;
      if (parent) parent.enter();
    }; // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
    // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898


    if (!IS_IOS && !IS_NODE && !IS_WEBOS_WEBKIT && MutationObserver && document) {
      toggle = true;
      node = document.createTextNode('');
      new MutationObserver(flush).observe(node, {
        characterData: true
      });

      notify = function notify() {
        node.data = toggle = !toggle;
      }; // environments with maybe non-completely correct, but existent Promise

    } else if (!IS_IOS_PEBBLE && Promise && Promise.resolve) {
      // Promise.resolve without an argument throws an error in LG WebOS 2
      promise = Promise.resolve(undefined); // workaround of WebKit ~ iOS Safari 10.1 bug

      promise.constructor = Promise;
      then = bind(promise.then, promise);

      notify = function notify() {
        then(flush);
      }; // Node.js without promises

    } else if (IS_NODE) {
      notify = function notify() {
        process.nextTick(flush);
      }; // for other environments - macrotask based on:
      // - setImmediate
      // - MessageChannel
      // - window.postMessag
      // - onreadystatechange
      // - setTimeout

    } else {
      // strange IE + webpack dev server bug - use .bind(global)
      macrotask = bind(macrotask, global);

      notify = function notify() {
        macrotask(flush);
      };
    }
  }

  module.exports = queueMicrotask || function (fn) {
    var task = {
      fn: fn,
      next: undefined
    };
    if (last) last.next = task;

    if (!head) {
      head = task;
      notify();
    }

    last = task;
  };
  /***/

},
/* 218 */

/***/
function (module, exports, __webpack_require__) {
  var global = __webpack_require__(1);

  module.exports = global.Promise;
  /***/
},
/* 219 */

/***/
function (module, exports, __webpack_require__) {
  var fails = __webpack_require__(2);

  var wellKnownSymbol = __webpack_require__(15);

  var IS_PURE = __webpack_require__(31);

  var ITERATOR = wellKnownSymbol('iterator');
  module.exports = !fails(function () {
    // eslint-disable-next-line unicorn/relative-url-style -- required for testing
    var url = new URL('b?a=1&b=2&c=3', 'http://a');
    var searchParams = url.searchParams;
    var result = '';
    url.pathname = 'c%20d';
    searchParams.forEach(function (value, key) {
      searchParams['delete']('b');
      result += key + value;
    });
    return IS_PURE && !url.toJSON || !searchParams.sort || url.href !== 'http://a/c%20d?a=1&c=3' || searchParams.get('c') !== '3' || String(new URLSearchParams('?a=1')) !== 'a=1' || !searchParams[ITERATOR] // throws in Edge
    || new URL('https://a@b').username !== 'a' || new URLSearchParams(new URLSearchParams('a=b')).get('a') !== 'b' // not punycoded in Edge
    || new URL('http://тест').host !== 'xn--e1aybc' // not escaped in Chrome 62-
    || new URL('http://a#б').hash !== '#%D0%B1' // fails in Chrome 66-
    || result !== 'a1c3' // throws in Safari
    || new URL('http://x', undefined).host !== 'x';
  });
  /***/
},
/* 220 */

/***/
function (module, exports, __webpack_require__) {
  var global = __webpack_require__(1);

  var isCallable = __webpack_require__(17);

  var inspectSource = __webpack_require__(117);

  var WeakMap = global.WeakMap;
  module.exports = isCallable(WeakMap) && /native code/.test(inspectSource(WeakMap));
  /***/
},
/* 221 */

/***/
function (module, exports, __webpack_require__) {
  var global = __webpack_require__(1);

  var fails = __webpack_require__(2);

  var uncurryThis = __webpack_require__(3);

  var toString = __webpack_require__(18);

  var trim = __webpack_require__(81).trim;

  var whitespaces = __webpack_require__(131);

  var charAt = uncurryThis(''.charAt);
  var n$ParseFloat = global.parseFloat;
  var Symbol = global.Symbol;
  var ITERATOR = Symbol && Symbol.iterator;
  var FORCED = 1 / n$ParseFloat(whitespaces + '-0') !== -Infinity // MS Edge 18- broken with boxed symbols
  || ITERATOR && !fails(function () {
    n$ParseFloat(Object(ITERATOR));
  }); // `parseFloat` method
  // https://tc39.es/ecma262/#sec-parsefloat-string

  module.exports = FORCED ? function parseFloat(string) {
    var trimmedString = trim(toString(string));
    var result = n$ParseFloat(trimmedString);
    return result === 0 && charAt(trimmedString, 0) == '-' ? -0 : result;
  } : n$ParseFloat;
  /***/
},
/* 222 */

/***/
function (module, exports, __webpack_require__) {
  var global = __webpack_require__(1);

  var fails = __webpack_require__(2);

  var uncurryThis = __webpack_require__(3);

  var toString = __webpack_require__(18);

  var trim = __webpack_require__(81).trim;

  var whitespaces = __webpack_require__(131);

  var $parseInt = global.parseInt;
  var Symbol = global.Symbol;
  var ITERATOR = Symbol && Symbol.iterator;
  var hex = /^[+-]?0x/i;
  var exec = uncurryThis(hex.exec);
  var FORCED = $parseInt(whitespaces + '08') !== 8 || $parseInt(whitespaces + '0x16') !== 22 // MS Edge 18- broken with boxed symbols
  || ITERATOR && !fails(function () {
    $parseInt(Object(ITERATOR));
  }); // `parseInt` method
  // https://tc39.es/ecma262/#sec-parseint-string-radix

  module.exports = FORCED ? function parseInt(string, radix) {
    var S = trim(toString(string));
    return $parseInt(S, radix >>> 0 || (exec(hex, S) ? 16 : 10));
  } : $parseInt;
  /***/
},
/* 223 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var DESCRIPTORS = __webpack_require__(12);

  var uncurryThis = __webpack_require__(3);

  var call = __webpack_require__(19);

  var fails = __webpack_require__(2);

  var objectKeys = __webpack_require__(98);

  var getOwnPropertySymbolsModule = __webpack_require__(159);

  var propertyIsEnumerableModule = __webpack_require__(121);

  var toObject = __webpack_require__(22);

  var IndexedObject = __webpack_require__(92); // eslint-disable-next-line es/no-object-assign -- safe


  var $assign = Object.assign; // eslint-disable-next-line es/no-object-defineproperty -- required for testing

  var defineProperty = Object.defineProperty;
  var concat = uncurryThis([].concat); // `Object.assign` method
  // https://tc39.es/ecma262/#sec-object.assign

  module.exports = !$assign || fails(function () {
    // should have correct order of operations (Edge bug)
    if (DESCRIPTORS && $assign({
      b: 1
    }, $assign(defineProperty({}, 'a', {
      enumerable: true,
      get: function get() {
        defineProperty(this, 'b', {
          value: 3,
          enumerable: false
        });
      }
    }), {
      b: 2
    })).b !== 1) return true; // should work with symbols and should have deterministic property order (V8 bug)

    var A = {};
    var B = {}; // eslint-disable-next-line es/no-symbol -- safe

    var symbol = Symbol();
    var alphabet = 'abcdefghijklmnopqrst';
    A[symbol] = 7;
    alphabet.split('').forEach(function (chr) {
      B[chr] = chr;
    });
    return $assign({}, A)[symbol] != 7 || objectKeys($assign({}, B)).join('') != alphabet;
  }) ? function assign(target, source) {
    // eslint-disable-line no-unused-vars -- required for `.length`
    var T = toObject(target);
    var argumentsLength = arguments.length;
    var index = 1;
    var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
    var propertyIsEnumerable = propertyIsEnumerableModule.f;

    while (argumentsLength > index) {
      var S = IndexedObject(arguments[index++]);
      var keys = getOwnPropertySymbols ? concat(objectKeys(S), getOwnPropertySymbols(S)) : objectKeys(S);
      var length = keys.length;
      var j = 0;
      var key;

      while (length > j) {
        key = keys[j++];
        if (!DESCRIPTORS || call(propertyIsEnumerable, S, key)) T[key] = S[key];
      }
    }

    return T;
  } : $assign;
  /***/
},
/* 224 */

/***/
function (module, exports, __webpack_require__) {
  var uncurryThis = __webpack_require__(3);

  var hasOwn = __webpack_require__(21);

  var toIndexedObject = __webpack_require__(37);

  var indexOf = __webpack_require__(84).indexOf;

  var hiddenKeys = __webpack_require__(91);

  var push = uncurryThis([].push);

  module.exports = function (object, names) {
    var O = toIndexedObject(object);
    var i = 0;
    var result = [];
    var key;

    for (key in O) {
      !hasOwn(hiddenKeys, key) && hasOwn(O, key) && push(result, key);
    } // Don't enum bug & hidden keys


    while (names.length > i) {
      if (hasOwn(O, key = names[i++])) {
        ~indexOf(result, key) || push(result, key);
      }
    }

    return result;
  };
  /***/

},
/* 225 */

/***/
function (module, exports, __webpack_require__) {
  var DESCRIPTORS = __webpack_require__(12);

  var uncurryThis = __webpack_require__(3);

  var objectKeys = __webpack_require__(98);

  var toIndexedObject = __webpack_require__(37);

  var $propertyIsEnumerable = __webpack_require__(121).f;

  var propertyIsEnumerable = uncurryThis($propertyIsEnumerable);
  var push = uncurryThis([].push); // `Object.{ entries, values }` methods implementation

  var createMethod = function createMethod(TO_ENTRIES) {
    return function (it) {
      var O = toIndexedObject(it);
      var keys = objectKeys(O);
      var length = keys.length;
      var i = 0;
      var result = [];
      var key;

      while (length > i) {
        key = keys[i++];

        if (!DESCRIPTORS || propertyIsEnumerable(O, key)) {
          push(result, TO_ENTRIES ? [key, O[key]] : O[key]);
        }
      }

      return result;
    };
  };

  module.exports = {
    // `Object.entries` method
    // https://tc39.es/ecma262/#sec-object.entries
    entries: createMethod(true),
    // `Object.values` method
    // https://tc39.es/ecma262/#sec-object.values
    values: createMethod(false)
  };
  /***/
},
/* 226 */

/***/
function (module, exports, __webpack_require__) {
  var global = __webpack_require__(1);

  var call = __webpack_require__(19);

  var isCallable = __webpack_require__(17);

  var isObject = __webpack_require__(13);

  var TypeError = global.TypeError; // `OrdinaryToPrimitive` abstract operation
  // https://tc39.es/ecma262/#sec-ordinarytoprimitive

  module.exports = function (input, pref) {
    var fn, val;
    if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
    if (isCallable(fn = input.valueOf) && !isObject(val = call(fn, input))) return val;
    if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
    throw TypeError("Can't convert object to primitive value");
  };
  /***/

},
/* 227 */

/***/
function (module, exports, __webpack_require__) {
  var global = __webpack_require__(1);

  module.exports = global;
  /***/
},
/* 228 */

/***/
function (module, exports, __webpack_require__) {
  var anObject = __webpack_require__(10);

  var isObject = __webpack_require__(13);

  var newPromiseCapability = __webpack_require__(119);

  module.exports = function (C, x) {
    anObject(C);
    if (isObject(x) && x.constructor === C) return x;
    var promiseCapability = newPromiseCapability.f(C);
    var resolve = promiseCapability.resolve;
    resolve(x);
    return promiseCapability.promise;
  };
  /***/

},
/* 229 */

/***/
function (module, exports, __webpack_require__) {
  var fails = __webpack_require__(2);

  var global = __webpack_require__(1); // babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError


  var $RegExp = global.RegExp;
  module.exports = fails(function () {
    var re = $RegExp('(?<a>b)', 'g');
    return re.exec('b').groups.a !== 'b' || 'b'.replace(re, '$<a>c') !== 'bc';
  });
  /***/
},
/* 230 */

/***/
function (module, exports) {
  // `SameValue` abstract operation
  // https://tc39.es/ecma262/#sec-samevalue
  // eslint-disable-next-line es/no-object-is -- safe
  module.exports = Object.is || function is(x, y) {
    // eslint-disable-next-line no-self-compare -- NaN check
    return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
  };
  /***/

},
/* 231 */

/***/
function (module, exports, __webpack_require__) {
  // https://github.com/zloirock/core-js/issues/280
  var userAgent = __webpack_require__(57);

  module.exports = /Version\/10(?:\.\d+){1,2}(?: [\w./]+)?(?: Mobile\/\w+)? Safari\//.test(userAgent);
  /***/
},
/* 232 */

/***/
function (module, exports, __webpack_require__) {
  var global = __webpack_require__(1);

  var toIntegerOrInfinity = __webpack_require__(29);

  var toLength = __webpack_require__(44);

  var RangeError = global.RangeError; // `ToIndex` abstract operation
  // https://tc39.es/ecma262/#sec-toindex

  module.exports = function (it) {
    if (it === undefined) return 0;
    var number = toIntegerOrInfinity(it);
    var length = toLength(number);
    if (number !== length) throw RangeError('Wrong length or index');
    return length;
  };
  /***/

},
/* 233 */

/***/
function (module, exports, __webpack_require__) {
  var global = __webpack_require__(1);

  var toPositiveInteger = __webpack_require__(358);

  var RangeError = global.RangeError;

  module.exports = function (it, BYTES) {
    var offset = toPositiveInteger(it);
    if (offset % BYTES) throw RangeError('Wrong offset');
    return offset;
  };
  /***/

},
/* 234 */

/***/
function (module, exports, __webpack_require__) {
  var bind = __webpack_require__(51);

  var call = __webpack_require__(19);

  var aConstructor = __webpack_require__(141);

  var toObject = __webpack_require__(22);

  var lengthOfArrayLike = __webpack_require__(23);

  var getIterator = __webpack_require__(116);

  var getIteratorMethod = __webpack_require__(90);

  var isArrayIteratorMethod = __webpack_require__(153);

  var aTypedArrayConstructor = __webpack_require__(16).aTypedArrayConstructor;

  module.exports = function from(source
  /* , mapfn, thisArg */
  ) {
    var C = aConstructor(this);
    var O = toObject(source);
    var argumentsLength = arguments.length;
    var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iteratorMethod = getIteratorMethod(O);
    var i, length, result, step, iterator, next;

    if (iteratorMethod && !isArrayIteratorMethod(iteratorMethod)) {
      iterator = getIterator(O, iteratorMethod);
      next = iterator.next;
      O = [];

      while (!(step = call(next, iterator)).done) {
        O.push(step.value);
      }
    }

    if (mapping && argumentsLength > 2) {
      mapfn = bind(mapfn, arguments[2]);
    }

    length = lengthOfArrayLike(O);
    result = new (aTypedArrayConstructor(C))(length);

    for (i = 0; length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }

    return result;
  };
  /***/

},
/* 235 */

/***/
function (module, exports, __webpack_require__) {
  /* eslint-disable es/no-symbol -- required for testing */
  var NATIVE_SYMBOL = __webpack_require__(156);

  module.exports = NATIVE_SYMBOL && !Symbol.sham && typeof Symbol.iterator == 'symbol';
  /***/
},
/* 236 */

/***/
function (module, exports, __webpack_require__) {
  var DESCRIPTORS = __webpack_require__(12);

  var fails = __webpack_require__(2); // V8 ~ Chrome 36-
  // https://bugs.chromium.org/p/v8/issues/detail?id=3334


  module.exports = DESCRIPTORS && fails(function () {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty(function () {
      /* empty */
    }, 'prototype', {
      value: 42,
      writable: false
    }).prototype != 42;
  });
  /***/
},
/* 237 */

/***/
function (module, exports, __webpack_require__) {
  var global = __webpack_require__(1);

  var TypeError = global.TypeError;

  module.exports = function (passed, required) {
    if (passed < required) throw TypeError('Not enough arguments');
    return passed;
  };
  /***/

},
/* 238 */

/***/
function (module, exports, __webpack_require__) {
  var wellKnownSymbol = __webpack_require__(15);

  exports.f = wellKnownSymbol;
  /***/
},
/* 239 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var getBuiltIn = __webpack_require__(26);

  var hasOwn = __webpack_require__(21);

  var createNonEnumerableProperty = __webpack_require__(35);

  var isPrototypeOf = __webpack_require__(42);

  var setPrototypeOf = __webpack_require__(52);

  var copyConstructorProperties = __webpack_require__(113);

  var inheritIfRequired = __webpack_require__(75);

  var normalizeStringArgument = __webpack_require__(96);

  var installErrorCause = __webpack_require__(211);

  var clearErrorStack = __webpack_require__(111);

  var ERROR_STACK_INSTALLABLE = __webpack_require__(152);

  var IS_PURE = __webpack_require__(31);

  module.exports = function (FULL_NAME, wrapper, FORCED, IS_AGGREGATE_ERROR) {
    var OPTIONS_POSITION = IS_AGGREGATE_ERROR ? 2 : 1;
    var path = FULL_NAME.split('.');
    var ERROR_NAME = path[path.length - 1];
    var OriginalError = getBuiltIn.apply(null, path);
    if (!OriginalError) return;
    var OriginalErrorPrototype = OriginalError.prototype; // V8 9.3- bug https://bugs.chromium.org/p/v8/issues/detail?id=12006

    if (!IS_PURE && hasOwn(OriginalErrorPrototype, 'cause')) delete OriginalErrorPrototype.cause;
    if (!FORCED) return OriginalError;
    var BaseError = getBuiltIn('Error');
    var WrappedError = wrapper(function (a, b) {
      var message = normalizeStringArgument(IS_AGGREGATE_ERROR ? b : a, undefined);
      var result = IS_AGGREGATE_ERROR ? new OriginalError(a) : new OriginalError();
      if (message !== undefined) createNonEnumerableProperty(result, 'message', message);
      if (ERROR_STACK_INSTALLABLE) createNonEnumerableProperty(result, 'stack', clearErrorStack(result.stack, 2));
      if (this && isPrototypeOf(OriginalErrorPrototype, this)) inheritIfRequired(result, this, WrappedError);
      if (arguments.length > OPTIONS_POSITION) installErrorCause(result, arguments[OPTIONS_POSITION]);
      return result;
    });
    WrappedError.prototype = OriginalErrorPrototype;

    if (ERROR_NAME !== 'Error') {
      if (setPrototypeOf) setPrototypeOf(WrappedError, BaseError);else copyConstructorProperties(WrappedError, BaseError, {
        name: true
      });
    }

    copyConstructorProperties(WrappedError, OriginalError);
    if (!IS_PURE) try {
      // Safari 13- bug: WebAssembly errors does not have a proper `.name`
      if (OriginalErrorPrototype.name !== ERROR_NAME) {
        createNonEnumerableProperty(OriginalErrorPrototype, 'name', ERROR_NAME);
      }

      OriginalErrorPrototype.constructor = WrappedError;
    } catch (error) {
      /* empty */
    }
    return WrappedError;
  };
  /***/

},
/* 240 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var charAt = __webpack_require__(127).charAt;

  var toString = __webpack_require__(18);

  var InternalStateModule = __webpack_require__(27);

  var defineIterator = __webpack_require__(149);

  var STRING_ITERATOR = 'String Iterator';
  var setInternalState = InternalStateModule.set;
  var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR); // `String.prototype[@@iterator]` method
  // https://tc39.es/ecma262/#sec-string.prototype-@@iterator

  defineIterator(String, 'String', function (iterated) {
    setInternalState(this, {
      type: STRING_ITERATOR,
      string: toString(iterated),
      index: 0
    }); // `%StringIteratorPrototype%.next` method
    // https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
  }, function next() {
    var state = getInternalState(this);
    var string = state.string;
    var index = state.index;
    var point;
    if (index >= string.length) return {
      value: undefined,
      done: true
    };
    point = charAt(string, index);
    state.index += point.length;
    return {
      value: point,
      done: false
    };
  });
  /***/
},
/* 241 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`

  __webpack_require__(132);

  var $ = __webpack_require__(0);

  var global = __webpack_require__(1);

  var getBuiltIn = __webpack_require__(26);

  var call = __webpack_require__(19);

  var uncurryThis = __webpack_require__(3);

  var USE_NATIVE_URL = __webpack_require__(219);

  var redefine = __webpack_require__(24);

  var redefineAll = __webpack_require__(78);

  var setToStringTag = __webpack_require__(49);

  var createIteratorConstructor = __webpack_require__(148);

  var InternalStateModule = __webpack_require__(27);

  var anInstance = __webpack_require__(50);

  var isCallable = __webpack_require__(17);

  var hasOwn = __webpack_require__(21);

  var bind = __webpack_require__(51);

  var classof = __webpack_require__(63);

  var anObject = __webpack_require__(10);

  var isObject = __webpack_require__(13);

  var $toString = __webpack_require__(18);

  var create = __webpack_require__(41);

  var createPropertyDescriptor = __webpack_require__(47);

  var getIterator = __webpack_require__(116);

  var getIteratorMethod = __webpack_require__(90);

  var validateArgumentsLength = __webpack_require__(237);

  var wellKnownSymbol = __webpack_require__(15);

  var arraySort = __webpack_require__(145);

  var ITERATOR = wellKnownSymbol('iterator');
  var URL_SEARCH_PARAMS = 'URLSearchParams';
  var URL_SEARCH_PARAMS_ITERATOR = URL_SEARCH_PARAMS + 'Iterator';
  var setInternalState = InternalStateModule.set;
  var getInternalParamsState = InternalStateModule.getterFor(URL_SEARCH_PARAMS);
  var getInternalIteratorState = InternalStateModule.getterFor(URL_SEARCH_PARAMS_ITERATOR);
  var n$Fetch = getBuiltIn('fetch');
  var N$Request = getBuiltIn('Request');
  var Headers = getBuiltIn('Headers');
  var RequestPrototype = N$Request && N$Request.prototype;
  var HeadersPrototype = Headers && Headers.prototype;
  var RegExp = global.RegExp;
  var TypeError = global.TypeError;
  var decodeURIComponent = global.decodeURIComponent;
  var encodeURIComponent = global.encodeURIComponent;
  var charAt = uncurryThis(''.charAt);
  var join = uncurryThis([].join);
  var push = uncurryThis([].push);
  var replace = uncurryThis(''.replace);
  var shift = uncurryThis([].shift);
  var splice = uncurryThis([].splice);
  var split = uncurryThis(''.split);
  var stringSlice = uncurryThis(''.slice);
  var plus = /\+/g;
  var sequences = Array(4);

  var percentSequence = function percentSequence(bytes) {
    return sequences[bytes - 1] || (sequences[bytes - 1] = RegExp('((?:%[\\da-f]{2}){' + bytes + '})', 'gi'));
  };

  var percentDecode = function percentDecode(sequence) {
    try {
      return decodeURIComponent(sequence);
    } catch (error) {
      return sequence;
    }
  };

  var deserialize = function deserialize(it) {
    var result = replace(it, plus, ' ');
    var bytes = 4;

    try {
      return decodeURIComponent(result);
    } catch (error) {
      while (bytes) {
        result = replace(result, percentSequence(bytes--), percentDecode);
      }

      return result;
    }
  };

  var find = /[!'()~]|%20/g;
  var replacements = {
    '!': '%21',
    "'": '%27',
    '(': '%28',
    ')': '%29',
    '~': '%7E',
    '%20': '+'
  };

  var replacer = function replacer(match) {
    return replacements[match];
  };

  var _serialize = function serialize(it) {
    return replace(encodeURIComponent(it), find, replacer);
  };

  var URLSearchParamsIterator = createIteratorConstructor(function Iterator(params, kind) {
    setInternalState(this, {
      type: URL_SEARCH_PARAMS_ITERATOR,
      iterator: getIterator(getInternalParamsState(params).entries),
      kind: kind
    });
  }, 'Iterator', function next() {
    var state = getInternalIteratorState(this);
    var kind = state.kind;
    var step = state.iterator.next();
    var entry = step.value;

    if (!step.done) {
      step.value = kind === 'keys' ? entry.key : kind === 'values' ? entry.value : [entry.key, entry.value];
    }

    return step;
  }, true);

  var URLSearchParamsState = function URLSearchParamsState(init) {
    this.entries = [];
    this.url = null;

    if (init !== undefined) {
      if (isObject(init)) this.parseObject(init);else this.parseQuery(typeof init == 'string' ? charAt(init, 0) === '?' ? stringSlice(init, 1) : init : $toString(init));
    }
  };

  URLSearchParamsState.prototype = {
    type: URL_SEARCH_PARAMS,
    bindURL: function bindURL(url) {
      this.url = url;
      this.update();
    },
    parseObject: function parseObject(object) {
      var iteratorMethod = getIteratorMethod(object);
      var iterator, next, step, entryIterator, entryNext, first, second;

      if (iteratorMethod) {
        iterator = getIterator(object, iteratorMethod);
        next = iterator.next;

        while (!(step = call(next, iterator)).done) {
          entryIterator = getIterator(anObject(step.value));
          entryNext = entryIterator.next;
          if ((first = call(entryNext, entryIterator)).done || (second = call(entryNext, entryIterator)).done || !call(entryNext, entryIterator).done) throw TypeError('Expected sequence with length 2');
          push(this.entries, {
            key: $toString(first.value),
            value: $toString(second.value)
          });
        }
      } else for (var key in object) {
        if (hasOwn(object, key)) {
          push(this.entries, {
            key: key,
            value: $toString(object[key])
          });
        }
      }
    },
    parseQuery: function parseQuery(query) {
      if (query) {
        var attributes = split(query, '&');
        var index = 0;
        var attribute, entry;

        while (index < attributes.length) {
          attribute = attributes[index++];

          if (attribute.length) {
            entry = split(attribute, '=');
            push(this.entries, {
              key: deserialize(shift(entry)),
              value: deserialize(join(entry, '='))
            });
          }
        }
      }
    },
    serialize: function serialize() {
      var entries = this.entries;
      var result = [];
      var index = 0;
      var entry;

      while (index < entries.length) {
        entry = entries[index++];
        push(result, _serialize(entry.key) + '=' + _serialize(entry.value));
      }

      return join(result, '&');
    },
    update: function update() {
      this.entries.length = 0;
      this.parseQuery(this.url.query);
    },
    updateURL: function updateURL() {
      if (this.url) this.url.update();
    }
  }; // `URLSearchParams` constructor
  // https://url.spec.whatwg.org/#interface-urlsearchparams

  var URLSearchParamsConstructor = function
    /* init */
  URLSearchParams() {
    anInstance(this, URLSearchParamsPrototype);
    var init = arguments.length > 0 ? arguments[0] : undefined;
    setInternalState(this, new URLSearchParamsState(init));
  };

  var URLSearchParamsPrototype = URLSearchParamsConstructor.prototype;
  redefineAll(URLSearchParamsPrototype, {
    // `URLSearchParams.prototype.append` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-append
    append: function append(name, value) {
      validateArgumentsLength(arguments.length, 2);
      var state = getInternalParamsState(this);
      push(state.entries, {
        key: $toString(name),
        value: $toString(value)
      });
      state.updateURL();
    },
    // `URLSearchParams.prototype.delete` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-delete
    'delete': function _delete(name) {
      validateArgumentsLength(arguments.length, 1);
      var state = getInternalParamsState(this);
      var entries = state.entries;
      var key = $toString(name);
      var index = 0;

      while (index < entries.length) {
        if (entries[index].key === key) splice(entries, index, 1);else index++;
      }

      state.updateURL();
    },
    // `URLSearchParams.prototype.get` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-get
    get: function get(name) {
      validateArgumentsLength(arguments.length, 1);
      var entries = getInternalParamsState(this).entries;
      var key = $toString(name);
      var index = 0;

      for (; index < entries.length; index++) {
        if (entries[index].key === key) return entries[index].value;
      }

      return null;
    },
    // `URLSearchParams.prototype.getAll` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-getall
    getAll: function getAll(name) {
      validateArgumentsLength(arguments.length, 1);
      var entries = getInternalParamsState(this).entries;
      var key = $toString(name);
      var result = [];
      var index = 0;

      for (; index < entries.length; index++) {
        if (entries[index].key === key) push(result, entries[index].value);
      }

      return result;
    },
    // `URLSearchParams.prototype.has` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-has
    has: function has(name) {
      validateArgumentsLength(arguments.length, 1);
      var entries = getInternalParamsState(this).entries;
      var key = $toString(name);
      var index = 0;

      while (index < entries.length) {
        if (entries[index++].key === key) return true;
      }

      return false;
    },
    // `URLSearchParams.prototype.set` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-set
    set: function set(name, value) {
      validateArgumentsLength(arguments.length, 1);
      var state = getInternalParamsState(this);
      var entries = state.entries;
      var found = false;
      var key = $toString(name);
      var val = $toString(value);
      var index = 0;
      var entry;

      for (; index < entries.length; index++) {
        entry = entries[index];

        if (entry.key === key) {
          if (found) splice(entries, index--, 1);else {
            found = true;
            entry.value = val;
          }
        }
      }

      if (!found) push(entries, {
        key: key,
        value: val
      });
      state.updateURL();
    },
    // `URLSearchParams.prototype.sort` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-sort
    sort: function sort() {
      var state = getInternalParamsState(this);
      arraySort(state.entries, function (a, b) {
        return a.key > b.key ? 1 : -1;
      });
      state.updateURL();
    },
    // `URLSearchParams.prototype.forEach` method
    forEach: function forEach(callback
    /* , thisArg */
    ) {
      var entries = getInternalParamsState(this).entries;
      var boundFunction = bind(callback, arguments.length > 1 ? arguments[1] : undefined);
      var index = 0;
      var entry;

      while (index < entries.length) {
        entry = entries[index++];
        boundFunction(entry.value, entry.key, this);
      }
    },
    // `URLSearchParams.prototype.keys` method
    keys: function keys() {
      return new URLSearchParamsIterator(this, 'keys');
    },
    // `URLSearchParams.prototype.values` method
    values: function values() {
      return new URLSearchParamsIterator(this, 'values');
    },
    // `URLSearchParams.prototype.entries` method
    entries: function entries() {
      return new URLSearchParamsIterator(this, 'entries');
    }
  }, {
    enumerable: true
  }); // `URLSearchParams.prototype[@@iterator]` method

  redefine(URLSearchParamsPrototype, ITERATOR, URLSearchParamsPrototype.entries, {
    name: 'entries'
  }); // `URLSearchParams.prototype.toString` method
  // https://url.spec.whatwg.org/#urlsearchparams-stringification-behavior

  redefine(URLSearchParamsPrototype, 'toString', function toString() {
    return getInternalParamsState(this).serialize();
  }, {
    enumerable: true
  });
  setToStringTag(URLSearchParamsConstructor, URL_SEARCH_PARAMS);
  $({
    global: true,
    forced: !USE_NATIVE_URL
  }, {
    URLSearchParams: URLSearchParamsConstructor
  }); // Wrap `fetch` and `Request` for correct work with polyfilled `URLSearchParams`

  if (!USE_NATIVE_URL && isCallable(Headers)) {
    var headersHas = uncurryThis(HeadersPrototype.has);
    var headersSet = uncurryThis(HeadersPrototype.set);

    var wrapRequestOptions = function wrapRequestOptions(init) {
      if (isObject(init)) {
        var body = init.body;
        var headers;

        if (classof(body) === URL_SEARCH_PARAMS) {
          headers = init.headers ? new Headers(init.headers) : new Headers();

          if (!headersHas(headers, 'content-type')) {
            headersSet(headers, 'content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
          }

          return create(init, {
            body: createPropertyDescriptor(0, $toString(body)),
            headers: createPropertyDescriptor(0, headers)
          });
        }
      }

      return init;
    };

    if (isCallable(n$Fetch)) {
      $({
        global: true,
        enumerable: true,
        forced: true
      }, {
        fetch: function fetch(input
        /* , init */
        ) {
          return n$Fetch(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
        }
      });
    }

    if (isCallable(N$Request)) {
      var RequestConstructor = function Request(input
      /* , init */
      ) {
        anInstance(this, RequestPrototype);
        return new N$Request(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
      };

      RequestPrototype.constructor = RequestConstructor;
      RequestConstructor.prototype = RequestPrototype;
      $({
        global: true,
        forced: true
      }, {
        Request: RequestConstructor
      });
    }
  }

  module.exports = {
    URLSearchParams: URLSearchParamsConstructor,
    getState: getInternalParamsState
  };
  /***/
},
/* 242 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (process) {
    /**
    * Copyright (c) 2013-present, Facebook, Inc.
    *
    * This source code is licensed under the MIT license found in the
    * LICENSE file in the root directory of this source tree.
    */

    /**
     * Use invariant() to assert state which your program assumes to be true.
     *
     * Provide sprintf-style format (only %s is supported) and arguments
     * to provide information about what broke and what you were
     * expecting.
     *
     * The invariant message will be stripped in production, but the invariant
     * will remain to ensure logic does not differ in production.
     */
    var invariant = function invariant(condition, format, a, b, c, d, e, f) {
      if (process.env.NODE_ENV !== 'production') {
        if (format === undefined) {
          throw new Error('invariant requires an error message argument');
        }
      }

      if (!condition) {
        var error;

        if (format === undefined) {
          error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
        } else {
          var args = [a, b, c, d, e, f];
          var argIndex = 0;
          error = new Error(format.replace(/%s/g, function () {
            return args[argIndex++];
          }));
          error.name = 'Invariant Violation';
        }

        error.framesToPop = 1; // we don't care about invariant's own frame

        throw error;
      }
    };

    module.exports = invariant;
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(25));
  /***/
},
/* 243 */

/***/
function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */
  (function (process) {
    /**
    * Copyright (c) 2013-present, Facebook, Inc.
    *
    * This source code is licensed under the MIT license found in the
    * LICENSE file in the root directory of this source tree.
    */
    if (process.env.NODE_ENV !== 'production') {
      var ReactIs = __webpack_require__(245); // By explicitly using `prop-types` you are opting into new development behavior.
      // http://fb.me/prop-types-in-prod


      var throwOnDirectAccess = true;
      module.exports = __webpack_require__(597)(ReactIs.isElement, throwOnDirectAccess);
    } else {
      // By explicitly using `prop-types` you are opting into new production behavior.
      // http://fb.me/prop-types-in-prod
      module.exports = __webpack_require__(596)();
    }
    /* WEBPACK VAR INJECTION */

  }).call(exports, __webpack_require__(25));
  /***/
},
/* 244 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (process) {
    function checkDCE() {
      /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') {
        return;
      }

      if (process.env.NODE_ENV !== 'production') {
        // This branch is unreachable because this function is only called
        // in production, but the condition is true only in development.
        // Therefore if the branch is still here, dead code elimination wasn't
        // properly applied.
        // Don't change the message. React DevTools relies on it. Also make sure
        // this message doesn't occur elsewhere in this function, or it will cause
        // a false positive.
        throw new Error('^_^');
      }

      try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
      } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
      }
    }

    if (process.env.NODE_ENV === 'production') {
      // DCE check should happen before ReactDOM bundle executes so that
      // DevTools can report bad minification during injection.
      checkDCE();
      module.exports = __webpack_require__(599);
    } else {
      module.exports = __webpack_require__(598);
    }
    /* WEBPACK VAR INJECTION */

  }).call(exports, __webpack_require__(25));
  /***/
},
/* 245 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (process) {
    if (process.env.NODE_ENV === 'production') {
      module.exports = __webpack_require__(604);
    } else {
      module.exports = __webpack_require__(603);
    }
    /* WEBPACK VAR INJECTION */

  }).call(exports, __webpack_require__(25));
  /***/
},
/* 246 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (process) {
    if (process.env.NODE_ENV === 'production') {
      module.exports = __webpack_require__(608);
    } else {
      module.exports = __webpack_require__(607);
    }
    /* WEBPACK VAR INJECTION */

  }).call(exports, __webpack_require__(25));
  /***/
},
/* 247 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (process) {
    /**
    * Copyright (c) 2014-present, Facebook, Inc.
    *
    * This source code is licensed under the MIT license found in the
    * LICENSE file in the root directory of this source tree.
    */

    /**
     * Similar to invariant but only logs a warning if the condition is not met.
     * This can be used to log issues in development environments in critical
     * paths. Removing the logging code for production environments will keep the
     * same logic and follow the same code paths.
     */
    var __DEV__ = process.env.NODE_ENV !== 'production';

    var warning = function warning() {};

    if (__DEV__) {
      var printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);

        for (var key = 1; key < len; key++) {
          args[key - 1] = arguments[key];
        }

        var argIndex = 0;
        var message = 'Warning: ' + format.replace(/%s/g, function () {
          return args[argIndex++];
        });

        if (typeof console !== 'undefined') {
          console.error(message);
        }

        try {
          // --- Welcome to debugging React ---
          // This error was thrown as a convenience so that you can use this stack
          // to find the callsite that caused this warning to fire.
          throw new Error(message);
        } catch (x) {}
      };

      warning = function warning(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);

        for (var key = 2; key < len; key++) {
          args[key - 2] = arguments[key];
        }

        if (format === undefined) {
          throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
        }

        if (!condition) {
          printWarning.apply(null, [format].concat(args));
        }
      };
    }

    module.exports = warning;
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(25));
  /***/
},
/* 248 */

/***/
function (module, exports) {
  module.exports = require("@emotion/react");
  /***/
},
/* 249 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__alert__ = __webpack_require__(285);
  /* harmony default export */


  __webpack_exports__["a"] = __WEBPACK_IMPORTED_MODULE_0__alert__["a"
  /* Alert */
  ];
  /***/
},
/* 250 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__auto_complete_input__ = __webpack_require__(286);
  /* harmony default export */


  __webpack_exports__["a"] = __WEBPACK_IMPORTED_MODULE_0__auto_complete_input__["a"
  /* AutoCompleteInput */
  ];
  /***/
},
/* 251 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__breadcrumbs__ = __webpack_require__(287);
  /* harmony default export */


  __webpack_exports__["a"] = __WEBPACK_IMPORTED_MODULE_0__breadcrumbs__["a"
  /* Breadcrumbs */
  ];
  /***/
},
/* 252 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__collapsible__ = __webpack_require__(292);
  /* harmony default export */


  __webpack_exports__["a"] = __WEBPACK_IMPORTED_MODULE_0__collapsible__["a"
  /* Collapsible */
  ];
  /***/
},
/* 253 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__credit_card_number_input__ = __webpack_require__(294);
  /* harmony default export */


  __webpack_exports__["a"] = __WEBPACK_IMPORTED_MODULE_0__credit_card_number_input__["a"
  /* CreditCardNumberInput */
  ];
  /***/
},
/* 254 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__cvv_input__ = __webpack_require__(295);
  /* harmony default export */


  __webpack_exports__["a"] = __WEBPACK_IMPORTED_MODULE_0__cvv_input__["a"
  /* CvvInput */
  ];
  /***/
},
/* 255 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__date_input_standard__ = __webpack_require__(185);
  /* harmony default export */


  __webpack_exports__["a"] = __WEBPACK_IMPORTED_MODULE_0__date_input_standard__["d"
  /* DateInputStandard */
  ];
  /***/
},
/* 256 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__date_input__ = __webpack_require__(296);
  /* harmony default export */


  __webpack_exports__["a"] = __WEBPACK_IMPORTED_MODULE_0__date_input__["a"
  /* DateInput */
  ];
  /***/
},
/* 257 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__dropdown__ = __webpack_require__(297);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__use_dropdown_action__ = __webpack_require__(298);
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "a", function () {
    return __WEBPACK_IMPORTED_MODULE_0__dropdown__["a"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "b", function () {
    return __WEBPACK_IMPORTED_MODULE_1__use_dropdown_action__["a"];
  });
  /***/

},
/* 258 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__email_input__ = __webpack_require__(299);
  /* harmony default export */


  __webpack_exports__["a"] = __WEBPACK_IMPORTED_MODULE_0__email_input__["a"
  /* EmailInput */
  ];
  /***/
},
/* 259 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__form_field__ = __webpack_require__(300);
  /* harmony default export */


  __webpack_exports__["a"] = __WEBPACK_IMPORTED_MODULE_0__form_field__["a"
  /* FormField */
  ];
  /***/
},
/* 260 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__form_stepper__ = __webpack_require__(301);
  /* harmony namespace reexport (by used) */


  __webpack_require__.d(__webpack_exports__, "a", function () {
    return __WEBPACK_IMPORTED_MODULE_0__form_stepper__["a"];
  });
  /* harmony namespace reexport (by used) */


  __webpack_require__.d(__webpack_exports__, "b", function () {
    return __WEBPACK_IMPORTED_MODULE_0__form_stepper__["b"];
  });
  /***/

},
/* 261 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__link__ = __webpack_require__(310);
  /* harmony default export */


  __webpack_exports__["a"] = __WEBPACK_IMPORTED_MODULE_0__link__["a"
  /* Link */
  ];
  /***/
},
/* 262 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__list__ = __webpack_require__(311);
  /* harmony namespace reexport (by used) */


  __webpack_require__.d(__webpack_exports__, "a", function () {
    return __WEBPACK_IMPORTED_MODULE_0__list__["a"];
  });
  /* harmony namespace reexport (by used) */


  __webpack_require__.d(__webpack_exports__, "b", function () {
    return __WEBPACK_IMPORTED_MODULE_0__list__["b"];
  });
  /***/

},
/* 263 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__modal__ = __webpack_require__(312);
  /* harmony default export */


  __webpack_exports__["a"] = __WEBPACK_IMPORTED_MODULE_0__modal__["a"
  /* Modal */
  ];
  /***/
},
/* 264 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__password_input__ = __webpack_require__(314);
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "a", function () {
    return __WEBPACK_IMPORTED_MODULE_0__password_input__["a"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "b", function () {
    return __WEBPACK_IMPORTED_MODULE_0__password_input__["b"];
  });
  /***/

},
/* 265 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__phone_number_input__ = __webpack_require__(315);
  /* harmony default export */


  __webpack_exports__["a"] = __WEBPACK_IMPORTED_MODULE_0__phone_number_input__["a"
  /* PhoneNumberInput */
  ];
  /***/
},
/* 266 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__postcode_input__ = __webpack_require__(316);
  /* harmony default export */


  __webpack_exports__["a"] = __WEBPACK_IMPORTED_MODULE_0__postcode_input__["a"
  /* PostcodeInput */
  ];
  /***/
},
/* 267 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__progress_bar__ = __webpack_require__(317);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__use_progress__ = __webpack_require__(318);
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "a", function () {
    return __WEBPACK_IMPORTED_MODULE_0__progress_bar__["a"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "b", function () {
    return __WEBPACK_IMPORTED_MODULE_1__use_progress__["a"];
  });
  /***/

},
/* 268 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__radio_group__ = __webpack_require__(138);
  /* harmony namespace reexport (by used) */


  __webpack_require__.d(__webpack_exports__, "b", function () {
    return __WEBPACK_IMPORTED_MODULE_0__radio_group__["a"];
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__radio__ = __webpack_require__(321);
  /* harmony namespace reexport (by used) */


  __webpack_require__.d(__webpack_exports__, "a", function () {
    return __WEBPACK_IMPORTED_MODULE_1__radio__["a"];
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__radio_button_group__ = __webpack_require__(320);
  /* harmony namespace reexport (by used) */


  __webpack_require__.d(__webpack_exports__, "c", function () {
    return __WEBPACK_IMPORTED_MODULE_2__radio_button_group__["a"];
  });
  /***/

},
/* 269 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__recaptcha__ = __webpack_require__(322);
  /* harmony default export */


  __webpack_exports__["a"] = __WEBPACK_IMPORTED_MODULE_0__recaptcha__["a"
  /* ReCaptcha */
  ];
  /***/
},
/* 270 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__select__ = __webpack_require__(323);
  /* harmony default export */


  __webpack_exports__["a"] = __WEBPACK_IMPORTED_MODULE_0__select__["a"
  /* Select */
  ];
  /***/
},
/* 271 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__switch__ = __webpack_require__(325);
  /* harmony default export */


  __webpack_exports__["a"] = __WEBPACK_IMPORTED_MODULE_0__switch__["a"
  /* Switch */
  ];
  /***/
},
/* 272 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__table__ = __webpack_require__(326);
  /* harmony default export */


  __webpack_exports__["a"] = __WEBPACK_IMPORTED_MODULE_0__table__["a"
  /* Table */
  ];
  /***/
},
/* 273 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__tabs__ = __webpack_require__(327);
  /* harmony namespace reexport (by used) */


  __webpack_require__.d(__webpack_exports__, "a", function () {
    return __WEBPACK_IMPORTED_MODULE_0__tabs__["a"];
  });
  /* harmony namespace reexport (by used) */


  __webpack_require__.d(__webpack_exports__, "b", function () {
    return __WEBPACK_IMPORTED_MODULE_0__tabs__["b"];
  });
  /***/

},
/* 274 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__text_area__ = __webpack_require__(328);
  /* harmony default export */


  __webpack_exports__["a"] = __WEBPACK_IMPORTED_MODULE_0__text_area__["a"
  /* TextArea */
  ];
  /***/
},
/* 275 */

/***/
function (module, exports, __webpack_require__) {
  __webpack_require__(536);

  __webpack_require__(532);

  __webpack_require__(531);

  __webpack_require__(533);

  __webpack_require__(534);

  __webpack_require__(535);

  __webpack_require__(538);

  __webpack_require__(537);

  __webpack_require__(539);

  __webpack_require__(540);

  __webpack_require__(541);

  __webpack_require__(542);

  __webpack_require__(543);

  __webpack_require__(544);

  __webpack_require__(545);

  __webpack_require__(404);

  __webpack_require__(405);

  __webpack_require__(362);

  __webpack_require__(361);

  __webpack_require__(366);

  __webpack_require__(367);

  __webpack_require__(368);

  __webpack_require__(369);

  __webpack_require__(370);

  __webpack_require__(371);

  __webpack_require__(373);

  __webpack_require__(372);

  __webpack_require__(375);

  __webpack_require__(374);

  __webpack_require__(376);

  __webpack_require__(377);

  __webpack_require__(378);

  __webpack_require__(379);

  __webpack_require__(380);

  __webpack_require__(132);

  __webpack_require__(381);

  __webpack_require__(382);

  __webpack_require__(383);

  __webpack_require__(384);

  __webpack_require__(386);

  __webpack_require__(385);

  __webpack_require__(387);

  __webpack_require__(388);

  __webpack_require__(389);

  __webpack_require__(390);

  __webpack_require__(391);

  __webpack_require__(392);

  __webpack_require__(394);

  __webpack_require__(393);

  __webpack_require__(363);

  __webpack_require__(364);

  __webpack_require__(365);

  __webpack_require__(395);

  __webpack_require__(396);

  __webpack_require__(397);

  __webpack_require__(398);

  __webpack_require__(399);

  __webpack_require__(400);

  __webpack_require__(401);

  __webpack_require__(402);

  __webpack_require__(403);

  __webpack_require__(406);

  __webpack_require__(407);

  __webpack_require__(408);

  __webpack_require__(409);

  __webpack_require__(410);

  __webpack_require__(411);

  __webpack_require__(412);

  __webpack_require__(413);

  __webpack_require__(414);

  __webpack_require__(415);

  __webpack_require__(416);

  __webpack_require__(417);

  __webpack_require__(418);

  __webpack_require__(419);

  __webpack_require__(420);

  __webpack_require__(421);

  __webpack_require__(422);

  __webpack_require__(423);

  __webpack_require__(424);

  __webpack_require__(425);

  __webpack_require__(426);

  __webpack_require__(427);

  __webpack_require__(428);

  __webpack_require__(429);

  __webpack_require__(430);

  __webpack_require__(431);

  __webpack_require__(432);

  __webpack_require__(433);

  __webpack_require__(434);

  __webpack_require__(435);

  __webpack_require__(436);

  __webpack_require__(437);

  __webpack_require__(438);

  __webpack_require__(439);

  __webpack_require__(440);

  __webpack_require__(441);

  __webpack_require__(442);

  __webpack_require__(443);

  __webpack_require__(444);

  __webpack_require__(445);

  __webpack_require__(446);

  __webpack_require__(447);

  __webpack_require__(448);

  __webpack_require__(449);

  __webpack_require__(450);

  __webpack_require__(451);

  __webpack_require__(452);

  __webpack_require__(453);

  __webpack_require__(454);

  __webpack_require__(455);

  __webpack_require__(456);

  __webpack_require__(457);

  __webpack_require__(458);

  __webpack_require__(462);

  __webpack_require__(459);

  __webpack_require__(460);

  __webpack_require__(461);

  __webpack_require__(463);

  __webpack_require__(464);

  __webpack_require__(465);

  __webpack_require__(466);

  __webpack_require__(467);

  __webpack_require__(468);

  __webpack_require__(469);

  __webpack_require__(470);

  __webpack_require__(471);

  __webpack_require__(472);

  __webpack_require__(476);

  __webpack_require__(473);

  __webpack_require__(474);

  __webpack_require__(475);

  __webpack_require__(477);

  __webpack_require__(478);

  __webpack_require__(479);

  __webpack_require__(480);

  __webpack_require__(483);

  __webpack_require__(481);

  __webpack_require__(482);

  __webpack_require__(484);

  __webpack_require__(485);

  __webpack_require__(486);

  __webpack_require__(487);

  __webpack_require__(489);

  __webpack_require__(488);

  __webpack_require__(490);

  __webpack_require__(491);

  __webpack_require__(492);

  __webpack_require__(171);

  __webpack_require__(493);

  __webpack_require__(494);

  __webpack_require__(495);

  __webpack_require__(496);

  __webpack_require__(497);

  __webpack_require__(499);

  __webpack_require__(503);

  __webpack_require__(504);

  __webpack_require__(508);

  __webpack_require__(509);

  __webpack_require__(240);

  __webpack_require__(513);

  __webpack_require__(512);

  __webpack_require__(514);

  __webpack_require__(515);

  __webpack_require__(516);

  __webpack_require__(517);

  __webpack_require__(519);

  __webpack_require__(518);

  __webpack_require__(520);

  __webpack_require__(522);

  __webpack_require__(523);

  __webpack_require__(526);

  __webpack_require__(530);

  __webpack_require__(528);

  __webpack_require__(529);

  __webpack_require__(498);

  __webpack_require__(500);

  __webpack_require__(501);

  __webpack_require__(502);

  __webpack_require__(505);

  __webpack_require__(506);

  __webpack_require__(507);

  __webpack_require__(510);

  __webpack_require__(511);

  __webpack_require__(521);

  __webpack_require__(524);

  __webpack_require__(525);

  __webpack_require__(527);

  __webpack_require__(553);

  __webpack_require__(554);

  __webpack_require__(561);

  __webpack_require__(559);

  __webpack_require__(560);

  __webpack_require__(579);

  __webpack_require__(580);

  __webpack_require__(577);

  __webpack_require__(578);

  __webpack_require__(546);

  __webpack_require__(547);

  __webpack_require__(548);

  __webpack_require__(549);

  __webpack_require__(550);

  __webpack_require__(552);

  __webpack_require__(551);

  __webpack_require__(555);

  __webpack_require__(556);

  __webpack_require__(557);

  __webpack_require__(558);

  __webpack_require__(562);

  __webpack_require__(563);

  __webpack_require__(564);

  __webpack_require__(565);

  __webpack_require__(566);

  __webpack_require__(568);

  __webpack_require__(567);

  __webpack_require__(569);

  __webpack_require__(570);

  __webpack_require__(571);

  __webpack_require__(572);

  __webpack_require__(573);

  __webpack_require__(574);

  __webpack_require__(575);

  __webpack_require__(576);

  __webpack_require__(581);

  __webpack_require__(582);

  __webpack_require__(583);

  __webpack_require__(584);

  __webpack_require__(585);

  __webpack_require__(586);

  __webpack_require__(587);

  __webpack_require__(588);

  __webpack_require__(589);

  __webpack_require__(590);

  __webpack_require__(591);

  __webpack_require__(592);

  __webpack_require__(593);

  __webpack_require__(594);

  __webpack_require__(241);

  module.exports = __webpack_require__(227);
  /***/
},
/* 276 */

/***/
function (module, exports) {
  function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
  }

  module.exports = _arrayWithHoles;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
  /***/
},
/* 277 */

/***/
function (module, exports, __webpack_require__) {
  var arrayLikeToArray = __webpack_require__(181);

  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return arrayLikeToArray(arr);
  }

  module.exports = _arrayWithoutHoles;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
  /***/
},
/* 278 */

/***/
function (module, exports) {
  function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
  }

  module.exports = _iterableToArray;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
  /***/
},
/* 279 */

/***/
function (module, exports) {
  function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;

    var _s, _e;

    try {
      for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"] != null) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  module.exports = _iterableToArrayLimit;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
  /***/
},
/* 280 */

/***/
function (module, exports) {
  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  module.exports = _nonIterableRest;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
  /***/
},
/* 281 */

/***/
function (module, exports) {
  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  module.exports = _nonIterableSpread;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
  /***/
},
/* 282 */

/***/
function (module, exports) {
  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }

  module.exports = _objectWithoutPropertiesLoose;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
  /***/
},
/* 283 */

/***/
function (module, exports) {
  function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
      raw = strings.slice(0);
    }

    return Object.freeze(Object.defineProperties(strings, {
      raw: {
        value: Object.freeze(raw)
      }
    }));
  }

  module.exports = _taggedTemplateLiteral;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
  /***/
},
/* 284 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony export (binding) */

  __webpack_require__.d(__webpack_exports__, "a", function () {
    return Accordion;
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__ = __webpack_require__(5);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__emotion_styled__ = __webpack_require__(14);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__emotion_styled___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__emotion_styled__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6__tal_gel_theming__ = __webpack_require__(11);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6__tal_gel_theming___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__tal_gel_theming__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7__tal_gel_core__ = __webpack_require__(7);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7__tal_gel_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__tal_gel_core__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_8__icon__ = __webpack_require__(45);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_9__button__ = __webpack_require__(133);

  var _excluded = ["theme", "title", "disabled", "inverse", "minContentHeight", "maxContentHeight", "onCollapse", "onExpand", "width", "expand", "defaultExpand", "removeContentPadding", "asFormStep", "linear", "reviewable", "onReview", "children"],
      _excluded2 = ["Wrapper"];

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);

      if (enumerableOnly) {
        symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
      }

      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  var AccordionComponent = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.forwardRef(function (_ref, forwardedRef) {
    var theme = _ref.theme,
        title = _ref.title,
        disabled = _ref.disabled,
        inverse = _ref.inverse,
        minContentHeight = _ref.minContentHeight,
        maxContentHeight = _ref.maxContentHeight,
        onCollapse = _ref.onCollapse,
        onExpand = _ref.onExpand,
        width = _ref.width,
        expand = _ref.expand,
        defaultExpand = _ref.defaultExpand,
        removeContentPadding = _ref.removeContentPadding,
        asFormStep = _ref.asFormStep,
        linear = _ref.linear,
        reviewable = _ref.reviewable,
        onReview = _ref.onReview,
        children = _ref.children,
        props = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties___default()(_ref, _excluded);

    var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useState"])(!defaultExpand),
        _useState2 = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray___default()(_useState, 2),
        isCollapsedInternal = _useState2[0],
        setIsCollapsedInternal = _useState2[1];

    var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useState"])(false),
        _useState4 = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray___default()(_useState3, 2),
        focusByClick = _useState4[0],
        setFocusByClick = _useState4[1];

    var _getStylesForStates = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__tal_gel_theming__["getStylesForStates"])({
      theme: theme,
      target: 'Accordion',
      subTarget: 'Title',
      inverse: inverse,
      isFunc: true,
      funcParams: [asFormStep, reviewable]
    }),
        titleNormalStyle = _getStylesForStates.normalStyles,
        titleActiveStyle = _getStylesForStates.activeStyles,
        titleFocusStyle = _getStylesForStates.focusStyles;

    var _getStylesForStates2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__tal_gel_theming__["getStylesForStates"])({
      theme: theme,
      target: 'Accordion',
      subTarget: 'TitleIcon',
      inverse: inverse,
      isFunc: true,
      funcParams: [asFormStep]
    }),
        iconNormalStyle = _getStylesForStates2.normalStyles,
        iconActiveStyle = _getStylesForStates2.activeStyles;

    var _getStylesForStates3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__tal_gel_theming__["getStylesForStates"])({
      theme: theme,
      target: 'Accordion',
      subTarget: 'Content',
      inverse: inverse,
      isFunc: true,
      funcParams: [asFormStep]
    }),
        contentNormalStyle = _getStylesForStates3.normalStyles;

    var onClick = function onClick() {
      if (!isControlled(expand)) {
        if (isCollapsedInternal) {
          // if Collapsed => Expanded
          setIsCollapsedInternal(false);
          onExpand && onExpand();
        } else {
          // if Expanded => Collapsed
          setIsCollapsedInternal(true);
          onCollapse && onCollapse();
        }
      } else {
        if (expand) {
          onCollapse && onCollapse();
        } else {
          onExpand && onExpand();
        }
      }
    };

    var onKeyDown = function onKeyDown(event) {
      if (event.keyCode === __WEBPACK_IMPORTED_MODULE_7__tal_gel_core__["SPACE"] || event.keyCode === __WEBPACK_IMPORTED_MODULE_7__tal_gel_core__["ENTER"]) {
        onClick();
      }
    };

    var onBlur = function onBlur() {
      return setFocusByClick(false);
    };

    var onMouseDown = function onMouseDown() {
      return setFocusByClick(true);
    };

    var isControlled = function isControlled(expand) {
      return expand !== undefined;
    };

    var shouldCollapse = function shouldCollapse() {
      if (!isControlled(expand)) {
        return isCollapsedInternal;
      }

      return !expand;
    };

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(AccordionContainer, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({
      ref: forwardedRef,
      disabled: disabled,
      width: width
    }, props), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(TitleContainer, {
      "data-cy": "gel-accordion-title",
      disabled: disabled,
      focusByClick: focusByClick,
      tabIndex: !disabled ? 0 : null // makes the div focusable if not disabled
      ,
      normalStyle: titleNormalStyle,
      activeStyle: titleActiveStyle,
      focusStyle: titleFocusStyle,
      active: !shouldCollapse(),
      asFormStep: asFormStep,
      onClick: onClick,
      onKeyDown: onKeyDown,
      onBlur: onBlur,
      onMouseDown: onMouseDown
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", null, title), !asFormStep &&
    /*#__PURE__*/
    // ChevronDown and ChevronUp icons in the accordion
    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__icon__["a"
    /* Icon */
    ], __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({
      "float": true
    }, shouldCollapse() ? iconNormalStyle : iconActiveStyle)), asFormStep && linear && reviewable &&
    /*#__PURE__*/
    // `Review` button in form stepper
    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__button__["a"
    /* default */
    ], {
      tertiary: true,
      small: true,
      onClick: onReview,
      style: {
        position: 'absolute',
        right: theme.Accordion.TitleIcon().right
      }
    }, "Review")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ContentContainer, {
      "data-cy": "gel-accordion-content",
      normalStyle: contentNormalStyle,
      isCollapsed: shouldCollapse()
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ContentWrapper, {
      normalStyle: contentNormalStyle,
      minHeight: minContentHeight,
      maxHeight: maxContentHeight,
      removeContentPadding: removeContentPadding
    }, children)));
  });

  var AccordionContainer = __WEBPACK_IMPORTED_MODULE_5__emotion_styled___default.a.div(function (_ref2) {
    var disabled = _ref2.disabled,
        width = _ref2.width;

    if (disabled) {
      // TODO: need to support disabled?
      return {
        width: width,
        cursor: 'not-allowed'
      };
    }

    return {
      width: width
    };
  });

  var TitleContainer = __WEBPACK_IMPORTED_MODULE_5__emotion_styled___default.a.div({
    display: 'flex',
    alignItems: 'start',
    position: 'relative',
    justifyContent: 'space-between'
  }, function (_ref3) {
    var disabled = _ref3.disabled,
        focusByClick = _ref3.focusByClick,
        active = _ref3.active,
        normalStyle = _ref3.normalStyle,
        activeStyle = _ref3.activeStyle,
        focusStyle = _ref3.focusStyle,
        borderBottomNone = _ref3.borderBottomNone,
        asFormStep = _ref3.asFormStep;
    return _objectSpread(_objectSpread(_objectSpread(_objectSpread({
      cursor: !asFormStep ? 'pointer' : 'default'
    }, !active ? normalStyle : activeStyle), borderBottomNone && {
      borderBottom: 'none'
    }), disabled && {
      pointerEvents: 'none'
    }), {}, {
      ':focus': !focusByClick ? focusStyle : null // only set focus style if focused via keyboard

    });
  });

  var ContentContainer = __WEBPACK_IMPORTED_MODULE_5__emotion_styled___default.a.div(function (_ref4) {
    var normalStyle = _ref4.normalStyle,
        isCollapsed = _ref4.isCollapsed;

    var Wrapper = normalStyle.Wrapper,
        contentStyle = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties___default()(normalStyle, _excluded2);

    return _objectSpread(_objectSpread({}, contentStyle), isCollapsed && {
      display: 'none'
    });
  });

  var ContentWrapper = __WEBPACK_IMPORTED_MODULE_5__emotion_styled___default.a.div(function (_ref5) {
    var normalStyle = _ref5.normalStyle,
        minHeight = _ref5.minHeight,
        maxHeight = _ref5.maxHeight,
        removeContentPadding = _ref5.removeContentPadding;
    return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, normalStyle.Wrapper), removeContentPadding && {
      padding: 0
    }), (minHeight || minHeight === 0) && {
      minHeight: minHeight
    }), (maxHeight || maxHeight === 0) && {
      maxHeight: maxHeight,
      overflow: 'auto'
    });
  });

  var Accordion = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__tal_gel_theming__["withTheme"])(AccordionComponent);
  /***/

},
/* 285 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony export (binding) */

  __webpack_require__.d(__webpack_exports__, "a", function () {
    return Alert;
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(5);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__emotion_styled__ = __webpack_require__(14);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__emotion_styled___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__emotion_styled__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6__tal_gel_theming__ = __webpack_require__(11);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6__tal_gel_theming___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__tal_gel_theming__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7__tal_gel_core__ = __webpack_require__(7);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7__tal_gel_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__tal_gel_core__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_8__icon__ = __webpack_require__(45);

  var _excluded = ["theme", "open", "onClose", "info", "danger", "success", "warning", "children"];

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);

      if (enumerableOnly) {
        symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
      }

      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  } // TODO: Tab order when multiple alerts are open


  var AlertComponent = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.forwardRef(function (_ref, forwardedRef) {
    var theme = _ref.theme,
        open = _ref.open,
        onClose = _ref.onClose,
        info = _ref.info,
        danger = _ref.danger,
        success = _ref.success,
        warning = _ref.warning,
        children = _ref.children,
        props = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties___default()(_ref, _excluded);

    var alertContainerRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useRef"])();

    var onceOpened = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useRef"])(false);

    var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useState"])(0),
        _useState2 = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray___default()(_useState, 2),
        posTop = _useState2[0],
        setPosTop = _useState2[1];

    var alertContext = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_7__tal_gel_core__["AlertContext"]); // context for when there is an alert removed


    var currentIndex = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useRef"])(-1);

    var initialMount = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useRef"])(true);

    var alertContainerHeightRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useRef"])(0);

    var type = getAlertType(info, danger, success, warning);

    var getAlertContainerRef = function getAlertContainerRef() {
      return forwardedRef || alertContainerRef;
    };

    if (!alertContext) return null;

    if (!__WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.count(children)) {
      throw 'Alert must have content';
    }

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useEffect"])(function () {
      var timer = delay(function () {
        // Store the height of alert
        // This is because if this alert gets unmounted while open, 
        // its height may change due to the unmounting of `CssReset` component
        alertContainerHeightRef.current = getAlertContainerRef().current.offsetHeight || 1; // Note that `|| 1` is really just a hack to make tests work, 
        // as jest does not render DOM so `offsetHeight` is always 0 for the tests
        // As the only case where `offsetHeight` is 0 is when the code runs in tests
        // we can safely put `|| 1` as a hack to assign a value to `offsetHeight` 
        // while not affecting production
      });
      return function () {
        // https://stackoverflow.com/a/57058707
        if (timer) clearTimeout(timer);
      };
    }, [children]); // when `children` changes


    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useEffect"])(function () {
      var setPosTopTimer, updateLayoutTimer;

      if (open && getAlertContainerRef().current) {
        // if open
        // once open, set focus on the alert container, 
        // to make it easier for the subsequent keyboard interactions inside the alert
        getAlertContainerRef().current.focus();
        setPosTopTimer = delay(function () {
          // set current body.style.marginTop as position top for this alert
          setPosTop(getPageMarginTop());
        });
        onceOpened.current = true;
      }

      if (onceOpened.current) {
        // if this alert has been opened before (regardless of whether it is currently open or closed)
        updateLayoutTimer = delay(function () {
          updateLayout(open); // whether this alert is currently open or closed, we need to update the layout (body marginTop)
        });
      }

      return function () {
        if (setPosTopTimer) clearTimeout(setPosTopTimer);
        if (updateLayoutTimer) clearTimeout(updateLayoutTimer);
      };
    }, [open]); // when controlled `open` prop changes


    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useEffect"])(function () {
      initialMount.current = false; // indicate it's not first render from this point forward

      return function () {
        // called upon unmount
        if (open) {
          // if this alert is still open, we revert the layout (body marginTop) as this alert is going to disappear after unmount
          updateLayout(false);
        }
      };
    }, []); // only after first render


    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useEffect"])(function () {
      // if there is an alert removed (otherwise indexOfAlertRemoved is -1),
      // and if the removed alert is higher in position than this alert (indexOfAlertRemoved less than currentIndex of this alert)
      if (alertContext.indexOfAlertRemoved >= 0 && alertContext.indexOfAlertRemoved < currentIndex.current) {
        setPosTop(posTop - alertContext.heightOfAlertRemoved); // move up this alert by the height of the removed alert

        currentIndex.current--; // -1, as there was an alert higher in position removed
      }
    }, [alertContext]); // only when `alertContext` changes. See `alert-context-provider` for the use of `useMemo`

    /**
     * For some reason useEffect callback can be invoked before all children 
     * (e.g. alert icon and exit icon) finish rendering. (TODO: investigate why)
     * 
     * This can cause the problem, that when useEffect callback is invoked the height of alert may not be correct
     * A workaround would be to wrap with setTimeout so React runs the actual code (which uses the alert height)
     * at the next `tick`
     * 
     * In our particular case, we want to wrap with setTimeout if the alert is open at first render,
     * as the useEffect callback invoked at first render may use the alert height when not all children have finished rendering
     * 
     * @param {function} fn: function to call at timeout
     */


    var isUnmountedRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__tal_gel_core__["useIsUnmounted"])();

    var delay = function delay(fn) {
      var timer;

      if (initialMount.current && open) {
        timer = setTimeout(function () {
          !isUnmountedRef.current && fn();
        });
      } else {
        fn();
      }

      return timer;
    };
    /**
     * Pushes down or up the entire page when alert is added or removed
     * @param {boolean} added - true (alert added), false (alert removed)
     */


    var updateLayout = function updateLayout(added) {
      var marginTop = getPageMarginTop(); // get current body margin top

      if (added) {
        // alert added
        marginTop += alertContainerHeightRef.current; // increase body margin top by the height of alert just added

        currentIndex.current = alertContext.addAlert(); // assign index to this added alert
      } else {
        // alert removed
        marginTop -= alertContainerHeightRef.current; // reduce body margin top by the height of alert just removed
        // update context with info of this removed alert, so other alerts can adjust their own positions (some may need to be moved up)

        alertContext.removeAlert(alertContainerHeightRef.current, currentIndex.current);
      }

      setPageMarginTop(marginTop); // update body margin top with the new value
    };
    /**
     * Gets the current body margin top
     * Note it is assuming that the application either has no marginTop or has marginTop measured in `px`
     */


    var getPageMarginTop = function getPageMarginTop() {
      if (!document.body.style.marginTop) return 0; // return 0 if marginTop is not specified

      return parseInt(document.body.style.marginTop.substring(0, document.body.style.marginTop.length - 2)); // strip the trailing `px`
    };
    /**
     * Sets the current body margin top
     * Note it is assuming that the application either has no marginTop or has marginTop measured in `px`
     * @param {number} marginTop 
     */


    var setPageMarginTop = function setPageMarginTop(marginTop) {
      document.body.style.marginTop = "".concat(marginTop, "px");
    };

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(AlertContainer, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
      "data-cy": "gel-alert",
      ref: getAlertContainerRef(),
      theme: theme,
      type: type // alert type
      ,
      tabIndex: -1 // cannot be focused by keyboard or mouse, but can be focused programmatically
      ,
      posTop: posTop,
      open: open
    }, props), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__icon__["a"
    /* Icon */
    ], _objectSpread(_objectSpread({}, theme.Alert.AccentIcon), theme.Alert[type].AccentIcon)), " ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ContentWrapper, {
      theme: theme,
      type: type
    }, children), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__icon__["a"
    /* Icon */
    ], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, _objectSpread(_objectSpread({}, theme.Alert.DismissIcon), theme.Alert[type].DismissIcon), {
      onClick: onClose
    })), " ");
  });
  /**
   * Gets the alert type which can be one of the following: 
   * `info`, `danger`, `success`, `warning`
   * 
   * @param {boolean} info
   * @param {boolean} danger
   * @param {boolean} success
   * @param {boolean} warning
   * @throws Will throw an error if no type is specified
   * @throws Will thrwo an error if more than one type are specified
   * @returns {string} alert type
   */


  var getAlertType = function getAlertType(info, danger, success, warning) {
    var type;
    var numberOfTypesActivated = 0;

    if (info) {
      type = 'Info';
      numberOfTypesActivated++;
    }

    if (danger) {
      type = 'Danger';
      numberOfTypesActivated++;
    }

    if (success) {
      type = 'Success';
      numberOfTypesActivated++;
    }

    if (warning) {
      type = 'Warning';
      numberOfTypesActivated++;
    }

    if (numberOfTypesActivated === 0) {
      throw 'Alert must be specified as info, danger, success or warning';
    }

    if (numberOfTypesActivated > 1) {
      throw 'Only one type can be specified';
    }

    return type;
  };

  var AlertContainer = __WEBPACK_IMPORTED_MODULE_5__emotion_styled___default.a.div({
    display: 'flex',
    position: 'fixed',
    left: 0,
    width: '100%',
    alignItems: 'center'
  }, function (_ref2) {
    var theme = _ref2.theme,
        type = _ref2.type,
        posTop = _ref2.posTop,
        open = _ref2.open;
    return _objectSpread({
      top: "".concat(posTop, "px"),
      padding: theme.Alert.padding,
      backgroundColor: theme.Alert[type].backgroundColor
    }, !open && __WEBPACK_IMPORTED_MODULE_7__tal_gel_core__["fixedAccessibleHiddenStyle"]);
  });

  var ContentWrapper = __WEBPACK_IMPORTED_MODULE_5__emotion_styled___default.a.div({
    flexGrow: '1'
  }, function (_ref3) {
    var theme = _ref3.theme,
        type = _ref3.type;
    return {
      color: theme.Alert[type].color,
      paddingLeft: theme.Alert.AccentIcon.gap,
      paddingRight: theme.Alert.DismissIcon.gap
    };
  });

  var Alert = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__tal_gel_theming__["withTheme"])(AlertComponent);
  /***/

},
/* 286 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony export (binding) */

  __webpack_require__.d(__webpack_exports__, "a", function () {
    return AutoCompleteInput;
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(5);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof__ = __webpack_require__(103);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_slicedToArray__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_objectWithoutProperties__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6__emotion_styled__ = __webpack_require__(14);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6__emotion_styled___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__emotion_styled__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7__tal_gel_core__ = __webpack_require__(7);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7__tal_gel_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__tal_gel_core__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_8__tal_gel_theming__ = __webpack_require__(11);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_8__tal_gel_theming___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__tal_gel_theming__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_9__text_input__ = __webpack_require__(46);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_10__number_input__ = __webpack_require__(135);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_11__layout_page_layout__ = __webpack_require__(134);

  var _excluded = ["onSearch", "debounceTime", "loading", "maxHeight", "errorMsg", "onError", "onOptionClick", "onOptionListOpen", "data", "index", "resetValidator", "width", "numbersOnly", "comboBox", "displayAllOptionsOnFocus", "required", "exact", "onChange", "onBlur", "labelValuePairAsValue", "extraHeightToAvoid", "theme", "onClear"],
      _excluded2 = ["numbersOnly"];

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);

      if (enumerableOnly) {
        symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
      }

      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  var AUTO_COMPLETE_DEBOUNCE_TIME = 500; // TODO: It is not yet supported for GelAutoCompleteInput to be used without GEL form.

  var AutoCompleteInputComponent = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react___default.a.forwardRef(function (_ref, forwardedRef) {
    var onSearch = _ref.onSearch,
        _ref$debounceTime = _ref.debounceTime,
        debounceTime = _ref$debounceTime === void 0 ? AUTO_COMPLETE_DEBOUNCE_TIME : _ref$debounceTime,
        loading = _ref.loading,
        maxHeight = _ref.maxHeight,
        errorMsg = _ref.errorMsg,
        onError = _ref.onError,
        onOptionClick = _ref.onOptionClick,
        onOptionListOpen = _ref.onOptionListOpen,
        data = _ref.data,
        index = _ref.index,
        resetValidator = _ref.resetValidator,
        width = _ref.width,
        numbersOnly = _ref.numbersOnly,
        comboBox = _ref.comboBox,
        _ref$displayAllOption = _ref.displayAllOptionsOnFocus,
        displayAllOptionsOnFocus = _ref$displayAllOption === void 0 ? true : _ref$displayAllOption,
        required = _ref.required,
        exact = _ref.exact,
        onChange = _ref.onChange,
        onBlur = _ref.onBlur,
        _ref$labelValuePairAs = _ref.labelValuePairAsValue,
        labelValuePairAsValue = _ref$labelValuePairAs === void 0 ? false : _ref$labelValuePairAs,
        extraHeightToAvoid = _ref.extraHeightToAvoid,
        theme = _ref.theme,
        onClear = _ref.onClear,
        props = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_objectWithoutProperties___default()(_ref, _excluded);

    var inputRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react__["useRef"])();

    var getInputRef = function getInputRef() {
      return forwardedRef || inputRef;
    };

    var isUnmounted = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__tal_gel_core__["useIsUnmounted"])();

    var focused = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react__["useRef"])(false);

    var shouldDisplayData = function shouldDisplayData() {
      return showOptionList && dataToDisplay && dataToDisplay.length > 0;
    };

    var _useValidator = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__tal_gel_core__["useValidator"])(_objectSpread(_objectSpread({}, props), {}, {
      // includes controlled `error`, `caption`, `value`, `defaultValue`, `setValidity`, etc.
      index: index,
      // index assigned by the form 
      onChange: onChange,
      onBlur: onBlur,
      reset: resetValidator,
      // whether to reset the validator (`touched` status, etc.)
      checkError: true,
      // tells validator to always check for error
      hasError: function hasError(value) {
        // tells validator HOW to check for error
        if (required && !value && value !== 0) {
          return 'required';
        }

        if (exact) {
          if (__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof___default()(props.value) !== 'object' || props.value === null) {
            if (!dataToDisplay) {
              return 'exact';
            }

            var exactMatched = dataToDisplay.filter(match(value, true));

            if (!exactMatched || exactMatched.length === 0) {
              return 'exact';
            }
          }
        }

        return false;
      },
      hideErrorInitially: true,
      // tells validator to hide error initially
      onError: onError,
      // tells validator the callback to invoke if error occurs or disappears
      errorMsg: errorMsg // tells validator the error message to include in caption if error occurs

    })),
        _useValidator2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_slicedToArray___default()(_useValidator, 4),
        __onBlur = _useValidator2[0],
        __onChange = _useValidator2[1],
        getCaption = _useValidator2[2],
        shouldShowError = _useValidator2[3];

    var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react__["useState"])(data),
        _useState2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_slicedToArray___default()(_useState, 2),
        staticData = _useState2[0],
        setStaticData = _useState2[1];

    var isStaticData = function isStaticData() {
      return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__tal_gel_core__["isFunction"])(onSearch);
    };

    var onChangeDebouncedRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__tal_gel_core__["useDebounce"])(function (value) {
      setIsLoadingDynamicData(true);
      onSearch(value);
    }, debounceTime);

    var clearText = function clearText() {
      var event = {
        target: {
          type: 'input',
          name: props.name,
          value: ''
        }
      }; // Do not trigger validator for the empty value
      // so that error message against checking empty
      // value won't be displayed

      _onChange(event, false); // Directly call onChange provided by the parent,
      // due to skipping validator


      onChange(event);
      getInputRef().current.focus();
      getInputRef().current.click();
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__tal_gel_core__["isFunction"])(onClear) && onClear();
    };

    var _onChange = function _onChange(event) {
      var triggerValidator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      if (!isStaticData()) {
        // `event` cannot be used in an async context, so get the value here
        if (onChangeDebouncedRef.current) {
          onChangeDebouncedRef.current(event.target.value);
        }
      } else {
        setStaticData((data || []).filter(match(event.target.value)));
        setShowOptionList(true);
      }

      if (triggerValidator) {
        __onChange(event);
      }
    };

    var _onBlur = function _onBlur(event) {
      if (shouldDisplayData()) {
        if (overlayMouseDown.current) {
          // not used
          __onBlur(event); // surfaced by the validator

        } else {
          if (!dataOptionContainerMouseDown.current) {
            __onBlur(event); // surfaced by the validator


            setShowOptionList(false);
          }
        }

        overlayMouseDown.current = false;
        dataOptionContainerMouseDown.current = false;
      } else {
        __onBlur(event); // surfaced by the validator

      }

      if (data && data[0] !== undefined && typeof data[0] !== 'string') {
        var exactMatched = dataToDisplay.filter(match(event.target.value, true));

        if (exactMatched && exactMatched.length > 0) {
          // Do not trigger validation checks straightaway, 
          // but only notify the parent
          onChange({
            target: {
              name: props.name,
              type: 'input',
              value: !labelValuePairAsValue ? exactMatched[0].value : exactMatched[0]
            }
          });
        }
      }

      focused.current = false;
    };

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react__["useEffect"])(function () {
      // Make sure to close option list caused by submit check 
      // (as submit check will trigger onFocus and onBlur of this component)
      if (props.submitCheck) {
        setShowOptionList(false);
      }
    }, [props.submitCheck]);

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react__["useEffect"])(function () {
      if (resetValidator && isStaticData()) {
        setShowOptionList(false);
        setStaticData(data);
      }
    }, [resetValidator]);

    var _useRenderOnTop = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__tal_gel_core__["useRenderOnTop"])({
      // Checks whether the dropdown should be displayed below or above the input
      PageLayoutContext: __WEBPACK_IMPORTED_MODULE_11__layout_page_layout__["b"
      /* PageLayoutContext */
      ],
      // Extra height to be added to the height of dropdown to 
      // determine whether the dropdown should be below or above 
      // the input. This gives users more flexibility as to how 
      // to determine the dropdown is too long to be displayed
      // below the input
      extraHeightToAvoid: extraHeightToAvoid
    }),
        targetRef = _useRenderOnTop.targetRef,
        shouldRenderOnTop = _useRenderOnTop.shouldRenderOnTop,
        getTargetHeight = _useRenderOnTop.getTargetHeight;

    var match = function match(value) {
      var exact = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return function (option) {
        var targetText = typeof option === 'string' ? option.toLowerCase() : focused.current && !numbersOnly ? option.label.toLowerCase() : option.value + '';
        return !exact ? targetText.indexOf(value.toLowerCase()) >= 0 : targetText === value.toLowerCase();
      };
    };

    var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react__["useState"])(false),
        _useState4 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_slicedToArray___default()(_useState3, 2),
        isLoadingDynamicData = _useState4[0],
        setIsLoadingDynamicData = _useState4[1];

    var isLoading = function isLoading() {
      if (loading === undefined) {
        // if loading is not controlled
        if (isStaticData()) {
          // Only show loading spinner when there is 
          // no (static) data provided 
          return !!(!data || data.length === 0);
        }

        return isLoadingDynamicData;
      }

      return loading;
    };

    var _useState5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react__["useState"])(false),
        _useState6 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_slicedToArray___default()(_useState5, 2),
        showOptionList = _useState6[0],
        setShowOptionList = _useState6[1];

    var checkingValidation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react__["useRef"])(false);

    var _onOptionClick = function _onOptionClick(option) {
      // Do not trigger validation checks straightaway, 
      // but only notify the parent
      onChange({
        target: {
          name: props.name,
          type: 'input',
          value: !labelValuePairAsValue ? typeof option === 'string' ? option : option.value : option
        }
      });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__tal_gel_core__["isFunction"])(onOptionClick) && onOptionClick(option);
      setShowOptionList(false);
      var timer = setTimeout(function () {
        // Ensure that validation status gets updated
        if (!isUnmounted.current) {
          checkingValidation.current = true;
          getInputRef().current.focus();
          getInputRef().current.blur();
        }

        clearTimeout(timer);
      });
    };

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react__["useEffect"])(function () {
      if (!isStaticData()) {
        if (data && data.length > 0) {
          setShowOptionList(true);
        }

        setIsLoadingDynamicData(false);
      } else {
        setStaticData(data);
      }
    }, [data]);

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react__["useEffect"])(function () {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__tal_gel_core__["isFunction"])(onOptionListOpen) && onOptionListOpen(shouldDisplayData());
    }, [shouldDisplayData()]);

    var dataToDisplay = !isStaticData() ? data : staticData;

    var overlayMouseDown = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react__["useRef"])(false);

    var dataOptionContainerMouseDown = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react__["useRef"])(false);

    var onDataOptionContainerMouseDown = function onDataOptionContainerMouseDown() {
      return dataOptionContainerMouseDown.current = true;
    };

    var onFocus = function onFocus() {
      if (comboBox && !checkingValidation.current) {
        setShowOptionList(true);
      }

      if (isStaticData() && props.value !== undefined && props.value !== null) {
        if (!displayAllOptionsOnFocus) {
          setStaticData((data || []).filter(match(props.value + '')));
        } else {
          setStaticData(data);
        }
      }

      checkingValidation.current = false;
      focused.current = true;
    };
    /**
     * `props.value` is either option itself (if option is a string) or option.value
     */


    var getDisplayValue = function getDisplayValue() {
      if (!labelValuePairAsValue || __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof___default()(props.value) !== 'object') {
        if (!dataToDisplay || typeof dataToDisplay[0] === 'string') {
          return props.value;
        }

        var selectedOption = dataToDisplay.filter(function (option) {
          return option.value === props.value;
        });

        if (selectedOption.length === 0) {
          return props.value;
        }

        return !numbersOnly ? selectedOption[0].label : selectedOption[0].value;
      }

      return props.value ? props.value.label : ''; // props.value being { label, value }
    };

    var getOptionLabel = function getOptionLabel(option) {
      return typeof option === 'string' ? option : option.label;
    };

    var getOptionValue = function getOptionValue(option) {
      return typeof option === 'string' ? option : option.value;
    };

    var shouldDisplayClear = function shouldDisplayClear() {
      // Checks whether to display the clear (X) button
      var displayValue = getDisplayValue();
      return !!(displayValue || displayValue === 0);
    };

    var _useState7 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react__["useState"])(-1),
        _useState8 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_slicedToArray___default()(_useState7, 2),
        indexOnHover = _useState8[0],
        setIndexOnHover = _useState8[1]; // Works with both mouse and keyboard


    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react__["useEffect"])(function () {
      setIndexOnHover(-1); // Reset hover status on new data
    }, [dataToDisplay]);

    var onKeyDown = function onKeyDown(event) {
      if (!shouldDisplayData()) return;

      if (event.keyCode === __WEBPACK_IMPORTED_MODULE_7__tal_gel_core__["ARROW_DOWN"]) {
        if (indexOnHover + 1 < dataToDisplay.length) {
          setIndexOnHover(indexOnHover + 1);
        }
      } else if (event.keyCode === __WEBPACK_IMPORTED_MODULE_7__tal_gel_core__["ARROW_UP"]) {
        if (indexOnHover - 1 >= 0) {
          setIndexOnHover(indexOnHover - 1);
        }
      } else if (event.keyCode === __WEBPACK_IMPORTED_MODULE_7__tal_gel_core__["ENTER"]) {
        _onOptionClick(dataToDisplay[indexOnHover]);

        var timer = setTimeout(function () {
          getInputRef().current.focus();
          getInputRef().current.blur();
          clearTimeout(timer);
        });
        event.preventDefault();
      }
    };

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Container, {
      width: width,
      shouldDisplayData: shouldDisplayData(),
      onKeyDown: onKeyDown
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Input, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
      "data-cy": "gel-auto-complete-input",
      ref: getInputRef()
    }, props, {
      value: getDisplayValue()
    }, index !== undefined && {
      index: index + '_0'
    }, {
      // assign a sub index to the underling TextInput
      resetValidator: resetValidator
    }, isStaticData() && !isLoading() && {
      suffixIcon: !shouldDisplayData() ? 'ChevronDown' : 'ChevronUp',
      onSuffixIconClick: function onSuffixIconClick() {
        getInputRef().current.focus();
        getInputRef().current.click();
      }
    }, isStaticData() && shouldDisplayClear() && {
      extraSuffixIcon: 'ExitSmall',
      onExtraSuffixIconClick: clearText
    }, !isStaticData() && shouldDisplayClear() && {
      suffixIcon: 'ExitSmall',
      onSuffixIconClick: clearText
    }, !isStaticData() && isLoading() && {
      spinnerExtraSuffixIcon: shouldDisplayClear()
    }, {
      spinner: isLoading(),
      onChange: _onChange,
      onBlur: _onBlur,
      onFocus: onFocus,
      caption: getCaption(),
      error: shouldShowError(),
      onError: onError,
      errorMsg: errorMsg,
      numbersOnly: numbersOnly
    })), shouldDisplayData() && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(DataOptionContainer, {
      "data-cy": "gel-auto-complete-option-container",
      theme: theme,
      maxHeight: maxHeight,
      onMouseDown: onDataOptionContainerMouseDown,
      ref: targetRef,
      shouldRenderOnTop: shouldRenderOnTop,
      height: getTargetHeight()
    }, dataToDisplay.map(function (option, index) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(DataOption, {
        "data-cy": "gel-auto-complete-option",
        key: index,
        theme: theme,
        onClick: function onClick() {
          return _onOptionClick(option);
        },
        onMouseOver: function onMouseOver() {
          return setIndexOnHover(index);
        },
        selected: // do not show selected status on dynamic data list 
        // or on filtered data list
        isStaticData() ? dataToDisplay.length === data.length && props.value === getOptionValue(option) : false,
        hovered: index === indexOnHover
      }, getOptionLabel(option));
    }))));
  }); // Note: We cannot define this component inside AutoCompleteInputComponent
  // as otherwise on each render Input will be considered a new component 
  // and thus focus inside TextInput or NumberInput will get lost.


  var Input = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react___default.a.forwardRef(function (_ref2, forwardedRef) {
    var numbersOnly = _ref2.numbersOnly,
        props = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_objectWithoutProperties___default()(_ref2, _excluded2);

    return !numbersOnly ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__text_input__["a"
    /* default */
    ], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
      ref: forwardedRef
    }, props)) : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__number_input__["a"
    /* default */
    ], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
      ref: forwardedRef
    }, props));
  });

  var Container = __WEBPACK_IMPORTED_MODULE_6__emotion_styled___default.a.div({
    position: 'relative'
  }, function (_ref3) {
    var width = _ref3.width,
        shouldDisplayData = _ref3.shouldDisplayData;
    return {
      width: width || '100%',
      zIndex: shouldDisplayData ? 1 : 0
    };
  }); // Detects outside clicks


  var Overlay = __WEBPACK_IMPORTED_MODULE_6__emotion_styled___default.a.div(function () {
    return _objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_7__tal_gel_core__["fixedAccessibleHiddenStyle"]), {}, {
      width: '100%',
      height: '100%',
      zIndex: 1
    });
  });

  var DataOptionContainer = __WEBPACK_IMPORTED_MODULE_6__emotion_styled___default.a.div({
    position: 'absolute',
    overflow: 'auto',
    width: '100%'
  }, function (_ref4) {
    var theme = _ref4.theme,
        maxHeight = _ref4.maxHeight,
        shouldRenderOnTop = _ref4.shouldRenderOnTop,
        height = _ref4.height;
    return _objectSpread(_objectSpread({}, theme.AutoCompleteInput.OptionContainer(shouldRenderOnTop, height)), {}, {
      maxHeight: maxHeight
    });
  });

  var DataOption = __WEBPACK_IMPORTED_MODULE_6__emotion_styled___default.a.div({
    cursor: 'pointer'
  }, function (_ref5) {
    var theme = _ref5.theme,
        selected = _ref5.selected,
        hovered = _ref5.hovered;
    return theme.AutoCompleteInput.Option(selected, hovered);
  });

  var AutoCompleteInput = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__tal_gel_theming__["withTheme"])(AutoCompleteInputComponent);
  /***/

},
/* 287 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony export (binding) */

  __webpack_require__.d(__webpack_exports__, "a", function () {
    return Breadcrumbs;
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__ = __webpack_require__(5);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(611);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_react_router_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__emotion_styled__ = __webpack_require__(14);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__emotion_styled___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__emotion_styled__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6__tal_gel_theming__ = __webpack_require__(11);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6__tal_gel_theming___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__tal_gel_theming__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7__tal_gel_core__ = __webpack_require__(7);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7__tal_gel_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__tal_gel_core__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_8__icon__ = __webpack_require__(45);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_9__grid_screen_detector__ = __webpack_require__(33);

  var _excluded = ["theme", "routes", "onRouteChange", "directLink", "target", "inverse"],
      _excluded2 = ["type", "text", "icon"];

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);

      if (enumerableOnly) {
        symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
      }

      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }
  /**
   * TGCL Breadcrumb component works hand in hand with `react-router`
   * 
   * Change route: useHistory, history.push and <Link to />
   * Respond to the change of route: https://stackoverflow.com/a/53712117
   */


  var BreadcrumbsComponent = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef(function (_ref, forwardedRef) {
    var theme = _ref.theme,
        routes = _ref.routes,
        onRouteChange = _ref.onRouteChange,
        directLink = _ref.directLink,
        target = _ref.target,
        inverse = _ref.inverse,
        props = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties___default()(_ref, _excluded);

    var histroy = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["useHistory"])();

    var _useContext = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_9__grid_screen_detector__["a"
    /* ScreenDetectorContext */
    ]),
        screen = _useContext.screen,
        isXsScreen = _useContext.isXsScreen;

    var hiddenLink = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react__["useRef"])(); // for the 'back' icon on mobile screen


    var onLinkKeyDown = function onLinkKeyDown(event, route) {
      // if `Space` key is hit on the breadcrumb link
      if (event.keyCode === __WEBPACK_IMPORTED_MODULE_7__tal_gel_core__["SPACE"]) {
        changeRoute(route);
      }
    };
    /**
     * Programmatically changes route (so `Router` can notify `Route`s which to show)
     * @param route - route to change to
     */


    var changeRoute = function changeRoute(route) {
      if (!isStandalone()) {
        // handle route change internally with React Router
        histroy.push(getRouteUrlWithParams(route));
      } else {
        // or notify parent of route change and let parent deal with it
        onRouteChange && onRouteChange(route);
      }
    };
    /**
     * Checks if this is a standalone breadcrumb
     * 
     * A standalone breadcrumb is not attached to React Router,
     * and it will notify parent of a route change via `onRouteChange`
     * so the parent can handle the route change
     */


    var isStandalone = function isStandalone() {
      return !!onRouteChange || directLink;
    };
    /**
     * Gets the route url including query params
     * Use `useParams` to get access to URL params
     * Use `useQueryParams` (from @tal-gel/core) to get access to query params
     */


    var getRouteUrlWithParams = function getRouteUrlWithParams(route) {
      return route.queryParams ? Object.keys(route.queryParams).reduce(function (result, currentKey, index, keys) {
        return result + "".concat(currentKey, "=").concat(route.queryParams[currentKey]) + (index < keys.length - 1 ? '&' : '');
      }, "".concat(route.to, "?")) : route.to;
    };

    var onBackButtonClick = function onBackButtonClick(route) {
      changeRoute(route);

      if (directLink && hiddenLink.current) {
        // Programmatically click a hidden link (for the 'back' icon) 
        // if breadcrumb items are direct links
        hiddenLink.current.click();
      }
    };

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("nav", {
      ref: forwardedRef
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(BreadcrumbsWrapper, props, !isXsScreen(screen) && routes.map(function (route, index) {
      // for non-mobile view
      if (index < routes.length - 1) {
        // if not the last one
        return (
          /*#__PURE__*/
          // render a link for this level as well as a separator next to it
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(BreadcrumbItem, {
            "data-cy": "gel-breadcrumbs-item",
            key: route.to,
            theme: theme,
            inverse: inverse
          }, !isStandalone() ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(StyledReactRouterLink // work with React Router
          , {
            "data-cy": "gel-breadcrumbs-item-link",
            to: getRouteUrlWithParams(route),
            theme: theme,
            inverse: inverse,
            onKeyDown: function onKeyDown(event) {
              return onLinkKeyDown(event, route);
            }
          }, route.label) : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(StyledLink, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({
            "data-cy": "gel-breadcrumbs-item-link",
            theme: theme,
            inverse: inverse
          }, directLink && {
            // goes to the link (href) directly 
            href: getRouteUrlWithParams(route),
            target: target
          }, {
            onClick: function onClick() {
              return changeRoute(route);
            } // notify parent of route change
            ,
            onKeyDown: function onKeyDown(event) {
              return onLinkKeyDown(event, route);
            }
          }), route.label), theme.Breadcrumb.Separator.type === 'text' ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(BreadcrumbsTextSeparator, {
            "data-cy": "gel-breadcrumbs-text-sep",
            theme: theme,
            inverse: inverse
          }) : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__icon__["a"
          /* Icon */
          ], __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({
            "data-cy": "gel-breadcrumbs-icon-sep"
          }, theme.Breadcrumb.Separator.icon, inverse && theme.Breadcrumb.Inverse.Separator.icon, {
            style: {
              marginLeft: theme.Breadcrumb.Separator.paddingLeft,
              marginRight: theme.Breadcrumb.Separator.paddingRight
            }
          })))
        );
      }

      return (
        /*#__PURE__*/
        // for the last one, render a non-clickable label
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(BreadcrumbItem, {
          "data-cy": "gel-breadcrumbs-last-item",
          key: "-1",
          theme: theme,
          inverse: inverse
        }, route.label)
      );
    }), isXsScreen(screen) && routes.length > 0 &&
    /*#__PURE__*/
    // for mobile view
    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__tal_gel_core__["GelFlexContainer"], {
      alignItems: "center"
    }, routes.length > 1 && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__icon__["a"
    /* Icon */
    ], __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({
      "data-cy": "gel-breadcrumbs-back"
    }, _objectSpread(_objectSpread({}, theme.Breadcrumb.BackIcon), inverse && theme.Breadcrumb.Inverse.BackIcon), {
      style: {
        marginRight: theme.Breadcrumb.BackIcon.gap
      },
      onClick: // upon click, go up a level
      function onClick() {
        return onBackButtonClick(routes[routes.length - 2]);
      }
    })), // If all breadcrumb items are supposed to be direct links, 
    // the 'back' icon also needs to be associated with a direct link (but hidden)
    directLink && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(HiddenLink // Hidden, goes to the link (href) directly upon programmatical click
    , {
      "data-cy": "gel-breadcrumbs-back-hidden-link",
      ref: hiddenLink,
      theme: theme,
      inverse: inverse,
      href: getRouteUrlWithParams(routes[routes.length - 2]),
      target: target
    })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(BreadcrumbItem, {
      "data-cy": "gel-breadcrumbs-last-item",
      theme: theme,
      inverse: inverse
    }, routes[routes.length - 1].label))));
  });

  var BreadcrumbsWrapper = __WEBPACK_IMPORTED_MODULE_5__emotion_styled___default.a.ul({
    display: 'flex',
    listStyle: 'none',
    margin: 0,
    padding: 0
  });

  var BreadcrumbItem = __WEBPACK_IMPORTED_MODULE_5__emotion_styled___default.a.li({
    margin: 0,
    display: 'flex',
    alignItems: 'center'
  }, function (_ref2) {
    var theme = _ref2.theme,
        inverse = _ref2.inverse;
    return _objectSpread(_objectSpread({}, theme.Breadcrumb.Item), inverse && theme.Breadcrumb.Inverse.Item);
  });

  var StyledReactRouterLink = __WEBPACK_IMPORTED_MODULE_5__emotion_styled___default()(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["Link"])( // `Link` from `react-router-dom`
  function (_ref3) {
    var theme = _ref3.theme,
        inverse = _ref3.inverse;
    return _objectSpread(_objectSpread(_objectSpread({}, theme.Breadcrumb.Item), theme.Breadcrumb.Item.Link), inverse && _objectSpread(_objectSpread({}, theme.Breadcrumb.Inverse.Item), theme.Breadcrumb.Inverse.Item.Link));
  });

  var StyledLink = __WEBPACK_IMPORTED_MODULE_5__emotion_styled___default.a.a({
    cursor: 'pointer'
  }, function (_ref4) {
    var theme = _ref4.theme,
        inverse = _ref4.inverse;
    return _objectSpread(_objectSpread(_objectSpread({}, theme.Breadcrumb.Item), theme.Breadcrumb.Item.Link), inverse && _objectSpread(_objectSpread({}, theme.Breadcrumb.Inverse.Item), theme.Breadcrumb.Inverse.Item.Link));
  });

  var HiddenLink = __WEBPACK_IMPORTED_MODULE_5__emotion_styled___default.a.a(__WEBPACK_IMPORTED_MODULE_6__tal_gel_theming__["accessibleHiddenStyle"]);

  var BreadcrumbsTextSeparator = __WEBPACK_IMPORTED_MODULE_5__emotion_styled___default.a.span({
    textAlign: 'center'
  }, function (_ref5) {
    var theme = _ref5.theme,
        inverse = _ref5.inverse;

    var _theme$Breadcrumb$Sep = theme.Breadcrumb.Separator,
        type = _theme$Breadcrumb$Sep.type,
        text = _theme$Breadcrumb$Sep.text,
        icon = _theme$Breadcrumb$Sep.icon,
        otherStyle = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties___default()(_theme$Breadcrumb$Sep, _excluded2);

    return _objectSpread(_objectSpread(_objectSpread({}, theme.Breadcrumb.Separator.text), otherStyle), inverse && theme.Breadcrumb.Inverse.Separator);
  });

  var Breadcrumbs = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__tal_gel_theming__["withTheme"])(BreadcrumbsComponent);
  /***/

},
/* 288 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony export (binding) */

  __webpack_require__.d(__webpack_exports__, "a", function () {
    return Button;
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends__ = __webpack_require__(5);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__emotion_styled__ = __webpack_require__(14);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__emotion_styled___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__emotion_styled__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6__tal_gel_core__ = __webpack_require__(7);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6__tal_gel_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__tal_gel_core__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7__tal_gel_theming__ = __webpack_require__(11);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7__tal_gel_theming___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__tal_gel_theming__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_8__icon__ = __webpack_require__(45);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_9__spinner__ = __webpack_require__(136);

  var _excluded = ["children", "theme", "primary", "secondary", "tertiary", "checkbox", "radio", "inverse", "danger", "icon", "iconLeft", "iconRight", "xlarge", "large", "medium", "small", "xsmall", "stretch", "width", "focus", "active", "hover", "disabled", "loading"],
      _excluded2 = ["padding", "Icon"];

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);

      if (enumerableOnly) {
        symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
      }

      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  var ButtonComponent = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.forwardRef(function (_ref, forwardedRef) {
    var children = _ref.children,
        theme = _ref.theme,
        primary = _ref.primary,
        secondary = _ref.secondary,
        tertiary = _ref.tertiary,
        checkbox = _ref.checkbox,
        radio = _ref.radio,
        _ref$inverse = _ref.inverse,
        inverse = _ref$inverse === void 0 ? false : _ref$inverse,
        danger = _ref.danger,
        icon = _ref.icon,
        iconLeft = _ref.iconLeft,
        iconRight = _ref.iconRight,
        xlarge = _ref.xlarge,
        large = _ref.large,
        medium = _ref.medium,
        small = _ref.small,
        xsmall = _ref.xsmall,
        stretch = _ref.stretch,
        width = _ref.width,
        focus = _ref.focus,
        active = _ref.active,
        hover = _ref.hover,
        disabled = _ref.disabled,
        loading = _ref.loading,
        props = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties___default()(_ref, _excluded); // Get button type


    var type = __WEBPACK_IMPORTED_MODULE_6__tal_gel_core__["ButtonUtils"].getType(primary, secondary, tertiary, checkbox, radio); // Get styles for various states


    var buttonStyleForStates = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__tal_gel_theming__["getStylesForStates"])({
      theme: theme,
      target: 'Button',
      subTarget: type,
      inverse: inverse,
      danger: danger
    }); // Get style by button size 


    var sizeRelatedStyle = getStyleBySize({
      buttonTheme: theme.Button,
      xlarge: xlarge,
      large: large,
      medium: medium,
      small: small,
      xsmall: xsmall,
      stretch: stretch,
      icon: icon,
      width: width
    }); // Get button state

    var state = __WEBPACK_IMPORTED_MODULE_6__tal_gel_core__["ButtonUtils"].getState(focus, active, hover, disabled); // Get icon color by state 


    var iconColor = buttonStyleForStates[!state ? 'normalStyles' : state.toLowerCase() + 'Styles'].iconColor; // Get button size

    var size = __WEBPACK_IMPORTED_MODULE_6__tal_gel_core__["ButtonUtils"].getSize(xlarge, large, medium, small, xsmall); // Get icon style by button size


    var iconStyle = theme.Button[size].Icon; // Only one of `icon`, `iconLeft` and `iconRight` can have a value.
    // icon: button with icon (no text)
    // iconLeft: button with icon + text
    // iconRight: button with text + icon

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(StyledButton, __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
      "data-cy": "gel-button",
      ref: forwardedRef,
      buttonStyleForStates: buttonStyleForStates,
      sizeRelatedStyle: sizeRelatedStyle,
      disabled: disabled || loading
    }, props), iconRight && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", {
      style: {
        paddingRight: iconStyle.gap
      }
    }, children), icon || iconLeft || iconRight ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__icon__["a"
    /* Icon */
    ], {
      name: icon || iconLeft || iconRight,
      width: iconStyle.width,
      height: iconStyle.height,
      marginBottom: iconStyle.marginBottom,
      color: iconColor
    }) : loading ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__spinner__["a"
    /* default */
    ], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({}, small && {
      inButtonSmall: true
    }, medium && {
      inButtonMedium: true
    }, large && {
      inButtonLarge: true
    })) : children, iconLeft && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", {
      style: {
        paddingLeft: iconStyle.gap
      }
    }, children));
  });

  var StyledButton = __WEBPACK_IMPORTED_MODULE_5__emotion_styled___default.a.button({
    // consistent button style across all themes
    position: 'relative',
    cursor: 'pointer',
    ':disabled': {
      cursor: 'not-allowed'
    },
    transitionProperty: 'background, border-color, color',
    display: 'flex',
    alignItems: 'center'
  }, function (_ref2) {
    var _objectSpread2;

    var pressed = _ref2.pressed,
        cosmeticFocus = _ref2.cosmeticFocus,
        buttonStyleForStates = _ref2.buttonStyleForStates,
        sizeRelatedStyle = _ref2.sizeRelatedStyle;
    return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, sizeRelatedStyle), buttonStyleForStates.normalStyles), cosmeticFocus && buttonStyleForStates.focusStyles), {}, (_objectSpread2 = {}, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(_objectSpread2, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__tal_gel_theming__["getFullState"])(':focus'), _objectSpread({}, !pressed ? buttonStyleForStates.focusStyles : buttonStyleForStates.focusStyles.Pressed)), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(_objectSpread2, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__tal_gel_theming__["getFullState"])(':hover'), buttonStyleForStates.hoverStyles), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(_objectSpread2, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__tal_gel_theming__["getFullState"])(':active'), buttonStyleForStates.activeStyles), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(_objectSpread2, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__tal_gel_theming__["getFullState"])(':disabled'), buttonStyleForStates.disabledStyles), _objectSpread2));
  });
  /**
   * Gets button style by button size
   */


  var getStyleBySize = function getStyleBySize(_ref3) {
    var buttonTheme = _ref3.buttonTheme,
        xlarge = _ref3.xlarge,
        large = _ref3.large,
        medium = _ref3.medium,
        small = _ref3.small,
        xsmall = _ref3.xsmall,
        stretch = _ref3.stretch,
        icon = _ref3.icon,
        width = _ref3.width;

    var size = __WEBPACK_IMPORTED_MODULE_6__tal_gel_core__["ButtonUtils"].getSize(xlarge, large, medium, small, xsmall);

    var _buttonTheme$size = buttonTheme[size],
        padding = _buttonTheme$size.padding,
        _ = _buttonTheme$size.Icon,
        otherStyle = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties___default()(_buttonTheme$size, _excluded2);

    return _objectSpread(_objectSpread({
      width: stretch ? '100%' : width
    }, otherStyle), !icon ? _objectSpread({
      padding: padding
    }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__tal_gel_core__["isInIE"])() && {
      // TODO: Review
      paddingTop: small ? 6 : 12,
      paddingBottom: small ? 6 : 12
    }) : {
      // icon button will always be square (and the icon itself is always square too)
      width: otherStyle.minHeight,
      height: otherStyle.minHeight,
      justifyContent: 'center',
      alignItems: 'center'
    });
  };
  /**
   * HOC to externalise and manage some states, 
   * so the states can, for example, be passed down to the icon component inside the button
   */


  var withStates = function withStates(ButtonComponent) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.forwardRef(function (props, forwardedRef) {
      var _useActiveState = useActiveState(props),
          _useActiveState2 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default()(_useActiveState, 3),
          active = _useActiveState2[0],
          checkIfActive = _useActiveState2[1],
          checkIfInactive = _useActiveState2[2];

      var _useHoverState = useHoverState(props),
          _useHoverState2 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default()(_useHoverState, 3),
          hover = _useHoverState2[0],
          onHover = _useHoverState2[1],
          onUnhover = _useHoverState2[2];

      var _usePressedState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__tal_gel_core__["usePressedState"])(props),
          _usePressedState2 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default()(_usePressedState, 3),
          pressed = _usePressedState2[0],
          onPress = _usePressedState2[1],
          onUnpress = _usePressedState2[2];

      var _useFocusState = useFocusState(props),
          _useFocusState2 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default()(_useFocusState, 3),
          focus = _useFocusState2[0],
          _onFocus2 = _useFocusState2[1],
          _onBlur2 = _useFocusState2[2];

      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ButtonComponent, __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
        ref: forwardedRef
      }, props, {
        type: props.submit ? 'submit' : 'button'
        /** --- active --- */
        ,
        active: active,
        onKeyDown: checkIfActive,
        onMouseDown: checkIfActive,
        onKeyUp: checkIfInactive,
        onMouseUp: checkIfInactive
        /** --- hover --- */
        ,
        hover: hover,
        onMouseEnter: onHover,
        onMouseLeave: onUnhover
        /** --- pressed --- */
        ,
        pressed: pressed,
        onClick: function onClick(event) {
          onPress(event); // Invoke onFocus again if the button is already on focus, 
          // as by default if the button is already on focus, clicking the button won't 
          // trigger another onFocus invocation 
          // Setting last param as false, as we don't want to trigger user onFocus handler again, 
          // to match the default behaviour

          focus && _onFocus2(null, false, true, false);
        }
        /** --- focus --- */
        ,
        focus: focus,
        onFocus: function onFocus(event) {
          return _onFocus2(event, active, pressed);
        },
        onBlur: function onBlur(event) {
          onUnpress(event, false);

          _onBlur2(event);
        }
      }));
    });
  };
  /**
   * Custom hook to manage the focus state of button
   * Focus state is when a button is tabbed in (and not in active or pressed state)
   * 
   * Note that if the button is in active or pressed state, focus will NOT be set as true
   */


  var useFocusState = function useFocusState(_ref4) {
    var onFocus = _ref4.onFocus,
        onBlur = _ref4.onBlur;

    var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useState"])(false),
        _useState2 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default()(_useState, 2),
        focus = _useState2[0],
        setFocus = _useState2[1];

    var _onFocus = function _onFocus(event, active, pressed) {
      var invokeCustom = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true; // set focus as true ONLY when the button is tabbed in and not in active or pressed state

      setFocus(!active && !pressed); // invoke custom focus handler if provided

      invokeCustom && onFocus && onFocus(event);
    };

    var _onBlur = function _onBlur(event) {
      setFocus(false); // invoke custom blur handler if provided

      onBlur && onBlur(event);
    };

    return [focus, _onFocus, _onBlur];
  };
  /**
   * Custom hook to manage the active state of button
   * Active state is when a button "is being" clicked with the left mouse button, or with the space key down 
   */


  var useActiveState = function useActiveState(_ref5) {
    var onKeyDown = _ref5.onKeyDown,
        onMouseDown = _ref5.onMouseDown,
        onKeyUp = _ref5.onKeyUp,
        onMouseUp = _ref5.onMouseUp;

    var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useState"])(false),
        _useState4 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default()(_useState3, 2),
        active = _useState4[0],
        setActive = _useState4[1]; // mousedown and keydown handler to check if the button is active


    var checkIfActive = function checkIfActive(event) {
      // set the button as "active" if left mouse button down or space key down
      if (event.nativeEvent.which === __WEBPACK_IMPORTED_MODULE_6__tal_gel_core__["LEFT_MOUSE_BUTTON"] || event.nativeEvent.which === __WEBPACK_IMPORTED_MODULE_6__tal_gel_core__["SPACE"]) {
        setActive(true);
      } // if the event is MouseEvent, invoke custom mousedown handler if provided


      event.nativeEvent instanceof MouseEvent && onMouseDown && onMouseDown(event); // if the event is KeyboardEvent, invoke custom keydown handler if provided

      event.nativeEvent instanceof KeyboardEvent && onKeyDown && onKeyDown(event);
    }; // mouseup and keyup handler to check if the button is inactive


    var checkIfInactive = function checkIfInactive(event) {
      // set the button as "inactive" if left mouse button up or space key up
      if (event.nativeEvent.which === __WEBPACK_IMPORTED_MODULE_6__tal_gel_core__["LEFT_MOUSE_BUTTON"] || event.nativeEvent.which === __WEBPACK_IMPORTED_MODULE_6__tal_gel_core__["SPACE"]) {
        setActive(false);
      } // if the event is MouseEvent, invoke custom mouseup handler if provided


      event.nativeEvent instanceof MouseEvent && onMouseUp && onMouseUp(event); // if the event is KeyboardEvent, invoke custom keyup handler if provided

      event.nativeEvent instanceof KeyboardEvent && onKeyUp && onKeyUp(event);
    };

    return [active, checkIfActive, checkIfInactive];
  };
  /**
   * Custom hook to manage the hover state of button
   * Hover state is when a button is being hovered by the mouse
   */


  var useHoverState = function useHoverState(_ref6) {
    var onMouseEnter = _ref6.onMouseEnter,
        onMouseLeave = _ref6.onMouseLeave;

    var _useState5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useState"])(false),
        _useState6 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default()(_useState5, 2),
        hover = _useState6[0],
        setHover = _useState6[1];

    var onHover = function onHover(event) {
      setHover(true); // invoke custom mouseover handler if provided

      onMouseEnter && onMouseEnter(event);
    };

    var onUnhover = function onUnhover(event) {
      setHover(false); // invoke custom mouseout handler if provided

      onMouseLeave && onMouseLeave(event);
    };

    return [hover, onHover, onUnhover];
  };

  var Button = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__tal_gel_theming__["withTheme"])(withStates(ButtonComponent));
  /***/

},
/* 289 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony export (binding) */

  __webpack_require__.d(__webpack_exports__, "a", function () {
    return CheckboxButtonGroup;
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(5);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__button_group__ = __webpack_require__(104);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4__utils_checkbox_radio_utils__ = __webpack_require__(67);

  var _excluded = ["labelLeft", "buttonsPerRow", "children"];
  /**
   * Non-adjacent checkbox buttons (with new button style)
   */

  var CheckboxButtonGroup = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function (_ref, forwardedRef) {
    var labelLeft = _ref.labelLeft,
        buttonsPerRow = _ref.buttonsPerRow,
        children = _ref.children,
        props = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default()(_ref, _excluded);

    var _useButtonLocationInG = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_checkbox_radio_utils__["b"
    /* useButtonLocationInGroup */
    ])(buttonsPerRow, children),
        isOnLastRow = _useButtonLocationInG.isOnLastRow,
        isOnRightMostCol = _useButtonLocationInG.isOnRightMostCol;

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__button_group__["a"
    /* ButtonGroup */
    ], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
      "data-cy": "gel-checkbox-button-group"
    }, props, {
      alternativeButtons: true,
      ref: forwardedRef
    }), __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.map(children, function (child, index) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(child, {
        alternativeButton: true,
        buttonsPerRow: buttonsPerRow,
        isOnLastRow: isOnLastRow(index),
        isOnRightMostCol: isOnRightMostCol(index),
        labelLeft: labelLeft
      });
    }));
  });

  CheckboxButtonGroup.displayName = 'CheckboxButtonGroup';
  /***/
},
/* 290 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony export (binding) */

  __webpack_require__.d(__webpack_exports__, "a", function () {
    return CheckboxGroup;
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(5);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__button_group__ = __webpack_require__(104);

  var _excluded = ["button", "children"];
  /**
   * Checkbox group for checkboxes
   * Even though Checkbox component can be used outside a CheckboxGroup,
   * it is recommended to have Checkbox wrapped by CheckboxGroup for GEL form support
   * 
   * Note that the direct use of ButtonGroup is deprecated
   */

  var CheckboxGroup = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function (_ref, forwardedRef) {
    var button = _ref.button,
        children = _ref.children,
        props = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default()(_ref, _excluded);

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__button_group__["a"
    /* ButtonGroup */
    ], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
      ref: forwardedRef
    }, props), button ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.map(children, function (child) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(child, {
        button: button
      });
    }) : children);
  });

  CheckboxGroup.displayName = 'CheckboxGroup';
  /***/
},
/* 291 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony export (binding) */

  __webpack_require__.d(__webpack_exports__, "a", function () {
    return Checkbox;
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(5);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__tal_gel_core__ = __webpack_require__(7);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__tal_gel_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__tal_gel_core__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4__tal_gel_theming__ = __webpack_require__(11);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4__tal_gel_theming___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__tal_gel_theming__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__button_group__ = __webpack_require__(104);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6__utils_checkbox_radio_utils__ = __webpack_require__(67);

  var _excluded = ["id", "checked", "defaultChecked", "indeterminate", "defaultIndeterminate", "error", "inverse", "disabled", "button", "groupContext", "onChange", "onChangeCheck", "onChangeUncheck", "onFocus", "onBlur", "onKeyDown", "alternativeButton", "caption", "buttonsPerRow", "isOnLastRow", "isOnRightMostCol", "labelLeft", "style", "children"]; // TODO: readOnly?

  var CheckboxComponent = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function (_ref, forwardedRef) {
    var id = _ref.id,
        checked = _ref.checked,
        defaultChecked = _ref.defaultChecked,
        indeterminate = _ref.indeterminate,
        defaultIndeterminate = _ref.defaultIndeterminate,
        error = _ref.error,
        inverse = _ref.inverse,
        disabled = _ref.disabled,
        button = _ref.button,
        _ref$groupContext = _ref.groupContext,
        groupContext = _ref$groupContext === void 0 ? {} : _ref$groupContext,
        onChange = _ref.onChange,
        onChangeCheck = _ref.onChangeCheck,
        onChangeUncheck = _ref.onChangeUncheck,
        onFocus = _ref.onFocus,
        onBlur = _ref.onBlur,
        onKeyDown = _ref.onKeyDown,
        alternativeButton = _ref.alternativeButton,
        caption = _ref.caption,
        buttonsPerRow = _ref.buttonsPerRow,
        isOnLastRow = _ref.isOnLastRow,
        isOnRightMostCol = _ref.isOnRightMostCol,
        labelLeft = _ref.labelLeft,
        style = _ref.style,
        children = _ref.children,
        props = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default()(_ref, _excluded);

    var buttonLooking = isButtonLooking(button, groupContext);

    var indexRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react__["useRef"])();

    if (groupContext.indexAssignmentDone && !groupContext.indexAssignmentDone.current) {
      indexRef.current = groupContext.index.current++;
    }

    var index = indexRef.current;
    var submitCheck = groupContext.submitCheck;
    error = groupContext.required ? groupContext.error : error;

    var _useCrCommon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_checkbox_radio_utils__["c"
    /* useCrCommon */
    ])({
      groupContext: groupContext,
      error: error,
      inverse: inverse,
      disabled: disabled,
      onFocus: onFocus,
      onBlur: onBlur,
      buttonLooking: buttonLooking,
      forwardedRef: forwardedRef
    }),
        focusByClick = _useCrCommon.focusByClick,
        setFocusByClick = _useCrCommon.setFocusByClick,
        buttonCosmeticFocus = _useCrCommon.buttonCosmeticFocus,
        setIgnoreCosmeticFocus = _useCrCommon.setIgnoreCosmeticFocus,
        getInputRef = _useCrCommon.getInputRef,
        groupRelatedProps = _useCrCommon.groupRelatedProps,
        _onFocus = _useCrCommon._onFocus,
        _onBlur = _useCrCommon._onBlur;

    var forceUpdate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__tal_gel_core__["useForceUpdate"])();

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react__["useEffect"])(function () {
      if (!buttonLooking) {
        // if not button looking

        /**
         * Set indeterminate state of the input as controlled value, 
         * if indeterminate state is controlled by the parent component.
         * Or set it as the value of defaultIndeterminate if not controlled
         * 
         * defaultIndeterminate is falsy by default.
         */
        getInputRef().current.indeterminate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_checkbox_radio_utils__["a"
        /* isControlledState */
        ])(indeterminate) ? indeterminate : !!defaultIndeterminate;
      }
    }, [indeterminate]); // observe changes of the indeterminate prop


    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react__["useEffect"])(function () {
      // Report its `checked` status to the checkbox group, 
      // but do NOT trigger `onChange` from validator
      getInputRef().current && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__tal_gel_core__["isFunction"])(groupContext.onChange) && groupContext.onChange(index, getInputRef().current.checked, true);
    });

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react__["useEffect"])(function () {
      if (submitCheck && getInputRef()) {
        // `focus()` first, otherwise `blur()` 
        // doesn't do anything (won't trigger onBlur)
        getInputRef().current.focus();
        getInputRef().current.blur();
      } // Show error if error exists, upon click of the submit button in the form

    }, [submitCheck]);
    /**
     * Hanlder to invoke when the hidden input is clicked (or via the label click)
     */


    var _onChange = function _onChange(event) {
      if (!buttonLooking && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_checkbox_radio_utils__["a"
      /* isControlledState */
      ])(indeterminate)) {
        /**
         * If indeterminate state is controlled by the parent component,
         * we do not allow internal changes of this state
         */
        getInputRef().current.indeterminate = indeterminate;

        if (indeterminate) {
          // if indeterminate, restore checked status back to before onChange
          getInputRef().current.checked = !event.target.checked;
        }
      } else {
        getInputRef().current.indeterminate = false;

        if (event.target.checked) {
          // call onChangeCheck handler if checkbox is checked
          onChangeCheck && onChangeCheck();
        } else {
          // call onChangeUncheck handler if checkbox is unchecked
          onChangeUncheck && onChangeUncheck();
        } // call onChange handler provided by the parent component


        onChange && onChange(event);
      } // Report its `checked` status to the checkbox group, 
      // and trigger `onChange` from validator


      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__tal_gel_core__["isFunction"])(groupContext.onChange) && groupContext.onChange(index, event.target.checked, false, event);
    };
    /**
     * Checks if checkbox is in the indeterminate state
     */


    var isIndeterminate = function isIndeterminate() {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_checkbox_radio_utils__["a"
      /* isControlledState */
      ])(indeterminate)) {
        /**
         * If the indeterminate state is controlled by the parent component,
         * return the controlled value 
         */
        return indeterminate;
      }

      if (getInputRef().current) {
        /**
         * If the indeterminate state is not controlled by the parent component,
         * and if it is not for the first time rendering,
         * return the indeterminate state of the hidden input element
         */
        return getInputRef().current.indeterminate;
      }
      /**
       * If the indeterminate state is not controlled by the parent component,
       * but if it is for the first time rendering,
       * return the default indeterminate 
       */


      return defaultIndeterminate;
    };

    var _onFocusCheckbox = function _onFocusCheckbox(event) {
      if (focusByClick) {
        // if focused by mouse click
        handleIndeterminateOnClickOrOnSpaceDown();
      } // tell group there's a checkbox on focus, see comments on group context


      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__tal_gel_core__["isFunction"])(groupContext.onFocus) && groupContext.onFocus();

      _onFocus(event); // invoke the common onFocus callback

    };

    var _onKeyDown = function _onKeyDown(event) {
      if (event.keyCode == __WEBPACK_IMPORTED_MODULE_3__tal_gel_core__["SPACE"]) {
        // if space key
        handleIndeterminateOnClickOrOnSpaceDown();
      }

      onKeyDown && onKeyDown(event); // invoke onKeyDown callback provided by parent
    };
    /**
     * Provided that this function is called upon mouse click or space key down,
     * we force the checkbox to rerender if its indeterminate state is true 
     * when onFocus or onKeyDown is triggered.
     * 
     * This is because the indeterminate state of checkbox is not yet updated
     * when the onFocus or onKeyDown of checkbox is triggered. So if indeterminate
     * is currently true (whilst it should be false shortly after onFocus or onKeyDown), 
     * we manually set it to false and make the checkbox rerender 
     * (so that the icon type can change on time)
     */


    var handleIndeterminateOnClickOrOnSpaceDown = function handleIndeterminateOnClickOrOnSpaceDown() {
      if (!buttonLooking && getInputRef().current && getInputRef().current.indeterminate) {
        getInputRef().current.indeterminate = false;
        forceUpdate();
      }
    };

    var _onBlur_ = function _onBlur_(event) {
      // tell group there's a checkbox on blur, see comments on group context
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__tal_gel_core__["isFunction"])(groupContext.onBlur) && groupContext.onBlur();

      _onBlur(event);
    };

    var uniqueId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__tal_gel_core__["useUniqueId"])();

    if (id) uniqueId = id; // Override the generated unique id if id is specified 

    var isMounted = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__tal_gel_core__["useIsMounted"])();

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__utils_checkbox_radio_utils__["d"
    /* CrContainer */
    ], {
      style: style,
      groupContext: groupContext,
      buttonsPerRow: buttonsPerRow,
      isOnLastRow: isOnLastRow,
      isOnRightMostCol: isOnRightMostCol
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__utils_checkbox_radio_utils__["e"
    /* CrInput */
    ], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
      "data-cy": "gel-checkbox-input",
      id: isMounted ? uniqueId : null,
      type: "checkbox",
      ref: getInputRef(),
      focusByClick: focusByClick // whether the checkbox is focused by mouse click

    }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_checkbox_radio_utils__["a"
    /* isControlledState */
    ])(checked) ? {
      checked: checked
    } : {
      defaultChecked: defaultChecked
    }, buttonLooking && {
      button: true
    }, groupRelatedProps, {
      // such as error, inverse, disabled, etc.
      alternativeButton: alternativeButton,
      labelLeft: labelLeft,
      onChange: _onChange,
      onBlur: _onBlur_,
      onFocus: _onFocusCheckbox,
      onKeyDown: _onKeyDown
    }, props)), !buttonLooking ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__utils_checkbox_radio_utils__["f"
    /* CrLabel */
    ], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
      id: isMounted ? uniqueId : null // to be used in the label inside CrLabel
      ,
      theme: props.theme,
      target: "Checkbox",
      indeterminate: isIndeterminate() // prop to select icon based off

    }, groupRelatedProps, {
      // such as error, inverse, disabled, etc.
      alternativeButton: alternativeButton,
      labelLeft: labelLeft,
      caption: caption,
      children: children,
      onClick: function onClick() {
        return setFocusByClick(true);
      } // indicate that the checkbox is focused by mouse click

    })) : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__utils_checkbox_radio_utils__["g"
    /* CrButton */
    ], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
      id: isMounted ? uniqueId : null // to be used in the hidden label inside CrButton
      ,
      checkbox: true // for checkbox 
      ,
      groupContext: groupContext
    }, groupRelatedProps, {
      // such as error, inverse, disabled, etc.
      // indicate whether or not the button should be in cosmetic focus state
      cosmeticFocus: buttonCosmeticFocus,
      children: children // ignore cosmetic focus (focus style without the actual focus state)
      ,
      onClick: function onClick() {
        return setIgnoreCosmeticFocus(true);
      }
    })));
  });
  /**
   * Checks whether this checkbox is button looking or not
   * @param button: indicates if this checkbox is specified to be button looking
   * @param groupContext: checkbox group context (Checkbox group can be specified as buttonGroup)
   */


  var isButtonLooking = function isButtonLooking(button, groupContext) {
    return button || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_checkbox_radio_utils__["i"
    /* inButtonGroup */
    ])(groupContext);
  };

  var Checkbox = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__button_group__["b"
  /* withButtonGroupContext */
  ])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__tal_gel_theming__["withTheme"])(CheckboxComponent));

  Checkbox.displayName = 'Checkbox';
  /***/
},
/* 292 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony export (binding) */

  __webpack_require__.d(__webpack_exports__, "a", function () {
    return Collapsible;
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(5);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(283);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_taggedTemplateLiteral__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__emotion_styled__ = __webpack_require__(14);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__emotion_styled___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__emotion_styled__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6__tal_gel_theming__ = __webpack_require__(11);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6__tal_gel_theming___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__tal_gel_theming__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7__tal_gel_core__ = __webpack_require__(7);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7__tal_gel_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__tal_gel_core__);

  var _excluded = ["theme", "open", "disabled", "direction", "children"];

  var _templateObject;
  /**
   * Created and maintained by Kerrie Hui
   * kerrie.hui@tal.com.au
   */


  var AnimatedBox = __WEBPACK_IMPORTED_MODULE_5__emotion_styled___default.a.div(_templateObject || (_templateObject = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_taggedTemplateLiteral___default()(["\n  ", "\n"])), function (props) {
    return "transition: ".concat("max-".concat(props.dimension, " ").concat(props.speedProp, "ms, opacity ").concat(props.speedProp, "ms"), ";\n      opacity: ", props.open ? 1 : 0, ";\n      overflow: ").concat(props.animate || !props.open ? "hidden" : "visible", ";\n      max-").concat(props.dimension, ": ").concat(props.open ? "unset" : 0, ";\n    ");
  });

  var CollapsibleComponent = function CollapsibleComponent(_ref) {
    var theme = _ref.theme,
        openArg = _ref.open,
        disabled = _ref.disabled,
        direction = _ref.direction,
        children = _ref.children,
        props = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties___default()(_ref, _excluded);

    var containerRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useRef"])();

    var minSpeed = 200; // minimum speed of the animation in milliseconds 

    var baseline = 500; // default height used to calculate the optimal collapsible speed. Expects a number.

    var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useState"])(openArg),
        _useState2 = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default()(_useState, 2),
        open = _useState2[0],
        setOpen = _useState2[1];

    var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useState"])(false),
        _useState4 = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default()(_useState3, 2),
        animate = _useState4[0],
        setAnimate = _useState4[1];

    var _useState5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useState"])(),
        _useState6 = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default()(_useState5, 2),
        size = _useState6[0],
        setSize = _useState6[1];

    var _useState7 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useState"])(minSpeed),
        _useState8 = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default()(_useState7, 2),
        speed = _useState8[0],
        setSpeed = _useState8[1];

    var dimension = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useMemo"])(function () {
      return direction === "horizontal" ? "width" : "height";
    }, [direction]); // when the caller changes openArg, trigger animation


    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useEffect"])(function () {
      if (openArg !== open) {
        setAnimate(true);
        setOpen(openArg);
      }
    }, [open, openArg]); // When we animate, start a timer to clear out the animation when it
    // has finished.


    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useEffect"])(function () {
      if (animate) {
        var timer = setTimeout(function () {
          setAnimate(false);
          setSize(undefined);
          var container = containerRef.current;
          container.removeAttribute("style");
        }, speed);
        return function () {
          return clearTimeout(timer);
        };
      }

      return undefined;
    }, [animate, containerRef, speed]);

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useEffect"])(function () {
      if (animate) {
        var container = containerRef.current; // get the desired size by unsetting the max temporarily

        container.style["max-".concat(dimension)] = "unset";
        var rect = container.getBoundingClientRect();
        container.removeAttribute("style");
        var nextSize = rect[dimension]; // start with the max set to the size we are starting from

        container.style["max-".concat(dimension)] = open ? 0 : "".concat(nextSize, "px");
        setSize(nextSize);
        var nextSpeed = Math.max(nextSize / baseline * minSpeed, minSpeed);
        setSpeed(nextSpeed);
      }
    }, [animate, containerRef, dimension, open, theme]);

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__tal_gel_core__["useLayoutEffect"])(function () {
      if (animate && size) {
        var container = containerRef.current;
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            // Change the max to where we want to end up, the transition will
            // animate to get there. We do this in an animation frame to
            // give our starter setting a chance to fully render.
            container.style["max-".concat(dimension)] = open ? "".concat(size, "px") : 0;
          });
        });
      }
    }, [animate, containerRef, dimension, open, size]);

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(AnimatedBox, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
      "data-cy": "gel-collapsible",
      "aria-hidden": !open,
      ref: containerRef,
      open: open,
      animate: animate,
      dimension: dimension,
      speedProp: speed
    }, props), open || animate ? children : null);
  };

  var Collapsible = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__tal_gel_theming__["withTheme"])(CollapsibleComponent);
  /**
   * Renders a TGCL collapsible
   * @param direction - direction to animate the collapsible container, either horizontal or vertical
   * @param children - content of the collapsible container
   * @param open - whether or not the component should be open
   */

  /***/

},
/* 293 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony export (binding) */

  __webpack_require__.d(__webpack_exports__, "a", function () {
    return isAusVisa;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "b", function () {
    return isAusMastercard;
  });

  function _createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

    if (!it) {
      if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;

        var F = function F() {};

        return {
          s: F,
          n: function n() {
            if (i >= o.length) return {
              done: true
            };
            return {
              done: false,
              value: o[i++]
            };
          },
          e: function e(_e) {
            throw _e;
          },
          f: F
        };
      }

      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }

    var normalCompletion = true,
        didErr = false,
        err;
    return {
      s: function s() {
        it = it.call(o);
      },
      n: function n() {
        var step = it.next();
        normalCompletion = step.done;
        return step;
      },
      e: function e(_e2) {
        didErr = true;
        err = _e2;
      },
      f: function f() {
        try {
          if (!normalCompletion && it["return"] != null) it["return"]();
        } finally {
          if (didErr) throw err;
        }
      }
    };
  }

  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }

  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } // https://www.creditcardvalidator.org/country/au-australia


  var ausVisaPrefixes = ['401795', '405221', '407220', '413332', '413348', '414726', '423953', '436356', '443084', '443415', '443420', '443438', '443441', '443445', '443469', '450606', '450949', '451890', '455701', '456004', '456441', '456443', '456444', '456450', '456462', '456468', '456469', '456471', '456472', '456474', '457356', '458594', '462239', '462485', '464579', '472437', '472660', '472690', '477361', '486270', '494052', '494053', '43638410'];
  var ausMastercardPrefixes = ['512576', '514045', '514813', '516296', '516310', '516319', '516320', '516361', '516390', '519244', '521729', '523748', '528013', '529020', '529512', '532655', '535316', '535318', '535319', '540482', '543568', '544434', '544637', '544647', '546827', '550201', '552033', '555005', '558850'];

  var isAusVisa = function isAusVisa(value) {
    var _iterator = _createForOfIteratorHelper(ausVisaPrefixes),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var ausVisaPrefix = _step.value;

        if (value.indexOf(ausVisaPrefix) === 0) {
          return true;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return false;
  };

  var isAusMastercard = function isAusMastercard(value) {
    var _iterator2 = _createForOfIteratorHelper(ausMastercardPrefixes),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var ausMastercardPrefix = _step2.value;

        if (value.indexOf(ausMastercardPrefix) === 0) {
          return true;
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }

    return false;
  };
  /***/

},
/* 294 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony export (binding) */

  __webpack_require__.d(__webpack_exports__, "a", function () {
    return CreditCardNumberInput;
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(5);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__tal_gel_core__ = __webpack_require__(7);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__tal_gel_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__tal_gel_core__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6__text_input__ = __webpack_require__(46);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7__aus_credit_card_prefixes__ = __webpack_require__(293);

  var _excluded = ["onError", "errorMsg", "index", "resetValidator"];

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);

      if (enumerableOnly) {
        symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
      }

      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  } // https://locastic.com/blog/how-to-check-credit-card-type-with-javascript/


  var visa = new RegExp('^4[0-9]{12}(?:[0-9]{3})?$');
  var mastercard = new RegExp('^5[1-5][0-9]{14}$');
  var mastercard2 = new RegExp('^2[2-7][0-9]{14}$');
  var amex = new RegExp('^3[47][0-9]{13}$'); // not being used

  var isValidVisa = function isValidVisa(value) {
    return value && visa.test(removeSpaces(value));
  };

  var isValidMastercard = function isValidMastercard(value) {
    var _value = removeSpaces(value);

    return _value && (mastercard.test(_value) || mastercard2.test(_value));
  };

  var removeSpaces = function removeSpaces(value) {
    return value.replace(/\s/g, '');
  };

  var CreditCardNumberInputComponent = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.forwardRef(function (_ref, forwardedRef) {
    var onError = _ref.onError,
        errorMsg = _ref.errorMsg,
        index = _ref.index,
        resetValidator = _ref.resetValidator,
        props = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties___default()(_ref, _excluded);

    var mask = '9999 9999 9999 9999';
    var maskPlaceholder = '';

    var _useUnderlyingError = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__tal_gel_core__["useUnderlyingError"])(onError),
        onErrorUnderlying = _useUnderlyingError.onErrorUnderlying,
        onErrorWrapping = _useUnderlyingError.onErrorWrapping;

    var _useValidator = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__tal_gel_core__["useValidator"])(_objectSpread(_objectSpread({}, props), {}, {
      // includes controlled `error`, `caption`, `value`, `defaultValue`, `setValidity`, etc.
      index: index,
      // index assigned by the form 
      reset: resetValidator,
      // whether to reset the validator (`touched` status, etc.)
      checkError: true,
      // tells validator to always check for error
      hasError: function hasError(valueToCheck) {
        // tells validator HOW to check for error
        // `required` error will have been checked by the underling TextInput
        if (valueToCheck && !isValidVisa(valueToCheck) && !isValidMastercard(valueToCheck)) {
          return 'format';
        }

        return false;
      },
      hideErrorInitially: true,
      // tells validator to hide error initially
      onError: onErrorWrapping,
      // tells validator the callback to invoke if error occurs or disappears
      errorMsg: errorMsg // tells validator the error message to include in caption if error occurs

    })),
        _useValidator2 = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray___default()(_useValidator, 4),
        onBlur = _useValidator2[0],
        onChange = _useValidator2[1],
        getCaption = _useValidator2[2],
        shouldShowError = _useValidator2[3];

    var _onChange = function _onChange(event) {
      onChange({
        target: {
          name: event.target.name,
          value: removeSpaces(event.target.value)
        }
      });
    };

    var getCreditCardType = function getCreditCardType() {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__aus_credit_card_prefixes__["a"
      /* isAusVisa */
      ])(props.value)) return 'Visa';
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__aus_credit_card_prefixes__["b"
      /* isAusMastercard */
      ])(props.value)) return 'Mastercard';
      return 'Card';
    };

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__text_input__["a"
    /* default */
    ], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
      "data-cy": "gel-cc-number-input",
      autoComplete: "cc-number",
      mask: mask,
      maskPlaceholder: maskPlaceholder,
      ref: forwardedRef
    }, props, index !== undefined && {
      index: index + '_0'
    }, {
      // assign a sub index to the underling TextInput
      resetValidator: resetValidator,
      prefixIcon: getCreditCardType(),
      onChange: _onChange,
      onBlur: onBlur,
      caption: getCaption(),
      error: shouldShowError(),
      onError: onErrorUnderlying,
      errorMsg: errorMsg
    }));
  });

  var CreditCardNumberInput = CreditCardNumberInputComponent;
  /***/
},
/* 295 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony export (binding) */

  __webpack_require__.d(__webpack_exports__, "a", function () {
    return CvvInput;
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(5);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__tal_gel_core__ = __webpack_require__(7);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__tal_gel_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__tal_gel_core__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6__text_input__ = __webpack_require__(46);

  var _excluded = ["value", "defaultValue", "onError", "errorMsg", "index", "resetValidator"];

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);

      if (enumerableOnly) {
        symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
      }

      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  var digitOnlyMaxFour = new RegExp('^[0-9]{0,4}$');

  var isDigitOnlyMaxFour = function isDigitOnlyMaxFour(value) {
    return digitOnlyMaxFour.test(value);
  };

  var CvvInputComponent = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.forwardRef(function (_ref, forwardedRef) {
    var value = _ref.value,
        defaultValue = _ref.defaultValue,
        onError = _ref.onError,
        errorMsg = _ref.errorMsg,
        index = _ref.index,
        resetValidator = _ref.resetValidator,
        props = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties___default()(_ref, _excluded);

    var _useUnderlyingError = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__tal_gel_core__["useUnderlyingError"])(onError),
        onErrorUnderlying = _useUnderlyingError.onErrorUnderlying,
        onErrorWrapping = _useUnderlyingError.onErrorWrapping;

    var _useValidator = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__tal_gel_core__["useValidator"])(_objectSpread(_objectSpread({}, props), {}, {
      // includes controlled `error`, `caption`, `setValidity`, etc.
      index: index,
      // index assigned by the form 
      reset: resetValidator,
      // whether to reset the validator (`touched` status, etc.)
      value: value,
      defaultValue: defaultValue,
      checkError: true,
      // tells validator whether to check for error
      // tells validator HOW to check for error
      hasError: function hasError(value) {
        if (value && value.length !== 3 && value.length !== 4) {
          return 'length';
        }
      },
      hideErrorInitially: true,
      // tells validator to hide error initially
      onError: onErrorWrapping,
      // tells validator the callback to invoke if error occurs or disappears
      errorMsg: errorMsg // tells validator the error message to include in caption if error occurs

    })),
        _useValidator2 = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray___default()(_useValidator, 4),
        onBlur = _useValidator2[0],
        onChange = _useValidator2[1],
        getCaption = _useValidator2[2],
        shouldShowError = _useValidator2[3];

    var initialInternalValue = '';

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__tal_gel_core__["useRunOnce"])(function () {
      if (!isControlled(value) && isControlled(defaultValue) && isDigitOnlyMaxFour(defaultValue)) {
        initialInternalValue = defaultValue;
      }
    }); // 'internalValue' is to be used if 'value' prop is not controlled by the parent


    var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useState"])(initialInternalValue),
        _useState2 = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray___default()(_useState, 2),
        internalValue = _useState2[0],
        setInternalValue = _useState2[1];

    if (isControlled(value) && !isDigitOnlyMaxFour(value)) {
      // If 'value' is controlled by the parent 
      // but if the 'value' provided is not digit only,
      // reset the controlled 'value' to empty string
      value = '';
    }

    var getValue = function getValue() {
      return isControlled(value) ? value : internalValue;
    };

    var _onChange = function _onChange(event) {
      if (isDigitOnlyMaxFour(event.target.value)) {
        if (!isControlled(value)) {
          setInternalValue(event.target.value);
        }

        onChange(event);
      }
    }; // Control the value of the TextInput wrapped inside
    // with either the internal valid value managed by CvvInput,
    // or with the 'value' prop of CvvInput controlled by the 
    // parent of CvvInput


    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__text_input__["a"
    /* default */
    ], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
      "data-cy": "gel-cvv-input",
      autoComplete: "cc-csc",
      ref: forwardedRef
    }, props, index !== undefined && {
      index: index + '_0'
    }, {
      // assign a sub index to the underling TextInput
      resetValidator: resetValidator,
      value: getValue(),
      onChange: _onChange,
      onBlur: onBlur,
      caption: getCaption(),
      error: shouldShowError(),
      onError: onErrorUnderlying,
      errorMsg: errorMsg
    }));
  });

  var isControlled = function isControlled(prop) {
    return prop !== undefined;
  };

  var CvvInput = CvvInputComponent;
  /***/
},
/* 296 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony export (binding) */

  __webpack_require__.d(__webpack_exports__, "a", function () {
    return DateInput;
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(5);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__tal_gel_core__ = __webpack_require__(7);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__tal_gel_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__tal_gel_core__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6__text_input__ = __webpack_require__(46);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7__date_input_standard_date_input_standard__ = __webpack_require__(185);

  var _excluded = ["value", "defaultValue", "onFocus", "gt", "gte", "lt", "lte", "onError", "errorMsg", "compareErrorMsg", "index", "resetValidator", "required", "monthYear"];

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);

      if (enumerableOnly) {
        symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
      }

      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  var DateInputComponent = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.forwardRef(function (_ref, forwardedRef) {
    var value = _ref.value,
        defaultValue = _ref.defaultValue,
        onFocus = _ref.onFocus,
        gt = _ref.gt,
        gte = _ref.gte,
        lt = _ref.lt,
        lte = _ref.lte,
        onError = _ref.onError,
        errorMsg = _ref.errorMsg,
        compareErrorMsg = _ref.compareErrorMsg,
        index = _ref.index,
        resetValidator = _ref.resetValidator,
        required = _ref.required,
        monthYear = _ref.monthYear,
        props = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties___default()(_ref, _excluded);

    var mask = !monthYear ? '99/99/9999' : '99/99';
    var maskPlaceholder = !monthYear ? 'DD/MM/YYYY' : 'MM/YY';
    var invalidDateDefault = !monthYear ? '0000-00-00' : '0000-00';

    var _useUnderlyingError = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__tal_gel_core__["useUnderlyingError"])(onError),
        onErrorUnderlying = _useUnderlyingError.onErrorUnderlying,
        onErrorWrapping = _useUnderlyingError.onErrorWrapping;

    var initialDisplayDate = '';

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__tal_gel_core__["useRunOnce"])(function () {
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__date_input_standard_date_input_standard__["a"
      /* isControlled */
      ])(value) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__date_input_standard_date_input_standard__["a"
      /* isControlled */
      ])(defaultValue) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__date_input_standard_date_input_standard__["b"
      /* isValidDate */
      ])(!monthYear ? defaultValue : addDayToMonthYear(defaultValue))) {
        // If 'value' is not controlled by the parent, 
        // and if provided with a valid default value,
        // we set it as the 'initialDisplayDate' (DD/MM/YYYY) 
        // for the input box
        initialDisplayDate = formatToDisplayDate(defaultValue, monthYear); // YYYY-MM-DD to DD/MM/YYYY
      }
    }); // 'displayDate' is the display date value if 'value' is not controlled by the parent


    var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useState"])(initialDisplayDate),
        _useState2 = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray___default()(_useState, 2),
        displayDate = _useState2[0],
        setDisplayDate = _useState2[1]; // `optionalDisplayDate` is the display date value if 'value' is 
    // controlled by the parent but is currently invalid


    var optionalDisplayDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useRef"])(initialDisplayDate);

    var _useValidator = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__tal_gel_core__["useValidator"])(_objectSpread(_objectSpread({}, props), {}, {
      // includes controlled `error`, `caption`, `setValidity`, etc.
      index: index,
      // index assigned by the form 
      reset: resetValidator,
      // whether to reset the validator (`touched` status, etc.)
      value: value,
      // date in the format of 'YYYY-MM-DD'
      defaultValue: defaultValue,
      // date in the format of 'YYYY-MM-DD'
      checkError: true,
      // tells validator whether to check for errors
      hasError: function hasError(value) {
        // tells validator HOW to check for errors
        if (value === '') {
          optionalDisplayDate.current = '';
        }

        if (!isInternalDate(value, monthYear)) {
          // if value is not of format YYYY-MM-DD
          value = formatToInternalDate( // turn it into YYYY-MM-DD
          optionalDisplayDate.current, maskPlaceholder, invalidDateDefault, monthYear);
        }

        if (value === '') {
          // value not provided
          // `props.required` won't be passed on to the 
          // underlying TextInput due to mask placeholder
          if (required) {
            return 'required';
          }

          return false;
        } else if (value === invalidDateDefault) {
          // invalid value
          return 'format';
        } else {
          return !monthYear ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__date_input_standard_date_input_standard__["c"
          /* checkCompareError */
          ])({
            value: value,
            gt: gt,
            gte: gte,
            lt: lt,
            lte: lte
          }) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__date_input_standard_date_input_standard__["c"
          /* checkCompareError */
          ])({
            value: addDayToMonthYear(value),
            gt: addDayToMonthYear(gt),
            gte: addDayToMonthYear(gte),
            lt: addDayToMonthYear(lt),
            lte: addDayToMonthYear(lte)
          });
        }
      },
      hideErrorInitially: true,
      // tells validator to hide error initially
      onError: onErrorWrapping,
      // tells validator the callback to invoke if error occurs or disappears
      errorMsg: _objectSpread({
        // tells validator the error message to include in caption if error occurs
        compare: compareErrorMsg
      }, errorMsg)
    })),
        _useValidator2 = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray___default()(_useValidator, 4),
        onBlur = _useValidator2[0],
        onChange = _useValidator2[1],
        getCaption = _useValidator2[2],
        shouldShowError = _useValidator2[3];

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__date_input_standard_date_input_standard__["a"
    /* isControlled */
    ])(value) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__date_input_standard_date_input_standard__["b"
    /* isValidDate */
    ])(!monthYear ? value : addDayToMonthYear(value))) {
      // If 'value' is controlled by the parent 
      // but if the 'value' provided is not a valid date,
      // reset the controlled 'value' to empty string
      value = '';
    }

    var _onBlur = function _onBlur(event) {
      onBlur({
        target: {
          name: event.target.name,
          value: formatToInternalDate(event.target.value, maskPlaceholder, invalidDateDefault, monthYear)
        }
      });
    };

    var _onChange = function _onChange(event) {
      // Add `0` to day if first number >= 4
      // add `0` to month if first number >= 2
      // also adjust caret position if `0` was added
      var autoFilledValue = !monthYear ? autoFillDayMonth(event.target) : autoFillMonth(event.target);

      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__date_input_standard_date_input_standard__["a"
      /* isControlled */
      ])(value)) {
        setDisplayDate(autoFilledValue);
      }

      optionalDisplayDate.current = autoFilledValue;
      onChange({
        target: {
          name: event.target.name,
          value: formatToInternalDate(optionalDisplayDate.current, maskPlaceholder, invalidDateDefault, monthYear)
        }
      });
    };

    var getValue = function getValue() {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__date_input_standard_date_input_standard__["a"
      /* isControlled */
      ])(value)) {
        if (value === '' || value === invalidDateDefault) {
          return optionalDisplayDate.current; // for example: '06/MM/YYYY'
        }

        return formatToDisplayDate(value, monthYear);
      }

      return displayDate;
    };

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useEffect"])(function () {
      if (resetValidator) {
        optionalDisplayDate.current = '';
      }
    }, [resetValidator]);

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__text_input__["a"
    /* default */
    ], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
      "data-cy": "gel-date-input"
    }, monthYear && {
      autoComplete: 'cc-exp'
    }, {
      mask: mask,
      maskPlaceholder: maskPlaceholder,
      alwaysShowMask: true,
      ref: forwardedRef
    }, props, index !== undefined && {
      index: index + '_0'
    }, {
      // assign a sub index (for GelForm) to the underling TextInput
      resetValidator: resetValidator,
      value: getValue(),
      onChange: _onChange,
      onBlur: _onBlur,
      caption: getCaption(),
      error: shouldShowError(),
      onError: onErrorUnderlying,
      errorMsg: errorMsg
    }));
  });
  /**
   * Add 01 as day in the monthYear mode
   * 
   * To blend in with the algorithm for day month year,
   * we sometimes need to add `01` as day make the date
   * complete.
   */


  var addDayToMonthYear = function addDayToMonthYear(value) {
    return value && "".concat(value, "-01");
  };
  /**
   * Add `0` to day if first number >= 4
   * add `0` to month if first number >= 2
   * also adjust caret position if `0` was added 
   */


  var autoFillDayMonth = function autoFillDayMonth(target) {
    var splits = target.value.split('/');
    var firstCharDay = parseInt(splits[0].charAt(0));
    var firstCharMonth = parseInt(splits[1].charAt(0));
    var day = isNaN(firstCharDay) ? -1 : firstCharDay;
    var month = isNaN(firstCharMonth) ? -1 : firstCharMonth;
    var filledDay = day >= 4 ? "0".concat(day) : splits[0];
    var filledMonth = month >= 2 ? "0".concat(month) : splits[1];

    if (day >= 4 || month >= 2) {
      var caretPos = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__tal_gel_core__["getCaretPos"])(target); // DD/MM/YYYY


      var timer = setTimeout(function () {
        if (caretPos < 6) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__tal_gel_core__["setCaretPos"])(target, caretPos + 2);
        } else {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__tal_gel_core__["setCaretPos"])(target, caretPos);
        }

        clearTimeout(timer);
      });
    }

    return "".concat(filledDay, "/").concat(filledMonth, "/").concat(splits[2]);
  };
  /**
   * Add `0` to month if first number >= 2
   * also adjust caret position if `0` was added 
   * 
   * Used for monthYear
   */


  var autoFillMonth = function autoFillMonth(target) {
    var splits = target.value.split('/');
    var firstCharMonth = parseInt(splits[0].charAt(0));
    var month = isNaN(firstCharMonth) ? -1 : firstCharMonth;
    var filledMonth = month >= 2 ? "0".concat(month) : splits[0];

    if (month >= 2) {
      var caretPos = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__tal_gel_core__["getCaretPos"])(target); // MM/YY


      var timer = setTimeout(function () {
        if (caretPos < 2) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__tal_gel_core__["setCaretPos"])(target, caretPos + 2);
        } else {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__tal_gel_core__["setCaretPos"])(target, caretPos);
        }

        clearTimeout(timer);
      });
    }

    return "".concat(filledMonth, "/").concat(splits[1]);
  };

  var isInternalDate = function isInternalDate(date, monthYear) {
    if (!date) return false;
    return !monthYear ? date.split('-').length === 3 : date.split('-').length === 2;
  };
  /**
   * DD/MM/YYYY to YYYY-MM-DD 
   */


  var formatToInternalDate = function formatToInternalDate(displayDate, maskPlaceholder, invalidDateDefault, monthYear) {
    if (!displayDate || displayDate === maskPlaceholder) {
      return ''; // value not provided
    }

    var splits = displayDate.split('/');

    if (!monthYear && (isNaN(parseInt(splits[0])) || isNaN(parseInt(splits[1])) || isNaN(parseInt(splits[2]))) || monthYear && (isNaN(parseInt(splits[0])) || isNaN(parseInt(splits[1])))) {
      // for example: `31/MM/YYYY`
      return invalidDateDefault; // value provided but invalid 
    }

    var internalDate = !monthYear ? "".concat(splits[2], "-").concat(splits[1], "-").concat(splits[0]) : "20".concat(splits[1], "-").concat(splits[0]);

    if (isNaN(Date.parse(!monthYear ? internalDate : addDayToMonthYear(internalDate)))) {
      // for example, `2021-01-32` won't be accepted as valid
      return invalidDateDefault; // value provided but invalid
    }

    return internalDate; // of format YYYY-MM-DD and it's a valid date
  };
  /**
   * YYYY-MM-DD to DD/MM/YYYY
   */


  var formatToDisplayDate = function formatToDisplayDate(internalDate, monthYear) {
    var splits = internalDate.split('-');

    if (!monthYear && (isNaN(parseInt(splits[0])) || isNaN(parseInt(splits[1])) || isNaN(parseInt(splits[2]))) || monthYear && (isNaN(parseInt(splits[0])) || isNaN(parseInt(splits[1])))) {
      return '';
    }

    if (isNaN(Date.parse(!monthYear ? internalDate : addDayToMonthYear(internalDate)))) {
      // for example, `2021-01-32` won't be accepted as valid
      return '';
    }

    return !monthYear ? "".concat(splits[2], "/").concat(splits[1], "/").concat(splits[0]) : "".concat(splits[1], "/").concat(splits[0].slice(2)) // remove the prefix `20`
    ;
  };

  var DateInput = DateInputComponent;
  /***/
},
/* 297 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony export (binding) */

  __webpack_require__.d(__webpack_exports__, "a", function () {
    return Dropdown;
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(5);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(102);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_slicedToArray__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_objectWithoutProperties__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6__emotion_styled__ = __webpack_require__(14);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6__emotion_styled___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__emotion_styled__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7__tal_gel_core__ = __webpack_require__(7);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7__tal_gel_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__tal_gel_core__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_8__tal_gel_theming__ = __webpack_require__(11);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_8__tal_gel_theming___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__tal_gel_theming__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_9__text_input__ = __webpack_require__(46);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_10__checkbox__ = __webpack_require__(175);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_11__layout__ = __webpack_require__(73);

  var _excluded = ["multiSelect", "value", "defaultValue", "options", "onChange", "defaultSelectAll", "optionSelectAll", "required", "min", "max", "requiredErrorMsg", "errorMsg", "onError", "resetValidator", "index", "name", "submitCheck", "onExpand", "onCollapse", "action", "applyAction", "extraHeightToAvoid"];

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);

      if (enumerableOnly) {
        symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
      }

      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  } // TODO: ESC key, Enter key etc.
  // TODO: Other modes apart from `multiSelect`


  var DropdownComponent = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react___default.a.forwardRef(function (_ref, forwardedRef) {
    var multiSelect = _ref.multiSelect,
        value = _ref.value,
        defaultValue = _ref.defaultValue,
        _ref$options = _ref.options,
        options = _ref$options === void 0 ? [] : _ref$options,
        onChange = _ref.onChange,
        defaultSelectAll = _ref.defaultSelectAll,
        optionSelectAll = _ref.optionSelectAll,
        required = _ref.required,
        min = _ref.min,
        max = _ref.max,
        requiredErrorMsg = _ref.requiredErrorMsg,
        errorMsg = _ref.errorMsg,
        onError = _ref.onError,
        resetValidator = _ref.resetValidator,
        index = _ref.index,
        name = _ref.name,
        submitCheck = _ref.submitCheck,
        onExpand = _ref.onExpand,
        onCollapse = _ref.onCollapse,
        action = _ref.action,
        applyAction = _ref.applyAction,
        extraHeightToAvoid = _ref.extraHeightToAvoid,
        props = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_objectWithoutProperties___default()(_ref, _excluded);

    var textInputRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react__["useRef"])();

    var separatorInDisplayValue = ', ';

    var getInputRef = function getInputRef() {
      return forwardedRef || textInputRef;
    };

    var savedValueForAction = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react__["useRef"])();

    var _useValidator = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__tal_gel_core__["useValidator"])(_objectSpread(_objectSpread({}, props), {}, {
      // includes controlled `error`, `caption`, etc.
      index: index,
      // index assigned by the form 
      name: name,
      onChange: onChange,
      reset: resetValidator,
      // whether to reset the validator (`touched` status, etc.)
      value: value,
      defaultValue: defaultValue,
      checkError: true,
      // tells validator whether to check for error
      hasError: function hasError(value) {
        // tells validator HOW to check for error
        if (value !== undefined) {
          if (typeof value === 'string') {
            if (isOpen) {
              // ignore if from onBlur and option list is open
              return false;
            } // if from onBlur and option list isn't open
            // if from onBlur and option list isn't open


            value = value.split(separatorInDisplayValue);

            if (value.length === 1 && value[0] === '') {
              // no value
              value = null;
            }
          } else if (Array.isArray(value) && typeof value[0] === 'boolean') {
            // if from onChange and if an array of booleans
            value = value.filter(function (_value) {
              return _value;
            });
          }
        } // `props.required` won't be passed on to the 
        // underlying TextInput as we are handling it here
        // `props.required` won't be passed on to the 
        // underlying TextInput as we are handling it here


        if (required && (!value || value.length === 0)) {
          return 'required';
        }

        if (value && (min !== undefined && value.length < min || max !== undefined && value.length > max)) {
          return 'count';
        }

        return false;
      },
      onError: onError,
      // tells validator the callback to invoke if error occurs or disappears
      errorMsg: _objectSpread({
        // tells validator the error message to include in caption if error occurs
        'required': requiredErrorMsg
      }, errorMsg),
      hideErrorInitially: true,
      // tells validator to hide the error initially
      submitCheck: {
        shouldTrigger: submitCheck,
        // empty object
        ref: getInputRef()
      }
    })),
        _useValidator2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_slicedToArray___default()(_useValidator, 4),
        onBlur = _useValidator2[0],
        _onChange = _useValidator2[1],
        getCaption = _useValidator2[2],
        shouldShowError = _useValidator2[3]; // Options can be either [{ label }] or [{ label, value }] (explicit value)


    var hasExplicitValues = function hasExplicitValues() {
      return options[0] && options[0].value !== undefined;
    }; // Generates an array of the same specified value


    var generateArrayOf = function generateArrayOf(value, length) {
      var result = [];

      for (var i = 0; i < length; i++) {
        result.push(value);
      }

      return result;
    }; // If no explict values in options, `value` or `defaultValue` can be, for example, 
    // [true, true] while options being [{ label: '1' }, { label: '2' }, { label: '3' }, { label: '4' }]
    // in which case we'd like `value` or `defaultValue` to be converted to [true, true, false, false]


    if ((value || defaultValue || []).length < options.length && !hasExplicitValues()) {
      if (value) {
        value = [].concat(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default()(value), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default()(generateArrayOf(false, options.length - value.length)));
      } else if (defaultValue) {
        defaultValue = [].concat(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default()(defaultValue), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default()(generateArrayOf(false, options.length - defaultValue.length)));
      }
    }

    var getInitialInternalValue = function getInitialInternalValue() {
      if (value) return []; // No need for internal value as this dropdown is controlled by `value`

      if (defaultValue) return defaultValue; // Uncontrolled, using defaultValue as the initial internal value

      if (defaultSelectAll) {
        // If selecting all by default
        if (!hasExplicitValues()) {
          return generateArrayOf(true, options.length); // [true...]
        } else {
          return options.map(function (_ref2) {
            var value = _ref2.value;
            return value;
          }); // Populate with each option value
        }
      }

      if (!hasExplicitValues()) {
        // [false...] if no defaults and options don't have explicit values
        return generateArrayOf(false, options.length);
      }

      return []; // if no defaults and options have explicit values
    };

    var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react__["useState"])(getInitialInternalValue()),
        _useState2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_slicedToArray___default()(_useState, 2),
        internalValue = _useState2[0],
        setInternalValue = _useState2[1];

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react__["useEffect"])(function () {
      if (applyAction && savedValueForAction.current) {
        _onChange({
          target: {
            name: name,
            value: savedValueForAction.current
          }
        });

        onOutsideClick();
      }
    }, [applyAction]);

    var getValue = function getValue(forDisplayInInput) {
      if (!action || !isOpen) {
        if (value !== undefined) {
          return value || [];
        }

        return internalValue || [];
      }

      if (forDisplayInInput && value !== undefined) {
        return value || [];
      } // Note that uncontrolled dropdown 
      // does not work with action/apply


      return internalValue || [];
    };

    var getDisplayValue = function getDisplayValue() {
      var checkedLabelList = [];

      if (!hasExplicitValues()) {
        // If options don't have explicit values
        // Pick option labels by true/false statuses sequentially
        checkedLabelList = getValue(true).map(function (isChecked, index) {
          return isChecked ? options[index] && options[index].label : null;
        }).filter(function (label) {
          return !!label;
        });
      } else {
        // If options have explicit values
        // Check through each option and if the option value exists in the value array,
        // pick the label of this option into `checkedLabelList`,
        // this will also ensure that the labels picked are in a sequential order
        options.forEach(function (_ref3) {
          var label = _ref3.label,
              _value = _ref3.value;

          if (getValue(true).findIndex(function (individualValue) {
            return individualValue === _value;
          }) >= 0) {
            checkedLabelList.push(label);
          }
        });
      } // If we want to display specific text (specified in `optionSelectAll`)
      // (eg: 'All' instead of all option labels) when all options are selected


      if (optionSelectAll) {
        shouldSelectAll.current = checkedLabelList.length === options.length;

        if (checkedLabelList.length === options.length) {
          // Check if all options are selected
          return optionSelectAll;
        }
      } // Otherwise, construct a comma separated string of the selected labels
      // no matter how many options are selected


      return checkedLabelList.reduce(function (result, label) {
        if (!result) {
          result = label;
        } else {
          result += "".concat(separatorInDisplayValue).concat(label);
        }

        return result;
      }, '');
    }; // The status of each checkbox is either true or false


    var getCheckboxStatusByIndex = function getCheckboxStatusByIndex(index) {
      if (!hasExplicitValues()) {
        return getValue()[index] || false;
      } else {
        // Check if the value of the corresponding option
        // exists in the value array. If it exists, true for the checkbox,
        // otherwise false for the checkbox
        return getValue().findIndex(function (_value) {
          return options[index].value === _value;
        }) >= 0;
      }
    };

    var onSelectionChange = function onSelectionChange(checked, index, _value) {
      var updatedValue = [];

      if (!hasExplicitValues()) {
        // No explicit values
        updatedValue = getValue().map(function (individualValue, _index) {
          // Find the one on change by index and update its status (true or false)
          return index === _index ? checked : individualValue;
        });
      } else if (checked) {
        // Have explicit values and the one on change is checked 
        // Ensure the sequential order by checking through options from the first to the last
        // Otherwise the newly selected label could not find a place 
        // to be inserted but to be appended to the end of the list
        options.forEach(function (_ref4) {
          var __value = _ref4.value;

          if (getValue().findIndex(function (individualValue) {
            return individualValue === __value;
          }) >= 0 || _value === __value) {
            // If already selected or if the value of the option equals the value specified
            updatedValue.push(__value);
          }
        });
      } else {
        // Ensure the sequential order by checking through options from the first to the last
        options.forEach(function (_ref5) {
          var __value = _ref5.value;

          if (getValue().findIndex(function (individualValue) {
            return individualValue === __value;
          }) >= 0 && _value !== __value) {
            // If already selected but the value of the option does not equal the value specified
            // so it effectively kicks out the one that just got unchecked
            updatedValue.push(__value);
          }
        });
      } // Note that we do not assume the value of `shouldSelectAll` at this stage if 
      // dropdown is controled, because the `updatedValue` is not guaranteed to 
      // be not modified by the parent (the controlling component)


      if (value === undefined || action) {
        setInternalValue(updatedValue);

        if (!hasExplicitValues()) {
          // Check if updatedValue is an array of true
          shouldSelectAll.current = !updatedValue.some(function (individualValue) {
            return !individualValue;
          });
        } else {
          shouldSelectAll.current = updatedValue.length === options.length;
        }
      }

      if (!action) {
        _onChange({
          target: {
            name: name,
            value: updatedValue
          }
        });
      } else {
        savedValueForAction.current = updatedValue;
      }
    };

    var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react__["useState"])(false),
        _useState4 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_slicedToArray___default()(_useState3, 2),
        isOpen = _useState4[0],
        setIsOpen = _useState4[1];

    var _useState5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react__["useState"])(),
        _useState6 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_slicedToArray___default()(_useState5, 2),
        focusOnInput = _useState6[0],
        setFocusOnInput = _useState6[1];

    var onOutsideClick = function onOutsideClick() {
      setIsOpen(false);
      setFocusOnInput({}); // new object triggers it
    };

    var firstRender = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react__["useRef"])(true);

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react__["useEffect"])(function () {
      if (!firstRender.current) {
        if (isOpen) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__tal_gel_core__["isFunction"])(onExpand) && onExpand();

          if (action && value !== undefined) {
            setInternalValue(value);
            savedValueForAction.current = null;
          }
        } else {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__tal_gel_core__["isFunction"])(onCollapse) && onCollapse();
        }
      }

      firstRender.current = false;
    }, [isOpen]);

    var uniqueIds = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__tal_gel_core__["useUniqueId"])(options.length); // Unique ids for the checkboxes


    var isMounted = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__tal_gel_core__["useIsMounted"])();

    var _useRenderOnTop = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__tal_gel_core__["useRenderOnTop"])({
      // Checks whether the dropdown should be displayed below or above the input
      PageLayoutContext: __WEBPACK_IMPORTED_MODULE_11__layout__["f"
      /* PageLayoutContext */
      ],
      // Extra height to be added to the height of dropdown to 
      // determine whether the dropdown should be below or above 
      // the input. This gives users more flexibility as to how 
      // to determine the dropdown is too long to be displayed
      // below the input
      extraHeightToAvoid: extraHeightToAvoid
    }),
        targetRef = _useRenderOnTop.targetRef,
        shouldRenderOnTop = _useRenderOnTop.shouldRenderOnTop,
        getTargetHeight = _useRenderOnTop.getTargetHeight;

    var shouldSelectAll = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react__["useRef"])(false);

    var selectAll = function selectAll() {
      var updatedValue = hasExplicitValues() ? options.map(function (_ref6) {
        var value = _ref6.value;
        return value;
      }) : generateArrayOf(true, options.length);

      if (!action) {
        _onChange({
          target: {
            name: name,
            value: updatedValue
          }
        });
      } else {
        savedValueForAction.current = updatedValue;
      }

      if (value === undefined || action) {
        setInternalValue(updatedValue);
        shouldSelectAll.current = true;
      } // does not assume true if component is controlled (See onSelectionChange)

    };

    var unselectAll = function unselectAll() {
      var updatedValue = hasExplicitValues() ? [] : generateArrayOf(false, options.length);

      if (!action) {
        _onChange({
          target: {
            name: name,
            value: updatedValue
          }
        });
      } else {
        savedValueForAction.current = updatedValue;
      }

      if (value === undefined || action) {
        setInternalValue(updatedValue);
        shouldSelectAll.current = false;
      } // does not assume false if component is controlled (See onSelectionChange)

    };

    var getTextInputHeight = function getTextInputHeight() {
      return getInputRef().current && getInputRef().current.offsetHeight || 0;
    };

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Fragment, null, multiSelect && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Fragment, null, isOpen && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Overlay, {
      onClick: onOutsideClick
    }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(StyledContainer, {
      width: props.width
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__text_input__["a"
    /* default */
    ], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
      "data-cy": "gel-dropdown-input",
      name: name,
      suffixIcon: !isOpen ? props.theme.Dropdown.AdornmentOpen : props.theme.Dropdown.AdornmentClose,
      ref: getInputRef(),
      value: getDisplayValue(),
      onClick: function onClick() {
        return setIsOpen(!isOpen);
      },
      onBlur: onBlur,
      caption: getCaption(),
      error: shouldShowError(),
      ellipsis: true,
      focusOnRequest: focusOnInput,
      ignoreBlur: isOpen
    }, props, index !== undefined && {
      index: index + '_0'
    })), isOpen && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ContentContainer, {
      "data-cy": "gel-dropdown-content-container",
      ref: targetRef,
      theme: props.theme,
      shouldRenderOnTop: shouldRenderOnTop,
      height: getTargetHeight(),
      textInputHeight: getTextInputHeight()
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ContentSubContainer, {
      theme: props.theme
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__layout__["b"
    /* BoxLayout */
    ], {
      vertical: true,
      space: "auto",
      alignment: "start",
      gap: "small"
    }, optionSelectAll && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__checkbox__["a"
    /* Checkbox */
    ], {
      "data-cy": "gel-dropdown-select-all",
      checked: shouldSelectAll.current,
      onChangeCheck: selectAll,
      onChangeUncheck: unselectAll
    }, optionSelectAll), options.map(function (_ref7, index) {
      var label = _ref7.label,
          value = _ref7.value;
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__checkbox__["a"
      /* Checkbox */
      ], {
        "data-cy": "gel-dropdown-option",
        key: uniqueIds[index],
        checked: getCheckboxStatusByIndex(index),
        onChangeCheck: function onChangeCheck() {
          return onSelectionChange(true, index, value);
        },
        onChangeUncheck: function onChangeUncheck() {
          return onSelectionChange(false, index, value);
        }
      }, label);
    }))), action && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ContentSubContainer, {
      "data-cy": "gel-dropdown-action",
      theme: props.theme,
      separator: true
    }, action)))));
  });

  var StyledContainer = __WEBPACK_IMPORTED_MODULE_6__emotion_styled___default.a.div({
    position: 'relative',
    display: 'inline-block'
  }, function (_ref8) {
    var width = _ref8.width;
    return {
      width: width || '100%'
    };
  });

  var ContentContainer = __WEBPACK_IMPORTED_MODULE_6__emotion_styled___default.a.div({
    position: 'absolute',
    width: '100%',
    // Note that this matches the zIndex of Overlay, as we want the 
    // Overlay to sit on top of other elements but the dropdown itself 
    // should sit on top of Overlay so clicking on dropdown itself won't 
    // be detected as an outside click
    zIndex: 1
  }, function (_ref9) {
    var theme = _ref9.theme,
        shouldRenderOnTop = _ref9.shouldRenderOnTop,
        height = _ref9.height,
        textInputHeight = _ref9.textInputHeight;
    var gap = theme.Dropdown.GapInBetweenInputAndList;
    return _objectSpread({}, !shouldRenderOnTop ? {
      top: textInputHeight + gap
    } : {
      top: -height - gap
    });
  });

  var ContentSubContainer = __WEBPACK_IMPORTED_MODULE_6__emotion_styled___default.a.div({}, function (_ref10) {
    var theme = _ref10.theme,
        separator = _ref10.separator;
    return _objectSpread(_objectSpread({}, theme.Dropdown.ContentContainer), separator && theme.Dropdown.ActionSeparator);
  }); // Detects outside clicks


  var Overlay = __WEBPACK_IMPORTED_MODULE_6__emotion_styled___default.a.div(function () {
    return _objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_7__tal_gel_core__["fixedAccessibleHiddenStyle"]), {}, {
      width: '100%',
      height: '100%',
      zIndex: 1
    });
  });

  var Dropdown = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__tal_gel_theming__["withTheme"])(DropdownComponent);
  /***/

},
/* 298 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
  /**
   * Works with the Action button in Dropdown
   */


  var useDropdownAction = function useDropdownAction() {
    var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(),
        _useState2 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default()(_useState, 2),
        apply = _useState2[0],
        setApply = _useState2[1];

    var onApply = function onApply() {
      return setApply({});
    };

    return {
      applyDropdownAction: apply,
      onDropdownActionApply: onApply
    };
  };
  /* harmony default export */


  __webpack_exports__["a"] = useDropdownAction;
  /***/
},
/* 299 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony export (binding) */

  __webpack_require__.d(__webpack_exports__, "a", function () {
    return EmailInput;
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(5);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__text_input__ = __webpack_require__(46);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6__tal_gel_core__ = __webpack_require__(7);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6__tal_gel_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__tal_gel_core__);

  var _excluded = ["index", "formatErrorMsg", "onError", "errorMsg", "resetValidator"];

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);

      if (enumerableOnly) {
        symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
      }

      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  var EmailInputComponent = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.forwardRef(function (_ref, forwardedRef) {
    var index = _ref.index,
        formatErrorMsg = _ref.formatErrorMsg,
        onError = _ref.onError,
        errorMsg = _ref.errorMsg,
        resetValidator = _ref.resetValidator,
        props = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties___default()(_ref, _excluded);

    var _useUnderlyingError = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__tal_gel_core__["useUnderlyingError"])(onError),
        onErrorUnderlying = _useUnderlyingError.onErrorUnderlying,
        onErrorWrapping = _useUnderlyingError.onErrorWrapping;

    var _useValidator = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__tal_gel_core__["useValidator"])(_objectSpread(_objectSpread({}, props), {}, {
      // includes controlled `error`, `caption`, `value`, `defaultValue`, `setValidity`, etc.
      index: index,
      // index assigned by the form 
      reset: resetValidator,
      // whether to reset the validator (`touched` status, etc.)
      checkError: true,
      // tells validator to always check for error
      hasError: function hasError(valueToCheck) {
        // tells validator HOW to check for error
        // `required` error will have been checked by the underling TextInput
        if (valueToCheck && !isValidEmailAddress(valueToCheck)) {
          return 'format';
        }

        return false;
      },
      hideErrorInitially: true,
      // tells validator to hide error initially
      onError: onErrorWrapping,
      // tells validator the callback to invoke if error occurs or disappears
      errorMsg: _objectSpread({
        // tells validator the error message to include in caption if error occurs
        'format': formatErrorMsg
      }, errorMsg)
    })),
        _useValidator2 = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray___default()(_useValidator, 4),
        onBlur = _useValidator2[0],
        onChange = _useValidator2[1],
        getCaption = _useValidator2[2],
        shouldShowError = _useValidator2[3];

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__text_input__["a"
    /* default */
    ], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
      "data-cy": "gel-email-input",
      ref: forwardedRef
    }, props, index !== undefined && {
      index: index + '_0'
    }, {
      // assign a sub index to the underling TextInput
      resetValidator: resetValidator,
      onChange: onChange,
      onBlur: onBlur,
      caption: getCaption(),
      error: shouldShowError(),
      onError: onErrorUnderlying,
      errorMsg: errorMsg
    }));
  });
  /**
   * Checks if value is a valid email address
   */


  var isValidEmailAddress = function isValidEmailAddress(value) {
    return RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/).test(value);
  };

  var EmailInput = EmailInputComponent;
  /***/
},
/* 300 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony export (binding) */

  __webpack_require__.d(__webpack_exports__, "a", function () {
    return FormField;
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__ = __webpack_require__(5);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(182);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_slicedToArray__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_objectWithoutProperties__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_regenerator__ = __webpack_require__(184);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_regenerator__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7__emotion_styled__ = __webpack_require__(14);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7__emotion_styled___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__emotion_styled__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_8__tal_gel_theming__ = __webpack_require__(11);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_8__tal_gel_theming___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__tal_gel_theming__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_9__tal_gel_core__ = __webpack_require__(7);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_9__tal_gel_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__tal_gel_core__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_10__form_form__ = __webpack_require__(186);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_11__tooltip__ = __webpack_require__(178);

  var _excluded = ["theme", "label", "labelOffset", "width", "tooltip", "tooltipMaxWidth", "tooltipFixedAtTopLevel", "index", "disabled", "valueField", "submitField", "otherField", "children"];

  function _createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

    if (!it) {
      if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;

        var F = function F() {};

        return {
          s: F,
          n: function n() {
            if (i >= o.length) return {
              done: true
            };
            return {
              done: false,
              value: o[i++]
            };
          },
          e: function e(_e) {
            throw _e;
          },
          f: F
        };
      }

      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }

    var normalCompletion = true,
        didErr = false,
        err;
    return {
      s: function s() {
        it = it.call(o);
      },
      n: function n() {
        var step = it.next();
        normalCompletion = step.done;
        return step;
      },
      e: function e(_e2) {
        didErr = true;
        err = _e2;
      },
      f: function f() {
        try {
          if (!normalCompletion && it["return"] != null) it["return"]();
        } finally {
          if (didErr) throw err;
        }
      }
    };
  }

  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }

  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);

      if (enumerableOnly) {
        symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
      }

      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  var RERENDER_RECAPTCHA_TIMEOUT = 5000;

  var FormFieldComponent = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.forwardRef(function (_ref, forwardedRef) {
    var theme = _ref.theme,
        label = _ref.label,
        labelOffset = _ref.labelOffset,
        width = _ref.width,
        tooltip = _ref.tooltip,
        tooltipMaxWidth = _ref.tooltipMaxWidth,
        tooltipFixedAtTopLevel = _ref.tooltipFixedAtTopLevel,
        index = _ref.index,
        disabled = _ref.disabled,
        valueField = _ref.valueField,
        submitField = _ref.submitField,
        otherField = _ref.otherField,
        children = _ref.children,
        props = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_objectWithoutProperties___default()(_ref, _excluded);

    var fieldComponent = findFieldComponent(children);

    if (!fieldComponent) {
      throw 'Form field must contain a component with `name` prop';
    }

    var uniqueId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__tal_gel_core__["useUniqueId"])();

    if (fieldComponent.props.id) {
      // Override the generated unique id if id is specified 
      uniqueId = fieldComponent.props.id;
    }

    var formContext = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_10__form_form__["b"
    /* FormContext */
    ]);

    if (formContext.isMounted) {
      // Two-pass render to avoid inconsistent id 
      // values from SSR and client side
      //
      // Making sure that HTML from SSR and virtual DOM 
      // from first render (dydration) (isMounted false) match
      fieldComponent = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(fieldComponent, {
        id: uniqueId
      });
    }

    var forceUpdate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__tal_gel_core__["useForceUpdate"])(); // checks if unmounted from DOM


    var isUnmountedRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__tal_gel_core__["useIsUnmounted"])(); // some fields (eg. field containing GelReCaptcha) may require 'reloading' after reset


    var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react__["useState"])(true),
        _useState2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_slicedToArray___default()(_useState, 2),
        shouldRenderField = _useState2[0],
        setShouldRenderField = _useState2[1];

    var skipAssigningIndexForReCaptcha = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react__["useRef"])(false);

    var assignedRecaptchaIndex = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react__["useRef"])();

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react__["useEffect"])(function () {
      // As reCaptcha may not render properly after page refresh
      // we manually force this field to render itself again after initial render
      if (isReCaptcha(children)) {
        var timer = setTimeout(function () {
          if (!isUnmountedRef.current) {
            // should not do anything if unmounted
            skipAssigningIndexForReCaptcha.current = true;
            forceUpdate();
            var timer2 = setTimeout(function () {
              skipAssigningIndexForReCaptcha.current = false;
              clearTimeout(timer2);
            });
          }

          clearTimeout(timer);
        }, RERENDER_RECAPTCHA_TIMEOUT);
      }
    }, []);

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react__["useEffect"])(function () {
      // cannot be async function
      __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5__babel_runtime_regenerator___default.a.mark(function _callee() {
        var timer;
        return __WEBPACK_IMPORTED_MODULE_5__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!isReCaptcha(children)) {
                  _context.next = 7;
                  break;
                }

                _context.next = 3;
                return Promise.resolve();

              case 3:
                skipAssigningIndexForReCaptcha.current = true; // reload/reset ReCaptcha

                setShouldRenderField(false);
                setShouldRenderField(true);
                timer = setTimeout(function () {
                  skipAssigningIndexForReCaptcha.current = false;
                  clearTimeout(timer);
                });

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }, [formContext.reset]); // handles reset of reCaptcha

    /**
     * Renders the actual content of field
     */


    var renderChildren = function renderChildren() {
      if (isValueField(label)) {
        // Note that we render reCaptcha twice to avoid some rendering issues.
        // For that reason, we want to make sure that if it is a reCaptcha field,
        // we only increment the index once
        if (!isReCaptcha(children)) {
          index = formContext.valueFieldIndex.current++;
        } else if (!skipAssigningIndexForReCaptcha.current) {
          index = formContext.valueFieldIndex.current++;
          assignedRecaptchaIndex.current = index;
        } else {
          index = assignedRecaptchaIndex.current;
        }

        disabled = formContext.disabled || formContext.disableOnSubmit && formContext.isSubmitting;
        formContext.addValueFieldName(fieldComponent.props.name);
        valueField = true;
      } else if (isSubmitField(fieldComponent)) {
        disabled = formContext.disabled || formContext.preventSubmitOnInvalid && !formContext.formValidity.current || formContext.disableOnSubmit && formContext.isSubmitting;
        submitField = true;
      } else if (isOtherField(label, fieldComponent)) {
        disabled = formContext.disabled || formContext.disableOnSubmit && formContext.isSubmitting;
        otherField = true;
      }

      return recursiveMap(children, function (child) {
        if ( // Means that this child is the one managed by GelFormField
        child.props.name !== undefined && // Excludes GelRadio as it's wrapped by GelRadioGroup which has name
        child.type.displayName !== 'Radio' && // Excludes GelCheckbox as it's wrapped by GelCheckboxGroup which has name
        child.type.displayName !== 'Checkbox') {
          if (valueField) {
            // The managed component inside of a value field
            // needs to report validity, work with validator, 
            // and may need to be disabled when the form is 
            // invalid or when data is being submitted
            return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(child, {
              id: formContext.isMounted ? uniqueId : null,
              index: index,
              setValidity: formContext.setValidity,
              disabled: child.props.disabled || disabled,
              resetValidator: formContext.reset,
              submitCheck: formContext.submitCheck
            });
          } else if (submitField || otherField) {
            // The managed component inside of a submit field 
            // or other field may need to be disabled when the 
            // form is invalid or when data is being submitted
            return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(child, {
              disabled: child.props.disabled || disabled
            });
          }
        } // Render the content directly without extra info,
        // if it's not the component managed by GelFormField


        return child;
      });
    };

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Fragment, null, shouldRenderField && (!formContext.vertical ?
    /*#__PURE__*/
    // horizontal layout
    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(FormFieldContainer, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({
      ref: forwardedRef,
      width: width,
      formContext: formContext
    }, props), (label !== undefined || labelOffset) && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(StyledLabel, {
      htmlFor: formContext.isMounted ? uniqueId : null,
      theme: theme,
      formContext: formContext,
      component: fieldComponent
    }, label), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ChildrenContainer, null, renderChildren()), tooltip && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(TooltipContainer, {
      theme: theme,
      component: fieldComponent,
      formContext: formContext
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__tooltip__["a"
    /* default */
    ], {
      selfAdaptive: true,
      maxWidth: tooltipMaxWidth,
      fixedAtTopLevel: tooltipFixedAtTopLevel
    }, tooltip))) :
    /*#__PURE__*/
    // vertical layout
    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(FormFieldContainer, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({
      ref: forwardedRef,
      width: width,
      formContext: formContext
    }, props), (label || tooltip) && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(LabelContainer, {
      formContext: formContext
    }, label && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(StyledLabel, {
      htmlFor: formContext.isMounted ? uniqueId : null,
      theme: theme,
      formContext: formContext,
      component: fieldComponent
    }, label), tooltip && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(StyledTooltip, {
      inline: true,
      selfAdaptive: true,
      maxWidth: tooltipMaxWidth,
      fixedAtTopLevel: tooltipFixedAtTopLevel,
      theme: theme
    }, tooltip)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ChildrenContainer, null, renderChildren()))));
  });

  var StyledTooltip = __WEBPACK_IMPORTED_MODULE_7__emotion_styled___default()(__WEBPACK_IMPORTED_MODULE_11__tooltip__["a"
  /* default */
  ])(function (_ref3) {
    var theme = _ref3.theme;
    return {
      marginLeft: theme.Form.Tooltip.marginLeft.DefaultVertical
    };
  });

  var FormFieldContainer = __WEBPACK_IMPORTED_MODULE_7__emotion_styled___default.a.div({
    display: 'flex'
  }, function (_ref4) {
    var width = _ref4.width,
        formContext = _ref4.formContext,
        noFieldGutter = _ref4.noFieldGutter;
    return _objectSpread(_objectSpread({
      width: width || '100%'
    }, !noFieldGutter && {
      ':not(:last-of-type)': {
        marginBottom: formContext.fieldGutter
      }
    }), {}, {
      flexDirection: !formContext.vertical ? 'row' : 'column'
    });
  });

  var StyledLabel = __WEBPACK_IMPORTED_MODULE_7__emotion_styled___default.a.label(function (_ref5) {
    var theme = _ref5.theme,
        formContext = _ref5.formContext,
        component = _ref5.component;
    return _objectSpread(_objectSpread({}, theme.Form.Label), !formContext.vertical && {
      flexShrink: 0,
      flexGrow: 0,
      marginTop: getOffsetY(theme, 'Label', component),
      flexBasis: formContext.labelWidth
    });
  });

  var LabelContainer = __WEBPACK_IMPORTED_MODULE_7__emotion_styled___default.a.div(function (_ref6) {
    var formContext = _ref6.formContext;
    return _objectSpread({}, formContext.vertical && {
      marginBottom: formContext.labelVerticalGutter
    });
  });

  var ChildrenContainer = __WEBPACK_IMPORTED_MODULE_7__emotion_styled___default.a.div({
    flexShrink: 1,
    flexGrow: 1
  });

  var TooltipContainer = __WEBPACK_IMPORTED_MODULE_7__emotion_styled___default.a.div({
    // only used in horizontal layout now
    display: 'flex'
  }, function (_ref7) {
    var theme = _ref7.theme,
        component = _ref7.component,
        formContext = _ref7.formContext;
    return _objectSpread(_objectSpread({}, theme.Form.Tooltip), !formContext.vertical ? {
      flexShrink: 0,
      flexGrow: 0,
      marginLeft: theme.Form.Tooltip.marginLeft.Default,
      marginTop: getOffsetY(theme, 'Tooltip', component)
    } : {
      marginLeft: theme.Form.Tooltip.marginLeft.DefaultVertical,
      marginTop: theme.Form.Tooltip.marginTop.DefaultVertical
    });
  });
  /**
   * Checks if this form field contains ReCaptcha
   */


  var isReCaptcha = function isReCaptcha(children) {
    var _iterator = _createForOfIteratorHelper(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Children.toArray(children)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var child = _step.value;

        if (child && child.type.displayName === 'ReCaptcha') {
          return true;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return false;
  };
  /**
   * Applying a `padding-top` to `label` and `tooltip` so they will look like 
   * `vertical-align: text-bottom` with the text in the actual field
   */


  var getOffsetY = function getOffsetY(theme, target, component) {
    return theme.Form[target].marginTop[[// If `component` is one of the following and it does not have 
    // any of the props in the `exclude` array, we apply a particular
    // `padding-top` for that particular component 
    // (eg. GelRadioGroup(non-button looking), GelCheckboxGroup(non-button looking), etc.)
    //
    // For all other cases (eg. GelTextInput, GelSelect, 
    // GelRadioGroup(button looking) etc., we apply a default `padding-top`
    {
      componentName: 'RadioGroup',
      exclude: ['button', 'buttonGroup']
    }, {
      componentName: 'CheckboxGroup',
      exclude: ['button', 'buttonGroup']
    } //  { componentName: 'Checkbox', exclude: ['button'] },
    ].findIndex(function (_ref8) {
      var componentName = _ref8.componentName,
          exclude = _ref8.exclude;

      if (componentName === component.type.displayName) {
        var _iterator2 = _createForOfIteratorHelper(exclude),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var propName = _step2.value;
            if (component.props[propName]) return false;
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }

        return true;
      }

      return false;
    }) >= 0 ? component.type.displayName : 'Default'];
  };
  /**
   * Value field is a field with `label` prop (including empty label)
   */


  var isValueField = function isValueField(label) {
    return label !== undefined && label !== null;
  };
  /**
   * Submit field is the field containing a submit button
   */


  var isSubmitField = function isSubmitField(component) {
    return component.props.submit;
  };

  var isOtherField = function isOtherField(label, component) {
    return !isSubmitField(component) && !isValueField(label);
  };
  /**
   * Recursively find a component with name prop.
   * Note that only the component with name prop will be 
   * managed by GelFormField, and if there are multiple, 
   * only the first one with name prop will be managed.
   * 
   * Therefore, ensure that there is ONLY ONE component 
   * with name prop inside of GelFormField, and that
   * component can be either child or grandchild of 
   * GelFormField, but cannot be rendered by another
   * component that is child or grandchild of GelFormField
   * (in which case the recursive algorithm below cannot
   * find that component)
   */


  var findFieldComponent = function findFieldComponent(children) {
    var childrenArray = __WEBPACK_IMPORTED_MODULE_6_react___default.a.Children.toArray(children);

    var _iterator3 = _createForOfIteratorHelper(childrenArray),
        _step3;

    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var child = _step3.value;

        if ( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.isValidElement(child)) {
          if (child.props.name !== undefined) {
            return child;
          }

          var fieldComponent = findFieldComponent(child.props.children);

          if (fieldComponent) {
            return fieldComponent;
          }
        }
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  };
  /**
   * Similar to `findFieldComponent`, this `recursiveMap` 
   * only works for children and grandchildren.
   * 
   * It means that the following structure would work:
   * <GelFormField>
   *   <GelTextInput name="name" /> // child
   * </GelFormField>
   * 
   * <GelFormField>
   *   <div>
   *     <GelTextInput name="name" /> // grandchild
   *   </div>
   * </GelFormField>
   * 
   * <GelFormField>
   *   <AnotherComponent>
   *     <GelTextInput name="name" /> // grandchild
   *   </AnotherComponent>
   * </GelFormField>
   * 
   * But something like below wouldn't work:
   * <GelFormField>
   *   <AnotherComponent /> // renders `<GelTextInput name="name" />` inside
   * </GelFormField>
   */


  var recursiveMap = function recursiveMap(children, mappingFn) {
    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.Children.map(children, function (child) {
      if (! /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.isValidElement(child)) {
        return child;
      }

      if (child.props.children) {
        child = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(child, {
          children: recursiveMap(child.props.children, mappingFn)
        });
      }

      return mappingFn(child);
    });
  };

  var FormField = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__tal_gel_theming__["withTheme"])(FormFieldComponent);

  FormField.displayName = 'FormField';
  /***/
},
/* 301 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony export (binding) */

  __webpack_require__.d(__webpack_exports__, "b", function () {
    return FormStep;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "a", function () {
    return FormStepper;
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(5);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__tal_gel_theming__ = __webpack_require__(11);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__tal_gel_theming___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__tal_gel_theming__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4__layout__ = __webpack_require__(73);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__accordion__ = __webpack_require__(174);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6__form__ = __webpack_require__(176);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7__progress_status__ = __webpack_require__(177);

  var _excluded = ["theme", "linear", "stepNum", "title", "children"];

  var FormStepComponent = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function (_ref, forwardedRef) {
    var theme = _ref.theme,
        linear = _ref.linear,
        stepNum = _ref.stepNum,
        title = _ref.title,
        children = _ref.children,
        props = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default()(_ref, _excluded);

    var _useContext = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_6__form__["d"
    /* MultiStepFormContext */
    ]),
        isStepTodo = _useContext.isStepTodo,
        isStepComplete = _useContext.isStepComplete,
        isStepOnError = _useContext.isStepOnError,
        isStepActive = _useContext.isStepActive,
        getCurrentStep = _useContext.getCurrentStep,
        onStep = _useContext.onStep;

    var shouldExpand = function shouldExpand() {
      return stepNum === getCurrentStep();
    };
    /**
     * Checks whether to display the Review button for this step
     */


    var isStepReviewable = function isStepReviewable() {
      return linear && (isStepComplete(stepNum) || isStepOnError(stepNum)) && !shouldExpand();
    };

    var stepRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react__["useRef"])();

    var getRef = function getRef() {
      return forwardedRef || stepRef;
    };

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react__["useEffect"])(function () {
      // stepNum is 1 based
      if (shouldExpand() && getRef().current && stepNum !== 1) {
        // Scroll to that step, if the step should expand and is NOT the first step
        // (This is due to that the first step is usually by default expanded, and we
        // don't want to scroll right to the first step as there may be content above
        // the first step which could be missed by users due to the auto scrolling)
        getRef().current.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }, [shouldExpand()]);

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Fragment, null, title ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__accordion__["a"
    /* default */
    ], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
      "data-cy": "gel-form-step-accordion"
    }, props, {
      ref: getRef(),
      disabled: isStepTodo(stepNum),
      title: /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__layout__["b"
      /* BoxLayout */
      ], {
        gap: "none",
        distribution: "start",
        space: ['auto', 1],
        alignment: "start",
        alignmentIndividual: [null, 'center']
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__progress_status__["a"
      /* default */
      ], {
        stepNum: stepNum,
        complete: isStepComplete(stepNum),
        todo: isStepTodo(stepNum),
        error: isStepOnError(stepNum),
        active: isStepActive(stepNum)
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", null, title)),
      expand: shouldExpand(),
      asFormStep: true,
      linear: linear,
      reviewable: isStepReviewable(),
      onReview: function onReview() {
        return onStep(stepNum);
      } // opens this step

    }), shouldExpand() && children) : shouldExpand() && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
      ref: getRef()
    }, children));
  });

  var FormStep = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__tal_gel_theming__["withTheme"])(FormStepComponent);

  var FormStepper = function FormStepper(_ref2) {
    var _ref2$linear = _ref2.linear,
        linear = _ref2$linear === void 0 ? true : _ref2$linear,
        _ref2$gutter = _ref2.gutter,
        gutter = _ref2$gutter === void 0 ? 'small' : _ref2$gutter,
        children = _ref2.children;

    var _useContext2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_6__form__["d"
    /* MultiStepFormContext */
    ]),
        setHasFormStepper = _useContext2.setHasFormStepper;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react__["useEffect"])(function () {
      // Let GelMultiStepForm know that a form stepper is contained
      setHasFormStepper(true);
    }, []);

    var childArray = __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.toArray(children);

    childArray.forEach(function (child) {
      if (child.type !== FormStep) {
        // if any direct child is not a Step component, throw error
        throw "Only 'GelFormStep' components are allowed as direct children of 'GelFormStepper'";
      }
    });
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__layout__["c"
    /* RowLayout */
    ], {
      gutter: gutter
    }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.map(children, function (child, index) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(child, {
        // form step
        stepNum: index + 1,
        // stepNum is 1 based
        linear: linear
      });
    }));
  };
  /***/

},
/* 302 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(102);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4__tal_gel_core__ = __webpack_require__(7);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4__tal_gel_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__tal_gel_core__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__multi_step_form__ = __webpack_require__(53);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6__number_input__ = __webpack_require__(135);

  function _createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

    if (!it) {
      if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;

        var F = function F() {};

        return {
          s: F,
          n: function n() {
            if (i >= o.length) return {
              done: true
            };
            return {
              done: false,
              value: o[i++]
            };
          },
          e: function e(_e) {
            throw _e;
          },
          f: F
        };
      }

      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }

    var normalCompletion = true,
        didErr = false,
        err;
    return {
      s: function s() {
        it = it.call(o);
      },
      n: function n() {
        var step = it.next();
        normalCompletion = step.done;
        return step;
      },
      e: function e(_e2) {
        didErr = true;
        err = _e2;
      },
      f: function f() {
        try {
          if (!normalCompletion && it["return"] != null) it["return"]();
        } finally {
          if (didErr) throw err;
        }
      }
    };
  }

  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }

  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);

      if (enumerableOnly) {
        symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
      }

      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  } // Identifier to store to session or retrieve from session an array of 
  // multi-step form names, with the capability to work with multiple multi-step forms


  var gelMultiStepFormNames = 'gelMultiStepFormNames';

  var useFormData = function useFormData(initFormData, whichStep, useSession) {
    var forceUpdate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__tal_gel_core__["useForceUpdate"])(); // Determines whether the component is unmounted


    var isUnmountedRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__tal_gel_core__["useIsUnmounted"])();

    var hasStepName = function hasStepName() {
      return whichStep !== undefined;
    };

    var multiStepFormContext = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_5__multi_step_form__["a"
    /* MultiStepFormContext */
    ]);

    var getInitFormData = function getInitFormData() {
      if (!multiStepFormContext || !hasStepName()) {
        return initFormData;
      }

      return multiStepFormContext.getMultiStepFormData(whichStep) || initFormData;
    };

    var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react__["useState"])(getInitFormData()),
        _useState2 = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray___default()(_useState, 2),
        formData = _useState2[0],
        setFormData = _useState2[1];

    var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react__["useState"])(),
        _useState4 = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray___default()(_useState3, 2),
        resetForm = _useState4[0],
        setFormReset = _useState4[1];

    var _useState5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react__["useState"])(null),
        _useState6 = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray___default()(_useState5, 2),
        submitCheck = _useState6[0],
        setSubmitCheck = _useState6[1];

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react__["useEffect"])(function () {
      // If in a multi step form context
      if (multiStepFormContext && hasStepName()) {
        multiStepFormContext.addMultiStepFormData(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()({}, whichStep, formData));
      }
    }, [formData]);

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react__["useEffect"])(function () {
      if (shouldUseSession()) {
        loadFromSession();
      }

      var timer = setTimeout(function () {
        if (!isUnmountedRef.current) {
          forceUpdate();
        }

        clearTimeout(timer);
      });
    }, []);
    /**
     * `useSession` can be set at the step level. 
     * If not specified, it will follow the setup in multi step form
     */


    var shouldUseSession = function shouldUseSession() {
      return multiStepFormContext && multiStepFormContext.name && (multiStepFormContext.useSession && (useSession || useSession === undefined) || !multiStepFormContext.useSession && useSession);
    };
    /**
     * Retrieves from session an array of multi-step form names 
     * with the capability to work with multiple multi-step forms
     */


    var getMultiStepFormNames = function getMultiStepFormNames() {
      return JSON.parse(sessionStorage.getItem(gelMultiStepFormNames)) || [];
    };
    /**
     * Stores to session an array of multi-step form names 
     * with the capability to work with multiple multi-step forms
     */


    var setMultiStepFormNames = function setMultiStepFormNames(multiStepFormNames) {
      sessionStorage.setItem(gelMultiStepFormNames, JSON.stringify(multiStepFormNames));
    };
    /**
     * Removes from session the array of multi-step form names 
     * with the capability to work with multiple multi-step forms
     */


    var removeMultiStepFormNames = function removeMultiStepFormNames() {
      sessionStorage.removeItem(gelMultiStepFormNames);
    };
    /**
     * Stores the individual form to session
     * 
     * Multiple individual forms can make up a multi-step form
     * An individual form in the multi-step form is considered as a step
     * 
     * `gelMultiStepFormNames` can work with multiple multi-step forms
     */


    var storeToSession = function storeToSession() {
      if (!hasStepName()) return; // Step name is required when storing form data to session

      try {
        // Get the multi-step form data from session
        // as per the name of this multi-step form
        var multiStepFormData = JSON.parse(sessionStorage.getItem(multiStepFormContext.name));

        if (!multiStepFormData) {
          // Save the multi-step form name, only if there is currently
          // no form data stored in session with this name. In other words, 
          // the same multi-step form name should only be added once.
          setMultiStepFormNames([].concat(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(getMultiStepFormNames()), [multiStepFormContext.name]));
        } // Save the step data of this multi-step form to session


        sessionStorage.setItem(multiStepFormContext.name, JSON.stringify(_objectSpread(_objectSpread({}, multiStepFormData), {}, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()({}, whichStep, formData))));
      } catch (e) {
        console.error(e);
      }
    };
    /**
     * Load data of individual form from session
     * 
     * Multiple individual forms can make up a multi-step form
     * An individual form in the multi-step form is considered as a step
     */


    var loadFromSession = function loadFromSession() {
      if (!hasStepName()) return; // Step name is required when loading form data from session

      try {
        // Get data of the multi-step form to which this step belongs
        var multiStepFormData = JSON.parse(sessionStorage.getItem(multiStepFormContext.name));

        if (multiStepFormData && multiStepFormData[whichStep]) {
          // Get step data from the multi-step form, and update state
          setFormData(multiStepFormData[whichStep]); // Trigger each field in this step to validate against the value assigned

          setSubmitCheck({});
        }
      } catch (e) {
        console.error(e);
      }
    };

    var allFormDataFromSession = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react__["useRef"])();
    /**
     * Removes data of all multi-step forms currently stored in session
     */


    var removeFromSession = function removeFromSession() {
      try {
        allFormDataFromSession.current = _getAllFormDataFromSession(); // Remove data of all multi-step forms from session

        getMultiStepFormNames().forEach(function (itemName) {
          sessionStorage.removeItem(itemName);
        }); // Remove names of all multi-step forms from session

        removeMultiStepFormNames();
      } catch (e) {
        console.error(e);
      }
    };
    /**
     * Gets data of all multi-step forms currently stored in session
     * The result will be something like below
     * {
     *  multiStepFormName1: {stepName1: data, stepName2: data, ...},
     *  multiStepFormName2: {stepName1: data, stepName2: data, ...},
     *  ...
     * }
     */


    var _getAllFormDataFromSession = function _getAllFormDataFromSession() {
      return getMultiStepFormNames().reduce(function (result, itemName) {
        try {
          var multiStepFormData = JSON.parse(sessionStorage.getItem(itemName));
          return _objectSpread(_objectSpread({}, result), {}, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()({}, itemName, multiStepFormData));
        } catch (e) {
          console.error(e);
        }
      }, {});
    };

    var onFormDataChange = function onFormDataChange(event) {
      var isNumeric = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var _event$target = event.target,
          type = _event$target.type,
          name = _event$target.name;
      var value = event.target[type !== 'checkbox' ? 'value' : 'checked']; // async, cannot use event.target in async context

      setFormData(function (lastUpdatedFormData) {
        return _objectSpread(_objectSpread({}, lastUpdatedFormData), {}, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()({}, name, !isNumeric ? value : // if from numeric field such as GelNumberInput
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__number_input__["b"
        /* convertEventTargetValueToNumeric */
        ])(value)));
      });
    };

    var onFormDataReset = function onFormDataReset() {
      // Put this to the next tick to support dynamic fields
      var timer = setTimeout(function () {
        if (!isUnmountedRef.current) {
          setFormData(initFormData); // New empty object ensures state changes each time it's called

          setFormReset({});

          if (multiStepFormContext) {
            multiStepFormContext.onIndividualFormDataReset();
          }
        }

        clearTimeout(timer);
      }, 500); // To resolve some weird race issues
    }; // Handles dynamic changes of FormField


    var onFormFieldChange = function onFormFieldChange(_ref) {
      var add = _ref.add,
          _ref$remove = _ref.remove,
          remove = _ref$remove === void 0 ? [] : _ref$remove;
      setFormData(function (lastUpdatedFormData) {
        var tempFormData = _objectSpread({}, lastUpdatedFormData);

        var _iterator = _createForOfIteratorHelper(remove),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var key = _step.value;
            delete tempFormData[key];
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        return _objectSpread(_objectSpread({}, tempFormData), add);
      });
    };

    var getMultiStepFormData = function getMultiStepFormData() {
      if (multiStepFormContext) {
        // Ensure that we get the latest data of this step,
        // because we only update multiStepFormData to reflect
        // the latest in useEffect after the re-render
        return hasStepName() ? _objectSpread(_objectSpread({}, multiStepFormContext.getMultiStepFormData()), {}, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()({}, whichStep, formData)) : multiStepFormContext.getMultiStepFormData();
      }

      return null;
    };

    return {
      formData: formData,
      onFormDataChange: onFormDataChange,
      onFormFieldChange: onFormFieldChange,
      resetForm: resetForm,
      onFormDataReset: onFormDataReset,
      setFormData: setFormData,
      multiStepFormData: getMultiStepFormData(),
      onMultiStepFormDataSubmit: function onMultiStepFormDataSubmit(onSubmit) {
        return function () {
          if (multiStepFormContext) {
            if (shouldUseSession()) {
              removeFromSession();
            } // Update form stepper


            multiStepFormContext.onSubmit();
          }

          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__tal_gel_core__["isFunction"])(onSubmit) && onSubmit();
        };
      },
      onMultiStepFormDataReset: function onMultiStepFormDataReset() {
        if (multiStepFormContext) {
          if (shouldUseSession()) {
            removeFromSession();
          }

          multiStepFormContext.onReset();
        }
      },
      getCurrentStep: multiStepFormContext && multiStepFormContext.getCurrentStep,
      onPrevStep: multiStepFormContext && multiStepFormContext.onPrevStep,
      onNextStep: function onNextStep() {
        if (multiStepFormContext) {
          if (shouldUseSession()) {
            storeToSession();
          }

          var timer = setTimeout(function () {
            if (!isUnmountedRef.current) {
              multiStepFormContext.onNextStep();
            }

            clearTimeout(timer);
          });
        }
      },
      // Due to the way `valueFieldIndex` is being used (See form.js), 
      // if a GelFormField component re-renders without the entire form being
      // re-rendered, `valueFieldIndex` can get messed up, and this can happen 
      // when this GelFormField is wrapped by another component (See example in
      // `/auto-complete-input/manually-validate-form`)
      //
      // `validateForm` must be present AFTER the re-rendering of such a GelFormField
      validateForm: forceUpdate,
      shouldValidateAfterInit: submitCheck,
      validateAfterInit: function validateAfterInit() {
        return setSubmitCheck({});
      },
      setStepStatus: multiStepFormContext && multiStepFormContext.setStepStatus,
      getStepStatus: multiStepFormContext && multiStepFormContext.getStepStatus,
      getAllFormDataFromSession: function getAllFormDataFromSession() {
        var data = _getAllFormDataFromSession();

        return Object.keys(data).length > 0 ? data : allFormDataFromSession.current;
      }
    };
  };
  /* harmony default export */


  __webpack_exports__["a"] = useFormData;
  /***/
},
/* 303 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony export (binding) */

  __webpack_require__.d(__webpack_exports__, "a", function () {
    return Hidden;
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__screen_detector__ = __webpack_require__(33);

  var _excluded = ["children", "only"];

  var Hidden = function Hidden(_ref) {
    var children = _ref.children,
        only = _ref.only,
        props = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties___default()(_ref, _excluded);

    var _useContext = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_2__screen_detector__["a"
    /* ScreenDetectorContext */
    ]),
        screen = _useContext.screen,
        hasAnyScreenProps = _useContext.hasAnyScreenProps,
        findScreenPropByScreen = _useContext.findScreenPropByScreen;

    var hidden;

    if (!hasAnyScreenProps(props)) {
      hidden = true;
    } else {
      var screenProp = findScreenPropByScreen(screen, props); // `only` means only hide it at the specified screen,
      // otherwise hide it if current screen is the specified screen 
      // or larger than the specified screen

      hidden = !only ? !!screenProp : screen === screenProp;
    }

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment, null, !hidden && children);
  };
  /***/

},
/* 304 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__tal_gel_theming__ = __webpack_require__(11);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__tal_gel_theming___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__tal_gel_theming__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__tal_gel_core__ = __webpack_require__(7);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__tal_gel_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__tal_gel_core__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_debounce__ = __webpack_require__(610);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_debounce__);

  function _createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

    if (!it) {
      if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;

        var F = function F() {};

        return {
          s: F,
          n: function n() {
            if (i >= o.length) return {
              done: true
            };
            return {
              done: false,
              value: o[i++]
            };
          },
          e: function e(_e) {
            throw _e;
          },
          f: F
        };
      }

      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }

    var normalCompletion = true,
        didErr = false,
        err;
    return {
      s: function s() {
        it = it.call(o);
      },
      n: function n() {
        var step = it.next();
        normalCompletion = step.done;
        return step;
      },
      e: function e(_e2) {
        didErr = true;
        err = _e2;
      },
      f: function f() {
        try {
          if (!normalCompletion && it["return"] != null) it["return"]();
        } finally {
          if (didErr) throw err;
        }
      }
    };
  }

  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }

  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } // Used by ScreenDetector


  var useScreen = function useScreen(_ref) {
    var _ref$debounceTime = _ref.debounceTime,
        debounceTime = _ref$debounceTime === void 0 ? __WEBPACK_IMPORTED_MODULE_3__tal_gel_core__["WINDOW_RESIZE_DEBOUNCE_TIME"] : _ref$debounceTime,
        requireHydration = _ref.requireHydration;

    var theme = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_2__tal_gel_theming__["ThemeContext"]); // for client side hydration and reconciliation


    var isMounted = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__tal_gel_core__["useIsMounted"])(); // Ensures that if GEL is used without SSR/SSG 
    // (requireHydration being false), ScreenDetector won't 
    // unnecessarily trigger double renders. The first render
    // will already use the correct current screen size.
    //
    // With SSR/SSG, the same default screen as used on server
    // will be used for the first render during client hydration, 
    // and then the second render will use the correct screen size 
    // and will trigger React reconciliation to patch up the 
    // differences between SSR/SSG and the actual intended DOM.
    //
    // The reason why we need two-pass render (see more comments 
    // in use-is-mounted), is that for the sake of performance 
    // (https://reactjs.org/docs/react-dom.html#hydrate) React
    // won't try to patch up differences in attributes during hydration
    // as validating all markups would be prohibitively expensive. 
    //
    // Consequently, if we use `GelScreenDetector` to assign dynamic 
    // values to props (which may translate into attributes), even if 
    // the virtual DOM tree generated by the first render using a different 
    // screen size during hydration may not fully match the HTML for some 
    // attributes, React won't try to reconcile. So we might as well use 
    // the same default screen as used in SSR/SSG for hydration to ensure 
    // that everything matches. So after the first render/hydration, we
    // get a mounted virtual DOM tree mathcing the actual DOM (outcome 
    // of SSR/SSG) and with all the necessary event handlers etc. wired up.
    // 
    // Then in the second render (triggered by a state change right after 
    // mount in useEffect), a new virtual DOM tree will be generated using 
    // the correct screen size, and React will compare the second virtual 
    // DOM tree to the first (with very efficient diffing algorithms 
    // https://reactjs.org/docs/reconciliation.html also check out 
    // https://reactjs.org/docs/reconciliation.html#keys) and will pick up 
    // the differences (in attributes for example) and do reconciliation,
    // so the actual DOM will be updated/patched (See comments in useLayoutEffect 
    // of use-is-mounted for more details) to reflect what is exactly correct
    // under the current actual screen size.


    var shouldUseDefaultScreen = function shouldUseDefaultScreen() {
      return !isMounted && requireHydration;
    }; // Only makes the component re-render when screen type actually changes
    // (Calling `setScreen` with the same screen name won't trigger re-render)


    var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(determineScreenByWindowSize(theme.Grid.screens, shouldUseDefaultScreen())),
        _useState2 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default()(_useState, 2),
        screen = _useState2[0],
        setScreen = _useState2[1];

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function () {
      // won't be invoked in SSR
      // Debounce the function for better performance
      var debouncedUpdateWindowSize = __WEBPACK_IMPORTED_MODULE_4_debounce___default()(function () {
        setScreen(determineScreenByWindowSize(theme.Grid.screens, shouldUseDefaultScreen()));
      }, debounceTime); // Add to `resize` event listener


      window.addEventListener('resize', debouncedUpdateWindowSize);

      if (isMounted) {
        // Two-pass render
        // 
        // If `requireHydration` is false, client will use
        // the actual current screen size for both the first 
        // (prior to mount) and second render (right after mount), 
        // hence no re-render for the second time
        //
        // If `requireHydration` is true, client will use
        // default screen size (as used on server) for the
        // first render (prior to mount), and use the actual
        // current screen size for the second render (right 
        // after mount). If current screen size is different 
        // to the default screen size, re-render takes place 
        // and the differences in the two virtual DOM tree 
        // will be patched up via React reconciliation.
        //
        // First pass render is for hydration and isMounted is false
        //
        // first render -> virtual DOM tree -> hydration with
        // the server generated HTML or updating the actual DOM 
        // (empty) with the virtual DOM tree (either case, event 
        // handlers etc. are wired up to the actual DOM elements
        // in this phase) -> *** MOUNTED *** -> state change 
        // (screen size) -> second render -> second virtual DOM 
        // tree -> diffing with the first virtual DOM tree -> 
        // patching up the differences and updating the actual DOM
        setScreen(determineScreenByWindowSize(theme.Grid.screens, shouldUseDefaultScreen()));
      }

      return function () {
        // only upon unmount
        debouncedUpdateWindowSize.clear();
        window.removeEventListener('resize', debouncedUpdateWindowSize);
      };
    }, [isMounted]);

    return screen;
  };
  /**
   * Determines which screen it's currently on, 
   * by comparing the current window size (width) with screen breakpoints
   */


  var determineScreenByWindowSize = function determineScreenByWindowSize(screens, shouldUseDefaultScreen) {
    if (!shouldUseDefaultScreen) {
      var _iterator = _createForOfIteratorHelper(screens.entries()),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default()(_step.value, 2),
              index = _step$value[0],
              screen = _step$value[1]; // `breakpoint` for each screen is `min-width`


          if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__tal_gel_core__["getWindowWidth"])() < screen.breakpoint) {
            if (index === 0) {
              // Smaller than the smallest screen (should not happen)
              console.log('Needs investigations in useScreen...');
              return screen.name;
            }

            return screens[index - 1].name; // return last screen (as breakpoint is min-width)
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return screens[screens.length - 1].name; // largest screen
    } // Return largest screen during SSR/SSG or client hydration
    // Check out comments in `useIsMounted` for how to deal 
    // with SSR/SSG and client side hydration


    return screens[screens.length - 1].name;
  };
  /* harmony default export */


  __webpack_exports__["a"] = useScreen;
  /***/
},
/* 305 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony export (binding) */

  __webpack_require__.d(__webpack_exports__, "a", function () {
    return Visible;
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__screen_detector__ = __webpack_require__(33);

  var _excluded = ["children", "only"];

  var Visible = function Visible(_ref) {
    var children = _ref.children,
        only = _ref.only,
        props = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties___default()(_ref, _excluded);

    var _useContext = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_2__screen_detector__["a"
    /* ScreenDetectorContext */
    ]),
        screen = _useContext.screen,
        hasAnyScreenProps = _useContext.hasAnyScreenProps,
        findScreenPropByScreen = _useContext.findScreenPropByScreen;

    var visible;

    if (!hasAnyScreenProps(props)) {
      visible = true;
    } else {
      var screenProp = findScreenPropByScreen(screen, props); // `only` means only show it at the specified screen,
      // otherwise show it if current screen is the specified screen 
      // or larger than the specified screen

      visible = !only ? !!screenProp : screen === screenProp;
    }

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment, null, visible && children);
  };
  /***/

},
/* 306 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony export (binding) */

  __webpack_require__.d(__webpack_exports__, "a", function () {
    return IconIterator;
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__tal_gel_theming__ = __webpack_require__(11);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__tal_gel_theming___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__tal_gel_theming__); // See comments on useThemeSelector


  var IconIterator = function IconIterator(_ref) {
    var _ref$brand = _ref.brand,
        brand = _ref$brand === void 0 ? false : _ref$brand,
        render = _ref.render;
    return Object.entries(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__tal_gel_theming__["getGelIcons"])(brand)).map(function (_ref2, index) {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default()(_ref2, 2),
          key = _ref3[0],
          _ = _ref3[1];

      return render(key, index);
    });
  };
  /***/

},
/* 307 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  Object.defineProperty(__webpack_exports__, "__esModule", {
    value: true
  });
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_core_js_stable__ = __webpack_require__(275);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_core_js_stable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_stable__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_regenerator_runtime_runtime_js__ = __webpack_require__(180);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_regenerator_runtime_runtime_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_regenerator_runtime_runtime_js__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__button__ = __webpack_require__(133);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__link__ = __webpack_require__(261);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4__icon__ = __webpack_require__(45);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__checkbox__ = __webpack_require__(175);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6__radio__ = __webpack_require__(268);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7__text_input__ = __webpack_require__(46);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_8__number_input__ = __webpack_require__(135);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_9__text_area__ = __webpack_require__(274);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_10__select__ = __webpack_require__(270);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_11__switch__ = __webpack_require__(271);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_12__accordion__ = __webpack_require__(174);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_13__tabs__ = __webpack_require__(273);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_14__modal__ = __webpack_require__(263);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_15__alert__ = __webpack_require__(249);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_16__breadcrumbs__ = __webpack_require__(251);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_17__list__ = __webpack_require__(262);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_18__tooltip__ = __webpack_require__(178);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_19__email_input__ = __webpack_require__(258);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_20__form__ = __webpack_require__(176);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_21__form_field__ = __webpack_require__(259);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_22__recaptcha__ = __webpack_require__(269);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_23__layout_page_layout__ = __webpack_require__(134);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_24__grid__ = __webpack_require__(101);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_25__layout__ = __webpack_require__(73);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_26__dropdown__ = __webpack_require__(257);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_27__date_input_standard__ = __webpack_require__(255);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_28__date_input__ = __webpack_require__(256);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_29__auto_complete_input__ = __webpack_require__(250);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_30__phone_number_input__ = __webpack_require__(265);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_31__postcode_input__ = __webpack_require__(266);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_32__collapsible__ = __webpack_require__(252);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_33__spinner__ = __webpack_require__(136);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_34__table__ = __webpack_require__(272);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_35__form_stepper__ = __webpack_require__(260);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_36__credit_card_number_input__ = __webpack_require__(253);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_37__cvv_input__ = __webpack_require__(254);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_38__password_input__ = __webpack_require__(264);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_39__progress_bar__ = __webpack_require__(267);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_40__progress_status__ = __webpack_require__(177);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_41__typography__ = __webpack_require__(179);
  /* harmony namespace reexport (by provided) */


  __webpack_require__.d(__webpack_exports__, "GelDisplay1", function () {
    return __WEBPACK_IMPORTED_MODULE_41__typography__["a"];
  });
  /* harmony namespace reexport (by provided) */


  __webpack_require__.d(__webpack_exports__, "GelDisplay2", function () {
    return __WEBPACK_IMPORTED_MODULE_41__typography__["b"];
  });
  /* harmony namespace reexport (by provided) */


  __webpack_require__.d(__webpack_exports__, "GelDisplay3", function () {
    return __WEBPACK_IMPORTED_MODULE_41__typography__["c"];
  });
  /* harmony namespace reexport (by provided) */


  __webpack_require__.d(__webpack_exports__, "GelDisplay4", function () {
    return __WEBPACK_IMPORTED_MODULE_41__typography__["d"];
  });
  /* harmony namespace reexport (by provided) */


  __webpack_require__.d(__webpack_exports__, "GelHeading1", function () {
    return __WEBPACK_IMPORTED_MODULE_41__typography__["e"];
  });
  /* harmony namespace reexport (by provided) */


  __webpack_require__.d(__webpack_exports__, "GelHeading2", function () {
    return __WEBPACK_IMPORTED_MODULE_41__typography__["f"];
  });
  /* harmony namespace reexport (by provided) */


  __webpack_require__.d(__webpack_exports__, "GelHeading3", function () {
    return __WEBPACK_IMPORTED_MODULE_41__typography__["g"];
  });
  /* harmony namespace reexport (by provided) */


  __webpack_require__.d(__webpack_exports__, "GelHeading4", function () {
    return __WEBPACK_IMPORTED_MODULE_41__typography__["h"];
  });
  /* harmony namespace reexport (by provided) */


  __webpack_require__.d(__webpack_exports__, "GelHeading5", function () {
    return __WEBPACK_IMPORTED_MODULE_41__typography__["i"];
  });
  /* harmony namespace reexport (by provided) */


  __webpack_require__.d(__webpack_exports__, "GelHeading6", function () {
    return __WEBPACK_IMPORTED_MODULE_41__typography__["j"];
  });
  /* harmony namespace reexport (by provided) */


  __webpack_require__.d(__webpack_exports__, "GelLabel", function () {
    return __WEBPACK_IMPORTED_MODULE_41__typography__["k"];
  });
  /* harmony namespace reexport (by provided) */


  __webpack_require__.d(__webpack_exports__, "GelParagraph", function () {
    return __WEBPACK_IMPORTED_MODULE_41__typography__["l"];
  });
  /* harmony namespace reexport (by provided) */


  __webpack_require__.d(__webpack_exports__, "GelCaption", function () {
    return __WEBPACK_IMPORTED_MODULE_41__typography__["m"];
  });
  /* harmony namespace reexport (by provided) */


  __webpack_require__.d(__webpack_exports__, "GelFootNote", function () {
    return __WEBPACK_IMPORTED_MODULE_41__typography__["n"];
  });
  /* harmony namespace reexport (by provided) */


  __webpack_require__.d(__webpack_exports__, "GelBlockQuote", function () {
    return __WEBPACK_IMPORTED_MODULE_41__typography__["o"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "GelButton", function () {
    return __WEBPACK_IMPORTED_MODULE_2__button__["a"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "GelLink", function () {
    return __WEBPACK_IMPORTED_MODULE_3__link__["a"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "GelIcon", function () {
    return __WEBPACK_IMPORTED_MODULE_4__icon__["a"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "GelIconIterator", function () {
    return __WEBPACK_IMPORTED_MODULE_4__icon__["b"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "GelCheckbox", function () {
    return __WEBPACK_IMPORTED_MODULE_5__checkbox__["a"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "GelCheckboxGroup", function () {
    return __WEBPACK_IMPORTED_MODULE_5__checkbox__["b"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "GelCheckboxButtonGroup", function () {
    return __WEBPACK_IMPORTED_MODULE_5__checkbox__["c"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "GelRadio", function () {
    return __WEBPACK_IMPORTED_MODULE_6__radio__["a"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "GelRadioGroup", function () {
    return __WEBPACK_IMPORTED_MODULE_6__radio__["b"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "GelRadioButtonGroup", function () {
    return __WEBPACK_IMPORTED_MODULE_6__radio__["c"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "GelTextInput", function () {
    return __WEBPACK_IMPORTED_MODULE_7__text_input__["a"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "GelNumberInput", function () {
    return __WEBPACK_IMPORTED_MODULE_8__number_input__["a"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "convertEventTargetValueToNumeric", function () {
    return __WEBPACK_IMPORTED_MODULE_8__number_input__["b"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "GelTextArea", function () {
    return __WEBPACK_IMPORTED_MODULE_9__text_area__["a"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "GelSelect", function () {
    return __WEBPACK_IMPORTED_MODULE_10__select__["a"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "GelSwitch", function () {
    return __WEBPACK_IMPORTED_MODULE_11__switch__["a"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "GelAccordion", function () {
    return __WEBPACK_IMPORTED_MODULE_12__accordion__["a"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "GelTabs", function () {
    return __WEBPACK_IMPORTED_MODULE_13__tabs__["a"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "GelTab", function () {
    return __WEBPACK_IMPORTED_MODULE_13__tabs__["b"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "GelModal", function () {
    return __WEBPACK_IMPORTED_MODULE_14__modal__["a"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "GelAlert", function () {
    return __WEBPACK_IMPORTED_MODULE_15__alert__["a"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "GelBreadcrumbs", function () {
    return __WEBPACK_IMPORTED_MODULE_16__breadcrumbs__["a"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "GelList", function () {
    return __WEBPACK_IMPORTED_MODULE_17__list__["a"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "GelListItem", function () {
    return __WEBPACK_IMPORTED_MODULE_17__list__["b"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "GelTooltip", function () {
    return __WEBPACK_IMPORTED_MODULE_18__tooltip__["a"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "GelEmailInput", function () {
    return __WEBPACK_IMPORTED_MODULE_19__email_input__["a"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "GelForm", function () {
    return __WEBPACK_IMPORTED_MODULE_20__form__["a"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "GelFormField", function () {
    return __WEBPACK_IMPORTED_MODULE_21__form_field__["a"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "useGelFormData", function () {
    return __WEBPACK_IMPORTED_MODULE_20__form__["b"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "GelMultiStepForm", function () {
    return __WEBPACK_IMPORTED_MODULE_20__form__["c"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "GelMultiStepFormContext", function () {
    return __WEBPACK_IMPORTED_MODULE_20__form__["d"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "GelReCaptcha", function () {
    return __WEBPACK_IMPORTED_MODULE_22__recaptcha__["a"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "GelScreenDetector", function () {
    return __WEBPACK_IMPORTED_MODULE_24__grid__["a"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "GelContainer", function () {
    return __WEBPACK_IMPORTED_MODULE_24__grid__["b"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "GelRow", function () {
    return __WEBPACK_IMPORTED_MODULE_24__grid__["c"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "GelScreenDetectorContext", function () {
    return __WEBPACK_IMPORTED_MODULE_24__grid__["d"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "withGelScreenDetector", function () {
    return __WEBPACK_IMPORTED_MODULE_24__grid__["e"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "GelCol", function () {
    return __WEBPACK_IMPORTED_MODULE_24__grid__["f"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "GelVisible", function () {
    return __WEBPACK_IMPORTED_MODULE_24__grid__["g"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "GelHidden", function () {
    return __WEBPACK_IMPORTED_MODULE_24__grid__["h"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "GelColumnLayout", function () {
    return __WEBPACK_IMPORTED_MODULE_25__layout__["a"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "GelBoxLayout", function () {
    return __WEBPACK_IMPORTED_MODULE_25__layout__["b"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "GelRowLayout", function () {
    return __WEBPACK_IMPORTED_MODULE_25__layout__["c"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "GelContainerLite", function () {
    return __WEBPACK_IMPORTED_MODULE_25__layout__["d"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "GelPageLayout", function () {
    return __WEBPACK_IMPORTED_MODULE_23__layout_page_layout__["a"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "GelPageLayoutContext", function () {
    return __WEBPACK_IMPORTED_MODULE_23__layout_page_layout__["b"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "useGelScrollContentToTop", function () {
    return __WEBPACK_IMPORTED_MODULE_23__layout_page_layout__["c"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "GelPageHeader", function () {
    return __WEBPACK_IMPORTED_MODULE_23__layout_page_layout__["d"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "GelPageFooter", function () {
    return __WEBPACK_IMPORTED_MODULE_23__layout_page_layout__["e"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "GelPageSideNav", function () {
    return __WEBPACK_IMPORTED_MODULE_23__layout_page_layout__["f"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "GelPageContent", function () {
    return __WEBPACK_IMPORTED_MODULE_23__layout_page_layout__["g"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "GelPageContentContainer", function () {
    return __WEBPACK_IMPORTED_MODULE_23__layout_page_layout__["h"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "GelDropdown", function () {
    return __WEBPACK_IMPORTED_MODULE_26__dropdown__["a"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "useGelDropdownAction", function () {
    return __WEBPACK_IMPORTED_MODULE_26__dropdown__["b"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "GelCardLayout", function () {
    return __WEBPACK_IMPORTED_MODULE_25__layout__["e"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "GelStandardDateInput", function () {
    return __WEBPACK_IMPORTED_MODULE_27__date_input_standard__["a"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "GelDateInput", function () {
    return __WEBPACK_IMPORTED_MODULE_28__date_input__["a"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "GelAutoCompleteInput", function () {
    return __WEBPACK_IMPORTED_MODULE_29__auto_complete_input__["a"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "GelPhoneNumberInput", function () {
    return __WEBPACK_IMPORTED_MODULE_30__phone_number_input__["a"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "GelPostcodeInput", function () {
    return __WEBPACK_IMPORTED_MODULE_31__postcode_input__["a"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "GelCollapsible", function () {
    return __WEBPACK_IMPORTED_MODULE_32__collapsible__["a"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "GelSpinner", function () {
    return __WEBPACK_IMPORTED_MODULE_33__spinner__["a"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "GelTable", function () {
    return __WEBPACK_IMPORTED_MODULE_34__table__["a"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "GelFormStepper", function () {
    return __WEBPACK_IMPORTED_MODULE_35__form_stepper__["a"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "GelFormStep", function () {
    return __WEBPACK_IMPORTED_MODULE_35__form_stepper__["b"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "GelCreditCardNumberInput", function () {
    return __WEBPACK_IMPORTED_MODULE_36__credit_card_number_input__["a"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "GelCvvInput", function () {
    return __WEBPACK_IMPORTED_MODULE_37__cvv_input__["a"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "GelPasswordInput", function () {
    return __WEBPACK_IMPORTED_MODULE_38__password_input__["a"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "GelPasswordCriteria", function () {
    return __WEBPACK_IMPORTED_MODULE_38__password_input__["b"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "GelProgressBar", function () {
    return __WEBPACK_IMPORTED_MODULE_39__progress_bar__["a"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "useGelProgress", function () {
    return __WEBPACK_IMPORTED_MODULE_39__progress_bar__["b"];
  });
  /* harmony reexport (binding) */


  __webpack_require__.d(__webpack_exports__, "GelProgressStatus", function () {
    return __WEBPACK_IMPORTED_MODULE_40__progress_status__["a"];
  }); // TODO: https://stackoverflow.com/a/56186570
  // babel-polyfill for syntax which cannot be transpiled by babel 
  // https://levelup.gitconnected.com/why-you-should-add-babel-polyfill-for-every-react-application-1997bdb8a524
  // Currently coming from /tal-gel-component-lib/node_modules/core-js/stable/index.js
  // https://github.com/babel/babel/issues/9849#issuecomment-487040428
  // Currently coming from /tal-gel-component-lib/src/component-lib/node_modules/regenerator-runtime/runtime.js

  /***/

},
/* 308 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony export (binding) */

  __webpack_require__.d(__webpack_exports__, "a", function () {
    return CardLayout;
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(5);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof__ = __webpack_require__(103);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__emotion_styled__ = __webpack_require__(14);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__emotion_styled___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__emotion_styled__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6__tal_gel_core__ = __webpack_require__(7);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6__tal_gel_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__tal_gel_core__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7__grid_screen_detector__ = __webpack_require__(33);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_8__box_layout__ = __webpack_require__(137);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_9__container_lite__ = __webpack_require__(62);

  var _excluded = ["fluid", "verticalMasonry", "cardWidth", "gap", "distribution", "children"]; // TODO: Typescript, then no need for conversion from string to number
  // TODO: Other masonry modes

  var CardLayoutComponent = function CardLayoutComponent(_ref) {
    var fluid = _ref.fluid,
        verticalMasonry = _ref.verticalMasonry,
        cardWidth = _ref.cardWidth,
        _ref$gap = _ref.gap,
        gap = _ref$gap === void 0 ? 'medium' : _ref$gap,
        _ref$distribution = _ref.distribution,
        distribution = _ref$distribution === void 0 ? 'center' : _ref$distribution,
        children = _ref.children,
        props = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties___default()(_ref, _excluded);

    var _useContext = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_7__grid_screen_detector__["a"
    /* ScreenDetectorContext */
    ]),
        screen = _useContext.screen,
        findScreenPropByScreen = _useContext.findScreenPropByScreen,
        gridGutters = _useContext.gridGutters; // For when layout is not fluid
    // We don't need to get the return value of useWindowSize,
    // as we only need it to trigger re-render once window size changes


    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__tal_gel_core__["useWindowSize"])();

    var gutterWidth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__container_lite__["a"
    /* getGutter */
    ])(gridGutters, gap);

    var containerRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useRef"])();

    var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useState"])(0),
        _useState2 = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray___default()(_useState, 2),
        numOfCardsPerRow = _useState2[0],
        setNumOfCardsPerRow = _useState2[1];

    var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useState"])(false),
        _useState4 = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray___default()(_useState3, 2),
        needsSqueezeWhenNotFluid = _useState4[0],
        setNeedsSqueezeWhenNotFluid = _useState4[1];

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__tal_gel_core__["useLayoutEffect"])(function () {
      // Flexible card width but fixed number of cards per row 
      // (for each range of screen sizes)
      if (fluid) {
        // Do not put this snippet of code directly in the component function,
        // as it will cause infinite re-renders (See useLayoutEffect of dropdown)
        if (__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof___default()(verticalMasonry) === 'object' && verticalMasonry !== null) {
          var screenProp = findScreenPropByScreen(screen, verticalMasonry); // Get the number of cards per row for the current screen size, 
          // as configured in the object of verticalMasonry

          setNumOfCardsPerRow(screenProp ? verticalMasonry[screenProp] : 1);
        }
      } // Fixed card width but flexible number of cards per row (fit as many as possible)
      else if (verticalMasonry && containerRef.current) {
        // Calculate the max number of cards per row 
        // for the current screen size
        var result = Math.floor((containerRef.current.offsetWidth + gutterWidth) / (cardWidth + gutterWidth));

        if (result) {
          setNumOfCardsPerRow(result);
          setNeedsSqueezeWhenNotFluid(false);
        } else {
          // result === 0
          // At least one card per row, and if it's forced to be 1, 
          // it will squeeze the card width
          setNumOfCardsPerRow(1);
          setNeedsSqueezeWhenNotFluid(true);
        }
      }
    }); // Picks all the cards that should go into the specified column


    var pickCardsByColumnIndex = function pickCardsByColumnIndex(columnIndex) {
      if (numOfCardsPerRow === 0) return;
      return cards.filter(function (_, index) {
        return index % numOfCardsPerRow === columnIndex;
      });
    }; // Card width is flexible if layout is fluid or if card width 
    // is supposed to be fixed but needs squeezing to fit onto a row 
    // (can happen on mobile screen)


    var isCardWidthFlexible = function isCardWidthFlexible() {
      return fluid || needsSqueezeWhenNotFluid;
    };

    var cards;

    if (isCardWidthFlexible()) {
      // Don't do anything about the children, 
      // as we assume each child is fluid in width (eg: a div or has `width: 100%`)
      cards = __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.toArray(children);
    } else {
      // Otherwise, wrap each card provided in children to set a fixed card width
      cards = __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.toArray(children).map(function (child, index) {
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(CardWrapper, {
          key: index,
          cardWidth: cardWidth
        }, child);
      });
    } // Construct columns of cards


    var columns = [];

    for (var i = 0; i < numOfCardsPerRow; i++) {
      columns.push( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__box_layout__["a"
      /* BoxLayout */
      ], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
        key: i,
        vertical: true,
        gap: gap,
        distribution: "start"
      }, isCardWidthFlexible() && {
        alignment: 'stretch'
      }), pickCardsByColumnIndex(i)));
    }

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__box_layout__["a"
    /* BoxLayout */
    ], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
      ref: containerRef,
      gap: gap,
      alignment: "start",
      space: !isCardWidthFlexible() ? 'auto' : 1
    }, !isCardWidthFlexible() && {
      distribution: distribution
    }, {
      wrap: !fluid
    }, props), columns);
  };

  var CardWrapper = __WEBPACK_IMPORTED_MODULE_5__emotion_styled___default.a.div(function (_ref2) {
    var cardWidth = _ref2.cardWidth;
    return {
      width: cardWidth
    };
  });

  var CardLayout = CardLayoutComponent;
  /***/
},
/* 309 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony export (binding) */

  __webpack_require__.d(__webpack_exports__, "a", function () {
    return ColumnLayout;
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(5);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__grid_screen_detector__ = __webpack_require__(33);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4__grid_row__ = __webpack_require__(106);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__grid_col__ = __webpack_require__(105);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6__container_lite__ = __webpack_require__(62);

  var _excluded = ["gutter", "distribution", "verticalGutter", "style", "children"]; // Illustratively,
  //
  // <GelColumnLayout distribution="1/3 1/3 1/3">
  //   <Block />
  //   <Block />
  //   <Block />
  // </GelBoxLayout>
  //
  // will become (props omitted):
  //
  // <Row>
  //   <Col><Block /></Col>
  //   <Col><Block /></Col>
  //   <Col><Block /></Col>
  // </Row>
  //
  // `Row` is flexbox and `Col` is flex item
  // Each `Block` will be wrapped by a flex item (container)
  // whose width can be greater than `Block`
  // Predefined column layouts (all vertically stacked on mobile view)
  // TODO: Check example 12 in the playground (bug with margin)

  var DistributionType = {
    // allows for multi-line
    D_1: '1',
    D_1_2__1_2: '1/2 1/2',
    D_1_3__1_3__1_3: '1/3 1/3 1/3',
    D_2_3__1_3: '2/3 1/3',
    D_1_3__2_3: '1/3 2/3',
    D_1_4__1_4__1_4__1_4: '1/4 1/4 1/4 1/4',
    D_2_4__1_4__1_4: '2/4 1/4 1/4',
    D_1_4__2_4__1_4: '1/4 2/4 1/4',
    D_1_4__1_4__2_4: '1/4 1/4 2/4',
    D_3_4__1_4: '3/4 1/4',
    D_1_4__3_4: '1/4 3/4'
  }; // Responsive flexbox based on flex-basis (%) - allowing for multi-line
  // The Row and Col components wrapped can both have access to 
  // ScreenDetector, so are both responsive

  var ColumnLayoutComponent = function ColumnLayoutComponent(_ref) {
    var _ref$gutter = _ref.gutter,
        gutter = _ref$gutter === void 0 ? 'large' : _ref$gutter,
        _ref$distribution = _ref.distribution,
        distribution = _ref$distribution === void 0 ? DistributionType.D_1 : _ref$distribution,
        _ref$verticalGutter = _ref.verticalGutter,
        verticalGutter = _ref$verticalGutter === void 0 ? 'large' : _ref$verticalGutter,
        style = _ref.style,
        children = _ref.children,
        props = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default()(_ref, _excluded);

    var _useContext = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_3__grid_screen_detector__["a"
    /* ScreenDetectorContext */
    ]),
        screen = _useContext.screen,
        isLargerThanXsScreen = _useContext.isLargerThanXsScreen,
        isLargerThanMdScreen = _useContext.isLargerThanMdScreen,
        gridColumns = _useContext.gridColumns,
        gridGutters = _useContext.gridGutters;

    var filteredChildren = __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.toArray(children).filter(function (child) {
      // Skip empty child (Eg: can happen with conditional render and commenting)
      return child && child !== ' ';
    });

    var gutterWidth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__container_lite__["a"
    /* getGutter */
    ])(gridGutters, gutter);

    var verticalGutterHeight = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__container_lite__["a"
    /* getGutter */
    ])(gridGutters, verticalGutter); // To deal with when the amount of children provided is greater than
    // indicated by the distribution type


    var getMarginTop = function getMarginTop(columnIndex, numOfColumnsToIgnoreAtFront) {
      if (columnIndex >= numOfColumnsToIgnoreAtFront) {
        return {
          style: {
            marginTop: verticalGutterHeight
          }
        };
      }

      return;
    }; // Predefined screens are listed by size (from small to large)
    // `getScreenByIndex(0)` returns screen name of the smallest screen
    // `getScreenByIndex(1)` returns screen name of the second smallest screen


    var cols;

    switch (distribution) {
      case DistributionType.D_1:
        cols = filteredChildren.map(function (child, index) {
          return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__grid_col__["a"
          /* Col */
          ], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
            key: index,
            xs: gridColumns
          }, getMarginTop(index, 1)), child);
        });
        break;

      case DistributionType.D_1_2__1_2:
        cols = filteredChildren.map(function (child, index) {
          return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__grid_col__["a"
          /* Col */
          ], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
            key: index,
            sm: gridColumns / 2
          }, getMarginTop(index, isLargerThanXsScreen(screen) ? 2 : 1)), child);
        });
        break;

      case DistributionType.D_1_3__1_3__1_3:
        cols = filteredChildren.map(function (child, index) {
          return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__grid_col__["a"
          /* Col */
          ], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
            key: index,
            sm: gridColumns / 3
          }, getMarginTop(index, isLargerThanXsScreen(screen) ? 3 : 1)), child);
        });
        break;

      case DistributionType.D_2_3__1_3:
        cols = filteredChildren.map(function (child, index) {
          return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__grid_col__["a"
          /* Col */
          ], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
            key: index,
            sm: index % 2 === 0 ? gridColumns * 2 / 3 : gridColumns / 3
          }, getMarginTop(index, isLargerThanXsScreen(screen) ? 2 : 1)), child);
        });
        break;

      case DistributionType.D_1_3__2_3:
        cols = filteredChildren.map(function (child, index) {
          return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__grid_col__["a"
          /* Col */
          ], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
            key: index,
            sm: index % 2 === 0 ? gridColumns / 3 : gridColumns * 2 / 3
          }, getMarginTop(index, isLargerThanXsScreen(screen) ? 2 : 1)), child);
        });
        break;

      case DistributionType.D_1_4__1_4__1_4__1_4:
        cols = filteredChildren.map(function (child, index) {
          return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__grid_col__["a"
          /* Col */
          ], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
            key: index,
            sm: gridColumns / 2,
            lg: gridColumns / 4
          }, getMarginTop(index, isLargerThanMdScreen(screen) ? 4 : isLargerThanXsScreen(screen) ? 2 : 1)), child);
        });
        break;

      case DistributionType.D_2_4__1_4__1_4:
        cols = filteredChildren.map(function (child, index) {
          return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__grid_col__["a"
          /* Col */
          ], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
            key: index,
            sm: index % 3 === 0 ? gridColumns / 2 : gridColumns / 4
          }, getMarginTop(index, isLargerThanXsScreen(screen) ? 3 : 1)), child);
        });
        break;

      case DistributionType.D_1_4__2_4__1_4:
        cols = filteredChildren.map(function (child, index) {
          return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__grid_col__["a"
          /* Col */
          ], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
            key: index,
            sm: index % 3 === 1 ? gridColumns / 2 : gridColumns / 4
          }, getMarginTop(index, isLargerThanXsScreen(screen) ? 3 : 1)), child);
        });
        break;

      case DistributionType.D_1_4__1_4__2_4:
        cols = filteredChildren.map(function (child, index) {
          return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__grid_col__["a"
          /* Col */
          ], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
            key: index,
            sm: index % 3 === 2 ? gridColumns / 2 : gridColumns / 4
          }, getMarginTop(index, isLargerThanXsScreen(screen) ? 3 : 1)), child);
        });
        break;

      case DistributionType.D_3_4__1_4:
        cols = filteredChildren.map(function (child, index) {
          return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__grid_col__["a"
          /* Col */
          ], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
            key: index,
            sm: index % 2 === 0 ? gridColumns * 3 / 4 : gridColumns / 4
          }, getMarginTop(index, isLargerThanXsScreen(screen) ? 2 : 1)), child);
        });
        break;

      case DistributionType.D_1_4__3_4:
        cols = filteredChildren.map(function (child, index) {
          return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__grid_col__["a"
          /* Col */
          ], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
            key: index,
            sm: index % 2 === 0 ? gridColumns / 4 : gridColumns * 3 / 4
          }, getMarginTop(index, isLargerThanXsScreen(screen) ? 2 : 1)), child);
        });
        break;
    }

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__grid_row__["a"
    /* Row */
    ], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
      gutter: gutterWidth,
      style: style
    }, props), cols);
  };

  var ColumnLayout = ColumnLayoutComponent;
  /***/
},
/* 310 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony export (binding) */

  __webpack_require__.d(__webpack_exports__, "a", function () {
    return Link;
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(5);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4__emotion_styled__ = __webpack_require__(14);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4__emotion_styled___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__emotion_styled__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__tal_gel_theming__ = __webpack_require__(11);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__tal_gel_theming___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__tal_gel_theming__);

  var _excluded = ["children"];

  var LinkComponent = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef(function (_ref, forwardedRef) {
    var children = _ref.children,
        props = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties___default()(_ref, _excluded); // Cannot only rely on `:focus` to display the outline


    var _usePressedState = usePressedState(props),
        _usePressedState2 = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default()(_usePressedState, 3),
        pressed = _usePressedState2[0],
        onPress = _usePressedState2[1],
        onUnpress = _usePressedState2[2];

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Fragment, null, (props.embedded || props.inline) && "\xA0", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(LinkWrapper, {
      theme: props.theme,
      disabled: props.disabled
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(StyledLink, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
      "data-cy": "gel-link",
      ref: forwardedRef
    }, props, {
      tabIndex: props.disabled ? '-1' : '0',
      pressed: pressed,
      onClick: onPress,
      onBlur: onUnpress
    }), children)), (props.embedded || props.inline) && "\xA0");
  });

  var LinkWrapper = __WEBPACK_IMPORTED_MODULE_4__emotion_styled___default.a.span(function (_ref2) {
    var theme = _ref2.theme,
        disabled = _ref2.disabled;
    return theme.Link.getLinkWrapperStyle({
      disabled: disabled
    });
  });

  var StyledLink = __WEBPACK_IMPORTED_MODULE_4__emotion_styled___default.a.a(function (_ref3) {
    var theme = _ref3.theme,
        _ref3$inverse = _ref3.inverse,
        inverse = _ref3$inverse === void 0 ? false : _ref3$inverse,
        disabled = _ref3.disabled,
        underlineThickness = _ref3.underlineThickness,
        pressed = _ref3.pressed,
        backgroundColorOnHover = _ref3.backgroundColorOnHover,
        backgroundColorOnActive = _ref3.backgroundColorOnActive,
        underlineColor = _ref3.underlineColor;
    return theme.Link.getLinkStyle({
      inverse: inverse,
      disabled: disabled,
      pressed: pressed,
      underlineThickness: underlineThickness,
      underlineColor: underlineColor,
      backgroundColorOnHover: backgroundColorOnHover,
      backgroundColorOnActive: backgroundColorOnActive
    });
  });
  /**
   * Custom hook to manage the pressed state of button
   * Pressed state is when a button "has been" clicked
   */


  var usePressedState = function usePressedState(_ref4) {
    var onClick = _ref4.onClick,
        onBlur = _ref4.onBlur;

    var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react__["useState"])(false),
        _useState2 = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default()(_useState, 2),
        pressed = _useState2[0],
        setPressed = _useState2[1];

    var onPress = function onPress(event) {
      setPressed(true); // invoke custom click handler if provided

      onClick && onClick(event);
    };

    var onUnpress = function onUnpress(event) {
      setPressed(false); // invoke custom blur handler if provided

      onBlur && onBlur(event);
    };

    return [pressed, onPress, onUnpress];
  };

  var Link = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__tal_gel_theming__["withTheme"])(LinkComponent);
  /***/

},
/* 311 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony export (binding) */

  __webpack_require__.d(__webpack_exports__, "b", function () {
    return ListItem;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "a", function () {
    return List;
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__ = __webpack_require__(5);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4__emotion_styled__ = __webpack_require__(14);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4__emotion_styled___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__emotion_styled__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__tal_gel_theming__ = __webpack_require__(11);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__tal_gel_theming___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__tal_gel_theming__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6__icon__ = __webpack_require__(45);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7__layout_container_lite__ = __webpack_require__(62);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_8__grid_screen_detector__ = __webpack_require__(33);

  var _excluded = ["ordered", "dot", "check", "gap", "alignment", "style", "iconSize", "iconOffset", "iconColor", "children"];

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);

      if (enumerableOnly) {
        symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
      }

      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  var ListContext = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createContext();

  var ListComponent = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef(function (_ref, forwardedRef) {
    var ordered = _ref.ordered,
        dot = _ref.dot,
        check = _ref.check,
        gap = _ref.gap,
        alignment = _ref.alignment,
        style = _ref.style,
        _ref$iconSize = _ref.iconSize,
        iconSize = _ref$iconSize === void 0 ? 'medium' : _ref$iconSize,
        iconOffset = _ref.iconOffset,
        iconColor = _ref.iconColor,
        children = _ref.children,
        props = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties___default()(_ref, _excluded);

    var childArray = __WEBPACK_IMPORTED_MODULE_3_react___default.a.Children.toArray(children);

    childArray.forEach(function (child) {
      if (child.type !== ListItem) {
        // if any child is not a ListItem, throw error
        throw "Only 'ListItem' components are allowed inside of 'List'";
      }
    });

    if (ordered && check) {
      throw 'Check list cannot be ordered list at the same time';
    }

    var _useContext = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_8__grid_screen_detector__["a"
    /* ScreenDetectorContext */
    ]),
        gridGutters = _useContext.gridGutters;

    gap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__layout_container_lite__["a"
    /* getGutter */
    ])(gridGutters, gap);

    var listContext = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react__["useMemo"])(function () {
      return {
        ordered: ordered,
        check: check,
        gap: gap
      };
    }, [// only create a new `listContext` when `ordered`, `check` or `gap` changes
    ordered, check, gap]);

    if (alignment === 'start') alignment = 'flex-start';
    if (alignment === 'end') alignment = 'flex-end';
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ListContext.Provider, {
      value: listContext
    }, !ordered ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(StyledUl, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({
      style: style,
      ref: forwardedRef
    }, props), __WEBPACK_IMPORTED_MODULE_3_react___default.a.Children.map(children, function (child) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.cloneElement(child, {
        // ListItem
        iconSize: iconSize,
        alignment: alignment,
        iconOffset: iconOffset,
        iconColor: iconColor
      });
    })) : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(StyledOl, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({
      style: style,
      ref: forwardedRef
    }, props), __WEBPACK_IMPORTED_MODULE_3_react___default.a.Children.map(children, function (child, index) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.cloneElement(child, {
        // ListItem
        index: index + 1,
        // `index` prop for ordered list item
        dot: dot,
        alignment: alignment,
        iconSize: iconSize // Need iconSize to determine width

      });
    })));
  });

  var ListItem = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.memo(function (_ref2) {
    var style = _ref2.style,
        index = _ref2.index,
        dot = _ref2.dot,
        alignment = _ref2.alignment,
        iconSize = _ref2.iconSize,
        iconOffset = _ref2.iconOffset,
        iconColor = _ref2.iconColor,
        children = _ref2.children;

    var listContext = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react__["useContext"])(ListContext);

    var theme = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_5__tal_gel_theming__["ThemeContext"]);

    var iconInfo = getIconInfo(theme, listContext, iconSize); // `null` if it's an ordered list item

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(StyledLi, {
      theme: theme,
      listContext: listContext,
      alignment: alignment
    }, iconInfo &&
    /*#__PURE__*/
    // display an appropriate icon if it's not an ordered list item
    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__icon__["a"
    /* Icon */
    ], __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({}, iconInfo, {
      style: _objectSpread(_objectSpread({}, style), iconOffset && {
        marginTop: iconOffset
      })
    }, iconColor && {
      color: iconColor
    })), index &&
    /*#__PURE__*/
    // display index number if it's an ordered list item
    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ListItemIndexWrapper, {
      theme: theme,
      style: style,
      dot: dot,
      width: iconSize
    }, index), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ListItemContentWrapper, {
      theme: theme,
      listContext: listContext
    }, children));
  });

  var StyledUl = __WEBPACK_IMPORTED_MODULE_4__emotion_styled___default.a.ul({
    listStyle: 'none',
    margin: 0,
    padding: 0
  });

  var StyledOl = __WEBPACK_IMPORTED_MODULE_4__emotion_styled___default.a.ol({
    listStyle: 'none',
    margin: 0,
    padding: 0
  });

  var StyledLi = __WEBPACK_IMPORTED_MODULE_4__emotion_styled___default.a.li({
    display: 'flex'
  }, function (_ref3) {
    var theme = _ref3.theme,
        listContext = _ref3.listContext,
        alignment = _ref3.alignment;
    return {
      alignItems: alignment || 'flex-start',
      ':not(:last-of-type)': _objectSpread(_objectSpread({}, theme.List.ListItem({
        last: false
      })), listContext.gap && {
        marginBottom: listContext.gap
      }),
      ':last-of-type': theme.List.ListItem({
        last: true
      })
    };
  });

  var ListItemIndexWrapper = __WEBPACK_IMPORTED_MODULE_4__emotion_styled___default.a.span( // used by ordered list item only
  function (_ref4) {
    var theme = _ref4.theme,
        dot = _ref4.dot,
        width = _ref4.width;
    return _objectSpread(_objectSpread({}, theme.List.Index(width)), dot && {
      '::after': {
        content: '"."'
      }
    });
  });

  var ListItemContentWrapper = __WEBPACK_IMPORTED_MODULE_4__emotion_styled___default.a.span({
    width: '100%',
    alignSelf: 'center'
  }, function (_ref5) {
    var theme = _ref5.theme;
    return theme.List.ContentWrapper;
  });
  /**
   * Gets icon info if it's a check list item or unordered list item
   * (Ordered list item does not need an icon)
   * 
   * A list item consists of Icon (or Index) and ContentWrapper
   * 
   * @param theme - theme context
   * @param listContext - list context
   */


  var getIconInfo = function getIconInfo(theme, listContext, iconSize) {
    if (!listContext.check && listContext.ordered) {
      return null;
    }

    return _objectSpread(_objectSpread({}, theme.List.Icon), {}, {
      name: theme.List.Icon.name[listContext.check ? 'check' : 'unordered'],
      width: theme.List.Icon.width[iconSize]
    });
  };

  var List = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__tal_gel_theming__["withTheme"])(ListComponent);
  /***/

},
/* 312 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony export (binding) */

  __webpack_require__.d(__webpack_exports__, "a", function () {
    return Modal;
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__ = __webpack_require__(5);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__emotion_styled__ = __webpack_require__(14);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__emotion_styled___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__emotion_styled__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6__tal_gel_theming__ = __webpack_require__(11);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6__tal_gel_theming___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__tal_gel_theming__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7__tal_gel_core__ = __webpack_require__(7);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7__tal_gel_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__tal_gel_core__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_8__icon__ = __webpack_require__(45);

  var _excluded = ["theme", "open", "width", "height", "maxWidth", "fullScreen", "sticky", "title", "action", "children", "onClose", "closeOnBackdropClick"];

  var ModalComponent = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.forwardRef(function (_ref, forwardedRef) {
    var _extends2;

    var theme = _ref.theme,
        open = _ref.open,
        width = _ref.width,
        height = _ref.height,
        maxWidth = _ref.maxWidth,
        fullScreen = _ref.fullScreen,
        sticky = _ref.sticky,
        title = _ref.title,
        action = _ref.action,
        children = _ref.children,
        onClose = _ref.onClose,
        _ref$closeOnBackdropC = _ref.closeOnBackdropClick,
        closeOnBackdropClick = _ref$closeOnBackdropC === void 0 ? true : _ref$closeOnBackdropC,
        props = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties___default()(_ref, _excluded);

    var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useState"])(false),
        _useState2 = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray___default()(_useState, 2),
        isWindowHeightLessThanModal = _useState2[0],
        setIsWindowHeightLessThanModal = _useState2[1];

    var overlayRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useRef"])();

    var headingRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useRef"])();

    var modalContainerRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useRef"])();

    var contentContainerRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useRef"])();

    var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useState"])(0),
        _useState4 = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray___default()(_useState3, 2),
        modalMinHeight = _useState4[0],
        setModalMinHeight = _useState4[1];

    var _useState5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useState"])(0),
        _useState6 = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray___default()(_useState5, 2),
        paddingVerticalDismissIcon = _useState6[0],
        setPaddingVerticalDismissIcon = _useState6[1];

    var modalFullHeight = 0;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useEffect"])(function () {
      if (open) {
        calculateModalFullHeight();
        calculateModalMinHeight();
        checkIfWindowHeightLessThanModal();
        setPaddingVerticalDismissIcon((headingRef.current.offsetHeight - theme.Modal.getDismissIconStyle().width) / 2); // Once open, set focus on the overlay, to make it easier for the subsequent keyboard interactions
        // for example, hitting the tab key for the first time will shift focus to the Exit button

        overlayRef.current && overlayRef.current.focus(); // Emotion Global doesn't seem to work inside this component..

        document.body.style.overflow = 'hidden';
        window.addEventListener('resize', checkIfWindowHeightLessThanModal); // debounce?
      } else {
        document.body.style.overflow = 'auto';
        window.removeEventListener('resize', checkIfWindowHeightLessThanModal);
      }

      return function () {
        window.removeEventListener('resize', checkIfWindowHeightLessThanModal);
      };
    }, [open]);
    /**
     * Calculates full height of Modal
     * 
     * If `height` is specified explicitly for Modal, this height is to be considered as full height of this modal
     * (even if this height could cause vertical scrollbar in the content area)
     * 
     * If `height` is not specified, full height of Modal is when the modal can render fully vertically 
     * (when there is no vertical scrollbar in the content area)
     */


    var calculateModalFullHeight = function calculateModalFullHeight() {
      if (height > 0) {
        // if height is explicitly specified for Modal
        modalFullHeight = height;
      } else {
        modalFullHeight = modalContainerRef.current.offsetHeight + contentContainerRef.current.scrollHeight - contentContainerRef.current.offsetHeight;
      }
    };
    /**
     * Calculates minimum height of Modal
     * 
     * Minimum height of Modal is height of title area + height of action area + necessary gutters 
     * and paddings inside the Modal (content area is omitted) 
     */


    var calculateModalMinHeight = function calculateModalMinHeight() {
      if (height > 0) {
        // if height is explicitly specified for Modal
        setModalMinHeight(modalFullHeight - contentContainerRef.current.offsetHeight);
      } else {
        setModalMinHeight(modalFullHeight - contentContainerRef.current.scrollHeight);
      }
    };
    /**
     * Checks if current window height is less than the modal full height (+ necessary margins)
     * 
     * If less, the actual modal height will be as per the current window height
     * If not less, the actual modal height will be the modal full height
     */


    var checkIfWindowHeightLessThanModal = function checkIfWindowHeightLessThanModal() {
      setIsWindowHeightLessThanModal( // TODO: Should we use innerHeight here? See comment in use-window-size
      window.outerHeight < modalFullHeight + theme.Modal.getContainerStyle({}).margin * 2 // typically margin-top + margin-bottom
      );
    };

    return open && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ModalRoot, {
      theme: theme
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Overlay, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({
      theme: theme
    }, closeOnBackdropClick && {
      onClick: onClose
    }, {
      sticky: sticky,
      isWindowHeightLessThanModal: isWindowHeightLessThanModal,
      ref: overlayRef
    }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ModalContainer, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()((_extends2 = {
      "data-cy": "gel-modal-container",
      ref: forwardedRef,
      theme: theme,
      width: width,
      height: height,
      minHeight: modalMinHeight,
      maxWidth: maxWidth,
      fullScreen: fullScreen,
      isWindowHeightLessThanModal: isWindowHeightLessThanModal
    }, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_extends2, "ref", modalContainerRef), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_extends2, "tabIndex", -1), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_extends2, "onClick", function onClick(event) {
      return event.stopPropagation();
    }), _extends2), props), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(DismissIconContainer, {
      theme: theme,
      paddingVertical: paddingVerticalDismissIcon
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__icon__["a"
    /* Icon */
    ], __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({
      "data-cy": "gel-modal-dismiss"
    }, theme.Modal.getDismissIconStyle(), {
      onClick: onClose
    }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__tal_gel_core__["GelFlexContainer"], {
      flexDirection: "column",
      alignItems: "stretch",
      style: {
        height: '100%',
        margin: 0
      }
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(HeadingContainer, {
      "data-cy": "gel-modal-heading-container",
      theme: theme,
      ref: headingRef
    }, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ContentContainer, {
      "data-cy": "gel-modal-content-container",
      theme: theme,
      ref: contentContainerRef,
      sticky: sticky,
      hasAction: action
    }, children), action && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ActionContainer, {
      "data-cy": "gel-modal-action-container",
      theme: theme
    }, action))))));
  });

  var ModalRoot = __WEBPACK_IMPORTED_MODULE_5__emotion_styled___default.a.div(function (_ref2) {
    var theme = _ref2.theme;
    return theme.Modal.getModalRootStyle();
  });

  var Overlay = __WEBPACK_IMPORTED_MODULE_5__emotion_styled___default.a.div(function (_ref3) {
    var theme = _ref3.theme,
        sticky = _ref3.sticky,
        isWindowHeightLessThanModal = _ref3.isWindowHeightLessThanModal;
    return theme.Modal.getOverlayStyle({
      sticky: sticky,
      isWindowHeightLessThanModal: isWindowHeightLessThanModal
    });
  });
  /**
   * ModalContainer is a flex item inside a flex box (Overlay) (with flex-wrap: nowrap)
   * 
   * ModalContainer has `flex-shrink: 1` by default (flex: 0 1 auto), 
   * so if the window is small in width, ModalContainer will shrink horizontally
   * 
   * If the window is small in height (less than the modal full height), 
   * we do not explicitly set height of ModalContainer so `alignItems: stretch` 
   * in the flex box can adjust the actual height of ModalContainer
   * 
   * If window height is not less than modal full height, we either set the height 
   * of ModalContainer as specified explicitly, or not set the height of ModalContainer 
   * so it can render fully vertically for the actual title, content and action areas.
   * 
   * Note that flex box (flex-direction: row) does not always respect the explicit width (or flex-basis) 
   * of flex items, but it respects the explicit height of flex items so for example `alignItems: stretch` 
   * does not work if a flex item has an explicitly specified height
   */


  var ModalContainer = __WEBPACK_IMPORTED_MODULE_5__emotion_styled___default.a.div(function (_ref4) {
    var theme = _ref4.theme,
        width = _ref4.width,
        height = _ref4.height,
        minHeight = _ref4.minHeight,
        maxWidth = _ref4.maxWidth,
        fullScreen = _ref4.fullScreen,
        isWindowHeightLessThanModal = _ref4.isWindowHeightLessThanModal;
    return theme.Modal.getContainerStyle({
      width: width,
      height: height,
      minHeight: minHeight,
      maxWidth: maxWidth,
      fullScreen: fullScreen,
      isWindowHeightLessThanModal: isWindowHeightLessThanModal
    });
  });

  var HeadingContainer = __WEBPACK_IMPORTED_MODULE_5__emotion_styled___default.a.div(function (_ref5) {
    var theme = _ref5.theme;
    return theme.Modal.getHeadingContainerStyle();
  });

  var DismissIconContainer = __WEBPACK_IMPORTED_MODULE_5__emotion_styled___default.a.div(function (_ref6) {
    var theme = _ref6.theme,
        paddingVertical = _ref6.paddingVertical;
    return theme.Modal.getDismissIconContainerStyle({
      paddingVertical: paddingVertical
    });
  });

  var ContentContainer = __WEBPACK_IMPORTED_MODULE_5__emotion_styled___default.a.div(function (_ref7) {
    var theme = _ref7.theme,
        sticky = _ref7.sticky;
    return theme.Modal.getContentContainerStyle({
      sticky: sticky
    });
  });

  var ActionContainer = __WEBPACK_IMPORTED_MODULE_5__emotion_styled___default.a.div(function (_ref8) {
    var theme = _ref8.theme;
    return theme.Modal.getFooterContainerStyle();
  });

  var Modal = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__tal_gel_theming__["withTheme"])(ModalComponent);
  /***/

},
/* 313 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony export (binding) */

  __webpack_require__.d(__webpack_exports__, "b", function () {
    return convertEventTargetValueToNumeric;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "a", function () {
    return NumberInput;
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(5);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__tal_gel_core__ = __webpack_require__(7);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__tal_gel_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__tal_gel_core__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6__text_input__ = __webpack_require__(46);

  var _excluded = ["value", "defaultValue", "onFocus", "gt", "gte", "lt", "lte", "decimals", "integer", "onError", "errorMsg", "index", "resetValidator", "preventNegative"];

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);

      if (enumerableOnly) {
        symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
      }

      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  } // TODO: mobile number pad?


  var NumberInputComponent = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.forwardRef(function (_ref, forwardedRef) {
    var value = _ref.value,
        defaultValue = _ref.defaultValue,
        onFocus = _ref.onFocus,
        gt = _ref.gt,
        gte = _ref.gte,
        lt = _ref.lt,
        lte = _ref.lte,
        decimals = _ref.decimals,
        integer = _ref.integer,
        onError = _ref.onError,
        errorMsg = _ref.errorMsg,
        index = _ref.index,
        resetValidator = _ref.resetValidator,
        preventNegative = _ref.preventNegative,
        props = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties___default()(_ref, _excluded);

    var _useUnderlyingError = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__tal_gel_core__["useUnderlyingError"])(onError),
        onErrorUnderlying = _useUnderlyingError.onErrorUnderlying,
        onErrorWrapping = _useUnderlyingError.onErrorWrapping;

    var _useValidator = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__tal_gel_core__["useValidator"])(_objectSpread(_objectSpread({}, props), {}, {
      // includes controlled `error`, `caption`, `setValidity`, etc.
      index: index,
      // index assigned by the form 
      reset: resetValidator,
      // whether to reset the validator (`touched` status, etc.)
      value: value,
      defaultValue: defaultValue,
      checkError: true,
      // tells validator whether to check for error
      // tells validator HOW to check for error
      // use `(gt, gte, lt, lte) => value => {}` if extracted out of the component
      hasError: function hasError(value) {
        // Note that for number input, 
        // value can be either a string or numeric value
        // (Check how `hasError` is invoked in useValidator)
        // gt (greather than), gte (greater than or equal to), 
        // lt (less than), lte (less than or equal to)
        // Sometimes `value` can be a string with `,`s. 
        // We remove all `,`s for parseFloat to work properly.
        // This can happen when `preventSubmitOnInvalid` is not
        // set on `GelForm` and when submit button is clicked.
        // (See `submitCheck` in use-validator.js)
        if (typeof value === 'string') {
          value = value && value.split(',').join('');
        }

        if (!value && value !== 0) {
          return false;
        } // Consider it as error if left with `-` or a trailing `.`
        // Consider it as error if left with `-` or a trailing `.`


        if (value === '-' || value[value.length - 1] === '.') {
          return 'format';
        }

        return (gt !== undefined && parseFloat(value) <= parseFloat(gt) || gte !== undefined && parseFloat(value) < parseFloat(gte) || lt !== undefined && parseFloat(value) >= parseFloat(lt) || lte !== undefined && parseFloat(value) > parseFloat(lte)) && 'compare';
      },
      hideErrorInitially: true,
      // tells validator to hide error initially
      onError: onErrorWrapping,
      // tells validator the callback to invoke if error occurs or disappears
      errorMsg: errorMsg // tells validator the error message to include in caption if error occurs

    })),
        _useValidator2 = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray___default()(_useValidator, 4),
        onBlur = _useValidator2[0],
        onChange = _useValidator2[1],
        getCaption = _useValidator2[2],
        shouldShowError = _useValidator2[3];

    var initialInternalValidValue = '';

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__tal_gel_core__["useRunOnce"])(function () {
      if (!isControlled(value) && isControlled(defaultValue) && (isNumeric(defaultValue) || value === '-')) {
        // If 'value' is not controlled by the parent, 
        // and if provided with a valid numeric default value,
        // we set it as the 'initialInternalValidValue' for the input box
        initialInternalValidValue = defaultValue;
      }
    }); // 'internalValidValue' is the internal numeric value if 'value' is not controlled by the parent


    var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useState"])(initialInternalValidValue),
        _useState2 = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray___default()(_useState, 2),
        internalValidValue = _useState2[0],
        setInternalValidValue = _useState2[1];

    var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useState"])(false),
        _useState4 = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray___default()(_useState3, 2),
        focused = _useState4[0],
        setFocused = _useState4[1];

    if (isControlled(value) && !isNumeric(value) && value !== '-') {
      // If 'value' is controlled by the parent 
      // but if the 'value' provided is not numeric,
      // reset the controlled 'value' to empty string
      value = '';
    }

    var isValueValidAsInput = function isValueValidAsInput(event) {
      if (event.target.value === '' || !preventNegative && event.target.value === '-') {
        return true;
      }

      if (integer && event.target.value.indexOf('.') >= 0) {
        return false; // block input
      }

      var isValueNumeric = isNumeric(event.target.value);

      if (isValueNumeric) {
        if (preventNegative && +event.target.value < 0) {
          return false; // block input
        }

        if (decimals === undefined) {
          return true;
        } else if (countDecimals(event.target.value) <= decimals) {
          // If numeric and not exceeding the max number of decimals
          return true;
        }
      }

      return false; // block input
    };

    var _onChange = function _onChange(event) {
      if (event.target.value === '.') {
        // if the input target value is '.', reset it to empty string
        event.target.value = '';
      }

      if (isValueValidAsInput(event)) {
        if (!isControlled(value)) {
          // If 'value' is not controlled by the parent, 
          // and if the input target value is either empty or a valid numeric value,
          // we set the input target value as 'internalValidValue'
          setInternalValidValue(convertEventTargetValueToNumeric(event.target.value));
        } // do not set 'internalValidValue' if 'value' is controlled by the parent


        onChange(event);
      } // do not invoke the parent onChange handler if the changed input target value isn't valid

    };

    var _onFocus = function _onFocus(event) {
      setFocused(true);
      onFocus && onFocus(event); // invoke onFocus handler if provided by the parent 
    };

    var _onBlur = function _onBlur(event) {
      setFocused(false);
      onBlur(event);
    };
    /**
     * Formats the value (either controlled by the parent or internal)
     * as per if the input box is on focus (caret in the box)
     */


    var formatValue = function formatValue() {
      // use the controlled 'value' if controlled, or use the internal valid value
      var valueToUse = isControlled(value) ? value : internalValidValue; // Add commas to the value if the input box is not on focus (for better number display)
      // and do not add commas if the input box is on focus (for entering a number normally)

      return !focused ? withCommas(valueToUse) : valueToUse;
    }; // Control the value of the TextInput wrapped inside
    // with either the internal valid value managed by NumberInput,
    // or with the 'value' of NumberInput controlled by the parent of NumberInput


    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__text_input__["a"
    /* default */
    ], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
      "data-cy": "gel-number-input",
      ref: forwardedRef
    }, props, index !== undefined && {
      index: index + '_0'
    }, {
      // assign a sub index to the underling TextInput
      resetValidator: resetValidator,
      value: formatValue(),
      onChange: _onChange,
      onFocus: _onFocus,
      onBlur: _onBlur,
      caption: getCaption(),
      error: shouldShowError(),
      onError: onErrorUnderlying,
      errorMsg: errorMsg,
      doubleCheck: true // See `onChange` in use-validator

    }));
  });

  var isNumeric = function isNumeric(value) {
    return !isNaN(parseFloat(value)) && isFinite(value);
  };

  var isControlled = function isControlled(prop) {
    return prop !== undefined;
  };

  var withCommas = function withCommas(value) {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  var countDecimals = function countDecimals(value) {
    if (value % 1 !== 0) {
      return value.toString().split('.')[1].length;
    }

    return 0;
  }; // Used by useGelFormData to convert event.target.value to numeric (if valid) or returns as is (if invalid) 


  var convertEventTargetValueToNumeric = function convertEventTargetValueToNumeric(value) {
    return value === '' ? null : // returns '.' or something like '1.' as invalid value (format error in GelNumberInput)
    value !== '-' && value[value.length - 1] !== '.' ? +value : value;
  };

  var NumberInput = NumberInputComponent;
  /***/
},
/* 314 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony export (binding) */

  __webpack_require__.d(__webpack_exports__, "b", function () {
    return PasswordCriteria;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "a", function () {
    return PasswordInput;
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(5);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__emotion_styled__ = __webpack_require__(14);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__emotion_styled___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__emotion_styled__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6__tal_gel_core__ = __webpack_require__(7);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6__tal_gel_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__tal_gel_core__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7__tal_gel_theming__ = __webpack_require__(11);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7__tal_gel_theming___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__tal_gel_theming__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_8__text_input__ = __webpack_require__(46);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_9__icon__ = __webpack_require__(45);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_10__layout__ = __webpack_require__(73);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_11__typography__ = __webpack_require__(179);

  var _excluded = ["value", "defaultValue", "onError", "errorMsg", "index", "resetValidator", "criteria", "theme"];

  function _createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

    if (!it) {
      if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;

        var F = function F() {};

        return {
          s: F,
          n: function n() {
            if (i >= o.length) return {
              done: true
            };
            return {
              done: false,
              value: o[i++]
            };
          },
          e: function e(_e) {
            throw _e;
          },
          f: F
        };
      }

      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }

    var normalCompletion = true,
        didErr = false,
        err;
    return {
      s: function s() {
        it = it.call(o);
      },
      n: function n() {
        var step = it.next();
        normalCompletion = step.done;
        return step;
      },
      e: function e(_e2) {
        didErr = true;
        err = _e2;
      },
      f: function f() {
        try {
          if (!normalCompletion && it["return"] != null) it["return"]();
        } finally {
          if (didErr) throw err;
        }
      }
    };
  }

  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }

  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);

      if (enumerableOnly) {
        symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
      }

      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  var PasswordCriteria = {
    minLength: function minLength(min) {
      return function (value) {
        return value.length >= min;
      };
    },
    maxLength: function maxLength(max) {
      return function (value) {
        return value.length <= max;
      };
    },
    hasUpperLowercase: function hasUpperLowercase(value) {
      return /[A-Z]/g.test(value) && /[a-z]/g.test(value);
    },
    containsNumber: function containsNumber(value) {
      return /[0-9]/g.test(value);
    },
    containsSpecialCharacter: function containsSpecialCharacter(value) {
      return /[@$!%*#?&]/g.test(value);
    },
    noWhitespace: function noWhitespace(value) {
      return value.indexOf(' ') < 0;
    }
  };

  var PasswordInputComponent = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.forwardRef(function (_ref, forwardedRef) {
    var value = _ref.value,
        defaultValue = _ref.defaultValue,
        onError = _ref.onError,
        errorMsg = _ref.errorMsg,
        index = _ref.index,
        resetValidator = _ref.resetValidator,
        criteria = _ref.criteria,
        theme = _ref.theme,
        props = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties___default()(_ref, _excluded);

    var inputRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useRef"])();

    var getInputRef = function getInputRef() {
      return forwardedRef || inputRef;
    };

    var _useUnderlyingError = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__tal_gel_core__["useUnderlyingError"])(onError),
        onErrorUnderlying = _useUnderlyingError.onErrorUnderlying,
        onErrorWrapping = _useUnderlyingError.onErrorWrapping;

    var _useValidator = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__tal_gel_core__["useValidator"])(_objectSpread(_objectSpread({}, props), {}, {
      // includes controlled `error`, `caption`, `setValidity`, etc.
      index: index,
      // index assigned by the form 
      reset: resetValidator,
      // whether to reset the validator (`touched` status, etc.)
      value: value,
      defaultValue: defaultValue,
      checkError: true,
      // tells validator whether to check for error
      hasError: function hasError(value) {
        // tells validator HOW to check for error
        if (criteria) {
          var _iterator = _createForOfIteratorHelper(criteria),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var each = _step.value;

              if (!each.validation(value)) {
                return 'invalid';
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }

        return false;
      },
      hideErrorInitially: true,
      // tells validator to hide error initially
      onError: onErrorWrapping,
      // tells validator the callback to invoke if error occurs or disappears
      errorMsg: errorMsg // tells validator the error message to include in caption if error occurs

    })),
        _useValidator2 = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray___default()(_useValidator, 4),
        onBlur = _useValidator2[0],
        onChange = _useValidator2[1],
        getCaption = _useValidator2[2],
        shouldShowError = _useValidator2[3];

    var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useState"])(false),
        _useState2 = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray___default()(_useState, 2),
        showPassword = _useState2[0],
        setShowPassword = _useState2[1];

    var onSuffixIconClick = function onSuffixIconClick() {
      setShowPassword(!showPassword);
      var timer = setTimeout(function () {
        getInputRef().current.focus();
        getInputRef().current.click();

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__tal_gel_core__["setCaretPos"])(getInputRef().current, getInputRef().current.value.length);

        clearTimeout(timer);
      });
    };

    var visibleIconMouseDown = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useRef"])(false);

    var onVisibleIconMouseDown = function onVisibleIconMouseDown() {
      return visibleIconMouseDown.current = true;
    };
    /**
     * Mousedown event on visible icon happens before onBlur of input
     * 
     * Do not trigger onBlur of validator (avoid showing error) 
     * if the visible icon is being clicked
     */


    var _onBlur = function _onBlur(event) {
      if (!visibleIconMouseDown.current) {
        onBlur(event); // surfaced by the validator
      } else {
        visibleIconMouseDown.current = false;
      }
    }; // Control the value of the TextInput wrapped inside
    // with either the internal valid value managed by NumberInput,
    // or with the 'value' of NumberInput controlled by the parent of NumberInput


    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__text_input__["a"
    /* default */
    ], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
      "data-cy": "gel-password-input",
      ref: getInputRef()
    }, props, index !== undefined && {
      index: index + '_0'
    }, {
      // assign a sub index to the underling TextInput
      type: !showPassword ? 'password' : 'text',
      suffixIcon: !showPassword ? 'VisibleOn' : 'VisibleOff',
      onSuffixIconClick: onSuffixIconClick,
      onSuffixIconMouseDown: onVisibleIconMouseDown,
      resetValidator: resetValidator,
      value: value,
      onChange: onChange,
      onBlur: _onBlur,
      caption: getCaption(),
      error: shouldShowError(),
      onError: onErrorUnderlying,
      errorMsg: errorMsg
    })), criteria && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__layout__["d"
    /* ContainerLite */
    ], {
      gutter: {
        top: 'medium',
        horizontal: 0
      }
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__layout__["c"
    /* RowLayout */
    ], {
      gutter: "small"
    }, criteria.map(function (each, index) {
      var met = each.validation(value);
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__layout__["b"
      /* BoxLayout */
      ], {
        key: index,
        space: ['auto', 1],
        gap: "none",
        alignment: "start"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(StepStatusContainer, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
        theme: theme
      }, met ? {
        isComplete: true
      } : {
        isTodo: true
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__icon__["a"
      /* Icon */
      ], theme.ProgressStatus.progressStatusIcon(_objectSpread(_objectSpread({
        isIcon: true
      }, met ? {
        isComplete: true
      } : {
        isTodo: true
      }), {}, {
        isPasswordCriteria: true
      })))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__typography__["l"
      /* GelParagraph */
      ], {
        "data-cy": "gel-password-criteria"
      }, each.label));
    }))));
  });

  var StepStatusContainer = __WEBPACK_IMPORTED_MODULE_5__emotion_styled___default.a.div(function (_ref2) {
    var theme = _ref2.theme,
        isComplete = _ref2.isComplete,
        isTodo = _ref2.isTodo;
    return _objectSpread(_objectSpread({}, theme.ProgressStatus.progressStatusContainer({
      isComplete: isComplete,
      isTodo: isTodo
    })), {}, {
      marginTop: -2 // TODO: Use token for it

    });
  });

  var PasswordInput = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__tal_gel_theming__["withTheme"])(PasswordInputComponent);
  /***/

},
/* 315 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony export (binding) */

  __webpack_require__.d(__webpack_exports__, "a", function () {
    return PhoneNumberInput;
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(5);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__tal_gel_core__ = __webpack_require__(7);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__tal_gel_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__tal_gel_core__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6__text_input__ = __webpack_require__(46);

  var _excluded = ["value", "defaultValue", "onFocus", "onError", "errorMsg", "index", "resetValidator"];

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);

      if (enumerableOnly) {
        symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
      }

      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  var PHONE_NUMBER_LENGTH = 10;

  var PhoneNumberInputComponent = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.forwardRef(function (_ref, forwardedRef) {
    var value = _ref.value,
        defaultValue = _ref.defaultValue,
        onFocus = _ref.onFocus,
        onError = _ref.onError,
        errorMsg = _ref.errorMsg,
        index = _ref.index,
        resetValidator = _ref.resetValidator,
        props = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties___default()(_ref, _excluded);

    var _useUnderlyingError = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__tal_gel_core__["useUnderlyingError"])(onError),
        onErrorUnderlying = _useUnderlyingError.onErrorUnderlying,
        onErrorWrapping = _useUnderlyingError.onErrorWrapping;

    var _useValidator = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__tal_gel_core__["useValidator"])(_objectSpread(_objectSpread({}, props), {}, {
      // includes controlled `error`, `caption`, `setValidity`, etc.
      index: index,
      // index assigned by the form 
      reset: resetValidator,
      // whether to reset the validator (`touched` status, etc.)
      value: value,
      defaultValue: defaultValue,
      checkError: true,
      // tells validator whether to check for error
      hasError: function hasError(value) {
        // tells validator HOW to check for error
        // Remove spaces, as sometimes value can be formatted 
        // (when input not on focus)
        value = value.replace(/\s/g, '');

        if (value) {
          if (value.length !== PHONE_NUMBER_LENGTH) {
            return 'length';
          }

          var prefix = value.slice(0, 2);

          if (prefix !== '02' && prefix !== '03' && prefix !== '04' && prefix !== '07' && prefix !== '08') {
            return 'prefix';
          }
        }

        return false;
      },
      hideErrorInitially: true,
      // tells validator to hide error initially
      onError: onErrorWrapping,
      errorMsg: errorMsg // tells validator the error message to include in caption if error occurs

    })),
        _useValidator2 = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray___default()(_useValidator, 4),
        onBlur = _useValidator2[0],
        onChange = _useValidator2[1],
        getCaption = _useValidator2[2],
        shouldShowError = _useValidator2[3];

    var initialInternalValidValue = '';

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__tal_gel_core__["useRunOnce"])(function () {
      if (!isControlled(value) && isControlled(defaultValue) && isDigitsOnly(defaultValue)) {
        // If 'value' is not controlled by the parent, 
        // and if provided with a valid numeric default value,
        // we set it as the 'initialInternalValidValue' for the input box
        initialInternalValidValue = defaultValue;
      }
    }); // 'internalValidValue' is the internal numeric value if 'value' is not controlled by the parent


    var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useState"])(initialInternalValidValue),
        _useState2 = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray___default()(_useState, 2),
        internalValidValue = _useState2[0],
        setInternalValidValue = _useState2[1];

    var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useState"])(false),
        _useState4 = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray___default()(_useState3, 2),
        focused = _useState4[0],
        setFocused = _useState4[1];

    if (isControlled(value) && !isDigitsOnly(value)) {
      // If 'value' is controlled by the parent 
      // but if the 'value' provided is not numeric,
      // reset the controlled 'value' to empty string
      value = '';
    }

    var _onChange = function _onChange(event) {
      if (isDigitsOnly(event.target.value) && event.target.value.length <= PHONE_NUMBER_LENGTH || event.target.value === '') {
        if (!isControlled(value)) {
          // If 'value' is not controlled by the parent, 
          // and if the input target value is either empty or a valid numeric value,
          // we set the input target value as 'internalValidValue'
          setInternalValidValue(event.target.value);
        } // do not set 'internalValidValue' if 'value' is controlled by the parent


        onChange(event);
      } // do not invoke the parent onChange handler if the changed input target value isn't valid

    };

    var _onFocus = function _onFocus(event) {
      setFocused(true);
      onFocus && onFocus(event); // invoke onFocus handler if provided by the parent 
    };

    var _onBlur = function _onBlur(event) {
      setFocused(false);
      onBlur(event);
    };
    /**
     * Formats the value (either controlled by the parent or internal)
     * as per if the input box is on focus (caret in the box)
     */


    var formatValue = function formatValue() {
      // use the controlled 'value' if controlled, or use the internal valid value
      var valueToUse = isControlled(value) ? value : internalValidValue; // Add commas to the value if the input box is not on focus (for better number display)
      // and do not add commas if the input box is on focus (for entering a number normally)

      return !focused ? withSpaces(valueToUse) : valueToUse;
    }; // Control the value of the TextInput wrapped inside
    // with either the internal valid value managed by NumberInput,
    // or with the 'value' of NumberInput controlled by the parent of NumberInput


    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__text_input__["a"
    /* default */
    ], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
      "data-cy": "gel-phone-number-input",
      ref: forwardedRef
    }, props, index !== undefined && {
      index: index + '_0'
    }, {
      // assign a sub index to the underling TextInput
      type: "tel",
      resetValidator: resetValidator,
      value: formatValue(),
      onChange: _onChange,
      onFocus: _onFocus,
      onBlur: _onBlur,
      caption: getCaption(),
      error: shouldShowError(),
      onError: onErrorUnderlying,
      errorMsg: errorMsg,
      doubleCheck: true // See `onChange` in use-validator

    }));
  });

  var isDigitsOnly = function isDigitsOnly(value) {
    return /^\d+$/.test(value);
  };

  var isControlled = function isControlled(prop) {
    return prop !== undefined;
  };

  var withSpaces = function withSpaces(value) {
    var part1 = value.slice(0, 4);
    var part2 = value.slice(4, 7);
    var part3 = value.slice(7, 10);
    return "".concat(part1).concat(part2 ? ' ' + part2 : '').concat(part3 ? ' ' + part3 : '');
  };

  var PhoneNumberInput = PhoneNumberInputComponent;
  /***/
},
/* 316 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony export (binding) */

  __webpack_require__.d(__webpack_exports__, "a", function () {
    return PostcodeInput;
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(5);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__tal_gel_core__ = __webpack_require__(7);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__tal_gel_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__tal_gel_core__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6__text_input__ = __webpack_require__(46);

  var _excluded = ["value", "defaultValue", "onFocus", "onError", "errorMsg", "index", "resetValidator"];

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);

      if (enumerableOnly) {
        symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
      }

      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  var POSTCODE_LENGTH = 4; // TODO: to be consolidated with CvvInput?

  var PostcodeInputComponent = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.forwardRef(function (_ref, forwardedRef) {
    var value = _ref.value,
        defaultValue = _ref.defaultValue,
        onFocus = _ref.onFocus,
        onError = _ref.onError,
        errorMsg = _ref.errorMsg,
        index = _ref.index,
        resetValidator = _ref.resetValidator,
        props = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties___default()(_ref, _excluded);

    var _useUnderlyingError = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__tal_gel_core__["useUnderlyingError"])(onError),
        onErrorUnderlying = _useUnderlyingError.onErrorUnderlying,
        onErrorWrapping = _useUnderlyingError.onErrorWrapping;

    var _useValidator = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__tal_gel_core__["useValidator"])(_objectSpread(_objectSpread({}, props), {}, {
      // includes controlled `error`, `caption`, `setValidity`, etc.
      index: index,
      // index assigned by the form 
      reset: resetValidator,
      // whether to reset the validator (`touched` status, etc.)
      value: value,
      defaultValue: defaultValue,
      checkError: true,
      // tells validator whether to check for error
      hasError: function hasError(value) {
        // tells validator HOW to check for error
        if (value && value.length !== POSTCODE_LENGTH) {
          return 'length';
        }

        return false;
      },
      hideErrorInitially: true,
      // tells validator to hide error initially
      onError: onErrorWrapping,
      // tells validator the callback to invoke if error occurs or disappears
      errorMsg: errorMsg // tells validator the error message to include in caption if error occurs

    })),
        _useValidator2 = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray___default()(_useValidator, 4),
        onBlur = _useValidator2[0],
        onChange = _useValidator2[1],
        getCaption = _useValidator2[2],
        shouldShowError = _useValidator2[3];

    var initialInternalValidValue = '';

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__tal_gel_core__["useRunOnce"])(function () {
      if (!isControlled(value) && isControlled(defaultValue) && isDigitsOnly(defaultValue)) {
        // If 'value' is not controlled by the parent, 
        // and if provided with a valid numeric default value,
        // we set it as the 'initialInternalValidValue' for the input box
        initialInternalValidValue = defaultValue;
      }
    }); // 'internalValidValue' is the internal numeric value if 'value' is not controlled by the parent


    var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useState"])(initialInternalValidValue),
        _useState2 = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray___default()(_useState, 2),
        internalValidValue = _useState2[0],
        setInternalValidValue = _useState2[1];

    if (isControlled(value) && !isDigitsOnly(value)) {
      // If 'value' is controlled by the parent 
      // but if the 'value' provided is not numeric,
      // reset the controlled 'value' to empty string
      value = '';
    }

    var _onChange = function _onChange(event) {
      if (isDigitsOnly(event.target.value) && event.target.value.length <= POSTCODE_LENGTH || event.target.value === '') {
        if (!isControlled(value)) {
          // If 'value' is not controlled by the parent, 
          // and if the input target value is either empty or a valid numeric value,
          // we set the input target value as 'internalValidValue'
          setInternalValidValue(event.target.value);
        } // do not set 'internalValidValue' if 'value' is controlled by the parent


        onChange(event);
      } // do not invoke the parent onChange handler if the changed input target value isn't valid

    };

    var getValue = function getValue() {
      return isControlled(value) ? value : internalValidValue;
    }; // Control the value of the TextInput wrapped inside
    // with either the internal valid value managed by NumberInput,
    // or with the 'value' of NumberInput controlled by the parent of NumberInput


    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__text_input__["a"
    /* default */
    ], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
      "data-cy": "gel-postcode-input",
      ref: forwardedRef
    }, props, index !== undefined && {
      index: index + '_0'
    }, {
      // assign a sub index to the underling TextInput
      resetValidator: resetValidator,
      value: getValue(),
      onChange: _onChange,
      onFocus: onFocus,
      onBlur: onBlur,
      caption: getCaption(),
      error: shouldShowError(),
      onError: onErrorUnderlying,
      errorMsg: errorMsg,
      doubleCheck: true // See `onChange` in use-validator

    }));
  });

  var isDigitsOnly = function isDigitsOnly(value) {
    return /^\d+$/.test(value);
  };

  var isControlled = function isControlled(prop) {
    return prop !== undefined;
  };

  var PostcodeInput = PostcodeInputComponent;
  /***/
},
/* 317 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony export (binding) */

  __webpack_require__.d(__webpack_exports__, "a", function () {
    return ProgressBar;
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__ = __webpack_require__(5);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__emotion_styled__ = __webpack_require__(14);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__emotion_styled___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__emotion_styled__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4__emotion_react__ = __webpack_require__(248);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4__emotion_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__emotion_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__tal_gel_theming__ = __webpack_require__(11);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__tal_gel_theming___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__tal_gel_theming__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6__tal_gel_core__ = __webpack_require__(7);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6__tal_gel_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__tal_gel_core__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7__layout__ = __webpack_require__(73);

  var _excluded = ["theme", "width", "progress"];

  var ProgressBarComponent = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function (_ref, forwardedRef) {
    var theme = _ref.theme,
        width = _ref.width,
        _ref$progress = _ref.progress,
        progress = _ref$progress === void 0 ? 0 : _ref$progress,
        captionSide = _ref.captionSide,
        captionTop = _ref.captionTop,
        _ref$captionBottom = _ref.captionBottom,
        captionBottom = _ref$captionBottom === void 0 ? true : _ref$captionBottom,
        showCaption = _ref.showCaption,
        color = _ref.color,
        indeterminate = _ref.indeterminate; // `progress` can either be a value of 0-1 (meaning 0% - 100%)
    // or a function that returns 0-1 (meaning 0% - 100%)

    var _progress = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__tal_gel_core__["isFunction"])(progress) ? progress() : progress;

    var progressWidth = 0; // Get the width of active progress bar based on
    // the total width and on whether it is used for 
    // indicating loading status (indeterminate)

    if (typeof width === 'number') {
      progressWidth = !indeterminate ? width * _progress : width * theme.ProgressBar.indeterminateRatio();
    } else {
      width = '100%'; // override all string values with 100%

      progressWidth = !indeterminate ? "calc(".concat(width, " * ").concat(_progress, ")") : "calc(".concat(width, " * ").concat(theme.ProgressBar.indeterminateRatio(), ")");
    }

    if (captionTop || captionSide) {
      captionBottom = false;
    }

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__layout__["c"
    /* RowLayout */
    ], {
      gutter: theme.ProgressBar.captionGap().y
    }, showCaption && captionTop && !indeterminate && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(ProgressCaptionContainer // Caption on top
    , {
      "data-cy": "gel-progress-bar-caption-top",
      theme: theme,
      width: progressWidth,
      progress: _progress
    }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__layout__["b"
    /* BoxLayout */
    ], __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({}, typeof width === 'number' ? {
      space: 'auto',
      distribution: 'start'
    } : {
      // width: 100%
      space: [1, 'auto']
    }, {
      gap: theme.ProgressBar.captionGap().x
    }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(ProgressBarContainer, {
      "data-cy": "gel-progress-bar-container",
      theme: theme,
      width: width,
      ref: forwardedRef
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(ProgressIndicator, {
      "data-cy": "gel-progress-bar-indicator",
      theme: theme,
      width: progressWidth,
      containerWidth: width,
      color: color,
      indeterminate: indeterminate
    })), showCaption && captionSide && !indeterminate && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(ProgressCaptionContainer // Caption at the end side
    , {
      "data-cy": "gel-progress-bar-caption-side",
      theme: theme,
      progress: _progress
    })), showCaption && captionBottom && !indeterminate && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(ProgressCaptionContainer // Caption at bottom
    , {
      "data-cy": "gel-progress-bar-caption-bottom",
      theme: theme,
      width: progressWidth,
      progress: _progress
    })));
  });

  var ProgressCaptionContainer = function ProgressCaptionContainer(_ref2) {
    var theme = _ref2.theme,
        width = _ref2.width,
        progress = _ref2.progress,
        props = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties___default()(_ref2, _excluded);

    var getProgressCaption = function getProgressCaption() {
      return "".concat(Math.round(progress * 100), "%");
    };

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(ProgressCaption, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({
      theme: theme,
      width: width
    }, props), getProgressCaption());
  };

  var ProgressBarContainer = __WEBPACK_IMPORTED_MODULE_3__emotion_styled___default.a.div(function (_ref3) {
    var theme = _ref3.theme,
        width = _ref3.width;
    return theme.ProgressBar.Container({
      width: width
    });
  });

  var ProgressIndicator = __WEBPACK_IMPORTED_MODULE_3__emotion_styled___default.a.div(function (_ref4) {
    var theme = _ref4.theme,
        width = _ref4.width,
        containerWidth = _ref4.containerWidth,
        color = _ref4.color,
        indeterminate = _ref4.indeterminate;
    return theme.ProgressBar.Indicator({
      width: width,
      color: color,
      indeterminate: indeterminate,
      animationName: indeterminate && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__emotion_react__["keyframes"])(theme.ProgressBar.keyframes({
        from: typeof width === 'number' ? "-".concat(width, "px") : "calc(-".concat(containerWidth, " * ").concat(theme.ProgressBar.indeterminateRatio(), ")"),
        to: typeof containerWidth === 'number' ? "".concat(containerWidth, "px") : containerWidth
      }))
    });
  });

  var ProgressCaption = __WEBPACK_IMPORTED_MODULE_3__emotion_styled___default.a.div(function (_ref5) {
    var theme = _ref5.theme,
        width = _ref5.width;
    return theme.ProgressBar.Caption({
      width: width
    });
  });

  var ProgressBar = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__tal_gel_theming__["withTheme"])(ProgressBarComponent);
  /***/

},
/* 318 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__tal_gel_core__ = __webpack_require__(7);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__tal_gel_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__tal_gel_core__);
  /**
   * A helper hook to deal with linear and 
   * non-linear (custom) progress bars
   */


  var useProgress = function useProgress(_ref) {
    var totalSteps = _ref.totalSteps,
        _ref$startFrom = _ref.startFrom,
        startFrom = _ref$startFrom === void 0 ? 0 : _ref$startFrom,
        customProgress = _ref.customProgress;

    var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(startFrom),
        _useState2 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default()(_useState, 2),
        currentStep = _useState2[0],
        setCurrentStep = _useState2[1];

    var currentProgress = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(0);

    var progress = function progress() {
      // the progress function to use with GelProgressBar
      currentProgress.current = !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__tal_gel_core__["isFunction"])(customProgress) ? currentStep / totalSteps : currentStep === 0 ? 0 : customProgress({
        // get custom progress (returning 0-1)
        currentStep: currentStep,
        totalSteps: totalSteps,
        currentProgress: currentProgress.current
      });
      return currentProgress.current;
    };

    var prev = function prev() {
      // moves back a step
      if (currentStep > 0) {
        setCurrentStep(currentStep - 1);
      }
    };

    var next = function next() {
      // moves forward a step
      if (currentStep < totalSteps) {
        setCurrentStep(currentStep + 1);
      }
    };

    return {
      progress: progress,
      prev: prev,
      next: next
    };
  };
  /* harmony default export */


  __webpack_exports__["a"] = useProgress;
  /***/
},
/* 319 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony export (binding) */

  __webpack_require__.d(__webpack_exports__, "a", function () {
    return ProgressStatus;
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(5);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__emotion_styled__ = __webpack_require__(14);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__emotion_styled___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__emotion_styled__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4__tal_gel_theming__ = __webpack_require__(11);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4__tal_gel_theming___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__tal_gel_theming__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__icon__ = __webpack_require__(45);

  var _excluded = ["theme", "stepNum", "complete", "todo", "error", "active"];

  var ProgressStatusComponent = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function (_ref, forwardedRef) {
    var theme = _ref.theme,
        stepNum = _ref.stepNum,
        complete = _ref.complete,
        todo = _ref.todo,
        error = _ref.error,
        active = _ref.active,
        props = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default()(_ref, _excluded);

    var statuses = {
      isComplete: complete,
      isTodo: todo,
      isOnError: error,
      isActive: active
    };
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(ProgressStatusContainer, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
      "data-cy": "gel-progress-status-container",
      theme: theme
    }, statuses, props, {
      ref: forwardedRef
    }), !statuses.isComplete && !statuses.isOnError ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(StyledStepNum, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
      "data-cy": "gel-progress-status-step-num",
      theme: theme
    }, statuses), stepNum) : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__icon__["a"
    /* Icon */
    ] // Show icons (without step number) to indicate Complete or OnError
    , __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
      "data-cy": "gel-progress-status-icon"
    }, statuses.isComplete && theme.ProgressStatus.progressStatusIcon({
      isIcon: true,
      isComplete: true
    }), statuses.isOnError && theme.ProgressStatus.progressStatusIcon({
      isIcon: true,
      isOnError: true
    }))));
  });

  var ProgressStatusContainer = __WEBPACK_IMPORTED_MODULE_3__emotion_styled___default.a.div(function (_ref2) {
    var theme = _ref2.theme,
        isComplete = _ref2.isComplete,
        isTodo = _ref2.isTodo,
        isOnError = _ref2.isOnError,
        isActive = _ref2.isActive;
    return theme.ProgressStatus.progressStatusContainer({
      isComplete: isComplete,
      isTodo: isTodo,
      isOnError: isOnError,
      isActive: isActive
    });
  });

  var StyledStepNum = __WEBPACK_IMPORTED_MODULE_3__emotion_styled___default.a.div(function (_ref3) {
    var theme = _ref3.theme,
        isComplete = _ref3.isComplete,
        isTodo = _ref3.isTodo,
        isOnError = _ref3.isOnError,
        isActive = _ref3.isActive;
    return theme.ProgressStatus.progressStatusIcon({
      isIcon: false,
      isComplete: isComplete,
      isTodo: isTodo,
      isOnError: isOnError,
      isActive: isActive
    });
  });

  var ProgressStatus = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__tal_gel_theming__["withTheme"])(ProgressStatusComponent);
  /***/

},
/* 320 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony export (binding) */

  __webpack_require__.d(__webpack_exports__, "a", function () {
    return RadioButtonGroup;
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(5);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__radio_group__ = __webpack_require__(138);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4__utils_checkbox_radio_utils__ = __webpack_require__(67);

  var _excluded = ["labelLeft", "buttonsPerRow", "children"];
  /**
   * Non-adjacent radio buttons (with new button style)
   */

  var RadioButtonGroup = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function (_ref, forwardedRef) {
    var labelLeft = _ref.labelLeft,
        buttonsPerRow = _ref.buttonsPerRow,
        children = _ref.children,
        props = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default()(_ref, _excluded);

    var _useButtonLocationInG = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_checkbox_radio_utils__["b"
    /* useButtonLocationInGroup */
    ])(buttonsPerRow, children),
        isOnLastRow = _useButtonLocationInG.isOnLastRow,
        isOnRightMostCol = _useButtonLocationInG.isOnRightMostCol;

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__radio_group__["a"
    /* RadioGroup */
    ], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
      "data-cy": "gel-checkbox-button-group"
    }, props, {
      alternativeButtons: true,
      ref: forwardedRef
    }), __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.map(children, function (child, index) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(child, {
        alternativeButton: true,
        buttonsPerRow: buttonsPerRow,
        isOnLastRow: isOnLastRow(index),
        isOnRightMostCol: isOnRightMostCol(index),
        labelLeft: labelLeft
      });
    }));
  });

  RadioButtonGroup.displayName = 'RadioButtonGroup';
  /***/
},
/* 321 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony export (binding) */

  __webpack_require__.d(__webpack_exports__, "a", function () {
    return Radio;
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(5);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__tal_gel_theming__ = __webpack_require__(11);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__tal_gel_theming___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__tal_gel_theming__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4__tal_gel_core__ = __webpack_require__(7);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4__tal_gel_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__tal_gel_core__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__radio_group__ = __webpack_require__(138);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6__utils_checkbox_radio_utils__ = __webpack_require__(67);

  var _excluded = ["id", "value", "error", "inverse", "disabled", "defaultChecked", "groupContext", "onChange", "onFocus", "onBlur", "alternativeButton", "caption", "buttonsPerRow", "isOnLastRow", "isOnRightMostCol", "labelLeft", "style", "children"];

  var RadioComponent = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function (_ref, forwardedRef) {
    var id = _ref.id,
        value = _ref.value,
        error = _ref.error,
        inverse = _ref.inverse,
        disabled = _ref.disabled,
        defaultChecked = _ref.defaultChecked,
        groupContext = _ref.groupContext,
        onChange = _ref.onChange,
        onFocus = _ref.onFocus,
        onBlur = _ref.onBlur,
        alternativeButton = _ref.alternativeButton,
        caption = _ref.caption,
        buttonsPerRow = _ref.buttonsPerRow,
        isOnLastRow = _ref.isOnLastRow,
        isOnRightMostCol = _ref.isOnRightMostCol,
        labelLeft = _ref.labelLeft,
        style = _ref.style,
        children = _ref.children,
        props = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default()(_ref, _excluded);

    if (!groupContext) {
      throw 'Radio component must be wrapped inside of a RadioGroup component';
    }

    var buttonLooking = isButtonLooking(groupContext);

    var indexRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react__["useRef"])();

    if (!groupContext.indexAssigmentDone.current) {
      indexRef.current = groupContext.index.current++;
    }

    var index = indexRef.current;
    var submitCheck = groupContext.submitCheck;
    error = groupContext.required ? groupContext.error : error;

    var _useCrCommon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_checkbox_radio_utils__["c"
    /* useCrCommon */
    ])({
      groupContext: groupContext,
      error: error,
      inverse: inverse,
      disabled: disabled,
      onFocus: onFocus,
      onBlur: onBlur,
      buttonLooking: buttonLooking,
      forwardedRef: forwardedRef
    }),
        focusByClick = _useCrCommon.focusByClick,
        setFocusByClick = _useCrCommon.setFocusByClick,
        buttonCosmeticFocus = _useCrCommon.buttonCosmeticFocus,
        setIgnoreCosmeticFocus = _useCrCommon.setIgnoreCosmeticFocus,
        getInputRef = _useCrCommon.getInputRef,
        groupRelatedProps = _useCrCommon.groupRelatedProps,
        _onFocus = _useCrCommon._onFocus,
        _onBlur = _useCrCommon._onBlur;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react__["useEffect"])(function () {
      // Set the group selected value as its own value
      // if this radio box is checked by default
      if (defaultChecked) {
        groupContext.setSelectedValue(value);
      }
    }, [defaultChecked]); // only run this after mounting/first rendering and when defaultChecked changes


    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react__["useEffect"])(function () {
      // Report its `checked` status to the radio group, 
      // but do NOT trigger `onChange` from validator
      getInputRef().current && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__tal_gel_core__["isFunction"])(groupContext.onChange) && groupContext.onChange(index, getInputRef().current.checked, true);
    });

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react__["useEffect"])(function () {
      if (submitCheck && getInputRef()) {
        // `focus()` first, otherwise `blur()` 
        // doesn't do anything (won't trigger onBlur)
        getInputRef().current.focus();
        getInputRef().current.blur();
      } // Show error if error exists, upon click of the submit button in the form

    }, [submitCheck]);
    /**
     * Hanlder to invoke when the hidden input is clicked (or via the label click)
     * Note that clicking on an already selected radio box won't invoke this handler
     */


    var _onChange = function _onChange(event) {
      // set the selected value as the value of this radio box
      groupContext.setSelectedValue(value); // call onChange handler provided upon Radio

      onChange && onChange(event); // Report its `checked` status to the radio group, 
      // trigger `onChange` from validator, and call onChange handler 
      // provided upon RadioGroup

      groupContext.onChange && groupContext.onChange(index, event.target.checked, false, event);
    };
    /**
     * Checks if the value of this radio box matches the selected value in the group
     * Note that values like '10' and 10 will be considered matching
     * 
     * This is because `event.target.value` will always be a string. 
     * If a radio box has a value of 10, and if users listen to `onChange` of RadioGroup 
     * and get the value via `event.target.value`, the value will be '10'.
     * So if that value is then used to control RadioGroup, no radio box would be considered as selected,
     * if '10' and 10 are not considered matching
     */


    var isChecked = function isChecked() {
      if (groupContext.selectedValue === undefined || value === undefined || groupContext.selectedValue === null || value === null) {
        return false;
      }

      return groupContext.selectedValue.toString() === value.toString();
    };

    var _onBlur_ = function _onBlur_(event) {
      // tell group there's a radiobox on blur, see comments on group context
      groupContext.onBlur();

      _onBlur(event);
    };

    var _onFocus_ = function _onFocus_(event) {
      // tell group there's a radiobox on focus, see comments on group context
      groupContext.onFocus();

      _onFocus(event);
    };

    var uniqueId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__tal_gel_core__["useUniqueId"])();

    if (id) uniqueId = id; // Override the generated unique id if id is specified 

    var isMounted = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__tal_gel_core__["useIsMounted"])();

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__utils_checkbox_radio_utils__["d"
    /* CrContainer */
    ], {
      style: style,
      groupContext: groupContext,
      buttonsPerRow: buttonsPerRow,
      isOnLastRow: isOnLastRow,
      isOnRightMostCol: isOnRightMostCol
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__utils_checkbox_radio_utils__["e"
    /* CrInput */
    ], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
      "data-cy": "gel-radio-input",
      id: isMounted ? uniqueId : null,
      type: "radio",
      ref: getInputRef(),
      name: groupContext.name,
      value: value,
      focusByClick: focusByClick // whether the radio box is focused by mouse click
      ,
      checked: isChecked()
    }, buttonLooking && {
      button: true
    }, groupRelatedProps, {
      // such as error, inverse, disabled, etc.
      alternativeButton: alternativeButton,
      labelLeft: labelLeft,
      onChange: _onChange,
      onBlur: _onBlur_,
      onFocus: _onFocus_
    }, props)), !buttonLooking ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__utils_checkbox_radio_utils__["f"
    /* CrLabel */
    ], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
      id: isMounted ? uniqueId : null // to be used in the label inside CrLabel
      ,
      theme: props.theme,
      target: "Radio"
    }, groupRelatedProps, {
      // such as error, inverse, disabled, etc.
      alternativeButton: alternativeButton,
      labelLeft: labelLeft,
      caption: caption,
      children: children // indicate that the radio box is focused by mouse click
      ,
      onClick: function onClick() {
        return setFocusByClick(true);
      }
    })) : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__utils_checkbox_radio_utils__["g"
    /* CrButton */
    ], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
      id: isMounted ? uniqueId : null // to be used in the hidden label inside CrButton
      ,
      groupContext: groupContext
    }, groupRelatedProps, {
      // such as error, inverse, disabled, etc.
      // indicate whether or not the button should be in cosmetic focus state
      cosmeticFocus: buttonCosmeticFocus,
      children: children // ignore cosmetic focus (focus style without the actual focus state)
      ,
      onClick: function onClick() {
        return setIgnoreCosmeticFocus(true);
      }
    })));
  });
  /**
   * Checks whether this radio box should be button looking or not
   * @param groupContext: radio group context. Any radio box must belong to a radio group
   */


  var isButtonLooking = function isButtonLooking(groupContext) {
    // The 'button' prop of radio group context indicates 
    // that all radio boxes in this group should be button looking
    //  
    // The 'buttonGroup' prop of radio group context indicates 
    // that all radio boxes in this group should be button looking
    // AND they should be adjacent to each other either
    // horizontally or vertically (like a ButtonGroup)
    return groupContext.button || groupContext.buttonGroup;
  };

  var Radio = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__radio_group__["b"
  /* withRadioGroupContext */
  ])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__tal_gel_theming__["withTheme"])(RadioComponent));

  Radio.displayName = 'Radio';
  /***/
},
/* 322 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony export (binding) */

  __webpack_require__.d(__webpack_exports__, "a", function () {
    return ReCaptcha;
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(5);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_react_google_recaptcha__ = __webpack_require__(338);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__emotion_styled__ = __webpack_require__(14);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__emotion_styled___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__emotion_styled__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6__tal_gel_core__ = __webpack_require__(7);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6__tal_gel_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__tal_gel_core__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7__tal_gel_theming__ = __webpack_require__(11);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7__tal_gel_theming___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__tal_gel_theming__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_8__grid__ = __webpack_require__(101);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_9__form_multi_step_form__ = __webpack_require__(53);

  var _excluded = ["sitekey", "onChange", "index", "setValidity", "errorMsg", "resetValidator", "name", "submitCheck", "theme"];

  var ReCaptchaComponent = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef(function (_ref, forwardedRef) {
    var sitekey = _ref.sitekey,
        onChange = _ref.onChange,
        index = _ref.index,
        setValidity = _ref.setValidity,
        errorMsg = _ref.errorMsg,
        resetValidator = _ref.resetValidator,
        name = _ref.name,
        submitCheck = _ref.submitCheck,
        theme = _ref.theme,
        props = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties___default()(_ref, _excluded);

    var _useContext = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_8__grid__["d"
    /* ScreenDetectorContext */
    ]),
        screen = _useContext.screen,
        isXsScreen = _useContext.isXsScreen;

    var token = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react__["useRef"])(null);

    var multiStepFormContext = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_9__form_multi_step_form__["a"
    /* MultiStepFormContext */
    ]);

    var _onChange = function _onChange(value) {
      // report validity true to the form
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__tal_gel_core__["isFunction"])(setValidity) && setValidity(index, true); // pass through the reCaptcha token value

      onChange({
        target: {
          name: name,
          value: value
        }
      });
      token.current = value;
      setShowRequiredError(null);
    };

    var onInvalid = function onInvalid() {
      // report validity false to the form
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__tal_gel_core__["isFunction"])(setValidity) && setValidity(index, false); // pass through `null` as reCaptcha token value

      onChange({
        target: {
          name: name,
          value: null
        }
      });
      token.current = null; // If in the context of a multi-step form,
      // we want to notify that this step now
      // has visible error. See `multiStepFormContext`
      // in `use-validator.js`

      multiStepFormContext && multiStepFormContext.onStepError();
    };

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react__["useEffect"])(function () {
      // initialise validity false to the form
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__tal_gel_core__["isFunction"])(setValidity) && setValidity(index, false);
    }, []);

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__tal_gel_core__["useEffectSkipTick"])(function () {
      if (resetValidator) {
        token.current = null;
        setShowRequiredError(null);
      }
    }, [resetValidator]);

    var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react__["useState"])(null),
        _useState2 = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default()(_useState, 2),
        showRequiredError = _useState2[0],
        setShowRequiredError = _useState2[1];

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react__["useEffect"])(function () {
      if (submitCheck && !token.current) {
        setShowRequiredError({});
      } // Show error if error exists, upon click of the submit button in the form

    }, [submitCheck]);

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(RecaptchaContainer, {
      xsScreen: isXsScreen(screen)
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_google_recaptcha__["a"
    /* default */
    ], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
      ref: forwardedRef,
      sitekey: sitekey,
      onChange: _onChange,
      onExpired: onInvalid,
      onErrored: onInvalid
    }, props))), showRequiredError && errorMsg.required && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Caption, {
      theme: theme
    }, errorMsg.required));
  });

  var RecaptchaContainer = __WEBPACK_IMPORTED_MODULE_5__emotion_styled___default.a.div(function (_ref2) {
    var xsScreen = _ref2.xsScreen;

    if (xsScreen) {
      return {
        // Google's ReCAPTCHA has a fixed width of 304px 
        transformOrigin: 0,
        transform: 'scale(0.9)',
        width: 0
      };
    }
  });

  var Caption = __WEBPACK_IMPORTED_MODULE_5__emotion_styled___default.a.div(function (_ref3) {
    var theme = _ref3.theme;
    return theme.Input.Danger.Caption;
  });

  var ReCaptcha = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__tal_gel_theming__["withTheme"])(ReCaptchaComponent);

  ReCaptcha.displayName = 'ReCaptcha';
  /***/
},
/* 323 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony export (binding) */

  __webpack_require__.d(__webpack_exports__, "a", function () {
    return Select;
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(5);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__emotion_styled__ = __webpack_require__(14);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__emotion_styled___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__emotion_styled__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6__tal_gel_core__ = __webpack_require__(7);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6__tal_gel_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__tal_gel_core__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7__tal_gel_theming__ = __webpack_require__(11);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7__tal_gel_theming___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__tal_gel_theming__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_8__utils_get_caption_elements__ = __webpack_require__(83);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_9__icon__ = __webpack_require__(45);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_10__form_multi_step_form__ = __webpack_require__(53);

  var _excluded = ["required", "requiredErrorMsg", "errorMsg", "onError", "resetValidator", "index", "setValidity", "submitCheck", "focusOnMount", "focusOnRequest"],
      _excluded2 = ["Caption", "Adornment"],
      _excluded3 = ["Adornment"];

  function _createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

    if (!it) {
      if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;

        var F = function F() {};

        return {
          s: F,
          n: function n() {
            if (i >= o.length) return {
              done: true
            };
            return {
              done: false,
              value: o[i++]
            };
          },
          e: function e(_e) {
            throw _e;
          },
          f: F
        };
      }

      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }

    var normalCompletion = true,
        didErr = false,
        err;
    return {
      s: function s() {
        it = it.call(o);
      },
      n: function n() {
        var step = it.next();
        normalCompletion = step.done;
        return step;
      },
      e: function e(_e2) {
        didErr = true;
        err = _e2;
      },
      f: function f() {
        try {
          if (!normalCompletion && it["return"] != null) it["return"]();
        } finally {
          if (didErr) throw err;
        }
      }
    };
  }

  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }

  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);

      if (enumerableOnly) {
        symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
      }

      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  } // Note that we do not animate icon or change icon in `Select` 
  // upon opening/closing the options, as the events fired on `Select` 
  // element in various scenarios across various browsers and platforms 
  // can be very different, making it hard to come up with a reliable 
  // solution that works on all browsers.
  // Supports mobile select widget due to the `select` and `option` HTML elements


  var SelectComponent = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.forwardRef(function (_ref, forwardedRef) {
    var required = _ref.required,
        requiredErrorMsg = _ref.requiredErrorMsg,
        errorMsg = _ref.errorMsg,
        onError = _ref.onError,
        resetValidator = _ref.resetValidator,
        index = _ref.index,
        setValidity = _ref.setValidity,
        submitCheck = _ref.submitCheck,
        focusOnMount = _ref.focusOnMount,
        focusOnRequest = _ref.focusOnRequest,
        props = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties___default()(_ref, _excluded);

    var inputRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useRef"])();

    var getInputRef = function getInputRef() {
      return forwardedRef || inputRef;
    };

    var _usePressedState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__tal_gel_core__["usePressedState"])(props),
        _usePressedState2 = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray___default()(_usePressedState, 4),
        pressed = _usePressedState2[0],
        onPress = _usePressedState2[1],
        onUnpress = _usePressedState2[2],
        setPressed = _usePressedState2[3];

    var _useValidator = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__tal_gel_core__["useValidator"])(_objectSpread(_objectSpread({}, props), {}, {
      // includes controlled error`, `caption`, etc.
      index: index,
      // index assigned by the form 
      setValidity: setValidity,
      // function to report validity of this Select to the form
      reset: resetValidator,
      // whether to reset the validator (`touched` status, etc.)
      onBlur: onUnpress,
      checkError: required,
      // tells validator whether to check for error
      hasError: function hasError(value) {
        // tells validator HOW to check for error
        return !value && 'required';
      },
      onError: onError,
      // tells validator the callback to invoke if error occurs or disappears
      errorMsg: _objectSpread({
        // tells validator the error message to include in caption if error occurs
        'required': requiredErrorMsg
      }, errorMsg),
      hideErrorInitially: true,
      // tells validator to hide the error initially
      submitCheck: {
        shouldTrigger: submitCheck,
        // empty object
        ref: getInputRef()
      },
      MultiStepFormContext: __WEBPACK_IMPORTED_MODULE_10__form_multi_step_form__["a"
      /* MultiStepFormContext */
      ]
    })),
        _useValidator2 = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray___default()(_useValidator, 4),
        onBlur = _useValidator2[0],
        onChange = _useValidator2[1],
        getCaption = _useValidator2[2],
        shouldShowError = _useValidator2[3];

    var getValue = function getValue() {
      if (props.value !== undefined) {
        // if controlled
        // if value matches any option value, control `select` to show that option
        // otherwise control `select` to show the placeholder
        return valueMatchesAnyOptionValue(props) ? props.value : '';
      }

      return undefined; // if uncontrolled, return undefined to not control the value of `select`
    }; // Get styles for various states


    var _getStylesForStates = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__tal_gel_theming__["getStylesForStates"])({
      theme: props.theme,
      target: 'Select',
      danger: shouldShowError(),
      inverse: props.inverse,
      readOnly: props.readOnly,
      disabled: props.disabled
    }),
        normalStyles = _getStylesForStates.normalStyles,
        focusStyles = _getStylesForStates.focusStyles,
        activeStyles = _getStylesForStates.activeStyles,
        hoverStyles = _getStylesForStates.hoverStyles,
        disabledStyles = _getStylesForStates.disabledStyles; // Extract caption and suffix (icon) style


    var captionNormalStyle = normalStyles.Caption,
        adornmentNormalStyle = normalStyles.Adornment,
        normalStyle = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties___default()(normalStyles, _excluded2);

    var adornmentDisabledStyle = disabledStyles.Adornment,
        disabledStyle = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties___default()(disabledStyles, _excluded3);

    var suffixIconStyle = adornmentNormalStyle && {
      name: adornmentNormalStyle.name,
      right: !props.captionWidth ? adornmentNormalStyle.offsetX : "calc(100% - ".concat(props.width, "px + ").concat(adornmentNormalStyle.offsetX, "px)"),
      top: adornmentNormalStyle.offsetY,
      color: !props.disabled ? adornmentNormalStyle.color : adornmentDisabledStyle.color,
      width: adornmentNormalStyle.width
    };

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__tal_gel_core__["useSetFocus"])({
      focusOnMount: focusOnMount,
      focusOnRequest: focusOnRequest,
      inputRef: getInputRef(),
      setPressed: setPressed
    });

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Container, {
      captionWidth: props.captionWidth,
      width: props.width
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(StyledSelect, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
      "data-cy": "gel-select",
      ref: getInputRef()
    }, props, props.captionWidth && {
      style: _objectSpread({
        width: props.width
      }, props.style)
    }, props.readOnly && {
      disabled: true
    }, {
      pressed: pressed,
      value: getValue(),
      onClick: onPress,
      onBlur: onBlur,
      onChange: onChange,
      normalStyle: normalStyle,
      focusStyle: focusStyles,
      activeStyle: activeStyles,
      hoverStyle: hoverStyles,
      disabledStyle: disabledStyle,
      captionNormalStyle: captionNormalStyle,
      adornmentNormalStyle: adornmentNormalStyle
    }), // If we rely on the native `select` and `option` tags, and if we want to 
    // have a placeholder option, that option will have to be present (not hidden, 
    // but regardless of whether disabled or not disabled) in the option list 
    // for it to work on all browsers, as Safari won't be able to hide the hidden option, 
    // and Mac Chrome will always tick the first unhidden option when the option list opens
    // (so it will appear that the first unhidden option is selected while it is actually
    // the placedholder option selected, which is confusing)
    // If the Select value is not controlled or if the controlled value does not 
    // match any values of options, the placedholder option (if specified) or the first option
    // will be selected by default (React will take the `value` prop of `select` and 
    // put `selected` prop on the matching option)
    props.placeholder && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("option", {
      "data-cy": "gel-select-option",
      value: ""
    }, props.placeholder), props.options.map(function (option, index) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("option", {
        "data-cy": "gel-select-option",
        key: index,
        value: option.value
      }, option.label);
    })), suffixIconStyle && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__icon__["a"
    /* Icon */
    ] // typically a chevron icon
    , __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
      "data-cy": "gel-select-icon",
      "float": true // position absolute

    }, suffixIconStyle)), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_get_caption_elements__["a"
    /* default */
    ])(getCaption));
  });

  var Container = __WEBPACK_IMPORTED_MODULE_5__emotion_styled___default.a.div(function (_ref2) {
    var captionWidth = _ref2.captionWidth,
        width = _ref2.width;
    return {
      position: 'relative',
      // for positioning the icon (typically a chevron)
      width: captionWidth || width || '100%'
    };
  });

  var StyledSelect = __WEBPACK_IMPORTED_MODULE_5__emotion_styled___default.a.select({
    // Consistent Select style across all themes
    width: '100%',
    cursor: 'pointer',
    ':disabled': {
      cursor: 'not-allowed'
    },
    transitionProperty: 'background, border-color, color',
    appearance: 'none',
    WebkitAppearance: 'none',
    '::-ms-expand': {
      display: 'none'
    }
  }, function (_ref3) {
    var _objectSpread2;

    var pressed = _ref3.pressed,
        normalStyle = _ref3.normalStyle,
        focusStyle = _ref3.focusStyle,
        activeStyle = _ref3.activeStyle,
        hoverStyle = _ref3.hoverStyle,
        disabledStyle = _ref3.disabledStyle,
        captionNormalStyle = _ref3.captionNormalStyle,
        adornmentNormalStyle = _ref3.adornmentNormalStyle;
    return _objectSpread(_objectSpread({}, normalStyle), {}, (_objectSpread2 = {
      paddingRight: "".concat(adornmentNormalStyle.offsetX + adornmentNormalStyle.width + adornmentNormalStyle.gap, "px !important"),
      '~ .caption': _objectSpread({}, captionNormalStyle)
    }, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(_objectSpread2, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__tal_gel_theming__["getFullState"])(':focus'), _objectSpread({}, !pressed ? focusStyle : focusStyle.Pressed)), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(_objectSpread2, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__tal_gel_theming__["getFullState"])(':disabled'), disabledStyle), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(_objectSpread2, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__tal_gel_theming__["getFullState"])(':hover'), hoverStyle), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(_objectSpread2, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__tal_gel_theming__["getFullState"])(':active'), activeStyle), _objectSpread2));
  });
  /**
   * Checks if the Select value matches any of the option values
   */


  var valueMatchesAnyOptionValue = function valueMatchesAnyOptionValue(_ref4) {
    var options = _ref4.options,
        value = _ref4.value;

    var _iterator = _createForOfIteratorHelper(options),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var option = _step.value;

        if (value === option.value) {
          return true;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return false;
  };

  var Select = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__tal_gel_theming__["withTheme"])(SelectComponent);
  /***/

},
/* 324 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony export (binding) */

  __webpack_require__.d(__webpack_exports__, "a", function () {
    return Spinner;
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__ = __webpack_require__(5);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4__emotion_styled__ = __webpack_require__(14);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4__emotion_styled___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__emotion_styled__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__emotion_react__ = __webpack_require__(248);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__emotion_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__emotion_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6__tal_gel_theming__ = __webpack_require__(11);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6__tal_gel_theming___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__tal_gel_theming__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7__layout_row_layout__ = __webpack_require__(189);

  var _excluded = ["theme", "overlayDescription"],
      _excluded2 = ["theme"],
      _excluded3 = ["theme"],
      _excluded4 = ["theme"],
      _excluded5 = ["theme"];

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);

      if (enumerableOnly) {
        symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
      }

      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  var SpinnerComponent = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef(function (_ref, forwardedRef) {
    var theme = _ref.theme,
        overlayDescription = _ref.overlayDescription,
        props = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties___default()(_ref, _excluded);

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Overlay, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({
      "data-cy": "gel-spinner",
      theme: theme
    }, props), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__layout_row_layout__["a"
    /* RowLayout */
    ], {
      gutter: "medium"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(RingContainer, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({
      theme: theme
    }, props), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Ring, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({
      theme: theme,
      ref: forwardedRef
    }, props), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(RingDiv, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({
      theme: theme
    }, props)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(RingDiv, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({
      theme: theme
    }, props)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(RingDiv, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({
      theme: theme
    }, props)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(RingDiv, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({
      theme: theme
    }, props)))), props.overlay && overlayDescription));
  });

  var Overlay = __WEBPACK_IMPORTED_MODULE_4__emotion_styled___default.a.div(function (_ref2) {
    var theme = _ref2.theme,
        props = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties___default()(_ref2, _excluded2);

    return theme.Spinner.Overlay(props);
  });

  var Ring = __WEBPACK_IMPORTED_MODULE_4__emotion_styled___default.a.div(function (_ref3) {
    var theme = _ref3.theme,
        props = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties___default()(_ref3, _excluded3);

    return theme.Spinner.Ring(props);
  });

  var RingDiv = __WEBPACK_IMPORTED_MODULE_4__emotion_styled___default.a.div(function (_ref4) {
    var theme = _ref4.theme,
        props = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties___default()(_ref4, _excluded4);

    return _objectSpread({}, theme.Spinner.RingDiv(_objectSpread(_objectSpread({}, props), {}, {
      keyframes: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__emotion_react__["keyframes"])(theme.Spinner.keyframes)
    })));
  });

  var RingContainer = __WEBPACK_IMPORTED_MODULE_4__emotion_styled___default.a.div(function (_ref5) {
    var theme = _ref5.theme,
        props = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties___default()(_ref5, _excluded5);

    return theme.Spinner.RingContainer(props);
  });

  var Spinner = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__tal_gel_theming__["withTheme"])(SpinnerComponent);
  /***/

},
/* 325 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony export (binding) */

  __webpack_require__.d(__webpack_exports__, "a", function () {
    return Switch;
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__ = __webpack_require__(5);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__emotion_styled__ = __webpack_require__(14);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__emotion_styled___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__emotion_styled__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6__tal_gel_theming__ = __webpack_require__(11);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6__tal_gel_theming___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__tal_gel_theming__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7__tal_gel_core__ = __webpack_require__(7);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7__tal_gel_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__tal_gel_core__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_8__utils_checkbox_radio_utils__ = __webpack_require__(67);

  var _excluded = ["id", "on", "defaultOn", "onBlur", "onChange", "onChangeOn", "onChangeOff", "abMode", "labelLeft", "labelRight", "labelOnLeft", "theme", "inverse", "children"],
      _excluded2 = ["labelOnLeft", "label", "abMode"];

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);

      if (enumerableOnly) {
        symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
      }

      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  var SwitchComponent = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.forwardRef(function (_ref, forwardedRef) {
    var id = _ref.id,
        on = _ref.on,
        defaultOn = _ref.defaultOn,
        onBlur = _ref.onBlur,
        onChange = _ref.onChange,
        onChangeOn = _ref.onChangeOn,
        onChangeOff = _ref.onChangeOff,
        abMode = _ref.abMode,
        labelLeft = _ref.labelLeft,
        labelRight = _ref.labelRight,
        labelOnLeft = _ref.labelOnLeft,
        theme = _ref.theme,
        inverse = _ref.inverse,
        children = _ref.children,
        props = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties___default()(_ref, _excluded);

    var hiddenInputRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useRef"])();

    var getHiddenInputRef = function getHiddenInputRef() {
      return forwardedRef || hiddenInputRef;
    };

    var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useState"])(false),
        _useState2 = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray___default()(_useState, 2),
        focusByClick = _useState2[0],
        setFocusByClick = _useState2[1];

    var _onBlur = function _onBlur(event) {
      setFocusByClick(false);
      onBlur && onBlur(event);
    };

    var _onChange = function _onChange(event) {
      event.target.checked && onChangeOn && onChangeOn();
      !event.target.checked && onChangeOff && onChangeOff();
      onChange && onChange(event);
    };

    var _getStylesForStates = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__tal_gel_theming__["getStylesForStates"])({
      theme: theme,
      target: 'Switch',
      subTarget: 'Track',
      inverse: inverse
    }),
        trackNormalStyle = _getStylesForStates.normalStyles,
        trackFocusStyle = _getStylesForStates.focusStyles,
        trackCheckedStyle = _getStylesForStates.checkedStyles,
        trackHoverStyle = _getStylesForStates.hoverStyles,
        trackDisabledStyle = _getStylesForStates.disabledStyles;

    var _getStylesForStates2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__tal_gel_theming__["getStylesForStates"])({
      theme: theme,
      target: 'Switch',
      subTarget: 'Handle',
      inverse: inverse
    }),
        handleNormalStyle = _getStylesForStates2.normalStyles,
        handleCheckedStyle = _getStylesForStates2.checkedStyles;

    var _getStylesForStates3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__tal_gel_theming__["getStylesForStates"])({
      theme: theme,
      target: 'Switch',
      subTarget: 'Label',
      inverse: inverse
    }),
        labelNormalStyle = _getStylesForStates3.normalStyles,
        labelDisabledStyle = _getStylesForStates3.disabledStyles;

    var uniqueId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__tal_gel_core__["useUniqueId"])();

    if (id) uniqueId = id; // Override the generated unique id if id is specified 

    var isMounted = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__tal_gel_core__["useIsMounted"])();

    var LabelAux = function LabelAux(_ref2) {
      var labelOnLeft = _ref2.labelOnLeft,
          label = _ref2.label,
          abMode = _ref2.abMode,
          props = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties___default()(_ref2, _excluded2);

      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(StyledLabelAux, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({
        className: "label-aux",
        labelNormalStyle: labelNormalStyle,
        labelOnLeft: labelOnLeft,
        onClick: function onClick() {
          return onLabelClick(abMode, labelOnLeft);
        }
      }, props), label || children);
    };

    var onLabelClick = function onLabelClick(abMode, labelOnLeft) {
      // Mutiple <label for /> can disrupt the statuses of <input id>,
      // so can the combination of <label for /> and ref.click()
      // An alternative is to use ref.click() only, and provide 
      // a hidden <label for /> for accessibility
      if (getHiddenInputRef().current) {
        if (!abMode || labelOnLeft && getHiddenInputRef().current.checked || !labelOnLeft && !getHiddenInputRef().current.checked) {
          getHiddenInputRef().current.click();
        }
      }

      setFocusByClick(true);
    };

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(SwitchContainer, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(HiddenInput, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({
      "data-cy": "gel-switch-input",
      ref: getHiddenInputRef(),
      id: isMounted ? uniqueId : null,
      type: "checkbox",
      focusByClick: focusByClick
    }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_checkbox_radio_utils__["a"
    /* isControlledState */
    ])(on) ? {
      checked: on
    } : {
      defaultChecked: defaultOn
    }, {
      onBlur: _onBlur,
      onChange: _onChange,
      trackCheckedStyle: trackCheckedStyle,
      trackFocusStyle: trackFocusStyle,
      trackDisabledStyle: trackDisabledStyle,
      handleCheckedStyle: handleCheckedStyle,
      labelDisabledStyle: labelDisabledStyle
    }, props)), !abMode && labelOnLeft && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(LabelAux, {
      "data-cy": "gel-switch-label-aux",
      labelOnLeft: true
    }), abMode && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(LabelAux, {
      "data-cy": "gel-switch-label-aux",
      labelOnLeft: true,
      label: labelLeft,
      abMode: true
    }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(StyledLabel, {
      "data-cy": "gel-switch-label",
      onClick: function onClick() {
        return onLabelClick(false);
      },
      trackNormalStyle: !abMode ? trackNormalStyle : trackCheckedStyle,
      trackHoverStyle: trackHoverStyle,
      handleNormalStyle: handleNormalStyle
    }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(HiddenLabel, {
      "data-cy": "gel-switch-label-hidden",
      htmlFor: isMounted ? uniqueId : null
    }, children), !abMode && !labelOnLeft && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(LabelAux, {
      "data-cy": "gel-switch-label-aux"
    }), abMode && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(LabelAux, {
      "data-cy": "gel-switch-label-aux",
      label: labelRight,
      abMode: true
    }));
  });

  var SwitchContainer = __WEBPACK_IMPORTED_MODULE_5__emotion_styled___default.a.div({
    position: 'relative',
    display: 'flex',
    alignItems: 'center'
  });

  var HiddenInput = __WEBPACK_IMPORTED_MODULE_5__emotion_styled___default.a.input(_objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_7__tal_gel_core__["accessibleHiddenStyle"]), {}, {
    ':disabled ~ label': {
      cursor: 'not-allowed'
    }
  }), function (_ref3) {
    var focusByClick = _ref3.focusByClick,
        trackCheckedStyle = _ref3.trackCheckedStyle,
        trackFocusStyle = _ref3.trackFocusStyle,
        trackDisabledStyle = _ref3.trackDisabledStyle,
        handleCheckedStyle = _ref3.handleCheckedStyle,
        labelDisabledStyle = _ref3.labelDisabledStyle;
    return {
      ':checked ~ label::before': trackCheckedStyle,
      ':checked ~ label::after': handleCheckedStyle,
      ':checked ~ label:hover::before': trackCheckedStyle.Hover,
      ':focus ~ label::before': !focusByClick ? trackFocusStyle : null,
      // ignore the focus style if focused by mouse click
      ':disabled ~ label::before': trackDisabledStyle,
      ':disabled ~ .label-aux': labelDisabledStyle,
      ':checked:disabled ~ label::before': trackCheckedStyle.Disabled
    };
  });

  var HiddenLabel = __WEBPACK_IMPORTED_MODULE_5__emotion_styled___default.a.label(__WEBPACK_IMPORTED_MODULE_7__tal_gel_core__["accessibleHiddenStyle"]);

  var StyledLabel = __WEBPACK_IMPORTED_MODULE_5__emotion_styled___default.a.label({
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    outline: 'none',
    cursor: 'pointer',
    '::before, ::after': {
      content: '""',
      position: 'absolute'
    }
  }, function (_ref4) {
    var trackNormalStyle = _ref4.trackNormalStyle,
        trackHoverStyle = _ref4.trackHoverStyle,
        handleNormalStyle = _ref4.handleNormalStyle;
    return {
      width: trackNormalStyle.width,
      '::before': trackNormalStyle,
      '::after': handleNormalStyle,
      ':hover + ::before': trackHoverStyle
    };
  });

  var StyledLabelAux = __WEBPACK_IMPORTED_MODULE_5__emotion_styled___default.a.label({
    cursor: 'pointer'
  }, function (_ref5) {
    var labelNormalStyle = _ref5.labelNormalStyle,
        labelOnLeft = _ref5.labelOnLeft;
    return _objectSpread(_objectSpread({}, labelNormalStyle), !labelOnLeft ? {
      marginLeft: labelNormalStyle.gap
    } : {
      marginRight: labelNormalStyle.gap
    });
  });

  var Switch = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__tal_gel_theming__["withTheme"])(SwitchComponent);
  /***/

},
/* 326 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony export (binding) */

  __webpack_require__.d(__webpack_exports__, "a", function () {
    return Table;
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__emotion_styled__ = __webpack_require__(14);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__emotion_styled___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__emotion_styled__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__tal_gel_theming__ = __webpack_require__(11);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__tal_gel_theming___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__tal_gel_theming__);

  var _excluded = ["theme", "data", "headers", "keyColMapping"]; // TODO: A lot more features yet to be added to this component

  var TableComponent = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.forwardRef(function (_ref, forwardedRef) {
    var theme = _ref.theme,
        data = _ref.data,
        headers = _ref.headers,
        keyColMapping = _ref.keyColMapping,
        props = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties___default()(_ref, _excluded);

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(StyledTable, {
      "data-cy": "gel-table",
      theme: theme
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("thead", {
      "data-cy": "gel-table-thead"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr", {
      "data-cy": "gel-table-thead-tr"
    }, headers && headers.map(function (header, index) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(StyledTh, {
        "data-cy": "gel-table-thead-th",
        theme: theme,
        key: index + header
      }, header);
    }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tbody", {
      "data-cy": "gel-table-tbody"
    }, data && data.map(function (row, index) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tr", {
        key: index,
        "data-cy": "gel-table-tbody-tr"
      }, Object.values(row).map(function (value, index) {
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(StyledTd, {
          "data-cy": "gel-table-tbody-td",
          theme: theme,
          key: index + value
        }, value);
      }));
    })));
  });

  var StyledTable = __WEBPACK_IMPORTED_MODULE_2__emotion_styled___default.a.table(function (_ref2) {
    var theme = _ref2.theme;
    return theme.Table.Table;
  });

  var StyledTh = __WEBPACK_IMPORTED_MODULE_2__emotion_styled___default.a.th(function (_ref3) {
    var theme = _ref3.theme;
    return theme.Table.Head;
  });

  var StyledTd = __WEBPACK_IMPORTED_MODULE_2__emotion_styled___default.a.td(function (_ref4) {
    var theme = _ref4.theme;
    return theme.Table.Cell;
  });

  var Table = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__tal_gel_theming__["withTheme"])(TableComponent);
  /***/

},
/* 327 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony export (binding) */

  __webpack_require__.d(__webpack_exports__, "b", function () {
    return Tab;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "a", function () {
    return Tabs;
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__ = __webpack_require__(5);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__emotion_styled__ = __webpack_require__(14);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__emotion_styled___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__emotion_styled__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6__tal_gel_theming__ = __webpack_require__(11);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6__tal_gel_theming___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__tal_gel_theming__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7__tal_gel_core__ = __webpack_require__(7);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7__tal_gel_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__tal_gel_core__);

  var _excluded = ["theme", "flushBottom", "minContentHeight", "maxContentHeight", "vertical", "verticalNavWidth", "width", "condensed", "children"];

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);

      if (enumerableOnly) {
        symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
      }

      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }
  /**
   * Tab component (to be wrapped by Tabs component)
   * 
   * Note that Tab component does not need to render itself 
   * (render function returning null)
   * 
   * The wrapper Tabs component will take the title and color props 
   * of Tab component to render tab selection, and use the children prop 
   * of Tab component to render the actual content when this Tab is selected
   */


  var Tab = function Tab() {
    return null;
  };

  Tab.displayName = 'Tab'; // Needs to be set explicitly if wrapped by Angular wrapper

  var TabsComponent = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.forwardRef(function (_ref, forwardedRef) {
    var theme = _ref.theme,
        flushBottom = _ref.flushBottom,
        minContentHeight = _ref.minContentHeight,
        maxContentHeight = _ref.maxContentHeight,
        vertical = _ref.vertical,
        verticalNavWidth = _ref.verticalNavWidth,
        width = _ref.width,
        condensed = _ref.condensed,
        children = _ref.children,
        props = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties___default()(_ref, _excluded);

    var childArray = __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.toArray(children);

    childArray.forEach(function (child) {
      if (child.type.displayName !== 'Tab') {
        // if any child is not a Tab componnet, throw error
        throw "Only 'Tab' components are allowed inside of 'Tabs'";
      }
    });

    if (vertical && flushBottom) {
      throw "Vertical tabs do not support 'flushBottom'";
    }

    if ((minContentHeight || maxContentHeight) && !flushBottom) {
      throw "'minContentHeight' and 'maxContentHeight' cannot be used without 'flushBottom'";
    }

    if (verticalNavWidth && !vertical) {
      throw "Horizontal tabs do not support 'verticalNavWidth'";
    }

    var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useState"])(0),
        _useState2 = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray___default()(_useState, 2),
        selectedTab = _useState2[0],
        setSelectedTab = _useState2[1];

    var tabOnFocus = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useRef"])(0);

    var readyToBeMadeDisplayNone = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useRef"])(false); // content height to be applied to all tabs if `flushBottom` is specified


    var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useState"])(0),
        _useState4 = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray___default()(_useState3, 2),
        universalContentHeight = _useState4[0],
        setUniversalContentHeight = _useState4[1]; // `childArray.map(() => useRef())` will violate hook rules


    var tabTitleRefs = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useRef"])(childArray.map(function () {
      return /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["createRef"])();
    }));

    var tabContentRefs = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useRef"])(childArray.map(function () {
      return /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["createRef"])();
    })); // each tab has a focusByClick status to indicate whether it is focused by mouse click or keyboard


    var _useState5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useState"])(childArray.map(function () {
      return false;
    })),
        _useState6 = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray___default()(_useState5, 2),
        focusByClickStatuses = _useState6[0],
        setFocusByClickStatuses = _useState6[1];

    var firstRender = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useRef"])(true);

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useEffect"])(function () {
      if (!firstRender.current) {
        // Re-initialise some refs and states, if the number of tabs changes
        // This can happen when tabs (not tab content) are dynamically loaded
        tabTitleRefs.current = childArray.map(function () {
          return /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["createRef"])();
        });
        tabContentRefs.current = childArray.map(function () {
          return /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["createRef"])();
        });
        setFocusByClickStatuses(childArray.map(function () {
          return false;
        })); // this will trigger re-render
      }

      firstRender.current = false;
    }, [childArray.length]);

    var isUnmountedRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__tal_gel_core__["useIsUnmounted"])();

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useEffect"])(function () {
      if (flushBottom) {
        // if flushBottom, determine the universal height of all tabs
        var timer = setTimeout(function () {
          // wait till all content has been rendered
          if (!isUnmountedRef.current) {
            // calculate thg longest tab content height
            var maxContentHeightOfTabs = getMaxContentHeightOfTabs();

            if (minContentHeight && maxContentHeightOfTabs < minContentHeight) {
              // use minContentHeight if minContentHeight is specified and 
              // is even greater than the longest tab content height
              setUniversalContentHeight(minContentHeight);
            } else {
              // if minContentHeight is not specified or is not greater than 
              // the longest tab content height, use the calculated the longest 
              // tab content height
              setUniversalContentHeight(maxContentHeightOfTabs);
            }
          }

          clearTimeout(timer);
        });
      }
    }, []); // only run after first mount


    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useEffect"])(function () {
      if (selectedTab !== tabOnFocus.current) {
        /**
         * If the selected tab is not the same as the tab on focus 
         * (which can happen with Arrow keys selecting tabs),
         * then set focus on the current Arrow key selected tab to make sure 
         * that the selected tab and focused tab are always the same
         */
        tabTitleRefs.current[selectedTab].current.focus();
      }
    });

    var onKeyDown = function onKeyDown(event) {
      if (!vertical && event.keyCode === __WEBPACK_IMPORTED_MODULE_7__tal_gel_core__["ARROW_RIGHT"] || vertical && event.keyCode === __WEBPACK_IMPORTED_MODULE_7__tal_gel_core__["ARROW_DOWN"]) {
        // ARROW_RIGHT and ARROW_LEFT for hotizontal tabs navigation
        setSelectedTab((selectedTab + 1) % childArray.length);
        event.preventDefault(); // prevent default browser behavior as it may cause page to move
      } else if (!vertical && event.keyCode === __WEBPACK_IMPORTED_MODULE_7__tal_gel_core__["ARROW_LEFT"] || vertical && event.keyCode === __WEBPACK_IMPORTED_MODULE_7__tal_gel_core__["ARROW_UP"]) {
        // ARROW_DOWN and ARROW_UP for vertical tabs navigation
        setSelectedTab((selectedTab + childArray.length - 1) % childArray.length);
        event.preventDefault(); // prevent default browser behavior as it may cause page to move
      } else if (event.keyCode === __WEBPACK_IMPORTED_MODULE_7__tal_gel_core__["SPACE"] || event.keyCode === __WEBPACK_IMPORTED_MODULE_7__tal_gel_core__["ENTER"]) {
        // SPACE and ENTER to display the tab content only when the selected tab is not the same as the focused tab
        // (which can happen if one uses TAB key to traverse the tab selections)
        if (selectedTab !== tabOnFocus.current) {
          setSelectedTab(tabOnFocus.current);
        }

        event.preventDefault(); // prevent default browser behavior as it may cause page to move
      }
    };

    var _onFocus = function onFocus(index) {
      tabOnFocus.current = index;
      readyToBeMadeDisplayNone.current = true;
    };

    var _onBlur = function onBlur(index) {
      return updateFocusByClickStatusByIndex(index, false);
    };

    var _onMouseDown = function onMouseDown(index) {
      return updateFocusByClickStatusByIndex(index, true);
    };

    var updateFocusByClickStatusByIndex = function updateFocusByClickStatusByIndex(index, status) {
      setFocusByClickStatuses(focusByClickStatuses.map(function (_status, _index) {
        return index === _index ? status : _status;
      }));
    };
    /**
     * Closed (not selected) content shouldn't receive focus or cannot be tabbed into (by TAB key)
     * 
     * As we make content skip focus by setting the content as `display: none` 
     * (which will make it impossible to calculate the actual content height), 
     * we only do it if flushBottom is not required (hence no need to calculate 
     * the actual content height) or if flushBottom is required but the universal 
     * content height has already been determined.
     * 
     * `readyToBeMadeDisplayNone` ensures that components in tab content be rendered 
     * properly before content is made `display: none`. This is because some components 
     * in content may require calculating element dimensions (such as for prefixText 
     * and suffixText of TextInputComponent). Setting`display: none` prematurely can 
     * cause element dimensions to be 0.
     */


    var shouldContentSkipFocus = function shouldContentSkipFocus(index) {
      return (!flushBottom || flushBottom && universalContentHeight > 0) && selectedTab !== index && readyToBeMadeDisplayNone.current;
    };

    var getTabTitles = function getTabTitles() {
      return childArray.map(function (child, index) {
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Fragment, {
          key: index
        }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(TabTitle, {
          "data-cy": "gel-tab-title",
          theme: theme,
          ref: tabTitleRefs.current[index],
          selected: selectedTab === index,
          vertical: vertical,
          tabIndex: 0 // make this tab (div) focusable, default is -1
          ,
          colorHighlight: child.props.color // use the `color` prop of Tab component
          ,
          focusByClick: focusByClickStatuses[index],
          condensed: condensed,
          onClick: function onClick() {
            return setSelectedTab(index);
          },
          onFocus: function onFocus() {
            return _onFocus(index);
          },
          onBlur: function onBlur() {
            return _onBlur(index);
          },
          onMouseDown: function onMouseDown() {
            return _onMouseDown(index);
          }
        }, child.props.title), !vertical && index < childArray.length - 1 &&
        /*#__PURE__*/
        // Only for horizontal tabs
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(TabTitleSeparator, {
          "data-cy": "gel-tab-title-separator",
          theme: theme // Choose the separators at both sides of the selected tab
          // Note that the first and last tabs only have separator at one side
          ,
          selected: index === selectedTab || index === selectedTab - 1
        }, "\xA0"));
      });
    };

    var getTabContents = function getTabContents() {
      return childArray.map(function (child, index) {
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(TabContent, {
          "data-cy": "gel-tab-content",
          theme: theme,
          ref: tabContentRefs.current[index],
          key: index,
          vertical: vertical,
          selected: selectedTab === index,
          maxHeight: maxContentHeight,
          flushBottom: flushBottom,
          universalHeight: universalContentHeight,
          skipFocus: shouldContentSkipFocus(index),
          removeContentPadding: child.props.removeContentPadding
        }, child.props.children);
      });
    }; // calculates the longest tab content height


    var getMaxContentHeightOfTabs = function getMaxContentHeightOfTabs() {
      return tabContentRefs.current.reduce(function (prev, content) {
        return content.current.offsetHeight > prev ? content.current.offsetHeight : prev;
      }, -1);
    };

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Fragment, null, !vertical ?
    /*#__PURE__*/
    // horizontal tabs
    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({
      style: {
        width: width
      }
    }, props), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__tal_gel_core__["GelFlexContainer"], {
      ref: forwardedRef,
      style: {
        margin: 0
      },
      justifyContent: "flex-start",
      alignItems: "stretch",
      onKeyDown: onKeyDown
    }, getTabTitles(), condensed && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(IndentedBlank, {
      "data-cy": "gel-tab-title-indented-blank",
      theme: theme,
      right: true
    }, "\xA0")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(TabContentContainer, {
      theme: theme
    }, getTabContents())) :
    /*#__PURE__*/
    // vertical tabs
    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__tal_gel_core__["GelFlexContainer"], __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({
      ref: forwardedRef,
      alignItems: "stretch",
      style: {
        margin: 0,
        width: width
      }
    }, props), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__tal_gel_core__["GelFlexContainer"], {
      style: {
        margin: 0,
        width: verticalNavWidth
      },
      flexDirection: "column",
      alignItems: "stretch",
      justifyContent: "flex-start",
      onKeyDown: onKeyDown
    }, getTabTitles()), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(TabContentContainer, {
      vertical: true
    }, getTabContents())));
  });

  var TabTitle = __WEBPACK_IMPORTED_MODULE_5__emotion_styled___default.a.div({
    cursor: 'pointer'
  }, function (_ref2) {
    var theme = _ref2.theme,
        selected = _ref2.selected,
        vertical = _ref2.vertical,
        colorHighlight = _ref2.colorHighlight,
        focusByClick = _ref2.focusByClick,
        condensed = _ref2.condensed; // Get styles for the various states of container label (horizontal label)

    var _getStylesForStates = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__tal_gel_theming__["getStylesForStates"])({
      theme: theme,
      target: 'Tabs',
      subTarget: 'ContainerLabel',
      inverse: false // TODO 

    }),
        containerLabelNormalStyle = _getStylesForStates.normalStyles,
        containerLabelFocusStyle = _getStylesForStates.focusStyles,
        containerLabelActiveStyle = _getStylesForStates.activeStyles; // Get styles for the various states of vertical label


    var _getStylesForStates2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__tal_gel_theming__["getStylesForStates"])({
      theme: theme,
      target: 'Tabs',
      subTarget: 'VerticalLabel',
      inverse: false // TODO 

    }),
        verticalLabelNormalStyle = _getStylesForStates2.normalStyles,
        verticalLabelFocusStyle = _getStylesForStates2.focusStyles,
        verticalLabelActiveStyle = _getStylesForStates2.activeStyles;

    return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, !vertical && !selected && containerLabelNormalStyle), vertical && !selected && verticalLabelNormalStyle), !vertical && selected && containerLabelActiveStyle), vertical && selected && verticalLabelActiveStyle), {}, {
      ':focus': !focusByClick ? // only set focus style if focused via keyboard
      !vertical ? containerLabelFocusStyle : verticalLabelFocusStyle : null
    }, !vertical ? {
      flexGrow: !condensed ? 1 : 0,
      ':first-of-type:not(:last-of-type)': {
        borderRight: 'none'
      },
      ':not(:first-of-type):not(:last-of-type)': {
        borderRight: 'none',
        borderLeft: 'none'
      },
      ':last-of-type:not(:first-of-type)': {
        borderLeft: 'none'
      }
    } : {
      ':not(:first-of-type)': {
        borderTop: 'none'
      }
    }), !selected && !vertical && colorHighlight && {
      // custom colour highlight
      borderTopColor: colorHighlight
    }), condensed && !vertical && selected && {
      borderBottomWidth: containerLabelActiveStyle.borderLeftWidth,
      borderBottomColor: containerLabelActiveStyle.backgroundColor
    }), condensed && !vertical && !selected && {
      borderBottomWidth: containerLabelNormalStyle.borderLeftWidth,
      borderBottomColor: containerLabelNormalStyle.backgroundColor
    });
  });

  var TabTitleSeparator = __WEBPACK_IMPORTED_MODULE_5__emotion_styled___default.a.div({
    display: 'inline-block'
  }, function (_ref3) {
    var theme = _ref3.theme,
        selected = _ref3.selected; // Get styles for the states of ContainerLabelSeparator

    var _getStylesForStates3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__tal_gel_theming__["getStylesForStates"])({
      theme: theme,
      target: 'Tabs',
      subTarget: 'ContainerLabelSeparator',
      inverse: false // TODO 

    }),
        normalStyles = _getStylesForStates3.normalStyles,
        activeStyles = _getStylesForStates3.activeStyles;

    return !selected ? normalStyles : activeStyles;
  });

  var TabContent = __WEBPACK_IMPORTED_MODULE_5__emotion_styled___default.a.div({
    overflow: 'visible'
  }, function (_ref4) {
    var theme = _ref4.theme,
        vertical = _ref4.vertical,
        selected = _ref4.selected,
        universalHeight = _ref4.universalHeight,
        maxHeight = _ref4.maxHeight,
        flushBottom = _ref4.flushBottom,
        skipFocus = _ref4.skipFocus,
        removeContentPadding = _ref4.removeContentPadding;

    var _getStylesForStates4 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__tal_gel_theming__["getStylesForStates"])({
      theme: theme,
      target: 'Tabs',
      subTarget: 'ContainerContent',
      inverse: false // TODO

    }),
        containerContentNormalStyle = _getStylesForStates4.normalStyles;

    var _getStylesForStates5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__tal_gel_theming__["getStylesForStates"])({
      theme: theme,
      target: 'Tabs',
      subTarget: 'VerticalContent',
      inverse: false // TODO 

    }),
        verticalContentNormalStyle = _getStylesForStates5.normalStyles;

    return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, !vertical ? _objectSpread(_objectSpread({}, containerContentNormalStyle), {}, {
      borderTop: 'none'
    }) : verticalContentNormalStyle), !selected && __WEBPACK_IMPORTED_MODULE_7__tal_gel_core__["accessibleHiddenStyle"]), !selected && !flushBottom && {
      // prevent long hidden content from pushing down the page
      maxHeight: 0,
      overflow: 'hidden'
    }), {}, {
      // only set a specific height if flushBottom is required and universalHeight is determined
      height: flushBottom ? universalHeight || null : null
    }, flushBottom && _objectSpread({
      maxHeight: maxHeight
    }, maxHeight && {
      // Apply overflow: 'auto' only if maxContentHeight is specified
      // as overflow: 'auto' can block the open list of GelDropdown
      // and GelAutoCompleteInput, as well as the tooltip box
      overflow: 'auto'
    })), skipFocus && {
      display: 'none'
    }), removeContentPadding && {
      padding: 0
    });
  });

  var TabContentContainer = __WEBPACK_IMPORTED_MODULE_5__emotion_styled___default.a.div({
    position: 'relative'
  }, function (_ref5) {
    var vertical = _ref5.vertical;
    return vertical && {
      flexGrow: 1
    };
  });

  var IndentedBlank = __WEBPACK_IMPORTED_MODULE_5__emotion_styled___default.a.div({
    // Used when `condensed`
    flexGrow: 1
  }, function (_ref6) {
    var theme = _ref6.theme,
        right = _ref6.right;
    return _objectSpread({
      fontSize: theme.Tabs.ContainerLabel.fontSize,
      paddingTop: theme.Tabs.ContainerLabel.paddingTop,
      // + theme.Tabs.ContainerLabel.borderTopWidth,
      paddingBottom: theme.Tabs.ContainerLabel.paddingBottom
    }, right && {
      borderLeftWidth: theme.Tabs.ContainerLabel.borderRightWidth,
      borderLeftColor: theme.Tabs.ContainerLabel.borderRightColor,
      borderLeftStyle: theme.Tabs.ContainerLabel.borderRightStyle,
      borderBottomWidth: theme.Tabs.ContainerLabel.borderRightWidth,
      borderBottomColor: theme.Tabs.ContainerLabel.borderRightColor,
      borderBottomStyle: theme.Tabs.ContainerLabel.borderRightStyle
    });
  });

  var Tabs = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__tal_gel_theming__["withTheme"])(TabsComponent);
  /***/

},
/* 328 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony export (binding) */

  __webpack_require__.d(__webpack_exports__, "a", function () {
    return TextArea;
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(5);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__emotion_styled__ = __webpack_require__(14);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__emotion_styled___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__emotion_styled__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6__tal_gel_core__ = __webpack_require__(7);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6__tal_gel_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__tal_gel_core__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7__tal_gel_theming__ = __webpack_require__(11);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7__tal_gel_theming___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__tal_gel_theming__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_8__utils_get_caption_elements__ = __webpack_require__(83);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_9__form_multi_step_form__ = __webpack_require__(53);

  var _excluded = ["required", "requiredErrorMsg", "onError", "errorMsg", "index", "setValidity", "resetValidator", "submitCheck", "focusOnMount", "focusOnRequest"],
      _excluded2 = ["Caption"];

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);

      if (enumerableOnly) {
        symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
      }

      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  var TextAreaComponent = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.forwardRef(function (_ref, forwardedRef) {
    var required = _ref.required,
        requiredErrorMsg = _ref.requiredErrorMsg,
        onError = _ref.onError,
        errorMsg = _ref.errorMsg,
        index = _ref.index,
        setValidity = _ref.setValidity,
        resetValidator = _ref.resetValidator,
        submitCheck = _ref.submitCheck,
        focusOnMount = _ref.focusOnMount,
        focusOnRequest = _ref.focusOnRequest,
        props = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties___default()(_ref, _excluded);

    var inputRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useRef"])();

    var getInputRef = function getInputRef() {
      return forwardedRef || inputRef;
    };

    var _usePressedState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__tal_gel_core__["usePressedState"])(props),
        _usePressedState2 = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray___default()(_usePressedState, 4),
        pressed = _usePressedState2[0],
        onPress = _usePressedState2[1],
        onUnpress = _usePressedState2[2],
        setPressed = _usePressedState2[3];

    var _useValidator = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__tal_gel_core__["useValidator"])(_objectSpread(_objectSpread({}, props), {}, {
      // includes controlled error`, `caption`, etc.
      index: index,
      // index assigned by the form 
      setValidity: setValidity,
      // function to report validity of this TextArea to the form
      reset: resetValidator,
      // whether to reset the validator (`touched` status, etc.)
      onBlur: onUnpress,
      checkError: required,
      // tells validator whether to check for error
      hasError: function hasError(value) {
        // tells validator HOW to check for error
        if (required && !value.toString().trim()) {
          return 'required';
        }
      },
      onError: onError,
      // tells validator the callback to invoke if error occurs or disappears
      errorMsg: _objectSpread({
        // tells validator the error message to include in caption if error occurs
        'required': requiredErrorMsg
      }, errorMsg),
      hideErrorInitially: true,
      // tells validator to hide the error initially
      submitCheck: {
        shouldTrigger: submitCheck,
        // empty object
        ref: getInputRef()
      },
      MultiStepFormContext: __WEBPACK_IMPORTED_MODULE_9__form_multi_step_form__["a"
      /* MultiStepFormContext */
      ]
    })),
        _useValidator2 = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray___default()(_useValidator, 4),
        onBlur = _useValidator2[0],
        onChange = _useValidator2[1],
        getCaption = _useValidator2[2],
        shouldShowError = _useValidator2[3];

    var getWrapperWidth = function getWrapperWidth() {
      if (!props.cols) {
        return props.captionWidth || props.width || '100%';
      }

      return 'auto';
    }; // Get styles for various states


    var _getStylesForStates = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__tal_gel_theming__["getStylesForStates"])({
      theme: props.theme,
      target: 'Input',
      danger: shouldShowError(),
      inverse: props.inverse,
      readOnly: props.readOnly,
      disabled: props.disabled
    }),
        normalStyles = _getStylesForStates.normalStyles,
        focusStyles = _getStylesForStates.focusStyles,
        activeStyles = _getStylesForStates.activeStyles,
        hoverStyles = _getStylesForStates.hoverStyles,
        disabledStyles = _getStylesForStates.disabledStyles; // Extract caption style 


    var captionNormalStyle = normalStyles.Caption,
        normalStyle = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties___default()(normalStyles, _excluded2);

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__tal_gel_core__["useSetFocus"])({
      focusOnMount: focusOnMount,
      focusOnRequest: focusOnRequest,
      inputRef: getInputRef(),
      setPressed: setPressed
    });

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Wrapper, {
      width: getWrapperWidth()
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(StyledTextArea, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
      "data-cy": "gel-textarea",
      ref: getInputRef()
    }, props, props.captionWidth && {
      style: _objectSpread({
        width: props.width
      }, props.style)
    }, props.readOnly && {
      disabled: true
    }, {
      pressed: pressed,
      onClick: onPress,
      onBlur: onBlur,
      onChange: onChange,
      normalStyle: normalStyle,
      focusStyle: focusStyles,
      activeStyle: activeStyles,
      hoverStyle: hoverStyles,
      disabledStyle: disabledStyles,
      captionNormalStyle: captionNormalStyle
    })), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_get_caption_elements__["a"
    /* default */
    ])(getCaption));
  });

  var Wrapper = __WEBPACK_IMPORTED_MODULE_5__emotion_styled___default.a.div(function (_ref2) {
    var width = _ref2.width;
    return {
      width: width
    };
  });

  var StyledTextArea = __WEBPACK_IMPORTED_MODULE_5__emotion_styled___default.a.textarea({
    // Consistent text area input style across all themes
    verticalAlign: 'top',
    ':disabled': {
      cursor: 'not-allowed'
    },
    transitionProperty: 'background, border-color, color'
  }, function (_ref3) {
    var _objectSpread2;

    var pressed = _ref3.pressed,
        cols = _ref3.cols,
        normalStyle = _ref3.normalStyle,
        focusStyle = _ref3.focusStyle,
        activeStyle = _ref3.activeStyle,
        hoverStyle = _ref3.hoverStyle,
        disabledStyle = _ref3.disabledStyle,
        captionNormalStyle = _ref3.captionNormalStyle;
    return _objectSpread(_objectSpread({}, normalStyle), {}, (_objectSpread2 = {
      width: !cols ? '100%' : 'auto',
      '~ .caption': _objectSpread({}, captionNormalStyle)
    }, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(_objectSpread2, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__tal_gel_theming__["getFullState"])(':focus'), _objectSpread({}, !pressed ? focusStyle : focusStyle.Pressed)), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(_objectSpread2, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__tal_gel_theming__["getFullState"])(':disabled'), disabledStyle), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(_objectSpread2, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__tal_gel_theming__["getFullState"])(':hover'), hoverStyle), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(_objectSpread2, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__tal_gel_theming__["getFullState"])(':active'), activeStyle), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(_objectSpread2, "height", 'auto !important'), _objectSpread2));
  });

  var TextArea = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__tal_gel_theming__["withTheme"])(TextAreaComponent);
  /***/

},
/* 329 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony export (binding) */

  __webpack_require__.d(__webpack_exports__, "a", function () {
    return TextInput;
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(102);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__ = __webpack_require__(5);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_slicedToArray__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_objectWithoutProperties__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6__emotion_styled__ = __webpack_require__(14);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6__emotion_styled___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__emotion_styled__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7_react_input_mask__ = __webpack_require__(600);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_input_mask__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_8__tal_gel_core__ = __webpack_require__(7);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_8__tal_gel_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__tal_gel_core__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_9__tal_gel_theming__ = __webpack_require__(11);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_9__tal_gel_theming___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__tal_gel_theming__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_10__utils_get_caption_elements__ = __webpack_require__(83);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_11__icon_icon__ = __webpack_require__(188);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_12__spinner__ = __webpack_require__(136);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_13__form_multi_step_form__ = __webpack_require__(53);

  var _excluded = ["required", "requiredErrorMsg", "regex", "onError", "errorMsg", "index", "setValidity", "resetValidator", "submitCheck", "focusOnMount", "focusOnRequest", "ignoreBlur", "doubleCheck", "select", "onPrefixIconClick", "onSuffixIconClick", "extraSuffixIcon", "onExtraSuffixIconClick", "spinnerExtraSuffixIcon", "onPrefixIconMouseDown", "onSuffixIconMouseDown", "onExtraSuffixIconMouseDown"],
      _excluded2 = ["Caption", "Adornment", "Placeholder"],
      _excluded3 = ["Adornment", "Placeholder"];

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);

      if (enumerableOnly) {
        symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
      }

      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  var TextInputComponent = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react___default.a.forwardRef(function (_ref, forwardedRef) {
    var required = _ref.required,
        requiredErrorMsg = _ref.requiredErrorMsg,
        regex = _ref.regex,
        onError = _ref.onError,
        errorMsg = _ref.errorMsg,
        index = _ref.index,
        setValidity = _ref.setValidity,
        resetValidator = _ref.resetValidator,
        submitCheck = _ref.submitCheck,
        focusOnMount = _ref.focusOnMount,
        focusOnRequest = _ref.focusOnRequest,
        ignoreBlur = _ref.ignoreBlur,
        doubleCheck = _ref.doubleCheck,
        select = _ref.select,
        onPrefixIconClick = _ref.onPrefixIconClick,
        onSuffixIconClick = _ref.onSuffixIconClick,
        extraSuffixIcon = _ref.extraSuffixIcon,
        onExtraSuffixIconClick = _ref.onExtraSuffixIconClick,
        spinnerExtraSuffixIcon = _ref.spinnerExtraSuffixIcon,
        onPrefixIconMouseDown = _ref.onPrefixIconMouseDown,
        onSuffixIconMouseDown = _ref.onSuffixIconMouseDown,
        onExtraSuffixIconMouseDown = _ref.onExtraSuffixIconMouseDown,
        props = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_objectWithoutProperties___default()(_ref, _excluded);

    var _usePressedState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__tal_gel_core__["usePressedState"])(props),
        _usePressedState2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_slicedToArray___default()(_usePressedState, 4),
        pressed = _usePressedState2[0],
        onPress = _usePressedState2[1],
        onUnpress = _usePressedState2[2],
        setPressed = _usePressedState2[3];

    var inputRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react__["useRef"])();

    var getInputRef = function getInputRef() {
      return forwardedRef || inputRef;
    };

    var prefixRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react__["useRef"])();

    var suffixRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react__["useRef"])();

    var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react__["useState"])(),
        _useState2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_slicedToArray___default()(_useState, 2),
        prefixWidth = _useState2[0],
        setPrefixWidth = _useState2[1];

    var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react__["useState"])(),
        _useState4 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_slicedToArray___default()(_useState3, 2),
        suffixWidth = _useState4[0],
        setSuffixWidth = _useState4[1];

    var prefixIconStyles = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react__["useRef"])();

    var suffixIconStyles = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react__["useRef"])();

    var extraSuffixIconStyles = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react__["useRef"])();

    var _useValidator = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__tal_gel_core__["useValidator"])(_objectSpread(_objectSpread({}, props), {}, {
      // includes controlled error`, `caption`, etc.
      index: index,
      // index assigned by the form 
      setValidity: setValidity,
      // function to report validity of this TextInput to the form
      reset: resetValidator,
      // whether to reset the validator (`touched` status, etc.)
      onBlur: onUnpress,
      checkError: required || !!regex,
      // tells validator whether to check for error
      hasError: function hasError(value) {
        // tells validator HOW to check for error
        if (required && !value.toString().trim()) {
          return 'required';
        }

        if (regex && !RegExp(regex).test(value)) {
          return 'regex';
        }

        return false;
      },
      onError: onError,
      // tells validator the callback to invoke if error occurs or disappears
      errorMsg: _objectSpread({
        // tells validator the error message to include in caption if error occurs
        'required': requiredErrorMsg
      }, errorMsg),
      hideErrorInitially: true,
      // tells validator to hide the error initially,
      ignoreBlur: ignoreBlur,
      // used by Dropdown to not show error prematurally
      doubleCheck: doubleCheck,
      // required if for example wrapped by GelNumberInput
      submitCheck: {
        shouldTrigger: submitCheck,
        // empty object
        ref: getInputRef()
      },
      MultiStepFormContext: __WEBPACK_IMPORTED_MODULE_13__form_multi_step_form__["a"
      /* MultiStepFormContext */
      ]
    })),
        _useValidator2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_slicedToArray___default()(_useValidator, 4),
        onBlur = _useValidator2[0],
        onChange = _useValidator2[1],
        getCaption = _useValidator2[2],
        shouldShowError = _useValidator2[3];

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__tal_gel_core__["useSetFocus"])({
      focusOnMount: focusOnMount,
      focusOnRequest: focusOnRequest,
      inputRef: getInputRef(),
      setPressed: setPressed
    });

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__tal_gel_core__["useLayoutEffect"])(function () {
      // Set prefix text width before browser paint
      // determine the width of text in the prefix each time a prefix text is provided
      if (prefixRef.current) {
        setPrefixWidth(prefixRef.current.clientWidth + 1);
      }
    }, [props.prefix]);

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__tal_gel_core__["useLayoutEffect"])(function () {
      // Set suffix text width before browser paint
      // determine the width of text in the suffix each time a suffix text is provided
      if (suffixRef.current) {
        setSuffixWidth(suffixRef.current.clientWidth + 1);
      }
    }, [props.suffix]);
    /**
     * Invoked by the child StyledInput to be passed the prefix/suffix icon styles
     */


    var retrieveIconStyles = function retrieveIconStyles(adornmentStyle, adornmentDisabledStyle, disabled) {
      if (props.prefixIcon && adornmentStyle) {
        prefixIconStyles.current = {
          left: adornmentStyle.offsetX,
          top: adornmentStyle.iconOffsetY,
          color: !disabled ? adornmentStyle.iconColor : adornmentDisabledStyle.iconColor,
          width: adornmentStyle.width // icon width

        };
        setPrefixWidth(adornmentStyle.width);
      } else if (!props.prefix) {
        setPrefixWidth(0);
      }

      if ((props.suffixIcon || props.spinner) && adornmentStyle) {
        suffixIconStyles.current = {
          right: !props.captionWidth ? adornmentStyle.offsetX : "calc(100% - ".concat(props.width, "px + ").concat(adornmentStyle.offsetX, "px)"),
          top: adornmentStyle.iconOffsetY,
          color: !disabled ? adornmentStyle.iconColor : adornmentDisabledStyle.iconColor,
          width: adornmentStyle.width // icon width

        };
        setSuffixWidth(adornmentStyle.width);
      } else if (!props.suffix) {
        setSuffixWidth(0);
      }

      if ((extraSuffixIcon || spinnerExtraSuffixIcon) && adornmentStyle) {
        var pos = adornmentStyle.offsetX + adornmentStyle.width + adornmentStyle.gap;
        extraSuffixIconStyles.current = {
          right: !props.captionWidth ? pos : "calc(100% - ".concat(props.width, "px + ").concat(pos, "px)"),
          top: adornmentStyle.iconOffsetY,
          color: !disabled ? adornmentStyle.iconColor : adornmentDisabledStyle.iconColor,
          width: adornmentStyle.width // icon width

        };
        setSuffixWidth(function () {
          var currentWidth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
          return currentWidth + adornmentStyle.width + adornmentStyle.gap;
        });
      }
    }; // Get styles for various states


    var _getStylesForStates = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__tal_gel_theming__["getStylesForStates"])({
      theme: props.theme,
      target: 'Input',
      danger: shouldShowError(),
      inverse: props.inverse,
      readOnly: props.readOnly,
      disabled: props.disabled
    }),
        normalStyles = _getStylesForStates.normalStyles,
        focusStyles = _getStylesForStates.focusStyles,
        activeStyles = _getStylesForStates.activeStyles,
        hoverStyles = _getStylesForStates.hoverStyles,
        disabledStyles = _getStylesForStates.disabledStyles; // Extract caption, prefix or suffix styles


    var captionNormalStyle = normalStyles.Caption,
        adornmentNormalStyle = normalStyles.Adornment,
        placeholderNormalStyle = normalStyles.Placeholder,
        _normalStyle = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_objectWithoutProperties___default()(normalStyles, _excluded2);

    var _disabledStyles$Adorn = disabledStyles.Adornment,
        adornmentDisabledStyle = _disabledStyles$Adorn === void 0 ? {} : _disabledStyles$Adorn,
        placeholderDisabledStyle = disabledStyles.Placeholder,
        _disabledStyle = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_objectWithoutProperties___default()(disabledStyles, _excluded3);

    var firstRender = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react__["useRef"])(true);

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__tal_gel_core__["useLayoutEffect"])(function () {
      // Skipping the first render, if theme changes, we want to retrieve 
      // icon style again from the new theme (See retrieveIconStyles)
      //
      // Note that usually we don't need to do this, as components retrieve
      // style from the current theme each time they are rendered. In this
      // case, however, as retrieveIconStyles is only invoked if prefixWidth
      // or suffixWidth is not set, when we switch theme retrieveIconStyles
      // will not be invoked again, causing the icon style to remain as in
      // the previous theme. So in this case we want to explicitly reset 
      // prefixWidth and suffixWidth if theme has changed, in order to get
      // the new icon style from the new theme
      if (!firstRender.current) {
        setPrefixWidth(null);
        setSuffixWidth(null);
      }

      firstRender.current = false;
    }, [props.theme]);

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__tal_gel_core__["useLayoutEffect"])(function () {
      retrieveIconStyles( // Override the theme for iconColor, if specified
      !props.iconColor ? adornmentNormalStyle : _objectSpread(_objectSpread({}, adornmentNormalStyle), {}, {
        iconColor: props.iconColor
      }), adornmentDisabledStyle, props.disabled);
    }, [props.prefixIcon, props.suffixIcon, props.spinner, extraSuffixIcon]);

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Container, {
      captionWidth: props.captionWidth,
      width: props.width
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Input, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({
      "data-cy": "gel-text-input",
      ref: getInputRef()
    }, props, props.captionWidth && {
      style: _objectSpread({
        width: props.width
      }, props.style)
    }, props.readOnly && {
      disabled: true
    }, props.onClick && {
      // If input has onClick handler specified
      cursorPointer: true,
      readOnly: true // Removes the caret when on focus (casued by the click)

    }, {
      type: props.type || 'text',
      pressed: pressed,
      onClick: onPress,
      onBlur: onBlur,
      onChange: onChange,
      prefixWidth: prefixWidth // width of text or width of icon in the prefix
      ,
      suffixWidth: suffixWidth // width of text or width of icon in the suffix
      ,
      normalStyles: _normalStyle,
      focusStyles: focusStyles,
      activeStyles: activeStyles,
      hoverStyles: hoverStyles,
      disabledStyles: _disabledStyle,
      captionNormalStyle: captionNormalStyle,
      adornmentNormalStyle: adornmentNormalStyle,
      adornmentDisabledStyle: adornmentDisabledStyle,
      placeholderNormalStyle: placeholderNormalStyle,
      placeholderDisabledStyle: placeholderDisabledStyle
    })), props.prefix &&
    /*#__PURE__*/
    // prefix text
    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("span", {
      "data-cy": "gel-text-prefix",
      className: "prefix",
      style: {
        pointerEvents: 'none'
      },
      ref: prefixRef
    }, props.prefix), props.prefixIcon && prefixIconStyles.current &&
    /*#__PURE__*/
    // prefix icon
    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__icon_icon__["a"
    /* Icon */
    ], __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({
      "data-cy": "gel-icon-prefix",
      name: props.prefixIcon,
      "float": true // position absolute

    }, prefixIconStyles.current, onPrefixIconClick && {
      onClick: onPrefixIconClick
    }, onPrefixIconMouseDown && {
      onMouseDown: onPrefixIconMouseDown
    })), props.suffix &&
    /*#__PURE__*/
    // suffix text
    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("span", {
      "data-cy": "gel-text-suffix",
      className: "suffix",
      style: {
        pointerEvents: 'none'
      },
      ref: suffixRef
    }, props.suffix), props.suffixIcon && suffixIconStyles.current &&
    /*#__PURE__*/
    // suffix icon
    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__icon_icon__["a"
    /* Icon */
    ], __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({
      "data-cy": "gel-icon-suffix",
      name: props.suffixIcon,
      "float": true // position absolute

    }, suffixIconStyles.current, onSuffixIconClick && {
      onClick: onSuffixIconClick
    }, onSuffixIconMouseDown && {
      onMouseDown: onSuffixIconMouseDown
    })), props.spinner && !spinnerExtraSuffixIcon && suffixIconStyles.current &&
    /*#__PURE__*/
    // loading spinner in suffix
    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__spinner__["a"
    /* default */
    ], {
      "data-cy": "gel-spinner-suffix",
      small: true,
      top: suffixIconStyles.current.top,
      right: suffixIconStyles.current.right
    }), props.spinner && spinnerExtraSuffixIcon && extraSuffixIconStyles.current &&
    /*#__PURE__*/
    // loading spinner in extra suffix
    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__spinner__["a"
    /* default */
    ], {
      "data-cy": "gel-spinner-extra-suffix",
      small: true,
      top: extraSuffixIconStyles.current.top,
      right: extraSuffixIconStyles.current.right
    }), extraSuffixIcon && extraSuffixIconStyles.current &&
    /*#__PURE__*/
    // extra suffix icon
    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__icon_icon__["a"
    /* Icon */
    ], __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({
      "data-cy": "gel-icon-extra-suffix",
      name: extraSuffixIcon,
      "float": true // position absolute

    }, extraSuffixIconStyles.current, onExtraSuffixIconClick && {
      onClick: onExtraSuffixIconClick
    }, onExtraSuffixIconMouseDown && {
      onMouseDown: onExtraSuffixIconMouseDown
    })), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_get_caption_elements__["a"
    /* default */
    ])(getCaption));
  });

  var Container = __WEBPACK_IMPORTED_MODULE_6__emotion_styled___default.a.div(function (_ref2) {
    var captionWidth = _ref2.captionWidth,
        width = _ref2.width;
    return {
      position: 'relative',
      // for positioning the icon (typically a chevron)
      width: captionWidth || width || '100%'
    };
  });

  var Input = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react___default.a.forwardRef(function (props, forwardedRef) {
    return !props.mask ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(StyledInput, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({
      ref: forwardedRef
    }, props)) : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(StyledMaskedInput, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({
      ref: forwardedRef
    }, props));
  });

  var getStyledInputParams = function getStyledInputParams() {
    return [{
      // Consistent input box style across all themes
      width: '100%',
      ':disabled': {
        cursor: 'not-allowed'
      },
      transitionProperty: 'background-color, border-color, color'
    }, function (_ref3) {
      var _objectSpread2;

      var pressed = _ref3.pressed,
          prefixWidth = _ref3.prefixWidth,
          suffixWidth = _ref3.suffixWidth,
          prefixIcon = _ref3.prefixIcon,
          suffixIcon = _ref3.suffixIcon,
          normalStyles = _ref3.normalStyles,
          focusStyles = _ref3.focusStyles,
          activeStyles = _ref3.activeStyles,
          hoverStyles = _ref3.hoverStyles,
          disabledStyles = _ref3.disabledStyles,
          captionNormalStyle = _ref3.captionNormalStyle,
          adornmentNormalStyle = _ref3.adornmentNormalStyle,
          adornmentDisabledStyle = _ref3.adornmentDisabledStyle,
          placeholderNormalStyle = _ref3.placeholderNormalStyle,
          placeholderDisabledStyle = _ref3.placeholderDisabledStyle,
          cursorPointer = _ref3.cursorPointer,
          ellipsis = _ref3.ellipsis,
          captionWidth = _ref3.captionWidth,
          width = _ref3.width;
      return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, normalStyles), prefixWidth && {
        // if prefix is present (text or icon), set padding-left
        paddingLeft: "".concat(adornmentNormalStyle.offsetX + prefixWidth + adornmentNormalStyle.gap, "px !important")
      }), suffixWidth && {
        // if suffix is present (text or icon), set padding-right
        paddingRight: "".concat(adornmentNormalStyle.offsetX + suffixWidth + adornmentNormalStyle.gap, "px !important")
      }), cursorPointer && {
        cursor: 'pointer'
      }), ellipsis && {
        textOverflow: 'ellipsis'
      }), {}, (_objectSpread2 = {
        '~ .caption': _objectSpread({}, captionNormalStyle),
        '~ .prefix': _objectSpread(_objectSpread({}, {
          position: 'absolute',
          left: adornmentNormalStyle.offsetX,
          top: adornmentNormalStyle.textOffsetY,
          color: adornmentNormalStyle.textColor,
          lineHeight: adornmentNormalStyle.lineHeight,
          fontSize: adornmentNormalStyle.fontSize
        }), !prefixIcon && {
          width: 'auto'
        }),
        '~ .suffix': _objectSpread(_objectSpread({}, {
          position: 'absolute',
          right: !captionWidth ? adornmentNormalStyle.offsetX : "calc(100% - ".concat(width, "px + ").concat(adornmentNormalStyle.offsetX, "px)"),
          top: adornmentNormalStyle.textOffsetY,
          color: adornmentNormalStyle.textColor,
          lineHeight: adornmentNormalStyle.lineHeight,
          fontSize: adornmentNormalStyle.fontSize
        }), !suffixIcon && {
          width: 'auto'
        }),
        '::placeholder': placeholderNormalStyle
      }, __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(_objectSpread2, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__tal_gel_theming__["getFullState"])(':focus'), _objectSpread({}, !pressed ? focusStyles : focusStyles.Pressed)), __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(_objectSpread2, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__tal_gel_theming__["getFullState"])(':disabled'), _objectSpread(_objectSpread({}, disabledStyles), {}, {
        '~ .prefix': {
          // prefix text
          color: adornmentDisabledStyle.textColor
        },
        '~ .suffix': {
          // suffix text
          color: adornmentDisabledStyle.textColor
        },
        '::placeholder': placeholderDisabledStyle
      })), __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(_objectSpread2, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__tal_gel_theming__["getFullState"])(':hover'), hoverStyles), __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(_objectSpread2, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__tal_gel_theming__["getFullState"])(':active'), activeStyles), _objectSpread2));
    }];
  };

  var StyledInput = __WEBPACK_IMPORTED_MODULE_6__emotion_styled___default.a.input.apply(__WEBPACK_IMPORTED_MODULE_6__emotion_styled___default.a, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(getStyledInputParams()));

  var StyledMaskedInput = __WEBPACK_IMPORTED_MODULE_6__emotion_styled___default()(__WEBPACK_IMPORTED_MODULE_7_react_input_mask___default.a, {
    shouldForwardProp: function shouldForwardProp(prop) {
      return ['theme', 'caption', 'captionWidth', 'prefixWidth', 'suffixWidth', 'normalStyles', 'focusStyles', 'activeStyles', 'hoverStyles', 'disabledStyles', 'captionNormalStyle', 'adornmentNormalStyle', 'adornmentDisabledStyle', 'placeholderNormalStyle', 'placeholderDisabledStyle', 'error', 'pressed', 'ellipsis', 'prefixIcon', 'suffixIcon', 'cursorPointer'].indexOf(prop) < 0;
    }
  }).apply(void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(getStyledInputParams()));

  var TextInput = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__tal_gel_theming__["withTheme"])(TextInputComponent);
  /***/

},
/* 330 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* unused harmony export convertToNumberFrom */

  /* harmony export (binding) */

  __webpack_require__.d(__webpack_exports__, "a", function () {
    return Tooltip;
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(5);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__emotion_styled__ = __webpack_require__(14);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__emotion_styled___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__emotion_styled__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6__tal_gel_core__ = __webpack_require__(7);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6__tal_gel_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__tal_gel_core__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7__tal_gel_theming__ = __webpack_require__(11);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7__tal_gel_theming___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__tal_gel_theming__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_8__icon__ = __webpack_require__(45);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_9__grid__ = __webpack_require__(101);

  var _excluded = ["theme", "selfAdaptive", "top", "bottom", "left", "right", "topLeft", "topRight", "bottomLeft", "bottomRight", "icon", "size", "color", "fixedAtTopLevel", "dark", "light", "maxWidth", "inline", "children"];

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);

      if (enumerableOnly) {
        symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
      }

      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  var selfAdaptivePositionDefaults = {
    top: false,
    bottom: false,
    left: false,
    right: false,
    topLeft: false,
    topRight: false,
    bottomLeft: false,
    bottomRight: false
  };

  var TooltipComponent = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.forwardRef(function (_ref, forwardedRef) {
    var theme = _ref.theme,
        selfAdaptive = _ref.selfAdaptive,
        top = _ref.top,
        bottom = _ref.bottom,
        left = _ref.left,
        right = _ref.right,
        topLeft = _ref.topLeft,
        topRight = _ref.topRight,
        bottomLeft = _ref.bottomLeft,
        bottomRight = _ref.bottomRight,
        icon = _ref.icon,
        size = _ref.size,
        color = _ref.color,
        fixedAtTopLevel = _ref.fixedAtTopLevel,
        _ref$dark = _ref.dark,
        dark = _ref$dark === void 0 ? true : _ref$dark,
        _ref$light = _ref.light,
        light = _ref$light === void 0 ? false : _ref$light,
        maxWidth = _ref.maxWidth,
        inline = _ref.inline,
        children = _ref.children,
        props = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties___default()(_ref, _excluded);

    var iconRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useRef"])();

    var getIconRef = function getIconRef() {
      return forwardedRef || iconRef;
    };

    var _useContext = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_9__grid__["d"
    /* ScreenDetectorContext */
    ]),
        isXsScreen = _useContext.isXsScreen,
        screen = _useContext.screen;

    var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useState"])(_objectSpread(_objectSpread({}, selfAdaptivePositionDefaults), {}, {
      right: true // Try `right` first

    })),
        _useState2 = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray___default()(_useState, 2),
        selfAdaptivePosition = _useState2[0],
        setSelfAdaptivePosition = _useState2[1];

    if (selfAdaptive) {
      top = selfAdaptivePosition.top;
      bottom = selfAdaptivePosition.bottom;
      left = selfAdaptivePosition.left;
      right = selfAdaptivePosition.right;
      topLeft = selfAdaptivePosition.topLeft;
      topRight = selfAdaptivePosition.topRight;
      bottomLeft = selfAdaptivePosition.bottomLeft;
      bottomRight = selfAdaptivePosition.bottomRight;
    } else {
      var numOfPositions = getNumOfPositions({
        // check how many positions are specified
        top: top,
        bottom: bottom,
        left: left,
        right: right,
        topLeft: topLeft,
        topRight: topRight,
        bottomLeft: bottomLeft,
        bottomRight: bottomRight
      });

      if (numOfPositions === 0) {
        // throw error if no position is specified
        throw 'Specify a position: top, bottom, left, right, topLeft, topRight, bottomLeft, bottomRight';
      }

      if (numOfPositions > 1) {
        // throw error if more than one position are specified
        throw 'Only one position can be specified';
      }
    }

    if (dark && light) {
      dark = false;
    }

    if (!dark && !light) {
      light = true;
    }

    var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useState"])(false),
        _useState4 = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray___default()(_useState3, 2),
        showTipBox = _useState4[0],
        setShowTipBox = _useState4[1];

    var tipBoxRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useRef"])();

    var _useState5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useState"])(),
        _useState6 = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray___default()(_useState5, 2),
        tipBoxDimension = _useState6[0],
        setTipBoxDimension = _useState6[1];

    var arrowDownRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useRef"])();

    var arrowUpRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useRef"])();

    var arrowLeftRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useRef"])();

    var arrowRightRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useRef"])();

    var _useState7 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useState"])(),
        _useState8 = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray___default()(_useState7, 2),
        tipBoxFixedPosition = _useState8[0],
        setTipBoxFixedPosition = _useState8[1];

    var _useState9 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useState"])(),
        _useState10 = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray___default()(_useState9, 2),
        arrowDownFixedPosition = _useState10[0],
        setArrowDownFixedPosition = _useState10[1];

    var _useState11 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useState"])(),
        _useState12 = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray___default()(_useState11, 2),
        arrowUpFixedPosition = _useState12[0],
        setArrowUpFixedPosition = _useState12[1];

    var _useState13 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useState"])(),
        _useState14 = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray___default()(_useState13, 2),
        arrowLeftFixedPosition = _useState14[0],
        setArrowLeftFixedPosition = _useState14[1];

    var _useState15 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useState"])(),
        _useState16 = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray___default()(_useState15, 2),
        arrowRightFixedPosition = _useState16[0],
        setArrowRightFixedPosition = _useState16[1];

    var tipBoxDimensionCompensated = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["useRef"])(false);

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__tal_gel_core__["useLayoutEffect"])(function () {
      // after render but before browser repaints (makes it visible to users)
      if (showTipBox && tipBoxRef.current) {
        // if the tip box is shown
        // Store width and height of the current tip box, 
        // as the dimension will determine precise positioning of the tip box
        // We want to position the tip box correctly before browser repaints
        setTipBoxDimension({
          // triggers synchronous re-render (before browser repaints)
          width: tipBoxRef.current.offsetWidth ? tipBoxDimensionCompensated.current ? tipBoxRef.current.offsetWidth : tipBoxRef.current.offsetWidth + 1 : 100,
          height: tipBoxRef.current.offsetHeight ? tipBoxDimensionCompensated.current ? tipBoxRef.current.offsetHeight : tipBoxRef.current.offsetHeight + 1 : 50
        });
        tipBoxDimensionCompensated.current = true; // Note that `|| 100` and `|| 50` are really just a hack to make tests work, 
        // as Jest does not render DOM so `offsetWidth` and `offsetHeight` are always 0 for the tests
        // As the only case where `offsetWidth` or `offsetHeight` is 0 is when the code runs in tests, 
        // we can safely put `|| 100` and `|| 50` as a hack to assign values 
        // to `offsetWidth` and `offsetHeight` while not affecting production
      }
    }, [showTipBox]); // only invoked if `showTipBox` changes


    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__tal_gel_core__["useLayoutEffect"])(function () {
      // If fixedAtTopLevel to break layering restrictions, we want to use the current positions 
      // of the tip box and arrow in the window, to set their fixed positions when `position: fixed`
      // So effectively the tipbox and the arrow appear to be still at the same spot, but fixed at
      // the top level to avoid getting blocked by other layers
      if (fixedAtTopLevel && showTipBox && tipBoxRef.current && tipBoxDimension && !tipBoxFixedPosition) {
        var rect = tipBoxRef.current.getBoundingClientRect();
        setTipBoxFixedPosition({
          x: rect.x,
          y: rect.y
        });

        if (arrowDownRef.current) {
          var _rect = arrowDownRef.current.getBoundingClientRect();

          setArrowDownFixedPosition({
            x: _rect.x,
            y: _rect.y
          });
        }

        if (arrowUpRef.current) {
          var _rect2 = arrowUpRef.current.getBoundingClientRect();

          setArrowUpFixedPosition({
            x: _rect2.x,
            y: _rect2.y
          });
        }

        if (arrowLeftRef.current) {
          var _rect3 = arrowLeftRef.current.getBoundingClientRect();

          setArrowLeftFixedPosition({
            x: _rect3.x,
            y: _rect3.y
          });
        }

        if (arrowRightRef.current) {
          var _rect4 = arrowRightRef.current.getBoundingClientRect();

          setArrowRightFixedPosition({
            x: _rect4.x,
            y: _rect4.y
          });
        }
      }
    });

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__tal_gel_core__["useLayoutEffect"])(function () {
      if (selfAdaptive && showTipBox && getIconRef().current && tipBoxDimension) {
        var iconRect = getIconRef().current.getBoundingClientRect();
        var centerX = (iconRect.right + iconRect.left) / 2;
        var centerY = (iconRect.bottom + iconRect.top) / 2;
        var arrowThickness = convertToNumberFrom(theme.Tooltip.Arrow.thickness);
        var gutterAroundIcon = convertToNumberFrom(theme.Tooltip.gutterAroundIcon);
        var offsetForCornerTipBox = convertToNumberFrom(theme.Tooltip.offsetForCornerTipBox);
        var distanceFromWindowBoundaries = 15; // See comment in use-window-size for window.outerWidth and window.innerHeight

        var fitsFullRight = function fitsFullRight() {
          return iconRect.right + gutterAroundIcon + arrowThickness + tipBoxDimension.width + distanceFromWindowBoundaries < __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__tal_gel_core__["getWindowWidth"])();
        };

        var fitsFullLeft = function fitsFullLeft() {
          return iconRect.left - gutterAroundIcon - arrowThickness - tipBoxDimension.width - distanceFromWindowBoundaries > 0;
        };

        var fitsFullTop = function fitsFullTop() {
          return iconRect.top - gutterAroundIcon - arrowThickness - tipBoxDimension.height - distanceFromWindowBoundaries > 0;
        };

        var fitsFullBottom = function fitsFullBottom() {
          return iconRect.bottom + gutterAroundIcon + arrowThickness + tipBoxDimension.height + distanceFromWindowBoundaries < window.innerHeight;
        };

        var fitsHalfTop = function fitsHalfTop() {
          return centerY - tipBoxDimension.height / 2 - distanceFromWindowBoundaries > 0;
        };

        var fitsHalfBottom = function fitsHalfBottom() {
          return centerY + tipBoxDimension.height / 2 + distanceFromWindowBoundaries < window.innerHeight;
        };

        var fitsHalfRight = function fitsHalfRight() {
          return centerX + tipBoxDimension.width / 2 + distanceFromWindowBoundaries < __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__tal_gel_core__["getWindowWidth"])();
        };

        var fitsHalfLeft = function fitsHalfLeft() {
          return centerX - tipBoxDimension.width / 2 - distanceFromWindowBoundaries > 0;
        };

        var pos;

        if (fitsFullRight() && fitsHalfTop() && fitsHalfBottom()) {
          // right
          pos = 'right';
        } else if (fitsFullTop() && fitsFullRight()) {
          // top right
          pos = 'topRight';
        } else if (fitsFullTop() && fitsHalfLeft() && fitsHalfRight()) {
          // top
          pos = 'top';
        } else if (fitsFullTop() && fitsFullLeft()) {
          // top left
          pos = 'topLeft';
        } else if (fitsFullLeft() && fitsHalfTop() && fitsHalfBottom()) {
          // left
          pos = 'left';
        } else if (fitsFullBottom() && fitsFullLeft()) {
          // bottom left
          pos = 'bottomLeft';
        } else if (fitsFullBottom() && fitsHalfLeft() && fitsHalfRight()) {
          // bottom
          pos = 'bottom';
        } else if (fitsFullBottom() && fitsFullRight()) {
          // bottom right
          pos = 'bottomRight';
        } else {
          // TODO: Screen too small; doesn't fit anywhere...
          setShowTipBox(false);
        }

        if (pos) {
          setSelfAdaptivePosition(function (prevState) {
            // Only updates if prev position wasn't the position determined
            if (prevState[pos]) return prevState;
            setTipBoxFixedPosition();
            return _objectSpread(_objectSpread({}, selfAdaptivePositionDefaults), {}, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()({}, pos, true));
          });
        }
      }
    });

    var onMouseEnter = function onMouseEnter() {
      setShowTipBox(true); // show tip box on hover
    };

    var onMouseLeave = function onMouseLeave() {
      setShowTipBox(false); // hide tip box when not on hover

      if (fixedAtTopLevel) {
        // Remove fixed positions
        setTipBoxFixedPosition();
        setArrowDownFixedPosition();
        setArrowUpFixedPosition();
        setArrowLeftFixedPosition();
        setArrowRightFixedPosition();
      }
    };

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(TooltipContainer, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
      inline: inline
    }, props), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__icon__["a"
    /* Icon */
    ], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
      "data-cy": "gel-tooltip-icon",
      ref: getIconRef(),
      inline: inline,
      noInlineGap: true
    }, theme.Tooltip.Icon, icon && {
      name: icon
    }, size && {
      width: size
    }, color && {
      color: color
    }, {
      // if icon color is specified, use it to override the theme
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      onFocus: onMouseEnter // tabbed in by keyboard
      ,
      onBlur: onMouseLeave // tabbed out by keyboard
      ,
      onClick: function onClick() {} // makes the icon focusable, but does nothing upon click

    })), showTipBox && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(TipBox, {
      "data-cy": "gel-tooltip-tip-box",
      theme: theme,
      ref: tipBoxRef,
      maxWidth: maxWidth,
      dimension: tipBoxDimension // determines precise positioning
      ,
      fixedPosition: tipBoxFixedPosition,
      fixedAtTopLevel: fixedAtTopLevel,
      iconWidth: size // icon width that overrides the theme
      ,
      top: top,
      bottom: bottom,
      left: left,
      right: right,
      topLeft: topLeft,
      topRight: topRight,
      bottomLeft: bottomLeft,
      bottomRight: bottomRight,
      dark: dark,
      light: light,
      isXsScreen: isXsScreen(screen)
    }, children), showTipBox && (top || topLeft || topRight) && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ArrowDown, {
      "data-cy": "gel-tooltip-arrow-down",
      theme: theme,
      iconWidth: size,
      ref: arrowDownRef,
      fixedPosition: arrowDownFixedPosition,
      fixedAtTopLevel: fixedAtTopLevel,
      dark: dark,
      light: light
    }), showTipBox && (bottom || bottomLeft || bottomRight) && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ArrowUp, {
      "data-cy": "gel-tooltip-arrow-up",
      theme: theme,
      iconWidth: size,
      ref: arrowUpRef,
      fixedPosition: arrowUpFixedPosition,
      fixedAtTopLevel: fixedAtTopLevel,
      dark: dark,
      light: light
    }), showTipBox && left && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ArrowRight, {
      "data-cy": "gel-tooltip-arrow-right",
      theme: theme,
      iconWidth: size,
      ref: arrowRightRef,
      fixedPosition: arrowRightFixedPosition,
      fixedAtTopLevel: fixedAtTopLevel,
      dark: dark,
      light: light
    }), showTipBox && right && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ArrowLeft, {
      "data-cy": "gel-tooltip-arrow-left",
      theme: theme,
      iconWidth: size,
      ref: arrowLeftRef,
      fixedPosition: arrowLeftFixedPosition,
      fixedAtTopLevel: fixedAtTopLevel,
      dark: dark,
      light: light
    }));
  });

  var TooltipContainer = __WEBPACK_IMPORTED_MODULE_5__emotion_styled___default.a.div({
    // container that wraps everything
    position: 'relative'
  }, function (_ref2) {
    var inline = _ref2.inline;
    return _objectSpread({
      display: !inline ? 'flex' : 'inline-flex'
    }, inline && {
      verticalAlign: 'middle'
    });
  });

  var TipBox = __WEBPACK_IMPORTED_MODULE_5__emotion_styled___default.a.div( // the tip box to show and hide
  {
    position: 'fixed',
    // for measuring the supposed dimension without restrictions, prior to browser paint
    left: 0,
    top: 0,
    zIndex: 10
  }, function (_ref3) {
    var theme = _ref3.theme,
        dimension = _ref3.dimension,
        maxWidth = _ref3.maxWidth,
        iconWidth = _ref3.iconWidth,
        top = _ref3.top,
        bottom = _ref3.bottom,
        left = _ref3.left,
        right = _ref3.right,
        dark = _ref3.dark,
        light = _ref3.light,
        topLeft = _ref3.topLeft,
        topRight = _ref3.topRight,
        bottomLeft = _ref3.bottomLeft,
        bottomRight = _ref3.bottomRight,
        fixedPosition = _ref3.fixedPosition,
        fixedAtTopLevel = _ref3.fixedAtTopLevel,
        isXsScreen = _ref3.isXsScreen;
    var arrowThickness = convertToNumberFrom(theme.Tooltip.Arrow.thickness);
    var gutterAroundIcon = convertToNumberFrom(theme.Tooltip.gutterAroundIcon);
    var offsetForCornerTipBox = convertToNumberFrom(theme.Tooltip.offsetForCornerTipBox);
    return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, theme.Tooltip.Tipbox({
      isXsScreen: isXsScreen,
      dark: dark || !light
    })), maxWidth && {
      maxWidth: maxWidth
    }), dimension && {
      position: 'absolute',
      width: dimension.width
    }), !fixedAtTopLevel || !fixedPosition ? _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, top && dimension && {
      // determine precise positioning for 'top'
      top: -(dimension.height + 2 * arrowThickness + gutterAroundIcon - 1),
      left: -(dimension.width / 2 - (iconWidth || theme.Tooltip.Icon.width) / 2)
    }), bottom && dimension && {
      // determine precise positioning for 'bottom'
      top: (iconWidth || theme.Tooltip.Icon.width) + 2 * arrowThickness + gutterAroundIcon,
      left: -(dimension.width / 2 - (iconWidth || theme.Tooltip.Icon.width) / 2)
    }), left && dimension && {
      // determine precise positioning for 'left'
      top: -(dimension.height / 2 - (iconWidth || theme.Tooltip.Icon.width) / 2),
      left: -(dimension.width + 2 * arrowThickness + gutterAroundIcon)
    }), right && dimension && {
      // determine precise positioning for 'right'
      top: -(dimension.height / 2 - (iconWidth || theme.Tooltip.Icon.width) / 2),
      left: (iconWidth || theme.Tooltip.Icon.width) + 3 * arrowThickness + gutterAroundIcon
    }), topLeft && dimension && {
      // determine precise positioning for 'top left'
      top: -(dimension.height + 2 * arrowThickness + gutterAroundIcon - 1),
      left: -(dimension.width - (iconWidth || theme.Tooltip.Icon.width)) + offsetForCornerTipBox
    }), topRight && dimension && {
      // determine precise positioning for 'top right'
      top: -(dimension.height + 2 * arrowThickness + gutterAroundIcon - 1),
      left: -offsetForCornerTipBox
    }), bottomLeft && dimension && {
      // determine precise positioning for 'bottom left'
      top: (iconWidth || theme.Tooltip.Icon.width) + 2 * arrowThickness + gutterAroundIcon,
      left: -(dimension.width - (iconWidth || theme.Tooltip.Icon.width)) + offsetForCornerTipBox
    }), bottomRight && dimension && {
      // determine precise positioning for 'bottom right'
      top: (iconWidth || theme.Tooltip.Icon.width) + 2 * arrowThickness + gutterAroundIcon,
      left: -offsetForCornerTipBox
    }) : {
      // When fixedPosition is available
      position: 'fixed',
      left: fixedPosition.x,
      top: fixedPosition.y
    });
  });

  var ArrowUp = __WEBPACK_IMPORTED_MODULE_5__emotion_styled___default.a.div({
    // arrow facing up
    position: 'absolute',
    width: 0,
    height: 0,
    zIndex: 10
  }, function (_ref4) {
    var theme = _ref4.theme,
        iconWidth = _ref4.iconWidth,
        fixedPosition = _ref4.fixedPosition,
        fixedAtTopLevel = _ref4.fixedAtTopLevel,
        dark = _ref4.dark,
        light = _ref4.light;
    var arrowThickness = convertToNumberFrom(theme.Tooltip.Arrow.thickness);
    var gutterAroundIcon = convertToNumberFrom(theme.Tooltip.gutterAroundIcon);
    return _objectSpread(_objectSpread({}, !fixedAtTopLevel || !fixedPosition ? {
      top: (iconWidth || theme.Tooltip.Icon.width) + arrowThickness + gutterAroundIcon,
      left: (iconWidth || theme.Tooltip.Icon.width) / 2 - arrowThickness
    } : {
      // When fixedPosition is available
      position: 'fixed',
      left: fixedPosition.x,
      top: fixedPosition.y
    }), {}, {
      borderLeft: "".concat(theme.Tooltip.Arrow.thickness, "px solid transparent"),
      borderRight: "".concat(theme.Tooltip.Arrow.thickness, "px solid transparent"),
      borderBottom: "".concat(theme.Tooltip.Arrow.thickness, "px solid ").concat(theme.Tooltip.Arrow.color[dark && 'dark' || light && 'light'])
    });
  });

  var ArrowDown = __WEBPACK_IMPORTED_MODULE_5__emotion_styled___default.a.div({
    // arrow facing down
    position: 'absolute',
    width: 0,
    height: 0,
    zIndex: 10
  }, function (_ref5) {
    var theme = _ref5.theme,
        iconWidth = _ref5.iconWidth,
        fixedPosition = _ref5.fixedPosition,
        fixedAtTopLevel = _ref5.fixedAtTopLevel,
        dark = _ref5.dark,
        light = _ref5.light;
    var arrowThickness = convertToNumberFrom(theme.Tooltip.Arrow.thickness);
    var gutterAroundIcon = convertToNumberFrom(theme.Tooltip.gutterAroundIcon);
    return _objectSpread(_objectSpread({}, !fixedAtTopLevel || !fixedPosition ? {
      top: -2 * arrowThickness - gutterAroundIcon,
      left: (iconWidth || theme.Tooltip.Icon.width) / 2 - arrowThickness
    } : {
      // When fixedPosition is available
      position: 'fixed',
      left: fixedPosition.x,
      top: fixedPosition.y
    }), {}, {
      borderLeft: "".concat(theme.Tooltip.Arrow.thickness, "px solid transparent"),
      borderRight: "".concat(theme.Tooltip.Arrow.thickness, "px solid transparent"),
      borderTop: "".concat(theme.Tooltip.Arrow.thickness, "px solid ").concat(theme.Tooltip.Arrow.color[dark && 'dark' || light && 'light'])
    });
  });

  var ArrowLeft = __WEBPACK_IMPORTED_MODULE_5__emotion_styled___default.a.div({
    // arrow facing left
    position: 'absolute',
    width: 0,
    height: 0,
    zIndex: 10
  }, function (_ref6) {
    var theme = _ref6.theme,
        iconWidth = _ref6.iconWidth,
        fixedPosition = _ref6.fixedPosition,
        fixedAtTopLevel = _ref6.fixedAtTopLevel,
        dark = _ref6.dark,
        light = _ref6.light;
    var arrowThickness = convertToNumberFrom(theme.Tooltip.Arrow.thickness);
    var gutterAroundIcon = convertToNumberFrom(theme.Tooltip.gutterAroundIcon);
    return _objectSpread(_objectSpread({}, !fixedAtTopLevel || !fixedPosition ? {
      top: (iconWidth || theme.Tooltip.Icon.width) / 2 - arrowThickness,
      left: (iconWidth || theme.Tooltip.Icon.width) + 2 * arrowThickness + gutterAroundIcon
    } : {
      // When fixedPosition is available
      position: 'fixed',
      left: fixedPosition.x,
      top: fixedPosition.y
    }), {}, {
      borderTop: "".concat(theme.Tooltip.Arrow.thickness, "px solid transparent"),
      borderBottom: "".concat(theme.Tooltip.Arrow.thickness, "px solid transparent"),
      borderRight: "".concat(theme.Tooltip.Arrow.thickness, "px solid ").concat(theme.Tooltip.Arrow.color[dark && 'dark' || light && 'light'])
    });
  });

  var ArrowRight = __WEBPACK_IMPORTED_MODULE_5__emotion_styled___default.a.div({
    // arrow facing right
    position: 'absolute',
    width: 0,
    height: 0,
    zIndex: 10
  }, function (_ref7) {
    var theme = _ref7.theme,
        iconWidth = _ref7.iconWidth,
        fixedPosition = _ref7.fixedPosition,
        fixedAtTopLevel = _ref7.fixedAtTopLevel,
        dark = _ref7.dark,
        light = _ref7.light;
    var arrowThickness = convertToNumberFrom(theme.Tooltip.Arrow.thickness);
    var gutterAroundIcon = convertToNumberFrom(theme.Tooltip.gutterAroundIcon);
    return _objectSpread(_objectSpread({}, !fixedAtTopLevel || !fixedPosition ? {
      top: (iconWidth || theme.Tooltip.Icon.width) / 2 - arrowThickness,
      left: -2 * arrowThickness - gutterAroundIcon
    } : {
      // When fixedPosition is available
      position: 'fixed',
      left: fixedPosition.x,
      top: fixedPosition.y
    }), {}, {
      borderTop: "".concat(theme.Tooltip.Arrow.thickness, "px solid transparent"),
      borderBottom: "".concat(theme.Tooltip.Arrow.thickness, "px solid transparent"),
      borderLeft: "".concat(theme.Tooltip.Arrow.thickness, "px solid ").concat(theme.Tooltip.Arrow.color[dark && 'dark' || light && 'light'])
    });
  });
  /**
   * Calculates how many positions are specified
   */


  var getNumOfPositions = function getNumOfPositions(_ref8) {
    var top = _ref8.top,
        bottom = _ref8.bottom,
        left = _ref8.left,
        right = _ref8.right,
        topLeft = _ref8.topLeft,
        topRight = _ref8.topRight,
        bottomLeft = _ref8.bottomLeft,
        bottomRight = _ref8.bottomRight;
    var positions = [top, bottom, left, right, topLeft, topRight, bottomLeft, bottomRight];
    return positions.reduce(function (numOfPositions, current) {
      if (current) return ++numOfPositions;
      return numOfPositions;
    }, 0);
  };
  /**
   * Converts string to integer, assuming `px` at the end
   */


  var convertToNumberFrom = function convertToNumberFrom(value) {
    if (Number.isInteger(value)) return value; // return without conversion if already an integer

    return Number.parseInt(value.slice(0, value.length - 2)); // assuming 'px'
  };

  var Tooltip = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__tal_gel_theming__["withTheme"])(TooltipComponent);
  /***/

},
/* 331 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony export (binding) */

  __webpack_require__.d(__webpack_exports__, "a", function () {
    return GelDisplay1;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "b", function () {
    return GelDisplay2;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "c", function () {
    return GelDisplay3;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "d", function () {
    return GelDisplay4;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "e", function () {
    return GelHeading1;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "f", function () {
    return GelHeading2;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "g", function () {
    return GelHeading3;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "h", function () {
    return GelHeading4;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "i", function () {
    return GelHeading5;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "j", function () {
    return GelHeading6;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "k", function () {
    return GelLabel;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "l", function () {
    return GelParagraph;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "m", function () {
    return GelCaption;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "n", function () {
    return GelFootNote;
  });
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "o", function () {
    return GelBlockQuote;
  });
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(5);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(6);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4__emotion_styled__ = __webpack_require__(14);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_4__emotion_styled___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__emotion_styled__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__tal_gel_theming__ = __webpack_require__(11);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_5__tal_gel_theming___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__tal_gel_theming__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6__tal_gel_core__ = __webpack_require__(7);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_6__tal_gel_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__tal_gel_core__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_7__grid_screen_detector__ = __webpack_require__(33);

  var _excluded = ["theme"],
      _excluded2 = ["target", "isXsScreen"];

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);

      if (enumerableOnly) {
        symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
      }

      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  var generateTypographyComponent = function generateTypographyComponent(tagName, target) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__tal_gel_theming__["withTheme"])( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef(function (_ref, forwardedRef) {
      var theme = _ref.theme,
          props = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties___default()(_ref, _excluded);

      var _useContext = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_7__grid_screen_detector__["a"
      /* ScreenDetectorContext */
      ]),
          screen = _useContext.screen,
          isXsScreen = _useContext.isXsScreen;

      var style = // If `theme.Typography[target]` is a function, 
      // it will read the backwardCompatible info from theme
      // and return the style accordingly
      !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__tal_gel_core__["isFunction"])(theme.Typography[target]) ? theme.Typography[target] : theme.Typography[target](theme); // If `as` is specified, it will override the default tag name
      // Eg: <GelHeading3 as="h2" /> 

      var StyledComponent = __WEBPACK_IMPORTED_MODULE_4__emotion_styled___default.a[props.as || tagName](function (_ref2) {
        var target = _ref2.target,
            isXsScreen = _ref2.isXsScreen,
            props = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties___default()(_ref2, _excluded2);

        var inverse = false; // such as `inverse`，large`, `small`

        var overridingStyle = Object.keys(props).reduce(function (result, currProp) {
          if (props[currProp]) {
            var entry = capitalizeFirstLetter(currProp);

            if (entry) {
              if (entry !== 'Inverse') {
                return _objectSpread(_objectSpread({}, result), style[entry] || {});
              }

              inverse = true;
            }
          }

          return result;
        }, {});
        var otherCustomStyle = Object.keys(props).reduce(function (result, currProp) {
          if (supportedTextProps.indexOf(currProp) >= 0) {
            return _objectSpread(_objectSpread({}, result), {}, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()({}, currProp, props[currProp]));
          } else if (supportedSpacingProps.indexOf(currProp) >= 0) {
            return _objectSpread(_objectSpread({}, result), {}, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()({}, currProp, typeof props[currProp] === 'string' ? theme.Grid.gridGutters[props[currProp]] : props[currProp]));
          }

          return result;
        }, {});
        return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, style), overridingStyle), isXsScreen && style.Mobile || {}), inverse && style.Inverse || {}), otherCustomStyle);
      });

      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(StyledComponent, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
        ref: forwardedRef
      }, props, {
        isXsScreen: isXsScreen(screen),
        target: target
      }));
    }));
  };

  var supportedTextProps = ['textAlign', 'textOverflow', 'whiteSpace'];
  var supportedSpacingProps = ['margin', 'marginTop', 'marginBottom', 'marginLeft', 'marginRight', 'padding', 'paddingTop', 'paddingBottom', 'paddingLeft', 'paddingRight'];

  function capitalizeFirstLetter(string) {
    if (typeof string === 'string') {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }

    return null;
  }

  var GelDisplay1 = generateTypographyComponent('div', 'Display1');
  var GelDisplay2 = generateTypographyComponent('div', 'Display2');
  var GelDisplay3 = generateTypographyComponent('div', 'Display3');
  var GelDisplay4 = generateTypographyComponent('div', 'Display4');
  var GelHeading1 = generateTypographyComponent('h1', 'Heading1');
  var GelHeading2 = generateTypographyComponent('h2', 'Heading2');
  var GelHeading3 = generateTypographyComponent('h3', 'Heading3');
  var GelHeading4 = generateTypographyComponent('h4', 'Heading4');
  var GelHeading5 = generateTypographyComponent('h5', 'Heading5');
  var GelHeading6 = generateTypographyComponent('h6', 'Heading6');
  var GelLabel = generateTypographyComponent('label', 'Label');
  var GelParagraph = generateTypographyComponent('p', 'Paragraph');
  var GelCaption = generateTypographyComponent('div', 'Caption');
  var GelFootNote = generateTypographyComponent('div', 'Footnote');
  var GelBlockQuote = generateTypographyComponent('blockquote', 'Blockquote');
  /***/
},
/* 332 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var reactIs = __webpack_require__(140);
  /**
   * Copyright 2015, Yahoo! Inc.
   * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
   */


  var REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
  };
  var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
  };
  var FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
  };
  var MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
  };
  var TYPE_STATICS = {};
  TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
  TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

  function getStatics(component) {
    // React v16.11 and below
    if (reactIs.isMemo(component)) {
      return MEMO_STATICS;
    } // React v16.12 and above


    return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
  }

  var defineProperty = Object.defineProperty;
  var getOwnPropertyNames = Object.getOwnPropertyNames;
  var getOwnPropertySymbols = Object.getOwnPropertySymbols;
  var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
  var getPrototypeOf = Object.getPrototypeOf;
  var objectPrototype = Object.prototype;

  function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
      // don't hoist over string (html) components
      if (objectPrototype) {
        var inheritedComponent = getPrototypeOf(sourceComponent);

        if (inheritedComponent && inheritedComponent !== objectPrototype) {
          hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
      }

      var keys = getOwnPropertyNames(sourceComponent);

      if (getOwnPropertySymbols) {
        keys = keys.concat(getOwnPropertySymbols(sourceComponent));
      }

      var targetStatics = getStatics(targetComponent);
      var sourceStatics = getStatics(sourceComponent);

      for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];

        if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
          var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

          try {
            // Avoid failures from read-only properties
            defineProperty(targetComponent, key, descriptor);
          } catch (e) {}
        }
      }
    }

    return targetComponent;
  }

  module.exports = hoistNonReactStatics;
  /***/
},
/* 333 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /*
  object-assign
  (c) Sindre Sorhus
  @license MIT
  */

  /* eslint-disable no-unused-vars */

  var getOwnPropertySymbols = Object.getOwnPropertySymbols;
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var propIsEnumerable = Object.prototype.propertyIsEnumerable;

  function toObject(val) {
    if (val === null || val === undefined) {
      throw new TypeError('Object.assign cannot be called with null or undefined');
    }

    return Object(val);
  }

  function shouldUseNative() {
    try {
      if (!Object.assign) {
        return false;
      } // Detect buggy property enumeration order in older V8 versions.
      // https://bugs.chromium.org/p/v8/issues/detail?id=4118


      var test1 = new String('abc'); // eslint-disable-line no-new-wrappers

      test1[5] = 'de';

      if (Object.getOwnPropertyNames(test1)[0] === '5') {
        return false;
      } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


      var test2 = {};

      for (var i = 0; i < 10; i++) {
        test2['_' + String.fromCharCode(i)] = i;
      }

      var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
        return test2[n];
      });

      if (order2.join('') !== '0123456789') {
        return false;
      } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


      var test3 = {};
      'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
        test3[letter] = letter;
      });

      if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
        return false;
      }

      return true;
    } catch (err) {
      // We don't expect any of the above to throw, but better to be safe.
      return false;
    }
  }

  module.exports = shouldUseNative() ? Object.assign : function (target, source) {
    var from;
    var to = toObject(target);
    var symbols;

    for (var s = 1; s < arguments.length; s++) {
      from = Object(arguments[s]);

      for (var key in from) {
        if (hasOwnProperty.call(from, key)) {
          to[key] = from[key];
        }
      }

      if (getOwnPropertySymbols) {
        symbols = getOwnPropertySymbols(from);

        for (var i = 0; i < symbols.length; i++) {
          if (propIsEnumerable.call(from, symbols[i])) {
            to[symbols[i]] = from[symbols[i]];
          }
        }
      }
    }

    return to;
  };
  /***/
},
/* 334 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (process) {
    /**
    * Copyright (c) 2013-present, Facebook, Inc.
    *
    * This source code is licensed under the MIT license found in the
    * LICENSE file in the root directory of this source tree.
    */
    var printWarning = function printWarning() {};

    if (process.env.NODE_ENV !== 'production') {
      var ReactPropTypesSecret = __webpack_require__(139);

      var loggedTypeFailures = {};
      var has = Function.call.bind(Object.prototype.hasOwnProperty);

      printWarning = function printWarning(text) {
        var message = 'Warning: ' + text;

        if (typeof console !== 'undefined') {
          console.error(message);
        }

        try {
          // --- Welcome to debugging React ---
          // This error was thrown as a convenience so that you can use this stack
          // to find the callsite that caused this warning to fire.
          throw new Error(message);
        } catch (x) {}
      };
    }
    /**
     * Assert that the values match with the type specs.
     * Error messages are memorized and will only be shown once.
     *
     * @param {object} typeSpecs Map of name to a ReactPropType
     * @param {object} values Runtime values that need to be type-checked
     * @param {string} location e.g. "prop", "context", "child context"
     * @param {string} componentName Name of the component for error messages.
     * @param {?Function} getStack Returns the component stack.
     * @private
     */


    function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
      if (process.env.NODE_ENV !== 'production') {
        for (var typeSpecName in typeSpecs) {
          if (has(typeSpecs, typeSpecName)) {
            var error; // Prop type validation may throw. In case they do, we don't want to
            // fail the render phase where it didn't fail before. So we log it.
            // After these have been cleaned up, we'll let them throw.

            try {
              // This is intentionally an invariant that gets caught. It's the same
              // behavior as without this statement except with a better message.
              if (typeof typeSpecs[typeSpecName] !== 'function') {
                var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.');
                err.name = 'Invariant Violation';
                throw err;
              }

              error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
            } catch (ex) {
              error = ex;
            }

            if (error && !(error instanceof Error)) {
              printWarning((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + typeof error + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
            }

            if (error instanceof Error && !(error.message in loggedTypeFailures)) {
              // Only monitor this failure once because there tends to be a lot of the
              // same error.
              loggedTypeFailures[error.message] = true;
              var stack = getStack ? getStack() : '';
              printWarning('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
            }
          }
        }
      }
    }
    /**
     * Resets warning cache when testing.
     *
     * @private
     */


    checkPropTypes.resetWarningCache = function () {
      if (process.env.NODE_ENV !== 'production') {
        loggedTypeFailures = {};
      }
    };

    module.exports = checkPropTypes;
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(25));
  /***/
},
/* 335 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  var ReactPropTypesSecret = __webpack_require__(139);

  function emptyFunction() {}

  function emptyFunctionWithReset() {}

  emptyFunctionWithReset.resetWarningCache = emptyFunction;

  module.exports = function () {
    function shim(props, propName, componentName, location, propFullName, secret) {
      if (secret === ReactPropTypesSecret) {
        // It is still safe when called from React.
        return;
      }

      var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
      err.name = 'Invariant Violation';
      throw err;
    }

    ;
    shim.isRequired = shim;

    function getShim() {
      return shim;
    }

    ; // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.

    var ReactPropTypes = {
      array: shim,
      bool: shim,
      func: shim,
      number: shim,
      object: shim,
      string: shim,
      symbol: shim,
      any: shim,
      arrayOf: getShim,
      element: shim,
      elementType: shim,
      instanceOf: getShim,
      node: shim,
      objectOf: getShim,
      oneOf: getShim,
      oneOfType: getShim,
      shape: getShim,
      exact: getShim,
      checkPropTypes: emptyFunctionWithReset,
      resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };
  /***/

},
/* 336 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (process) {
    /**
    * Copyright (c) 2013-present, Facebook, Inc.
    *
    * This source code is licensed under the MIT license found in the
    * LICENSE file in the root directory of this source tree.
    */
    var ReactIs = __webpack_require__(140);

    var assign = __webpack_require__(333);

    var ReactPropTypesSecret = __webpack_require__(139);

    var checkPropTypes = __webpack_require__(334);

    var has = Function.call.bind(Object.prototype.hasOwnProperty);

    var printWarning = function printWarning() {};

    if (process.env.NODE_ENV !== 'production') {
      printWarning = function printWarning(text) {
        var message = 'Warning: ' + text;

        if (typeof console !== 'undefined') {
          console.error(message);
        }

        try {
          // --- Welcome to debugging React ---
          // This error was thrown as a convenience so that you can use this stack
          // to find the callsite that caused this warning to fire.
          throw new Error(message);
        } catch (x) {}
      };
    }

    function emptyFunctionThatReturnsNull() {
      return null;
    }

    module.exports = function (isValidElement, throwOnDirectAccess) {
      /* global Symbol */
      var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
      var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

      /**
       * Returns the iterator method function contained on the iterable object.
       *
       * Be sure to invoke the function with the iterable as context:
       *
       *     var iteratorFn = getIteratorFn(myIterable);
       *     if (iteratorFn) {
       *       var iterator = iteratorFn.call(myIterable);
       *       ...
       *     }
       *
       * @param {?object} maybeIterable
       * @return {?function}
       */

      function getIteratorFn(maybeIterable) {
        var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);

        if (typeof iteratorFn === 'function') {
          return iteratorFn;
        }
      }
      /**
       * Collection of methods that allow declaration and validation of props that are
       * supplied to React components. Example usage:
       *
       *   var Props = require('ReactPropTypes');
       *   var MyArticle = React.createClass({
       *     propTypes: {
       *       // An optional string prop named "description".
       *       description: Props.string,
       *
       *       // A required enum prop named "category".
       *       category: Props.oneOf(['News','Photos']).isRequired,
       *
       *       // A prop named "dialog" that requires an instance of Dialog.
       *       dialog: Props.instanceOf(Dialog).isRequired
       *     },
       *     render: function() { ... }
       *   });
       *
       * A more formal specification of how these methods are used:
       *
       *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
       *   decl := ReactPropTypes.{type}(.isRequired)?
       *
       * Each and every declaration produces a function with the same signature. This
       * allows the creation of custom validation functions. For example:
       *
       *  var MyLink = React.createClass({
       *    propTypes: {
       *      // An optional string or URI prop named "href".
       *      href: function(props, propName, componentName) {
       *        var propValue = props[propName];
       *        if (propValue != null && typeof propValue !== 'string' &&
       *            !(propValue instanceof URI)) {
       *          return new Error(
       *            'Expected a string or an URI for ' + propName + ' in ' +
       *            componentName
       *          );
       *        }
       *      }
       *    },
       *    render: function() {...}
       *  });
       *
       * @internal
       */


      var ANONYMOUS = '<<anonymous>>'; // Important!
      // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.

      var ReactPropTypes = {
        array: createPrimitiveTypeChecker('array'),
        bool: createPrimitiveTypeChecker('boolean'),
        func: createPrimitiveTypeChecker('function'),
        number: createPrimitiveTypeChecker('number'),
        object: createPrimitiveTypeChecker('object'),
        string: createPrimitiveTypeChecker('string'),
        symbol: createPrimitiveTypeChecker('symbol'),
        any: createAnyTypeChecker(),
        arrayOf: createArrayOfTypeChecker,
        element: createElementTypeChecker(),
        elementType: createElementTypeTypeChecker(),
        instanceOf: createInstanceTypeChecker,
        node: createNodeChecker(),
        objectOf: createObjectOfTypeChecker,
        oneOf: createEnumTypeChecker,
        oneOfType: createUnionTypeChecker,
        shape: createShapeTypeChecker,
        exact: createStrictShapeTypeChecker
      };
      /**
       * inlined Object.is polyfill to avoid requiring consumers ship their own
       * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
       */

      /*eslint-disable no-self-compare*/

      function is(x, y) {
        // SameValue algorithm
        if (x === y) {
          // Steps 1-5, 7-10
          // Steps 6.b-6.e: +0 != -0
          return x !== 0 || 1 / x === 1 / y;
        } else {
          // Step 6.a: NaN == NaN
          return x !== x && y !== y;
        }
      }
      /*eslint-enable no-self-compare*/

      /**
       * We use an Error-like object for backward compatibility as people may call
       * PropTypes directly and inspect their output. However, we don't use real
       * Errors anymore. We don't inspect their stack anyway, and creating them
       * is prohibitively expensive if they are created too often, such as what
       * happens in oneOfType() for any type before the one that matched.
       */


      function PropTypeError(message) {
        this.message = message;
        this.stack = '';
      } // Make `instanceof Error` still work for returned errors.


      PropTypeError.prototype = Error.prototype;

      function createChainableTypeChecker(validate) {
        if (process.env.NODE_ENV !== 'production') {
          var manualPropTypeCallCache = {};
          var manualPropTypeWarningCount = 0;
        }

        function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
          componentName = componentName || ANONYMOUS;
          propFullName = propFullName || propName;

          if (secret !== ReactPropTypesSecret) {
            if (throwOnDirectAccess) {
              // New behavior only for users of `prop-types` package
              var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use `PropTypes.checkPropTypes()` to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
              err.name = 'Invariant Violation';
              throw err;
            } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
              // Old behavior for people using React.PropTypes
              var cacheKey = componentName + ':' + propName;

              if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
              manualPropTypeWarningCount < 3) {
                printWarning('You are manually calling a React.PropTypes validation ' + 'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.');
                manualPropTypeCallCache[cacheKey] = true;
                manualPropTypeWarningCount++;
              }
            }
          }

          if (props[propName] == null) {
            if (isRequired) {
              if (props[propName] === null) {
                return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
              }

              return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
            }

            return null;
          } else {
            return validate(props, propName, componentName, location, propFullName);
          }
        }

        var chainedCheckType = checkType.bind(null, false);
        chainedCheckType.isRequired = checkType.bind(null, true);
        return chainedCheckType;
      }

      function createPrimitiveTypeChecker(expectedType) {
        function validate(props, propName, componentName, location, propFullName, secret) {
          var propValue = props[propName];
          var propType = getPropType(propValue);

          if (propType !== expectedType) {
            // `propValue` being instance of, say, date/regexp, pass the 'object'
            // check, but we can offer a more precise error message here rather than
            // 'of type `object`'.
            var preciseType = getPreciseType(propValue);
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
          }

          return null;
        }

        return createChainableTypeChecker(validate);
      }

      function createAnyTypeChecker() {
        return createChainableTypeChecker(emptyFunctionThatReturnsNull);
      }

      function createArrayOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
          if (typeof typeChecker !== 'function') {
            return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
          }

          var propValue = props[propName];

          if (!Array.isArray(propValue)) {
            var propType = getPropType(propValue);
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
          }

          for (var i = 0; i < propValue.length; i++) {
            var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);

            if (error instanceof Error) {
              return error;
            }
          }

          return null;
        }

        return createChainableTypeChecker(validate);
      }

      function createElementTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];

          if (!isValidElement(propValue)) {
            var propType = getPropType(propValue);
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
          }

          return null;
        }

        return createChainableTypeChecker(validate);
      }

      function createElementTypeTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];

          if (!ReactIs.isValidElementType(propValue)) {
            var propType = getPropType(propValue);
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
          }

          return null;
        }

        return createChainableTypeChecker(validate);
      }

      function createInstanceTypeChecker(expectedClass) {
        function validate(props, propName, componentName, location, propFullName) {
          if (!(props[propName] instanceof expectedClass)) {
            var expectedClassName = expectedClass.name || ANONYMOUS;
            var actualClassName = getClassName(props[propName]);
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
          }

          return null;
        }

        return createChainableTypeChecker(validate);
      }

      function createEnumTypeChecker(expectedValues) {
        if (!Array.isArray(expectedValues)) {
          if (process.env.NODE_ENV !== 'production') {
            if (arguments.length > 1) {
              printWarning('Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' + 'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).');
            } else {
              printWarning('Invalid argument supplied to oneOf, expected an array.');
            }
          }

          return emptyFunctionThatReturnsNull;
        }

        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];

          for (var i = 0; i < expectedValues.length; i++) {
            if (is(propValue, expectedValues[i])) {
              return null;
            }
          }

          var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
            var type = getPreciseType(value);

            if (type === 'symbol') {
              return String(value);
            }

            return value;
          });
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
        }

        return createChainableTypeChecker(validate);
      }

      function createObjectOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
          if (typeof typeChecker !== 'function') {
            return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
          }

          var propValue = props[propName];
          var propType = getPropType(propValue);

          if (propType !== 'object') {
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
          }

          for (var key in propValue) {
            if (has(propValue, key)) {
              var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);

              if (error instanceof Error) {
                return error;
              }
            }
          }

          return null;
        }

        return createChainableTypeChecker(validate);
      }

      function createUnionTypeChecker(arrayOfTypeCheckers) {
        if (!Array.isArray(arrayOfTypeCheckers)) {
          process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
          return emptyFunctionThatReturnsNull;
        }

        for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
          var checker = arrayOfTypeCheckers[i];

          if (typeof checker !== 'function') {
            printWarning('Invalid argument supplied to oneOfType. Expected an array of check functions, but ' + 'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
            return emptyFunctionThatReturnsNull;
          }
        }

        function validate(props, propName, componentName, location, propFullName) {
          for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
            var checker = arrayOfTypeCheckers[i];

            if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
              return null;
            }
          }

          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
        }

        return createChainableTypeChecker(validate);
      }

      function createNodeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
          if (!isNode(props[propName])) {
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
          }

          return null;
        }

        return createChainableTypeChecker(validate);
      }

      function createShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];
          var propType = getPropType(propValue);

          if (propType !== 'object') {
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
          }

          for (var key in shapeTypes) {
            var checker = shapeTypes[key];

            if (!checker) {
              continue;
            }

            var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);

            if (error) {
              return error;
            }
          }

          return null;
        }

        return createChainableTypeChecker(validate);
      }

      function createStrictShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];
          var propType = getPropType(propValue);

          if (propType !== 'object') {
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
          } // We need to check all keys in case some are required but missing from
          // props.


          var allKeys = assign({}, props[propName], shapeTypes);

          for (var key in allKeys) {
            var checker = shapeTypes[key];

            if (!checker) {
              return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
            }

            var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);

            if (error) {
              return error;
            }
          }

          return null;
        }

        return createChainableTypeChecker(validate);
      }

      function isNode(propValue) {
        switch (typeof propValue) {
          case 'number':
          case 'string':
          case 'undefined':
            return true;

          case 'boolean':
            return !propValue;

          case 'object':
            if (Array.isArray(propValue)) {
              return propValue.every(isNode);
            }

            if (propValue === null || isValidElement(propValue)) {
              return true;
            }

            var iteratorFn = getIteratorFn(propValue);

            if (iteratorFn) {
              var iterator = iteratorFn.call(propValue);
              var step;

              if (iteratorFn !== propValue.entries) {
                while (!(step = iterator.next()).done) {
                  if (!isNode(step.value)) {
                    return false;
                  }
                }
              } else {
                // Iterator will provide entry [k,v] tuples rather than values.
                while (!(step = iterator.next()).done) {
                  var entry = step.value;

                  if (entry) {
                    if (!isNode(entry[1])) {
                      return false;
                    }
                  }
                }
              }
            } else {
              return false;
            }

            return true;

          default:
            return false;
        }
      }

      function isSymbol(propType, propValue) {
        // Native Symbol.
        if (propType === 'symbol') {
          return true;
        } // falsy value can't be a Symbol


        if (!propValue) {
          return false;
        } // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'


        if (propValue['@@toStringTag'] === 'Symbol') {
          return true;
        } // Fallback for non-spec compliant Symbols which are polyfilled.


        if (typeof Symbol === 'function' && propValue instanceof Symbol) {
          return true;
        }

        return false;
      } // Equivalent of `typeof` but with special handling for array and regexp.


      function getPropType(propValue) {
        var propType = typeof propValue;

        if (Array.isArray(propValue)) {
          return 'array';
        }

        if (propValue instanceof RegExp) {
          // Old webkits (at least until Android 4.0) return 'function' rather than
          // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
          // passes PropTypes.object.
          return 'object';
        }

        if (isSymbol(propType, propValue)) {
          return 'symbol';
        }

        return propType;
      } // This handles more types than `getPropType`. Only used for error messages.
      // See `createPrimitiveTypeChecker`.


      function getPreciseType(propValue) {
        if (typeof propValue === 'undefined' || propValue === null) {
          return '' + propValue;
        }

        var propType = getPropType(propValue);

        if (propType === 'object') {
          if (propValue instanceof Date) {
            return 'date';
          } else if (propValue instanceof RegExp) {
            return 'regexp';
          }
        }

        return propType;
      } // Returns a string that is postfixed to a warning about an invalid type.
      // For example, "undefined" or "of type array"


      function getPostfixForTypeWarning(value) {
        var type = getPreciseType(value);

        switch (type) {
          case 'array':
          case 'object':
            return 'an ' + type;

          case 'boolean':
          case 'date':
          case 'regexp':
            return 'a ' + type;

          default:
            return type;
        }
      } // Returns class name of the object, if any.


      function getClassName(propValue) {
        if (!propValue.constructor || !propValue.constructor.name) {
          return ANONYMOUS;
        }

        return propValue.constructor.name;
      }

      ReactPropTypes.checkPropTypes = checkPropTypes;
      ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
      ReactPropTypes.PropTypes = ReactPropTypes;
      return ReactPropTypes;
    };
    /* WEBPACK VAR INJECTION */

  }).call(exports, __webpack_require__(25));
  /***/
},
/* 337 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony export (immutable) */

  __webpack_exports__["a"] = makeAsyncScript;
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(4);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(190);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(332);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }

  function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
  }

  var SCRIPT_MAP = {}; // A counter used to generate a unique id for each component that uses the function

  var idCount = 0;

  function makeAsyncScript(getScriptURL, options) {
    options = options || {};
    return function wrapWithAsyncScript(WrappedComponent) {
      var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";

      var AsyncScriptLoader = /*#__PURE__*/function (_Component) {
        _inheritsLoose(AsyncScriptLoader, _Component);

        function AsyncScriptLoader(props, context) {
          var _this;

          _this = _Component.call(this, props, context) || this;
          _this.state = {};
          _this.__scriptURL = "";
          return _this;
        }

        var _proto = AsyncScriptLoader.prototype;

        _proto.asyncScriptLoaderGetScriptLoaderID = function asyncScriptLoaderGetScriptLoaderID() {
          if (!this.__scriptLoaderID) {
            this.__scriptLoaderID = "async-script-loader-" + idCount++;
          }

          return this.__scriptLoaderID;
        };

        _proto.setupScriptURL = function setupScriptURL() {
          this.__scriptURL = typeof getScriptURL === "function" ? getScriptURL() : getScriptURL;
          return this.__scriptURL;
        };

        _proto.asyncScriptLoaderHandleLoad = function asyncScriptLoaderHandleLoad(state) {
          var _this2 = this; // use reacts setState callback to fire props.asyncScriptOnLoad with new state/entry


          this.setState(state, function () {
            return _this2.props.asyncScriptOnLoad && _this2.props.asyncScriptOnLoad(_this2.state);
          });
        };

        _proto.asyncScriptLoaderTriggerOnScriptLoaded = function asyncScriptLoaderTriggerOnScriptLoaded() {
          var mapEntry = SCRIPT_MAP[this.__scriptURL];

          if (!mapEntry || !mapEntry.loaded) {
            throw new Error("Script is not loaded.");
          }

          for (var obsKey in mapEntry.observers) {
            mapEntry.observers[obsKey](mapEntry);
          }

          delete window[options.callbackName];
        };

        _proto.componentDidMount = function componentDidMount() {
          var _this3 = this;

          var scriptURL = this.setupScriptURL();
          var key = this.asyncScriptLoaderGetScriptLoaderID();
          var _options = options,
              globalName = _options.globalName,
              callbackName = _options.callbackName,
              scriptId = _options.scriptId; // check if global object already attached to window

          if (globalName && typeof window[globalName] !== "undefined") {
            SCRIPT_MAP[scriptURL] = {
              loaded: true,
              observers: {}
            };
          } // check if script loading already


          if (SCRIPT_MAP[scriptURL]) {
            var entry = SCRIPT_MAP[scriptURL]; // if loaded or errored then "finish"

            if (entry && (entry.loaded || entry.errored)) {
              this.asyncScriptLoaderHandleLoad(entry);
              return;
            } // if still loading then callback to observer queue


            entry.observers[key] = function (entry) {
              return _this3.asyncScriptLoaderHandleLoad(entry);
            };

            return;
          }
          /*
           * hasn't started loading
           * start the "magic"
           * setup script to load and observers
           */


          var observers = {};

          observers[key] = function (entry) {
            return _this3.asyncScriptLoaderHandleLoad(entry);
          };

          SCRIPT_MAP[scriptURL] = {
            loaded: false,
            observers: observers
          };
          var script = document.createElement("script");
          script.src = scriptURL;
          script.async = true;

          for (var attribute in options.attributes) {
            script.setAttribute(attribute, options.attributes[attribute]);
          }

          if (scriptId) {
            script.id = scriptId;
          }

          var callObserverFuncAndRemoveObserver = function callObserverFuncAndRemoveObserver(func) {
            if (SCRIPT_MAP[scriptURL]) {
              var mapEntry = SCRIPT_MAP[scriptURL];
              var observersMap = mapEntry.observers;

              for (var obsKey in observersMap) {
                if (func(observersMap[obsKey])) {
                  delete observersMap[obsKey];
                }
              }
            }
          };

          if (callbackName && typeof window !== "undefined") {
            window[callbackName] = function () {
              return _this3.asyncScriptLoaderTriggerOnScriptLoaded();
            };
          }

          script.onload = function () {
            var mapEntry = SCRIPT_MAP[scriptURL];

            if (mapEntry) {
              mapEntry.loaded = true;
              callObserverFuncAndRemoveObserver(function (observer) {
                if (callbackName) {
                  return false;
                }

                observer(mapEntry);
                return true;
              });
            }
          };

          script.onerror = function () {
            var mapEntry = SCRIPT_MAP[scriptURL];

            if (mapEntry) {
              mapEntry.errored = true;
              callObserverFuncAndRemoveObserver(function (observer) {
                observer(mapEntry);
                return true;
              });
            }
          };

          document.body.appendChild(script);
        };

        _proto.componentWillUnmount = function componentWillUnmount() {
          // Remove tag script
          var scriptURL = this.__scriptURL;

          if (options.removeOnUnmount === true) {
            var allScripts = document.getElementsByTagName("script");

            for (var i = 0; i < allScripts.length; i += 1) {
              if (allScripts[i].src.indexOf(scriptURL) > -1) {
                if (allScripts[i].parentNode) {
                  allScripts[i].parentNode.removeChild(allScripts[i]);
                }
              }
            }
          } // Clean the observer entry


          var mapEntry = SCRIPT_MAP[scriptURL];

          if (mapEntry) {
            delete mapEntry.observers[this.asyncScriptLoaderGetScriptLoaderID()];

            if (options.removeOnUnmount === true) {
              delete SCRIPT_MAP[scriptURL];
            }
          }
        };

        _proto.render = function render() {
          var globalName = options.globalName; // remove asyncScriptOnLoad from childProps

          var _this$props = this.props,
              asyncScriptOnLoad = _this$props.asyncScriptOnLoad,
              forwardedRef = _this$props.forwardedRef,
              childProps = _objectWithoutPropertiesLoose(_this$props, ["asyncScriptOnLoad", "forwardedRef"]); // eslint-disable-line no-unused-vars


          if (globalName && typeof window !== "undefined") {
            childProps[globalName] = typeof window[globalName] !== "undefined" ? window[globalName] : undefined;
          }

          childProps.ref = forwardedRef;
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(WrappedComponent, childProps);
        };

        return AsyncScriptLoader;
      }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]); // Note the second param "ref" provided by React.forwardRef.
      // We can pass it along to AsyncScriptLoader as a regular prop, e.g. "forwardedRef"
      // And it can then be attached to the Component.


      var ForwardedComponent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["forwardRef"])(function (props, ref) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(AsyncScriptLoader, _extends({}, props, {
          forwardedRef: ref
        }));
      });

      ForwardedComponent.displayName = "AsyncScriptLoader(" + wrappedComponentName + ")";
      ForwardedComponent.propTypes = {
        asyncScriptOnLoad: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
      };
      return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(ForwardedComponent, WrappedComponent);
    };
  }
  /***/

},
/* 338 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__recaptcha_wrapper__ = __webpack_require__(339);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1__recaptcha__ = __webpack_require__(191);
  /* unused harmony reexport ReCAPTCHA */

  /* harmony default export */


  __webpack_exports__["a"] = __WEBPACK_IMPORTED_MODULE_0__recaptcha_wrapper__["a"
  /* default */
  ];
  /***/
},
/* 339 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";
  /* harmony import */

  var __WEBPACK_IMPORTED_MODULE_0__recaptcha__ = __webpack_require__(191);
  /* harmony import */


  var __WEBPACK_IMPORTED_MODULE_1_react_async_script__ = __webpack_require__(337);

  var callbackName = "onloadcallback";
  var globalName = "grecaptcha";

  function getOptions() {
    return typeof window !== "undefined" && window.recaptchaOptions || {};
  }

  function getURL() {
    var dynamicOptions = getOptions();
    var hostname = dynamicOptions.useRecaptchaNet ? "recaptcha.net" : "www.google.com";
    return "https://" + hostname + "/recaptcha/api.js?onload=" + callbackName + "&render=explicit";
  }
  /* harmony default export */


  __webpack_exports__["a"] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_async_script__["a"
  /* default */
  ])(getURL, {
    callbackName: callbackName,
    globalName: globalName
  })(__WEBPACK_IMPORTED_MODULE_0__recaptcha__["a"
  /* default */
  ]);
  /***/
},
/* 340 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (process) {
    /** @license React v16.13.1
    * react-is.development.js
    *
    * Copyright (c) Facebook, Inc. and its affiliates.
    *
    * This source code is licensed under the MIT license found in the
    * LICENSE file in the root directory of this source tree.
    */
    if (process.env.NODE_ENV !== "production") {
      (function () {
        'use strict'; // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
        // nor polyfill, then a plain number is used for performance.

        var hasSymbol = typeof Symbol === 'function' && Symbol.for;
        var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
        var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
        var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
        var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
        var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
        var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
        var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
        // (unstable) APIs that have been removed. Can we remove the symbols?

        var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
        var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
        var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
        var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
        var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
        var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
        var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
        var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
        var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
        var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
        var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

        function isValidElementType(type) {
          return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
          type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
        }

        function typeOf(object) {
          if (typeof object === 'object' && object !== null) {
            var $$typeof = object.$$typeof;

            switch ($$typeof) {
              case REACT_ELEMENT_TYPE:
                var type = object.type;

                switch (type) {
                  case REACT_ASYNC_MODE_TYPE:
                  case REACT_CONCURRENT_MODE_TYPE:
                  case REACT_FRAGMENT_TYPE:
                  case REACT_PROFILER_TYPE:
                  case REACT_STRICT_MODE_TYPE:
                  case REACT_SUSPENSE_TYPE:
                    return type;

                  default:
                    var $$typeofType = type && type.$$typeof;

                    switch ($$typeofType) {
                      case REACT_CONTEXT_TYPE:
                      case REACT_FORWARD_REF_TYPE:
                      case REACT_LAZY_TYPE:
                      case REACT_MEMO_TYPE:
                      case REACT_PROVIDER_TYPE:
                        return $$typeofType;

                      default:
                        return $$typeof;
                    }

                }

              case REACT_PORTAL_TYPE:
                return $$typeof;
            }
          }

          return undefined;
        } // AsyncMode is deprecated along with isAsyncMode


        var AsyncMode = REACT_ASYNC_MODE_TYPE;
        var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
        var ContextConsumer = REACT_CONTEXT_TYPE;
        var ContextProvider = REACT_PROVIDER_TYPE;
        var Element = REACT_ELEMENT_TYPE;
        var ForwardRef = REACT_FORWARD_REF_TYPE;
        var Fragment = REACT_FRAGMENT_TYPE;
        var Lazy = REACT_LAZY_TYPE;
        var Memo = REACT_MEMO_TYPE;
        var Portal = REACT_PORTAL_TYPE;
        var Profiler = REACT_PROFILER_TYPE;
        var StrictMode = REACT_STRICT_MODE_TYPE;
        var Suspense = REACT_SUSPENSE_TYPE;
        var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

        function isAsyncMode(object) {
          {
            if (!hasWarnedAboutDeprecatedIsAsyncMode) {
              hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

              console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
            }
          }
          return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
        }

        function isConcurrentMode(object) {
          return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
        }

        function isContextConsumer(object) {
          return typeOf(object) === REACT_CONTEXT_TYPE;
        }

        function isContextProvider(object) {
          return typeOf(object) === REACT_PROVIDER_TYPE;
        }

        function isElement(object) {
          return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
        }

        function isForwardRef(object) {
          return typeOf(object) === REACT_FORWARD_REF_TYPE;
        }

        function isFragment(object) {
          return typeOf(object) === REACT_FRAGMENT_TYPE;
        }

        function isLazy(object) {
          return typeOf(object) === REACT_LAZY_TYPE;
        }

        function isMemo(object) {
          return typeOf(object) === REACT_MEMO_TYPE;
        }

        function isPortal(object) {
          return typeOf(object) === REACT_PORTAL_TYPE;
        }

        function isProfiler(object) {
          return typeOf(object) === REACT_PROFILER_TYPE;
        }

        function isStrictMode(object) {
          return typeOf(object) === REACT_STRICT_MODE_TYPE;
        }

        function isSuspense(object) {
          return typeOf(object) === REACT_SUSPENSE_TYPE;
        }

        exports.AsyncMode = AsyncMode;
        exports.ConcurrentMode = ConcurrentMode;
        exports.ContextConsumer = ContextConsumer;
        exports.ContextProvider = ContextProvider;
        exports.Element = Element;
        exports.ForwardRef = ForwardRef;
        exports.Fragment = Fragment;
        exports.Lazy = Lazy;
        exports.Memo = Memo;
        exports.Portal = Portal;
        exports.Profiler = Profiler;
        exports.StrictMode = StrictMode;
        exports.Suspense = Suspense;
        exports.isAsyncMode = isAsyncMode;
        exports.isConcurrentMode = isConcurrentMode;
        exports.isContextConsumer = isContextConsumer;
        exports.isContextProvider = isContextProvider;
        exports.isElement = isElement;
        exports.isForwardRef = isForwardRef;
        exports.isFragment = isFragment;
        exports.isLazy = isLazy;
        exports.isMemo = isMemo;
        exports.isPortal = isPortal;
        exports.isProfiler = isProfiler;
        exports.isStrictMode = isStrictMode;
        exports.isSuspense = isSuspense;
        exports.isValidElementType = isValidElementType;
        exports.typeOf = typeOf;
      })();
    }
    /* WEBPACK VAR INJECTION */

  }).call(exports, __webpack_require__(25));
  /***/
},
/* 341 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /** @license React v16.13.1
   * react-is.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  var b = "function" === typeof Symbol && Symbol.for,
      c = b ? Symbol.for("react.element") : 60103,
      d = b ? Symbol.for("react.portal") : 60106,
      e = b ? Symbol.for("react.fragment") : 60107,
      f = b ? Symbol.for("react.strict_mode") : 60108,
      g = b ? Symbol.for("react.profiler") : 60114,
      h = b ? Symbol.for("react.provider") : 60109,
      k = b ? Symbol.for("react.context") : 60110,
      l = b ? Symbol.for("react.async_mode") : 60111,
      m = b ? Symbol.for("react.concurrent_mode") : 60111,
      n = b ? Symbol.for("react.forward_ref") : 60112,
      p = b ? Symbol.for("react.suspense") : 60113,
      q = b ? Symbol.for("react.suspense_list") : 60120,
      r = b ? Symbol.for("react.memo") : 60115,
      t = b ? Symbol.for("react.lazy") : 60116,
      v = b ? Symbol.for("react.block") : 60121,
      w = b ? Symbol.for("react.fundamental") : 60117,
      x = b ? Symbol.for("react.responder") : 60118,
      y = b ? Symbol.for("react.scope") : 60119;

  function z(a) {
    if ("object" === typeof a && null !== a) {
      var u = a.$$typeof;

      switch (u) {
        case c:
          switch (a = a.type, a) {
            case l:
            case m:
            case e:
            case g:
            case f:
            case p:
              return a;

            default:
              switch (a = a && a.$$typeof, a) {
                case k:
                case n:
                case t:
                case r:
                case h:
                  return a;

                default:
                  return u;
              }

          }

        case d:
          return u;
      }
    }
  }

  function A(a) {
    return z(a) === m;
  }

  exports.AsyncMode = l;
  exports.ConcurrentMode = m;
  exports.ContextConsumer = k;
  exports.ContextProvider = h;
  exports.Element = c;
  exports.ForwardRef = n;
  exports.Fragment = e;
  exports.Lazy = t;
  exports.Memo = r;
  exports.Portal = d;
  exports.Profiler = g;
  exports.StrictMode = f;
  exports.Suspense = p;

  exports.isAsyncMode = function (a) {
    return A(a) || z(a) === l;
  };

  exports.isConcurrentMode = A;

  exports.isContextConsumer = function (a) {
    return z(a) === k;
  };

  exports.isContextProvider = function (a) {
    return z(a) === h;
  };

  exports.isElement = function (a) {
    return "object" === typeof a && null !== a && a.$$typeof === c;
  };

  exports.isForwardRef = function (a) {
    return z(a) === n;
  };

  exports.isFragment = function (a) {
    return z(a) === e;
  };

  exports.isLazy = function (a) {
    return z(a) === t;
  };

  exports.isMemo = function (a) {
    return z(a) === r;
  };

  exports.isPortal = function (a) {
    return z(a) === d;
  };

  exports.isProfiler = function (a) {
    return z(a) === g;
  };

  exports.isStrictMode = function (a) {
    return z(a) === f;
  };

  exports.isSuspense = function (a) {
    return z(a) === p;
  };

  exports.isValidElementType = function (a) {
    return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
  };

  exports.typeOf = z;
  /***/
},
/* 342 */

/***/
function (module, exports) {
  var g; // This works in non-strict mode

  g = function () {
    return this;
  }();

  try {
    // This works if eval is allowed (see CSP)
    g = g || Function("return this")() || (1, eval)("this");
  } catch (e) {
    // This works if the window reference is available
    if (typeof window === "object") g = window;
  } // g can still be undefined, but nothing to do about it...
  // We return undefined, instead of nothing here, so it's
  // easier to handle this case. if(!global) { ...}


  module.exports = g;
  /***/
},
/* 343 */

/***/
function (module, exports, __webpack_require__) {
  var lengthOfArrayLike = __webpack_require__(23);

  module.exports = function (Constructor, list) {
    var index = 0;
    var length = lengthOfArrayLike(list);
    var result = new Constructor(length);

    while (length > index) {
      result[index] = list[index++];
    }

    return result;
  };
  /***/

},
/* 344 */

/***/
function (module, exports, __webpack_require__) {
  var global = __webpack_require__(1);

  var isArray = __webpack_require__(71);

  var isConstructor = __webpack_require__(76);

  var isObject = __webpack_require__(13);

  var wellKnownSymbol = __webpack_require__(15);

  var SPECIES = wellKnownSymbol('species');
  var Array = global.Array; // a part of `ArraySpeciesCreate` abstract operation
  // https://tc39.es/ecma262/#sec-arrayspeciescreate

  module.exports = function (originalArray) {
    var C;

    if (isArray(originalArray)) {
      C = originalArray.constructor; // cross-realm fallback

      if (isConstructor(C) && (C === Array || isArray(C.prototype))) C = undefined;else if (isObject(C)) {
        C = C[SPECIES];
        if (C === null) C = undefined;
      }
    }

    return C === undefined ? Array : C;
  };
  /***/

},
/* 345 */

/***/
function (module, exports, __webpack_require__) {
  var anObject = __webpack_require__(10);

  var iteratorClose = __webpack_require__(213); // call something on iterator step with safe closing on error


  module.exports = function (iterator, fn, value, ENTRIES) {
    try {
      return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
    } catch (error) {
      iteratorClose(iterator, 'throw', error);
    }
  };
  /***/

},
/* 346 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var global = __webpack_require__(1);

  var uncurryThis = __webpack_require__(3);

  var fails = __webpack_require__(2);

  var padStart = __webpack_require__(165).start;

  var RangeError = global.RangeError;
  var abs = Math.abs;
  var DatePrototype = Date.prototype;
  var n$DateToISOString = DatePrototype.toISOString;
  var getTime = uncurryThis(DatePrototype.getTime);
  var getUTCDate = uncurryThis(DatePrototype.getUTCDate);
  var getUTCFullYear = uncurryThis(DatePrototype.getUTCFullYear);
  var getUTCHours = uncurryThis(DatePrototype.getUTCHours);
  var getUTCMilliseconds = uncurryThis(DatePrototype.getUTCMilliseconds);
  var getUTCMinutes = uncurryThis(DatePrototype.getUTCMinutes);
  var getUTCMonth = uncurryThis(DatePrototype.getUTCMonth);
  var getUTCSeconds = uncurryThis(DatePrototype.getUTCSeconds); // `Date.prototype.toISOString` method implementation
  // https://tc39.es/ecma262/#sec-date.prototype.toisostring
  // PhantomJS / old WebKit fails here:

  module.exports = fails(function () {
    return n$DateToISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
  }) || !fails(function () {
    n$DateToISOString.call(new Date(NaN));
  }) ? function toISOString() {
    if (!isFinite(getTime(this))) throw RangeError('Invalid time value');
    var date = this;
    var year = getUTCFullYear(date);
    var milliseconds = getUTCMilliseconds(date);
    var sign = year < 0 ? '-' : year > 9999 ? '+' : '';
    return sign + padStart(abs(year), sign ? 6 : 4, 0) + '-' + padStart(getUTCMonth(date) + 1, 2, 0) + '-' + padStart(getUTCDate(date), 2, 0) + 'T' + padStart(getUTCHours(date), 2, 0) + ':' + padStart(getUTCMinutes(date), 2, 0) + ':' + padStart(getUTCSeconds(date), 2, 0) + '.' + padStart(milliseconds, 3, 0) + 'Z';
  } : n$DateToISOString;
  /***/
},
/* 347 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var global = __webpack_require__(1);

  var anObject = __webpack_require__(10);

  var ordinaryToPrimitive = __webpack_require__(226);

  var TypeError = global.TypeError; // `Date.prototype[@@toPrimitive](hint)` method implementation
  // https://tc39.es/ecma262/#sec-date.prototype-@@toprimitive

  module.exports = function (hint) {
    anObject(this);
    if (hint === 'string' || hint === 'default') hint = 'string';else if (hint !== 'number') throw TypeError('Incorrect hint');
    return ordinaryToPrimitive(this, hint);
  };
  /***/

},
/* 348 */

/***/
function (module, exports) {
  module.exports = typeof window == 'object';
  /***/
},
/* 349 */

/***/
function (module, exports, __webpack_require__) {
  var userAgent = __webpack_require__(57);

  var global = __webpack_require__(1);

  module.exports = /ipad|iphone|ipod/i.test(userAgent) && global.Pebble !== undefined;
  /***/
},
/* 350 */

/***/
function (module, exports, __webpack_require__) {
  var userAgent = __webpack_require__(57);

  module.exports = /web0s(?!.*chrome)/i.test(userAgent);
  /***/
},
/* 351 */

/***/
function (module, exports, __webpack_require__) {
  var global = __webpack_require__(1);

  module.exports = function (a, b) {
    var console = global.console;

    if (console && console.error) {
      arguments.length == 1 ? console.error(a) : console.error(a, b);
    }
  };
  /***/

},
/* 352 */

/***/
function (module, exports, __webpack_require__) {
  // IEEE754 conversions based on https://github.com/feross/ieee754
  var global = __webpack_require__(1);

  var Array = global.Array;
  var abs = Math.abs;
  var pow = Math.pow;
  var floor = Math.floor;
  var log = Math.log;
  var LN2 = Math.LN2;

  var pack = function pack(number, mantissaLength, bytes) {
    var buffer = Array(bytes);
    var exponentLength = bytes * 8 - mantissaLength - 1;
    var eMax = (1 << exponentLength) - 1;
    var eBias = eMax >> 1;
    var rt = mantissaLength === 23 ? pow(2, -24) - pow(2, -77) : 0;
    var sign = number < 0 || number === 0 && 1 / number < 0 ? 1 : 0;
    var index = 0;
    var exponent, mantissa, c;
    number = abs(number); // eslint-disable-next-line no-self-compare -- NaN check

    if (number != number || number === Infinity) {
      // eslint-disable-next-line no-self-compare -- NaN check
      mantissa = number != number ? 1 : 0;
      exponent = eMax;
    } else {
      exponent = floor(log(number) / LN2);
      c = pow(2, -exponent);

      if (number * c < 1) {
        exponent--;
        c *= 2;
      }

      if (exponent + eBias >= 1) {
        number += rt / c;
      } else {
        number += rt * pow(2, 1 - eBias);
      }

      if (number * c >= 2) {
        exponent++;
        c /= 2;
      }

      if (exponent + eBias >= eMax) {
        mantissa = 0;
        exponent = eMax;
      } else if (exponent + eBias >= 1) {
        mantissa = (number * c - 1) * pow(2, mantissaLength);
        exponent = exponent + eBias;
      } else {
        mantissa = number * pow(2, eBias - 1) * pow(2, mantissaLength);
        exponent = 0;
      }
    }

    while (mantissaLength >= 8) {
      buffer[index++] = mantissa & 255;
      mantissa /= 256;
      mantissaLength -= 8;
    }

    exponent = exponent << mantissaLength | mantissa;
    exponentLength += mantissaLength;

    while (exponentLength > 0) {
      buffer[index++] = exponent & 255;
      exponent /= 256;
      exponentLength -= 8;
    }

    buffer[--index] |= sign * 128;
    return buffer;
  };

  var unpack = function unpack(buffer, mantissaLength) {
    var bytes = buffer.length;
    var exponentLength = bytes * 8 - mantissaLength - 1;
    var eMax = (1 << exponentLength) - 1;
    var eBias = eMax >> 1;
    var nBits = exponentLength - 7;
    var index = bytes - 1;
    var sign = buffer[index--];
    var exponent = sign & 127;
    var mantissa;
    sign >>= 7;

    while (nBits > 0) {
      exponent = exponent * 256 + buffer[index--];
      nBits -= 8;
    }

    mantissa = exponent & (1 << -nBits) - 1;
    exponent >>= -nBits;
    nBits += mantissaLength;

    while (nBits > 0) {
      mantissa = mantissa * 256 + buffer[index--];
      nBits -= 8;
    }

    if (exponent === 0) {
      exponent = 1 - eBias;
    } else if (exponent === eMax) {
      return mantissa ? NaN : sign ? -Infinity : Infinity;
    } else {
      mantissa = mantissa + pow(2, mantissaLength);
      exponent = exponent - eBias;
    }

    return (sign ? -1 : 1) * mantissa * pow(2, exponent - mantissaLength);
  };

  module.exports = {
    pack: pack,
    unpack: unpack
  };
  /***/
},
/* 353 */

/***/
function (module, exports, __webpack_require__) {
  var sign = __webpack_require__(155);

  var abs = Math.abs;
  var pow = Math.pow;
  var EPSILON = pow(2, -52);
  var EPSILON32 = pow(2, -23);
  var MAX32 = pow(2, 127) * (2 - EPSILON32);
  var MIN32 = pow(2, -126);

  var roundTiesToEven = function roundTiesToEven(n) {
    return n + 1 / EPSILON - 1 / EPSILON;
  }; // `Math.fround` method implementation
  // https://tc39.es/ecma262/#sec-math.fround
  // eslint-disable-next-line es/no-math-fround -- safe


  module.exports = Math.fround || function fround(x) {
    var $abs = abs(x);
    var $sign = sign(x);
    var a, result;
    if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
    a = (1 + EPSILON32 / EPSILON) * $abs;
    result = a - (a - $abs); // eslint-disable-next-line no-self-compare -- NaN check

    if (result > MAX32 || result != result) return $sign * Infinity;
    return $sign * result;
  };
  /***/

},
/* 354 */

/***/
function (module, exports, __webpack_require__) {
  var global = __webpack_require__(1);

  var globalIsFinite = global.isFinite; // `Number.isFinite` method
  // https://tc39.es/ecma262/#sec-number.isfinite
  // eslint-disable-next-line es/no-number-isfinite -- safe

  module.exports = Number.isFinite || function isFinite(it) {
    return typeof it == 'number' && globalIsFinite(it);
  };
  /***/

},
/* 355 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var TO_STRING_TAG_SUPPORT = __webpack_require__(169);

  var classof = __webpack_require__(63); // `Object.prototype.toString` method implementation
  // https://tc39.es/ecma262/#sec-object.prototype.tostring


  module.exports = TO_STRING_TAG_SUPPORT ? {}.toString : function toString() {
    return '[object ' + classof(this) + ']';
  };
  /***/
},
/* 356 */

/***/
function (module, exports) {
  var Queue = function Queue() {
    this.head = null;
    this.tail = null;
  };

  Queue.prototype = {
    add: function add(item) {
      var entry = {
        item: item,
        next: null
      };
      if (this.head) this.tail.next = entry;else this.head = entry;
      this.tail = entry;
    },
    get: function get() {
      var entry = this.head;

      if (entry) {
        this.head = entry.next;
        if (this.tail === entry) this.tail = null;
        return entry.item;
      }
    }
  };
  module.exports = Queue;
  /***/
},
/* 357 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // based on https://github.com/bestiejs/punycode.js/blob/master/punycode.js

  var global = __webpack_require__(1);

  var uncurryThis = __webpack_require__(3);

  var maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1

  var base = 36;
  var tMin = 1;
  var tMax = 26;
  var skew = 38;
  var damp = 700;
  var initialBias = 72;
  var initialN = 128; // 0x80

  var delimiter = '-'; // '\x2D'

  var regexNonASCII = /[^\0-\u007E]/; // non-ASCII chars

  var regexSeparators = /[.\u3002\uFF0E\uFF61]/g; // RFC 3490 separators

  var OVERFLOW_ERROR = 'Overflow: input needs wider integers to process';
  var baseMinusTMin = base - tMin;
  var RangeError = global.RangeError;
  var exec = uncurryThis(regexSeparators.exec);
  var floor = Math.floor;
  var fromCharCode = String.fromCharCode;
  var charCodeAt = uncurryThis(''.charCodeAt);
  var join = uncurryThis([].join);
  var push = uncurryThis([].push);
  var replace = uncurryThis(''.replace);
  var split = uncurryThis(''.split);
  var toLowerCase = uncurryThis(''.toLowerCase);
  /**
   * Creates an array containing the numeric code points of each Unicode
   * character in the string. While JavaScript uses UCS-2 internally,
   * this function will convert a pair of surrogate halves (each of which
   * UCS-2 exposes as separate characters) into a single code point,
   * matching UTF-16.
   */

  var ucs2decode = function ucs2decode(string) {
    var output = [];
    var counter = 0;
    var length = string.length;

    while (counter < length) {
      var value = charCodeAt(string, counter++);

      if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
        // It's a high surrogate, and there is a next character.
        var extra = charCodeAt(string, counter++);

        if ((extra & 0xFC00) == 0xDC00) {
          // Low surrogate.
          push(output, ((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
        } else {
          // It's an unmatched surrogate; only append this code unit, in case the
          // next code unit is the high surrogate of a surrogate pair.
          push(output, value);
          counter--;
        }
      } else {
        push(output, value);
      }
    }

    return output;
  };
  /**
   * Converts a digit/integer into a basic code point.
   */


  var digitToBasic = function digitToBasic(digit) {
    //  0..25 map to ASCII a..z or A..Z
    // 26..35 map to ASCII 0..9
    return digit + 22 + 75 * (digit < 26);
  };
  /**
   * Bias adaptation function as per section 3.4 of RFC 3492.
   * https://tools.ietf.org/html/rfc3492#section-3.4
   */


  var adapt = function adapt(delta, numPoints, firstTime) {
    var k = 0;
    delta = firstTime ? floor(delta / damp) : delta >> 1;
    delta += floor(delta / numPoints);

    while (delta > baseMinusTMin * tMax >> 1) {
      delta = floor(delta / baseMinusTMin);
      k += base;
    }

    return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
  };
  /**
   * Converts a string of Unicode symbols (e.g. a domain name label) to a
   * Punycode string of ASCII-only symbols.
   */


  var encode = function encode(input) {
    var output = []; // Convert the input in UCS-2 to an array of Unicode code points.

    input = ucs2decode(input); // Cache the length.

    var inputLength = input.length; // Initialize the state.

    var n = initialN;
    var delta = 0;
    var bias = initialBias;
    var i, currentValue; // Handle the basic code points.

    for (i = 0; i < input.length; i++) {
      currentValue = input[i];

      if (currentValue < 0x80) {
        push(output, fromCharCode(currentValue));
      }
    }

    var basicLength = output.length; // number of basic code points.

    var handledCPCount = basicLength; // number of code points that have been handled;
    // Finish the basic string with a delimiter unless it's empty.

    if (basicLength) {
      push(output, delimiter);
    } // Main encoding loop:


    while (handledCPCount < inputLength) {
      // All non-basic code points < n have been handled already. Find the next larger one:
      var m = maxInt;

      for (i = 0; i < input.length; i++) {
        currentValue = input[i];

        if (currentValue >= n && currentValue < m) {
          m = currentValue;
        }
      } // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>, but guard against overflow.


      var handledCPCountPlusOne = handledCPCount + 1;

      if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
        throw RangeError(OVERFLOW_ERROR);
      }

      delta += (m - n) * handledCPCountPlusOne;
      n = m;

      for (i = 0; i < input.length; i++) {
        currentValue = input[i];

        if (currentValue < n && ++delta > maxInt) {
          throw RangeError(OVERFLOW_ERROR);
        }

        if (currentValue == n) {
          // Represent delta as a generalized variable-length integer.
          var q = delta;
          var k = base;

          while (true) {
            var t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
            if (q < t) break;
            var qMinusT = q - t;
            var baseMinusT = base - t;
            push(output, fromCharCode(digitToBasic(t + qMinusT % baseMinusT)));
            q = floor(qMinusT / baseMinusT);
            k += base;
          }

          push(output, fromCharCode(digitToBasic(q)));
          bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
          delta = 0;
          handledCPCount++;
        }
      }

      delta++;
      n++;
    }

    return join(output, '');
  };

  module.exports = function (input) {
    var encoded = [];
    var labels = split(replace(toLowerCase(input), regexSeparators, "."), '.');
    var i, label;

    for (i = 0; i < labels.length; i++) {
      label = labels[i];
      push(encoded, exec(regexNonASCII, label) ? 'xn--' + encode(label) : label);
    }

    return join(encoded, '.');
  };
  /***/

},
/* 358 */

/***/
function (module, exports, __webpack_require__) {
  var global = __webpack_require__(1);

  var toIntegerOrInfinity = __webpack_require__(29);

  var RangeError = global.RangeError;

  module.exports = function (it) {
    var result = toIntegerOrInfinity(it);
    if (result < 0) throw RangeError("The argument can't be less than 0");
    return result;
  };
  /***/

},
/* 359 */

/***/
function (module, exports, __webpack_require__) {
  var IS_NODE = __webpack_require__(69);

  module.exports = function (name) {
    try {
      // eslint-disable-next-line no-new-func -- safe
      if (IS_NODE) return Function('return require("' + name + '")')();
    } catch (error) {
      /* empty */
    }
  };
  /***/

},
/* 360 */

/***/
function (module, exports, __webpack_require__) {
  var arrayFromConstructorAndList = __webpack_require__(343);

  var typedArraySpeciesConstructor = __webpack_require__(130);

  module.exports = function (instance, list) {
    return arrayFromConstructorAndList(typedArraySpeciesConstructor(instance), list);
  };
  /***/

},
/* 361 */

/***/
function (module, exports, __webpack_require__) {
  var $ = __webpack_require__(0);

  var getBuiltIn = __webpack_require__(26);

  var apply = __webpack_require__(40);

  var fails = __webpack_require__(2);

  var wrapErrorConstructorWithCause = __webpack_require__(239);

  var AGGREGATE_ERROR = 'AggregateError';
  var $AggregateError = getBuiltIn(AGGREGATE_ERROR);
  var FORCED = !fails(function () {
    return $AggregateError([1]).errors[0] !== 1;
  }) && fails(function () {
    return $AggregateError([1], AGGREGATE_ERROR, {
      cause: 7
    }).cause !== 7;
  }); // https://github.com/tc39/proposal-error-cause

  $({
    global: true,
    forced: FORCED
  }, {
    AggregateError: wrapErrorConstructorWithCause(AGGREGATE_ERROR, function (init) {
      // eslint-disable-next-line no-unused-vars -- required for functions `.length`
      return function AggregateError(errors, message) {
        return apply(init, this, arguments);
      };
    }, FORCED, true)
  });
  /***/
},
/* 362 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $ = __webpack_require__(0);

  var global = __webpack_require__(1);

  var isPrototypeOf = __webpack_require__(42);

  var getPrototypeOf = __webpack_require__(48);

  var setPrototypeOf = __webpack_require__(52);

  var copyConstructorProperties = __webpack_require__(113);

  var create = __webpack_require__(41);

  var createNonEnumerableProperty = __webpack_require__(35);

  var createPropertyDescriptor = __webpack_require__(47);

  var clearErrorStack = __webpack_require__(111);

  var installErrorCause = __webpack_require__(211);

  var iterate = __webpack_require__(59);

  var normalizeStringArgument = __webpack_require__(96);

  var wellKnownSymbol = __webpack_require__(15);

  var ERROR_STACK_INSTALLABLE = __webpack_require__(152);

  var TO_STRING_TAG = wellKnownSymbol('toStringTag');
  var Error = global.Error;
  var push = [].push;

  var $AggregateError = function AggregateError(errors, message
  /* , options */
  ) {
    var options = arguments.length > 2 ? arguments[2] : undefined;
    var isInstance = isPrototypeOf(AggregateErrorPrototype, this);
    var that;

    if (setPrototypeOf) {
      that = setPrototypeOf(new Error(), isInstance ? getPrototypeOf(this) : AggregateErrorPrototype);
    } else {
      that = isInstance ? this : create(AggregateErrorPrototype);
      createNonEnumerableProperty(that, TO_STRING_TAG, 'Error');
    }

    if (message !== undefined) createNonEnumerableProperty(that, 'message', normalizeStringArgument(message));
    if (ERROR_STACK_INSTALLABLE) createNonEnumerableProperty(that, 'stack', clearErrorStack(that.stack, 1));
    installErrorCause(that, options);
    var errorsArray = [];
    iterate(errors, push, {
      that: errorsArray
    });
    createNonEnumerableProperty(that, 'errors', errorsArray);
    return that;
  };

  if (setPrototypeOf) setPrototypeOf($AggregateError, Error);else copyConstructorProperties($AggregateError, Error, {
    name: true
  });
  var AggregateErrorPrototype = $AggregateError.prototype = create(Error.prototype, {
    constructor: createPropertyDescriptor(1, $AggregateError),
    message: createPropertyDescriptor(1, ''),
    name: createPropertyDescriptor(1, 'AggregateError')
  }); // `AggregateError` constructor
  // https://tc39.es/ecma262/#sec-aggregate-error-constructor

  $({
    global: true
  }, {
    AggregateError: $AggregateError
  });
  /***/
},
/* 363 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $ = __webpack_require__(0);

  var global = __webpack_require__(1);

  var arrayBufferModule = __webpack_require__(108);

  var setSpecies = __webpack_require__(79);

  var ARRAY_BUFFER = 'ArrayBuffer';
  var ArrayBuffer = arrayBufferModule[ARRAY_BUFFER];
  var NativeArrayBuffer = global[ARRAY_BUFFER]; // `ArrayBuffer` constructor
  // https://tc39.es/ecma262/#sec-arraybuffer-constructor

  $({
    global: true,
    forced: NativeArrayBuffer !== ArrayBuffer
  }, {
    ArrayBuffer: ArrayBuffer
  });
  setSpecies(ARRAY_BUFFER);
  /***/
},
/* 364 */

/***/
function (module, exports, __webpack_require__) {
  var $ = __webpack_require__(0);

  var ArrayBufferViewCore = __webpack_require__(16);

  var NATIVE_ARRAY_BUFFER_VIEWS = ArrayBufferViewCore.NATIVE_ARRAY_BUFFER_VIEWS; // `ArrayBuffer.isView` method
  // https://tc39.es/ecma262/#sec-arraybuffer.isview

  $({
    target: 'ArrayBuffer',
    stat: true,
    forced: !NATIVE_ARRAY_BUFFER_VIEWS
  }, {
    isView: ArrayBufferViewCore.isView
  });
  /***/
},
/* 365 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $ = __webpack_require__(0);

  var uncurryThis = __webpack_require__(3);

  var fails = __webpack_require__(2);

  var ArrayBufferModule = __webpack_require__(108);

  var anObject = __webpack_require__(10);

  var toAbsoluteIndex = __webpack_require__(60);

  var toLength = __webpack_require__(44);

  var speciesConstructor = __webpack_require__(80);

  var ArrayBuffer = ArrayBufferModule.ArrayBuffer;
  var DataView = ArrayBufferModule.DataView;
  var DataViewPrototype = DataView.prototype;
  var un$ArrayBufferSlice = uncurryThis(ArrayBuffer.prototype.slice);
  var getUint8 = uncurryThis(DataViewPrototype.getUint8);
  var setUint8 = uncurryThis(DataViewPrototype.setUint8);
  var INCORRECT_SLICE = fails(function () {
    return !new ArrayBuffer(2).slice(1, undefined).byteLength;
  }); // `ArrayBuffer.prototype.slice` method
  // https://tc39.es/ecma262/#sec-arraybuffer.prototype.slice

  $({
    target: 'ArrayBuffer',
    proto: true,
    unsafe: true,
    forced: INCORRECT_SLICE
  }, {
    slice: function slice(start, end) {
      if (un$ArrayBufferSlice && end === undefined) {
        return un$ArrayBufferSlice(anObject(this), start); // FF fix
      }

      var length = anObject(this).byteLength;
      var first = toAbsoluteIndex(start, length);
      var fin = toAbsoluteIndex(end === undefined ? length : end, length);
      var result = new (speciesConstructor(this, ArrayBuffer))(toLength(fin - first));
      var viewSource = new DataView(this);
      var viewTarget = new DataView(result);
      var index = 0;

      while (first < fin) {
        setUint8(viewTarget, index++, getUint8(viewSource, first++));
      }

      return result;
    }
  });
  /***/
},
/* 366 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $ = __webpack_require__(0);

  var toObject = __webpack_require__(22);

  var lengthOfArrayLike = __webpack_require__(23);

  var toIntegerOrInfinity = __webpack_require__(29);

  var addToUnscopables = __webpack_require__(54); // `Array.prototype.at` method
  // https://github.com/tc39/proposal-relative-indexing-method


  $({
    target: 'Array',
    proto: true
  }, {
    at: function at(index) {
      var O = toObject(this);
      var len = lengthOfArrayLike(O);
      var relativeIndex = toIntegerOrInfinity(index);
      var k = relativeIndex >= 0 ? relativeIndex : len + relativeIndex;
      return k < 0 || k >= len ? undefined : O[k];
    }
  });
  addToUnscopables('at');
  /***/
},
/* 367 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $ = __webpack_require__(0);

  var global = __webpack_require__(1);

  var fails = __webpack_require__(2);

  var isArray = __webpack_require__(71);

  var isObject = __webpack_require__(13);

  var toObject = __webpack_require__(22);

  var lengthOfArrayLike = __webpack_require__(23);

  var createProperty = __webpack_require__(56);

  var arraySpeciesCreate = __webpack_require__(87);

  var arrayMethodHasSpeciesSupport = __webpack_require__(85);

  var wellKnownSymbol = __webpack_require__(15);

  var V8_VERSION = __webpack_require__(64);

  var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');
  var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
  var MAXIMUM_ALLOWED_INDEX_EXCEEDED = 'Maximum allowed index exceeded';
  var TypeError = global.TypeError; // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/679

  var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails(function () {
    var array = [];
    array[IS_CONCAT_SPREADABLE] = false;
    return array.concat()[0] !== array;
  });
  var SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('concat');

  var isConcatSpreadable = function isConcatSpreadable(O) {
    if (!isObject(O)) return false;
    var spreadable = O[IS_CONCAT_SPREADABLE];
    return spreadable !== undefined ? !!spreadable : isArray(O);
  };

  var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT; // `Array.prototype.concat` method
  // https://tc39.es/ecma262/#sec-array.prototype.concat
  // with adding support of @@isConcatSpreadable and @@species

  $({
    target: 'Array',
    proto: true,
    forced: FORCED
  }, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    concat: function concat(arg) {
      var O = toObject(this);
      var A = arraySpeciesCreate(O, 0);
      var n = 0;
      var i, k, length, len, E;

      for (i = -1, length = arguments.length; i < length; i++) {
        E = i === -1 ? O : arguments[i];

        if (isConcatSpreadable(E)) {
          len = lengthOfArrayLike(E);
          if (n + len > MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);

          for (k = 0; k < len; k++, n++) {
            if (k in E) createProperty(A, n, E[k]);
          }
        } else {
          if (n >= MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
          createProperty(A, n++, E);
        }
      }

      A.length = n;
      return A;
    }
  });
  /***/
},
/* 368 */

/***/
function (module, exports, __webpack_require__) {
  var $ = __webpack_require__(0);

  var copyWithin = __webpack_require__(193);

  var addToUnscopables = __webpack_require__(54); // `Array.prototype.copyWithin` method
  // https://tc39.es/ecma262/#sec-array.prototype.copywithin


  $({
    target: 'Array',
    proto: true
  }, {
    copyWithin: copyWithin
  }); // https://tc39.es/ecma262/#sec-array.prototype-@@unscopables

  addToUnscopables('copyWithin');
  /***/
},
/* 369 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $ = __webpack_require__(0);

  var $every = __webpack_require__(30).every;

  var arrayMethodIsStrict = __webpack_require__(55);

  var STRICT_METHOD = arrayMethodIsStrict('every'); // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every

  $({
    target: 'Array',
    proto: true,
    forced: !STRICT_METHOD
  }, {
    every: function every(callbackfn
    /* , thisArg */
    ) {
      return $every(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
  });
  /***/
},
/* 370 */

/***/
function (module, exports, __webpack_require__) {
  var $ = __webpack_require__(0);

  var fill = __webpack_require__(144);

  var addToUnscopables = __webpack_require__(54); // `Array.prototype.fill` method
  // https://tc39.es/ecma262/#sec-array.prototype.fill


  $({
    target: 'Array',
    proto: true
  }, {
    fill: fill
  }); // https://tc39.es/ecma262/#sec-array.prototype-@@unscopables

  addToUnscopables('fill');
  /***/
},
/* 371 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $ = __webpack_require__(0);

  var $filter = __webpack_require__(30).filter;

  var arrayMethodHasSpeciesSupport = __webpack_require__(85);

  var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('filter'); // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  // with adding support of @@species

  $({
    target: 'Array',
    proto: true,
    forced: !HAS_SPECIES_SUPPORT
  }, {
    filter: function filter(callbackfn
    /* , thisArg */
    ) {
      return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
  });
  /***/
},
/* 372 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $ = __webpack_require__(0);

  var $findIndex = __webpack_require__(30).findIndex;

  var addToUnscopables = __webpack_require__(54);

  var FIND_INDEX = 'findIndex';
  var SKIPS_HOLES = true; // Shouldn't skip holes

  if (FIND_INDEX in []) Array(1)[FIND_INDEX](function () {
    SKIPS_HOLES = false;
  }); // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findindex

  $({
    target: 'Array',
    proto: true,
    forced: SKIPS_HOLES
  }, {
    findIndex: function findIndex(callbackfn
    /* , that = undefined */
    ) {
      return $findIndex(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
  }); // https://tc39.es/ecma262/#sec-array.prototype-@@unscopables

  addToUnscopables(FIND_INDEX);
  /***/
},
/* 373 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $ = __webpack_require__(0);

  var $find = __webpack_require__(30).find;

  var addToUnscopables = __webpack_require__(54);

  var FIND = 'find';
  var SKIPS_HOLES = true; // Shouldn't skip holes

  if (FIND in []) Array(1)[FIND](function () {
    SKIPS_HOLES = false;
  }); // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find

  $({
    target: 'Array',
    proto: true,
    forced: SKIPS_HOLES
  }, {
    find: function find(callbackfn
    /* , that = undefined */
    ) {
      return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
  }); // https://tc39.es/ecma262/#sec-array.prototype-@@unscopables

  addToUnscopables(FIND);
  /***/
},
/* 374 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $ = __webpack_require__(0);

  var flattenIntoArray = __webpack_require__(206);

  var aCallable = __webpack_require__(34);

  var toObject = __webpack_require__(22);

  var lengthOfArrayLike = __webpack_require__(23);

  var arraySpeciesCreate = __webpack_require__(87); // `Array.prototype.flatMap` method
  // https://tc39.es/ecma262/#sec-array.prototype.flatmap


  $({
    target: 'Array',
    proto: true
  }, {
    flatMap: function flatMap(callbackfn
    /* , thisArg */
    ) {
      var O = toObject(this);
      var sourceLen = lengthOfArrayLike(O);
      var A;
      aCallable(callbackfn);
      A = arraySpeciesCreate(O, 0);
      A.length = flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
      return A;
    }
  });
  /***/
},
/* 375 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $ = __webpack_require__(0);

  var flattenIntoArray = __webpack_require__(206);

  var toObject = __webpack_require__(22);

  var lengthOfArrayLike = __webpack_require__(23);

  var toIntegerOrInfinity = __webpack_require__(29);

  var arraySpeciesCreate = __webpack_require__(87); // `Array.prototype.flat` method
  // https://tc39.es/ecma262/#sec-array.prototype.flat


  $({
    target: 'Array',
    proto: true
  }, {
    flat: function
      /* depthArg = 1 */
    flat() {
      var depthArg = arguments.length ? arguments[0] : undefined;
      var O = toObject(this);
      var sourceLen = lengthOfArrayLike(O);
      var A = arraySpeciesCreate(O, 0);
      A.length = flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toIntegerOrInfinity(depthArg));
      return A;
    }
  });
  /***/
},
/* 376 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $ = __webpack_require__(0);

  var forEach = __webpack_require__(194); // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  // eslint-disable-next-line es/no-array-prototype-foreach -- safe


  $({
    target: 'Array',
    proto: true,
    forced: [].forEach != forEach
  }, {
    forEach: forEach
  });
  /***/
},
/* 377 */

/***/
function (module, exports, __webpack_require__) {
  var $ = __webpack_require__(0);

  var from = __webpack_require__(195);

  var checkCorrectnessOfIteration = __webpack_require__(110);

  var INCORRECT_ITERATION = !checkCorrectnessOfIteration(function (iterable) {
    // eslint-disable-next-line es/no-array-from -- required for testing
    Array.from(iterable);
  }); // `Array.from` method
  // https://tc39.es/ecma262/#sec-array.from

  $({
    target: 'Array',
    stat: true,
    forced: INCORRECT_ITERATION
  }, {
    from: from
  });
  /***/
},
/* 378 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $ = __webpack_require__(0);

  var $includes = __webpack_require__(84).includes;

  var addToUnscopables = __webpack_require__(54); // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes


  $({
    target: 'Array',
    proto: true
  }, {
    includes: function includes(el
    /* , fromIndex = 0 */
    ) {
      return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
    }
  }); // https://tc39.es/ecma262/#sec-array.prototype-@@unscopables

  addToUnscopables('includes');
  /***/
},
/* 379 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* eslint-disable es/no-array-prototype-indexof -- required for testing */

  var $ = __webpack_require__(0);

  var uncurryThis = __webpack_require__(3);

  var $IndexOf = __webpack_require__(84).indexOf;

  var arrayMethodIsStrict = __webpack_require__(55);

  var un$IndexOf = uncurryThis([].indexOf);
  var NEGATIVE_ZERO = !!un$IndexOf && 1 / un$IndexOf([1], 1, -0) < 0;
  var STRICT_METHOD = arrayMethodIsStrict('indexOf'); // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof

  $({
    target: 'Array',
    proto: true,
    forced: NEGATIVE_ZERO || !STRICT_METHOD
  }, {
    indexOf: function indexOf(searchElement
    /* , fromIndex = 0 */
    ) {
      var fromIndex = arguments.length > 1 ? arguments[1] : undefined;
      return NEGATIVE_ZERO // convert -0 to +0
      ? un$IndexOf(this, searchElement, fromIndex) || 0 : $IndexOf(this, searchElement, fromIndex);
    }
  });
  /***/
},
/* 380 */

/***/
function (module, exports, __webpack_require__) {
  var $ = __webpack_require__(0);

  var isArray = __webpack_require__(71); // `Array.isArray` method
  // https://tc39.es/ecma262/#sec-array.isarray


  $({
    target: 'Array',
    stat: true
  }, {
    isArray: isArray
  });
  /***/
},
/* 381 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $ = __webpack_require__(0);

  var uncurryThis = __webpack_require__(3);

  var IndexedObject = __webpack_require__(92);

  var toIndexedObject = __webpack_require__(37);

  var arrayMethodIsStrict = __webpack_require__(55);

  var un$Join = uncurryThis([].join);
  var ES3_STRINGS = IndexedObject != Object;
  var STRICT_METHOD = arrayMethodIsStrict('join', ','); // `Array.prototype.join` method
  // https://tc39.es/ecma262/#sec-array.prototype.join

  $({
    target: 'Array',
    proto: true,
    forced: ES3_STRINGS || !STRICT_METHOD
  }, {
    join: function join(separator) {
      return un$Join(toIndexedObject(this), separator === undefined ? ',' : separator);
    }
  });
  /***/
},
/* 382 */

/***/
function (module, exports, __webpack_require__) {
  var $ = __webpack_require__(0);

  var lastIndexOf = __webpack_require__(196); // `Array.prototype.lastIndexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.lastindexof
  // eslint-disable-next-line es/no-array-prototype-lastindexof -- required for testing


  $({
    target: 'Array',
    proto: true,
    forced: lastIndexOf !== [].lastIndexOf
  }, {
    lastIndexOf: lastIndexOf
  });
  /***/
},
/* 383 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $ = __webpack_require__(0);

  var $map = __webpack_require__(30).map;

  var arrayMethodHasSpeciesSupport = __webpack_require__(85);

  var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('map'); // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  // with adding support of @@species

  $({
    target: 'Array',
    proto: true,
    forced: !HAS_SPECIES_SUPPORT
  }, {
    map: function map(callbackfn
    /* , thisArg */
    ) {
      return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
  });
  /***/
},
/* 384 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $ = __webpack_require__(0);

  var global = __webpack_require__(1);

  var fails = __webpack_require__(2);

  var isConstructor = __webpack_require__(76);

  var createProperty = __webpack_require__(56);

  var Array = global.Array;
  var ISNT_GENERIC = fails(function () {
    function F() {
      /* empty */
    }

    return !(Array.of.call(F) instanceof F);
  }); // `Array.of` method
  // https://tc39.es/ecma262/#sec-array.of
  // WebKit Array.of isn't generic

  $({
    target: 'Array',
    stat: true,
    forced: ISNT_GENERIC
  }, {
    of: function
      /* ...args */
    of() {
      var index = 0;
      var argumentsLength = arguments.length;
      var result = new (isConstructor(this) ? this : Array)(argumentsLength);

      while (argumentsLength > index) {
        createProperty(result, index, arguments[index++]);
      }

      result.length = argumentsLength;
      return result;
    }
  });
  /***/
},
/* 385 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $ = __webpack_require__(0);

  var $reduceRight = __webpack_require__(109).right;

  var arrayMethodIsStrict = __webpack_require__(55);

  var CHROME_VERSION = __webpack_require__(64);

  var IS_NODE = __webpack_require__(69);

  var STRICT_METHOD = arrayMethodIsStrict('reduceRight'); // Chrome 80-82 has a critical bug
  // https://bugs.chromium.org/p/chromium/issues/detail?id=1049982

  var CHROME_BUG = !IS_NODE && CHROME_VERSION > 79 && CHROME_VERSION < 83; // `Array.prototype.reduceRight` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduceright

  $({
    target: 'Array',
    proto: true,
    forced: !STRICT_METHOD || CHROME_BUG
  }, {
    reduceRight: function reduceRight(callbackfn
    /* , initialValue */
    ) {
      return $reduceRight(this, callbackfn, arguments.length, arguments.length > 1 ? arguments[1] : undefined);
    }
  });
  /***/
},
/* 386 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $ = __webpack_require__(0);

  var $reduce = __webpack_require__(109).left;

  var arrayMethodIsStrict = __webpack_require__(55);

  var CHROME_VERSION = __webpack_require__(64);

  var IS_NODE = __webpack_require__(69);

  var STRICT_METHOD = arrayMethodIsStrict('reduce'); // Chrome 80-82 has a critical bug
  // https://bugs.chromium.org/p/chromium/issues/detail?id=1049982

  var CHROME_BUG = !IS_NODE && CHROME_VERSION > 79 && CHROME_VERSION < 83; // `Array.prototype.reduce` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduce

  $({
    target: 'Array',
    proto: true,
    forced: !STRICT_METHOD || CHROME_BUG
  }, {
    reduce: function reduce(callbackfn
    /* , initialValue */
    ) {
      var length = arguments.length;
      return $reduce(this, callbackfn, length, length > 1 ? arguments[1] : undefined);
    }
  });
  /***/
},
/* 387 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $ = __webpack_require__(0);

  var uncurryThis = __webpack_require__(3);

  var isArray = __webpack_require__(71);

  var un$Reverse = uncurryThis([].reverse);
  var test = [1, 2]; // `Array.prototype.reverse` method
  // https://tc39.es/ecma262/#sec-array.prototype.reverse
  // fix for Safari 12.0 bug
  // https://bugs.webkit.org/show_bug.cgi?id=188794

  $({
    target: 'Array',
    proto: true,
    forced: String(test) === String(test.reverse())
  }, {
    reverse: function reverse() {
      // eslint-disable-next-line no-self-assign -- dirty hack
      if (isArray(this)) this.length = this.length;
      return un$Reverse(this);
    }
  });
  /***/
},
/* 388 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $ = __webpack_require__(0);

  var global = __webpack_require__(1);

  var isArray = __webpack_require__(71);

  var isConstructor = __webpack_require__(76);

  var isObject = __webpack_require__(13);

  var toAbsoluteIndex = __webpack_require__(60);

  var lengthOfArrayLike = __webpack_require__(23);

  var toIndexedObject = __webpack_require__(37);

  var createProperty = __webpack_require__(56);

  var wellKnownSymbol = __webpack_require__(15);

  var arrayMethodHasSpeciesSupport = __webpack_require__(85);

  var un$Slice = __webpack_require__(68);

  var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('slice');
  var SPECIES = wellKnownSymbol('species');
  var Array = global.Array;
  var max = Math.max; // `Array.prototype.slice` method
  // https://tc39.es/ecma262/#sec-array.prototype.slice
  // fallback for not array-like ES3 strings and DOM objects

  $({
    target: 'Array',
    proto: true,
    forced: !HAS_SPECIES_SUPPORT
  }, {
    slice: function slice(start, end) {
      var O = toIndexedObject(this);
      var length = lengthOfArrayLike(O);
      var k = toAbsoluteIndex(start, length);
      var fin = toAbsoluteIndex(end === undefined ? length : end, length); // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible

      var Constructor, result, n;

      if (isArray(O)) {
        Constructor = O.constructor; // cross-realm fallback

        if (isConstructor(Constructor) && (Constructor === Array || isArray(Constructor.prototype))) {
          Constructor = undefined;
        } else if (isObject(Constructor)) {
          Constructor = Constructor[SPECIES];
          if (Constructor === null) Constructor = undefined;
        }

        if (Constructor === Array || Constructor === undefined) {
          return un$Slice(O, k, fin);
        }
      }

      result = new (Constructor === undefined ? Array : Constructor)(max(fin - k, 0));

      for (n = 0; k < fin; k++, n++) {
        if (k in O) createProperty(result, n, O[k]);
      }

      result.length = n;
      return result;
    }
  });
  /***/
},
/* 389 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $ = __webpack_require__(0);

  var $some = __webpack_require__(30).some;

  var arrayMethodIsStrict = __webpack_require__(55);

  var STRICT_METHOD = arrayMethodIsStrict('some'); // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some

  $({
    target: 'Array',
    proto: true,
    forced: !STRICT_METHOD
  }, {
    some: function some(callbackfn
    /* , thisArg */
    ) {
      return $some(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
  });
  /***/
},
/* 390 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $ = __webpack_require__(0);

  var uncurryThis = __webpack_require__(3);

  var aCallable = __webpack_require__(34);

  var toObject = __webpack_require__(22);

  var lengthOfArrayLike = __webpack_require__(23);

  var toString = __webpack_require__(18);

  var fails = __webpack_require__(2);

  var internalSort = __webpack_require__(145);

  var arrayMethodIsStrict = __webpack_require__(55);

  var FF = __webpack_require__(202);

  var IE_OR_EDGE = __webpack_require__(203);

  var V8 = __webpack_require__(64);

  var WEBKIT = __webpack_require__(150);

  var test = [];
  var un$Sort = uncurryThis(test.sort);
  var push = uncurryThis(test.push); // IE8-

  var FAILS_ON_UNDEFINED = fails(function () {
    test.sort(undefined);
  }); // V8 bug

  var FAILS_ON_NULL = fails(function () {
    test.sort(null);
  }); // Old WebKit

  var STRICT_METHOD = arrayMethodIsStrict('sort');
  var STABLE_SORT = !fails(function () {
    // feature detection can be too slow, so check engines versions
    if (V8) return V8 < 70;
    if (FF && FF > 3) return;
    if (IE_OR_EDGE) return true;
    if (WEBKIT) return WEBKIT < 603;
    var result = '';
    var code, chr, value, index; // generate an array with more 512 elements (Chakra and old V8 fails only in this case)

    for (code = 65; code < 76; code++) {
      chr = String.fromCharCode(code);

      switch (code) {
        case 66:
        case 69:
        case 70:
        case 72:
          value = 3;
          break;

        case 68:
        case 71:
          value = 4;
          break;

        default:
          value = 2;
      }

      for (index = 0; index < 47; index++) {
        test.push({
          k: chr + index,
          v: value
        });
      }
    }

    test.sort(function (a, b) {
      return b.v - a.v;
    });

    for (index = 0; index < test.length; index++) {
      chr = test[index].k.charAt(0);
      if (result.charAt(result.length - 1) !== chr) result += chr;
    }

    return result !== 'DGBEFHACIJK';
  });
  var FORCED = FAILS_ON_UNDEFINED || !FAILS_ON_NULL || !STRICT_METHOD || !STABLE_SORT;

  var getSortCompare = function getSortCompare(comparefn) {
    return function (x, y) {
      if (y === undefined) return -1;
      if (x === undefined) return 1;
      if (comparefn !== undefined) return +comparefn(x, y) || 0;
      return toString(x) > toString(y) ? 1 : -1;
    };
  }; // `Array.prototype.sort` method
  // https://tc39.es/ecma262/#sec-array.prototype.sort


  $({
    target: 'Array',
    proto: true,
    forced: FORCED
  }, {
    sort: function sort(comparefn) {
      if (comparefn !== undefined) aCallable(comparefn);
      var array = toObject(this);
      if (STABLE_SORT) return comparefn === undefined ? un$Sort(array) : un$Sort(array, comparefn);
      var items = [];
      var arrayLength = lengthOfArrayLike(array);
      var itemsLength, index;

      for (index = 0; index < arrayLength; index++) {
        if (index in array) push(items, array[index]);
      }

      internalSort(items, getSortCompare(comparefn));
      itemsLength = items.length;
      index = 0;

      while (index < itemsLength) {
        array[index] = items[index++];
      }

      while (index < arrayLength) {
        delete array[index++];
      }

      return array;
    }
  });
  /***/
},
/* 391 */

/***/
function (module, exports, __webpack_require__) {
  var setSpecies = __webpack_require__(79); // `Array[@@species]` getter
  // https://tc39.es/ecma262/#sec-get-array-@@species


  setSpecies('Array');
  /***/
},
/* 392 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $ = __webpack_require__(0);

  var global = __webpack_require__(1);

  var toAbsoluteIndex = __webpack_require__(60);

  var toIntegerOrInfinity = __webpack_require__(29);

  var lengthOfArrayLike = __webpack_require__(23);

  var toObject = __webpack_require__(22);

  var arraySpeciesCreate = __webpack_require__(87);

  var createProperty = __webpack_require__(56);

  var arrayMethodHasSpeciesSupport = __webpack_require__(85);

  var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('splice');
  var TypeError = global.TypeError;
  var max = Math.max;
  var min = Math.min;
  var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
  var MAXIMUM_ALLOWED_LENGTH_EXCEEDED = 'Maximum allowed length exceeded'; // `Array.prototype.splice` method
  // https://tc39.es/ecma262/#sec-array.prototype.splice
  // with adding support of @@species

  $({
    target: 'Array',
    proto: true,
    forced: !HAS_SPECIES_SUPPORT
  }, {
    splice: function splice(start, deleteCount
    /* , ...items */
    ) {
      var O = toObject(this);
      var len = lengthOfArrayLike(O);
      var actualStart = toAbsoluteIndex(start, len);
      var argumentsLength = arguments.length;
      var insertCount, actualDeleteCount, A, k, from, to;

      if (argumentsLength === 0) {
        insertCount = actualDeleteCount = 0;
      } else if (argumentsLength === 1) {
        insertCount = 0;
        actualDeleteCount = len - actualStart;
      } else {
        insertCount = argumentsLength - 2;
        actualDeleteCount = min(max(toIntegerOrInfinity(deleteCount), 0), len - actualStart);
      }

      if (len + insertCount - actualDeleteCount > MAX_SAFE_INTEGER) {
        throw TypeError(MAXIMUM_ALLOWED_LENGTH_EXCEEDED);
      }

      A = arraySpeciesCreate(O, actualDeleteCount);

      for (k = 0; k < actualDeleteCount; k++) {
        from = actualStart + k;
        if (from in O) createProperty(A, k, O[from]);
      }

      A.length = actualDeleteCount;

      if (insertCount < actualDeleteCount) {
        for (k = actualStart; k < len - actualDeleteCount; k++) {
          from = k + actualDeleteCount;
          to = k + insertCount;
          if (from in O) O[to] = O[from];else delete O[to];
        }

        for (k = len; k > len - actualDeleteCount + insertCount; k--) {
          delete O[k - 1];
        }
      } else if (insertCount > actualDeleteCount) {
        for (k = len - actualDeleteCount; k > actualStart; k--) {
          from = k + actualDeleteCount - 1;
          to = k + insertCount - 1;
          if (from in O) O[to] = O[from];else delete O[to];
        }
      }

      for (k = 0; k < insertCount; k++) {
        O[k + actualStart] = arguments[k + 2];
      }

      O.length = len - actualDeleteCount + insertCount;
      return A;
    }
  });
  /***/
},
/* 393 */

/***/
function (module, exports, __webpack_require__) {
  // this method was added to unscopables after implementation
  // in popular engines, so it's moved to a separate module
  var addToUnscopables = __webpack_require__(54); // https://tc39.es/ecma262/#sec-array.prototype-@@unscopables


  addToUnscopables('flatMap');
  /***/
},
/* 394 */

/***/
function (module, exports, __webpack_require__) {
  // this method was added to unscopables after implementation
  // in popular engines, so it's moved to a separate module
  var addToUnscopables = __webpack_require__(54); // https://tc39.es/ecma262/#sec-array.prototype-@@unscopables


  addToUnscopables('flat');
  /***/
},
/* 395 */

/***/
function (module, exports, __webpack_require__) {
  var $ = __webpack_require__(0);

  var ArrayBufferModule = __webpack_require__(108);

  var NATIVE_ARRAY_BUFFER = __webpack_require__(142); // `DataView` constructor
  // https://tc39.es/ecma262/#sec-dataview-constructor


  $({
    global: true,
    forced: !NATIVE_ARRAY_BUFFER
  }, {
    DataView: ArrayBufferModule.DataView
  });
  /***/
},
/* 396 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $ = __webpack_require__(0);

  var uncurryThis = __webpack_require__(3);

  var fails = __webpack_require__(2);

  var FORCED = fails(function () {
    return new Date(16e11).getYear() !== 120;
  });
  var getFullYear = uncurryThis(Date.prototype.getFullYear); // `Date.prototype.getYear` method
  // https://tc39.es/ecma262/#sec-date.prototype.getyear

  $({
    target: 'Date',
    proto: true,
    forced: FORCED
  }, {
    getYear: function getYear() {
      return getFullYear(this) - 1900;
    }
  });
  /***/
},
/* 397 */

/***/
function (module, exports, __webpack_require__) {
  var $ = __webpack_require__(0);

  var global = __webpack_require__(1);

  var uncurryThis = __webpack_require__(3);

  var Date = global.Date;
  var getTime = uncurryThis(Date.prototype.getTime); // `Date.now` method
  // https://tc39.es/ecma262/#sec-date.now

  $({
    target: 'Date',
    stat: true
  }, {
    now: function now() {
      return getTime(new Date());
    }
  });
  /***/
},
/* 398 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $ = __webpack_require__(0);

  var uncurryThis = __webpack_require__(3);

  var toIntegerOrInfinity = __webpack_require__(29);

  var DatePrototype = Date.prototype;
  var getTime = uncurryThis(DatePrototype.getTime);
  var setFullYear = uncurryThis(DatePrototype.setFullYear); // `Date.prototype.setYear` method
  // https://tc39.es/ecma262/#sec-date.prototype.setyear

  $({
    target: 'Date',
    proto: true
  }, {
    setYear: function setYear(year) {
      // validate
      getTime(this);
      var yi = toIntegerOrInfinity(year);
      var yyyy = 0 <= yi && yi <= 99 ? yi + 1900 : yi;
      return setFullYear(this, yyyy);
    }
  });
  /***/
},
/* 399 */

/***/
function (module, exports, __webpack_require__) {
  var $ = __webpack_require__(0); // `Date.prototype.toGMTString` method
  // https://tc39.es/ecma262/#sec-date.prototype.togmtstring


  $({
    target: 'Date',
    proto: true
  }, {
    toGMTString: Date.prototype.toUTCString
  });
  /***/
},
/* 400 */

/***/
function (module, exports, __webpack_require__) {
  var $ = __webpack_require__(0);

  var toISOString = __webpack_require__(346); // `Date.prototype.toISOString` method
  // https://tc39.es/ecma262/#sec-date.prototype.toisostring
  // PhantomJS / old WebKit has a broken implementations


  $({
    target: 'Date',
    proto: true,
    forced: Date.prototype.toISOString !== toISOString
  }, {
    toISOString: toISOString
  });
  /***/
},
/* 401 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $ = __webpack_require__(0);

  var fails = __webpack_require__(2);

  var toObject = __webpack_require__(22);

  var toPrimitive = __webpack_require__(168);

  var FORCED = fails(function () {
    return new Date(NaN).toJSON() !== null || Date.prototype.toJSON.call({
      toISOString: function toISOString() {
        return 1;
      }
    }) !== 1;
  }); // `Date.prototype.toJSON` method
  // https://tc39.es/ecma262/#sec-date.prototype.tojson

  $({
    target: 'Date',
    proto: true,
    forced: FORCED
  }, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    toJSON: function toJSON(key) {
      var O = toObject(this);
      var pv = toPrimitive(O, 'number');
      return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
    }
  });
  /***/
},
/* 402 */

/***/
function (module, exports, __webpack_require__) {
  var hasOwn = __webpack_require__(21);

  var redefine = __webpack_require__(24);

  var dateToPrimitive = __webpack_require__(347);

  var wellKnownSymbol = __webpack_require__(15);

  var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
  var DatePrototype = Date.prototype; // `Date.prototype[@@toPrimitive]` method
  // https://tc39.es/ecma262/#sec-date.prototype-@@toprimitive

  if (!hasOwn(DatePrototype, TO_PRIMITIVE)) {
    redefine(DatePrototype, TO_PRIMITIVE, dateToPrimitive);
  }
  /***/

},
/* 403 */

/***/
function (module, exports, __webpack_require__) {
  var uncurryThis = __webpack_require__(3);

  var redefine = __webpack_require__(24);

  var DatePrototype = Date.prototype;
  var INVALID_DATE = 'Invalid Date';
  var TO_STRING = 'toString';
  var un$DateToString = uncurryThis(DatePrototype[TO_STRING]);
  var getTime = uncurryThis(DatePrototype.getTime); // `Date.prototype.toString` method
  // https://tc39.es/ecma262/#sec-date.prototype.tostring

  if (String(new Date(NaN)) != INVALID_DATE) {
    redefine(DatePrototype, TO_STRING, function toString() {
      var value = getTime(this); // eslint-disable-next-line no-self-compare -- NaN check

      return value === value ? un$DateToString(this) : INVALID_DATE;
    });
  }
  /***/

},
/* 404 */

/***/
function (module, exports, __webpack_require__) {
  /* eslint-disable no-unused-vars -- required for functions `.length` */
  var $ = __webpack_require__(0);

  var global = __webpack_require__(1);

  var apply = __webpack_require__(40);

  var wrapErrorConstructorWithCause = __webpack_require__(239);

  var WEB_ASSEMBLY = 'WebAssembly';
  var WebAssembly = global[WEB_ASSEMBLY];
  var FORCED = Error('e', {
    cause: 7
  }).cause !== 7;

  var exportGlobalErrorCauseWrapper = function exportGlobalErrorCauseWrapper(ERROR_NAME, wrapper) {
    var O = {};
    O[ERROR_NAME] = wrapErrorConstructorWithCause(ERROR_NAME, wrapper, FORCED);
    $({
      global: true,
      forced: FORCED
    }, O);
  };

  var exportWebAssemblyErrorCauseWrapper = function exportWebAssemblyErrorCauseWrapper(ERROR_NAME, wrapper) {
    if (WebAssembly && WebAssembly[ERROR_NAME]) {
      var O = {};
      O[ERROR_NAME] = wrapErrorConstructorWithCause(WEB_ASSEMBLY + '.' + ERROR_NAME, wrapper, FORCED);
      $({
        target: WEB_ASSEMBLY,
        stat: true,
        forced: FORCED
      }, O);
    }
  }; // https://github.com/tc39/proposal-error-cause


  exportGlobalErrorCauseWrapper('Error', function (init) {
    return function Error(message) {
      return apply(init, this, arguments);
    };
  });
  exportGlobalErrorCauseWrapper('EvalError', function (init) {
    return function EvalError(message) {
      return apply(init, this, arguments);
    };
  });
  exportGlobalErrorCauseWrapper('RangeError', function (init) {
    return function RangeError(message) {
      return apply(init, this, arguments);
    };
  });
  exportGlobalErrorCauseWrapper('ReferenceError', function (init) {
    return function ReferenceError(message) {
      return apply(init, this, arguments);
    };
  });
  exportGlobalErrorCauseWrapper('SyntaxError', function (init) {
    return function SyntaxError(message) {
      return apply(init, this, arguments);
    };
  });
  exportGlobalErrorCauseWrapper('TypeError', function (init) {
    return function TypeError(message) {
      return apply(init, this, arguments);
    };
  });
  exportGlobalErrorCauseWrapper('URIError', function (init) {
    return function URIError(message) {
      return apply(init, this, arguments);
    };
  });
  exportWebAssemblyErrorCauseWrapper('CompileError', function (init) {
    return function CompileError(message) {
      return apply(init, this, arguments);
    };
  });
  exportWebAssemblyErrorCauseWrapper('LinkError', function (init) {
    return function LinkError(message) {
      return apply(init, this, arguments);
    };
  });
  exportWebAssemblyErrorCauseWrapper('RuntimeError', function (init) {
    return function RuntimeError(message) {
      return apply(init, this, arguments);
    };
  });
  /***/
},
/* 405 */

/***/
function (module, exports, __webpack_require__) {
  var redefine = __webpack_require__(24);

  var errorToString = __webpack_require__(205);

  var ErrorPrototype = Error.prototype; // `Error.prototype.toString` method fix
  // https://tc39.es/ecma262/#sec-error.prototype.tostring

  if (ErrorPrototype.toString !== errorToString) {
    redefine(ErrorPrototype, 'toString', errorToString);
  }
  /***/

},
/* 406 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $ = __webpack_require__(0);

  var uncurryThis = __webpack_require__(3);

  var toString = __webpack_require__(18);

  var charAt = uncurryThis(''.charAt);
  var charCodeAt = uncurryThis(''.charCodeAt);
  var exec = uncurryThis(/./.exec);
  var numberToString = uncurryThis(1.0.toString);
  var toUpperCase = uncurryThis(''.toUpperCase);
  var raw = /[\w*+\-./@]/;

  var hex = function hex(code, length) {
    var result = numberToString(code, 16);

    while (result.length < length) {
      result = '0' + result;
    }

    return result;
  }; // `escape` method
  // https://tc39.es/ecma262/#sec-escape-string


  $({
    global: true
  }, {
    escape: function escape(string) {
      var str = toString(string);
      var result = '';
      var length = str.length;
      var index = 0;
      var chr, code;

      while (index < length) {
        chr = charAt(str, index++);

        if (exec(raw, chr)) {
          result += chr;
        } else {
          code = charCodeAt(chr, 0);

          if (code < 256) {
            result += '%' + hex(code, 2);
          } else {
            result += '%u' + toUpperCase(hex(code, 4));
          }
        }
      }

      return result;
    }
  });
  /***/
},
/* 407 */

/***/
function (module, exports, __webpack_require__) {
  var $ = __webpack_require__(0);

  var bind = __webpack_require__(207); // `Function.prototype.bind` method
  // https://tc39.es/ecma262/#sec-function.prototype.bind


  $({
    target: 'Function',
    proto: true,
    forced: Function.bind !== bind
  }, {
    bind: bind
  });
  /***/
},
/* 408 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var isCallable = __webpack_require__(17);

  var isObject = __webpack_require__(13);

  var definePropertyModule = __webpack_require__(20);

  var getPrototypeOf = __webpack_require__(48);

  var wellKnownSymbol = __webpack_require__(15);

  var HAS_INSTANCE = wellKnownSymbol('hasInstance');
  var FunctionPrototype = Function.prototype; // `Function.prototype[@@hasInstance]` method
  // https://tc39.es/ecma262/#sec-function.prototype-@@hasinstance

  if (!(HAS_INSTANCE in FunctionPrototype)) {
    definePropertyModule.f(FunctionPrototype, HAS_INSTANCE, {
      value: function value(O) {
        if (!isCallable(this) || !isObject(O)) return false;
        var P = this.prototype;
        if (!isObject(P)) return O instanceof this; // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:

        while (O = getPrototypeOf(O)) {
          if (P === O) return true;
        }

        return false;
      }
    });
  }
  /***/

},
/* 409 */

/***/
function (module, exports, __webpack_require__) {
  var DESCRIPTORS = __webpack_require__(12);

  var FUNCTION_NAME_EXISTS = __webpack_require__(74).EXISTS;

  var uncurryThis = __webpack_require__(3);

  var defineProperty = __webpack_require__(20).f;

  var FunctionPrototype = Function.prototype;
  var functionToString = uncurryThis(FunctionPrototype.toString);
  var nameRE = /function\b(?:\s|\/\*[\S\s]*?\*\/|\/\/[^\n\r]*[\n\r]+)*([^\s(/]*)/;
  var regExpExec = uncurryThis(nameRE.exec);
  var NAME = 'name'; // Function instances `.name` property
  // https://tc39.es/ecma262/#sec-function-instances-name

  if (DESCRIPTORS && !FUNCTION_NAME_EXISTS) {
    defineProperty(FunctionPrototype, NAME, {
      configurable: true,
      get: function get() {
        try {
          return regExpExec(nameRE, functionToString(this))[1];
        } catch (error) {
          return '';
        }
      }
    });
  }
  /***/

},
/* 410 */

/***/
function (module, exports, __webpack_require__) {
  var $ = __webpack_require__(0);

  var global = __webpack_require__(1); // `globalThis` object
  // https://tc39.es/ecma262/#sec-globalthis


  $({
    global: true
  }, {
    globalThis: global
  });
  /***/
},
/* 411 */

/***/
function (module, exports, __webpack_require__) {
  var $ = __webpack_require__(0);

  var global = __webpack_require__(1);

  var getBuiltIn = __webpack_require__(26);

  var apply = __webpack_require__(40);

  var uncurryThis = __webpack_require__(3);

  var fails = __webpack_require__(2);

  var Array = global.Array;
  var $stringify = getBuiltIn('JSON', 'stringify');
  var exec = uncurryThis(/./.exec);
  var charAt = uncurryThis(''.charAt);
  var charCodeAt = uncurryThis(''.charCodeAt);
  var replace = uncurryThis(''.replace);
  var numberToString = uncurryThis(1.0.toString);
  var tester = /[\uD800-\uDFFF]/g;
  var low = /^[\uD800-\uDBFF]$/;
  var hi = /^[\uDC00-\uDFFF]$/;

  var fix = function fix(match, offset, string) {
    var prev = charAt(string, offset - 1);
    var next = charAt(string, offset + 1);

    if (exec(low, match) && !exec(hi, next) || exec(hi, match) && !exec(low, prev)) {
      return "\\u" + numberToString(charCodeAt(match, 0), 16);
    }

    return match;
  };

  var FORCED = fails(function () {
    return $stringify("\uDF06\uD834") !== "\"\\udf06\\ud834\"" || $stringify("\uDEAD") !== "\"\\udead\"";
  });

  if ($stringify) {
    // `JSON.stringify` method
    // https://tc39.es/ecma262/#sec-json.stringify
    // https://github.com/tc39/proposal-well-formed-stringify
    $({
      target: 'JSON',
      stat: true,
      forced: FORCED
    }, {
      // eslint-disable-next-line no-unused-vars -- required for `.length`
      stringify: function stringify(it, replacer, space) {
        for (var i = 0, l = arguments.length, args = Array(l); i < l; i++) {
          args[i] = arguments[i];
        }

        var result = apply($stringify, null, args);
        return typeof result == 'string' ? replace(result, tester, fix) : result;
      }
    });
  }
  /***/

},
/* 412 */

/***/
function (module, exports, __webpack_require__) {
  var global = __webpack_require__(1);

  var setToStringTag = __webpack_require__(49); // JSON[@@toStringTag] property
  // https://tc39.es/ecma262/#sec-json-@@tostringtag


  setToStringTag(global.JSON, 'JSON', true);
  /***/
},
/* 413 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var collection = __webpack_require__(112);

  var collectionStrong = __webpack_require__(197); // `Map` constructor
  // https://tc39.es/ecma262/#sec-map-objects


  collection('Map', function (init) {
    return function Map() {
      return init(this, arguments.length ? arguments[0] : undefined);
    };
  }, collectionStrong);
  /***/
},
/* 414 */

/***/
function (module, exports, __webpack_require__) {
  var $ = __webpack_require__(0);

  var log1p = __webpack_require__(216); // eslint-disable-next-line es/no-math-acosh -- required for testing


  var $acosh = Math.acosh;
  var log = Math.log;
  var sqrt = Math.sqrt;
  var LN2 = Math.LN2;
  var FORCED = !$acosh // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  || Math.floor($acosh(Number.MAX_VALUE)) != 710 // Tor Browser bug: Math.acosh(Infinity) -> NaN
  || $acosh(Infinity) != Infinity; // `Math.acosh` method
  // https://tc39.es/ecma262/#sec-math.acosh

  $({
    target: 'Math',
    stat: true,
    forced: FORCED
  }, {
    acosh: function acosh(x) {
      return (x = +x) < 1 ? NaN : x > 94906265.62425156 ? log(x) + LN2 : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
    }
  });
  /***/
},
/* 415 */

/***/
function (module, exports, __webpack_require__) {
  var $ = __webpack_require__(0); // eslint-disable-next-line es/no-math-asinh -- required for testing


  var $asinh = Math.asinh;
  var log = Math.log;
  var sqrt = Math.sqrt;

  function asinh(x) {
    return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : log(x + sqrt(x * x + 1));
  } // `Math.asinh` method
  // https://tc39.es/ecma262/#sec-math.asinh
  // Tor Browser bug: Math.asinh(0) -> -0


  $({
    target: 'Math',
    stat: true,
    forced: !($asinh && 1 / $asinh(0) > 0)
  }, {
    asinh: asinh
  });
  /***/
},
/* 416 */

/***/
function (module, exports, __webpack_require__) {
  var $ = __webpack_require__(0); // eslint-disable-next-line es/no-math-atanh -- required for testing


  var $atanh = Math.atanh;
  var log = Math.log; // `Math.atanh` method
  // https://tc39.es/ecma262/#sec-math.atanh
  // Tor Browser bug: Math.atanh(-0) -> 0

  $({
    target: 'Math',
    stat: true,
    forced: !($atanh && 1 / $atanh(-0) < 0)
  }, {
    atanh: function atanh(x) {
      return (x = +x) == 0 ? x : log((1 + x) / (1 - x)) / 2;
    }
  });
  /***/
},
/* 417 */

/***/
function (module, exports, __webpack_require__) {
  var $ = __webpack_require__(0);

  var sign = __webpack_require__(155);

  var abs = Math.abs;
  var pow = Math.pow; // `Math.cbrt` method
  // https://tc39.es/ecma262/#sec-math.cbrt

  $({
    target: 'Math',
    stat: true
  }, {
    cbrt: function cbrt(x) {
      return sign(x = +x) * pow(abs(x), 1 / 3);
    }
  });
  /***/
},
/* 418 */

/***/
function (module, exports, __webpack_require__) {
  var $ = __webpack_require__(0);

  var floor = Math.floor;
  var log = Math.log;
  var LOG2E = Math.LOG2E; // `Math.clz32` method
  // https://tc39.es/ecma262/#sec-math.clz32

  $({
    target: 'Math',
    stat: true
  }, {
    clz32: function clz32(x) {
      return (x >>>= 0) ? 31 - floor(log(x + 0.5) * LOG2E) : 32;
    }
  });
  /***/
},
/* 419 */

/***/
function (module, exports, __webpack_require__) {
  var $ = __webpack_require__(0);

  var expm1 = __webpack_require__(118); // eslint-disable-next-line es/no-math-cosh -- required for testing


  var $cosh = Math.cosh;
  var abs = Math.abs;
  var E = Math.E; // `Math.cosh` method
  // https://tc39.es/ecma262/#sec-math.cosh

  $({
    target: 'Math',
    stat: true,
    forced: !$cosh || $cosh(710) === Infinity
  }, {
    cosh: function cosh(x) {
      var t = expm1(abs(x) - 1) + 1;
      return (t + 1 / (t * E * E)) * (E / 2);
    }
  });
  /***/
},
/* 420 */

/***/
function (module, exports, __webpack_require__) {
  var $ = __webpack_require__(0);

  var expm1 = __webpack_require__(118); // `Math.expm1` method
  // https://tc39.es/ecma262/#sec-math.expm1
  // eslint-disable-next-line es/no-math-expm1 -- required for testing


  $({
    target: 'Math',
    stat: true,
    forced: expm1 != Math.expm1
  }, {
    expm1: expm1
  });
  /***/
},
/* 421 */

/***/
function (module, exports, __webpack_require__) {
  var $ = __webpack_require__(0);

  var fround = __webpack_require__(353); // `Math.fround` method
  // https://tc39.es/ecma262/#sec-math.fround


  $({
    target: 'Math',
    stat: true
  }, {
    fround: fround
  });
  /***/
},
/* 422 */

/***/
function (module, exports, __webpack_require__) {
  var $ = __webpack_require__(0); // eslint-disable-next-line es/no-math-hypot -- required for testing


  var $hypot = Math.hypot;
  var abs = Math.abs;
  var sqrt = Math.sqrt; // Chrome 77 bug
  // https://bugs.chromium.org/p/v8/issues/detail?id=9546

  var BUGGY = !!$hypot && $hypot(Infinity, NaN) !== Infinity; // `Math.hypot` method
  // https://tc39.es/ecma262/#sec-math.hypot

  $({
    target: 'Math',
    stat: true,
    forced: BUGGY
  }, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    hypot: function hypot(value1, value2) {
      var sum = 0;
      var i = 0;
      var aLen = arguments.length;
      var larg = 0;
      var arg, div;

      while (i < aLen) {
        arg = abs(arguments[i++]);

        if (larg < arg) {
          div = larg / arg;
          sum = sum * div * div + 1;
          larg = arg;
        } else if (arg > 0) {
          div = arg / larg;
          sum += div * div;
        } else sum += arg;
      }

      return larg === Infinity ? Infinity : larg * sqrt(sum);
    }
  });
  /***/
},
/* 423 */

/***/
function (module, exports, __webpack_require__) {
  var $ = __webpack_require__(0);

  var fails = __webpack_require__(2); // eslint-disable-next-line es/no-math-imul -- required for testing


  var $imul = Math.imul;
  var FORCED = fails(function () {
    return $imul(0xFFFFFFFF, 5) != -5 || $imul.length != 2;
  }); // `Math.imul` method
  // https://tc39.es/ecma262/#sec-math.imul
  // some WebKit versions fails with big numbers, some has wrong arity

  $({
    target: 'Math',
    stat: true,
    forced: FORCED
  }, {
    imul: function imul(x, y) {
      var UINT16 = 0xFFFF;
      var xn = +x;
      var yn = +y;
      var xl = UINT16 & xn;
      var yl = UINT16 & yn;
      return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
    }
  });
  /***/
},
/* 424 */

/***/
function (module, exports, __webpack_require__) {
  var $ = __webpack_require__(0);

  var log10 = __webpack_require__(215); // `Math.log10` method
  // https://tc39.es/ecma262/#sec-math.log10


  $({
    target: 'Math',
    stat: true
  }, {
    log10: log10
  });
  /***/
},
/* 425 */

/***/
function (module, exports, __webpack_require__) {
  var $ = __webpack_require__(0);

  var log1p = __webpack_require__(216); // `Math.log1p` method
  // https://tc39.es/ecma262/#sec-math.log1p


  $({
    target: 'Math',
    stat: true
  }, {
    log1p: log1p
  });
  /***/
},
/* 426 */

/***/
function (module, exports, __webpack_require__) {
  var $ = __webpack_require__(0);

  var log = Math.log;
  var LN2 = Math.LN2; // `Math.log2` method
  // https://tc39.es/ecma262/#sec-math.log2

  $({
    target: 'Math',
    stat: true
  }, {
    log2: function log2(x) {
      return log(x) / LN2;
    }
  });
  /***/
},
/* 427 */

/***/
function (module, exports, __webpack_require__) {
  var $ = __webpack_require__(0);

  var sign = __webpack_require__(155); // `Math.sign` method
  // https://tc39.es/ecma262/#sec-math.sign


  $({
    target: 'Math',
    stat: true
  }, {
    sign: sign
  });
  /***/
},
/* 428 */

/***/
function (module, exports, __webpack_require__) {
  var $ = __webpack_require__(0);

  var fails = __webpack_require__(2);

  var expm1 = __webpack_require__(118);

  var abs = Math.abs;
  var exp = Math.exp;
  var E = Math.E;
  var FORCED = fails(function () {
    // eslint-disable-next-line es/no-math-sinh -- required for testing
    return Math.sinh(-2e-17) != -2e-17;
  }); // `Math.sinh` method
  // https://tc39.es/ecma262/#sec-math.sinh
  // V8 near Chromium 38 has a problem with very small numbers

  $({
    target: 'Math',
    stat: true,
    forced: FORCED
  }, {
    sinh: function sinh(x) {
      return abs(x = +x) < 1 ? (expm1(x) - expm1(-x)) / 2 : (exp(x - 1) - exp(-x - 1)) * (E / 2);
    }
  });
  /***/
},
/* 429 */

/***/
function (module, exports, __webpack_require__) {
  var $ = __webpack_require__(0);

  var expm1 = __webpack_require__(118);

  var exp = Math.exp; // `Math.tanh` method
  // https://tc39.es/ecma262/#sec-math.tanh

  $({
    target: 'Math',
    stat: true
  }, {
    tanh: function tanh(x) {
      var a = expm1(x = +x);
      var b = expm1(-x);
      return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
    }
  });
  /***/
},
/* 430 */

/***/
function (module, exports, __webpack_require__) {
  var setToStringTag = __webpack_require__(49); // Math[@@toStringTag] property
  // https://tc39.es/ecma262/#sec-math-@@tostringtag


  setToStringTag(Math, 'Math', true);
  /***/
},
/* 431 */

/***/
function (module, exports, __webpack_require__) {
  var $ = __webpack_require__(0);

  var ceil = Math.ceil;
  var floor = Math.floor; // `Math.trunc` method
  // https://tc39.es/ecma262/#sec-math.trunc

  $({
    target: 'Math',
    stat: true
  }, {
    trunc: function trunc(it) {
      return (it > 0 ? floor : ceil)(it);
    }
  });
  /***/
},
/* 432 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var DESCRIPTORS = __webpack_require__(12);

  var global = __webpack_require__(1);

  var uncurryThis = __webpack_require__(3);

  var isForced = __webpack_require__(93);

  var redefine = __webpack_require__(24);

  var hasOwn = __webpack_require__(21);

  var inheritIfRequired = __webpack_require__(75);

  var isPrototypeOf = __webpack_require__(42);

  var isSymbol = __webpack_require__(77);

  var toPrimitive = __webpack_require__(168);

  var fails = __webpack_require__(2);

  var getOwnPropertyNames = __webpack_require__(65).f;

  var getOwnPropertyDescriptor = __webpack_require__(32).f;

  var defineProperty = __webpack_require__(20).f;

  var thisNumberValue = __webpack_require__(129);

  var trim = __webpack_require__(81).trim;

  var NUMBER = 'Number';
  var NativeNumber = global[NUMBER];
  var NumberPrototype = NativeNumber.prototype;
  var TypeError = global.TypeError;
  var arraySlice = uncurryThis(''.slice);
  var charCodeAt = uncurryThis(''.charCodeAt); // `ToNumeric` abstract operation
  // https://tc39.es/ecma262/#sec-tonumeric

  var toNumeric = function toNumeric(value) {
    var primValue = toPrimitive(value, 'number');
    return typeof primValue == 'bigint' ? primValue : toNumber(primValue);
  }; // `ToNumber` abstract operation
  // https://tc39.es/ecma262/#sec-tonumber


  var toNumber = function toNumber(argument) {
    var it = toPrimitive(argument, 'number');
    var first, third, radix, maxCode, digits, length, index, code;
    if (isSymbol(it)) throw TypeError('Cannot convert a Symbol value to a number');

    if (typeof it == 'string' && it.length > 2) {
      it = trim(it);
      first = charCodeAt(it, 0);

      if (first === 43 || first === 45) {
        third = charCodeAt(it, 2);
        if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
      } else if (first === 48) {
        switch (charCodeAt(it, 1)) {
          case 66:
          case 98:
            radix = 2;
            maxCode = 49;
            break;
          // fast equal of /^0b[01]+$/i

          case 79:
          case 111:
            radix = 8;
            maxCode = 55;
            break;
          // fast equal of /^0o[0-7]+$/i

          default:
            return +it;
        }

        digits = arraySlice(it, 2);
        length = digits.length;

        for (index = 0; index < length; index++) {
          code = charCodeAt(digits, index); // parseInt parses a string to a first unavailable symbol
          // but ToNumber should return NaN if a string contains unavailable symbols

          if (code < 48 || code > maxCode) return NaN;
        }

        return parseInt(digits, radix);
      }
    }

    return +it;
  }; // `Number` constructor
  // https://tc39.es/ecma262/#sec-number-constructor


  if (isForced(NUMBER, !NativeNumber(' 0o1') || !NativeNumber('0b1') || NativeNumber('+0x1'))) {
    var NumberWrapper = function Number(value) {
      var n = arguments.length < 1 ? 0 : NativeNumber(toNumeric(value));
      var dummy = this; // check on 1..constructor(foo) case

      return isPrototypeOf(NumberPrototype, dummy) && fails(function () {
        thisNumberValue(dummy);
      }) ? inheritIfRequired(Object(n), dummy, NumberWrapper) : n;
    };

    for (var keys = DESCRIPTORS ? getOwnPropertyNames(NativeNumber) : ( // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' + // ES2015 (in case, if modules with ES2015 Number statics required before):
    'EPSILON,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,isFinite,isInteger,isNaN,isSafeInteger,parseFloat,parseInt,' + // ESNext
    'fromString,range').split(','), j = 0, key; keys.length > j; j++) {
      if (hasOwn(NativeNumber, key = keys[j]) && !hasOwn(NumberWrapper, key)) {
        defineProperty(NumberWrapper, key, getOwnPropertyDescriptor(NativeNumber, key));
      }
    }

    NumberWrapper.prototype = NumberPrototype;
    NumberPrototype.constructor = NumberWrapper;
    redefine(global, NUMBER, NumberWrapper);
  }
  /***/

},
/* 433 */

/***/
function (module, exports, __webpack_require__) {
  var $ = __webpack_require__(0); // `Number.EPSILON` constant
  // https://tc39.es/ecma262/#sec-number.epsilon


  $({
    target: 'Number',
    stat: true
  }, {
    EPSILON: Math.pow(2, -52)
  });
  /***/
},
/* 434 */

/***/
function (module, exports, __webpack_require__) {
  var $ = __webpack_require__(0);

  var numberIsFinite = __webpack_require__(354); // `Number.isFinite` method
  // https://tc39.es/ecma262/#sec-number.isfinite


  $({
    target: 'Number',
    stat: true
  }, {
    isFinite: numberIsFinite
  });
  /***/
},
/* 435 */

/***/
function (module, exports, __webpack_require__) {
  var $ = __webpack_require__(0);

  var isIntegralNumber = __webpack_require__(154); // `Number.isInteger` method
  // https://tc39.es/ecma262/#sec-number.isinteger


  $({
    target: 'Number',
    stat: true
  }, {
    isInteger: isIntegralNumber
  });
  /***/
},
/* 436 */

/***/
function (module, exports, __webpack_require__) {
  var $ = __webpack_require__(0); // `Number.isNaN` method
  // https://tc39.es/ecma262/#sec-number.isnan


  $({
    target: 'Number',
    stat: true
  }, {
    isNaN: function isNaN(number) {
      // eslint-disable-next-line no-self-compare -- NaN check
      return number != number;
    }
  });
  /***/
},
/* 437 */

/***/
function (module, exports, __webpack_require__) {
  var $ = __webpack_require__(0);

  var isIntegralNumber = __webpack_require__(154);

  var abs = Math.abs; // `Number.isSafeInteger` method
  // https://tc39.es/ecma262/#sec-number.issafeinteger

  $({
    target: 'Number',
    stat: true
  }, {
    isSafeInteger: function isSafeInteger(number) {
      return isIntegralNumber(number) && abs(number) <= 0x1FFFFFFFFFFFFF;
    }
  });
  /***/
},
/* 438 */

/***/
function (module, exports, __webpack_require__) {
  var $ = __webpack_require__(0); // `Number.MAX_SAFE_INTEGER` constant
  // https://tc39.es/ecma262/#sec-number.max_safe_integer


  $({
    target: 'Number',
    stat: true
  }, {
    MAX_SAFE_INTEGER: 0x1FFFFFFFFFFFFF
  });
  /***/
},
/* 439 */

/***/
function (module, exports, __webpack_require__) {
  var $ = __webpack_require__(0); // `Number.MIN_SAFE_INTEGER` constant
  // https://tc39.es/ecma262/#sec-number.min_safe_integer


  $({
    target: 'Number',
    stat: true
  }, {
    MIN_SAFE_INTEGER: -0x1FFFFFFFFFFFFF
  });
  /***/
},
/* 440 */

/***/
function (module, exports, __webpack_require__) {
  var $ = __webpack_require__(0);

  var parseFloat = __webpack_require__(221); // `Number.parseFloat` method
  // https://tc39.es/ecma262/#sec-number.parseFloat
  // eslint-disable-next-line es/no-number-parsefloat -- required for testing


  $({
    target: 'Number',
    stat: true,
    forced: Number.parseFloat != parseFloat
  }, {
    parseFloat: parseFloat
  });
  /***/
},
/* 441 */

/***/
function (module, exports, __webpack_require__) {
  var $ = __webpack_require__(0);

  var parseInt = __webpack_require__(222); // `Number.parseInt` method
  // https://tc39.es/ecma262/#sec-number.parseint
  // eslint-disable-next-line es/no-number-parseint -- required for testing


  $({
    target: 'Number',
    stat: true,
    forced: Number.parseInt != parseInt
  }, {
    parseInt: parseInt
  });
  /***/
},
/* 442 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $ = __webpack_require__(0);

  var global = __webpack_require__(1);

  var uncurryThis = __webpack_require__(3);

  var toIntegerOrInfinity = __webpack_require__(29);

  var thisNumberValue = __webpack_require__(129);

  var $repeat = __webpack_require__(128);

  var log10 = __webpack_require__(215);

  var fails = __webpack_require__(2);

  var RangeError = global.RangeError;
  var String = global.String;
  var isFinite = global.isFinite;
  var abs = Math.abs;
  var floor = Math.floor;
  var pow = Math.pow;
  var round = Math.round;
  var un$ToExponential = uncurryThis(1.0.toExponential);
  var repeat = uncurryThis($repeat);
  var stringSlice = uncurryThis(''.slice); // Edge 17-

  var ROUNDS_PROPERLY = un$ToExponential(-6.9e-11, 4) === '-6.9000e-11' // IE11- && Edge 14-
  && un$ToExponential(1.255, 2) === '1.25e+0' // FF86-, V8 ~ Chrome 49-50
  && un$ToExponential(12345, 3) === '1.235e+4' // FF86-, V8 ~ Chrome 49-50
  && un$ToExponential(25, 0) === '3e+1'; // IE8-

  var THROWS_ON_INFINITY_FRACTION = fails(function () {
    un$ToExponential(1, Infinity);
  }) && fails(function () {
    un$ToExponential(1, -Infinity);
  }); // Safari <11 && FF <50

  var PROPER_NON_FINITE_THIS_CHECK = !fails(function () {
    un$ToExponential(Infinity, Infinity);
  }) && !fails(function () {
    un$ToExponential(NaN, Infinity);
  });
  var FORCED = !ROUNDS_PROPERLY || !THROWS_ON_INFINITY_FRACTION || !PROPER_NON_FINITE_THIS_CHECK; // `Number.prototype.toExponential` method
  // https://tc39.es/ecma262/#sec-number.prototype.toexponential

  $({
    target: 'Number',
    proto: true,
    forced: FORCED
  }, {
    toExponential: function toExponential(fractionDigits) {
      var x = thisNumberValue(this);
      if (fractionDigits === undefined) return un$ToExponential(x);
      var f = toIntegerOrInfinity(fractionDigits);
      if (!isFinite(x)) return String(x); // TODO: ES2018 increased the maximum number of fraction digits to 100, need to improve the implementation

      if (f < 0 || f > 20) throw RangeError('Incorrect fraction digits');
      if (ROUNDS_PROPERLY) return un$ToExponential(x, f);
      var s = '';
      var m = '';
      var e = 0;
      var c = '';
      var d = '';

      if (x < 0) {
        s = '-';
        x = -x;
      }

      if (x === 0) {
        e = 0;
        m = repeat('0', f + 1);
      } else {
        // this block is based on https://gist.github.com/SheetJSDev/1100ad56b9f856c95299ed0e068eea08
        // TODO: improve accuracy with big fraction digits
        var l = log10(x);
        e = floor(l);
        var n = 0;
        var w = pow(10, e - f);
        n = round(x / w);

        if (2 * x >= (2 * n + 1) * w) {
          n += 1;
        }

        if (n >= pow(10, f + 1)) {
          n /= 10;
          e += 1;
        }

        m = String(n);
      }

      if (f !== 0) {
        m = stringSlice(m, 0, 1) + '.' + stringSlice(m, 1);
      }

      if (e === 0) {
        c = '+';
        d = '0';
      } else {
        c = e > 0 ? '+' : '-';
        d = String(abs(e));
      }

      m += 'e' + c + d;
      return s + m;
    }
  });
  /***/
},
/* 443 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $ = __webpack_require__(0);

  var global = __webpack_require__(1);

  var uncurryThis = __webpack_require__(3);

  var toIntegerOrInfinity = __webpack_require__(29);

  var thisNumberValue = __webpack_require__(129);

  var $repeat = __webpack_require__(128);

  var fails = __webpack_require__(2);

  var RangeError = global.RangeError;
  var String = global.String;
  var floor = Math.floor;
  var repeat = uncurryThis($repeat);
  var stringSlice = uncurryThis(''.slice);
  var un$ToFixed = uncurryThis(1.0.toFixed);

  var pow = function pow(x, n, acc) {
    return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
  };

  var log = function log(x) {
    var n = 0;
    var x2 = x;

    while (x2 >= 4096) {
      n += 12;
      x2 /= 4096;
    }

    while (x2 >= 2) {
      n += 1;
      x2 /= 2;
    }

    return n;
  };

  var multiply = function multiply(data, n, c) {
    var index = -1;
    var c2 = c;

    while (++index < 6) {
      c2 += n * data[index];
      data[index] = c2 % 1e7;
      c2 = floor(c2 / 1e7);
    }
  };

  var divide = function divide(data, n) {
    var index = 6;
    var c = 0;

    while (--index >= 0) {
      c += data[index];
      data[index] = floor(c / n);
      c = c % n * 1e7;
    }
  };

  var dataToString = function dataToString(data) {
    var index = 6;
    var s = '';

    while (--index >= 0) {
      if (s !== '' || index === 0 || data[index] !== 0) {
        var t = String(data[index]);
        s = s === '' ? t : s + repeat('0', 7 - t.length) + t;
      }
    }

    return s;
  };

  var FORCED = fails(function () {
    return un$ToFixed(0.00008, 3) !== '0.000' || un$ToFixed(0.9, 0) !== '1' || un$ToFixed(1.255, 2) !== '1.25' || un$ToFixed(1000000000000000128.0, 0) !== '1000000000000000128';
  }) || !fails(function () {
    // V8 ~ Android 4.3-
    un$ToFixed({});
  }); // `Number.prototype.toFixed` method
  // https://tc39.es/ecma262/#sec-number.prototype.tofixed

  $({
    target: 'Number',
    proto: true,
    forced: FORCED
  }, {
    toFixed: function toFixed(fractionDigits) {
      var number = thisNumberValue(this);
      var fractDigits = toIntegerOrInfinity(fractionDigits);
      var data = [0, 0, 0, 0, 0, 0];
      var sign = '';
      var result = '0';
      var e, z, j, k; // TODO: ES2018 increased the maximum number of fraction digits to 100, need to improve the implementation

      if (fractDigits < 0 || fractDigits > 20) throw RangeError('Incorrect fraction digits'); // eslint-disable-next-line no-self-compare -- NaN check

      if (number != number) return 'NaN';
      if (number <= -1e21 || number >= 1e21) return String(number);

      if (number < 0) {
        sign = '-';
        number = -number;
      }

      if (number > 1e-21) {
        e = log(number * pow(2, 69, 1)) - 69;
        z = e < 0 ? number * pow(2, -e, 1) : number / pow(2, e, 1);
        z *= 0x10000000000000;
        e = 52 - e;

        if (e > 0) {
          multiply(data, 0, z);
          j = fractDigits;

          while (j >= 7) {
            multiply(data, 1e7, 0);
            j -= 7;
          }

          multiply(data, pow(10, j, 1), 0);
          j = e - 1;

          while (j >= 23) {
            divide(data, 1 << 23);
            j -= 23;
          }

          divide(data, 1 << j);
          multiply(data, 1, 1);
          divide(data, 2);
          result = dataToString(data);
        } else {
          multiply(data, 0, z);
          multiply(data, 1 << -e, 0);
          result = dataToString(data) + repeat('0', fractDigits);
        }
      }

      if (fractDigits > 0) {
        k = result.length;
        result = sign + (k <= fractDigits ? '0.' + repeat('0', fractDigits - k) + result : stringSlice(result, 0, k - fractDigits) + '.' + stringSlice(result, k - fractDigits));
      } else {
        result = sign + result;
      }

      return result;
    }
  });
  /***/
},
/* 444 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $ = __webpack_require__(0);

  var uncurryThis = __webpack_require__(3);

  var fails = __webpack_require__(2);

  var thisNumberValue = __webpack_require__(129);

  var un$ToPrecision = uncurryThis(1.0.toPrecision);
  var FORCED = fails(function () {
    // IE7-
    return un$ToPrecision(1, undefined) !== '1';
  }) || !fails(function () {
    // V8 ~ Android 4.3-
    un$ToPrecision({});
  }); // `Number.prototype.toPrecision` method
  // https://tc39.es/ecma262/#sec-number.prototype.toprecision

  $({
    target: 'Number',
    proto: true,
    forced: FORCED
  }, {
    toPrecision: function toPrecision(precision) {
      return precision === undefined ? un$ToPrecision(thisNumberValue(this)) : un$ToPrecision(thisNumberValue(this), precision);
    }
  });
  /***/
},
/* 445 */

/***/
function (module, exports, __webpack_require__) {
  var $ = __webpack_require__(0);

  var assign = __webpack_require__(223); // `Object.assign` method
  // https://tc39.es/ecma262/#sec-object.assign
  // eslint-disable-next-line es/no-object-assign -- required for testing


  $({
    target: 'Object',
    stat: true,
    forced: Object.assign !== assign
  }, {
    assign: assign
  });
  /***/
},
/* 446 */

/***/
function (module, exports, __webpack_require__) {
  var $ = __webpack_require__(0);

  var DESCRIPTORS = __webpack_require__(12);

  var create = __webpack_require__(41); // `Object.create` method
  // https://tc39.es/ecma262/#sec-object.create


  $({
    target: 'Object',
    stat: true,
    sham: !DESCRIPTORS
  }, {
    create: create
  });
  /***/
},
/* 447 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $ = __webpack_require__(0);

  var DESCRIPTORS = __webpack_require__(12);

  var FORCED = __webpack_require__(122);

  var aCallable = __webpack_require__(34);

  var toObject = __webpack_require__(22);

  var definePropertyModule = __webpack_require__(20); // `Object.prototype.__defineGetter__` method
  // https://tc39.es/ecma262/#sec-object.prototype.__defineGetter__


  if (DESCRIPTORS) {
    $({
      target: 'Object',
      proto: true,
      forced: FORCED
    }, {
      __defineGetter__: function __defineGetter__(P, getter) {
        definePropertyModule.f(toObject(this), P, {
          get: aCallable(getter),
          enumerable: true,
          configurable: true
        });
      }
    });
  }
  /***/

},
/* 448 */

/***/
function (module, exports, __webpack_require__) {
  var $ = __webpack_require__(0);

  var DESCRIPTORS = __webpack_require__(12);

  var defineProperties = __webpack_require__(97).f; // `Object.defineProperties` method
  // https://tc39.es/ecma262/#sec-object.defineproperties
  // eslint-disable-next-line es/no-object-defineproperties -- safe


  $({
    target: 'Object',
    stat: true,
    forced: Object.defineProperties !== defineProperties,
    sham: !DESCRIPTORS
  }, {
    defineProperties: defineProperties
  });
  /***/
},
/* 449 */

/***/
function (module, exports, __webpack_require__) {
  var $ = __webpack_require__(0);

  var DESCRIPTORS = __webpack_require__(12);

  var defineProperty = __webpack_require__(20).f; // `Object.defineProperty` method
  // https://tc39.es/ecma262/#sec-object.defineproperty
  // eslint-disable-next-line es/no-object-defineproperty -- safe


  $({
    target: 'Object',
    stat: true,
    forced: Object.defineProperty !== defineProperty,
    sham: !DESCRIPTORS
  }, {
    defineProperty: defineProperty
  });
  /***/
},
/* 450 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $ = __webpack_require__(0);

  var DESCRIPTORS = __webpack_require__(12);

  var FORCED = __webpack_require__(122);

  var aCallable = __webpack_require__(34);

  var toObject = __webpack_require__(22);

  var definePropertyModule = __webpack_require__(20); // `Object.prototype.__defineSetter__` method
  // https://tc39.es/ecma262/#sec-object.prototype.__defineSetter__


  if (DESCRIPTORS) {
    $({
      target: 'Object',
      proto: true,
      forced: FORCED
    }, {
      __defineSetter__: function __defineSetter__(P, setter) {
        definePropertyModule.f(toObject(this), P, {
          set: aCallable(setter),
          enumerable: true,
          configurable: true
        });
      }
    });
  }
  /***/

},
/* 451 */

/***/
function (module, exports, __webpack_require__) {
  var $ = __webpack_require__(0);

  var $entries = __webpack_require__(225).entries; // `Object.entries` method
  // https://tc39.es/ecma262/#sec-object.entries


  $({
    target: 'Object',
    stat: true
  }, {
    entries: function entries(O) {
      return $entries(O);
    }
  });
  /***/
},
/* 452 */

/***/
function (module, exports, __webpack_require__) {
  var $ = __webpack_require__(0);

  var FREEZING = __webpack_require__(88);

  var fails = __webpack_require__(2);

  var isObject = __webpack_require__(13);

  var onFreeze = __webpack_require__(70).onFreeze; // eslint-disable-next-line es/no-object-freeze -- safe


  var $freeze = Object.freeze;
  var FAILS_ON_PRIMITIVES = fails(function () {
    $freeze(1);
  }); // `Object.freeze` method
  // https://tc39.es/ecma262/#sec-object.freeze

  $({
    target: 'Object',
    stat: true,
    forced: FAILS_ON_PRIMITIVES,
    sham: !FREEZING
  }, {
    freeze: function freeze(it) {
      return $freeze && isObject(it) ? $freeze(onFreeze(it)) : it;
    }
  });
  /***/
},
/* 453 */

/***/
function (module, exports, __webpack_require__) {
  var $ = __webpack_require__(0);

  var iterate = __webpack_require__(59);

  var createProperty = __webpack_require__(56); // `Object.fromEntries` method
  // https://github.com/tc39/proposal-object-from-entries


  $({
    target: 'Object',
    stat: true
  }, {
    fromEntries: function fromEntries(iterable) {
      var obj = {};
      iterate(iterable, function (k, v) {
        createProperty(obj, k, v);
      }, {
        AS_ENTRIES: true
      });
      return obj;
    }
  });
  /***/
},
/* 454 */

/***/
function (module, exports, __webpack_require__) {
  var $ = __webpack_require__(0);

  var fails = __webpack_require__(2);

  var toIndexedObject = __webpack_require__(37);

  var nativeGetOwnPropertyDescriptor = __webpack_require__(32).f;

  var DESCRIPTORS = __webpack_require__(12);

  var FAILS_ON_PRIMITIVES = fails(function () {
    nativeGetOwnPropertyDescriptor(1);
  });
  var FORCED = !DESCRIPTORS || FAILS_ON_PRIMITIVES; // `Object.getOwnPropertyDescriptor` method
  // https://tc39.es/ecma262/#sec-object.getownpropertydescriptor

  $({
    target: 'Object',
    stat: true,
    forced: FORCED,
    sham: !DESCRIPTORS
  }, {
    getOwnPropertyDescriptor: function getOwnPropertyDescriptor(it, key) {
      return nativeGetOwnPropertyDescriptor(toIndexedObject(it), key);
    }
  });
  /***/
},
/* 455 */

/***/
function (module, exports, __webpack_require__) {
  var $ = __webpack_require__(0);

  var DESCRIPTORS = __webpack_require__(12);

  var ownKeys = __webpack_require__(160);

  var toIndexedObject = __webpack_require__(37);

  var getOwnPropertyDescriptorModule = __webpack_require__(32);

  var createProperty = __webpack_require__(56); // `Object.getOwnPropertyDescriptors` method
  // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors


  $({
    target: 'Object',
    stat: true,
    sham: !DESCRIPTORS
  }, {
    getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
      var O = toIndexedObject(object);
      var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
      var keys = ownKeys(O);
      var result = {};
      var index = 0;
      var key, descriptor;

      while (keys.length > index) {
        descriptor = getOwnPropertyDescriptor(O, key = keys[index++]);
        if (descriptor !== undefined) createProperty(result, key, descriptor);
      }

      return result;
    }
  });
  /***/
},
/* 456 */

/***/
function (module, exports, __webpack_require__) {
  var $ = __webpack_require__(0);

  var fails = __webpack_require__(2);

  var getOwnPropertyNames = __webpack_require__(158).f; // eslint-disable-next-line es/no-object-getownpropertynames -- required for testing


  var FAILS_ON_PRIMITIVES = fails(function () {
    return !Object.getOwnPropertyNames(1);
  }); // `Object.getOwnPropertyNames` method
  // https://tc39.es/ecma262/#sec-object.getownpropertynames

  $({
    target: 'Object',
    stat: true,
    forced: FAILS_ON_PRIMITIVES
  }, {
    getOwnPropertyNames: getOwnPropertyNames
  });
  /***/
},
/* 457 */

/***/
function (module, exports, __webpack_require__) {
  var $ = __webpack_require__(0);

  var fails = __webpack_require__(2);

  var toObject = __webpack_require__(22);

  var nativeGetPrototypeOf = __webpack_require__(48);

  var CORRECT_PROTOTYPE_GETTER = __webpack_require__(147);

  var FAILS_ON_PRIMITIVES = fails(function () {
    nativeGetPrototypeOf(1);
  }); // `Object.getPrototypeOf` method
  // https://tc39.es/ecma262/#sec-object.getprototypeof

  $({
    target: 'Object',
    stat: true,
    forced: FAILS_ON_PRIMITIVES,
    sham: !CORRECT_PROTOTYPE_GETTER
  }, {
    getPrototypeOf: function getPrototypeOf(it) {
      return nativeGetPrototypeOf(toObject(it));
    }
  });
  /***/
},
/* 458 */

/***/
function (module, exports, __webpack_require__) {
  var $ = __webpack_require__(0);

  var hasOwn = __webpack_require__(21); // `Object.hasOwn` method
  // https://github.com/tc39/proposal-accessible-object-hasownproperty


  $({
    target: 'Object',
    stat: true
  }, {
    hasOwn: hasOwn
  });
  /***/
},
/* 459 */

/***/
function (module, exports, __webpack_require__) {
  var $ = __webpack_require__(0);

  var $isExtensible = __webpack_require__(120); // `Object.isExtensible` method
  // https://tc39.es/ecma262/#sec-object.isextensible
  // eslint-disable-next-line es/no-object-isextensible -- safe


  $({
    target: 'Object',
    stat: true,
    forced: Object.isExtensible !== $isExtensible
  }, {
    isExtensible: $isExtensible
  });
  /***/
},
/* 460 */

/***/
function (module, exports, __webpack_require__) {
  var $ = __webpack_require__(0);

  var fails = __webpack_require__(2);

  var isObject = __webpack_require__(13);

  var classof = __webpack_require__(38);

  var ARRAY_BUFFER_NON_EXTENSIBLE = __webpack_require__(143); // eslint-disable-next-line es/no-object-isfrozen -- safe


  var $isFrozen = Object.isFrozen;
  var FAILS_ON_PRIMITIVES = fails(function () {
    $isFrozen(1);
  }); // `Object.isFrozen` method
  // https://tc39.es/ecma262/#sec-object.isfrozen

  $({
    target: 'Object',
    stat: true,
    forced: FAILS_ON_PRIMITIVES || ARRAY_BUFFER_NON_EXTENSIBLE
  }, {
    isFrozen: function isFrozen(it) {
      if (!isObject(it)) return true;
      if (ARRAY_BUFFER_NON_EXTENSIBLE && classof(it) == 'ArrayBuffer') return true;
      return $isFrozen ? $isFrozen(it) : false;
    }
  });
  /***/
},
/* 461 */

/***/
function (module, exports, __webpack_require__) {
  var $ = __webpack_require__(0);

  var fails = __webpack_require__(2);

  var isObject = __webpack_require__(13);

  var classof = __webpack_require__(38);

  var ARRAY_BUFFER_NON_EXTENSIBLE = __webpack_require__(143); // eslint-disable-next-line es/no-object-issealed -- safe


  var $isSealed = Object.isSealed;
  var FAILS_ON_PRIMITIVES = fails(function () {
    $isSealed(1);
  }); // `Object.isSealed` method
  // https://tc39.es/ecma262/#sec-object.issealed

  $({
    target: 'Object',
    stat: true,
    forced: FAILS_ON_PRIMITIVES || ARRAY_BUFFER_NON_EXTENSIBLE
  }, {
    isSealed: function isSealed(it) {
      if (!isObject(it)) return true;
      if (ARRAY_BUFFER_NON_EXTENSIBLE && classof(it) == 'ArrayBuffer') return true;
      return $isSealed ? $isSealed(it) : false;
    }
  });
  /***/
},
/* 462 */

/***/
function (module, exports, __webpack_require__) {
  var $ = __webpack_require__(0);

  var is = __webpack_require__(230); // `Object.is` method
  // https://tc39.es/ecma262/#sec-object.is


  $({
    target: 'Object',
    stat: true
  }, {
    is: is
  });
  /***/
},
/* 463 */

/***/
function (module, exports, __webpack_require__) {
  var $ = __webpack_require__(0);

  var toObject = __webpack_require__(22);

  var nativeKeys = __webpack_require__(98);

  var fails = __webpack_require__(2);

  var FAILS_ON_PRIMITIVES = fails(function () {
    nativeKeys(1);
  }); // `Object.keys` method
  // https://tc39.es/ecma262/#sec-object.keys

  $({
    target: 'Object',
    stat: true,
    forced: FAILS_ON_PRIMITIVES
  }, {
    keys: function keys(it) {
      return nativeKeys(toObject(it));
    }
  });
  /***/
},
/* 464 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $ = __webpack_require__(0);

  var DESCRIPTORS = __webpack_require__(12);

  var FORCED = __webpack_require__(122);

  var toObject = __webpack_require__(22);

  var toPropertyKey = __webpack_require__(66);

  var getPrototypeOf = __webpack_require__(48);

  var getOwnPropertyDescriptor = __webpack_require__(32).f; // `Object.prototype.__lookupGetter__` method
  // https://tc39.es/ecma262/#sec-object.prototype.__lookupGetter__


  if (DESCRIPTORS) {
    $({
      target: 'Object',
      proto: true,
      forced: FORCED
    }, {
      __lookupGetter__: function __lookupGetter__(P) {
        var O = toObject(this);
        var key = toPropertyKey(P);
        var desc;

        do {
          if (desc = getOwnPropertyDescriptor(O, key)) return desc.get;
        } while (O = getPrototypeOf(O));
      }
    });
  }
  /***/

},
/* 465 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $ = __webpack_require__(0);

  var DESCRIPTORS = __webpack_require__(12);

  var FORCED = __webpack_require__(122);

  var toObject = __webpack_require__(22);

  var toPropertyKey = __webpack_require__(66);

  var getPrototypeOf = __webpack_require__(48);

  var getOwnPropertyDescriptor = __webpack_require__(32).f; // `Object.prototype.__lookupSetter__` method
  // https://tc39.es/ecma262/#sec-object.prototype.__lookupSetter__


  if (DESCRIPTORS) {
    $({
      target: 'Object',
      proto: true,
      forced: FORCED
    }, {
      __lookupSetter__: function __lookupSetter__(P) {
        var O = toObject(this);
        var key = toPropertyKey(P);
        var desc;

        do {
          if (desc = getOwnPropertyDescriptor(O, key)) return desc.set;
        } while (O = getPrototypeOf(O));
      }
    });
  }
  /***/

},
/* 466 */

/***/
function (module, exports, __webpack_require__) {
  var $ = __webpack_require__(0);

  var isObject = __webpack_require__(13);

  var onFreeze = __webpack_require__(70).onFreeze;

  var FREEZING = __webpack_require__(88);

  var fails = __webpack_require__(2); // eslint-disable-next-line es/no-object-preventextensions -- safe


  var $preventExtensions = Object.preventExtensions;
  var FAILS_ON_PRIMITIVES = fails(function () {
    $preventExtensions(1);
  }); // `Object.preventExtensions` method
  // https://tc39.es/ecma262/#sec-object.preventextensions

  $({
    target: 'Object',
    stat: true,
    forced: FAILS_ON_PRIMITIVES,
    sham: !FREEZING
  }, {
    preventExtensions: function preventExtensions(it) {
      return $preventExtensions && isObject(it) ? $preventExtensions(onFreeze(it)) : it;
    }
  });
  /***/
},
/* 467 */

/***/
function (module, exports, __webpack_require__) {
  var $ = __webpack_require__(0);

  var isObject = __webpack_require__(13);

  var onFreeze = __webpack_require__(70).onFreeze;

  var FREEZING = __webpack_require__(88);

  var fails = __webpack_require__(2); // eslint-disable-next-line es/no-object-seal -- safe


  var $seal = Object.seal;
  var FAILS_ON_PRIMITIVES = fails(function () {
    $seal(1);
  }); // `Object.seal` method
  // https://tc39.es/ecma262/#sec-object.seal

  $({
    target: 'Object',
    stat: true,
    forced: FAILS_ON_PRIMITIVES,
    sham: !FREEZING
  }, {
    seal: function seal(it) {
      return $seal && isObject(it) ? $seal(onFreeze(it)) : it;
    }
  });
  /***/
},
/* 468 */

/***/
function (module, exports, __webpack_require__) {
  var $ = __webpack_require__(0);

  var setPrototypeOf = __webpack_require__(52); // `Object.setPrototypeOf` method
  // https://tc39.es/ecma262/#sec-object.setprototypeof


  $({
    target: 'Object',
    stat: true
  }, {
    setPrototypeOf: setPrototypeOf
  });
  /***/
},
/* 469 */

/***/
function (module, exports, __webpack_require__) {
  var TO_STRING_TAG_SUPPORT = __webpack_require__(169);

  var redefine = __webpack_require__(24);

  var toString = __webpack_require__(355); // `Object.prototype.toString` method
  // https://tc39.es/ecma262/#sec-object.prototype.tostring


  if (!TO_STRING_TAG_SUPPORT) {
    redefine(Object.prototype, 'toString', toString, {
      unsafe: true
    });
  }
  /***/

},
/* 470 */

/***/
function (module, exports, __webpack_require__) {
  var $ = __webpack_require__(0);

  var $values = __webpack_require__(225).values; // `Object.values` method
  // https://tc39.es/ecma262/#sec-object.values


  $({
    target: 'Object',
    stat: true
  }, {
    values: function values(O) {
      return $values(O);
    }
  });
  /***/
},
/* 471 */

/***/
function (module, exports, __webpack_require__) {
  var $ = __webpack_require__(0);

  var $parseFloat = __webpack_require__(221); // `parseFloat` method
  // https://tc39.es/ecma262/#sec-parsefloat-string


  $({
    global: true,
    forced: parseFloat != $parseFloat
  }, {
    parseFloat: $parseFloat
  });
  /***/
},
/* 472 */

/***/
function (module, exports, __webpack_require__) {
  var $ = __webpack_require__(0);

  var $parseInt = __webpack_require__(222); // `parseInt` method
  // https://tc39.es/ecma262/#sec-parseint-string-radix


  $({
    global: true,
    forced: parseInt != $parseInt
  }, {
    parseInt: $parseInt
  });
  /***/
},
/* 473 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $ = __webpack_require__(0);

  var call = __webpack_require__(19);

  var aCallable = __webpack_require__(34);

  var newPromiseCapabilityModule = __webpack_require__(119);

  var perform = __webpack_require__(161);

  var iterate = __webpack_require__(59); // `Promise.allSettled` method
  // https://tc39.es/ecma262/#sec-promise.allsettled


  $({
    target: 'Promise',
    stat: true
  }, {
    allSettled: function allSettled(iterable) {
      var C = this;
      var capability = newPromiseCapabilityModule.f(C);
      var resolve = capability.resolve;
      var reject = capability.reject;
      var result = perform(function () {
        var promiseResolve = aCallable(C.resolve);
        var values = [];
        var counter = 0;
        var remaining = 1;
        iterate(iterable, function (promise) {
          var index = counter++;
          var alreadyCalled = false;
          remaining++;
          call(promiseResolve, C, promise).then(function (value) {
            if (alreadyCalled) return;
            alreadyCalled = true;
            values[index] = {
              status: 'fulfilled',
              value: value
            };
            --remaining || resolve(values);
          }, function (error) {
            if (alreadyCalled) return;
            alreadyCalled = true;
            values[index] = {
              status: 'rejected',
              reason: error
            };
            --remaining || resolve(values);
          });
        });
        --remaining || resolve(values);
      });
      if (result.error) reject(result.value);
      return capability.promise;
    }
  });
  /***/
},
/* 474 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $ = __webpack_require__(0);

  var aCallable = __webpack_require__(34);

  var getBuiltIn = __webpack_require__(26);

  var call = __webpack_require__(19);

  var newPromiseCapabilityModule = __webpack_require__(119);

  var perform = __webpack_require__(161);

  var iterate = __webpack_require__(59);

  var PROMISE_ANY_ERROR = 'No one promise resolved'; // `Promise.any` method
  // https://tc39.es/ecma262/#sec-promise.any

  $({
    target: 'Promise',
    stat: true
  }, {
    any: function any(iterable) {
      var C = this;
      var AggregateError = getBuiltIn('AggregateError');
      var capability = newPromiseCapabilityModule.f(C);
      var resolve = capability.resolve;
      var reject = capability.reject;
      var result = perform(function () {
        var promiseResolve = aCallable(C.resolve);
        var errors = [];
        var counter = 0;
        var remaining = 1;
        var alreadyResolved = false;
        iterate(iterable, function (promise) {
          var index = counter++;
          var alreadyRejected = false;
          remaining++;
          call(promiseResolve, C, promise).then(function (value) {
            if (alreadyRejected || alreadyResolved) return;
            alreadyResolved = true;
            resolve(value);
          }, function (error) {
            if (alreadyRejected || alreadyResolved) return;
            alreadyRejected = true;
            errors[index] = error;
            --remaining || reject(new AggregateError(errors, PROMISE_ANY_ERROR));
          });
        });
        --remaining || reject(new AggregateError(errors, PROMISE_ANY_ERROR));
      });
      if (result.error) reject(result.value);
      return capability.promise;
    }
  });
  /***/
},
/* 475 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $ = __webpack_require__(0);

  var IS_PURE = __webpack_require__(31);

  var NativePromise = __webpack_require__(218);

  var fails = __webpack_require__(2);

  var getBuiltIn = __webpack_require__(26);

  var isCallable = __webpack_require__(17);

  var speciesConstructor = __webpack_require__(80);

  var promiseResolve = __webpack_require__(228);

  var redefine = __webpack_require__(24); // Safari bug https://bugs.webkit.org/show_bug.cgi?id=200829


  var NON_GENERIC = !!NativePromise && fails(function () {
    // eslint-disable-next-line unicorn/no-thenable -- required for testing
    NativePromise.prototype['finally'].call({
      then: function then() {
        /* empty */
      }
    }, function () {
      /* empty */
    });
  }); // `Promise.prototype.finally` method
  // https://tc39.es/ecma262/#sec-promise.prototype.finally

  $({
    target: 'Promise',
    proto: true,
    real: true,
    forced: NON_GENERIC
  }, {
    'finally': function _finally(onFinally) {
      var C = speciesConstructor(this, getBuiltIn('Promise'));
      var isFunction = isCallable(onFinally);
      return this.then(isFunction ? function (x) {
        return promiseResolve(C, onFinally()).then(function () {
          return x;
        });
      } : onFinally, isFunction ? function (e) {
        return promiseResolve(C, onFinally()).then(function () {
          throw e;
        });
      } : onFinally);
    }
  }); // makes sure that native promise-based APIs `Promise#finally` properly works with patched `Promise#then`

  if (!IS_PURE && isCallable(NativePromise)) {
    var method = getBuiltIn('Promise').prototype['finally'];

    if (NativePromise.prototype['finally'] !== method) {
      redefine(NativePromise.prototype, 'finally', method, {
        unsafe: true
      });
    }
  }
  /***/

},
/* 476 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $ = __webpack_require__(0);

  var IS_PURE = __webpack_require__(31);

  var global = __webpack_require__(1);

  var getBuiltIn = __webpack_require__(26);

  var call = __webpack_require__(19);

  var NativePromise = __webpack_require__(218);

  var redefine = __webpack_require__(24);

  var redefineAll = __webpack_require__(78);

  var setPrototypeOf = __webpack_require__(52);

  var setToStringTag = __webpack_require__(49);

  var setSpecies = __webpack_require__(79);

  var aCallable = __webpack_require__(34);

  var isCallable = __webpack_require__(17);

  var isObject = __webpack_require__(13);

  var anInstance = __webpack_require__(50);

  var inspectSource = __webpack_require__(117);

  var iterate = __webpack_require__(59);

  var checkCorrectnessOfIteration = __webpack_require__(110);

  var speciesConstructor = __webpack_require__(80);

  var task = __webpack_require__(167).set;

  var microtask = __webpack_require__(217);

  var promiseResolve = __webpack_require__(228);

  var hostReportErrors = __webpack_require__(351);

  var newPromiseCapabilityModule = __webpack_require__(119);

  var perform = __webpack_require__(161);

  var Queue = __webpack_require__(356);

  var InternalStateModule = __webpack_require__(27);

  var isForced = __webpack_require__(93);

  var wellKnownSymbol = __webpack_require__(15);

  var IS_BROWSER = __webpack_require__(348);

  var IS_NODE = __webpack_require__(69);

  var V8_VERSION = __webpack_require__(64);

  var SPECIES = wellKnownSymbol('species');
  var PROMISE = 'Promise';
  var getInternalState = InternalStateModule.getterFor(PROMISE);
  var setInternalState = InternalStateModule.set;
  var getInternalPromiseState = InternalStateModule.getterFor(PROMISE);
  var NativePromisePrototype = NativePromise && NativePromise.prototype;
  var PromiseConstructor = NativePromise;
  var PromisePrototype = NativePromisePrototype;
  var TypeError = global.TypeError;
  var document = global.document;
  var process = global.process;
  var newPromiseCapability = newPromiseCapabilityModule.f;
  var newGenericPromiseCapability = newPromiseCapability;
  var DISPATCH_EVENT = !!(document && document.createEvent && global.dispatchEvent);
  var NATIVE_REJECTION_EVENT = isCallable(global.PromiseRejectionEvent);
  var UNHANDLED_REJECTION = 'unhandledrejection';
  var REJECTION_HANDLED = 'rejectionhandled';
  var PENDING = 0;
  var FULFILLED = 1;
  var REJECTED = 2;
  var HANDLED = 1;
  var UNHANDLED = 2;
  var SUBCLASSING = false;
  var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;
  var FORCED = isForced(PROMISE, function () {
    var PROMISE_CONSTRUCTOR_SOURCE = inspectSource(PromiseConstructor);
    var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(PromiseConstructor); // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
    // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
    // We can't detect it synchronously, so just check versions

    if (!GLOBAL_CORE_JS_PROMISE && V8_VERSION === 66) return true; // We need Promise#finally in the pure version for preventing prototype pollution

    if (IS_PURE && !PromisePrototype['finally']) return true; // We can't use @@species feature detection in V8 since it causes
    // deoptimization and performance degradation
    // https://github.com/zloirock/core-js/issues/679

    if (V8_VERSION >= 51 && /native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) return false; // Detect correctness of subclassing with @@species support

    var promise = new PromiseConstructor(function (resolve) {
      resolve(1);
    });

    var FakePromise = function FakePromise(exec) {
      exec(function () {
        /* empty */
      }, function () {
        /* empty */
      });
    };

    var constructor = promise.constructor = {};
    constructor[SPECIES] = FakePromise;
    SUBCLASSING = promise.then(function () {
      /* empty */
    }) instanceof FakePromise;
    if (!SUBCLASSING) return true; // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test

    return !GLOBAL_CORE_JS_PROMISE && IS_BROWSER && !NATIVE_REJECTION_EVENT;
  });
  var INCORRECT_ITERATION = FORCED || !checkCorrectnessOfIteration(function (iterable) {
    PromiseConstructor.all(iterable)['catch'](function () {
      /* empty */
    });
  }); // helpers

  var isThenable = function isThenable(it) {
    var then;
    return isObject(it) && isCallable(then = it.then) ? then : false;
  };

  var callReaction = function callReaction(reaction, state) {
    var value = state.value;
    var ok = state.state == FULFILLED;
    var handler = ok ? reaction.ok : reaction.fail;
    var resolve = reaction.resolve;
    var reject = reaction.reject;
    var domain = reaction.domain;
    var result, then, exited;

    try {
      if (handler) {
        if (!ok) {
          if (state.rejection === UNHANDLED) onHandleUnhandled(state);
          state.rejection = HANDLED;
        }

        if (handler === true) result = value;else {
          if (domain) domain.enter();
          result = handler(value); // can throw

          if (domain) {
            domain.exit();
            exited = true;
          }
        }

        if (result === reaction.promise) {
          reject(TypeError('Promise-chain cycle'));
        } else if (then = isThenable(result)) {
          call(then, result, resolve, reject);
        } else resolve(result);
      } else reject(value);
    } catch (error) {
      if (domain && !exited) domain.exit();
      reject(error);
    }
  };

  var notify = function notify(state, isReject) {
    if (state.notified) return;
    state.notified = true;
    microtask(function () {
      var reactions = state.reactions;
      var reaction;

      while (reaction = reactions.get()) {
        callReaction(reaction, state);
      }

      state.notified = false;
      if (isReject && !state.rejection) onUnhandled(state);
    });
  };

  var dispatchEvent = function dispatchEvent(name, promise, reason) {
    var event, handler;

    if (DISPATCH_EVENT) {
      event = document.createEvent('Event');
      event.promise = promise;
      event.reason = reason;
      event.initEvent(name, false, true);
      global.dispatchEvent(event);
    } else event = {
      promise: promise,
      reason: reason
    };

    if (!NATIVE_REJECTION_EVENT && (handler = global['on' + name])) handler(event);else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
  };

  var onUnhandled = function onUnhandled(state) {
    call(task, global, function () {
      var promise = state.facade;
      var value = state.value;
      var IS_UNHANDLED = isUnhandled(state);
      var result;

      if (IS_UNHANDLED) {
        result = perform(function () {
          if (IS_NODE) {
            process.emit('unhandledRejection', value, promise);
          } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
        }); // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should

        state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
        if (result.error) throw result.value;
      }
    });
  };

  var isUnhandled = function isUnhandled(state) {
    return state.rejection !== HANDLED && !state.parent;
  };

  var onHandleUnhandled = function onHandleUnhandled(state) {
    call(task, global, function () {
      var promise = state.facade;

      if (IS_NODE) {
        process.emit('rejectionHandled', promise);
      } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
    });
  };

  var bind = function bind(fn, state, unwrap) {
    return function (value) {
      fn(state, value, unwrap);
    };
  };

  var internalReject = function internalReject(state, value, unwrap) {
    if (state.done) return;
    state.done = true;
    if (unwrap) state = unwrap;
    state.value = value;
    state.state = REJECTED;
    notify(state, true);
  };

  var internalResolve = function internalResolve(state, value, unwrap) {
    if (state.done) return;
    state.done = true;
    if (unwrap) state = unwrap;

    try {
      if (state.facade === value) throw TypeError("Promise can't be resolved itself");
      var then = isThenable(value);

      if (then) {
        microtask(function () {
          var wrapper = {
            done: false
          };

          try {
            call(then, value, bind(internalResolve, wrapper, state), bind(internalReject, wrapper, state));
          } catch (error) {
            internalReject(wrapper, error, state);
          }
        });
      } else {
        state.value = value;
        state.state = FULFILLED;
        notify(state, false);
      }
    } catch (error) {
      internalReject({
        done: false
      }, error, state);
    }
  }; // constructor polyfill


  if (FORCED) {
    // 25.4.3.1 Promise(executor)
    PromiseConstructor = function Promise(executor) {
      anInstance(this, PromisePrototype);
      aCallable(executor);
      call(Internal, this);
      var state = getInternalState(this);

      try {
        executor(bind(internalResolve, state), bind(internalReject, state));
      } catch (error) {
        internalReject(state, error);
      }
    };

    PromisePrototype = PromiseConstructor.prototype; // eslint-disable-next-line no-unused-vars -- required for `.length`

    Internal = function Promise(executor) {
      setInternalState(this, {
        type: PROMISE,
        done: false,
        notified: false,
        parent: false,
        reactions: new Queue(),
        rejection: false,
        state: PENDING,
        value: undefined
      });
    };

    Internal.prototype = redefineAll(PromisePrototype, {
      // `Promise.prototype.then` method
      // https://tc39.es/ecma262/#sec-promise.prototype.then
      // eslint-disable-next-line unicorn/no-thenable -- safe
      then: function then(onFulfilled, onRejected) {
        var state = getInternalPromiseState(this);
        var reaction = newPromiseCapability(speciesConstructor(this, PromiseConstructor));
        state.parent = true;
        reaction.ok = isCallable(onFulfilled) ? onFulfilled : true;
        reaction.fail = isCallable(onRejected) && onRejected;
        reaction.domain = IS_NODE ? process.domain : undefined;
        if (state.state == PENDING) state.reactions.add(reaction);else microtask(function () {
          callReaction(reaction, state);
        });
        return reaction.promise;
      },
      // `Promise.prototype.catch` method
      // https://tc39.es/ecma262/#sec-promise.prototype.catch
      'catch': function _catch(onRejected) {
        return this.then(undefined, onRejected);
      }
    });

    OwnPromiseCapability = function OwnPromiseCapability() {
      var promise = new Internal();
      var state = getInternalState(promise);
      this.promise = promise;
      this.resolve = bind(internalResolve, state);
      this.reject = bind(internalReject, state);
    };

    newPromiseCapabilityModule.f = newPromiseCapability = function newPromiseCapability(C) {
      return C === PromiseConstructor || C === PromiseWrapper ? new OwnPromiseCapability(C) : newGenericPromiseCapability(C);
    };

    if (!IS_PURE && isCallable(NativePromise) && NativePromisePrototype !== Object.prototype) {
      nativeThen = NativePromisePrototype.then;

      if (!SUBCLASSING) {
        // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
        redefine(NativePromisePrototype, 'then', function then(onFulfilled, onRejected) {
          var that = this;
          return new PromiseConstructor(function (resolve, reject) {
            call(nativeThen, that, resolve, reject);
          }).then(onFulfilled, onRejected); // https://github.com/zloirock/core-js/issues/640
        }, {
          unsafe: true
        }); // makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`

        redefine(NativePromisePrototype, 'catch', PromisePrototype['catch'], {
          unsafe: true
        });
      } // make `.constructor === Promise` work for native promise-based APIs


      try {
        delete NativePromisePrototype.constructor;
      } catch (error) {
        /* empty */
      } // make `instanceof Promise` work for native promise-based APIs


      if (setPrototypeOf) {
        setPrototypeOf(NativePromisePrototype, PromisePrototype);
      }
    }
  }

  $({
    global: true,
    wrap: true,
    forced: FORCED
  }, {
    Promise: PromiseConstructor
  });
  setToStringTag(PromiseConstructor, PROMISE, false, true);
  setSpecies(PROMISE);
  PromiseWrapper = getBuiltIn(PROMISE); // statics

  $({
    target: PROMISE,
    stat: true,
    forced: FORCED
  }, {
    // `Promise.reject` method
    // https://tc39.es/ecma262/#sec-promise.reject
    reject: function reject(r) {
      var capability = newPromiseCapability(this);
      call(capability.reject, undefined, r);
      return capability.promise;
    }
  });
  $({
    target: PROMISE,
    stat: true,
    forced: IS_PURE || FORCED
  }, {
    // `Promise.resolve` method
    // https://tc39.es/ecma262/#sec-promise.resolve
    resolve: function resolve(x) {
      return promiseResolve(IS_PURE && this === PromiseWrapper ? PromiseConstructor : this, x);
    }
  });
  $({
    target: PROMISE,
    stat: true,
    forced: INCORRECT_ITERATION
  }, {
    // `Promise.all` method
    // https://tc39.es/ecma262/#sec-promise.all
    all: function all(iterable) {
      var C = this;
      var capability = newPromiseCapability(C);
      var resolve = capability.resolve;
      var reject = capability.reject;
      var result = perform(function () {
        var $promiseResolve = aCallable(C.resolve);
        var values = [];
        var counter = 0;
        var remaining = 1;
        iterate(iterable, function (promise) {
          var index = counter++;
          var alreadyCalled = false;
          remaining++;
          call($promiseResolve, C, promise).then(function (value) {
            if (alreadyCalled) return;
            alreadyCalled = true;
            values[index] = value;
            --remaining || resolve(values);
          }, reject);
        });
        --remaining || resolve(values);
      });
      if (result.error) reject(result.value);
      return capability.promise;
    },
    // `Promise.race` method
    // https://tc39.es/ecma262/#sec-promise.race
    race: function race(iterable) {
      var C = this;
      var capability = newPromiseCapability(C);
      var reject = capability.reject;
      var result = perform(function () {
        var $promiseResolve = aCallable(C.resolve);
        iterate(iterable, function (promise) {
          call($promiseResolve, C, promise).then(capability.resolve, reject);
        });
      });
      if (result.error) reject(result.value);
      return capability.promise;
    }
  });
  /***/
},
/* 477 */

/***/
function (module, exports, __webpack_require__) {
  var $ = __webpack_require__(0);

  var functionApply = __webpack_require__(40);

  var aCallable = __webpack_require__(34);

  var anObject = __webpack_require__(10);

  var fails = __webpack_require__(2); // MS Edge argumentsList argument is optional


  var OPTIONAL_ARGUMENTS_LIST = !fails(function () {
    // eslint-disable-next-line es/no-reflect -- required for testing
    Reflect.apply(function () {
      /* empty */
    });
  }); // `Reflect.apply` method
  // https://tc39.es/ecma262/#sec-reflect.apply

  $({
    target: 'Reflect',
    stat: true,
    forced: OPTIONAL_ARGUMENTS_LIST
  }, {
    apply: function apply(target, thisArgument, argumentsList) {
      return functionApply(aCallable(target), thisArgument, anObject(argumentsList));
    }
  });
  /***/
},
/* 478 */

/***/
function (module, exports, __webpack_require__) {
  var $ = __webpack_require__(0);

  var getBuiltIn = __webpack_require__(26);

  var apply = __webpack_require__(40);

  var bind = __webpack_require__(207);

  var aConstructor = __webpack_require__(141);

  var anObject = __webpack_require__(10);

  var isObject = __webpack_require__(13);

  var create = __webpack_require__(41);

  var fails = __webpack_require__(2);

  var nativeConstruct = getBuiltIn('Reflect', 'construct');
  var ObjectPrototype = Object.prototype;
  var push = [].push; // `Reflect.construct` method
  // https://tc39.es/ecma262/#sec-reflect.construct
  // MS Edge supports only 2 arguments and argumentsList argument is optional
  // FF Nightly sets third argument as `new.target`, but does not create `this` from it

  var NEW_TARGET_BUG = fails(function () {
    function F() {
      /* empty */
    }

    return !(nativeConstruct(function () {
      /* empty */
    }, [], F) instanceof F);
  });
  var ARGS_BUG = !fails(function () {
    nativeConstruct(function () {
      /* empty */
    });
  });
  var FORCED = NEW_TARGET_BUG || ARGS_BUG;
  $({
    target: 'Reflect',
    stat: true,
    forced: FORCED,
    sham: FORCED
  }, {
    construct: function construct(Target, args
    /* , newTarget */
    ) {
      aConstructor(Target);
      anObject(args);
      var newTarget = arguments.length < 3 ? Target : aConstructor(arguments[2]);
      if (ARGS_BUG && !NEW_TARGET_BUG) return nativeConstruct(Target, args, newTarget);

      if (Target == newTarget) {
        // w/o altered newTarget, optimization for 0-4 arguments
        switch (args.length) {
          case 0:
            return new Target();

          case 1:
            return new Target(args[0]);

          case 2:
            return new Target(args[0], args[1]);

          case 3:
            return new Target(args[0], args[1], args[2]);

          case 4:
            return new Target(args[0], args[1], args[2], args[3]);
        } // w/o altered newTarget, lot of arguments case


        var $args = [null];
        apply(push, $args, args);
        return new (apply(bind, Target, $args))();
      } // with altered newTarget, not support built-in constructors


      var proto = newTarget.prototype;
      var instance = create(isObject(proto) ? proto : ObjectPrototype);
      var result = apply(Target, instance, args);
      return isObject(result) ? result : instance;
    }
  });
  /***/
},
/* 479 */

/***/
function (module, exports, __webpack_require__) {
  var $ = __webpack_require__(0);

  var DESCRIPTORS = __webpack_require__(12);

  var anObject = __webpack_require__(10);

  var toPropertyKey = __webpack_require__(66);

  var definePropertyModule = __webpack_require__(20);

  var fails = __webpack_require__(2); // MS Edge has broken Reflect.defineProperty - throwing instead of returning false


  var ERROR_INSTEAD_OF_FALSE = fails(function () {
    // eslint-disable-next-line es/no-reflect -- required for testing
    Reflect.defineProperty(definePropertyModule.f({}, 1, {
      value: 1
    }), 1, {
      value: 2
    });
  }); // `Reflect.defineProperty` method
  // https://tc39.es/ecma262/#sec-reflect.defineproperty

  $({
    target: 'Reflect',
    stat: true,
    forced: ERROR_INSTEAD_OF_FALSE,
    sham: !DESCRIPTORS
  }, {
    defineProperty: function defineProperty(target, propertyKey, attributes) {
      anObject(target);
      var key = toPropertyKey(propertyKey);
      anObject(attributes);

      try {
        definePropertyModule.f(target, key, attributes);
        return true;
      } catch (error) {
        return false;
      }
    }
  });
  /***/
},
/* 480 */

/***/
function (module, exports, __webpack_require__) {
  var $ = __webpack_require__(0);

  var anObject = __webpack_require__(10);

  var getOwnPropertyDescriptor = __webpack_require__(32).f; // `Reflect.deleteProperty` method
  // https://tc39.es/ecma262/#sec-reflect.deleteproperty


  $({
    target: 'Reflect',
    stat: true
  }, {
    deleteProperty: function deleteProperty(target, propertyKey) {
      var descriptor = getOwnPropertyDescriptor(anObject(target), propertyKey);
      return descriptor && !descriptor.configurable ? false : delete target[propertyKey];
    }
  });
  /***/
},
/* 481 */

/***/
function (module, exports, __webpack_require__) {
  var $ = __webpack_require__(0);

  var DESCRIPTORS = __webpack_require__(12);

  var anObject = __webpack_require__(10);

  var getOwnPropertyDescriptorModule = __webpack_require__(32); // `Reflect.getOwnPropertyDescriptor` method
  // https://tc39.es/ecma262/#sec-reflect.getownpropertydescriptor


  $({
    target: 'Reflect',
    stat: true,
    sham: !DESCRIPTORS
  }, {
    getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
      return getOwnPropertyDescriptorModule.f(anObject(target), propertyKey);
    }
  });
  /***/
},
/* 482 */

/***/
function (module, exports, __webpack_require__) {
  var $ = __webpack_require__(0);

  var anObject = __webpack_require__(10);

  var objectGetPrototypeOf = __webpack_require__(48);

  var CORRECT_PROTOTYPE_GETTER = __webpack_require__(147); // `Reflect.getPrototypeOf` method
  // https://tc39.es/ecma262/#sec-reflect.getprototypeof


  $({
    target: 'Reflect',
    stat: true,
    sham: !CORRECT_PROTOTYPE_GETTER
  }, {
    getPrototypeOf: function getPrototypeOf(target) {
      return objectGetPrototypeOf(anObject(target));
    }
  });
  /***/
},
/* 483 */

/***/
function (module, exports, __webpack_require__) {
  var $ = __webpack_require__(0);

  var call = __webpack_require__(19);

  var isObject = __webpack_require__(13);

  var anObject = __webpack_require__(10);

  var isDataDescriptor = __webpack_require__(212);

  var getOwnPropertyDescriptorModule = __webpack_require__(32);

  var getPrototypeOf = __webpack_require__(48); // `Reflect.get` method
  // https://tc39.es/ecma262/#sec-reflect.get


  function get(target, propertyKey
  /* , receiver */
  ) {
    var receiver = arguments.length < 3 ? target : arguments[2];
    var descriptor, prototype;
    if (anObject(target) === receiver) return target[propertyKey];
    descriptor = getOwnPropertyDescriptorModule.f(target, propertyKey);
    if (descriptor) return isDataDescriptor(descriptor) ? descriptor.value : descriptor.get === undefined ? undefined : call(descriptor.get, receiver);
    if (isObject(prototype = getPrototypeOf(target))) return get(prototype, propertyKey, receiver);
  }

  $({
    target: 'Reflect',
    stat: true
  }, {
    get: get
  });
  /***/
},
/* 484 */

/***/
function (module, exports, __webpack_require__) {
  var $ = __webpack_require__(0); // `Reflect.has` method
  // https://tc39.es/ecma262/#sec-reflect.has


  $({
    target: 'Reflect',
    stat: true
  }, {
    has: function has(target, propertyKey) {
      return propertyKey in target;
    }
  });
  /***/
},
/* 485 */

/***/
function (module, exports, __webpack_require__) {
  var $ = __webpack_require__(0);

  var anObject = __webpack_require__(10);

  var $isExtensible = __webpack_require__(120); // `Reflect.isExtensible` method
  // https://tc39.es/ecma262/#sec-reflect.isextensible


  $({
    target: 'Reflect',
    stat: true
  }, {
    isExtensible: function isExtensible(target) {
      anObject(target);
      return $isExtensible(target);
    }
  });
  /***/
},
/* 486 */

/***/
function (module, exports, __webpack_require__) {
  var $ = __webpack_require__(0);

  var ownKeys = __webpack_require__(160); // `Reflect.ownKeys` method
  // https://tc39.es/ecma262/#sec-reflect.ownkeys


  $({
    target: 'Reflect',
    stat: true
  }, {
    ownKeys: ownKeys
  });
  /***/
},
/* 487 */

/***/
function (module, exports, __webpack_require__) {
  var $ = __webpack_require__(0);

  var getBuiltIn = __webpack_require__(26);

  var anObject = __webpack_require__(10);

  var FREEZING = __webpack_require__(88); // `Reflect.preventExtensions` method
  // https://tc39.es/ecma262/#sec-reflect.preventextensions


  $({
    target: 'Reflect',
    stat: true,
    sham: !FREEZING
  }, {
    preventExtensions: function preventExtensions(target) {
      anObject(target);

      try {
        var objectPreventExtensions = getBuiltIn('Object', 'preventExtensions');
        if (objectPreventExtensions) objectPreventExtensions(target);
        return true;
      } catch (error) {
        return false;
      }
    }
  });
  /***/
},
/* 488 */

/***/
function (module, exports, __webpack_require__) {
  var $ = __webpack_require__(0);

  var anObject = __webpack_require__(10);

  var aPossiblePrototype = __webpack_require__(192);

  var objectSetPrototypeOf = __webpack_require__(52); // `Reflect.setPrototypeOf` method
  // https://tc39.es/ecma262/#sec-reflect.setprototypeof


  if (objectSetPrototypeOf) $({
    target: 'Reflect',
    stat: true
  }, {
    setPrototypeOf: function setPrototypeOf(target, proto) {
      anObject(target);
      aPossiblePrototype(proto);

      try {
        objectSetPrototypeOf(target, proto);
        return true;
      } catch (error) {
        return false;
      }
    }
  });
  /***/
},
/* 489 */

/***/
function (module, exports, __webpack_require__) {
  var $ = __webpack_require__(0);

  var call = __webpack_require__(19);

  var anObject = __webpack_require__(10);

  var isObject = __webpack_require__(13);

  var isDataDescriptor = __webpack_require__(212);

  var fails = __webpack_require__(2);

  var definePropertyModule = __webpack_require__(20);

  var getOwnPropertyDescriptorModule = __webpack_require__(32);

  var getPrototypeOf = __webpack_require__(48);

  var createPropertyDescriptor = __webpack_require__(47); // `Reflect.set` method
  // https://tc39.es/ecma262/#sec-reflect.set


  function set(target, propertyKey, V
  /* , receiver */
  ) {
    var receiver = arguments.length < 4 ? target : arguments[3];
    var ownDescriptor = getOwnPropertyDescriptorModule.f(anObject(target), propertyKey);
    var existingDescriptor, prototype, setter;

    if (!ownDescriptor) {
      if (isObject(prototype = getPrototypeOf(target))) {
        return set(prototype, propertyKey, V, receiver);
      }

      ownDescriptor = createPropertyDescriptor(0);
    }

    if (isDataDescriptor(ownDescriptor)) {
      if (ownDescriptor.writable === false || !isObject(receiver)) return false;

      if (existingDescriptor = getOwnPropertyDescriptorModule.f(receiver, propertyKey)) {
        if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
        existingDescriptor.value = V;
        definePropertyModule.f(receiver, propertyKey, existingDescriptor);
      } else definePropertyModule.f(receiver, propertyKey, createPropertyDescriptor(0, V));
    } else {
      setter = ownDescriptor.set;
      if (setter === undefined) return false;
      call(setter, receiver, V);
    }

    return true;
  } // MS Edge 17-18 Reflect.set allows setting the property to object
  // with non-writable property on the prototype


  var MS_EDGE_BUG = fails(function () {
    var Constructor = function Constructor() {
      /* empty */
    };

    var object = definePropertyModule.f(new Constructor(), 'a', {
      configurable: true
    }); // eslint-disable-next-line es/no-reflect -- required for testing

    return Reflect.set(Constructor.prototype, 'a', 1, object) !== false;
  });
  $({
    target: 'Reflect',
    stat: true,
    forced: MS_EDGE_BUG
  }, {
    set: set
  });
  /***/
},
/* 490 */

/***/
function (module, exports, __webpack_require__) {
  var $ = __webpack_require__(0);

  var global = __webpack_require__(1);

  var setToStringTag = __webpack_require__(49);

  $({
    global: true
  }, {
    Reflect: {}
  }); // Reflect[@@toStringTag] property
  // https://tc39.es/ecma262/#sec-reflect-@@tostringtag

  setToStringTag(global.Reflect, 'Reflect', true);
  /***/
},
/* 491 */

/***/
function (module, exports, __webpack_require__) {
  var DESCRIPTORS = __webpack_require__(12);

  var global = __webpack_require__(1);

  var uncurryThis = __webpack_require__(3);

  var isForced = __webpack_require__(93);

  var inheritIfRequired = __webpack_require__(75);

  var createNonEnumerableProperty = __webpack_require__(35);

  var defineProperty = __webpack_require__(20).f;

  var getOwnPropertyNames = __webpack_require__(65).f;

  var isPrototypeOf = __webpack_require__(42);

  var isRegExp = __webpack_require__(94);

  var toString = __webpack_require__(18);

  var regExpFlags = __webpack_require__(72);

  var stickyHelpers = __webpack_require__(124);

  var redefine = __webpack_require__(24);

  var fails = __webpack_require__(2);

  var hasOwn = __webpack_require__(21);

  var enforceInternalState = __webpack_require__(27).enforce;

  var setSpecies = __webpack_require__(79);

  var wellKnownSymbol = __webpack_require__(15);

  var UNSUPPORTED_DOT_ALL = __webpack_require__(162);

  var UNSUPPORTED_NCG = __webpack_require__(229);

  var MATCH = wellKnownSymbol('match');
  var NativeRegExp = global.RegExp;
  var RegExpPrototype = NativeRegExp.prototype;
  var SyntaxError = global.SyntaxError;
  var getFlags = uncurryThis(regExpFlags);
  var exec = uncurryThis(RegExpPrototype.exec);
  var charAt = uncurryThis(''.charAt);
  var replace = uncurryThis(''.replace);
  var stringIndexOf = uncurryThis(''.indexOf);
  var stringSlice = uncurryThis(''.slice); // TODO: Use only propper RegExpIdentifierName

  var IS_NCG = /^\?<[^\s\d!#%&*+<=>@^][^\s!#%&*+<=>@^]*>/;
  var re1 = /a/g;
  var re2 = /a/g; // "new" should create a new object, old webkit bug

  var CORRECT_NEW = new NativeRegExp(re1) !== re1;
  var MISSED_STICKY = stickyHelpers.MISSED_STICKY;
  var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y;
  var BASE_FORCED = DESCRIPTORS && (!CORRECT_NEW || MISSED_STICKY || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG || fails(function () {
    re2[MATCH] = false; // RegExp constructor can alter flags and IsRegExp works correct with @@match

    return NativeRegExp(re1) != re1 || NativeRegExp(re2) == re2 || NativeRegExp(re1, 'i') != '/a/i';
  }));

  var handleDotAll = function handleDotAll(string) {
    var length = string.length;
    var index = 0;
    var result = '';
    var brackets = false;
    var chr;

    for (; index <= length; index++) {
      chr = charAt(string, index);

      if (chr === '\\') {
        result += chr + charAt(string, ++index);
        continue;
      }

      if (!brackets && chr === '.') {
        result += '[\\s\\S]';
      } else {
        if (chr === '[') {
          brackets = true;
        } else if (chr === ']') {
          brackets = false;
        }

        result += chr;
      }
    }

    return result;
  };

  var handleNCG = function handleNCG(string) {
    var length = string.length;
    var index = 0;
    var result = '';
    var named = [];
    var names = {};
    var brackets = false;
    var ncg = false;
    var groupid = 0;
    var groupname = '';
    var chr;

    for (; index <= length; index++) {
      chr = charAt(string, index);

      if (chr === '\\') {
        chr = chr + charAt(string, ++index);
      } else if (chr === ']') {
        brackets = false;
      } else if (!brackets) switch (true) {
        case chr === '[':
          brackets = true;
          break;

        case chr === '(':
          if (exec(IS_NCG, stringSlice(string, index + 1))) {
            index += 2;
            ncg = true;
          }

          result += chr;
          groupid++;
          continue;

        case chr === '>' && ncg:
          if (groupname === '' || hasOwn(names, groupname)) {
            throw new SyntaxError('Invalid capture group name');
          }

          names[groupname] = true;
          named[named.length] = [groupname, groupid];
          ncg = false;
          groupname = '';
          continue;
      }

      if (ncg) groupname += chr;else result += chr;
    }

    return [result, named];
  }; // `RegExp` constructor
  // https://tc39.es/ecma262/#sec-regexp-constructor


  if (isForced('RegExp', BASE_FORCED)) {
    var RegExpWrapper = function RegExp(pattern, flags) {
      var thisIsRegExp = isPrototypeOf(RegExpPrototype, this);
      var patternIsRegExp = isRegExp(pattern);
      var flagsAreUndefined = flags === undefined;
      var groups = [];
      var rawPattern = pattern;
      var rawFlags, dotAll, sticky, handled, result, state;

      if (!thisIsRegExp && patternIsRegExp && flagsAreUndefined && pattern.constructor === RegExpWrapper) {
        return pattern;
      }

      if (patternIsRegExp || isPrototypeOf(RegExpPrototype, pattern)) {
        pattern = pattern.source;
        if (flagsAreUndefined) flags = 'flags' in rawPattern ? rawPattern.flags : getFlags(rawPattern);
      }

      pattern = pattern === undefined ? '' : toString(pattern);
      flags = flags === undefined ? '' : toString(flags);
      rawPattern = pattern;

      if (UNSUPPORTED_DOT_ALL && 'dotAll' in re1) {
        dotAll = !!flags && stringIndexOf(flags, 's') > -1;
        if (dotAll) flags = replace(flags, /s/g, '');
      }

      rawFlags = flags;

      if (MISSED_STICKY && 'sticky' in re1) {
        sticky = !!flags && stringIndexOf(flags, 'y') > -1;
        if (sticky && UNSUPPORTED_Y) flags = replace(flags, /y/g, '');
      }

      if (UNSUPPORTED_NCG) {
        handled = handleNCG(pattern);
        pattern = handled[0];
        groups = handled[1];
      }

      result = inheritIfRequired(NativeRegExp(pattern, flags), thisIsRegExp ? this : RegExpPrototype, RegExpWrapper);

      if (dotAll || sticky || groups.length) {
        state = enforceInternalState(result);

        if (dotAll) {
          state.dotAll = true;
          state.raw = RegExpWrapper(handleDotAll(pattern), rawFlags);
        }

        if (sticky) state.sticky = true;
        if (groups.length) state.groups = groups;
      }

      if (pattern !== rawPattern) try {
        // fails in old engines, but we have no alternatives for unsupported regex syntax
        createNonEnumerableProperty(result, 'source', rawPattern === '' ? '(?:)' : rawPattern);
      } catch (error) {
        /* empty */
      }
      return result;
    };

    var proxy = function proxy(key) {
      key in RegExpWrapper || defineProperty(RegExpWrapper, key, {
        configurable: true,
        get: function get() {
          return NativeRegExp[key];
        },
        set: function set(it) {
          NativeRegExp[key] = it;
        }
      });
    };

    for (var keys = getOwnPropertyNames(NativeRegExp), index = 0; keys.length > index;) {
      proxy(keys[index++]);
    }

    RegExpPrototype.constructor = RegExpWrapper;
    RegExpWrapper.prototype = RegExpPrototype;
    redefine(global, 'RegExp', RegExpWrapper);
  } // https://tc39.es/ecma262/#sec-get-regexp-@@species


  setSpecies('RegExp');
  /***/
},
/* 492 */

/***/
function (module, exports, __webpack_require__) {
  var global = __webpack_require__(1);

  var DESCRIPTORS = __webpack_require__(12);

  var UNSUPPORTED_DOT_ALL = __webpack_require__(162);

  var classof = __webpack_require__(38);

  var defineProperty = __webpack_require__(20).f;

  var getInternalState = __webpack_require__(27).get;

  var RegExpPrototype = RegExp.prototype;
  var TypeError = global.TypeError; // `RegExp.prototype.dotAll` getter
  // https://tc39.es/ecma262/#sec-get-regexp.prototype.dotall

  if (DESCRIPTORS && UNSUPPORTED_DOT_ALL) {
    defineProperty(RegExpPrototype, 'dotAll', {
      configurable: true,
      get: function get() {
        if (this === RegExpPrototype) return undefined; // We can't use InternalStateModule.getterFor because
        // we don't add metadata for regexps created by a literal.

        if (classof(this) === 'RegExp') {
          return !!getInternalState(this).dotAll;
        }

        throw TypeError('Incompatible receiver, RegExp required');
      }
    });
  }
  /***/

},
/* 493 */

/***/
function (module, exports, __webpack_require__) {
  var DESCRIPTORS = __webpack_require__(12);

  var objectDefinePropertyModule = __webpack_require__(20);

  var regExpFlags = __webpack_require__(72);

  var fails = __webpack_require__(2);

  var RegExpPrototype = RegExp.prototype;
  var FORCED = DESCRIPTORS && fails(function () {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    return Object.getOwnPropertyDescriptor(RegExpPrototype, 'flags').get.call({
      dotAll: true,
      sticky: true
    }) !== 'sy';
  }); // `RegExp.prototype.flags` getter
  // https://tc39.es/ecma262/#sec-get-regexp.prototype.flags

  if (FORCED) objectDefinePropertyModule.f(RegExpPrototype, 'flags', {
    configurable: true,
    get: regExpFlags
  });
  /***/
},
/* 494 */

/***/
function (module, exports, __webpack_require__) {
  var global = __webpack_require__(1);

  var DESCRIPTORS = __webpack_require__(12);

  var MISSED_STICKY = __webpack_require__(124).MISSED_STICKY;

  var classof = __webpack_require__(38);

  var defineProperty = __webpack_require__(20).f;

  var getInternalState = __webpack_require__(27).get;

  var RegExpPrototype = RegExp.prototype;
  var TypeError = global.TypeError; // `RegExp.prototype.sticky` getter
  // https://tc39.es/ecma262/#sec-get-regexp.prototype.sticky

  if (DESCRIPTORS && MISSED_STICKY) {
    defineProperty(RegExpPrototype, 'sticky', {
      configurable: true,
      get: function get() {
        if (this === RegExpPrototype) return undefined; // We can't use InternalStateModule.getterFor because
        // we don't add metadata for regexps created by a literal.

        if (classof(this) === 'RegExp') {
          return !!getInternalState(this).sticky;
        }

        throw TypeError('Incompatible receiver, RegExp required');
      }
    });
  }
  /***/

},
/* 495 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // TODO: Remove from `core-js@4` since it's moved to entry points

  __webpack_require__(171);

  var $ = __webpack_require__(0);

  var global = __webpack_require__(1);

  var call = __webpack_require__(19);

  var uncurryThis = __webpack_require__(3);

  var isCallable = __webpack_require__(17);

  var isObject = __webpack_require__(13);

  var DELEGATES_TO_EXEC = function () {
    var execCalled = false;
    var re = /[ac]/;

    re.exec = function () {
      execCalled = true;
      return /./.exec.apply(this, arguments);
    };

    return re.test('abc') === true && execCalled;
  }();

  var Error = global.Error;
  var un$Test = uncurryThis(/./.test); // `RegExp.prototype.test` method
  // https://tc39.es/ecma262/#sec-regexp.prototype.test

  $({
    target: 'RegExp',
    proto: true,
    forced: !DELEGATES_TO_EXEC
  }, {
    test: function test(str) {
      var exec = this.exec;
      if (!isCallable(exec)) return un$Test(this, str);
      var result = call(exec, this, str);

      if (result !== null && !isObject(result)) {
        throw new Error('RegExp exec method returned something other than an Object or null');
      }

      return !!result;
    }
  });
  /***/
},
/* 496 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var uncurryThis = __webpack_require__(3);

  var PROPER_FUNCTION_NAME = __webpack_require__(74).PROPER;

  var redefine = __webpack_require__(24);

  var anObject = __webpack_require__(10);

  var isPrototypeOf = __webpack_require__(42);

  var $toString = __webpack_require__(18);

  var fails = __webpack_require__(2);

  var regExpFlags = __webpack_require__(72);

  var TO_STRING = 'toString';
  var RegExpPrototype = RegExp.prototype;
  var n$ToString = RegExpPrototype[TO_STRING];
  var getFlags = uncurryThis(regExpFlags);
  var NOT_GENERIC = fails(function () {
    return n$ToString.call({
      source: 'a',
      flags: 'b'
    }) != '/a/b';
  }); // FF44- RegExp#toString has a wrong name

  var INCORRECT_NAME = PROPER_FUNCTION_NAME && n$ToString.name != TO_STRING; // `RegExp.prototype.toString` method
  // https://tc39.es/ecma262/#sec-regexp.prototype.tostring

  if (NOT_GENERIC || INCORRECT_NAME) {
    redefine(RegExp.prototype, TO_STRING, function toString() {
      var R = anObject(this);
      var p = $toString(R.source);
      var rf = R.flags;
      var f = $toString(rf === undefined && isPrototypeOf(RegExpPrototype, R) && !('flags' in RegExpPrototype) ? getFlags(R) : rf);
      return '/' + p + '/' + f;
    }, {
      unsafe: true
    });
  }
  /***/

},
/* 497 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var collection = __webpack_require__(112);

  var collectionStrong = __webpack_require__(197); // `Set` constructor
  // https://tc39.es/ecma262/#sec-set-objects


  collection('Set', function (init) {
    return function Set() {
      return init(this, arguments.length ? arguments[0] : undefined);
    };
  }, collectionStrong);
  /***/
},
/* 498 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $ = __webpack_require__(0);

  var createHTML = __webpack_require__(39);

  var forcedStringHTMLMethod = __webpack_require__(43); // `String.prototype.anchor` method
  // https://tc39.es/ecma262/#sec-string.prototype.anchor


  $({
    target: 'String',
    proto: true,
    forced: forcedStringHTMLMethod('anchor')
  }, {
    anchor: function anchor(name) {
      return createHTML(this, 'a', 'name', name);
    }
  });
  /***/
},
/* 499 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $ = __webpack_require__(0);

  var uncurryThis = __webpack_require__(3);

  var requireObjectCoercible = __webpack_require__(28);

  var toIntegerOrInfinity = __webpack_require__(29);

  var toString = __webpack_require__(18);

  var fails = __webpack_require__(2);

  var charAt = uncurryThis(''.charAt);
  var FORCED = fails(function () {
    return '𠮷'.at(-2) !== "\uD842";
  }); // `String.prototype.at` method
  // https://github.com/tc39/proposal-relative-indexing-method

  $({
    target: 'String',
    proto: true,
    forced: FORCED
  }, {
    at: function at(index) {
      var S = toString(requireObjectCoercible(this));
      var len = S.length;
      var relativeIndex = toIntegerOrInfinity(index);
      var k = relativeIndex >= 0 ? relativeIndex : len + relativeIndex;
      return k < 0 || k >= len ? undefined : charAt(S, k);
    }
  });
  /***/
},
/* 500 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $ = __webpack_require__(0);

  var createHTML = __webpack_require__(39);

  var forcedStringHTMLMethod = __webpack_require__(43); // `String.prototype.big` method
  // https://tc39.es/ecma262/#sec-string.prototype.big


  $({
    target: 'String',
    proto: true,
    forced: forcedStringHTMLMethod('big')
  }, {
    big: function big() {
      return createHTML(this, 'big', '', '');
    }
  });
  /***/
},
/* 501 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $ = __webpack_require__(0);

  var createHTML = __webpack_require__(39);

  var forcedStringHTMLMethod = __webpack_require__(43); // `String.prototype.blink` method
  // https://tc39.es/ecma262/#sec-string.prototype.blink


  $({
    target: 'String',
    proto: true,
    forced: forcedStringHTMLMethod('blink')
  }, {
    blink: function blink() {
      return createHTML(this, 'blink', '', '');
    }
  });
  /***/
},
/* 502 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $ = __webpack_require__(0);

  var createHTML = __webpack_require__(39);

  var forcedStringHTMLMethod = __webpack_require__(43); // `String.prototype.bold` method
  // https://tc39.es/ecma262/#sec-string.prototype.bold


  $({
    target: 'String',
    proto: true,
    forced: forcedStringHTMLMethod('bold')
  }, {
    bold: function bold() {
      return createHTML(this, 'b', '', '');
    }
  });
  /***/
},
/* 503 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $ = __webpack_require__(0);

  var codeAt = __webpack_require__(127).codeAt; // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat


  $({
    target: 'String',
    proto: true
  }, {
    codePointAt: function codePointAt(pos) {
      return codeAt(this, pos);
    }
  });
  /***/
},
/* 504 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $ = __webpack_require__(0);

  var uncurryThis = __webpack_require__(3);

  var getOwnPropertyDescriptor = __webpack_require__(32).f;

  var toLength = __webpack_require__(44);

  var toString = __webpack_require__(18);

  var notARegExp = __webpack_require__(157);

  var requireObjectCoercible = __webpack_require__(28);

  var correctIsRegExpLogic = __webpack_require__(146);

  var IS_PURE = __webpack_require__(31); // eslint-disable-next-line es/no-string-prototype-endswith -- safe


  var un$EndsWith = uncurryThis(''.endsWith);
  var slice = uncurryThis(''.slice);
  var min = Math.min;
  var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic('endsWith'); // https://github.com/zloirock/core-js/pull/702

  var MDN_POLYFILL_BUG = !IS_PURE && !CORRECT_IS_REGEXP_LOGIC && !!function () {
    var descriptor = getOwnPropertyDescriptor(String.prototype, 'endsWith');
    return descriptor && !descriptor.writable;
  }(); // `String.prototype.endsWith` method
  // https://tc39.es/ecma262/#sec-string.prototype.endswith

  $({
    target: 'String',
    proto: true,
    forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC
  }, {
    endsWith: function endsWith(searchString
    /* , endPosition = @length */
    ) {
      var that = toString(requireObjectCoercible(this));
      notARegExp(searchString);
      var endPosition = arguments.length > 1 ? arguments[1] : undefined;
      var len = that.length;
      var end = endPosition === undefined ? len : min(toLength(endPosition), len);
      var search = toString(searchString);
      return un$EndsWith ? un$EndsWith(that, search, end) : slice(that, end - search.length, end) === search;
    }
  });
  /***/
},
/* 505 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $ = __webpack_require__(0);

  var createHTML = __webpack_require__(39);

  var forcedStringHTMLMethod = __webpack_require__(43); // `String.prototype.fixed` method
  // https://tc39.es/ecma262/#sec-string.prototype.fixed


  $({
    target: 'String',
    proto: true,
    forced: forcedStringHTMLMethod('fixed')
  }, {
    fixed: function fixed() {
      return createHTML(this, 'tt', '', '');
    }
  });
  /***/
},
/* 506 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $ = __webpack_require__(0);

  var createHTML = __webpack_require__(39);

  var forcedStringHTMLMethod = __webpack_require__(43); // `String.prototype.fontcolor` method
  // https://tc39.es/ecma262/#sec-string.prototype.fontcolor


  $({
    target: 'String',
    proto: true,
    forced: forcedStringHTMLMethod('fontcolor')
  }, {
    fontcolor: function fontcolor(color) {
      return createHTML(this, 'font', 'color', color);
    }
  });
  /***/
},
/* 507 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $ = __webpack_require__(0);

  var createHTML = __webpack_require__(39);

  var forcedStringHTMLMethod = __webpack_require__(43); // `String.prototype.fontsize` method
  // https://tc39.es/ecma262/#sec-string.prototype.fontsize


  $({
    target: 'String',
    proto: true,
    forced: forcedStringHTMLMethod('fontsize')
  }, {
    fontsize: function fontsize(size) {
      return createHTML(this, 'font', 'size', size);
    }
  });
  /***/
},
/* 508 */

/***/
function (module, exports, __webpack_require__) {
  var $ = __webpack_require__(0);

  var global = __webpack_require__(1);

  var uncurryThis = __webpack_require__(3);

  var toAbsoluteIndex = __webpack_require__(60);

  var RangeError = global.RangeError;
  var fromCharCode = String.fromCharCode; // eslint-disable-next-line es/no-string-fromcodepoint -- required for testing

  var $fromCodePoint = String.fromCodePoint;
  var join = uncurryThis([].join); // length should be 1, old FF problem

  var INCORRECT_LENGTH = !!$fromCodePoint && $fromCodePoint.length != 1; // `String.fromCodePoint` method
  // https://tc39.es/ecma262/#sec-string.fromcodepoint

  $({
    target: 'String',
    stat: true,
    forced: INCORRECT_LENGTH
  }, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    fromCodePoint: function fromCodePoint(x) {
      var elements = [];
      var length = arguments.length;
      var i = 0;
      var code;

      while (length > i) {
        code = +arguments[i++];
        if (toAbsoluteIndex(code, 0x10FFFF) !== code) throw RangeError(code + ' is not a valid code point');
        elements[i] = code < 0x10000 ? fromCharCode(code) : fromCharCode(((code -= 0x10000) >> 10) + 0xD800, code % 0x400 + 0xDC00);
      }

      return join(elements, '');
    }
  });
  /***/
},
/* 509 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $ = __webpack_require__(0);

  var uncurryThis = __webpack_require__(3);

  var notARegExp = __webpack_require__(157);

  var requireObjectCoercible = __webpack_require__(28);

  var toString = __webpack_require__(18);

  var correctIsRegExpLogic = __webpack_require__(146);

  var stringIndexOf = uncurryThis(''.indexOf); // `String.prototype.includes` method
  // https://tc39.es/ecma262/#sec-string.prototype.includes

  $({
    target: 'String',
    proto: true,
    forced: !correctIsRegExpLogic('includes')
  }, {
    includes: function includes(searchString
    /* , position = 0 */
    ) {
      return !!~stringIndexOf(toString(requireObjectCoercible(this)), toString(notARegExp(searchString)), arguments.length > 1 ? arguments[1] : undefined);
    }
  });
  /***/
},
/* 510 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $ = __webpack_require__(0);

  var createHTML = __webpack_require__(39);

  var forcedStringHTMLMethod = __webpack_require__(43); // `String.prototype.italics` method
  // https://tc39.es/ecma262/#sec-string.prototype.italics


  $({
    target: 'String',
    proto: true,
    forced: forcedStringHTMLMethod('italics')
  }, {
    italics: function italics() {
      return createHTML(this, 'i', '', '');
    }
  });
  /***/
},
/* 511 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $ = __webpack_require__(0);

  var createHTML = __webpack_require__(39);

  var forcedStringHTMLMethod = __webpack_require__(43); // `String.prototype.link` method
  // https://tc39.es/ecma262/#sec-string.prototype.link


  $({
    target: 'String',
    proto: true,
    forced: forcedStringHTMLMethod('link')
  }, {
    link: function link(url) {
      return createHTML(this, 'a', 'href', url);
    }
  });
  /***/
},
/* 512 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* eslint-disable es/no-string-prototype-matchall -- safe */

  var $ = __webpack_require__(0);

  var global = __webpack_require__(1);

  var call = __webpack_require__(19);

  var uncurryThis = __webpack_require__(3);

  var createIteratorConstructor = __webpack_require__(148);

  var requireObjectCoercible = __webpack_require__(28);

  var toLength = __webpack_require__(44);

  var toString = __webpack_require__(18);

  var anObject = __webpack_require__(10);

  var classof = __webpack_require__(38);

  var isPrototypeOf = __webpack_require__(42);

  var isRegExp = __webpack_require__(94);

  var regExpFlags = __webpack_require__(72);

  var getMethod = __webpack_require__(58);

  var redefine = __webpack_require__(24);

  var fails = __webpack_require__(2);

  var wellKnownSymbol = __webpack_require__(15);

  var speciesConstructor = __webpack_require__(80);

  var advanceStringIndex = __webpack_require__(107);

  var regExpExec = __webpack_require__(99);

  var InternalStateModule = __webpack_require__(27);

  var IS_PURE = __webpack_require__(31);

  var MATCH_ALL = wellKnownSymbol('matchAll');
  var REGEXP_STRING = 'RegExp String';
  var REGEXP_STRING_ITERATOR = REGEXP_STRING + ' Iterator';
  var setInternalState = InternalStateModule.set;
  var getInternalState = InternalStateModule.getterFor(REGEXP_STRING_ITERATOR);
  var RegExpPrototype = RegExp.prototype;
  var TypeError = global.TypeError;
  var getFlags = uncurryThis(regExpFlags);
  var stringIndexOf = uncurryThis(''.indexOf);
  var un$MatchAll = uncurryThis(''.matchAll);
  var WORKS_WITH_NON_GLOBAL_REGEX = !!un$MatchAll && !fails(function () {
    un$MatchAll('a', /./);
  });
  var $RegExpStringIterator = createIteratorConstructor(function RegExpStringIterator(regexp, string, $global, fullUnicode) {
    setInternalState(this, {
      type: REGEXP_STRING_ITERATOR,
      regexp: regexp,
      string: string,
      global: $global,
      unicode: fullUnicode,
      done: false
    });
  }, REGEXP_STRING, function next() {
    var state = getInternalState(this);
    if (state.done) return {
      value: undefined,
      done: true
    };
    var R = state.regexp;
    var S = state.string;
    var match = regExpExec(R, S);
    if (match === null) return {
      value: undefined,
      done: state.done = true
    };

    if (state.global) {
      if (toString(match[0]) === '') R.lastIndex = advanceStringIndex(S, toLength(R.lastIndex), state.unicode);
      return {
        value: match,
        done: false
      };
    }

    state.done = true;
    return {
      value: match,
      done: false
    };
  });

  var $matchAll = function $matchAll(string) {
    var R = anObject(this);
    var S = toString(string);
    var C, flagsValue, flags, matcher, $global, fullUnicode;
    C = speciesConstructor(R, RegExp);
    flagsValue = R.flags;

    if (flagsValue === undefined && isPrototypeOf(RegExpPrototype, R) && !('flags' in RegExpPrototype)) {
      flagsValue = getFlags(R);
    }

    flags = flagsValue === undefined ? '' : toString(flagsValue);
    matcher = new C(C === RegExp ? R.source : R, flags);
    $global = !!~stringIndexOf(flags, 'g');
    fullUnicode = !!~stringIndexOf(flags, 'u');
    matcher.lastIndex = toLength(R.lastIndex);
    return new $RegExpStringIterator(matcher, S, $global, fullUnicode);
  }; // `String.prototype.matchAll` method
  // https://tc39.es/ecma262/#sec-string.prototype.matchall


  $({
    target: 'String',
    proto: true,
    forced: WORKS_WITH_NON_GLOBAL_REGEX
  }, {
    matchAll: function matchAll(regexp) {
      var O = requireObjectCoercible(this);
      var flags, S, matcher, rx;

      if (regexp != null) {
        if (isRegExp(regexp)) {
          flags = toString(requireObjectCoercible('flags' in RegExpPrototype ? regexp.flags : getFlags(regexp)));
          if (!~stringIndexOf(flags, 'g')) throw TypeError('`.matchAll` does not allow non-global regexes');
        }

        if (WORKS_WITH_NON_GLOBAL_REGEX) return un$MatchAll(O, regexp);
        matcher = getMethod(regexp, MATCH_ALL);
        if (matcher === undefined && IS_PURE && classof(regexp) == 'RegExp') matcher = $matchAll;
        if (matcher) return call(matcher, regexp, O);
      } else if (WORKS_WITH_NON_GLOBAL_REGEX) return un$MatchAll(O, regexp);

      S = toString(O);
      rx = new RegExp(regexp, 'g');
      return IS_PURE ? call($matchAll, rx, S) : rx[MATCH_ALL](S);
    }
  });
  IS_PURE || MATCH_ALL in RegExpPrototype || redefine(RegExpPrototype, MATCH_ALL, $matchAll);
  /***/
},
/* 513 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var call = __webpack_require__(19);

  var fixRegExpWellKnownSymbolLogic = __webpack_require__(115);

  var anObject = __webpack_require__(10);

  var toLength = __webpack_require__(44);

  var toString = __webpack_require__(18);

  var requireObjectCoercible = __webpack_require__(28);

  var getMethod = __webpack_require__(58);

  var advanceStringIndex = __webpack_require__(107);

  var regExpExec = __webpack_require__(99); // @@match logic


  fixRegExpWellKnownSymbolLogic('match', function (MATCH, nativeMatch, maybeCallNative) {
    return [// `String.prototype.match` method
    // https://tc39.es/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = requireObjectCoercible(this);
      var matcher = regexp == undefined ? undefined : getMethod(regexp, MATCH);
      return matcher ? call(matcher, regexp, O) : new RegExp(regexp)[MATCH](toString(O));
    }, // `RegExp.prototype[@@match]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
    function (string) {
      var rx = anObject(this);
      var S = toString(string);
      var res = maybeCallNative(nativeMatch, rx, S);
      if (res.done) return res.value;
      if (!rx.global) return regExpExec(rx, S);
      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;

      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = toString(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }

      return n === 0 ? null : A;
    }];
  });
  /***/
},
/* 514 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $ = __webpack_require__(0);

  var $padEnd = __webpack_require__(165).end;

  var WEBKIT_BUG = __webpack_require__(231); // `String.prototype.padEnd` method
  // https://tc39.es/ecma262/#sec-string.prototype.padend


  $({
    target: 'String',
    proto: true,
    forced: WEBKIT_BUG
  }, {
    padEnd: function padEnd(maxLength
    /* , fillString = ' ' */
    ) {
      return $padEnd(this, maxLength, arguments.length > 1 ? arguments[1] : undefined);
    }
  });
  /***/
},
/* 515 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $ = __webpack_require__(0);

  var $padStart = __webpack_require__(165).start;

  var WEBKIT_BUG = __webpack_require__(231); // `String.prototype.padStart` method
  // https://tc39.es/ecma262/#sec-string.prototype.padstart


  $({
    target: 'String',
    proto: true,
    forced: WEBKIT_BUG
  }, {
    padStart: function padStart(maxLength
    /* , fillString = ' ' */
    ) {
      return $padStart(this, maxLength, arguments.length > 1 ? arguments[1] : undefined);
    }
  });
  /***/
},
/* 516 */

/***/
function (module, exports, __webpack_require__) {
  var $ = __webpack_require__(0);

  var uncurryThis = __webpack_require__(3);

  var toIndexedObject = __webpack_require__(37);

  var toObject = __webpack_require__(22);

  var toString = __webpack_require__(18);

  var lengthOfArrayLike = __webpack_require__(23);

  var push = uncurryThis([].push);
  var join = uncurryThis([].join); // `String.raw` method
  // https://tc39.es/ecma262/#sec-string.raw

  $({
    target: 'String',
    stat: true
  }, {
    raw: function raw(template) {
      var rawTemplate = toIndexedObject(toObject(template).raw);
      var literalSegments = lengthOfArrayLike(rawTemplate);
      var argumentsLength = arguments.length;
      var elements = [];
      var i = 0;

      while (literalSegments > i) {
        push(elements, toString(rawTemplate[i++]));
        if (i === literalSegments) return join(elements, '');
        if (i < argumentsLength) push(elements, toString(arguments[i]));
      }
    }
  });
  /***/
},
/* 517 */

/***/
function (module, exports, __webpack_require__) {
  var $ = __webpack_require__(0);

  var repeat = __webpack_require__(128); // `String.prototype.repeat` method
  // https://tc39.es/ecma262/#sec-string.prototype.repeat


  $({
    target: 'String',
    proto: true
  }, {
    repeat: repeat
  });
  /***/
},
/* 518 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $ = __webpack_require__(0);

  var global = __webpack_require__(1);

  var call = __webpack_require__(19);

  var uncurryThis = __webpack_require__(3);

  var requireObjectCoercible = __webpack_require__(28);

  var isCallable = __webpack_require__(17);

  var isRegExp = __webpack_require__(94);

  var toString = __webpack_require__(18);

  var getMethod = __webpack_require__(58);

  var regExpFlags = __webpack_require__(72);

  var getSubstitution = __webpack_require__(208);

  var wellKnownSymbol = __webpack_require__(15);

  var IS_PURE = __webpack_require__(31);

  var REPLACE = wellKnownSymbol('replace');
  var RegExpPrototype = RegExp.prototype;
  var TypeError = global.TypeError;
  var getFlags = uncurryThis(regExpFlags);
  var indexOf = uncurryThis(''.indexOf);
  var replace = uncurryThis(''.replace);
  var stringSlice = uncurryThis(''.slice);
  var max = Math.max;

  var stringIndexOf = function stringIndexOf(string, searchValue, fromIndex) {
    if (fromIndex > string.length) return -1;
    if (searchValue === '') return fromIndex;
    return indexOf(string, searchValue, fromIndex);
  }; // `String.prototype.replaceAll` method
  // https://tc39.es/ecma262/#sec-string.prototype.replaceall


  $({
    target: 'String',
    proto: true
  }, {
    replaceAll: function replaceAll(searchValue, replaceValue) {
      var O = requireObjectCoercible(this);
      var IS_REG_EXP, flags, replacer, string, searchString, functionalReplace, searchLength, advanceBy, replacement;
      var position = 0;
      var endOfLastMatch = 0;
      var result = '';

      if (searchValue != null) {
        IS_REG_EXP = isRegExp(searchValue);

        if (IS_REG_EXP) {
          flags = toString(requireObjectCoercible('flags' in RegExpPrototype ? searchValue.flags : getFlags(searchValue)));
          if (!~indexOf(flags, 'g')) throw TypeError('`.replaceAll` does not allow non-global regexes');
        }

        replacer = getMethod(searchValue, REPLACE);

        if (replacer) {
          return call(replacer, searchValue, O, replaceValue);
        } else if (IS_PURE && IS_REG_EXP) {
          return replace(toString(O), searchValue, replaceValue);
        }
      }

      string = toString(O);
      searchString = toString(searchValue);
      functionalReplace = isCallable(replaceValue);
      if (!functionalReplace) replaceValue = toString(replaceValue);
      searchLength = searchString.length;
      advanceBy = max(1, searchLength);
      position = stringIndexOf(string, searchString, 0);

      while (position !== -1) {
        replacement = functionalReplace ? toString(replaceValue(searchString, position, string)) : getSubstitution(searchString, string, position, [], undefined, replaceValue);
        result += stringSlice(string, endOfLastMatch, position) + replacement;
        endOfLastMatch = position + searchLength;
        position = stringIndexOf(string, searchString, position + advanceBy);
      }

      if (endOfLastMatch < string.length) {
        result += stringSlice(string, endOfLastMatch);
      }

      return result;
    }
  });
  /***/
},
/* 519 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var apply = __webpack_require__(40);

  var call = __webpack_require__(19);

  var uncurryThis = __webpack_require__(3);

  var fixRegExpWellKnownSymbolLogic = __webpack_require__(115);

  var fails = __webpack_require__(2);

  var anObject = __webpack_require__(10);

  var isCallable = __webpack_require__(17);

  var toIntegerOrInfinity = __webpack_require__(29);

  var toLength = __webpack_require__(44);

  var toString = __webpack_require__(18);

  var requireObjectCoercible = __webpack_require__(28);

  var advanceStringIndex = __webpack_require__(107);

  var getMethod = __webpack_require__(58);

  var getSubstitution = __webpack_require__(208);

  var regExpExec = __webpack_require__(99);

  var wellKnownSymbol = __webpack_require__(15);

  var REPLACE = wellKnownSymbol('replace');
  var max = Math.max;
  var min = Math.min;
  var concat = uncurryThis([].concat);
  var push = uncurryThis([].push);
  var stringIndexOf = uncurryThis(''.indexOf);
  var stringSlice = uncurryThis(''.slice);

  var maybeToString = function maybeToString(it) {
    return it === undefined ? it : String(it);
  }; // IE <= 11 replaces $0 with the whole match, as if it was $&
  // https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0


  var REPLACE_KEEPS_$0 = function () {
    // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
    return 'a'.replace(/./, '$0') === '$0';
  }(); // Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string


  var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = function () {
    if (/./[REPLACE]) {
      return /./[REPLACE]('a', '$0') === '';
    }

    return false;
  }();

  var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
    var re = /./;

    re.exec = function () {
      var result = [];
      result.groups = {
        a: '7'
      };
      return result;
    }; // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive


    return ''.replace(re, '$<a>') !== '7';
  }); // @@replace logic

  fixRegExpWellKnownSymbolLogic('replace', function (_, nativeReplace, maybeCallNative) {
    var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';
    return [// `String.prototype.replace` method
    // https://tc39.es/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = requireObjectCoercible(this);
      var replacer = searchValue == undefined ? undefined : getMethod(searchValue, REPLACE);
      return replacer ? call(replacer, searchValue, O, replaceValue) : call(nativeReplace, toString(O), searchValue, replaceValue);
    }, // `RegExp.prototype[@@replace]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
    function (string, replaceValue) {
      var rx = anObject(this);
      var S = toString(string);

      if (typeof replaceValue == 'string' && stringIndexOf(replaceValue, UNSAFE_SUBSTITUTE) === -1 && stringIndexOf(replaceValue, '$<') === -1) {
        var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
        if (res.done) return res.value;
      }

      var functionalReplace = isCallable(replaceValue);
      if (!functionalReplace) replaceValue = toString(replaceValue);
      var global = rx.global;

      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }

      var results = [];

      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;
        push(results, result);
        if (!global) break;
        var matchStr = toString(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }

      var accumulatedResult = '';
      var nextSourcePosition = 0;

      for (var i = 0; i < results.length; i++) {
        result = results[i];
        var matched = toString(result[0]);
        var position = max(min(toIntegerOrInfinity(result.index), S.length), 0);
        var captures = []; // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.

        for (var j = 1; j < result.length; j++) {
          push(captures, maybeToString(result[j]));
        }

        var namedCaptures = result.groups;

        if (functionalReplace) {
          var replacerArgs = concat([matched], captures, position, S);
          if (namedCaptures !== undefined) push(replacerArgs, namedCaptures);
          var replacement = toString(apply(replaceValue, undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }

        if (position >= nextSourcePosition) {
          accumulatedResult += stringSlice(S, nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }

      return accumulatedResult + stringSlice(S, nextSourcePosition);
    }];
  }, !REPLACE_SUPPORTS_NAMED_GROUPS || !REPLACE_KEEPS_$0 || REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);
  /***/
},
/* 520 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var call = __webpack_require__(19);

  var fixRegExpWellKnownSymbolLogic = __webpack_require__(115);

  var anObject = __webpack_require__(10);

  var requireObjectCoercible = __webpack_require__(28);

  var sameValue = __webpack_require__(230);

  var toString = __webpack_require__(18);

  var getMethod = __webpack_require__(58);

  var regExpExec = __webpack_require__(99); // @@search logic


  fixRegExpWellKnownSymbolLogic('search', function (SEARCH, nativeSearch, maybeCallNative) {
    return [// `String.prototype.search` method
    // https://tc39.es/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = requireObjectCoercible(this);
      var searcher = regexp == undefined ? undefined : getMethod(regexp, SEARCH);
      return searcher ? call(searcher, regexp, O) : new RegExp(regexp)[SEARCH](toString(O));
    }, // `RegExp.prototype[@@search]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@search
    function (string) {
      var rx = anObject(this);
      var S = toString(string);
      var res = maybeCallNative(nativeSearch, rx, S);
      if (res.done) return res.value;
      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }];
  });
  /***/
},
/* 521 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $ = __webpack_require__(0);

  var createHTML = __webpack_require__(39);

  var forcedStringHTMLMethod = __webpack_require__(43); // `String.prototype.small` method
  // https://tc39.es/ecma262/#sec-string.prototype.small


  $({
    target: 'String',
    proto: true,
    forced: forcedStringHTMLMethod('small')
  }, {
    small: function small() {
      return createHTML(this, 'small', '', '');
    }
  });
  /***/
},
/* 522 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var apply = __webpack_require__(40);

  var call = __webpack_require__(19);

  var uncurryThis = __webpack_require__(3);

  var fixRegExpWellKnownSymbolLogic = __webpack_require__(115);

  var isRegExp = __webpack_require__(94);

  var anObject = __webpack_require__(10);

  var requireObjectCoercible = __webpack_require__(28);

  var speciesConstructor = __webpack_require__(80);

  var advanceStringIndex = __webpack_require__(107);

  var toLength = __webpack_require__(44);

  var toString = __webpack_require__(18);

  var getMethod = __webpack_require__(58);

  var arraySlice = __webpack_require__(86);

  var callRegExpExec = __webpack_require__(99);

  var regexpExec = __webpack_require__(123);

  var stickyHelpers = __webpack_require__(124);

  var fails = __webpack_require__(2);

  var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y;
  var MAX_UINT32 = 0xFFFFFFFF;
  var min = Math.min;
  var $push = [].push;
  var exec = uncurryThis(/./.exec);
  var push = uncurryThis($push);
  var stringSlice = uncurryThis(''.slice); // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  // Weex JS has frozen built-in prototypes, so use try / catch wrapper

  var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails(function () {
    // eslint-disable-next-line regexp/no-empty-group -- required for testing
    var re = /(?:)/;
    var originalExec = re.exec;

    re.exec = function () {
      return originalExec.apply(this, arguments);
    };

    var result = 'ab'.split(re);
    return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
  }); // @@split logic

  fixRegExpWellKnownSymbolLogic('split', function (SPLIT, nativeSplit, maybeCallNative) {
    var internalSplit;

    if ('abbc'.split(/(b)*/)[1] == 'c' || // eslint-disable-next-line regexp/no-empty-group -- required for testing
    'test'.split(/(?:)/, -1).length != 4 || 'ab'.split(/(?:ab)*/).length != 2 || '.'.split(/(.?)(.?)/).length != 4 || // eslint-disable-next-line regexp/no-empty-capturing-group, regexp/no-empty-group -- required for testing
    '.'.split(/()()/).length > 1 || ''.split(/.?/).length) {
      // based on es5-shim implementation, need to rework it
      internalSplit = function internalSplit(separator, limit) {
        var string = toString(requireObjectCoercible(this));
        var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
        if (lim === 0) return [];
        if (separator === undefined) return [string]; // If `separator` is not a regex, use native split

        if (!isRegExp(separator)) {
          return call(nativeSplit, string, separator, lim);
        }

        var output = [];
        var flags = (separator.ignoreCase ? 'i' : '') + (separator.multiline ? 'm' : '') + (separator.unicode ? 'u' : '') + (separator.sticky ? 'y' : '');
        var lastLastIndex = 0; // Make `global` and avoid `lastIndex` issues by working with a copy

        var separatorCopy = new RegExp(separator.source, flags + 'g');
        var match, lastIndex, lastLength;

        while (match = call(regexpExec, separatorCopy, string)) {
          lastIndex = separatorCopy.lastIndex;

          if (lastIndex > lastLastIndex) {
            push(output, stringSlice(string, lastLastIndex, match.index));
            if (match.length > 1 && match.index < string.length) apply($push, output, arraySlice(match, 1));
            lastLength = match[0].length;
            lastLastIndex = lastIndex;
            if (output.length >= lim) break;
          }

          if (separatorCopy.lastIndex === match.index) separatorCopy.lastIndex++; // Avoid an infinite loop
        }

        if (lastLastIndex === string.length) {
          if (lastLength || !exec(separatorCopy, '')) push(output, '');
        } else push(output, stringSlice(string, lastLastIndex));

        return output.length > lim ? arraySlice(output, 0, lim) : output;
      }; // Chakra, V8

    } else if ('0'.split(undefined, 0).length) {
      internalSplit = function internalSplit(separator, limit) {
        return separator === undefined && limit === 0 ? [] : call(nativeSplit, this, separator, limit);
      };
    } else internalSplit = nativeSplit;

    return [// `String.prototype.split` method
    // https://tc39.es/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = requireObjectCoercible(this);
      var splitter = separator == undefined ? undefined : getMethod(separator, SPLIT);
      return splitter ? call(splitter, separator, O, limit) : call(internalSplit, toString(O), separator, limit);
    }, // `RegExp.prototype[@@split]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (string, limit) {
      var rx = anObject(this);
      var S = toString(string);
      var res = maybeCallNative(internalSplit, rx, S, limit, internalSplit !== nativeSplit);
      if (res.done) return res.value;
      var C = speciesConstructor(rx, RegExp);
      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') + (rx.multiline ? 'm' : '') + (rx.unicode ? 'u' : '') + (UNSUPPORTED_Y ? 'g' : 'y'); // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.

      var splitter = new C(UNSUPPORTED_Y ? '^(?:' + rx.source + ')' : rx, flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];

      while (q < S.length) {
        splitter.lastIndex = UNSUPPORTED_Y ? 0 : q;
        var z = callRegExpExec(splitter, UNSUPPORTED_Y ? stringSlice(S, q) : S);
        var e;

        if (z === null || (e = min(toLength(splitter.lastIndex + (UNSUPPORTED_Y ? q : 0)), S.length)) === p) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          push(A, stringSlice(S, p, q));
          if (A.length === lim) return A;

          for (var i = 1; i <= z.length - 1; i++) {
            push(A, z[i]);
            if (A.length === lim) return A;
          }

          q = p = e;
        }
      }

      push(A, stringSlice(S, p));
      return A;
    }];
  }, !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC, UNSUPPORTED_Y);
  /***/
},
/* 523 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $ = __webpack_require__(0);

  var uncurryThis = __webpack_require__(3);

  var getOwnPropertyDescriptor = __webpack_require__(32).f;

  var toLength = __webpack_require__(44);

  var toString = __webpack_require__(18);

  var notARegExp = __webpack_require__(157);

  var requireObjectCoercible = __webpack_require__(28);

  var correctIsRegExpLogic = __webpack_require__(146);

  var IS_PURE = __webpack_require__(31); // eslint-disable-next-line es/no-string-prototype-startswith -- safe


  var un$StartsWith = uncurryThis(''.startsWith);
  var stringSlice = uncurryThis(''.slice);
  var min = Math.min;
  var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic('startsWith'); // https://github.com/zloirock/core-js/pull/702

  var MDN_POLYFILL_BUG = !IS_PURE && !CORRECT_IS_REGEXP_LOGIC && !!function () {
    var descriptor = getOwnPropertyDescriptor(String.prototype, 'startsWith');
    return descriptor && !descriptor.writable;
  }(); // `String.prototype.startsWith` method
  // https://tc39.es/ecma262/#sec-string.prototype.startswith

  $({
    target: 'String',
    proto: true,
    forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC
  }, {
    startsWith: function startsWith(searchString
    /* , position = 0 */
    ) {
      var that = toString(requireObjectCoercible(this));
      notARegExp(searchString);
      var index = toLength(min(arguments.length > 1 ? arguments[1] : undefined, that.length));
      var search = toString(searchString);
      return un$StartsWith ? un$StartsWith(that, search, index) : stringSlice(that, index, index + search.length) === search;
    }
  });
  /***/
},
/* 524 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $ = __webpack_require__(0);

  var createHTML = __webpack_require__(39);

  var forcedStringHTMLMethod = __webpack_require__(43); // `String.prototype.strike` method
  // https://tc39.es/ecma262/#sec-string.prototype.strike


  $({
    target: 'String',
    proto: true,
    forced: forcedStringHTMLMethod('strike')
  }, {
    strike: function strike() {
      return createHTML(this, 'strike', '', '');
    }
  });
  /***/
},
/* 525 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $ = __webpack_require__(0);

  var createHTML = __webpack_require__(39);

  var forcedStringHTMLMethod = __webpack_require__(43); // `String.prototype.sub` method
  // https://tc39.es/ecma262/#sec-string.prototype.sub


  $({
    target: 'String',
    proto: true,
    forced: forcedStringHTMLMethod('sub')
  }, {
    sub: function sub() {
      return createHTML(this, 'sub', '', '');
    }
  });
  /***/
},
/* 526 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $ = __webpack_require__(0);

  var uncurryThis = __webpack_require__(3);

  var requireObjectCoercible = __webpack_require__(28);

  var toIntegerOrInfinity = __webpack_require__(29);

  var toString = __webpack_require__(18);

  var stringSlice = uncurryThis(''.slice);
  var max = Math.max;
  var min = Math.min; // eslint-disable-next-line unicorn/prefer-string-slice -- required for testing

  var FORCED = !''.substr || 'ab'.substr(-1) !== 'b'; // `String.prototype.substr` method
  // https://tc39.es/ecma262/#sec-string.prototype.substr

  $({
    target: 'String',
    proto: true,
    forced: FORCED
  }, {
    substr: function substr(start, length) {
      var that = toString(requireObjectCoercible(this));
      var size = that.length;
      var intStart = toIntegerOrInfinity(start);
      var intLength, intEnd;
      if (intStart === Infinity) intStart = 0;
      if (intStart < 0) intStart = max(size + intStart, 0);
      intLength = length === undefined ? size : toIntegerOrInfinity(length);
      if (intLength <= 0 || intLength === Infinity) return '';
      intEnd = min(intStart + intLength, size);
      return intStart >= intEnd ? '' : stringSlice(that, intStart, intEnd);
    }
  });
  /***/
},
/* 527 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $ = __webpack_require__(0);

  var createHTML = __webpack_require__(39);

  var forcedStringHTMLMethod = __webpack_require__(43); // `String.prototype.sup` method
  // https://tc39.es/ecma262/#sec-string.prototype.sup


  $({
    target: 'String',
    proto: true,
    forced: forcedStringHTMLMethod('sup')
  }, {
    sup: function sup() {
      return createHTML(this, 'sup', '', '');
    }
  });
  /***/
},
/* 528 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $ = __webpack_require__(0);

  var $trimEnd = __webpack_require__(81).end;

  var forcedStringTrimMethod = __webpack_require__(166);

  var FORCED = forcedStringTrimMethod('trimEnd');
  var trimEnd = FORCED ? function trimEnd() {
    return $trimEnd(this); // eslint-disable-next-line es/no-string-prototype-trimstart-trimend -- safe
  } : ''.trimEnd; // `String.prototype.{ trimEnd, trimRight }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimend
  // https://tc39.es/ecma262/#String.prototype.trimright

  $({
    target: 'String',
    proto: true,
    name: 'trimEnd',
    forced: FORCED
  }, {
    trimEnd: trimEnd,
    trimRight: trimEnd
  });
  /***/
},
/* 529 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $ = __webpack_require__(0);

  var $trimStart = __webpack_require__(81).start;

  var forcedStringTrimMethod = __webpack_require__(166);

  var FORCED = forcedStringTrimMethod('trimStart');
  var trimStart = FORCED ? function trimStart() {
    return $trimStart(this); // eslint-disable-next-line es/no-string-prototype-trimstart-trimend -- safe
  } : ''.trimStart; // `String.prototype.{ trimStart, trimLeft }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
  // https://tc39.es/ecma262/#String.prototype.trimleft

  $({
    target: 'String',
    proto: true,
    name: 'trimStart',
    forced: FORCED
  }, {
    trimStart: trimStart,
    trimLeft: trimStart
  });
  /***/
},
/* 530 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $ = __webpack_require__(0);

  var $trim = __webpack_require__(81).trim;

  var forcedStringTrimMethod = __webpack_require__(166); // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim


  $({
    target: 'String',
    proto: true,
    forced: forcedStringTrimMethod('trim')
  }, {
    trim: function trim() {
      return $trim(this);
    }
  });
  /***/
},
/* 531 */

/***/
function (module, exports, __webpack_require__) {
  var defineWellKnownSymbol = __webpack_require__(36); // `Symbol.asyncIterator` well-known symbol
  // https://tc39.es/ecma262/#sec-symbol.asynciterator


  defineWellKnownSymbol('asyncIterator');
  /***/
},
/* 532 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // `Symbol.prototype.description` getter
  // https://tc39.es/ecma262/#sec-symbol.prototype.description

  var $ = __webpack_require__(0);

  var DESCRIPTORS = __webpack_require__(12);

  var global = __webpack_require__(1);

  var uncurryThis = __webpack_require__(3);

  var hasOwn = __webpack_require__(21);

  var isCallable = __webpack_require__(17);

  var isPrototypeOf = __webpack_require__(42);

  var toString = __webpack_require__(18);

  var defineProperty = __webpack_require__(20).f;

  var copyConstructorProperties = __webpack_require__(113);

  var NativeSymbol = global.Symbol;
  var SymbolPrototype = NativeSymbol && NativeSymbol.prototype;

  if (DESCRIPTORS && isCallable(NativeSymbol) && (!('description' in SymbolPrototype) || // Safari 12 bug
  NativeSymbol().description !== undefined)) {
    var EmptyStringDescriptionStore = {}; // wrap Symbol constructor for correct work with undefined description

    var SymbolWrapper = function Symbol() {
      var description = arguments.length < 1 || arguments[0] === undefined ? undefined : toString(arguments[0]);
      var result = isPrototypeOf(SymbolPrototype, this) ? new NativeSymbol(description) // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
      : description === undefined ? NativeSymbol() : NativeSymbol(description);
      if (description === '') EmptyStringDescriptionStore[result] = true;
      return result;
    };

    copyConstructorProperties(SymbolWrapper, NativeSymbol);
    SymbolWrapper.prototype = SymbolPrototype;
    SymbolPrototype.constructor = SymbolWrapper;
    var NATIVE_SYMBOL = String(NativeSymbol('test')) == 'Symbol(test)';
    var symbolToString = uncurryThis(SymbolPrototype.toString);
    var symbolValueOf = uncurryThis(SymbolPrototype.valueOf);
    var regexp = /^Symbol\((.*)\)[^)]+$/;
    var replace = uncurryThis(''.replace);
    var stringSlice = uncurryThis(''.slice);
    defineProperty(SymbolPrototype, 'description', {
      configurable: true,
      get: function description() {
        var symbol = symbolValueOf(this);
        var string = symbolToString(symbol);
        if (hasOwn(EmptyStringDescriptionStore, symbol)) return '';
        var desc = NATIVE_SYMBOL ? stringSlice(string, 7, -1) : replace(string, regexp, '$1');
        return desc === '' ? undefined : desc;
      }
    });
    $({
      global: true,
      forced: true
    }, {
      Symbol: SymbolWrapper
    });
  }
  /***/

},
/* 533 */

/***/
function (module, exports, __webpack_require__) {
  var defineWellKnownSymbol = __webpack_require__(36); // `Symbol.hasInstance` well-known symbol
  // https://tc39.es/ecma262/#sec-symbol.hasinstance


  defineWellKnownSymbol('hasInstance');
  /***/
},
/* 534 */

/***/
function (module, exports, __webpack_require__) {
  var defineWellKnownSymbol = __webpack_require__(36); // `Symbol.isConcatSpreadable` well-known symbol
  // https://tc39.es/ecma262/#sec-symbol.isconcatspreadable


  defineWellKnownSymbol('isConcatSpreadable');
  /***/
},
/* 535 */

/***/
function (module, exports, __webpack_require__) {
  var defineWellKnownSymbol = __webpack_require__(36); // `Symbol.iterator` well-known symbol
  // https://tc39.es/ecma262/#sec-symbol.iterator


  defineWellKnownSymbol('iterator');
  /***/
},
/* 536 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $ = __webpack_require__(0);

  var global = __webpack_require__(1);

  var getBuiltIn = __webpack_require__(26);

  var apply = __webpack_require__(40);

  var call = __webpack_require__(19);

  var uncurryThis = __webpack_require__(3);

  var IS_PURE = __webpack_require__(31);

  var DESCRIPTORS = __webpack_require__(12);

  var NATIVE_SYMBOL = __webpack_require__(156);

  var fails = __webpack_require__(2);

  var hasOwn = __webpack_require__(21);

  var isArray = __webpack_require__(71);

  var isCallable = __webpack_require__(17);

  var isObject = __webpack_require__(13);

  var isPrototypeOf = __webpack_require__(42);

  var isSymbol = __webpack_require__(77);

  var anObject = __webpack_require__(10);

  var toObject = __webpack_require__(22);

  var toIndexedObject = __webpack_require__(37);

  var toPropertyKey = __webpack_require__(66);

  var $toString = __webpack_require__(18);

  var createPropertyDescriptor = __webpack_require__(47);

  var nativeObjectCreate = __webpack_require__(41);

  var objectKeys = __webpack_require__(98);

  var getOwnPropertyNamesModule = __webpack_require__(65);

  var getOwnPropertyNamesExternal = __webpack_require__(158);

  var getOwnPropertySymbolsModule = __webpack_require__(159);

  var getOwnPropertyDescriptorModule = __webpack_require__(32);

  var definePropertyModule = __webpack_require__(20);

  var definePropertiesModule = __webpack_require__(97);

  var propertyIsEnumerableModule = __webpack_require__(121);

  var arraySlice = __webpack_require__(68);

  var redefine = __webpack_require__(24);

  var shared = __webpack_require__(126);

  var sharedKey = __webpack_require__(125);

  var hiddenKeys = __webpack_require__(91);

  var uid = __webpack_require__(82);

  var wellKnownSymbol = __webpack_require__(15);

  var wrappedWellKnownSymbolModule = __webpack_require__(238);

  var defineWellKnownSymbol = __webpack_require__(36);

  var setToStringTag = __webpack_require__(49);

  var InternalStateModule = __webpack_require__(27);

  var $forEach = __webpack_require__(30).forEach;

  var HIDDEN = sharedKey('hidden');
  var SYMBOL = 'Symbol';
  var PROTOTYPE = 'prototype';
  var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
  var setInternalState = InternalStateModule.set;
  var getInternalState = InternalStateModule.getterFor(SYMBOL);
  var ObjectPrototype = Object[PROTOTYPE];
  var $Symbol = global.Symbol;
  var SymbolPrototype = $Symbol && $Symbol[PROTOTYPE];
  var TypeError = global.TypeError;
  var QObject = global.QObject;
  var $stringify = getBuiltIn('JSON', 'stringify');
  var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  var nativeDefineProperty = definePropertyModule.f;
  var nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
  var nativePropertyIsEnumerable = propertyIsEnumerableModule.f;
  var push = uncurryThis([].push);
  var AllSymbols = shared('symbols');
  var ObjectPrototypeSymbols = shared('op-symbols');
  var StringToSymbolRegistry = shared('string-to-symbol-registry');
  var SymbolToStringRegistry = shared('symbol-to-string-registry');
  var WellKnownSymbolsStore = shared('wks'); // Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173

  var USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild; // fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687

  var setSymbolDescriptor = DESCRIPTORS && fails(function () {
    return nativeObjectCreate(nativeDefineProperty({}, 'a', {
      get: function get() {
        return nativeDefineProperty(this, 'a', {
          value: 7
        }).a;
      }
    })).a != 7;
  }) ? function (O, P, Attributes) {
    var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype, P);
    if (ObjectPrototypeDescriptor) delete ObjectPrototype[P];
    nativeDefineProperty(O, P, Attributes);

    if (ObjectPrototypeDescriptor && O !== ObjectPrototype) {
      nativeDefineProperty(ObjectPrototype, P, ObjectPrototypeDescriptor);
    }
  } : nativeDefineProperty;

  var wrap = function wrap(tag, description) {
    var symbol = AllSymbols[tag] = nativeObjectCreate(SymbolPrototype);
    setInternalState(symbol, {
      type: SYMBOL,
      tag: tag,
      description: description
    });
    if (!DESCRIPTORS) symbol.description = description;
    return symbol;
  };

  var $defineProperty = function defineProperty(O, P, Attributes) {
    if (O === ObjectPrototype) $defineProperty(ObjectPrototypeSymbols, P, Attributes);
    anObject(O);
    var key = toPropertyKey(P);
    anObject(Attributes);

    if (hasOwn(AllSymbols, key)) {
      if (!Attributes.enumerable) {
        if (!hasOwn(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, {}));
        O[HIDDEN][key] = true;
      } else {
        if (hasOwn(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
        Attributes = nativeObjectCreate(Attributes, {
          enumerable: createPropertyDescriptor(0, false)
        });
      }

      return setSymbolDescriptor(O, key, Attributes);
    }

    return nativeDefineProperty(O, key, Attributes);
  };

  var $defineProperties = function defineProperties(O, Properties) {
    anObject(O);
    var properties = toIndexedObject(Properties);
    var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
    $forEach(keys, function (key) {
      if (!DESCRIPTORS || call($propertyIsEnumerable, properties, key)) $defineProperty(O, key, properties[key]);
    });
    return O;
  };

  var $create = function create(O, Properties) {
    return Properties === undefined ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
  };

  var $propertyIsEnumerable = function propertyIsEnumerable(V) {
    var P = toPropertyKey(V);
    var enumerable = call(nativePropertyIsEnumerable, this, P);
    if (this === ObjectPrototype && hasOwn(AllSymbols, P) && !hasOwn(ObjectPrototypeSymbols, P)) return false;
    return enumerable || !hasOwn(this, P) || !hasOwn(AllSymbols, P) || hasOwn(this, HIDDEN) && this[HIDDEN][P] ? enumerable : true;
  };

  var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
    var it = toIndexedObject(O);
    var key = toPropertyKey(P);
    if (it === ObjectPrototype && hasOwn(AllSymbols, key) && !hasOwn(ObjectPrototypeSymbols, key)) return;
    var descriptor = nativeGetOwnPropertyDescriptor(it, key);

    if (descriptor && hasOwn(AllSymbols, key) && !(hasOwn(it, HIDDEN) && it[HIDDEN][key])) {
      descriptor.enumerable = true;
    }

    return descriptor;
  };

  var $getOwnPropertyNames = function getOwnPropertyNames(O) {
    var names = nativeGetOwnPropertyNames(toIndexedObject(O));
    var result = [];
    $forEach(names, function (key) {
      if (!hasOwn(AllSymbols, key) && !hasOwn(hiddenKeys, key)) push(result, key);
    });
    return result;
  };

  var $getOwnPropertySymbols = function getOwnPropertySymbols(O) {
    var IS_OBJECT_PROTOTYPE = O === ObjectPrototype;
    var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
    var result = [];
    $forEach(names, function (key) {
      if (hasOwn(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || hasOwn(ObjectPrototype, key))) {
        push(result, AllSymbols[key]);
      }
    });
    return result;
  }; // `Symbol` constructor
  // https://tc39.es/ecma262/#sec-symbol-constructor


  if (!NATIVE_SYMBOL) {
    $Symbol = function Symbol() {
      if (isPrototypeOf(SymbolPrototype, this)) throw TypeError('Symbol is not a constructor');
      var description = !arguments.length || arguments[0] === undefined ? undefined : $toString(arguments[0]);
      var tag = uid(description);

      var setter = function setter(value) {
        if (this === ObjectPrototype) call(setter, ObjectPrototypeSymbols, value);
        if (hasOwn(this, HIDDEN) && hasOwn(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
        setSymbolDescriptor(this, tag, createPropertyDescriptor(1, value));
      };

      if (DESCRIPTORS && USE_SETTER) setSymbolDescriptor(ObjectPrototype, tag, {
        configurable: true,
        set: setter
      });
      return wrap(tag, description);
    };

    SymbolPrototype = $Symbol[PROTOTYPE];
    redefine(SymbolPrototype, 'toString', function toString() {
      return getInternalState(this).tag;
    });
    redefine($Symbol, 'withoutSetter', function (description) {
      return wrap(uid(description), description);
    });
    propertyIsEnumerableModule.f = $propertyIsEnumerable;
    definePropertyModule.f = $defineProperty;
    definePropertiesModule.f = $defineProperties;
    getOwnPropertyDescriptorModule.f = $getOwnPropertyDescriptor;
    getOwnPropertyNamesModule.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
    getOwnPropertySymbolsModule.f = $getOwnPropertySymbols;

    wrappedWellKnownSymbolModule.f = function (name) {
      return wrap(wellKnownSymbol(name), name);
    };

    if (DESCRIPTORS) {
      // https://github.com/tc39/proposal-Symbol-description
      nativeDefineProperty(SymbolPrototype, 'description', {
        configurable: true,
        get: function description() {
          return getInternalState(this).description;
        }
      });

      if (!IS_PURE) {
        redefine(ObjectPrototype, 'propertyIsEnumerable', $propertyIsEnumerable, {
          unsafe: true
        });
      }
    }
  }

  $({
    global: true,
    wrap: true,
    forced: !NATIVE_SYMBOL,
    sham: !NATIVE_SYMBOL
  }, {
    Symbol: $Symbol
  });
  $forEach(objectKeys(WellKnownSymbolsStore), function (name) {
    defineWellKnownSymbol(name);
  });
  $({
    target: SYMBOL,
    stat: true,
    forced: !NATIVE_SYMBOL
  }, {
    // `Symbol.for` method
    // https://tc39.es/ecma262/#sec-symbol.for
    'for': function _for(key) {
      var string = $toString(key);
      if (hasOwn(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
      var symbol = $Symbol(string);
      StringToSymbolRegistry[string] = symbol;
      SymbolToStringRegistry[symbol] = string;
      return symbol;
    },
    // `Symbol.keyFor` method
    // https://tc39.es/ecma262/#sec-symbol.keyfor
    keyFor: function keyFor(sym) {
      if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol');
      if (hasOwn(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
    },
    useSetter: function useSetter() {
      USE_SETTER = true;
    },
    useSimple: function useSimple() {
      USE_SETTER = false;
    }
  });
  $({
    target: 'Object',
    stat: true,
    forced: !NATIVE_SYMBOL,
    sham: !DESCRIPTORS
  }, {
    // `Object.create` method
    // https://tc39.es/ecma262/#sec-object.create
    create: $create,
    // `Object.defineProperty` method
    // https://tc39.es/ecma262/#sec-object.defineproperty
    defineProperty: $defineProperty,
    // `Object.defineProperties` method
    // https://tc39.es/ecma262/#sec-object.defineproperties
    defineProperties: $defineProperties,
    // `Object.getOwnPropertyDescriptor` method
    // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
    getOwnPropertyDescriptor: $getOwnPropertyDescriptor
  });
  $({
    target: 'Object',
    stat: true,
    forced: !NATIVE_SYMBOL
  }, {
    // `Object.getOwnPropertyNames` method
    // https://tc39.es/ecma262/#sec-object.getownpropertynames
    getOwnPropertyNames: $getOwnPropertyNames,
    // `Object.getOwnPropertySymbols` method
    // https://tc39.es/ecma262/#sec-object.getownpropertysymbols
    getOwnPropertySymbols: $getOwnPropertySymbols
  }); // Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
  // https://bugs.chromium.org/p/v8/issues/detail?id=3443

  $({
    target: 'Object',
    stat: true,
    forced: fails(function () {
      getOwnPropertySymbolsModule.f(1);
    })
  }, {
    getOwnPropertySymbols: function getOwnPropertySymbols(it) {
      return getOwnPropertySymbolsModule.f(toObject(it));
    }
  }); // `JSON.stringify` method behavior with symbols
  // https://tc39.es/ecma262/#sec-json.stringify

  if ($stringify) {
    var FORCED_JSON_STRINGIFY = !NATIVE_SYMBOL || fails(function () {
      var symbol = $Symbol(); // MS Edge converts symbol values to JSON as {}

      return $stringify([symbol]) != '[null]' // WebKit converts symbol values to JSON as null
      || $stringify({
        a: symbol
      }) != '{}' // V8 throws on boxed symbols
      || $stringify(Object(symbol)) != '{}';
    });
    $({
      target: 'JSON',
      stat: true,
      forced: FORCED_JSON_STRINGIFY
    }, {
      // eslint-disable-next-line no-unused-vars -- required for `.length`
      stringify: function stringify(it, replacer, space) {
        var args = arraySlice(arguments);
        var $replacer = replacer;
        if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined

        if (!isArray(replacer)) replacer = function replacer(key, value) {
          if (isCallable($replacer)) value = call($replacer, this, key, value);
          if (!isSymbol(value)) return value;
        };
        args[1] = replacer;
        return apply($stringify, null, args);
      }
    });
  } // `Symbol.prototype[@@toPrimitive]` method
  // https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive


  if (!SymbolPrototype[TO_PRIMITIVE]) {
    var valueOf = SymbolPrototype.valueOf; // eslint-disable-next-line no-unused-vars -- required for .length

    redefine(SymbolPrototype, TO_PRIMITIVE, function (hint) {
      // TODO: improve hint logic
      return call(valueOf, this);
    });
  } // `Symbol.prototype[@@toStringTag]` property
  // https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag


  setToStringTag($Symbol, SYMBOL);
  hiddenKeys[HIDDEN] = true;
  /***/
},
/* 537 */

/***/
function (module, exports, __webpack_require__) {
  var defineWellKnownSymbol = __webpack_require__(36); // `Symbol.matchAll` well-known symbol
  // https://tc39.es/ecma262/#sec-symbol.matchall


  defineWellKnownSymbol('matchAll');
  /***/
},
/* 538 */

/***/
function (module, exports, __webpack_require__) {
  var defineWellKnownSymbol = __webpack_require__(36); // `Symbol.match` well-known symbol
  // https://tc39.es/ecma262/#sec-symbol.match


  defineWellKnownSymbol('match');
  /***/
},
/* 539 */

/***/
function (module, exports, __webpack_require__) {
  var defineWellKnownSymbol = __webpack_require__(36); // `Symbol.replace` well-known symbol
  // https://tc39.es/ecma262/#sec-symbol.replace


  defineWellKnownSymbol('replace');
  /***/
},
/* 540 */

/***/
function (module, exports, __webpack_require__) {
  var defineWellKnownSymbol = __webpack_require__(36); // `Symbol.search` well-known symbol
  // https://tc39.es/ecma262/#sec-symbol.search


  defineWellKnownSymbol('search');
  /***/
},
/* 541 */

/***/
function (module, exports, __webpack_require__) {
  var defineWellKnownSymbol = __webpack_require__(36); // `Symbol.species` well-known symbol
  // https://tc39.es/ecma262/#sec-symbol.species


  defineWellKnownSymbol('species');
  /***/
},
/* 542 */

/***/
function (module, exports, __webpack_require__) {
  var defineWellKnownSymbol = __webpack_require__(36); // `Symbol.split` well-known symbol
  // https://tc39.es/ecma262/#sec-symbol.split


  defineWellKnownSymbol('split');
  /***/
},
/* 543 */

/***/
function (module, exports, __webpack_require__) {
  var defineWellKnownSymbol = __webpack_require__(36); // `Symbol.toPrimitive` well-known symbol
  // https://tc39.es/ecma262/#sec-symbol.toprimitive


  defineWellKnownSymbol('toPrimitive');
  /***/
},
/* 544 */

/***/
function (module, exports, __webpack_require__) {
  var defineWellKnownSymbol = __webpack_require__(36); // `Symbol.toStringTag` well-known symbol
  // https://tc39.es/ecma262/#sec-symbol.tostringtag


  defineWellKnownSymbol('toStringTag');
  /***/
},
/* 545 */

/***/
function (module, exports, __webpack_require__) {
  var defineWellKnownSymbol = __webpack_require__(36); // `Symbol.unscopables` well-known symbol
  // https://tc39.es/ecma262/#sec-symbol.unscopables


  defineWellKnownSymbol('unscopables');
  /***/
},
/* 546 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var ArrayBufferViewCore = __webpack_require__(16);

  var lengthOfArrayLike = __webpack_require__(23);

  var toIntegerOrInfinity = __webpack_require__(29);

  var aTypedArray = ArrayBufferViewCore.aTypedArray;
  var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod; // `%TypedArray%.prototype.at` method
  // https://github.com/tc39/proposal-relative-indexing-method

  exportTypedArrayMethod('at', function at(index) {
    var O = aTypedArray(this);
    var len = lengthOfArrayLike(O);
    var relativeIndex = toIntegerOrInfinity(index);
    var k = relativeIndex >= 0 ? relativeIndex : len + relativeIndex;
    return k < 0 || k >= len ? undefined : O[k];
  });
  /***/
},
/* 547 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var uncurryThis = __webpack_require__(3);

  var ArrayBufferViewCore = __webpack_require__(16);

  var $ArrayCopyWithin = __webpack_require__(193);

  var u$ArrayCopyWithin = uncurryThis($ArrayCopyWithin);
  var aTypedArray = ArrayBufferViewCore.aTypedArray;
  var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod; // `%TypedArray%.prototype.copyWithin` method
  // https://tc39.es/ecma262/#sec-%typedarray%.prototype.copywithin

  exportTypedArrayMethod('copyWithin', function copyWithin(target, start
  /* , end */
  ) {
    return u$ArrayCopyWithin(aTypedArray(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
  });
  /***/
},
/* 548 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var ArrayBufferViewCore = __webpack_require__(16);

  var $every = __webpack_require__(30).every;

  var aTypedArray = ArrayBufferViewCore.aTypedArray;
  var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod; // `%TypedArray%.prototype.every` method
  // https://tc39.es/ecma262/#sec-%typedarray%.prototype.every

  exportTypedArrayMethod('every', function every(callbackfn
  /* , thisArg */
  ) {
    return $every(aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  });
  /***/
},
/* 549 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var ArrayBufferViewCore = __webpack_require__(16);

  var call = __webpack_require__(19);

  var $fill = __webpack_require__(144);

  var aTypedArray = ArrayBufferViewCore.aTypedArray;
  var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod; // `%TypedArray%.prototype.fill` method
  // https://tc39.es/ecma262/#sec-%typedarray%.prototype.fill

  exportTypedArrayMethod('fill', function fill(value
  /* , start, end */
  ) {
    var length = arguments.length;
    return call($fill, aTypedArray(this), value, length > 1 ? arguments[1] : undefined, length > 2 ? arguments[2] : undefined);
  });
  /***/
},
/* 550 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var ArrayBufferViewCore = __webpack_require__(16);

  var $filter = __webpack_require__(30).filter;

  var fromSpeciesAndList = __webpack_require__(360);

  var aTypedArray = ArrayBufferViewCore.aTypedArray;
  var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod; // `%TypedArray%.prototype.filter` method
  // https://tc39.es/ecma262/#sec-%typedarray%.prototype.filter

  exportTypedArrayMethod('filter', function filter(callbackfn
  /* , thisArg */
  ) {
    var list = $filter(aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    return fromSpeciesAndList(this, list);
  });
  /***/
},
/* 551 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var ArrayBufferViewCore = __webpack_require__(16);

  var $findIndex = __webpack_require__(30).findIndex;

  var aTypedArray = ArrayBufferViewCore.aTypedArray;
  var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod; // `%TypedArray%.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-%typedarray%.prototype.findindex

  exportTypedArrayMethod('findIndex', function findIndex(predicate
  /* , thisArg */
  ) {
    return $findIndex(aTypedArray(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
  });
  /***/
},
/* 552 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var ArrayBufferViewCore = __webpack_require__(16);

  var $find = __webpack_require__(30).find;

  var aTypedArray = ArrayBufferViewCore.aTypedArray;
  var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod; // `%TypedArray%.prototype.find` method
  // https://tc39.es/ecma262/#sec-%typedarray%.prototype.find

  exportTypedArrayMethod('find', function find(predicate
  /* , thisArg */
  ) {
    return $find(aTypedArray(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
  });
  /***/
},
/* 553 */

/***/
function (module, exports, __webpack_require__) {
  var createTypedArrayConstructor = __webpack_require__(61); // `Float32Array` constructor
  // https://tc39.es/ecma262/#sec-typedarray-objects


  createTypedArrayConstructor('Float32', function (init) {
    return function Float32Array(data, byteOffset, length) {
      return init(this, data, byteOffset, length);
    };
  });
  /***/
},
/* 554 */

/***/
function (module, exports, __webpack_require__) {
  var createTypedArrayConstructor = __webpack_require__(61); // `Float64Array` constructor
  // https://tc39.es/ecma262/#sec-typedarray-objects


  createTypedArrayConstructor('Float64', function (init) {
    return function Float64Array(data, byteOffset, length) {
      return init(this, data, byteOffset, length);
    };
  });
  /***/
},
/* 555 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var ArrayBufferViewCore = __webpack_require__(16);

  var $forEach = __webpack_require__(30).forEach;

  var aTypedArray = ArrayBufferViewCore.aTypedArray;
  var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod; // `%TypedArray%.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-%typedarray%.prototype.foreach

  exportTypedArrayMethod('forEach', function forEach(callbackfn
  /* , thisArg */
  ) {
    $forEach(aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  });
  /***/
},
/* 556 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS = __webpack_require__(170);

  var exportTypedArrayStaticMethod = __webpack_require__(16).exportTypedArrayStaticMethod;

  var typedArrayFrom = __webpack_require__(234); // `%TypedArray%.from` method
  // https://tc39.es/ecma262/#sec-%typedarray%.from


  exportTypedArrayStaticMethod('from', typedArrayFrom, TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS);
  /***/
},
/* 557 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var ArrayBufferViewCore = __webpack_require__(16);

  var $includes = __webpack_require__(84).includes;

  var aTypedArray = ArrayBufferViewCore.aTypedArray;
  var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod; // `%TypedArray%.prototype.includes` method
  // https://tc39.es/ecma262/#sec-%typedarray%.prototype.includes

  exportTypedArrayMethod('includes', function includes(searchElement
  /* , fromIndex */
  ) {
    return $includes(aTypedArray(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
  });
  /***/
},
/* 558 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var ArrayBufferViewCore = __webpack_require__(16);

  var $indexOf = __webpack_require__(84).indexOf;

  var aTypedArray = ArrayBufferViewCore.aTypedArray;
  var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod; // `%TypedArray%.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-%typedarray%.prototype.indexof

  exportTypedArrayMethod('indexOf', function indexOf(searchElement
  /* , fromIndex */
  ) {
    return $indexOf(aTypedArray(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
  });
  /***/
},
/* 559 */

/***/
function (module, exports, __webpack_require__) {
  var createTypedArrayConstructor = __webpack_require__(61); // `Int16Array` constructor
  // https://tc39.es/ecma262/#sec-typedarray-objects


  createTypedArrayConstructor('Int16', function (init) {
    return function Int16Array(data, byteOffset, length) {
      return init(this, data, byteOffset, length);
    };
  });
  /***/
},
/* 560 */

/***/
function (module, exports, __webpack_require__) {
  var createTypedArrayConstructor = __webpack_require__(61); // `Int32Array` constructor
  // https://tc39.es/ecma262/#sec-typedarray-objects


  createTypedArrayConstructor('Int32', function (init) {
    return function Int32Array(data, byteOffset, length) {
      return init(this, data, byteOffset, length);
    };
  });
  /***/
},
/* 561 */

/***/
function (module, exports, __webpack_require__) {
  var createTypedArrayConstructor = __webpack_require__(61); // `Int8Array` constructor
  // https://tc39.es/ecma262/#sec-typedarray-objects


  createTypedArrayConstructor('Int8', function (init) {
    return function Int8Array(data, byteOffset, length) {
      return init(this, data, byteOffset, length);
    };
  });
  /***/
},
/* 562 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var global = __webpack_require__(1);

  var fails = __webpack_require__(2);

  var uncurryThis = __webpack_require__(3);

  var ArrayBufferViewCore = __webpack_require__(16);

  var ArrayIterators = __webpack_require__(132);

  var wellKnownSymbol = __webpack_require__(15);

  var ITERATOR = wellKnownSymbol('iterator');
  var Uint8Array = global.Uint8Array;
  var arrayValues = uncurryThis(ArrayIterators.values);
  var arrayKeys = uncurryThis(ArrayIterators.keys);
  var arrayEntries = uncurryThis(ArrayIterators.entries);
  var aTypedArray = ArrayBufferViewCore.aTypedArray;
  var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
  var TypedArrayPrototype = Uint8Array && Uint8Array.prototype;
  var GENERIC = !fails(function () {
    TypedArrayPrototype[ITERATOR].call([1]);
  });
  var ITERATOR_IS_VALUES = !!TypedArrayPrototype && TypedArrayPrototype.values && TypedArrayPrototype[ITERATOR] === TypedArrayPrototype.values && TypedArrayPrototype.values.name === 'values';

  var typedArrayValues = function values() {
    return arrayValues(aTypedArray(this));
  }; // `%TypedArray%.prototype.entries` method
  // https://tc39.es/ecma262/#sec-%typedarray%.prototype.entries


  exportTypedArrayMethod('entries', function entries() {
    return arrayEntries(aTypedArray(this));
  }, GENERIC); // `%TypedArray%.prototype.keys` method
  // https://tc39.es/ecma262/#sec-%typedarray%.prototype.keys

  exportTypedArrayMethod('keys', function keys() {
    return arrayKeys(aTypedArray(this));
  }, GENERIC); // `%TypedArray%.prototype.values` method
  // https://tc39.es/ecma262/#sec-%typedarray%.prototype.values

  exportTypedArrayMethod('values', typedArrayValues, GENERIC || !ITERATOR_IS_VALUES, {
    name: 'values'
  }); // `%TypedArray%.prototype[@@iterator]` method
  // https://tc39.es/ecma262/#sec-%typedarray%.prototype-@@iterator

  exportTypedArrayMethod(ITERATOR, typedArrayValues, GENERIC || !ITERATOR_IS_VALUES, {
    name: 'values'
  });
  /***/
},
/* 563 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var ArrayBufferViewCore = __webpack_require__(16);

  var uncurryThis = __webpack_require__(3);

  var aTypedArray = ArrayBufferViewCore.aTypedArray;
  var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
  var $join = uncurryThis([].join); // `%TypedArray%.prototype.join` method
  // https://tc39.es/ecma262/#sec-%typedarray%.prototype.join

  exportTypedArrayMethod('join', function join(separator) {
    return $join(aTypedArray(this), separator);
  });
  /***/
},
/* 564 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var ArrayBufferViewCore = __webpack_require__(16);

  var apply = __webpack_require__(40);

  var $lastIndexOf = __webpack_require__(196);

  var aTypedArray = ArrayBufferViewCore.aTypedArray;
  var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod; // `%TypedArray%.prototype.lastIndexOf` method
  // https://tc39.es/ecma262/#sec-%typedarray%.prototype.lastindexof

  exportTypedArrayMethod('lastIndexOf', function lastIndexOf(searchElement
  /* , fromIndex */
  ) {
    var length = arguments.length;
    return apply($lastIndexOf, aTypedArray(this), length > 1 ? [searchElement, arguments[1]] : [searchElement]);
  });
  /***/
},
/* 565 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var ArrayBufferViewCore = __webpack_require__(16);

  var $map = __webpack_require__(30).map;

  var typedArraySpeciesConstructor = __webpack_require__(130);

  var aTypedArray = ArrayBufferViewCore.aTypedArray;
  var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod; // `%TypedArray%.prototype.map` method
  // https://tc39.es/ecma262/#sec-%typedarray%.prototype.map

  exportTypedArrayMethod('map', function map(mapfn
  /* , thisArg */
  ) {
    return $map(aTypedArray(this), mapfn, arguments.length > 1 ? arguments[1] : undefined, function (O, length) {
      return new (typedArraySpeciesConstructor(O))(length);
    });
  });
  /***/
},
/* 566 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var ArrayBufferViewCore = __webpack_require__(16);

  var TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS = __webpack_require__(170);

  var aTypedArrayConstructor = ArrayBufferViewCore.aTypedArrayConstructor;
  var exportTypedArrayStaticMethod = ArrayBufferViewCore.exportTypedArrayStaticMethod; // `%TypedArray%.of` method
  // https://tc39.es/ecma262/#sec-%typedarray%.of

  exportTypedArrayStaticMethod('of', function
    /* ...items */
  of() {
    var index = 0;
    var length = arguments.length;
    var result = new (aTypedArrayConstructor(this))(length);

    while (length > index) {
      result[index] = arguments[index++];
    }

    return result;
  }, TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS);
  /***/
},
/* 567 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var ArrayBufferViewCore = __webpack_require__(16);

  var $reduceRight = __webpack_require__(109).right;

  var aTypedArray = ArrayBufferViewCore.aTypedArray;
  var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod; // `%TypedArray%.prototype.reduceRicht` method
  // https://tc39.es/ecma262/#sec-%typedarray%.prototype.reduceright

  exportTypedArrayMethod('reduceRight', function reduceRight(callbackfn
  /* , initialValue */
  ) {
    var length = arguments.length;
    return $reduceRight(aTypedArray(this), callbackfn, length, length > 1 ? arguments[1] : undefined);
  });
  /***/
},
/* 568 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var ArrayBufferViewCore = __webpack_require__(16);

  var $reduce = __webpack_require__(109).left;

  var aTypedArray = ArrayBufferViewCore.aTypedArray;
  var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod; // `%TypedArray%.prototype.reduce` method
  // https://tc39.es/ecma262/#sec-%typedarray%.prototype.reduce

  exportTypedArrayMethod('reduce', function reduce(callbackfn
  /* , initialValue */
  ) {
    var length = arguments.length;
    return $reduce(aTypedArray(this), callbackfn, length, length > 1 ? arguments[1] : undefined);
  });
  /***/
},
/* 569 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var ArrayBufferViewCore = __webpack_require__(16);

  var aTypedArray = ArrayBufferViewCore.aTypedArray;
  var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
  var floor = Math.floor; // `%TypedArray%.prototype.reverse` method
  // https://tc39.es/ecma262/#sec-%typedarray%.prototype.reverse

  exportTypedArrayMethod('reverse', function reverse() {
    var that = this;
    var length = aTypedArray(that).length;
    var middle = floor(length / 2);
    var index = 0;
    var value;

    while (index < middle) {
      value = that[index];
      that[index++] = that[--length];
      that[length] = value;
    }

    return that;
  });
  /***/
},
/* 570 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var global = __webpack_require__(1);

  var call = __webpack_require__(19);

  var ArrayBufferViewCore = __webpack_require__(16);

  var lengthOfArrayLike = __webpack_require__(23);

  var toOffset = __webpack_require__(233);

  var toIndexedObject = __webpack_require__(22);

  var fails = __webpack_require__(2);

  var RangeError = global.RangeError;
  var Int8Array = global.Int8Array;
  var Int8ArrayPrototype = Int8Array && Int8Array.prototype;
  var $set = Int8ArrayPrototype && Int8ArrayPrototype.set;
  var aTypedArray = ArrayBufferViewCore.aTypedArray;
  var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
  var WORKS_WITH_OBJECTS_AND_GEERIC_ON_TYPED_ARRAYS = !fails(function () {
    // eslint-disable-next-line es/no-typed-arrays -- required for testing
    var array = new Uint8ClampedArray(2);
    call($set, array, {
      length: 1,
      0: 3
    }, 1);
    return array[1] !== 3;
  }); // https://bugs.chromium.org/p/v8/issues/detail?id=11294 and other

  var TO_OBJECT_BUG = WORKS_WITH_OBJECTS_AND_GEERIC_ON_TYPED_ARRAYS && ArrayBufferViewCore.NATIVE_ARRAY_BUFFER_VIEWS && fails(function () {
    var array = new Int8Array(2);
    array.set(1);
    array.set('2', 1);
    return array[0] !== 0 || array[1] !== 2;
  }); // `%TypedArray%.prototype.set` method
  // https://tc39.es/ecma262/#sec-%typedarray%.prototype.set

  exportTypedArrayMethod('set', function set(arrayLike
  /* , offset */
  ) {
    aTypedArray(this);
    var offset = toOffset(arguments.length > 1 ? arguments[1] : undefined, 1);
    var src = toIndexedObject(arrayLike);
    if (WORKS_WITH_OBJECTS_AND_GEERIC_ON_TYPED_ARRAYS) return call($set, this, src, offset);
    var length = this.length;
    var len = lengthOfArrayLike(src);
    var index = 0;
    if (len + offset > length) throw RangeError('Wrong length');

    while (index < len) {
      this[offset + index] = src[index++];
    }
  }, !WORKS_WITH_OBJECTS_AND_GEERIC_ON_TYPED_ARRAYS || TO_OBJECT_BUG);
  /***/
},
/* 571 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var ArrayBufferViewCore = __webpack_require__(16);

  var typedArraySpeciesConstructor = __webpack_require__(130);

  var fails = __webpack_require__(2);

  var arraySlice = __webpack_require__(68);

  var aTypedArray = ArrayBufferViewCore.aTypedArray;
  var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
  var FORCED = fails(function () {
    // eslint-disable-next-line es/no-typed-arrays -- required for testing
    new Int8Array(1).slice();
  }); // `%TypedArray%.prototype.slice` method
  // https://tc39.es/ecma262/#sec-%typedarray%.prototype.slice

  exportTypedArrayMethod('slice', function slice(start, end) {
    var list = arraySlice(aTypedArray(this), start, end);
    var C = typedArraySpeciesConstructor(this);
    var index = 0;
    var length = list.length;
    var result = new C(length);

    while (length > index) {
      result[index] = list[index++];
    }

    return result;
  }, FORCED);
  /***/
},
/* 572 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var ArrayBufferViewCore = __webpack_require__(16);

  var $some = __webpack_require__(30).some;

  var aTypedArray = ArrayBufferViewCore.aTypedArray;
  var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod; // `%TypedArray%.prototype.some` method
  // https://tc39.es/ecma262/#sec-%typedarray%.prototype.some

  exportTypedArrayMethod('some', function some(callbackfn
  /* , thisArg */
  ) {
    return $some(aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  });
  /***/
},
/* 573 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var global = __webpack_require__(1);

  var uncurryThis = __webpack_require__(3);

  var fails = __webpack_require__(2);

  var aCallable = __webpack_require__(34);

  var internalSort = __webpack_require__(145);

  var ArrayBufferViewCore = __webpack_require__(16);

  var FF = __webpack_require__(202);

  var IE_OR_EDGE = __webpack_require__(203);

  var V8 = __webpack_require__(64);

  var WEBKIT = __webpack_require__(150);

  var Array = global.Array;
  var aTypedArray = ArrayBufferViewCore.aTypedArray;
  var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
  var Uint16Array = global.Uint16Array;
  var un$Sort = Uint16Array && uncurryThis(Uint16Array.prototype.sort); // WebKit

  var ACCEPT_INCORRECT_ARGUMENTS = !!un$Sort && !(fails(function () {
    un$Sort(new Uint16Array(2), null);
  }) && fails(function () {
    un$Sort(new Uint16Array(2), {});
  }));
  var STABLE_SORT = !!un$Sort && !fails(function () {
    // feature detection can be too slow, so check engines versions
    if (V8) return V8 < 74;
    if (FF) return FF < 67;
    if (IE_OR_EDGE) return true;
    if (WEBKIT) return WEBKIT < 602;
    var array = new Uint16Array(516);
    var expected = Array(516);
    var index, mod;

    for (index = 0; index < 516; index++) {
      mod = index % 4;
      array[index] = 515 - index;
      expected[index] = index - 2 * mod + 3;
    }

    un$Sort(array, function (a, b) {
      return (a / 4 | 0) - (b / 4 | 0);
    });

    for (index = 0; index < 516; index++) {
      if (array[index] !== expected[index]) return true;
    }
  });

  var getSortCompare = function getSortCompare(comparefn) {
    return function (x, y) {
      if (comparefn !== undefined) return +comparefn(x, y) || 0; // eslint-disable-next-line no-self-compare -- NaN check

      if (y !== y) return -1; // eslint-disable-next-line no-self-compare -- NaN check

      if (x !== x) return 1;
      if (x === 0 && y === 0) return 1 / x > 0 && 1 / y < 0 ? 1 : -1;
      return x > y;
    };
  }; // `%TypedArray%.prototype.sort` method
  // https://tc39.es/ecma262/#sec-%typedarray%.prototype.sort


  exportTypedArrayMethod('sort', function sort(comparefn) {
    if (comparefn !== undefined) aCallable(comparefn);
    if (STABLE_SORT) return un$Sort(this, comparefn);
    return internalSort(aTypedArray(this), getSortCompare(comparefn));
  }, !STABLE_SORT || ACCEPT_INCORRECT_ARGUMENTS);
  /***/
},
/* 574 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var ArrayBufferViewCore = __webpack_require__(16);

  var toLength = __webpack_require__(44);

  var toAbsoluteIndex = __webpack_require__(60);

  var typedArraySpeciesConstructor = __webpack_require__(130);

  var aTypedArray = ArrayBufferViewCore.aTypedArray;
  var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod; // `%TypedArray%.prototype.subarray` method
  // https://tc39.es/ecma262/#sec-%typedarray%.prototype.subarray

  exportTypedArrayMethod('subarray', function subarray(begin, end) {
    var O = aTypedArray(this);
    var length = O.length;
    var beginIndex = toAbsoluteIndex(begin, length);
    var C = typedArraySpeciesConstructor(O);
    return new C(O.buffer, O.byteOffset + beginIndex * O.BYTES_PER_ELEMENT, toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - beginIndex));
  });
  /***/
},
/* 575 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var global = __webpack_require__(1);

  var apply = __webpack_require__(40);

  var ArrayBufferViewCore = __webpack_require__(16);

  var fails = __webpack_require__(2);

  var arraySlice = __webpack_require__(68);

  var Int8Array = global.Int8Array;
  var aTypedArray = ArrayBufferViewCore.aTypedArray;
  var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
  var $toLocaleString = [].toLocaleString; // iOS Safari 6.x fails here

  var TO_LOCALE_STRING_BUG = !!Int8Array && fails(function () {
    $toLocaleString.call(new Int8Array(1));
  });
  var FORCED = fails(function () {
    return [1, 2].toLocaleString() != new Int8Array([1, 2]).toLocaleString();
  }) || !fails(function () {
    Int8Array.prototype.toLocaleString.call([1, 2]);
  }); // `%TypedArray%.prototype.toLocaleString` method
  // https://tc39.es/ecma262/#sec-%typedarray%.prototype.tolocalestring

  exportTypedArrayMethod('toLocaleString', function toLocaleString() {
    return apply($toLocaleString, TO_LOCALE_STRING_BUG ? arraySlice(aTypedArray(this)) : aTypedArray(this), arraySlice(arguments));
  }, FORCED);
  /***/
},
/* 576 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var exportTypedArrayMethod = __webpack_require__(16).exportTypedArrayMethod;

  var fails = __webpack_require__(2);

  var global = __webpack_require__(1);

  var uncurryThis = __webpack_require__(3);

  var Uint8Array = global.Uint8Array;
  var Uint8ArrayPrototype = Uint8Array && Uint8Array.prototype || {};
  var arrayToString = [].toString;
  var join = uncurryThis([].join);

  if (fails(function () {
    arrayToString.call({});
  })) {
    arrayToString = function toString() {
      return join(this);
    };
  }

  var IS_NOT_ARRAY_METHOD = Uint8ArrayPrototype.toString != arrayToString; // `%TypedArray%.prototype.toString` method
  // https://tc39.es/ecma262/#sec-%typedarray%.prototype.tostring

  exportTypedArrayMethod('toString', arrayToString, IS_NOT_ARRAY_METHOD);
  /***/
},
/* 577 */

/***/
function (module, exports, __webpack_require__) {
  var createTypedArrayConstructor = __webpack_require__(61); // `Uint16Array` constructor
  // https://tc39.es/ecma262/#sec-typedarray-objects


  createTypedArrayConstructor('Uint16', function (init) {
    return function Uint16Array(data, byteOffset, length) {
      return init(this, data, byteOffset, length);
    };
  });
  /***/
},
/* 578 */

/***/
function (module, exports, __webpack_require__) {
  var createTypedArrayConstructor = __webpack_require__(61); // `Uint32Array` constructor
  // https://tc39.es/ecma262/#sec-typedarray-objects


  createTypedArrayConstructor('Uint32', function (init) {
    return function Uint32Array(data, byteOffset, length) {
      return init(this, data, byteOffset, length);
    };
  });
  /***/
},
/* 579 */

/***/
function (module, exports, __webpack_require__) {
  var createTypedArrayConstructor = __webpack_require__(61); // `Uint8Array` constructor
  // https://tc39.es/ecma262/#sec-typedarray-objects


  createTypedArrayConstructor('Uint8', function (init) {
    return function Uint8Array(data, byteOffset, length) {
      return init(this, data, byteOffset, length);
    };
  });
  /***/
},
/* 580 */

/***/
function (module, exports, __webpack_require__) {
  var createTypedArrayConstructor = __webpack_require__(61); // `Uint8ClampedArray` constructor
  // https://tc39.es/ecma262/#sec-typedarray-objects


  createTypedArrayConstructor('Uint8', function (init) {
    return function Uint8ClampedArray(data, byteOffset, length) {
      return init(this, data, byteOffset, length);
    };
  }, true);
  /***/
},
/* 581 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $ = __webpack_require__(0);

  var uncurryThis = __webpack_require__(3);

  var toString = __webpack_require__(18);

  var fromCharCode = String.fromCharCode;
  var charAt = uncurryThis(''.charAt);
  var exec = uncurryThis(/./.exec);
  var stringSlice = uncurryThis(''.slice);
  var hex2 = /^[\da-f]{2}$/i;
  var hex4 = /^[\da-f]{4}$/i; // `unescape` method
  // https://tc39.es/ecma262/#sec-unescape-string

  $({
    global: true
  }, {
    unescape: function unescape(string) {
      var str = toString(string);
      var result = '';
      var length = str.length;
      var index = 0;
      var chr, part;

      while (index < length) {
        chr = charAt(str, index++);

        if (chr === '%') {
          if (charAt(str, index) === 'u') {
            part = stringSlice(str, index + 1, index + 5);

            if (exec(hex4, part)) {
              result += fromCharCode(parseInt(part, 16));
              index += 5;
              continue;
            }
          } else {
            part = stringSlice(str, index, index + 2);

            if (exec(hex2, part)) {
              result += fromCharCode(parseInt(part, 16));
              index += 2;
              continue;
            }
          }
        }

        result += chr;
      }

      return result;
    }
  });
  /***/
},
/* 582 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var global = __webpack_require__(1);

  var uncurryThis = __webpack_require__(3);

  var redefineAll = __webpack_require__(78);

  var InternalMetadataModule = __webpack_require__(70);

  var collection = __webpack_require__(112);

  var collectionWeak = __webpack_require__(198);

  var isObject = __webpack_require__(13);

  var isExtensible = __webpack_require__(120);

  var enforceInternalState = __webpack_require__(27).enforce;

  var NATIVE_WEAK_MAP = __webpack_require__(220);

  var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
  var InternalWeakMap;

  var wrapper = function wrapper(init) {
    return function WeakMap() {
      return init(this, arguments.length ? arguments[0] : undefined);
    };
  }; // `WeakMap` constructor
  // https://tc39.es/ecma262/#sec-weakmap-constructor


  var $WeakMap = collection('WeakMap', wrapper, collectionWeak); // IE11 WeakMap frozen keys fix
  // We can't use feature detection because it crash some old IE builds
  // https://github.com/zloirock/core-js/issues/485

  if (NATIVE_WEAK_MAP && IS_IE11) {
    InternalWeakMap = collectionWeak.getConstructor(wrapper, 'WeakMap', true);
    InternalMetadataModule.enable();
    var WeakMapPrototype = $WeakMap.prototype;
    var nativeDelete = uncurryThis(WeakMapPrototype['delete']);
    var nativeHas = uncurryThis(WeakMapPrototype.has);
    var nativeGet = uncurryThis(WeakMapPrototype.get);
    var nativeSet = uncurryThis(WeakMapPrototype.set);
    redefineAll(WeakMapPrototype, {
      'delete': function _delete(key) {
        if (isObject(key) && !isExtensible(key)) {
          var state = enforceInternalState(this);
          if (!state.frozen) state.frozen = new InternalWeakMap();
          return nativeDelete(this, key) || state.frozen['delete'](key);
        }

        return nativeDelete(this, key);
      },
      has: function has(key) {
        if (isObject(key) && !isExtensible(key)) {
          var state = enforceInternalState(this);
          if (!state.frozen) state.frozen = new InternalWeakMap();
          return nativeHas(this, key) || state.frozen.has(key);
        }

        return nativeHas(this, key);
      },
      get: function get(key) {
        if (isObject(key) && !isExtensible(key)) {
          var state = enforceInternalState(this);
          if (!state.frozen) state.frozen = new InternalWeakMap();
          return nativeHas(this, key) ? nativeGet(this, key) : state.frozen.get(key);
        }

        return nativeGet(this, key);
      },
      set: function set(key, value) {
        if (isObject(key) && !isExtensible(key)) {
          var state = enforceInternalState(this);
          if (!state.frozen) state.frozen = new InternalWeakMap();
          nativeHas(this, key) ? nativeSet(this, key, value) : state.frozen.set(key, value);
        } else nativeSet(this, key, value);

        return this;
      }
    });
  }
  /***/

},
/* 583 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var collection = __webpack_require__(112);

  var collectionWeak = __webpack_require__(198); // `WeakSet` constructor
  // https://tc39.es/ecma262/#sec-weakset-constructor


  collection('WeakSet', function (init) {
    return function WeakSet() {
      return init(this, arguments.length ? arguments[0] : undefined);
    };
  }, collectionWeak);
  /***/
},
/* 584 */

/***/
function (module, exports, __webpack_require__) {
  var global = __webpack_require__(1);

  var DOMIterables = __webpack_require__(200);

  var DOMTokenListPrototype = __webpack_require__(201);

  var forEach = __webpack_require__(194);

  var createNonEnumerableProperty = __webpack_require__(35);

  var handlePrototype = function handlePrototype(CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype && CollectionPrototype.forEach !== forEach) try {
      createNonEnumerableProperty(CollectionPrototype, 'forEach', forEach);
    } catch (error) {
      CollectionPrototype.forEach = forEach;
    }
  };

  for (var COLLECTION_NAME in DOMIterables) {
    if (DOMIterables[COLLECTION_NAME]) {
      handlePrototype(global[COLLECTION_NAME] && global[COLLECTION_NAME].prototype);
    }
  }

  handlePrototype(DOMTokenListPrototype);
  /***/
},
/* 585 */

/***/
function (module, exports, __webpack_require__) {
  var global = __webpack_require__(1);

  var DOMIterables = __webpack_require__(200);

  var DOMTokenListPrototype = __webpack_require__(201);

  var ArrayIteratorMethods = __webpack_require__(132);

  var createNonEnumerableProperty = __webpack_require__(35);

  var wellKnownSymbol = __webpack_require__(15);

  var ITERATOR = wellKnownSymbol('iterator');
  var TO_STRING_TAG = wellKnownSymbol('toStringTag');
  var ArrayValues = ArrayIteratorMethods.values;

  var handlePrototype = function handlePrototype(CollectionPrototype, COLLECTION_NAME) {
    if (CollectionPrototype) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
        createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
      } catch (error) {
        CollectionPrototype[ITERATOR] = ArrayValues;
      }

      if (!CollectionPrototype[TO_STRING_TAG]) {
        createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
      }

      if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
        // some Chrome versions have non-configurable methods on DOMTokenList
        if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
          createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
        } catch (error) {
          CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
        }
      }
    }
  };

  for (var COLLECTION_NAME in DOMIterables) {
    handlePrototype(global[COLLECTION_NAME] && global[COLLECTION_NAME].prototype, COLLECTION_NAME);
  }

  handlePrototype(DOMTokenListPrototype, 'DOMTokenList');
  /***/
},
/* 586 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $ = __webpack_require__(0);

  var tryNodeRequire = __webpack_require__(359);

  var getBuiltIn = __webpack_require__(26);

  var fails = __webpack_require__(2);

  var create = __webpack_require__(41);

  var createPropertyDescriptor = __webpack_require__(47);

  var defineProperty = __webpack_require__(20).f;

  var defineProperties = __webpack_require__(97).f;

  var redefine = __webpack_require__(24);

  var hasOwn = __webpack_require__(21);

  var anInstance = __webpack_require__(50);

  var anObject = __webpack_require__(10);

  var errorToString = __webpack_require__(205);

  var normalizeStringArgument = __webpack_require__(96);

  var DOMExceptionConstants = __webpack_require__(199);

  var clearErrorStack = __webpack_require__(111);

  var InternalStateModule = __webpack_require__(27);

  var DESCRIPTORS = __webpack_require__(12);

  var IS_PURE = __webpack_require__(31);

  var DOM_EXCEPTION = 'DOMException';
  var DATA_CLONE_ERR = 'DATA_CLONE_ERR';
  var Error = getBuiltIn('Error'); // NodeJS < 17.0 does not expose `DOMException` to global

  var NativeDOMException = getBuiltIn(DOM_EXCEPTION) || function () {
    try {
      // NodeJS < 15.0 does not expose `MessageChannel` to global
      var MessageChannel = getBuiltIn('MessageChannel') || tryNodeRequire('worker_threads').MessageChannel; // eslint-disable-next-line es/no-weak-map, unicorn/require-post-message-target-origin -- safe

      new MessageChannel().port1.postMessage(new WeakMap());
    } catch (error) {
      if (error.name == DATA_CLONE_ERR && error.code == 25) return error.constructor;
    }
  }();

  var NativeDOMExceptionPrototype = NativeDOMException && NativeDOMException.prototype;
  var ErrorPrototype = Error.prototype;
  var setInternalState = InternalStateModule.set;
  var getInternalState = InternalStateModule.getterFor(DOM_EXCEPTION);
  var HAS_STACK = ('stack' in Error(DOM_EXCEPTION));

  var codeFor = function codeFor(name) {
    return hasOwn(DOMExceptionConstants, name) && DOMExceptionConstants[name].m ? DOMExceptionConstants[name].c : 0;
  };

  var $DOMException = function DOMException() {
    anInstance(this, DOMExceptionPrototype);
    var argumentsLength = arguments.length;
    var message = normalizeStringArgument(argumentsLength < 1 ? undefined : arguments[0]);
    var name = normalizeStringArgument(argumentsLength < 2 ? undefined : arguments[1], 'Error');
    var code = codeFor(name);
    setInternalState(this, {
      type: DOM_EXCEPTION,
      name: name,
      message: message,
      code: code
    });

    if (!DESCRIPTORS) {
      this.name = name;
      this.message = message;
      this.code = code;
    }

    if (HAS_STACK) {
      var error = Error(message);
      error.name = DOM_EXCEPTION;
      defineProperty(this, 'stack', createPropertyDescriptor(1, clearErrorStack(error.stack, 1)));
    }
  };

  var DOMExceptionPrototype = $DOMException.prototype = create(ErrorPrototype);

  var createGetterDescriptor = function createGetterDescriptor(get) {
    return {
      enumerable: true,
      configurable: true,
      get: get
    };
  };

  var getterFor = function getterFor(key) {
    return createGetterDescriptor(function () {
      return getInternalState(this)[key];
    });
  };

  if (DESCRIPTORS) defineProperties(DOMExceptionPrototype, {
    name: getterFor('name'),
    message: getterFor('message'),
    code: getterFor('code')
  });
  defineProperty(DOMExceptionPrototype, 'constructor', createPropertyDescriptor(1, $DOMException)); // FF36- DOMException is a function, but can't be constructed

  var INCORRECT_CONSTRUCTOR = fails(function () {
    return !(new NativeDOMException() instanceof Error);
  }); // Safari 10.1 / Chrome 32- / IE8- DOMException.prototype.toString bugs

  var INCORRECT_TO_STRING = INCORRECT_CONSTRUCTOR || fails(function () {
    return ErrorPrototype.toString !== errorToString || String(new NativeDOMException(1, 2)) !== '2: 1';
  }); // Deno 1.6.3- DOMException.prototype.code just missed

  var INCORRECT_CODE = INCORRECT_CONSTRUCTOR || fails(function () {
    return new NativeDOMException(1, 'DataCloneError').code !== 25;
  }); // Deno 1.6.3- DOMException constants just missed

  var MISSED_CONSTANTS = INCORRECT_CONSTRUCTOR || NativeDOMException[DATA_CLONE_ERR] !== 25 || NativeDOMExceptionPrototype[DATA_CLONE_ERR] !== 25;
  var FORCED_CONSTRUCTOR = IS_PURE ? INCORRECT_TO_STRING || INCORRECT_CODE || MISSED_CONSTANTS : INCORRECT_CONSTRUCTOR; // `DOMException` constructor
  // https://webidl.spec.whatwg.org/#idl-DOMException

  $({
    global: true,
    forced: FORCED_CONSTRUCTOR
  }, {
    DOMException: FORCED_CONSTRUCTOR ? $DOMException : NativeDOMException
  });
  var PolyfilledDOMException = getBuiltIn(DOM_EXCEPTION);
  var PolyfilledDOMExceptionPrototype = PolyfilledDOMException.prototype;

  if (INCORRECT_TO_STRING && (IS_PURE || NativeDOMException === PolyfilledDOMException)) {
    redefine(PolyfilledDOMExceptionPrototype, 'toString', errorToString);
  }

  if (INCORRECT_CODE && DESCRIPTORS && NativeDOMException === PolyfilledDOMException) {
    defineProperty(PolyfilledDOMExceptionPrototype, 'code', createGetterDescriptor(function () {
      return codeFor(anObject(this).name);
    }));
  }

  for (var key in DOMExceptionConstants) {
    if (hasOwn(DOMExceptionConstants, key)) {
      var constant = DOMExceptionConstants[key];
      var constantName = constant.s;
      var descriptor = createPropertyDescriptor(6, constant.c);

      if (!hasOwn(PolyfilledDOMException, constantName)) {
        defineProperty(PolyfilledDOMException, constantName, descriptor);
      }

      if (!hasOwn(PolyfilledDOMExceptionPrototype, constantName)) {
        defineProperty(PolyfilledDOMExceptionPrototype, constantName, descriptor);
      }
    }
  }
  /***/

},
/* 587 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $ = __webpack_require__(0);

  var getBuiltIn = __webpack_require__(26);

  var createPropertyDescriptor = __webpack_require__(47);

  var defineProperty = __webpack_require__(20).f;

  var hasOwn = __webpack_require__(21);

  var anInstance = __webpack_require__(50);

  var inheritIfRequired = __webpack_require__(75);

  var normalizeStringArgument = __webpack_require__(96);

  var DOMExceptionConstants = __webpack_require__(199);

  var clearErrorStack = __webpack_require__(111);

  var IS_PURE = __webpack_require__(31);

  var DOM_EXCEPTION = 'DOMException';
  var Error = getBuiltIn('Error');
  var NativeDOMException = getBuiltIn(DOM_EXCEPTION);

  var $DOMException = function DOMException() {
    anInstance(this, DOMExceptionPrototype);
    var argumentsLength = arguments.length;
    var message = normalizeStringArgument(argumentsLength < 1 ? undefined : arguments[0]);
    var name = normalizeStringArgument(argumentsLength < 2 ? undefined : arguments[1], 'Error');
    var that = new NativeDOMException(message, name);
    var error = Error(message);
    error.name = DOM_EXCEPTION;
    defineProperty(that, 'stack', createPropertyDescriptor(1, clearErrorStack(error.stack, 1)));
    inheritIfRequired(that, this, $DOMException);
    return that;
  };

  var DOMExceptionPrototype = $DOMException.prototype = NativeDOMException.prototype;
  var ERROR_HAS_STACK = ('stack' in Error(DOM_EXCEPTION));
  var DOM_EXCEPTION_HAS_STACK = ('stack' in new NativeDOMException(1, 2));
  var FORCED_CONSTRUCTOR = ERROR_HAS_STACK && !DOM_EXCEPTION_HAS_STACK; // `DOMException` constructor patch for `.stack` where it's required
  // https://webidl.spec.whatwg.org/#es-DOMException-specialness

  $({
    global: true,
    forced: IS_PURE || FORCED_CONSTRUCTOR
  }, {
    // TODO: fix export logic
    DOMException: FORCED_CONSTRUCTOR ? $DOMException : NativeDOMException
  });
  var PolyfilledDOMException = getBuiltIn(DOM_EXCEPTION);
  var PolyfilledDOMExceptionPrototype = PolyfilledDOMException.prototype;

  if (PolyfilledDOMExceptionPrototype.constructor !== PolyfilledDOMException) {
    if (!IS_PURE) {
      defineProperty(PolyfilledDOMExceptionPrototype, 'constructor', createPropertyDescriptor(1, PolyfilledDOMException));
    }

    for (var key in DOMExceptionConstants) {
      if (hasOwn(DOMExceptionConstants, key)) {
        var constant = DOMExceptionConstants[key];
        var constantName = constant.s;

        if (!hasOwn(PolyfilledDOMException, constantName)) {
          defineProperty(PolyfilledDOMException, constantName, createPropertyDescriptor(6, constant.c));
        }
      }
    }
  }
  /***/

},
/* 588 */

/***/
function (module, exports, __webpack_require__) {
  var getBuiltIn = __webpack_require__(26);

  var setToStringTag = __webpack_require__(49);

  var DOM_EXCEPTION = 'DOMException';
  setToStringTag(getBuiltIn(DOM_EXCEPTION), DOM_EXCEPTION);
  /***/
},
/* 589 */

/***/
function (module, exports, __webpack_require__) {
  var $ = __webpack_require__(0);

  var global = __webpack_require__(1);

  var task = __webpack_require__(167);

  var FORCED = !global.setImmediate || !global.clearImmediate; // http://w3c.github.io/setImmediate/

  $({
    global: true,
    bind: true,
    enumerable: true,
    forced: FORCED
  }, {
    // `setImmediate` method
    // http://w3c.github.io/setImmediate/#si-setImmediate
    setImmediate: task.set,
    // `clearImmediate` method
    // http://w3c.github.io/setImmediate/#si-clearImmediate
    clearImmediate: task.clear
  });
  /***/
},
/* 590 */

/***/
function (module, exports, __webpack_require__) {
  var $ = __webpack_require__(0);

  var global = __webpack_require__(1);

  var microtask = __webpack_require__(217);

  var IS_NODE = __webpack_require__(69);

  var process = global.process; // `queueMicrotask` method
  // https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-queuemicrotask

  $({
    global: true,
    enumerable: true,
    noTargetGet: true
  }, {
    queueMicrotask: function queueMicrotask(fn) {
      var domain = IS_NODE && process.domain;
      microtask(domain ? domain.bind(fn) : fn);
    }
  });
  /***/
},
/* 591 */

/***/
function (module, exports, __webpack_require__) {
  var IS_PURE = __webpack_require__(31);

  var $ = __webpack_require__(0);

  var global = __webpack_require__(1);

  var getBuiltin = __webpack_require__(26);

  var uncurryThis = __webpack_require__(3);

  var fails = __webpack_require__(2);

  var uid = __webpack_require__(82);

  var isCallable = __webpack_require__(17);

  var isConstructor = __webpack_require__(76);

  var isObject = __webpack_require__(13);

  var isSymbol = __webpack_require__(77);

  var iterate = __webpack_require__(59);

  var anObject = __webpack_require__(10);

  var classof = __webpack_require__(63);

  var hasOwn = __webpack_require__(21);

  var createProperty = __webpack_require__(56);

  var createNonEnumerableProperty = __webpack_require__(35);

  var lengthOfArrayLike = __webpack_require__(23);

  var validateArgumentsLength = __webpack_require__(237);

  var regExpFlags = __webpack_require__(72);

  var ERROR_STACK_INSTALLABLE = __webpack_require__(152);

  var Object = global.Object;
  var Date = global.Date;
  var Error = global.Error;
  var EvalError = global.EvalError;
  var RangeError = global.RangeError;
  var ReferenceError = global.ReferenceError;
  var SyntaxError = global.SyntaxError;
  var TypeError = global.TypeError;
  var URIError = global.URIError;
  var PerformanceMark = global.PerformanceMark;
  var WebAssembly = global.WebAssembly;
  var CompileError = WebAssembly && WebAssembly.CompileError || Error;
  var LinkError = WebAssembly && WebAssembly.LinkError || Error;
  var RuntimeError = WebAssembly && WebAssembly.RuntimeError || Error;
  var DOMException = getBuiltin('DOMException');
  var Set = getBuiltin('Set');
  var Map = getBuiltin('Map');
  var MapPrototype = Map.prototype;
  var mapHas = uncurryThis(MapPrototype.has);
  var mapGet = uncurryThis(MapPrototype.get);
  var mapSet = uncurryThis(MapPrototype.set);
  var setAdd = uncurryThis(Set.prototype.add);
  var objectKeys = getBuiltin('Object', 'keys');
  var push = uncurryThis([].push);
  var booleanValueOf = uncurryThis(true.valueOf);
  var numberValueOf = uncurryThis(1.0.valueOf);
  var stringValueOf = uncurryThis(''.valueOf);
  var getFlags = uncurryThis(regExpFlags);
  var getTime = uncurryThis(Date.prototype.getTime);
  var PERFORMANCE_MARK = uid('structuredClone');
  var DATA_CLONE_ERROR = 'DataCloneError';
  var TRANSFERRING = 'Transferring';

  var checkBasicSemantic = function checkBasicSemantic(structuredCloneImplementation) {
    return !fails(function () {
      var set1 = new global.Set([7]);
      var set2 = structuredCloneImplementation(set1);
      var number = structuredCloneImplementation(Object(7));
      return set2 == set1 || !set2.has(7) || typeof number != 'object' || number != 7;
    }) && structuredCloneImplementation;
  }; // https://github.com/whatwg/html/pull/5749


  var checkNewErrorsSemantic = function checkNewErrorsSemantic(structuredCloneImplementation) {
    return !fails(function () {
      var test = structuredCloneImplementation(new global.AggregateError([1], PERFORMANCE_MARK, {
        cause: 3
      }));
      return test.name != 'AggregateError' || test.errors[0] != 1 || test.message != PERFORMANCE_MARK || test.cause != 3;
    }) && structuredCloneImplementation;
  }; // FF94+, Safari TP134+, Chrome Canary 98+, NodeJS 17.0+, Deno 1.13+
  // current FF and Safari implementations can't clone errors
  // https://bugzilla.mozilla.org/show_bug.cgi?id=1556604
  // no one of current implementations supports new (html/5749) error cloning semantic


  var nativeStructuredClone = global.structuredClone;
  var FORCED_REPLACEMENT = IS_PURE || !checkNewErrorsSemantic(nativeStructuredClone); // Chrome 82+, Safari 14.1+, Deno 1.11+
  // Chrome 78-81 implementation swaps `.name` and `.message` of cloned `DOMException`
  // Safari 14.1 implementation doesn't clone some `RegExp` flags, so requires a workaround
  // current Safari implementation can't clone errors
  // Deno 1.2-1.10 implementations too naive
  // NodeJS 16.0+ does not have `PerformanceMark` constructor, structured cloning implementation
  //   from `performance.mark` is too naive and can't clone, for example, `RegExp` or some boxed primitives
  //   https://github.com/nodejs/node/issues/40840
  // no one of current implementations supports new (html/5749) error cloning semantic

  var structuredCloneFromMark = !nativeStructuredClone && checkBasicSemantic(function (value) {
    return new PerformanceMark(PERFORMANCE_MARK, {
      detail: value
    }).detail;
  });
  var nativeRestrictedStructuredClone = checkBasicSemantic(nativeStructuredClone) || structuredCloneFromMark;

  var throwUncloneable = function throwUncloneable(type) {
    throw new DOMException('Uncloneable type: ' + type, DATA_CLONE_ERROR);
  };

  var throwUnpolyfillable = function throwUnpolyfillable(type, kind) {
    throw new DOMException((kind || 'Cloning') + ' of ' + type + ' cannot be properly polyfilled in this engine', DATA_CLONE_ERROR);
  };

  var structuredCloneInternal = function structuredCloneInternal(value, map) {
    if (isSymbol(value)) throwUncloneable('Symbol');
    if (!isObject(value)) return value; // effectively preserves circular references

    if (map) {
      if (mapHas(map, value)) return mapGet(map, value);
    } else map = new Map();

    var type = classof(value);
    var deep = false;
    var C, name, cloned, dataTransfer, i, length, keys, key, source, target;

    switch (type) {
      case 'Array':
        cloned = [];
        deep = true;
        break;

      case 'Object':
        cloned = {};
        deep = true;
        break;

      case 'Map':
        cloned = new Map();
        deep = true;
        break;

      case 'Set':
        cloned = new Set();
        deep = true;
        break;

      case 'RegExp':
        // in this block because of a Safari 14.1 bug
        // old FF does not clone regexes passed to the constructor, so get the source and flags directly
        cloned = new RegExp(value.source, 'flags' in value ? value.flags : getFlags(value));
        break;

      case 'Error':
        name = value.name;

        switch (name) {
          case 'AggregateError':
            cloned = getBuiltin('AggregateError')([]);
            break;

          case 'EvalError':
            cloned = EvalError();
            break;

          case 'RangeError':
            cloned = RangeError();
            break;

          case 'ReferenceError':
            cloned = ReferenceError();
            break;

          case 'SyntaxError':
            cloned = SyntaxError();
            break;

          case 'TypeError':
            cloned = TypeError();
            break;

          case 'URIError':
            cloned = URIError();
            break;

          case 'CompileError':
            cloned = CompileError();
            break;

          case 'LinkError':
            cloned = LinkError();
            break;

          case 'RuntimeError':
            cloned = RuntimeError();
            break;

          default:
            cloned = Error();
        }

        deep = true;
        break;

      case 'DOMException':
        cloned = new DOMException(value.message, value.name);
        deep = true;
        break;

      case 'DataView':
      case 'Int8Array':
      case 'Uint8Array':
      case 'Uint8ClampedArray':
      case 'Int16Array':
      case 'Uint16Array':
      case 'Int32Array':
      case 'Uint32Array':
      case 'Float32Array':
      case 'Float64Array':
      case 'BigInt64Array':
      case 'BigUint64Array':
        C = global[type]; // in some old engines like Safari 9, typeof C is 'object'
        // on Uint8ClampedArray or some other constructors

        if (!isObject(C)) throwUnpolyfillable(type);
        cloned = new C( // this is safe, since arraybuffer cannot have circular references
        structuredCloneInternal(value.buffer, map), value.byteOffset, type === 'DataView' ? value.byteLength : value.length);
        break;

      case 'DOMQuad':
        try {
          cloned = new DOMQuad(structuredCloneInternal(value.p1, map), structuredCloneInternal(value.p2, map), structuredCloneInternal(value.p3, map), structuredCloneInternal(value.p4, map));
        } catch (error) {
          if (nativeRestrictedStructuredClone) {
            cloned = nativeRestrictedStructuredClone(value);
          } else throwUnpolyfillable(type);
        }

        break;

      case 'FileList':
        C = global.DataTransfer;

        if (isConstructor(C)) {
          dataTransfer = new C();

          for (i = 0, length = lengthOfArrayLike(value); i < length; i++) {
            dataTransfer.items.add(structuredCloneInternal(value[i], map));
          }

          cloned = dataTransfer.files;
        } else if (nativeRestrictedStructuredClone) {
          cloned = nativeRestrictedStructuredClone(value);
        } else throwUnpolyfillable(type);

        break;

      case 'ImageData':
        // Safari 9 ImageData is a constructor, but typeof ImageData is 'object'
        try {
          cloned = new ImageData(structuredCloneInternal(value.data, map), value.width, value.height, {
            colorSpace: value.colorSpace
          });
        } catch (error) {
          if (nativeRestrictedStructuredClone) {
            cloned = nativeRestrictedStructuredClone(value);
          } else throwUnpolyfillable(type);
        }

        break;

      default:
        if (nativeRestrictedStructuredClone) {
          cloned = nativeRestrictedStructuredClone(value);
        } else switch (type) {
          case 'BigInt':
            // can be a 3rd party polyfill
            cloned = Object(value.valueOf());
            break;

          case 'Boolean':
            cloned = Object(booleanValueOf(value));
            break;

          case 'Number':
            cloned = Object(numberValueOf(value));
            break;

          case 'String':
            cloned = Object(stringValueOf(value));
            break;

          case 'Date':
            cloned = new Date(getTime(value));
            break;

          case 'ArrayBuffer':
            C = global.DataView; // `ArrayBuffer#slice` is not available in IE10
            // `ArrayBuffer#slice` and `DataView` are not available in old FF

            if (!C && typeof value.slice != 'function') throwUnpolyfillable(type); // detached buffers throws in `DataView` and `.slice`

            try {
              if (typeof value.slice == 'function') {
                cloned = value.slice(0);
              } else {
                length = value.byteLength;
                cloned = new ArrayBuffer(length);
                source = new C(value);
                target = new C(cloned);

                for (i = 0; i < length; i++) {
                  target.setUint8(i, source.getUint8(i));
                }
              }
            } catch (error) {
              throw new DOMException('ArrayBuffer is detached', DATA_CLONE_ERROR);
            }

            break;

          case 'SharedArrayBuffer':
            // SharedArrayBuffer should use shared memory, we can't polyfill it, so return the original
            cloned = value;
            break;

          case 'Blob':
            try {
              cloned = value.slice(0, value.size, value.type);
            } catch (error) {
              throwUnpolyfillable(type);
            }

            break;

          case 'DOMPoint':
          case 'DOMPointReadOnly':
            C = global[type];

            try {
              cloned = C.fromPoint ? C.fromPoint(value) : new C(value.x, value.y, value.z, value.w);
            } catch (error) {
              throwUnpolyfillable(type);
            }

            break;

          case 'DOMRect':
          case 'DOMRectReadOnly':
            C = global[type];

            try {
              cloned = C.fromRect ? C.fromRect(value) : new C(value.x, value.y, value.width, value.height);
            } catch (error) {
              throwUnpolyfillable(type);
            }

            break;

          case 'DOMMatrix':
          case 'DOMMatrixReadOnly':
            C = global[type];

            try {
              cloned = C.fromMatrix ? C.fromMatrix(value) : new C(value);
            } catch (error) {
              throwUnpolyfillable(type);
            }

            break;

          case 'AudioData':
          case 'VideoFrame':
            if (!isCallable(value.clone)) throwUnpolyfillable(type);

            try {
              cloned = value.clone();
            } catch (error) {
              throwUncloneable(type);
            }

            break;

          case 'File':
            try {
              cloned = new File([value], value.name, value);
            } catch (error) {
              throwUnpolyfillable(type);
            }

            break;

          case 'CryptoKey':
          case 'GPUCompilationMessage':
          case 'GPUCompilationInfo':
          case 'ImageBitmap':
          case 'RTCCertificate':
          case 'WebAssembly.Module':
            throwUnpolyfillable(type);
          // break omitted

          default:
            throwUncloneable(type);
        }

    }

    mapSet(map, value, cloned);
    if (deep) switch (type) {
      case 'Array':
      case 'Object':
        keys = objectKeys(value);

        for (i = 0, length = lengthOfArrayLike(keys); i < length; i++) {
          key = keys[i];
          createProperty(cloned, key, structuredCloneInternal(value[key], map));
        }

        break;

      case 'Map':
        value.forEach(function (v, k) {
          mapSet(cloned, structuredCloneInternal(k, map), structuredCloneInternal(v, map));
        });
        break;

      case 'Set':
        value.forEach(function (v) {
          setAdd(cloned, structuredCloneInternal(v, map));
        });
        break;

      case 'Error':
        createNonEnumerableProperty(cloned, 'message', structuredCloneInternal(value.message, map));

        if (hasOwn(value, 'cause')) {
          createNonEnumerableProperty(cloned, 'cause', structuredCloneInternal(value.cause, map));
        }

        if (name == 'AggregateError') {
          cloned.errors = structuredCloneInternal(value.errors, map);
        }

      // break omitted

      case 'DOMException':
        if (ERROR_STACK_INSTALLABLE) {
          createNonEnumerableProperty(cloned, 'stack', structuredCloneInternal(value.stack, map));
        }

    }
    return cloned;
  };

  var PROPER_TRANSFER = nativeStructuredClone && !fails(function () {
    var buffer = new ArrayBuffer(8);
    var clone = nativeStructuredClone(buffer, {
      transfer: [buffer]
    });
    return buffer.byteLength != 0 || clone.byteLength != 8;
  });

  var tryToTransfer = function tryToTransfer(rawTransfer, map) {
    if (!isObject(rawTransfer)) throw TypeError('Transfer option cannot be converted to a sequence');
    var transfer = [];
    iterate(rawTransfer, function (value) {
      push(transfer, anObject(value));
    });
    var i = 0;
    var length = lengthOfArrayLike(transfer);
    var value, type, C, transferredArray, transferred, canvas, context;

    if (PROPER_TRANSFER) {
      transferredArray = nativeStructuredClone(transfer, {
        transfer: transfer
      });

      while (i < length) {
        mapSet(map, transfer[i], transferredArray[i++]);
      }
    } else while (i < length) {
      value = transfer[i++];
      if (mapHas(map, value)) throw new DOMException('Duplicate transferable', DATA_CLONE_ERROR);
      type = classof(value);

      switch (type) {
        case 'ImageBitmap':
          C = global.OffscreenCanvas;
          if (!isConstructor(C)) throwUnpolyfillable(type, TRANSFERRING);

          try {
            canvas = new C(value.width, value.height);
            context = canvas.getContext('bitmaprenderer');
            context.transferFromImageBitmap(value);
            transferred = canvas.transferToImageBitmap();
          } catch (error) {
            /* empty */
          }

          break;

        case 'AudioData':
        case 'VideoFrame':
          if (!isCallable(value.clone) || !isCallable(value.close)) throwUnpolyfillable(type, TRANSFERRING);

          try {
            transferred = value.clone();
            value.close();
          } catch (error) {
            /* empty */
          }

          break;

        case 'ArrayBuffer':
        case 'MessagePort':
        case 'OffscreenCanvas':
        case 'ReadableStream':
        case 'TransformStream':
        case 'WritableStream':
          throwUnpolyfillable(type, TRANSFERRING);
      }

      if (transferred === undefined) throw new DOMException('This object cannot be transferred: ' + type, DATA_CLONE_ERROR);
      mapSet(map, value, transferred);
    }
  };

  $({
    global: true,
    enumerable: true,
    sham: !PROPER_TRANSFER,
    forced: FORCED_REPLACEMENT
  }, {
    structuredClone: function structuredClone(value
    /* , { transfer } */
    ) {
      var options = validateArgumentsLength(arguments.length, 1) > 1 ? anObject(arguments[1]) : undefined;
      var transfer = options ? options.transfer : undefined;
      var map;

      if (transfer !== undefined) {
        map = new Map();
        tryToTransfer(transfer, map);
      }

      return structuredCloneInternal(value, map);
    }
  });
  /***/
},
/* 592 */

/***/
function (module, exports, __webpack_require__) {
  var $ = __webpack_require__(0);

  var global = __webpack_require__(1);

  var apply = __webpack_require__(40);

  var isCallable = __webpack_require__(17);

  var userAgent = __webpack_require__(57);

  var arraySlice = __webpack_require__(68);

  var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check

  var Function = global.Function;

  var wrap = function wrap(scheduler) {
    return function (handler, timeout
    /* , ...arguments */
    ) {
      var boundArgs = arguments.length > 2;
      var args = boundArgs ? arraySlice(arguments, 2) : undefined;
      return scheduler(boundArgs ? function () {
        apply(isCallable(handler) ? handler : Function(handler), this, args);
      } : handler, timeout);
    };
  }; // ie9- setTimeout & setInterval additional parameters fix
  // https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#timers


  $({
    global: true,
    bind: true,
    forced: MSIE
  }, {
    // `setTimeout` method
    // https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-settimeout
    setTimeout: wrap(global.setTimeout),
    // `setInterval` method
    // https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-setinterval
    setInterval: wrap(global.setInterval)
  });
  /***/
},
/* 593 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`

  __webpack_require__(240);

  var $ = __webpack_require__(0);

  var DESCRIPTORS = __webpack_require__(12);

  var USE_NATIVE_URL = __webpack_require__(219);

  var global = __webpack_require__(1);

  var bind = __webpack_require__(51);

  var uncurryThis = __webpack_require__(3);

  var defineProperties = __webpack_require__(97).f;

  var redefine = __webpack_require__(24);

  var anInstance = __webpack_require__(50);

  var hasOwn = __webpack_require__(21);

  var assign = __webpack_require__(223);

  var arrayFrom = __webpack_require__(195);

  var arraySlice = __webpack_require__(86);

  var codeAt = __webpack_require__(127).codeAt;

  var toASCII = __webpack_require__(357);

  var $toString = __webpack_require__(18);

  var setToStringTag = __webpack_require__(49);

  var URLSearchParamsModule = __webpack_require__(241);

  var InternalStateModule = __webpack_require__(27);

  var setInternalState = InternalStateModule.set;
  var getInternalURLState = InternalStateModule.getterFor('URL');
  var URLSearchParams = URLSearchParamsModule.URLSearchParams;
  var getInternalSearchParamsState = URLSearchParamsModule.getState;
  var NativeURL = global.URL;
  var TypeError = global.TypeError;
  var parseInt = global.parseInt;
  var floor = Math.floor;
  var pow = Math.pow;
  var charAt = uncurryThis(''.charAt);
  var exec = uncurryThis(/./.exec);
  var join = uncurryThis([].join);
  var numberToString = uncurryThis(1.0.toString);
  var pop = uncurryThis([].pop);
  var push = uncurryThis([].push);
  var replace = uncurryThis(''.replace);
  var shift = uncurryThis([].shift);
  var split = uncurryThis(''.split);
  var stringSlice = uncurryThis(''.slice);
  var toLowerCase = uncurryThis(''.toLowerCase);
  var unshift = uncurryThis([].unshift);
  var INVALID_AUTHORITY = 'Invalid authority';
  var INVALID_SCHEME = 'Invalid scheme';
  var INVALID_HOST = 'Invalid host';
  var INVALID_PORT = 'Invalid port';
  var ALPHA = /[a-z]/i; // eslint-disable-next-line regexp/no-obscure-range -- safe

  var ALPHANUMERIC = /[\d+-.a-z]/i;
  var DIGIT = /\d/;
  var HEX_START = /^0x/i;
  var OCT = /^[0-7]+$/;
  var DEC = /^\d+$/;
  var HEX = /^[\da-f]+$/i;
  /* eslint-disable regexp/no-control-character -- safe */

  var FORBIDDEN_HOST_CODE_POINT = /[\0\t\n\r #%/:<>?@[\\\]^|]/;
  var FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT = /[\0\t\n\r #/:<>?@[\\\]^|]/;
  var LEADING_AND_TRAILING_C0_CONTROL_OR_SPACE = /^[\u0000-\u0020]+|[\u0000-\u0020]+$/g;
  var TAB_AND_NEW_LINE = /[\t\n\r]/g;
  /* eslint-enable regexp/no-control-character -- safe */

  var EOF; // https://url.spec.whatwg.org/#ipv4-number-parser

  var parseIPv4 = function parseIPv4(input) {
    var parts = split(input, '.');
    var partsLength, numbers, index, part, radix, number, ipv4;

    if (parts.length && parts[parts.length - 1] == '') {
      parts.length--;
    }

    partsLength = parts.length;
    if (partsLength > 4) return input;
    numbers = [];

    for (index = 0; index < partsLength; index++) {
      part = parts[index];
      if (part == '') return input;
      radix = 10;

      if (part.length > 1 && charAt(part, 0) == '0') {
        radix = exec(HEX_START, part) ? 16 : 8;
        part = stringSlice(part, radix == 8 ? 1 : 2);
      }

      if (part === '') {
        number = 0;
      } else {
        if (!exec(radix == 10 ? DEC : radix == 8 ? OCT : HEX, part)) return input;
        number = parseInt(part, radix);
      }

      push(numbers, number);
    }

    for (index = 0; index < partsLength; index++) {
      number = numbers[index];

      if (index == partsLength - 1) {
        if (number >= pow(256, 5 - partsLength)) return null;
      } else if (number > 255) return null;
    }

    ipv4 = pop(numbers);

    for (index = 0; index < numbers.length; index++) {
      ipv4 += numbers[index] * pow(256, 3 - index);
    }

    return ipv4;
  }; // https://url.spec.whatwg.org/#concept-ipv6-parser
  // eslint-disable-next-line max-statements -- TODO


  var parseIPv6 = function parseIPv6(input) {
    var address = [0, 0, 0, 0, 0, 0, 0, 0];
    var pieceIndex = 0;
    var compress = null;
    var pointer = 0;
    var value, length, numbersSeen, ipv4Piece, number, swaps, swap;

    var chr = function chr() {
      return charAt(input, pointer);
    };

    if (chr() == ':') {
      if (charAt(input, 1) != ':') return;
      pointer += 2;
      pieceIndex++;
      compress = pieceIndex;
    }

    while (chr()) {
      if (pieceIndex == 8) return;

      if (chr() == ':') {
        if (compress !== null) return;
        pointer++;
        pieceIndex++;
        compress = pieceIndex;
        continue;
      }

      value = length = 0;

      while (length < 4 && exec(HEX, chr())) {
        value = value * 16 + parseInt(chr(), 16);
        pointer++;
        length++;
      }

      if (chr() == '.') {
        if (length == 0) return;
        pointer -= length;
        if (pieceIndex > 6) return;
        numbersSeen = 0;

        while (chr()) {
          ipv4Piece = null;

          if (numbersSeen > 0) {
            if (chr() == '.' && numbersSeen < 4) pointer++;else return;
          }

          if (!exec(DIGIT, chr())) return;

          while (exec(DIGIT, chr())) {
            number = parseInt(chr(), 10);
            if (ipv4Piece === null) ipv4Piece = number;else if (ipv4Piece == 0) return;else ipv4Piece = ipv4Piece * 10 + number;
            if (ipv4Piece > 255) return;
            pointer++;
          }

          address[pieceIndex] = address[pieceIndex] * 256 + ipv4Piece;
          numbersSeen++;
          if (numbersSeen == 2 || numbersSeen == 4) pieceIndex++;
        }

        if (numbersSeen != 4) return;
        break;
      } else if (chr() == ':') {
        pointer++;
        if (!chr()) return;
      } else if (chr()) return;

      address[pieceIndex++] = value;
    }

    if (compress !== null) {
      swaps = pieceIndex - compress;
      pieceIndex = 7;

      while (pieceIndex != 0 && swaps > 0) {
        swap = address[pieceIndex];
        address[pieceIndex--] = address[compress + swaps - 1];
        address[compress + --swaps] = swap;
      }
    } else if (pieceIndex != 8) return;

    return address;
  };

  var findLongestZeroSequence = function findLongestZeroSequence(ipv6) {
    var maxIndex = null;
    var maxLength = 1;
    var currStart = null;
    var currLength = 0;
    var index = 0;

    for (; index < 8; index++) {
      if (ipv6[index] !== 0) {
        if (currLength > maxLength) {
          maxIndex = currStart;
          maxLength = currLength;
        }

        currStart = null;
        currLength = 0;
      } else {
        if (currStart === null) currStart = index;
        ++currLength;
      }
    }

    if (currLength > maxLength) {
      maxIndex = currStart;
      maxLength = currLength;
    }

    return maxIndex;
  }; // https://url.spec.whatwg.org/#host-serializing


  var serializeHost = function serializeHost(host) {
    var result, index, compress, ignore0; // ipv4

    if (typeof host == 'number') {
      result = [];

      for (index = 0; index < 4; index++) {
        unshift(result, host % 256);
        host = floor(host / 256);
      }

      return join(result, '.'); // ipv6
    } else if (typeof host == 'object') {
      result = '';
      compress = findLongestZeroSequence(host);

      for (index = 0; index < 8; index++) {
        if (ignore0 && host[index] === 0) continue;
        if (ignore0) ignore0 = false;

        if (compress === index) {
          result += index ? ':' : '::';
          ignore0 = true;
        } else {
          result += numberToString(host[index], 16);
          if (index < 7) result += ':';
        }
      }

      return '[' + result + ']';
    }

    return host;
  };

  var C0ControlPercentEncodeSet = {};
  var fragmentPercentEncodeSet = assign({}, C0ControlPercentEncodeSet, {
    ' ': 1,
    '"': 1,
    '<': 1,
    '>': 1,
    '`': 1
  });
  var pathPercentEncodeSet = assign({}, fragmentPercentEncodeSet, {
    '#': 1,
    '?': 1,
    '{': 1,
    '}': 1
  });
  var userinfoPercentEncodeSet = assign({}, pathPercentEncodeSet, {
    '/': 1,
    ':': 1,
    ';': 1,
    '=': 1,
    '@': 1,
    '[': 1,
    '\\': 1,
    ']': 1,
    '^': 1,
    '|': 1
  });

  var percentEncode = function percentEncode(chr, set) {
    var code = codeAt(chr, 0);
    return code > 0x20 && code < 0x7F && !hasOwn(set, chr) ? chr : encodeURIComponent(chr);
  }; // https://url.spec.whatwg.org/#special-scheme


  var specialSchemes = {
    ftp: 21,
    file: null,
    http: 80,
    https: 443,
    ws: 80,
    wss: 443
  }; // https://url.spec.whatwg.org/#windows-drive-letter

  var isWindowsDriveLetter = function isWindowsDriveLetter(string, normalized) {
    var second;
    return string.length == 2 && exec(ALPHA, charAt(string, 0)) && ((second = charAt(string, 1)) == ':' || !normalized && second == '|');
  }; // https://url.spec.whatwg.org/#start-with-a-windows-drive-letter


  var startsWithWindowsDriveLetter = function startsWithWindowsDriveLetter(string) {
    var third;
    return string.length > 1 && isWindowsDriveLetter(stringSlice(string, 0, 2)) && (string.length == 2 || (third = charAt(string, 2)) === '/' || third === '\\' || third === '?' || third === '#');
  }; // https://url.spec.whatwg.org/#single-dot-path-segment


  var isSingleDot = function isSingleDot(segment) {
    return segment === '.' || toLowerCase(segment) === '%2e';
  }; // https://url.spec.whatwg.org/#double-dot-path-segment


  var isDoubleDot = function isDoubleDot(segment) {
    segment = toLowerCase(segment);
    return segment === '..' || segment === '%2e.' || segment === '.%2e' || segment === '%2e%2e';
  }; // States:


  var SCHEME_START = {};
  var SCHEME = {};
  var NO_SCHEME = {};
  var SPECIAL_RELATIVE_OR_AUTHORITY = {};
  var PATH_OR_AUTHORITY = {};
  var RELATIVE = {};
  var RELATIVE_SLASH = {};
  var SPECIAL_AUTHORITY_SLASHES = {};
  var SPECIAL_AUTHORITY_IGNORE_SLASHES = {};
  var AUTHORITY = {};
  var HOST = {};
  var HOSTNAME = {};
  var PORT = {};
  var FILE = {};
  var FILE_SLASH = {};
  var FILE_HOST = {};
  var PATH_START = {};
  var PATH = {};
  var CANNOT_BE_A_BASE_URL_PATH = {};
  var QUERY = {};
  var FRAGMENT = {};

  var URLState = function URLState(url, isBase, base) {
    var urlString = $toString(url);
    var baseState, failure, searchParams;

    if (isBase) {
      failure = this.parse(urlString);
      if (failure) throw TypeError(failure);
      this.searchParams = null;
    } else {
      if (base !== undefined) baseState = new URLState(base, true);
      failure = this.parse(urlString, null, baseState);
      if (failure) throw TypeError(failure);
      searchParams = getInternalSearchParamsState(new URLSearchParams());
      searchParams.bindURL(this);
      this.searchParams = searchParams;
    }
  };

  URLState.prototype = {
    type: 'URL',
    // https://url.spec.whatwg.org/#url-parsing
    // eslint-disable-next-line max-statements -- TODO
    parse: function parse(input, stateOverride, base) {
      var url = this;
      var state = stateOverride || SCHEME_START;
      var pointer = 0;
      var buffer = '';
      var seenAt = false;
      var seenBracket = false;
      var seenPasswordToken = false;
      var codePoints, chr, bufferCodePoints, failure;
      input = $toString(input);

      if (!stateOverride) {
        url.scheme = '';
        url.username = '';
        url.password = '';
        url.host = null;
        url.port = null;
        url.path = [];
        url.query = null;
        url.fragment = null;
        url.cannotBeABaseURL = false;
        input = replace(input, LEADING_AND_TRAILING_C0_CONTROL_OR_SPACE, '');
      }

      input = replace(input, TAB_AND_NEW_LINE, '');
      codePoints = arrayFrom(input);

      while (pointer <= codePoints.length) {
        chr = codePoints[pointer];

        switch (state) {
          case SCHEME_START:
            if (chr && exec(ALPHA, chr)) {
              buffer += toLowerCase(chr);
              state = SCHEME;
            } else if (!stateOverride) {
              state = NO_SCHEME;
              continue;
            } else return INVALID_SCHEME;

            break;

          case SCHEME:
            if (chr && (exec(ALPHANUMERIC, chr) || chr == '+' || chr == '-' || chr == '.')) {
              buffer += toLowerCase(chr);
            } else if (chr == ':') {
              if (stateOverride && (url.isSpecial() != hasOwn(specialSchemes, buffer) || buffer == 'file' && (url.includesCredentials() || url.port !== null) || url.scheme == 'file' && !url.host)) return;
              url.scheme = buffer;

              if (stateOverride) {
                if (url.isSpecial() && specialSchemes[url.scheme] == url.port) url.port = null;
                return;
              }

              buffer = '';

              if (url.scheme == 'file') {
                state = FILE;
              } else if (url.isSpecial() && base && base.scheme == url.scheme) {
                state = SPECIAL_RELATIVE_OR_AUTHORITY;
              } else if (url.isSpecial()) {
                state = SPECIAL_AUTHORITY_SLASHES;
              } else if (codePoints[pointer + 1] == '/') {
                state = PATH_OR_AUTHORITY;
                pointer++;
              } else {
                url.cannotBeABaseURL = true;
                push(url.path, '');
                state = CANNOT_BE_A_BASE_URL_PATH;
              }
            } else if (!stateOverride) {
              buffer = '';
              state = NO_SCHEME;
              pointer = 0;
              continue;
            } else return INVALID_SCHEME;

            break;

          case NO_SCHEME:
            if (!base || base.cannotBeABaseURL && chr != '#') return INVALID_SCHEME;

            if (base.cannotBeABaseURL && chr == '#') {
              url.scheme = base.scheme;
              url.path = arraySlice(base.path);
              url.query = base.query;
              url.fragment = '';
              url.cannotBeABaseURL = true;
              state = FRAGMENT;
              break;
            }

            state = base.scheme == 'file' ? FILE : RELATIVE;
            continue;

          case SPECIAL_RELATIVE_OR_AUTHORITY:
            if (chr == '/' && codePoints[pointer + 1] == '/') {
              state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
              pointer++;
            } else {
              state = RELATIVE;
              continue;
            }

            break;

          case PATH_OR_AUTHORITY:
            if (chr == '/') {
              state = AUTHORITY;
              break;
            } else {
              state = PATH;
              continue;
            }

          case RELATIVE:
            url.scheme = base.scheme;

            if (chr == EOF) {
              url.username = base.username;
              url.password = base.password;
              url.host = base.host;
              url.port = base.port;
              url.path = arraySlice(base.path);
              url.query = base.query;
            } else if (chr == '/' || chr == '\\' && url.isSpecial()) {
              state = RELATIVE_SLASH;
            } else if (chr == '?') {
              url.username = base.username;
              url.password = base.password;
              url.host = base.host;
              url.port = base.port;
              url.path = arraySlice(base.path);
              url.query = '';
              state = QUERY;
            } else if (chr == '#') {
              url.username = base.username;
              url.password = base.password;
              url.host = base.host;
              url.port = base.port;
              url.path = arraySlice(base.path);
              url.query = base.query;
              url.fragment = '';
              state = FRAGMENT;
            } else {
              url.username = base.username;
              url.password = base.password;
              url.host = base.host;
              url.port = base.port;
              url.path = arraySlice(base.path);
              url.path.length--;
              state = PATH;
              continue;
            }

            break;

          case RELATIVE_SLASH:
            if (url.isSpecial() && (chr == '/' || chr == '\\')) {
              state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
            } else if (chr == '/') {
              state = AUTHORITY;
            } else {
              url.username = base.username;
              url.password = base.password;
              url.host = base.host;
              url.port = base.port;
              state = PATH;
              continue;
            }

            break;

          case SPECIAL_AUTHORITY_SLASHES:
            state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
            if (chr != '/' || charAt(buffer, pointer + 1) != '/') continue;
            pointer++;
            break;

          case SPECIAL_AUTHORITY_IGNORE_SLASHES:
            if (chr != '/' && chr != '\\') {
              state = AUTHORITY;
              continue;
            }

            break;

          case AUTHORITY:
            if (chr == '@') {
              if (seenAt) buffer = '%40' + buffer;
              seenAt = true;
              bufferCodePoints = arrayFrom(buffer);

              for (var i = 0; i < bufferCodePoints.length; i++) {
                var codePoint = bufferCodePoints[i];

                if (codePoint == ':' && !seenPasswordToken) {
                  seenPasswordToken = true;
                  continue;
                }

                var encodedCodePoints = percentEncode(codePoint, userinfoPercentEncodeSet);
                if (seenPasswordToken) url.password += encodedCodePoints;else url.username += encodedCodePoints;
              }

              buffer = '';
            } else if (chr == EOF || chr == '/' || chr == '?' || chr == '#' || chr == '\\' && url.isSpecial()) {
              if (seenAt && buffer == '') return INVALID_AUTHORITY;
              pointer -= arrayFrom(buffer).length + 1;
              buffer = '';
              state = HOST;
            } else buffer += chr;

            break;

          case HOST:
          case HOSTNAME:
            if (stateOverride && url.scheme == 'file') {
              state = FILE_HOST;
              continue;
            } else if (chr == ':' && !seenBracket) {
              if (buffer == '') return INVALID_HOST;
              failure = url.parseHost(buffer);
              if (failure) return failure;
              buffer = '';
              state = PORT;
              if (stateOverride == HOSTNAME) return;
            } else if (chr == EOF || chr == '/' || chr == '?' || chr == '#' || chr == '\\' && url.isSpecial()) {
              if (url.isSpecial() && buffer == '') return INVALID_HOST;
              if (stateOverride && buffer == '' && (url.includesCredentials() || url.port !== null)) return;
              failure = url.parseHost(buffer);
              if (failure) return failure;
              buffer = '';
              state = PATH_START;
              if (stateOverride) return;
              continue;
            } else {
              if (chr == '[') seenBracket = true;else if (chr == ']') seenBracket = false;
              buffer += chr;
            }

            break;

          case PORT:
            if (exec(DIGIT, chr)) {
              buffer += chr;
            } else if (chr == EOF || chr == '/' || chr == '?' || chr == '#' || chr == '\\' && url.isSpecial() || stateOverride) {
              if (buffer != '') {
                var port = parseInt(buffer, 10);
                if (port > 0xFFFF) return INVALID_PORT;
                url.port = url.isSpecial() && port === specialSchemes[url.scheme] ? null : port;
                buffer = '';
              }

              if (stateOverride) return;
              state = PATH_START;
              continue;
            } else return INVALID_PORT;

            break;

          case FILE:
            url.scheme = 'file';
            if (chr == '/' || chr == '\\') state = FILE_SLASH;else if (base && base.scheme == 'file') {
              if (chr == EOF) {
                url.host = base.host;
                url.path = arraySlice(base.path);
                url.query = base.query;
              } else if (chr == '?') {
                url.host = base.host;
                url.path = arraySlice(base.path);
                url.query = '';
                state = QUERY;
              } else if (chr == '#') {
                url.host = base.host;
                url.path = arraySlice(base.path);
                url.query = base.query;
                url.fragment = '';
                state = FRAGMENT;
              } else {
                if (!startsWithWindowsDriveLetter(join(arraySlice(codePoints, pointer), ''))) {
                  url.host = base.host;
                  url.path = arraySlice(base.path);
                  url.shortenPath();
                }

                state = PATH;
                continue;
              }
            } else {
              state = PATH;
              continue;
            }
            break;

          case FILE_SLASH:
            if (chr == '/' || chr == '\\') {
              state = FILE_HOST;
              break;
            }

            if (base && base.scheme == 'file' && !startsWithWindowsDriveLetter(join(arraySlice(codePoints, pointer), ''))) {
              if (isWindowsDriveLetter(base.path[0], true)) push(url.path, base.path[0]);else url.host = base.host;
            }

            state = PATH;
            continue;

          case FILE_HOST:
            if (chr == EOF || chr == '/' || chr == '\\' || chr == '?' || chr == '#') {
              if (!stateOverride && isWindowsDriveLetter(buffer)) {
                state = PATH;
              } else if (buffer == '') {
                url.host = '';
                if (stateOverride) return;
                state = PATH_START;
              } else {
                failure = url.parseHost(buffer);
                if (failure) return failure;
                if (url.host == 'localhost') url.host = '';
                if (stateOverride) return;
                buffer = '';
                state = PATH_START;
              }

              continue;
            } else buffer += chr;

            break;

          case PATH_START:
            if (url.isSpecial()) {
              state = PATH;
              if (chr != '/' && chr != '\\') continue;
            } else if (!stateOverride && chr == '?') {
              url.query = '';
              state = QUERY;
            } else if (!stateOverride && chr == '#') {
              url.fragment = '';
              state = FRAGMENT;
            } else if (chr != EOF) {
              state = PATH;
              if (chr != '/') continue;
            }

            break;

          case PATH:
            if (chr == EOF || chr == '/' || chr == '\\' && url.isSpecial() || !stateOverride && (chr == '?' || chr == '#')) {
              if (isDoubleDot(buffer)) {
                url.shortenPath();

                if (chr != '/' && !(chr == '\\' && url.isSpecial())) {
                  push(url.path, '');
                }
              } else if (isSingleDot(buffer)) {
                if (chr != '/' && !(chr == '\\' && url.isSpecial())) {
                  push(url.path, '');
                }
              } else {
                if (url.scheme == 'file' && !url.path.length && isWindowsDriveLetter(buffer)) {
                  if (url.host) url.host = '';
                  buffer = charAt(buffer, 0) + ':'; // normalize windows drive letter
                }

                push(url.path, buffer);
              }

              buffer = '';

              if (url.scheme == 'file' && (chr == EOF || chr == '?' || chr == '#')) {
                while (url.path.length > 1 && url.path[0] === '') {
                  shift(url.path);
                }
              }

              if (chr == '?') {
                url.query = '';
                state = QUERY;
              } else if (chr == '#') {
                url.fragment = '';
                state = FRAGMENT;
              }
            } else {
              buffer += percentEncode(chr, pathPercentEncodeSet);
            }

            break;

          case CANNOT_BE_A_BASE_URL_PATH:
            if (chr == '?') {
              url.query = '';
              state = QUERY;
            } else if (chr == '#') {
              url.fragment = '';
              state = FRAGMENT;
            } else if (chr != EOF) {
              url.path[0] += percentEncode(chr, C0ControlPercentEncodeSet);
            }

            break;

          case QUERY:
            if (!stateOverride && chr == '#') {
              url.fragment = '';
              state = FRAGMENT;
            } else if (chr != EOF) {
              if (chr == "'" && url.isSpecial()) url.query += '%27';else if (chr == '#') url.query += '%23';else url.query += percentEncode(chr, C0ControlPercentEncodeSet);
            }

            break;

          case FRAGMENT:
            if (chr != EOF) url.fragment += percentEncode(chr, fragmentPercentEncodeSet);
            break;
        }

        pointer++;
      }
    },
    // https://url.spec.whatwg.org/#host-parsing
    parseHost: function parseHost(input) {
      var result, codePoints, index;

      if (charAt(input, 0) == '[') {
        if (charAt(input, input.length - 1) != ']') return INVALID_HOST;
        result = parseIPv6(stringSlice(input, 1, -1));
        if (!result) return INVALID_HOST;
        this.host = result; // opaque host
      } else if (!this.isSpecial()) {
        if (exec(FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT, input)) return INVALID_HOST;
        result = '';
        codePoints = arrayFrom(input);

        for (index = 0; index < codePoints.length; index++) {
          result += percentEncode(codePoints[index], C0ControlPercentEncodeSet);
        }

        this.host = result;
      } else {
        input = toASCII(input);
        if (exec(FORBIDDEN_HOST_CODE_POINT, input)) return INVALID_HOST;
        result = parseIPv4(input);
        if (result === null) return INVALID_HOST;
        this.host = result;
      }
    },
    // https://url.spec.whatwg.org/#cannot-have-a-username-password-port
    cannotHaveUsernamePasswordPort: function cannotHaveUsernamePasswordPort() {
      return !this.host || this.cannotBeABaseURL || this.scheme == 'file';
    },
    // https://url.spec.whatwg.org/#include-credentials
    includesCredentials: function includesCredentials() {
      return this.username != '' || this.password != '';
    },
    // https://url.spec.whatwg.org/#is-special
    isSpecial: function isSpecial() {
      return hasOwn(specialSchemes, this.scheme);
    },
    // https://url.spec.whatwg.org/#shorten-a-urls-path
    shortenPath: function shortenPath() {
      var path = this.path;
      var pathSize = path.length;

      if (pathSize && (this.scheme != 'file' || pathSize != 1 || !isWindowsDriveLetter(path[0], true))) {
        path.length--;
      }
    },
    // https://url.spec.whatwg.org/#concept-url-serializer
    serialize: function serialize() {
      var url = this;
      var scheme = url.scheme;
      var username = url.username;
      var password = url.password;
      var host = url.host;
      var port = url.port;
      var path = url.path;
      var query = url.query;
      var fragment = url.fragment;
      var output = scheme + ':';

      if (host !== null) {
        output += '//';

        if (url.includesCredentials()) {
          output += username + (password ? ':' + password : '') + '@';
        }

        output += serializeHost(host);
        if (port !== null) output += ':' + port;
      } else if (scheme == 'file') output += '//';

      output += url.cannotBeABaseURL ? path[0] : path.length ? '/' + join(path, '/') : '';
      if (query !== null) output += '?' + query;
      if (fragment !== null) output += '#' + fragment;
      return output;
    },
    // https://url.spec.whatwg.org/#dom-url-href
    setHref: function setHref(href) {
      var failure = this.parse(href);
      if (failure) throw TypeError(failure);
      this.searchParams.update();
    },
    // https://url.spec.whatwg.org/#dom-url-origin
    getOrigin: function getOrigin() {
      var scheme = this.scheme;
      var port = this.port;
      if (scheme == 'blob') try {
        return new URLConstructor(scheme.path[0]).origin;
      } catch (error) {
        return 'null';
      }
      if (scheme == 'file' || !this.isSpecial()) return 'null';
      return scheme + '://' + serializeHost(this.host) + (port !== null ? ':' + port : '');
    },
    // https://url.spec.whatwg.org/#dom-url-protocol
    getProtocol: function getProtocol() {
      return this.scheme + ':';
    },
    setProtocol: function setProtocol(protocol) {
      this.parse($toString(protocol) + ':', SCHEME_START);
    },
    // https://url.spec.whatwg.org/#dom-url-username
    getUsername: function getUsername() {
      return this.username;
    },
    setUsername: function setUsername(username) {
      var codePoints = arrayFrom($toString(username));
      if (this.cannotHaveUsernamePasswordPort()) return;
      this.username = '';

      for (var i = 0; i < codePoints.length; i++) {
        this.username += percentEncode(codePoints[i], userinfoPercentEncodeSet);
      }
    },
    // https://url.spec.whatwg.org/#dom-url-password
    getPassword: function getPassword() {
      return this.password;
    },
    setPassword: function setPassword(password) {
      var codePoints = arrayFrom($toString(password));
      if (this.cannotHaveUsernamePasswordPort()) return;
      this.password = '';

      for (var i = 0; i < codePoints.length; i++) {
        this.password += percentEncode(codePoints[i], userinfoPercentEncodeSet);
      }
    },
    // https://url.spec.whatwg.org/#dom-url-host
    getHost: function getHost() {
      var host = this.host;
      var port = this.port;
      return host === null ? '' : port === null ? serializeHost(host) : serializeHost(host) + ':' + port;
    },
    setHost: function setHost(host) {
      if (this.cannotBeABaseURL) return;
      this.parse(host, HOST);
    },
    // https://url.spec.whatwg.org/#dom-url-hostname
    getHostname: function getHostname() {
      var host = this.host;
      return host === null ? '' : serializeHost(host);
    },
    setHostname: function setHostname(hostname) {
      if (this.cannotBeABaseURL) return;
      this.parse(hostname, HOSTNAME);
    },
    // https://url.spec.whatwg.org/#dom-url-port
    getPort: function getPort() {
      var port = this.port;
      return port === null ? '' : $toString(port);
    },
    setPort: function setPort(port) {
      if (this.cannotHaveUsernamePasswordPort()) return;
      port = $toString(port);
      if (port == '') this.port = null;else this.parse(port, PORT);
    },
    // https://url.spec.whatwg.org/#dom-url-pathname
    getPathname: function getPathname() {
      var path = this.path;
      return this.cannotBeABaseURL ? path[0] : path.length ? '/' + join(path, '/') : '';
    },
    setPathname: function setPathname(pathname) {
      if (this.cannotBeABaseURL) return;
      this.path = [];
      this.parse(pathname, PATH_START);
    },
    // https://url.spec.whatwg.org/#dom-url-search
    getSearch: function getSearch() {
      var query = this.query;
      return query ? '?' + query : '';
    },
    setSearch: function setSearch(search) {
      search = $toString(search);

      if (search == '') {
        this.query = null;
      } else {
        if ('?' == charAt(search, 0)) search = stringSlice(search, 1);
        this.query = '';
        this.parse(search, QUERY);
      }

      this.searchParams.update();
    },
    // https://url.spec.whatwg.org/#dom-url-searchparams
    getSearchParams: function getSearchParams() {
      return this.searchParams.facade;
    },
    // https://url.spec.whatwg.org/#dom-url-hash
    getHash: function getHash() {
      var fragment = this.fragment;
      return fragment ? '#' + fragment : '';
    },
    setHash: function setHash(hash) {
      hash = $toString(hash);

      if (hash == '') {
        this.fragment = null;
        return;
      }

      if ('#' == charAt(hash, 0)) hash = stringSlice(hash, 1);
      this.fragment = '';
      this.parse(hash, FRAGMENT);
    },
    update: function update() {
      this.query = this.searchParams.serialize() || null;
    }
  }; // `URL` constructor
  // https://url.spec.whatwg.org/#url-class

  var URLConstructor = function URL(url
  /* , base */
  ) {
    var that = anInstance(this, URLPrototype);
    var base = arguments.length > 1 ? arguments[1] : undefined;
    var state = setInternalState(that, new URLState(url, false, base));

    if (!DESCRIPTORS) {
      that.href = state.serialize();
      that.origin = state.getOrigin();
      that.protocol = state.getProtocol();
      that.username = state.getUsername();
      that.password = state.getPassword();
      that.host = state.getHost();
      that.hostname = state.getHostname();
      that.port = state.getPort();
      that.pathname = state.getPathname();
      that.search = state.getSearch();
      that.searchParams = state.getSearchParams();
      that.hash = state.getHash();
    }
  };

  var URLPrototype = URLConstructor.prototype;

  var accessorDescriptor = function accessorDescriptor(getter, setter) {
    return {
      get: function get() {
        return getInternalURLState(this)[getter]();
      },
      set: setter && function (value) {
        return getInternalURLState(this)[setter](value);
      },
      configurable: true,
      enumerable: true
    };
  };

  if (DESCRIPTORS) {
    defineProperties(URLPrototype, {
      // `URL.prototype.href` accessors pair
      // https://url.spec.whatwg.org/#dom-url-href
      href: accessorDescriptor('serialize', 'setHref'),
      // `URL.prototype.origin` getter
      // https://url.spec.whatwg.org/#dom-url-origin
      origin: accessorDescriptor('getOrigin'),
      // `URL.prototype.protocol` accessors pair
      // https://url.spec.whatwg.org/#dom-url-protocol
      protocol: accessorDescriptor('getProtocol', 'setProtocol'),
      // `URL.prototype.username` accessors pair
      // https://url.spec.whatwg.org/#dom-url-username
      username: accessorDescriptor('getUsername', 'setUsername'),
      // `URL.prototype.password` accessors pair
      // https://url.spec.whatwg.org/#dom-url-password
      password: accessorDescriptor('getPassword', 'setPassword'),
      // `URL.prototype.host` accessors pair
      // https://url.spec.whatwg.org/#dom-url-host
      host: accessorDescriptor('getHost', 'setHost'),
      // `URL.prototype.hostname` accessors pair
      // https://url.spec.whatwg.org/#dom-url-hostname
      hostname: accessorDescriptor('getHostname', 'setHostname'),
      // `URL.prototype.port` accessors pair
      // https://url.spec.whatwg.org/#dom-url-port
      port: accessorDescriptor('getPort', 'setPort'),
      // `URL.prototype.pathname` accessors pair
      // https://url.spec.whatwg.org/#dom-url-pathname
      pathname: accessorDescriptor('getPathname', 'setPathname'),
      // `URL.prototype.search` accessors pair
      // https://url.spec.whatwg.org/#dom-url-search
      search: accessorDescriptor('getSearch', 'setSearch'),
      // `URL.prototype.searchParams` getter
      // https://url.spec.whatwg.org/#dom-url-searchparams
      searchParams: accessorDescriptor('getSearchParams'),
      // `URL.prototype.hash` accessors pair
      // https://url.spec.whatwg.org/#dom-url-hash
      hash: accessorDescriptor('getHash', 'setHash')
    });
  } // `URL.prototype.toJSON` method
  // https://url.spec.whatwg.org/#dom-url-tojson


  redefine(URLPrototype, 'toJSON', function toJSON() {
    return getInternalURLState(this).serialize();
  }, {
    enumerable: true
  }); // `URL.prototype.toString` method
  // https://url.spec.whatwg.org/#URL-stringification-behavior

  redefine(URLPrototype, 'toString', function toString() {
    return getInternalURLState(this).serialize();
  }, {
    enumerable: true
  });

  if (NativeURL) {
    var nativeCreateObjectURL = NativeURL.createObjectURL;
    var nativeRevokeObjectURL = NativeURL.revokeObjectURL; // `URL.createObjectURL` method
    // https://developer.mozilla.org/en-US/docs/Web/API/URL/createObjectURL

    if (nativeCreateObjectURL) redefine(URLConstructor, 'createObjectURL', bind(nativeCreateObjectURL, NativeURL)); // `URL.revokeObjectURL` method
    // https://developer.mozilla.org/en-US/docs/Web/API/URL/revokeObjectURL

    if (nativeRevokeObjectURL) redefine(URLConstructor, 'revokeObjectURL', bind(nativeRevokeObjectURL, NativeURL));
  }

  setToStringTag(URLConstructor, 'URL');
  $({
    global: true,
    forced: !USE_NATIVE_URL,
    sham: !DESCRIPTORS
  }, {
    URL: URLConstructor
  });
  /***/
},
/* 594 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $ = __webpack_require__(0);

  var call = __webpack_require__(19); // `URL.prototype.toJSON` method
  // https://url.spec.whatwg.org/#dom-url-tojson


  $({
    target: 'URL',
    proto: true,
    enumerable: true
  }, {
    toJSON: function toJSON() {
      return call(URL.prototype.toString, this);
    }
  });
  /***/
},
/* 595 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (process) {
    /**
    * Copyright (c) 2013-present, Facebook, Inc.
    *
    * This source code is licensed under the MIT license found in the
    * LICENSE file in the root directory of this source tree.
    */
    var printWarning = function printWarning() {};

    if (process.env.NODE_ENV !== 'production') {
      var ReactPropTypesSecret = __webpack_require__(173);

      var loggedTypeFailures = {};
      var has = Function.call.bind(Object.prototype.hasOwnProperty);

      printWarning = function printWarning(text) {
        var message = 'Warning: ' + text;

        if (typeof console !== 'undefined') {
          console.error(message);
        }

        try {
          // --- Welcome to debugging React ---
          // This error was thrown as a convenience so that you can use this stack
          // to find the callsite that caused this warning to fire.
          throw new Error(message);
        } catch (x) {}
      };
    }
    /**
     * Assert that the values match with the type specs.
     * Error messages are memorized and will only be shown once.
     *
     * @param {object} typeSpecs Map of name to a ReactPropType
     * @param {object} values Runtime values that need to be type-checked
     * @param {string} location e.g. "prop", "context", "child context"
     * @param {string} componentName Name of the component for error messages.
     * @param {?Function} getStack Returns the component stack.
     * @private
     */


    function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
      if (process.env.NODE_ENV !== 'production') {
        for (var typeSpecName in typeSpecs) {
          if (has(typeSpecs, typeSpecName)) {
            var error; // Prop type validation may throw. In case they do, we don't want to
            // fail the render phase where it didn't fail before. So we log it.
            // After these have been cleaned up, we'll let them throw.

            try {
              // This is intentionally an invariant that gets caught. It's the same
              // behavior as without this statement except with a better message.
              if (typeof typeSpecs[typeSpecName] !== 'function') {
                var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.');
                err.name = 'Invariant Violation';
                throw err;
              }

              error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
            } catch (ex) {
              error = ex;
            }

            if (error && !(error instanceof Error)) {
              printWarning((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + typeof error + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
            }

            if (error instanceof Error && !(error.message in loggedTypeFailures)) {
              // Only monitor this failure once because there tends to be a lot of the
              // same error.
              loggedTypeFailures[error.message] = true;
              var stack = getStack ? getStack() : '';
              printWarning('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
            }
          }
        }
      }
    }
    /**
     * Resets warning cache when testing.
     *
     * @private
     */


    checkPropTypes.resetWarningCache = function () {
      if (process.env.NODE_ENV !== 'production') {
        loggedTypeFailures = {};
      }
    };

    module.exports = checkPropTypes;
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(25));
  /***/
},
/* 596 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  var ReactPropTypesSecret = __webpack_require__(173);

  function emptyFunction() {}

  function emptyFunctionWithReset() {}

  emptyFunctionWithReset.resetWarningCache = emptyFunction;

  module.exports = function () {
    function shim(props, propName, componentName, location, propFullName, secret) {
      if (secret === ReactPropTypesSecret) {
        // It is still safe when called from React.
        return;
      }

      var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
      err.name = 'Invariant Violation';
      throw err;
    }

    ;
    shim.isRequired = shim;

    function getShim() {
      return shim;
    }

    ; // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.

    var ReactPropTypes = {
      array: shim,
      bool: shim,
      func: shim,
      number: shim,
      object: shim,
      string: shim,
      symbol: shim,
      any: shim,
      arrayOf: getShim,
      element: shim,
      elementType: shim,
      instanceOf: getShim,
      node: shim,
      objectOf: getShim,
      oneOf: getShim,
      oneOfType: getShim,
      shape: getShim,
      exact: getShim,
      checkPropTypes: emptyFunctionWithReset,
      resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };
  /***/

},
/* 597 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (process) {
    /**
    * Copyright (c) 2013-present, Facebook, Inc.
    *
    * This source code is licensed under the MIT license found in the
    * LICENSE file in the root directory of this source tree.
    */
    var ReactIs = __webpack_require__(245);

    var assign = __webpack_require__(172);

    var ReactPropTypesSecret = __webpack_require__(173);

    var checkPropTypes = __webpack_require__(595);

    var has = Function.call.bind(Object.prototype.hasOwnProperty);

    var printWarning = function printWarning() {};

    if (process.env.NODE_ENV !== 'production') {
      printWarning = function printWarning(text) {
        var message = 'Warning: ' + text;

        if (typeof console !== 'undefined') {
          console.error(message);
        }

        try {
          // --- Welcome to debugging React ---
          // This error was thrown as a convenience so that you can use this stack
          // to find the callsite that caused this warning to fire.
          throw new Error(message);
        } catch (x) {}
      };
    }

    function emptyFunctionThatReturnsNull() {
      return null;
    }

    module.exports = function (isValidElement, throwOnDirectAccess) {
      /* global Symbol */
      var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
      var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

      /**
       * Returns the iterator method function contained on the iterable object.
       *
       * Be sure to invoke the function with the iterable as context:
       *
       *     var iteratorFn = getIteratorFn(myIterable);
       *     if (iteratorFn) {
       *       var iterator = iteratorFn.call(myIterable);
       *       ...
       *     }
       *
       * @param {?object} maybeIterable
       * @return {?function}
       */

      function getIteratorFn(maybeIterable) {
        var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);

        if (typeof iteratorFn === 'function') {
          return iteratorFn;
        }
      }
      /**
       * Collection of methods that allow declaration and validation of props that are
       * supplied to React components. Example usage:
       *
       *   var Props = require('ReactPropTypes');
       *   var MyArticle = React.createClass({
       *     propTypes: {
       *       // An optional string prop named "description".
       *       description: Props.string,
       *
       *       // A required enum prop named "category".
       *       category: Props.oneOf(['News','Photos']).isRequired,
       *
       *       // A prop named "dialog" that requires an instance of Dialog.
       *       dialog: Props.instanceOf(Dialog).isRequired
       *     },
       *     render: function() { ... }
       *   });
       *
       * A more formal specification of how these methods are used:
       *
       *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
       *   decl := ReactPropTypes.{type}(.isRequired)?
       *
       * Each and every declaration produces a function with the same signature. This
       * allows the creation of custom validation functions. For example:
       *
       *  var MyLink = React.createClass({
       *    propTypes: {
       *      // An optional string or URI prop named "href".
       *      href: function(props, propName, componentName) {
       *        var propValue = props[propName];
       *        if (propValue != null && typeof propValue !== 'string' &&
       *            !(propValue instanceof URI)) {
       *          return new Error(
       *            'Expected a string or an URI for ' + propName + ' in ' +
       *            componentName
       *          );
       *        }
       *      }
       *    },
       *    render: function() {...}
       *  });
       *
       * @internal
       */


      var ANONYMOUS = '<<anonymous>>'; // Important!
      // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.

      var ReactPropTypes = {
        array: createPrimitiveTypeChecker('array'),
        bool: createPrimitiveTypeChecker('boolean'),
        func: createPrimitiveTypeChecker('function'),
        number: createPrimitiveTypeChecker('number'),
        object: createPrimitiveTypeChecker('object'),
        string: createPrimitiveTypeChecker('string'),
        symbol: createPrimitiveTypeChecker('symbol'),
        any: createAnyTypeChecker(),
        arrayOf: createArrayOfTypeChecker,
        element: createElementTypeChecker(),
        elementType: createElementTypeTypeChecker(),
        instanceOf: createInstanceTypeChecker,
        node: createNodeChecker(),
        objectOf: createObjectOfTypeChecker,
        oneOf: createEnumTypeChecker,
        oneOfType: createUnionTypeChecker,
        shape: createShapeTypeChecker,
        exact: createStrictShapeTypeChecker
      };
      /**
       * inlined Object.is polyfill to avoid requiring consumers ship their own
       * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
       */

      /*eslint-disable no-self-compare*/

      function is(x, y) {
        // SameValue algorithm
        if (x === y) {
          // Steps 1-5, 7-10
          // Steps 6.b-6.e: +0 != -0
          return x !== 0 || 1 / x === 1 / y;
        } else {
          // Step 6.a: NaN == NaN
          return x !== x && y !== y;
        }
      }
      /*eslint-enable no-self-compare*/

      /**
       * We use an Error-like object for backward compatibility as people may call
       * PropTypes directly and inspect their output. However, we don't use real
       * Errors anymore. We don't inspect their stack anyway, and creating them
       * is prohibitively expensive if they are created too often, such as what
       * happens in oneOfType() for any type before the one that matched.
       */


      function PropTypeError(message) {
        this.message = message;
        this.stack = '';
      } // Make `instanceof Error` still work for returned errors.


      PropTypeError.prototype = Error.prototype;

      function createChainableTypeChecker(validate) {
        if (process.env.NODE_ENV !== 'production') {
          var manualPropTypeCallCache = {};
          var manualPropTypeWarningCount = 0;
        }

        function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
          componentName = componentName || ANONYMOUS;
          propFullName = propFullName || propName;

          if (secret !== ReactPropTypesSecret) {
            if (throwOnDirectAccess) {
              // New behavior only for users of `prop-types` package
              var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use `PropTypes.checkPropTypes()` to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
              err.name = 'Invariant Violation';
              throw err;
            } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
              // Old behavior for people using React.PropTypes
              var cacheKey = componentName + ':' + propName;

              if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
              manualPropTypeWarningCount < 3) {
                printWarning('You are manually calling a React.PropTypes validation ' + 'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.');
                manualPropTypeCallCache[cacheKey] = true;
                manualPropTypeWarningCount++;
              }
            }
          }

          if (props[propName] == null) {
            if (isRequired) {
              if (props[propName] === null) {
                return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
              }

              return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
            }

            return null;
          } else {
            return validate(props, propName, componentName, location, propFullName);
          }
        }

        var chainedCheckType = checkType.bind(null, false);
        chainedCheckType.isRequired = checkType.bind(null, true);
        return chainedCheckType;
      }

      function createPrimitiveTypeChecker(expectedType) {
        function validate(props, propName, componentName, location, propFullName, secret) {
          var propValue = props[propName];
          var propType = getPropType(propValue);

          if (propType !== expectedType) {
            // `propValue` being instance of, say, date/regexp, pass the 'object'
            // check, but we can offer a more precise error message here rather than
            // 'of type `object`'.
            var preciseType = getPreciseType(propValue);
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
          }

          return null;
        }

        return createChainableTypeChecker(validate);
      }

      function createAnyTypeChecker() {
        return createChainableTypeChecker(emptyFunctionThatReturnsNull);
      }

      function createArrayOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
          if (typeof typeChecker !== 'function') {
            return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
          }

          var propValue = props[propName];

          if (!Array.isArray(propValue)) {
            var propType = getPropType(propValue);
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
          }

          for (var i = 0; i < propValue.length; i++) {
            var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);

            if (error instanceof Error) {
              return error;
            }
          }

          return null;
        }

        return createChainableTypeChecker(validate);
      }

      function createElementTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];

          if (!isValidElement(propValue)) {
            var propType = getPropType(propValue);
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
          }

          return null;
        }

        return createChainableTypeChecker(validate);
      }

      function createElementTypeTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];

          if (!ReactIs.isValidElementType(propValue)) {
            var propType = getPropType(propValue);
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
          }

          return null;
        }

        return createChainableTypeChecker(validate);
      }

      function createInstanceTypeChecker(expectedClass) {
        function validate(props, propName, componentName, location, propFullName) {
          if (!(props[propName] instanceof expectedClass)) {
            var expectedClassName = expectedClass.name || ANONYMOUS;
            var actualClassName = getClassName(props[propName]);
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
          }

          return null;
        }

        return createChainableTypeChecker(validate);
      }

      function createEnumTypeChecker(expectedValues) {
        if (!Array.isArray(expectedValues)) {
          if (process.env.NODE_ENV !== 'production') {
            if (arguments.length > 1) {
              printWarning('Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' + 'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).');
            } else {
              printWarning('Invalid argument supplied to oneOf, expected an array.');
            }
          }

          return emptyFunctionThatReturnsNull;
        }

        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];

          for (var i = 0; i < expectedValues.length; i++) {
            if (is(propValue, expectedValues[i])) {
              return null;
            }
          }

          var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
            var type = getPreciseType(value);

            if (type === 'symbol') {
              return String(value);
            }

            return value;
          });
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
        }

        return createChainableTypeChecker(validate);
      }

      function createObjectOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
          if (typeof typeChecker !== 'function') {
            return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
          }

          var propValue = props[propName];
          var propType = getPropType(propValue);

          if (propType !== 'object') {
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
          }

          for (var key in propValue) {
            if (has(propValue, key)) {
              var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);

              if (error instanceof Error) {
                return error;
              }
            }
          }

          return null;
        }

        return createChainableTypeChecker(validate);
      }

      function createUnionTypeChecker(arrayOfTypeCheckers) {
        if (!Array.isArray(arrayOfTypeCheckers)) {
          process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
          return emptyFunctionThatReturnsNull;
        }

        for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
          var checker = arrayOfTypeCheckers[i];

          if (typeof checker !== 'function') {
            printWarning('Invalid argument supplied to oneOfType. Expected an array of check functions, but ' + 'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
            return emptyFunctionThatReturnsNull;
          }
        }

        function validate(props, propName, componentName, location, propFullName) {
          for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
            var checker = arrayOfTypeCheckers[i];

            if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
              return null;
            }
          }

          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
        }

        return createChainableTypeChecker(validate);
      }

      function createNodeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
          if (!isNode(props[propName])) {
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
          }

          return null;
        }

        return createChainableTypeChecker(validate);
      }

      function createShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];
          var propType = getPropType(propValue);

          if (propType !== 'object') {
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
          }

          for (var key in shapeTypes) {
            var checker = shapeTypes[key];

            if (!checker) {
              continue;
            }

            var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);

            if (error) {
              return error;
            }
          }

          return null;
        }

        return createChainableTypeChecker(validate);
      }

      function createStrictShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];
          var propType = getPropType(propValue);

          if (propType !== 'object') {
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
          } // We need to check all keys in case some are required but missing from
          // props.


          var allKeys = assign({}, props[propName], shapeTypes);

          for (var key in allKeys) {
            var checker = shapeTypes[key];

            if (!checker) {
              return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
            }

            var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);

            if (error) {
              return error;
            }
          }

          return null;
        }

        return createChainableTypeChecker(validate);
      }

      function isNode(propValue) {
        switch (typeof propValue) {
          case 'number':
          case 'string':
          case 'undefined':
            return true;

          case 'boolean':
            return !propValue;

          case 'object':
            if (Array.isArray(propValue)) {
              return propValue.every(isNode);
            }

            if (propValue === null || isValidElement(propValue)) {
              return true;
            }

            var iteratorFn = getIteratorFn(propValue);

            if (iteratorFn) {
              var iterator = iteratorFn.call(propValue);
              var step;

              if (iteratorFn !== propValue.entries) {
                while (!(step = iterator.next()).done) {
                  if (!isNode(step.value)) {
                    return false;
                  }
                }
              } else {
                // Iterator will provide entry [k,v] tuples rather than values.
                while (!(step = iterator.next()).done) {
                  var entry = step.value;

                  if (entry) {
                    if (!isNode(entry[1])) {
                      return false;
                    }
                  }
                }
              }
            } else {
              return false;
            }

            return true;

          default:
            return false;
        }
      }

      function isSymbol(propType, propValue) {
        // Native Symbol.
        if (propType === 'symbol') {
          return true;
        } // falsy value can't be a Symbol


        if (!propValue) {
          return false;
        } // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'


        if (propValue['@@toStringTag'] === 'Symbol') {
          return true;
        } // Fallback for non-spec compliant Symbols which are polyfilled.


        if (typeof Symbol === 'function' && propValue instanceof Symbol) {
          return true;
        }

        return false;
      } // Equivalent of `typeof` but with special handling for array and regexp.


      function getPropType(propValue) {
        var propType = typeof propValue;

        if (Array.isArray(propValue)) {
          return 'array';
        }

        if (propValue instanceof RegExp) {
          // Old webkits (at least until Android 4.0) return 'function' rather than
          // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
          // passes PropTypes.object.
          return 'object';
        }

        if (isSymbol(propType, propValue)) {
          return 'symbol';
        }

        return propType;
      } // This handles more types than `getPropType`. Only used for error messages.
      // See `createPrimitiveTypeChecker`.


      function getPreciseType(propValue) {
        if (typeof propValue === 'undefined' || propValue === null) {
          return '' + propValue;
        }

        var propType = getPropType(propValue);

        if (propType === 'object') {
          if (propValue instanceof Date) {
            return 'date';
          } else if (propValue instanceof RegExp) {
            return 'regexp';
          }
        }

        return propType;
      } // Returns a string that is postfixed to a warning about an invalid type.
      // For example, "undefined" or "of type array"


      function getPostfixForTypeWarning(value) {
        var type = getPreciseType(value);

        switch (type) {
          case 'array':
          case 'object':
            return 'an ' + type;

          case 'boolean':
          case 'date':
          case 'regexp':
            return 'a ' + type;

          default:
            return type;
        }
      } // Returns class name of the object, if any.


      function getClassName(propValue) {
        if (!propValue.constructor || !propValue.constructor.name) {
          return ANONYMOUS;
        }

        return propValue.constructor.name;
      }

      ReactPropTypes.checkPropTypes = checkPropTypes;
      ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
      ReactPropTypes.PropTypes = ReactPropTypes;
      return ReactPropTypes;
    };
    /* WEBPACK VAR INJECTION */

  }).call(exports, __webpack_require__(25));
  /***/
},
/* 598 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (process) {
    /** @license React v17.0.1
    * react-dom.development.js
    *
    * Copyright (c) Facebook, Inc. and its affiliates.
    *
    * This source code is licensed under the MIT license found in the
    * LICENSE file in the root directory of this source tree.
    */
    if (process.env.NODE_ENV !== "production") {
      (function () {
        'use strict';

        var React = __webpack_require__(4);

        var _assign = __webpack_require__(172);

        var Scheduler = __webpack_require__(246);

        var tracing = __webpack_require__(609);

        var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED; // by calls to these methods by a Babel plugin.
        //
        // In PROD (or in packages without access to React internals),
        // they are left as they are instead.

        function warn(format) {
          {
            for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
              args[_key - 1] = arguments[_key];
            }

            printWarning('warn', format, args);
          }
        }

        function error(format) {
          {
            for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              args[_key2 - 1] = arguments[_key2];
            }

            printWarning('error', format, args);
          }
        }

        function printWarning(level, format, args) {
          // When changing this logic, you might want to also
          // update consoleWithStackDev.www.js as well.
          {
            var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
            var stack = ReactDebugCurrentFrame.getStackAddendum();

            if (stack !== '') {
              format += '%s';
              args = args.concat([stack]);
            }

            var argsWithFormat = args.map(function (item) {
              return '' + item;
            }); // Careful: RN currently depends on this prefix

            argsWithFormat.unshift('Warning: ' + format); // We intentionally don't use spread (or .apply) directly because it
            // breaks IE9: https://github.com/facebook/react/issues/13610
            // eslint-disable-next-line react-internal/no-production-logging

            Function.prototype.apply.call(console[level], console, argsWithFormat);
          }
        }

        if (!React) {
          {
            throw Error("ReactDOM was loaded before React. Make sure you load the React package before loading ReactDOM.");
          }
        }

        var FunctionComponent = 0;
        var ClassComponent = 1;
        var IndeterminateComponent = 2; // Before we know whether it is function or class

        var HostRoot = 3; // Root of a host tree. Could be nested inside another node.

        var HostPortal = 4; // A subtree. Could be an entry point to a different renderer.

        var HostComponent = 5;
        var HostText = 6;
        var Fragment = 7;
        var Mode = 8;
        var ContextConsumer = 9;
        var ContextProvider = 10;
        var ForwardRef = 11;
        var Profiler = 12;
        var SuspenseComponent = 13;
        var MemoComponent = 14;
        var SimpleMemoComponent = 15;
        var LazyComponent = 16;
        var IncompleteClassComponent = 17;
        var DehydratedFragment = 18;
        var SuspenseListComponent = 19;
        var FundamentalComponent = 20;
        var ScopeComponent = 21;
        var Block = 22;
        var OffscreenComponent = 23;
        var LegacyHiddenComponent = 24; // Filter certain DOM attributes (e.g. src, href) if their values are empty strings.

        var enableProfilerTimer = true; // Record durations for commit and passive effects phases.

        var enableFundamentalAPI = false; // Experimental Scope support.

        var enableNewReconciler = false; // Errors that are thrown while unmounting (or after in the case of passive effects)

        var warnAboutStringRefs = false;
        var allNativeEvents = new Set();
        /**
         * Mapping from registration name to event name
         */

        var registrationNameDependencies = {};
        /**
         * Mapping from lowercase registration names to the properly cased version,
         * used to warn in the case of missing event handlers. Available
         * only in true.
         * @type {Object}
         */

        var possibleRegistrationNames = {}; // Trust the developer to only use possibleRegistrationNames in true

        function registerTwoPhaseEvent(registrationName, dependencies) {
          registerDirectEvent(registrationName, dependencies);
          registerDirectEvent(registrationName + 'Capture', dependencies);
        }

        function registerDirectEvent(registrationName, dependencies) {
          {
            if (registrationNameDependencies[registrationName]) {
              error('EventRegistry: More than one plugin attempted to publish the same ' + 'registration name, `%s`.', registrationName);
            }
          }
          registrationNameDependencies[registrationName] = dependencies;
          {
            var lowerCasedName = registrationName.toLowerCase();
            possibleRegistrationNames[lowerCasedName] = registrationName;

            if (registrationName === 'onDoubleClick') {
              possibleRegistrationNames.ondblclick = registrationName;
            }
          }

          for (var i = 0; i < dependencies.length; i++) {
            allNativeEvents.add(dependencies[i]);
          }
        }

        var canUseDOM = !!(typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined'); // A reserved attribute.
        // It is handled by React separately and shouldn't be written to the DOM.

        var RESERVED = 0; // A simple string attribute.
        // Attributes that aren't in the filter are presumed to have this type.

        var STRING = 1; // A string attribute that accepts booleans in React. In HTML, these are called
        // "enumerated" attributes with "true" and "false" as possible values.
        // When true, it should be set to a "true" string.
        // When false, it should be set to a "false" string.

        var BOOLEANISH_STRING = 2; // A real boolean attribute.
        // When true, it should be present (set either to an empty string or its name).
        // When false, it should be omitted.

        var BOOLEAN = 3; // An attribute that can be used as a flag as well as with a value.
        // When true, it should be present (set either to an empty string or its name).
        // When false, it should be omitted.
        // For any other value, should be present with that value.

        var OVERLOADED_BOOLEAN = 4; // An attribute that must be numeric or parse as a numeric.
        // When falsy, it should be removed.

        var NUMERIC = 5; // An attribute that must be positive numeric or parse as a positive numeric.
        // When falsy, it should be removed.

        var POSITIVE_NUMERIC = 6;
        /* eslint-disable max-len */

        var ATTRIBUTE_NAME_START_CHAR = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD";
        /* eslint-enable max-len */

        var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040";
        var ROOT_ATTRIBUTE_NAME = 'data-reactroot';
        var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + ATTRIBUTE_NAME_START_CHAR + '][' + ATTRIBUTE_NAME_CHAR + ']*$');
        var hasOwnProperty = Object.prototype.hasOwnProperty;
        var illegalAttributeNameCache = {};
        var validatedAttributeNameCache = {};

        function isAttributeNameSafe(attributeName) {
          if (hasOwnProperty.call(validatedAttributeNameCache, attributeName)) {
            return true;
          }

          if (hasOwnProperty.call(illegalAttributeNameCache, attributeName)) {
            return false;
          }

          if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
            validatedAttributeNameCache[attributeName] = true;
            return true;
          }

          illegalAttributeNameCache[attributeName] = true;
          {
            error('Invalid attribute name: `%s`', attributeName);
          }
          return false;
        }

        function shouldIgnoreAttribute(name, propertyInfo, isCustomComponentTag) {
          if (propertyInfo !== null) {
            return propertyInfo.type === RESERVED;
          }

          if (isCustomComponentTag) {
            return false;
          }

          if (name.length > 2 && (name[0] === 'o' || name[0] === 'O') && (name[1] === 'n' || name[1] === 'N')) {
            return true;
          }

          return false;
        }

        function shouldRemoveAttributeWithWarning(name, value, propertyInfo, isCustomComponentTag) {
          if (propertyInfo !== null && propertyInfo.type === RESERVED) {
            return false;
          }

          switch (typeof value) {
            case 'function': // $FlowIssue symbol is perfectly valid here

            case 'symbol':
              // eslint-disable-line
              return true;

            case 'boolean':
              {
                if (isCustomComponentTag) {
                  return false;
                }

                if (propertyInfo !== null) {
                  return !propertyInfo.acceptsBooleans;
                } else {
                  var prefix = name.toLowerCase().slice(0, 5);
                  return prefix !== 'data-' && prefix !== 'aria-';
                }
              }

            default:
              return false;
          }
        }

        function shouldRemoveAttribute(name, value, propertyInfo, isCustomComponentTag) {
          if (value === null || typeof value === 'undefined') {
            return true;
          }

          if (shouldRemoveAttributeWithWarning(name, value, propertyInfo, isCustomComponentTag)) {
            return true;
          }

          if (isCustomComponentTag) {
            return false;
          }

          if (propertyInfo !== null) {
            switch (propertyInfo.type) {
              case BOOLEAN:
                return !value;

              case OVERLOADED_BOOLEAN:
                return value === false;

              case NUMERIC:
                return isNaN(value);

              case POSITIVE_NUMERIC:
                return isNaN(value) || value < 1;
            }
          }

          return false;
        }

        function getPropertyInfo(name) {
          return properties.hasOwnProperty(name) ? properties[name] : null;
        }

        function PropertyInfoRecord(name, type, mustUseProperty, attributeName, attributeNamespace, sanitizeURL, removeEmptyString) {
          this.acceptsBooleans = type === BOOLEANISH_STRING || type === BOOLEAN || type === OVERLOADED_BOOLEAN;
          this.attributeName = attributeName;
          this.attributeNamespace = attributeNamespace;
          this.mustUseProperty = mustUseProperty;
          this.propertyName = name;
          this.type = type;
          this.sanitizeURL = sanitizeURL;
          this.removeEmptyString = removeEmptyString;
        } // When adding attributes to this list, be sure to also add them to
        // the `possibleStandardNames` module to ensure casing and incorrect
        // name warnings.


        var properties = {}; // These props are reserved by React. They shouldn't be written to the DOM.

        var reservedProps = ['children', 'dangerouslySetInnerHTML', // TODO: This prevents the assignment of defaultValue to regular
        // elements (not just inputs). Now that ReactDOMInput assigns to the
        // defaultValue property -- do we need this?
        'defaultValue', 'defaultChecked', 'innerHTML', 'suppressContentEditableWarning', 'suppressHydrationWarning', 'style'];
        reservedProps.forEach(function (name) {
          properties[name] = new PropertyInfoRecord(name, RESERVED, false, // mustUseProperty
          name, // attributeName
          null, // attributeNamespace
          false, // sanitizeURL
          false);
        }); // A few React string attributes have a different name.
        // This is a mapping from React prop names to the attribute names.

        [['acceptCharset', 'accept-charset'], ['className', 'class'], ['htmlFor', 'for'], ['httpEquiv', 'http-equiv']].forEach(function (_ref) {
          var name = _ref[0],
              attributeName = _ref[1];
          properties[name] = new PropertyInfoRecord(name, STRING, false, // mustUseProperty
          attributeName, // attributeName
          null, // attributeNamespace
          false, // sanitizeURL
          false);
        }); // These are "enumerated" HTML attributes that accept "true" and "false".
        // In React, we let users pass `true` and `false` even though technically
        // these aren't boolean attributes (they are coerced to strings).

        ['contentEditable', 'draggable', 'spellCheck', 'value'].forEach(function (name) {
          properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, // mustUseProperty
          name.toLowerCase(), // attributeName
          null, // attributeNamespace
          false, // sanitizeURL
          false);
        }); // These are "enumerated" SVG attributes that accept "true" and "false".
        // In React, we let users pass `true` and `false` even though technically
        // these aren't boolean attributes (they are coerced to strings).
        // Since these are SVG attributes, their attribute names are case-sensitive.

        ['autoReverse', 'externalResourcesRequired', 'focusable', 'preserveAlpha'].forEach(function (name) {
          properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, // mustUseProperty
          name, // attributeName
          null, // attributeNamespace
          false, // sanitizeURL
          false);
        }); // These are HTML boolean attributes.

        ['allowFullScreen', 'async', // Note: there is a special case that prevents it from being written to the DOM
        // on the client side because the browsers are inconsistent. Instead we call focus().
        'autoFocus', 'autoPlay', 'controls', 'default', 'defer', 'disabled', 'disablePictureInPicture', 'disableRemotePlayback', 'formNoValidate', 'hidden', 'loop', 'noModule', 'noValidate', 'open', 'playsInline', 'readOnly', 'required', 'reversed', 'scoped', 'seamless', // Microdata
        'itemScope'].forEach(function (name) {
          properties[name] = new PropertyInfoRecord(name, BOOLEAN, false, // mustUseProperty
          name.toLowerCase(), // attributeName
          null, // attributeNamespace
          false, // sanitizeURL
          false);
        }); // These are the few React props that we set as DOM properties
        // rather than attributes. These are all booleans.

        ['checked', // Note: `option.selected` is not updated if `select.multiple` is
        // disabled with `removeAttribute`. We have special logic for handling this.
        'multiple', 'muted', 'selected' // NOTE: if you add a camelCased prop to this list,
        // you'll need to set attributeName to name.toLowerCase()
        // instead in the assignment below.
        ].forEach(function (name) {
          properties[name] = new PropertyInfoRecord(name, BOOLEAN, true, // mustUseProperty
          name, // attributeName
          null, // attributeNamespace
          false, // sanitizeURL
          false);
        }); // These are HTML attributes that are "overloaded booleans": they behave like
        // booleans, but can also accept a string value.

        ['capture', 'download' // NOTE: if you add a camelCased prop to this list,
        // you'll need to set attributeName to name.toLowerCase()
        // instead in the assignment below.
        ].forEach(function (name) {
          properties[name] = new PropertyInfoRecord(name, OVERLOADED_BOOLEAN, false, // mustUseProperty
          name, // attributeName
          null, // attributeNamespace
          false, // sanitizeURL
          false);
        }); // These are HTML attributes that must be positive numbers.

        ['cols', 'rows', 'size', 'span' // NOTE: if you add a camelCased prop to this list,
        // you'll need to set attributeName to name.toLowerCase()
        // instead in the assignment below.
        ].forEach(function (name) {
          properties[name] = new PropertyInfoRecord(name, POSITIVE_NUMERIC, false, // mustUseProperty
          name, // attributeName
          null, // attributeNamespace
          false, // sanitizeURL
          false);
        }); // These are HTML attributes that must be numbers.

        ['rowSpan', 'start'].forEach(function (name) {
          properties[name] = new PropertyInfoRecord(name, NUMERIC, false, // mustUseProperty
          name.toLowerCase(), // attributeName
          null, // attributeNamespace
          false, // sanitizeURL
          false);
        });
        var CAMELIZE = /[\-\:]([a-z])/g;

        var capitalize = function capitalize(token) {
          return token[1].toUpperCase();
        }; // This is a list of all SVG attributes that need special casing, namespacing,
        // or boolean value assignment. Regular attributes that just accept strings
        // and have the same names are omitted, just like in the HTML attribute filter.
        // Some of these attributes can be hard to find. This list was created by
        // scraping the MDN documentation.


        ['accent-height', 'alignment-baseline', 'arabic-form', 'baseline-shift', 'cap-height', 'clip-path', 'clip-rule', 'color-interpolation', 'color-interpolation-filters', 'color-profile', 'color-rendering', 'dominant-baseline', 'enable-background', 'fill-opacity', 'fill-rule', 'flood-color', 'flood-opacity', 'font-family', 'font-size', 'font-size-adjust', 'font-stretch', 'font-style', 'font-variant', 'font-weight', 'glyph-name', 'glyph-orientation-horizontal', 'glyph-orientation-vertical', 'horiz-adv-x', 'horiz-origin-x', 'image-rendering', 'letter-spacing', 'lighting-color', 'marker-end', 'marker-mid', 'marker-start', 'overline-position', 'overline-thickness', 'paint-order', 'panose-1', 'pointer-events', 'rendering-intent', 'shape-rendering', 'stop-color', 'stop-opacity', 'strikethrough-position', 'strikethrough-thickness', 'stroke-dasharray', 'stroke-dashoffset', 'stroke-linecap', 'stroke-linejoin', 'stroke-miterlimit', 'stroke-opacity', 'stroke-width', 'text-anchor', 'text-decoration', 'text-rendering', 'underline-position', 'underline-thickness', 'unicode-bidi', 'unicode-range', 'units-per-em', 'v-alphabetic', 'v-hanging', 'v-ideographic', 'v-mathematical', 'vector-effect', 'vert-adv-y', 'vert-origin-x', 'vert-origin-y', 'word-spacing', 'writing-mode', 'xmlns:xlink', 'x-height' // NOTE: if you add a camelCased prop to this list,
        // you'll need to set attributeName to name.toLowerCase()
        // instead in the assignment below.
        ].forEach(function (attributeName) {
          var name = attributeName.replace(CAMELIZE, capitalize);
          properties[name] = new PropertyInfoRecord(name, STRING, false, // mustUseProperty
          attributeName, null, // attributeNamespace
          false, // sanitizeURL
          false);
        }); // String SVG attributes with the xlink namespace.

        ['xlink:actuate', 'xlink:arcrole', 'xlink:role', 'xlink:show', 'xlink:title', 'xlink:type' // NOTE: if you add a camelCased prop to this list,
        // you'll need to set attributeName to name.toLowerCase()
        // instead in the assignment below.
        ].forEach(function (attributeName) {
          var name = attributeName.replace(CAMELIZE, capitalize);
          properties[name] = new PropertyInfoRecord(name, STRING, false, // mustUseProperty
          attributeName, 'http://www.w3.org/1999/xlink', false, // sanitizeURL
          false);
        }); // String SVG attributes with the xml namespace.

        ['xml:base', 'xml:lang', 'xml:space' // NOTE: if you add a camelCased prop to this list,
        // you'll need to set attributeName to name.toLowerCase()
        // instead in the assignment below.
        ].forEach(function (attributeName) {
          var name = attributeName.replace(CAMELIZE, capitalize);
          properties[name] = new PropertyInfoRecord(name, STRING, false, // mustUseProperty
          attributeName, 'http://www.w3.org/XML/1998/namespace', false, // sanitizeURL
          false);
        }); // These attribute exists both in HTML and SVG.
        // The attribute name is case-sensitive in SVG so we can't just use
        // the React name like we do for attributes that exist only in HTML.

        ['tabIndex', 'crossOrigin'].forEach(function (attributeName) {
          properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, // mustUseProperty
          attributeName.toLowerCase(), // attributeName
          null, // attributeNamespace
          false, // sanitizeURL
          false);
        }); // These attributes accept URLs. These must not allow javascript: URLS.
        // These will also need to accept Trusted Types object in the future.

        var xlinkHref = 'xlinkHref';
        properties[xlinkHref] = new PropertyInfoRecord('xlinkHref', STRING, false, // mustUseProperty
        'xlink:href', 'http://www.w3.org/1999/xlink', true, // sanitizeURL
        false);
        ['src', 'href', 'action', 'formAction'].forEach(function (attributeName) {
          properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, // mustUseProperty
          attributeName.toLowerCase(), // attributeName
          null, // attributeNamespace
          true, // sanitizeURL
          true);
        }); // and any newline or tab are filtered out as if they're not part of the URL.
        // https://url.spec.whatwg.org/#url-parsing
        // Tab or newline are defined as \r\n\t:
        // https://infra.spec.whatwg.org/#ascii-tab-or-newline
        // A C0 control is a code point in the range \u0000 NULL to \u001F
        // INFORMATION SEPARATOR ONE, inclusive:
        // https://infra.spec.whatwg.org/#c0-control-or-space

        /* eslint-disable max-len */

        var isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i;
        var didWarn = false;

        function sanitizeURL(url) {
          {
            if (!didWarn && isJavaScriptProtocol.test(url)) {
              didWarn = true;
              error('A future version of React will block javascript: URLs as a security precaution. ' + 'Use event handlers instead if you can. If you need to generate unsafe HTML try ' + 'using dangerouslySetInnerHTML instead. React was passed %s.', JSON.stringify(url));
            }
          }
        }
        /**
         * Get the value for a property on a node. Only used in DEV for SSR validation.
         * The "expected" argument is used as a hint of what the expected value is.
         * Some properties have multiple equivalent values.
         */


        function getValueForProperty(node, name, expected, propertyInfo) {
          {
            if (propertyInfo.mustUseProperty) {
              var propertyName = propertyInfo.propertyName;
              return node[propertyName];
            } else {
              if (propertyInfo.sanitizeURL) {
                // If we haven't fully disabled javascript: URLs, and if
                // the hydration is successful of a javascript: URL, we
                // still want to warn on the client.
                sanitizeURL('' + expected);
              }

              var attributeName = propertyInfo.attributeName;
              var stringValue = null;

              if (propertyInfo.type === OVERLOADED_BOOLEAN) {
                if (node.hasAttribute(attributeName)) {
                  var value = node.getAttribute(attributeName);

                  if (value === '') {
                    return true;
                  }

                  if (shouldRemoveAttribute(name, expected, propertyInfo, false)) {
                    return value;
                  }

                  if (value === '' + expected) {
                    return expected;
                  }

                  return value;
                }
              } else if (node.hasAttribute(attributeName)) {
                if (shouldRemoveAttribute(name, expected, propertyInfo, false)) {
                  // We had an attribute but shouldn't have had one, so read it
                  // for the error message.
                  return node.getAttribute(attributeName);
                }

                if (propertyInfo.type === BOOLEAN) {
                  // If this was a boolean, it doesn't matter what the value is
                  // the fact that we have it is the same as the expected.
                  return expected;
                } // Even if this property uses a namespace we use getAttribute
                // because we assume its namespaced name is the same as our config.
                // To use getAttributeNS we need the local name which we don't have
                // in our config atm.


                stringValue = node.getAttribute(attributeName);
              }

              if (shouldRemoveAttribute(name, expected, propertyInfo, false)) {
                return stringValue === null ? expected : stringValue;
              } else if (stringValue === '' + expected) {
                return expected;
              } else {
                return stringValue;
              }
            }
          }
        }
        /**
         * Get the value for a attribute on a node. Only used in DEV for SSR validation.
         * The third argument is used as a hint of what the expected value is. Some
         * attributes have multiple equivalent values.
         */


        function getValueForAttribute(node, name, expected) {
          {
            if (!isAttributeNameSafe(name)) {
              return;
            } // If the object is an opaque reference ID, it's expected that
            // the next prop is different than the server value, so just return
            // expected


            if (isOpaqueHydratingObject(expected)) {
              return expected;
            }

            if (!node.hasAttribute(name)) {
              return expected === undefined ? undefined : null;
            }

            var value = node.getAttribute(name);

            if (value === '' + expected) {
              return expected;
            }

            return value;
          }
        }
        /**
         * Sets the value for a property on a node.
         *
         * @param {DOMElement} node
         * @param {string} name
         * @param {*} value
         */


        function setValueForProperty(node, name, value, isCustomComponentTag) {
          var propertyInfo = getPropertyInfo(name);

          if (shouldIgnoreAttribute(name, propertyInfo, isCustomComponentTag)) {
            return;
          }

          if (shouldRemoveAttribute(name, value, propertyInfo, isCustomComponentTag)) {
            value = null;
          } // If the prop isn't in the special list, treat it as a simple attribute.


          if (isCustomComponentTag || propertyInfo === null) {
            if (isAttributeNameSafe(name)) {
              var _attributeName = name;

              if (value === null) {
                node.removeAttribute(_attributeName);
              } else {
                node.setAttribute(_attributeName, '' + value);
              }
            }

            return;
          }

          var mustUseProperty = propertyInfo.mustUseProperty;

          if (mustUseProperty) {
            var propertyName = propertyInfo.propertyName;

            if (value === null) {
              var type = propertyInfo.type;
              node[propertyName] = type === BOOLEAN ? false : '';
            } else {
              // Contrary to `setAttribute`, object properties are properly
              // `toString`ed by IE8/9.
              node[propertyName] = value;
            }

            return;
          } // The rest are treated as attributes with special cases.


          var attributeName = propertyInfo.attributeName,
              attributeNamespace = propertyInfo.attributeNamespace;

          if (value === null) {
            node.removeAttribute(attributeName);
          } else {
            var _type = propertyInfo.type;
            var attributeValue;

            if (_type === BOOLEAN || _type === OVERLOADED_BOOLEAN && value === true) {
              // If attribute type is boolean, we know for sure it won't be an execution sink
              // and we won't require Trusted Type here.
              attributeValue = '';
            } else {
              // `setAttribute` with objects becomes only `[object]` in IE8/9,
              // ('' + value) makes it output the correct toString()-value.
              {
                attributeValue = '' + value;
              }

              if (propertyInfo.sanitizeURL) {
                sanitizeURL(attributeValue.toString());
              }
            }

            if (attributeNamespace) {
              node.setAttributeNS(attributeNamespace, attributeName, attributeValue);
            } else {
              node.setAttribute(attributeName, attributeValue);
            }
          }
        } // ATTENTION
        // When adding new symbols to this file,
        // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
        // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
        // nor polyfill, then a plain number is used for performance.


        var REACT_ELEMENT_TYPE = 0xeac7;
        var REACT_PORTAL_TYPE = 0xeaca;
        var REACT_FRAGMENT_TYPE = 0xeacb;
        var REACT_STRICT_MODE_TYPE = 0xeacc;
        var REACT_PROFILER_TYPE = 0xead2;
        var REACT_PROVIDER_TYPE = 0xeacd;
        var REACT_CONTEXT_TYPE = 0xeace;
        var REACT_FORWARD_REF_TYPE = 0xead0;
        var REACT_SUSPENSE_TYPE = 0xead1;
        var REACT_SUSPENSE_LIST_TYPE = 0xead8;
        var REACT_MEMO_TYPE = 0xead3;
        var REACT_LAZY_TYPE = 0xead4;
        var REACT_BLOCK_TYPE = 0xead9;
        var REACT_SERVER_BLOCK_TYPE = 0xeada;
        var REACT_FUNDAMENTAL_TYPE = 0xead5;
        var REACT_SCOPE_TYPE = 0xead7;
        var REACT_OPAQUE_ID_TYPE = 0xeae0;
        var REACT_DEBUG_TRACING_MODE_TYPE = 0xeae1;
        var REACT_OFFSCREEN_TYPE = 0xeae2;
        var REACT_LEGACY_HIDDEN_TYPE = 0xeae3;

        if (typeof Symbol === 'function' && Symbol.for) {
          var symbolFor = Symbol.for;
          REACT_ELEMENT_TYPE = symbolFor('react.element');
          REACT_PORTAL_TYPE = symbolFor('react.portal');
          REACT_FRAGMENT_TYPE = symbolFor('react.fragment');
          REACT_STRICT_MODE_TYPE = symbolFor('react.strict_mode');
          REACT_PROFILER_TYPE = symbolFor('react.profiler');
          REACT_PROVIDER_TYPE = symbolFor('react.provider');
          REACT_CONTEXT_TYPE = symbolFor('react.context');
          REACT_FORWARD_REF_TYPE = symbolFor('react.forward_ref');
          REACT_SUSPENSE_TYPE = symbolFor('react.suspense');
          REACT_SUSPENSE_LIST_TYPE = symbolFor('react.suspense_list');
          REACT_MEMO_TYPE = symbolFor('react.memo');
          REACT_LAZY_TYPE = symbolFor('react.lazy');
          REACT_BLOCK_TYPE = symbolFor('react.block');
          REACT_SERVER_BLOCK_TYPE = symbolFor('react.server.block');
          REACT_FUNDAMENTAL_TYPE = symbolFor('react.fundamental');
          REACT_SCOPE_TYPE = symbolFor('react.scope');
          REACT_OPAQUE_ID_TYPE = symbolFor('react.opaque.id');
          REACT_DEBUG_TRACING_MODE_TYPE = symbolFor('react.debug_trace_mode');
          REACT_OFFSCREEN_TYPE = symbolFor('react.offscreen');
          REACT_LEGACY_HIDDEN_TYPE = symbolFor('react.legacy_hidden');
        }

        var MAYBE_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
        var FAUX_ITERATOR_SYMBOL = '@@iterator';

        function getIteratorFn(maybeIterable) {
          if (maybeIterable === null || typeof maybeIterable !== 'object') {
            return null;
          }

          var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];

          if (typeof maybeIterator === 'function') {
            return maybeIterator;
          }

          return null;
        } // Helpers to patch console.logs to avoid logging during side-effect free
        // replaying on render function. This currently only patches the object
        // lazily which won't cover if the log function was extracted eagerly.
        // We could also eagerly patch the method.


        var disabledDepth = 0;
        var prevLog;
        var prevInfo;
        var prevWarn;
        var prevError;
        var prevGroup;
        var prevGroupCollapsed;
        var prevGroupEnd;

        function disabledLog() {}

        disabledLog.__reactDisabledLog = true;

        function disableLogs() {
          {
            if (disabledDepth === 0) {
              /* eslint-disable react-internal/no-production-logging */
              prevLog = console.log;
              prevInfo = console.info;
              prevWarn = console.warn;
              prevError = console.error;
              prevGroup = console.group;
              prevGroupCollapsed = console.groupCollapsed;
              prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099

              var props = {
                configurable: true,
                enumerable: true,
                value: disabledLog,
                writable: true
              }; // $FlowFixMe Flow thinks console is immutable.

              Object.defineProperties(console, {
                info: props,
                log: props,
                warn: props,
                error: props,
                group: props,
                groupCollapsed: props,
                groupEnd: props
              });
              /* eslint-enable react-internal/no-production-logging */
            }

            disabledDepth++;
          }
        }

        function reenableLogs() {
          {
            disabledDepth--;

            if (disabledDepth === 0) {
              /* eslint-disable react-internal/no-production-logging */
              var props = {
                configurable: true,
                enumerable: true,
                writable: true
              }; // $FlowFixMe Flow thinks console is immutable.

              Object.defineProperties(console, {
                log: _assign({}, props, {
                  value: prevLog
                }),
                info: _assign({}, props, {
                  value: prevInfo
                }),
                warn: _assign({}, props, {
                  value: prevWarn
                }),
                error: _assign({}, props, {
                  value: prevError
                }),
                group: _assign({}, props, {
                  value: prevGroup
                }),
                groupCollapsed: _assign({}, props, {
                  value: prevGroupCollapsed
                }),
                groupEnd: _assign({}, props, {
                  value: prevGroupEnd
                })
              });
              /* eslint-enable react-internal/no-production-logging */
            }

            if (disabledDepth < 0) {
              error('disabledDepth fell below zero. ' + 'This is a bug in React. Please file an issue.');
            }
          }
        }

        var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
        var prefix;

        function describeBuiltInComponentFrame(name, source, ownerFn) {
          {
            if (prefix === undefined) {
              // Extract the VM specific prefix used by each line.
              try {
                throw Error();
              } catch (x) {
                var match = x.stack.trim().match(/\n( *(at )?)/);
                prefix = match && match[1] || '';
              }
            } // We use the prefix to ensure our stacks line up with native stack frames.


            return '\n' + prefix + name;
          }
        }

        var reentry = false;
        var componentFrameCache;
        {
          var PossiblyWeakMap = typeof WeakMap === 'function' ? WeakMap : Map;
          componentFrameCache = new PossiblyWeakMap();
        }

        function describeNativeComponentFrame(fn, construct) {
          // If something asked for a stack inside a fake render, it should get ignored.
          if (!fn || reentry) {
            return '';
          }

          {
            var frame = componentFrameCache.get(fn);

            if (frame !== undefined) {
              return frame;
            }
          }
          var control;
          reentry = true;
          var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.

          Error.prepareStackTrace = undefined;
          var previousDispatcher;
          {
            previousDispatcher = ReactCurrentDispatcher.current; // Set the dispatcher in DEV because this might be call in the render function
            // for warnings.

            ReactCurrentDispatcher.current = null;
            disableLogs();
          }

          try {
            // This should throw.
            if (construct) {
              // Something should be setting the props in the constructor.
              var Fake = function Fake() {
                throw Error();
              }; // $FlowFixMe


              Object.defineProperty(Fake.prototype, 'props', {
                set: function set() {
                  // We use a throwing setter instead of frozen or non-writable props
                  // because that won't throw in a non-strict mode function.
                  throw Error();
                }
              });

              if (typeof Reflect === 'object' && Reflect.construct) {
                // We construct a different control for this case to include any extra
                // frames added by the construct call.
                try {
                  Reflect.construct(Fake, []);
                } catch (x) {
                  control = x;
                }

                Reflect.construct(fn, [], Fake);
              } else {
                try {
                  Fake.call();
                } catch (x) {
                  control = x;
                }

                fn.call(Fake.prototype);
              }
            } else {
              try {
                throw Error();
              } catch (x) {
                control = x;
              }

              fn();
            }
          } catch (sample) {
            // This is inlined manually because closure doesn't do it for us.
            if (sample && control && typeof sample.stack === 'string') {
              // This extracts the first frame from the sample that isn't also in the control.
              // Skipping one frame that we assume is the frame that calls the two.
              var sampleLines = sample.stack.split('\n');
              var controlLines = control.stack.split('\n');
              var s = sampleLines.length - 1;
              var c = controlLines.length - 1;

              while (s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c]) {
                // We expect at least one stack frame to be shared.
                // Typically this will be the root most one. However, stack frames may be
                // cut off due to maximum stack limits. In this case, one maybe cut off
                // earlier than the other. We assume that the sample is longer or the same
                // and there for cut off earlier. So we should find the root most frame in
                // the sample somewhere in the control.
                c--;
              }

              for (; s >= 1 && c >= 0; s--, c--) {
                // Next we find the first one that isn't the same which should be the
                // frame that called our sample function and the control.
                if (sampleLines[s] !== controlLines[c]) {
                  // In V8, the first line is describing the message but other VMs don't.
                  // If we're about to return the first line, and the control is also on the same
                  // line, that's a pretty good indicator that our sample threw at same line as
                  // the control. I.e. before we entered the sample frame. So we ignore this result.
                  // This can happen if you passed a class to function component, or non-function.
                  if (s !== 1 || c !== 1) {
                    do {
                      s--;
                      c--; // We may still have similar intermediate frames from the construct call.
                      // The next one that isn't the same should be our match though.

                      if (c < 0 || sampleLines[s] !== controlLines[c]) {
                        // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                        var _frame = '\n' + sampleLines[s].replace(' at new ', ' at ');

                        {
                          if (typeof fn === 'function') {
                            componentFrameCache.set(fn, _frame);
                          }
                        } // Return the line we found.

                        return _frame;
                      }
                    } while (s >= 1 && c >= 0);
                  }

                  break;
                }
              }
            }
          } finally {
            reentry = false;
            {
              ReactCurrentDispatcher.current = previousDispatcher;
              reenableLogs();
            }
            Error.prepareStackTrace = previousPrepareStackTrace;
          } // Fallback to just using the name if we couldn't make it throw.


          var name = fn ? fn.displayName || fn.name : '';
          var syntheticFrame = name ? describeBuiltInComponentFrame(name) : '';
          {
            if (typeof fn === 'function') {
              componentFrameCache.set(fn, syntheticFrame);
            }
          }
          return syntheticFrame;
        }

        function describeClassComponentFrame(ctor, source, ownerFn) {
          {
            return describeNativeComponentFrame(ctor, true);
          }
        }

        function describeFunctionComponentFrame(fn, source, ownerFn) {
          {
            return describeNativeComponentFrame(fn, false);
          }
        }

        function shouldConstruct(Component) {
          var prototype = Component.prototype;
          return !!(prototype && prototype.isReactComponent);
        }

        function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
          if (type == null) {
            return '';
          }

          if (typeof type === 'function') {
            {
              return describeNativeComponentFrame(type, shouldConstruct(type));
            }
          }

          if (typeof type === 'string') {
            return describeBuiltInComponentFrame(type);
          }

          switch (type) {
            case REACT_SUSPENSE_TYPE:
              return describeBuiltInComponentFrame('Suspense');

            case REACT_SUSPENSE_LIST_TYPE:
              return describeBuiltInComponentFrame('SuspenseList');
          }

          if (typeof type === 'object') {
            switch (type.$$typeof) {
              case REACT_FORWARD_REF_TYPE:
                return describeFunctionComponentFrame(type.render);

              case REACT_MEMO_TYPE:
                // Memo may contain any component type so we recursively resolve it.
                return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);

              case REACT_BLOCK_TYPE:
                return describeFunctionComponentFrame(type._render);

              case REACT_LAZY_TYPE:
                {
                  var lazyComponent = type;
                  var payload = lazyComponent._payload;
                  var init = lazyComponent._init;

                  try {
                    // Lazy may contain any component type so we recursively resolve it.
                    return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
                  } catch (x) {}
                }
            }
          }

          return '';
        }

        function describeFiber(fiber) {
          var owner = fiber._debugOwner ? fiber._debugOwner.type : null;
          var source = fiber._debugSource;

          switch (fiber.tag) {
            case HostComponent:
              return describeBuiltInComponentFrame(fiber.type);

            case LazyComponent:
              return describeBuiltInComponentFrame('Lazy');

            case SuspenseComponent:
              return describeBuiltInComponentFrame('Suspense');

            case SuspenseListComponent:
              return describeBuiltInComponentFrame('SuspenseList');

            case FunctionComponent:
            case IndeterminateComponent:
            case SimpleMemoComponent:
              return describeFunctionComponentFrame(fiber.type);

            case ForwardRef:
              return describeFunctionComponentFrame(fiber.type.render);

            case Block:
              return describeFunctionComponentFrame(fiber.type._render);

            case ClassComponent:
              return describeClassComponentFrame(fiber.type);

            default:
              return '';
          }
        }

        function getStackByFiberInDevAndProd(workInProgress) {
          try {
            var info = '';
            var node = workInProgress;

            do {
              info += describeFiber(node);
              node = node.return;
            } while (node);

            return info;
          } catch (x) {
            return '\nError generating stack: ' + x.message + '\n' + x.stack;
          }
        }

        function getWrappedName(outerType, innerType, wrapperName) {
          var functionName = innerType.displayName || innerType.name || '';
          return outerType.displayName || (functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName);
        }

        function getContextName(type) {
          return type.displayName || 'Context';
        }

        function getComponentName(type) {
          if (type == null) {
            // Host root, text node or just invalid type.
            return null;
          }

          {
            if (typeof type.tag === 'number') {
              error('Received an unexpected object in getComponentName(). ' + 'This is likely a bug in React. Please file an issue.');
            }
          }

          if (typeof type === 'function') {
            return type.displayName || type.name || null;
          }

          if (typeof type === 'string') {
            return type;
          }

          switch (type) {
            case REACT_FRAGMENT_TYPE:
              return 'Fragment';

            case REACT_PORTAL_TYPE:
              return 'Portal';

            case REACT_PROFILER_TYPE:
              return 'Profiler';

            case REACT_STRICT_MODE_TYPE:
              return 'StrictMode';

            case REACT_SUSPENSE_TYPE:
              return 'Suspense';

            case REACT_SUSPENSE_LIST_TYPE:
              return 'SuspenseList';
          }

          if (typeof type === 'object') {
            switch (type.$$typeof) {
              case REACT_CONTEXT_TYPE:
                var context = type;
                return getContextName(context) + '.Consumer';

              case REACT_PROVIDER_TYPE:
                var provider = type;
                return getContextName(provider._context) + '.Provider';

              case REACT_FORWARD_REF_TYPE:
                return getWrappedName(type, type.render, 'ForwardRef');

              case REACT_MEMO_TYPE:
                return getComponentName(type.type);

              case REACT_BLOCK_TYPE:
                return getComponentName(type._render);

              case REACT_LAZY_TYPE:
                {
                  var lazyComponent = type;
                  var payload = lazyComponent._payload;
                  var init = lazyComponent._init;

                  try {
                    return getComponentName(init(payload));
                  } catch (x) {
                    return null;
                  }
                }
            }
          }

          return null;
        }

        var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
        var current = null;
        var isRendering = false;

        function getCurrentFiberOwnerNameInDevOrNull() {
          {
            if (current === null) {
              return null;
            }

            var owner = current._debugOwner;

            if (owner !== null && typeof owner !== 'undefined') {
              return getComponentName(owner.type);
            }
          }
          return null;
        }

        function getCurrentFiberStackInDev() {
          {
            if (current === null) {
              return '';
            } // Safe because if current fiber exists, we are reconciling,
            // and it is guaranteed to be the work-in-progress version.


            return getStackByFiberInDevAndProd(current);
          }
        }

        function resetCurrentFiber() {
          {
            ReactDebugCurrentFrame.getCurrentStack = null;
            current = null;
            isRendering = false;
          }
        }

        function setCurrentFiber(fiber) {
          {
            ReactDebugCurrentFrame.getCurrentStack = getCurrentFiberStackInDev;
            current = fiber;
            isRendering = false;
          }
        }

        function setIsRendering(rendering) {
          {
            isRendering = rendering;
          }
        }

        function getIsRendering() {
          {
            return isRendering;
          }
        } // Flow does not allow string concatenation of most non-string types. To work
        // around this limitation, we use an opaque type that can only be obtained by
        // passing the value through getToStringValue first.


        function toString(value) {
          return '' + value;
        }

        function getToStringValue(value) {
          switch (typeof value) {
            case 'boolean':
            case 'number':
            case 'object':
            case 'string':
            case 'undefined':
              return value;

            default:
              // function, symbol are assigned as empty strings
              return '';
          }
        }

        var hasReadOnlyValue = {
          button: true,
          checkbox: true,
          image: true,
          hidden: true,
          radio: true,
          reset: true,
          submit: true
        };

        function checkControlledValueProps(tagName, props) {
          {
            if (!(hasReadOnlyValue[props.type] || props.onChange || props.onInput || props.readOnly || props.disabled || props.value == null)) {
              error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
            }

            if (!(props.onChange || props.readOnly || props.disabled || props.checked == null)) {
              error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
            }
          }
        }

        function isCheckable(elem) {
          var type = elem.type;
          var nodeName = elem.nodeName;
          return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
        }

        function getTracker(node) {
          return node._valueTracker;
        }

        function detachTracker(node) {
          node._valueTracker = null;
        }

        function getValueFromNode(node) {
          var value = '';

          if (!node) {
            return value;
          }

          if (isCheckable(node)) {
            value = node.checked ? 'true' : 'false';
          } else {
            value = node.value;
          }

          return value;
        }

        function trackValueOnNode(node) {
          var valueField = isCheckable(node) ? 'checked' : 'value';
          var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
          var currentValue = '' + node[valueField]; // if someone has already defined a value or Safari, then bail
          // and don't track value will cause over reporting of changes,
          // but it's better then a hard failure
          // (needed for certain tests that spyOn input values and Safari)

          if (node.hasOwnProperty(valueField) || typeof descriptor === 'undefined' || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
            return;
          }

          var _get = descriptor.get,
              _set = descriptor.set;
          Object.defineProperty(node, valueField, {
            configurable: true,
            get: function get() {
              return _get.call(this);
            },
            set: function set(value) {
              currentValue = '' + value;

              _set.call(this, value);
            }
          }); // We could've passed this the first time
          // but it triggers a bug in IE11 and Edge 14/15.
          // Calling defineProperty() again should be equivalent.
          // https://github.com/facebook/react/issues/11768

          Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
          });
          var tracker = {
            getValue: function getValue() {
              return currentValue;
            },
            setValue: function setValue(value) {
              currentValue = '' + value;
            },
            stopTracking: function stopTracking() {
              detachTracker(node);
              delete node[valueField];
            }
          };
          return tracker;
        }

        function track(node) {
          if (getTracker(node)) {
            return;
          } // TODO: Once it's just Fiber we can move this to node._wrapperState


          node._valueTracker = trackValueOnNode(node);
        }

        function updateValueIfChanged(node) {
          if (!node) {
            return false;
          }

          var tracker = getTracker(node); // if there is no tracker at this point it's unlikely
          // that trying again will succeed

          if (!tracker) {
            return true;
          }

          var lastValue = tracker.getValue();
          var nextValue = getValueFromNode(node);

          if (nextValue !== lastValue) {
            tracker.setValue(nextValue);
            return true;
          }

          return false;
        }

        function getActiveElement(doc) {
          doc = doc || (typeof document !== 'undefined' ? document : undefined);

          if (typeof doc === 'undefined') {
            return null;
          }

          try {
            return doc.activeElement || doc.body;
          } catch (e) {
            return doc.body;
          }
        }

        var didWarnValueDefaultValue = false;
        var didWarnCheckedDefaultChecked = false;
        var didWarnControlledToUncontrolled = false;
        var didWarnUncontrolledToControlled = false;

        function isControlled(props) {
          var usesChecked = props.type === 'checkbox' || props.type === 'radio';
          return usesChecked ? props.checked != null : props.value != null;
        }
        /**
         * Implements an <input> host component that allows setting these optional
         * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
         *
         * If `checked` or `value` are not supplied (or null/undefined), user actions
         * that affect the checked state or value will trigger updates to the element.
         *
         * If they are supplied (and not null/undefined), the rendered element will not
         * trigger updates to the element. Instead, the props must change in order for
         * the rendered element to be updated.
         *
         * The rendered element will be initialized as unchecked (or `defaultChecked`)
         * with an empty value (or `defaultValue`).
         *
         * See http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
         */


        function getHostProps(element, props) {
          var node = element;
          var checked = props.checked;

          var hostProps = _assign({}, props, {
            defaultChecked: undefined,
            defaultValue: undefined,
            value: undefined,
            checked: checked != null ? checked : node._wrapperState.initialChecked
          });

          return hostProps;
        }

        function initWrapperState(element, props) {
          {
            checkControlledValueProps('input', props);

            if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
              error('%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://reactjs.org/link/controlled-components', getCurrentFiberOwnerNameInDevOrNull() || 'A component', props.type);
              didWarnCheckedDefaultChecked = true;
            }

            if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
              error('%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://reactjs.org/link/controlled-components', getCurrentFiberOwnerNameInDevOrNull() || 'A component', props.type);
              didWarnValueDefaultValue = true;
            }
          }
          var node = element;
          var defaultValue = props.defaultValue == null ? '' : props.defaultValue;
          node._wrapperState = {
            initialChecked: props.checked != null ? props.checked : props.defaultChecked,
            initialValue: getToStringValue(props.value != null ? props.value : defaultValue),
            controlled: isControlled(props)
          };
        }

        function updateChecked(element, props) {
          var node = element;
          var checked = props.checked;

          if (checked != null) {
            setValueForProperty(node, 'checked', checked, false);
          }
        }

        function updateWrapper(element, props) {
          var node = element;
          {
            var controlled = isControlled(props);

            if (!node._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
              error('A component is changing an uncontrolled input to be controlled. ' + 'This is likely caused by the value changing from undefined to ' + 'a defined value, which should not happen. ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components');
              didWarnUncontrolledToControlled = true;
            }

            if (node._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
              error('A component is changing a controlled input to be uncontrolled. ' + 'This is likely caused by the value changing from a defined to ' + 'undefined, which should not happen. ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components');
              didWarnControlledToUncontrolled = true;
            }
          }
          updateChecked(element, props);
          var value = getToStringValue(props.value);
          var type = props.type;

          if (value != null) {
            if (type === 'number') {
              if (value === 0 && node.value === '' || // We explicitly want to coerce to number here if possible.
              // eslint-disable-next-line
              node.value != value) {
                node.value = toString(value);
              }
            } else if (node.value !== toString(value)) {
              node.value = toString(value);
            }
          } else if (type === 'submit' || type === 'reset') {
            // Submit/reset inputs need the attribute removed completely to avoid
            // blank-text buttons.
            node.removeAttribute('value');
            return;
          }

          {
            // When syncing the value attribute, the value comes from a cascade of
            // properties:
            //  1. The value React property
            //  2. The defaultValue React property
            //  3. Otherwise there should be no change
            if (props.hasOwnProperty('value')) {
              setDefaultValue(node, props.type, value);
            } else if (props.hasOwnProperty('defaultValue')) {
              setDefaultValue(node, props.type, getToStringValue(props.defaultValue));
            }
          }
          {
            // When syncing the checked attribute, it only changes when it needs
            // to be removed, such as transitioning from a checkbox into a text input
            if (props.checked == null && props.defaultChecked != null) {
              node.defaultChecked = !!props.defaultChecked;
            }
          }
        }

        function postMountWrapper(element, props, isHydrating) {
          var node = element; // Do not assign value if it is already set. This prevents user text input
          // from being lost during SSR hydration.

          if (props.hasOwnProperty('value') || props.hasOwnProperty('defaultValue')) {
            var type = props.type;
            var isButton = type === 'submit' || type === 'reset'; // Avoid setting value attribute on submit/reset inputs as it overrides the
            // default value provided by the browser. See: #12872

            if (isButton && (props.value === undefined || props.value === null)) {
              return;
            }

            var initialValue = toString(node._wrapperState.initialValue); // Do not assign value if it is already set. This prevents user text input
            // from being lost during SSR hydration.

            if (!isHydrating) {
              {
                // When syncing the value attribute, the value property should use
                // the wrapperState._initialValue property. This uses:
                //
                //   1. The value React property when present
                //   2. The defaultValue React property when present
                //   3. An empty string
                if (initialValue !== node.value) {
                  node.value = initialValue;
                }
              }
            }

            {
              // Otherwise, the value attribute is synchronized to the property,
              // so we assign defaultValue to the same thing as the value property
              // assignment step above.
              node.defaultValue = initialValue;
            }
          } // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
          // this is needed to work around a chrome bug where setting defaultChecked
          // will sometimes influence the value of checked (even after detachment).
          // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
          // We need to temporarily unset name to avoid disrupting radio button groups.


          var name = node.name;

          if (name !== '') {
            node.name = '';
          }

          {
            // When syncing the checked attribute, both the checked property and
            // attribute are assigned at the same time using defaultChecked. This uses:
            //
            //   1. The checked React property when present
            //   2. The defaultChecked React property when present
            //   3. Otherwise, false
            node.defaultChecked = !node.defaultChecked;
            node.defaultChecked = !!node._wrapperState.initialChecked;
          }

          if (name !== '') {
            node.name = name;
          }
        }

        function restoreControlledState(element, props) {
          var node = element;
          updateWrapper(node, props);
          updateNamedCousins(node, props);
        }

        function updateNamedCousins(rootNode, props) {
          var name = props.name;

          if (props.type === 'radio' && name != null) {
            var queryRoot = rootNode;

            while (queryRoot.parentNode) {
              queryRoot = queryRoot.parentNode;
            } // If `rootNode.form` was non-null, then we could try `form.elements`,
            // but that sometimes behaves strangely in IE8. We could also try using
            // `form.getElementsByName`, but that will only return direct children
            // and won't include inputs that use the HTML5 `form=` attribute. Since
            // the input might not even be in a form. It might not even be in the
            // document. Let's just use the local `querySelectorAll` to ensure we don't
            // miss anything.


            var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');

            for (var i = 0; i < group.length; i++) {
              var otherNode = group[i];

              if (otherNode === rootNode || otherNode.form !== rootNode.form) {
                continue;
              } // This will throw if radio buttons rendered by different copies of React
              // and the same name are rendered into the same form (same as #1939).
              // That's probably okay; we don't support it just as we don't support
              // mixing React radio buttons with non-React ones.


              var otherProps = getFiberCurrentPropsFromNode(otherNode);

              if (!otherProps) {
                {
                  throw Error("ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.");
                }
              } // We need update the tracked value on the named cousin since the value
              // was changed but the input saw no event or value set


              updateValueIfChanged(otherNode); // If this is a controlled radio button group, forcing the input that
              // was previously checked to update will cause it to be come re-checked
              // as appropriate.

              updateWrapper(otherNode, otherProps);
            }
          }
        } // In Chrome, assigning defaultValue to certain input types triggers input validation.
        // For number inputs, the display value loses trailing decimal points. For email inputs,
        // Chrome raises "The specified value <x> is not a valid email address".
        //
        // Here we check to see if the defaultValue has actually changed, avoiding these problems
        // when the user is inputting text
        //
        // https://github.com/facebook/react/issues/7253


        function setDefaultValue(node, type, value) {
          if ( // Focused number inputs synchronize on blur. See ChangeEventPlugin.js
          type !== 'number' || getActiveElement(node.ownerDocument) !== node) {
            if (value == null) {
              node.defaultValue = toString(node._wrapperState.initialValue);
            } else if (node.defaultValue !== toString(value)) {
              node.defaultValue = toString(value);
            }
          }
        }

        var didWarnSelectedSetOnOption = false;
        var didWarnInvalidChild = false;

        function flattenChildren(children) {
          var content = ''; // Flatten children. We'll warn if they are invalid
          // during validateProps() which runs for hydration too.
          // Note that this would throw on non-element objects.
          // Elements are stringified (which is normally irrelevant
          // but matters for <fbt>).

          React.Children.forEach(children, function (child) {
            if (child == null) {
              return;
            }

            content += child; // Note: we don't warn about invalid children here.
            // Instead, this is done separately below so that
            // it happens during the hydration code path too.
          });
          return content;
        }
        /**
         * Implements an <option> host component that warns when `selected` is set.
         */


        function validateProps(element, props) {
          {
            // This mirrors the code path above, but runs for hydration too.
            // Warn about invalid children here so that client and hydration are consistent.
            // TODO: this seems like it could cause a DEV-only throw for hydration
            // if children contains a non-element object. We should try to avoid that.
            if (typeof props.children === 'object' && props.children !== null) {
              React.Children.forEach(props.children, function (child) {
                if (child == null) {
                  return;
                }

                if (typeof child === 'string' || typeof child === 'number') {
                  return;
                }

                if (typeof child.type !== 'string') {
                  return;
                }

                if (!didWarnInvalidChild) {
                  didWarnInvalidChild = true;
                  error('Only strings and numbers are supported as <option> children.');
                }
              });
            } // TODO: Remove support for `selected` in <option>.


            if (props.selected != null && !didWarnSelectedSetOnOption) {
              error('Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.');
              didWarnSelectedSetOnOption = true;
            }
          }
        }

        function postMountWrapper$1(element, props) {
          // value="" should make a value attribute (#6219)
          if (props.value != null) {
            element.setAttribute('value', toString(getToStringValue(props.value)));
          }
        }

        function getHostProps$1(element, props) {
          var hostProps = _assign({
            children: undefined
          }, props);

          var content = flattenChildren(props.children);

          if (content) {
            hostProps.children = content;
          }

          return hostProps;
        }

        var didWarnValueDefaultValue$1;
        {
          didWarnValueDefaultValue$1 = false;
        }

        function getDeclarationErrorAddendum() {
          var ownerName = getCurrentFiberOwnerNameInDevOrNull();

          if (ownerName) {
            return '\n\nCheck the render method of `' + ownerName + '`.';
          }

          return '';
        }

        var valuePropNames = ['value', 'defaultValue'];
        /**
         * Validation function for `value` and `defaultValue`.
         */

        function checkSelectPropTypes(props) {
          {
            checkControlledValueProps('select', props);

            for (var i = 0; i < valuePropNames.length; i++) {
              var propName = valuePropNames[i];

              if (props[propName] == null) {
                continue;
              }

              var isArray = Array.isArray(props[propName]);

              if (props.multiple && !isArray) {
                error('The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum());
              } else if (!props.multiple && isArray) {
                error('The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum());
              }
            }
          }
        }

        function updateOptions(node, multiple, propValue, setDefaultSelected) {
          var options = node.options;

          if (multiple) {
            var selectedValues = propValue;
            var selectedValue = {};

            for (var i = 0; i < selectedValues.length; i++) {
              // Prefix to avoid chaos with special keys.
              selectedValue['$' + selectedValues[i]] = true;
            }

            for (var _i = 0; _i < options.length; _i++) {
              var selected = selectedValue.hasOwnProperty('$' + options[_i].value);

              if (options[_i].selected !== selected) {
                options[_i].selected = selected;
              }

              if (selected && setDefaultSelected) {
                options[_i].defaultSelected = true;
              }
            }
          } else {
            // Do not set `select.value` as exact behavior isn't consistent across all
            // browsers for all cases.
            var _selectedValue = toString(getToStringValue(propValue));

            var defaultSelected = null;

            for (var _i2 = 0; _i2 < options.length; _i2++) {
              if (options[_i2].value === _selectedValue) {
                options[_i2].selected = true;

                if (setDefaultSelected) {
                  options[_i2].defaultSelected = true;
                }

                return;
              }

              if (defaultSelected === null && !options[_i2].disabled) {
                defaultSelected = options[_i2];
              }
            }

            if (defaultSelected !== null) {
              defaultSelected.selected = true;
            }
          }
        }
        /**
         * Implements a <select> host component that allows optionally setting the
         * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
         * stringable. If `multiple` is true, the prop must be an array of stringables.
         *
         * If `value` is not supplied (or null/undefined), user actions that change the
         * selected option will trigger updates to the rendered options.
         *
         * If it is supplied (and not null/undefined), the rendered options will not
         * update in response to user actions. Instead, the `value` prop must change in
         * order for the rendered options to update.
         *
         * If `defaultValue` is provided, any options with the supplied values will be
         * selected.
         */


        function getHostProps$2(element, props) {
          return _assign({}, props, {
            value: undefined
          });
        }

        function initWrapperState$1(element, props) {
          var node = element;
          {
            checkSelectPropTypes(props);
          }
          node._wrapperState = {
            wasMultiple: !!props.multiple
          };
          {
            if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue$1) {
              error('Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://reactjs.org/link/controlled-components');
              didWarnValueDefaultValue$1 = true;
            }
          }
        }

        function postMountWrapper$2(element, props) {
          var node = element;
          node.multiple = !!props.multiple;
          var value = props.value;

          if (value != null) {
            updateOptions(node, !!props.multiple, value, false);
          } else if (props.defaultValue != null) {
            updateOptions(node, !!props.multiple, props.defaultValue, true);
          }
        }

        function postUpdateWrapper(element, props) {
          var node = element;
          var wasMultiple = node._wrapperState.wasMultiple;
          node._wrapperState.wasMultiple = !!props.multiple;
          var value = props.value;

          if (value != null) {
            updateOptions(node, !!props.multiple, value, false);
          } else if (wasMultiple !== !!props.multiple) {
            // For simplicity, reapply `defaultValue` if `multiple` is toggled.
            if (props.defaultValue != null) {
              updateOptions(node, !!props.multiple, props.defaultValue, true);
            } else {
              // Revert the select back to its default unselected state.
              updateOptions(node, !!props.multiple, props.multiple ? [] : '', false);
            }
          }
        }

        function restoreControlledState$1(element, props) {
          var node = element;
          var value = props.value;

          if (value != null) {
            updateOptions(node, !!props.multiple, value, false);
          }
        }

        var didWarnValDefaultVal = false;
        /**
         * Implements a <textarea> host component that allows setting `value`, and
         * `defaultValue`. This differs from the traditional DOM API because value is
         * usually set as PCDATA children.
         *
         * If `value` is not supplied (or null/undefined), user actions that affect the
         * value will trigger updates to the element.
         *
         * If `value` is supplied (and not null/undefined), the rendered element will
         * not trigger updates to the element. Instead, the `value` prop must change in
         * order for the rendered element to be updated.
         *
         * The rendered element will be initialized with an empty value, the prop
         * `defaultValue` if specified, or the children content (deprecated).
         */

        function getHostProps$3(element, props) {
          var node = element;

          if (!(props.dangerouslySetInnerHTML == null)) {
            {
              throw Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
            }
          } // Always set children to the same thing. In IE9, the selection range will
          // get reset if `textContent` is mutated.  We could add a check in setTextContent
          // to only set the value if/when the value differs from the node value (which would
          // completely solve this IE9 bug), but Sebastian+Sophie seemed to like this
          // solution. The value can be a boolean or object so that's why it's forced
          // to be a string.


          var hostProps = _assign({}, props, {
            value: undefined,
            defaultValue: undefined,
            children: toString(node._wrapperState.initialValue)
          });

          return hostProps;
        }

        function initWrapperState$2(element, props) {
          var node = element;
          {
            checkControlledValueProps('textarea', props);

            if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
              error('%s contains a textarea with both value and defaultValue props. ' + 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://reactjs.org/link/controlled-components', getCurrentFiberOwnerNameInDevOrNull() || 'A component');
              didWarnValDefaultVal = true;
            }
          }
          var initialValue = props.value; // Only bother fetching default value if we're going to use it

          if (initialValue == null) {
            var children = props.children,
                defaultValue = props.defaultValue;

            if (children != null) {
              {
                error('Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.');
              }
              {
                if (!(defaultValue == null)) {
                  {
                    throw Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
                  }
                }

                if (Array.isArray(children)) {
                  if (!(children.length <= 1)) {
                    {
                      throw Error("<textarea> can only have at most one child.");
                    }
                  }

                  children = children[0];
                }

                defaultValue = children;
              }
            }

            if (defaultValue == null) {
              defaultValue = '';
            }

            initialValue = defaultValue;
          }

          node._wrapperState = {
            initialValue: getToStringValue(initialValue)
          };
        }

        function updateWrapper$1(element, props) {
          var node = element;
          var value = getToStringValue(props.value);
          var defaultValue = getToStringValue(props.defaultValue);

          if (value != null) {
            // Cast `value` to a string to ensure the value is set correctly. While
            // browsers typically do this as necessary, jsdom doesn't.
            var newValue = toString(value); // To avoid side effects (such as losing text selection), only set value if changed

            if (newValue !== node.value) {
              node.value = newValue;
            }

            if (props.defaultValue == null && node.defaultValue !== newValue) {
              node.defaultValue = newValue;
            }
          }

          if (defaultValue != null) {
            node.defaultValue = toString(defaultValue);
          }
        }

        function postMountWrapper$3(element, props) {
          var node = element; // This is in postMount because we need access to the DOM node, which is not
          // available until after the component has mounted.

          var textContent = node.textContent; // Only set node.value if textContent is equal to the expected
          // initial value. In IE10/IE11 there is a bug where the placeholder attribute
          // will populate textContent as well.
          // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/

          if (textContent === node._wrapperState.initialValue) {
            if (textContent !== '' && textContent !== null) {
              node.value = textContent;
            }
          }
        }

        function restoreControlledState$2(element, props) {
          // DOM component is still mounted; update
          updateWrapper$1(element, props);
        }

        var HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
        var MATH_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
        var SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
        var Namespaces = {
          html: HTML_NAMESPACE,
          mathml: MATH_NAMESPACE,
          svg: SVG_NAMESPACE
        }; // Assumes there is no parent namespace.

        function getIntrinsicNamespace(type) {
          switch (type) {
            case 'svg':
              return SVG_NAMESPACE;

            case 'math':
              return MATH_NAMESPACE;

            default:
              return HTML_NAMESPACE;
          }
        }

        function getChildNamespace(parentNamespace, type) {
          if (parentNamespace == null || parentNamespace === HTML_NAMESPACE) {
            // No (or default) parent namespace: potential entry point.
            return getIntrinsicNamespace(type);
          }

          if (parentNamespace === SVG_NAMESPACE && type === 'foreignObject') {
            // We're leaving SVG.
            return HTML_NAMESPACE;
          } // By default, pass namespace below.


          return parentNamespace;
        }
        /* globals MSApp */

        /**
         * Create a function which has 'unsafe' privileges (required by windows8 apps)
         */


        var createMicrosoftUnsafeLocalFunction = function createMicrosoftUnsafeLocalFunction(func) {
          if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
            return function (arg0, arg1, arg2, arg3) {
              MSApp.execUnsafeLocalFunction(function () {
                return func(arg0, arg1, arg2, arg3);
              });
            };
          } else {
            return func;
          }
        };

        var reusableSVGContainer;
        /**
         * Set the innerHTML property of a node
         *
         * @param {DOMElement} node
         * @param {string} html
         * @internal
         */

        var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
          if (node.namespaceURI === Namespaces.svg) {
            if (!('innerHTML' in node)) {
              // IE does not have innerHTML for SVG nodes, so instead we inject the
              // new markup in a temp node and then move the child nodes across into
              // the target node
              reusableSVGContainer = reusableSVGContainer || document.createElement('div');
              reusableSVGContainer.innerHTML = '<svg>' + html.valueOf().toString() + '</svg>';
              var svgNode = reusableSVGContainer.firstChild;

              while (node.firstChild) {
                node.removeChild(node.firstChild);
              }

              while (svgNode.firstChild) {
                node.appendChild(svgNode.firstChild);
              }

              return;
            }
          }

          node.innerHTML = html;
        });
        /**
         * HTML nodeType values that represent the type of the node
         */

        var ELEMENT_NODE = 1;
        var TEXT_NODE = 3;
        var COMMENT_NODE = 8;
        var DOCUMENT_NODE = 9;
        var DOCUMENT_FRAGMENT_NODE = 11;
        /**
         * Set the textContent property of a node. For text updates, it's faster
         * to set the `nodeValue` of the Text node directly instead of using
         * `.textContent` which will remove the existing node and create a new one.
         *
         * @param {DOMElement} node
         * @param {string} text
         * @internal
         */

        var setTextContent = function setTextContent(node, text) {
          if (text) {
            var firstChild = node.firstChild;

            if (firstChild && firstChild === node.lastChild && firstChild.nodeType === TEXT_NODE) {
              firstChild.nodeValue = text;
              return;
            }
          }

          node.textContent = text;
        }; // List derived from Gecko source code:
        // https://github.com/mozilla/gecko-dev/blob/4e638efc71/layout/style/test/property_database.js


        var shorthandToLonghand = {
          animation: ['animationDelay', 'animationDirection', 'animationDuration', 'animationFillMode', 'animationIterationCount', 'animationName', 'animationPlayState', 'animationTimingFunction'],
          background: ['backgroundAttachment', 'backgroundClip', 'backgroundColor', 'backgroundImage', 'backgroundOrigin', 'backgroundPositionX', 'backgroundPositionY', 'backgroundRepeat', 'backgroundSize'],
          backgroundPosition: ['backgroundPositionX', 'backgroundPositionY'],
          border: ['borderBottomColor', 'borderBottomStyle', 'borderBottomWidth', 'borderImageOutset', 'borderImageRepeat', 'borderImageSlice', 'borderImageSource', 'borderImageWidth', 'borderLeftColor', 'borderLeftStyle', 'borderLeftWidth', 'borderRightColor', 'borderRightStyle', 'borderRightWidth', 'borderTopColor', 'borderTopStyle', 'borderTopWidth'],
          borderBlockEnd: ['borderBlockEndColor', 'borderBlockEndStyle', 'borderBlockEndWidth'],
          borderBlockStart: ['borderBlockStartColor', 'borderBlockStartStyle', 'borderBlockStartWidth'],
          borderBottom: ['borderBottomColor', 'borderBottomStyle', 'borderBottomWidth'],
          borderColor: ['borderBottomColor', 'borderLeftColor', 'borderRightColor', 'borderTopColor'],
          borderImage: ['borderImageOutset', 'borderImageRepeat', 'borderImageSlice', 'borderImageSource', 'borderImageWidth'],
          borderInlineEnd: ['borderInlineEndColor', 'borderInlineEndStyle', 'borderInlineEndWidth'],
          borderInlineStart: ['borderInlineStartColor', 'borderInlineStartStyle', 'borderInlineStartWidth'],
          borderLeft: ['borderLeftColor', 'borderLeftStyle', 'borderLeftWidth'],
          borderRadius: ['borderBottomLeftRadius', 'borderBottomRightRadius', 'borderTopLeftRadius', 'borderTopRightRadius'],
          borderRight: ['borderRightColor', 'borderRightStyle', 'borderRightWidth'],
          borderStyle: ['borderBottomStyle', 'borderLeftStyle', 'borderRightStyle', 'borderTopStyle'],
          borderTop: ['borderTopColor', 'borderTopStyle', 'borderTopWidth'],
          borderWidth: ['borderBottomWidth', 'borderLeftWidth', 'borderRightWidth', 'borderTopWidth'],
          columnRule: ['columnRuleColor', 'columnRuleStyle', 'columnRuleWidth'],
          columns: ['columnCount', 'columnWidth'],
          flex: ['flexBasis', 'flexGrow', 'flexShrink'],
          flexFlow: ['flexDirection', 'flexWrap'],
          font: ['fontFamily', 'fontFeatureSettings', 'fontKerning', 'fontLanguageOverride', 'fontSize', 'fontSizeAdjust', 'fontStretch', 'fontStyle', 'fontVariant', 'fontVariantAlternates', 'fontVariantCaps', 'fontVariantEastAsian', 'fontVariantLigatures', 'fontVariantNumeric', 'fontVariantPosition', 'fontWeight', 'lineHeight'],
          fontVariant: ['fontVariantAlternates', 'fontVariantCaps', 'fontVariantEastAsian', 'fontVariantLigatures', 'fontVariantNumeric', 'fontVariantPosition'],
          gap: ['columnGap', 'rowGap'],
          grid: ['gridAutoColumns', 'gridAutoFlow', 'gridAutoRows', 'gridTemplateAreas', 'gridTemplateColumns', 'gridTemplateRows'],
          gridArea: ['gridColumnEnd', 'gridColumnStart', 'gridRowEnd', 'gridRowStart'],
          gridColumn: ['gridColumnEnd', 'gridColumnStart'],
          gridColumnGap: ['columnGap'],
          gridGap: ['columnGap', 'rowGap'],
          gridRow: ['gridRowEnd', 'gridRowStart'],
          gridRowGap: ['rowGap'],
          gridTemplate: ['gridTemplateAreas', 'gridTemplateColumns', 'gridTemplateRows'],
          listStyle: ['listStyleImage', 'listStylePosition', 'listStyleType'],
          margin: ['marginBottom', 'marginLeft', 'marginRight', 'marginTop'],
          marker: ['markerEnd', 'markerMid', 'markerStart'],
          mask: ['maskClip', 'maskComposite', 'maskImage', 'maskMode', 'maskOrigin', 'maskPositionX', 'maskPositionY', 'maskRepeat', 'maskSize'],
          maskPosition: ['maskPositionX', 'maskPositionY'],
          outline: ['outlineColor', 'outlineStyle', 'outlineWidth'],
          overflow: ['overflowX', 'overflowY'],
          padding: ['paddingBottom', 'paddingLeft', 'paddingRight', 'paddingTop'],
          placeContent: ['alignContent', 'justifyContent'],
          placeItems: ['alignItems', 'justifyItems'],
          placeSelf: ['alignSelf', 'justifySelf'],
          textDecoration: ['textDecorationColor', 'textDecorationLine', 'textDecorationStyle'],
          textEmphasis: ['textEmphasisColor', 'textEmphasisStyle'],
          transition: ['transitionDelay', 'transitionDuration', 'transitionProperty', 'transitionTimingFunction'],
          wordWrap: ['overflowWrap']
        };
        /**
         * CSS properties which accept numbers but are not in units of "px".
         */

        var isUnitlessNumber = {
          animationIterationCount: true,
          borderImageOutset: true,
          borderImageSlice: true,
          borderImageWidth: true,
          boxFlex: true,
          boxFlexGroup: true,
          boxOrdinalGroup: true,
          columnCount: true,
          columns: true,
          flex: true,
          flexGrow: true,
          flexPositive: true,
          flexShrink: true,
          flexNegative: true,
          flexOrder: true,
          gridArea: true,
          gridRow: true,
          gridRowEnd: true,
          gridRowSpan: true,
          gridRowStart: true,
          gridColumn: true,
          gridColumnEnd: true,
          gridColumnSpan: true,
          gridColumnStart: true,
          fontWeight: true,
          lineClamp: true,
          lineHeight: true,
          opacity: true,
          order: true,
          orphans: true,
          tabSize: true,
          widows: true,
          zIndex: true,
          zoom: true,
          // SVG-related properties
          fillOpacity: true,
          floodOpacity: true,
          stopOpacity: true,
          strokeDasharray: true,
          strokeDashoffset: true,
          strokeMiterlimit: true,
          strokeOpacity: true,
          strokeWidth: true
        };
        /**
         * @param {string} prefix vendor-specific prefix, eg: Webkit
         * @param {string} key style name, eg: transitionDuration
         * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
         * WebkitTransitionDuration
         */

        function prefixKey(prefix, key) {
          return prefix + key.charAt(0).toUpperCase() + key.substring(1);
        }
        /**
         * Support style names that may come passed in prefixed by adding permutations
         * of vendor prefixes.
         */


        var prefixes = ['Webkit', 'ms', 'Moz', 'O']; // Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
        // infinite loop, because it iterates over the newly added props too.

        Object.keys(isUnitlessNumber).forEach(function (prop) {
          prefixes.forEach(function (prefix) {
            isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
          });
        });
        /**
         * Convert a value into the proper css writable value. The style name `name`
         * should be logical (no hyphens), as specified
         * in `CSSProperty.isUnitlessNumber`.
         *
         * @param {string} name CSS property name such as `topMargin`.
         * @param {*} value CSS property value such as `10px`.
         * @return {string} Normalized style value with dimensions applied.
         */

        function dangerousStyleValue(name, value, isCustomProperty) {
          // Note that we've removed escapeTextForBrowser() calls here since the
          // whole string will be escaped when the attribute is injected into
          // the markup. If you provide unsafe user data here they can inject
          // arbitrary CSS which may be problematic (I couldn't repro this):
          // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
          // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
          // This is not an XSS hole but instead a potential CSS injection issue
          // which has lead to a greater discussion about how we're going to
          // trust URLs moving forward. See #2115901
          var isEmpty = value == null || typeof value === 'boolean' || value === '';

          if (isEmpty) {
            return '';
          }

          if (!isCustomProperty && typeof value === 'number' && value !== 0 && !(isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name])) {
            return value + 'px'; // Presumes implicit 'px' suffix for unitless numbers
          }

          return ('' + value).trim();
        }

        var uppercasePattern = /([A-Z])/g;
        var msPattern = /^ms-/;
        /**
         * Hyphenates a camelcased CSS property name, for example:
         *
         *   > hyphenateStyleName('backgroundColor')
         *   < "background-color"
         *   > hyphenateStyleName('MozTransition')
         *   < "-moz-transition"
         *   > hyphenateStyleName('msTransition')
         *   < "-ms-transition"
         *
         * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
         * is converted to `-ms-`.
         */

        function hyphenateStyleName(name) {
          return name.replace(uppercasePattern, '-$1').toLowerCase().replace(msPattern, '-ms-');
        }

        var warnValidStyle = function warnValidStyle() {};

        {
          // 'msTransform' is correct, but the other prefixes should be capitalized
          var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
          var msPattern$1 = /^-ms-/;
          var hyphenPattern = /-(.)/g; // style values shouldn't contain a semicolon

          var badStyleValueWithSemicolonPattern = /;\s*$/;
          var warnedStyleNames = {};
          var warnedStyleValues = {};
          var warnedForNaNValue = false;
          var warnedForInfinityValue = false;

          var camelize = function camelize(string) {
            return string.replace(hyphenPattern, function (_, character) {
              return character.toUpperCase();
            });
          };

          var warnHyphenatedStyleName = function warnHyphenatedStyleName(name) {
            if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
              return;
            }

            warnedStyleNames[name] = true;
            error('Unsupported style property %s. Did you mean %s?', name, // As Andi Smith suggests
            // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
            // is converted to lowercase `ms`.
            camelize(name.replace(msPattern$1, 'ms-')));
          };

          var warnBadVendoredStyleName = function warnBadVendoredStyleName(name) {
            if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
              return;
            }

            warnedStyleNames[name] = true;
            error('Unsupported vendor-prefixed style property %s. Did you mean %s?', name, name.charAt(0).toUpperCase() + name.slice(1));
          };

          var warnStyleValueWithSemicolon = function warnStyleValueWithSemicolon(name, value) {
            if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
              return;
            }

            warnedStyleValues[value] = true;
            error("Style property values shouldn't contain a semicolon. " + 'Try "%s: %s" instead.', name, value.replace(badStyleValueWithSemicolonPattern, ''));
          };

          var warnStyleValueIsNaN = function warnStyleValueIsNaN(name, value) {
            if (warnedForNaNValue) {
              return;
            }

            warnedForNaNValue = true;
            error('`NaN` is an invalid value for the `%s` css style property.', name);
          };

          var warnStyleValueIsInfinity = function warnStyleValueIsInfinity(name, value) {
            if (warnedForInfinityValue) {
              return;
            }

            warnedForInfinityValue = true;
            error('`Infinity` is an invalid value for the `%s` css style property.', name);
          };

          warnValidStyle = function warnValidStyle(name, value) {
            if (name.indexOf('-') > -1) {
              warnHyphenatedStyleName(name);
            } else if (badVendoredStyleNamePattern.test(name)) {
              warnBadVendoredStyleName(name);
            } else if (badStyleValueWithSemicolonPattern.test(value)) {
              warnStyleValueWithSemicolon(name, value);
            }

            if (typeof value === 'number') {
              if (isNaN(value)) {
                warnStyleValueIsNaN(name, value);
              } else if (!isFinite(value)) {
                warnStyleValueIsInfinity(name, value);
              }
            }
          };
        }
        var warnValidStyle$1 = warnValidStyle;
        /**
         * Operations for dealing with CSS properties.
         */

        /**
         * This creates a string that is expected to be equivalent to the style
         * attribute generated by server-side rendering. It by-passes warnings and
         * security checks so it's not safe to use this value for anything other than
         * comparison. It is only used in DEV for SSR validation.
         */

        function createDangerousStringForStyles(styles) {
          {
            var serialized = '';
            var delimiter = '';

            for (var styleName in styles) {
              if (!styles.hasOwnProperty(styleName)) {
                continue;
              }

              var styleValue = styles[styleName];

              if (styleValue != null) {
                var isCustomProperty = styleName.indexOf('--') === 0;
                serialized += delimiter + (isCustomProperty ? styleName : hyphenateStyleName(styleName)) + ':';
                serialized += dangerousStyleValue(styleName, styleValue, isCustomProperty);
                delimiter = ';';
              }
            }

            return serialized || null;
          }
        }
        /**
         * Sets the value for multiple styles on a node.  If a value is specified as
         * '' (empty string), the corresponding style property will be unset.
         *
         * @param {DOMElement} node
         * @param {object} styles
         */


        function setValueForStyles(node, styles) {
          var style = node.style;

          for (var styleName in styles) {
            if (!styles.hasOwnProperty(styleName)) {
              continue;
            }

            var isCustomProperty = styleName.indexOf('--') === 0;
            {
              if (!isCustomProperty) {
                warnValidStyle$1(styleName, styles[styleName]);
              }
            }
            var styleValue = dangerousStyleValue(styleName, styles[styleName], isCustomProperty);

            if (styleName === 'float') {
              styleName = 'cssFloat';
            }

            if (isCustomProperty) {
              style.setProperty(styleName, styleValue);
            } else {
              style[styleName] = styleValue;
            }
          }
        }

        function isValueEmpty(value) {
          return value == null || typeof value === 'boolean' || value === '';
        }
        /**
         * Given {color: 'red', overflow: 'hidden'} returns {
         *   color: 'color',
         *   overflowX: 'overflow',
         *   overflowY: 'overflow',
         * }. This can be read as "the overflowY property was set by the overflow
         * shorthand". That is, the values are the property that each was derived from.
         */


        function expandShorthandMap(styles) {
          var expanded = {};

          for (var key in styles) {
            var longhands = shorthandToLonghand[key] || [key];

            for (var i = 0; i < longhands.length; i++) {
              expanded[longhands[i]] = key;
            }
          }

          return expanded;
        }
        /**
         * When mixing shorthand and longhand property names, we warn during updates if
         * we expect an incorrect result to occur. In particular, we warn for:
         *
         * Updating a shorthand property (longhand gets overwritten):
         *   {font: 'foo', fontVariant: 'bar'} -> {font: 'baz', fontVariant: 'bar'}
         *   becomes .style.font = 'baz'
         * Removing a shorthand property (longhand gets lost too):
         *   {font: 'foo', fontVariant: 'bar'} -> {fontVariant: 'bar'}
         *   becomes .style.font = ''
         * Removing a longhand property (should revert to shorthand; doesn't):
         *   {font: 'foo', fontVariant: 'bar'} -> {font: 'foo'}
         *   becomes .style.fontVariant = ''
         */


        function validateShorthandPropertyCollisionInDev(styleUpdates, nextStyles) {
          {
            if (!nextStyles) {
              return;
            }

            var expandedUpdates = expandShorthandMap(styleUpdates);
            var expandedStyles = expandShorthandMap(nextStyles);
            var warnedAbout = {};

            for (var key in expandedUpdates) {
              var originalKey = expandedUpdates[key];
              var correctOriginalKey = expandedStyles[key];

              if (correctOriginalKey && originalKey !== correctOriginalKey) {
                var warningKey = originalKey + ',' + correctOriginalKey;

                if (warnedAbout[warningKey]) {
                  continue;
                }

                warnedAbout[warningKey] = true;
                error('%s a style property during rerender (%s) when a ' + 'conflicting property is set (%s) can lead to styling bugs. To ' + "avoid this, don't mix shorthand and non-shorthand properties " + 'for the same value; instead, replace the shorthand with ' + 'separate values.', isValueEmpty(styleUpdates[originalKey]) ? 'Removing' : 'Updating', originalKey, correctOriginalKey);
              }
            }
          }
        } // For HTML, certain tags should omit their close tag. We keep a list for
        // those special-case tags.


        var omittedCloseTags = {
          area: true,
          base: true,
          br: true,
          col: true,
          embed: true,
          hr: true,
          img: true,
          input: true,
          keygen: true,
          link: true,
          meta: true,
          param: true,
          source: true,
          track: true,
          wbr: true // NOTE: menuitem's close tag should be omitted, but that causes problems.

        }; // `omittedCloseTags` except that `menuitem` should still have its closing tag.

        var voidElementTags = _assign({
          menuitem: true
        }, omittedCloseTags);

        var HTML = '__html';

        function assertValidProps(tag, props) {
          if (!props) {
            return;
          } // Note the use of `==` which checks for null or undefined.


          if (voidElementTags[tag]) {
            if (!(props.children == null && props.dangerouslySetInnerHTML == null)) {
              {
                throw Error(tag + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
              }
            }
          }

          if (props.dangerouslySetInnerHTML != null) {
            if (!(props.children == null)) {
              {
                throw Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
              }
            }

            if (!(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML)) {
              {
                throw Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
              }
            }
          }

          {
            if (!props.suppressContentEditableWarning && props.contentEditable && props.children != null) {
              error('A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.');
            }
          }

          if (!(props.style == null || typeof props.style === 'object')) {
            {
              throw Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
            }
          }
        }

        function isCustomComponent(tagName, props) {
          if (tagName.indexOf('-') === -1) {
            return typeof props.is === 'string';
          }

          switch (tagName) {
            // These are reserved SVG and MathML elements.
            // We don't mind this list too much because we expect it to never grow.
            // The alternative is to track the namespace in a few places which is convoluted.
            // https://w3c.github.io/webcomponents/spec/custom/#custom-elements-core-concepts
            case 'annotation-xml':
            case 'color-profile':
            case 'font-face':
            case 'font-face-src':
            case 'font-face-uri':
            case 'font-face-format':
            case 'font-face-name':
            case 'missing-glyph':
              return false;

            default:
              return true;
          }
        } // When adding attributes to the HTML or SVG allowed attribute list, be sure to
        // also add them to this module to ensure casing and incorrect name
        // warnings.


        var possibleStandardNames = {
          // HTML
          accept: 'accept',
          acceptcharset: 'acceptCharset',
          'accept-charset': 'acceptCharset',
          accesskey: 'accessKey',
          action: 'action',
          allowfullscreen: 'allowFullScreen',
          alt: 'alt',
          as: 'as',
          async: 'async',
          autocapitalize: 'autoCapitalize',
          autocomplete: 'autoComplete',
          autocorrect: 'autoCorrect',
          autofocus: 'autoFocus',
          autoplay: 'autoPlay',
          autosave: 'autoSave',
          capture: 'capture',
          cellpadding: 'cellPadding',
          cellspacing: 'cellSpacing',
          challenge: 'challenge',
          charset: 'charSet',
          checked: 'checked',
          children: 'children',
          cite: 'cite',
          class: 'className',
          classid: 'classID',
          classname: 'className',
          cols: 'cols',
          colspan: 'colSpan',
          content: 'content',
          contenteditable: 'contentEditable',
          contextmenu: 'contextMenu',
          controls: 'controls',
          controlslist: 'controlsList',
          coords: 'coords',
          crossorigin: 'crossOrigin',
          dangerouslysetinnerhtml: 'dangerouslySetInnerHTML',
          data: 'data',
          datetime: 'dateTime',
          default: 'default',
          defaultchecked: 'defaultChecked',
          defaultvalue: 'defaultValue',
          defer: 'defer',
          dir: 'dir',
          disabled: 'disabled',
          disablepictureinpicture: 'disablePictureInPicture',
          disableremoteplayback: 'disableRemotePlayback',
          download: 'download',
          draggable: 'draggable',
          enctype: 'encType',
          enterkeyhint: 'enterKeyHint',
          for: 'htmlFor',
          form: 'form',
          formmethod: 'formMethod',
          formaction: 'formAction',
          formenctype: 'formEncType',
          formnovalidate: 'formNoValidate',
          formtarget: 'formTarget',
          frameborder: 'frameBorder',
          headers: 'headers',
          height: 'height',
          hidden: 'hidden',
          high: 'high',
          href: 'href',
          hreflang: 'hrefLang',
          htmlfor: 'htmlFor',
          httpequiv: 'httpEquiv',
          'http-equiv': 'httpEquiv',
          icon: 'icon',
          id: 'id',
          innerhtml: 'innerHTML',
          inputmode: 'inputMode',
          integrity: 'integrity',
          is: 'is',
          itemid: 'itemID',
          itemprop: 'itemProp',
          itemref: 'itemRef',
          itemscope: 'itemScope',
          itemtype: 'itemType',
          keyparams: 'keyParams',
          keytype: 'keyType',
          kind: 'kind',
          label: 'label',
          lang: 'lang',
          list: 'list',
          loop: 'loop',
          low: 'low',
          manifest: 'manifest',
          marginwidth: 'marginWidth',
          marginheight: 'marginHeight',
          max: 'max',
          maxlength: 'maxLength',
          media: 'media',
          mediagroup: 'mediaGroup',
          method: 'method',
          min: 'min',
          minlength: 'minLength',
          multiple: 'multiple',
          muted: 'muted',
          name: 'name',
          nomodule: 'noModule',
          nonce: 'nonce',
          novalidate: 'noValidate',
          open: 'open',
          optimum: 'optimum',
          pattern: 'pattern',
          placeholder: 'placeholder',
          playsinline: 'playsInline',
          poster: 'poster',
          preload: 'preload',
          profile: 'profile',
          radiogroup: 'radioGroup',
          readonly: 'readOnly',
          referrerpolicy: 'referrerPolicy',
          rel: 'rel',
          required: 'required',
          reversed: 'reversed',
          role: 'role',
          rows: 'rows',
          rowspan: 'rowSpan',
          sandbox: 'sandbox',
          scope: 'scope',
          scoped: 'scoped',
          scrolling: 'scrolling',
          seamless: 'seamless',
          selected: 'selected',
          shape: 'shape',
          size: 'size',
          sizes: 'sizes',
          span: 'span',
          spellcheck: 'spellCheck',
          src: 'src',
          srcdoc: 'srcDoc',
          srclang: 'srcLang',
          srcset: 'srcSet',
          start: 'start',
          step: 'step',
          style: 'style',
          summary: 'summary',
          tabindex: 'tabIndex',
          target: 'target',
          title: 'title',
          type: 'type',
          usemap: 'useMap',
          value: 'value',
          width: 'width',
          wmode: 'wmode',
          wrap: 'wrap',
          // SVG
          about: 'about',
          accentheight: 'accentHeight',
          'accent-height': 'accentHeight',
          accumulate: 'accumulate',
          additive: 'additive',
          alignmentbaseline: 'alignmentBaseline',
          'alignment-baseline': 'alignmentBaseline',
          allowreorder: 'allowReorder',
          alphabetic: 'alphabetic',
          amplitude: 'amplitude',
          arabicform: 'arabicForm',
          'arabic-form': 'arabicForm',
          ascent: 'ascent',
          attributename: 'attributeName',
          attributetype: 'attributeType',
          autoreverse: 'autoReverse',
          azimuth: 'azimuth',
          basefrequency: 'baseFrequency',
          baselineshift: 'baselineShift',
          'baseline-shift': 'baselineShift',
          baseprofile: 'baseProfile',
          bbox: 'bbox',
          begin: 'begin',
          bias: 'bias',
          by: 'by',
          calcmode: 'calcMode',
          capheight: 'capHeight',
          'cap-height': 'capHeight',
          clip: 'clip',
          clippath: 'clipPath',
          'clip-path': 'clipPath',
          clippathunits: 'clipPathUnits',
          cliprule: 'clipRule',
          'clip-rule': 'clipRule',
          color: 'color',
          colorinterpolation: 'colorInterpolation',
          'color-interpolation': 'colorInterpolation',
          colorinterpolationfilters: 'colorInterpolationFilters',
          'color-interpolation-filters': 'colorInterpolationFilters',
          colorprofile: 'colorProfile',
          'color-profile': 'colorProfile',
          colorrendering: 'colorRendering',
          'color-rendering': 'colorRendering',
          contentscripttype: 'contentScriptType',
          contentstyletype: 'contentStyleType',
          cursor: 'cursor',
          cx: 'cx',
          cy: 'cy',
          d: 'd',
          datatype: 'datatype',
          decelerate: 'decelerate',
          descent: 'descent',
          diffuseconstant: 'diffuseConstant',
          direction: 'direction',
          display: 'display',
          divisor: 'divisor',
          dominantbaseline: 'dominantBaseline',
          'dominant-baseline': 'dominantBaseline',
          dur: 'dur',
          dx: 'dx',
          dy: 'dy',
          edgemode: 'edgeMode',
          elevation: 'elevation',
          enablebackground: 'enableBackground',
          'enable-background': 'enableBackground',
          end: 'end',
          exponent: 'exponent',
          externalresourcesrequired: 'externalResourcesRequired',
          fill: 'fill',
          fillopacity: 'fillOpacity',
          'fill-opacity': 'fillOpacity',
          fillrule: 'fillRule',
          'fill-rule': 'fillRule',
          filter: 'filter',
          filterres: 'filterRes',
          filterunits: 'filterUnits',
          floodopacity: 'floodOpacity',
          'flood-opacity': 'floodOpacity',
          floodcolor: 'floodColor',
          'flood-color': 'floodColor',
          focusable: 'focusable',
          fontfamily: 'fontFamily',
          'font-family': 'fontFamily',
          fontsize: 'fontSize',
          'font-size': 'fontSize',
          fontsizeadjust: 'fontSizeAdjust',
          'font-size-adjust': 'fontSizeAdjust',
          fontstretch: 'fontStretch',
          'font-stretch': 'fontStretch',
          fontstyle: 'fontStyle',
          'font-style': 'fontStyle',
          fontvariant: 'fontVariant',
          'font-variant': 'fontVariant',
          fontweight: 'fontWeight',
          'font-weight': 'fontWeight',
          format: 'format',
          from: 'from',
          fx: 'fx',
          fy: 'fy',
          g1: 'g1',
          g2: 'g2',
          glyphname: 'glyphName',
          'glyph-name': 'glyphName',
          glyphorientationhorizontal: 'glyphOrientationHorizontal',
          'glyph-orientation-horizontal': 'glyphOrientationHorizontal',
          glyphorientationvertical: 'glyphOrientationVertical',
          'glyph-orientation-vertical': 'glyphOrientationVertical',
          glyphref: 'glyphRef',
          gradienttransform: 'gradientTransform',
          gradientunits: 'gradientUnits',
          hanging: 'hanging',
          horizadvx: 'horizAdvX',
          'horiz-adv-x': 'horizAdvX',
          horizoriginx: 'horizOriginX',
          'horiz-origin-x': 'horizOriginX',
          ideographic: 'ideographic',
          imagerendering: 'imageRendering',
          'image-rendering': 'imageRendering',
          in2: 'in2',
          in: 'in',
          inlist: 'inlist',
          intercept: 'intercept',
          k1: 'k1',
          k2: 'k2',
          k3: 'k3',
          k4: 'k4',
          k: 'k',
          kernelmatrix: 'kernelMatrix',
          kernelunitlength: 'kernelUnitLength',
          kerning: 'kerning',
          keypoints: 'keyPoints',
          keysplines: 'keySplines',
          keytimes: 'keyTimes',
          lengthadjust: 'lengthAdjust',
          letterspacing: 'letterSpacing',
          'letter-spacing': 'letterSpacing',
          lightingcolor: 'lightingColor',
          'lighting-color': 'lightingColor',
          limitingconeangle: 'limitingConeAngle',
          local: 'local',
          markerend: 'markerEnd',
          'marker-end': 'markerEnd',
          markerheight: 'markerHeight',
          markermid: 'markerMid',
          'marker-mid': 'markerMid',
          markerstart: 'markerStart',
          'marker-start': 'markerStart',
          markerunits: 'markerUnits',
          markerwidth: 'markerWidth',
          mask: 'mask',
          maskcontentunits: 'maskContentUnits',
          maskunits: 'maskUnits',
          mathematical: 'mathematical',
          mode: 'mode',
          numoctaves: 'numOctaves',
          offset: 'offset',
          opacity: 'opacity',
          operator: 'operator',
          order: 'order',
          orient: 'orient',
          orientation: 'orientation',
          origin: 'origin',
          overflow: 'overflow',
          overlineposition: 'overlinePosition',
          'overline-position': 'overlinePosition',
          overlinethickness: 'overlineThickness',
          'overline-thickness': 'overlineThickness',
          paintorder: 'paintOrder',
          'paint-order': 'paintOrder',
          panose1: 'panose1',
          'panose-1': 'panose1',
          pathlength: 'pathLength',
          patterncontentunits: 'patternContentUnits',
          patterntransform: 'patternTransform',
          patternunits: 'patternUnits',
          pointerevents: 'pointerEvents',
          'pointer-events': 'pointerEvents',
          points: 'points',
          pointsatx: 'pointsAtX',
          pointsaty: 'pointsAtY',
          pointsatz: 'pointsAtZ',
          prefix: 'prefix',
          preservealpha: 'preserveAlpha',
          preserveaspectratio: 'preserveAspectRatio',
          primitiveunits: 'primitiveUnits',
          property: 'property',
          r: 'r',
          radius: 'radius',
          refx: 'refX',
          refy: 'refY',
          renderingintent: 'renderingIntent',
          'rendering-intent': 'renderingIntent',
          repeatcount: 'repeatCount',
          repeatdur: 'repeatDur',
          requiredextensions: 'requiredExtensions',
          requiredfeatures: 'requiredFeatures',
          resource: 'resource',
          restart: 'restart',
          result: 'result',
          results: 'results',
          rotate: 'rotate',
          rx: 'rx',
          ry: 'ry',
          scale: 'scale',
          security: 'security',
          seed: 'seed',
          shaperendering: 'shapeRendering',
          'shape-rendering': 'shapeRendering',
          slope: 'slope',
          spacing: 'spacing',
          specularconstant: 'specularConstant',
          specularexponent: 'specularExponent',
          speed: 'speed',
          spreadmethod: 'spreadMethod',
          startoffset: 'startOffset',
          stddeviation: 'stdDeviation',
          stemh: 'stemh',
          stemv: 'stemv',
          stitchtiles: 'stitchTiles',
          stopcolor: 'stopColor',
          'stop-color': 'stopColor',
          stopopacity: 'stopOpacity',
          'stop-opacity': 'stopOpacity',
          strikethroughposition: 'strikethroughPosition',
          'strikethrough-position': 'strikethroughPosition',
          strikethroughthickness: 'strikethroughThickness',
          'strikethrough-thickness': 'strikethroughThickness',
          string: 'string',
          stroke: 'stroke',
          strokedasharray: 'strokeDasharray',
          'stroke-dasharray': 'strokeDasharray',
          strokedashoffset: 'strokeDashoffset',
          'stroke-dashoffset': 'strokeDashoffset',
          strokelinecap: 'strokeLinecap',
          'stroke-linecap': 'strokeLinecap',
          strokelinejoin: 'strokeLinejoin',
          'stroke-linejoin': 'strokeLinejoin',
          strokemiterlimit: 'strokeMiterlimit',
          'stroke-miterlimit': 'strokeMiterlimit',
          strokewidth: 'strokeWidth',
          'stroke-width': 'strokeWidth',
          strokeopacity: 'strokeOpacity',
          'stroke-opacity': 'strokeOpacity',
          suppresscontenteditablewarning: 'suppressContentEditableWarning',
          suppresshydrationwarning: 'suppressHydrationWarning',
          surfacescale: 'surfaceScale',
          systemlanguage: 'systemLanguage',
          tablevalues: 'tableValues',
          targetx: 'targetX',
          targety: 'targetY',
          textanchor: 'textAnchor',
          'text-anchor': 'textAnchor',
          textdecoration: 'textDecoration',
          'text-decoration': 'textDecoration',
          textlength: 'textLength',
          textrendering: 'textRendering',
          'text-rendering': 'textRendering',
          to: 'to',
          transform: 'transform',
          typeof: 'typeof',
          u1: 'u1',
          u2: 'u2',
          underlineposition: 'underlinePosition',
          'underline-position': 'underlinePosition',
          underlinethickness: 'underlineThickness',
          'underline-thickness': 'underlineThickness',
          unicode: 'unicode',
          unicodebidi: 'unicodeBidi',
          'unicode-bidi': 'unicodeBidi',
          unicoderange: 'unicodeRange',
          'unicode-range': 'unicodeRange',
          unitsperem: 'unitsPerEm',
          'units-per-em': 'unitsPerEm',
          unselectable: 'unselectable',
          valphabetic: 'vAlphabetic',
          'v-alphabetic': 'vAlphabetic',
          values: 'values',
          vectoreffect: 'vectorEffect',
          'vector-effect': 'vectorEffect',
          version: 'version',
          vertadvy: 'vertAdvY',
          'vert-adv-y': 'vertAdvY',
          vertoriginx: 'vertOriginX',
          'vert-origin-x': 'vertOriginX',
          vertoriginy: 'vertOriginY',
          'vert-origin-y': 'vertOriginY',
          vhanging: 'vHanging',
          'v-hanging': 'vHanging',
          videographic: 'vIdeographic',
          'v-ideographic': 'vIdeographic',
          viewbox: 'viewBox',
          viewtarget: 'viewTarget',
          visibility: 'visibility',
          vmathematical: 'vMathematical',
          'v-mathematical': 'vMathematical',
          vocab: 'vocab',
          widths: 'widths',
          wordspacing: 'wordSpacing',
          'word-spacing': 'wordSpacing',
          writingmode: 'writingMode',
          'writing-mode': 'writingMode',
          x1: 'x1',
          x2: 'x2',
          x: 'x',
          xchannelselector: 'xChannelSelector',
          xheight: 'xHeight',
          'x-height': 'xHeight',
          xlinkactuate: 'xlinkActuate',
          'xlink:actuate': 'xlinkActuate',
          xlinkarcrole: 'xlinkArcrole',
          'xlink:arcrole': 'xlinkArcrole',
          xlinkhref: 'xlinkHref',
          'xlink:href': 'xlinkHref',
          xlinkrole: 'xlinkRole',
          'xlink:role': 'xlinkRole',
          xlinkshow: 'xlinkShow',
          'xlink:show': 'xlinkShow',
          xlinktitle: 'xlinkTitle',
          'xlink:title': 'xlinkTitle',
          xlinktype: 'xlinkType',
          'xlink:type': 'xlinkType',
          xmlbase: 'xmlBase',
          'xml:base': 'xmlBase',
          xmllang: 'xmlLang',
          'xml:lang': 'xmlLang',
          xmlns: 'xmlns',
          'xml:space': 'xmlSpace',
          xmlnsxlink: 'xmlnsXlink',
          'xmlns:xlink': 'xmlnsXlink',
          xmlspace: 'xmlSpace',
          y1: 'y1',
          y2: 'y2',
          y: 'y',
          ychannelselector: 'yChannelSelector',
          z: 'z',
          zoomandpan: 'zoomAndPan'
        };
        var ariaProperties = {
          'aria-current': 0,
          // state
          'aria-details': 0,
          'aria-disabled': 0,
          // state
          'aria-hidden': 0,
          // state
          'aria-invalid': 0,
          // state
          'aria-keyshortcuts': 0,
          'aria-label': 0,
          'aria-roledescription': 0,
          // Widget Attributes
          'aria-autocomplete': 0,
          'aria-checked': 0,
          'aria-expanded': 0,
          'aria-haspopup': 0,
          'aria-level': 0,
          'aria-modal': 0,
          'aria-multiline': 0,
          'aria-multiselectable': 0,
          'aria-orientation': 0,
          'aria-placeholder': 0,
          'aria-pressed': 0,
          'aria-readonly': 0,
          'aria-required': 0,
          'aria-selected': 0,
          'aria-sort': 0,
          'aria-valuemax': 0,
          'aria-valuemin': 0,
          'aria-valuenow': 0,
          'aria-valuetext': 0,
          // Live Region Attributes
          'aria-atomic': 0,
          'aria-busy': 0,
          'aria-live': 0,
          'aria-relevant': 0,
          // Drag-and-Drop Attributes
          'aria-dropeffect': 0,
          'aria-grabbed': 0,
          // Relationship Attributes
          'aria-activedescendant': 0,
          'aria-colcount': 0,
          'aria-colindex': 0,
          'aria-colspan': 0,
          'aria-controls': 0,
          'aria-describedby': 0,
          'aria-errormessage': 0,
          'aria-flowto': 0,
          'aria-labelledby': 0,
          'aria-owns': 0,
          'aria-posinset': 0,
          'aria-rowcount': 0,
          'aria-rowindex': 0,
          'aria-rowspan': 0,
          'aria-setsize': 0
        };
        var warnedProperties = {};
        var rARIA = new RegExp('^(aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$');
        var rARIACamel = new RegExp('^(aria)[A-Z][' + ATTRIBUTE_NAME_CHAR + ']*$');
        var hasOwnProperty$1 = Object.prototype.hasOwnProperty;

        function validateProperty(tagName, name) {
          {
            if (hasOwnProperty$1.call(warnedProperties, name) && warnedProperties[name]) {
              return true;
            }

            if (rARIACamel.test(name)) {
              var ariaName = 'aria-' + name.slice(4).toLowerCase();
              var correctName = ariaProperties.hasOwnProperty(ariaName) ? ariaName : null; // If this is an aria-* attribute, but is not listed in the known DOM
              // DOM properties, then it is an invalid aria-* attribute.

              if (correctName == null) {
                error('Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.', name);
                warnedProperties[name] = true;
                return true;
              } // aria-* attributes should be lowercase; suggest the lowercase version.


              if (name !== correctName) {
                error('Invalid ARIA attribute `%s`. Did you mean `%s`?', name, correctName);
                warnedProperties[name] = true;
                return true;
              }
            }

            if (rARIA.test(name)) {
              var lowerCasedName = name.toLowerCase();
              var standardName = ariaProperties.hasOwnProperty(lowerCasedName) ? lowerCasedName : null; // If this is an aria-* attribute, but is not listed in the known DOM
              // DOM properties, then it is an invalid aria-* attribute.

              if (standardName == null) {
                warnedProperties[name] = true;
                return false;
              } // aria-* attributes should be lowercase; suggest the lowercase version.


              if (name !== standardName) {
                error('Unknown ARIA attribute `%s`. Did you mean `%s`?', name, standardName);
                warnedProperties[name] = true;
                return true;
              }
            }
          }
          return true;
        }

        function warnInvalidARIAProps(type, props) {
          {
            var invalidProps = [];

            for (var key in props) {
              var isValid = validateProperty(type, key);

              if (!isValid) {
                invalidProps.push(key);
              }
            }

            var unknownPropString = invalidProps.map(function (prop) {
              return '`' + prop + '`';
            }).join(', ');

            if (invalidProps.length === 1) {
              error('Invalid aria prop %s on <%s> tag. ' + 'For details, see https://reactjs.org/link/invalid-aria-props', unknownPropString, type);
            } else if (invalidProps.length > 1) {
              error('Invalid aria props %s on <%s> tag. ' + 'For details, see https://reactjs.org/link/invalid-aria-props', unknownPropString, type);
            }
          }
        }

        function validateProperties(type, props) {
          if (isCustomComponent(type, props)) {
            return;
          }

          warnInvalidARIAProps(type, props);
        }

        var didWarnValueNull = false;

        function validateProperties$1(type, props) {
          {
            if (type !== 'input' && type !== 'textarea' && type !== 'select') {
              return;
            }

            if (props != null && props.value === null && !didWarnValueNull) {
              didWarnValueNull = true;

              if (type === 'select' && props.multiple) {
                error('`value` prop on `%s` should not be null. ' + 'Consider using an empty array when `multiple` is set to `true` ' + 'to clear the component or `undefined` for uncontrolled components.', type);
              } else {
                error('`value` prop on `%s` should not be null. ' + 'Consider using an empty string to clear the component or `undefined` ' + 'for uncontrolled components.', type);
              }
            }
          }
        }

        var validateProperty$1 = function validateProperty$1() {};

        {
          var warnedProperties$1 = {};
          var _hasOwnProperty = Object.prototype.hasOwnProperty;
          var EVENT_NAME_REGEX = /^on./;
          var INVALID_EVENT_NAME_REGEX = /^on[^A-Z]/;
          var rARIA$1 = new RegExp('^(aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$');
          var rARIACamel$1 = new RegExp('^(aria)[A-Z][' + ATTRIBUTE_NAME_CHAR + ']*$');

          validateProperty$1 = function validateProperty$1(tagName, name, value, eventRegistry) {
            if (_hasOwnProperty.call(warnedProperties$1, name) && warnedProperties$1[name]) {
              return true;
            }

            var lowerCasedName = name.toLowerCase();

            if (lowerCasedName === 'onfocusin' || lowerCasedName === 'onfocusout') {
              error('React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.');
              warnedProperties$1[name] = true;
              return true;
            } // We can't rely on the event system being injected on the server.


            if (eventRegistry != null) {
              var registrationNameDependencies = eventRegistry.registrationNameDependencies,
                  possibleRegistrationNames = eventRegistry.possibleRegistrationNames;

              if (registrationNameDependencies.hasOwnProperty(name)) {
                return true;
              }

              var registrationName = possibleRegistrationNames.hasOwnProperty(lowerCasedName) ? possibleRegistrationNames[lowerCasedName] : null;

              if (registrationName != null) {
                error('Invalid event handler property `%s`. Did you mean `%s`?', name, registrationName);
                warnedProperties$1[name] = true;
                return true;
              }

              if (EVENT_NAME_REGEX.test(name)) {
                error('Unknown event handler property `%s`. It will be ignored.', name);
                warnedProperties$1[name] = true;
                return true;
              }
            } else if (EVENT_NAME_REGEX.test(name)) {
              // If no event plugins have been injected, we are in a server environment.
              // So we can't tell if the event name is correct for sure, but we can filter
              // out known bad ones like `onclick`. We can't suggest a specific replacement though.
              if (INVALID_EVENT_NAME_REGEX.test(name)) {
                error('Invalid event handler property `%s`. ' + 'React events use the camelCase naming convention, for example `onClick`.', name);
              }

              warnedProperties$1[name] = true;
              return true;
            } // Let the ARIA attribute hook validate ARIA attributes


            if (rARIA$1.test(name) || rARIACamel$1.test(name)) {
              return true;
            }

            if (lowerCasedName === 'innerhtml') {
              error('Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.');
              warnedProperties$1[name] = true;
              return true;
            }

            if (lowerCasedName === 'aria') {
              error('The `aria` attribute is reserved for future use in React. ' + 'Pass individual `aria-` attributes instead.');
              warnedProperties$1[name] = true;
              return true;
            }

            if (lowerCasedName === 'is' && value !== null && value !== undefined && typeof value !== 'string') {
              error('Received a `%s` for a string attribute `is`. If this is expected, cast ' + 'the value to a string.', typeof value);
              warnedProperties$1[name] = true;
              return true;
            }

            if (typeof value === 'number' && isNaN(value)) {
              error('Received NaN for the `%s` attribute. If this is expected, cast ' + 'the value to a string.', name);
              warnedProperties$1[name] = true;
              return true;
            }

            var propertyInfo = getPropertyInfo(name);
            var isReserved = propertyInfo !== null && propertyInfo.type === RESERVED; // Known attributes should match the casing specified in the property config.

            if (possibleStandardNames.hasOwnProperty(lowerCasedName)) {
              var standardName = possibleStandardNames[lowerCasedName];

              if (standardName !== name) {
                error('Invalid DOM property `%s`. Did you mean `%s`?', name, standardName);
                warnedProperties$1[name] = true;
                return true;
              }
            } else if (!isReserved && name !== lowerCasedName) {
              // Unknown attributes should have lowercase casing since that's how they
              // will be cased anyway with server rendering.
              error('React does not recognize the `%s` prop on a DOM element. If you ' + 'intentionally want it to appear in the DOM as a custom ' + 'attribute, spell it as lowercase `%s` instead. ' + 'If you accidentally passed it from a parent component, remove ' + 'it from the DOM element.', name, lowerCasedName);
              warnedProperties$1[name] = true;
              return true;
            }

            if (typeof value === 'boolean' && shouldRemoveAttributeWithWarning(name, value, propertyInfo, false)) {
              if (value) {
                error('Received `%s` for a non-boolean attribute `%s`.\n\n' + 'If you want to write it to the DOM, pass a string instead: ' + '%s="%s" or %s={value.toString()}.', value, name, name, value, name);
              } else {
                error('Received `%s` for a non-boolean attribute `%s`.\n\n' + 'If you want to write it to the DOM, pass a string instead: ' + '%s="%s" or %s={value.toString()}.\n\n' + 'If you used to conditionally omit it with %s={condition && value}, ' + 'pass %s={condition ? value : undefined} instead.', value, name, name, value, name, name, name);
              }

              warnedProperties$1[name] = true;
              return true;
            } // Now that we've validated casing, do not validate
            // data types for reserved props


            if (isReserved) {
              return true;
            } // Warn when a known attribute is a bad type


            if (shouldRemoveAttributeWithWarning(name, value, propertyInfo, false)) {
              warnedProperties$1[name] = true;
              return false;
            } // Warn when passing the strings 'false' or 'true' into a boolean prop


            if ((value === 'false' || value === 'true') && propertyInfo !== null && propertyInfo.type === BOOLEAN) {
              error('Received the string `%s` for the boolean attribute `%s`. ' + '%s ' + 'Did you mean %s={%s}?', value, name, value === 'false' ? 'The browser will interpret it as a truthy value.' : 'Although this works, it will not work as expected if you pass the string "false".', name, value);
              warnedProperties$1[name] = true;
              return true;
            }

            return true;
          };
        }

        var warnUnknownProperties = function warnUnknownProperties(type, props, eventRegistry) {
          {
            var unknownProps = [];

            for (var key in props) {
              var isValid = validateProperty$1(type, key, props[key], eventRegistry);

              if (!isValid) {
                unknownProps.push(key);
              }
            }

            var unknownPropString = unknownProps.map(function (prop) {
              return '`' + prop + '`';
            }).join(', ');

            if (unknownProps.length === 1) {
              error('Invalid value for prop %s on <%s> tag. Either remove it from the element, ' + 'or pass a string or number value to keep it in the DOM. ' + 'For details, see https://reactjs.org/link/attribute-behavior ', unknownPropString, type);
            } else if (unknownProps.length > 1) {
              error('Invalid values for props %s on <%s> tag. Either remove them from the element, ' + 'or pass a string or number value to keep them in the DOM. ' + 'For details, see https://reactjs.org/link/attribute-behavior ', unknownPropString, type);
            }
          }
        };

        function validateProperties$2(type, props, eventRegistry) {
          if (isCustomComponent(type, props)) {
            return;
          }

          warnUnknownProperties(type, props, eventRegistry);
        }

        var IS_EVENT_HANDLE_NON_MANAGED_NODE = 1;
        var IS_NON_DELEGATED = 1 << 1;
        var IS_CAPTURE_PHASE = 1 << 2;
        var IS_REPLAYED = 1 << 4; // set to LEGACY_FB_SUPPORT. LEGACY_FB_SUPPORT only gets set when
        // we call willDeferLaterForLegacyFBSupport, thus not bailing out
        // will result in endless cycles like an infinite loop.
        // We also don't want to defer during event replaying.

        var SHOULD_NOT_PROCESS_POLYFILL_EVENT_PLUGINS = IS_EVENT_HANDLE_NON_MANAGED_NODE | IS_NON_DELEGATED | IS_CAPTURE_PHASE;
        /**
         * Gets the target node from a native browser event by accounting for
         * inconsistencies in browser DOM APIs.
         *
         * @param {object} nativeEvent Native browser event.
         * @return {DOMEventTarget} Target node.
         */

        function getEventTarget(nativeEvent) {
          // Fallback to nativeEvent.srcElement for IE9
          // https://github.com/facebook/react/issues/12506
          var target = nativeEvent.target || nativeEvent.srcElement || window; // Normalize SVG <use> element events #4963

          if (target.correspondingUseElement) {
            target = target.correspondingUseElement;
          } // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
          // @see http://www.quirksmode.org/js/events_properties.html


          return target.nodeType === TEXT_NODE ? target.parentNode : target;
        }

        var restoreImpl = null;
        var restoreTarget = null;
        var restoreQueue = null;

        function restoreStateOfTarget(target) {
          // We perform this translation at the end of the event loop so that we
          // always receive the correct fiber here
          var internalInstance = getInstanceFromNode(target);

          if (!internalInstance) {
            // Unmounted
            return;
          }

          if (!(typeof restoreImpl === 'function')) {
            {
              throw Error("setRestoreImplementation() needs to be called to handle a target for controlled events. This error is likely caused by a bug in React. Please file an issue.");
            }
          }

          var stateNode = internalInstance.stateNode; // Guard against Fiber being unmounted.

          if (stateNode) {
            var _props = getFiberCurrentPropsFromNode(stateNode);

            restoreImpl(internalInstance.stateNode, internalInstance.type, _props);
          }
        }

        function setRestoreImplementation(impl) {
          restoreImpl = impl;
        }

        function enqueueStateRestore(target) {
          if (restoreTarget) {
            if (restoreQueue) {
              restoreQueue.push(target);
            } else {
              restoreQueue = [target];
            }
          } else {
            restoreTarget = target;
          }
        }

        function needsStateRestore() {
          return restoreTarget !== null || restoreQueue !== null;
        }

        function restoreStateIfNeeded() {
          if (!restoreTarget) {
            return;
          }

          var target = restoreTarget;
          var queuedTargets = restoreQueue;
          restoreTarget = null;
          restoreQueue = null;
          restoreStateOfTarget(target);

          if (queuedTargets) {
            for (var i = 0; i < queuedTargets.length; i++) {
              restoreStateOfTarget(queuedTargets[i]);
            }
          }
        } // the renderer. Such as when we're dispatching events or if third party
        // libraries need to call batchedUpdates. Eventually, this API will go away when
        // everything is batched by default. We'll then have a similar API to opt-out of
        // scheduled work and instead do synchronous work.
        // Defaults


        var batchedUpdatesImpl = function batchedUpdatesImpl(fn, bookkeeping) {
          return fn(bookkeeping);
        };

        var discreteUpdatesImpl = function discreteUpdatesImpl(fn, a, b, c, d) {
          return fn(a, b, c, d);
        };

        var flushDiscreteUpdatesImpl = function flushDiscreteUpdatesImpl() {};

        var batchedEventUpdatesImpl = batchedUpdatesImpl;
        var isInsideEventHandler = false;
        var isBatchingEventUpdates = false;

        function finishEventHandler() {
          // Here we wait until all updates have propagated, which is important
          // when using controlled components within layers:
          // https://github.com/facebook/react/issues/1698
          // Then we restore state of any controlled component.
          var controlledComponentsHavePendingUpdates = needsStateRestore();

          if (controlledComponentsHavePendingUpdates) {
            // If a controlled event was fired, we may need to restore the state of
            // the DOM node back to the controlled value. This is necessary when React
            // bails out of the update without touching the DOM.
            flushDiscreteUpdatesImpl();
            restoreStateIfNeeded();
          }
        }

        function batchedUpdates(fn, bookkeeping) {
          if (isInsideEventHandler) {
            // If we are currently inside another batch, we need to wait until it
            // fully completes before restoring state.
            return fn(bookkeeping);
          }

          isInsideEventHandler = true;

          try {
            return batchedUpdatesImpl(fn, bookkeeping);
          } finally {
            isInsideEventHandler = false;
            finishEventHandler();
          }
        }

        function batchedEventUpdates(fn, a, b) {
          if (isBatchingEventUpdates) {
            // If we are currently inside another batch, we need to wait until it
            // fully completes before restoring state.
            return fn(a, b);
          }

          isBatchingEventUpdates = true;

          try {
            return batchedEventUpdatesImpl(fn, a, b);
          } finally {
            isBatchingEventUpdates = false;
            finishEventHandler();
          }
        }

        function discreteUpdates(fn, a, b, c, d) {
          var prevIsInsideEventHandler = isInsideEventHandler;
          isInsideEventHandler = true;

          try {
            return discreteUpdatesImpl(fn, a, b, c, d);
          } finally {
            isInsideEventHandler = prevIsInsideEventHandler;

            if (!isInsideEventHandler) {
              finishEventHandler();
            }
          }
        }

        function flushDiscreteUpdatesIfNeeded(timeStamp) {
          {
            if (!isInsideEventHandler) {
              flushDiscreteUpdatesImpl();
            }
          }
        }

        function setBatchingImplementation(_batchedUpdatesImpl, _discreteUpdatesImpl, _flushDiscreteUpdatesImpl, _batchedEventUpdatesImpl) {
          batchedUpdatesImpl = _batchedUpdatesImpl;
          discreteUpdatesImpl = _discreteUpdatesImpl;
          flushDiscreteUpdatesImpl = _flushDiscreteUpdatesImpl;
          batchedEventUpdatesImpl = _batchedEventUpdatesImpl;
        }

        function isInteractive(tag) {
          return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
        }

        function shouldPreventMouseEvent(name, type, props) {
          switch (name) {
            case 'onClick':
            case 'onClickCapture':
            case 'onDoubleClick':
            case 'onDoubleClickCapture':
            case 'onMouseDown':
            case 'onMouseDownCapture':
            case 'onMouseMove':
            case 'onMouseMoveCapture':
            case 'onMouseUp':
            case 'onMouseUpCapture':
            case 'onMouseEnter':
              return !!(props.disabled && isInteractive(type));

            default:
              return false;
          }
        }
        /**
         * @param {object} inst The instance, which is the source of events.
         * @param {string} registrationName Name of listener (e.g. `onClick`).
         * @return {?function} The stored callback.
         */


        function getListener(inst, registrationName) {
          var stateNode = inst.stateNode;

          if (stateNode === null) {
            // Work in progress (ex: onload events in incremental mode).
            return null;
          }

          var props = getFiberCurrentPropsFromNode(stateNode);

          if (props === null) {
            // Work in progress.
            return null;
          }

          var listener = props[registrationName];

          if (shouldPreventMouseEvent(registrationName, inst.type, props)) {
            return null;
          }

          if (!(!listener || typeof listener === 'function')) {
            {
              throw Error("Expected `" + registrationName + "` listener to be a function, instead got a value of `" + typeof listener + "` type.");
            }
          }

          return listener;
        }

        var passiveBrowserEventsSupported = false; // Check if browser support events with passive listeners
        // https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support

        if (canUseDOM) {
          try {
            var options = {}; // $FlowFixMe: Ignore Flow complaining about needing a value

            Object.defineProperty(options, 'passive', {
              get: function get() {
                passiveBrowserEventsSupported = true;
              }
            });
            window.addEventListener('test', options, options);
            window.removeEventListener('test', options, options);
          } catch (e) {
            passiveBrowserEventsSupported = false;
          }
        }

        function invokeGuardedCallbackProd(name, func, context, a, b, c, d, e, f) {
          var funcArgs = Array.prototype.slice.call(arguments, 3);

          try {
            func.apply(context, funcArgs);
          } catch (error) {
            this.onError(error);
          }
        }

        var invokeGuardedCallbackImpl = invokeGuardedCallbackProd;
        {
          // In DEV mode, we swap out invokeGuardedCallback for a special version
          // that plays more nicely with the browser's DevTools. The idea is to preserve
          // "Pause on exceptions" behavior. Because React wraps all user-provided
          // functions in invokeGuardedCallback, and the production version of
          // invokeGuardedCallback uses a try-catch, all user exceptions are treated
          // like caught exceptions, and the DevTools won't pause unless the developer
          // takes the extra step of enabling pause on caught exceptions. This is
          // unintuitive, though, because even though React has caught the error, from
          // the developer's perspective, the error is uncaught.
          //
          // To preserve the expected "Pause on exceptions" behavior, we don't use a
          // try-catch in DEV. Instead, we synchronously dispatch a fake event to a fake
          // DOM node, and call the user-provided callback from inside an event handler
          // for that fake event. If the callback throws, the error is "captured" using
          // a global event handler. But because the error happens in a different
          // event loop context, it does not interrupt the normal program flow.
          // Effectively, this gives us try-catch behavior without actually using
          // try-catch. Neat!
          // Check that the browser supports the APIs we need to implement our special
          // DEV version of invokeGuardedCallback
          if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
            var fakeNode = document.createElement('react');

            invokeGuardedCallbackImpl = function invokeGuardedCallbackDev(name, func, context, a, b, c, d, e, f) {
              // If document doesn't exist we know for sure we will crash in this method
              // when we call document.createEvent(). However this can cause confusing
              // errors: https://github.com/facebookincubator/create-react-app/issues/3482
              // So we preemptively throw with a better message instead.
              if (!(typeof document !== 'undefined')) {
                {
                  throw Error("The `document` global was defined when React was initialized, but is not defined anymore. This can happen in a test environment if a component schedules an update from an asynchronous callback, but the test has already finished running. To solve this, you can either unmount the component at the end of your test (and ensure that any asynchronous operations get canceled in `componentWillUnmount`), or you can change the test itself to be asynchronous.");
                }
              }

              var evt = document.createEvent('Event');
              var didCall = false; // Keeps track of whether the user-provided callback threw an error. We
              // set this to true at the beginning, then set it to false right after
              // calling the function. If the function errors, `didError` will never be
              // set to false. This strategy works even if the browser is flaky and
              // fails to call our global error handler, because it doesn't rely on
              // the error event at all.

              var didError = true; // Keeps track of the value of window.event so that we can reset it
              // during the callback to let user code access window.event in the
              // browsers that support it.

              var windowEvent = window.event; // Keeps track of the descriptor of window.event to restore it after event
              // dispatching: https://github.com/facebook/react/issues/13688

              var windowEventDescriptor = Object.getOwnPropertyDescriptor(window, 'event');

              function restoreAfterDispatch() {
                // We immediately remove the callback from event listeners so that
                // nested `invokeGuardedCallback` calls do not clash. Otherwise, a
                // nested call would trigger the fake event handlers of any call higher
                // in the stack.
                fakeNode.removeEventListener(evtType, callCallback, false); // We check for window.hasOwnProperty('event') to prevent the
                // window.event assignment in both IE <= 10 as they throw an error
                // "Member not found" in strict mode, and in Firefox which does not
                // support window.event.

                if (typeof window.event !== 'undefined' && window.hasOwnProperty('event')) {
                  window.event = windowEvent;
                }
              } // Create an event handler for our fake event. We will synchronously
              // dispatch our fake event using `dispatchEvent`. Inside the handler, we
              // call the user-provided callback.


              var funcArgs = Array.prototype.slice.call(arguments, 3);

              function callCallback() {
                didCall = true;
                restoreAfterDispatch();
                func.apply(context, funcArgs);
                didError = false;
              } // Create a global error event handler. We use this to capture the value
              // that was thrown. It's possible that this error handler will fire more
              // than once; for example, if non-React code also calls `dispatchEvent`
              // and a handler for that event throws. We should be resilient to most of
              // those cases. Even if our error event handler fires more than once, the
              // last error event is always used. If the callback actually does error,
              // we know that the last error event is the correct one, because it's not
              // possible for anything else to have happened in between our callback
              // erroring and the code that follows the `dispatchEvent` call below. If
              // the callback doesn't error, but the error event was fired, we know to
              // ignore it because `didError` will be false, as described above.


              var error; // Use this to track whether the error event is ever called.

              var didSetError = false;
              var isCrossOriginError = false;

              function handleWindowError(event) {
                error = event.error;
                didSetError = true;

                if (error === null && event.colno === 0 && event.lineno === 0) {
                  isCrossOriginError = true;
                }

                if (event.defaultPrevented) {
                  // Some other error handler has prevented default.
                  // Browsers silence the error report if this happens.
                  // We'll remember this to later decide whether to log it or not.
                  if (error != null && typeof error === 'object') {
                    try {
                      error._suppressLogging = true;
                    } catch (inner) {// Ignore.
                    }
                  }
                }
              } // Create a fake event type.


              var evtType = "react-" + (name ? name : 'invokeguardedcallback'); // Attach our event handlers

              window.addEventListener('error', handleWindowError);
              fakeNode.addEventListener(evtType, callCallback, false); // Synchronously dispatch our fake event. If the user-provided function
              // errors, it will trigger our global error handler.

              evt.initEvent(evtType, false, false);
              fakeNode.dispatchEvent(evt);

              if (windowEventDescriptor) {
                Object.defineProperty(window, 'event', windowEventDescriptor);
              }

              if (didCall && didError) {
                if (!didSetError) {
                  // The callback errored, but the error event never fired.
                  error = new Error('An error was thrown inside one of your components, but React ' + "doesn't know what it was. This is likely due to browser " + 'flakiness. React does its best to preserve the "Pause on ' + 'exceptions" behavior of the DevTools, which requires some ' + "DEV-mode only tricks. It's possible that these don't work in " + 'your browser. Try triggering the error in production mode, ' + 'or switching to a modern browser. If you suspect that this is ' + 'actually an issue with React, please file an issue.');
                } else if (isCrossOriginError) {
                  error = new Error("A cross-origin error was thrown. React doesn't have access to " + 'the actual error object in development. ' + 'See https://reactjs.org/link/crossorigin-error for more information.');
                }

                this.onError(error);
              } // Remove our event listeners


              window.removeEventListener('error', handleWindowError);

              if (!didCall) {
                // Something went really wrong, and our event was not dispatched.
                // https://github.com/facebook/react/issues/16734
                // https://github.com/facebook/react/issues/16585
                // Fall back to the production implementation.
                restoreAfterDispatch();
                return invokeGuardedCallbackProd.apply(this, arguments);
              }
            };
          }
        }
        var invokeGuardedCallbackImpl$1 = invokeGuardedCallbackImpl;
        var hasError = false;
        var caughtError = null; // Used by event system to capture/rethrow the first error.

        var hasRethrowError = false;
        var rethrowError = null;
        var reporter = {
          onError: function onError(error) {
            hasError = true;
            caughtError = error;
          }
        };
        /**
         * Call a function while guarding against errors that happens within it.
         * Returns an error if it throws, otherwise null.
         *
         * In production, this is implemented using a try-catch. The reason we don't
         * use a try-catch directly is so that we can swap out a different
         * implementation in DEV mode.
         *
         * @param {String} name of the guard to use for logging or debugging
         * @param {Function} func The function to invoke
         * @param {*} context The context to use when calling the function
         * @param {...*} args Arguments for function
         */

        function invokeGuardedCallback(name, func, context, a, b, c, d, e, f) {
          hasError = false;
          caughtError = null;
          invokeGuardedCallbackImpl$1.apply(reporter, arguments);
        }
        /**
         * Same as invokeGuardedCallback, but instead of returning an error, it stores
         * it in a global so it can be rethrown by `rethrowCaughtError` later.
         * TODO: See if caughtError and rethrowError can be unified.
         *
         * @param {String} name of the guard to use for logging or debugging
         * @param {Function} func The function to invoke
         * @param {*} context The context to use when calling the function
         * @param {...*} args Arguments for function
         */


        function invokeGuardedCallbackAndCatchFirstError(name, func, context, a, b, c, d, e, f) {
          invokeGuardedCallback.apply(this, arguments);

          if (hasError) {
            var error = clearCaughtError();

            if (!hasRethrowError) {
              hasRethrowError = true;
              rethrowError = error;
            }
          }
        }
        /**
         * During execution of guarded functions we will capture the first error which
         * we will rethrow to be handled by the top level error handler.
         */


        function rethrowCaughtError() {
          if (hasRethrowError) {
            var error = rethrowError;
            hasRethrowError = false;
            rethrowError = null;
            throw error;
          }
        }

        function hasCaughtError() {
          return hasError;
        }

        function clearCaughtError() {
          if (hasError) {
            var error = caughtError;
            hasError = false;
            caughtError = null;
            return error;
          } else {
            {
              {
                throw Error("clearCaughtError was called but no error was captured. This error is likely caused by a bug in React. Please file an issue.");
              }
            }
          }
        }
        /**
         * `ReactInstanceMap` maintains a mapping from a public facing stateful
         * instance (key) and the internal representation (value). This allows public
         * methods to accept the user facing instance as an argument and map them back
         * to internal methods.
         *
         * Note that this module is currently shared and assumed to be stateless.
         * If this becomes an actual Map, that will break.
         */


        function get(key) {
          return key._reactInternals;
        }

        function has(key) {
          return key._reactInternals !== undefined;
        }

        function set(key, value) {
          key._reactInternals = value;
        } // Don't change these two values. They're used by React Dev Tools.


        var NoFlags =
        /*                      */
        0;
        var PerformedWork =
        /*                */
        1; // You can change the rest (and add more).

        var Placement =
        /*                    */
        2;
        var Update =
        /*                       */
        4;
        var PlacementAndUpdate =
        /*           */
        6;
        var Deletion =
        /*                     */
        8;
        var ContentReset =
        /*                 */
        16;
        var Callback =
        /*                     */
        32;
        var DidCapture =
        /*                   */
        64;
        var Ref =
        /*                          */
        128;
        var Snapshot =
        /*                     */
        256;
        var Passive =
        /*                      */
        512; // TODO (effects) Remove this bit once the new reconciler is synced to the old.

        var PassiveUnmountPendingDev =
        /*     */
        8192;
        var Hydrating =
        /*                    */
        1024;
        var HydratingAndUpdate =
        /*           */
        1028; // Passive & Update & Callback & Ref & Snapshot

        var LifecycleEffectMask =
        /*          */
        932; // Union of all host effects

        var HostEffectMask =
        /*               */
        2047; // These are not really side effects, but we still reuse this field.

        var Incomplete =
        /*                   */
        2048;
        var ShouldCapture =
        /*                */
        4096;
        var ForceUpdateForLegacySuspense =
        /* */
        16384; // Static tags describe aspects of a fiber that are not specific to a render,

        var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;

        function getNearestMountedFiber(fiber) {
          var node = fiber;
          var nearestMounted = fiber;

          if (!fiber.alternate) {
            // If there is no alternate, this might be a new tree that isn't inserted
            // yet. If it is, then it will have a pending insertion effect on it.
            var nextNode = node;

            do {
              node = nextNode;

              if ((node.flags & (Placement | Hydrating)) !== NoFlags) {
                // This is an insertion or in-progress hydration. The nearest possible
                // mounted fiber is the parent but we need to continue to figure out
                // if that one is still mounted.
                nearestMounted = node.return;
              }

              nextNode = node.return;
            } while (nextNode);
          } else {
            while (node.return) {
              node = node.return;
            }
          }

          if (node.tag === HostRoot) {
            // TODO: Check if this was a nested HostRoot when used with
            // renderContainerIntoSubtree.
            return nearestMounted;
          } // If we didn't hit the root, that means that we're in an disconnected tree
          // that has been unmounted.


          return null;
        }

        function getSuspenseInstanceFromFiber(fiber) {
          if (fiber.tag === SuspenseComponent) {
            var suspenseState = fiber.memoizedState;

            if (suspenseState === null) {
              var current = fiber.alternate;

              if (current !== null) {
                suspenseState = current.memoizedState;
              }
            }

            if (suspenseState !== null) {
              return suspenseState.dehydrated;
            }
          }

          return null;
        }

        function getContainerFromFiber(fiber) {
          return fiber.tag === HostRoot ? fiber.stateNode.containerInfo : null;
        }

        function isFiberMounted(fiber) {
          return getNearestMountedFiber(fiber) === fiber;
        }

        function isMounted(component) {
          {
            var owner = ReactCurrentOwner.current;

            if (owner !== null && owner.tag === ClassComponent) {
              var ownerFiber = owner;
              var instance = ownerFiber.stateNode;

              if (!instance._warnedAboutRefsInRender) {
                error('%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', getComponentName(ownerFiber.type) || 'A component');
              }

              instance._warnedAboutRefsInRender = true;
            }
          }
          var fiber = get(component);

          if (!fiber) {
            return false;
          }

          return getNearestMountedFiber(fiber) === fiber;
        }

        function assertIsMounted(fiber) {
          if (!(getNearestMountedFiber(fiber) === fiber)) {
            {
              throw Error("Unable to find node on an unmounted component.");
            }
          }
        }

        function findCurrentFiberUsingSlowPath(fiber) {
          var alternate = fiber.alternate;

          if (!alternate) {
            // If there is no alternate, then we only need to check if it is mounted.
            var nearestMounted = getNearestMountedFiber(fiber);

            if (!(nearestMounted !== null)) {
              {
                throw Error("Unable to find node on an unmounted component.");
              }
            }

            if (nearestMounted !== fiber) {
              return null;
            }

            return fiber;
          } // If we have two possible branches, we'll walk backwards up to the root
          // to see what path the root points to. On the way we may hit one of the
          // special cases and we'll deal with them.


          var a = fiber;
          var b = alternate;

          while (true) {
            var parentA = a.return;

            if (parentA === null) {
              // We're at the root.
              break;
            }

            var parentB = parentA.alternate;

            if (parentB === null) {
              // There is no alternate. This is an unusual case. Currently, it only
              // happens when a Suspense component is hidden. An extra fragment fiber
              // is inserted in between the Suspense fiber and its children. Skip
              // over this extra fragment fiber and proceed to the next parent.
              var nextParent = parentA.return;

              if (nextParent !== null) {
                a = b = nextParent;
                continue;
              } // If there's no parent, we're at the root.


              break;
            } // If both copies of the parent fiber point to the same child, we can
            // assume that the child is current. This happens when we bailout on low
            // priority: the bailed out fiber's child reuses the current child.


            if (parentA.child === parentB.child) {
              var child = parentA.child;

              while (child) {
                if (child === a) {
                  // We've determined that A is the current branch.
                  assertIsMounted(parentA);
                  return fiber;
                }

                if (child === b) {
                  // We've determined that B is the current branch.
                  assertIsMounted(parentA);
                  return alternate;
                }

                child = child.sibling;
              } // We should never have an alternate for any mounting node. So the only
              // way this could possibly happen is if this was unmounted, if at all.


              {
                {
                  throw Error("Unable to find node on an unmounted component.");
                }
              }
            }

            if (a.return !== b.return) {
              // The return pointer of A and the return pointer of B point to different
              // fibers. We assume that return pointers never criss-cross, so A must
              // belong to the child set of A.return, and B must belong to the child
              // set of B.return.
              a = parentA;
              b = parentB;
            } else {
              // The return pointers point to the same fiber. We'll have to use the
              // default, slow path: scan the child sets of each parent alternate to see
              // which child belongs to which set.
              //
              // Search parent A's child set
              var didFindChild = false;
              var _child = parentA.child;

              while (_child) {
                if (_child === a) {
                  didFindChild = true;
                  a = parentA;
                  b = parentB;
                  break;
                }

                if (_child === b) {
                  didFindChild = true;
                  b = parentA;
                  a = parentB;
                  break;
                }

                _child = _child.sibling;
              }

              if (!didFindChild) {
                // Search parent B's child set
                _child = parentB.child;

                while (_child) {
                  if (_child === a) {
                    didFindChild = true;
                    a = parentB;
                    b = parentA;
                    break;
                  }

                  if (_child === b) {
                    didFindChild = true;
                    b = parentB;
                    a = parentA;
                    break;
                  }

                  _child = _child.sibling;
                }

                if (!didFindChild) {
                  {
                    throw Error("Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.");
                  }
                }
              }
            }

            if (!(a.alternate === b)) {
              {
                throw Error("Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue.");
              }
            }
          } // If the root is not a host container, we're in a disconnected tree. I.e.
          // unmounted.


          if (!(a.tag === HostRoot)) {
            {
              throw Error("Unable to find node on an unmounted component.");
            }
          }

          if (a.stateNode.current === a) {
            // We've determined that A is the current branch.
            return fiber;
          } // Otherwise B has to be current branch.


          return alternate;
        }

        function findCurrentHostFiber(parent) {
          var currentParent = findCurrentFiberUsingSlowPath(parent);

          if (!currentParent) {
            return null;
          } // Next we'll drill down this component to find the first HostComponent/Text.


          var node = currentParent;

          while (true) {
            if (node.tag === HostComponent || node.tag === HostText) {
              return node;
            } else if (node.child) {
              node.child.return = node;
              node = node.child;
              continue;
            }

            if (node === currentParent) {
              return null;
            }

            while (!node.sibling) {
              if (!node.return || node.return === currentParent) {
                return null;
              }

              node = node.return;
            }

            node.sibling.return = node.return;
            node = node.sibling;
          } // Flow needs the return null here, but ESLint complains about it.
          // eslint-disable-next-line no-unreachable


          return null;
        }

        function findCurrentHostFiberWithNoPortals(parent) {
          var currentParent = findCurrentFiberUsingSlowPath(parent);

          if (!currentParent) {
            return null;
          } // Next we'll drill down this component to find the first HostComponent/Text.


          var node = currentParent;

          while (true) {
            if (node.tag === HostComponent || node.tag === HostText || enableFundamentalAPI) {
              return node;
            } else if (node.child && node.tag !== HostPortal) {
              node.child.return = node;
              node = node.child;
              continue;
            }

            if (node === currentParent) {
              return null;
            }

            while (!node.sibling) {
              if (!node.return || node.return === currentParent) {
                return null;
              }

              node = node.return;
            }

            node.sibling.return = node.return;
            node = node.sibling;
          } // Flow needs the return null here, but ESLint complains about it.
          // eslint-disable-next-line no-unreachable


          return null;
        }

        function doesFiberContain(parentFiber, childFiber) {
          var node = childFiber;
          var parentFiberAlternate = parentFiber.alternate;

          while (node !== null) {
            if (node === parentFiber || node === parentFiberAlternate) {
              return true;
            }

            node = node.return;
          }

          return false;
        }

        var attemptUserBlockingHydration;

        function setAttemptUserBlockingHydration(fn) {
          attemptUserBlockingHydration = fn;
        }

        var attemptContinuousHydration;

        function setAttemptContinuousHydration(fn) {
          attemptContinuousHydration = fn;
        }

        var attemptHydrationAtCurrentPriority;

        function setAttemptHydrationAtCurrentPriority(fn) {
          attemptHydrationAtCurrentPriority = fn;
        }

        var attemptHydrationAtPriority;

        function setAttemptHydrationAtPriority(fn) {
          attemptHydrationAtPriority = fn;
        } // TODO: Upgrade this definition once we're on a newer version of Flow that


        var hasScheduledReplayAttempt = false; // The queue of discrete events to be replayed.

        var queuedDiscreteEvents = []; // Indicates if any continuous event targets are non-null for early bailout.
        // if the last target was dehydrated.

        var queuedFocus = null;
        var queuedDrag = null;
        var queuedMouse = null; // For pointer events there can be one latest event per pointerId.

        var queuedPointers = new Map();
        var queuedPointerCaptures = new Map(); // We could consider replaying selectionchange and touchmoves too.

        var queuedExplicitHydrationTargets = [];

        function hasQueuedDiscreteEvents() {
          return queuedDiscreteEvents.length > 0;
        }

        var discreteReplayableEvents = ['mousedown', 'mouseup', 'touchcancel', 'touchend', 'touchstart', 'auxclick', 'dblclick', 'pointercancel', 'pointerdown', 'pointerup', 'dragend', 'dragstart', 'drop', 'compositionend', 'compositionstart', 'keydown', 'keypress', 'keyup', 'input', 'textInput', // Intentionally camelCase
        'copy', 'cut', 'paste', 'click', 'change', 'contextmenu', 'reset', 'submit'];

        function isReplayableDiscreteEvent(eventType) {
          return discreteReplayableEvents.indexOf(eventType) > -1;
        }

        function createQueuedReplayableEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
          return {
            blockedOn: blockedOn,
            domEventName: domEventName,
            eventSystemFlags: eventSystemFlags | IS_REPLAYED,
            nativeEvent: nativeEvent,
            targetContainers: [targetContainer]
          };
        }

        function queueDiscreteEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
          var queuedEvent = createQueuedReplayableEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent);
          queuedDiscreteEvents.push(queuedEvent);
        } // Resets the replaying for this type of continuous event to no event.


        function clearIfContinuousEvent(domEventName, nativeEvent) {
          switch (domEventName) {
            case 'focusin':
            case 'focusout':
              queuedFocus = null;
              break;

            case 'dragenter':
            case 'dragleave':
              queuedDrag = null;
              break;

            case 'mouseover':
            case 'mouseout':
              queuedMouse = null;
              break;

            case 'pointerover':
            case 'pointerout':
              {
                var pointerId = nativeEvent.pointerId;
                queuedPointers.delete(pointerId);
                break;
              }

            case 'gotpointercapture':
            case 'lostpointercapture':
              {
                var _pointerId = nativeEvent.pointerId;
                queuedPointerCaptures.delete(_pointerId);
                break;
              }
          }
        }

        function accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
          if (existingQueuedEvent === null || existingQueuedEvent.nativeEvent !== nativeEvent) {
            var queuedEvent = createQueuedReplayableEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent);

            if (blockedOn !== null) {
              var _fiber2 = getInstanceFromNode(blockedOn);

              if (_fiber2 !== null) {
                // Attempt to increase the priority of this target.
                attemptContinuousHydration(_fiber2);
              }
            }

            return queuedEvent;
          } // If we have already queued this exact event, then it's because
          // the different event systems have different DOM event listeners.
          // We can accumulate the flags, and the targetContainers, and
          // store a single event to be replayed.


          existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
          var targetContainers = existingQueuedEvent.targetContainers;

          if (targetContainer !== null && targetContainers.indexOf(targetContainer) === -1) {
            targetContainers.push(targetContainer);
          }

          return existingQueuedEvent;
        }

        function queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
          // These set relatedTarget to null because the replayed event will be treated as if we
          // moved from outside the window (no target) onto the target once it hydrates.
          // Instead of mutating we could clone the event.
          switch (domEventName) {
            case 'focusin':
              {
                var focusEvent = nativeEvent;
                queuedFocus = accumulateOrCreateContinuousQueuedReplayableEvent(queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, focusEvent);
                return true;
              }

            case 'dragenter':
              {
                var dragEvent = nativeEvent;
                queuedDrag = accumulateOrCreateContinuousQueuedReplayableEvent(queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, dragEvent);
                return true;
              }

            case 'mouseover':
              {
                var mouseEvent = nativeEvent;
                queuedMouse = accumulateOrCreateContinuousQueuedReplayableEvent(queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, mouseEvent);
                return true;
              }

            case 'pointerover':
              {
                var pointerEvent = nativeEvent;
                var pointerId = pointerEvent.pointerId;
                queuedPointers.set(pointerId, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, pointerEvent));
                return true;
              }

            case 'gotpointercapture':
              {
                var _pointerEvent = nativeEvent;
                var _pointerId2 = _pointerEvent.pointerId;
                queuedPointerCaptures.set(_pointerId2, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointerCaptures.get(_pointerId2) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, _pointerEvent));
                return true;
              }
          }

          return false;
        } // Check if this target is unblocked. Returns true if it's unblocked.


        function attemptExplicitHydrationTarget(queuedTarget) {
          // TODO: This function shares a lot of logic with attemptToDispatchEvent.
          // Try to unify them. It's a bit tricky since it would require two return
          // values.
          var targetInst = getClosestInstanceFromNode(queuedTarget.target);

          if (targetInst !== null) {
            var nearestMounted = getNearestMountedFiber(targetInst);

            if (nearestMounted !== null) {
              var tag = nearestMounted.tag;

              if (tag === SuspenseComponent) {
                var instance = getSuspenseInstanceFromFiber(nearestMounted);

                if (instance !== null) {
                  // We're blocked on hydrating this boundary.
                  // Increase its priority.
                  queuedTarget.blockedOn = instance;
                  attemptHydrationAtPriority(queuedTarget.lanePriority, function () {
                    Scheduler.unstable_runWithPriority(queuedTarget.priority, function () {
                      attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                  });
                  return;
                }
              } else if (tag === HostRoot) {
                var root = nearestMounted.stateNode;

                if (root.hydrate) {
                  queuedTarget.blockedOn = getContainerFromFiber(nearestMounted); // We don't currently have a way to increase the priority of
                  // a root other than sync.

                  return;
                }
              }
            }
          }

          queuedTarget.blockedOn = null;
        }

        function attemptReplayContinuousQueuedEvent(queuedEvent) {
          if (queuedEvent.blockedOn !== null) {
            return false;
          }

          var targetContainers = queuedEvent.targetContainers;

          while (targetContainers.length > 0) {
            var targetContainer = targetContainers[0];
            var nextBlockedOn = attemptToDispatchEvent(queuedEvent.domEventName, queuedEvent.eventSystemFlags, targetContainer, queuedEvent.nativeEvent);

            if (nextBlockedOn !== null) {
              // We're still blocked. Try again later.
              var _fiber3 = getInstanceFromNode(nextBlockedOn);

              if (_fiber3 !== null) {
                attemptContinuousHydration(_fiber3);
              }

              queuedEvent.blockedOn = nextBlockedOn;
              return false;
            } // This target container was successfully dispatched. Try the next.


            targetContainers.shift();
          }

          return true;
        }

        function attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
          if (attemptReplayContinuousQueuedEvent(queuedEvent)) {
            map.delete(key);
          }
        }

        function replayUnblockedEvents() {
          hasScheduledReplayAttempt = false; // First replay discrete events.

          while (queuedDiscreteEvents.length > 0) {
            var nextDiscreteEvent = queuedDiscreteEvents[0];

            if (nextDiscreteEvent.blockedOn !== null) {
              // We're still blocked.
              // Increase the priority of this boundary to unblock
              // the next discrete event.
              var _fiber4 = getInstanceFromNode(nextDiscreteEvent.blockedOn);

              if (_fiber4 !== null) {
                attemptUserBlockingHydration(_fiber4);
              }

              break;
            }

            var targetContainers = nextDiscreteEvent.targetContainers;

            while (targetContainers.length > 0) {
              var targetContainer = targetContainers[0];
              var nextBlockedOn = attemptToDispatchEvent(nextDiscreteEvent.domEventName, nextDiscreteEvent.eventSystemFlags, targetContainer, nextDiscreteEvent.nativeEvent);

              if (nextBlockedOn !== null) {
                // We're still blocked. Try again later.
                nextDiscreteEvent.blockedOn = nextBlockedOn;
                break;
              } // This target container was successfully dispatched. Try the next.


              targetContainers.shift();
            }

            if (nextDiscreteEvent.blockedOn === null) {
              // We've successfully replayed the first event. Let's try the next one.
              queuedDiscreteEvents.shift();
            }
          } // Next replay any continuous events.


          if (queuedFocus !== null && attemptReplayContinuousQueuedEvent(queuedFocus)) {
            queuedFocus = null;
          }

          if (queuedDrag !== null && attemptReplayContinuousQueuedEvent(queuedDrag)) {
            queuedDrag = null;
          }

          if (queuedMouse !== null && attemptReplayContinuousQueuedEvent(queuedMouse)) {
            queuedMouse = null;
          }

          queuedPointers.forEach(attemptReplayContinuousQueuedEventInMap);
          queuedPointerCaptures.forEach(attemptReplayContinuousQueuedEventInMap);
        }

        function scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
          if (queuedEvent.blockedOn === unblocked) {
            queuedEvent.blockedOn = null;

            if (!hasScheduledReplayAttempt) {
              hasScheduledReplayAttempt = true; // Schedule a callback to attempt replaying as many events as are
              // now unblocked. This first might not actually be unblocked yet.
              // We could check it early to avoid scheduling an unnecessary callback.

              Scheduler.unstable_scheduleCallback(Scheduler.unstable_NormalPriority, replayUnblockedEvents);
            }
          }
        }

        function retryIfBlockedOn(unblocked) {
          // Mark anything that was blocked on this as no longer blocked
          // and eligible for a replay.
          if (queuedDiscreteEvents.length > 0) {
            scheduleCallbackIfUnblocked(queuedDiscreteEvents[0], unblocked); // This is a exponential search for each boundary that commits. I think it's
            // worth it because we expect very few discrete events to queue up and once
            // we are actually fully unblocked it will be fast to replay them.

            for (var i = 1; i < queuedDiscreteEvents.length; i++) {
              var queuedEvent = queuedDiscreteEvents[i];

              if (queuedEvent.blockedOn === unblocked) {
                queuedEvent.blockedOn = null;
              }
            }
          }

          if (queuedFocus !== null) {
            scheduleCallbackIfUnblocked(queuedFocus, unblocked);
          }

          if (queuedDrag !== null) {
            scheduleCallbackIfUnblocked(queuedDrag, unblocked);
          }

          if (queuedMouse !== null) {
            scheduleCallbackIfUnblocked(queuedMouse, unblocked);
          }

          var unblock = function unblock(queuedEvent) {
            return scheduleCallbackIfUnblocked(queuedEvent, unblocked);
          };

          queuedPointers.forEach(unblock);
          queuedPointerCaptures.forEach(unblock);

          for (var _i = 0; _i < queuedExplicitHydrationTargets.length; _i++) {
            var queuedTarget = queuedExplicitHydrationTargets[_i];

            if (queuedTarget.blockedOn === unblocked) {
              queuedTarget.blockedOn = null;
            }
          }

          while (queuedExplicitHydrationTargets.length > 0) {
            var nextExplicitTarget = queuedExplicitHydrationTargets[0];

            if (nextExplicitTarget.blockedOn !== null) {
              // We're still blocked.
              break;
            } else {
              attemptExplicitHydrationTarget(nextExplicitTarget);

              if (nextExplicitTarget.blockedOn === null) {
                // We're unblocked.
                queuedExplicitHydrationTargets.shift();
              }
            }
          }
        }

        var DiscreteEvent = 0;
        var UserBlockingEvent = 1;
        var ContinuousEvent = 2;
        /**
         * Generate a mapping of standard vendor prefixes using the defined style property and event name.
         *
         * @param {string} styleProp
         * @param {string} eventName
         * @returns {object}
         */

        function makePrefixMap(styleProp, eventName) {
          var prefixes = {};
          prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
          prefixes['Webkit' + styleProp] = 'webkit' + eventName;
          prefixes['Moz' + styleProp] = 'moz' + eventName;
          return prefixes;
        }
        /**
         * A list of event names to a configurable list of vendor prefixes.
         */


        var vendorPrefixes = {
          animationend: makePrefixMap('Animation', 'AnimationEnd'),
          animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
          animationstart: makePrefixMap('Animation', 'AnimationStart'),
          transitionend: makePrefixMap('Transition', 'TransitionEnd')
        };
        /**
         * Event names that have already been detected and prefixed (if applicable).
         */

        var prefixedEventNames = {};
        /**
         * Element to check for prefixes on.
         */

        var style = {};
        /**
         * Bootstrap if a DOM exists.
         */

        if (canUseDOM) {
          style = document.createElement('div').style; // On some platforms, in particular some releases of Android 4.x,
          // the un-prefixed "animation" and "transition" properties are defined on the
          // style object but the events that fire will still be prefixed, so we need
          // to check if the un-prefixed events are usable, and if not remove them from the map.

          if (!('AnimationEvent' in window)) {
            delete vendorPrefixes.animationend.animation;
            delete vendorPrefixes.animationiteration.animation;
            delete vendorPrefixes.animationstart.animation;
          } // Same as above


          if (!('TransitionEvent' in window)) {
            delete vendorPrefixes.transitionend.transition;
          }
        }
        /**
         * Attempts to determine the correct vendor prefixed event name.
         *
         * @param {string} eventName
         * @returns {string}
         */


        function getVendorPrefixedEventName(eventName) {
          if (prefixedEventNames[eventName]) {
            return prefixedEventNames[eventName];
          } else if (!vendorPrefixes[eventName]) {
            return eventName;
          }

          var prefixMap = vendorPrefixes[eventName];

          for (var styleProp in prefixMap) {
            if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
              return prefixedEventNames[eventName] = prefixMap[styleProp];
            }
          }

          return eventName;
        }

        var ANIMATION_END = getVendorPrefixedEventName('animationend');
        var ANIMATION_ITERATION = getVendorPrefixedEventName('animationiteration');
        var ANIMATION_START = getVendorPrefixedEventName('animationstart');
        var TRANSITION_END = getVendorPrefixedEventName('transitionend');
        var topLevelEventsToReactNames = new Map();
        var eventPriorities = new Map(); // We store most of the events in this module in pairs of two strings so we can re-use
        // the code required to apply the same logic for event prioritization and that of the
        // SimpleEventPlugin. This complicates things slightly, but the aim is to reduce code
        // duplication (for which there would be quite a bit). For the events that are not needed
        // for the SimpleEventPlugin (otherDiscreteEvents) we process them separately as an
        // array of top level events.
        // Lastly, we ignore prettier so we can keep the formatting sane.
        // prettier-ignore

        var discreteEventPairsForSimpleEventPlugin = ['cancel', 'cancel', 'click', 'click', 'close', 'close', 'contextmenu', 'contextMenu', 'copy', 'copy', 'cut', 'cut', 'auxclick', 'auxClick', 'dblclick', 'doubleClick', // Careful!
        'dragend', 'dragEnd', 'dragstart', 'dragStart', 'drop', 'drop', 'focusin', 'focus', // Careful!
        'focusout', 'blur', // Careful!
        'input', 'input', 'invalid', 'invalid', 'keydown', 'keyDown', 'keypress', 'keyPress', 'keyup', 'keyUp', 'mousedown', 'mouseDown', 'mouseup', 'mouseUp', 'paste', 'paste', 'pause', 'pause', 'play', 'play', 'pointercancel', 'pointerCancel', 'pointerdown', 'pointerDown', 'pointerup', 'pointerUp', 'ratechange', 'rateChange', 'reset', 'reset', 'seeked', 'seeked', 'submit', 'submit', 'touchcancel', 'touchCancel', 'touchend', 'touchEnd', 'touchstart', 'touchStart', 'volumechange', 'volumeChange'];
        var otherDiscreteEvents = ['change', 'selectionchange', 'textInput', 'compositionstart', 'compositionend', 'compositionupdate'];
        var userBlockingPairsForSimpleEventPlugin = ['drag', 'drag', 'dragenter', 'dragEnter', 'dragexit', 'dragExit', 'dragleave', 'dragLeave', 'dragover', 'dragOver', 'mousemove', 'mouseMove', 'mouseout', 'mouseOut', 'mouseover', 'mouseOver', 'pointermove', 'pointerMove', 'pointerout', 'pointerOut', 'pointerover', 'pointerOver', 'scroll', 'scroll', 'toggle', 'toggle', 'touchmove', 'touchMove', 'wheel', 'wheel']; // prettier-ignore

        var continuousPairsForSimpleEventPlugin = ['abort', 'abort', ANIMATION_END, 'animationEnd', ANIMATION_ITERATION, 'animationIteration', ANIMATION_START, 'animationStart', 'canplay', 'canPlay', 'canplaythrough', 'canPlayThrough', 'durationchange', 'durationChange', 'emptied', 'emptied', 'encrypted', 'encrypted', 'ended', 'ended', 'error', 'error', 'gotpointercapture', 'gotPointerCapture', 'load', 'load', 'loadeddata', 'loadedData', 'loadedmetadata', 'loadedMetadata', 'loadstart', 'loadStart', 'lostpointercapture', 'lostPointerCapture', 'playing', 'playing', 'progress', 'progress', 'seeking', 'seeking', 'stalled', 'stalled', 'suspend', 'suspend', 'timeupdate', 'timeUpdate', TRANSITION_END, 'transitionEnd', 'waiting', 'waiting'];
        /**
         * Turns
         * ['abort', ...]
         *
         * into
         *
         * topLevelEventsToReactNames = new Map([
         *   ['abort', 'onAbort'],
         * ]);
         *
         * and registers them.
         */

        function registerSimplePluginEventsAndSetTheirPriorities(eventTypes, priority) {
          // As the event types are in pairs of two, we need to iterate
          // through in twos. The events are in pairs of two to save code
          // and improve init perf of processing this array, as it will
          // result in far fewer object allocations and property accesses
          // if we only use three arrays to process all the categories of
          // instead of tuples.
          for (var i = 0; i < eventTypes.length; i += 2) {
            var topEvent = eventTypes[i];
            var event = eventTypes[i + 1];
            var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
            var reactName = 'on' + capitalizedEvent;
            eventPriorities.set(topEvent, priority);
            topLevelEventsToReactNames.set(topEvent, reactName);
            registerTwoPhaseEvent(reactName, [topEvent]);
          }
        }

        function setEventPriorities(eventTypes, priority) {
          for (var i = 0; i < eventTypes.length; i++) {
            eventPriorities.set(eventTypes[i], priority);
          }
        }

        function getEventPriorityForPluginSystem(domEventName) {
          var priority = eventPriorities.get(domEventName); // Default to a ContinuousEvent. Note: we might
          // want to warn if we can't detect the priority
          // for the event.

          return priority === undefined ? ContinuousEvent : priority;
        }

        function registerSimpleEvents() {
          registerSimplePluginEventsAndSetTheirPriorities(discreteEventPairsForSimpleEventPlugin, DiscreteEvent);
          registerSimplePluginEventsAndSetTheirPriorities(userBlockingPairsForSimpleEventPlugin, UserBlockingEvent);
          registerSimplePluginEventsAndSetTheirPriorities(continuousPairsForSimpleEventPlugin, ContinuousEvent);
          setEventPriorities(otherDiscreteEvents, DiscreteEvent);
        }

        var Scheduler_now = Scheduler.unstable_now;
        {
          // Provide explicit error message when production+profiling bundle of e.g.
          // react-dom is used with production (non-profiling) bundle of
          // scheduler/tracing
          if (!(tracing.__interactionsRef != null && tracing.__interactionsRef.current != null)) {
            {
              throw Error("It is not supported to run the profiling version of a renderer (for example, `react-dom/profiling`) without also replacing the `scheduler/tracing` module with `scheduler/tracing-profiling`. Your bundler might have a setting for aliasing both modules. Learn more at https://reactjs.org/link/profiling");
            }
          }
        } // ascending numbers so we can compare them like numbers. They start at 90 to
        // avoid clashing with Scheduler's priorities.

        var ImmediatePriority = 99;
        var UserBlockingPriority = 98;
        var NormalPriority = 97;
        var LowPriority = 96;
        var IdlePriority = 95; // NoPriority is the absence of priority. Also React-only.

        var NoPriority = 90;
        var initialTimeMs = Scheduler_now(); // If the initial timestamp is reasonably small, use Scheduler's `now` directly.

        var SyncLanePriority = 15;
        var SyncBatchedLanePriority = 14;
        var InputDiscreteHydrationLanePriority = 13;
        var InputDiscreteLanePriority = 12;
        var InputContinuousHydrationLanePriority = 11;
        var InputContinuousLanePriority = 10;
        var DefaultHydrationLanePriority = 9;
        var DefaultLanePriority = 8;
        var TransitionHydrationPriority = 7;
        var TransitionPriority = 6;
        var RetryLanePriority = 5;
        var SelectiveHydrationLanePriority = 4;
        var IdleHydrationLanePriority = 3;
        var IdleLanePriority = 2;
        var OffscreenLanePriority = 1;
        var NoLanePriority = 0;
        var TotalLanes = 31;
        var NoLanes =
        /*                        */
        0;
        var NoLane =
        /*                          */
        0;
        var SyncLane =
        /*                        */
        1;
        var SyncBatchedLane =
        /*                 */
        2;
        var InputDiscreteHydrationLane =
        /*      */
        4;
        var InputDiscreteLanes =
        /*                    */
        24;
        var InputContinuousHydrationLane =
        /*           */
        32;
        var InputContinuousLanes =
        /*                  */
        192;
        var DefaultHydrationLane =
        /*            */
        256;
        var DefaultLanes =
        /*                   */
        3584;
        var TransitionHydrationLane =
        /*                */
        4096;
        var TransitionLanes =
        /*                       */
        4186112;
        var RetryLanes =
        /*                            */
        62914560;
        var SomeRetryLane =
        /*                  */
        33554432;
        var SelectiveHydrationLane =
        /*          */
        67108864;
        var NonIdleLanes =
        /*                                 */
        134217727;
        var IdleHydrationLane =
        /*               */
        134217728;
        var IdleLanes =
        /*                             */
        805306368;
        var OffscreenLane =
        /*                   */
        1073741824;
        var NoTimestamp = -1;

        function setCurrentUpdateLanePriority(newLanePriority) {} // "Registers" used to "return" multiple values
        // Used by getHighestPriorityLanes and getNextLanes:


        var return_highestLanePriority = DefaultLanePriority;

        function getHighestPriorityLanes(lanes) {
          if ((SyncLane & lanes) !== NoLanes) {
            return_highestLanePriority = SyncLanePriority;
            return SyncLane;
          }

          if ((SyncBatchedLane & lanes) !== NoLanes) {
            return_highestLanePriority = SyncBatchedLanePriority;
            return SyncBatchedLane;
          }

          if ((InputDiscreteHydrationLane & lanes) !== NoLanes) {
            return_highestLanePriority = InputDiscreteHydrationLanePriority;
            return InputDiscreteHydrationLane;
          }

          var inputDiscreteLanes = InputDiscreteLanes & lanes;

          if (inputDiscreteLanes !== NoLanes) {
            return_highestLanePriority = InputDiscreteLanePriority;
            return inputDiscreteLanes;
          }

          if ((lanes & InputContinuousHydrationLane) !== NoLanes) {
            return_highestLanePriority = InputContinuousHydrationLanePriority;
            return InputContinuousHydrationLane;
          }

          var inputContinuousLanes = InputContinuousLanes & lanes;

          if (inputContinuousLanes !== NoLanes) {
            return_highestLanePriority = InputContinuousLanePriority;
            return inputContinuousLanes;
          }

          if ((lanes & DefaultHydrationLane) !== NoLanes) {
            return_highestLanePriority = DefaultHydrationLanePriority;
            return DefaultHydrationLane;
          }

          var defaultLanes = DefaultLanes & lanes;

          if (defaultLanes !== NoLanes) {
            return_highestLanePriority = DefaultLanePriority;
            return defaultLanes;
          }

          if ((lanes & TransitionHydrationLane) !== NoLanes) {
            return_highestLanePriority = TransitionHydrationPriority;
            return TransitionHydrationLane;
          }

          var transitionLanes = TransitionLanes & lanes;

          if (transitionLanes !== NoLanes) {
            return_highestLanePriority = TransitionPriority;
            return transitionLanes;
          }

          var retryLanes = RetryLanes & lanes;

          if (retryLanes !== NoLanes) {
            return_highestLanePriority = RetryLanePriority;
            return retryLanes;
          }

          if (lanes & SelectiveHydrationLane) {
            return_highestLanePriority = SelectiveHydrationLanePriority;
            return SelectiveHydrationLane;
          }

          if ((lanes & IdleHydrationLane) !== NoLanes) {
            return_highestLanePriority = IdleHydrationLanePriority;
            return IdleHydrationLane;
          }

          var idleLanes = IdleLanes & lanes;

          if (idleLanes !== NoLanes) {
            return_highestLanePriority = IdleLanePriority;
            return idleLanes;
          }

          if ((OffscreenLane & lanes) !== NoLanes) {
            return_highestLanePriority = OffscreenLanePriority;
            return OffscreenLane;
          }

          {
            error('Should have found matching lanes. This is a bug in React.');
          } // This shouldn't be reachable, but as a fallback, return the entire bitmask.

          return_highestLanePriority = DefaultLanePriority;
          return lanes;
        }

        function schedulerPriorityToLanePriority(schedulerPriorityLevel) {
          switch (schedulerPriorityLevel) {
            case ImmediatePriority:
              return SyncLanePriority;

            case UserBlockingPriority:
              return InputContinuousLanePriority;

            case NormalPriority:
            case LowPriority:
              // TODO: Handle LowSchedulerPriority, somehow. Maybe the same lane as hydration.
              return DefaultLanePriority;

            case IdlePriority:
              return IdleLanePriority;

            default:
              return NoLanePriority;
          }
        }

        function lanePriorityToSchedulerPriority(lanePriority) {
          switch (lanePriority) {
            case SyncLanePriority:
            case SyncBatchedLanePriority:
              return ImmediatePriority;

            case InputDiscreteHydrationLanePriority:
            case InputDiscreteLanePriority:
            case InputContinuousHydrationLanePriority:
            case InputContinuousLanePriority:
              return UserBlockingPriority;

            case DefaultHydrationLanePriority:
            case DefaultLanePriority:
            case TransitionHydrationPriority:
            case TransitionPriority:
            case SelectiveHydrationLanePriority:
            case RetryLanePriority:
              return NormalPriority;

            case IdleHydrationLanePriority:
            case IdleLanePriority:
            case OffscreenLanePriority:
              return IdlePriority;

            case NoLanePriority:
              return NoPriority;

            default:
              {
                {
                  throw Error("Invalid update priority: " + lanePriority + ". This is a bug in React.");
                }
              }
          }
        }

        function getNextLanes(root, wipLanes) {
          // Early bailout if there's no pending work left.
          var pendingLanes = root.pendingLanes;

          if (pendingLanes === NoLanes) {
            return_highestLanePriority = NoLanePriority;
            return NoLanes;
          }

          var nextLanes = NoLanes;
          var nextLanePriority = NoLanePriority;
          var expiredLanes = root.expiredLanes;
          var suspendedLanes = root.suspendedLanes;
          var pingedLanes = root.pingedLanes; // Check if any work has expired.

          if (expiredLanes !== NoLanes) {
            nextLanes = expiredLanes;
            nextLanePriority = return_highestLanePriority = SyncLanePriority;
          } else {
            // Do not work on any idle work until all the non-idle work has finished,
            // even if the work is suspended.
            var nonIdlePendingLanes = pendingLanes & NonIdleLanes;

            if (nonIdlePendingLanes !== NoLanes) {
              var nonIdleUnblockedLanes = nonIdlePendingLanes & ~suspendedLanes;

              if (nonIdleUnblockedLanes !== NoLanes) {
                nextLanes = getHighestPriorityLanes(nonIdleUnblockedLanes);
                nextLanePriority = return_highestLanePriority;
              } else {
                var nonIdlePingedLanes = nonIdlePendingLanes & pingedLanes;

                if (nonIdlePingedLanes !== NoLanes) {
                  nextLanes = getHighestPriorityLanes(nonIdlePingedLanes);
                  nextLanePriority = return_highestLanePriority;
                }
              }
            } else {
              // The only remaining work is Idle.
              var unblockedLanes = pendingLanes & ~suspendedLanes;

              if (unblockedLanes !== NoLanes) {
                nextLanes = getHighestPriorityLanes(unblockedLanes);
                nextLanePriority = return_highestLanePriority;
              } else {
                if (pingedLanes !== NoLanes) {
                  nextLanes = getHighestPriorityLanes(pingedLanes);
                  nextLanePriority = return_highestLanePriority;
                }
              }
            }
          }

          if (nextLanes === NoLanes) {
            // This should only be reachable if we're suspended
            // TODO: Consider warning in this path if a fallback timer is not scheduled.
            return NoLanes;
          } // If there are higher priority lanes, we'll include them even if they
          // are suspended.


          nextLanes = pendingLanes & getEqualOrHigherPriorityLanes(nextLanes); // If we're already in the middle of a render, switching lanes will interrupt
          // it and we'll lose our progress. We should only do this if the new lanes are
          // higher priority.

          if (wipLanes !== NoLanes && wipLanes !== nextLanes && // If we already suspended with a delay, then interrupting is fine. Don't
          // bother waiting until the root is complete.
          (wipLanes & suspendedLanes) === NoLanes) {
            getHighestPriorityLanes(wipLanes);
            var wipLanePriority = return_highestLanePriority;

            if (nextLanePriority <= wipLanePriority) {
              return wipLanes;
            } else {
              return_highestLanePriority = nextLanePriority;
            }
          } // Check for entangled lanes and add them to the batch.
          //
          // A lane is said to be entangled with another when it's not allowed to render
          // in a batch that does not also include the other lane. Typically we do this
          // when multiple updates have the same source, and we only want to respond to
          // the most recent event from that source.
          //
          // Note that we apply entanglements *after* checking for partial work above.
          // This means that if a lane is entangled during an interleaved event while
          // it's already rendering, we won't interrupt it. This is intentional, since
          // entanglement is usually "best effort": we'll try our best to render the
          // lanes in the same batch, but it's not worth throwing out partially
          // completed work in order to do it.
          //
          // For those exceptions where entanglement is semantically important, like
          // useMutableSource, we should ensure that there is no partial work at the
          // time we apply the entanglement.


          var entangledLanes = root.entangledLanes;

          if (entangledLanes !== NoLanes) {
            var entanglements = root.entanglements;
            var lanes = nextLanes & entangledLanes;

            while (lanes > 0) {
              var index = pickArbitraryLaneIndex(lanes);
              var lane = 1 << index;
              nextLanes |= entanglements[index];
              lanes &= ~lane;
            }
          }

          return nextLanes;
        }

        function getMostRecentEventTime(root, lanes) {
          var eventTimes = root.eventTimes;
          var mostRecentEventTime = NoTimestamp;

          while (lanes > 0) {
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            var eventTime = eventTimes[index];

            if (eventTime > mostRecentEventTime) {
              mostRecentEventTime = eventTime;
            }

            lanes &= ~lane;
          }

          return mostRecentEventTime;
        }

        function computeExpirationTime(lane, currentTime) {
          // TODO: Expiration heuristic is constant per lane, so could use a map.
          getHighestPriorityLanes(lane);
          var priority = return_highestLanePriority;

          if (priority >= InputContinuousLanePriority) {
            // User interactions should expire slightly more quickly.
            //
            // NOTE: This is set to the corresponding constant as in Scheduler.js. When
            // we made it larger, a product metric in www regressed, suggesting there's
            // a user interaction that's being starved by a series of synchronous
            // updates. If that theory is correct, the proper solution is to fix the
            // starvation. However, this scenario supports the idea that expiration
            // times are an important safeguard when starvation does happen.
            //
            // Also note that, in the case of user input specifically, this will soon no
            // longer be an issue because we plan to make user input synchronous by
            // default (until you enter `startTransition`, of course.)
            //
            // If weren't planning to make these updates synchronous soon anyway, I
            // would probably make this number a configurable parameter.
            return currentTime + 250;
          } else if (priority >= TransitionPriority) {
            return currentTime + 5000;
          } else {
            // Anything idle priority or lower should never expire.
            return NoTimestamp;
          }
        }

        function markStarvedLanesAsExpired(root, currentTime) {
          // TODO: This gets called every time we yield. We can optimize by storing
          // the earliest expiration time on the root. Then use that to quickly bail out
          // of this function.
          var pendingLanes = root.pendingLanes;
          var suspendedLanes = root.suspendedLanes;
          var pingedLanes = root.pingedLanes;
          var expirationTimes = root.expirationTimes; // Iterate through the pending lanes and check if we've reached their
          // expiration time. If so, we'll assume the update is being starved and mark
          // it as expired to force it to finish.

          var lanes = pendingLanes;

          while (lanes > 0) {
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            var expirationTime = expirationTimes[index];

            if (expirationTime === NoTimestamp) {
              // Found a pending lane with no expiration time. If it's not suspended, or
              // if it's pinged, assume it's CPU-bound. Compute a new expiration time
              // using the current time.
              if ((lane & suspendedLanes) === NoLanes || (lane & pingedLanes) !== NoLanes) {
                // Assumes timestamps are monotonically increasing.
                expirationTimes[index] = computeExpirationTime(lane, currentTime);
              }
            } else if (expirationTime <= currentTime) {
              // This lane expired
              root.expiredLanes |= lane;
            }

            lanes &= ~lane;
          }
        } // This returns the highest priority pending lanes regardless of whether they


        function getLanesToRetrySynchronouslyOnError(root) {
          var everythingButOffscreen = root.pendingLanes & ~OffscreenLane;

          if (everythingButOffscreen !== NoLanes) {
            return everythingButOffscreen;
          }

          if (everythingButOffscreen & OffscreenLane) {
            return OffscreenLane;
          }

          return NoLanes;
        }

        function returnNextLanesPriority() {
          return return_highestLanePriority;
        }

        function includesNonIdleWork(lanes) {
          return (lanes & NonIdleLanes) !== NoLanes;
        }

        function includesOnlyRetries(lanes) {
          return (lanes & RetryLanes) === lanes;
        }

        function includesOnlyTransitions(lanes) {
          return (lanes & TransitionLanes) === lanes;
        } // To ensure consistency across multiple updates in the same event, this should
        // be a pure function, so that it always returns the same lane for given inputs.


        function findUpdateLane(lanePriority, wipLanes) {
          switch (lanePriority) {
            case NoLanePriority:
              break;

            case SyncLanePriority:
              return SyncLane;

            case SyncBatchedLanePriority:
              return SyncBatchedLane;

            case InputDiscreteLanePriority:
              {
                var _lane = pickArbitraryLane(InputDiscreteLanes & ~wipLanes);

                if (_lane === NoLane) {
                  // Shift to the next priority level
                  return findUpdateLane(InputContinuousLanePriority, wipLanes);
                }

                return _lane;
              }

            case InputContinuousLanePriority:
              {
                var _lane2 = pickArbitraryLane(InputContinuousLanes & ~wipLanes);

                if (_lane2 === NoLane) {
                  // Shift to the next priority level
                  return findUpdateLane(DefaultLanePriority, wipLanes);
                }

                return _lane2;
              }

            case DefaultLanePriority:
              {
                var _lane3 = pickArbitraryLane(DefaultLanes & ~wipLanes);

                if (_lane3 === NoLane) {
                  // If all the default lanes are already being worked on, look for a
                  // lane in the transition range.
                  _lane3 = pickArbitraryLane(TransitionLanes & ~wipLanes);

                  if (_lane3 === NoLane) {
                    // All the transition lanes are taken, too. This should be very
                    // rare, but as a last resort, pick a default lane. This will have
                    // the effect of interrupting the current work-in-progress render.
                    _lane3 = pickArbitraryLane(DefaultLanes);
                  }
                }

                return _lane3;
              }

            case TransitionPriority: // Should be handled by findTransitionLane instead

            case RetryLanePriority:
              // Should be handled by findRetryLane instead
              break;

            case IdleLanePriority:
              var lane = pickArbitraryLane(IdleLanes & ~wipLanes);

              if (lane === NoLane) {
                lane = pickArbitraryLane(IdleLanes);
              }

              return lane;
          }

          {
            {
              throw Error("Invalid update priority: " + lanePriority + ". This is a bug in React.");
            }
          }
        } // To ensure consistency across multiple updates in the same event, this should
        // be pure function, so that it always returns the same lane for given inputs.


        function findTransitionLane(wipLanes, pendingLanes) {
          // First look for lanes that are completely unclaimed, i.e. have no
          // pending work.
          var lane = pickArbitraryLane(TransitionLanes & ~pendingLanes);

          if (lane === NoLane) {
            // If all lanes have pending work, look for a lane that isn't currently
            // being worked on.
            lane = pickArbitraryLane(TransitionLanes & ~wipLanes);

            if (lane === NoLane) {
              // If everything is being worked on, pick any lane. This has the
              // effect of interrupting the current work-in-progress.
              lane = pickArbitraryLane(TransitionLanes);
            }
          }

          return lane;
        } // To ensure consistency across multiple updates in the same event, this should
        // be pure function, so that it always returns the same lane for given inputs.


        function findRetryLane(wipLanes) {
          // This is a fork of `findUpdateLane` designed specifically for Suspense
          // "retries" — a special update that attempts to flip a Suspense boundary
          // from its placeholder state to its primary/resolved state.
          var lane = pickArbitraryLane(RetryLanes & ~wipLanes);

          if (lane === NoLane) {
            lane = pickArbitraryLane(RetryLanes);
          }

          return lane;
        }

        function getHighestPriorityLane(lanes) {
          return lanes & -lanes;
        }

        function getLowestPriorityLane(lanes) {
          // This finds the most significant non-zero bit.
          var index = 31 - clz32(lanes);
          return index < 0 ? NoLanes : 1 << index;
        }

        function getEqualOrHigherPriorityLanes(lanes) {
          return (getLowestPriorityLane(lanes) << 1) - 1;
        }

        function pickArbitraryLane(lanes) {
          // This wrapper function gets inlined. Only exists so to communicate that it
          // doesn't matter which bit is selected; you can pick any bit without
          // affecting the algorithms where its used. Here I'm using
          // getHighestPriorityLane because it requires the fewest operations.
          return getHighestPriorityLane(lanes);
        }

        function pickArbitraryLaneIndex(lanes) {
          return 31 - clz32(lanes);
        }

        function laneToIndex(lane) {
          return pickArbitraryLaneIndex(lane);
        }

        function includesSomeLane(a, b) {
          return (a & b) !== NoLanes;
        }

        function isSubsetOfLanes(set, subset) {
          return (set & subset) === subset;
        }

        function mergeLanes(a, b) {
          return a | b;
        }

        function removeLanes(set, subset) {
          return set & ~subset;
        } // Seems redundant, but it changes the type from a single lane (used for
        // updates) to a group of lanes (used for flushing work).


        function laneToLanes(lane) {
          return lane;
        }

        function higherPriorityLane(a, b) {
          // This works because the bit ranges decrease in priority as you go left.
          return a !== NoLane && a < b ? a : b;
        }

        function createLaneMap(initial) {
          // Intentionally pushing one by one.
          // https://v8.dev/blog/elements-kinds#avoid-creating-holes
          var laneMap = [];

          for (var i = 0; i < TotalLanes; i++) {
            laneMap.push(initial);
          }

          return laneMap;
        }

        function markRootUpdated(root, updateLane, eventTime) {
          root.pendingLanes |= updateLane; // TODO: Theoretically, any update to any lane can unblock any other lane. But
          // it's not practical to try every single possible combination. We need a
          // heuristic to decide which lanes to attempt to render, and in which batches.
          // For now, we use the same heuristic as in the old ExpirationTimes model:
          // retry any lane at equal or lower priority, but don't try updates at higher
          // priority without also including the lower priority updates. This works well
          // when considering updates across different priority levels, but isn't
          // sufficient for updates within the same priority, since we want to treat
          // those updates as parallel.
          // Unsuspend any update at equal or lower priority.

          var higherPriorityLanes = updateLane - 1; // Turns 0b1000 into 0b0111

          root.suspendedLanes &= higherPriorityLanes;
          root.pingedLanes &= higherPriorityLanes;
          var eventTimes = root.eventTimes;
          var index = laneToIndex(updateLane); // We can always overwrite an existing timestamp because we prefer the most
          // recent event, and we assume time is monotonically increasing.

          eventTimes[index] = eventTime;
        }

        function markRootSuspended(root, suspendedLanes) {
          root.suspendedLanes |= suspendedLanes;
          root.pingedLanes &= ~suspendedLanes; // The suspended lanes are no longer CPU-bound. Clear their expiration times.

          var expirationTimes = root.expirationTimes;
          var lanes = suspendedLanes;

          while (lanes > 0) {
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            expirationTimes[index] = NoTimestamp;
            lanes &= ~lane;
          }
        }

        function markRootPinged(root, pingedLanes, eventTime) {
          root.pingedLanes |= root.suspendedLanes & pingedLanes;
        }

        function markDiscreteUpdatesExpired(root) {
          root.expiredLanes |= InputDiscreteLanes & root.pendingLanes;
        }

        function hasDiscreteLanes(lanes) {
          return (lanes & InputDiscreteLanes) !== NoLanes;
        }

        function markRootMutableRead(root, updateLane) {
          root.mutableReadLanes |= updateLane & root.pendingLanes;
        }

        function markRootFinished(root, remainingLanes) {
          var noLongerPendingLanes = root.pendingLanes & ~remainingLanes;
          root.pendingLanes = remainingLanes; // Let's try everything again

          root.suspendedLanes = 0;
          root.pingedLanes = 0;
          root.expiredLanes &= remainingLanes;
          root.mutableReadLanes &= remainingLanes;
          root.entangledLanes &= remainingLanes;
          var entanglements = root.entanglements;
          var eventTimes = root.eventTimes;
          var expirationTimes = root.expirationTimes; // Clear the lanes that no longer have pending work

          var lanes = noLongerPendingLanes;

          while (lanes > 0) {
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            entanglements[index] = NoLanes;
            eventTimes[index] = NoTimestamp;
            expirationTimes[index] = NoTimestamp;
            lanes &= ~lane;
          }
        }

        function markRootEntangled(root, entangledLanes) {
          root.entangledLanes |= entangledLanes;
          var entanglements = root.entanglements;
          var lanes = entangledLanes;

          while (lanes > 0) {
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            entanglements[index] |= entangledLanes;
            lanes &= ~lane;
          }
        }

        var clz32 = Math.clz32 ? Math.clz32 : clz32Fallback; // Count leading zeros. Only used on lanes, so assume input is an integer.
        // Based on:
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/clz32

        var log = Math.log;
        var LN2 = Math.LN2;

        function clz32Fallback(lanes) {
          if (lanes === 0) {
            return 32;
          }

          return 31 - (log(lanes) / LN2 | 0) | 0;
        } // Intentionally not named imports because Rollup would use dynamic dispatch for


        var UserBlockingPriority$1 = Scheduler.unstable_UserBlockingPriority,
            runWithPriority = Scheduler.unstable_runWithPriority; // TODO: can we stop exporting these?

        var _enabled = true; // This is exported in FB builds for use by legacy FB layer infra.
        // We'd like to remove this but it's not clear if this is safe.

        function setEnabled(enabled) {
          _enabled = !!enabled;
        }

        function isEnabled() {
          return _enabled;
        }

        function createEventListenerWrapperWithPriority(targetContainer, domEventName, eventSystemFlags) {
          var eventPriority = getEventPriorityForPluginSystem(domEventName);
          var listenerWrapper;

          switch (eventPriority) {
            case DiscreteEvent:
              listenerWrapper = dispatchDiscreteEvent;
              break;

            case UserBlockingEvent:
              listenerWrapper = dispatchUserBlockingUpdate;
              break;

            case ContinuousEvent:
            default:
              listenerWrapper = dispatchEvent;
              break;
          }

          return listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
        }

        function dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
          {
            flushDiscreteUpdatesIfNeeded(nativeEvent.timeStamp);
          }
          discreteUpdates(dispatchEvent, domEventName, eventSystemFlags, container, nativeEvent);
        }

        function dispatchUserBlockingUpdate(domEventName, eventSystemFlags, container, nativeEvent) {
          {
            runWithPriority(UserBlockingPriority$1, dispatchEvent.bind(null, domEventName, eventSystemFlags, container, nativeEvent));
          }
        }

        function dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
          if (!_enabled) {
            return;
          }

          var allowReplay = true;
          {
            // TODO: replaying capture phase events is currently broken
            // because we used to do it during top-level native bubble handlers
            // but now we use different bubble and capture handlers.
            // In eager mode, we attach capture listeners early, so we need
            // to filter them out until we fix the logic to handle them correctly.
            // This could've been outside the flag but I put it inside to reduce risk.
            allowReplay = (eventSystemFlags & IS_CAPTURE_PHASE) === 0;
          }

          if (allowReplay && hasQueuedDiscreteEvents() && isReplayableDiscreteEvent(domEventName)) {
            // If we already have a queue of discrete events, and this is another discrete
            // event, then we can't dispatch it regardless of its target, since they
            // need to dispatch in order.
            queueDiscreteEvent(null, // Flags that we're not actually blocked on anything as far as we know.
            domEventName, eventSystemFlags, targetContainer, nativeEvent);
            return;
          }

          var blockedOn = attemptToDispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent);

          if (blockedOn === null) {
            // We successfully dispatched this event.
            if (allowReplay) {
              clearIfContinuousEvent(domEventName, nativeEvent);
            }

            return;
          }

          if (allowReplay) {
            if (isReplayableDiscreteEvent(domEventName)) {
              // This this to be replayed later once the target is available.
              queueDiscreteEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent);
              return;
            }

            if (queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) {
              return;
            } // We need to clear only if we didn't queue because
            // queueing is accummulative.


            clearIfContinuousEvent(domEventName, nativeEvent);
          } // This is not replayable so we'll invoke it but without a target,
          // in case the event system needs to trace it.


          dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
        } // Attempt dispatching an event. Returns a SuspenseInstance or Container if it's blocked.


        function attemptToDispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
          // TODO: Warn if _enabled is false.
          var nativeEventTarget = getEventTarget(nativeEvent);
          var targetInst = getClosestInstanceFromNode(nativeEventTarget);

          if (targetInst !== null) {
            var nearestMounted = getNearestMountedFiber(targetInst);

            if (nearestMounted === null) {
              // This tree has been unmounted already. Dispatch without a target.
              targetInst = null;
            } else {
              var tag = nearestMounted.tag;

              if (tag === SuspenseComponent) {
                var instance = getSuspenseInstanceFromFiber(nearestMounted);

                if (instance !== null) {
                  // Queue the event to be replayed later. Abort dispatching since we
                  // don't want this event dispatched twice through the event system.
                  // TODO: If this is the first discrete event in the queue. Schedule an increased
                  // priority for this boundary.
                  return instance;
                } // This shouldn't happen, something went wrong but to avoid blocking
                // the whole system, dispatch the event without a target.
                // TODO: Warn.


                targetInst = null;
              } else if (tag === HostRoot) {
                var root = nearestMounted.stateNode;

                if (root.hydrate) {
                  // If this happens during a replay something went wrong and it might block
                  // the whole system.
                  return getContainerFromFiber(nearestMounted);
                }

                targetInst = null;
              } else if (nearestMounted !== targetInst) {
                // If we get an event (ex: img onload) before committing that
                // component's mount, ignore it for now (that is, treat it as if it was an
                // event on a non-React tree). We might also consider queueing events and
                // dispatching them after the mount.
                targetInst = null;
              }
            }
          }

          dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst, targetContainer); // We're not blocked on anything.

          return null;
        }

        function addEventBubbleListener(target, eventType, listener) {
          target.addEventListener(eventType, listener, false);
          return listener;
        }

        function addEventCaptureListener(target, eventType, listener) {
          target.addEventListener(eventType, listener, true);
          return listener;
        }

        function addEventCaptureListenerWithPassiveFlag(target, eventType, listener, passive) {
          target.addEventListener(eventType, listener, {
            capture: true,
            passive: passive
          });
          return listener;
        }

        function addEventBubbleListenerWithPassiveFlag(target, eventType, listener, passive) {
          target.addEventListener(eventType, listener, {
            passive: passive
          });
          return listener;
        }
        /**
         * These variables store information about text content of a target node,
         * allowing comparison of content before and after a given event.
         *
         * Identify the node where selection currently begins, then observe
         * both its text content and its current position in the DOM. Since the
         * browser may natively replace the target node during composition, we can
         * use its position to find its replacement.
         *
         *
         */


        var root = null;
        var startText = null;
        var fallbackText = null;

        function initialize(nativeEventTarget) {
          root = nativeEventTarget;
          startText = getText();
          return true;
        }

        function reset() {
          root = null;
          startText = null;
          fallbackText = null;
        }

        function getData() {
          if (fallbackText) {
            return fallbackText;
          }

          var start;
          var startValue = startText;
          var startLength = startValue.length;
          var end;
          var endValue = getText();
          var endLength = endValue.length;

          for (start = 0; start < startLength; start++) {
            if (startValue[start] !== endValue[start]) {
              break;
            }
          }

          var minEnd = startLength - start;

          for (end = 1; end <= minEnd; end++) {
            if (startValue[startLength - end] !== endValue[endLength - end]) {
              break;
            }
          }

          var sliceTail = end > 1 ? 1 - end : undefined;
          fallbackText = endValue.slice(start, sliceTail);
          return fallbackText;
        }

        function getText() {
          if ('value' in root) {
            return root.value;
          }

          return root.textContent;
        }
        /**
         * `charCode` represents the actual "character code" and is safe to use with
         * `String.fromCharCode`. As such, only keys that correspond to printable
         * characters produce a valid `charCode`, the only exception to this is Enter.
         * The Tab-key is considered non-printable and does not have a `charCode`,
         * presumably because it does not produce a tab-character in browsers.
         *
         * @param {object} nativeEvent Native browser event.
         * @return {number} Normalized `charCode` property.
         */


        function getEventCharCode(nativeEvent) {
          var charCode;
          var keyCode = nativeEvent.keyCode;

          if ('charCode' in nativeEvent) {
            charCode = nativeEvent.charCode; // FF does not set `charCode` for the Enter-key, check against `keyCode`.

            if (charCode === 0 && keyCode === 13) {
              charCode = 13;
            }
          } else {
            // IE8 does not implement `charCode`, but `keyCode` has the correct value.
            charCode = keyCode;
          } // IE and Edge (on Windows) and Chrome / Safari (on Windows and Linux)
          // report Enter as charCode 10 when ctrl is pressed.


          if (charCode === 10) {
            charCode = 13;
          } // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
          // Must not discard the (non-)printable Enter-key.


          if (charCode >= 32 || charCode === 13) {
            return charCode;
          }

          return 0;
        }

        function functionThatReturnsTrue() {
          return true;
        }

        function functionThatReturnsFalse() {
          return false;
        } // This is intentionally a factory so that we have different returned constructors.
        // If we had a single constructor, it would be megamorphic and engines would deopt.


        function createSyntheticEvent(Interface) {
          /**
           * Synthetic events are dispatched by event plugins, typically in response to a
           * top-level event delegation handler.
           *
           * These systems should generally use pooling to reduce the frequency of garbage
           * collection. The system should check `isPersistent` to determine whether the
           * event should be released into the pool after being dispatched. Users that
           * need a persisted event should invoke `persist`.
           *
           * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
           * normalizing browser quirks. Subclasses do not necessarily have to implement a
           * DOM interface; custom application-specific events can also subclass this.
           */
          function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
            this._reactName = reactName;
            this._targetInst = targetInst;
            this.type = reactEventType;
            this.nativeEvent = nativeEvent;
            this.target = nativeEventTarget;
            this.currentTarget = null;

            for (var _propName in Interface) {
              if (!Interface.hasOwnProperty(_propName)) {
                continue;
              }

              var normalize = Interface[_propName];

              if (normalize) {
                this[_propName] = normalize(nativeEvent);
              } else {
                this[_propName] = nativeEvent[_propName];
              }
            }

            var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;

            if (defaultPrevented) {
              this.isDefaultPrevented = functionThatReturnsTrue;
            } else {
              this.isDefaultPrevented = functionThatReturnsFalse;
            }

            this.isPropagationStopped = functionThatReturnsFalse;
            return this;
          }

          _assign(SyntheticBaseEvent.prototype, {
            preventDefault: function preventDefault() {
              this.defaultPrevented = true;
              var event = this.nativeEvent;

              if (!event) {
                return;
              }

              if (event.preventDefault) {
                event.preventDefault(); // $FlowFixMe - flow is not aware of `unknown` in IE
              } else if (typeof event.returnValue !== 'unknown') {
                event.returnValue = false;
              }

              this.isDefaultPrevented = functionThatReturnsTrue;
            },
            stopPropagation: function stopPropagation() {
              var event = this.nativeEvent;

              if (!event) {
                return;
              }

              if (event.stopPropagation) {
                event.stopPropagation(); // $FlowFixMe - flow is not aware of `unknown` in IE
              } else if (typeof event.cancelBubble !== 'unknown') {
                // The ChangeEventPlugin registers a "propertychange" event for
                // IE. This event does not support bubbling or cancelling, and
                // any references to cancelBubble throw "Member not found".  A
                // typeof check of "unknown" circumvents this issue (and is also
                // IE specific).
                event.cancelBubble = true;
              }

              this.isPropagationStopped = functionThatReturnsTrue;
            },

            /**
             * We release all dispatched `SyntheticEvent`s after each event loop, adding
             * them back into the pool. This allows a way to hold onto a reference that
             * won't be added back into the pool.
             */
            persist: function persist() {// Modern event system doesn't use pooling.
            },

            /**
             * Checks if this event should be released back into the pool.
             *
             * @return {boolean} True if this should not be released, false otherwise.
             */
            isPersistent: functionThatReturnsTrue
          });

          return SyntheticBaseEvent;
        }
        /**
         * @interface Event
         * @see http://www.w3.org/TR/DOM-Level-3-Events/
         */


        var EventInterface = {
          eventPhase: 0,
          bubbles: 0,
          cancelable: 0,
          timeStamp: function timeStamp(event) {
            return event.timeStamp || Date.now();
          },
          defaultPrevented: 0,
          isTrusted: 0
        };
        var SyntheticEvent = createSyntheticEvent(EventInterface);

        var UIEventInterface = _assign({}, EventInterface, {
          view: 0,
          detail: 0
        });

        var SyntheticUIEvent = createSyntheticEvent(UIEventInterface);
        var lastMovementX;
        var lastMovementY;
        var lastMouseEvent;

        function updateMouseMovementPolyfillState(event) {
          if (event !== lastMouseEvent) {
            if (lastMouseEvent && event.type === 'mousemove') {
              lastMovementX = event.screenX - lastMouseEvent.screenX;
              lastMovementY = event.screenY - lastMouseEvent.screenY;
            } else {
              lastMovementX = 0;
              lastMovementY = 0;
            }

            lastMouseEvent = event;
          }
        }
        /**
         * @interface MouseEvent
         * @see http://www.w3.org/TR/DOM-Level-3-Events/
         */


        var MouseEventInterface = _assign({}, UIEventInterface, {
          screenX: 0,
          screenY: 0,
          clientX: 0,
          clientY: 0,
          pageX: 0,
          pageY: 0,
          ctrlKey: 0,
          shiftKey: 0,
          altKey: 0,
          metaKey: 0,
          getModifierState: getEventModifierState,
          button: 0,
          buttons: 0,
          relatedTarget: function relatedTarget(event) {
            if (event.relatedTarget === undefined) return event.fromElement === event.srcElement ? event.toElement : event.fromElement;
            return event.relatedTarget;
          },
          movementX: function movementX(event) {
            if ('movementX' in event) {
              return event.movementX;
            }

            updateMouseMovementPolyfillState(event);
            return lastMovementX;
          },
          movementY: function movementY(event) {
            if ('movementY' in event) {
              return event.movementY;
            } // Don't need to call updateMouseMovementPolyfillState() here
            // because it's guaranteed to have already run when movementX
            // was copied.


            return lastMovementY;
          }
        });

        var SyntheticMouseEvent = createSyntheticEvent(MouseEventInterface);
        /**
         * @interface DragEvent
         * @see http://www.w3.org/TR/DOM-Level-3-Events/
         */

        var DragEventInterface = _assign({}, MouseEventInterface, {
          dataTransfer: 0
        });

        var SyntheticDragEvent = createSyntheticEvent(DragEventInterface);
        /**
         * @interface FocusEvent
         * @see http://www.w3.org/TR/DOM-Level-3-Events/
         */

        var FocusEventInterface = _assign({}, UIEventInterface, {
          relatedTarget: 0
        });

        var SyntheticFocusEvent = createSyntheticEvent(FocusEventInterface);
        /**
         * @interface Event
         * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
         * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
         */

        var AnimationEventInterface = _assign({}, EventInterface, {
          animationName: 0,
          elapsedTime: 0,
          pseudoElement: 0
        });

        var SyntheticAnimationEvent = createSyntheticEvent(AnimationEventInterface);
        /**
         * @interface Event
         * @see http://www.w3.org/TR/clipboard-apis/
         */

        var ClipboardEventInterface = _assign({}, EventInterface, {
          clipboardData: function clipboardData(event) {
            return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
          }
        });

        var SyntheticClipboardEvent = createSyntheticEvent(ClipboardEventInterface);
        /**
         * @interface Event
         * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
         */

        var CompositionEventInterface = _assign({}, EventInterface, {
          data: 0
        });

        var SyntheticCompositionEvent = createSyntheticEvent(CompositionEventInterface);
        /**
         * @interface Event
         * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
         *      /#events-inputevents
         */
        // Happens to share the same list for now.

        var SyntheticInputEvent = SyntheticCompositionEvent;
        /**
         * Normalization of deprecated HTML5 `key` values
         * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
         */

        var normalizeKey = {
          Esc: 'Escape',
          Spacebar: ' ',
          Left: 'ArrowLeft',
          Up: 'ArrowUp',
          Right: 'ArrowRight',
          Down: 'ArrowDown',
          Del: 'Delete',
          Win: 'OS',
          Menu: 'ContextMenu',
          Apps: 'ContextMenu',
          Scroll: 'ScrollLock',
          MozPrintableKey: 'Unidentified'
        };
        /**
         * Translation from legacy `keyCode` to HTML5 `key`
         * Only special keys supported, all others depend on keyboard layout or browser
         * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
         */

        var translateToKey = {
          '8': 'Backspace',
          '9': 'Tab',
          '12': 'Clear',
          '13': 'Enter',
          '16': 'Shift',
          '17': 'Control',
          '18': 'Alt',
          '19': 'Pause',
          '20': 'CapsLock',
          '27': 'Escape',
          '32': ' ',
          '33': 'PageUp',
          '34': 'PageDown',
          '35': 'End',
          '36': 'Home',
          '37': 'ArrowLeft',
          '38': 'ArrowUp',
          '39': 'ArrowRight',
          '40': 'ArrowDown',
          '45': 'Insert',
          '46': 'Delete',
          '112': 'F1',
          '113': 'F2',
          '114': 'F3',
          '115': 'F4',
          '116': 'F5',
          '117': 'F6',
          '118': 'F7',
          '119': 'F8',
          '120': 'F9',
          '121': 'F10',
          '122': 'F11',
          '123': 'F12',
          '144': 'NumLock',
          '145': 'ScrollLock',
          '224': 'Meta'
        };
        /**
         * @param {object} nativeEvent Native browser event.
         * @return {string} Normalized `key` property.
         */

        function getEventKey(nativeEvent) {
          if (nativeEvent.key) {
            // Normalize inconsistent values reported by browsers due to
            // implementations of a working draft specification.
            // FireFox implements `key` but returns `MozPrintableKey` for all
            // printable characters (normalized to `Unidentified`), ignore it.
            var key = normalizeKey[nativeEvent.key] || nativeEvent.key;

            if (key !== 'Unidentified') {
              return key;
            }
          } // Browser does not implement `key`, polyfill as much of it as we can.


          if (nativeEvent.type === 'keypress') {
            var charCode = getEventCharCode(nativeEvent); // The enter-key is technically both printable and non-printable and can
            // thus be captured by `keypress`, no other non-printable key should.

            return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
          }

          if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
            // While user keyboard layout determines the actual meaning of each
            // `keyCode` value, almost all function keys have a universal value.
            return translateToKey[nativeEvent.keyCode] || 'Unidentified';
          }

          return '';
        }
        /**
         * Translation from modifier key to the associated property in the event.
         * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
         */


        var modifierKeyToProp = {
          Alt: 'altKey',
          Control: 'ctrlKey',
          Meta: 'metaKey',
          Shift: 'shiftKey'
        }; // Older browsers (Safari <= 10, iOS Safari <= 10.2) do not support
        // getModifierState. If getModifierState is not supported, we map it to a set of
        // modifier keys exposed by the event. In this case, Lock-keys are not supported.

        function modifierStateGetter(keyArg) {
          var syntheticEvent = this;
          var nativeEvent = syntheticEvent.nativeEvent;

          if (nativeEvent.getModifierState) {
            return nativeEvent.getModifierState(keyArg);
          }

          var keyProp = modifierKeyToProp[keyArg];
          return keyProp ? !!nativeEvent[keyProp] : false;
        }

        function getEventModifierState(nativeEvent) {
          return modifierStateGetter;
        }
        /**
         * @interface KeyboardEvent
         * @see http://www.w3.org/TR/DOM-Level-3-Events/
         */


        var KeyboardEventInterface = _assign({}, UIEventInterface, {
          key: getEventKey,
          code: 0,
          location: 0,
          ctrlKey: 0,
          shiftKey: 0,
          altKey: 0,
          metaKey: 0,
          repeat: 0,
          locale: 0,
          getModifierState: getEventModifierState,
          // Legacy Interface
          charCode: function charCode(event) {
            // `charCode` is the result of a KeyPress event and represents the value of
            // the actual printable character.
            // KeyPress is deprecated, but its replacement is not yet final and not
            // implemented in any major browser. Only KeyPress has charCode.
            if (event.type === 'keypress') {
              return getEventCharCode(event);
            }

            return 0;
          },
          keyCode: function keyCode(event) {
            // `keyCode` is the result of a KeyDown/Up event and represents the value of
            // physical keyboard key.
            // The actual meaning of the value depends on the users' keyboard layout
            // which cannot be detected. Assuming that it is a US keyboard layout
            // provides a surprisingly accurate mapping for US and European users.
            // Due to this, it is left to the user to implement at this time.
            if (event.type === 'keydown' || event.type === 'keyup') {
              return event.keyCode;
            }

            return 0;
          },
          which: function which(event) {
            // `which` is an alias for either `keyCode` or `charCode` depending on the
            // type of the event.
            if (event.type === 'keypress') {
              return getEventCharCode(event);
            }

            if (event.type === 'keydown' || event.type === 'keyup') {
              return event.keyCode;
            }

            return 0;
          }
        });

        var SyntheticKeyboardEvent = createSyntheticEvent(KeyboardEventInterface);
        /**
         * @interface PointerEvent
         * @see http://www.w3.org/TR/pointerevents/
         */

        var PointerEventInterface = _assign({}, MouseEventInterface, {
          pointerId: 0,
          width: 0,
          height: 0,
          pressure: 0,
          tangentialPressure: 0,
          tiltX: 0,
          tiltY: 0,
          twist: 0,
          pointerType: 0,
          isPrimary: 0
        });

        var SyntheticPointerEvent = createSyntheticEvent(PointerEventInterface);
        /**
         * @interface TouchEvent
         * @see http://www.w3.org/TR/touch-events/
         */

        var TouchEventInterface = _assign({}, UIEventInterface, {
          touches: 0,
          targetTouches: 0,
          changedTouches: 0,
          altKey: 0,
          metaKey: 0,
          ctrlKey: 0,
          shiftKey: 0,
          getModifierState: getEventModifierState
        });

        var SyntheticTouchEvent = createSyntheticEvent(TouchEventInterface);
        /**
         * @interface Event
         * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
         * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
         */

        var TransitionEventInterface = _assign({}, EventInterface, {
          propertyName: 0,
          elapsedTime: 0,
          pseudoElement: 0
        });

        var SyntheticTransitionEvent = createSyntheticEvent(TransitionEventInterface);
        /**
         * @interface WheelEvent
         * @see http://www.w3.org/TR/DOM-Level-3-Events/
         */

        var WheelEventInterface = _assign({}, MouseEventInterface, {
          deltaX: function deltaX(event) {
            return 'deltaX' in event ? event.deltaX : // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
            'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
          },
          deltaY: function deltaY(event) {
            return 'deltaY' in event ? event.deltaY : // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
            'wheelDeltaY' in event ? -event.wheelDeltaY : // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
            'wheelDelta' in event ? -event.wheelDelta : 0;
          },
          deltaZ: 0,
          // Browsers without "deltaMode" is reporting in raw wheel delta where one
          // notch on the scroll is always +/- 120, roughly equivalent to pixels.
          // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
          // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
          deltaMode: 0
        });

        var SyntheticWheelEvent = createSyntheticEvent(WheelEventInterface);
        var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space

        var START_KEYCODE = 229;
        var canUseCompositionEvent = canUseDOM && 'CompositionEvent' in window;
        var documentMode = null;

        if (canUseDOM && 'documentMode' in document) {
          documentMode = document.documentMode;
        } // Webkit offers a very useful `textInput` event that can be used to
        // directly represent `beforeInput`. The IE `textinput` event is not as
        // useful, so we don't use it.


        var canUseTextInputEvent = canUseDOM && 'TextEvent' in window && !documentMode; // In IE9+, we have access to composition events, but the data supplied
        // by the native compositionend event may be incorrect. Japanese ideographic
        // spaces, for instance (\u3000) are not recorded correctly.

        var useFallbackCompositionData = canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
        var SPACEBAR_CODE = 32;
        var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);

        function registerEvents() {
          registerTwoPhaseEvent('onBeforeInput', ['compositionend', 'keypress', 'textInput', 'paste']);
          registerTwoPhaseEvent('onCompositionEnd', ['compositionend', 'focusout', 'keydown', 'keypress', 'keyup', 'mousedown']);
          registerTwoPhaseEvent('onCompositionStart', ['compositionstart', 'focusout', 'keydown', 'keypress', 'keyup', 'mousedown']);
          registerTwoPhaseEvent('onCompositionUpdate', ['compositionupdate', 'focusout', 'keydown', 'keypress', 'keyup', 'mousedown']);
        } // Track whether we've ever handled a keypress on the space key.


        var hasSpaceKeypress = false;
        /**
         * Return whether a native keypress event is assumed to be a command.
         * This is required because Firefox fires `keypress` events for key commands
         * (cut, copy, select-all, etc.) even though no character is inserted.
         */

        function isKeypressCommand(nativeEvent) {
          return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) && // ctrlKey && altKey is equivalent to AltGr, and is not a command.
          !(nativeEvent.ctrlKey && nativeEvent.altKey);
        }
        /**
         * Translate native top level events into event types.
         */


        function getCompositionEventType(domEventName) {
          switch (domEventName) {
            case 'compositionstart':
              return 'onCompositionStart';

            case 'compositionend':
              return 'onCompositionEnd';

            case 'compositionupdate':
              return 'onCompositionUpdate';
          }
        }
        /**
         * Does our fallback best-guess model think this event signifies that
         * composition has begun?
         */


        function isFallbackCompositionStart(domEventName, nativeEvent) {
          return domEventName === 'keydown' && nativeEvent.keyCode === START_KEYCODE;
        }
        /**
         * Does our fallback mode think that this event is the end of composition?
         */


        function isFallbackCompositionEnd(domEventName, nativeEvent) {
          switch (domEventName) {
            case 'keyup':
              // Command keys insert or clear IME input.
              return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;

            case 'keydown':
              // Expect IME keyCode on each keydown. If we get any other
              // code we must have exited earlier.
              return nativeEvent.keyCode !== START_KEYCODE;

            case 'keypress':
            case 'mousedown':
            case 'focusout':
              // Events are not possible without cancelling IME.
              return true;

            default:
              return false;
          }
        }
        /**
         * Google Input Tools provides composition data via a CustomEvent,
         * with the `data` property populated in the `detail` object. If this
         * is available on the event object, use it. If not, this is a plain
         * composition event and we have nothing special to extract.
         *
         * @param {object} nativeEvent
         * @return {?string}
         */


        function getDataFromCustomEvent(nativeEvent) {
          var detail = nativeEvent.detail;

          if (typeof detail === 'object' && 'data' in detail) {
            return detail.data;
          }

          return null;
        }
        /**
         * Check if a composition event was triggered by Korean IME.
         * Our fallback mode does not work well with IE's Korean IME,
         * so just use native composition events when Korean IME is used.
         * Although CompositionEvent.locale property is deprecated,
         * it is available in IE, where our fallback mode is enabled.
         *
         * @param {object} nativeEvent
         * @return {boolean}
         */


        function isUsingKoreanIME(nativeEvent) {
          return nativeEvent.locale === 'ko';
        } // Track the current IME composition status, if any.


        var isComposing = false;
        /**
         * @return {?object} A SyntheticCompositionEvent.
         */

        function extractCompositionEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget) {
          var eventType;
          var fallbackData;

          if (canUseCompositionEvent) {
            eventType = getCompositionEventType(domEventName);
          } else if (!isComposing) {
            if (isFallbackCompositionStart(domEventName, nativeEvent)) {
              eventType = 'onCompositionStart';
            }
          } else if (isFallbackCompositionEnd(domEventName, nativeEvent)) {
            eventType = 'onCompositionEnd';
          }

          if (!eventType) {
            return null;
          }

          if (useFallbackCompositionData && !isUsingKoreanIME(nativeEvent)) {
            // The current composition is stored statically and must not be
            // overwritten while composition continues.
            if (!isComposing && eventType === 'onCompositionStart') {
              isComposing = initialize(nativeEventTarget);
            } else if (eventType === 'onCompositionEnd') {
              if (isComposing) {
                fallbackData = getData();
              }
            }
          }

          var listeners = accumulateTwoPhaseListeners(targetInst, eventType);

          if (listeners.length > 0) {
            var event = new SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget);
            dispatchQueue.push({
              event: event,
              listeners: listeners
            });

            if (fallbackData) {
              // Inject data generated from fallback path into the synthetic event.
              // This matches the property of native CompositionEventInterface.
              event.data = fallbackData;
            } else {
              var customData = getDataFromCustomEvent(nativeEvent);

              if (customData !== null) {
                event.data = customData;
              }
            }
          }
        }

        function getNativeBeforeInputChars(domEventName, nativeEvent) {
          switch (domEventName) {
            case 'compositionend':
              return getDataFromCustomEvent(nativeEvent);

            case 'keypress':
              /**
               * If native `textInput` events are available, our goal is to make
               * use of them. However, there is a special case: the spacebar key.
               * In Webkit, preventing default on a spacebar `textInput` event
               * cancels character insertion, but it *also* causes the browser
               * to fall back to its default spacebar behavior of scrolling the
               * page.
               *
               * Tracking at:
               * https://code.google.com/p/chromium/issues/detail?id=355103
               *
               * To avoid this issue, use the keypress event as if no `textInput`
               * event is available.
               */
              var which = nativeEvent.which;

              if (which !== SPACEBAR_CODE) {
                return null;
              }

              hasSpaceKeypress = true;
              return SPACEBAR_CHAR;

            case 'textInput':
              // Record the characters to be added to the DOM.
              var chars = nativeEvent.data; // If it's a spacebar character, assume that we have already handled
              // it at the keypress level and bail immediately. Android Chrome
              // doesn't give us keycodes, so we need to ignore it.

              if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
                return null;
              }

              return chars;

            default:
              // For other native event types, do nothing.
              return null;
          }
        }
        /**
         * For browsers that do not provide the `textInput` event, extract the
         * appropriate string to use for SyntheticInputEvent.
         */


        function getFallbackBeforeInputChars(domEventName, nativeEvent) {
          // If we are currently composing (IME) and using a fallback to do so,
          // try to extract the composed characters from the fallback object.
          // If composition event is available, we extract a string only at
          // compositionevent, otherwise extract it at fallback events.
          if (isComposing) {
            if (domEventName === 'compositionend' || !canUseCompositionEvent && isFallbackCompositionEnd(domEventName, nativeEvent)) {
              var chars = getData();
              reset();
              isComposing = false;
              return chars;
            }

            return null;
          }

          switch (domEventName) {
            case 'paste':
              // If a paste event occurs after a keypress, throw out the input
              // chars. Paste events should not lead to BeforeInput events.
              return null;

            case 'keypress':
              /**
               * As of v27, Firefox may fire keypress events even when no character
               * will be inserted. A few possibilities:
               *
               * - `which` is `0`. Arrow keys, Esc key, etc.
               *
               * - `which` is the pressed key code, but no char is available.
               *   Ex: 'AltGr + d` in Polish. There is no modified character for
               *   this key combination and no character is inserted into the
               *   document, but FF fires the keypress for char code `100` anyway.
               *   No `input` event will occur.
               *
               * - `which` is the pressed key code, but a command combination is
               *   being used. Ex: `Cmd+C`. No character is inserted, and no
               *   `input` event will occur.
               */
              if (!isKeypressCommand(nativeEvent)) {
                // IE fires the `keypress` event when a user types an emoji via
                // Touch keyboard of Windows.  In such a case, the `char` property
                // holds an emoji character like `\uD83D\uDE0A`.  Because its length
                // is 2, the property `which` does not represent an emoji correctly.
                // In such a case, we directly return the `char` property instead of
                // using `which`.
                if (nativeEvent.char && nativeEvent.char.length > 1) {
                  return nativeEvent.char;
                } else if (nativeEvent.which) {
                  return String.fromCharCode(nativeEvent.which);
                }
              }

              return null;

            case 'compositionend':
              return useFallbackCompositionData && !isUsingKoreanIME(nativeEvent) ? null : nativeEvent.data;

            default:
              return null;
          }
        }
        /**
         * Extract a SyntheticInputEvent for `beforeInput`, based on either native
         * `textInput` or fallback behavior.
         *
         * @return {?object} A SyntheticInputEvent.
         */


        function extractBeforeInputEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget) {
          var chars;

          if (canUseTextInputEvent) {
            chars = getNativeBeforeInputChars(domEventName, nativeEvent);
          } else {
            chars = getFallbackBeforeInputChars(domEventName, nativeEvent);
          } // If no characters are being inserted, no BeforeInput event should
          // be fired.


          if (!chars) {
            return null;
          }

          var listeners = accumulateTwoPhaseListeners(targetInst, 'onBeforeInput');

          if (listeners.length > 0) {
            var event = new SyntheticInputEvent('onBeforeInput', 'beforeinput', null, nativeEvent, nativeEventTarget);
            dispatchQueue.push({
              event: event,
              listeners: listeners
            });
            event.data = chars;
          }
        }
        /**
         * Create an `onBeforeInput` event to match
         * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
         *
         * This event plugin is based on the native `textInput` event
         * available in Chrome, Safari, Opera, and IE. This event fires after
         * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
         *
         * `beforeInput` is spec'd but not implemented in any browsers, and
         * the `input` event does not provide any useful information about what has
         * actually been added, contrary to the spec. Thus, `textInput` is the best
         * available event to identify the characters that have actually been inserted
         * into the target node.
         *
         * This plugin is also responsible for emitting `composition` events, thus
         * allowing us to share composition fallback code for both `beforeInput` and
         * `composition` event types.
         */


        function extractEvents(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
          extractCompositionEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
          extractBeforeInputEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        /**
         * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
         */


        var supportedInputTypes = {
          color: true,
          date: true,
          datetime: true,
          'datetime-local': true,
          email: true,
          month: true,
          number: true,
          password: true,
          range: true,
          search: true,
          tel: true,
          text: true,
          time: true,
          url: true,
          week: true
        };

        function isTextInputElement(elem) {
          var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();

          if (nodeName === 'input') {
            return !!supportedInputTypes[elem.type];
          }

          if (nodeName === 'textarea') {
            return true;
          }

          return false;
        }
        /**
         * Checks if an event is supported in the current execution environment.
         *
         * NOTE: This will not work correctly for non-generic events such as `change`,
         * `reset`, `load`, `error`, and `select`.
         *
         * Borrows from Modernizr.
         *
         * @param {string} eventNameSuffix Event name, e.g. "click".
         * @return {boolean} True if the event is supported.
         * @internal
         * @license Modernizr 3.0.0pre (Custom Build) | MIT
         */


        function isEventSupported(eventNameSuffix) {
          if (!canUseDOM) {
            return false;
          }

          var eventName = 'on' + eventNameSuffix;
          var isSupported = (eventName in document);

          if (!isSupported) {
            var element = document.createElement('div');
            element.setAttribute(eventName, 'return;');
            isSupported = typeof element[eventName] === 'function';
          }

          return isSupported;
        }

        function registerEvents$1() {
          registerTwoPhaseEvent('onChange', ['change', 'click', 'focusin', 'focusout', 'input', 'keydown', 'keyup', 'selectionchange']);
        }

        function createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
          // Flag this event loop as needing state restore.
          enqueueStateRestore(target);
          var listeners = accumulateTwoPhaseListeners(inst, 'onChange');

          if (listeners.length > 0) {
            var event = new SyntheticEvent('onChange', 'change', null, nativeEvent, target);
            dispatchQueue.push({
              event: event,
              listeners: listeners
            });
          }
        }
        /**
         * For IE shims
         */


        var activeElement = null;
        var activeElementInst = null;
        /**
         * SECTION: handle `change` event
         */

        function shouldUseChangeEvent(elem) {
          var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
          return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
        }

        function manualDispatchChangeEvent(nativeEvent) {
          var dispatchQueue = [];
          createAndAccumulateChangeEvent(dispatchQueue, activeElementInst, nativeEvent, getEventTarget(nativeEvent)); // If change and propertychange bubbled, we'd just bind to it like all the
          // other events and have it go through ReactBrowserEventEmitter. Since it
          // doesn't, we manually listen for the events and so we have to enqueue and
          // process the abstract event manually.
          //
          // Batching is necessary here in order to ensure that all event handlers run
          // before the next rerender (including event handlers attached to ancestor
          // elements instead of directly on the input). Without this, controlled
          // components don't work properly in conjunction with event bubbling because
          // the component is rerendered and the value reverted before all the event
          // handlers can run. See https://github.com/facebook/react/issues/708.

          batchedUpdates(runEventInBatch, dispatchQueue);
        }

        function runEventInBatch(dispatchQueue) {
          processDispatchQueue(dispatchQueue, 0);
        }

        function getInstIfValueChanged(targetInst) {
          var targetNode = getNodeFromInstance(targetInst);

          if (updateValueIfChanged(targetNode)) {
            return targetInst;
          }
        }

        function getTargetInstForChangeEvent(domEventName, targetInst) {
          if (domEventName === 'change') {
            return targetInst;
          }
        }
        /**
         * SECTION: handle `input` event
         */


        var isInputEventSupported = false;

        if (canUseDOM) {
          // IE9 claims to support the input event but fails to trigger it when
          // deleting text, so we ignore its input events.
          isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 9);
        }
        /**
         * (For IE <=9) Starts tracking propertychange events on the passed-in element
         * and override the value property so that we can distinguish user events from
         * value changes in JS.
         */


        function startWatchingForValueChange(target, targetInst) {
          activeElement = target;
          activeElementInst = targetInst;
          activeElement.attachEvent('onpropertychange', handlePropertyChange);
        }
        /**
         * (For IE <=9) Removes the event listeners from the currently-tracked element,
         * if any exists.
         */


        function stopWatchingForValueChange() {
          if (!activeElement) {
            return;
          }

          activeElement.detachEvent('onpropertychange', handlePropertyChange);
          activeElement = null;
          activeElementInst = null;
        }
        /**
         * (For IE <=9) Handles a propertychange event, sending a `change` event if
         * the value of the active element has changed.
         */


        function handlePropertyChange(nativeEvent) {
          if (nativeEvent.propertyName !== 'value') {
            return;
          }

          if (getInstIfValueChanged(activeElementInst)) {
            manualDispatchChangeEvent(nativeEvent);
          }
        }

        function handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
          if (domEventName === 'focusin') {
            // In IE9, propertychange fires for most input events but is buggy and
            // doesn't fire when text is deleted, but conveniently, selectionchange
            // appears to fire in all of the remaining cases so we catch those and
            // forward the event if the value has changed
            // In either case, we don't want to call the event handler if the value
            // is changed from JS so we redefine a setter for `.value` that updates
            // our activeElementValue variable, allowing us to ignore those changes
            //
            // stopWatching() should be a noop here but we call it just in case we
            // missed a blur event somehow.
            stopWatchingForValueChange();
            startWatchingForValueChange(target, targetInst);
          } else if (domEventName === 'focusout') {
            stopWatchingForValueChange();
          }
        } // For IE8 and IE9.


        function getTargetInstForInputEventPolyfill(domEventName, targetInst) {
          if (domEventName === 'selectionchange' || domEventName === 'keyup' || domEventName === 'keydown') {
            // On the selectionchange event, the target is just document which isn't
            // helpful for us so just check activeElement instead.
            //
            // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
            // propertychange on the first input event after setting `value` from a
            // script and fires only keydown, keypress, keyup. Catching keyup usually
            // gets it and catching keydown lets us fire an event for the first
            // keystroke if user does a key repeat (it'll be a little delayed: right
            // before the second keystroke). Other input methods (e.g., paste) seem to
            // fire selectionchange normally.
            return getInstIfValueChanged(activeElementInst);
          }
        }
        /**
         * SECTION: handle `click` event
         */


        function shouldUseClickEvent(elem) {
          // Use the `click` event to detect changes to checkbox and radio inputs.
          // This approach works across all browsers, whereas `change` does not fire
          // until `blur` in IE8.
          var nodeName = elem.nodeName;
          return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
        }

        function getTargetInstForClickEvent(domEventName, targetInst) {
          if (domEventName === 'click') {
            return getInstIfValueChanged(targetInst);
          }
        }

        function getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
          if (domEventName === 'input' || domEventName === 'change') {
            return getInstIfValueChanged(targetInst);
          }
        }

        function handleControlledInputBlur(node) {
          var state = node._wrapperState;

          if (!state || !state.controlled || node.type !== 'number') {
            return;
          }

          {
            // If controlled, assign the value attribute to the current value on blur
            setDefaultValue(node, 'number', node.value);
          }
        }
        /**
         * This plugin creates an `onChange` event that normalizes change events
         * across form elements. This event fires at a time when it's possible to
         * change the element's value without seeing a flicker.
         *
         * Supported elements are:
         * - input (see `isTextInputElement`)
         * - textarea
         * - select
         */


        function extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
          var targetNode = targetInst ? getNodeFromInstance(targetInst) : window;
          var getTargetInstFunc, handleEventFunc;

          if (shouldUseChangeEvent(targetNode)) {
            getTargetInstFunc = getTargetInstForChangeEvent;
          } else if (isTextInputElement(targetNode)) {
            if (isInputEventSupported) {
              getTargetInstFunc = getTargetInstForInputOrChangeEvent;
            } else {
              getTargetInstFunc = getTargetInstForInputEventPolyfill;
              handleEventFunc = handleEventsForInputEventPolyfill;
            }
          } else if (shouldUseClickEvent(targetNode)) {
            getTargetInstFunc = getTargetInstForClickEvent;
          }

          if (getTargetInstFunc) {
            var inst = getTargetInstFunc(domEventName, targetInst);

            if (inst) {
              createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, nativeEventTarget);
              return;
            }
          }

          if (handleEventFunc) {
            handleEventFunc(domEventName, targetNode, targetInst);
          } // When blurring, set the value attribute for number inputs


          if (domEventName === 'focusout') {
            handleControlledInputBlur(targetNode);
          }
        }

        function registerEvents$2() {
          registerDirectEvent('onMouseEnter', ['mouseout', 'mouseover']);
          registerDirectEvent('onMouseLeave', ['mouseout', 'mouseover']);
          registerDirectEvent('onPointerEnter', ['pointerout', 'pointerover']);
          registerDirectEvent('onPointerLeave', ['pointerout', 'pointerover']);
        }
        /**
         * For almost every interaction we care about, there will be both a top-level
         * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
         * we do not extract duplicate events. However, moving the mouse into the
         * browser from outside will not fire a `mouseout` event. In this case, we use
         * the `mouseover` top-level event.
         */


        function extractEvents$2(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
          var isOverEvent = domEventName === 'mouseover' || domEventName === 'pointerover';
          var isOutEvent = domEventName === 'mouseout' || domEventName === 'pointerout';

          if (isOverEvent && (eventSystemFlags & IS_REPLAYED) === 0) {
            // If this is an over event with a target, we might have already dispatched
            // the event in the out event of the other target. If this is replayed,
            // then it's because we couldn't dispatch against this target previously
            // so we have to do it now instead.
            var related = nativeEvent.relatedTarget || nativeEvent.fromElement;

            if (related) {
              // If the related node is managed by React, we can assume that we have
              // already dispatched the corresponding events during its mouseout.
              if (getClosestInstanceFromNode(related) || isContainerMarkedAsRoot(related)) {
                return;
              }
            }
          }

          if (!isOutEvent && !isOverEvent) {
            // Must not be a mouse or pointer in or out - ignoring.
            return;
          }

          var win; // TODO: why is this nullable in the types but we read from it?

          if (nativeEventTarget.window === nativeEventTarget) {
            // `nativeEventTarget` is probably a window object.
            win = nativeEventTarget;
          } else {
            // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
            var doc = nativeEventTarget.ownerDocument;

            if (doc) {
              win = doc.defaultView || doc.parentWindow;
            } else {
              win = window;
            }
          }

          var from;
          var to;

          if (isOutEvent) {
            var _related = nativeEvent.relatedTarget || nativeEvent.toElement;

            from = targetInst;
            to = _related ? getClosestInstanceFromNode(_related) : null;

            if (to !== null) {
              var nearestMounted = getNearestMountedFiber(to);

              if (to !== nearestMounted || to.tag !== HostComponent && to.tag !== HostText) {
                to = null;
              }
            }
          } else {
            // Moving to a node from outside the window.
            from = null;
            to = targetInst;
          }

          if (from === to) {
            // Nothing pertains to our managed components.
            return;
          }

          var SyntheticEventCtor = SyntheticMouseEvent;
          var leaveEventType = 'onMouseLeave';
          var enterEventType = 'onMouseEnter';
          var eventTypePrefix = 'mouse';

          if (domEventName === 'pointerout' || domEventName === 'pointerover') {
            SyntheticEventCtor = SyntheticPointerEvent;
            leaveEventType = 'onPointerLeave';
            enterEventType = 'onPointerEnter';
            eventTypePrefix = 'pointer';
          }

          var fromNode = from == null ? win : getNodeFromInstance(from);
          var toNode = to == null ? win : getNodeFromInstance(to);
          var leave = new SyntheticEventCtor(leaveEventType, eventTypePrefix + 'leave', from, nativeEvent, nativeEventTarget);
          leave.target = fromNode;
          leave.relatedTarget = toNode;
          var enter = null; // We should only process this nativeEvent if we are processing
          // the first ancestor. Next time, we will ignore the event.

          var nativeTargetInst = getClosestInstanceFromNode(nativeEventTarget);

          if (nativeTargetInst === targetInst) {
            var enterEvent = new SyntheticEventCtor(enterEventType, eventTypePrefix + 'enter', to, nativeEvent, nativeEventTarget);
            enterEvent.target = toNode;
            enterEvent.relatedTarget = fromNode;
            enter = enterEvent;
          }

          accumulateEnterLeaveTwoPhaseListeners(dispatchQueue, leave, enter, from, to);
        }
        /**
         * inlined Object.is polyfill to avoid requiring consumers ship their own
         * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
         */


        function is(x, y) {
          return x === y && (x !== 0 || 1 / x === 1 / y) || x !== x && y !== y // eslint-disable-line no-self-compare
          ;
        }

        var objectIs = typeof Object.is === 'function' ? Object.is : is;
        var hasOwnProperty$2 = Object.prototype.hasOwnProperty;
        /**
         * Performs equality by iterating through keys on an object and returning false
         * when any key has values which are not strictly equal between the arguments.
         * Returns true when the values of all keys are strictly equal.
         */

        function shallowEqual(objA, objB) {
          if (objectIs(objA, objB)) {
            return true;
          }

          if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
            return false;
          }

          var keysA = Object.keys(objA);
          var keysB = Object.keys(objB);

          if (keysA.length !== keysB.length) {
            return false;
          } // Test for A's keys different from B.


          for (var i = 0; i < keysA.length; i++) {
            if (!hasOwnProperty$2.call(objB, keysA[i]) || !objectIs(objA[keysA[i]], objB[keysA[i]])) {
              return false;
            }
          }

          return true;
        }
        /**
         * Given any node return the first leaf node without children.
         *
         * @param {DOMElement|DOMTextNode} node
         * @return {DOMElement|DOMTextNode}
         */


        function getLeafNode(node) {
          while (node && node.firstChild) {
            node = node.firstChild;
          }

          return node;
        }
        /**
         * Get the next sibling within a container. This will walk up the
         * DOM if a node's siblings have been exhausted.
         *
         * @param {DOMElement|DOMTextNode} node
         * @return {?DOMElement|DOMTextNode}
         */


        function getSiblingNode(node) {
          while (node) {
            if (node.nextSibling) {
              return node.nextSibling;
            }

            node = node.parentNode;
          }
        }
        /**
         * Get object describing the nodes which contain characters at offset.
         *
         * @param {DOMElement|DOMTextNode} root
         * @param {number} offset
         * @return {?object}
         */


        function getNodeForCharacterOffset(root, offset) {
          var node = getLeafNode(root);
          var nodeStart = 0;
          var nodeEnd = 0;

          while (node) {
            if (node.nodeType === TEXT_NODE) {
              nodeEnd = nodeStart + node.textContent.length;

              if (nodeStart <= offset && nodeEnd >= offset) {
                return {
                  node: node,
                  offset: offset - nodeStart
                };
              }

              nodeStart = nodeEnd;
            }

            node = getLeafNode(getSiblingNode(node));
          }
        }
        /**
         * @param {DOMElement} outerNode
         * @return {?object}
         */


        function getOffsets(outerNode) {
          var ownerDocument = outerNode.ownerDocument;
          var win = ownerDocument && ownerDocument.defaultView || window;
          var selection = win.getSelection && win.getSelection();

          if (!selection || selection.rangeCount === 0) {
            return null;
          }

          var anchorNode = selection.anchorNode,
              anchorOffset = selection.anchorOffset,
              focusNode = selection.focusNode,
              focusOffset = selection.focusOffset; // In Firefox, anchorNode and focusNode can be "anonymous divs", e.g. the
          // up/down buttons on an <input type="number">. Anonymous divs do not seem to
          // expose properties, triggering a "Permission denied error" if any of its
          // properties are accessed. The only seemingly possible way to avoid erroring
          // is to access a property that typically works for non-anonymous divs and
          // catch any error that may otherwise arise. See
          // https://bugzilla.mozilla.org/show_bug.cgi?id=208427

          try {
            /* eslint-disable no-unused-expressions */
            anchorNode.nodeType;
            focusNode.nodeType;
            /* eslint-enable no-unused-expressions */
          } catch (e) {
            return null;
          }

          return getModernOffsetsFromPoints(outerNode, anchorNode, anchorOffset, focusNode, focusOffset);
        }
        /**
         * Returns {start, end} where `start` is the character/codepoint index of
         * (anchorNode, anchorOffset) within the textContent of `outerNode`, and
         * `end` is the index of (focusNode, focusOffset).
         *
         * Returns null if you pass in garbage input but we should probably just crash.
         *
         * Exported only for testing.
         */


        function getModernOffsetsFromPoints(outerNode, anchorNode, anchorOffset, focusNode, focusOffset) {
          var length = 0;
          var start = -1;
          var end = -1;
          var indexWithinAnchor = 0;
          var indexWithinFocus = 0;
          var node = outerNode;
          var parentNode = null;

          outer: while (true) {
            var next = null;

            while (true) {
              if (node === anchorNode && (anchorOffset === 0 || node.nodeType === TEXT_NODE)) {
                start = length + anchorOffset;
              }

              if (node === focusNode && (focusOffset === 0 || node.nodeType === TEXT_NODE)) {
                end = length + focusOffset;
              }

              if (node.nodeType === TEXT_NODE) {
                length += node.nodeValue.length;
              }

              if ((next = node.firstChild) === null) {
                break;
              } // Moving from `node` to its first child `next`.


              parentNode = node;
              node = next;
            }

            while (true) {
              if (node === outerNode) {
                // If `outerNode` has children, this is always the second time visiting
                // it. If it has no children, this is still the first loop, and the only
                // valid selection is anchorNode and focusNode both equal to this node
                // and both offsets 0, in which case we will have handled above.
                break outer;
              }

              if (parentNode === anchorNode && ++indexWithinAnchor === anchorOffset) {
                start = length;
              }

              if (parentNode === focusNode && ++indexWithinFocus === focusOffset) {
                end = length;
              }

              if ((next = node.nextSibling) !== null) {
                break;
              }

              node = parentNode;
              parentNode = node.parentNode;
            } // Moving from `node` to its next sibling `next`.


            node = next;
          }

          if (start === -1 || end === -1) {
            // This should never happen. (Would happen if the anchor/focus nodes aren't
            // actually inside the passed-in node.)
            return null;
          }

          return {
            start: start,
            end: end
          };
        }
        /**
         * In modern non-IE browsers, we can support both forward and backward
         * selections.
         *
         * Note: IE10+ supports the Selection object, but it does not support
         * the `extend` method, which means that even in modern IE, it's not possible
         * to programmatically create a backward selection. Thus, for all IE
         * versions, we use the old IE API to create our selections.
         *
         * @param {DOMElement|DOMTextNode} node
         * @param {object} offsets
         */


        function setOffsets(node, offsets) {
          var doc = node.ownerDocument || document;
          var win = doc && doc.defaultView || window; // Edge fails with "Object expected" in some scenarios.
          // (For instance: TinyMCE editor used in a list component that supports pasting to add more,
          // fails when pasting 100+ items)

          if (!win.getSelection) {
            return;
          }

          var selection = win.getSelection();
          var length = node.textContent.length;
          var start = Math.min(offsets.start, length);
          var end = offsets.end === undefined ? start : Math.min(offsets.end, length); // IE 11 uses modern selection, but doesn't support the extend method.
          // Flip backward selections, so we can set with a single range.

          if (!selection.extend && start > end) {
            var temp = end;
            end = start;
            start = temp;
          }

          var startMarker = getNodeForCharacterOffset(node, start);
          var endMarker = getNodeForCharacterOffset(node, end);

          if (startMarker && endMarker) {
            if (selection.rangeCount === 1 && selection.anchorNode === startMarker.node && selection.anchorOffset === startMarker.offset && selection.focusNode === endMarker.node && selection.focusOffset === endMarker.offset) {
              return;
            }

            var range = doc.createRange();
            range.setStart(startMarker.node, startMarker.offset);
            selection.removeAllRanges();

            if (start > end) {
              selection.addRange(range);
              selection.extend(endMarker.node, endMarker.offset);
            } else {
              range.setEnd(endMarker.node, endMarker.offset);
              selection.addRange(range);
            }
          }
        }

        function isTextNode(node) {
          return node && node.nodeType === TEXT_NODE;
        }

        function containsNode(outerNode, innerNode) {
          if (!outerNode || !innerNode) {
            return false;
          } else if (outerNode === innerNode) {
            return true;
          } else if (isTextNode(outerNode)) {
            return false;
          } else if (isTextNode(innerNode)) {
            return containsNode(outerNode, innerNode.parentNode);
          } else if ('contains' in outerNode) {
            return outerNode.contains(innerNode);
          } else if (outerNode.compareDocumentPosition) {
            return !!(outerNode.compareDocumentPosition(innerNode) & 16);
          } else {
            return false;
          }
        }

        function isInDocument(node) {
          return node && node.ownerDocument && containsNode(node.ownerDocument.documentElement, node);
        }

        function isSameOriginFrame(iframe) {
          try {
            // Accessing the contentDocument of a HTMLIframeElement can cause the browser
            // to throw, e.g. if it has a cross-origin src attribute.
            // Safari will show an error in the console when the access results in "Blocked a frame with origin". e.g:
            // iframe.contentDocument.defaultView;
            // A safety way is to access one of the cross origin properties: Window or Location
            // Which might result in "SecurityError" DOM Exception and it is compatible to Safari.
            // https://html.spec.whatwg.org/multipage/browsers.html#integration-with-idl
            return typeof iframe.contentWindow.location.href === 'string';
          } catch (err) {
            return false;
          }
        }

        function getActiveElementDeep() {
          var win = window;
          var element = getActiveElement();

          while (element instanceof win.HTMLIFrameElement) {
            if (isSameOriginFrame(element)) {
              win = element.contentWindow;
            } else {
              return element;
            }

            element = getActiveElement(win.document);
          }

          return element;
        }
        /**
         * @ReactInputSelection: React input selection module. Based on Selection.js,
         * but modified to be suitable for react and has a couple of bug fixes (doesn't
         * assume buttons have range selections allowed).
         * Input selection module for React.
         */

        /**
         * @hasSelectionCapabilities: we get the element types that support selection
         * from https://html.spec.whatwg.org/#do-not-apply, looking at `selectionStart`
         * and `selectionEnd` rows.
         */


        function hasSelectionCapabilities(elem) {
          var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
          return nodeName && (nodeName === 'input' && (elem.type === 'text' || elem.type === 'search' || elem.type === 'tel' || elem.type === 'url' || elem.type === 'password') || nodeName === 'textarea' || elem.contentEditable === 'true');
        }

        function getSelectionInformation() {
          var focusedElem = getActiveElementDeep();
          return {
            focusedElem: focusedElem,
            selectionRange: hasSelectionCapabilities(focusedElem) ? getSelection(focusedElem) : null
          };
        }
        /**
         * @restoreSelection: If any selection information was potentially lost,
         * restore it. This is useful when performing operations that could remove dom
         * nodes and place them back in, resulting in focus being lost.
         */


        function restoreSelection(priorSelectionInformation) {
          var curFocusedElem = getActiveElementDeep();
          var priorFocusedElem = priorSelectionInformation.focusedElem;
          var priorSelectionRange = priorSelectionInformation.selectionRange;

          if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
            if (priorSelectionRange !== null && hasSelectionCapabilities(priorFocusedElem)) {
              setSelection(priorFocusedElem, priorSelectionRange);
            } // Focusing a node can change the scroll position, which is undesirable


            var ancestors = [];
            var ancestor = priorFocusedElem;

            while (ancestor = ancestor.parentNode) {
              if (ancestor.nodeType === ELEMENT_NODE) {
                ancestors.push({
                  element: ancestor,
                  left: ancestor.scrollLeft,
                  top: ancestor.scrollTop
                });
              }
            }

            if (typeof priorFocusedElem.focus === 'function') {
              priorFocusedElem.focus();
            }

            for (var i = 0; i < ancestors.length; i++) {
              var info = ancestors[i];
              info.element.scrollLeft = info.left;
              info.element.scrollTop = info.top;
            }
          }
        }
        /**
         * @getSelection: Gets the selection bounds of a focused textarea, input or
         * contentEditable node.
         * -@input: Look up selection bounds of this input
         * -@return {start: selectionStart, end: selectionEnd}
         */


        function getSelection(input) {
          var selection;

          if ('selectionStart' in input) {
            // Modern browser with input or textarea.
            selection = {
              start: input.selectionStart,
              end: input.selectionEnd
            };
          } else {
            // Content editable or old IE textarea.
            selection = getOffsets(input);
          }

          return selection || {
            start: 0,
            end: 0
          };
        }
        /**
         * @setSelection: Sets the selection bounds of a textarea or input and focuses
         * the input.
         * -@input     Set selection bounds of this input or textarea
         * -@offsets   Object of same form that is returned from get*
         */


        function setSelection(input, offsets) {
          var start = offsets.start;
          var end = offsets.end;

          if (end === undefined) {
            end = start;
          }

          if ('selectionStart' in input) {
            input.selectionStart = start;
            input.selectionEnd = Math.min(end, input.value.length);
          } else {
            setOffsets(input, offsets);
          }
        }

        var skipSelectionChangeEvent = canUseDOM && 'documentMode' in document && document.documentMode <= 11;

        function registerEvents$3() {
          registerTwoPhaseEvent('onSelect', ['focusout', 'contextmenu', 'dragend', 'focusin', 'keydown', 'keyup', 'mousedown', 'mouseup', 'selectionchange']);
        }

        var activeElement$1 = null;
        var activeElementInst$1 = null;
        var lastSelection = null;
        var mouseDown = false;
        /**
         * Get an object which is a unique representation of the current selection.
         *
         * The return value will not be consistent across nodes or browsers, but
         * two identical selections on the same node will return identical objects.
         */

        function getSelection$1(node) {
          if ('selectionStart' in node && hasSelectionCapabilities(node)) {
            return {
              start: node.selectionStart,
              end: node.selectionEnd
            };
          } else {
            var win = node.ownerDocument && node.ownerDocument.defaultView || window;
            var selection = win.getSelection();
            return {
              anchorNode: selection.anchorNode,
              anchorOffset: selection.anchorOffset,
              focusNode: selection.focusNode,
              focusOffset: selection.focusOffset
            };
          }
        }
        /**
         * Get document associated with the event target.
         */


        function getEventTargetDocument(eventTarget) {
          return eventTarget.window === eventTarget ? eventTarget.document : eventTarget.nodeType === DOCUMENT_NODE ? eventTarget : eventTarget.ownerDocument;
        }
        /**
         * Poll selection to see whether it's changed.
         *
         * @param {object} nativeEvent
         * @param {object} nativeEventTarget
         * @return {?SyntheticEvent}
         */


        function constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
          // Ensure we have the right element, and that the user is not dragging a
          // selection (this matches native `select` event behavior). In HTML5, select
          // fires only on input and textarea thus if there's no focused element we
          // won't dispatch.
          var doc = getEventTargetDocument(nativeEventTarget);

          if (mouseDown || activeElement$1 == null || activeElement$1 !== getActiveElement(doc)) {
            return;
          } // Only fire when selection has actually changed.


          var currentSelection = getSelection$1(activeElement$1);

          if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
            lastSelection = currentSelection;
            var listeners = accumulateTwoPhaseListeners(activeElementInst$1, 'onSelect');

            if (listeners.length > 0) {
              var event = new SyntheticEvent('onSelect', 'select', null, nativeEvent, nativeEventTarget);
              dispatchQueue.push({
                event: event,
                listeners: listeners
              });
              event.target = activeElement$1;
            }
          }
        }
        /**
         * This plugin creates an `onSelect` event that normalizes select events
         * across form elements.
         *
         * Supported elements are:
         * - input (see `isTextInputElement`)
         * - textarea
         * - contentEditable
         *
         * This differs from native browser implementations in the following ways:
         * - Fires on contentEditable fields as well as inputs.
         * - Fires for collapsed selection.
         * - Fires after user input.
         */


        function extractEvents$3(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
          var targetNode = targetInst ? getNodeFromInstance(targetInst) : window;

          switch (domEventName) {
            // Track the input node that has focus.
            case 'focusin':
              if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
                activeElement$1 = targetNode;
                activeElementInst$1 = targetInst;
                lastSelection = null;
              }

              break;

            case 'focusout':
              activeElement$1 = null;
              activeElementInst$1 = null;
              lastSelection = null;
              break;
            // Don't fire the event while the user is dragging. This matches the
            // semantics of the native select event.

            case 'mousedown':
              mouseDown = true;
              break;

            case 'contextmenu':
            case 'mouseup':
            case 'dragend':
              mouseDown = false;
              constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
              break;
            // Chrome and IE fire non-standard event when selection is changed (and
            // sometimes when it hasn't). IE's event fires out of order with respect
            // to key and input events on deletion, so we discard it.
            //
            // Firefox doesn't support selectionchange, so check selection status
            // after each key entry. The selection changes after keydown and before
            // keyup, but we check on keydown as well in the case of holding down a
            // key, when multiple keydown events are fired but only one keyup is.
            // This is also our approach for IE handling, for the reason above.

            case 'selectionchange':
              if (skipSelectionChangeEvent) {
                break;
              }

            // falls through

            case 'keydown':
            case 'keyup':
              constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
          }
        }

        function extractEvents$4(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
          var reactName = topLevelEventsToReactNames.get(domEventName);

          if (reactName === undefined) {
            return;
          }

          var SyntheticEventCtor = SyntheticEvent;
          var reactEventType = domEventName;

          switch (domEventName) {
            case 'keypress':
              // Firefox creates a keypress event for function keys too. This removes
              // the unwanted keypress events. Enter is however both printable and
              // non-printable. One would expect Tab to be as well (but it isn't).
              if (getEventCharCode(nativeEvent) === 0) {
                return;
              }

            /* falls through */

            case 'keydown':
            case 'keyup':
              SyntheticEventCtor = SyntheticKeyboardEvent;
              break;

            case 'focusin':
              reactEventType = 'focus';
              SyntheticEventCtor = SyntheticFocusEvent;
              break;

            case 'focusout':
              reactEventType = 'blur';
              SyntheticEventCtor = SyntheticFocusEvent;
              break;

            case 'beforeblur':
            case 'afterblur':
              SyntheticEventCtor = SyntheticFocusEvent;
              break;

            case 'click':
              // Firefox creates a click event on right mouse clicks. This removes the
              // unwanted click events.
              if (nativeEvent.button === 2) {
                return;
              }

            /* falls through */

            case 'auxclick':
            case 'dblclick':
            case 'mousedown':
            case 'mousemove':
            case 'mouseup': // TODO: Disabled elements should not respond to mouse events

            /* falls through */

            case 'mouseout':
            case 'mouseover':
            case 'contextmenu':
              SyntheticEventCtor = SyntheticMouseEvent;
              break;

            case 'drag':
            case 'dragend':
            case 'dragenter':
            case 'dragexit':
            case 'dragleave':
            case 'dragover':
            case 'dragstart':
            case 'drop':
              SyntheticEventCtor = SyntheticDragEvent;
              break;

            case 'touchcancel':
            case 'touchend':
            case 'touchmove':
            case 'touchstart':
              SyntheticEventCtor = SyntheticTouchEvent;
              break;

            case ANIMATION_END:
            case ANIMATION_ITERATION:
            case ANIMATION_START:
              SyntheticEventCtor = SyntheticAnimationEvent;
              break;

            case TRANSITION_END:
              SyntheticEventCtor = SyntheticTransitionEvent;
              break;

            case 'scroll':
              SyntheticEventCtor = SyntheticUIEvent;
              break;

            case 'wheel':
              SyntheticEventCtor = SyntheticWheelEvent;
              break;

            case 'copy':
            case 'cut':
            case 'paste':
              SyntheticEventCtor = SyntheticClipboardEvent;
              break;

            case 'gotpointercapture':
            case 'lostpointercapture':
            case 'pointercancel':
            case 'pointerdown':
            case 'pointermove':
            case 'pointerout':
            case 'pointerover':
            case 'pointerup':
              SyntheticEventCtor = SyntheticPointerEvent;
              break;
          }

          var inCapturePhase = (eventSystemFlags & IS_CAPTURE_PHASE) !== 0;
          {
            // Some events don't bubble in the browser.
            // In the past, React has always bubbled them, but this can be surprising.
            // We're going to try aligning closer to the browser behavior by not bubbling
            // them in React either. We'll start by not bubbling onScroll, and then expand.
            var accumulateTargetOnly = !inCapturePhase && // TODO: ideally, we'd eventually add all events from
            // nonDelegatedEvents list in DOMPluginEventSystem.
            // Then we can remove this special list.
            // This is a breaking change that can wait until React 18.
            domEventName === 'scroll';

            var _listeners = accumulateSinglePhaseListeners(targetInst, reactName, nativeEvent.type, inCapturePhase, accumulateTargetOnly);

            if (_listeners.length > 0) {
              // Intentionally create event lazily.
              var _event = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget);

              dispatchQueue.push({
                event: _event,
                listeners: _listeners
              });
            }
          }
        } // TODO: remove top-level side effect.


        registerSimpleEvents();
        registerEvents$2();
        registerEvents$1();
        registerEvents$3();
        registerEvents();

        function extractEvents$5(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
          // TODO: we should remove the concept of a "SimpleEventPlugin".
          // This is the basic functionality of the event system. All
          // the other plugins are essentially polyfills. So the plugin
          // should probably be inlined somewhere and have its logic
          // be core the to event system. This would potentially allow
          // us to ship builds of React without the polyfilled plugins below.
          extractEvents$4(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags);
          var shouldProcessPolyfillPlugins = (eventSystemFlags & SHOULD_NOT_PROCESS_POLYFILL_EVENT_PLUGINS) === 0; // We don't process these events unless we are in the
          // event's native "bubble" phase, which means that we're
          // not in the capture phase. That's because we emulate
          // the capture phase here still. This is a trade-off,
          // because in an ideal world we would not emulate and use
          // the phases properly, like we do with the SimpleEvent
          // plugin. However, the plugins below either expect
          // emulation (EnterLeave) or use state localized to that
          // plugin (BeforeInput, Change, Select). The state in
          // these modules complicates things, as you'll essentially
          // get the case where the capture phase event might change
          // state, only for the following bubble event to come in
          // later and not trigger anything as the state now
          // invalidates the heuristics of the event plugin. We
          // could alter all these plugins to work in such ways, but
          // that might cause other unknown side-effects that we
          // can't forsee right now.

          if (shouldProcessPolyfillPlugins) {
            extractEvents$2(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags);
            extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
            extractEvents$3(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
            extractEvents(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
          }
        } // List of events that need to be individually attached to media elements.


        var mediaEventTypes = ['abort', 'canplay', 'canplaythrough', 'durationchange', 'emptied', 'encrypted', 'ended', 'error', 'loadeddata', 'loadedmetadata', 'loadstart', 'pause', 'play', 'playing', 'progress', 'ratechange', 'seeked', 'seeking', 'stalled', 'suspend', 'timeupdate', 'volumechange', 'waiting']; // We should not delegate these events to the container, but rather
        // set them on the actual target element itself. This is primarily
        // because these events do not consistently bubble in the DOM.

        var nonDelegatedEvents = new Set(['cancel', 'close', 'invalid', 'load', 'scroll', 'toggle'].concat(mediaEventTypes));

        function executeDispatch(event, listener, currentTarget) {
          var type = event.type || 'unknown-event';
          event.currentTarget = currentTarget;
          invokeGuardedCallbackAndCatchFirstError(type, listener, undefined, event);
          event.currentTarget = null;
        }

        function processDispatchQueueItemsInOrder(event, dispatchListeners, inCapturePhase) {
          var previousInstance;

          if (inCapturePhase) {
            for (var i = dispatchListeners.length - 1; i >= 0; i--) {
              var _dispatchListeners$i = dispatchListeners[i],
                  instance = _dispatchListeners$i.instance,
                  currentTarget = _dispatchListeners$i.currentTarget,
                  listener = _dispatchListeners$i.listener;

              if (instance !== previousInstance && event.isPropagationStopped()) {
                return;
              }

              executeDispatch(event, listener, currentTarget);
              previousInstance = instance;
            }
          } else {
            for (var _i = 0; _i < dispatchListeners.length; _i++) {
              var _dispatchListeners$_i = dispatchListeners[_i],
                  _instance = _dispatchListeners$_i.instance,
                  _currentTarget = _dispatchListeners$_i.currentTarget,
                  _listener = _dispatchListeners$_i.listener;

              if (_instance !== previousInstance && event.isPropagationStopped()) {
                return;
              }

              executeDispatch(event, _listener, _currentTarget);
              previousInstance = _instance;
            }
          }
        }

        function processDispatchQueue(dispatchQueue, eventSystemFlags) {
          var inCapturePhase = (eventSystemFlags & IS_CAPTURE_PHASE) !== 0;

          for (var i = 0; i < dispatchQueue.length; i++) {
            var _dispatchQueue$i = dispatchQueue[i],
                event = _dispatchQueue$i.event,
                listeners = _dispatchQueue$i.listeners;
            processDispatchQueueItemsInOrder(event, listeners, inCapturePhase); //  event system doesn't use pooling.
          } // This would be a good time to rethrow if any of the event handlers threw.


          rethrowCaughtError();
        }

        function dispatchEventsForPlugins(domEventName, eventSystemFlags, nativeEvent, targetInst, targetContainer) {
          var nativeEventTarget = getEventTarget(nativeEvent);
          var dispatchQueue = [];
          extractEvents$5(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags);
          processDispatchQueue(dispatchQueue, eventSystemFlags);
        }

        function listenToNonDelegatedEvent(domEventName, targetElement) {
          var isCapturePhaseListener = false;
          var listenerSet = getEventListenerSet(targetElement);
          var listenerSetKey = getListenerSetKey(domEventName, isCapturePhaseListener);

          if (!listenerSet.has(listenerSetKey)) {
            addTrappedEventListener(targetElement, domEventName, IS_NON_DELEGATED, isCapturePhaseListener);
            listenerSet.add(listenerSetKey);
          }
        }

        var listeningMarker = '_reactListening' + Math.random().toString(36).slice(2);

        function listenToAllSupportedEvents(rootContainerElement) {
          {
            if (rootContainerElement[listeningMarker]) {
              // Performance optimization: don't iterate through events
              // for the same portal container or root node more than once.
              // TODO: once we remove the flag, we may be able to also
              // remove some of the bookkeeping maps used for laziness.
              return;
            }

            rootContainerElement[listeningMarker] = true;
            allNativeEvents.forEach(function (domEventName) {
              if (!nonDelegatedEvents.has(domEventName)) {
                listenToNativeEvent(domEventName, false, rootContainerElement, null);
              }

              listenToNativeEvent(domEventName, true, rootContainerElement, null);
            });
          }
        }

        function listenToNativeEvent(domEventName, isCapturePhaseListener, rootContainerElement, targetElement) {
          var eventSystemFlags = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
          var target = rootContainerElement; // selectionchange needs to be attached to the document
          // otherwise it won't capture incoming events that are only
          // triggered on the document directly.

          if (domEventName === 'selectionchange' && rootContainerElement.nodeType !== DOCUMENT_NODE) {
            target = rootContainerElement.ownerDocument;
          } // If the event can be delegated (or is capture phase), we can
          // register it to the root container. Otherwise, we should
          // register the event to the target element and mark it as
          // a non-delegated event.


          if (targetElement !== null && !isCapturePhaseListener && nonDelegatedEvents.has(domEventName)) {
            // For all non-delegated events, apart from scroll, we attach
            // their event listeners to the respective elements that their
            // events fire on. That means we can skip this step, as event
            // listener has already been added previously. However, we
            // special case the scroll event because the reality is that any
            // element can scroll.
            // TODO: ideally, we'd eventually apply the same logic to all
            // events from the nonDelegatedEvents list. Then we can remove
            // this special case and use the same logic for all events.
            if (domEventName !== 'scroll') {
              return;
            }

            eventSystemFlags |= IS_NON_DELEGATED;
            target = targetElement;
          }

          var listenerSet = getEventListenerSet(target);
          var listenerSetKey = getListenerSetKey(domEventName, isCapturePhaseListener); // If the listener entry is empty or we should upgrade, then
          // we need to trap an event listener onto the target.

          if (!listenerSet.has(listenerSetKey)) {
            if (isCapturePhaseListener) {
              eventSystemFlags |= IS_CAPTURE_PHASE;
            }

            addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
            listenerSet.add(listenerSetKey);
          }
        }

        function addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener, isDeferredListenerForLegacyFBSupport) {
          var listener = createEventListenerWrapperWithPriority(targetContainer, domEventName, eventSystemFlags); // If passive option is not supported, then the event will be
          // active and not passive.

          var isPassiveListener = undefined;

          if (passiveBrowserEventsSupported) {
            // Browsers introduced an intervention, making these events
            // passive by default on document. React doesn't bind them
            // to document anymore, but changing this now would undo
            // the performance wins from the change. So we emulate
            // the existing behavior manually on the roots now.
            // https://github.com/facebook/react/issues/19651
            if (domEventName === 'touchstart' || domEventName === 'touchmove' || domEventName === 'wheel') {
              isPassiveListener = true;
            }
          }

          targetContainer = targetContainer;
          var unsubscribeListener; // When legacyFBSupport is enabled, it's for when we

          if (isCapturePhaseListener) {
            if (isPassiveListener !== undefined) {
              unsubscribeListener = addEventCaptureListenerWithPassiveFlag(targetContainer, domEventName, listener, isPassiveListener);
            } else {
              unsubscribeListener = addEventCaptureListener(targetContainer, domEventName, listener);
            }
          } else {
            if (isPassiveListener !== undefined) {
              unsubscribeListener = addEventBubbleListenerWithPassiveFlag(targetContainer, domEventName, listener, isPassiveListener);
            } else {
              unsubscribeListener = addEventBubbleListener(targetContainer, domEventName, listener);
            }
          }
        }

        function isMatchingRootContainer(grandContainer, targetContainer) {
          return grandContainer === targetContainer || grandContainer.nodeType === COMMENT_NODE && grandContainer.parentNode === targetContainer;
        }

        function dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst, targetContainer) {
          var ancestorInst = targetInst;

          if ((eventSystemFlags & IS_EVENT_HANDLE_NON_MANAGED_NODE) === 0 && (eventSystemFlags & IS_NON_DELEGATED) === 0) {
            var targetContainerNode = targetContainer; // If we are using the legacy FB support flag, we

            if (targetInst !== null) {
              // The below logic attempts to work out if we need to change
              // the target fiber to a different ancestor. We had similar logic
              // in the legacy event system, except the big difference between
              // systems is that the modern event system now has an event listener
              // attached to each React Root and React Portal Root. Together,
              // the DOM nodes representing these roots are the "rootContainer".
              // To figure out which ancestor instance we should use, we traverse
              // up the fiber tree from the target instance and attempt to find
              // root boundaries that match that of our current "rootContainer".
              // If we find that "rootContainer", we find the parent fiber
              // sub-tree for that root and make that our ancestor instance.
              var node = targetInst;

              mainLoop: while (true) {
                if (node === null) {
                  return;
                }

                var nodeTag = node.tag;

                if (nodeTag === HostRoot || nodeTag === HostPortal) {
                  var container = node.stateNode.containerInfo;

                  if (isMatchingRootContainer(container, targetContainerNode)) {
                    break;
                  }

                  if (nodeTag === HostPortal) {
                    // The target is a portal, but it's not the rootContainer we're looking for.
                    // Normally portals handle their own events all the way down to the root.
                    // So we should be able to stop now. However, we don't know if this portal
                    // was part of *our* root.
                    var grandNode = node.return;

                    while (grandNode !== null) {
                      var grandTag = grandNode.tag;

                      if (grandTag === HostRoot || grandTag === HostPortal) {
                        var grandContainer = grandNode.stateNode.containerInfo;

                        if (isMatchingRootContainer(grandContainer, targetContainerNode)) {
                          // This is the rootContainer we're looking for and we found it as
                          // a parent of the Portal. That means we can ignore it because the
                          // Portal will bubble through to us.
                          return;
                        }
                      }

                      grandNode = grandNode.return;
                    }
                  } // Now we need to find it's corresponding host fiber in the other
                  // tree. To do this we can use getClosestInstanceFromNode, but we
                  // need to validate that the fiber is a host instance, otherwise
                  // we need to traverse up through the DOM till we find the correct
                  // node that is from the other tree.


                  while (container !== null) {
                    var parentNode = getClosestInstanceFromNode(container);

                    if (parentNode === null) {
                      return;
                    }

                    var parentTag = parentNode.tag;

                    if (parentTag === HostComponent || parentTag === HostText) {
                      node = ancestorInst = parentNode;
                      continue mainLoop;
                    }

                    container = container.parentNode;
                  }
                }

                node = node.return;
              }
            }
          }

          batchedEventUpdates(function () {
            return dispatchEventsForPlugins(domEventName, eventSystemFlags, nativeEvent, ancestorInst);
          });
        }

        function createDispatchListener(instance, listener, currentTarget) {
          return {
            instance: instance,
            listener: listener,
            currentTarget: currentTarget
          };
        }

        function accumulateSinglePhaseListeners(targetFiber, reactName, nativeEventType, inCapturePhase, accumulateTargetOnly) {
          var captureName = reactName !== null ? reactName + 'Capture' : null;
          var reactEventName = inCapturePhase ? captureName : reactName;
          var listeners = [];
          var instance = targetFiber;
          var lastHostComponent = null; // Accumulate all instances and listeners via the target -> root path.

          while (instance !== null) {
            var _instance2 = instance,
                stateNode = _instance2.stateNode,
                tag = _instance2.tag; // Handle listeners that are on HostComponents (i.e. <div>)

            if (tag === HostComponent && stateNode !== null) {
              lastHostComponent = stateNode; // createEventHandle listeners

              if (reactEventName !== null) {
                var listener = getListener(instance, reactEventName);

                if (listener != null) {
                  listeners.push(createDispatchListener(instance, listener, lastHostComponent));
                }
              }
            } // If we are only accumulating events for the target, then we don't
            // continue to propagate through the React fiber tree to find other
            // listeners.


            if (accumulateTargetOnly) {
              break;
            }

            instance = instance.return;
          }

          return listeners;
        } // We should only use this function for:
        // - BeforeInputEventPlugin
        // - ChangeEventPlugin
        // - SelectEventPlugin
        // This is because we only process these plugins
        // in the bubble phase, so we need to accumulate two
        // phase event listeners (via emulation).


        function accumulateTwoPhaseListeners(targetFiber, reactName) {
          var captureName = reactName + 'Capture';
          var listeners = [];
          var instance = targetFiber; // Accumulate all instances and listeners via the target -> root path.

          while (instance !== null) {
            var _instance3 = instance,
                stateNode = _instance3.stateNode,
                tag = _instance3.tag; // Handle listeners that are on HostComponents (i.e. <div>)

            if (tag === HostComponent && stateNode !== null) {
              var currentTarget = stateNode;
              var captureListener = getListener(instance, captureName);

              if (captureListener != null) {
                listeners.unshift(createDispatchListener(instance, captureListener, currentTarget));
              }

              var bubbleListener = getListener(instance, reactName);

              if (bubbleListener != null) {
                listeners.push(createDispatchListener(instance, bubbleListener, currentTarget));
              }
            }

            instance = instance.return;
          }

          return listeners;
        }

        function getParent(inst) {
          if (inst === null) {
            return null;
          }

          do {
            inst = inst.return; // TODO: If this is a HostRoot we might want to bail out.
            // That is depending on if we want nested subtrees (layers) to bubble
            // events to their parent. We could also go through parentNode on the
            // host node but that wouldn't work for React Native and doesn't let us
            // do the portal feature.
          } while (inst && inst.tag !== HostComponent);

          if (inst) {
            return inst;
          }

          return null;
        }
        /**
         * Return the lowest common ancestor of A and B, or null if they are in
         * different trees.
         */


        function getLowestCommonAncestor(instA, instB) {
          var nodeA = instA;
          var nodeB = instB;
          var depthA = 0;

          for (var tempA = nodeA; tempA; tempA = getParent(tempA)) {
            depthA++;
          }

          var depthB = 0;

          for (var tempB = nodeB; tempB; tempB = getParent(tempB)) {
            depthB++;
          } // If A is deeper, crawl up.


          while (depthA - depthB > 0) {
            nodeA = getParent(nodeA);
            depthA--;
          } // If B is deeper, crawl up.


          while (depthB - depthA > 0) {
            nodeB = getParent(nodeB);
            depthB--;
          } // Walk in lockstep until we find a match.


          var depth = depthA;

          while (depth--) {
            if (nodeA === nodeB || nodeB !== null && nodeA === nodeB.alternate) {
              return nodeA;
            }

            nodeA = getParent(nodeA);
            nodeB = getParent(nodeB);
          }

          return null;
        }

        function accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
          var registrationName = event._reactName;
          var listeners = [];
          var instance = target;

          while (instance !== null) {
            if (instance === common) {
              break;
            }

            var _instance4 = instance,
                alternate = _instance4.alternate,
                stateNode = _instance4.stateNode,
                tag = _instance4.tag;

            if (alternate !== null && alternate === common) {
              break;
            }

            if (tag === HostComponent && stateNode !== null) {
              var currentTarget = stateNode;

              if (inCapturePhase) {
                var captureListener = getListener(instance, registrationName);

                if (captureListener != null) {
                  listeners.unshift(createDispatchListener(instance, captureListener, currentTarget));
                }
              } else if (!inCapturePhase) {
                var bubbleListener = getListener(instance, registrationName);

                if (bubbleListener != null) {
                  listeners.push(createDispatchListener(instance, bubbleListener, currentTarget));
                }
              }
            }

            instance = instance.return;
          }

          if (listeners.length !== 0) {
            dispatchQueue.push({
              event: event,
              listeners: listeners
            });
          }
        } // We should only use this function for:
        // - EnterLeaveEventPlugin
        // This is because we only process this plugin
        // in the bubble phase, so we need to accumulate two
        // phase event listeners.


        function accumulateEnterLeaveTwoPhaseListeners(dispatchQueue, leaveEvent, enterEvent, from, to) {
          var common = from && to ? getLowestCommonAncestor(from, to) : null;

          if (from !== null) {
            accumulateEnterLeaveListenersForEvent(dispatchQueue, leaveEvent, from, common, false);
          }

          if (to !== null && enterEvent !== null) {
            accumulateEnterLeaveListenersForEvent(dispatchQueue, enterEvent, to, common, true);
          }
        }

        function getListenerSetKey(domEventName, capture) {
          return domEventName + "__" + (capture ? 'capture' : 'bubble');
        }

        var didWarnInvalidHydration = false;
        var DANGEROUSLY_SET_INNER_HTML = 'dangerouslySetInnerHTML';
        var SUPPRESS_CONTENT_EDITABLE_WARNING = 'suppressContentEditableWarning';
        var SUPPRESS_HYDRATION_WARNING = 'suppressHydrationWarning';
        var AUTOFOCUS = 'autoFocus';
        var CHILDREN = 'children';
        var STYLE = 'style';
        var HTML$1 = '__html';
        var HTML_NAMESPACE$1 = Namespaces.html;
        var warnedUnknownTags;
        var suppressHydrationWarning;
        var validatePropertiesInDevelopment;
        var warnForTextDifference;
        var warnForPropDifference;
        var warnForExtraAttributes;
        var warnForInvalidEventListener;
        var canDiffStyleForHydrationWarning;
        var normalizeMarkupForTextOrAttribute;
        var normalizeHTML;
        {
          warnedUnknownTags = {
            // There are working polyfills for <dialog>. Let people use it.
            dialog: true,
            // Electron ships a custom <webview> tag to display external web content in
            // an isolated frame and process.
            // This tag is not present in non Electron environments such as JSDom which
            // is often used for testing purposes.
            // @see https://electronjs.org/docs/api/webview-tag
            webview: true
          };

          validatePropertiesInDevelopment = function validatePropertiesInDevelopment(type, props) {
            validateProperties(type, props);
            validateProperties$1(type, props);
            validateProperties$2(type, props, {
              registrationNameDependencies: registrationNameDependencies,
              possibleRegistrationNames: possibleRegistrationNames
            });
          }; // IE 11 parses & normalizes the style attribute as opposed to other
          // browsers. It adds spaces and sorts the properties in some
          // non-alphabetical order. Handling that would require sorting CSS
          // properties in the client & server versions or applying
          // `expectedStyle` to a temporary DOM node to read its `style` attribute
          // normalized. Since it only affects IE, we're skipping style warnings
          // in that browser completely in favor of doing all that work.
          // See https://github.com/facebook/react/issues/11807


          canDiffStyleForHydrationWarning = canUseDOM && !document.documentMode; // HTML parsing normalizes CR and CRLF to LF.
          // It also can turn \u0000 into \uFFFD inside attributes.
          // https://www.w3.org/TR/html5/single-page.html#preprocessing-the-input-stream
          // If we have a mismatch, it might be caused by that.
          // We will still patch up in this case but not fire the warning.

          var NORMALIZE_NEWLINES_REGEX = /\r\n?/g;
          var NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;

          normalizeMarkupForTextOrAttribute = function normalizeMarkupForTextOrAttribute(markup) {
            var markupString = typeof markup === 'string' ? markup : '' + markup;
            return markupString.replace(NORMALIZE_NEWLINES_REGEX, '\n').replace(NORMALIZE_NULL_AND_REPLACEMENT_REGEX, '');
          };

          warnForTextDifference = function warnForTextDifference(serverText, clientText) {
            if (didWarnInvalidHydration) {
              return;
            }

            var normalizedClientText = normalizeMarkupForTextOrAttribute(clientText);
            var normalizedServerText = normalizeMarkupForTextOrAttribute(serverText);

            if (normalizedServerText === normalizedClientText) {
              return;
            }

            didWarnInvalidHydration = true;
            error('Text content did not match. Server: "%s" Client: "%s"', normalizedServerText, normalizedClientText);
          };

          warnForPropDifference = function warnForPropDifference(propName, serverValue, clientValue) {
            if (didWarnInvalidHydration) {
              return;
            }

            var normalizedClientValue = normalizeMarkupForTextOrAttribute(clientValue);
            var normalizedServerValue = normalizeMarkupForTextOrAttribute(serverValue);

            if (normalizedServerValue === normalizedClientValue) {
              return;
            }

            didWarnInvalidHydration = true;
            error('Prop `%s` did not match. Server: %s Client: %s', propName, JSON.stringify(normalizedServerValue), JSON.stringify(normalizedClientValue));
          };

          warnForExtraAttributes = function warnForExtraAttributes(attributeNames) {
            if (didWarnInvalidHydration) {
              return;
            }

            didWarnInvalidHydration = true;
            var names = [];
            attributeNames.forEach(function (name) {
              names.push(name);
            });
            error('Extra attributes from the server: %s', names);
          };

          warnForInvalidEventListener = function warnForInvalidEventListener(registrationName, listener) {
            if (listener === false) {
              error('Expected `%s` listener to be a function, instead got `false`.\n\n' + 'If you used to conditionally omit it with %s={condition && value}, ' + 'pass %s={condition ? value : undefined} instead.', registrationName, registrationName, registrationName);
            } else {
              error('Expected `%s` listener to be a function, instead got a value of `%s` type.', registrationName, typeof listener);
            }
          }; // Parse the HTML and read it back to normalize the HTML string so that it
          // can be used for comparison.


          normalizeHTML = function normalizeHTML(parent, html) {
            // We could have created a separate document here to avoid
            // re-initializing custom elements if they exist. But this breaks
            // how <noscript> is being handled. So we use the same document.
            // See the discussion in https://github.com/facebook/react/pull/11157.
            var testElement = parent.namespaceURI === HTML_NAMESPACE$1 ? parent.ownerDocument.createElement(parent.tagName) : parent.ownerDocument.createElementNS(parent.namespaceURI, parent.tagName);
            testElement.innerHTML = html;
            return testElement.innerHTML;
          };
        }

        function getOwnerDocumentFromRootContainer(rootContainerElement) {
          return rootContainerElement.nodeType === DOCUMENT_NODE ? rootContainerElement : rootContainerElement.ownerDocument;
        }

        function noop() {}

        function trapClickOnNonInteractiveElement(node) {
          // Mobile Safari does not fire properly bubble click events on
          // non-interactive elements, which means delegated click listeners do not
          // fire. The workaround for this bug involves attaching an empty click
          // listener on the target node.
          // https://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
          // Just set it using the onclick property so that we don't have to manage any
          // bookkeeping for it. Not sure if we need to clear it when the listener is
          // removed.
          // TODO: Only do this for the relevant Safaris maybe?
          node.onclick = noop;
        }

        function setInitialDOMProperties(tag, domElement, rootContainerElement, nextProps, isCustomComponentTag) {
          for (var propKey in nextProps) {
            if (!nextProps.hasOwnProperty(propKey)) {
              continue;
            }

            var nextProp = nextProps[propKey];

            if (propKey === STYLE) {
              {
                if (nextProp) {
                  // Freeze the next style object so that we can assume it won't be
                  // mutated. We have already warned for this in the past.
                  Object.freeze(nextProp);
                }
              } // Relies on `updateStylesByID` not mutating `styleUpdates`.

              setValueForStyles(domElement, nextProp);
            } else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
              var nextHtml = nextProp ? nextProp[HTML$1] : undefined;

              if (nextHtml != null) {
                setInnerHTML(domElement, nextHtml);
              }
            } else if (propKey === CHILDREN) {
              if (typeof nextProp === 'string') {
                // Avoid setting initial textContent when the text is empty. In IE11 setting
                // textContent on a <textarea> will cause the placeholder to not
                // show within the <textarea> until it has been focused and blurred again.
                // https://github.com/facebook/react/issues/6731#issuecomment-254874553
                var canSetTextContent = tag !== 'textarea' || nextProp !== '';

                if (canSetTextContent) {
                  setTextContent(domElement, nextProp);
                }
              } else if (typeof nextProp === 'number') {
                setTextContent(domElement, '' + nextProp);
              }
            } else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ;else if (propKey === AUTOFOCUS) ;else if (registrationNameDependencies.hasOwnProperty(propKey)) {
              if (nextProp != null) {
                if (typeof nextProp !== 'function') {
                  warnForInvalidEventListener(propKey, nextProp);
                }

                if (propKey === 'onScroll') {
                  listenToNonDelegatedEvent('scroll', domElement);
                }
              }
            } else if (nextProp != null) {
              setValueForProperty(domElement, propKey, nextProp, isCustomComponentTag);
            }
          }
        }

        function updateDOMProperties(domElement, updatePayload, wasCustomComponentTag, isCustomComponentTag) {
          // TODO: Handle wasCustomComponentTag
          for (var i = 0; i < updatePayload.length; i += 2) {
            var propKey = updatePayload[i];
            var propValue = updatePayload[i + 1];

            if (propKey === STYLE) {
              setValueForStyles(domElement, propValue);
            } else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
              setInnerHTML(domElement, propValue);
            } else if (propKey === CHILDREN) {
              setTextContent(domElement, propValue);
            } else {
              setValueForProperty(domElement, propKey, propValue, isCustomComponentTag);
            }
          }
        }

        function createElement(type, props, rootContainerElement, parentNamespace) {
          var isCustomComponentTag; // We create tags in the namespace of their parent container, except HTML
          // tags get no namespace.

          var ownerDocument = getOwnerDocumentFromRootContainer(rootContainerElement);
          var domElement;
          var namespaceURI = parentNamespace;

          if (namespaceURI === HTML_NAMESPACE$1) {
            namespaceURI = getIntrinsicNamespace(type);
          }

          if (namespaceURI === HTML_NAMESPACE$1) {
            {
              isCustomComponentTag = isCustomComponent(type, props); // Should this check be gated by parent namespace? Not sure we want to
              // allow <SVG> or <mATH>.

              if (!isCustomComponentTag && type !== type.toLowerCase()) {
                error('<%s /> is using incorrect casing. ' + 'Use PascalCase for React components, ' + 'or lowercase for HTML elements.', type);
              }
            }

            if (type === 'script') {
              // Create the script via .innerHTML so its "parser-inserted" flag is
              // set to true and it does not execute
              var div = ownerDocument.createElement('div');
              div.innerHTML = '<script><' + '/script>'; // eslint-disable-line
              // This is guaranteed to yield a script element.

              var firstChild = div.firstChild;
              domElement = div.removeChild(firstChild);
            } else if (typeof props.is === 'string') {
              // $FlowIssue `createElement` should be updated for Web Components
              domElement = ownerDocument.createElement(type, {
                is: props.is
              });
            } else {
              // Separate else branch instead of using `props.is || undefined` above because of a Firefox bug.
              // See discussion in https://github.com/facebook/react/pull/6896
              // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
              domElement = ownerDocument.createElement(type); // Normally attributes are assigned in `setInitialDOMProperties`, however the `multiple` and `size`
              // attributes on `select`s needs to be added before `option`s are inserted.
              // This prevents:
              // - a bug where the `select` does not scroll to the correct option because singular
              //  `select` elements automatically pick the first item #13222
              // - a bug where the `select` set the first item as selected despite the `size` attribute #14239
              // See https://github.com/facebook/react/issues/13222
              // and https://github.com/facebook/react/issues/14239

              if (type === 'select') {
                var node = domElement;

                if (props.multiple) {
                  node.multiple = true;
                } else if (props.size) {
                  // Setting a size greater than 1 causes a select to behave like `multiple=true`, where
                  // it is possible that no option is selected.
                  //
                  // This is only necessary when a select in "single selection mode".
                  node.size = props.size;
                }
              }
            }
          } else {
            domElement = ownerDocument.createElementNS(namespaceURI, type);
          }

          {
            if (namespaceURI === HTML_NAMESPACE$1) {
              if (!isCustomComponentTag && Object.prototype.toString.call(domElement) === '[object HTMLUnknownElement]' && !Object.prototype.hasOwnProperty.call(warnedUnknownTags, type)) {
                warnedUnknownTags[type] = true;
                error('The tag <%s> is unrecognized in this browser. ' + 'If you meant to render a React component, start its name with ' + 'an uppercase letter.', type);
              }
            }
          }
          return domElement;
        }

        function createTextNode(text, rootContainerElement) {
          return getOwnerDocumentFromRootContainer(rootContainerElement).createTextNode(text);
        }

        function setInitialProperties(domElement, tag, rawProps, rootContainerElement) {
          var isCustomComponentTag = isCustomComponent(tag, rawProps);
          {
            validatePropertiesInDevelopment(tag, rawProps);
          } // TODO: Make sure that we check isMounted before firing any of these events.

          var props;

          switch (tag) {
            case 'dialog':
              listenToNonDelegatedEvent('cancel', domElement);
              listenToNonDelegatedEvent('close', domElement);
              props = rawProps;
              break;

            case 'iframe':
            case 'object':
            case 'embed':
              // We listen to this event in case to ensure emulated bubble
              // listeners still fire for the load event.
              listenToNonDelegatedEvent('load', domElement);
              props = rawProps;
              break;

            case 'video':
            case 'audio':
              // We listen to these events in case to ensure emulated bubble
              // listeners still fire for all the media events.
              for (var i = 0; i < mediaEventTypes.length; i++) {
                listenToNonDelegatedEvent(mediaEventTypes[i], domElement);
              }

              props = rawProps;
              break;

            case 'source':
              // We listen to this event in case to ensure emulated bubble
              // listeners still fire for the error event.
              listenToNonDelegatedEvent('error', domElement);
              props = rawProps;
              break;

            case 'img':
            case 'image':
            case 'link':
              // We listen to these events in case to ensure emulated bubble
              // listeners still fire for error and load events.
              listenToNonDelegatedEvent('error', domElement);
              listenToNonDelegatedEvent('load', domElement);
              props = rawProps;
              break;

            case 'details':
              // We listen to this event in case to ensure emulated bubble
              // listeners still fire for the toggle event.
              listenToNonDelegatedEvent('toggle', domElement);
              props = rawProps;
              break;

            case 'input':
              initWrapperState(domElement, rawProps);
              props = getHostProps(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
              // listeners still fire for the invalid event.

              listenToNonDelegatedEvent('invalid', domElement);
              break;

            case 'option':
              validateProps(domElement, rawProps);
              props = getHostProps$1(domElement, rawProps);
              break;

            case 'select':
              initWrapperState$1(domElement, rawProps);
              props = getHostProps$2(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
              // listeners still fire for the invalid event.

              listenToNonDelegatedEvent('invalid', domElement);
              break;

            case 'textarea':
              initWrapperState$2(domElement, rawProps);
              props = getHostProps$3(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
              // listeners still fire for the invalid event.

              listenToNonDelegatedEvent('invalid', domElement);
              break;

            default:
              props = rawProps;
          }

          assertValidProps(tag, props);
          setInitialDOMProperties(tag, domElement, rootContainerElement, props, isCustomComponentTag);

          switch (tag) {
            case 'input':
              // TODO: Make sure we check if this is still unmounted or do any clean
              // up necessary since we never stop tracking anymore.
              track(domElement);
              postMountWrapper(domElement, rawProps, false);
              break;

            case 'textarea':
              // TODO: Make sure we check if this is still unmounted or do any clean
              // up necessary since we never stop tracking anymore.
              track(domElement);
              postMountWrapper$3(domElement);
              break;

            case 'option':
              postMountWrapper$1(domElement, rawProps);
              break;

            case 'select':
              postMountWrapper$2(domElement, rawProps);
              break;

            default:
              if (typeof props.onClick === 'function') {
                // TODO: This cast may not be sound for SVG, MathML or custom elements.
                trapClickOnNonInteractiveElement(domElement);
              }

              break;
          }
        } // Calculate the diff between the two objects.


        function diffProperties(domElement, tag, lastRawProps, nextRawProps, rootContainerElement) {
          {
            validatePropertiesInDevelopment(tag, nextRawProps);
          }
          var updatePayload = null;
          var lastProps;
          var nextProps;

          switch (tag) {
            case 'input':
              lastProps = getHostProps(domElement, lastRawProps);
              nextProps = getHostProps(domElement, nextRawProps);
              updatePayload = [];
              break;

            case 'option':
              lastProps = getHostProps$1(domElement, lastRawProps);
              nextProps = getHostProps$1(domElement, nextRawProps);
              updatePayload = [];
              break;

            case 'select':
              lastProps = getHostProps$2(domElement, lastRawProps);
              nextProps = getHostProps$2(domElement, nextRawProps);
              updatePayload = [];
              break;

            case 'textarea':
              lastProps = getHostProps$3(domElement, lastRawProps);
              nextProps = getHostProps$3(domElement, nextRawProps);
              updatePayload = [];
              break;

            default:
              lastProps = lastRawProps;
              nextProps = nextRawProps;

              if (typeof lastProps.onClick !== 'function' && typeof nextProps.onClick === 'function') {
                // TODO: This cast may not be sound for SVG, MathML or custom elements.
                trapClickOnNonInteractiveElement(domElement);
              }

              break;
          }

          assertValidProps(tag, nextProps);
          var propKey;
          var styleName;
          var styleUpdates = null;

          for (propKey in lastProps) {
            if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
              continue;
            }

            if (propKey === STYLE) {
              var lastStyle = lastProps[propKey];

              for (styleName in lastStyle) {
                if (lastStyle.hasOwnProperty(styleName)) {
                  if (!styleUpdates) {
                    styleUpdates = {};
                  }

                  styleUpdates[styleName] = '';
                }
              }
            } else if (propKey === DANGEROUSLY_SET_INNER_HTML || propKey === CHILDREN) ;else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ;else if (propKey === AUTOFOCUS) ;else if (registrationNameDependencies.hasOwnProperty(propKey)) {
              // This is a special case. If any listener updates we need to ensure
              // that the "current" fiber pointer gets updated so we need a commit
              // to update this element.
              if (!updatePayload) {
                updatePayload = [];
              }
            } else {
              // For all other deleted properties we add it to the queue. We use
              // the allowed property list in the commit phase instead.
              (updatePayload = updatePayload || []).push(propKey, null);
            }
          }

          for (propKey in nextProps) {
            var nextProp = nextProps[propKey];
            var lastProp = lastProps != null ? lastProps[propKey] : undefined;

            if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
              continue;
            }

            if (propKey === STYLE) {
              {
                if (nextProp) {
                  // Freeze the next style object so that we can assume it won't be
                  // mutated. We have already warned for this in the past.
                  Object.freeze(nextProp);
                }
              }

              if (lastProp) {
                // Unset styles on `lastProp` but not on `nextProp`.
                for (styleName in lastProp) {
                  if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
                    if (!styleUpdates) {
                      styleUpdates = {};
                    }

                    styleUpdates[styleName] = '';
                  }
                } // Update styles that changed since `lastProp`.


                for (styleName in nextProp) {
                  if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
                    if (!styleUpdates) {
                      styleUpdates = {};
                    }

                    styleUpdates[styleName] = nextProp[styleName];
                  }
                }
              } else {
                // Relies on `updateStylesByID` not mutating `styleUpdates`.
                if (!styleUpdates) {
                  if (!updatePayload) {
                    updatePayload = [];
                  }

                  updatePayload.push(propKey, styleUpdates);
                }

                styleUpdates = nextProp;
              }
            } else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
              var nextHtml = nextProp ? nextProp[HTML$1] : undefined;
              var lastHtml = lastProp ? lastProp[HTML$1] : undefined;

              if (nextHtml != null) {
                if (lastHtml !== nextHtml) {
                  (updatePayload = updatePayload || []).push(propKey, nextHtml);
                }
              }
            } else if (propKey === CHILDREN) {
              if (typeof nextProp === 'string' || typeof nextProp === 'number') {
                (updatePayload = updatePayload || []).push(propKey, '' + nextProp);
              }
            } else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ;else if (registrationNameDependencies.hasOwnProperty(propKey)) {
              if (nextProp != null) {
                // We eagerly listen to this even though we haven't committed yet.
                if (typeof nextProp !== 'function') {
                  warnForInvalidEventListener(propKey, nextProp);
                }

                if (propKey === 'onScroll') {
                  listenToNonDelegatedEvent('scroll', domElement);
                }
              }

              if (!updatePayload && lastProp !== nextProp) {
                // This is a special case. If any listener updates we need to ensure
                // that the "current" props pointer gets updated so we need a commit
                // to update this element.
                updatePayload = [];
              }
            } else if (typeof nextProp === 'object' && nextProp !== null && nextProp.$$typeof === REACT_OPAQUE_ID_TYPE) {
              // If we encounter useOpaqueReference's opaque object, this means we are hydrating.
              // In this case, call the opaque object's toString function which generates a new client
              // ID so client and server IDs match and throws to rerender.
              nextProp.toString();
            } else {
              // For any other property we always add it to the queue and then we
              // filter it out using the allowed property list during the commit.
              (updatePayload = updatePayload || []).push(propKey, nextProp);
            }
          }

          if (styleUpdates) {
            {
              validateShorthandPropertyCollisionInDev(styleUpdates, nextProps[STYLE]);
            }
            (updatePayload = updatePayload || []).push(STYLE, styleUpdates);
          }

          return updatePayload;
        } // Apply the diff.


        function updateProperties(domElement, updatePayload, tag, lastRawProps, nextRawProps) {
          // Update checked *before* name.
          // In the middle of an update, it is possible to have multiple checked.
          // When a checked radio tries to change name, browser makes another radio's checked false.
          if (tag === 'input' && nextRawProps.type === 'radio' && nextRawProps.name != null) {
            updateChecked(domElement, nextRawProps);
          }

          var wasCustomComponentTag = isCustomComponent(tag, lastRawProps);
          var isCustomComponentTag = isCustomComponent(tag, nextRawProps); // Apply the diff.

          updateDOMProperties(domElement, updatePayload, wasCustomComponentTag, isCustomComponentTag); // TODO: Ensure that an update gets scheduled if any of the special props
          // changed.

          switch (tag) {
            case 'input':
              // Update the wrapper around inputs *after* updating props. This has to
              // happen after `updateDOMProperties`. Otherwise HTML5 input validations
              // raise warnings and prevent the new value from being assigned.
              updateWrapper(domElement, nextRawProps);
              break;

            case 'textarea':
              updateWrapper$1(domElement, nextRawProps);
              break;

            case 'select':
              // <select> value update needs to occur after <option> children
              // reconciliation
              postUpdateWrapper(domElement, nextRawProps);
              break;
          }
        }

        function getPossibleStandardName(propName) {
          {
            var lowerCasedName = propName.toLowerCase();

            if (!possibleStandardNames.hasOwnProperty(lowerCasedName)) {
              return null;
            }

            return possibleStandardNames[lowerCasedName] || null;
          }
        }

        function diffHydratedProperties(domElement, tag, rawProps, parentNamespace, rootContainerElement) {
          var isCustomComponentTag;
          var extraAttributeNames;
          {
            suppressHydrationWarning = rawProps[SUPPRESS_HYDRATION_WARNING] === true;
            isCustomComponentTag = isCustomComponent(tag, rawProps);
            validatePropertiesInDevelopment(tag, rawProps);
          } // TODO: Make sure that we check isMounted before firing any of these events.

          switch (tag) {
            case 'dialog':
              listenToNonDelegatedEvent('cancel', domElement);
              listenToNonDelegatedEvent('close', domElement);
              break;

            case 'iframe':
            case 'object':
            case 'embed':
              // We listen to this event in case to ensure emulated bubble
              // listeners still fire for the load event.
              listenToNonDelegatedEvent('load', domElement);
              break;

            case 'video':
            case 'audio':
              // We listen to these events in case to ensure emulated bubble
              // listeners still fire for all the media events.
              for (var i = 0; i < mediaEventTypes.length; i++) {
                listenToNonDelegatedEvent(mediaEventTypes[i], domElement);
              }

              break;

            case 'source':
              // We listen to this event in case to ensure emulated bubble
              // listeners still fire for the error event.
              listenToNonDelegatedEvent('error', domElement);
              break;

            case 'img':
            case 'image':
            case 'link':
              // We listen to these events in case to ensure emulated bubble
              // listeners still fire for error and load events.
              listenToNonDelegatedEvent('error', domElement);
              listenToNonDelegatedEvent('load', domElement);
              break;

            case 'details':
              // We listen to this event in case to ensure emulated bubble
              // listeners still fire for the toggle event.
              listenToNonDelegatedEvent('toggle', domElement);
              break;

            case 'input':
              initWrapperState(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
              // listeners still fire for the invalid event.

              listenToNonDelegatedEvent('invalid', domElement);
              break;

            case 'option':
              validateProps(domElement, rawProps);
              break;

            case 'select':
              initWrapperState$1(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
              // listeners still fire for the invalid event.

              listenToNonDelegatedEvent('invalid', domElement);
              break;

            case 'textarea':
              initWrapperState$2(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
              // listeners still fire for the invalid event.

              listenToNonDelegatedEvent('invalid', domElement);
              break;
          }

          assertValidProps(tag, rawProps);
          {
            extraAttributeNames = new Set();
            var attributes = domElement.attributes;

            for (var _i = 0; _i < attributes.length; _i++) {
              var name = attributes[_i].name.toLowerCase();

              switch (name) {
                // Built-in SSR attribute is allowed
                case 'data-reactroot':
                  break;
                // Controlled attributes are not validated
                // TODO: Only ignore them on controlled tags.

                case 'value':
                  break;

                case 'checked':
                  break;

                case 'selected':
                  break;

                default:
                  // Intentionally use the original name.
                  // See discussion in https://github.com/facebook/react/pull/10676.
                  extraAttributeNames.add(attributes[_i].name);
              }
            }
          }
          var updatePayload = null;

          for (var propKey in rawProps) {
            if (!rawProps.hasOwnProperty(propKey)) {
              continue;
            }

            var nextProp = rawProps[propKey];

            if (propKey === CHILDREN) {
              // For text content children we compare against textContent. This
              // might match additional HTML that is hidden when we read it using
              // textContent. E.g. "foo" will match "f<span>oo</span>" but that still
              // satisfies our requirement. Our requirement is not to produce perfect
              // HTML and attributes. Ideally we should preserve structure but it's
              // ok not to if the visible content is still enough to indicate what
              // even listeners these nodes might be wired up to.
              // TODO: Warn if there is more than a single textNode as a child.
              // TODO: Should we use domElement.firstChild.nodeValue to compare?
              if (typeof nextProp === 'string') {
                if (domElement.textContent !== nextProp) {
                  if (!suppressHydrationWarning) {
                    warnForTextDifference(domElement.textContent, nextProp);
                  }

                  updatePayload = [CHILDREN, nextProp];
                }
              } else if (typeof nextProp === 'number') {
                if (domElement.textContent !== '' + nextProp) {
                  if (!suppressHydrationWarning) {
                    warnForTextDifference(domElement.textContent, nextProp);
                  }

                  updatePayload = [CHILDREN, '' + nextProp];
                }
              }
            } else if (registrationNameDependencies.hasOwnProperty(propKey)) {
              if (nextProp != null) {
                if (typeof nextProp !== 'function') {
                  warnForInvalidEventListener(propKey, nextProp);
                }

                if (propKey === 'onScroll') {
                  listenToNonDelegatedEvent('scroll', domElement);
                }
              }
            } else if ( // Convince Flow we've calculated it (it's DEV-only in this method.)
            typeof isCustomComponentTag === 'boolean') {
              // Validate that the properties correspond to their expected values.
              var serverValue = void 0;
              var propertyInfo = getPropertyInfo(propKey);
              if (suppressHydrationWarning) ;else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING || // Controlled attributes are not validated
              // TODO: Only ignore them on controlled tags.
              propKey === 'value' || propKey === 'checked' || propKey === 'selected') ;else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
                var serverHTML = domElement.innerHTML;
                var nextHtml = nextProp ? nextProp[HTML$1] : undefined;

                if (nextHtml != null) {
                  var expectedHTML = normalizeHTML(domElement, nextHtml);

                  if (expectedHTML !== serverHTML) {
                    warnForPropDifference(propKey, serverHTML, expectedHTML);
                  }
                }
              } else if (propKey === STYLE) {
                // $FlowFixMe - Should be inferred as not undefined.
                extraAttributeNames.delete(propKey);

                if (canDiffStyleForHydrationWarning) {
                  var expectedStyle = createDangerousStringForStyles(nextProp);
                  serverValue = domElement.getAttribute('style');

                  if (expectedStyle !== serverValue) {
                    warnForPropDifference(propKey, serverValue, expectedStyle);
                  }
                }
              } else if (isCustomComponentTag) {
                // $FlowFixMe - Should be inferred as not undefined.
                extraAttributeNames.delete(propKey.toLowerCase());
                serverValue = getValueForAttribute(domElement, propKey, nextProp);

                if (nextProp !== serverValue) {
                  warnForPropDifference(propKey, serverValue, nextProp);
                }
              } else if (!shouldIgnoreAttribute(propKey, propertyInfo, isCustomComponentTag) && !shouldRemoveAttribute(propKey, nextProp, propertyInfo, isCustomComponentTag)) {
                var isMismatchDueToBadCasing = false;

                if (propertyInfo !== null) {
                  // $FlowFixMe - Should be inferred as not undefined.
                  extraAttributeNames.delete(propertyInfo.attributeName);
                  serverValue = getValueForProperty(domElement, propKey, nextProp, propertyInfo);
                } else {
                  var ownNamespace = parentNamespace;

                  if (ownNamespace === HTML_NAMESPACE$1) {
                    ownNamespace = getIntrinsicNamespace(tag);
                  }

                  if (ownNamespace === HTML_NAMESPACE$1) {
                    // $FlowFixMe - Should be inferred as not undefined.
                    extraAttributeNames.delete(propKey.toLowerCase());
                  } else {
                    var standardName = getPossibleStandardName(propKey);

                    if (standardName !== null && standardName !== propKey) {
                      // If an SVG prop is supplied with bad casing, it will
                      // be successfully parsed from HTML, but will produce a mismatch
                      // (and would be incorrectly rendered on the client).
                      // However, we already warn about bad casing elsewhere.
                      // So we'll skip the misleading extra mismatch warning in this case.
                      isMismatchDueToBadCasing = true; // $FlowFixMe - Should be inferred as not undefined.

                      extraAttributeNames.delete(standardName);
                    } // $FlowFixMe - Should be inferred as not undefined.


                    extraAttributeNames.delete(propKey);
                  }

                  serverValue = getValueForAttribute(domElement, propKey, nextProp);
                }

                if (nextProp !== serverValue && !isMismatchDueToBadCasing) {
                  warnForPropDifference(propKey, serverValue, nextProp);
                }
              }
            }
          }

          {
            // $FlowFixMe - Should be inferred as not undefined.
            if (extraAttributeNames.size > 0 && !suppressHydrationWarning) {
              // $FlowFixMe - Should be inferred as not undefined.
              warnForExtraAttributes(extraAttributeNames);
            }
          }

          switch (tag) {
            case 'input':
              // TODO: Make sure we check if this is still unmounted or do any clean
              // up necessary since we never stop tracking anymore.
              track(domElement);
              postMountWrapper(domElement, rawProps, true);
              break;

            case 'textarea':
              // TODO: Make sure we check if this is still unmounted or do any clean
              // up necessary since we never stop tracking anymore.
              track(domElement);
              postMountWrapper$3(domElement);
              break;

            case 'select':
            case 'option':
              // For input and textarea we current always set the value property at
              // post mount to force it to diverge from attributes. However, for
              // option and select we don't quite do the same thing and select
              // is not resilient to the DOM state changing so we don't do that here.
              // TODO: Consider not doing this for input and textarea.
              break;

            default:
              if (typeof rawProps.onClick === 'function') {
                // TODO: This cast may not be sound for SVG, MathML or custom elements.
                trapClickOnNonInteractiveElement(domElement);
              }

              break;
          }

          return updatePayload;
        }

        function diffHydratedText(textNode, text) {
          var isDifferent = textNode.nodeValue !== text;
          return isDifferent;
        }

        function warnForUnmatchedText(textNode, text) {
          {
            warnForTextDifference(textNode.nodeValue, text);
          }
        }

        function warnForDeletedHydratableElement(parentNode, child) {
          {
            if (didWarnInvalidHydration) {
              return;
            }

            didWarnInvalidHydration = true;
            error('Did not expect server HTML to contain a <%s> in <%s>.', child.nodeName.toLowerCase(), parentNode.nodeName.toLowerCase());
          }
        }

        function warnForDeletedHydratableText(parentNode, child) {
          {
            if (didWarnInvalidHydration) {
              return;
            }

            didWarnInvalidHydration = true;
            error('Did not expect server HTML to contain the text node "%s" in <%s>.', child.nodeValue, parentNode.nodeName.toLowerCase());
          }
        }

        function warnForInsertedHydratedElement(parentNode, tag, props) {
          {
            if (didWarnInvalidHydration) {
              return;
            }

            didWarnInvalidHydration = true;
            error('Expected server HTML to contain a matching <%s> in <%s>.', tag, parentNode.nodeName.toLowerCase());
          }
        }

        function warnForInsertedHydratedText(parentNode, text) {
          {
            if (text === '') {
              // We expect to insert empty text nodes since they're not represented in
              // the HTML.
              // TODO: Remove this special case if we can just avoid inserting empty
              // text nodes.
              return;
            }

            if (didWarnInvalidHydration) {
              return;
            }

            didWarnInvalidHydration = true;
            error('Expected server HTML to contain a matching text node for "%s" in <%s>.', text, parentNode.nodeName.toLowerCase());
          }
        }

        function restoreControlledState$3(domElement, tag, props) {
          switch (tag) {
            case 'input':
              restoreControlledState(domElement, props);
              return;

            case 'textarea':
              restoreControlledState$2(domElement, props);
              return;

            case 'select':
              restoreControlledState$1(domElement, props);
              return;
          }
        }

        var validateDOMNesting = function validateDOMNesting() {};

        var updatedAncestorInfo = function updatedAncestorInfo() {};

        {
          // This validation code was written based on the HTML5 parsing spec:
          // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
          //
          // Note: this does not catch all invalid nesting, nor does it try to (as it's
          // not clear what practical benefit doing so provides); instead, we warn only
          // for cases where the parser will give a parse tree differing from what React
          // intended. For example, <b><div></div></b> is invalid but we don't warn
          // because it still parses correctly; we do warn for other cases like nested
          // <p> tags where the beginning of the second element implicitly closes the
          // first, causing a confusing mess.
          // https://html.spec.whatwg.org/multipage/syntax.html#special
          var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp']; // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope

          var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template', // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
          // TODO: Distinguish by namespace here -- for <title>, including it here
          // errs on the side of fewer warnings
          'foreignObject', 'desc', 'title']; // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope

          var buttonScopeTags = inScopeTags.concat(['button']); // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags

          var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
          var emptyAncestorInfo = {
            current: null,
            formTag: null,
            aTagInScope: null,
            buttonTagInScope: null,
            nobrTagInScope: null,
            pTagInButtonScope: null,
            listItemTagAutoclosing: null,
            dlItemTagAutoclosing: null
          };

          updatedAncestorInfo = function updatedAncestorInfo(oldInfo, tag) {
            var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);

            var info = {
              tag: tag
            };

            if (inScopeTags.indexOf(tag) !== -1) {
              ancestorInfo.aTagInScope = null;
              ancestorInfo.buttonTagInScope = null;
              ancestorInfo.nobrTagInScope = null;
            }

            if (buttonScopeTags.indexOf(tag) !== -1) {
              ancestorInfo.pTagInButtonScope = null;
            } // See rules for 'li', 'dd', 'dt' start tags in
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody


            if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
              ancestorInfo.listItemTagAutoclosing = null;
              ancestorInfo.dlItemTagAutoclosing = null;
            }

            ancestorInfo.current = info;

            if (tag === 'form') {
              ancestorInfo.formTag = info;
            }

            if (tag === 'a') {
              ancestorInfo.aTagInScope = info;
            }

            if (tag === 'button') {
              ancestorInfo.buttonTagInScope = info;
            }

            if (tag === 'nobr') {
              ancestorInfo.nobrTagInScope = info;
            }

            if (tag === 'p') {
              ancestorInfo.pTagInButtonScope = info;
            }

            if (tag === 'li') {
              ancestorInfo.listItemTagAutoclosing = info;
            }

            if (tag === 'dd' || tag === 'dt') {
              ancestorInfo.dlItemTagAutoclosing = info;
            }

            return ancestorInfo;
          };
          /**
           * Returns whether
           */


          var isTagValidWithParent = function isTagValidWithParent(tag, parentTag) {
            // First, let's check if we're in an unusual parsing mode...
            switch (parentTag) {
              // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
              case 'select':
                return tag === 'option' || tag === 'optgroup' || tag === '#text';

              case 'optgroup':
                return tag === 'option' || tag === '#text';
              // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
              // but

              case 'option':
                return tag === '#text';
              // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
              // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
              // No special behavior since these rules fall back to "in body" mode for
              // all except special table nodes which cause bad parsing behavior anyway.
              // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr

              case 'tr':
                return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
              // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody

              case 'tbody':
              case 'thead':
              case 'tfoot':
                return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
              // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup

              case 'colgroup':
                return tag === 'col' || tag === 'template';
              // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable

              case 'table':
                return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
              // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead

              case 'head':
                return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
              // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element

              case 'html':
                return tag === 'head' || tag === 'body' || tag === 'frameset';

              case 'frameset':
                return tag === 'frame';

              case '#document':
                return tag === 'html';
            } // Probably in the "in body" parsing mode, so we outlaw only tag combos
            // where the parsing rules cause implicit opens or closes to be added.
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody


            switch (tag) {
              case 'h1':
              case 'h2':
              case 'h3':
              case 'h4':
              case 'h5':
              case 'h6':
                return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';

              case 'rp':
              case 'rt':
                return impliedEndTags.indexOf(parentTag) === -1;

              case 'body':
              case 'caption':
              case 'col':
              case 'colgroup':
              case 'frameset':
              case 'frame':
              case 'head':
              case 'html':
              case 'tbody':
              case 'td':
              case 'tfoot':
              case 'th':
              case 'thead':
              case 'tr':
                // These tags are only valid with a few parents that have special child
                // parsing rules -- if we're down here, then none of those matched and
                // so we allow it only if we don't know what the parent is, as all other
                // cases are invalid.
                return parentTag == null;
            }

            return true;
          };
          /**
           * Returns whether
           */


          var findInvalidAncestorForTag = function findInvalidAncestorForTag(tag, ancestorInfo) {
            switch (tag) {
              case 'address':
              case 'article':
              case 'aside':
              case 'blockquote':
              case 'center':
              case 'details':
              case 'dialog':
              case 'dir':
              case 'div':
              case 'dl':
              case 'fieldset':
              case 'figcaption':
              case 'figure':
              case 'footer':
              case 'header':
              case 'hgroup':
              case 'main':
              case 'menu':
              case 'nav':
              case 'ol':
              case 'p':
              case 'section':
              case 'summary':
              case 'ul':
              case 'pre':
              case 'listing':
              case 'table':
              case 'hr':
              case 'xmp':
              case 'h1':
              case 'h2':
              case 'h3':
              case 'h4':
              case 'h5':
              case 'h6':
                return ancestorInfo.pTagInButtonScope;

              case 'form':
                return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;

              case 'li':
                return ancestorInfo.listItemTagAutoclosing;

              case 'dd':
              case 'dt':
                return ancestorInfo.dlItemTagAutoclosing;

              case 'button':
                return ancestorInfo.buttonTagInScope;

              case 'a':
                // Spec says something about storing a list of markers, but it sounds
                // equivalent to this check.
                return ancestorInfo.aTagInScope;

              case 'nobr':
                return ancestorInfo.nobrTagInScope;
            }

            return null;
          };

          var didWarn$1 = {};

          validateDOMNesting = function validateDOMNesting(childTag, childText, ancestorInfo) {
            ancestorInfo = ancestorInfo || emptyAncestorInfo;
            var parentInfo = ancestorInfo.current;
            var parentTag = parentInfo && parentInfo.tag;

            if (childText != null) {
              if (childTag != null) {
                error('validateDOMNesting: when childText is passed, childTag should be null');
              }

              childTag = '#text';
            }

            var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
            var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
            var invalidParentOrAncestor = invalidParent || invalidAncestor;

            if (!invalidParentOrAncestor) {
              return;
            }

            var ancestorTag = invalidParentOrAncestor.tag;
            var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag;

            if (didWarn$1[warnKey]) {
              return;
            }

            didWarn$1[warnKey] = true;
            var tagDisplayName = childTag;
            var whitespaceInfo = '';

            if (childTag === '#text') {
              if (/\S/.test(childText)) {
                tagDisplayName = 'Text nodes';
              } else {
                tagDisplayName = 'Whitespace text nodes';
                whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
              }
            } else {
              tagDisplayName = '<' + childTag + '>';
            }

            if (invalidParent) {
              var info = '';

              if (ancestorTag === 'table' && childTag === 'tr') {
                info += ' Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by ' + 'the browser.';
              }

              error('validateDOMNesting(...): %s cannot appear as a child of <%s>.%s%s', tagDisplayName, ancestorTag, whitespaceInfo, info);
            } else {
              error('validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>.', tagDisplayName, ancestorTag);
            }
          };
        }
        var SUPPRESS_HYDRATION_WARNING$1;
        {
          SUPPRESS_HYDRATION_WARNING$1 = 'suppressHydrationWarning';
        }
        var SUSPENSE_START_DATA = '$';
        var SUSPENSE_END_DATA = '/$';
        var SUSPENSE_PENDING_START_DATA = '$?';
        var SUSPENSE_FALLBACK_START_DATA = '$!';
        var STYLE$1 = 'style';
        var eventsEnabled = null;
        var selectionInformation = null;

        function shouldAutoFocusHostComponent(type, props) {
          switch (type) {
            case 'button':
            case 'input':
            case 'select':
            case 'textarea':
              return !!props.autoFocus;
          }

          return false;
        }

        function getRootHostContext(rootContainerInstance) {
          var type;
          var namespace;
          var nodeType = rootContainerInstance.nodeType;

          switch (nodeType) {
            case DOCUMENT_NODE:
            case DOCUMENT_FRAGMENT_NODE:
              {
                type = nodeType === DOCUMENT_NODE ? '#document' : '#fragment';
                var root = rootContainerInstance.documentElement;
                namespace = root ? root.namespaceURI : getChildNamespace(null, '');
                break;
              }

            default:
              {
                var container = nodeType === COMMENT_NODE ? rootContainerInstance.parentNode : rootContainerInstance;
                var ownNamespace = container.namespaceURI || null;
                type = container.tagName;
                namespace = getChildNamespace(ownNamespace, type);
                break;
              }
          }

          {
            var validatedTag = type.toLowerCase();
            var ancestorInfo = updatedAncestorInfo(null, validatedTag);
            return {
              namespace: namespace,
              ancestorInfo: ancestorInfo
            };
          }
        }

        function getChildHostContext(parentHostContext, type, rootContainerInstance) {
          {
            var parentHostContextDev = parentHostContext;
            var namespace = getChildNamespace(parentHostContextDev.namespace, type);
            var ancestorInfo = updatedAncestorInfo(parentHostContextDev.ancestorInfo, type);
            return {
              namespace: namespace,
              ancestorInfo: ancestorInfo
            };
          }
        }

        function getPublicInstance(instance) {
          return instance;
        }

        function prepareForCommit(containerInfo) {
          eventsEnabled = isEnabled();
          selectionInformation = getSelectionInformation();
          var activeInstance = null;
          setEnabled(false);
          return activeInstance;
        }

        function resetAfterCommit(containerInfo) {
          restoreSelection(selectionInformation);
          setEnabled(eventsEnabled);
          eventsEnabled = null;
          selectionInformation = null;
        }

        function createInstance(type, props, rootContainerInstance, hostContext, internalInstanceHandle) {
          var parentNamespace;
          {
            // TODO: take namespace into account when validating.
            var hostContextDev = hostContext;
            validateDOMNesting(type, null, hostContextDev.ancestorInfo);

            if (typeof props.children === 'string' || typeof props.children === 'number') {
              var string = '' + props.children;
              var ownAncestorInfo = updatedAncestorInfo(hostContextDev.ancestorInfo, type);
              validateDOMNesting(null, string, ownAncestorInfo);
            }

            parentNamespace = hostContextDev.namespace;
          }
          var domElement = createElement(type, props, rootContainerInstance, parentNamespace);
          precacheFiberNode(internalInstanceHandle, domElement);
          updateFiberProps(domElement, props);
          return domElement;
        }

        function appendInitialChild(parentInstance, child) {
          parentInstance.appendChild(child);
        }

        function finalizeInitialChildren(domElement, type, props, rootContainerInstance, hostContext) {
          setInitialProperties(domElement, type, props, rootContainerInstance);
          return shouldAutoFocusHostComponent(type, props);
        }

        function prepareUpdate(domElement, type, oldProps, newProps, rootContainerInstance, hostContext) {
          {
            var hostContextDev = hostContext;

            if (typeof newProps.children !== typeof oldProps.children && (typeof newProps.children === 'string' || typeof newProps.children === 'number')) {
              var string = '' + newProps.children;
              var ownAncestorInfo = updatedAncestorInfo(hostContextDev.ancestorInfo, type);
              validateDOMNesting(null, string, ownAncestorInfo);
            }
          }
          return diffProperties(domElement, type, oldProps, newProps);
        }

        function shouldSetTextContent(type, props) {
          return type === 'textarea' || type === 'option' || type === 'noscript' || typeof props.children === 'string' || typeof props.children === 'number' || typeof props.dangerouslySetInnerHTML === 'object' && props.dangerouslySetInnerHTML !== null && props.dangerouslySetInnerHTML.__html != null;
        }

        function createTextInstance(text, rootContainerInstance, hostContext, internalInstanceHandle) {
          {
            var hostContextDev = hostContext;
            validateDOMNesting(null, text, hostContextDev.ancestorInfo);
          }
          var textNode = createTextNode(text, rootContainerInstance);
          precacheFiberNode(internalInstanceHandle, textNode);
          return textNode;
        } // if a component just imports ReactDOM (e.g. for findDOMNode).
        // Some environments might not have setTimeout or clearTimeout.


        var scheduleTimeout = typeof setTimeout === 'function' ? setTimeout : undefined;
        var cancelTimeout = typeof clearTimeout === 'function' ? clearTimeout : undefined;
        var noTimeout = -1; // -------------------

        function commitMount(domElement, type, newProps, internalInstanceHandle) {
          // Despite the naming that might imply otherwise, this method only
          // fires if there is an `Update` effect scheduled during mounting.
          // This happens if `finalizeInitialChildren` returns `true` (which it
          // does to implement the `autoFocus` attribute on the client). But
          // there are also other cases when this might happen (such as patching
          // up text content during hydration mismatch). So we'll check this again.
          if (shouldAutoFocusHostComponent(type, newProps)) {
            domElement.focus();
          }
        }

        function commitUpdate(domElement, updatePayload, type, oldProps, newProps, internalInstanceHandle) {
          // Update the props handle so that we know which props are the ones with
          // with current event handlers.
          updateFiberProps(domElement, newProps); // Apply the diff to the DOM node.

          updateProperties(domElement, updatePayload, type, oldProps, newProps);
        }

        function resetTextContent(domElement) {
          setTextContent(domElement, '');
        }

        function commitTextUpdate(textInstance, oldText, newText) {
          textInstance.nodeValue = newText;
        }

        function appendChild(parentInstance, child) {
          parentInstance.appendChild(child);
        }

        function appendChildToContainer(container, child) {
          var parentNode;

          if (container.nodeType === COMMENT_NODE) {
            parentNode = container.parentNode;
            parentNode.insertBefore(child, container);
          } else {
            parentNode = container;
            parentNode.appendChild(child);
          } // This container might be used for a portal.
          // If something inside a portal is clicked, that click should bubble
          // through the React tree. However, on Mobile Safari the click would
          // never bubble through the *DOM* tree unless an ancestor with onclick
          // event exists. So we wouldn't see it and dispatch it.
          // This is why we ensure that non React root containers have inline onclick
          // defined.
          // https://github.com/facebook/react/issues/11918


          var reactRootContainer = container._reactRootContainer;

          if ((reactRootContainer === null || reactRootContainer === undefined) && parentNode.onclick === null) {
            // TODO: This cast may not be sound for SVG, MathML or custom elements.
            trapClickOnNonInteractiveElement(parentNode);
          }
        }

        function insertBefore(parentInstance, child, beforeChild) {
          parentInstance.insertBefore(child, beforeChild);
        }

        function insertInContainerBefore(container, child, beforeChild) {
          if (container.nodeType === COMMENT_NODE) {
            container.parentNode.insertBefore(child, beforeChild);
          } else {
            container.insertBefore(child, beforeChild);
          }
        }

        function removeChild(parentInstance, child) {
          parentInstance.removeChild(child);
        }

        function removeChildFromContainer(container, child) {
          if (container.nodeType === COMMENT_NODE) {
            container.parentNode.removeChild(child);
          } else {
            container.removeChild(child);
          }
        }

        function hideInstance(instance) {
          // TODO: Does this work for all element types? What about MathML? Should we
          // pass host context to this method?
          instance = instance;
          var style = instance.style;

          if (typeof style.setProperty === 'function') {
            style.setProperty('display', 'none', 'important');
          } else {
            style.display = 'none';
          }
        }

        function hideTextInstance(textInstance) {
          textInstance.nodeValue = '';
        }

        function unhideInstance(instance, props) {
          instance = instance;
          var styleProp = props[STYLE$1];
          var display = styleProp !== undefined && styleProp !== null && styleProp.hasOwnProperty('display') ? styleProp.display : null;
          instance.style.display = dangerousStyleValue('display', display);
        }

        function unhideTextInstance(textInstance, text) {
          textInstance.nodeValue = text;
        }

        function clearContainer(container) {
          if (container.nodeType === ELEMENT_NODE) {
            container.textContent = '';
          } else if (container.nodeType === DOCUMENT_NODE) {
            var body = container.body;

            if (body != null) {
              body.textContent = '';
            }
          }
        } // -------------------


        function canHydrateInstance(instance, type, props) {
          if (instance.nodeType !== ELEMENT_NODE || type.toLowerCase() !== instance.nodeName.toLowerCase()) {
            return null;
          } // This has now been refined to an element node.


          return instance;
        }

        function canHydrateTextInstance(instance, text) {
          if (text === '' || instance.nodeType !== TEXT_NODE) {
            // Empty strings are not parsed by HTML so there won't be a correct match here.
            return null;
          } // This has now been refined to a text node.


          return instance;
        }

        function isSuspenseInstancePending(instance) {
          return instance.data === SUSPENSE_PENDING_START_DATA;
        }

        function isSuspenseInstanceFallback(instance) {
          return instance.data === SUSPENSE_FALLBACK_START_DATA;
        }

        function getNextHydratable(node) {
          // Skip non-hydratable nodes.
          for (; node != null; node = node.nextSibling) {
            var nodeType = node.nodeType;

            if (nodeType === ELEMENT_NODE || nodeType === TEXT_NODE) {
              break;
            }
          }

          return node;
        }

        function getNextHydratableSibling(instance) {
          return getNextHydratable(instance.nextSibling);
        }

        function getFirstHydratableChild(parentInstance) {
          return getNextHydratable(parentInstance.firstChild);
        }

        function hydrateInstance(instance, type, props, rootContainerInstance, hostContext, internalInstanceHandle) {
          precacheFiberNode(internalInstanceHandle, instance); // TODO: Possibly defer this until the commit phase where all the events
          // get attached.

          updateFiberProps(instance, props);
          var parentNamespace;
          {
            var hostContextDev = hostContext;
            parentNamespace = hostContextDev.namespace;
          }
          return diffHydratedProperties(instance, type, props, parentNamespace);
        }

        function hydrateTextInstance(textInstance, text, internalInstanceHandle) {
          precacheFiberNode(internalInstanceHandle, textInstance);
          return diffHydratedText(textInstance, text);
        }

        function getNextHydratableInstanceAfterSuspenseInstance(suspenseInstance) {
          var node = suspenseInstance.nextSibling; // Skip past all nodes within this suspense boundary.
          // There might be nested nodes so we need to keep track of how
          // deep we are and only break out when we're back on top.

          var depth = 0;

          while (node) {
            if (node.nodeType === COMMENT_NODE) {
              var data = node.data;

              if (data === SUSPENSE_END_DATA) {
                if (depth === 0) {
                  return getNextHydratableSibling(node);
                } else {
                  depth--;
                }
              } else if (data === SUSPENSE_START_DATA || data === SUSPENSE_FALLBACK_START_DATA || data === SUSPENSE_PENDING_START_DATA) {
                depth++;
              }
            }

            node = node.nextSibling;
          } // TODO: Warn, we didn't find the end comment boundary.


          return null;
        } // Returns the SuspenseInstance if this node is a direct child of a
        // SuspenseInstance. I.e. if its previous sibling is a Comment with
        // SUSPENSE_x_START_DATA. Otherwise, null.


        function getParentSuspenseInstance(targetInstance) {
          var node = targetInstance.previousSibling; // Skip past all nodes within this suspense boundary.
          // There might be nested nodes so we need to keep track of how
          // deep we are and only break out when we're back on top.

          var depth = 0;

          while (node) {
            if (node.nodeType === COMMENT_NODE) {
              var data = node.data;

              if (data === SUSPENSE_START_DATA || data === SUSPENSE_FALLBACK_START_DATA || data === SUSPENSE_PENDING_START_DATA) {
                if (depth === 0) {
                  return node;
                } else {
                  depth--;
                }
              } else if (data === SUSPENSE_END_DATA) {
                depth++;
              }
            }

            node = node.previousSibling;
          }

          return null;
        }

        function commitHydratedContainer(container) {
          // Retry if any event replaying was blocked on this.
          retryIfBlockedOn(container);
        }

        function commitHydratedSuspenseInstance(suspenseInstance) {
          // Retry if any event replaying was blocked on this.
          retryIfBlockedOn(suspenseInstance);
        }

        function didNotMatchHydratedContainerTextInstance(parentContainer, textInstance, text) {
          {
            warnForUnmatchedText(textInstance, text);
          }
        }

        function didNotMatchHydratedTextInstance(parentType, parentProps, parentInstance, textInstance, text) {
          if (parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) {
            warnForUnmatchedText(textInstance, text);
          }
        }

        function didNotHydrateContainerInstance(parentContainer, instance) {
          {
            if (instance.nodeType === ELEMENT_NODE) {
              warnForDeletedHydratableElement(parentContainer, instance);
            } else if (instance.nodeType === COMMENT_NODE) ;else {
              warnForDeletedHydratableText(parentContainer, instance);
            }
          }
        }

        function didNotHydrateInstance(parentType, parentProps, parentInstance, instance) {
          if (parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) {
            if (instance.nodeType === ELEMENT_NODE) {
              warnForDeletedHydratableElement(parentInstance, instance);
            } else if (instance.nodeType === COMMENT_NODE) ;else {
              warnForDeletedHydratableText(parentInstance, instance);
            }
          }
        }

        function didNotFindHydratableContainerInstance(parentContainer, type, props) {
          {
            warnForInsertedHydratedElement(parentContainer, type);
          }
        }

        function didNotFindHydratableContainerTextInstance(parentContainer, text) {
          {
            warnForInsertedHydratedText(parentContainer, text);
          }
        }

        function didNotFindHydratableInstance(parentType, parentProps, parentInstance, type, props) {
          if (parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) {
            warnForInsertedHydratedElement(parentInstance, type);
          }
        }

        function didNotFindHydratableTextInstance(parentType, parentProps, parentInstance, text) {
          if (parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) {
            warnForInsertedHydratedText(parentInstance, text);
          }
        }

        function didNotFindHydratableSuspenseInstance(parentType, parentProps, parentInstance) {
          if (parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) ;
        }

        var clientId = 0;

        function makeClientIdInDEV(warnOnAccessInDEV) {
          var id = 'r:' + (clientId++).toString(36);
          return {
            toString: function toString() {
              warnOnAccessInDEV();
              return id;
            },
            valueOf: function valueOf() {
              warnOnAccessInDEV();
              return id;
            }
          };
        }

        function isOpaqueHydratingObject(value) {
          return value !== null && typeof value === 'object' && value.$$typeof === REACT_OPAQUE_ID_TYPE;
        }

        function makeOpaqueHydratingObject(attemptToReadValue) {
          return {
            $$typeof: REACT_OPAQUE_ID_TYPE,
            toString: attemptToReadValue,
            valueOf: attemptToReadValue
          };
        }

        function preparePortalMount(portalInstance) {
          {
            listenToAllSupportedEvents(portalInstance);
          }
        }

        var randomKey = Math.random().toString(36).slice(2);
        var internalInstanceKey = '__reactFiber$' + randomKey;
        var internalPropsKey = '__reactProps$' + randomKey;
        var internalContainerInstanceKey = '__reactContainer$' + randomKey;
        var internalEventHandlersKey = '__reactEvents$' + randomKey;

        function precacheFiberNode(hostInst, node) {
          node[internalInstanceKey] = hostInst;
        }

        function markContainerAsRoot(hostRoot, node) {
          node[internalContainerInstanceKey] = hostRoot;
        }

        function unmarkContainerAsRoot(node) {
          node[internalContainerInstanceKey] = null;
        }

        function isContainerMarkedAsRoot(node) {
          return !!node[internalContainerInstanceKey];
        } // Given a DOM node, return the closest HostComponent or HostText fiber ancestor.
        // If the target node is part of a hydrated or not yet rendered subtree, then
        // this may also return a SuspenseComponent or HostRoot to indicate that.
        // Conceptually the HostRoot fiber is a child of the Container node. So if you
        // pass the Container node as the targetNode, you will not actually get the
        // HostRoot back. To get to the HostRoot, you need to pass a child of it.
        // The same thing applies to Suspense boundaries.


        function getClosestInstanceFromNode(targetNode) {
          var targetInst = targetNode[internalInstanceKey];

          if (targetInst) {
            // Don't return HostRoot or SuspenseComponent here.
            return targetInst;
          } // If the direct event target isn't a React owned DOM node, we need to look
          // to see if one of its parents is a React owned DOM node.


          var parentNode = targetNode.parentNode;

          while (parentNode) {
            // We'll check if this is a container root that could include
            // React nodes in the future. We need to check this first because
            // if we're a child of a dehydrated container, we need to first
            // find that inner container before moving on to finding the parent
            // instance. Note that we don't check this field on  the targetNode
            // itself because the fibers are conceptually between the container
            // node and the first child. It isn't surrounding the container node.
            // If it's not a container, we check if it's an instance.
            targetInst = parentNode[internalContainerInstanceKey] || parentNode[internalInstanceKey];

            if (targetInst) {
              // Since this wasn't the direct target of the event, we might have
              // stepped past dehydrated DOM nodes to get here. However they could
              // also have been non-React nodes. We need to answer which one.
              // If we the instance doesn't have any children, then there can't be
              // a nested suspense boundary within it. So we can use this as a fast
              // bailout. Most of the time, when people add non-React children to
              // the tree, it is using a ref to a child-less DOM node.
              // Normally we'd only need to check one of the fibers because if it
              // has ever gone from having children to deleting them or vice versa
              // it would have deleted the dehydrated boundary nested inside already.
              // However, since the HostRoot starts out with an alternate it might
              // have one on the alternate so we need to check in case this was a
              // root.
              var alternate = targetInst.alternate;

              if (targetInst.child !== null || alternate !== null && alternate.child !== null) {
                // Next we need to figure out if the node that skipped past is
                // nested within a dehydrated boundary and if so, which one.
                var suspenseInstance = getParentSuspenseInstance(targetNode);

                while (suspenseInstance !== null) {
                  // We found a suspense instance. That means that we haven't
                  // hydrated it yet. Even though we leave the comments in the
                  // DOM after hydrating, and there are boundaries in the DOM
                  // that could already be hydrated, we wouldn't have found them
                  // through this pass since if the target is hydrated it would
                  // have had an internalInstanceKey on it.
                  // Let's get the fiber associated with the SuspenseComponent
                  // as the deepest instance.
                  var targetSuspenseInst = suspenseInstance[internalInstanceKey];

                  if (targetSuspenseInst) {
                    return targetSuspenseInst;
                  } // If we don't find a Fiber on the comment, it might be because
                  // we haven't gotten to hydrate it yet. There might still be a
                  // parent boundary that hasn't above this one so we need to find
                  // the outer most that is known.


                  suspenseInstance = getParentSuspenseInstance(suspenseInstance); // If we don't find one, then that should mean that the parent
                  // host component also hasn't hydrated yet. We can return it
                  // below since it will bail out on the isMounted check later.
                }
              }

              return targetInst;
            }

            targetNode = parentNode;
            parentNode = targetNode.parentNode;
          }

          return null;
        }
        /**
         * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
         * instance, or null if the node was not rendered by this React.
         */


        function getInstanceFromNode(node) {
          var inst = node[internalInstanceKey] || node[internalContainerInstanceKey];

          if (inst) {
            if (inst.tag === HostComponent || inst.tag === HostText || inst.tag === SuspenseComponent || inst.tag === HostRoot) {
              return inst;
            } else {
              return null;
            }
          }

          return null;
        }
        /**
         * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
         * DOM node.
         */


        function getNodeFromInstance(inst) {
          if (inst.tag === HostComponent || inst.tag === HostText) {
            // In Fiber this, is just the state node right now. We assume it will be
            // a host component or host text.
            return inst.stateNode;
          } // Without this first invariant, passing a non-DOM-component triggers the next
          // invariant for a missing parent, which is super confusing.


          {
            {
              throw Error("getNodeFromInstance: Invalid argument.");
            }
          }
        }

        function getFiberCurrentPropsFromNode(node) {
          return node[internalPropsKey] || null;
        }

        function updateFiberProps(node, props) {
          node[internalPropsKey] = props;
        }

        function getEventListenerSet(node) {
          var elementListenerSet = node[internalEventHandlersKey];

          if (elementListenerSet === undefined) {
            elementListenerSet = node[internalEventHandlersKey] = new Set();
          }

          return elementListenerSet;
        }

        var loggedTypeFailures = {};
        var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;

        function setCurrentlyValidatingElement(element) {
          {
            if (element) {
              var owner = element._owner;
              var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
              ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
            } else {
              ReactDebugCurrentFrame$1.setExtraStackFrame(null);
            }
          }
        }

        function checkPropTypes(typeSpecs, values, location, componentName, element) {
          {
            // $FlowFixMe This is okay but Flow doesn't know it.
            var has = Function.call.bind(Object.prototype.hasOwnProperty);

            for (var typeSpecName in typeSpecs) {
              if (has(typeSpecs, typeSpecName)) {
                var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
                // fail the render phase where it didn't fail before. So we log it.
                // After these have been cleaned up, we'll let them throw.

                try {
                  // This is intentionally an invariant that gets caught. It's the same
                  // behavior as without this statement except with a better message.
                  if (typeof typeSpecs[typeSpecName] !== 'function') {
                    var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
                    err.name = 'Invariant Violation';
                    throw err;
                  }

                  error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
                } catch (ex) {
                  error$1 = ex;
                }

                if (error$1 && !(error$1 instanceof Error)) {
                  setCurrentlyValidatingElement(element);
                  error('%s: type specification of %s' + ' `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error$1);
                  setCurrentlyValidatingElement(null);
                }

                if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                  // Only monitor this failure once because there tends to be a lot of the
                  // same error.
                  loggedTypeFailures[error$1.message] = true;
                  setCurrentlyValidatingElement(element);
                  error('Failed %s type: %s', location, error$1.message);
                  setCurrentlyValidatingElement(null);
                }
              }
            }
          }
        }

        var valueStack = [];
        var fiberStack;
        {
          fiberStack = [];
        }
        var index = -1;

        function createCursor(defaultValue) {
          return {
            current: defaultValue
          };
        }

        function pop(cursor, fiber) {
          if (index < 0) {
            {
              error('Unexpected pop.');
            }
            return;
          }

          {
            if (fiber !== fiberStack[index]) {
              error('Unexpected Fiber popped.');
            }
          }
          cursor.current = valueStack[index];
          valueStack[index] = null;
          {
            fiberStack[index] = null;
          }
          index--;
        }

        function push(cursor, value, fiber) {
          index++;
          valueStack[index] = cursor.current;
          {
            fiberStack[index] = fiber;
          }
          cursor.current = value;
        }

        var warnedAboutMissingGetChildContext;
        {
          warnedAboutMissingGetChildContext = {};
        }
        var emptyContextObject = {};
        {
          Object.freeze(emptyContextObject);
        } // A cursor to the current merged context object on the stack.

        var contextStackCursor = createCursor(emptyContextObject); // A cursor to a boolean indicating whether the context has changed.

        var didPerformWorkStackCursor = createCursor(false); // Keep track of the previous context object that was on the stack.
        // We use this to get access to the parent context after we have already
        // pushed the next context provider, and now need to merge their contexts.

        var previousContext = emptyContextObject;

        function getUnmaskedContext(workInProgress, Component, didPushOwnContextIfProvider) {
          {
            if (didPushOwnContextIfProvider && isContextProvider(Component)) {
              // If the fiber is a context provider itself, when we read its context
              // we may have already pushed its own child context on the stack. A context
              // provider should not "see" its own child context. Therefore we read the
              // previous (parent) context instead for a context provider.
              return previousContext;
            }

            return contextStackCursor.current;
          }
        }

        function cacheContext(workInProgress, unmaskedContext, maskedContext) {
          {
            var instance = workInProgress.stateNode;
            instance.__reactInternalMemoizedUnmaskedChildContext = unmaskedContext;
            instance.__reactInternalMemoizedMaskedChildContext = maskedContext;
          }
        }

        function getMaskedContext(workInProgress, unmaskedContext) {
          {
            var type = workInProgress.type;
            var contextTypes = type.contextTypes;

            if (!contextTypes) {
              return emptyContextObject;
            } // Avoid recreating masked context unless unmasked context has changed.
            // Failing to do this will result in unnecessary calls to componentWillReceiveProps.
            // This may trigger infinite loops if componentWillReceiveProps calls setState.


            var instance = workInProgress.stateNode;

            if (instance && instance.__reactInternalMemoizedUnmaskedChildContext === unmaskedContext) {
              return instance.__reactInternalMemoizedMaskedChildContext;
            }

            var context = {};

            for (var key in contextTypes) {
              context[key] = unmaskedContext[key];
            }

            {
              var name = getComponentName(type) || 'Unknown';
              checkPropTypes(contextTypes, context, 'context', name);
            } // Cache unmasked context so we can avoid recreating masked context unless necessary.
            // Context is created before the class component is instantiated so check for instance.

            if (instance) {
              cacheContext(workInProgress, unmaskedContext, context);
            }

            return context;
          }
        }

        function hasContextChanged() {
          {
            return didPerformWorkStackCursor.current;
          }
        }

        function isContextProvider(type) {
          {
            var childContextTypes = type.childContextTypes;
            return childContextTypes !== null && childContextTypes !== undefined;
          }
        }

        function popContext(fiber) {
          {
            pop(didPerformWorkStackCursor, fiber);
            pop(contextStackCursor, fiber);
          }
        }

        function popTopLevelContextObject(fiber) {
          {
            pop(didPerformWorkStackCursor, fiber);
            pop(contextStackCursor, fiber);
          }
        }

        function pushTopLevelContextObject(fiber, context, didChange) {
          {
            if (!(contextStackCursor.current === emptyContextObject)) {
              {
                throw Error("Unexpected context found on stack. This error is likely caused by a bug in React. Please file an issue.");
              }
            }

            push(contextStackCursor, context, fiber);
            push(didPerformWorkStackCursor, didChange, fiber);
          }
        }

        function processChildContext(fiber, type, parentContext) {
          {
            var instance = fiber.stateNode;
            var childContextTypes = type.childContextTypes; // TODO (bvaughn) Replace this behavior with an invariant() in the future.
            // It has only been added in Fiber to match the (unintentional) behavior in Stack.

            if (typeof instance.getChildContext !== 'function') {
              {
                var componentName = getComponentName(type) || 'Unknown';

                if (!warnedAboutMissingGetChildContext[componentName]) {
                  warnedAboutMissingGetChildContext[componentName] = true;
                  error('%s.childContextTypes is specified but there is no getChildContext() method ' + 'on the instance. You can either define getChildContext() on %s or remove ' + 'childContextTypes from it.', componentName, componentName);
                }
              }
              return parentContext;
            }

            var childContext = instance.getChildContext();

            for (var contextKey in childContext) {
              if (!(contextKey in childContextTypes)) {
                {
                  throw Error((getComponentName(type) || 'Unknown') + ".getChildContext(): key \"" + contextKey + "\" is not defined in childContextTypes.");
                }
              }
            }

            {
              var name = getComponentName(type) || 'Unknown';
              checkPropTypes(childContextTypes, childContext, 'child context', name);
            }
            return _assign({}, parentContext, childContext);
          }
        }

        function pushContextProvider(workInProgress) {
          {
            var instance = workInProgress.stateNode; // We push the context as early as possible to ensure stack integrity.
            // If the instance does not exist yet, we will push null at first,
            // and replace it on the stack later when invalidating the context.

            var memoizedMergedChildContext = instance && instance.__reactInternalMemoizedMergedChildContext || emptyContextObject; // Remember the parent context so we can merge with it later.
            // Inherit the parent's did-perform-work value to avoid inadvertently blocking updates.

            previousContext = contextStackCursor.current;
            push(contextStackCursor, memoizedMergedChildContext, workInProgress);
            push(didPerformWorkStackCursor, didPerformWorkStackCursor.current, workInProgress);
            return true;
          }
        }

        function invalidateContextProvider(workInProgress, type, didChange) {
          {
            var instance = workInProgress.stateNode;

            if (!instance) {
              {
                throw Error("Expected to have an instance by this point. This error is likely caused by a bug in React. Please file an issue.");
              }
            }

            if (didChange) {
              // Merge parent and own context.
              // Skip this if we're not updating due to sCU.
              // This avoids unnecessarily recomputing memoized values.
              var mergedContext = processChildContext(workInProgress, type, previousContext);
              instance.__reactInternalMemoizedMergedChildContext = mergedContext; // Replace the old (or empty) context with the new one.
              // It is important to unwind the context in the reverse order.

              pop(didPerformWorkStackCursor, workInProgress);
              pop(contextStackCursor, workInProgress); // Now push the new context and mark that it has changed.

              push(contextStackCursor, mergedContext, workInProgress);
              push(didPerformWorkStackCursor, didChange, workInProgress);
            } else {
              pop(didPerformWorkStackCursor, workInProgress);
              push(didPerformWorkStackCursor, didChange, workInProgress);
            }
          }
        }

        function findCurrentUnmaskedContext(fiber) {
          {
            // Currently this is only used with renderSubtreeIntoContainer; not sure if it
            // makes sense elsewhere
            if (!(isFiberMounted(fiber) && fiber.tag === ClassComponent)) {
              {
                throw Error("Expected subtree parent to be a mounted class component. This error is likely caused by a bug in React. Please file an issue.");
              }
            }

            var node = fiber;

            do {
              switch (node.tag) {
                case HostRoot:
                  return node.stateNode.context;

                case ClassComponent:
                  {
                    var Component = node.type;

                    if (isContextProvider(Component)) {
                      return node.stateNode.__reactInternalMemoizedMergedChildContext;
                    }

                    break;
                  }
              }

              node = node.return;
            } while (node !== null);

            {
              {
                throw Error("Found unexpected detached subtree parent. This error is likely caused by a bug in React. Please file an issue.");
              }
            }
          }
        }

        var LegacyRoot = 0;
        var BlockingRoot = 1;
        var ConcurrentRoot = 2;
        var rendererID = null;
        var injectedHook = null;
        var hasLoggedError = false;
        var isDevToolsPresent = typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined';

        function injectInternals(internals) {
          if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
            // No DevTools
            return false;
          }

          var hook = __REACT_DEVTOOLS_GLOBAL_HOOK__;

          if (hook.isDisabled) {
            // This isn't a real property on the hook, but it can be set to opt out
            // of DevTools integration and associated warnings and logs.
            // https://github.com/facebook/react/issues/3877
            return true;
          }

          if (!hook.supportsFiber) {
            {
              error('The installed version of React DevTools is too old and will not work ' + 'with the current version of React. Please update React DevTools. ' + 'https://reactjs.org/link/react-devtools');
            } // DevTools exists, even though it doesn't support Fiber.

            return true;
          }

          try {
            rendererID = hook.inject(internals); // We have successfully injected, so now it is safe to set up hooks.

            injectedHook = hook;
          } catch (err) {
            // Catch all errors because it is unsafe to throw during initialization.
            {
              error('React instrumentation encountered an error: %s.', err);
            }
          } // DevTools exists


          return true;
        }

        function onScheduleRoot(root, children) {
          {
            if (injectedHook && typeof injectedHook.onScheduleFiberRoot === 'function') {
              try {
                injectedHook.onScheduleFiberRoot(rendererID, root, children);
              } catch (err) {
                if (!hasLoggedError) {
                  hasLoggedError = true;
                  error('React instrumentation encountered an error: %s', err);
                }
              }
            }
          }
        }

        function onCommitRoot(root, priorityLevel) {
          if (injectedHook && typeof injectedHook.onCommitFiberRoot === 'function') {
            try {
              var didError = (root.current.flags & DidCapture) === DidCapture;

              if (enableProfilerTimer) {
                injectedHook.onCommitFiberRoot(rendererID, root, priorityLevel, didError);
              } else {
                injectedHook.onCommitFiberRoot(rendererID, root, undefined, didError);
              }
            } catch (err) {
              {
                if (!hasLoggedError) {
                  hasLoggedError = true;
                  error('React instrumentation encountered an error: %s', err);
                }
              }
            }
          }
        }

        function onCommitUnmount(fiber) {
          if (injectedHook && typeof injectedHook.onCommitFiberUnmount === 'function') {
            try {
              injectedHook.onCommitFiberUnmount(rendererID, fiber);
            } catch (err) {
              {
                if (!hasLoggedError) {
                  hasLoggedError = true;
                  error('React instrumentation encountered an error: %s', err);
                }
              }
            }
          }
        }

        var Scheduler_runWithPriority = Scheduler.unstable_runWithPriority,
            Scheduler_scheduleCallback = Scheduler.unstable_scheduleCallback,
            Scheduler_cancelCallback = Scheduler.unstable_cancelCallback,
            Scheduler_shouldYield = Scheduler.unstable_shouldYield,
            Scheduler_requestPaint = Scheduler.unstable_requestPaint,
            Scheduler_now$1 = Scheduler.unstable_now,
            Scheduler_getCurrentPriorityLevel = Scheduler.unstable_getCurrentPriorityLevel,
            Scheduler_ImmediatePriority = Scheduler.unstable_ImmediatePriority,
            Scheduler_UserBlockingPriority = Scheduler.unstable_UserBlockingPriority,
            Scheduler_NormalPriority = Scheduler.unstable_NormalPriority,
            Scheduler_LowPriority = Scheduler.unstable_LowPriority,
            Scheduler_IdlePriority = Scheduler.unstable_IdlePriority;
        {
          // Provide explicit error message when production+profiling bundle of e.g.
          // react-dom is used with production (non-profiling) bundle of
          // scheduler/tracing
          if (!(tracing.__interactionsRef != null && tracing.__interactionsRef.current != null)) {
            {
              throw Error("It is not supported to run the profiling version of a renderer (for example, `react-dom/profiling`) without also replacing the `scheduler/tracing` module with `scheduler/tracing-profiling`. Your bundler might have a setting for aliasing both modules. Learn more at https://reactjs.org/link/profiling");
            }
          }
        }
        var fakeCallbackNode = {}; // Except for NoPriority, these correspond to Scheduler priorities. We use
        // ascending numbers so we can compare them like numbers. They start at 90 to
        // avoid clashing with Scheduler's priorities.

        var ImmediatePriority$1 = 99;
        var UserBlockingPriority$2 = 98;
        var NormalPriority$1 = 97;
        var LowPriority$1 = 96;
        var IdlePriority$1 = 95; // NoPriority is the absence of priority. Also React-only.

        var NoPriority$1 = 90;
        var shouldYield = Scheduler_shouldYield;
        var requestPaint = // Fall back gracefully if we're running an older version of Scheduler.
        Scheduler_requestPaint !== undefined ? Scheduler_requestPaint : function () {};
        var syncQueue = null;
        var immediateQueueCallbackNode = null;
        var isFlushingSyncQueue = false;
        var initialTimeMs$1 = Scheduler_now$1(); // If the initial timestamp is reasonably small, use Scheduler's `now` directly.
        // This will be the case for modern browsers that support `performance.now`. In
        // older browsers, Scheduler falls back to `Date.now`, which returns a Unix
        // timestamp. In that case, subtract the module initialization time to simulate
        // the behavior of performance.now and keep our times small enough to fit
        // within 32 bits.
        // TODO: Consider lifting this into Scheduler.

        var now = initialTimeMs$1 < 10000 ? Scheduler_now$1 : function () {
          return Scheduler_now$1() - initialTimeMs$1;
        };

        function getCurrentPriorityLevel() {
          switch (Scheduler_getCurrentPriorityLevel()) {
            case Scheduler_ImmediatePriority:
              return ImmediatePriority$1;

            case Scheduler_UserBlockingPriority:
              return UserBlockingPriority$2;

            case Scheduler_NormalPriority:
              return NormalPriority$1;

            case Scheduler_LowPriority:
              return LowPriority$1;

            case Scheduler_IdlePriority:
              return IdlePriority$1;

            default:
              {
                {
                  throw Error("Unknown priority level.");
                }
              }
          }
        }

        function reactPriorityToSchedulerPriority(reactPriorityLevel) {
          switch (reactPriorityLevel) {
            case ImmediatePriority$1:
              return Scheduler_ImmediatePriority;

            case UserBlockingPriority$2:
              return Scheduler_UserBlockingPriority;

            case NormalPriority$1:
              return Scheduler_NormalPriority;

            case LowPriority$1:
              return Scheduler_LowPriority;

            case IdlePriority$1:
              return Scheduler_IdlePriority;

            default:
              {
                {
                  throw Error("Unknown priority level.");
                }
              }
          }
        }

        function runWithPriority$1(reactPriorityLevel, fn) {
          var priorityLevel = reactPriorityToSchedulerPriority(reactPriorityLevel);
          return Scheduler_runWithPriority(priorityLevel, fn);
        }

        function scheduleCallback(reactPriorityLevel, callback, options) {
          var priorityLevel = reactPriorityToSchedulerPriority(reactPriorityLevel);
          return Scheduler_scheduleCallback(priorityLevel, callback, options);
        }

        function scheduleSyncCallback(callback) {
          // Push this callback into an internal queue. We'll flush these either in
          // the next tick, or earlier if something calls `flushSyncCallbackQueue`.
          if (syncQueue === null) {
            syncQueue = [callback]; // Flush the queue in the next tick, at the earliest.

            immediateQueueCallbackNode = Scheduler_scheduleCallback(Scheduler_ImmediatePriority, flushSyncCallbackQueueImpl);
          } else {
            // Push onto existing queue. Don't need to schedule a callback because
            // we already scheduled one when we created the queue.
            syncQueue.push(callback);
          }

          return fakeCallbackNode;
        }

        function cancelCallback(callbackNode) {
          if (callbackNode !== fakeCallbackNode) {
            Scheduler_cancelCallback(callbackNode);
          }
        }

        function flushSyncCallbackQueue() {
          if (immediateQueueCallbackNode !== null) {
            var node = immediateQueueCallbackNode;
            immediateQueueCallbackNode = null;
            Scheduler_cancelCallback(node);
          }

          flushSyncCallbackQueueImpl();
        }

        function flushSyncCallbackQueueImpl() {
          if (!isFlushingSyncQueue && syncQueue !== null) {
            // Prevent re-entrancy.
            isFlushingSyncQueue = true;
            var i = 0;
            {
              try {
                var _isSync2 = true;
                var _queue = syncQueue;
                runWithPriority$1(ImmediatePriority$1, function () {
                  for (; i < _queue.length; i++) {
                    var callback = _queue[i];

                    do {
                      callback = callback(_isSync2);
                    } while (callback !== null);
                  }
                });
                syncQueue = null;
              } catch (error) {
                // If something throws, leave the remaining callbacks on the queue.
                if (syncQueue !== null) {
                  syncQueue = syncQueue.slice(i + 1);
                } // Resume flushing in the next tick


                Scheduler_scheduleCallback(Scheduler_ImmediatePriority, flushSyncCallbackQueue);
                throw error;
              } finally {
                isFlushingSyncQueue = false;
              }
            }
          }
        } // TODO: this is special because it gets imported during build.


        var ReactVersion = '17.0.1';
        var NoMode = 0;
        var StrictMode = 1; // TODO: Remove BlockingMode and ConcurrentMode by reading from the root
        // tag instead

        var BlockingMode = 2;
        var ConcurrentMode = 4;
        var ProfileMode = 8;
        var DebugTracingMode = 16;
        var ReactCurrentBatchConfig = ReactSharedInternals.ReactCurrentBatchConfig;
        var NoTransition = 0;

        function requestCurrentTransition() {
          return ReactCurrentBatchConfig.transition;
        }

        var ReactStrictModeWarnings = {
          recordUnsafeLifecycleWarnings: function recordUnsafeLifecycleWarnings(fiber, instance) {},
          flushPendingUnsafeLifecycleWarnings: function flushPendingUnsafeLifecycleWarnings() {},
          recordLegacyContextWarning: function recordLegacyContextWarning(fiber, instance) {},
          flushLegacyContextWarning: function flushLegacyContextWarning() {},
          discardPendingWarnings: function discardPendingWarnings() {}
        };
        {
          var findStrictRoot = function findStrictRoot(fiber) {
            var maybeStrictRoot = null;
            var node = fiber;

            while (node !== null) {
              if (node.mode & StrictMode) {
                maybeStrictRoot = node;
              }

              node = node.return;
            }

            return maybeStrictRoot;
          };

          var setToSortedString = function setToSortedString(set) {
            var array = [];
            set.forEach(function (value) {
              array.push(value);
            });
            return array.sort().join(', ');
          };

          var pendingComponentWillMountWarnings = [];
          var pendingUNSAFE_ComponentWillMountWarnings = [];
          var pendingComponentWillReceivePropsWarnings = [];
          var pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
          var pendingComponentWillUpdateWarnings = [];
          var pendingUNSAFE_ComponentWillUpdateWarnings = []; // Tracks components we have already warned about.

          var didWarnAboutUnsafeLifecycles = new Set();

          ReactStrictModeWarnings.recordUnsafeLifecycleWarnings = function (fiber, instance) {
            // Dedup strategy: Warn once per component.
            if (didWarnAboutUnsafeLifecycles.has(fiber.type)) {
              return;
            }

            if (typeof instance.componentWillMount === 'function' && // Don't warn about react-lifecycles-compat polyfilled components.
            instance.componentWillMount.__suppressDeprecationWarning !== true) {
              pendingComponentWillMountWarnings.push(fiber);
            }

            if (fiber.mode & StrictMode && typeof instance.UNSAFE_componentWillMount === 'function') {
              pendingUNSAFE_ComponentWillMountWarnings.push(fiber);
            }

            if (typeof instance.componentWillReceiveProps === 'function' && instance.componentWillReceiveProps.__suppressDeprecationWarning !== true) {
              pendingComponentWillReceivePropsWarnings.push(fiber);
            }

            if (fiber.mode & StrictMode && typeof instance.UNSAFE_componentWillReceiveProps === 'function') {
              pendingUNSAFE_ComponentWillReceivePropsWarnings.push(fiber);
            }

            if (typeof instance.componentWillUpdate === 'function' && instance.componentWillUpdate.__suppressDeprecationWarning !== true) {
              pendingComponentWillUpdateWarnings.push(fiber);
            }

            if (fiber.mode & StrictMode && typeof instance.UNSAFE_componentWillUpdate === 'function') {
              pendingUNSAFE_ComponentWillUpdateWarnings.push(fiber);
            }
          };

          ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings = function () {
            // We do an initial pass to gather component names
            var componentWillMountUniqueNames = new Set();

            if (pendingComponentWillMountWarnings.length > 0) {
              pendingComponentWillMountWarnings.forEach(function (fiber) {
                componentWillMountUniqueNames.add(getComponentName(fiber.type) || 'Component');
                didWarnAboutUnsafeLifecycles.add(fiber.type);
              });
              pendingComponentWillMountWarnings = [];
            }

            var UNSAFE_componentWillMountUniqueNames = new Set();

            if (pendingUNSAFE_ComponentWillMountWarnings.length > 0) {
              pendingUNSAFE_ComponentWillMountWarnings.forEach(function (fiber) {
                UNSAFE_componentWillMountUniqueNames.add(getComponentName(fiber.type) || 'Component');
                didWarnAboutUnsafeLifecycles.add(fiber.type);
              });
              pendingUNSAFE_ComponentWillMountWarnings = [];
            }

            var componentWillReceivePropsUniqueNames = new Set();

            if (pendingComponentWillReceivePropsWarnings.length > 0) {
              pendingComponentWillReceivePropsWarnings.forEach(function (fiber) {
                componentWillReceivePropsUniqueNames.add(getComponentName(fiber.type) || 'Component');
                didWarnAboutUnsafeLifecycles.add(fiber.type);
              });
              pendingComponentWillReceivePropsWarnings = [];
            }

            var UNSAFE_componentWillReceivePropsUniqueNames = new Set();

            if (pendingUNSAFE_ComponentWillReceivePropsWarnings.length > 0) {
              pendingUNSAFE_ComponentWillReceivePropsWarnings.forEach(function (fiber) {
                UNSAFE_componentWillReceivePropsUniqueNames.add(getComponentName(fiber.type) || 'Component');
                didWarnAboutUnsafeLifecycles.add(fiber.type);
              });
              pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
            }

            var componentWillUpdateUniqueNames = new Set();

            if (pendingComponentWillUpdateWarnings.length > 0) {
              pendingComponentWillUpdateWarnings.forEach(function (fiber) {
                componentWillUpdateUniqueNames.add(getComponentName(fiber.type) || 'Component');
                didWarnAboutUnsafeLifecycles.add(fiber.type);
              });
              pendingComponentWillUpdateWarnings = [];
            }

            var UNSAFE_componentWillUpdateUniqueNames = new Set();

            if (pendingUNSAFE_ComponentWillUpdateWarnings.length > 0) {
              pendingUNSAFE_ComponentWillUpdateWarnings.forEach(function (fiber) {
                UNSAFE_componentWillUpdateUniqueNames.add(getComponentName(fiber.type) || 'Component');
                didWarnAboutUnsafeLifecycles.add(fiber.type);
              });
              pendingUNSAFE_ComponentWillUpdateWarnings = [];
            } // Finally, we flush all the warnings
            // UNSAFE_ ones before the deprecated ones, since they'll be 'louder'


            if (UNSAFE_componentWillMountUniqueNames.size > 0) {
              var sortedNames = setToSortedString(UNSAFE_componentWillMountUniqueNames);
              error('Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. ' + 'See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n' + '* Move code with side effects to componentDidMount, and set initial state in the constructor.\n' + '\nPlease update the following components: %s', sortedNames);
            }

            if (UNSAFE_componentWillReceivePropsUniqueNames.size > 0) {
              var _sortedNames = setToSortedString(UNSAFE_componentWillReceivePropsUniqueNames);

              error('Using UNSAFE_componentWillReceiveProps in strict mode is not recommended ' + 'and may indicate bugs in your code. ' + 'See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n' + '* Move data fetching code or side effects to componentDidUpdate.\n' + "* If you're updating state whenever props change, " + 'refactor your code to use memoization techniques or move it to ' + 'static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state\n' + '\nPlease update the following components: %s', _sortedNames);
            }

            if (UNSAFE_componentWillUpdateUniqueNames.size > 0) {
              var _sortedNames2 = setToSortedString(UNSAFE_componentWillUpdateUniqueNames);

              error('Using UNSAFE_componentWillUpdate in strict mode is not recommended ' + 'and may indicate bugs in your code. ' + 'See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n' + '* Move data fetching code or side effects to componentDidUpdate.\n' + '\nPlease update the following components: %s', _sortedNames2);
            }

            if (componentWillMountUniqueNames.size > 0) {
              var _sortedNames3 = setToSortedString(componentWillMountUniqueNames);

              warn('componentWillMount has been renamed, and is not recommended for use. ' + 'See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n' + '* Move code with side effects to componentDidMount, and set initial state in the constructor.\n' + '* Rename componentWillMount to UNSAFE_componentWillMount to suppress ' + 'this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. ' + 'To rename all deprecated lifecycles to their new names, you can run ' + '`npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n' + '\nPlease update the following components: %s', _sortedNames3);
            }

            if (componentWillReceivePropsUniqueNames.size > 0) {
              var _sortedNames4 = setToSortedString(componentWillReceivePropsUniqueNames);

              warn('componentWillReceiveProps has been renamed, and is not recommended for use. ' + 'See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n' + '* Move data fetching code or side effects to componentDidUpdate.\n' + "* If you're updating state whenever props change, refactor your " + 'code to use memoization techniques or move it to ' + 'static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state\n' + '* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress ' + 'this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. ' + 'To rename all deprecated lifecycles to their new names, you can run ' + '`npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n' + '\nPlease update the following components: %s', _sortedNames4);
            }

            if (componentWillUpdateUniqueNames.size > 0) {
              var _sortedNames5 = setToSortedString(componentWillUpdateUniqueNames);

              warn('componentWillUpdate has been renamed, and is not recommended for use. ' + 'See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n' + '* Move data fetching code or side effects to componentDidUpdate.\n' + '* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress ' + 'this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. ' + 'To rename all deprecated lifecycles to their new names, you can run ' + '`npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n' + '\nPlease update the following components: %s', _sortedNames5);
            }
          };

          var pendingLegacyContextWarning = new Map(); // Tracks components we have already warned about.

          var didWarnAboutLegacyContext = new Set();

          ReactStrictModeWarnings.recordLegacyContextWarning = function (fiber, instance) {
            var strictRoot = findStrictRoot(fiber);

            if (strictRoot === null) {
              error('Expected to find a StrictMode component in a strict mode tree. ' + 'This error is likely caused by a bug in React. Please file an issue.');
              return;
            } // Dedup strategy: Warn once per component.


            if (didWarnAboutLegacyContext.has(fiber.type)) {
              return;
            }

            var warningsForRoot = pendingLegacyContextWarning.get(strictRoot);

            if (fiber.type.contextTypes != null || fiber.type.childContextTypes != null || instance !== null && typeof instance.getChildContext === 'function') {
              if (warningsForRoot === undefined) {
                warningsForRoot = [];
                pendingLegacyContextWarning.set(strictRoot, warningsForRoot);
              }

              warningsForRoot.push(fiber);
            }
          };

          ReactStrictModeWarnings.flushLegacyContextWarning = function () {
            pendingLegacyContextWarning.forEach(function (fiberArray, strictRoot) {
              if (fiberArray.length === 0) {
                return;
              }

              var firstFiber = fiberArray[0];
              var uniqueNames = new Set();
              fiberArray.forEach(function (fiber) {
                uniqueNames.add(getComponentName(fiber.type) || 'Component');
                didWarnAboutLegacyContext.add(fiber.type);
              });
              var sortedNames = setToSortedString(uniqueNames);

              try {
                setCurrentFiber(firstFiber);
                error('Legacy context API has been detected within a strict-mode tree.' + '\n\nThe old API will be supported in all 16.x releases, but applications ' + 'using it should migrate to the new version.' + '\n\nPlease update the following components: %s' + '\n\nLearn more about this warning here: https://reactjs.org/link/legacy-context', sortedNames);
              } finally {
                resetCurrentFiber();
              }
            });
          };

          ReactStrictModeWarnings.discardPendingWarnings = function () {
            pendingComponentWillMountWarnings = [];
            pendingUNSAFE_ComponentWillMountWarnings = [];
            pendingComponentWillReceivePropsWarnings = [];
            pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
            pendingComponentWillUpdateWarnings = [];
            pendingUNSAFE_ComponentWillUpdateWarnings = [];
            pendingLegacyContextWarning = new Map();
          };
        }

        function resolveDefaultProps(Component, baseProps) {
          if (Component && Component.defaultProps) {
            // Resolve default props. Taken from ReactElement
            var props = _assign({}, baseProps);

            var defaultProps = Component.defaultProps;

            for (var propName in defaultProps) {
              if (props[propName] === undefined) {
                props[propName] = defaultProps[propName];
              }
            }

            return props;
          }

          return baseProps;
        } // Max 31 bit integer. The max integer size in V8 for 32-bit systems.
        // Math.pow(2, 30) - 1
        // 0b111111111111111111111111111111


        var MAX_SIGNED_31_BIT_INT = 1073741823;
        var valueCursor = createCursor(null);
        var rendererSigil;
        {
          // Use this to detect multiple renderers using the same context
          rendererSigil = {};
        }
        var currentlyRenderingFiber = null;
        var lastContextDependency = null;
        var lastContextWithAllBitsObserved = null;
        var isDisallowedContextReadInDEV = false;

        function resetContextDependencies() {
          // This is called right before React yields execution, to ensure `readContext`
          // cannot be called outside the render phase.
          currentlyRenderingFiber = null;
          lastContextDependency = null;
          lastContextWithAllBitsObserved = null;
          {
            isDisallowedContextReadInDEV = false;
          }
        }

        function enterDisallowedContextReadInDEV() {
          {
            isDisallowedContextReadInDEV = true;
          }
        }

        function exitDisallowedContextReadInDEV() {
          {
            isDisallowedContextReadInDEV = false;
          }
        }

        function pushProvider(providerFiber, nextValue) {
          var context = providerFiber.type._context;
          {
            push(valueCursor, context._currentValue, providerFiber);
            context._currentValue = nextValue;
            {
              if (context._currentRenderer !== undefined && context._currentRenderer !== null && context._currentRenderer !== rendererSigil) {
                error('Detected multiple renderers concurrently rendering the ' + 'same context provider. This is currently unsupported.');
              }

              context._currentRenderer = rendererSigil;
            }
          }
        }

        function popProvider(providerFiber) {
          var currentValue = valueCursor.current;
          pop(valueCursor, providerFiber);
          var context = providerFiber.type._context;
          {
            context._currentValue = currentValue;
          }
        }

        function calculateChangedBits(context, newValue, oldValue) {
          if (objectIs(oldValue, newValue)) {
            // No change
            return 0;
          } else {
            var changedBits = typeof context._calculateChangedBits === 'function' ? context._calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
            {
              if ((changedBits & MAX_SIGNED_31_BIT_INT) !== changedBits) {
                error('calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: %s', changedBits);
              }
            }
            return changedBits | 0;
          }
        }

        function scheduleWorkOnParentPath(parent, renderLanes) {
          // Update the child lanes of all the ancestors, including the alternates.
          var node = parent;

          while (node !== null) {
            var alternate = node.alternate;

            if (!isSubsetOfLanes(node.childLanes, renderLanes)) {
              node.childLanes = mergeLanes(node.childLanes, renderLanes);

              if (alternate !== null) {
                alternate.childLanes = mergeLanes(alternate.childLanes, renderLanes);
              }
            } else if (alternate !== null && !isSubsetOfLanes(alternate.childLanes, renderLanes)) {
              alternate.childLanes = mergeLanes(alternate.childLanes, renderLanes);
            } else {
              // Neither alternate was updated, which means the rest of the
              // ancestor path already has sufficient priority.
              break;
            }

            node = node.return;
          }
        }

        function propagateContextChange(workInProgress, context, changedBits, renderLanes) {
          var fiber = workInProgress.child;

          if (fiber !== null) {
            // Set the return pointer of the child to the work-in-progress fiber.
            fiber.return = workInProgress;
          }

          while (fiber !== null) {
            var nextFiber = void 0; // Visit this fiber.

            var list = fiber.dependencies;

            if (list !== null) {
              nextFiber = fiber.child;
              var dependency = list.firstContext;

              while (dependency !== null) {
                // Check if the context matches.
                if (dependency.context === context && (dependency.observedBits & changedBits) !== 0) {
                  // Match! Schedule an update on this fiber.
                  if (fiber.tag === ClassComponent) {
                    // Schedule a force update on the work-in-progress.
                    var update = createUpdate(NoTimestamp, pickArbitraryLane(renderLanes));
                    update.tag = ForceUpdate; // TODO: Because we don't have a work-in-progress, this will add the
                    // update to the current fiber, too, which means it will persist even if
                    // this render is thrown away. Since it's a race condition, not sure it's
                    // worth fixing.

                    enqueueUpdate(fiber, update);
                  }

                  fiber.lanes = mergeLanes(fiber.lanes, renderLanes);
                  var alternate = fiber.alternate;

                  if (alternate !== null) {
                    alternate.lanes = mergeLanes(alternate.lanes, renderLanes);
                  }

                  scheduleWorkOnParentPath(fiber.return, renderLanes); // Mark the updated lanes on the list, too.

                  list.lanes = mergeLanes(list.lanes, renderLanes); // Since we already found a match, we can stop traversing the
                  // dependency list.

                  break;
                }

                dependency = dependency.next;
              }
            } else if (fiber.tag === ContextProvider) {
              // Don't scan deeper if this is a matching provider
              nextFiber = fiber.type === workInProgress.type ? null : fiber.child;
            } else {
              // Traverse down.
              nextFiber = fiber.child;
            }

            if (nextFiber !== null) {
              // Set the return pointer of the child to the work-in-progress fiber.
              nextFiber.return = fiber;
            } else {
              // No child. Traverse to next sibling.
              nextFiber = fiber;

              while (nextFiber !== null) {
                if (nextFiber === workInProgress) {
                  // We're back to the root of this subtree. Exit.
                  nextFiber = null;
                  break;
                }

                var sibling = nextFiber.sibling;

                if (sibling !== null) {
                  // Set the return pointer of the sibling to the work-in-progress fiber.
                  sibling.return = nextFiber.return;
                  nextFiber = sibling;
                  break;
                } // No more siblings. Traverse up.


                nextFiber = nextFiber.return;
              }
            }

            fiber = nextFiber;
          }
        }

        function prepareToReadContext(workInProgress, renderLanes) {
          currentlyRenderingFiber = workInProgress;
          lastContextDependency = null;
          lastContextWithAllBitsObserved = null;
          var dependencies = workInProgress.dependencies;

          if (dependencies !== null) {
            var firstContext = dependencies.firstContext;

            if (firstContext !== null) {
              if (includesSomeLane(dependencies.lanes, renderLanes)) {
                // Context list has a pending update. Mark that this fiber performed work.
                markWorkInProgressReceivedUpdate();
              } // Reset the work-in-progress list


              dependencies.firstContext = null;
            }
          }
        }

        function _readContext(context, observedBits) {
          {
            // This warning would fire if you read context inside a Hook like useMemo.
            // Unlike the class check below, it's not enforced in production for perf.
            if (isDisallowedContextReadInDEV) {
              error('Context can only be read while React is rendering. ' + 'In classes, you can read it in the render method or getDerivedStateFromProps. ' + 'In function components, you can read it directly in the function body, but not ' + 'inside Hooks like useReducer() or useMemo().');
            }
          }
          if (lastContextWithAllBitsObserved === context) ;else if (observedBits === false || observedBits === 0) ;else {
            var resolvedObservedBits; // Avoid deopting on observable arguments or heterogeneous types.

            if (typeof observedBits !== 'number' || observedBits === MAX_SIGNED_31_BIT_INT) {
              // Observe all updates.
              lastContextWithAllBitsObserved = context;
              resolvedObservedBits = MAX_SIGNED_31_BIT_INT;
            } else {
              resolvedObservedBits = observedBits;
            }

            var contextItem = {
              context: context,
              observedBits: resolvedObservedBits,
              next: null
            };

            if (lastContextDependency === null) {
              if (!(currentlyRenderingFiber !== null)) {
                {
                  throw Error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
                }
              } // This is the first dependency for this component. Create a new list.


              lastContextDependency = contextItem;
              currentlyRenderingFiber.dependencies = {
                lanes: NoLanes,
                firstContext: contextItem,
                responders: null
              };
            } else {
              // Append a new context item.
              lastContextDependency = lastContextDependency.next = contextItem;
            }
          }
          return context._currentValue;
        }

        var UpdateState = 0;
        var ReplaceState = 1;
        var ForceUpdate = 2;
        var CaptureUpdate = 3; // Global state that is reset at the beginning of calling `processUpdateQueue`.
        // It should only be read right after calling `processUpdateQueue`, via
        // `checkHasForceUpdateAfterProcessing`.

        var hasForceUpdate = false;
        var didWarnUpdateInsideUpdate;
        var currentlyProcessingQueue;
        {
          didWarnUpdateInsideUpdate = false;
          currentlyProcessingQueue = null;
        }

        function initializeUpdateQueue(fiber) {
          var queue = {
            baseState: fiber.memoizedState,
            firstBaseUpdate: null,
            lastBaseUpdate: null,
            shared: {
              pending: null
            },
            effects: null
          };
          fiber.updateQueue = queue;
        }

        function cloneUpdateQueue(current, workInProgress) {
          // Clone the update queue from current. Unless it's already a clone.
          var queue = workInProgress.updateQueue;
          var currentQueue = current.updateQueue;

          if (queue === currentQueue) {
            var clone = {
              baseState: currentQueue.baseState,
              firstBaseUpdate: currentQueue.firstBaseUpdate,
              lastBaseUpdate: currentQueue.lastBaseUpdate,
              shared: currentQueue.shared,
              effects: currentQueue.effects
            };
            workInProgress.updateQueue = clone;
          }
        }

        function createUpdate(eventTime, lane) {
          var update = {
            eventTime: eventTime,
            lane: lane,
            tag: UpdateState,
            payload: null,
            callback: null,
            next: null
          };
          return update;
        }

        function enqueueUpdate(fiber, update) {
          var updateQueue = fiber.updateQueue;

          if (updateQueue === null) {
            // Only occurs if the fiber has been unmounted.
            return;
          }

          var sharedQueue = updateQueue.shared;
          var pending = sharedQueue.pending;

          if (pending === null) {
            // This is the first update. Create a circular list.
            update.next = update;
          } else {
            update.next = pending.next;
            pending.next = update;
          }

          sharedQueue.pending = update;
          {
            if (currentlyProcessingQueue === sharedQueue && !didWarnUpdateInsideUpdate) {
              error('An update (setState, replaceState, or forceUpdate) was scheduled ' + 'from inside an update function. Update functions should be pure, ' + 'with zero side-effects. Consider using componentDidUpdate or a ' + 'callback.');
              didWarnUpdateInsideUpdate = true;
            }
          }
        }

        function enqueueCapturedUpdate(workInProgress, capturedUpdate) {
          // Captured updates are updates that are thrown by a child during the render
          // phase. They should be discarded if the render is aborted. Therefore,
          // we should only put them on the work-in-progress queue, not the current one.
          var queue = workInProgress.updateQueue; // Check if the work-in-progress queue is a clone.

          var current = workInProgress.alternate;

          if (current !== null) {
            var currentQueue = current.updateQueue;

            if (queue === currentQueue) {
              // The work-in-progress queue is the same as current. This happens when
              // we bail out on a parent fiber that then captures an error thrown by
              // a child. Since we want to append the update only to the work-in
              // -progress queue, we need to clone the updates. We usually clone during
              // processUpdateQueue, but that didn't happen in this case because we
              // skipped over the parent when we bailed out.
              var newFirst = null;
              var newLast = null;
              var firstBaseUpdate = queue.firstBaseUpdate;

              if (firstBaseUpdate !== null) {
                // Loop through the updates and clone them.
                var update = firstBaseUpdate;

                do {
                  var clone = {
                    eventTime: update.eventTime,
                    lane: update.lane,
                    tag: update.tag,
                    payload: update.payload,
                    callback: update.callback,
                    next: null
                  };

                  if (newLast === null) {
                    newFirst = newLast = clone;
                  } else {
                    newLast.next = clone;
                    newLast = clone;
                  }

                  update = update.next;
                } while (update !== null); // Append the captured update the end of the cloned list.


                if (newLast === null) {
                  newFirst = newLast = capturedUpdate;
                } else {
                  newLast.next = capturedUpdate;
                  newLast = capturedUpdate;
                }
              } else {
                // There are no base updates.
                newFirst = newLast = capturedUpdate;
              }

              queue = {
                baseState: currentQueue.baseState,
                firstBaseUpdate: newFirst,
                lastBaseUpdate: newLast,
                shared: currentQueue.shared,
                effects: currentQueue.effects
              };
              workInProgress.updateQueue = queue;
              return;
            }
          } // Append the update to the end of the list.


          var lastBaseUpdate = queue.lastBaseUpdate;

          if (lastBaseUpdate === null) {
            queue.firstBaseUpdate = capturedUpdate;
          } else {
            lastBaseUpdate.next = capturedUpdate;
          }

          queue.lastBaseUpdate = capturedUpdate;
        }

        function getStateFromUpdate(workInProgress, queue, update, prevState, nextProps, instance) {
          switch (update.tag) {
            case ReplaceState:
              {
                var payload = update.payload;

                if (typeof payload === 'function') {
                  // Updater function
                  {
                    enterDisallowedContextReadInDEV();
                  }
                  var nextState = payload.call(instance, prevState, nextProps);
                  {
                    if (workInProgress.mode & StrictMode) {
                      disableLogs();

                      try {
                        payload.call(instance, prevState, nextProps);
                      } finally {
                        reenableLogs();
                      }
                    }

                    exitDisallowedContextReadInDEV();
                  }
                  return nextState;
                } // State object


                return payload;
              }

            case CaptureUpdate:
              {
                workInProgress.flags = workInProgress.flags & ~ShouldCapture | DidCapture;
              }
            // Intentional fallthrough

            case UpdateState:
              {
                var _payload = update.payload;
                var partialState;

                if (typeof _payload === 'function') {
                  // Updater function
                  {
                    enterDisallowedContextReadInDEV();
                  }
                  partialState = _payload.call(instance, prevState, nextProps);
                  {
                    if (workInProgress.mode & StrictMode) {
                      disableLogs();

                      try {
                        _payload.call(instance, prevState, nextProps);
                      } finally {
                        reenableLogs();
                      }
                    }

                    exitDisallowedContextReadInDEV();
                  }
                } else {
                  // Partial state object
                  partialState = _payload;
                }

                if (partialState === null || partialState === undefined) {
                  // Null and undefined are treated as no-ops.
                  return prevState;
                } // Merge the partial state and the previous state.


                return _assign({}, prevState, partialState);
              }

            case ForceUpdate:
              {
                hasForceUpdate = true;
                return prevState;
              }
          }

          return prevState;
        }

        function processUpdateQueue(workInProgress, props, instance, renderLanes) {
          // This is always non-null on a ClassComponent or HostRoot
          var queue = workInProgress.updateQueue;
          hasForceUpdate = false;
          {
            currentlyProcessingQueue = queue.shared;
          }
          var firstBaseUpdate = queue.firstBaseUpdate;
          var lastBaseUpdate = queue.lastBaseUpdate; // Check if there are pending updates. If so, transfer them to the base queue.

          var pendingQueue = queue.shared.pending;

          if (pendingQueue !== null) {
            queue.shared.pending = null; // The pending queue is circular. Disconnect the pointer between first
            // and last so that it's non-circular.

            var lastPendingUpdate = pendingQueue;
            var firstPendingUpdate = lastPendingUpdate.next;
            lastPendingUpdate.next = null; // Append pending updates to base queue

            if (lastBaseUpdate === null) {
              firstBaseUpdate = firstPendingUpdate;
            } else {
              lastBaseUpdate.next = firstPendingUpdate;
            }

            lastBaseUpdate = lastPendingUpdate; // If there's a current queue, and it's different from the base queue, then
            // we need to transfer the updates to that queue, too. Because the base
            // queue is a singly-linked list with no cycles, we can append to both
            // lists and take advantage of structural sharing.
            // TODO: Pass `current` as argument

            var current = workInProgress.alternate;

            if (current !== null) {
              // This is always non-null on a ClassComponent or HostRoot
              var currentQueue = current.updateQueue;
              var currentLastBaseUpdate = currentQueue.lastBaseUpdate;

              if (currentLastBaseUpdate !== lastBaseUpdate) {
                if (currentLastBaseUpdate === null) {
                  currentQueue.firstBaseUpdate = firstPendingUpdate;
                } else {
                  currentLastBaseUpdate.next = firstPendingUpdate;
                }

                currentQueue.lastBaseUpdate = lastPendingUpdate;
              }
            }
          } // These values may change as we process the queue.


          if (firstBaseUpdate !== null) {
            // Iterate through the list of updates to compute the result.
            var newState = queue.baseState; // TODO: Don't need to accumulate this. Instead, we can remove renderLanes
            // from the original lanes.

            var newLanes = NoLanes;
            var newBaseState = null;
            var newFirstBaseUpdate = null;
            var newLastBaseUpdate = null;
            var update = firstBaseUpdate;

            do {
              var updateLane = update.lane;
              var updateEventTime = update.eventTime;

              if (!isSubsetOfLanes(renderLanes, updateLane)) {
                // Priority is insufficient. Skip this update. If this is the first
                // skipped update, the previous update/state is the new base
                // update/state.
                var clone = {
                  eventTime: updateEventTime,
                  lane: updateLane,
                  tag: update.tag,
                  payload: update.payload,
                  callback: update.callback,
                  next: null
                };

                if (newLastBaseUpdate === null) {
                  newFirstBaseUpdate = newLastBaseUpdate = clone;
                  newBaseState = newState;
                } else {
                  newLastBaseUpdate = newLastBaseUpdate.next = clone;
                } // Update the remaining priority in the queue.


                newLanes = mergeLanes(newLanes, updateLane);
              } else {
                // This update does have sufficient priority.
                if (newLastBaseUpdate !== null) {
                  var _clone = {
                    eventTime: updateEventTime,
                    // This update is going to be committed so we never want uncommit
                    // it. Using NoLane works because 0 is a subset of all bitmasks, so
                    // this will never be skipped by the check above.
                    lane: NoLane,
                    tag: update.tag,
                    payload: update.payload,
                    callback: update.callback,
                    next: null
                  };
                  newLastBaseUpdate = newLastBaseUpdate.next = _clone;
                } // Process this update.


                newState = getStateFromUpdate(workInProgress, queue, update, newState, props, instance);
                var callback = update.callback;

                if (callback !== null) {
                  workInProgress.flags |= Callback;
                  var effects = queue.effects;

                  if (effects === null) {
                    queue.effects = [update];
                  } else {
                    effects.push(update);
                  }
                }
              }

              update = update.next;

              if (update === null) {
                pendingQueue = queue.shared.pending;

                if (pendingQueue === null) {
                  break;
                } else {
                  // An update was scheduled from inside a reducer. Add the new
                  // pending updates to the end of the list and keep processing.
                  var _lastPendingUpdate = pendingQueue; // Intentionally unsound. Pending updates form a circular list, but we
                  // unravel them when transferring them to the base queue.

                  var _firstPendingUpdate = _lastPendingUpdate.next;
                  _lastPendingUpdate.next = null;
                  update = _firstPendingUpdate;
                  queue.lastBaseUpdate = _lastPendingUpdate;
                  queue.shared.pending = null;
                }
              }
            } while (true);

            if (newLastBaseUpdate === null) {
              newBaseState = newState;
            }

            queue.baseState = newBaseState;
            queue.firstBaseUpdate = newFirstBaseUpdate;
            queue.lastBaseUpdate = newLastBaseUpdate; // Set the remaining expiration time to be whatever is remaining in the queue.
            // This should be fine because the only two other things that contribute to
            // expiration time are props and context. We're already in the middle of the
            // begin phase by the time we start processing the queue, so we've already
            // dealt with the props. Context in components that specify
            // shouldComponentUpdate is tricky; but we'll have to account for
            // that regardless.

            markSkippedUpdateLanes(newLanes);
            workInProgress.lanes = newLanes;
            workInProgress.memoizedState = newState;
          }

          {
            currentlyProcessingQueue = null;
          }
        }

        function callCallback(callback, context) {
          if (!(typeof callback === 'function')) {
            {
              throw Error("Invalid argument passed as callback. Expected a function. Instead received: " + callback);
            }
          }

          callback.call(context);
        }

        function resetHasForceUpdateBeforeProcessing() {
          hasForceUpdate = false;
        }

        function checkHasForceUpdateAfterProcessing() {
          return hasForceUpdate;
        }

        function commitUpdateQueue(finishedWork, finishedQueue, instance) {
          // Commit the effects
          var effects = finishedQueue.effects;
          finishedQueue.effects = null;

          if (effects !== null) {
            for (var i = 0; i < effects.length; i++) {
              var effect = effects[i];
              var callback = effect.callback;

              if (callback !== null) {
                effect.callback = null;
                callCallback(callback, instance);
              }
            }
          }
        }

        var fakeInternalInstance = {};
        var isArray = Array.isArray; // React.Component uses a shared frozen object by default.
        // We'll use it to determine whether we need to initialize legacy refs.

        var emptyRefsObject = new React.Component().refs;
        var didWarnAboutStateAssignmentForComponent;
        var didWarnAboutUninitializedState;
        var didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate;
        var didWarnAboutLegacyLifecyclesAndDerivedState;
        var didWarnAboutUndefinedDerivedState;
        var warnOnUndefinedDerivedState;
        var warnOnInvalidCallback;
        var didWarnAboutDirectlyAssigningPropsToState;
        var didWarnAboutContextTypeAndContextTypes;
        var didWarnAboutInvalidateContextType;
        {
          didWarnAboutStateAssignmentForComponent = new Set();
          didWarnAboutUninitializedState = new Set();
          didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate = new Set();
          didWarnAboutLegacyLifecyclesAndDerivedState = new Set();
          didWarnAboutDirectlyAssigningPropsToState = new Set();
          didWarnAboutUndefinedDerivedState = new Set();
          didWarnAboutContextTypeAndContextTypes = new Set();
          didWarnAboutInvalidateContextType = new Set();
          var didWarnOnInvalidCallback = new Set();

          warnOnInvalidCallback = function warnOnInvalidCallback(callback, callerName) {
            if (callback === null || typeof callback === 'function') {
              return;
            }

            var key = callerName + '_' + callback;

            if (!didWarnOnInvalidCallback.has(key)) {
              didWarnOnInvalidCallback.add(key);
              error('%s(...): Expected the last optional `callback` argument to be a ' + 'function. Instead received: %s.', callerName, callback);
            }
          };

          warnOnUndefinedDerivedState = function warnOnUndefinedDerivedState(type, partialState) {
            if (partialState === undefined) {
              var componentName = getComponentName(type) || 'Component';

              if (!didWarnAboutUndefinedDerivedState.has(componentName)) {
                didWarnAboutUndefinedDerivedState.add(componentName);
                error('%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. ' + 'You have returned undefined.', componentName);
              }
            }
          }; // This is so gross but it's at least non-critical and can be removed if
          // it causes problems. This is meant to give a nicer error message for
          // ReactDOM15.unstable_renderSubtreeIntoContainer(reactDOM16Component,
          // ...)) which otherwise throws a "_processChildContext is not a function"
          // exception.


          Object.defineProperty(fakeInternalInstance, '_processChildContext', {
            enumerable: false,
            value: function value() {
              {
                {
                  throw Error("_processChildContext is not available in React 16+. This likely means you have multiple copies of React and are attempting to nest a React 15 tree inside a React 16 tree using unstable_renderSubtreeIntoContainer, which isn't supported. Try to make sure you have only one copy of React (and ideally, switch to ReactDOM.createPortal).");
                }
              }
            }
          });
          Object.freeze(fakeInternalInstance);
        }

        function applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
          var prevState = workInProgress.memoizedState;
          {
            if (workInProgress.mode & StrictMode) {
              disableLogs();

              try {
                // Invoke the function an extra time to help detect side-effects.
                getDerivedStateFromProps(nextProps, prevState);
              } finally {
                reenableLogs();
              }
            }
          }
          var partialState = getDerivedStateFromProps(nextProps, prevState);
          {
            warnOnUndefinedDerivedState(ctor, partialState);
          } // Merge the partial state and the previous state.

          var memoizedState = partialState === null || partialState === undefined ? prevState : _assign({}, prevState, partialState);
          workInProgress.memoizedState = memoizedState; // Once the update queue is empty, persist the derived state onto the
          // base state.

          if (workInProgress.lanes === NoLanes) {
            // Queue is always non-null for classes
            var updateQueue = workInProgress.updateQueue;
            updateQueue.baseState = memoizedState;
          }
        }

        var classComponentUpdater = {
          isMounted: isMounted,
          enqueueSetState: function enqueueSetState(inst, payload, callback) {
            var fiber = get(inst);
            var eventTime = requestEventTime();
            var lane = requestUpdateLane(fiber);
            var update = createUpdate(eventTime, lane);
            update.payload = payload;

            if (callback !== undefined && callback !== null) {
              {
                warnOnInvalidCallback(callback, 'setState');
              }
              update.callback = callback;
            }

            enqueueUpdate(fiber, update);
            scheduleUpdateOnFiber(fiber, lane, eventTime);
          },
          enqueueReplaceState: function enqueueReplaceState(inst, payload, callback) {
            var fiber = get(inst);
            var eventTime = requestEventTime();
            var lane = requestUpdateLane(fiber);
            var update = createUpdate(eventTime, lane);
            update.tag = ReplaceState;
            update.payload = payload;

            if (callback !== undefined && callback !== null) {
              {
                warnOnInvalidCallback(callback, 'replaceState');
              }
              update.callback = callback;
            }

            enqueueUpdate(fiber, update);
            scheduleUpdateOnFiber(fiber, lane, eventTime);
          },
          enqueueForceUpdate: function enqueueForceUpdate(inst, callback) {
            var fiber = get(inst);
            var eventTime = requestEventTime();
            var lane = requestUpdateLane(fiber);
            var update = createUpdate(eventTime, lane);
            update.tag = ForceUpdate;

            if (callback !== undefined && callback !== null) {
              {
                warnOnInvalidCallback(callback, 'forceUpdate');
              }
              update.callback = callback;
            }

            enqueueUpdate(fiber, update);
            scheduleUpdateOnFiber(fiber, lane, eventTime);
          }
        };

        function checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
          var instance = workInProgress.stateNode;

          if (typeof instance.shouldComponentUpdate === 'function') {
            {
              if (workInProgress.mode & StrictMode) {
                disableLogs();

                try {
                  // Invoke the function an extra time to help detect side-effects.
                  instance.shouldComponentUpdate(newProps, newState, nextContext);
                } finally {
                  reenableLogs();
                }
              }
            }
            var shouldUpdate = instance.shouldComponentUpdate(newProps, newState, nextContext);
            {
              if (shouldUpdate === undefined) {
                error('%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', getComponentName(ctor) || 'Component');
              }
            }
            return shouldUpdate;
          }

          if (ctor.prototype && ctor.prototype.isPureReactComponent) {
            return !shallowEqual(oldProps, newProps) || !shallowEqual(oldState, newState);
          }

          return true;
        }

        function checkClassInstance(workInProgress, ctor, newProps) {
          var instance = workInProgress.stateNode;
          {
            var name = getComponentName(ctor) || 'Component';
            var renderPresent = instance.render;

            if (!renderPresent) {
              if (ctor.prototype && typeof ctor.prototype.render === 'function') {
                error('%s(...): No `render` method found on the returned component ' + 'instance: did you accidentally return an object from the constructor?', name);
              } else {
                error('%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', name);
              }
            }

            if (instance.getInitialState && !instance.getInitialState.isReactClassApproved && !instance.state) {
              error('getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', name);
            }

            if (instance.getDefaultProps && !instance.getDefaultProps.isReactClassApproved) {
              error('getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', name);
            }

            if (instance.propTypes) {
              error('propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', name);
            }

            if (instance.contextType) {
              error('contextType was defined as an instance property on %s. Use a static ' + 'property to define contextType instead.', name);
            }

            {
              if (instance.contextTypes) {
                error('contextTypes was defined as an instance property on %s. Use a static ' + 'property to define contextTypes instead.', name);
              }

              if (ctor.contextType && ctor.contextTypes && !didWarnAboutContextTypeAndContextTypes.has(ctor)) {
                didWarnAboutContextTypeAndContextTypes.add(ctor);
                error('%s declares both contextTypes and contextType static properties. ' + 'The legacy contextTypes property will be ignored.', name);
              }
            }

            if (typeof instance.componentShouldUpdate === 'function') {
              error('%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', name);
            }

            if (ctor.prototype && ctor.prototype.isPureReactComponent && typeof instance.shouldComponentUpdate !== 'undefined') {
              error('%s has a method called shouldComponentUpdate(). ' + 'shouldComponentUpdate should not be used when extending React.PureComponent. ' + 'Please extend React.Component if shouldComponentUpdate is used.', getComponentName(ctor) || 'A pure component');
            }

            if (typeof instance.componentDidUnmount === 'function') {
              error('%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', name);
            }

            if (typeof instance.componentDidReceiveProps === 'function') {
              error('%s has a method called ' + 'componentDidReceiveProps(). But there is no such lifecycle method. ' + 'If you meant to update the state in response to changing props, ' + 'use componentWillReceiveProps(). If you meant to fetch data or ' + 'run side-effects or mutations after React has updated the UI, use componentDidUpdate().', name);
            }

            if (typeof instance.componentWillRecieveProps === 'function') {
              error('%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', name);
            }

            if (typeof instance.UNSAFE_componentWillRecieveProps === 'function') {
              error('%s has a method called ' + 'UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?', name);
            }

            var hasMutatedProps = instance.props !== newProps;

            if (instance.props !== undefined && hasMutatedProps) {
              error('%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", name, name);
            }

            if (instance.defaultProps) {
              error('Setting defaultProps as an instance property on %s is not supported and will be ignored.' + ' Instead, define defaultProps as a static property on %s.', name, name);
            }

            if (typeof instance.getSnapshotBeforeUpdate === 'function' && typeof instance.componentDidUpdate !== 'function' && !didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.has(ctor)) {
              didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.add(ctor);
              error('%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). ' + 'This component defines getSnapshotBeforeUpdate() only.', getComponentName(ctor));
            }

            if (typeof instance.getDerivedStateFromProps === 'function') {
              error('%s: getDerivedStateFromProps() is defined as an instance method ' + 'and will be ignored. Instead, declare it as a static method.', name);
            }

            if (typeof instance.getDerivedStateFromError === 'function') {
              error('%s: getDerivedStateFromError() is defined as an instance method ' + 'and will be ignored. Instead, declare it as a static method.', name);
            }

            if (typeof ctor.getSnapshotBeforeUpdate === 'function') {
              error('%s: getSnapshotBeforeUpdate() is defined as a static method ' + 'and will be ignored. Instead, declare it as an instance method.', name);
            }

            var _state = instance.state;

            if (_state && (typeof _state !== 'object' || isArray(_state))) {
              error('%s.state: must be set to an object or null', name);
            }

            if (typeof instance.getChildContext === 'function' && typeof ctor.childContextTypes !== 'object') {
              error('%s.getChildContext(): childContextTypes must be defined in order to ' + 'use getChildContext().', name);
            }
          }
        }

        function adoptClassInstance(workInProgress, instance) {
          instance.updater = classComponentUpdater;
          workInProgress.stateNode = instance; // The instance needs access to the fiber so that it can schedule updates

          set(instance, workInProgress);
          {
            instance._reactInternalInstance = fakeInternalInstance;
          }
        }

        function constructClassInstance(workInProgress, ctor, props) {
          var isLegacyContextConsumer = false;
          var unmaskedContext = emptyContextObject;
          var context = emptyContextObject;
          var contextType = ctor.contextType;
          {
            if ('contextType' in ctor) {
              var isValid = // Allow null for conditional declaration
              contextType === null || contextType !== undefined && contextType.$$typeof === REACT_CONTEXT_TYPE && contextType._context === undefined; // Not a <Context.Consumer>

              if (!isValid && !didWarnAboutInvalidateContextType.has(ctor)) {
                didWarnAboutInvalidateContextType.add(ctor);
                var addendum = '';

                if (contextType === undefined) {
                  addendum = ' However, it is set to undefined. ' + 'This can be caused by a typo or by mixing up named and default imports. ' + 'This can also happen due to a circular dependency, so ' + 'try moving the createContext() call to a separate file.';
                } else if (typeof contextType !== 'object') {
                  addendum = ' However, it is set to a ' + typeof contextType + '.';
                } else if (contextType.$$typeof === REACT_PROVIDER_TYPE) {
                  addendum = ' Did you accidentally pass the Context.Provider instead?';
                } else if (contextType._context !== undefined) {
                  // <Context.Consumer>
                  addendum = ' Did you accidentally pass the Context.Consumer instead?';
                } else {
                  addendum = ' However, it is set to an object with keys {' + Object.keys(contextType).join(', ') + '}.';
                }

                error('%s defines an invalid contextType. ' + 'contextType should point to the Context object returned by React.createContext().%s', getComponentName(ctor) || 'Component', addendum);
              }
            }
          }

          if (typeof contextType === 'object' && contextType !== null) {
            context = _readContext(contextType);
          } else {
            unmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            var contextTypes = ctor.contextTypes;
            isLegacyContextConsumer = contextTypes !== null && contextTypes !== undefined;
            context = isLegacyContextConsumer ? getMaskedContext(workInProgress, unmaskedContext) : emptyContextObject;
          } // Instantiate twice to help detect side-effects.


          {
            if (workInProgress.mode & StrictMode) {
              disableLogs();

              try {
                new ctor(props, context); // eslint-disable-line no-new
              } finally {
                reenableLogs();
              }
            }
          }
          var instance = new ctor(props, context);
          var state = workInProgress.memoizedState = instance.state !== null && instance.state !== undefined ? instance.state : null;
          adoptClassInstance(workInProgress, instance);
          {
            if (typeof ctor.getDerivedStateFromProps === 'function' && state === null) {
              var componentName = getComponentName(ctor) || 'Component';

              if (!didWarnAboutUninitializedState.has(componentName)) {
                didWarnAboutUninitializedState.add(componentName);
                error('`%s` uses `getDerivedStateFromProps` but its initial state is ' + '%s. This is not recommended. Instead, define the initial state by ' + 'assigning an object to `this.state` in the constructor of `%s`. ' + 'This ensures that `getDerivedStateFromProps` arguments have a consistent shape.', componentName, instance.state === null ? 'null' : 'undefined', componentName);
              }
            } // If new component APIs are defined, "unsafe" lifecycles won't be called.
            // Warn about these lifecycles if they are present.
            // Don't warn about react-lifecycles-compat polyfilled methods though.


            if (typeof ctor.getDerivedStateFromProps === 'function' || typeof instance.getSnapshotBeforeUpdate === 'function') {
              var foundWillMountName = null;
              var foundWillReceivePropsName = null;
              var foundWillUpdateName = null;

              if (typeof instance.componentWillMount === 'function' && instance.componentWillMount.__suppressDeprecationWarning !== true) {
                foundWillMountName = 'componentWillMount';
              } else if (typeof instance.UNSAFE_componentWillMount === 'function') {
                foundWillMountName = 'UNSAFE_componentWillMount';
              }

              if (typeof instance.componentWillReceiveProps === 'function' && instance.componentWillReceiveProps.__suppressDeprecationWarning !== true) {
                foundWillReceivePropsName = 'componentWillReceiveProps';
              } else if (typeof instance.UNSAFE_componentWillReceiveProps === 'function') {
                foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
              }

              if (typeof instance.componentWillUpdate === 'function' && instance.componentWillUpdate.__suppressDeprecationWarning !== true) {
                foundWillUpdateName = 'componentWillUpdate';
              } else if (typeof instance.UNSAFE_componentWillUpdate === 'function') {
                foundWillUpdateName = 'UNSAFE_componentWillUpdate';
              }

              if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
                var _componentName = getComponentName(ctor) || 'Component';

                var newApiName = typeof ctor.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';

                if (!didWarnAboutLegacyLifecyclesAndDerivedState.has(_componentName)) {
                  didWarnAboutLegacyLifecyclesAndDerivedState.add(_componentName);
                  error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + '%s uses %s but also contains the following legacy lifecycles:%s%s%s\n\n' + 'The above lifecycles should be removed. Learn more about this warning here:\n' + 'https://reactjs.org/link/unsafe-component-lifecycles', _componentName, newApiName, foundWillMountName !== null ? "\n  " + foundWillMountName : '', foundWillReceivePropsName !== null ? "\n  " + foundWillReceivePropsName : '', foundWillUpdateName !== null ? "\n  " + foundWillUpdateName : '');
                }
              }
            }
          } // Cache unmasked context so we can avoid recreating masked context unless necessary.
          // ReactFiberContext usually updates this cache but can't for newly-created instances.

          if (isLegacyContextConsumer) {
            cacheContext(workInProgress, unmaskedContext, context);
          }

          return instance;
        }

        function callComponentWillMount(workInProgress, instance) {
          var oldState = instance.state;

          if (typeof instance.componentWillMount === 'function') {
            instance.componentWillMount();
          }

          if (typeof instance.UNSAFE_componentWillMount === 'function') {
            instance.UNSAFE_componentWillMount();
          }

          if (oldState !== instance.state) {
            {
              error('%s.componentWillMount(): Assigning directly to this.state is ' + "deprecated (except inside a component's " + 'constructor). Use setState instead.', getComponentName(workInProgress.type) || 'Component');
            }
            classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
          }
        }

        function callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
          var oldState = instance.state;

          if (typeof instance.componentWillReceiveProps === 'function') {
            instance.componentWillReceiveProps(newProps, nextContext);
          }

          if (typeof instance.UNSAFE_componentWillReceiveProps === 'function') {
            instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
          }

          if (instance.state !== oldState) {
            {
              var componentName = getComponentName(workInProgress.type) || 'Component';

              if (!didWarnAboutStateAssignmentForComponent.has(componentName)) {
                didWarnAboutStateAssignmentForComponent.add(componentName);
                error('%s.componentWillReceiveProps(): Assigning directly to ' + "this.state is deprecated (except inside a component's " + 'constructor). Use setState instead.', componentName);
              }
            }
            classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
          }
        } // Invokes the mount life-cycles on a previously never rendered instance.


        function mountClassInstance(workInProgress, ctor, newProps, renderLanes) {
          {
            checkClassInstance(workInProgress, ctor, newProps);
          }
          var instance = workInProgress.stateNode;
          instance.props = newProps;
          instance.state = workInProgress.memoizedState;
          instance.refs = emptyRefsObject;
          initializeUpdateQueue(workInProgress);
          var contextType = ctor.contextType;

          if (typeof contextType === 'object' && contextType !== null) {
            instance.context = _readContext(contextType);
          } else {
            var unmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            instance.context = getMaskedContext(workInProgress, unmaskedContext);
          }

          {
            if (instance.state === newProps) {
              var componentName = getComponentName(ctor) || 'Component';

              if (!didWarnAboutDirectlyAssigningPropsToState.has(componentName)) {
                didWarnAboutDirectlyAssigningPropsToState.add(componentName);
                error('%s: It is not recommended to assign props directly to state ' + "because updates to props won't be reflected in state. " + 'In most cases, it is better to use props directly.', componentName);
              }
            }

            if (workInProgress.mode & StrictMode) {
              ReactStrictModeWarnings.recordLegacyContextWarning(workInProgress, instance);
            }

            {
              ReactStrictModeWarnings.recordUnsafeLifecycleWarnings(workInProgress, instance);
            }
          }
          processUpdateQueue(workInProgress, newProps, instance, renderLanes);
          instance.state = workInProgress.memoizedState;
          var getDerivedStateFromProps = ctor.getDerivedStateFromProps;

          if (typeof getDerivedStateFromProps === 'function') {
            applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
            instance.state = workInProgress.memoizedState;
          } // In order to support react-lifecycles-compat polyfilled components,
          // Unsafe lifecycles should not be invoked for components using the new APIs.


          if (typeof ctor.getDerivedStateFromProps !== 'function' && typeof instance.getSnapshotBeforeUpdate !== 'function' && (typeof instance.UNSAFE_componentWillMount === 'function' || typeof instance.componentWillMount === 'function')) {
            callComponentWillMount(workInProgress, instance); // If we had additional state updates during this life-cycle, let's
            // process them now.

            processUpdateQueue(workInProgress, newProps, instance, renderLanes);
            instance.state = workInProgress.memoizedState;
          }

          if (typeof instance.componentDidMount === 'function') {
            workInProgress.flags |= Update;
          }
        }

        function resumeMountClassInstance(workInProgress, ctor, newProps, renderLanes) {
          var instance = workInProgress.stateNode;
          var oldProps = workInProgress.memoizedProps;
          instance.props = oldProps;
          var oldContext = instance.context;
          var contextType = ctor.contextType;
          var nextContext = emptyContextObject;

          if (typeof contextType === 'object' && contextType !== null) {
            nextContext = _readContext(contextType);
          } else {
            var nextLegacyUnmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            nextContext = getMaskedContext(workInProgress, nextLegacyUnmaskedContext);
          }

          var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
          var hasNewLifecycles = typeof getDerivedStateFromProps === 'function' || typeof instance.getSnapshotBeforeUpdate === 'function'; // Note: During these life-cycles, instance.props/instance.state are what
          // ever the previously attempted to render - not the "current". However,
          // during componentDidUpdate we pass the "current" props.
          // In order to support react-lifecycles-compat polyfilled components,
          // Unsafe lifecycles should not be invoked for components using the new APIs.

          if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillReceiveProps === 'function' || typeof instance.componentWillReceiveProps === 'function')) {
            if (oldProps !== newProps || oldContext !== nextContext) {
              callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext);
            }
          }

          resetHasForceUpdateBeforeProcessing();
          var oldState = workInProgress.memoizedState;
          var newState = instance.state = oldState;
          processUpdateQueue(workInProgress, newProps, instance, renderLanes);
          newState = workInProgress.memoizedState;

          if (oldProps === newProps && oldState === newState && !hasContextChanged() && !checkHasForceUpdateAfterProcessing()) {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidMount === 'function') {
              workInProgress.flags |= Update;
            }

            return false;
          }

          if (typeof getDerivedStateFromProps === 'function') {
            applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
            newState = workInProgress.memoizedState;
          }

          var shouldUpdate = checkHasForceUpdateAfterProcessing() || checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext);

          if (shouldUpdate) {
            // In order to support react-lifecycles-compat polyfilled components,
            // Unsafe lifecycles should not be invoked for components using the new APIs.
            if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillMount === 'function' || typeof instance.componentWillMount === 'function')) {
              if (typeof instance.componentWillMount === 'function') {
                instance.componentWillMount();
              }

              if (typeof instance.UNSAFE_componentWillMount === 'function') {
                instance.UNSAFE_componentWillMount();
              }
            }

            if (typeof instance.componentDidMount === 'function') {
              workInProgress.flags |= Update;
            }
          } else {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidMount === 'function') {
              workInProgress.flags |= Update;
            } // If shouldComponentUpdate returned false, we should still update the
            // memoized state to indicate that this work can be reused.


            workInProgress.memoizedProps = newProps;
            workInProgress.memoizedState = newState;
          } // Update the existing instance's state, props, and context pointers even
          // if shouldComponentUpdate returns false.


          instance.props = newProps;
          instance.state = newState;
          instance.context = nextContext;
          return shouldUpdate;
        } // Invokes the update life-cycles and returns false if it shouldn't rerender.


        function updateClassInstance(current, workInProgress, ctor, newProps, renderLanes) {
          var instance = workInProgress.stateNode;
          cloneUpdateQueue(current, workInProgress);
          var unresolvedOldProps = workInProgress.memoizedProps;
          var oldProps = workInProgress.type === workInProgress.elementType ? unresolvedOldProps : resolveDefaultProps(workInProgress.type, unresolvedOldProps);
          instance.props = oldProps;
          var unresolvedNewProps = workInProgress.pendingProps;
          var oldContext = instance.context;
          var contextType = ctor.contextType;
          var nextContext = emptyContextObject;

          if (typeof contextType === 'object' && contextType !== null) {
            nextContext = _readContext(contextType);
          } else {
            var nextUnmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            nextContext = getMaskedContext(workInProgress, nextUnmaskedContext);
          }

          var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
          var hasNewLifecycles = typeof getDerivedStateFromProps === 'function' || typeof instance.getSnapshotBeforeUpdate === 'function'; // Note: During these life-cycles, instance.props/instance.state are what
          // ever the previously attempted to render - not the "current". However,
          // during componentDidUpdate we pass the "current" props.
          // In order to support react-lifecycles-compat polyfilled components,
          // Unsafe lifecycles should not be invoked for components using the new APIs.

          if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillReceiveProps === 'function' || typeof instance.componentWillReceiveProps === 'function')) {
            if (unresolvedOldProps !== unresolvedNewProps || oldContext !== nextContext) {
              callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext);
            }
          }

          resetHasForceUpdateBeforeProcessing();
          var oldState = workInProgress.memoizedState;
          var newState = instance.state = oldState;
          processUpdateQueue(workInProgress, newProps, instance, renderLanes);
          newState = workInProgress.memoizedState;

          if (unresolvedOldProps === unresolvedNewProps && oldState === newState && !hasContextChanged() && !checkHasForceUpdateAfterProcessing()) {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidUpdate === 'function') {
              if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) {
                workInProgress.flags |= Update;
              }
            }

            if (typeof instance.getSnapshotBeforeUpdate === 'function') {
              if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) {
                workInProgress.flags |= Snapshot;
              }
            }

            return false;
          }

          if (typeof getDerivedStateFromProps === 'function') {
            applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
            newState = workInProgress.memoizedState;
          }

          var shouldUpdate = checkHasForceUpdateAfterProcessing() || checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext);

          if (shouldUpdate) {
            // In order to support react-lifecycles-compat polyfilled components,
            // Unsafe lifecycles should not be invoked for components using the new APIs.
            if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillUpdate === 'function' || typeof instance.componentWillUpdate === 'function')) {
              if (typeof instance.componentWillUpdate === 'function') {
                instance.componentWillUpdate(newProps, newState, nextContext);
              }

              if (typeof instance.UNSAFE_componentWillUpdate === 'function') {
                instance.UNSAFE_componentWillUpdate(newProps, newState, nextContext);
              }
            }

            if (typeof instance.componentDidUpdate === 'function') {
              workInProgress.flags |= Update;
            }

            if (typeof instance.getSnapshotBeforeUpdate === 'function') {
              workInProgress.flags |= Snapshot;
            }
          } else {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidUpdate === 'function') {
              if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) {
                workInProgress.flags |= Update;
              }
            }

            if (typeof instance.getSnapshotBeforeUpdate === 'function') {
              if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) {
                workInProgress.flags |= Snapshot;
              }
            } // If shouldComponentUpdate returned false, we should still update the
            // memoized props/state to indicate that this work can be reused.


            workInProgress.memoizedProps = newProps;
            workInProgress.memoizedState = newState;
          } // Update the existing instance's state, props, and context pointers even
          // if shouldComponentUpdate returns false.


          instance.props = newProps;
          instance.state = newState;
          instance.context = nextContext;
          return shouldUpdate;
        }

        var didWarnAboutMaps;
        var didWarnAboutGenerators;
        var didWarnAboutStringRefs;
        var ownerHasKeyUseWarning;
        var ownerHasFunctionTypeWarning;

        var warnForMissingKey = function warnForMissingKey(child, returnFiber) {};

        {
          didWarnAboutMaps = false;
          didWarnAboutGenerators = false;
          didWarnAboutStringRefs = {};
          /**
           * Warn if there's no key explicitly set on dynamic arrays of children or
           * object keys are not valid. This allows us to keep track of children between
           * updates.
           */

          ownerHasKeyUseWarning = {};
          ownerHasFunctionTypeWarning = {};

          warnForMissingKey = function warnForMissingKey(child, returnFiber) {
            if (child === null || typeof child !== 'object') {
              return;
            }

            if (!child._store || child._store.validated || child.key != null) {
              return;
            }

            if (!(typeof child._store === 'object')) {
              {
                throw Error("React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue.");
              }
            }

            child._store.validated = true;
            var componentName = getComponentName(returnFiber.type) || 'Component';

            if (ownerHasKeyUseWarning[componentName]) {
              return;
            }

            ownerHasKeyUseWarning[componentName] = true;
            error('Each child in a list should have a unique ' + '"key" prop. See https://reactjs.org/link/warning-keys for ' + 'more information.');
          };
        }
        var isArray$1 = Array.isArray;

        function coerceRef(returnFiber, current, element) {
          var mixedRef = element.ref;

          if (mixedRef !== null && typeof mixedRef !== 'function' && typeof mixedRef !== 'object') {
            {
              // TODO: Clean this up once we turn on the string ref warning for
              // everyone, because the strict mode case will no longer be relevant
              if ((returnFiber.mode & StrictMode || warnAboutStringRefs) && // We warn in ReactElement.js if owner and self are equal for string refs
              // because these cannot be automatically converted to an arrow function
              // using a codemod. Therefore, we don't have to warn about string refs again.
              !(element._owner && element._self && element._owner.stateNode !== element._self)) {
                var componentName = getComponentName(returnFiber.type) || 'Component';

                if (!didWarnAboutStringRefs[componentName]) {
                  {
                    error('A string ref, "%s", has been found within a strict mode tree. ' + 'String refs are a source of potential bugs and should be avoided. ' + 'We recommend using useRef() or createRef() instead. ' + 'Learn more about using refs safely here: ' + 'https://reactjs.org/link/strict-mode-string-ref', mixedRef);
                  }
                  didWarnAboutStringRefs[componentName] = true;
                }
              }
            }

            if (element._owner) {
              var owner = element._owner;
              var inst;

              if (owner) {
                var ownerFiber = owner;

                if (!(ownerFiber.tag === ClassComponent)) {
                  {
                    throw Error("Function components cannot have string refs. We recommend using useRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref");
                  }
                }

                inst = ownerFiber.stateNode;
              }

              if (!inst) {
                {
                  throw Error("Missing owner for string ref " + mixedRef + ". This error is likely caused by a bug in React. Please file an issue.");
                }
              }

              var stringRef = '' + mixedRef; // Check if previous string ref matches new string ref

              if (current !== null && current.ref !== null && typeof current.ref === 'function' && current.ref._stringRef === stringRef) {
                return current.ref;
              }

              var ref = function ref(value) {
                var refs = inst.refs;

                if (refs === emptyRefsObject) {
                  // This is a lazy pooled frozen object, so we need to initialize.
                  refs = inst.refs = {};
                }

                if (value === null) {
                  delete refs[stringRef];
                } else {
                  refs[stringRef] = value;
                }
              };

              ref._stringRef = stringRef;
              return ref;
            } else {
              if (!(typeof mixedRef === 'string')) {
                {
                  throw Error("Expected ref to be a function, a string, an object returned by React.createRef(), or null.");
                }
              }

              if (!element._owner) {
                {
                  throw Error("Element ref was specified as a string (" + mixedRef + ") but no owner was set. This could happen for one of the following reasons:\n1. You may be adding a ref to a function component\n2. You may be adding a ref to a component that was not created inside a component's render method\n3. You have multiple copies of React loaded\nSee https://reactjs.org/link/refs-must-have-owner for more information.");
                }
              }
            }
          }

          return mixedRef;
        }

        function throwOnInvalidObjectType(returnFiber, newChild) {
          if (returnFiber.type !== 'textarea') {
            {
              {
                throw Error("Objects are not valid as a React child (found: " + (Object.prototype.toString.call(newChild) === '[object Object]' ? 'object with keys {' + Object.keys(newChild).join(', ') + '}' : newChild) + "). If you meant to render a collection of children, use an array instead.");
              }
            }
          }
        }

        function warnOnFunctionType(returnFiber) {
          {
            var componentName = getComponentName(returnFiber.type) || 'Component';

            if (ownerHasFunctionTypeWarning[componentName]) {
              return;
            }

            ownerHasFunctionTypeWarning[componentName] = true;
            error('Functions are not valid as a React child. This may happen if ' + 'you return a Component instead of <Component /> from render. ' + 'Or maybe you meant to call this function rather than return it.');
          }
        } // We avoid inlining this to avoid potential deopts from using try/catch.
        // to be able to optimize each path individually by branching early. This needs
        // a compiler or we can do it manually. Helpers that don't need this branching
        // live outside of this function.


        function ChildReconciler(shouldTrackSideEffects) {
          function deleteChild(returnFiber, childToDelete) {
            if (!shouldTrackSideEffects) {
              // Noop.
              return;
            } // Deletions are added in reversed order so we add it to the front.
            // At this point, the return fiber's effect list is empty except for
            // deletions, so we can just append the deletion to the list. The remaining
            // effects aren't added until the complete phase. Once we implement
            // resuming, this may not be true.


            var last = returnFiber.lastEffect;

            if (last !== null) {
              last.nextEffect = childToDelete;
              returnFiber.lastEffect = childToDelete;
            } else {
              returnFiber.firstEffect = returnFiber.lastEffect = childToDelete;
            }

            childToDelete.nextEffect = null;
            childToDelete.flags = Deletion;
          }

          function deleteRemainingChildren(returnFiber, currentFirstChild) {
            if (!shouldTrackSideEffects) {
              // Noop.
              return null;
            } // TODO: For the shouldClone case, this could be micro-optimized a bit by
            // assuming that after the first child we've already added everything.


            var childToDelete = currentFirstChild;

            while (childToDelete !== null) {
              deleteChild(returnFiber, childToDelete);
              childToDelete = childToDelete.sibling;
            }

            return null;
          }

          function mapRemainingChildren(returnFiber, currentFirstChild) {
            // Add the remaining children to a temporary map so that we can find them by
            // keys quickly. Implicit (null) keys get added to this set with their index
            // instead.
            var existingChildren = new Map();
            var existingChild = currentFirstChild;

            while (existingChild !== null) {
              if (existingChild.key !== null) {
                existingChildren.set(existingChild.key, existingChild);
              } else {
                existingChildren.set(existingChild.index, existingChild);
              }

              existingChild = existingChild.sibling;
            }

            return existingChildren;
          }

          function useFiber(fiber, pendingProps) {
            // We currently set sibling to null and index to 0 here because it is easy
            // to forget to do before returning it. E.g. for the single child case.
            var clone = createWorkInProgress(fiber, pendingProps);
            clone.index = 0;
            clone.sibling = null;
            return clone;
          }

          function placeChild(newFiber, lastPlacedIndex, newIndex) {
            newFiber.index = newIndex;

            if (!shouldTrackSideEffects) {
              // Noop.
              return lastPlacedIndex;
            }

            var current = newFiber.alternate;

            if (current !== null) {
              var oldIndex = current.index;

              if (oldIndex < lastPlacedIndex) {
                // This is a move.
                newFiber.flags = Placement;
                return lastPlacedIndex;
              } else {
                // This item can stay in place.
                return oldIndex;
              }
            } else {
              // This is an insertion.
              newFiber.flags = Placement;
              return lastPlacedIndex;
            }
          }

          function placeSingleChild(newFiber) {
            // This is simpler for the single child case. We only need to do a
            // placement for inserting new children.
            if (shouldTrackSideEffects && newFiber.alternate === null) {
              newFiber.flags = Placement;
            }

            return newFiber;
          }

          function updateTextNode(returnFiber, current, textContent, lanes) {
            if (current === null || current.tag !== HostText) {
              // Insert
              var created = createFiberFromText(textContent, returnFiber.mode, lanes);
              created.return = returnFiber;
              return created;
            } else {
              // Update
              var existing = useFiber(current, textContent);
              existing.return = returnFiber;
              return existing;
            }
          }

          function updateElement(returnFiber, current, element, lanes) {
            if (current !== null) {
              if (current.elementType === element.type || // Keep this check inline so it only runs on the false path:
              isCompatibleFamilyForHotReloading(current, element)) {
                // Move based on index
                var existing = useFiber(current, element.props);
                existing.ref = coerceRef(returnFiber, current, element);
                existing.return = returnFiber;
                {
                  existing._debugSource = element._source;
                  existing._debugOwner = element._owner;
                }
                return existing;
              }
            } // Insert


            var created = createFiberFromElement(element, returnFiber.mode, lanes);
            created.ref = coerceRef(returnFiber, current, element);
            created.return = returnFiber;
            return created;
          }

          function updatePortal(returnFiber, current, portal, lanes) {
            if (current === null || current.tag !== HostPortal || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) {
              // Insert
              var created = createFiberFromPortal(portal, returnFiber.mode, lanes);
              created.return = returnFiber;
              return created;
            } else {
              // Update
              var existing = useFiber(current, portal.children || []);
              existing.return = returnFiber;
              return existing;
            }
          }

          function updateFragment(returnFiber, current, fragment, lanes, key) {
            if (current === null || current.tag !== Fragment) {
              // Insert
              var created = createFiberFromFragment(fragment, returnFiber.mode, lanes, key);
              created.return = returnFiber;
              return created;
            } else {
              // Update
              var existing = useFiber(current, fragment);
              existing.return = returnFiber;
              return existing;
            }
          }

          function createChild(returnFiber, newChild, lanes) {
            if (typeof newChild === 'string' || typeof newChild === 'number') {
              // Text nodes don't have keys. If the previous node is implicitly keyed
              // we can continue to replace it without aborting even if it is not a text
              // node.
              var created = createFiberFromText('' + newChild, returnFiber.mode, lanes);
              created.return = returnFiber;
              return created;
            }

            if (typeof newChild === 'object' && newChild !== null) {
              switch (newChild.$$typeof) {
                case REACT_ELEMENT_TYPE:
                  {
                    var _created = createFiberFromElement(newChild, returnFiber.mode, lanes);

                    _created.ref = coerceRef(returnFiber, null, newChild);
                    _created.return = returnFiber;
                    return _created;
                  }

                case REACT_PORTAL_TYPE:
                  {
                    var _created2 = createFiberFromPortal(newChild, returnFiber.mode, lanes);

                    _created2.return = returnFiber;
                    return _created2;
                  }
              }

              if (isArray$1(newChild) || getIteratorFn(newChild)) {
                var _created3 = createFiberFromFragment(newChild, returnFiber.mode, lanes, null);

                _created3.return = returnFiber;
                return _created3;
              }

              throwOnInvalidObjectType(returnFiber, newChild);
            }

            {
              if (typeof newChild === 'function') {
                warnOnFunctionType(returnFiber);
              }
            }
            return null;
          }

          function updateSlot(returnFiber, oldFiber, newChild, lanes) {
            // Update the fiber if the keys match, otherwise return null.
            var key = oldFiber !== null ? oldFiber.key : null;

            if (typeof newChild === 'string' || typeof newChild === 'number') {
              // Text nodes don't have keys. If the previous node is implicitly keyed
              // we can continue to replace it without aborting even if it is not a text
              // node.
              if (key !== null) {
                return null;
              }

              return updateTextNode(returnFiber, oldFiber, '' + newChild, lanes);
            }

            if (typeof newChild === 'object' && newChild !== null) {
              switch (newChild.$$typeof) {
                case REACT_ELEMENT_TYPE:
                  {
                    if (newChild.key === key) {
                      if (newChild.type === REACT_FRAGMENT_TYPE) {
                        return updateFragment(returnFiber, oldFiber, newChild.props.children, lanes, key);
                      }

                      return updateElement(returnFiber, oldFiber, newChild, lanes);
                    } else {
                      return null;
                    }
                  }

                case REACT_PORTAL_TYPE:
                  {
                    if (newChild.key === key) {
                      return updatePortal(returnFiber, oldFiber, newChild, lanes);
                    } else {
                      return null;
                    }
                  }
              }

              if (isArray$1(newChild) || getIteratorFn(newChild)) {
                if (key !== null) {
                  return null;
                }

                return updateFragment(returnFiber, oldFiber, newChild, lanes, null);
              }

              throwOnInvalidObjectType(returnFiber, newChild);
            }

            {
              if (typeof newChild === 'function') {
                warnOnFunctionType(returnFiber);
              }
            }
            return null;
          }

          function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
            if (typeof newChild === 'string' || typeof newChild === 'number') {
              // Text nodes don't have keys, so we neither have to check the old nor
              // new node for the key. If both are text nodes, they match.
              var matchedFiber = existingChildren.get(newIdx) || null;
              return updateTextNode(returnFiber, matchedFiber, '' + newChild, lanes);
            }

            if (typeof newChild === 'object' && newChild !== null) {
              switch (newChild.$$typeof) {
                case REACT_ELEMENT_TYPE:
                  {
                    var _matchedFiber = existingChildren.get(newChild.key === null ? newIdx : newChild.key) || null;

                    if (newChild.type === REACT_FRAGMENT_TYPE) {
                      return updateFragment(returnFiber, _matchedFiber, newChild.props.children, lanes, newChild.key);
                    }

                    return updateElement(returnFiber, _matchedFiber, newChild, lanes);
                  }

                case REACT_PORTAL_TYPE:
                  {
                    var _matchedFiber2 = existingChildren.get(newChild.key === null ? newIdx : newChild.key) || null;

                    return updatePortal(returnFiber, _matchedFiber2, newChild, lanes);
                  }
              }

              if (isArray$1(newChild) || getIteratorFn(newChild)) {
                var _matchedFiber3 = existingChildren.get(newIdx) || null;

                return updateFragment(returnFiber, _matchedFiber3, newChild, lanes, null);
              }

              throwOnInvalidObjectType(returnFiber, newChild);
            }

            {
              if (typeof newChild === 'function') {
                warnOnFunctionType(returnFiber);
              }
            }
            return null;
          }
          /**
           * Warns if there is a duplicate or missing key
           */


          function warnOnInvalidKey(child, knownKeys, returnFiber) {
            {
              if (typeof child !== 'object' || child === null) {
                return knownKeys;
              }

              switch (child.$$typeof) {
                case REACT_ELEMENT_TYPE:
                case REACT_PORTAL_TYPE:
                  warnForMissingKey(child, returnFiber);
                  var key = child.key;

                  if (typeof key !== 'string') {
                    break;
                  }

                  if (knownKeys === null) {
                    knownKeys = new Set();
                    knownKeys.add(key);
                    break;
                  }

                  if (!knownKeys.has(key)) {
                    knownKeys.add(key);
                    break;
                  }

                  error('Encountered two children with the same key, `%s`. ' + 'Keys should be unique so that components maintain their identity ' + 'across updates. Non-unique keys may cause children to be ' + 'duplicated and/or omitted — the behavior is unsupported and ' + 'could change in a future version.', key);
                  break;
              }
            }
            return knownKeys;
          }

          function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
            // This algorithm can't optimize by searching from both ends since we
            // don't have backpointers on fibers. I'm trying to see how far we can get
            // with that model. If it ends up not being worth the tradeoffs, we can
            // add it later.
            // Even with a two ended optimization, we'd want to optimize for the case
            // where there are few changes and brute force the comparison instead of
            // going for the Map. It'd like to explore hitting that path first in
            // forward-only mode and only go for the Map once we notice that we need
            // lots of look ahead. This doesn't handle reversal as well as two ended
            // search but that's unusual. Besides, for the two ended optimization to
            // work on Iterables, we'd need to copy the whole set.
            // In this first iteration, we'll just live with hitting the bad case
            // (adding everything to a Map) in for every insert/move.
            // If you change this code, also update reconcileChildrenIterator() which
            // uses the same algorithm.
            {
              // First, validate keys.
              var knownKeys = null;

              for (var i = 0; i < newChildren.length; i++) {
                var child = newChildren[i];
                knownKeys = warnOnInvalidKey(child, knownKeys, returnFiber);
              }
            }
            var resultingFirstChild = null;
            var previousNewFiber = null;
            var oldFiber = currentFirstChild;
            var lastPlacedIndex = 0;
            var newIdx = 0;
            var nextOldFiber = null;

            for (; oldFiber !== null && newIdx < newChildren.length; newIdx++) {
              if (oldFiber.index > newIdx) {
                nextOldFiber = oldFiber;
                oldFiber = null;
              } else {
                nextOldFiber = oldFiber.sibling;
              }

              var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);

              if (newFiber === null) {
                // TODO: This breaks on empty slots like null children. That's
                // unfortunate because it triggers the slow path all the time. We need
                // a better way to communicate whether this was a miss or null,
                // boolean, undefined, etc.
                if (oldFiber === null) {
                  oldFiber = nextOldFiber;
                }

                break;
              }

              if (shouldTrackSideEffects) {
                if (oldFiber && newFiber.alternate === null) {
                  // We matched the slot, but we didn't reuse the existing fiber, so we
                  // need to delete the existing child.
                  deleteChild(returnFiber, oldFiber);
                }
              }

              lastPlacedIndex = placeChild(newFiber, lastPlacedIndex, newIdx);

              if (previousNewFiber === null) {
                // TODO: Move out of the loop. This only happens for the first run.
                resultingFirstChild = newFiber;
              } else {
                // TODO: Defer siblings if we're not at the right index for this slot.
                // I.e. if we had null values before, then we want to defer this
                // for each null value. However, we also don't want to call updateSlot
                // with the previous one.
                previousNewFiber.sibling = newFiber;
              }

              previousNewFiber = newFiber;
              oldFiber = nextOldFiber;
            }

            if (newIdx === newChildren.length) {
              // We've reached the end of the new children. We can delete the rest.
              deleteRemainingChildren(returnFiber, oldFiber);
              return resultingFirstChild;
            }

            if (oldFiber === null) {
              // If we don't have any more existing children we can choose a fast path
              // since the rest will all be insertions.
              for (; newIdx < newChildren.length; newIdx++) {
                var _newFiber = createChild(returnFiber, newChildren[newIdx], lanes);

                if (_newFiber === null) {
                  continue;
                }

                lastPlacedIndex = placeChild(_newFiber, lastPlacedIndex, newIdx);

                if (previousNewFiber === null) {
                  // TODO: Move out of the loop. This only happens for the first run.
                  resultingFirstChild = _newFiber;
                } else {
                  previousNewFiber.sibling = _newFiber;
                }

                previousNewFiber = _newFiber;
              }

              return resultingFirstChild;
            } // Add all children to a key map for quick lookups.


            var existingChildren = mapRemainingChildren(returnFiber, oldFiber); // Keep scanning and use the map to restore deleted items as moves.

            for (; newIdx < newChildren.length; newIdx++) {
              var _newFiber2 = updateFromMap(existingChildren, returnFiber, newIdx, newChildren[newIdx], lanes);

              if (_newFiber2 !== null) {
                if (shouldTrackSideEffects) {
                  if (_newFiber2.alternate !== null) {
                    // The new fiber is a work in progress, but if there exists a
                    // current, that means that we reused the fiber. We need to delete
                    // it from the child list so that we don't add it to the deletion
                    // list.
                    existingChildren.delete(_newFiber2.key === null ? newIdx : _newFiber2.key);
                  }
                }

                lastPlacedIndex = placeChild(_newFiber2, lastPlacedIndex, newIdx);

                if (previousNewFiber === null) {
                  resultingFirstChild = _newFiber2;
                } else {
                  previousNewFiber.sibling = _newFiber2;
                }

                previousNewFiber = _newFiber2;
              }
            }

            if (shouldTrackSideEffects) {
              // Any existing children that weren't consumed above were deleted. We need
              // to add them to the deletion list.
              existingChildren.forEach(function (child) {
                return deleteChild(returnFiber, child);
              });
            }

            return resultingFirstChild;
          }

          function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildrenIterable, lanes) {
            // This is the same implementation as reconcileChildrenArray(),
            // but using the iterator instead.
            var iteratorFn = getIteratorFn(newChildrenIterable);

            if (!(typeof iteratorFn === 'function')) {
              {
                throw Error("An object is not an iterable. This error is likely caused by a bug in React. Please file an issue.");
              }
            }

            {
              // We don't support rendering Generators because it's a mutation.
              // See https://github.com/facebook/react/issues/12995
              if (typeof Symbol === 'function' && // $FlowFixMe Flow doesn't know about toStringTag
              newChildrenIterable[Symbol.toStringTag] === 'Generator') {
                if (!didWarnAboutGenerators) {
                  error('Using Generators as children is unsupported and will likely yield ' + 'unexpected results because enumerating a generator mutates it. ' + 'You may convert it to an array with `Array.from()` or the ' + '`[...spread]` operator before rendering. Keep in mind ' + 'you might need to polyfill these features for older browsers.');
                }

                didWarnAboutGenerators = true;
              } // Warn about using Maps as children


              if (newChildrenIterable.entries === iteratorFn) {
                if (!didWarnAboutMaps) {
                  error('Using Maps as children is not supported. ' + 'Use an array of keyed ReactElements instead.');
                }

                didWarnAboutMaps = true;
              } // First, validate keys.
              // We'll get a different iterator later for the main pass.


              var _newChildren = iteratorFn.call(newChildrenIterable);

              if (_newChildren) {
                var knownKeys = null;

                var _step = _newChildren.next();

                for (; !_step.done; _step = _newChildren.next()) {
                  var child = _step.value;
                  knownKeys = warnOnInvalidKey(child, knownKeys, returnFiber);
                }
              }
            }
            var newChildren = iteratorFn.call(newChildrenIterable);

            if (!(newChildren != null)) {
              {
                throw Error("An iterable object provided no iterator.");
              }
            }

            var resultingFirstChild = null;
            var previousNewFiber = null;
            var oldFiber = currentFirstChild;
            var lastPlacedIndex = 0;
            var newIdx = 0;
            var nextOldFiber = null;
            var step = newChildren.next();

            for (; oldFiber !== null && !step.done; newIdx++, step = newChildren.next()) {
              if (oldFiber.index > newIdx) {
                nextOldFiber = oldFiber;
                oldFiber = null;
              } else {
                nextOldFiber = oldFiber.sibling;
              }

              var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);

              if (newFiber === null) {
                // TODO: This breaks on empty slots like null children. That's
                // unfortunate because it triggers the slow path all the time. We need
                // a better way to communicate whether this was a miss or null,
                // boolean, undefined, etc.
                if (oldFiber === null) {
                  oldFiber = nextOldFiber;
                }

                break;
              }

              if (shouldTrackSideEffects) {
                if (oldFiber && newFiber.alternate === null) {
                  // We matched the slot, but we didn't reuse the existing fiber, so we
                  // need to delete the existing child.
                  deleteChild(returnFiber, oldFiber);
                }
              }

              lastPlacedIndex = placeChild(newFiber, lastPlacedIndex, newIdx);

              if (previousNewFiber === null) {
                // TODO: Move out of the loop. This only happens for the first run.
                resultingFirstChild = newFiber;
              } else {
                // TODO: Defer siblings if we're not at the right index for this slot.
                // I.e. if we had null values before, then we want to defer this
                // for each null value. However, we also don't want to call updateSlot
                // with the previous one.
                previousNewFiber.sibling = newFiber;
              }

              previousNewFiber = newFiber;
              oldFiber = nextOldFiber;
            }

            if (step.done) {
              // We've reached the end of the new children. We can delete the rest.
              deleteRemainingChildren(returnFiber, oldFiber);
              return resultingFirstChild;
            }

            if (oldFiber === null) {
              // If we don't have any more existing children we can choose a fast path
              // since the rest will all be insertions.
              for (; !step.done; newIdx++, step = newChildren.next()) {
                var _newFiber3 = createChild(returnFiber, step.value, lanes);

                if (_newFiber3 === null) {
                  continue;
                }

                lastPlacedIndex = placeChild(_newFiber3, lastPlacedIndex, newIdx);

                if (previousNewFiber === null) {
                  // TODO: Move out of the loop. This only happens for the first run.
                  resultingFirstChild = _newFiber3;
                } else {
                  previousNewFiber.sibling = _newFiber3;
                }

                previousNewFiber = _newFiber3;
              }

              return resultingFirstChild;
            } // Add all children to a key map for quick lookups.


            var existingChildren = mapRemainingChildren(returnFiber, oldFiber); // Keep scanning and use the map to restore deleted items as moves.

            for (; !step.done; newIdx++, step = newChildren.next()) {
              var _newFiber4 = updateFromMap(existingChildren, returnFiber, newIdx, step.value, lanes);

              if (_newFiber4 !== null) {
                if (shouldTrackSideEffects) {
                  if (_newFiber4.alternate !== null) {
                    // The new fiber is a work in progress, but if there exists a
                    // current, that means that we reused the fiber. We need to delete
                    // it from the child list so that we don't add it to the deletion
                    // list.
                    existingChildren.delete(_newFiber4.key === null ? newIdx : _newFiber4.key);
                  }
                }

                lastPlacedIndex = placeChild(_newFiber4, lastPlacedIndex, newIdx);

                if (previousNewFiber === null) {
                  resultingFirstChild = _newFiber4;
                } else {
                  previousNewFiber.sibling = _newFiber4;
                }

                previousNewFiber = _newFiber4;
              }
            }

            if (shouldTrackSideEffects) {
              // Any existing children that weren't consumed above were deleted. We need
              // to add them to the deletion list.
              existingChildren.forEach(function (child) {
                return deleteChild(returnFiber, child);
              });
            }

            return resultingFirstChild;
          }

          function reconcileSingleTextNode(returnFiber, currentFirstChild, textContent, lanes) {
            // There's no need to check for keys on text nodes since we don't have a
            // way to define them.
            if (currentFirstChild !== null && currentFirstChild.tag === HostText) {
              // We already have an existing node so let's just update it and delete
              // the rest.
              deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
              var existing = useFiber(currentFirstChild, textContent);
              existing.return = returnFiber;
              return existing;
            } // The existing first child is not a text node so we need to create one
            // and delete the existing ones.


            deleteRemainingChildren(returnFiber, currentFirstChild);
            var created = createFiberFromText(textContent, returnFiber.mode, lanes);
            created.return = returnFiber;
            return created;
          }

          function reconcileSingleElement(returnFiber, currentFirstChild, element, lanes) {
            var key = element.key;
            var child = currentFirstChild;

            while (child !== null) {
              // TODO: If key === null and child.key === null, then this only applies to
              // the first item in the list.
              if (child.key === key) {
                switch (child.tag) {
                  case Fragment:
                    {
                      if (element.type === REACT_FRAGMENT_TYPE) {
                        deleteRemainingChildren(returnFiber, child.sibling);
                        var existing = useFiber(child, element.props.children);
                        existing.return = returnFiber;
                        {
                          existing._debugSource = element._source;
                          existing._debugOwner = element._owner;
                        }
                        return existing;
                      }

                      break;
                    }

                  case Block: // We intentionally fallthrough here if enableBlocksAPI is not on.
                  // eslint-disable-next-lined no-fallthrough

                  default:
                    {
                      if (child.elementType === element.type || // Keep this check inline so it only runs on the false path:
                      isCompatibleFamilyForHotReloading(child, element)) {
                        deleteRemainingChildren(returnFiber, child.sibling);

                        var _existing3 = useFiber(child, element.props);

                        _existing3.ref = coerceRef(returnFiber, child, element);
                        _existing3.return = returnFiber;
                        {
                          _existing3._debugSource = element._source;
                          _existing3._debugOwner = element._owner;
                        }
                        return _existing3;
                      }

                      break;
                    }
                } // Didn't match.


                deleteRemainingChildren(returnFiber, child);
                break;
              } else {
                deleteChild(returnFiber, child);
              }

              child = child.sibling;
            }

            if (element.type === REACT_FRAGMENT_TYPE) {
              var created = createFiberFromFragment(element.props.children, returnFiber.mode, lanes, element.key);
              created.return = returnFiber;
              return created;
            } else {
              var _created4 = createFiberFromElement(element, returnFiber.mode, lanes);

              _created4.ref = coerceRef(returnFiber, currentFirstChild, element);
              _created4.return = returnFiber;
              return _created4;
            }
          }

          function reconcileSinglePortal(returnFiber, currentFirstChild, portal, lanes) {
            var key = portal.key;
            var child = currentFirstChild;

            while (child !== null) {
              // TODO: If key === null and child.key === null, then this only applies to
              // the first item in the list.
              if (child.key === key) {
                if (child.tag === HostPortal && child.stateNode.containerInfo === portal.containerInfo && child.stateNode.implementation === portal.implementation) {
                  deleteRemainingChildren(returnFiber, child.sibling);
                  var existing = useFiber(child, portal.children || []);
                  existing.return = returnFiber;
                  return existing;
                } else {
                  deleteRemainingChildren(returnFiber, child);
                  break;
                }
              } else {
                deleteChild(returnFiber, child);
              }

              child = child.sibling;
            }

            var created = createFiberFromPortal(portal, returnFiber.mode, lanes);
            created.return = returnFiber;
            return created;
          } // This API will tag the children with the side-effect of the reconciliation
          // itself. They will be added to the side-effect list as we pass through the
          // children and the parent.


          function reconcileChildFibers(returnFiber, currentFirstChild, newChild, lanes) {
            // This function is not recursive.
            // If the top level item is an array, we treat it as a set of children,
            // not as a fragment. Nested arrays on the other hand will be treated as
            // fragment nodes. Recursion happens at the normal flow.
            // Handle top level unkeyed fragments as if they were arrays.
            // This leads to an ambiguity between <>{[...]}</> and <>...</>.
            // We treat the ambiguous cases above the same.
            var isUnkeyedTopLevelFragment = typeof newChild === 'object' && newChild !== null && newChild.type === REACT_FRAGMENT_TYPE && newChild.key === null;

            if (isUnkeyedTopLevelFragment) {
              newChild = newChild.props.children;
            } // Handle object types


            var isObject = typeof newChild === 'object' && newChild !== null;

            if (isObject) {
              switch (newChild.$$typeof) {
                case REACT_ELEMENT_TYPE:
                  return placeSingleChild(reconcileSingleElement(returnFiber, currentFirstChild, newChild, lanes));

                case REACT_PORTAL_TYPE:
                  return placeSingleChild(reconcileSinglePortal(returnFiber, currentFirstChild, newChild, lanes));
              }
            }

            if (typeof newChild === 'string' || typeof newChild === 'number') {
              return placeSingleChild(reconcileSingleTextNode(returnFiber, currentFirstChild, '' + newChild, lanes));
            }

            if (isArray$1(newChild)) {
              return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            }

            if (getIteratorFn(newChild)) {
              return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }

            if (isObject) {
              throwOnInvalidObjectType(returnFiber, newChild);
            }

            {
              if (typeof newChild === 'function') {
                warnOnFunctionType(returnFiber);
              }
            }

            if (typeof newChild === 'undefined' && !isUnkeyedTopLevelFragment) {
              // If the new child is undefined, and the return fiber is a composite
              // component, throw an error. If Fiber return types are disabled,
              // we already threw above.
              switch (returnFiber.tag) {
                case ClassComponent:
                  {
                    {
                      var instance = returnFiber.stateNode;

                      if (instance.render._isMockFunction) {
                        // We allow auto-mocks to proceed as if they're returning null.
                        break;
                      }
                    }
                  }
                // Intentionally fall through to the next case, which handles both
                // functions and classes
                // eslint-disable-next-lined no-fallthrough

                case Block:
                case FunctionComponent:
                case ForwardRef:
                case SimpleMemoComponent:
                  {
                    {
                      {
                        throw Error((getComponentName(returnFiber.type) || 'Component') + "(...): Nothing was returned from render. This usually means a return statement is missing. Or, to render nothing, return null.");
                      }
                    }
                  }
              }
            } // Remaining cases are all treated as empty.


            return deleteRemainingChildren(returnFiber, currentFirstChild);
          }

          return reconcileChildFibers;
        }

        var reconcileChildFibers = ChildReconciler(true);
        var mountChildFibers = ChildReconciler(false);

        function cloneChildFibers(current, workInProgress) {
          if (!(current === null || workInProgress.child === current.child)) {
            {
              throw Error("Resuming work not yet implemented.");
            }
          }

          if (workInProgress.child === null) {
            return;
          }

          var currentChild = workInProgress.child;
          var newChild = createWorkInProgress(currentChild, currentChild.pendingProps);
          workInProgress.child = newChild;
          newChild.return = workInProgress;

          while (currentChild.sibling !== null) {
            currentChild = currentChild.sibling;
            newChild = newChild.sibling = createWorkInProgress(currentChild, currentChild.pendingProps);
            newChild.return = workInProgress;
          }

          newChild.sibling = null;
        } // Reset a workInProgress child set to prepare it for a second pass.


        function resetChildFibers(workInProgress, lanes) {
          var child = workInProgress.child;

          while (child !== null) {
            resetWorkInProgress(child, lanes);
            child = child.sibling;
          }
        }

        var NO_CONTEXT = {};
        var contextStackCursor$1 = createCursor(NO_CONTEXT);
        var contextFiberStackCursor = createCursor(NO_CONTEXT);
        var rootInstanceStackCursor = createCursor(NO_CONTEXT);

        function requiredContext(c) {
          if (!(c !== NO_CONTEXT)) {
            {
              throw Error("Expected host context to exist. This error is likely caused by a bug in React. Please file an issue.");
            }
          }

          return c;
        }

        function getRootHostContainer() {
          var rootInstance = requiredContext(rootInstanceStackCursor.current);
          return rootInstance;
        }

        function pushHostContainer(fiber, nextRootInstance) {
          // Push current root instance onto the stack;
          // This allows us to reset root when portals are popped.
          push(rootInstanceStackCursor, nextRootInstance, fiber); // Track the context and the Fiber that provided it.
          // This enables us to pop only Fibers that provide unique contexts.

          push(contextFiberStackCursor, fiber, fiber); // Finally, we need to push the host context to the stack.
          // However, we can't just call getRootHostContext() and push it because
          // we'd have a different number of entries on the stack depending on
          // whether getRootHostContext() throws somewhere in renderer code or not.
          // So we push an empty value first. This lets us safely unwind on errors.

          push(contextStackCursor$1, NO_CONTEXT, fiber);
          var nextRootContext = getRootHostContext(nextRootInstance); // Now that we know this function doesn't throw, replace it.

          pop(contextStackCursor$1, fiber);
          push(contextStackCursor$1, nextRootContext, fiber);
        }

        function popHostContainer(fiber) {
          pop(contextStackCursor$1, fiber);
          pop(contextFiberStackCursor, fiber);
          pop(rootInstanceStackCursor, fiber);
        }

        function getHostContext() {
          var context = requiredContext(contextStackCursor$1.current);
          return context;
        }

        function pushHostContext(fiber) {
          var rootInstance = requiredContext(rootInstanceStackCursor.current);
          var context = requiredContext(contextStackCursor$1.current);
          var nextContext = getChildHostContext(context, fiber.type); // Don't push this Fiber's context unless it's unique.

          if (context === nextContext) {
            return;
          } // Track the context and the Fiber that provided it.
          // This enables us to pop only Fibers that provide unique contexts.


          push(contextFiberStackCursor, fiber, fiber);
          push(contextStackCursor$1, nextContext, fiber);
        }

        function popHostContext(fiber) {
          // Do not pop unless this Fiber provided the current context.
          // pushHostContext() only pushes Fibers that provide unique contexts.
          if (contextFiberStackCursor.current !== fiber) {
            return;
          }

          pop(contextStackCursor$1, fiber);
          pop(contextFiberStackCursor, fiber);
        }

        var DefaultSuspenseContext = 0; // The Suspense Context is split into two parts. The lower bits is
        // inherited deeply down the subtree. The upper bits only affect
        // this immediate suspense boundary and gets reset each new
        // boundary or suspense list.

        var SubtreeSuspenseContextMask = 1; // Subtree Flags:
        // InvisibleParentSuspenseContext indicates that one of our parent Suspense
        // boundaries is not currently showing visible main content.
        // Either because it is already showing a fallback or is not mounted at all.
        // We can use this to determine if it is desirable to trigger a fallback at
        // the parent. If not, then we might need to trigger undesirable boundaries
        // and/or suspend the commit to avoid hiding the parent content.

        var InvisibleParentSuspenseContext = 1; // Shallow Flags:
        // ForceSuspenseFallback can be used by SuspenseList to force newly added
        // items into their fallback state during one of the render passes.

        var ForceSuspenseFallback = 2;
        var suspenseStackCursor = createCursor(DefaultSuspenseContext);

        function hasSuspenseContext(parentContext, flag) {
          return (parentContext & flag) !== 0;
        }

        function setDefaultShallowSuspenseContext(parentContext) {
          return parentContext & SubtreeSuspenseContextMask;
        }

        function setShallowSuspenseContext(parentContext, shallowContext) {
          return parentContext & SubtreeSuspenseContextMask | shallowContext;
        }

        function addSubtreeSuspenseContext(parentContext, subtreeContext) {
          return parentContext | subtreeContext;
        }

        function pushSuspenseContext(fiber, newContext) {
          push(suspenseStackCursor, newContext, fiber);
        }

        function popSuspenseContext(fiber) {
          pop(suspenseStackCursor, fiber);
        }

        function shouldCaptureSuspense(workInProgress, hasInvisibleParent) {
          // If it was the primary children that just suspended, capture and render the
          // fallback. Otherwise, don't capture and bubble to the next boundary.
          var nextState = workInProgress.memoizedState;

          if (nextState !== null) {
            if (nextState.dehydrated !== null) {
              // A dehydrated boundary always captures.
              return true;
            }

            return false;
          }

          var props = workInProgress.memoizedProps; // In order to capture, the Suspense component must have a fallback prop.

          if (props.fallback === undefined) {
            return false;
          } // Regular boundaries always capture.


          if (props.unstable_avoidThisFallback !== true) {
            return true;
          } // If it's a boundary we should avoid, then we prefer to bubble up to the
          // parent boundary if it is currently invisible.


          if (hasInvisibleParent) {
            return false;
          } // If the parent is not able to handle it, we must handle it.


          return true;
        }

        function findFirstSuspended(row) {
          var node = row;

          while (node !== null) {
            if (node.tag === SuspenseComponent) {
              var state = node.memoizedState;

              if (state !== null) {
                var dehydrated = state.dehydrated;

                if (dehydrated === null || isSuspenseInstancePending(dehydrated) || isSuspenseInstanceFallback(dehydrated)) {
                  return node;
                }
              }
            } else if (node.tag === SuspenseListComponent && // revealOrder undefined can't be trusted because it don't
            // keep track of whether it suspended or not.
            node.memoizedProps.revealOrder !== undefined) {
              var didSuspend = (node.flags & DidCapture) !== NoFlags;

              if (didSuspend) {
                return node;
              }
            } else if (node.child !== null) {
              node.child.return = node;
              node = node.child;
              continue;
            }

            if (node === row) {
              return null;
            }

            while (node.sibling === null) {
              if (node.return === null || node.return === row) {
                return null;
              }

              node = node.return;
            }

            node.sibling.return = node.return;
            node = node.sibling;
          }

          return null;
        }

        var NoFlags$1 =
        /*  */
        0; // Represents whether effect should fire.

        var HasEffect =
        /* */
        1; // Represents the phase in which the effect (not the clean-up) fires.

        var Layout =
        /*    */
        2;
        var Passive$1 =
        /*   */
        4; // This may have been an insertion or a hydration.

        var hydrationParentFiber = null;
        var nextHydratableInstance = null;
        var isHydrating = false;

        function enterHydrationState(fiber) {
          var parentInstance = fiber.stateNode.containerInfo;
          nextHydratableInstance = getFirstHydratableChild(parentInstance);
          hydrationParentFiber = fiber;
          isHydrating = true;
          return true;
        }

        function deleteHydratableInstance(returnFiber, instance) {
          {
            switch (returnFiber.tag) {
              case HostRoot:
                didNotHydrateContainerInstance(returnFiber.stateNode.containerInfo, instance);
                break;

              case HostComponent:
                didNotHydrateInstance(returnFiber.type, returnFiber.memoizedProps, returnFiber.stateNode, instance);
                break;
            }
          }
          var childToDelete = createFiberFromHostInstanceForDeletion();
          childToDelete.stateNode = instance;
          childToDelete.return = returnFiber;
          childToDelete.flags = Deletion; // This might seem like it belongs on progressedFirstDeletion. However,
          // these children are not part of the reconciliation list of children.
          // Even if we abort and rereconcile the children, that will try to hydrate
          // again and the nodes are still in the host tree so these will be
          // recreated.

          if (returnFiber.lastEffect !== null) {
            returnFiber.lastEffect.nextEffect = childToDelete;
            returnFiber.lastEffect = childToDelete;
          } else {
            returnFiber.firstEffect = returnFiber.lastEffect = childToDelete;
          }
        }

        function insertNonHydratedInstance(returnFiber, fiber) {
          fiber.flags = fiber.flags & ~Hydrating | Placement;
          {
            switch (returnFiber.tag) {
              case HostRoot:
                {
                  var parentContainer = returnFiber.stateNode.containerInfo;

                  switch (fiber.tag) {
                    case HostComponent:
                      var type = fiber.type;
                      var props = fiber.pendingProps;
                      didNotFindHydratableContainerInstance(parentContainer, type);
                      break;

                    case HostText:
                      var text = fiber.pendingProps;
                      didNotFindHydratableContainerTextInstance(parentContainer, text);
                      break;
                  }

                  break;
                }

              case HostComponent:
                {
                  var parentType = returnFiber.type;
                  var parentProps = returnFiber.memoizedProps;
                  var parentInstance = returnFiber.stateNode;

                  switch (fiber.tag) {
                    case HostComponent:
                      var _type = fiber.type;
                      var _props = fiber.pendingProps;
                      didNotFindHydratableInstance(parentType, parentProps, parentInstance, _type);
                      break;

                    case HostText:
                      var _text = fiber.pendingProps;
                      didNotFindHydratableTextInstance(parentType, parentProps, parentInstance, _text);
                      break;

                    case SuspenseComponent:
                      didNotFindHydratableSuspenseInstance(parentType, parentProps);
                      break;
                  }

                  break;
                }

              default:
                return;
            }
          }
        }

        function tryHydrate(fiber, nextInstance) {
          switch (fiber.tag) {
            case HostComponent:
              {
                var type = fiber.type;
                var props = fiber.pendingProps;
                var instance = canHydrateInstance(nextInstance, type);

                if (instance !== null) {
                  fiber.stateNode = instance;
                  return true;
                }

                return false;
              }

            case HostText:
              {
                var text = fiber.pendingProps;
                var textInstance = canHydrateTextInstance(nextInstance, text);

                if (textInstance !== null) {
                  fiber.stateNode = textInstance;
                  return true;
                }

                return false;
              }

            case SuspenseComponent:
              {
                return false;
              }

            default:
              return false;
          }
        }

        function tryToClaimNextHydratableInstance(fiber) {
          if (!isHydrating) {
            return;
          }

          var nextInstance = nextHydratableInstance;

          if (!nextInstance) {
            // Nothing to hydrate. Make it an insertion.
            insertNonHydratedInstance(hydrationParentFiber, fiber);
            isHydrating = false;
            hydrationParentFiber = fiber;
            return;
          }

          var firstAttemptedInstance = nextInstance;

          if (!tryHydrate(fiber, nextInstance)) {
            // If we can't hydrate this instance let's try the next one.
            // We use this as a heuristic. It's based on intuition and not data so it
            // might be flawed or unnecessary.
            nextInstance = getNextHydratableSibling(firstAttemptedInstance);

            if (!nextInstance || !tryHydrate(fiber, nextInstance)) {
              // Nothing to hydrate. Make it an insertion.
              insertNonHydratedInstance(hydrationParentFiber, fiber);
              isHydrating = false;
              hydrationParentFiber = fiber;
              return;
            } // We matched the next one, we'll now assume that the first one was
            // superfluous and we'll delete it. Since we can't eagerly delete it
            // we'll have to schedule a deletion. To do that, this node needs a dummy
            // fiber associated with it.


            deleteHydratableInstance(hydrationParentFiber, firstAttemptedInstance);
          }

          hydrationParentFiber = fiber;
          nextHydratableInstance = getFirstHydratableChild(nextInstance);
        }

        function prepareToHydrateHostInstance(fiber, rootContainerInstance, hostContext) {
          var instance = fiber.stateNode;
          var updatePayload = hydrateInstance(instance, fiber.type, fiber.memoizedProps, rootContainerInstance, hostContext, fiber); // TODO: Type this specific to this type of component.

          fiber.updateQueue = updatePayload; // If the update payload indicates that there is a change or if there
          // is a new ref we mark this as an update.

          if (updatePayload !== null) {
            return true;
          }

          return false;
        }

        function prepareToHydrateHostTextInstance(fiber) {
          var textInstance = fiber.stateNode;
          var textContent = fiber.memoizedProps;
          var shouldUpdate = hydrateTextInstance(textInstance, textContent, fiber);
          {
            if (shouldUpdate) {
              // We assume that prepareToHydrateHostTextInstance is called in a context where the
              // hydration parent is the parent host component of this host text.
              var returnFiber = hydrationParentFiber;

              if (returnFiber !== null) {
                switch (returnFiber.tag) {
                  case HostRoot:
                    {
                      var parentContainer = returnFiber.stateNode.containerInfo;
                      didNotMatchHydratedContainerTextInstance(parentContainer, textInstance, textContent);
                      break;
                    }

                  case HostComponent:
                    {
                      var parentType = returnFiber.type;
                      var parentProps = returnFiber.memoizedProps;
                      var parentInstance = returnFiber.stateNode;
                      didNotMatchHydratedTextInstance(parentType, parentProps, parentInstance, textInstance, textContent);
                      break;
                    }
                }
              }
            }
          }
          return shouldUpdate;
        }

        function skipPastDehydratedSuspenseInstance(fiber) {
          var suspenseState = fiber.memoizedState;
          var suspenseInstance = suspenseState !== null ? suspenseState.dehydrated : null;

          if (!suspenseInstance) {
            {
              throw Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
            }
          }

          return getNextHydratableInstanceAfterSuspenseInstance(suspenseInstance);
        }

        function popToNextHostParent(fiber) {
          var parent = fiber.return;

          while (parent !== null && parent.tag !== HostComponent && parent.tag !== HostRoot && parent.tag !== SuspenseComponent) {
            parent = parent.return;
          }

          hydrationParentFiber = parent;
        }

        function popHydrationState(fiber) {
          if (fiber !== hydrationParentFiber) {
            // We're deeper than the current hydration context, inside an inserted
            // tree.
            return false;
          }

          if (!isHydrating) {
            // If we're not currently hydrating but we're in a hydration context, then
            // we were an insertion and now need to pop up reenter hydration of our
            // siblings.
            popToNextHostParent(fiber);
            isHydrating = true;
            return false;
          }

          var type = fiber.type; // If we have any remaining hydratable nodes, we need to delete them now.
          // We only do this deeper than head and body since they tend to have random
          // other nodes in them. We also ignore components with pure text content in
          // side of them.
          // TODO: Better heuristic.

          if (fiber.tag !== HostComponent || type !== 'head' && type !== 'body' && !shouldSetTextContent(type, fiber.memoizedProps)) {
            var nextInstance = nextHydratableInstance;

            while (nextInstance) {
              deleteHydratableInstance(fiber, nextInstance);
              nextInstance = getNextHydratableSibling(nextInstance);
            }
          }

          popToNextHostParent(fiber);

          if (fiber.tag === SuspenseComponent) {
            nextHydratableInstance = skipPastDehydratedSuspenseInstance(fiber);
          } else {
            nextHydratableInstance = hydrationParentFiber ? getNextHydratableSibling(fiber.stateNode) : null;
          }

          return true;
        }

        function resetHydrationState() {
          hydrationParentFiber = null;
          nextHydratableInstance = null;
          isHydrating = false;
        }

        function getIsHydrating() {
          return isHydrating;
        } // and should be reset before starting a new render.
        // This tracks which mutable sources need to be reset after a render.


        var workInProgressSources = [];
        var rendererSigil$1;
        {
          // Used to detect multiple renderers using the same mutable source.
          rendererSigil$1 = {};
        }

        function markSourceAsDirty(mutableSource) {
          workInProgressSources.push(mutableSource);
        }

        function resetWorkInProgressVersions() {
          for (var i = 0; i < workInProgressSources.length; i++) {
            var mutableSource = workInProgressSources[i];
            {
              mutableSource._workInProgressVersionPrimary = null;
            }
          }

          workInProgressSources.length = 0;
        }

        function getWorkInProgressVersion(mutableSource) {
          {
            return mutableSource._workInProgressVersionPrimary;
          }
        }

        function setWorkInProgressVersion(mutableSource, version) {
          {
            mutableSource._workInProgressVersionPrimary = version;
          }
          workInProgressSources.push(mutableSource);
        }

        function warnAboutMultipleRenderersDEV(mutableSource) {
          {
            {
              if (mutableSource._currentPrimaryRenderer == null) {
                mutableSource._currentPrimaryRenderer = rendererSigil$1;
              } else if (mutableSource._currentPrimaryRenderer !== rendererSigil$1) {
                error('Detected multiple renderers concurrently rendering the ' + 'same mutable source. This is currently unsupported.');
              }
            }
          }
        } // Eager reads the version of a mutable source and stores it on the root.


        var ReactCurrentDispatcher$1 = ReactSharedInternals.ReactCurrentDispatcher,
            ReactCurrentBatchConfig$1 = ReactSharedInternals.ReactCurrentBatchConfig;
        var didWarnAboutMismatchedHooksForComponent;
        var didWarnAboutUseOpaqueIdentifier;
        {
          didWarnAboutUseOpaqueIdentifier = {};
          didWarnAboutMismatchedHooksForComponent = new Set();
        } // These are set right before calling the component.

        var renderLanes = NoLanes; // The work-in-progress fiber. I've named it differently to distinguish it from
        // the work-in-progress hook.

        var currentlyRenderingFiber$1 = null; // Hooks are stored as a linked list on the fiber's memoizedState field. The
        // current hook list is the list that belongs to the current fiber. The
        // work-in-progress hook list is a new list that will be added to the
        // work-in-progress fiber.

        var currentHook = null;
        var workInProgressHook = null; // Whether an update was scheduled at any point during the render phase. This
        // does not get reset if we do another render pass; only when we're completely
        // finished evaluating this component. This is an optimization so we know
        // whether we need to clear render phase updates after a throw.

        var didScheduleRenderPhaseUpdate = false; // Where an update was scheduled only during the current render pass. This
        // gets reset after each attempt.
        // TODO: Maybe there's some way to consolidate this with
        // `didScheduleRenderPhaseUpdate`. Or with `numberOfReRenders`.

        var didScheduleRenderPhaseUpdateDuringThisPass = false;
        var RE_RENDER_LIMIT = 25; // In DEV, this is the name of the currently executing primitive hook

        var currentHookNameInDev = null; // In DEV, this list ensures that hooks are called in the same order between renders.
        // The list stores the order of hooks used during the initial render (mount).
        // Subsequent renders (updates) reference this list.

        var hookTypesDev = null;
        var hookTypesUpdateIndexDev = -1; // In DEV, this tracks whether currently rendering component needs to ignore
        // the dependencies for Hooks that need them (e.g. useEffect or useMemo).
        // When true, such Hooks will always be "remounted". Only used during hot reload.

        var ignorePreviousDependencies = false;

        function mountHookTypesDev() {
          {
            var hookName = currentHookNameInDev;

            if (hookTypesDev === null) {
              hookTypesDev = [hookName];
            } else {
              hookTypesDev.push(hookName);
            }
          }
        }

        function updateHookTypesDev() {
          {
            var hookName = currentHookNameInDev;

            if (hookTypesDev !== null) {
              hookTypesUpdateIndexDev++;

              if (hookTypesDev[hookTypesUpdateIndexDev] !== hookName) {
                warnOnHookMismatchInDev(hookName);
              }
            }
          }
        }

        function checkDepsAreArrayDev(deps) {
          {
            if (deps !== undefined && deps !== null && !Array.isArray(deps)) {
              // Verify deps, but only on mount to avoid extra checks.
              // It's unlikely their type would change as usually you define them inline.
              error('%s received a final argument that is not an array (instead, received `%s`). When ' + 'specified, the final argument must be an array.', currentHookNameInDev, typeof deps);
            }
          }
        }

        function warnOnHookMismatchInDev(currentHookName) {
          {
            var componentName = getComponentName(currentlyRenderingFiber$1.type);

            if (!didWarnAboutMismatchedHooksForComponent.has(componentName)) {
              didWarnAboutMismatchedHooksForComponent.add(componentName);

              if (hookTypesDev !== null) {
                var table = '';
                var secondColumnStart = 30;

                for (var i = 0; i <= hookTypesUpdateIndexDev; i++) {
                  var oldHookName = hookTypesDev[i];
                  var newHookName = i === hookTypesUpdateIndexDev ? currentHookName : oldHookName;
                  var row = i + 1 + ". " + oldHookName; // Extra space so second column lines up
                  // lol @ IE not supporting String#repeat

                  while (row.length < secondColumnStart) {
                    row += ' ';
                  }

                  row += newHookName + '\n';
                  table += row;
                }

                error('React has detected a change in the order of Hooks called by %s. ' + 'This will lead to bugs and errors if not fixed. ' + 'For more information, read the Rules of Hooks: https://reactjs.org/link/rules-of-hooks\n\n' + '   Previous render            Next render\n' + '   ------------------------------------------------------\n' + '%s' + '   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^\n', componentName, table);
              }
            }
          }
        }

        function throwInvalidHookError() {
          {
            {
              throw Error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.");
            }
          }
        }

        function areHookInputsEqual(nextDeps, prevDeps) {
          {
            if (ignorePreviousDependencies) {
              // Only true when this component is being hot reloaded.
              return false;
            }
          }

          if (prevDeps === null) {
            {
              error('%s received a final argument during this render, but not during ' + 'the previous render. Even though the final argument is optional, ' + 'its type cannot change between renders.', currentHookNameInDev);
            }
            return false;
          }

          {
            // Don't bother comparing lengths in prod because these arrays should be
            // passed inline.
            if (nextDeps.length !== prevDeps.length) {
              error('The final argument passed to %s changed size between renders. The ' + 'order and size of this array must remain constant.\n\n' + 'Previous: %s\n' + 'Incoming: %s', currentHookNameInDev, "[" + prevDeps.join(', ') + "]", "[" + nextDeps.join(', ') + "]");
            }
          }

          for (var i = 0; i < prevDeps.length && i < nextDeps.length; i++) {
            if (objectIs(nextDeps[i], prevDeps[i])) {
              continue;
            }

            return false;
          }

          return true;
        }

        function renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
          renderLanes = nextRenderLanes;
          currentlyRenderingFiber$1 = workInProgress;
          {
            hookTypesDev = current !== null ? current._debugHookTypes : null;
            hookTypesUpdateIndexDev = -1; // Used for hot reloading:

            ignorePreviousDependencies = current !== null && current.type !== workInProgress.type;
          }
          workInProgress.memoizedState = null;
          workInProgress.updateQueue = null;
          workInProgress.lanes = NoLanes; // The following should have already been reset
          // currentHook = null;
          // workInProgressHook = null;
          // didScheduleRenderPhaseUpdate = false;
          // TODO Warn if no hooks are used at all during mount, then some are used during update.
          // Currently we will identify the update render as a mount because memoizedState === null.
          // This is tricky because it's valid for certain types of components (e.g. React.lazy)
          // Using memoizedState to differentiate between mount/update only works if at least one stateful hook is used.
          // Non-stateful hooks (e.g. context) don't get added to memoizedState,
          // so memoizedState would be null during updates and mounts.

          {
            if (current !== null && current.memoizedState !== null) {
              ReactCurrentDispatcher$1.current = HooksDispatcherOnUpdateInDEV;
            } else if (hookTypesDev !== null) {
              // This dispatcher handles an edge case where a component is updating,
              // but no stateful hooks have been used.
              // We want to match the production code behavior (which will use HooksDispatcherOnMount),
              // but with the extra DEV validation to ensure hooks ordering hasn't changed.
              // This dispatcher does that.
              ReactCurrentDispatcher$1.current = HooksDispatcherOnMountWithHookTypesInDEV;
            } else {
              ReactCurrentDispatcher$1.current = HooksDispatcherOnMountInDEV;
            }
          }
          var children = Component(props, secondArg); // Check if there was a render phase update

          if (didScheduleRenderPhaseUpdateDuringThisPass) {
            // Keep rendering in a loop for as long as render phase updates continue to
            // be scheduled. Use a counter to prevent infinite loops.
            var numberOfReRenders = 0;

            do {
              didScheduleRenderPhaseUpdateDuringThisPass = false;

              if (!(numberOfReRenders < RE_RENDER_LIMIT)) {
                {
                  throw Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
                }
              }

              numberOfReRenders += 1;
              {
                // Even when hot reloading, allow dependencies to stabilize
                // after first render to prevent infinite render phase updates.
                ignorePreviousDependencies = false;
              } // Start over from the beginning of the list

              currentHook = null;
              workInProgressHook = null;
              workInProgress.updateQueue = null;
              {
                // Also validate hook order for cascading updates.
                hookTypesUpdateIndexDev = -1;
              }
              ReactCurrentDispatcher$1.current = HooksDispatcherOnRerenderInDEV;
              children = Component(props, secondArg);
            } while (didScheduleRenderPhaseUpdateDuringThisPass);
          } // We can assume the previous dispatcher is always this one, since we set it
          // at the beginning of the render phase and there's no re-entrancy.


          ReactCurrentDispatcher$1.current = ContextOnlyDispatcher;
          {
            workInProgress._debugHookTypes = hookTypesDev;
          } // This check uses currentHook so that it works the same in DEV and prod bundles.
          // hookTypesDev could catch more cases (e.g. context) but only in DEV bundles.

          var didRenderTooFewHooks = currentHook !== null && currentHook.next !== null;
          renderLanes = NoLanes;
          currentlyRenderingFiber$1 = null;
          currentHook = null;
          workInProgressHook = null;
          {
            currentHookNameInDev = null;
            hookTypesDev = null;
            hookTypesUpdateIndexDev = -1;
          }
          didScheduleRenderPhaseUpdate = false;

          if (!!didRenderTooFewHooks) {
            {
              throw Error("Rendered fewer hooks than expected. This may be caused by an accidental early return statement.");
            }
          }

          return children;
        }

        function bailoutHooks(current, workInProgress, lanes) {
          workInProgress.updateQueue = current.updateQueue;
          workInProgress.flags &= ~(Passive | Update);
          current.lanes = removeLanes(current.lanes, lanes);
        }

        function resetHooksAfterThrow() {
          // We can assume the previous dispatcher is always this one, since we set it
          // at the beginning of the render phase and there's no re-entrancy.
          ReactCurrentDispatcher$1.current = ContextOnlyDispatcher;

          if (didScheduleRenderPhaseUpdate) {
            // There were render phase updates. These are only valid for this render
            // phase, which we are now aborting. Remove the updates from the queues so
            // they do not persist to the next render. Do not remove updates from hooks
            // that weren't processed.
            //
            // Only reset the updates from the queue if it has a clone. If it does
            // not have a clone, that means it wasn't processed, and the updates were
            // scheduled before we entered the render phase.
            var hook = currentlyRenderingFiber$1.memoizedState;

            while (hook !== null) {
              var queue = hook.queue;

              if (queue !== null) {
                queue.pending = null;
              }

              hook = hook.next;
            }

            didScheduleRenderPhaseUpdate = false;
          }

          renderLanes = NoLanes;
          currentlyRenderingFiber$1 = null;
          currentHook = null;
          workInProgressHook = null;
          {
            hookTypesDev = null;
            hookTypesUpdateIndexDev = -1;
            currentHookNameInDev = null;
            isUpdatingOpaqueValueInRenderPhase = false;
          }
          didScheduleRenderPhaseUpdateDuringThisPass = false;
        }

        function mountWorkInProgressHook() {
          var hook = {
            memoizedState: null,
            baseState: null,
            baseQueue: null,
            queue: null,
            next: null
          };

          if (workInProgressHook === null) {
            // This is the first hook in the list
            currentlyRenderingFiber$1.memoizedState = workInProgressHook = hook;
          } else {
            // Append to the end of the list
            workInProgressHook = workInProgressHook.next = hook;
          }

          return workInProgressHook;
        }

        function updateWorkInProgressHook() {
          // This function is used both for updates and for re-renders triggered by a
          // render phase update. It assumes there is either a current hook we can
          // clone, or a work-in-progress hook from a previous render pass that we can
          // use as a base. When we reach the end of the base list, we must switch to
          // the dispatcher used for mounts.
          var nextCurrentHook;

          if (currentHook === null) {
            var current = currentlyRenderingFiber$1.alternate;

            if (current !== null) {
              nextCurrentHook = current.memoizedState;
            } else {
              nextCurrentHook = null;
            }
          } else {
            nextCurrentHook = currentHook.next;
          }

          var nextWorkInProgressHook;

          if (workInProgressHook === null) {
            nextWorkInProgressHook = currentlyRenderingFiber$1.memoizedState;
          } else {
            nextWorkInProgressHook = workInProgressHook.next;
          }

          if (nextWorkInProgressHook !== null) {
            // There's already a work-in-progress. Reuse it.
            workInProgressHook = nextWorkInProgressHook;
            nextWorkInProgressHook = workInProgressHook.next;
            currentHook = nextCurrentHook;
          } else {
            // Clone from the current hook.
            if (!(nextCurrentHook !== null)) {
              {
                throw Error("Rendered more hooks than during the previous render.");
              }
            }

            currentHook = nextCurrentHook;
            var newHook = {
              memoizedState: currentHook.memoizedState,
              baseState: currentHook.baseState,
              baseQueue: currentHook.baseQueue,
              queue: currentHook.queue,
              next: null
            };

            if (workInProgressHook === null) {
              // This is the first hook in the list.
              currentlyRenderingFiber$1.memoizedState = workInProgressHook = newHook;
            } else {
              // Append to the end of the list.
              workInProgressHook = workInProgressHook.next = newHook;
            }
          }

          return workInProgressHook;
        }

        function createFunctionComponentUpdateQueue() {
          return {
            lastEffect: null
          };
        }

        function basicStateReducer(state, action) {
          // $FlowFixMe: Flow doesn't like mixed types
          return typeof action === 'function' ? action(state) : action;
        }

        function mountReducer(reducer, initialArg, init) {
          var hook = mountWorkInProgressHook();
          var initialState;

          if (init !== undefined) {
            initialState = init(initialArg);
          } else {
            initialState = initialArg;
          }

          hook.memoizedState = hook.baseState = initialState;
          var queue = hook.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
          };
          var dispatch = queue.dispatch = dispatchAction.bind(null, currentlyRenderingFiber$1, queue);
          return [hook.memoizedState, dispatch];
        }

        function updateReducer(reducer, initialArg, init) {
          var hook = updateWorkInProgressHook();
          var queue = hook.queue;

          if (!(queue !== null)) {
            {
              throw Error("Should have a queue. This is likely a bug in React. Please file an issue.");
            }
          }

          queue.lastRenderedReducer = reducer;
          var current = currentHook; // The last rebase update that is NOT part of the base state.

          var baseQueue = current.baseQueue; // The last pending update that hasn't been processed yet.

          var pendingQueue = queue.pending;

          if (pendingQueue !== null) {
            // We have new updates that haven't been processed yet.
            // We'll add them to the base queue.
            if (baseQueue !== null) {
              // Merge the pending queue and the base queue.
              var baseFirst = baseQueue.next;
              var pendingFirst = pendingQueue.next;
              baseQueue.next = pendingFirst;
              pendingQueue.next = baseFirst;
            }

            {
              if (current.baseQueue !== baseQueue) {
                // Internal invariant that should never happen, but feasibly could in
                // the future if we implement resuming, or some form of that.
                error('Internal error: Expected work-in-progress queue to be a clone. ' + 'This is a bug in React.');
              }
            }
            current.baseQueue = baseQueue = pendingQueue;
            queue.pending = null;
          }

          if (baseQueue !== null) {
            // We have a queue to process.
            var first = baseQueue.next;
            var newState = current.baseState;
            var newBaseState = null;
            var newBaseQueueFirst = null;
            var newBaseQueueLast = null;
            var update = first;

            do {
              var updateLane = update.lane;

              if (!isSubsetOfLanes(renderLanes, updateLane)) {
                // Priority is insufficient. Skip this update. If this is the first
                // skipped update, the previous update/state is the new base
                // update/state.
                var clone = {
                  lane: updateLane,
                  action: update.action,
                  eagerReducer: update.eagerReducer,
                  eagerState: update.eagerState,
                  next: null
                };

                if (newBaseQueueLast === null) {
                  newBaseQueueFirst = newBaseQueueLast = clone;
                  newBaseState = newState;
                } else {
                  newBaseQueueLast = newBaseQueueLast.next = clone;
                } // Update the remaining priority in the queue.
                // TODO: Don't need to accumulate this. Instead, we can remove
                // renderLanes from the original lanes.


                currentlyRenderingFiber$1.lanes = mergeLanes(currentlyRenderingFiber$1.lanes, updateLane);
                markSkippedUpdateLanes(updateLane);
              } else {
                // This update does have sufficient priority.
                if (newBaseQueueLast !== null) {
                  var _clone = {
                    // This update is going to be committed so we never want uncommit
                    // it. Using NoLane works because 0 is a subset of all bitmasks, so
                    // this will never be skipped by the check above.
                    lane: NoLane,
                    action: update.action,
                    eagerReducer: update.eagerReducer,
                    eagerState: update.eagerState,
                    next: null
                  };
                  newBaseQueueLast = newBaseQueueLast.next = _clone;
                } // Process this update.


                if (update.eagerReducer === reducer) {
                  // If this update was processed eagerly, and its reducer matches the
                  // current reducer, we can use the eagerly computed state.
                  newState = update.eagerState;
                } else {
                  var action = update.action;
                  newState = reducer(newState, action);
                }
              }

              update = update.next;
            } while (update !== null && update !== first);

            if (newBaseQueueLast === null) {
              newBaseState = newState;
            } else {
              newBaseQueueLast.next = newBaseQueueFirst;
            } // Mark that the fiber performed work, but only if the new state is
            // different from the current state.


            if (!objectIs(newState, hook.memoizedState)) {
              markWorkInProgressReceivedUpdate();
            }

            hook.memoizedState = newState;
            hook.baseState = newBaseState;
            hook.baseQueue = newBaseQueueLast;
            queue.lastRenderedState = newState;
          }

          var dispatch = queue.dispatch;
          return [hook.memoizedState, dispatch];
        }

        function rerenderReducer(reducer, initialArg, init) {
          var hook = updateWorkInProgressHook();
          var queue = hook.queue;

          if (!(queue !== null)) {
            {
              throw Error("Should have a queue. This is likely a bug in React. Please file an issue.");
            }
          }

          queue.lastRenderedReducer = reducer; // This is a re-render. Apply the new render phase updates to the previous
          // work-in-progress hook.

          var dispatch = queue.dispatch;
          var lastRenderPhaseUpdate = queue.pending;
          var newState = hook.memoizedState;

          if (lastRenderPhaseUpdate !== null) {
            // The queue doesn't persist past this render pass.
            queue.pending = null;
            var firstRenderPhaseUpdate = lastRenderPhaseUpdate.next;
            var update = firstRenderPhaseUpdate;

            do {
              // Process this render phase update. We don't have to check the
              // priority because it will always be the same as the current
              // render's.
              var action = update.action;
              newState = reducer(newState, action);
              update = update.next;
            } while (update !== firstRenderPhaseUpdate); // Mark that the fiber performed work, but only if the new state is
            // different from the current state.


            if (!objectIs(newState, hook.memoizedState)) {
              markWorkInProgressReceivedUpdate();
            }

            hook.memoizedState = newState; // Don't persist the state accumulated from the render phase updates to
            // the base state unless the queue is empty.
            // TODO: Not sure if this is the desired semantics, but it's what we
            // do for gDSFP. I can't remember why.

            if (hook.baseQueue === null) {
              hook.baseState = newState;
            }

            queue.lastRenderedState = newState;
          }

          return [newState, dispatch];
        }

        function readFromUnsubcribedMutableSource(root, source, getSnapshot) {
          {
            warnAboutMultipleRenderersDEV(source);
          }
          var getVersion = source._getVersion;
          var version = getVersion(source._source); // Is it safe for this component to read from this source during the current render?

          var isSafeToReadFromSource = false; // Check the version first.
          // If this render has already been started with a specific version,
          // we can use it alone to determine if we can safely read from the source.

          var currentRenderVersion = getWorkInProgressVersion(source);

          if (currentRenderVersion !== null) {
            // It's safe to read if the store hasn't been mutated since the last time
            // we read something.
            isSafeToReadFromSource = currentRenderVersion === version;
          } else {
            // If there's no version, then this is the first time we've read from the
            // source during the current render pass, so we need to do a bit more work.
            // What we need to determine is if there are any hooks that already
            // subscribed to the source, and if so, whether there are any pending
            // mutations that haven't been synchronized yet.
            //
            // If there are no pending mutations, then `root.mutableReadLanes` will be
            // empty, and we know we can safely read.
            //
            // If there *are* pending mutations, we may still be able to safely read
            // if the currently rendering lanes are inclusive of the pending mutation
            // lanes, since that guarantees that the value we're about to read from
            // the source is consistent with the values that we read during the most
            // recent mutation.
            isSafeToReadFromSource = isSubsetOfLanes(renderLanes, root.mutableReadLanes);

            if (isSafeToReadFromSource) {
              // If it's safe to read from this source during the current render,
              // store the version in case other components read from it.
              // A changed version number will let those components know to throw and restart the render.
              setWorkInProgressVersion(source, version);
            }
          }

          if (isSafeToReadFromSource) {
            var snapshot = getSnapshot(source._source);
            {
              if (typeof snapshot === 'function') {
                error('Mutable source should not return a function as the snapshot value. ' + 'Functions may close over mutable values and cause tearing.');
              }
            }
            return snapshot;
          } else {
            // This handles the special case of a mutable source being shared between renderers.
            // In that case, if the source is mutated between the first and second renderer,
            // The second renderer don't know that it needs to reset the WIP version during unwind,
            // (because the hook only marks sources as dirty if it's written to their WIP version).
            // That would cause this tear check to throw again and eventually be visible to the user.
            // We can avoid this infinite loop by explicitly marking the source as dirty.
            //
            // This can lead to tearing in the first renderer when it resumes,
            // but there's nothing we can do about that (short of throwing here and refusing to continue the render).
            markSourceAsDirty(source);
            {
              {
                throw Error("Cannot read from mutable source during the current render without tearing. This is a bug in React. Please file an issue.");
              }
            }
          }
        }

        function useMutableSource(hook, source, getSnapshot, subscribe) {
          var root = getWorkInProgressRoot();

          if (!(root !== null)) {
            {
              throw Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
            }
          }

          var getVersion = source._getVersion;
          var version = getVersion(source._source);
          var dispatcher = ReactCurrentDispatcher$1.current; // eslint-disable-next-line prefer-const

          var _dispatcher$useState = dispatcher.useState(function () {
            return readFromUnsubcribedMutableSource(root, source, getSnapshot);
          }),
              currentSnapshot = _dispatcher$useState[0],
              setSnapshot = _dispatcher$useState[1];

          var snapshot = currentSnapshot; // Grab a handle to the state hook as well.
          // We use it to clear the pending update queue if we have a new source.

          var stateHook = workInProgressHook;
          var memoizedState = hook.memoizedState;
          var refs = memoizedState.refs;
          var prevGetSnapshot = refs.getSnapshot;
          var prevSource = memoizedState.source;
          var prevSubscribe = memoizedState.subscribe;
          var fiber = currentlyRenderingFiber$1;
          hook.memoizedState = {
            refs: refs,
            source: source,
            subscribe: subscribe
          }; // Sync the values needed by our subscription handler after each commit.

          dispatcher.useEffect(function () {
            refs.getSnapshot = getSnapshot; // Normally the dispatch function for a state hook never changes,
            // but this hook recreates the queue in certain cases  to avoid updates from stale sources.
            // handleChange() below needs to reference the dispatch function without re-subscribing,
            // so we use a ref to ensure that it always has the latest version.

            refs.setSnapshot = setSnapshot; // Check for a possible change between when we last rendered now.

            var maybeNewVersion = getVersion(source._source);

            if (!objectIs(version, maybeNewVersion)) {
              var maybeNewSnapshot = getSnapshot(source._source);
              {
                if (typeof maybeNewSnapshot === 'function') {
                  error('Mutable source should not return a function as the snapshot value. ' + 'Functions may close over mutable values and cause tearing.');
                }
              }

              if (!objectIs(snapshot, maybeNewSnapshot)) {
                setSnapshot(maybeNewSnapshot);
                var lane = requestUpdateLane(fiber);
                markRootMutableRead(root, lane);
              } // If the source mutated between render and now,
              // there may be state updates already scheduled from the old source.
              // Entangle the updates so that they render in the same batch.


              markRootEntangled(root, root.mutableReadLanes);
            }
          }, [getSnapshot, source, subscribe]); // If we got a new source or subscribe function, re-subscribe in a passive effect.

          dispatcher.useEffect(function () {
            var handleChange = function handleChange() {
              var latestGetSnapshot = refs.getSnapshot;
              var latestSetSnapshot = refs.setSnapshot;

              try {
                latestSetSnapshot(latestGetSnapshot(source._source)); // Record a pending mutable source update with the same expiration time.

                var lane = requestUpdateLane(fiber);
                markRootMutableRead(root, lane);
              } catch (error) {
                // A selector might throw after a source mutation.
                // e.g. it might try to read from a part of the store that no longer exists.
                // In this case we should still schedule an update with React.
                // Worst case the selector will throw again and then an error boundary will handle it.
                latestSetSnapshot(function () {
                  throw error;
                });
              }
            };

            var unsubscribe = subscribe(source._source, handleChange);
            {
              if (typeof unsubscribe !== 'function') {
                error('Mutable source subscribe function must return an unsubscribe function.');
              }
            }
            return unsubscribe;
          }, [source, subscribe]); // If any of the inputs to useMutableSource change, reading is potentially unsafe.
          //
          // If either the source or the subscription have changed we can't can't trust the update queue.
          // Maybe the source changed in a way that the old subscription ignored but the new one depends on.
          //
          // If the getSnapshot function changed, we also shouldn't rely on the update queue.
          // It's possible that the underlying source was mutated between the when the last "change" event fired,
          // and when the current render (with the new getSnapshot function) is processed.
          //
          // In both cases, we need to throw away pending updates (since they are no longer relevant)
          // and treat reading from the source as we do in the mount case.

          if (!objectIs(prevGetSnapshot, getSnapshot) || !objectIs(prevSource, source) || !objectIs(prevSubscribe, subscribe)) {
            // Create a new queue and setState method,
            // So if there are interleaved updates, they get pushed to the older queue.
            // When this becomes current, the previous queue and dispatch method will be discarded,
            // including any interleaving updates that occur.
            var newQueue = {
              pending: null,
              dispatch: null,
              lastRenderedReducer: basicStateReducer,
              lastRenderedState: snapshot
            };
            newQueue.dispatch = setSnapshot = dispatchAction.bind(null, currentlyRenderingFiber$1, newQueue);
            stateHook.queue = newQueue;
            stateHook.baseQueue = null;
            snapshot = readFromUnsubcribedMutableSource(root, source, getSnapshot);
            stateHook.memoizedState = stateHook.baseState = snapshot;
          }

          return snapshot;
        }

        function mountMutableSource(source, getSnapshot, subscribe) {
          var hook = mountWorkInProgressHook();
          hook.memoizedState = {
            refs: {
              getSnapshot: getSnapshot,
              setSnapshot: null
            },
            source: source,
            subscribe: subscribe
          };
          return useMutableSource(hook, source, getSnapshot, subscribe);
        }

        function updateMutableSource(source, getSnapshot, subscribe) {
          var hook = updateWorkInProgressHook();
          return useMutableSource(hook, source, getSnapshot, subscribe);
        }

        function mountState(initialState) {
          var hook = mountWorkInProgressHook();

          if (typeof initialState === 'function') {
            // $FlowFixMe: Flow doesn't like mixed types
            initialState = initialState();
          }

          hook.memoizedState = hook.baseState = initialState;
          var queue = hook.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: basicStateReducer,
            lastRenderedState: initialState
          };
          var dispatch = queue.dispatch = dispatchAction.bind(null, currentlyRenderingFiber$1, queue);
          return [hook.memoizedState, dispatch];
        }

        function updateState(initialState) {
          return updateReducer(basicStateReducer);
        }

        function rerenderState(initialState) {
          return rerenderReducer(basicStateReducer);
        }

        function pushEffect(tag, create, destroy, deps) {
          var effect = {
            tag: tag,
            create: create,
            destroy: destroy,
            deps: deps,
            // Circular
            next: null
          };
          var componentUpdateQueue = currentlyRenderingFiber$1.updateQueue;

          if (componentUpdateQueue === null) {
            componentUpdateQueue = createFunctionComponentUpdateQueue();
            currentlyRenderingFiber$1.updateQueue = componentUpdateQueue;
            componentUpdateQueue.lastEffect = effect.next = effect;
          } else {
            var lastEffect = componentUpdateQueue.lastEffect;

            if (lastEffect === null) {
              componentUpdateQueue.lastEffect = effect.next = effect;
            } else {
              var firstEffect = lastEffect.next;
              lastEffect.next = effect;
              effect.next = firstEffect;
              componentUpdateQueue.lastEffect = effect;
            }
          }

          return effect;
        }

        function mountRef(initialValue) {
          var hook = mountWorkInProgressHook();
          var ref = {
            current: initialValue
          };
          {
            Object.seal(ref);
          }
          hook.memoizedState = ref;
          return ref;
        }

        function updateRef(initialValue) {
          var hook = updateWorkInProgressHook();
          return hook.memoizedState;
        }

        function mountEffectImpl(fiberFlags, hookFlags, create, deps) {
          var hook = mountWorkInProgressHook();
          var nextDeps = deps === undefined ? null : deps;
          currentlyRenderingFiber$1.flags |= fiberFlags;
          hook.memoizedState = pushEffect(HasEffect | hookFlags, create, undefined, nextDeps);
        }

        function updateEffectImpl(fiberFlags, hookFlags, create, deps) {
          var hook = updateWorkInProgressHook();
          var nextDeps = deps === undefined ? null : deps;
          var destroy = undefined;

          if (currentHook !== null) {
            var prevEffect = currentHook.memoizedState;
            destroy = prevEffect.destroy;

            if (nextDeps !== null) {
              var prevDeps = prevEffect.deps;

              if (areHookInputsEqual(nextDeps, prevDeps)) {
                pushEffect(hookFlags, create, destroy, nextDeps);
                return;
              }
            }
          }

          currentlyRenderingFiber$1.flags |= fiberFlags;
          hook.memoizedState = pushEffect(HasEffect | hookFlags, create, destroy, nextDeps);
        }

        function mountEffect(create, deps) {
          {
            // $FlowExpectedError - jest isn't a global, and isn't recognized outside of tests
            if ('undefined' !== typeof jest) {
              warnIfNotCurrentlyActingEffectsInDEV(currentlyRenderingFiber$1);
            }
          }
          return mountEffectImpl(Update | Passive, Passive$1, create, deps);
        }

        function updateEffect(create, deps) {
          {
            // $FlowExpectedError - jest isn't a global, and isn't recognized outside of tests
            if ('undefined' !== typeof jest) {
              warnIfNotCurrentlyActingEffectsInDEV(currentlyRenderingFiber$1);
            }
          }
          return updateEffectImpl(Update | Passive, Passive$1, create, deps);
        }

        function mountLayoutEffect(create, deps) {
          return mountEffectImpl(Update, Layout, create, deps);
        }

        function updateLayoutEffect(create, deps) {
          return updateEffectImpl(Update, Layout, create, deps);
        }

        function imperativeHandleEffect(create, ref) {
          if (typeof ref === 'function') {
            var refCallback = ref;

            var _inst = create();

            refCallback(_inst);
            return function () {
              refCallback(null);
            };
          } else if (ref !== null && ref !== undefined) {
            var refObject = ref;
            {
              if (!refObject.hasOwnProperty('current')) {
                error('Expected useImperativeHandle() first argument to either be a ' + 'ref callback or React.createRef() object. Instead received: %s.', 'an object with keys {' + Object.keys(refObject).join(', ') + '}');
              }
            }

            var _inst2 = create();

            refObject.current = _inst2;
            return function () {
              refObject.current = null;
            };
          }
        }

        function mountImperativeHandle(ref, create, deps) {
          {
            if (typeof create !== 'function') {
              error('Expected useImperativeHandle() second argument to be a function ' + 'that creates a handle. Instead received: %s.', create !== null ? typeof create : 'null');
            }
          } // TODO: If deps are provided, should we skip comparing the ref itself?

          var effectDeps = deps !== null && deps !== undefined ? deps.concat([ref]) : null;
          return mountEffectImpl(Update, Layout, imperativeHandleEffect.bind(null, create, ref), effectDeps);
        }

        function updateImperativeHandle(ref, create, deps) {
          {
            if (typeof create !== 'function') {
              error('Expected useImperativeHandle() second argument to be a function ' + 'that creates a handle. Instead received: %s.', create !== null ? typeof create : 'null');
            }
          } // TODO: If deps are provided, should we skip comparing the ref itself?

          var effectDeps = deps !== null && deps !== undefined ? deps.concat([ref]) : null;
          return updateEffectImpl(Update, Layout, imperativeHandleEffect.bind(null, create, ref), effectDeps);
        }

        function mountDebugValue(value, formatterFn) {// This hook is normally a no-op.
          // The react-debug-hooks package injects its own implementation
          // so that e.g. DevTools can display custom hook values.
        }

        var updateDebugValue = mountDebugValue;

        function mountCallback(callback, deps) {
          var hook = mountWorkInProgressHook();
          var nextDeps = deps === undefined ? null : deps;
          hook.memoizedState = [callback, nextDeps];
          return callback;
        }

        function updateCallback(callback, deps) {
          var hook = updateWorkInProgressHook();
          var nextDeps = deps === undefined ? null : deps;
          var prevState = hook.memoizedState;

          if (prevState !== null) {
            if (nextDeps !== null) {
              var prevDeps = prevState[1];

              if (areHookInputsEqual(nextDeps, prevDeps)) {
                return prevState[0];
              }
            }
          }

          hook.memoizedState = [callback, nextDeps];
          return callback;
        }

        function mountMemo(nextCreate, deps) {
          var hook = mountWorkInProgressHook();
          var nextDeps = deps === undefined ? null : deps;
          var nextValue = nextCreate();
          hook.memoizedState = [nextValue, nextDeps];
          return nextValue;
        }

        function updateMemo(nextCreate, deps) {
          var hook = updateWorkInProgressHook();
          var nextDeps = deps === undefined ? null : deps;
          var prevState = hook.memoizedState;

          if (prevState !== null) {
            // Assume these are defined. If they're not, areHookInputsEqual will warn.
            if (nextDeps !== null) {
              var prevDeps = prevState[1];

              if (areHookInputsEqual(nextDeps, prevDeps)) {
                return prevState[0];
              }
            }
          }

          var nextValue = nextCreate();
          hook.memoizedState = [nextValue, nextDeps];
          return nextValue;
        }

        function mountDeferredValue(value) {
          var _mountState = mountState(value),
              prevValue = _mountState[0],
              setValue = _mountState[1];

          mountEffect(function () {
            var prevTransition = ReactCurrentBatchConfig$1.transition;
            ReactCurrentBatchConfig$1.transition = 1;

            try {
              setValue(value);
            } finally {
              ReactCurrentBatchConfig$1.transition = prevTransition;
            }
          }, [value]);
          return prevValue;
        }

        function updateDeferredValue(value) {
          var _updateState = updateState(),
              prevValue = _updateState[0],
              setValue = _updateState[1];

          updateEffect(function () {
            var prevTransition = ReactCurrentBatchConfig$1.transition;
            ReactCurrentBatchConfig$1.transition = 1;

            try {
              setValue(value);
            } finally {
              ReactCurrentBatchConfig$1.transition = prevTransition;
            }
          }, [value]);
          return prevValue;
        }

        function rerenderDeferredValue(value) {
          var _rerenderState = rerenderState(),
              prevValue = _rerenderState[0],
              setValue = _rerenderState[1];

          updateEffect(function () {
            var prevTransition = ReactCurrentBatchConfig$1.transition;
            ReactCurrentBatchConfig$1.transition = 1;

            try {
              setValue(value);
            } finally {
              ReactCurrentBatchConfig$1.transition = prevTransition;
            }
          }, [value]);
          return prevValue;
        }

        function startTransition(setPending, callback) {
          var priorityLevel = getCurrentPriorityLevel();
          {
            runWithPriority$1(priorityLevel < UserBlockingPriority$2 ? UserBlockingPriority$2 : priorityLevel, function () {
              setPending(true);
            });
            runWithPriority$1(priorityLevel > NormalPriority$1 ? NormalPriority$1 : priorityLevel, function () {
              var prevTransition = ReactCurrentBatchConfig$1.transition;
              ReactCurrentBatchConfig$1.transition = 1;

              try {
                setPending(false);
                callback();
              } finally {
                ReactCurrentBatchConfig$1.transition = prevTransition;
              }
            });
          }
        }

        function mountTransition() {
          var _mountState2 = mountState(false),
              isPending = _mountState2[0],
              setPending = _mountState2[1]; // The `start` method can be stored on a ref, since `setPending`
          // never changes.


          var start = startTransition.bind(null, setPending);
          mountRef(start);
          return [start, isPending];
        }

        function updateTransition() {
          var _updateState2 = updateState(),
              isPending = _updateState2[0];

          var startRef = updateRef();
          var start = startRef.current;
          return [start, isPending];
        }

        function rerenderTransition() {
          var _rerenderState2 = rerenderState(),
              isPending = _rerenderState2[0];

          var startRef = updateRef();
          var start = startRef.current;
          return [start, isPending];
        }

        var isUpdatingOpaqueValueInRenderPhase = false;

        function getIsUpdatingOpaqueValueInRenderPhaseInDEV() {
          {
            return isUpdatingOpaqueValueInRenderPhase;
          }
        }

        function warnOnOpaqueIdentifierAccessInDEV(fiber) {
          {
            // TODO: Should warn in effects and callbacks, too
            var name = getComponentName(fiber.type) || 'Unknown';

            if (getIsRendering() && !didWarnAboutUseOpaqueIdentifier[name]) {
              error('The object passed back from useOpaqueIdentifier is meant to be ' + 'passed through to attributes only. Do not read the ' + 'value directly.');
              didWarnAboutUseOpaqueIdentifier[name] = true;
            }
          }
        }

        function mountOpaqueIdentifier() {
          var makeId = makeClientIdInDEV.bind(null, warnOnOpaqueIdentifierAccessInDEV.bind(null, currentlyRenderingFiber$1));

          if (getIsHydrating()) {
            var didUpgrade = false;
            var fiber = currentlyRenderingFiber$1;

            var readValue = function readValue() {
              if (!didUpgrade) {
                // Only upgrade once. This works even inside the render phase because
                // the update is added to a shared queue, which outlasts the
                // in-progress render.
                didUpgrade = true;
                {
                  isUpdatingOpaqueValueInRenderPhase = true;
                  setId(makeId());
                  isUpdatingOpaqueValueInRenderPhase = false;
                  warnOnOpaqueIdentifierAccessInDEV(fiber);
                }
              }

              {
                {
                  throw Error("The object passed back from useOpaqueIdentifier is meant to be passed through to attributes only. Do not read the value directly.");
                }
              }
            };

            var id = makeOpaqueHydratingObject(readValue);
            var setId = mountState(id)[1];

            if ((currentlyRenderingFiber$1.mode & BlockingMode) === NoMode) {
              currentlyRenderingFiber$1.flags |= Update | Passive;
              pushEffect(HasEffect | Passive$1, function () {
                setId(makeId());
              }, undefined, null);
            }

            return id;
          } else {
            var _id = makeId();

            mountState(_id);
            return _id;
          }
        }

        function updateOpaqueIdentifier() {
          var id = updateState()[0];
          return id;
        }

        function rerenderOpaqueIdentifier() {
          var id = rerenderState()[0];
          return id;
        }

        function dispatchAction(fiber, queue, action) {
          {
            if (typeof arguments[3] === 'function') {
              error("State updates from the useState() and useReducer() Hooks don't support the " + 'second callback argument. To execute a side effect after ' + 'rendering, declare it in the component body with useEffect().');
            }
          }
          var eventTime = requestEventTime();
          var lane = requestUpdateLane(fiber);
          var update = {
            lane: lane,
            action: action,
            eagerReducer: null,
            eagerState: null,
            next: null
          }; // Append the update to the end of the list.

          var pending = queue.pending;

          if (pending === null) {
            // This is the first update. Create a circular list.
            update.next = update;
          } else {
            update.next = pending.next;
            pending.next = update;
          }

          queue.pending = update;
          var alternate = fiber.alternate;

          if (fiber === currentlyRenderingFiber$1 || alternate !== null && alternate === currentlyRenderingFiber$1) {
            // This is a render phase update. Stash it in a lazily-created map of
            // queue -> linked list of updates. After this render pass, we'll restart
            // and apply the stashed updates on top of the work-in-progress hook.
            didScheduleRenderPhaseUpdateDuringThisPass = didScheduleRenderPhaseUpdate = true;
          } else {
            if (fiber.lanes === NoLanes && (alternate === null || alternate.lanes === NoLanes)) {
              // The queue is currently empty, which means we can eagerly compute the
              // next state before entering the render phase. If the new state is the
              // same as the current state, we may be able to bail out entirely.
              var lastRenderedReducer = queue.lastRenderedReducer;

              if (lastRenderedReducer !== null) {
                var prevDispatcher;
                {
                  prevDispatcher = ReactCurrentDispatcher$1.current;
                  ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
                }

                try {
                  var currentState = queue.lastRenderedState;
                  var eagerState = lastRenderedReducer(currentState, action); // Stash the eagerly computed state, and the reducer used to compute
                  // it, on the update object. If the reducer hasn't changed by the
                  // time we enter the render phase, then the eager state can be used
                  // without calling the reducer again.

                  update.eagerReducer = lastRenderedReducer;
                  update.eagerState = eagerState;

                  if (objectIs(eagerState, currentState)) {
                    // Fast path. We can bail out without scheduling React to re-render.
                    // It's still possible that we'll need to rebase this update later,
                    // if the component re-renders for a different reason and by that
                    // time the reducer has changed.
                    return;
                  }
                } catch (error) {// Suppress the error. It will throw again in the render phase.
                } finally {
                  {
                    ReactCurrentDispatcher$1.current = prevDispatcher;
                  }
                }
              }
            }

            {
              // $FlowExpectedError - jest isn't a global, and isn't recognized outside of tests
              if ('undefined' !== typeof jest) {
                warnIfNotScopedWithMatchingAct(fiber);
                warnIfNotCurrentlyActingUpdatesInDev(fiber);
              }
            }
            scheduleUpdateOnFiber(fiber, lane, eventTime);
          }
        }

        var ContextOnlyDispatcher = {
          readContext: _readContext,
          useCallback: throwInvalidHookError,
          useContext: throwInvalidHookError,
          useEffect: throwInvalidHookError,
          useImperativeHandle: throwInvalidHookError,
          useLayoutEffect: throwInvalidHookError,
          useMemo: throwInvalidHookError,
          useReducer: throwInvalidHookError,
          useRef: throwInvalidHookError,
          useState: throwInvalidHookError,
          useDebugValue: throwInvalidHookError,
          useDeferredValue: throwInvalidHookError,
          useTransition: throwInvalidHookError,
          useMutableSource: throwInvalidHookError,
          useOpaqueIdentifier: throwInvalidHookError,
          unstable_isNewReconciler: enableNewReconciler
        };
        var HooksDispatcherOnMountInDEV = null;
        var HooksDispatcherOnMountWithHookTypesInDEV = null;
        var HooksDispatcherOnUpdateInDEV = null;
        var HooksDispatcherOnRerenderInDEV = null;
        var InvalidNestedHooksDispatcherOnMountInDEV = null;
        var InvalidNestedHooksDispatcherOnUpdateInDEV = null;
        var InvalidNestedHooksDispatcherOnRerenderInDEV = null;
        {
          var warnInvalidContextAccess = function warnInvalidContextAccess() {
            error('Context can only be read while React is rendering. ' + 'In classes, you can read it in the render method or getDerivedStateFromProps. ' + 'In function components, you can read it directly in the function body, but not ' + 'inside Hooks like useReducer() or useMemo().');
          };

          var warnInvalidHookAccess = function warnInvalidHookAccess() {
            error('Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. ' + 'You can only call Hooks at the top level of your React function. ' + 'For more information, see ' + 'https://reactjs.org/link/rules-of-hooks');
          };

          HooksDispatcherOnMountInDEV = {
            readContext: function readContext(context, observedBits) {
              return _readContext(context, observedBits);
            },
            useCallback: function useCallback(callback, deps) {
              currentHookNameInDev = 'useCallback';
              mountHookTypesDev();
              checkDepsAreArrayDev(deps);
              return mountCallback(callback, deps);
            },
            useContext: function useContext(context, observedBits) {
              currentHookNameInDev = 'useContext';
              mountHookTypesDev();
              return _readContext(context, observedBits);
            },
            useEffect: function useEffect(create, deps) {
              currentHookNameInDev = 'useEffect';
              mountHookTypesDev();
              checkDepsAreArrayDev(deps);
              return mountEffect(create, deps);
            },
            useImperativeHandle: function useImperativeHandle(ref, create, deps) {
              currentHookNameInDev = 'useImperativeHandle';
              mountHookTypesDev();
              checkDepsAreArrayDev(deps);
              return mountImperativeHandle(ref, create, deps);
            },
            useLayoutEffect: function useLayoutEffect(create, deps) {
              currentHookNameInDev = 'useLayoutEffect';
              mountHookTypesDev();
              checkDepsAreArrayDev(deps);
              return mountLayoutEffect(create, deps);
            },
            useMemo: function useMemo(create, deps) {
              currentHookNameInDev = 'useMemo';
              mountHookTypesDev();
              checkDepsAreArrayDev(deps);
              var prevDispatcher = ReactCurrentDispatcher$1.current;
              ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;

              try {
                return mountMemo(create, deps);
              } finally {
                ReactCurrentDispatcher$1.current = prevDispatcher;
              }
            },
            useReducer: function useReducer(reducer, initialArg, init) {
              currentHookNameInDev = 'useReducer';
              mountHookTypesDev();
              var prevDispatcher = ReactCurrentDispatcher$1.current;
              ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;

              try {
                return mountReducer(reducer, initialArg, init);
              } finally {
                ReactCurrentDispatcher$1.current = prevDispatcher;
              }
            },
            useRef: function useRef(initialValue) {
              currentHookNameInDev = 'useRef';
              mountHookTypesDev();
              return mountRef(initialValue);
            },
            useState: function useState(initialState) {
              currentHookNameInDev = 'useState';
              mountHookTypesDev();
              var prevDispatcher = ReactCurrentDispatcher$1.current;
              ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;

              try {
                return mountState(initialState);
              } finally {
                ReactCurrentDispatcher$1.current = prevDispatcher;
              }
            },
            useDebugValue: function useDebugValue(value, formatterFn) {
              currentHookNameInDev = 'useDebugValue';
              mountHookTypesDev();
              return mountDebugValue();
            },
            useDeferredValue: function useDeferredValue(value) {
              currentHookNameInDev = 'useDeferredValue';
              mountHookTypesDev();
              return mountDeferredValue(value);
            },
            useTransition: function useTransition() {
              currentHookNameInDev = 'useTransition';
              mountHookTypesDev();
              return mountTransition();
            },
            useMutableSource: function useMutableSource(source, getSnapshot, subscribe) {
              currentHookNameInDev = 'useMutableSource';
              mountHookTypesDev();
              return mountMutableSource(source, getSnapshot, subscribe);
            },
            useOpaqueIdentifier: function useOpaqueIdentifier() {
              currentHookNameInDev = 'useOpaqueIdentifier';
              mountHookTypesDev();
              return mountOpaqueIdentifier();
            },
            unstable_isNewReconciler: enableNewReconciler
          };
          HooksDispatcherOnMountWithHookTypesInDEV = {
            readContext: function readContext(context, observedBits) {
              return _readContext(context, observedBits);
            },
            useCallback: function useCallback(callback, deps) {
              currentHookNameInDev = 'useCallback';
              updateHookTypesDev();
              return mountCallback(callback, deps);
            },
            useContext: function useContext(context, observedBits) {
              currentHookNameInDev = 'useContext';
              updateHookTypesDev();
              return _readContext(context, observedBits);
            },
            useEffect: function useEffect(create, deps) {
              currentHookNameInDev = 'useEffect';
              updateHookTypesDev();
              return mountEffect(create, deps);
            },
            useImperativeHandle: function useImperativeHandle(ref, create, deps) {
              currentHookNameInDev = 'useImperativeHandle';
              updateHookTypesDev();
              return mountImperativeHandle(ref, create, deps);
            },
            useLayoutEffect: function useLayoutEffect(create, deps) {
              currentHookNameInDev = 'useLayoutEffect';
              updateHookTypesDev();
              return mountLayoutEffect(create, deps);
            },
            useMemo: function useMemo(create, deps) {
              currentHookNameInDev = 'useMemo';
              updateHookTypesDev();
              var prevDispatcher = ReactCurrentDispatcher$1.current;
              ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;

              try {
                return mountMemo(create, deps);
              } finally {
                ReactCurrentDispatcher$1.current = prevDispatcher;
              }
            },
            useReducer: function useReducer(reducer, initialArg, init) {
              currentHookNameInDev = 'useReducer';
              updateHookTypesDev();
              var prevDispatcher = ReactCurrentDispatcher$1.current;
              ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;

              try {
                return mountReducer(reducer, initialArg, init);
              } finally {
                ReactCurrentDispatcher$1.current = prevDispatcher;
              }
            },
            useRef: function useRef(initialValue) {
              currentHookNameInDev = 'useRef';
              updateHookTypesDev();
              return mountRef(initialValue);
            },
            useState: function useState(initialState) {
              currentHookNameInDev = 'useState';
              updateHookTypesDev();
              var prevDispatcher = ReactCurrentDispatcher$1.current;
              ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;

              try {
                return mountState(initialState);
              } finally {
                ReactCurrentDispatcher$1.current = prevDispatcher;
              }
            },
            useDebugValue: function useDebugValue(value, formatterFn) {
              currentHookNameInDev = 'useDebugValue';
              updateHookTypesDev();
              return mountDebugValue();
            },
            useDeferredValue: function useDeferredValue(value) {
              currentHookNameInDev = 'useDeferredValue';
              updateHookTypesDev();
              return mountDeferredValue(value);
            },
            useTransition: function useTransition() {
              currentHookNameInDev = 'useTransition';
              updateHookTypesDev();
              return mountTransition();
            },
            useMutableSource: function useMutableSource(source, getSnapshot, subscribe) {
              currentHookNameInDev = 'useMutableSource';
              updateHookTypesDev();
              return mountMutableSource(source, getSnapshot, subscribe);
            },
            useOpaqueIdentifier: function useOpaqueIdentifier() {
              currentHookNameInDev = 'useOpaqueIdentifier';
              updateHookTypesDev();
              return mountOpaqueIdentifier();
            },
            unstable_isNewReconciler: enableNewReconciler
          };
          HooksDispatcherOnUpdateInDEV = {
            readContext: function readContext(context, observedBits) {
              return _readContext(context, observedBits);
            },
            useCallback: function useCallback(callback, deps) {
              currentHookNameInDev = 'useCallback';
              updateHookTypesDev();
              return updateCallback(callback, deps);
            },
            useContext: function useContext(context, observedBits) {
              currentHookNameInDev = 'useContext';
              updateHookTypesDev();
              return _readContext(context, observedBits);
            },
            useEffect: function useEffect(create, deps) {
              currentHookNameInDev = 'useEffect';
              updateHookTypesDev();
              return updateEffect(create, deps);
            },
            useImperativeHandle: function useImperativeHandle(ref, create, deps) {
              currentHookNameInDev = 'useImperativeHandle';
              updateHookTypesDev();
              return updateImperativeHandle(ref, create, deps);
            },
            useLayoutEffect: function useLayoutEffect(create, deps) {
              currentHookNameInDev = 'useLayoutEffect';
              updateHookTypesDev();
              return updateLayoutEffect(create, deps);
            },
            useMemo: function useMemo(create, deps) {
              currentHookNameInDev = 'useMemo';
              updateHookTypesDev();
              var prevDispatcher = ReactCurrentDispatcher$1.current;
              ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;

              try {
                return updateMemo(create, deps);
              } finally {
                ReactCurrentDispatcher$1.current = prevDispatcher;
              }
            },
            useReducer: function useReducer(reducer, initialArg, init) {
              currentHookNameInDev = 'useReducer';
              updateHookTypesDev();
              var prevDispatcher = ReactCurrentDispatcher$1.current;
              ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;

              try {
                return updateReducer(reducer, initialArg, init);
              } finally {
                ReactCurrentDispatcher$1.current = prevDispatcher;
              }
            },
            useRef: function useRef(initialValue) {
              currentHookNameInDev = 'useRef';
              updateHookTypesDev();
              return updateRef();
            },
            useState: function useState(initialState) {
              currentHookNameInDev = 'useState';
              updateHookTypesDev();
              var prevDispatcher = ReactCurrentDispatcher$1.current;
              ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;

              try {
                return updateState(initialState);
              } finally {
                ReactCurrentDispatcher$1.current = prevDispatcher;
              }
            },
            useDebugValue: function useDebugValue(value, formatterFn) {
              currentHookNameInDev = 'useDebugValue';
              updateHookTypesDev();
              return updateDebugValue();
            },
            useDeferredValue: function useDeferredValue(value) {
              currentHookNameInDev = 'useDeferredValue';
              updateHookTypesDev();
              return updateDeferredValue(value);
            },
            useTransition: function useTransition() {
              currentHookNameInDev = 'useTransition';
              updateHookTypesDev();
              return updateTransition();
            },
            useMutableSource: function useMutableSource(source, getSnapshot, subscribe) {
              currentHookNameInDev = 'useMutableSource';
              updateHookTypesDev();
              return updateMutableSource(source, getSnapshot, subscribe);
            },
            useOpaqueIdentifier: function useOpaqueIdentifier() {
              currentHookNameInDev = 'useOpaqueIdentifier';
              updateHookTypesDev();
              return updateOpaqueIdentifier();
            },
            unstable_isNewReconciler: enableNewReconciler
          };
          HooksDispatcherOnRerenderInDEV = {
            readContext: function readContext(context, observedBits) {
              return _readContext(context, observedBits);
            },
            useCallback: function useCallback(callback, deps) {
              currentHookNameInDev = 'useCallback';
              updateHookTypesDev();
              return updateCallback(callback, deps);
            },
            useContext: function useContext(context, observedBits) {
              currentHookNameInDev = 'useContext';
              updateHookTypesDev();
              return _readContext(context, observedBits);
            },
            useEffect: function useEffect(create, deps) {
              currentHookNameInDev = 'useEffect';
              updateHookTypesDev();
              return updateEffect(create, deps);
            },
            useImperativeHandle: function useImperativeHandle(ref, create, deps) {
              currentHookNameInDev = 'useImperativeHandle';
              updateHookTypesDev();
              return updateImperativeHandle(ref, create, deps);
            },
            useLayoutEffect: function useLayoutEffect(create, deps) {
              currentHookNameInDev = 'useLayoutEffect';
              updateHookTypesDev();
              return updateLayoutEffect(create, deps);
            },
            useMemo: function useMemo(create, deps) {
              currentHookNameInDev = 'useMemo';
              updateHookTypesDev();
              var prevDispatcher = ReactCurrentDispatcher$1.current;
              ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;

              try {
                return updateMemo(create, deps);
              } finally {
                ReactCurrentDispatcher$1.current = prevDispatcher;
              }
            },
            useReducer: function useReducer(reducer, initialArg, init) {
              currentHookNameInDev = 'useReducer';
              updateHookTypesDev();
              var prevDispatcher = ReactCurrentDispatcher$1.current;
              ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;

              try {
                return rerenderReducer(reducer, initialArg, init);
              } finally {
                ReactCurrentDispatcher$1.current = prevDispatcher;
              }
            },
            useRef: function useRef(initialValue) {
              currentHookNameInDev = 'useRef';
              updateHookTypesDev();
              return updateRef();
            },
            useState: function useState(initialState) {
              currentHookNameInDev = 'useState';
              updateHookTypesDev();
              var prevDispatcher = ReactCurrentDispatcher$1.current;
              ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;

              try {
                return rerenderState(initialState);
              } finally {
                ReactCurrentDispatcher$1.current = prevDispatcher;
              }
            },
            useDebugValue: function useDebugValue(value, formatterFn) {
              currentHookNameInDev = 'useDebugValue';
              updateHookTypesDev();
              return updateDebugValue();
            },
            useDeferredValue: function useDeferredValue(value) {
              currentHookNameInDev = 'useDeferredValue';
              updateHookTypesDev();
              return rerenderDeferredValue(value);
            },
            useTransition: function useTransition() {
              currentHookNameInDev = 'useTransition';
              updateHookTypesDev();
              return rerenderTransition();
            },
            useMutableSource: function useMutableSource(source, getSnapshot, subscribe) {
              currentHookNameInDev = 'useMutableSource';
              updateHookTypesDev();
              return updateMutableSource(source, getSnapshot, subscribe);
            },
            useOpaqueIdentifier: function useOpaqueIdentifier() {
              currentHookNameInDev = 'useOpaqueIdentifier';
              updateHookTypesDev();
              return rerenderOpaqueIdentifier();
            },
            unstable_isNewReconciler: enableNewReconciler
          };
          InvalidNestedHooksDispatcherOnMountInDEV = {
            readContext: function readContext(context, observedBits) {
              warnInvalidContextAccess();
              return _readContext(context, observedBits);
            },
            useCallback: function useCallback(callback, deps) {
              currentHookNameInDev = 'useCallback';
              warnInvalidHookAccess();
              mountHookTypesDev();
              return mountCallback(callback, deps);
            },
            useContext: function useContext(context, observedBits) {
              currentHookNameInDev = 'useContext';
              warnInvalidHookAccess();
              mountHookTypesDev();
              return _readContext(context, observedBits);
            },
            useEffect: function useEffect(create, deps) {
              currentHookNameInDev = 'useEffect';
              warnInvalidHookAccess();
              mountHookTypesDev();
              return mountEffect(create, deps);
            },
            useImperativeHandle: function useImperativeHandle(ref, create, deps) {
              currentHookNameInDev = 'useImperativeHandle';
              warnInvalidHookAccess();
              mountHookTypesDev();
              return mountImperativeHandle(ref, create, deps);
            },
            useLayoutEffect: function useLayoutEffect(create, deps) {
              currentHookNameInDev = 'useLayoutEffect';
              warnInvalidHookAccess();
              mountHookTypesDev();
              return mountLayoutEffect(create, deps);
            },
            useMemo: function useMemo(create, deps) {
              currentHookNameInDev = 'useMemo';
              warnInvalidHookAccess();
              mountHookTypesDev();
              var prevDispatcher = ReactCurrentDispatcher$1.current;
              ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;

              try {
                return mountMemo(create, deps);
              } finally {
                ReactCurrentDispatcher$1.current = prevDispatcher;
              }
            },
            useReducer: function useReducer(reducer, initialArg, init) {
              currentHookNameInDev = 'useReducer';
              warnInvalidHookAccess();
              mountHookTypesDev();
              var prevDispatcher = ReactCurrentDispatcher$1.current;
              ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;

              try {
                return mountReducer(reducer, initialArg, init);
              } finally {
                ReactCurrentDispatcher$1.current = prevDispatcher;
              }
            },
            useRef: function useRef(initialValue) {
              currentHookNameInDev = 'useRef';
              warnInvalidHookAccess();
              mountHookTypesDev();
              return mountRef(initialValue);
            },
            useState: function useState(initialState) {
              currentHookNameInDev = 'useState';
              warnInvalidHookAccess();
              mountHookTypesDev();
              var prevDispatcher = ReactCurrentDispatcher$1.current;
              ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;

              try {
                return mountState(initialState);
              } finally {
                ReactCurrentDispatcher$1.current = prevDispatcher;
              }
            },
            useDebugValue: function useDebugValue(value, formatterFn) {
              currentHookNameInDev = 'useDebugValue';
              warnInvalidHookAccess();
              mountHookTypesDev();
              return mountDebugValue();
            },
            useDeferredValue: function useDeferredValue(value) {
              currentHookNameInDev = 'useDeferredValue';
              warnInvalidHookAccess();
              mountHookTypesDev();
              return mountDeferredValue(value);
            },
            useTransition: function useTransition() {
              currentHookNameInDev = 'useTransition';
              warnInvalidHookAccess();
              mountHookTypesDev();
              return mountTransition();
            },
            useMutableSource: function useMutableSource(source, getSnapshot, subscribe) {
              currentHookNameInDev = 'useMutableSource';
              warnInvalidHookAccess();
              mountHookTypesDev();
              return mountMutableSource(source, getSnapshot, subscribe);
            },
            useOpaqueIdentifier: function useOpaqueIdentifier() {
              currentHookNameInDev = 'useOpaqueIdentifier';
              warnInvalidHookAccess();
              mountHookTypesDev();
              return mountOpaqueIdentifier();
            },
            unstable_isNewReconciler: enableNewReconciler
          };
          InvalidNestedHooksDispatcherOnUpdateInDEV = {
            readContext: function readContext(context, observedBits) {
              warnInvalidContextAccess();
              return _readContext(context, observedBits);
            },
            useCallback: function useCallback(callback, deps) {
              currentHookNameInDev = 'useCallback';
              warnInvalidHookAccess();
              updateHookTypesDev();
              return updateCallback(callback, deps);
            },
            useContext: function useContext(context, observedBits) {
              currentHookNameInDev = 'useContext';
              warnInvalidHookAccess();
              updateHookTypesDev();
              return _readContext(context, observedBits);
            },
            useEffect: function useEffect(create, deps) {
              currentHookNameInDev = 'useEffect';
              warnInvalidHookAccess();
              updateHookTypesDev();
              return updateEffect(create, deps);
            },
            useImperativeHandle: function useImperativeHandle(ref, create, deps) {
              currentHookNameInDev = 'useImperativeHandle';
              warnInvalidHookAccess();
              updateHookTypesDev();
              return updateImperativeHandle(ref, create, deps);
            },
            useLayoutEffect: function useLayoutEffect(create, deps) {
              currentHookNameInDev = 'useLayoutEffect';
              warnInvalidHookAccess();
              updateHookTypesDev();
              return updateLayoutEffect(create, deps);
            },
            useMemo: function useMemo(create, deps) {
              currentHookNameInDev = 'useMemo';
              warnInvalidHookAccess();
              updateHookTypesDev();
              var prevDispatcher = ReactCurrentDispatcher$1.current;
              ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;

              try {
                return updateMemo(create, deps);
              } finally {
                ReactCurrentDispatcher$1.current = prevDispatcher;
              }
            },
            useReducer: function useReducer(reducer, initialArg, init) {
              currentHookNameInDev = 'useReducer';
              warnInvalidHookAccess();
              updateHookTypesDev();
              var prevDispatcher = ReactCurrentDispatcher$1.current;
              ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;

              try {
                return updateReducer(reducer, initialArg, init);
              } finally {
                ReactCurrentDispatcher$1.current = prevDispatcher;
              }
            },
            useRef: function useRef(initialValue) {
              currentHookNameInDev = 'useRef';
              warnInvalidHookAccess();
              updateHookTypesDev();
              return updateRef();
            },
            useState: function useState(initialState) {
              currentHookNameInDev = 'useState';
              warnInvalidHookAccess();
              updateHookTypesDev();
              var prevDispatcher = ReactCurrentDispatcher$1.current;
              ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;

              try {
                return updateState(initialState);
              } finally {
                ReactCurrentDispatcher$1.current = prevDispatcher;
              }
            },
            useDebugValue: function useDebugValue(value, formatterFn) {
              currentHookNameInDev = 'useDebugValue';
              warnInvalidHookAccess();
              updateHookTypesDev();
              return updateDebugValue();
            },
            useDeferredValue: function useDeferredValue(value) {
              currentHookNameInDev = 'useDeferredValue';
              warnInvalidHookAccess();
              updateHookTypesDev();
              return updateDeferredValue(value);
            },
            useTransition: function useTransition() {
              currentHookNameInDev = 'useTransition';
              warnInvalidHookAccess();
              updateHookTypesDev();
              return updateTransition();
            },
            useMutableSource: function useMutableSource(source, getSnapshot, subscribe) {
              currentHookNameInDev = 'useMutableSource';
              warnInvalidHookAccess();
              updateHookTypesDev();
              return updateMutableSource(source, getSnapshot, subscribe);
            },
            useOpaqueIdentifier: function useOpaqueIdentifier() {
              currentHookNameInDev = 'useOpaqueIdentifier';
              warnInvalidHookAccess();
              updateHookTypesDev();
              return updateOpaqueIdentifier();
            },
            unstable_isNewReconciler: enableNewReconciler
          };
          InvalidNestedHooksDispatcherOnRerenderInDEV = {
            readContext: function readContext(context, observedBits) {
              warnInvalidContextAccess();
              return _readContext(context, observedBits);
            },
            useCallback: function useCallback(callback, deps) {
              currentHookNameInDev = 'useCallback';
              warnInvalidHookAccess();
              updateHookTypesDev();
              return updateCallback(callback, deps);
            },
            useContext: function useContext(context, observedBits) {
              currentHookNameInDev = 'useContext';
              warnInvalidHookAccess();
              updateHookTypesDev();
              return _readContext(context, observedBits);
            },
            useEffect: function useEffect(create, deps) {
              currentHookNameInDev = 'useEffect';
              warnInvalidHookAccess();
              updateHookTypesDev();
              return updateEffect(create, deps);
            },
            useImperativeHandle: function useImperativeHandle(ref, create, deps) {
              currentHookNameInDev = 'useImperativeHandle';
              warnInvalidHookAccess();
              updateHookTypesDev();
              return updateImperativeHandle(ref, create, deps);
            },
            useLayoutEffect: function useLayoutEffect(create, deps) {
              currentHookNameInDev = 'useLayoutEffect';
              warnInvalidHookAccess();
              updateHookTypesDev();
              return updateLayoutEffect(create, deps);
            },
            useMemo: function useMemo(create, deps) {
              currentHookNameInDev = 'useMemo';
              warnInvalidHookAccess();
              updateHookTypesDev();
              var prevDispatcher = ReactCurrentDispatcher$1.current;
              ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;

              try {
                return updateMemo(create, deps);
              } finally {
                ReactCurrentDispatcher$1.current = prevDispatcher;
              }
            },
            useReducer: function useReducer(reducer, initialArg, init) {
              currentHookNameInDev = 'useReducer';
              warnInvalidHookAccess();
              updateHookTypesDev();
              var prevDispatcher = ReactCurrentDispatcher$1.current;
              ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;

              try {
                return rerenderReducer(reducer, initialArg, init);
              } finally {
                ReactCurrentDispatcher$1.current = prevDispatcher;
              }
            },
            useRef: function useRef(initialValue) {
              currentHookNameInDev = 'useRef';
              warnInvalidHookAccess();
              updateHookTypesDev();
              return updateRef();
            },
            useState: function useState(initialState) {
              currentHookNameInDev = 'useState';
              warnInvalidHookAccess();
              updateHookTypesDev();
              var prevDispatcher = ReactCurrentDispatcher$1.current;
              ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;

              try {
                return rerenderState(initialState);
              } finally {
                ReactCurrentDispatcher$1.current = prevDispatcher;
              }
            },
            useDebugValue: function useDebugValue(value, formatterFn) {
              currentHookNameInDev = 'useDebugValue';
              warnInvalidHookAccess();
              updateHookTypesDev();
              return updateDebugValue();
            },
            useDeferredValue: function useDeferredValue(value) {
              currentHookNameInDev = 'useDeferredValue';
              warnInvalidHookAccess();
              updateHookTypesDev();
              return rerenderDeferredValue(value);
            },
            useTransition: function useTransition() {
              currentHookNameInDev = 'useTransition';
              warnInvalidHookAccess();
              updateHookTypesDev();
              return rerenderTransition();
            },
            useMutableSource: function useMutableSource(source, getSnapshot, subscribe) {
              currentHookNameInDev = 'useMutableSource';
              warnInvalidHookAccess();
              updateHookTypesDev();
              return updateMutableSource(source, getSnapshot, subscribe);
            },
            useOpaqueIdentifier: function useOpaqueIdentifier() {
              currentHookNameInDev = 'useOpaqueIdentifier';
              warnInvalidHookAccess();
              updateHookTypesDev();
              return rerenderOpaqueIdentifier();
            },
            unstable_isNewReconciler: enableNewReconciler
          };
        }
        var now$1 = Scheduler.unstable_now;
        var commitTime = 0;
        var profilerStartTime = -1;

        function getCommitTime() {
          return commitTime;
        }

        function recordCommitTime() {
          commitTime = now$1();
        }

        function startProfilerTimer(fiber) {
          profilerStartTime = now$1();

          if (fiber.actualStartTime < 0) {
            fiber.actualStartTime = now$1();
          }
        }

        function stopProfilerTimerIfRunning(fiber) {
          profilerStartTime = -1;
        }

        function stopProfilerTimerIfRunningAndRecordDelta(fiber, overrideBaseTime) {
          if (profilerStartTime >= 0) {
            var elapsedTime = now$1() - profilerStartTime;
            fiber.actualDuration += elapsedTime;

            if (overrideBaseTime) {
              fiber.selfBaseDuration = elapsedTime;
            }

            profilerStartTime = -1;
          }
        }

        function transferActualDuration(fiber) {
          // Transfer time spent rendering these children so we don't lose it
          // after we rerender. This is used as a helper in special cases
          // where we should count the work of multiple passes.
          var child = fiber.child;

          while (child) {
            fiber.actualDuration += child.actualDuration;
            child = child.sibling;
          }
        }

        var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
        var didReceiveUpdate = false;
        var didWarnAboutBadClass;
        var didWarnAboutModulePatternComponent;
        var didWarnAboutContextTypeOnFunctionComponent;
        var didWarnAboutGetDerivedStateOnFunctionComponent;
        var didWarnAboutFunctionRefs;
        var didWarnAboutReassigningProps;
        var didWarnAboutRevealOrder;
        var didWarnAboutTailOptions;
        {
          didWarnAboutBadClass = {};
          didWarnAboutModulePatternComponent = {};
          didWarnAboutContextTypeOnFunctionComponent = {};
          didWarnAboutGetDerivedStateOnFunctionComponent = {};
          didWarnAboutFunctionRefs = {};
          didWarnAboutReassigningProps = false;
          didWarnAboutRevealOrder = {};
          didWarnAboutTailOptions = {};
        }

        function reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
          if (current === null) {
            // If this is a fresh new component that hasn't been rendered yet, we
            // won't update its child set by applying minimal side-effects. Instead,
            // we will add them all to the child before it gets rendered. That means
            // we can optimize this reconciliation pass by not tracking side-effects.
            workInProgress.child = mountChildFibers(workInProgress, null, nextChildren, renderLanes);
          } else {
            // If the current child is the same as the work in progress, it means that
            // we haven't yet started any work on these children. Therefore, we use
            // the clone algorithm to create a copy of all the current children.
            // If we had any progressed work already, that is invalid at this point so
            // let's throw it out.
            workInProgress.child = reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
          }
        }

        function forceUnmountCurrentAndReconcile(current, workInProgress, nextChildren, renderLanes) {
          // This function is fork of reconcileChildren. It's used in cases where we
          // want to reconcile without matching against the existing set. This has the
          // effect of all current children being unmounted; even if the type and key
          // are the same, the old child is unmounted and a new child is created.
          //
          // To do this, we're going to go through the reconcile algorithm twice. In
          // the first pass, we schedule a deletion for all the current children by
          // passing null.
          workInProgress.child = reconcileChildFibers(workInProgress, current.child, null, renderLanes); // In the second pass, we mount the new children. The trick here is that we
          // pass null in place of where we usually pass the current child set. This has
          // the effect of remounting all children regardless of whether their
          // identities match.

          workInProgress.child = reconcileChildFibers(workInProgress, null, nextChildren, renderLanes);
        }

        function updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
          // TODO: current can be non-null here even if the component
          // hasn't yet mounted. This happens after the first render suspends.
          // We'll need to figure out if this is fine or can cause issues.
          {
            if (workInProgress.type !== workInProgress.elementType) {
              // Lazy component props can't be validated in createElement
              // because they're only guaranteed to be resolved here.
              var innerPropTypes = Component.propTypes;

              if (innerPropTypes) {
                checkPropTypes(innerPropTypes, nextProps, // Resolved props
                'prop', getComponentName(Component));
              }
            }
          }
          var render = Component.render;
          var ref = workInProgress.ref; // The rest is a fork of updateFunctionComponent

          var nextChildren;
          prepareToReadContext(workInProgress, renderLanes);
          {
            ReactCurrentOwner$1.current = workInProgress;
            setIsRendering(true);
            nextChildren = renderWithHooks(current, workInProgress, render, nextProps, ref, renderLanes);

            if (workInProgress.mode & StrictMode) {
              disableLogs();

              try {
                nextChildren = renderWithHooks(current, workInProgress, render, nextProps, ref, renderLanes);
              } finally {
                reenableLogs();
              }
            }

            setIsRendering(false);
          }

          if (current !== null && !didReceiveUpdate) {
            bailoutHooks(current, workInProgress, renderLanes);
            return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
          } // React DevTools reads this flag.


          workInProgress.flags |= PerformedWork;
          reconcileChildren(current, workInProgress, nextChildren, renderLanes);
          return workInProgress.child;
        }

        function updateMemoComponent(current, workInProgress, Component, nextProps, updateLanes, renderLanes) {
          if (current === null) {
            var type = Component.type;

            if (isSimpleFunctionComponent(type) && Component.compare === null && // SimpleMemoComponent codepath doesn't resolve outer props either.
            Component.defaultProps === undefined) {
              var resolvedType = type;
              {
                resolvedType = resolveFunctionForHotReloading(type);
              } // If this is a plain function component without default props,
              // and with only the default shallow comparison, we upgrade it
              // to a SimpleMemoComponent to allow fast path updates.

              workInProgress.tag = SimpleMemoComponent;
              workInProgress.type = resolvedType;
              {
                validateFunctionComponentInDev(workInProgress, type);
              }
              return updateSimpleMemoComponent(current, workInProgress, resolvedType, nextProps, updateLanes, renderLanes);
            }

            {
              var innerPropTypes = type.propTypes;

              if (innerPropTypes) {
                // Inner memo component props aren't currently validated in createElement.
                // We could move it there, but we'd still need this for lazy code path.
                checkPropTypes(innerPropTypes, nextProps, // Resolved props
                'prop', getComponentName(type));
              }
            }
            var child = createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
            child.ref = workInProgress.ref;
            child.return = workInProgress;
            workInProgress.child = child;
            return child;
          }

          {
            var _type = Component.type;
            var _innerPropTypes = _type.propTypes;

            if (_innerPropTypes) {
              // Inner memo component props aren't currently validated in createElement.
              // We could move it there, but we'd still need this for lazy code path.
              checkPropTypes(_innerPropTypes, nextProps, // Resolved props
              'prop', getComponentName(_type));
            }
          }
          var currentChild = current.child; // This is always exactly one child

          if (!includesSomeLane(updateLanes, renderLanes)) {
            // This will be the props with resolved defaultProps,
            // unlike current.memoizedProps which will be the unresolved ones.
            var prevProps = currentChild.memoizedProps; // Default to shallow comparison

            var compare = Component.compare;
            compare = compare !== null ? compare : shallowEqual;

            if (compare(prevProps, nextProps) && current.ref === workInProgress.ref) {
              return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
            }
          } // React DevTools reads this flag.


          workInProgress.flags |= PerformedWork;
          var newChild = createWorkInProgress(currentChild, nextProps);
          newChild.ref = workInProgress.ref;
          newChild.return = workInProgress;
          workInProgress.child = newChild;
          return newChild;
        }

        function updateSimpleMemoComponent(current, workInProgress, Component, nextProps, updateLanes, renderLanes) {
          // TODO: current can be non-null here even if the component
          // hasn't yet mounted. This happens when the inner render suspends.
          // We'll need to figure out if this is fine or can cause issues.
          {
            if (workInProgress.type !== workInProgress.elementType) {
              // Lazy component props can't be validated in createElement
              // because they're only guaranteed to be resolved here.
              var outerMemoType = workInProgress.elementType;

              if (outerMemoType.$$typeof === REACT_LAZY_TYPE) {
                // We warn when you define propTypes on lazy()
                // so let's just skip over it to find memo() outer wrapper.
                // Inner props for memo are validated later.
                var lazyComponent = outerMemoType;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;

                try {
                  outerMemoType = init(payload);
                } catch (x) {
                  outerMemoType = null;
                } // Inner propTypes will be validated in the function component path.


                var outerPropTypes = outerMemoType && outerMemoType.propTypes;

                if (outerPropTypes) {
                  checkPropTypes(outerPropTypes, nextProps, // Resolved (SimpleMemoComponent has no defaultProps)
                  'prop', getComponentName(outerMemoType));
                }
              }
            }
          }

          if (current !== null) {
            var prevProps = current.memoizedProps;

            if (shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref && // Prevent bailout if the implementation changed due to hot reload.
            workInProgress.type === current.type) {
              didReceiveUpdate = false;

              if (!includesSomeLane(renderLanes, updateLanes)) {
                // The pending lanes were cleared at the beginning of beginWork. We're
                // about to bail out, but there might be other lanes that weren't
                // included in the current render. Usually, the priority level of the
                // remaining updates is accumlated during the evaluation of the
                // component (i.e. when processing the update queue). But since since
                // we're bailing out early *without* evaluating the component, we need
                // to account for it here, too. Reset to the value of the current fiber.
                // NOTE: This only applies to SimpleMemoComponent, not MemoComponent,
                // because a MemoComponent fiber does not have hooks or an update queue;
                // rather, it wraps around an inner component, which may or may not
                // contains hooks.
                // TODO: Move the reset at in beginWork out of the common path so that
                // this is no longer necessary.
                workInProgress.lanes = current.lanes;
                return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
              } else if ((current.flags & ForceUpdateForLegacySuspense) !== NoFlags) {
                // This is a special case that only exists for legacy mode.
                // See https://github.com/facebook/react/pull/19216.
                didReceiveUpdate = true;
              }
            }
          }

          return updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
        }

        function updateOffscreenComponent(current, workInProgress, renderLanes) {
          var nextProps = workInProgress.pendingProps;
          var nextChildren = nextProps.children;
          var prevState = current !== null ? current.memoizedState : null;

          if (nextProps.mode === 'hidden' || nextProps.mode === 'unstable-defer-without-hiding') {
            if ((workInProgress.mode & ConcurrentMode) === NoMode) {
              // In legacy sync mode, don't defer the subtree. Render it now.
              // TODO: Figure out what we should do in Blocking mode.
              var nextState = {
                baseLanes: NoLanes
              };
              workInProgress.memoizedState = nextState;
              pushRenderLanes(workInProgress, renderLanes);
            } else if (!includesSomeLane(renderLanes, OffscreenLane)) {
              var nextBaseLanes;

              if (prevState !== null) {
                var prevBaseLanes = prevState.baseLanes;
                nextBaseLanes = mergeLanes(prevBaseLanes, renderLanes);
              } else {
                nextBaseLanes = renderLanes;
              } // Schedule this fiber to re-render at offscreen priority. Then bailout.


              {
                markSpawnedWork(OffscreenLane);
              }
              workInProgress.lanes = workInProgress.childLanes = laneToLanes(OffscreenLane);
              var _nextState = {
                baseLanes: nextBaseLanes
              };
              workInProgress.memoizedState = _nextState; // We're about to bail out, but we need to push this to the stack anyway
              // to avoid a push/pop misalignment.

              pushRenderLanes(workInProgress, nextBaseLanes);
              return null;
            } else {
              // Rendering at offscreen, so we can clear the base lanes.
              var _nextState2 = {
                baseLanes: NoLanes
              };
              workInProgress.memoizedState = _nextState2; // Push the lanes that were skipped when we bailed out.

              var subtreeRenderLanes = prevState !== null ? prevState.baseLanes : renderLanes;
              pushRenderLanes(workInProgress, subtreeRenderLanes);
            }
          } else {
            var _subtreeRenderLanes;

            if (prevState !== null) {
              _subtreeRenderLanes = mergeLanes(prevState.baseLanes, renderLanes); // Since we're not hidden anymore, reset the state

              workInProgress.memoizedState = null;
            } else {
              // We weren't previously hidden, and we still aren't, so there's nothing
              // special to do. Need to push to the stack regardless, though, to avoid
              // a push/pop misalignment.
              _subtreeRenderLanes = renderLanes;
            }

            pushRenderLanes(workInProgress, _subtreeRenderLanes);
          }

          reconcileChildren(current, workInProgress, nextChildren, renderLanes);
          return workInProgress.child;
        } // Note: These happen to have identical begin phases, for now. We shouldn't hold
        // ourselves to this constraint, though. If the behavior diverges, we should
        // fork the function.


        var updateLegacyHiddenComponent = updateOffscreenComponent;

        function updateFragment(current, workInProgress, renderLanes) {
          var nextChildren = workInProgress.pendingProps;
          reconcileChildren(current, workInProgress, nextChildren, renderLanes);
          return workInProgress.child;
        }

        function updateMode(current, workInProgress, renderLanes) {
          var nextChildren = workInProgress.pendingProps.children;
          reconcileChildren(current, workInProgress, nextChildren, renderLanes);
          return workInProgress.child;
        }

        function updateProfiler(current, workInProgress, renderLanes) {
          {
            workInProgress.flags |= Update; // Reset effect durations for the next eventual effect phase.
            // These are reset during render to allow the DevTools commit hook a chance to read them,

            var stateNode = workInProgress.stateNode;
            stateNode.effectDuration = 0;
            stateNode.passiveEffectDuration = 0;
          }
          var nextProps = workInProgress.pendingProps;
          var nextChildren = nextProps.children;
          reconcileChildren(current, workInProgress, nextChildren, renderLanes);
          return workInProgress.child;
        }

        function markRef(current, workInProgress) {
          var ref = workInProgress.ref;

          if (current === null && ref !== null || current !== null && current.ref !== ref) {
            // Schedule a Ref effect
            workInProgress.flags |= Ref;
          }
        }

        function updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
          {
            if (workInProgress.type !== workInProgress.elementType) {
              // Lazy component props can't be validated in createElement
              // because they're only guaranteed to be resolved here.
              var innerPropTypes = Component.propTypes;

              if (innerPropTypes) {
                checkPropTypes(innerPropTypes, nextProps, // Resolved props
                'prop', getComponentName(Component));
              }
            }
          }
          var context;
          {
            var unmaskedContext = getUnmaskedContext(workInProgress, Component, true);
            context = getMaskedContext(workInProgress, unmaskedContext);
          }
          var nextChildren;
          prepareToReadContext(workInProgress, renderLanes);
          {
            ReactCurrentOwner$1.current = workInProgress;
            setIsRendering(true);
            nextChildren = renderWithHooks(current, workInProgress, Component, nextProps, context, renderLanes);

            if (workInProgress.mode & StrictMode) {
              disableLogs();

              try {
                nextChildren = renderWithHooks(current, workInProgress, Component, nextProps, context, renderLanes);
              } finally {
                reenableLogs();
              }
            }

            setIsRendering(false);
          }

          if (current !== null && !didReceiveUpdate) {
            bailoutHooks(current, workInProgress, renderLanes);
            return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
          } // React DevTools reads this flag.


          workInProgress.flags |= PerformedWork;
          reconcileChildren(current, workInProgress, nextChildren, renderLanes);
          return workInProgress.child;
        }

        function updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
          {
            if (workInProgress.type !== workInProgress.elementType) {
              // Lazy component props can't be validated in createElement
              // because they're only guaranteed to be resolved here.
              var innerPropTypes = Component.propTypes;

              if (innerPropTypes) {
                checkPropTypes(innerPropTypes, nextProps, // Resolved props
                'prop', getComponentName(Component));
              }
            }
          } // Push context providers early to prevent context stack mismatches.
          // During mounting we don't know the child context yet as the instance doesn't exist.
          // We will invalidate the child context in finishClassComponent() right after rendering.

          var hasContext;

          if (isContextProvider(Component)) {
            hasContext = true;
            pushContextProvider(workInProgress);
          } else {
            hasContext = false;
          }

          prepareToReadContext(workInProgress, renderLanes);
          var instance = workInProgress.stateNode;
          var shouldUpdate;

          if (instance === null) {
            if (current !== null) {
              // A class component without an instance only mounts if it suspended
              // inside a non-concurrent tree, in an inconsistent state. We want to
              // treat it like a new mount, even though an empty version of it already
              // committed. Disconnect the alternate pointers.
              current.alternate = null;
              workInProgress.alternate = null; // Since this is conceptually a new fiber, schedule a Placement effect

              workInProgress.flags |= Placement;
            } // In the initial pass we might need to construct the instance.


            constructClassInstance(workInProgress, Component, nextProps);
            mountClassInstance(workInProgress, Component, nextProps, renderLanes);
            shouldUpdate = true;
          } else if (current === null) {
            // In a resume, we'll already have an instance we can reuse.
            shouldUpdate = resumeMountClassInstance(workInProgress, Component, nextProps, renderLanes);
          } else {
            shouldUpdate = updateClassInstance(current, workInProgress, Component, nextProps, renderLanes);
          }

          var nextUnitOfWork = finishClassComponent(current, workInProgress, Component, shouldUpdate, hasContext, renderLanes);
          {
            var inst = workInProgress.stateNode;

            if (shouldUpdate && inst.props !== nextProps) {
              if (!didWarnAboutReassigningProps) {
                error('It looks like %s is reassigning its own `this.props` while rendering. ' + 'This is not supported and can lead to confusing bugs.', getComponentName(workInProgress.type) || 'a component');
              }

              didWarnAboutReassigningProps = true;
            }
          }
          return nextUnitOfWork;
        }

        function finishClassComponent(current, workInProgress, Component, shouldUpdate, hasContext, renderLanes) {
          // Refs should update even if shouldComponentUpdate returns false
          markRef(current, workInProgress);
          var didCaptureError = (workInProgress.flags & DidCapture) !== NoFlags;

          if (!shouldUpdate && !didCaptureError) {
            // Context providers should defer to sCU for rendering
            if (hasContext) {
              invalidateContextProvider(workInProgress, Component, false);
            }

            return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
          }

          var instance = workInProgress.stateNode; // Rerender

          ReactCurrentOwner$1.current = workInProgress;
          var nextChildren;

          if (didCaptureError && typeof Component.getDerivedStateFromError !== 'function') {
            // If we captured an error, but getDerivedStateFromError is not defined,
            // unmount all the children. componentDidCatch will schedule an update to
            // re-render a fallback. This is temporary until we migrate everyone to
            // the new API.
            // TODO: Warn in a future release.
            nextChildren = null;
            {
              stopProfilerTimerIfRunning();
            }
          } else {
            {
              setIsRendering(true);
              nextChildren = instance.render();

              if (workInProgress.mode & StrictMode) {
                disableLogs();

                try {
                  instance.render();
                } finally {
                  reenableLogs();
                }
              }

              setIsRendering(false);
            }
          } // React DevTools reads this flag.


          workInProgress.flags |= PerformedWork;

          if (current !== null && didCaptureError) {
            // If we're recovering from an error, reconcile without reusing any of
            // the existing children. Conceptually, the normal children and the children
            // that are shown on error are two different sets, so we shouldn't reuse
            // normal children even if their identities match.
            forceUnmountCurrentAndReconcile(current, workInProgress, nextChildren, renderLanes);
          } else {
            reconcileChildren(current, workInProgress, nextChildren, renderLanes);
          } // Memoize state using the values we just used to render.
          // TODO: Restructure so we never read values from the instance.


          workInProgress.memoizedState = instance.state; // The context might have changed so we need to recalculate it.

          if (hasContext) {
            invalidateContextProvider(workInProgress, Component, true);
          }

          return workInProgress.child;
        }

        function pushHostRootContext(workInProgress) {
          var root = workInProgress.stateNode;

          if (root.pendingContext) {
            pushTopLevelContextObject(workInProgress, root.pendingContext, root.pendingContext !== root.context);
          } else if (root.context) {
            // Should always be set
            pushTopLevelContextObject(workInProgress, root.context, false);
          }

          pushHostContainer(workInProgress, root.containerInfo);
        }

        function updateHostRoot(current, workInProgress, renderLanes) {
          pushHostRootContext(workInProgress);
          var updateQueue = workInProgress.updateQueue;

          if (!(current !== null && updateQueue !== null)) {
            {
              throw Error("If the root does not have an updateQueue, we should have already bailed out. This error is likely caused by a bug in React. Please file an issue.");
            }
          }

          var nextProps = workInProgress.pendingProps;
          var prevState = workInProgress.memoizedState;
          var prevChildren = prevState !== null ? prevState.element : null;
          cloneUpdateQueue(current, workInProgress);
          processUpdateQueue(workInProgress, nextProps, null, renderLanes);
          var nextState = workInProgress.memoizedState; // Caution: React DevTools currently depends on this property
          // being called "element".

          var nextChildren = nextState.element;

          if (nextChildren === prevChildren) {
            resetHydrationState();
            return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
          }

          var root = workInProgress.stateNode;

          if (root.hydrate && enterHydrationState(workInProgress)) {
            // If we don't have any current children this might be the first pass.
            // We always try to hydrate. If this isn't a hydration pass there won't
            // be any children to hydrate which is effectively the same thing as
            // not hydrating.
            {
              var mutableSourceEagerHydrationData = root.mutableSourceEagerHydrationData;

              if (mutableSourceEagerHydrationData != null) {
                for (var i = 0; i < mutableSourceEagerHydrationData.length; i += 2) {
                  var mutableSource = mutableSourceEagerHydrationData[i];
                  var version = mutableSourceEagerHydrationData[i + 1];
                  setWorkInProgressVersion(mutableSource, version);
                }
              }
            }
            var child = mountChildFibers(workInProgress, null, nextChildren, renderLanes);
            workInProgress.child = child;
            var node = child;

            while (node) {
              // Mark each child as hydrating. This is a fast path to know whether this
              // tree is part of a hydrating tree. This is used to determine if a child
              // node has fully mounted yet, and for scheduling event replaying.
              // Conceptually this is similar to Placement in that a new subtree is
              // inserted into the React tree here. It just happens to not need DOM
              // mutations because it already exists.
              node.flags = node.flags & ~Placement | Hydrating;
              node = node.sibling;
            }
          } else {
            // Otherwise reset hydration state in case we aborted and resumed another
            // root.
            reconcileChildren(current, workInProgress, nextChildren, renderLanes);
            resetHydrationState();
          }

          return workInProgress.child;
        }

        function updateHostComponent(current, workInProgress, renderLanes) {
          pushHostContext(workInProgress);

          if (current === null) {
            tryToClaimNextHydratableInstance(workInProgress);
          }

          var type = workInProgress.type;
          var nextProps = workInProgress.pendingProps;
          var prevProps = current !== null ? current.memoizedProps : null;
          var nextChildren = nextProps.children;
          var isDirectTextChild = shouldSetTextContent(type, nextProps);

          if (isDirectTextChild) {
            // We special case a direct text child of a host node. This is a common
            // case. We won't handle it as a reified child. We will instead handle
            // this in the host environment that also has access to this prop. That
            // avoids allocating another HostText fiber and traversing it.
            nextChildren = null;
          } else if (prevProps !== null && shouldSetTextContent(type, prevProps)) {
            // If we're switching from a direct text child to a normal child, or to
            // empty, we need to schedule the text content to be reset.
            workInProgress.flags |= ContentReset;
          }

          markRef(current, workInProgress);
          reconcileChildren(current, workInProgress, nextChildren, renderLanes);
          return workInProgress.child;
        }

        function updateHostText(current, workInProgress) {
          if (current === null) {
            tryToClaimNextHydratableInstance(workInProgress);
          } // Nothing to do here. This is terminal. We'll do the completion step
          // immediately after.


          return null;
        }

        function mountLazyComponent(_current, workInProgress, elementType, updateLanes, renderLanes) {
          if (_current !== null) {
            // A lazy component only mounts if it suspended inside a non-
            // concurrent tree, in an inconsistent state. We want to treat it like
            // a new mount, even though an empty version of it already committed.
            // Disconnect the alternate pointers.
            _current.alternate = null;
            workInProgress.alternate = null; // Since this is conceptually a new fiber, schedule a Placement effect

            workInProgress.flags |= Placement;
          }

          var props = workInProgress.pendingProps;
          var lazyComponent = elementType;
          var payload = lazyComponent._payload;
          var init = lazyComponent._init;
          var Component = init(payload); // Store the unwrapped component in the type.

          workInProgress.type = Component;
          var resolvedTag = workInProgress.tag = resolveLazyComponentTag(Component);
          var resolvedProps = resolveDefaultProps(Component, props);
          var child;

          switch (resolvedTag) {
            case FunctionComponent:
              {
                {
                  validateFunctionComponentInDev(workInProgress, Component);
                  workInProgress.type = Component = resolveFunctionForHotReloading(Component);
                }
                child = updateFunctionComponent(null, workInProgress, Component, resolvedProps, renderLanes);
                return child;
              }

            case ClassComponent:
              {
                {
                  workInProgress.type = Component = resolveClassForHotReloading(Component);
                }
                child = updateClassComponent(null, workInProgress, Component, resolvedProps, renderLanes);
                return child;
              }

            case ForwardRef:
              {
                {
                  workInProgress.type = Component = resolveForwardRefForHotReloading(Component);
                }
                child = updateForwardRef(null, workInProgress, Component, resolvedProps, renderLanes);
                return child;
              }

            case MemoComponent:
              {
                {
                  if (workInProgress.type !== workInProgress.elementType) {
                    var outerPropTypes = Component.propTypes;

                    if (outerPropTypes) {
                      checkPropTypes(outerPropTypes, resolvedProps, // Resolved for outer only
                      'prop', getComponentName(Component));
                    }
                  }
                }
                child = updateMemoComponent(null, workInProgress, Component, resolveDefaultProps(Component.type, resolvedProps), // The inner type can have defaults too
                updateLanes, renderLanes);
                return child;
              }
          }

          var hint = '';
          {
            if (Component !== null && typeof Component === 'object' && Component.$$typeof === REACT_LAZY_TYPE) {
              hint = ' Did you wrap a component in React.lazy() more than once?';
            }
          } // This message intentionally doesn't mention ForwardRef or MemoComponent
          // because the fact that it's a separate type of work is an
          // implementation detail.

          {
            {
              throw Error("Element type is invalid. Received a promise that resolves to: " + Component + ". Lazy element type must resolve to a class or function." + hint);
            }
          }
        }

        function mountIncompleteClassComponent(_current, workInProgress, Component, nextProps, renderLanes) {
          if (_current !== null) {
            // An incomplete component only mounts if it suspended inside a non-
            // concurrent tree, in an inconsistent state. We want to treat it like
            // a new mount, even though an empty version of it already committed.
            // Disconnect the alternate pointers.
            _current.alternate = null;
            workInProgress.alternate = null; // Since this is conceptually a new fiber, schedule a Placement effect

            workInProgress.flags |= Placement;
          } // Promote the fiber to a class and try rendering again.


          workInProgress.tag = ClassComponent; // The rest of this function is a fork of `updateClassComponent`
          // Push context providers early to prevent context stack mismatches.
          // During mounting we don't know the child context yet as the instance doesn't exist.
          // We will invalidate the child context in finishClassComponent() right after rendering.

          var hasContext;

          if (isContextProvider(Component)) {
            hasContext = true;
            pushContextProvider(workInProgress);
          } else {
            hasContext = false;
          }

          prepareToReadContext(workInProgress, renderLanes);
          constructClassInstance(workInProgress, Component, nextProps);
          mountClassInstance(workInProgress, Component, nextProps, renderLanes);
          return finishClassComponent(null, workInProgress, Component, true, hasContext, renderLanes);
        }

        function mountIndeterminateComponent(_current, workInProgress, Component, renderLanes) {
          if (_current !== null) {
            // An indeterminate component only mounts if it suspended inside a non-
            // concurrent tree, in an inconsistent state. We want to treat it like
            // a new mount, even though an empty version of it already committed.
            // Disconnect the alternate pointers.
            _current.alternate = null;
            workInProgress.alternate = null; // Since this is conceptually a new fiber, schedule a Placement effect

            workInProgress.flags |= Placement;
          }

          var props = workInProgress.pendingProps;
          var context;
          {
            var unmaskedContext = getUnmaskedContext(workInProgress, Component, false);
            context = getMaskedContext(workInProgress, unmaskedContext);
          }
          prepareToReadContext(workInProgress, renderLanes);
          var value;
          {
            if (Component.prototype && typeof Component.prototype.render === 'function') {
              var componentName = getComponentName(Component) || 'Unknown';

              if (!didWarnAboutBadClass[componentName]) {
                error("The <%s /> component appears to have a render method, but doesn't extend React.Component. " + 'This is likely to cause errors. Change %s to extend React.Component instead.', componentName, componentName);
                didWarnAboutBadClass[componentName] = true;
              }
            }

            if (workInProgress.mode & StrictMode) {
              ReactStrictModeWarnings.recordLegacyContextWarning(workInProgress, null);
            }

            setIsRendering(true);
            ReactCurrentOwner$1.current = workInProgress;
            value = renderWithHooks(null, workInProgress, Component, props, context, renderLanes);
            setIsRendering(false);
          } // React DevTools reads this flag.

          workInProgress.flags |= PerformedWork;
          {
            // Support for module components is deprecated and is removed behind a flag.
            // Whether or not it would crash later, we want to show a good message in DEV first.
            if (typeof value === 'object' && value !== null && typeof value.render === 'function' && value.$$typeof === undefined) {
              var _componentName = getComponentName(Component) || 'Unknown';

              if (!didWarnAboutModulePatternComponent[_componentName]) {
                error('The <%s /> component appears to be a function component that returns a class instance. ' + 'Change %s to a class that extends React.Component instead. ' + "If you can't use a class try assigning the prototype on the function as a workaround. " + "`%s.prototype = React.Component.prototype`. Don't use an arrow function since it " + 'cannot be called with `new` by React.', _componentName, _componentName, _componentName);
                didWarnAboutModulePatternComponent[_componentName] = true;
              }
            }
          }

          if ( // Run these checks in production only if the flag is off.
          // Eventually we'll delete this branch altogether.
          typeof value === 'object' && value !== null && typeof value.render === 'function' && value.$$typeof === undefined) {
            {
              var _componentName2 = getComponentName(Component) || 'Unknown';

              if (!didWarnAboutModulePatternComponent[_componentName2]) {
                error('The <%s /> component appears to be a function component that returns a class instance. ' + 'Change %s to a class that extends React.Component instead. ' + "If you can't use a class try assigning the prototype on the function as a workaround. " + "`%s.prototype = React.Component.prototype`. Don't use an arrow function since it " + 'cannot be called with `new` by React.', _componentName2, _componentName2, _componentName2);
                didWarnAboutModulePatternComponent[_componentName2] = true;
              }
            } // Proceed under the assumption that this is a class instance

            workInProgress.tag = ClassComponent; // Throw out any hooks that were used.

            workInProgress.memoizedState = null;
            workInProgress.updateQueue = null; // Push context providers early to prevent context stack mismatches.
            // During mounting we don't know the child context yet as the instance doesn't exist.
            // We will invalidate the child context in finishClassComponent() right after rendering.

            var hasContext = false;

            if (isContextProvider(Component)) {
              hasContext = true;
              pushContextProvider(workInProgress);
            } else {
              hasContext = false;
            }

            workInProgress.memoizedState = value.state !== null && value.state !== undefined ? value.state : null;
            initializeUpdateQueue(workInProgress);
            var getDerivedStateFromProps = Component.getDerivedStateFromProps;

            if (typeof getDerivedStateFromProps === 'function') {
              applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, props);
            }

            adoptClassInstance(workInProgress, value);
            mountClassInstance(workInProgress, Component, props, renderLanes);
            return finishClassComponent(null, workInProgress, Component, true, hasContext, renderLanes);
          } else {
            // Proceed under the assumption that this is a function component
            workInProgress.tag = FunctionComponent;
            {
              if (workInProgress.mode & StrictMode) {
                disableLogs();

                try {
                  value = renderWithHooks(null, workInProgress, Component, props, context, renderLanes);
                } finally {
                  reenableLogs();
                }
              }
            }
            reconcileChildren(null, workInProgress, value, renderLanes);
            {
              validateFunctionComponentInDev(workInProgress, Component);
            }
            return workInProgress.child;
          }
        }

        function validateFunctionComponentInDev(workInProgress, Component) {
          {
            if (Component) {
              if (Component.childContextTypes) {
                error('%s(...): childContextTypes cannot be defined on a function component.', Component.displayName || Component.name || 'Component');
              }
            }

            if (workInProgress.ref !== null) {
              var info = '';
              var ownerName = getCurrentFiberOwnerNameInDevOrNull();

              if (ownerName) {
                info += '\n\nCheck the render method of `' + ownerName + '`.';
              }

              var warningKey = ownerName || workInProgress._debugID || '';
              var debugSource = workInProgress._debugSource;

              if (debugSource) {
                warningKey = debugSource.fileName + ':' + debugSource.lineNumber;
              }

              if (!didWarnAboutFunctionRefs[warningKey]) {
                didWarnAboutFunctionRefs[warningKey] = true;
                error('Function components cannot be given refs. ' + 'Attempts to access this ref will fail. ' + 'Did you mean to use React.forwardRef()?%s', info);
              }
            }

            if (typeof Component.getDerivedStateFromProps === 'function') {
              var _componentName3 = getComponentName(Component) || 'Unknown';

              if (!didWarnAboutGetDerivedStateOnFunctionComponent[_componentName3]) {
                error('%s: Function components do not support getDerivedStateFromProps.', _componentName3);
                didWarnAboutGetDerivedStateOnFunctionComponent[_componentName3] = true;
              }
            }

            if (typeof Component.contextType === 'object' && Component.contextType !== null) {
              var _componentName4 = getComponentName(Component) || 'Unknown';

              if (!didWarnAboutContextTypeOnFunctionComponent[_componentName4]) {
                error('%s: Function components do not support contextType.', _componentName4);
                didWarnAboutContextTypeOnFunctionComponent[_componentName4] = true;
              }
            }
          }
        }

        var SUSPENDED_MARKER = {
          dehydrated: null,
          retryLane: NoLane
        };

        function mountSuspenseOffscreenState(renderLanes) {
          return {
            baseLanes: renderLanes
          };
        }

        function updateSuspenseOffscreenState(prevOffscreenState, renderLanes) {
          return {
            baseLanes: mergeLanes(prevOffscreenState.baseLanes, renderLanes)
          };
        } // TODO: Probably should inline this back


        function shouldRemainOnFallback(suspenseContext, current, workInProgress, renderLanes) {
          // If we're already showing a fallback, there are cases where we need to
          // remain on that fallback regardless of whether the content has resolved.
          // For example, SuspenseList coordinates when nested content appears.
          if (current !== null) {
            var suspenseState = current.memoizedState;

            if (suspenseState === null) {
              // Currently showing content. Don't hide it, even if ForceSuspenseFallack
              // is true. More precise name might be "ForceRemainSuspenseFallback".
              // Note: This is a factoring smell. Can't remain on a fallback if there's
              // no fallback to remain on.
              return false;
            }
          } // Not currently showing content. Consult the Suspense context.


          return hasSuspenseContext(suspenseContext, ForceSuspenseFallback);
        }

        function getRemainingWorkInPrimaryTree(current, renderLanes) {
          // TODO: Should not remove render lanes that were pinged during this render
          return removeLanes(current.childLanes, renderLanes);
        }

        function updateSuspenseComponent(current, workInProgress, renderLanes) {
          var nextProps = workInProgress.pendingProps; // This is used by DevTools to force a boundary to suspend.

          {
            if (shouldSuspend(workInProgress)) {
              workInProgress.flags |= DidCapture;
            }
          }
          var suspenseContext = suspenseStackCursor.current;
          var showFallback = false;
          var didSuspend = (workInProgress.flags & DidCapture) !== NoFlags;

          if (didSuspend || shouldRemainOnFallback(suspenseContext, current)) {
            // Something in this boundary's subtree already suspended. Switch to
            // rendering the fallback children.
            showFallback = true;
            workInProgress.flags &= ~DidCapture;
          } else {
            // Attempting the main content
            if (current === null || current.memoizedState !== null) {
              // This is a new mount or this boundary is already showing a fallback state.
              // Mark this subtree context as having at least one invisible parent that could
              // handle the fallback state.
              // Boundaries without fallbacks or should be avoided are not considered since
              // they cannot handle preferred fallback states.
              if (nextProps.fallback !== undefined && nextProps.unstable_avoidThisFallback !== true) {
                suspenseContext = addSubtreeSuspenseContext(suspenseContext, InvisibleParentSuspenseContext);
              }
            }
          }

          suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
          pushSuspenseContext(workInProgress, suspenseContext); // OK, the next part is confusing. We're about to reconcile the Suspense
          // boundary's children. This involves some custom reconcilation logic. Two
          // main reasons this is so complicated.
          //
          // First, Legacy Mode has different semantics for backwards compatibility. The
          // primary tree will commit in an inconsistent state, so when we do the
          // second pass to render the fallback, we do some exceedingly, uh, clever
          // hacks to make that not totally break. Like transferring effects and
          // deletions from hidden tree. In Concurrent Mode, it's much simpler,
          // because we bailout on the primary tree completely and leave it in its old
          // state, no effects. Same as what we do for Offscreen (except that
          // Offscreen doesn't have the first render pass).
          //
          // Second is hydration. During hydration, the Suspense fiber has a slightly
          // different layout, where the child points to a dehydrated fragment, which
          // contains the DOM rendered by the server.
          //
          // Third, even if you set all that aside, Suspense is like error boundaries in
          // that we first we try to render one tree, and if that fails, we render again
          // and switch to a different tree. Like a try/catch block. So we have to track
          // which branch we're currently rendering. Ideally we would model this using
          // a stack.

          if (current === null) {
            // Initial mount
            // If we're currently hydrating, try to hydrate this boundary.
            // But only if this has a fallback.
            if (nextProps.fallback !== undefined) {
              tryToClaimNextHydratableInstance(workInProgress); // This could've been a dehydrated suspense component.
            }

            var nextPrimaryChildren = nextProps.children;
            var nextFallbackChildren = nextProps.fallback;

            if (showFallback) {
              var fallbackFragment = mountSuspenseFallbackChildren(workInProgress, nextPrimaryChildren, nextFallbackChildren, renderLanes);
              var primaryChildFragment = workInProgress.child;
              primaryChildFragment.memoizedState = mountSuspenseOffscreenState(renderLanes);
              workInProgress.memoizedState = SUSPENDED_MARKER;
              return fallbackFragment;
            } else if (typeof nextProps.unstable_expectedLoadTime === 'number') {
              // This is a CPU-bound tree. Skip this tree and show a placeholder to
              // unblock the surrounding content. Then immediately retry after the
              // initial commit.
              var _fallbackFragment = mountSuspenseFallbackChildren(workInProgress, nextPrimaryChildren, nextFallbackChildren, renderLanes);

              var _primaryChildFragment = workInProgress.child;
              _primaryChildFragment.memoizedState = mountSuspenseOffscreenState(renderLanes);
              workInProgress.memoizedState = SUSPENDED_MARKER; // Since nothing actually suspended, there will nothing to ping this to
              // get it started back up to attempt the next item. While in terms of
              // priority this work has the same priority as this current render, it's
              // not part of the same transition once the transition has committed. If
              // it's sync, we still want to yield so that it can be painted.
              // Conceptually, this is really the same as pinging. We can use any
              // RetryLane even if it's the one currently rendering since we're leaving
              // it behind on this node.

              workInProgress.lanes = SomeRetryLane;
              {
                markSpawnedWork(SomeRetryLane);
              }
              return _fallbackFragment;
            } else {
              return mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren, renderLanes);
            }
          } else {
            // This is an update.
            // If the current fiber has a SuspenseState, that means it's already showing
            // a fallback.
            var prevState = current.memoizedState;

            if (prevState !== null) {
              if (showFallback) {
                var _nextFallbackChildren2 = nextProps.fallback;
                var _nextPrimaryChildren2 = nextProps.children;

                var _fallbackChildFragment = updateSuspenseFallbackChildren(current, workInProgress, _nextPrimaryChildren2, _nextFallbackChildren2, renderLanes);

                var _primaryChildFragment3 = workInProgress.child;
                var prevOffscreenState = current.child.memoizedState;
                _primaryChildFragment3.memoizedState = prevOffscreenState === null ? mountSuspenseOffscreenState(renderLanes) : updateSuspenseOffscreenState(prevOffscreenState, renderLanes);
                _primaryChildFragment3.childLanes = getRemainingWorkInPrimaryTree(current, renderLanes);
                workInProgress.memoizedState = SUSPENDED_MARKER;
                return _fallbackChildFragment;
              } else {
                var _nextPrimaryChildren3 = nextProps.children;

                var _primaryChildFragment4 = updateSuspensePrimaryChildren(current, workInProgress, _nextPrimaryChildren3, renderLanes);

                workInProgress.memoizedState = null;
                return _primaryChildFragment4;
              }
            } else {
              // The current tree is not already showing a fallback.
              if (showFallback) {
                // Timed out.
                var _nextFallbackChildren3 = nextProps.fallback;
                var _nextPrimaryChildren4 = nextProps.children;

                var _fallbackChildFragment2 = updateSuspenseFallbackChildren(current, workInProgress, _nextPrimaryChildren4, _nextFallbackChildren3, renderLanes);

                var _primaryChildFragment5 = workInProgress.child;
                var _prevOffscreenState = current.child.memoizedState;
                _primaryChildFragment5.memoizedState = _prevOffscreenState === null ? mountSuspenseOffscreenState(renderLanes) : updateSuspenseOffscreenState(_prevOffscreenState, renderLanes);
                _primaryChildFragment5.childLanes = getRemainingWorkInPrimaryTree(current, renderLanes); // Skip the primary children, and continue working on the
                // fallback children.

                workInProgress.memoizedState = SUSPENDED_MARKER;
                return _fallbackChildFragment2;
              } else {
                // Still haven't timed out. Continue rendering the children, like we
                // normally do.
                var _nextPrimaryChildren5 = nextProps.children;

                var _primaryChildFragment6 = updateSuspensePrimaryChildren(current, workInProgress, _nextPrimaryChildren5, renderLanes);

                workInProgress.memoizedState = null;
                return _primaryChildFragment6;
              }
            }
          }
        }

        function mountSuspensePrimaryChildren(workInProgress, primaryChildren, renderLanes) {
          var mode = workInProgress.mode;
          var primaryChildProps = {
            mode: 'visible',
            children: primaryChildren
          };
          var primaryChildFragment = createFiberFromOffscreen(primaryChildProps, mode, renderLanes, null);
          primaryChildFragment.return = workInProgress;
          workInProgress.child = primaryChildFragment;
          return primaryChildFragment;
        }

        function mountSuspenseFallbackChildren(workInProgress, primaryChildren, fallbackChildren, renderLanes) {
          var mode = workInProgress.mode;
          var progressedPrimaryFragment = workInProgress.child;
          var primaryChildProps = {
            mode: 'hidden',
            children: primaryChildren
          };
          var primaryChildFragment;
          var fallbackChildFragment;

          if ((mode & BlockingMode) === NoMode && progressedPrimaryFragment !== null) {
            // In legacy mode, we commit the primary tree as if it successfully
            // completed, even though it's in an inconsistent state.
            primaryChildFragment = progressedPrimaryFragment;
            primaryChildFragment.childLanes = NoLanes;
            primaryChildFragment.pendingProps = primaryChildProps;

            if (workInProgress.mode & ProfileMode) {
              // Reset the durations from the first pass so they aren't included in the
              // final amounts. This seems counterintuitive, since we're intentionally
              // not measuring part of the render phase, but this makes it match what we
              // do in Concurrent Mode.
              primaryChildFragment.actualDuration = 0;
              primaryChildFragment.actualStartTime = -1;
              primaryChildFragment.selfBaseDuration = 0;
              primaryChildFragment.treeBaseDuration = 0;
            }

            fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode, renderLanes, null);
          } else {
            primaryChildFragment = createFiberFromOffscreen(primaryChildProps, mode, NoLanes, null);
            fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode, renderLanes, null);
          }

          primaryChildFragment.return = workInProgress;
          fallbackChildFragment.return = workInProgress;
          primaryChildFragment.sibling = fallbackChildFragment;
          workInProgress.child = primaryChildFragment;
          return fallbackChildFragment;
        }

        function createWorkInProgressOffscreenFiber(current, offscreenProps) {
          // The props argument to `createWorkInProgress` is `any` typed, so we use this
          // wrapper function to constrain it.
          return createWorkInProgress(current, offscreenProps);
        }

        function updateSuspensePrimaryChildren(current, workInProgress, primaryChildren, renderLanes) {
          var currentPrimaryChildFragment = current.child;
          var currentFallbackChildFragment = currentPrimaryChildFragment.sibling;
          var primaryChildFragment = createWorkInProgressOffscreenFiber(currentPrimaryChildFragment, {
            mode: 'visible',
            children: primaryChildren
          });

          if ((workInProgress.mode & BlockingMode) === NoMode) {
            primaryChildFragment.lanes = renderLanes;
          }

          primaryChildFragment.return = workInProgress;
          primaryChildFragment.sibling = null;

          if (currentFallbackChildFragment !== null) {
            // Delete the fallback child fragment
            currentFallbackChildFragment.nextEffect = null;
            currentFallbackChildFragment.flags = Deletion;
            workInProgress.firstEffect = workInProgress.lastEffect = currentFallbackChildFragment;
          }

          workInProgress.child = primaryChildFragment;
          return primaryChildFragment;
        }

        function updateSuspenseFallbackChildren(current, workInProgress, primaryChildren, fallbackChildren, renderLanes) {
          var mode = workInProgress.mode;
          var currentPrimaryChildFragment = current.child;
          var currentFallbackChildFragment = currentPrimaryChildFragment.sibling;
          var primaryChildProps = {
            mode: 'hidden',
            children: primaryChildren
          };
          var primaryChildFragment;

          if ( // In legacy mode, we commit the primary tree as if it successfully
          // completed, even though it's in an inconsistent state.
          (mode & BlockingMode) === NoMode && // Make sure we're on the second pass, i.e. the primary child fragment was
          // already cloned. In legacy mode, the only case where this isn't true is
          // when DevTools forces us to display a fallback; we skip the first render
          // pass entirely and go straight to rendering the fallback. (In Concurrent
          // Mode, SuspenseList can also trigger this scenario, but this is a legacy-
          // only codepath.)
          workInProgress.child !== currentPrimaryChildFragment) {
            var progressedPrimaryFragment = workInProgress.child;
            primaryChildFragment = progressedPrimaryFragment;
            primaryChildFragment.childLanes = NoLanes;
            primaryChildFragment.pendingProps = primaryChildProps;

            if (workInProgress.mode & ProfileMode) {
              // Reset the durations from the first pass so they aren't included in the
              // final amounts. This seems counterintuitive, since we're intentionally
              // not measuring part of the render phase, but this makes it match what we
              // do in Concurrent Mode.
              primaryChildFragment.actualDuration = 0;
              primaryChildFragment.actualStartTime = -1;
              primaryChildFragment.selfBaseDuration = currentPrimaryChildFragment.selfBaseDuration;
              primaryChildFragment.treeBaseDuration = currentPrimaryChildFragment.treeBaseDuration;
            } // The fallback fiber was added as a deletion effect during the first pass.
            // However, since we're going to remain on the fallback, we no longer want
            // to delete it. So we need to remove it from the list. Deletions are stored
            // on the same list as effects. We want to keep the effects from the primary
            // tree. So we copy the primary child fragment's effect list, which does not
            // include the fallback deletion effect.


            var progressedLastEffect = primaryChildFragment.lastEffect;

            if (progressedLastEffect !== null) {
              workInProgress.firstEffect = primaryChildFragment.firstEffect;
              workInProgress.lastEffect = progressedLastEffect;
              progressedLastEffect.nextEffect = null;
            } else {
              // TODO: Reset this somewhere else? Lol legacy mode is so weird.
              workInProgress.firstEffect = workInProgress.lastEffect = null;
            }
          } else {
            primaryChildFragment = createWorkInProgressOffscreenFiber(currentPrimaryChildFragment, primaryChildProps);
          }

          var fallbackChildFragment;

          if (currentFallbackChildFragment !== null) {
            fallbackChildFragment = createWorkInProgress(currentFallbackChildFragment, fallbackChildren);
          } else {
            fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode, renderLanes, null); // Needs a placement effect because the parent (the Suspense boundary) already
            // mounted but this is a new fiber.

            fallbackChildFragment.flags |= Placement;
          }

          fallbackChildFragment.return = workInProgress;
          primaryChildFragment.return = workInProgress;
          primaryChildFragment.sibling = fallbackChildFragment;
          workInProgress.child = primaryChildFragment;
          return fallbackChildFragment;
        }

        function scheduleWorkOnFiber(fiber, renderLanes) {
          fiber.lanes = mergeLanes(fiber.lanes, renderLanes);
          var alternate = fiber.alternate;

          if (alternate !== null) {
            alternate.lanes = mergeLanes(alternate.lanes, renderLanes);
          }

          scheduleWorkOnParentPath(fiber.return, renderLanes);
        }

        function propagateSuspenseContextChange(workInProgress, firstChild, renderLanes) {
          // Mark any Suspense boundaries with fallbacks as having work to do.
          // If they were previously forced into fallbacks, they may now be able
          // to unblock.
          var node = firstChild;

          while (node !== null) {
            if (node.tag === SuspenseComponent) {
              var state = node.memoizedState;

              if (state !== null) {
                scheduleWorkOnFiber(node, renderLanes);
              }
            } else if (node.tag === SuspenseListComponent) {
              // If the tail is hidden there might not be an Suspense boundaries
              // to schedule work on. In this case we have to schedule it on the
              // list itself.
              // We don't have to traverse to the children of the list since
              // the list will propagate the change when it rerenders.
              scheduleWorkOnFiber(node, renderLanes);
            } else if (node.child !== null) {
              node.child.return = node;
              node = node.child;
              continue;
            }

            if (node === workInProgress) {
              return;
            }

            while (node.sibling === null) {
              if (node.return === null || node.return === workInProgress) {
                return;
              }

              node = node.return;
            }

            node.sibling.return = node.return;
            node = node.sibling;
          }
        }

        function findLastContentRow(firstChild) {
          // This is going to find the last row among these children that is already
          // showing content on the screen, as opposed to being in fallback state or
          // new. If a row has multiple Suspense boundaries, any of them being in the
          // fallback state, counts as the whole row being in a fallback state.
          // Note that the "rows" will be workInProgress, but any nested children
          // will still be current since we haven't rendered them yet. The mounted
          // order may not be the same as the new order. We use the new order.
          var row = firstChild;
          var lastContentRow = null;

          while (row !== null) {
            var currentRow = row.alternate; // New rows can't be content rows.

            if (currentRow !== null && findFirstSuspended(currentRow) === null) {
              lastContentRow = row;
            }

            row = row.sibling;
          }

          return lastContentRow;
        }

        function validateRevealOrder(revealOrder) {
          {
            if (revealOrder !== undefined && revealOrder !== 'forwards' && revealOrder !== 'backwards' && revealOrder !== 'together' && !didWarnAboutRevealOrder[revealOrder]) {
              didWarnAboutRevealOrder[revealOrder] = true;

              if (typeof revealOrder === 'string') {
                switch (revealOrder.toLowerCase()) {
                  case 'together':
                  case 'forwards':
                  case 'backwards':
                    {
                      error('"%s" is not a valid value for revealOrder on <SuspenseList />. ' + 'Use lowercase "%s" instead.', revealOrder, revealOrder.toLowerCase());
                      break;
                    }

                  case 'forward':
                  case 'backward':
                    {
                      error('"%s" is not a valid value for revealOrder on <SuspenseList />. ' + 'React uses the -s suffix in the spelling. Use "%ss" instead.', revealOrder, revealOrder.toLowerCase());
                      break;
                    }

                  default:
                    error('"%s" is not a supported revealOrder on <SuspenseList />. ' + 'Did you mean "together", "forwards" or "backwards"?', revealOrder);
                    break;
                }
              } else {
                error('%s is not a supported value for revealOrder on <SuspenseList />. ' + 'Did you mean "together", "forwards" or "backwards"?', revealOrder);
              }
            }
          }
        }

        function validateTailOptions(tailMode, revealOrder) {
          {
            if (tailMode !== undefined && !didWarnAboutTailOptions[tailMode]) {
              if (tailMode !== 'collapsed' && tailMode !== 'hidden') {
                didWarnAboutTailOptions[tailMode] = true;
                error('"%s" is not a supported value for tail on <SuspenseList />. ' + 'Did you mean "collapsed" or "hidden"?', tailMode);
              } else if (revealOrder !== 'forwards' && revealOrder !== 'backwards') {
                didWarnAboutTailOptions[tailMode] = true;
                error('<SuspenseList tail="%s" /> is only valid if revealOrder is ' + '"forwards" or "backwards". ' + 'Did you mean to specify revealOrder="forwards"?', tailMode);
              }
            }
          }
        }

        function validateSuspenseListNestedChild(childSlot, index) {
          {
            var isArray = Array.isArray(childSlot);
            var isIterable = !isArray && typeof getIteratorFn(childSlot) === 'function';

            if (isArray || isIterable) {
              var type = isArray ? 'array' : 'iterable';
              error('A nested %s was passed to row #%s in <SuspenseList />. Wrap it in ' + 'an additional SuspenseList to configure its revealOrder: ' + '<SuspenseList revealOrder=...> ... ' + '<SuspenseList revealOrder=...>{%s}</SuspenseList> ... ' + '</SuspenseList>', type, index, type);
              return false;
            }
          }
          return true;
        }

        function validateSuspenseListChildren(children, revealOrder) {
          {
            if ((revealOrder === 'forwards' || revealOrder === 'backwards') && children !== undefined && children !== null && children !== false) {
              if (Array.isArray(children)) {
                for (var i = 0; i < children.length; i++) {
                  if (!validateSuspenseListNestedChild(children[i], i)) {
                    return;
                  }
                }
              } else {
                var iteratorFn = getIteratorFn(children);

                if (typeof iteratorFn === 'function') {
                  var childrenIterator = iteratorFn.call(children);

                  if (childrenIterator) {
                    var step = childrenIterator.next();
                    var _i = 0;

                    for (; !step.done; step = childrenIterator.next()) {
                      if (!validateSuspenseListNestedChild(step.value, _i)) {
                        return;
                      }

                      _i++;
                    }
                  }
                } else {
                  error('A single row was passed to a <SuspenseList revealOrder="%s" />. ' + 'This is not useful since it needs multiple rows. ' + 'Did you mean to pass multiple children or an array?', revealOrder);
                }
              }
            }
          }
        }

        function initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, lastEffectBeforeRendering) {
          var renderState = workInProgress.memoizedState;

          if (renderState === null) {
            workInProgress.memoizedState = {
              isBackwards: isBackwards,
              rendering: null,
              renderingStartTime: 0,
              last: lastContentRow,
              tail: tail,
              tailMode: tailMode,
              lastEffect: lastEffectBeforeRendering
            };
          } else {
            // We can reuse the existing object from previous renders.
            renderState.isBackwards = isBackwards;
            renderState.rendering = null;
            renderState.renderingStartTime = 0;
            renderState.last = lastContentRow;
            renderState.tail = tail;
            renderState.tailMode = tailMode;
            renderState.lastEffect = lastEffectBeforeRendering;
          }
        } // This can end up rendering this component multiple passes.
        // The first pass splits the children fibers into two sets. A head and tail.
        // We first render the head. If anything is in fallback state, we do another
        // pass through beginWork to rerender all children (including the tail) with
        // the force suspend context. If the first render didn't have anything in
        // in fallback state. Then we render each row in the tail one-by-one.
        // That happens in the completeWork phase without going back to beginWork.


        function updateSuspenseListComponent(current, workInProgress, renderLanes) {
          var nextProps = workInProgress.pendingProps;
          var revealOrder = nextProps.revealOrder;
          var tailMode = nextProps.tail;
          var newChildren = nextProps.children;
          validateRevealOrder(revealOrder);
          validateTailOptions(tailMode, revealOrder);
          validateSuspenseListChildren(newChildren, revealOrder);
          reconcileChildren(current, workInProgress, newChildren, renderLanes);
          var suspenseContext = suspenseStackCursor.current;
          var shouldForceFallback = hasSuspenseContext(suspenseContext, ForceSuspenseFallback);

          if (shouldForceFallback) {
            suspenseContext = setShallowSuspenseContext(suspenseContext, ForceSuspenseFallback);
            workInProgress.flags |= DidCapture;
          } else {
            var didSuspendBefore = current !== null && (current.flags & DidCapture) !== NoFlags;

            if (didSuspendBefore) {
              // If we previously forced a fallback, we need to schedule work
              // on any nested boundaries to let them know to try to render
              // again. This is the same as context updating.
              propagateSuspenseContextChange(workInProgress, workInProgress.child, renderLanes);
            }

            suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
          }

          pushSuspenseContext(workInProgress, suspenseContext);

          if ((workInProgress.mode & BlockingMode) === NoMode) {
            // In legacy mode, SuspenseList doesn't work so we just
            // use make it a noop by treating it as the default revealOrder.
            workInProgress.memoizedState = null;
          } else {
            switch (revealOrder) {
              case 'forwards':
                {
                  var lastContentRow = findLastContentRow(workInProgress.child);
                  var tail;

                  if (lastContentRow === null) {
                    // The whole list is part of the tail.
                    // TODO: We could fast path by just rendering the tail now.
                    tail = workInProgress.child;
                    workInProgress.child = null;
                  } else {
                    // Disconnect the tail rows after the content row.
                    // We're going to render them separately later.
                    tail = lastContentRow.sibling;
                    lastContentRow.sibling = null;
                  }

                  initSuspenseListRenderState(workInProgress, false, // isBackwards
                  tail, lastContentRow, tailMode, workInProgress.lastEffect);
                  break;
                }

              case 'backwards':
                {
                  // We're going to find the first row that has existing content.
                  // At the same time we're going to reverse the list of everything
                  // we pass in the meantime. That's going to be our tail in reverse
                  // order.
                  var _tail = null;
                  var row = workInProgress.child;
                  workInProgress.child = null;

                  while (row !== null) {
                    var currentRow = row.alternate; // New rows can't be content rows.

                    if (currentRow !== null && findFirstSuspended(currentRow) === null) {
                      // This is the beginning of the main content.
                      workInProgress.child = row;
                      break;
                    }

                    var nextRow = row.sibling;
                    row.sibling = _tail;
                    _tail = row;
                    row = nextRow;
                  } // TODO: If workInProgress.child is null, we can continue on the tail immediately.


                  initSuspenseListRenderState(workInProgress, true, // isBackwards
                  _tail, null, // last
                  tailMode, workInProgress.lastEffect);
                  break;
                }

              case 'together':
                {
                  initSuspenseListRenderState(workInProgress, false, // isBackwards
                  null, // tail
                  null, // last
                  undefined, workInProgress.lastEffect);
                  break;
                }

              default:
                {
                  // The default reveal order is the same as not having
                  // a boundary.
                  workInProgress.memoizedState = null;
                }
            }
          }

          return workInProgress.child;
        }

        function updatePortalComponent(current, workInProgress, renderLanes) {
          pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
          var nextChildren = workInProgress.pendingProps;

          if (current === null) {
            // Portals are special because we don't append the children during mount
            // but at commit. Therefore we need to track insertions which the normal
            // flow doesn't do during mount. This doesn't happen at the root because
            // the root always starts with a "current" with a null child.
            // TODO: Consider unifying this with how the root works.
            workInProgress.child = reconcileChildFibers(workInProgress, null, nextChildren, renderLanes);
          } else {
            reconcileChildren(current, workInProgress, nextChildren, renderLanes);
          }

          return workInProgress.child;
        }

        var hasWarnedAboutUsingNoValuePropOnContextProvider = false;

        function updateContextProvider(current, workInProgress, renderLanes) {
          var providerType = workInProgress.type;
          var context = providerType._context;
          var newProps = workInProgress.pendingProps;
          var oldProps = workInProgress.memoizedProps;
          var newValue = newProps.value;
          {
            if (!('value' in newProps)) {
              if (!hasWarnedAboutUsingNoValuePropOnContextProvider) {
                hasWarnedAboutUsingNoValuePropOnContextProvider = true;
                error('The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?');
              }
            }

            var providerPropTypes = workInProgress.type.propTypes;

            if (providerPropTypes) {
              checkPropTypes(providerPropTypes, newProps, 'prop', 'Context.Provider');
            }
          }
          pushProvider(workInProgress, newValue);

          if (oldProps !== null) {
            var oldValue = oldProps.value;
            var changedBits = calculateChangedBits(context, newValue, oldValue);

            if (changedBits === 0) {
              // No change. Bailout early if children are the same.
              if (oldProps.children === newProps.children && !hasContextChanged()) {
                return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
              }
            } else {
              // The context value changed. Search for matching consumers and schedule
              // them to update.
              propagateContextChange(workInProgress, context, changedBits, renderLanes);
            }
          }

          var newChildren = newProps.children;
          reconcileChildren(current, workInProgress, newChildren, renderLanes);
          return workInProgress.child;
        }

        var hasWarnedAboutUsingContextAsConsumer = false;

        function updateContextConsumer(current, workInProgress, renderLanes) {
          var context = workInProgress.type; // The logic below for Context differs depending on PROD or DEV mode. In
          // DEV mode, we create a separate object for Context.Consumer that acts
          // like a proxy to Context. This proxy object adds unnecessary code in PROD
          // so we use the old behaviour (Context.Consumer references Context) to
          // reduce size and overhead. The separate object references context via
          // a property called "_context", which also gives us the ability to check
          // in DEV mode if this property exists or not and warn if it does not.

          {
            if (context._context === undefined) {
              // This may be because it's a Context (rather than a Consumer).
              // Or it may be because it's older React where they're the same thing.
              // We only want to warn if we're sure it's a new React.
              if (context !== context.Consumer) {
                if (!hasWarnedAboutUsingContextAsConsumer) {
                  hasWarnedAboutUsingContextAsConsumer = true;
                  error('Rendering <Context> directly is not supported and will be removed in ' + 'a future major release. Did you mean to render <Context.Consumer> instead?');
                }
              }
            } else {
              context = context._context;
            }
          }
          var newProps = workInProgress.pendingProps;
          var render = newProps.children;
          {
            if (typeof render !== 'function') {
              error('A context consumer was rendered with multiple children, or a child ' + "that isn't a function. A context consumer expects a single child " + 'that is a function. If you did pass a function, make sure there ' + 'is no trailing or leading whitespace around it.');
            }
          }
          prepareToReadContext(workInProgress, renderLanes);

          var newValue = _readContext(context, newProps.unstable_observedBits);

          var newChildren;
          {
            ReactCurrentOwner$1.current = workInProgress;
            setIsRendering(true);
            newChildren = render(newValue);
            setIsRendering(false);
          } // React DevTools reads this flag.

          workInProgress.flags |= PerformedWork;
          reconcileChildren(current, workInProgress, newChildren, renderLanes);
          return workInProgress.child;
        }

        function markWorkInProgressReceivedUpdate() {
          didReceiveUpdate = true;
        }

        function bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
          if (current !== null) {
            // Reuse previous dependencies
            workInProgress.dependencies = current.dependencies;
          }

          {
            // Don't update "base" render times for bailouts.
            stopProfilerTimerIfRunning();
          }
          markSkippedUpdateLanes(workInProgress.lanes); // Check if the children have any pending work.

          if (!includesSomeLane(renderLanes, workInProgress.childLanes)) {
            // The children don't have any work either. We can skip them.
            // TODO: Once we add back resuming, we should check if the children are
            // a work-in-progress set. If so, we need to transfer their effects.
            return null;
          } else {
            // This fiber doesn't have work, but its subtree does. Clone the child
            // fibers and continue.
            cloneChildFibers(current, workInProgress);
            return workInProgress.child;
          }
        }

        function remountFiber(current, oldWorkInProgress, newWorkInProgress) {
          {
            var returnFiber = oldWorkInProgress.return;

            if (returnFiber === null) {
              throw new Error('Cannot swap the root fiber.');
            } // Disconnect from the old current.
            // It will get deleted.


            current.alternate = null;
            oldWorkInProgress.alternate = null; // Connect to the new tree.

            newWorkInProgress.index = oldWorkInProgress.index;
            newWorkInProgress.sibling = oldWorkInProgress.sibling;
            newWorkInProgress.return = oldWorkInProgress.return;
            newWorkInProgress.ref = oldWorkInProgress.ref; // Replace the child/sibling pointers above it.

            if (oldWorkInProgress === returnFiber.child) {
              returnFiber.child = newWorkInProgress;
            } else {
              var prevSibling = returnFiber.child;

              if (prevSibling === null) {
                throw new Error('Expected parent to have a child.');
              }

              while (prevSibling.sibling !== oldWorkInProgress) {
                prevSibling = prevSibling.sibling;

                if (prevSibling === null) {
                  throw new Error('Expected to find the previous sibling.');
                }
              }

              prevSibling.sibling = newWorkInProgress;
            } // Delete the old fiber and place the new one.
            // Since the old fiber is disconnected, we have to schedule it manually.


            var last = returnFiber.lastEffect;

            if (last !== null) {
              last.nextEffect = current;
              returnFiber.lastEffect = current;
            } else {
              returnFiber.firstEffect = returnFiber.lastEffect = current;
            }

            current.nextEffect = null;
            current.flags = Deletion;
            newWorkInProgress.flags |= Placement; // Restart work from the new fiber.

            return newWorkInProgress;
          }
        }

        function beginWork(current, workInProgress, renderLanes) {
          var updateLanes = workInProgress.lanes;
          {
            if (workInProgress._debugNeedsRemount && current !== null) {
              // This will restart the begin phase with a new fiber.
              return remountFiber(current, workInProgress, createFiberFromTypeAndProps(workInProgress.type, workInProgress.key, workInProgress.pendingProps, workInProgress._debugOwner || null, workInProgress.mode, workInProgress.lanes));
            }
          }

          if (current !== null) {
            var oldProps = current.memoizedProps;
            var newProps = workInProgress.pendingProps;

            if (oldProps !== newProps || hasContextChanged() || // Force a re-render if the implementation changed due to hot reload:
            workInProgress.type !== current.type) {
              // If props or context changed, mark the fiber as having performed work.
              // This may be unset if the props are determined to be equal later (memo).
              didReceiveUpdate = true;
            } else if (!includesSomeLane(renderLanes, updateLanes)) {
              didReceiveUpdate = false; // This fiber does not have any pending work. Bailout without entering
              // the begin phase. There's still some bookkeeping we that needs to be done
              // in this optimized path, mostly pushing stuff onto the stack.

              switch (workInProgress.tag) {
                case HostRoot:
                  pushHostRootContext(workInProgress);
                  resetHydrationState();
                  break;

                case HostComponent:
                  pushHostContext(workInProgress);
                  break;

                case ClassComponent:
                  {
                    var Component = workInProgress.type;

                    if (isContextProvider(Component)) {
                      pushContextProvider(workInProgress);
                    }

                    break;
                  }

                case HostPortal:
                  pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                  break;

                case ContextProvider:
                  {
                    var newValue = workInProgress.memoizedProps.value;
                    pushProvider(workInProgress, newValue);
                    break;
                  }

                case Profiler:
                  {
                    // Profiler should only call onRender when one of its descendants actually rendered.
                    var hasChildWork = includesSomeLane(renderLanes, workInProgress.childLanes);

                    if (hasChildWork) {
                      workInProgress.flags |= Update;
                    } // Reset effect durations for the next eventual effect phase.
                    // These are reset during render to allow the DevTools commit hook a chance to read them,


                    var stateNode = workInProgress.stateNode;
                    stateNode.effectDuration = 0;
                    stateNode.passiveEffectDuration = 0;
                  }
                  break;

                case SuspenseComponent:
                  {
                    var state = workInProgress.memoizedState;

                    if (state !== null) {
                      // whether to retry the primary children, or to skip over it and
                      // go straight to the fallback. Check the priority of the primary
                      // child fragment.
                      var primaryChildFragment = workInProgress.child;
                      var primaryChildLanes = primaryChildFragment.childLanes;

                      if (includesSomeLane(renderLanes, primaryChildLanes)) {
                        // The primary children have pending work. Use the normal path
                        // to attempt to render the primary children again.
                        return updateSuspenseComponent(current, workInProgress, renderLanes);
                      } else {
                        // The primary child fragment does not have pending work marked
                        // on it
                        pushSuspenseContext(workInProgress, setDefaultShallowSuspenseContext(suspenseStackCursor.current)); // The primary children do not have pending work with sufficient
                        // priority. Bailout.

                        var child = bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);

                        if (child !== null) {
                          // The fallback children have pending work. Skip over the
                          // primary children and work on the fallback.
                          return child.sibling;
                        } else {
                          return null;
                        }
                      }
                    } else {
                      pushSuspenseContext(workInProgress, setDefaultShallowSuspenseContext(suspenseStackCursor.current));
                    }

                    break;
                  }

                case SuspenseListComponent:
                  {
                    var didSuspendBefore = (current.flags & DidCapture) !== NoFlags;

                    var _hasChildWork = includesSomeLane(renderLanes, workInProgress.childLanes);

                    if (didSuspendBefore) {
                      if (_hasChildWork) {
                        // If something was in fallback state last time, and we have all the
                        // same children then we're still in progressive loading state.
                        // Something might get unblocked by state updates or retries in the
                        // tree which will affect the tail. So we need to use the normal
                        // path to compute the correct tail.
                        return updateSuspenseListComponent(current, workInProgress, renderLanes);
                      } // If none of the children had any work, that means that none of
                      // them got retried so they'll still be blocked in the same way
                      // as before. We can fast bail out.


                      workInProgress.flags |= DidCapture;
                    } // If nothing suspended before and we're rendering the same children,
                    // then the tail doesn't matter. Anything new that suspends will work
                    // in the "together" mode, so we can continue from the state we had.


                    var renderState = workInProgress.memoizedState;

                    if (renderState !== null) {
                      // Reset to the "together" mode in case we've started a different
                      // update in the past but didn't complete it.
                      renderState.rendering = null;
                      renderState.tail = null;
                      renderState.lastEffect = null;
                    }

                    pushSuspenseContext(workInProgress, suspenseStackCursor.current);

                    if (_hasChildWork) {
                      break;
                    } else {
                      // If none of the children had any work, that means that none of
                      // them got retried so they'll still be blocked in the same way
                      // as before. We can fast bail out.
                      return null;
                    }
                  }

                case OffscreenComponent:
                case LegacyHiddenComponent:
                  {
                    // Need to check if the tree still needs to be deferred. This is
                    // almost identical to the logic used in the normal update path,
                    // so we'll just enter that. The only difference is we'll bail out
                    // at the next level instead of this one, because the child props
                    // have not changed. Which is fine.
                    // TODO: Probably should refactor `beginWork` to split the bailout
                    // path from the normal path. I'm tempted to do a labeled break here
                    // but I won't :)
                    workInProgress.lanes = NoLanes;
                    return updateOffscreenComponent(current, workInProgress, renderLanes);
                  }
              }

              return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
            } else {
              if ((current.flags & ForceUpdateForLegacySuspense) !== NoFlags) {
                // This is a special case that only exists for legacy mode.
                // See https://github.com/facebook/react/pull/19216.
                didReceiveUpdate = true;
              } else {
                // An update was scheduled on this fiber, but there are no new props
                // nor legacy context. Set this to false. If an update queue or context
                // consumer produces a changed value, it will set this to true. Otherwise,
                // the component will assume the children have not changed and bail out.
                didReceiveUpdate = false;
              }
            }
          } else {
            didReceiveUpdate = false;
          } // Before entering the begin phase, clear pending update priority.
          // TODO: This assumes that we're about to evaluate the component and process
          // the update queue. However, there's an exception: SimpleMemoComponent
          // sometimes bails out later in the begin phase. This indicates that we should
          // move this assignment out of the common path and into each branch.


          workInProgress.lanes = NoLanes;

          switch (workInProgress.tag) {
            case IndeterminateComponent:
              {
                return mountIndeterminateComponent(current, workInProgress, workInProgress.type, renderLanes);
              }

            case LazyComponent:
              {
                var elementType = workInProgress.elementType;
                return mountLazyComponent(current, workInProgress, elementType, updateLanes, renderLanes);
              }

            case FunctionComponent:
              {
                var _Component = workInProgress.type;
                var unresolvedProps = workInProgress.pendingProps;
                var resolvedProps = workInProgress.elementType === _Component ? unresolvedProps : resolveDefaultProps(_Component, unresolvedProps);
                return updateFunctionComponent(current, workInProgress, _Component, resolvedProps, renderLanes);
              }

            case ClassComponent:
              {
                var _Component2 = workInProgress.type;
                var _unresolvedProps = workInProgress.pendingProps;

                var _resolvedProps = workInProgress.elementType === _Component2 ? _unresolvedProps : resolveDefaultProps(_Component2, _unresolvedProps);

                return updateClassComponent(current, workInProgress, _Component2, _resolvedProps, renderLanes);
              }

            case HostRoot:
              return updateHostRoot(current, workInProgress, renderLanes);

            case HostComponent:
              return updateHostComponent(current, workInProgress, renderLanes);

            case HostText:
              return updateHostText(current, workInProgress);

            case SuspenseComponent:
              return updateSuspenseComponent(current, workInProgress, renderLanes);

            case HostPortal:
              return updatePortalComponent(current, workInProgress, renderLanes);

            case ForwardRef:
              {
                var type = workInProgress.type;
                var _unresolvedProps2 = workInProgress.pendingProps;

                var _resolvedProps2 = workInProgress.elementType === type ? _unresolvedProps2 : resolveDefaultProps(type, _unresolvedProps2);

                return updateForwardRef(current, workInProgress, type, _resolvedProps2, renderLanes);
              }

            case Fragment:
              return updateFragment(current, workInProgress, renderLanes);

            case Mode:
              return updateMode(current, workInProgress, renderLanes);

            case Profiler:
              return updateProfiler(current, workInProgress, renderLanes);

            case ContextProvider:
              return updateContextProvider(current, workInProgress, renderLanes);

            case ContextConsumer:
              return updateContextConsumer(current, workInProgress, renderLanes);

            case MemoComponent:
              {
                var _type2 = workInProgress.type;
                var _unresolvedProps3 = workInProgress.pendingProps; // Resolve outer props first, then resolve inner props.

                var _resolvedProps3 = resolveDefaultProps(_type2, _unresolvedProps3);

                {
                  if (workInProgress.type !== workInProgress.elementType) {
                    var outerPropTypes = _type2.propTypes;

                    if (outerPropTypes) {
                      checkPropTypes(outerPropTypes, _resolvedProps3, // Resolved for outer only
                      'prop', getComponentName(_type2));
                    }
                  }
                }
                _resolvedProps3 = resolveDefaultProps(_type2.type, _resolvedProps3);
                return updateMemoComponent(current, workInProgress, _type2, _resolvedProps3, updateLanes, renderLanes);
              }

            case SimpleMemoComponent:
              {
                return updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, updateLanes, renderLanes);
              }

            case IncompleteClassComponent:
              {
                var _Component3 = workInProgress.type;
                var _unresolvedProps4 = workInProgress.pendingProps;

                var _resolvedProps4 = workInProgress.elementType === _Component3 ? _unresolvedProps4 : resolveDefaultProps(_Component3, _unresolvedProps4);

                return mountIncompleteClassComponent(current, workInProgress, _Component3, _resolvedProps4, renderLanes);
              }

            case SuspenseListComponent:
              {
                return updateSuspenseListComponent(current, workInProgress, renderLanes);
              }

            case FundamentalComponent:
              {
                break;
              }

            case ScopeComponent:
              {
                break;
              }

            case Block:
              {
                break;
              }

            case OffscreenComponent:
              {
                return updateOffscreenComponent(current, workInProgress, renderLanes);
              }

            case LegacyHiddenComponent:
              {
                return updateLegacyHiddenComponent(current, workInProgress, renderLanes);
              }
          }

          {
            {
              throw Error("Unknown unit of work tag (" + workInProgress.tag + "). This error is likely caused by a bug in React. Please file an issue.");
            }
          }
        }

        function markUpdate(workInProgress) {
          // Tag the fiber with an update effect. This turns a Placement into
          // a PlacementAndUpdate.
          workInProgress.flags |= Update;
        }

        function markRef$1(workInProgress) {
          workInProgress.flags |= Ref;
        }

        var appendAllChildren;
        var updateHostContainer;
        var updateHostComponent$1;
        var updateHostText$1;
        {
          // Mutation mode
          appendAllChildren = function appendAllChildren(parent, workInProgress, needsVisibilityToggle, isHidden) {
            // We only have the top Fiber that was created but we need recurse down its
            // children to find all the terminal nodes.
            var node = workInProgress.child;

            while (node !== null) {
              if (node.tag === HostComponent || node.tag === HostText) {
                appendInitialChild(parent, node.stateNode);
              } else if (node.tag === HostPortal) ;else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
              }

              if (node === workInProgress) {
                return;
              }

              while (node.sibling === null) {
                if (node.return === null || node.return === workInProgress) {
                  return;
                }

                node = node.return;
              }

              node.sibling.return = node.return;
              node = node.sibling;
            }
          };

          updateHostContainer = function updateHostContainer(workInProgress) {// Noop
          };

          updateHostComponent$1 = function updateHostComponent$1(current, workInProgress, type, newProps, rootContainerInstance) {
            // If we have an alternate, that means this is an update and we need to
            // schedule a side-effect to do the updates.
            var oldProps = current.memoizedProps;

            if (oldProps === newProps) {
              // In mutation mode, this is sufficient for a bailout because
              // we won't touch this node even if children changed.
              return;
            } // If we get updated because one of our children updated, we don't
            // have newProps so we'll have to reuse them.
            // TODO: Split the update API as separate for the props vs. children.
            // Even better would be if children weren't special cased at all tho.


            var instance = workInProgress.stateNode;
            var currentHostContext = getHostContext(); // TODO: Experiencing an error where oldProps is null. Suggests a host
            // component is hitting the resume path. Figure out why. Possibly
            // related to `hidden`.

            var updatePayload = prepareUpdate(instance, type, oldProps, newProps, rootContainerInstance, currentHostContext); // TODO: Type this specific to this type of component.

            workInProgress.updateQueue = updatePayload; // If the update payload indicates that there is a change or if there
            // is a new ref we mark this as an update. All the work is done in commitWork.

            if (updatePayload) {
              markUpdate(workInProgress);
            }
          };

          updateHostText$1 = function updateHostText$1(current, workInProgress, oldText, newText) {
            // If the text differs, mark it as an update. All the work in done in commitWork.
            if (oldText !== newText) {
              markUpdate(workInProgress);
            }
          };
        }

        function cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
          if (getIsHydrating()) {
            // If we're hydrating, we should consume as many items as we can
            // so we don't leave any behind.
            return;
          }

          switch (renderState.tailMode) {
            case 'hidden':
              {
                // Any insertions at the end of the tail list after this point
                // should be invisible. If there are already mounted boundaries
                // anything before them are not considered for collapsing.
                // Therefore we need to go through the whole tail to find if
                // there are any.
                var tailNode = renderState.tail;
                var lastTailNode = null;

                while (tailNode !== null) {
                  if (tailNode.alternate !== null) {
                    lastTailNode = tailNode;
                  }

                  tailNode = tailNode.sibling;
                } // Next we're simply going to delete all insertions after the
                // last rendered item.


                if (lastTailNode === null) {
                  // All remaining items in the tail are insertions.
                  renderState.tail = null;
                } else {
                  // Detach the insertion after the last node that was already
                  // inserted.
                  lastTailNode.sibling = null;
                }

                break;
              }

            case 'collapsed':
              {
                // Any insertions at the end of the tail list after this point
                // should be invisible. If there are already mounted boundaries
                // anything before them are not considered for collapsing.
                // Therefore we need to go through the whole tail to find if
                // there are any.
                var _tailNode = renderState.tail;
                var _lastTailNode = null;

                while (_tailNode !== null) {
                  if (_tailNode.alternate !== null) {
                    _lastTailNode = _tailNode;
                  }

                  _tailNode = _tailNode.sibling;
                } // Next we're simply going to delete all insertions after the
                // last rendered item.


                if (_lastTailNode === null) {
                  // All remaining items in the tail are insertions.
                  if (!hasRenderedATailFallback && renderState.tail !== null) {
                    // We suspended during the head. We want to show at least one
                    // row at the tail. So we'll keep on and cut off the rest.
                    renderState.tail.sibling = null;
                  } else {
                    renderState.tail = null;
                  }
                } else {
                  // Detach the insertion after the last node that was already
                  // inserted.
                  _lastTailNode.sibling = null;
                }

                break;
              }
          }
        }

        function completeWork(current, workInProgress, renderLanes) {
          var newProps = workInProgress.pendingProps;

          switch (workInProgress.tag) {
            case IndeterminateComponent:
            case LazyComponent:
            case SimpleMemoComponent:
            case FunctionComponent:
            case ForwardRef:
            case Fragment:
            case Mode:
            case Profiler:
            case ContextConsumer:
            case MemoComponent:
              return null;

            case ClassComponent:
              {
                var Component = workInProgress.type;

                if (isContextProvider(Component)) {
                  popContext(workInProgress);
                }

                return null;
              }

            case HostRoot:
              {
                popHostContainer(workInProgress);
                popTopLevelContextObject(workInProgress);
                resetWorkInProgressVersions();
                var fiberRoot = workInProgress.stateNode;

                if (fiberRoot.pendingContext) {
                  fiberRoot.context = fiberRoot.pendingContext;
                  fiberRoot.pendingContext = null;
                }

                if (current === null || current.child === null) {
                  // If we hydrated, pop so that we can delete any remaining children
                  // that weren't hydrated.
                  var wasHydrated = popHydrationState(workInProgress);

                  if (wasHydrated) {
                    // If we hydrated, then we'll need to schedule an update for
                    // the commit side-effects on the root.
                    markUpdate(workInProgress);
                  } else if (!fiberRoot.hydrate) {
                    // Schedule an effect to clear this container at the start of the next commit.
                    // This handles the case of React rendering into a container with previous children.
                    // It's also safe to do for updates too, because current.child would only be null
                    // if the previous render was null (so the the container would already be empty).
                    workInProgress.flags |= Snapshot;
                  }
                }

                updateHostContainer(workInProgress);
                return null;
              }

            case HostComponent:
              {
                popHostContext(workInProgress);
                var rootContainerInstance = getRootHostContainer();
                var type = workInProgress.type;

                if (current !== null && workInProgress.stateNode != null) {
                  updateHostComponent$1(current, workInProgress, type, newProps, rootContainerInstance);

                  if (current.ref !== workInProgress.ref) {
                    markRef$1(workInProgress);
                  }
                } else {
                  if (!newProps) {
                    if (!(workInProgress.stateNode !== null)) {
                      {
                        throw Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
                      }
                    } // This can happen when we abort work.


                    return null;
                  }

                  var currentHostContext = getHostContext(); // TODO: Move createInstance to beginWork and keep it on a context
                  // "stack" as the parent. Then append children as we go in beginWork
                  // or completeWork depending on whether we want to add them top->down or
                  // bottom->up. Top->down is faster in IE11.

                  var _wasHydrated = popHydrationState(workInProgress);

                  if (_wasHydrated) {
                    // TODO: Move this and createInstance step into the beginPhase
                    // to consolidate.
                    if (prepareToHydrateHostInstance(workInProgress, rootContainerInstance, currentHostContext)) {
                      // If changes to the hydrated node need to be applied at the
                      // commit-phase we mark this as such.
                      markUpdate(workInProgress);
                    }
                  } else {
                    var instance = createInstance(type, newProps, rootContainerInstance, currentHostContext, workInProgress);
                    appendAllChildren(instance, workInProgress, false, false);
                    workInProgress.stateNode = instance; // Certain renderers require commit-time effects for initial mount.
                    // (eg DOM renderer supports auto-focus for certain elements).
                    // Make sure such renderers get scheduled for later work.

                    if (finalizeInitialChildren(instance, type, newProps, rootContainerInstance)) {
                      markUpdate(workInProgress);
                    }
                  }

                  if (workInProgress.ref !== null) {
                    // If there is a ref on a host node we need to schedule a callback
                    markRef$1(workInProgress);
                  }
                }

                return null;
              }

            case HostText:
              {
                var newText = newProps;

                if (current && workInProgress.stateNode != null) {
                  var oldText = current.memoizedProps; // If we have an alternate, that means this is an update and we need
                  // to schedule a side-effect to do the updates.

                  updateHostText$1(current, workInProgress, oldText, newText);
                } else {
                  if (typeof newText !== 'string') {
                    if (!(workInProgress.stateNode !== null)) {
                      {
                        throw Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
                      }
                    } // This can happen when we abort work.

                  }

                  var _rootContainerInstance = getRootHostContainer();

                  var _currentHostContext = getHostContext();

                  var _wasHydrated2 = popHydrationState(workInProgress);

                  if (_wasHydrated2) {
                    if (prepareToHydrateHostTextInstance(workInProgress)) {
                      markUpdate(workInProgress);
                    }
                  } else {
                    workInProgress.stateNode = createTextInstance(newText, _rootContainerInstance, _currentHostContext, workInProgress);
                  }
                }

                return null;
              }

            case SuspenseComponent:
              {
                popSuspenseContext(workInProgress);
                var nextState = workInProgress.memoizedState;

                if ((workInProgress.flags & DidCapture) !== NoFlags) {
                  // Something suspended. Re-render with the fallback children.
                  workInProgress.lanes = renderLanes; // Do not reset the effect list.

                  if ((workInProgress.mode & ProfileMode) !== NoMode) {
                    transferActualDuration(workInProgress);
                  }

                  return workInProgress;
                }

                var nextDidTimeout = nextState !== null;
                var prevDidTimeout = false;

                if (current === null) {
                  if (workInProgress.memoizedProps.fallback !== undefined) {
                    popHydrationState(workInProgress);
                  }
                } else {
                  var prevState = current.memoizedState;
                  prevDidTimeout = prevState !== null;
                }

                if (nextDidTimeout && !prevDidTimeout) {
                  // If this subtreee is running in blocking mode we can suspend,
                  // otherwise we won't suspend.
                  // TODO: This will still suspend a synchronous tree if anything
                  // in the concurrent tree already suspended during this render.
                  // This is a known bug.
                  if ((workInProgress.mode & BlockingMode) !== NoMode) {
                    // TODO: Move this back to throwException because this is too late
                    // if this is a large tree which is common for initial loads. We
                    // don't know if we should restart a render or not until we get
                    // this marker, and this is too late.
                    // If this render already had a ping or lower pri updates,
                    // and this is the first time we know we're going to suspend we
                    // should be able to immediately restart from within throwException.
                    var hasInvisibleChildContext = current === null && workInProgress.memoizedProps.unstable_avoidThisFallback !== true;

                    if (hasInvisibleChildContext || hasSuspenseContext(suspenseStackCursor.current, InvisibleParentSuspenseContext)) {
                      // If this was in an invisible tree or a new render, then showing
                      // this boundary is ok.
                      renderDidSuspend();
                    } else {
                      // Otherwise, we're going to have to hide content so we should
                      // suspend for longer if possible.
                      renderDidSuspendDelayIfPossible();
                    }
                  }
                }

                {
                  // TODO: Only schedule updates if these values are non equal, i.e. it changed.
                  if (nextDidTimeout || prevDidTimeout) {
                    // If this boundary just timed out, schedule an effect to attach a
                    // retry listener to the promise. This flag is also used to hide the
                    // primary children. In mutation mode, we also need the flag to
                    // *unhide* children that were previously hidden, so check if this
                    // is currently timed out, too.
                    workInProgress.flags |= Update;
                  }
                }
                return null;
              }

            case HostPortal:
              popHostContainer(workInProgress);
              updateHostContainer(workInProgress);

              if (current === null) {
                preparePortalMount(workInProgress.stateNode.containerInfo);
              }

              return null;

            case ContextProvider:
              // Pop provider fiber
              popProvider(workInProgress);
              return null;

            case IncompleteClassComponent:
              {
                // Same as class component case. I put it down here so that the tags are
                // sequential to ensure this switch is compiled to a jump table.
                var _Component = workInProgress.type;

                if (isContextProvider(_Component)) {
                  popContext(workInProgress);
                }

                return null;
              }

            case SuspenseListComponent:
              {
                popSuspenseContext(workInProgress);
                var renderState = workInProgress.memoizedState;

                if (renderState === null) {
                  // We're running in the default, "independent" mode.
                  // We don't do anything in this mode.
                  return null;
                }

                var didSuspendAlready = (workInProgress.flags & DidCapture) !== NoFlags;
                var renderedTail = renderState.rendering;

                if (renderedTail === null) {
                  // We just rendered the head.
                  if (!didSuspendAlready) {
                    // This is the first pass. We need to figure out if anything is still
                    // suspended in the rendered set.
                    // If new content unsuspended, but there's still some content that
                    // didn't. Then we need to do a second pass that forces everything
                    // to keep showing their fallbacks.
                    // We might be suspended if something in this render pass suspended, or
                    // something in the previous committed pass suspended. Otherwise,
                    // there's no chance so we can skip the expensive call to
                    // findFirstSuspended.
                    var cannotBeSuspended = renderHasNotSuspendedYet() && (current === null || (current.flags & DidCapture) === NoFlags);

                    if (!cannotBeSuspended) {
                      var row = workInProgress.child;

                      while (row !== null) {
                        var suspended = findFirstSuspended(row);

                        if (suspended !== null) {
                          didSuspendAlready = true;
                          workInProgress.flags |= DidCapture;
                          cutOffTailIfNeeded(renderState, false); // If this is a newly suspended tree, it might not get committed as
                          // part of the second pass. In that case nothing will subscribe to
                          // its thennables. Instead, we'll transfer its thennables to the
                          // SuspenseList so that it can retry if they resolve.
                          // There might be multiple of these in the list but since we're
                          // going to wait for all of them anyway, it doesn't really matter
                          // which ones gets to ping. In theory we could get clever and keep
                          // track of how many dependencies remain but it gets tricky because
                          // in the meantime, we can add/remove/change items and dependencies.
                          // We might bail out of the loop before finding any but that
                          // doesn't matter since that means that the other boundaries that
                          // we did find already has their listeners attached.

                          var newThennables = suspended.updateQueue;

                          if (newThennables !== null) {
                            workInProgress.updateQueue = newThennables;
                            workInProgress.flags |= Update;
                          } // Rerender the whole list, but this time, we'll force fallbacks
                          // to stay in place.
                          // Reset the effect list before doing the second pass since that's now invalid.


                          if (renderState.lastEffect === null) {
                            workInProgress.firstEffect = null;
                          }

                          workInProgress.lastEffect = renderState.lastEffect; // Reset the child fibers to their original state.

                          resetChildFibers(workInProgress, renderLanes); // Set up the Suspense Context to force suspense and immediately
                          // rerender the children.

                          pushSuspenseContext(workInProgress, setShallowSuspenseContext(suspenseStackCursor.current, ForceSuspenseFallback));
                          return workInProgress.child;
                        }

                        row = row.sibling;
                      }
                    }

                    if (renderState.tail !== null && now() > getRenderTargetTime()) {
                      // We have already passed our CPU deadline but we still have rows
                      // left in the tail. We'll just give up further attempts to render
                      // the main content and only render fallbacks.
                      workInProgress.flags |= DidCapture;
                      didSuspendAlready = true;
                      cutOffTailIfNeeded(renderState, false); // Since nothing actually suspended, there will nothing to ping this
                      // to get it started back up to attempt the next item. While in terms
                      // of priority this work has the same priority as this current render,
                      // it's not part of the same transition once the transition has
                      // committed. If it's sync, we still want to yield so that it can be
                      // painted. Conceptually, this is really the same as pinging.
                      // We can use any RetryLane even if it's the one currently rendering
                      // since we're leaving it behind on this node.

                      workInProgress.lanes = SomeRetryLane;
                      {
                        markSpawnedWork(SomeRetryLane);
                      }
                    }
                  } else {
                    cutOffTailIfNeeded(renderState, false);
                  } // Next we're going to render the tail.

                } else {
                  // Append the rendered row to the child list.
                  if (!didSuspendAlready) {
                    var _suspended = findFirstSuspended(renderedTail);

                    if (_suspended !== null) {
                      workInProgress.flags |= DidCapture;
                      didSuspendAlready = true; // Ensure we transfer the update queue to the parent so that it doesn't
                      // get lost if this row ends up dropped during a second pass.

                      var _newThennables = _suspended.updateQueue;

                      if (_newThennables !== null) {
                        workInProgress.updateQueue = _newThennables;
                        workInProgress.flags |= Update;
                      }

                      cutOffTailIfNeeded(renderState, true); // This might have been modified.

                      if (renderState.tail === null && renderState.tailMode === 'hidden' && !renderedTail.alternate && !getIsHydrating() // We don't cut it if we're hydrating.
                      ) {
                        // We need to delete the row we just rendered.
                        // Reset the effect list to what it was before we rendered this
                        // child. The nested children have already appended themselves.
                        var lastEffect = workInProgress.lastEffect = renderState.lastEffect; // Remove any effects that were appended after this point.

                        if (lastEffect !== null) {
                          lastEffect.nextEffect = null;
                        } // We're done.


                        return null;
                      }
                    } else if ( // The time it took to render last row is greater than the remaining
                    // time we have to render. So rendering one more row would likely
                    // exceed it.
                    now() * 2 - renderState.renderingStartTime > getRenderTargetTime() && renderLanes !== OffscreenLane) {
                      // We have now passed our CPU deadline and we'll just give up further
                      // attempts to render the main content and only render fallbacks.
                      // The assumption is that this is usually faster.
                      workInProgress.flags |= DidCapture;
                      didSuspendAlready = true;
                      cutOffTailIfNeeded(renderState, false); // Since nothing actually suspended, there will nothing to ping this
                      // to get it started back up to attempt the next item. While in terms
                      // of priority this work has the same priority as this current render,
                      // it's not part of the same transition once the transition has
                      // committed. If it's sync, we still want to yield so that it can be
                      // painted. Conceptually, this is really the same as pinging.
                      // We can use any RetryLane even if it's the one currently rendering
                      // since we're leaving it behind on this node.

                      workInProgress.lanes = SomeRetryLane;
                      {
                        markSpawnedWork(SomeRetryLane);
                      }
                    }
                  }

                  if (renderState.isBackwards) {
                    // The effect list of the backwards tail will have been added
                    // to the end. This breaks the guarantee that life-cycles fire in
                    // sibling order but that isn't a strong guarantee promised by React.
                    // Especially since these might also just pop in during future commits.
                    // Append to the beginning of the list.
                    renderedTail.sibling = workInProgress.child;
                    workInProgress.child = renderedTail;
                  } else {
                    var previousSibling = renderState.last;

                    if (previousSibling !== null) {
                      previousSibling.sibling = renderedTail;
                    } else {
                      workInProgress.child = renderedTail;
                    }

                    renderState.last = renderedTail;
                  }
                }

                if (renderState.tail !== null) {
                  // We still have tail rows to render.
                  // Pop a row.
                  var next = renderState.tail;
                  renderState.rendering = next;
                  renderState.tail = next.sibling;
                  renderState.lastEffect = workInProgress.lastEffect;
                  renderState.renderingStartTime = now();
                  next.sibling = null; // Restore the context.
                  // TODO: We can probably just avoid popping it instead and only
                  // setting it the first time we go from not suspended to suspended.

                  var suspenseContext = suspenseStackCursor.current;

                  if (didSuspendAlready) {
                    suspenseContext = setShallowSuspenseContext(suspenseContext, ForceSuspenseFallback);
                  } else {
                    suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
                  }

                  pushSuspenseContext(workInProgress, suspenseContext); // Do a pass over the next row.

                  return next;
                }

                return null;
              }

            case FundamentalComponent:
              {
                break;
              }

            case ScopeComponent:
              {
                break;
              }

            case Block:
              break;

            case OffscreenComponent:
            case LegacyHiddenComponent:
              {
                popRenderLanes(workInProgress);

                if (current !== null) {
                  var _nextState = workInProgress.memoizedState;
                  var _prevState = current.memoizedState;
                  var prevIsHidden = _prevState !== null;
                  var nextIsHidden = _nextState !== null;

                  if (prevIsHidden !== nextIsHidden && newProps.mode !== 'unstable-defer-without-hiding') {
                    workInProgress.flags |= Update;
                  }
                }

                return null;
              }
          }

          {
            {
              throw Error("Unknown unit of work tag (" + workInProgress.tag + "). This error is likely caused by a bug in React. Please file an issue.");
            }
          }
        }

        function unwindWork(workInProgress, renderLanes) {
          switch (workInProgress.tag) {
            case ClassComponent:
              {
                var Component = workInProgress.type;

                if (isContextProvider(Component)) {
                  popContext(workInProgress);
                }

                var flags = workInProgress.flags;

                if (flags & ShouldCapture) {
                  workInProgress.flags = flags & ~ShouldCapture | DidCapture;

                  if ((workInProgress.mode & ProfileMode) !== NoMode) {
                    transferActualDuration(workInProgress);
                  }

                  return workInProgress;
                }

                return null;
              }

            case HostRoot:
              {
                popHostContainer(workInProgress);
                popTopLevelContextObject(workInProgress);
                resetWorkInProgressVersions();
                var _flags = workInProgress.flags;

                if (!((_flags & DidCapture) === NoFlags)) {
                  {
                    throw Error("The root failed to unmount after an error. This is likely a bug in React. Please file an issue.");
                  }
                }

                workInProgress.flags = _flags & ~ShouldCapture | DidCapture;
                return workInProgress;
              }

            case HostComponent:
              {
                // TODO: popHydrationState
                popHostContext(workInProgress);
                return null;
              }

            case SuspenseComponent:
              {
                popSuspenseContext(workInProgress);
                var _flags2 = workInProgress.flags;

                if (_flags2 & ShouldCapture) {
                  workInProgress.flags = _flags2 & ~ShouldCapture | DidCapture; // Captured a suspense effect. Re-render the boundary.

                  if ((workInProgress.mode & ProfileMode) !== NoMode) {
                    transferActualDuration(workInProgress);
                  }

                  return workInProgress;
                }

                return null;
              }

            case SuspenseListComponent:
              {
                popSuspenseContext(workInProgress); // SuspenseList doesn't actually catch anything. It should've been
                // caught by a nested boundary. If not, it should bubble through.

                return null;
              }

            case HostPortal:
              popHostContainer(workInProgress);
              return null;

            case ContextProvider:
              popProvider(workInProgress);
              return null;

            case OffscreenComponent:
            case LegacyHiddenComponent:
              popRenderLanes(workInProgress);
              return null;

            default:
              return null;
          }
        }

        function unwindInterruptedWork(interruptedWork) {
          switch (interruptedWork.tag) {
            case ClassComponent:
              {
                var childContextTypes = interruptedWork.type.childContextTypes;

                if (childContextTypes !== null && childContextTypes !== undefined) {
                  popContext(interruptedWork);
                }

                break;
              }

            case HostRoot:
              {
                popHostContainer(interruptedWork);
                popTopLevelContextObject(interruptedWork);
                resetWorkInProgressVersions();
                break;
              }

            case HostComponent:
              {
                popHostContext(interruptedWork);
                break;
              }

            case HostPortal:
              popHostContainer(interruptedWork);
              break;

            case SuspenseComponent:
              popSuspenseContext(interruptedWork);
              break;

            case SuspenseListComponent:
              popSuspenseContext(interruptedWork);
              break;

            case ContextProvider:
              popProvider(interruptedWork);
              break;

            case OffscreenComponent:
            case LegacyHiddenComponent:
              popRenderLanes(interruptedWork);
              break;
          }
        }

        function createCapturedValue(value, source) {
          // If the value is an error, call this function immediately after it is thrown
          // so the stack is accurate.
          return {
            value: value,
            source: source,
            stack: getStackByFiberInDevAndProd(source)
          };
        } // This module is forked in different environments.
        // By default, return `true` to log errors to the console.
        // Forks can return `false` if this isn't desirable.


        function showErrorDialog(boundary, errorInfo) {
          return true;
        }

        function logCapturedError(boundary, errorInfo) {
          try {
            var logError = showErrorDialog(boundary, errorInfo); // Allow injected showErrorDialog() to prevent default console.error logging.
            // This enables renderers like ReactNative to better manage redbox behavior.

            if (logError === false) {
              return;
            }

            var error = errorInfo.value;

            if (true) {
              var source = errorInfo.source;
              var stack = errorInfo.stack;
              var componentStack = stack !== null ? stack : ''; // Browsers support silencing uncaught errors by calling
              // `preventDefault()` in window `error` handler.
              // We record this information as an expando on the error.

              if (error != null && error._suppressLogging) {
                if (boundary.tag === ClassComponent) {
                  // The error is recoverable and was silenced.
                  // Ignore it and don't print the stack addendum.
                  // This is handy for testing error boundaries without noise.
                  return;
                } // The error is fatal. Since the silencing might have
                // been accidental, we'll surface it anyway.
                // However, the browser would have silenced the original error
                // so we'll print it first, and then print the stack addendum.


                console['error'](error); // Don't transform to our wrapper
                // For a more detailed description of this block, see:
                // https://github.com/facebook/react/pull/13384
              }

              var componentName = source ? getComponentName(source.type) : null;
              var componentNameMessage = componentName ? "The above error occurred in the <" + componentName + "> component:" : 'The above error occurred in one of your React components:';
              var errorBoundaryMessage;
              var errorBoundaryName = getComponentName(boundary.type);

              if (errorBoundaryName) {
                errorBoundaryMessage = "React will try to recreate this component tree from scratch " + ("using the error boundary you provided, " + errorBoundaryName + ".");
              } else {
                errorBoundaryMessage = 'Consider adding an error boundary to your tree to customize error handling behavior.\n' + 'Visit https://reactjs.org/link/error-boundaries to learn more about error boundaries.';
              }

              var combinedMessage = componentNameMessage + "\n" + componentStack + "\n\n" + ("" + errorBoundaryMessage); // In development, we provide our own message with just the component stack.
              // We don't include the original error message and JS stack because the browser
              // has already printed it. Even if the application swallows the error, it is still
              // displayed by the browser thanks to the DEV-only fake event trick in ReactErrorUtils.

              console['error'](combinedMessage); // Don't transform to our wrapper
            } else {
              // In production, we print the error directly.
              // This will include the message, the JS stack, and anything the browser wants to show.
              // We pass the error object instead of custom message so that the browser displays the error natively.
              console['error'](error); // Don't transform to our wrapper
            }
          } catch (e) {
            // This method must not throw, or React internal state will get messed up.
            // If console.error is overridden, or logCapturedError() shows a dialog that throws,
            // we want to report this error outside of the normal stack as a last resort.
            // https://github.com/facebook/react/issues/13188
            setTimeout(function () {
              throw e;
            });
          }
        }

        var PossiblyWeakMap$1 = typeof WeakMap === 'function' ? WeakMap : Map;

        function createRootErrorUpdate(fiber, errorInfo, lane) {
          var update = createUpdate(NoTimestamp, lane); // Unmount the root by rendering null.

          update.tag = CaptureUpdate; // Caution: React DevTools currently depends on this property
          // being called "element".

          update.payload = {
            element: null
          };
          var error = errorInfo.value;

          update.callback = function () {
            onUncaughtError(error);
            logCapturedError(fiber, errorInfo);
          };

          return update;
        }

        function createClassErrorUpdate(fiber, errorInfo, lane) {
          var update = createUpdate(NoTimestamp, lane);
          update.tag = CaptureUpdate;
          var getDerivedStateFromError = fiber.type.getDerivedStateFromError;

          if (typeof getDerivedStateFromError === 'function') {
            var error$1 = errorInfo.value;

            update.payload = function () {
              logCapturedError(fiber, errorInfo);
              return getDerivedStateFromError(error$1);
            };
          }

          var inst = fiber.stateNode;

          if (inst !== null && typeof inst.componentDidCatch === 'function') {
            update.callback = function callback() {
              {
                markFailedErrorBoundaryForHotReloading(fiber);
              }

              if (typeof getDerivedStateFromError !== 'function') {
                // To preserve the preexisting retry behavior of error boundaries,
                // we keep track of which ones already failed during this batch.
                // This gets reset before we yield back to the browser.
                // TODO: Warn in strict mode if getDerivedStateFromError is
                // not defined.
                markLegacyErrorBoundaryAsFailed(this); // Only log here if componentDidCatch is the only error boundary method defined

                logCapturedError(fiber, errorInfo);
              }

              var error$1 = errorInfo.value;
              var stack = errorInfo.stack;
              this.componentDidCatch(error$1, {
                componentStack: stack !== null ? stack : ''
              });
              {
                if (typeof getDerivedStateFromError !== 'function') {
                  // If componentDidCatch is the only error boundary method defined,
                  // then it needs to call setState to recover from errors.
                  // If no state update is scheduled then the boundary will swallow the error.
                  if (!includesSomeLane(fiber.lanes, SyncLane)) {
                    error('%s: Error boundaries should implement getDerivedStateFromError(). ' + 'In that method, return a state update to display an error message or fallback UI.', getComponentName(fiber.type) || 'Unknown');
                  }
                }
              }
            };
          } else {
            update.callback = function () {
              markFailedErrorBoundaryForHotReloading(fiber);
            };
          }

          return update;
        }

        function attachPingListener(root, wakeable, lanes) {
          // Attach a listener to the promise to "ping" the root and retry. But only if
          // one does not already exist for the lanes we're currently rendering (which
          // acts like a "thread ID" here).
          var pingCache = root.pingCache;
          var threadIDs;

          if (pingCache === null) {
            pingCache = root.pingCache = new PossiblyWeakMap$1();
            threadIDs = new Set();
            pingCache.set(wakeable, threadIDs);
          } else {
            threadIDs = pingCache.get(wakeable);

            if (threadIDs === undefined) {
              threadIDs = new Set();
              pingCache.set(wakeable, threadIDs);
            }
          }

          if (!threadIDs.has(lanes)) {
            // Memoize using the thread ID to prevent redundant listeners.
            threadIDs.add(lanes);
            var ping = pingSuspendedRoot.bind(null, root, wakeable, lanes);
            wakeable.then(ping, ping);
          }
        }

        function throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
          // The source fiber did not complete.
          sourceFiber.flags |= Incomplete; // Its effect list is no longer valid.

          sourceFiber.firstEffect = sourceFiber.lastEffect = null;

          if (value !== null && typeof value === 'object' && typeof value.then === 'function') {
            // This is a wakeable.
            var wakeable = value;

            if ((sourceFiber.mode & BlockingMode) === NoMode) {
              // Reset the memoizedState to what it was before we attempted
              // to render it.
              var currentSource = sourceFiber.alternate;

              if (currentSource) {
                sourceFiber.updateQueue = currentSource.updateQueue;
                sourceFiber.memoizedState = currentSource.memoizedState;
                sourceFiber.lanes = currentSource.lanes;
              } else {
                sourceFiber.updateQueue = null;
                sourceFiber.memoizedState = null;
              }
            }

            var hasInvisibleParentBoundary = hasSuspenseContext(suspenseStackCursor.current, InvisibleParentSuspenseContext); // Schedule the nearest Suspense to re-render the timed out view.

            var _workInProgress = returnFiber;

            do {
              if (_workInProgress.tag === SuspenseComponent && shouldCaptureSuspense(_workInProgress, hasInvisibleParentBoundary)) {
                // Found the nearest boundary.
                // Stash the promise on the boundary fiber. If the boundary times out, we'll
                // attach another listener to flip the boundary back to its normal state.
                var wakeables = _workInProgress.updateQueue;

                if (wakeables === null) {
                  var updateQueue = new Set();
                  updateQueue.add(wakeable);
                  _workInProgress.updateQueue = updateQueue;
                } else {
                  wakeables.add(wakeable);
                } // If the boundary is outside of blocking mode, we should *not*
                // suspend the commit. Pretend as if the suspended component rendered
                // null and keep rendering. In the commit phase, we'll schedule a
                // subsequent synchronous update to re-render the Suspense.
                //
                // Note: It doesn't matter whether the component that suspended was
                // inside a blocking mode tree. If the Suspense is outside of it, we
                // should *not* suspend the commit.


                if ((_workInProgress.mode & BlockingMode) === NoMode) {
                  _workInProgress.flags |= DidCapture;
                  sourceFiber.flags |= ForceUpdateForLegacySuspense; // We're going to commit this fiber even though it didn't complete.
                  // But we shouldn't call any lifecycle methods or callbacks. Remove
                  // all lifecycle effect tags.

                  sourceFiber.flags &= ~(LifecycleEffectMask | Incomplete);

                  if (sourceFiber.tag === ClassComponent) {
                    var currentSourceFiber = sourceFiber.alternate;

                    if (currentSourceFiber === null) {
                      // This is a new mount. Change the tag so it's not mistaken for a
                      // completed class component. For example, we should not call
                      // componentWillUnmount if it is deleted.
                      sourceFiber.tag = IncompleteClassComponent;
                    } else {
                      // When we try rendering again, we should not reuse the current fiber,
                      // since it's known to be in an inconsistent state. Use a force update to
                      // prevent a bail out.
                      var update = createUpdate(NoTimestamp, SyncLane);
                      update.tag = ForceUpdate;
                      enqueueUpdate(sourceFiber, update);
                    }
                  } // The source fiber did not complete. Mark it with Sync priority to
                  // indicate that it still has pending work.


                  sourceFiber.lanes = mergeLanes(sourceFiber.lanes, SyncLane); // Exit without suspending.

                  return;
                } // Confirmed that the boundary is in a concurrent mode tree. Continue
                // with the normal suspend path.
                //
                // After this we'll use a set of heuristics to determine whether this
                // render pass will run to completion or restart or "suspend" the commit.
                // The actual logic for this is spread out in different places.
                //
                // This first principle is that if we're going to suspend when we complete
                // a root, then we should also restart if we get an update or ping that
                // might unsuspend it, and vice versa. The only reason to suspend is
                // because you think you might want to restart before committing. However,
                // it doesn't make sense to restart only while in the period we're suspended.
                //
                // Restarting too aggressively is also not good because it starves out any
                // intermediate loading state. So we use heuristics to determine when.
                // Suspense Heuristics
                //
                // If nothing threw a Promise or all the same fallbacks are already showing,
                // then don't suspend/restart.
                //
                // If this is an initial render of a new tree of Suspense boundaries and
                // those trigger a fallback, then don't suspend/restart. We want to ensure
                // that we can show the initial loading state as quickly as possible.
                //
                // If we hit a "Delayed" case, such as when we'd switch from content back into
                // a fallback, then we should always suspend/restart. Transitions apply
                // to this case. If none is defined, JND is used instead.
                //
                // If we're already showing a fallback and it gets "retried", allowing us to show
                // another level, but there's still an inner boundary that would show a fallback,
                // then we suspend/restart for 500ms since the last time we showed a fallback
                // anywhere in the tree. This effectively throttles progressive loading into a
                // consistent train of commits. This also gives us an opportunity to restart to
                // get to the completed state slightly earlier.
                //
                // If there's ambiguity due to batching it's resolved in preference of:
                // 1) "delayed", 2) "initial render", 3) "retry".
                //
                // We want to ensure that a "busy" state doesn't get force committed. We want to
                // ensure that new initial loading states can commit as soon as possible.


                attachPingListener(root, wakeable, rootRenderLanes);
                _workInProgress.flags |= ShouldCapture;
                _workInProgress.lanes = rootRenderLanes;
                return;
              } // This boundary already captured during this render. Continue to the next
              // boundary.


              _workInProgress = _workInProgress.return;
            } while (_workInProgress !== null); // No boundary was found. Fallthrough to error mode.
            // TODO: Use invariant so the message is stripped in prod?


            value = new Error((getComponentName(sourceFiber.type) || 'A React component') + ' suspended while rendering, but no fallback UI was specified.\n' + '\n' + 'Add a <Suspense fallback=...> component higher in the tree to ' + 'provide a loading indicator or placeholder to display.');
          } // We didn't find a boundary that could handle this type of exception. Start
          // over and traverse parent path again, this time treating the exception
          // as an error.


          renderDidError();
          value = createCapturedValue(value, sourceFiber);
          var workInProgress = returnFiber;

          do {
            switch (workInProgress.tag) {
              case HostRoot:
                {
                  var _errorInfo = value;
                  workInProgress.flags |= ShouldCapture;
                  var lane = pickArbitraryLane(rootRenderLanes);
                  workInProgress.lanes = mergeLanes(workInProgress.lanes, lane);

                  var _update = createRootErrorUpdate(workInProgress, _errorInfo, lane);

                  enqueueCapturedUpdate(workInProgress, _update);
                  return;
                }

              case ClassComponent:
                // Capture and retry
                var errorInfo = value;
                var ctor = workInProgress.type;
                var instance = workInProgress.stateNode;

                if ((workInProgress.flags & DidCapture) === NoFlags && (typeof ctor.getDerivedStateFromError === 'function' || instance !== null && typeof instance.componentDidCatch === 'function' && !isAlreadyFailedLegacyErrorBoundary(instance))) {
                  workInProgress.flags |= ShouldCapture;

                  var _lane = pickArbitraryLane(rootRenderLanes);

                  workInProgress.lanes = mergeLanes(workInProgress.lanes, _lane); // Schedule the error boundary to re-render using updated state

                  var _update2 = createClassErrorUpdate(workInProgress, errorInfo, _lane);

                  enqueueCapturedUpdate(workInProgress, _update2);
                  return;
                }

                break;
            }

            workInProgress = workInProgress.return;
          } while (workInProgress !== null);
        }

        var didWarnAboutUndefinedSnapshotBeforeUpdate = null;
        {
          didWarnAboutUndefinedSnapshotBeforeUpdate = new Set();
        }
        var PossiblyWeakSet = typeof WeakSet === 'function' ? WeakSet : Set;

        var callComponentWillUnmountWithTimer = function callComponentWillUnmountWithTimer(current, instance) {
          instance.props = current.memoizedProps;
          instance.state = current.memoizedState;
          {
            instance.componentWillUnmount();
          }
        }; // Capture errors so they don't interrupt unmounting.


        function safelyCallComponentWillUnmount(current, instance) {
          {
            invokeGuardedCallback(null, callComponentWillUnmountWithTimer, null, current, instance);

            if (hasCaughtError()) {
              var unmountError = clearCaughtError();
              captureCommitPhaseError(current, unmountError);
            }
          }
        }

        function safelyDetachRef(current) {
          var ref = current.ref;

          if (ref !== null) {
            if (typeof ref === 'function') {
              {
                invokeGuardedCallback(null, ref, null, null);

                if (hasCaughtError()) {
                  var refError = clearCaughtError();
                  captureCommitPhaseError(current, refError);
                }
              }
            } else {
              ref.current = null;
            }
          }
        }

        function safelyCallDestroy(current, destroy) {
          {
            invokeGuardedCallback(null, destroy, null);

            if (hasCaughtError()) {
              var error = clearCaughtError();
              captureCommitPhaseError(current, error);
            }
          }
        }

        function commitBeforeMutationLifeCycles(current, finishedWork) {
          switch (finishedWork.tag) {
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
            case Block:
              {
                return;
              }

            case ClassComponent:
              {
                if (finishedWork.flags & Snapshot) {
                  if (current !== null) {
                    var prevProps = current.memoizedProps;
                    var prevState = current.memoizedState;
                    var instance = finishedWork.stateNode; // We could update instance props and state here,
                    // but instead we rely on them being set during last render.
                    // TODO: revisit this when we implement resuming.

                    {
                      if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                        if (instance.props !== finishedWork.memoizedProps) {
                          error('Expected %s props to match memoized props before ' + 'getSnapshotBeforeUpdate. ' + 'This might either be because of a bug in React, or because ' + 'a component reassigns its own `this.props`. ' + 'Please file an issue.', getComponentName(finishedWork.type) || 'instance');
                        }

                        if (instance.state !== finishedWork.memoizedState) {
                          error('Expected %s state to match memoized state before ' + 'getSnapshotBeforeUpdate. ' + 'This might either be because of a bug in React, or because ' + 'a component reassigns its own `this.state`. ' + 'Please file an issue.', getComponentName(finishedWork.type) || 'instance');
                        }
                      }
                    }
                    var snapshot = instance.getSnapshotBeforeUpdate(finishedWork.elementType === finishedWork.type ? prevProps : resolveDefaultProps(finishedWork.type, prevProps), prevState);
                    {
                      var didWarnSet = didWarnAboutUndefinedSnapshotBeforeUpdate;

                      if (snapshot === undefined && !didWarnSet.has(finishedWork.type)) {
                        didWarnSet.add(finishedWork.type);
                        error('%s.getSnapshotBeforeUpdate(): A snapshot value (or null) ' + 'must be returned. You have returned undefined.', getComponentName(finishedWork.type));
                      }
                    }
                    instance.__reactInternalSnapshotBeforeUpdate = snapshot;
                  }
                }

                return;
              }

            case HostRoot:
              {
                {
                  if (finishedWork.flags & Snapshot) {
                    var root = finishedWork.stateNode;
                    clearContainer(root.containerInfo);
                  }
                }
                return;
              }

            case HostComponent:
            case HostText:
            case HostPortal:
            case IncompleteClassComponent:
              // Nothing to do for these component types
              return;
          }

          {
            {
              throw Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
            }
          }
        }

        function commitHookEffectListUnmount(tag, finishedWork) {
          var updateQueue = finishedWork.updateQueue;
          var lastEffect = updateQueue !== null ? updateQueue.lastEffect : null;

          if (lastEffect !== null) {
            var firstEffect = lastEffect.next;
            var effect = firstEffect;

            do {
              if ((effect.tag & tag) === tag) {
                // Unmount
                var destroy = effect.destroy;
                effect.destroy = undefined;

                if (destroy !== undefined) {
                  destroy();
                }
              }

              effect = effect.next;
            } while (effect !== firstEffect);
          }
        }

        function commitHookEffectListMount(tag, finishedWork) {
          var updateQueue = finishedWork.updateQueue;
          var lastEffect = updateQueue !== null ? updateQueue.lastEffect : null;

          if (lastEffect !== null) {
            var firstEffect = lastEffect.next;
            var effect = firstEffect;

            do {
              if ((effect.tag & tag) === tag) {
                // Mount
                var create = effect.create;
                effect.destroy = create();
                {
                  var destroy = effect.destroy;

                  if (destroy !== undefined && typeof destroy !== 'function') {
                    var addendum = void 0;

                    if (destroy === null) {
                      addendum = ' You returned null. If your effect does not require clean ' + 'up, return undefined (or nothing).';
                    } else if (typeof destroy.then === 'function') {
                      addendum = '\n\nIt looks like you wrote useEffect(async () => ...) or returned a Promise. ' + 'Instead, write the async function inside your effect ' + 'and call it immediately:\n\n' + 'useEffect(() => {\n' + '  async function fetchData() {\n' + '    // You can await here\n' + '    const response = await MyAPI.getData(someId);\n' + '    // ...\n' + '  }\n' + '  fetchData();\n' + "}, [someId]); // Or [] if effect doesn't need props or state\n\n" + 'Learn more about data fetching with Hooks: https://reactjs.org/link/hooks-data-fetching';
                    } else {
                      addendum = ' You returned: ' + destroy;
                    }

                    error('An effect function must not return anything besides a function, ' + 'which is used for clean-up.%s', addendum);
                  }
                }
              }

              effect = effect.next;
            } while (effect !== firstEffect);
          }
        }

        function schedulePassiveEffects(finishedWork) {
          var updateQueue = finishedWork.updateQueue;
          var lastEffect = updateQueue !== null ? updateQueue.lastEffect : null;

          if (lastEffect !== null) {
            var firstEffect = lastEffect.next;
            var effect = firstEffect;

            do {
              var _effect = effect,
                  next = _effect.next,
                  tag = _effect.tag;

              if ((tag & Passive$1) !== NoFlags$1 && (tag & HasEffect) !== NoFlags$1) {
                enqueuePendingPassiveHookEffectUnmount(finishedWork, effect);
                enqueuePendingPassiveHookEffectMount(finishedWork, effect);
              }

              effect = next;
            } while (effect !== firstEffect);
          }
        }

        function commitLifeCycles(finishedRoot, current, finishedWork, committedLanes) {
          switch (finishedWork.tag) {
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
            case Block:
              {
                // At this point layout effects have already been destroyed (during mutation phase).
                // This is done to prevent sibling component effects from interfering with each other,
                // e.g. a destroy function in one component should never override a ref set
                // by a create function in another component during the same commit.
                {
                  commitHookEffectListMount(Layout | HasEffect, finishedWork);
                }
                schedulePassiveEffects(finishedWork);
                return;
              }

            case ClassComponent:
              {
                var instance = finishedWork.stateNode;

                if (finishedWork.flags & Update) {
                  if (current === null) {
                    // We could update instance props and state here,
                    // but instead we rely on them being set during last render.
                    // TODO: revisit this when we implement resuming.
                    {
                      if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                        if (instance.props !== finishedWork.memoizedProps) {
                          error('Expected %s props to match memoized props before ' + 'componentDidMount. ' + 'This might either be because of a bug in React, or because ' + 'a component reassigns its own `this.props`. ' + 'Please file an issue.', getComponentName(finishedWork.type) || 'instance');
                        }

                        if (instance.state !== finishedWork.memoizedState) {
                          error('Expected %s state to match memoized state before ' + 'componentDidMount. ' + 'This might either be because of a bug in React, or because ' + 'a component reassigns its own `this.state`. ' + 'Please file an issue.', getComponentName(finishedWork.type) || 'instance');
                        }
                      }
                    }
                    {
                      instance.componentDidMount();
                    }
                  } else {
                    var prevProps = finishedWork.elementType === finishedWork.type ? current.memoizedProps : resolveDefaultProps(finishedWork.type, current.memoizedProps);
                    var prevState = current.memoizedState; // We could update instance props and state here,
                    // but instead we rely on them being set during last render.
                    // TODO: revisit this when we implement resuming.

                    {
                      if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                        if (instance.props !== finishedWork.memoizedProps) {
                          error('Expected %s props to match memoized props before ' + 'componentDidUpdate. ' + 'This might either be because of a bug in React, or because ' + 'a component reassigns its own `this.props`. ' + 'Please file an issue.', getComponentName(finishedWork.type) || 'instance');
                        }

                        if (instance.state !== finishedWork.memoizedState) {
                          error('Expected %s state to match memoized state before ' + 'componentDidUpdate. ' + 'This might either be because of a bug in React, or because ' + 'a component reassigns its own `this.state`. ' + 'Please file an issue.', getComponentName(finishedWork.type) || 'instance');
                        }
                      }
                    }
                    {
                      instance.componentDidUpdate(prevProps, prevState, instance.__reactInternalSnapshotBeforeUpdate);
                    }
                  }
                } // TODO: I think this is now always non-null by the time it reaches the
                // commit phase. Consider removing the type check.


                var updateQueue = finishedWork.updateQueue;

                if (updateQueue !== null) {
                  {
                    if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                      if (instance.props !== finishedWork.memoizedProps) {
                        error('Expected %s props to match memoized props before ' + 'processing the update queue. ' + 'This might either be because of a bug in React, or because ' + 'a component reassigns its own `this.props`. ' + 'Please file an issue.', getComponentName(finishedWork.type) || 'instance');
                      }

                      if (instance.state !== finishedWork.memoizedState) {
                        error('Expected %s state to match memoized state before ' + 'processing the update queue. ' + 'This might either be because of a bug in React, or because ' + 'a component reassigns its own `this.state`. ' + 'Please file an issue.', getComponentName(finishedWork.type) || 'instance');
                      }
                    }
                  } // We could update instance props and state here,
                  // but instead we rely on them being set during last render.
                  // TODO: revisit this when we implement resuming.

                  commitUpdateQueue(finishedWork, updateQueue, instance);
                }

                return;
              }

            case HostRoot:
              {
                // TODO: I think this is now always non-null by the time it reaches the
                // commit phase. Consider removing the type check.
                var _updateQueue = finishedWork.updateQueue;

                if (_updateQueue !== null) {
                  var _instance = null;

                  if (finishedWork.child !== null) {
                    switch (finishedWork.child.tag) {
                      case HostComponent:
                        _instance = getPublicInstance(finishedWork.child.stateNode);
                        break;

                      case ClassComponent:
                        _instance = finishedWork.child.stateNode;
                        break;
                    }
                  }

                  commitUpdateQueue(finishedWork, _updateQueue, _instance);
                }

                return;
              }

            case HostComponent:
              {
                var _instance2 = finishedWork.stateNode; // Renderers may schedule work to be done after host components are mounted
                // (eg DOM renderer may schedule auto-focus for inputs and form controls).
                // These effects should only be committed when components are first mounted,
                // aka when there is no current/alternate.

                if (current === null && finishedWork.flags & Update) {
                  var type = finishedWork.type;
                  var props = finishedWork.memoizedProps;
                  commitMount(_instance2, type, props);
                }

                return;
              }

            case HostText:
              {
                // We have no life-cycles associated with text.
                return;
              }

            case HostPortal:
              {
                // We have no life-cycles associated with portals.
                return;
              }

            case Profiler:
              {
                {
                  var _finishedWork$memoize2 = finishedWork.memoizedProps,
                      onCommit = _finishedWork$memoize2.onCommit,
                      onRender = _finishedWork$memoize2.onRender;
                  var effectDuration = finishedWork.stateNode.effectDuration;
                  var commitTime = getCommitTime();

                  if (typeof onRender === 'function') {
                    {
                      onRender(finishedWork.memoizedProps.id, current === null ? 'mount' : 'update', finishedWork.actualDuration, finishedWork.treeBaseDuration, finishedWork.actualStartTime, commitTime, finishedRoot.memoizedInteractions);
                    }
                  }
                }
                return;
              }

            case SuspenseComponent:
              {
                commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                return;
              }

            case SuspenseListComponent:
            case IncompleteClassComponent:
            case FundamentalComponent:
            case ScopeComponent:
            case OffscreenComponent:
            case LegacyHiddenComponent:
              return;
          }

          {
            {
              throw Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
            }
          }
        }

        function hideOrUnhideAllChildren(finishedWork, isHidden) {
          {
            // We only have the top Fiber that was inserted but we need to recurse down its
            // children to find all the terminal nodes.
            var node = finishedWork;

            while (true) {
              if (node.tag === HostComponent) {
                var instance = node.stateNode;

                if (isHidden) {
                  hideInstance(instance);
                } else {
                  unhideInstance(node.stateNode, node.memoizedProps);
                }
              } else if (node.tag === HostText) {
                var _instance3 = node.stateNode;

                if (isHidden) {
                  hideTextInstance(_instance3);
                } else {
                  unhideTextInstance(_instance3, node.memoizedProps);
                }
              } else if ((node.tag === OffscreenComponent || node.tag === LegacyHiddenComponent) && node.memoizedState !== null && node !== finishedWork) ;else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
              }

              if (node === finishedWork) {
                return;
              }

              while (node.sibling === null) {
                if (node.return === null || node.return === finishedWork) {
                  return;
                }

                node = node.return;
              }

              node.sibling.return = node.return;
              node = node.sibling;
            }
          }
        }

        function commitAttachRef(finishedWork) {
          var ref = finishedWork.ref;

          if (ref !== null) {
            var instance = finishedWork.stateNode;
            var instanceToUse;

            switch (finishedWork.tag) {
              case HostComponent:
                instanceToUse = getPublicInstance(instance);
                break;

              default:
                instanceToUse = instance;
            } // Moved outside to ensure DCE works with this flag


            if (typeof ref === 'function') {
              ref(instanceToUse);
            } else {
              {
                if (!ref.hasOwnProperty('current')) {
                  error('Unexpected ref object provided for %s. ' + 'Use either a ref-setter function or React.createRef().', getComponentName(finishedWork.type));
                }
              }
              ref.current = instanceToUse;
            }
          }
        }

        function commitDetachRef(current) {
          var currentRef = current.ref;

          if (currentRef !== null) {
            if (typeof currentRef === 'function') {
              currentRef(null);
            } else {
              currentRef.current = null;
            }
          }
        } // User-originating errors (lifecycles and refs) should not interrupt
        // deletion, so don't let them throw. Host-originating errors should
        // interrupt deletion, so it's okay


        function commitUnmount(finishedRoot, current, renderPriorityLevel) {
          onCommitUnmount(current);

          switch (current.tag) {
            case FunctionComponent:
            case ForwardRef:
            case MemoComponent:
            case SimpleMemoComponent:
            case Block:
              {
                var updateQueue = current.updateQueue;

                if (updateQueue !== null) {
                  var lastEffect = updateQueue.lastEffect;

                  if (lastEffect !== null) {
                    var firstEffect = lastEffect.next;
                    var effect = firstEffect;

                    do {
                      var _effect2 = effect,
                          destroy = _effect2.destroy,
                          tag = _effect2.tag;

                      if (destroy !== undefined) {
                        if ((tag & Passive$1) !== NoFlags$1) {
                          enqueuePendingPassiveHookEffectUnmount(current, effect);
                        } else {
                          {
                            safelyCallDestroy(current, destroy);
                          }
                        }
                      }

                      effect = effect.next;
                    } while (effect !== firstEffect);
                  }
                }

                return;
              }

            case ClassComponent:
              {
                safelyDetachRef(current);
                var instance = current.stateNode;

                if (typeof instance.componentWillUnmount === 'function') {
                  safelyCallComponentWillUnmount(current, instance);
                }

                return;
              }

            case HostComponent:
              {
                safelyDetachRef(current);
                return;
              }

            case HostPortal:
              {
                // TODO: this is recursive.
                // We are also not using this parent because
                // the portal will get pushed immediately.
                {
                  unmountHostComponents(finishedRoot, current);
                }
                return;
              }

            case FundamentalComponent:
              {
                return;
              }

            case DehydratedFragment:
              {
                return;
              }

            case ScopeComponent:
              {
                return;
              }
          }
        }

        function commitNestedUnmounts(finishedRoot, root, renderPriorityLevel) {
          // While we're inside a removed host node we don't want to call
          // removeChild on the inner nodes because they're removed by the top
          // call anyway. We also want to call componentWillUnmount on all
          // composites before this host node is removed from the tree. Therefore
          // we do an inner loop while we're still inside the host node.
          var node = root;

          while (true) {
            commitUnmount(finishedRoot, node); // Visit children because they may contain more composite or host nodes.
            // Skip portals because commitUnmount() currently visits them recursively.

            if (node.child !== null && // If we use mutation we drill down into portals using commitUnmount above.
            // If we don't use mutation we drill down into portals here instead.
            node.tag !== HostPortal) {
              node.child.return = node;
              node = node.child;
              continue;
            }

            if (node === root) {
              return;
            }

            while (node.sibling === null) {
              if (node.return === null || node.return === root) {
                return;
              }

              node = node.return;
            }

            node.sibling.return = node.return;
            node = node.sibling;
          }
        }

        function detachFiberMutation(fiber) {
          // Cut off the return pointers to disconnect it from the tree. Ideally, we
          // should clear the child pointer of the parent alternate to let this
          // get GC:ed but we don't know which for sure which parent is the current
          // one so we'll settle for GC:ing the subtree of this child. This child
          // itself will be GC:ed when the parent updates the next time.
          // Note: we cannot null out sibling here, otherwise it can cause issues
          // with findDOMNode and how it requires the sibling field to carry out
          // traversal in a later effect. See PR #16820. We now clear the sibling
          // field after effects, see: detachFiberAfterEffects.
          //
          // Don't disconnect stateNode now; it will be detached in detachFiberAfterEffects.
          // It may be required if the current component is an error boundary,
          // and one of its descendants throws while unmounting a passive effect.
          fiber.alternate = null;
          fiber.child = null;
          fiber.dependencies = null;
          fiber.firstEffect = null;
          fiber.lastEffect = null;
          fiber.memoizedProps = null;
          fiber.memoizedState = null;
          fiber.pendingProps = null;
          fiber.return = null;
          fiber.updateQueue = null;
          {
            fiber._debugOwner = null;
          }
        }

        function getHostParentFiber(fiber) {
          var parent = fiber.return;

          while (parent !== null) {
            if (isHostParent(parent)) {
              return parent;
            }

            parent = parent.return;
          }

          {
            {
              throw Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
            }
          }
        }

        function isHostParent(fiber) {
          return fiber.tag === HostComponent || fiber.tag === HostRoot || fiber.tag === HostPortal;
        }

        function getHostSibling(fiber) {
          // We're going to search forward into the tree until we find a sibling host
          // node. Unfortunately, if multiple insertions are done in a row we have to
          // search past them. This leads to exponential search for the next sibling.
          // TODO: Find a more efficient way to do this.
          var node = fiber;

          siblings: while (true) {
            // If we didn't find anything, let's try the next sibling.
            while (node.sibling === null) {
              if (node.return === null || isHostParent(node.return)) {
                // If we pop out of the root or hit the parent the fiber we are the
                // last sibling.
                return null;
              }

              node = node.return;
            }

            node.sibling.return = node.return;
            node = node.sibling;

            while (node.tag !== HostComponent && node.tag !== HostText && node.tag !== DehydratedFragment) {
              // If it is not host node and, we might have a host node inside it.
              // Try to search down until we find one.
              if (node.flags & Placement) {
                // If we don't have a child, try the siblings instead.
                continue siblings;
              } // If we don't have a child, try the siblings instead.
              // We also skip portals because they are not part of this host tree.


              if (node.child === null || node.tag === HostPortal) {
                continue siblings;
              } else {
                node.child.return = node;
                node = node.child;
              }
            } // Check if this host node is stable or about to be placed.


            if (!(node.flags & Placement)) {
              // Found it!
              return node.stateNode;
            }
          }
        }

        function commitPlacement(finishedWork) {
          var parentFiber = getHostParentFiber(finishedWork); // Note: these two variables *must* always be updated together.

          var parent;
          var isContainer;
          var parentStateNode = parentFiber.stateNode;

          switch (parentFiber.tag) {
            case HostComponent:
              parent = parentStateNode;
              isContainer = false;
              break;

            case HostRoot:
              parent = parentStateNode.containerInfo;
              isContainer = true;
              break;

            case HostPortal:
              parent = parentStateNode.containerInfo;
              isContainer = true;
              break;

            case FundamentalComponent: // eslint-disable-next-line-no-fallthrough

            default:
              {
                {
                  throw Error("Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue.");
                }
              }
          }

          if (parentFiber.flags & ContentReset) {
            // Reset the text content of the parent before doing any insertions
            resetTextContent(parent); // Clear ContentReset from the effect tag

            parentFiber.flags &= ~ContentReset;
          }

          var before = getHostSibling(finishedWork); // We only have the top Fiber that was inserted but we need to recurse down its
          // children to find all the terminal nodes.

          if (isContainer) {
            insertOrAppendPlacementNodeIntoContainer(finishedWork, before, parent);
          } else {
            insertOrAppendPlacementNode(finishedWork, before, parent);
          }
        }

        function insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
          var tag = node.tag;
          var isHost = tag === HostComponent || tag === HostText;

          if (isHost || enableFundamentalAPI) {
            var stateNode = isHost ? node.stateNode : node.stateNode.instance;

            if (before) {
              insertInContainerBefore(parent, stateNode, before);
            } else {
              appendChildToContainer(parent, stateNode);
            }
          } else if (tag === HostPortal) ;else {
            var child = node.child;

            if (child !== null) {
              insertOrAppendPlacementNodeIntoContainer(child, before, parent);
              var sibling = child.sibling;

              while (sibling !== null) {
                insertOrAppendPlacementNodeIntoContainer(sibling, before, parent);
                sibling = sibling.sibling;
              }
            }
          }
        }

        function insertOrAppendPlacementNode(node, before, parent) {
          var tag = node.tag;
          var isHost = tag === HostComponent || tag === HostText;

          if (isHost || enableFundamentalAPI) {
            var stateNode = isHost ? node.stateNode : node.stateNode.instance;

            if (before) {
              insertBefore(parent, stateNode, before);
            } else {
              appendChild(parent, stateNode);
            }
          } else if (tag === HostPortal) ;else {
            var child = node.child;

            if (child !== null) {
              insertOrAppendPlacementNode(child, before, parent);
              var sibling = child.sibling;

              while (sibling !== null) {
                insertOrAppendPlacementNode(sibling, before, parent);
                sibling = sibling.sibling;
              }
            }
          }
        }

        function unmountHostComponents(finishedRoot, current, renderPriorityLevel) {
          // We only have the top Fiber that was deleted but we need to recurse down its
          // children to find all the terminal nodes.
          var node = current; // Each iteration, currentParent is populated with node's host parent if not
          // currentParentIsValid.

          var currentParentIsValid = false; // Note: these two variables *must* always be updated together.

          var currentParent;
          var currentParentIsContainer;

          while (true) {
            if (!currentParentIsValid) {
              var parent = node.return;

              findParent: while (true) {
                if (!(parent !== null)) {
                  {
                    throw Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
                  }
                }

                var parentStateNode = parent.stateNode;

                switch (parent.tag) {
                  case HostComponent:
                    currentParent = parentStateNode;
                    currentParentIsContainer = false;
                    break findParent;

                  case HostRoot:
                    currentParent = parentStateNode.containerInfo;
                    currentParentIsContainer = true;
                    break findParent;

                  case HostPortal:
                    currentParent = parentStateNode.containerInfo;
                    currentParentIsContainer = true;
                    break findParent;
                }

                parent = parent.return;
              }

              currentParentIsValid = true;
            }

            if (node.tag === HostComponent || node.tag === HostText) {
              commitNestedUnmounts(finishedRoot, node); // After all the children have unmounted, it is now safe to remove the
              // node from the tree.

              if (currentParentIsContainer) {
                removeChildFromContainer(currentParent, node.stateNode);
              } else {
                removeChild(currentParent, node.stateNode);
              } // Don't visit children because we already visited them.

            } else if (node.tag === HostPortal) {
              if (node.child !== null) {
                // When we go into a portal, it becomes the parent to remove from.
                // We will reassign it back when we pop the portal on the way up.
                currentParent = node.stateNode.containerInfo;
                currentParentIsContainer = true; // Visit children because portals might contain host components.

                node.child.return = node;
                node = node.child;
                continue;
              }
            } else {
              commitUnmount(finishedRoot, node); // Visit children because we may find more host components below.

              if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
              }
            }

            if (node === current) {
              return;
            }

            while (node.sibling === null) {
              if (node.return === null || node.return === current) {
                return;
              }

              node = node.return;

              if (node.tag === HostPortal) {
                // When we go out of the portal, we need to restore the parent.
                // Since we don't keep a stack of them, we will search for it.
                currentParentIsValid = false;
              }
            }

            node.sibling.return = node.return;
            node = node.sibling;
          }
        }

        function commitDeletion(finishedRoot, current, renderPriorityLevel) {
          {
            // Recursively delete all host nodes from the parent.
            // Detach refs and call componentWillUnmount() on the whole subtree.
            unmountHostComponents(finishedRoot, current);
          }
          var alternate = current.alternate;
          detachFiberMutation(current);

          if (alternate !== null) {
            detachFiberMutation(alternate);
          }
        }

        function commitWork(current, finishedWork) {
          switch (finishedWork.tag) {
            case FunctionComponent:
            case ForwardRef:
            case MemoComponent:
            case SimpleMemoComponent:
            case Block:
              {
                // Layout effects are destroyed during the mutation phase so that all
                // destroy functions for all fibers are called before any create functions.
                // This prevents sibling component effects from interfering with each other,
                // e.g. a destroy function in one component should never override a ref set
                // by a create function in another component during the same commit.
                {
                  commitHookEffectListUnmount(Layout | HasEffect, finishedWork);
                }
                return;
              }

            case ClassComponent:
              {
                return;
              }

            case HostComponent:
              {
                var instance = finishedWork.stateNode;

                if (instance != null) {
                  // Commit the work prepared earlier.
                  var newProps = finishedWork.memoizedProps; // For hydration we reuse the update path but we treat the oldProps
                  // as the newProps. The updatePayload will contain the real change in
                  // this case.

                  var oldProps = current !== null ? current.memoizedProps : newProps;
                  var type = finishedWork.type; // TODO: Type the updateQueue to be specific to host components.

                  var updatePayload = finishedWork.updateQueue;
                  finishedWork.updateQueue = null;

                  if (updatePayload !== null) {
                    commitUpdate(instance, updatePayload, type, oldProps, newProps);
                  }
                }

                return;
              }

            case HostText:
              {
                if (!(finishedWork.stateNode !== null)) {
                  {
                    throw Error("This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue.");
                  }
                }

                var textInstance = finishedWork.stateNode;
                var newText = finishedWork.memoizedProps; // For hydration we reuse the update path but we treat the oldProps
                // as the newProps. The updatePayload will contain the real change in
                // this case.

                var oldText = current !== null ? current.memoizedProps : newText;
                commitTextUpdate(textInstance, oldText, newText);
                return;
              }

            case HostRoot:
              {
                {
                  var _root = finishedWork.stateNode;

                  if (_root.hydrate) {
                    // We've just hydrated. No need to hydrate again.
                    _root.hydrate = false;
                    commitHydratedContainer(_root.containerInfo);
                  }
                }
                return;
              }

            case Profiler:
              {
                return;
              }

            case SuspenseComponent:
              {
                commitSuspenseComponent(finishedWork);
                attachSuspenseRetryListeners(finishedWork);
                return;
              }

            case SuspenseListComponent:
              {
                attachSuspenseRetryListeners(finishedWork);
                return;
              }

            case IncompleteClassComponent:
              {
                return;
              }

            case FundamentalComponent:
              {
                break;
              }

            case ScopeComponent:
              {
                break;
              }

            case OffscreenComponent:
            case LegacyHiddenComponent:
              {
                var newState = finishedWork.memoizedState;
                var isHidden = newState !== null;
                hideOrUnhideAllChildren(finishedWork, isHidden);
                return;
              }
          }

          {
            {
              throw Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
            }
          }
        }

        function commitSuspenseComponent(finishedWork) {
          var newState = finishedWork.memoizedState;

          if (newState !== null) {
            markCommitTimeOfFallback();
            {
              // Hide the Offscreen component that contains the primary children. TODO:
              // Ideally, this effect would have been scheduled on the Offscreen fiber
              // itself. That's how unhiding works: the Offscreen component schedules an
              // effect on itself. However, in this case, the component didn't complete,
              // so the fiber was never added to the effect list in the normal path. We
              // could have appended it to the effect list in the Suspense component's
              // second pass, but doing it this way is less complicated. This would be
              // simpler if we got rid of the effect list and traversed the tree, like
              // we're planning to do.
              var primaryChildParent = finishedWork.child;
              hideOrUnhideAllChildren(primaryChildParent, true);
            }
          }
        }

        function commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
          var newState = finishedWork.memoizedState;

          if (newState === null) {
            var current = finishedWork.alternate;

            if (current !== null) {
              var prevState = current.memoizedState;

              if (prevState !== null) {
                var suspenseInstance = prevState.dehydrated;

                if (suspenseInstance !== null) {
                  commitHydratedSuspenseInstance(suspenseInstance);
                }
              }
            }
          }
        }

        function attachSuspenseRetryListeners(finishedWork) {
          // If this boundary just timed out, then it will have a set of wakeables.
          // For each wakeable, attach a listener so that when it resolves, React
          // attempts to re-render the boundary in the primary (pre-timeout) state.
          var wakeables = finishedWork.updateQueue;

          if (wakeables !== null) {
            finishedWork.updateQueue = null;
            var retryCache = finishedWork.stateNode;

            if (retryCache === null) {
              retryCache = finishedWork.stateNode = new PossiblyWeakSet();
            }

            wakeables.forEach(function (wakeable) {
              // Memoize using the boundary fiber to prevent redundant listeners.
              var retry = resolveRetryWakeable.bind(null, finishedWork, wakeable);

              if (!retryCache.has(wakeable)) {
                {
                  if (wakeable.__reactDoNotTraceInteractions !== true) {
                    retry = tracing.unstable_wrap(retry);
                  }
                }
                retryCache.add(wakeable);
                wakeable.then(retry, retry);
              }
            });
          }
        } // This function detects when a Suspense boundary goes from visible to hidden.
        // It returns false if the boundary is already hidden.
        // TODO: Use an effect tag.


        function isSuspenseBoundaryBeingHidden(current, finishedWork) {
          if (current !== null) {
            var oldState = current.memoizedState;

            if (oldState === null || oldState.dehydrated !== null) {
              var newState = finishedWork.memoizedState;
              return newState !== null && newState.dehydrated === null;
            }
          }

          return false;
        }

        function commitResetTextContent(current) {
          resetTextContent(current.stateNode);
        }

        var COMPONENT_TYPE = 0;
        var HAS_PSEUDO_CLASS_TYPE = 1;
        var ROLE_TYPE = 2;
        var TEST_NAME_TYPE = 3;
        var TEXT_TYPE = 4;

        if (typeof Symbol === 'function' && Symbol.for) {
          var symbolFor$1 = Symbol.for;
          COMPONENT_TYPE = symbolFor$1('selector.component');
          HAS_PSEUDO_CLASS_TYPE = symbolFor$1('selector.has_pseudo_class');
          ROLE_TYPE = symbolFor$1('selector.role');
          TEST_NAME_TYPE = symbolFor$1('selector.test_id');
          TEXT_TYPE = symbolFor$1('selector.text');
        }

        var commitHooks = [];

        function onCommitRoot$1() {
          {
            commitHooks.forEach(function (commitHook) {
              return commitHook();
            });
          }
        }

        var ceil = Math.ceil;
        var ReactCurrentDispatcher$2 = ReactSharedInternals.ReactCurrentDispatcher,
            ReactCurrentOwner$2 = ReactSharedInternals.ReactCurrentOwner,
            IsSomeRendererActing = ReactSharedInternals.IsSomeRendererActing;
        var NoContext =
        /*             */
        0;
        var BatchedContext =
        /*               */
        1;
        var EventContext =
        /*                 */
        2;
        var DiscreteEventContext =
        /*         */
        4;
        var LegacyUnbatchedContext =
        /*       */
        8;
        var RenderContext =
        /*                */
        16;
        var CommitContext =
        /*                */
        32;
        var RetryAfterError =
        /*       */
        64;
        var RootIncomplete = 0;
        var RootFatalErrored = 1;
        var RootErrored = 2;
        var RootSuspended = 3;
        var RootSuspendedWithDelay = 4;
        var RootCompleted = 5; // Describes where we are in the React execution stack

        var executionContext = NoContext; // The root we're working on

        var workInProgressRoot = null; // The fiber we're working on

        var workInProgress = null; // The lanes we're rendering

        var workInProgressRootRenderLanes = NoLanes; // Stack that allows components to change the render lanes for its subtree
        // This is a superset of the lanes we started working on at the root. The only
        // case where it's different from `workInProgressRootRenderLanes` is when we
        // enter a subtree that is hidden and needs to be unhidden: Suspense and
        // Offscreen component.
        //
        // Most things in the work loop should deal with workInProgressRootRenderLanes.
        // Most things in begin/complete phases should deal with subtreeRenderLanes.

        var subtreeRenderLanes = NoLanes;
        var subtreeRenderLanesCursor = createCursor(NoLanes); // Whether to root completed, errored, suspended, etc.

        var workInProgressRootExitStatus = RootIncomplete; // A fatal error, if one is thrown

        var workInProgressRootFatalError = null; // "Included" lanes refer to lanes that were worked on during this render. It's
        // slightly different than `renderLanes` because `renderLanes` can change as you
        // enter and exit an Offscreen tree. This value is the combination of all render
        // lanes for the entire render phase.

        var workInProgressRootIncludedLanes = NoLanes; // The work left over by components that were visited during this render. Only
        // includes unprocessed updates, not work in bailed out children.

        var workInProgressRootSkippedLanes = NoLanes; // Lanes that were updated (in an interleaved event) during this render.

        var workInProgressRootUpdatedLanes = NoLanes; // Lanes that were pinged (in an interleaved event) during this render.

        var workInProgressRootPingedLanes = NoLanes;
        var mostRecentlyUpdatedRoot = null; // The most recent time we committed a fallback. This lets us ensure a train
        // model where we don't commit new loading states in too quick succession.

        var globalMostRecentFallbackTime = 0;
        var FALLBACK_THROTTLE_MS = 500; // The absolute time for when we should start giving up on rendering
        // more and prefer CPU suspense heuristics instead.

        var workInProgressRootRenderTargetTime = Infinity; // How long a render is supposed to take before we start following CPU
        // suspense heuristics and opt out of rendering more content.

        var RENDER_TIMEOUT_MS = 500;

        function resetRenderTimer() {
          workInProgressRootRenderTargetTime = now() + RENDER_TIMEOUT_MS;
        }

        function getRenderTargetTime() {
          return workInProgressRootRenderTargetTime;
        }

        var nextEffect = null;
        var hasUncaughtError = false;
        var firstUncaughtError = null;
        var legacyErrorBoundariesThatAlreadyFailed = null;
        var rootDoesHavePassiveEffects = false;
        var rootWithPendingPassiveEffects = null;
        var pendingPassiveEffectsRenderPriority = NoPriority$1;
        var pendingPassiveEffectsLanes = NoLanes;
        var pendingPassiveHookEffectsMount = [];
        var pendingPassiveHookEffectsUnmount = [];
        var rootsWithPendingDiscreteUpdates = null; // Use these to prevent an infinite loop of nested updates

        var NESTED_UPDATE_LIMIT = 50;
        var nestedUpdateCount = 0;
        var rootWithNestedUpdates = null;
        var NESTED_PASSIVE_UPDATE_LIMIT = 50;
        var nestedPassiveUpdateCount = 0; // Marks the need to reschedule pending interactions at these lanes
        // during the commit phase. This enables them to be traced across components
        // that spawn new work during render. E.g. hidden boundaries, suspended SSR
        // hydration or SuspenseList.
        // TODO: Can use a bitmask instead of an array

        var spawnedWorkDuringRender = null; // If two updates are scheduled within the same event, we should treat their
        // event times as simultaneous, even if the actual clock time has advanced
        // between the first and second call.

        var currentEventTime = NoTimestamp;
        var currentEventWipLanes = NoLanes;
        var currentEventPendingLanes = NoLanes; // Dev only flag that tracks if passive effects are currently being flushed.
        // We warn about state updates for unmounted components differently in this case.

        var isFlushingPassiveEffects = false;
        var focusedInstanceHandle = null;
        var shouldFireAfterActiveInstanceBlur = false;

        function getWorkInProgressRoot() {
          return workInProgressRoot;
        }

        function requestEventTime() {
          if ((executionContext & (RenderContext | CommitContext)) !== NoContext) {
            // We're inside React, so it's fine to read the actual time.
            return now();
          } // We're not inside React, so we may be in the middle of a browser event.


          if (currentEventTime !== NoTimestamp) {
            // Use the same start time for all updates until we enter React again.
            return currentEventTime;
          } // This is the first update since React yielded. Compute a new start time.


          currentEventTime = now();
          return currentEventTime;
        }

        function requestUpdateLane(fiber) {
          // Special cases
          var mode = fiber.mode;

          if ((mode & BlockingMode) === NoMode) {
            return SyncLane;
          } else if ((mode & ConcurrentMode) === NoMode) {
            return getCurrentPriorityLevel() === ImmediatePriority$1 ? SyncLane : SyncBatchedLane;
          } // The algorithm for assigning an update to a lane should be stable for all
          // updates at the same priority within the same event. To do this, the inputs
          // to the algorithm must be the same. For example, we use the `renderLanes`
          // to avoid choosing a lane that is already in the middle of rendering.
          //
          // However, the "included" lanes could be mutated in between updates in the
          // same event, like if you perform an update inside `flushSync`. Or any other
          // code path that might call `prepareFreshStack`.
          //
          // The trick we use is to cache the first of each of these inputs within an
          // event. Then reset the cached values once we can be sure the event is over.
          // Our heuristic for that is whenever we enter a concurrent work loop.
          //
          // We'll do the same for `currentEventPendingLanes` below.


          if (currentEventWipLanes === NoLanes) {
            currentEventWipLanes = workInProgressRootIncludedLanes;
          }

          var isTransition = requestCurrentTransition() !== NoTransition;

          if (isTransition) {
            if (currentEventPendingLanes !== NoLanes) {
              currentEventPendingLanes = mostRecentlyUpdatedRoot !== null ? mostRecentlyUpdatedRoot.pendingLanes : NoLanes;
            }

            return findTransitionLane(currentEventWipLanes, currentEventPendingLanes);
          } // TODO: Remove this dependency on the Scheduler priority.
          // To do that, we're replacing it with an update lane priority.


          var schedulerPriority = getCurrentPriorityLevel(); // The old behavior was using the priority level of the Scheduler.
          // This couples React to the Scheduler internals, so we're replacing it
          // with the currentUpdateLanePriority above. As an example of how this
          // could be problematic, if we're not inside `Scheduler.runWithPriority`,
          // then we'll get the priority of the current running Scheduler task,
          // which is probably not what we want.

          var lane;

          if ( // TODO: Temporary. We're removing the concept of discrete updates.
          (executionContext & DiscreteEventContext) !== NoContext && schedulerPriority === UserBlockingPriority$2) {
            lane = findUpdateLane(InputDiscreteLanePriority, currentEventWipLanes);
          } else {
            var schedulerLanePriority = schedulerPriorityToLanePriority(schedulerPriority);
            lane = findUpdateLane(schedulerLanePriority, currentEventWipLanes);
          }

          return lane;
        }

        function requestRetryLane(fiber) {
          // This is a fork of `requestUpdateLane` designed specifically for Suspense
          // "retries" — a special update that attempts to flip a Suspense boundary
          // from its placeholder state to its primary/resolved state.
          // Special cases
          var mode = fiber.mode;

          if ((mode & BlockingMode) === NoMode) {
            return SyncLane;
          } else if ((mode & ConcurrentMode) === NoMode) {
            return getCurrentPriorityLevel() === ImmediatePriority$1 ? SyncLane : SyncBatchedLane;
          } // See `requestUpdateLane` for explanation of `currentEventWipLanes`


          if (currentEventWipLanes === NoLanes) {
            currentEventWipLanes = workInProgressRootIncludedLanes;
          }

          return findRetryLane(currentEventWipLanes);
        }

        function scheduleUpdateOnFiber(fiber, lane, eventTime) {
          checkForNestedUpdates();
          warnAboutRenderPhaseUpdatesInDEV(fiber);
          var root = markUpdateLaneFromFiberToRoot(fiber, lane);

          if (root === null) {
            warnAboutUpdateOnUnmountedFiberInDEV(fiber);
            return null;
          } // Mark that the root has a pending update.


          markRootUpdated(root, lane, eventTime);

          if (root === workInProgressRoot) {
            // Received an update to a tree that's in the middle of rendering. Mark
            // that there was an interleaved update work on this root. Unless the
            // `deferRenderPhaseUpdateToNextBatch` flag is off and this is a render
            // phase update. In that case, we don't treat render phase updates as if
            // they were interleaved, for backwards compat reasons.
            {
              workInProgressRootUpdatedLanes = mergeLanes(workInProgressRootUpdatedLanes, lane);
            }

            if (workInProgressRootExitStatus === RootSuspendedWithDelay) {
              // The root already suspended with a delay, which means this render
              // definitely won't finish. Since we have a new update, let's mark it as
              // suspended now, right before marking the incoming update. This has the
              // effect of interrupting the current render and switching to the update.
              // TODO: Make sure this doesn't override pings that happen while we've
              // already started rendering.
              markRootSuspended$1(root, workInProgressRootRenderLanes);
            }
          } // TODO: requestUpdateLanePriority also reads the priority. Pass the
          // priority as an argument to that function and this one.


          var priorityLevel = getCurrentPriorityLevel();

          if (lane === SyncLane) {
            if ( // Check if we're inside unbatchedUpdates
            (executionContext & LegacyUnbatchedContext) !== NoContext && // Check if we're not already rendering
            (executionContext & (RenderContext | CommitContext)) === NoContext) {
              // Register pending interactions on the root to avoid losing traced interaction data.
              schedulePendingInteractions(root, lane); // This is a legacy edge case. The initial mount of a ReactDOM.render-ed
              // root inside of batchedUpdates should be synchronous, but layout updates
              // should be deferred until the end of the batch.

              performSyncWorkOnRoot(root);
            } else {
              ensureRootIsScheduled(root, eventTime);
              schedulePendingInteractions(root, lane);

              if (executionContext === NoContext) {
                // Flush the synchronous work now, unless we're already working or inside
                // a batch. This is intentionally inside scheduleUpdateOnFiber instead of
                // scheduleCallbackForFiber to preserve the ability to schedule a callback
                // without immediately flushing it. We only do this for user-initiated
                // updates, to preserve historical behavior of legacy mode.
                resetRenderTimer();
                flushSyncCallbackQueue();
              }
            }
          } else {
            // Schedule a discrete update but only if it's not Sync.
            if ((executionContext & DiscreteEventContext) !== NoContext && ( // Only updates at user-blocking priority or greater are considered
            // discrete, even inside a discrete event.
            priorityLevel === UserBlockingPriority$2 || priorityLevel === ImmediatePriority$1)) {
              // This is the result of a discrete event. Track the lowest priority
              // discrete update per root so we can flush them early, if needed.
              if (rootsWithPendingDiscreteUpdates === null) {
                rootsWithPendingDiscreteUpdates = new Set([root]);
              } else {
                rootsWithPendingDiscreteUpdates.add(root);
              }
            } // Schedule other updates after in case the callback is sync.


            ensureRootIsScheduled(root, eventTime);
            schedulePendingInteractions(root, lane);
          } // We use this when assigning a lane for a transition inside
          // `requestUpdateLane`. We assume it's the same as the root being updated,
          // since in the common case of a single root app it probably is. If it's not
          // the same root, then it's not a huge deal, we just might batch more stuff
          // together more than necessary.


          mostRecentlyUpdatedRoot = root;
        } // This is split into a separate function so we can mark a fiber with pending
        // work without treating it as a typical update that originates from an event;
        // e.g. retrying a Suspense boundary isn't an update, but it does schedule work
        // on a fiber.


        function markUpdateLaneFromFiberToRoot(sourceFiber, lane) {
          // Update the source fiber's lanes
          sourceFiber.lanes = mergeLanes(sourceFiber.lanes, lane);
          var alternate = sourceFiber.alternate;

          if (alternate !== null) {
            alternate.lanes = mergeLanes(alternate.lanes, lane);
          }

          {
            if (alternate === null && (sourceFiber.flags & (Placement | Hydrating)) !== NoFlags) {
              warnAboutUpdateOnNotYetMountedFiberInDEV(sourceFiber);
            }
          } // Walk the parent path to the root and update the child expiration time.

          var node = sourceFiber;
          var parent = sourceFiber.return;

          while (parent !== null) {
            parent.childLanes = mergeLanes(parent.childLanes, lane);
            alternate = parent.alternate;

            if (alternate !== null) {
              alternate.childLanes = mergeLanes(alternate.childLanes, lane);
            } else {
              {
                if ((parent.flags & (Placement | Hydrating)) !== NoFlags) {
                  warnAboutUpdateOnNotYetMountedFiberInDEV(sourceFiber);
                }
              }
            }

            node = parent;
            parent = parent.return;
          }

          if (node.tag === HostRoot) {
            var root = node.stateNode;
            return root;
          } else {
            return null;
          }
        } // Use this function to schedule a task for a root. There's only one task per
        // root; if a task was already scheduled, we'll check to make sure the priority
        // of the existing task is the same as the priority of the next level that the
        // root has work on. This function is called on every update, and right before
        // exiting a task.


        function ensureRootIsScheduled(root, currentTime) {
          var existingCallbackNode = root.callbackNode; // Check if any lanes are being starved by other work. If so, mark them as
          // expired so we know to work on those next.

          markStarvedLanesAsExpired(root, currentTime); // Determine the next lanes to work on, and their priority.

          var nextLanes = getNextLanes(root, root === workInProgressRoot ? workInProgressRootRenderLanes : NoLanes); // This returns the priority level computed during the `getNextLanes` call.

          var newCallbackPriority = returnNextLanesPriority();

          if (nextLanes === NoLanes) {
            // Special case: There's nothing to work on.
            if (existingCallbackNode !== null) {
              cancelCallback(existingCallbackNode);
              root.callbackNode = null;
              root.callbackPriority = NoLanePriority;
            }

            return;
          } // Check if there's an existing task. We may be able to reuse it.


          if (existingCallbackNode !== null) {
            var existingCallbackPriority = root.callbackPriority;

            if (existingCallbackPriority === newCallbackPriority) {
              // The priority hasn't changed. We can reuse the existing task. Exit.
              return;
            } // The priority changed. Cancel the existing callback. We'll schedule a new
            // one below.


            cancelCallback(existingCallbackNode);
          } // Schedule a new callback.


          var newCallbackNode;

          if (newCallbackPriority === SyncLanePriority) {
            // Special case: Sync React callbacks are scheduled on a special
            // internal queue
            newCallbackNode = scheduleSyncCallback(performSyncWorkOnRoot.bind(null, root));
          } else if (newCallbackPriority === SyncBatchedLanePriority) {
            newCallbackNode = scheduleCallback(ImmediatePriority$1, performSyncWorkOnRoot.bind(null, root));
          } else {
            var schedulerPriorityLevel = lanePriorityToSchedulerPriority(newCallbackPriority);
            newCallbackNode = scheduleCallback(schedulerPriorityLevel, performConcurrentWorkOnRoot.bind(null, root));
          }

          root.callbackPriority = newCallbackPriority;
          root.callbackNode = newCallbackNode;
        } // This is the entry point for every concurrent task, i.e. anything that
        // goes through Scheduler.


        function performConcurrentWorkOnRoot(root) {
          // Since we know we're in a React event, we can clear the current
          // event time. The next update will compute a new event time.
          currentEventTime = NoTimestamp;
          currentEventWipLanes = NoLanes;
          currentEventPendingLanes = NoLanes;

          if (!((executionContext & (RenderContext | CommitContext)) === NoContext)) {
            {
              throw Error("Should not already be working.");
            }
          } // Flush any pending passive effects before deciding which lanes to work on,
          // in case they schedule additional work.


          var originalCallbackNode = root.callbackNode;
          var didFlushPassiveEffects = flushPassiveEffects();

          if (didFlushPassiveEffects) {
            // Something in the passive effect phase may have canceled the current task.
            // Check if the task node for this root was changed.
            if (root.callbackNode !== originalCallbackNode) {
              // The current task was canceled. Exit. We don't need to call
              // `ensureRootIsScheduled` because the check above implies either that
              // there's a new task, or that there's no remaining work on this root.
              return null;
            }
          } // Determine the next expiration time to work on, using the fields stored
          // on the root.


          var lanes = getNextLanes(root, root === workInProgressRoot ? workInProgressRootRenderLanes : NoLanes);

          if (lanes === NoLanes) {
            // Defensive coding. This is never expected to happen.
            return null;
          }

          var exitStatus = renderRootConcurrent(root, lanes);

          if (includesSomeLane(workInProgressRootIncludedLanes, workInProgressRootUpdatedLanes)) {
            // The render included lanes that were updated during the render phase.
            // For example, when unhiding a hidden tree, we include all the lanes
            // that were previously skipped when the tree was hidden. That set of
            // lanes is a superset of the lanes we started rendering with.
            //
            // So we'll throw out the current work and restart.
            prepareFreshStack(root, NoLanes);
          } else if (exitStatus !== RootIncomplete) {
            if (exitStatus === RootErrored) {
              executionContext |= RetryAfterError; // If an error occurred during hydration,
              // discard server response and fall back to client side render.

              if (root.hydrate) {
                root.hydrate = false;
                clearContainer(root.containerInfo);
              } // If something threw an error, try rendering one more time. We'll render
              // synchronously to block concurrent data mutations, and we'll includes
              // all pending updates are included. If it still fails after the second
              // attempt, we'll give up and commit the resulting tree.


              lanes = getLanesToRetrySynchronouslyOnError(root);

              if (lanes !== NoLanes) {
                exitStatus = renderRootSync(root, lanes);
              }
            }

            if (exitStatus === RootFatalErrored) {
              var fatalError = workInProgressRootFatalError;
              prepareFreshStack(root, NoLanes);
              markRootSuspended$1(root, lanes);
              ensureRootIsScheduled(root, now());
              throw fatalError;
            } // We now have a consistent tree. The next step is either to commit it,
            // or, if something suspended, wait to commit it after a timeout.


            var finishedWork = root.current.alternate;
            root.finishedWork = finishedWork;
            root.finishedLanes = lanes;
            finishConcurrentRender(root, exitStatus, lanes);
          }

          ensureRootIsScheduled(root, now());

          if (root.callbackNode === originalCallbackNode) {
            // The task node scheduled for this root is the same one that's
            // currently executed. Need to return a continuation.
            return performConcurrentWorkOnRoot.bind(null, root);
          }

          return null;
        }

        function finishConcurrentRender(root, exitStatus, lanes) {
          switch (exitStatus) {
            case RootIncomplete:
            case RootFatalErrored:
              {
                {
                  {
                    throw Error("Root did not complete. This is a bug in React.");
                  }
                }
              }
            // Flow knows about invariant, so it complains if I add a break
            // statement, but eslint doesn't know about invariant, so it complains
            // if I do. eslint-disable-next-line no-fallthrough

            case RootErrored:
              {
                // We should have already attempted to retry this tree. If we reached
                // this point, it errored again. Commit it.
                commitRoot(root);
                break;
              }

            case RootSuspended:
              {
                markRootSuspended$1(root, lanes); // We have an acceptable loading state. We need to figure out if we
                // should immediately commit it or wait a bit.

                if (includesOnlyRetries(lanes) && // do not delay if we're inside an act() scope
                !shouldForceFlushFallbacksInDEV()) {
                  // This render only included retries, no updates. Throttle committing
                  // retries so that we don't show too many loading states too quickly.
                  var msUntilTimeout = globalMostRecentFallbackTime + FALLBACK_THROTTLE_MS - now(); // Don't bother with a very short suspense time.

                  if (msUntilTimeout > 10) {
                    var nextLanes = getNextLanes(root, NoLanes);

                    if (nextLanes !== NoLanes) {
                      // There's additional work on this root.
                      break;
                    }

                    var suspendedLanes = root.suspendedLanes;

                    if (!isSubsetOfLanes(suspendedLanes, lanes)) {
                      // We should prefer to render the fallback of at the last
                      // suspended level. Ping the last suspended level to try
                      // rendering it again.
                      // FIXME: What if the suspended lanes are Idle? Should not restart.
                      var eventTime = requestEventTime();
                      markRootPinged(root, suspendedLanes);
                      break;
                    } // The render is suspended, it hasn't timed out, and there's no
                    // lower priority work to do. Instead of committing the fallback
                    // immediately, wait for more data to arrive.


                    root.timeoutHandle = scheduleTimeout(commitRoot.bind(null, root), msUntilTimeout);
                    break;
                  }
                } // The work expired. Commit immediately.


                commitRoot(root);
                break;
              }

            case RootSuspendedWithDelay:
              {
                markRootSuspended$1(root, lanes);

                if (includesOnlyTransitions(lanes)) {
                  // This is a transition, so we should exit without committing a
                  // placeholder and without scheduling a timeout. Delay indefinitely
                  // until we receive more data.
                  break;
                }

                if (!shouldForceFlushFallbacksInDEV()) {
                  // This is not a transition, but we did trigger an avoided state.
                  // Schedule a placeholder to display after a short delay, using the Just
                  // Noticeable Difference.
                  // TODO: Is the JND optimization worth the added complexity? If this is
                  // the only reason we track the event time, then probably not.
                  // Consider removing.
                  var mostRecentEventTime = getMostRecentEventTime(root, lanes);
                  var eventTimeMs = mostRecentEventTime;
                  var timeElapsedMs = now() - eventTimeMs;

                  var _msUntilTimeout = jnd(timeElapsedMs) - timeElapsedMs; // Don't bother with a very short suspense time.


                  if (_msUntilTimeout > 10) {
                    // Instead of committing the fallback immediately, wait for more data
                    // to arrive.
                    root.timeoutHandle = scheduleTimeout(commitRoot.bind(null, root), _msUntilTimeout);
                    break;
                  }
                } // Commit the placeholder.


                commitRoot(root);
                break;
              }

            case RootCompleted:
              {
                // The work completed. Ready to commit.
                commitRoot(root);
                break;
              }

            default:
              {
                {
                  {
                    throw Error("Unknown root exit status.");
                  }
                }
              }
          }
        }

        function markRootSuspended$1(root, suspendedLanes) {
          // When suspending, we should always exclude lanes that were pinged or (more
          // rarely, since we try to avoid it) updated during the render phase.
          // TODO: Lol maybe there's a better way to factor this besides this
          // obnoxiously named function :)
          suspendedLanes = removeLanes(suspendedLanes, workInProgressRootPingedLanes);
          suspendedLanes = removeLanes(suspendedLanes, workInProgressRootUpdatedLanes);
          markRootSuspended(root, suspendedLanes);
        } // This is the entry point for synchronous tasks that don't go
        // through Scheduler


        function performSyncWorkOnRoot(root) {
          if (!((executionContext & (RenderContext | CommitContext)) === NoContext)) {
            {
              throw Error("Should not already be working.");
            }
          }

          flushPassiveEffects();
          var lanes;
          var exitStatus;

          if (root === workInProgressRoot && includesSomeLane(root.expiredLanes, workInProgressRootRenderLanes)) {
            // There's a partial tree, and at least one of its lanes has expired. Finish
            // rendering it before rendering the rest of the expired work.
            lanes = workInProgressRootRenderLanes;
            exitStatus = renderRootSync(root, lanes);

            if (includesSomeLane(workInProgressRootIncludedLanes, workInProgressRootUpdatedLanes)) {
              // The render included lanes that were updated during the render phase.
              // For example, when unhiding a hidden tree, we include all the lanes
              // that were previously skipped when the tree was hidden. That set of
              // lanes is a superset of the lanes we started rendering with.
              //
              // Note that this only happens when part of the tree is rendered
              // concurrently. If the whole tree is rendered synchronously, then there
              // are no interleaved events.
              lanes = getNextLanes(root, lanes);
              exitStatus = renderRootSync(root, lanes);
            }
          } else {
            lanes = getNextLanes(root, NoLanes);
            exitStatus = renderRootSync(root, lanes);
          }

          if (root.tag !== LegacyRoot && exitStatus === RootErrored) {
            executionContext |= RetryAfterError; // If an error occurred during hydration,
            // discard server response and fall back to client side render.

            if (root.hydrate) {
              root.hydrate = false;
              clearContainer(root.containerInfo);
            } // If something threw an error, try rendering one more time. We'll render
            // synchronously to block concurrent data mutations, and we'll includes
            // all pending updates are included. If it still fails after the second
            // attempt, we'll give up and commit the resulting tree.


            lanes = getLanesToRetrySynchronouslyOnError(root);

            if (lanes !== NoLanes) {
              exitStatus = renderRootSync(root, lanes);
            }
          }

          if (exitStatus === RootFatalErrored) {
            var fatalError = workInProgressRootFatalError;
            prepareFreshStack(root, NoLanes);
            markRootSuspended$1(root, lanes);
            ensureRootIsScheduled(root, now());
            throw fatalError;
          } // We now have a consistent tree. Because this is a sync render, we
          // will commit it even if something suspended.


          var finishedWork = root.current.alternate;
          root.finishedWork = finishedWork;
          root.finishedLanes = lanes;
          commitRoot(root); // Before exiting, make sure there's a callback scheduled for the next
          // pending level.

          ensureRootIsScheduled(root, now());
          return null;
        }

        function flushDiscreteUpdates() {
          // TODO: Should be able to flush inside batchedUpdates, but not inside `act`.
          // However, `act` uses `batchedUpdates`, so there's no way to distinguish
          // those two cases. Need to fix this before exposing flushDiscreteUpdates
          // as a public API.
          if ((executionContext & (BatchedContext | RenderContext | CommitContext)) !== NoContext) {
            {
              if ((executionContext & RenderContext) !== NoContext) {
                error('unstable_flushDiscreteUpdates: Cannot flush updates when React is ' + 'already rendering.');
              }
            } // We're already rendering, so we can't synchronously flush pending work.
            // This is probably a nested event dispatch triggered by a lifecycle/effect,
            // like `el.focus()`. Exit.

            return;
          }

          flushPendingDiscreteUpdates(); // If the discrete updates scheduled passive effects, flush them now so that
          // they fire before the next serial event.

          flushPassiveEffects();
        }

        function flushPendingDiscreteUpdates() {
          if (rootsWithPendingDiscreteUpdates !== null) {
            // For each root with pending discrete updates, schedule a callback to
            // immediately flush them.
            var roots = rootsWithPendingDiscreteUpdates;
            rootsWithPendingDiscreteUpdates = null;
            roots.forEach(function (root) {
              markDiscreteUpdatesExpired(root);
              ensureRootIsScheduled(root, now());
            });
          } // Now flush the immediate queue.


          flushSyncCallbackQueue();
        }

        function batchedUpdates$1(fn, a) {
          var prevExecutionContext = executionContext;
          executionContext |= BatchedContext;

          try {
            return fn(a);
          } finally {
            executionContext = prevExecutionContext;

            if (executionContext === NoContext) {
              // Flush the immediate callbacks that were scheduled during this batch
              resetRenderTimer();
              flushSyncCallbackQueue();
            }
          }
        }

        function batchedEventUpdates$1(fn, a) {
          var prevExecutionContext = executionContext;
          executionContext |= EventContext;

          try {
            return fn(a);
          } finally {
            executionContext = prevExecutionContext;

            if (executionContext === NoContext) {
              // Flush the immediate callbacks that were scheduled during this batch
              resetRenderTimer();
              flushSyncCallbackQueue();
            }
          }
        }

        function discreteUpdates$1(fn, a, b, c, d) {
          var prevExecutionContext = executionContext;
          executionContext |= DiscreteEventContext;
          {
            try {
              return runWithPriority$1(UserBlockingPriority$2, fn.bind(null, a, b, c, d));
            } finally {
              executionContext = prevExecutionContext;

              if (executionContext === NoContext) {
                // Flush the immediate callbacks that were scheduled during this batch
                resetRenderTimer();
                flushSyncCallbackQueue();
              }
            }
          }
        }

        function unbatchedUpdates(fn, a) {
          var prevExecutionContext = executionContext;
          executionContext &= ~BatchedContext;
          executionContext |= LegacyUnbatchedContext;

          try {
            return fn(a);
          } finally {
            executionContext = prevExecutionContext;

            if (executionContext === NoContext) {
              // Flush the immediate callbacks that were scheduled during this batch
              resetRenderTimer();
              flushSyncCallbackQueue();
            }
          }
        }

        function flushSync(fn, a) {
          var prevExecutionContext = executionContext;

          if ((prevExecutionContext & (RenderContext | CommitContext)) !== NoContext) {
            {
              error('flushSync was called from inside a lifecycle method. React cannot ' + 'flush when React is already rendering. Consider moving this call to ' + 'a scheduler task or micro task.');
            }
            return fn(a);
          }

          executionContext |= BatchedContext;
          {
            try {
              if (fn) {
                return runWithPriority$1(ImmediatePriority$1, fn.bind(null, a));
              } else {
                return undefined;
              }
            } finally {
              executionContext = prevExecutionContext; // Flush the immediate callbacks that were scheduled during this batch.
              // Note that this will happen even if batchedUpdates is higher up
              // the stack.

              flushSyncCallbackQueue();
            }
          }
        }

        function pushRenderLanes(fiber, lanes) {
          push(subtreeRenderLanesCursor, subtreeRenderLanes, fiber);
          subtreeRenderLanes = mergeLanes(subtreeRenderLanes, lanes);
          workInProgressRootIncludedLanes = mergeLanes(workInProgressRootIncludedLanes, lanes);
        }

        function popRenderLanes(fiber) {
          subtreeRenderLanes = subtreeRenderLanesCursor.current;
          pop(subtreeRenderLanesCursor, fiber);
        }

        function prepareFreshStack(root, lanes) {
          root.finishedWork = null;
          root.finishedLanes = NoLanes;
          var timeoutHandle = root.timeoutHandle;

          if (timeoutHandle !== noTimeout) {
            // The root previous suspended and scheduled a timeout to commit a fallback
            // state. Now that we have additional work, cancel the timeout.
            root.timeoutHandle = noTimeout; // $FlowFixMe Complains noTimeout is not a TimeoutID, despite the check above

            cancelTimeout(timeoutHandle);
          }

          if (workInProgress !== null) {
            var interruptedWork = workInProgress.return;

            while (interruptedWork !== null) {
              unwindInterruptedWork(interruptedWork);
              interruptedWork = interruptedWork.return;
            }
          }

          workInProgressRoot = root;
          workInProgress = createWorkInProgress(root.current, null);
          workInProgressRootRenderLanes = subtreeRenderLanes = workInProgressRootIncludedLanes = lanes;
          workInProgressRootExitStatus = RootIncomplete;
          workInProgressRootFatalError = null;
          workInProgressRootSkippedLanes = NoLanes;
          workInProgressRootUpdatedLanes = NoLanes;
          workInProgressRootPingedLanes = NoLanes;
          {
            spawnedWorkDuringRender = null;
          }
          {
            ReactStrictModeWarnings.discardPendingWarnings();
          }
        }

        function handleError(root, thrownValue) {
          do {
            var erroredWork = workInProgress;

            try {
              // Reset module-level state that was set during the render phase.
              resetContextDependencies();
              resetHooksAfterThrow();
              resetCurrentFiber(); // TODO: I found and added this missing line while investigating a
              // separate issue. Write a regression test using string refs.

              ReactCurrentOwner$2.current = null;

              if (erroredWork === null || erroredWork.return === null) {
                // Expected to be working on a non-root fiber. This is a fatal error
                // because there's no ancestor that can handle it; the root is
                // supposed to capture all errors that weren't caught by an error
                // boundary.
                workInProgressRootExitStatus = RootFatalErrored;
                workInProgressRootFatalError = thrownValue; // Set `workInProgress` to null. This represents advancing to the next
                // sibling, or the parent if there are no siblings. But since the root
                // has no siblings nor a parent, we set it to null. Usually this is
                // handled by `completeUnitOfWork` or `unwindWork`, but since we're
                // intentionally not calling those, we need set it here.
                // TODO: Consider calling `unwindWork` to pop the contexts.

                workInProgress = null;
                return;
              }

              if (enableProfilerTimer && erroredWork.mode & ProfileMode) {
                // Record the time spent rendering before an error was thrown. This
                // avoids inaccurate Profiler durations in the case of a
                // suspended render.
                stopProfilerTimerIfRunningAndRecordDelta(erroredWork, true);
              }

              throwException(root, erroredWork.return, erroredWork, thrownValue, workInProgressRootRenderLanes);
              completeUnitOfWork(erroredWork);
            } catch (yetAnotherThrownValue) {
              // Something in the return path also threw.
              thrownValue = yetAnotherThrownValue;

              if (workInProgress === erroredWork && erroredWork !== null) {
                // If this boundary has already errored, then we had trouble processing
                // the error. Bubble it to the next boundary.
                erroredWork = erroredWork.return;
                workInProgress = erroredWork;
              } else {
                erroredWork = workInProgress;
              }

              continue;
            } // Return to the normal work loop.


            return;
          } while (true);
        }

        function pushDispatcher() {
          var prevDispatcher = ReactCurrentDispatcher$2.current;
          ReactCurrentDispatcher$2.current = ContextOnlyDispatcher;

          if (prevDispatcher === null) {
            // The React isomorphic package does not include a default dispatcher.
            // Instead the first renderer will lazily attach one, in order to give
            // nicer error messages.
            return ContextOnlyDispatcher;
          } else {
            return prevDispatcher;
          }
        }

        function popDispatcher(prevDispatcher) {
          ReactCurrentDispatcher$2.current = prevDispatcher;
        }

        function pushInteractions(root) {
          {
            var prevInteractions = tracing.__interactionsRef.current;
            tracing.__interactionsRef.current = root.memoizedInteractions;
            return prevInteractions;
          }
        }

        function popInteractions(prevInteractions) {
          {
            tracing.__interactionsRef.current = prevInteractions;
          }
        }

        function markCommitTimeOfFallback() {
          globalMostRecentFallbackTime = now();
        }

        function markSkippedUpdateLanes(lane) {
          workInProgressRootSkippedLanes = mergeLanes(lane, workInProgressRootSkippedLanes);
        }

        function renderDidSuspend() {
          if (workInProgressRootExitStatus === RootIncomplete) {
            workInProgressRootExitStatus = RootSuspended;
          }
        }

        function renderDidSuspendDelayIfPossible() {
          if (workInProgressRootExitStatus === RootIncomplete || workInProgressRootExitStatus === RootSuspended) {
            workInProgressRootExitStatus = RootSuspendedWithDelay;
          } // Check if there are updates that we skipped tree that might have unblocked
          // this render.


          if (workInProgressRoot !== null && (includesNonIdleWork(workInProgressRootSkippedLanes) || includesNonIdleWork(workInProgressRootUpdatedLanes))) {
            // Mark the current render as suspended so that we switch to working on
            // the updates that were skipped. Usually we only suspend at the end of
            // the render phase.
            // TODO: We should probably always mark the root as suspended immediately
            // (inside this function), since by suspending at the end of the render
            // phase introduces a potential mistake where we suspend lanes that were
            // pinged or updated while we were rendering.
            markRootSuspended$1(workInProgressRoot, workInProgressRootRenderLanes);
          }
        }

        function renderDidError() {
          if (workInProgressRootExitStatus !== RootCompleted) {
            workInProgressRootExitStatus = RootErrored;
          }
        } // Called during render to determine if anything has suspended.
        // Returns false if we're not sure.


        function renderHasNotSuspendedYet() {
          // If something errored or completed, we can't really be sure,
          // so those are false.
          return workInProgressRootExitStatus === RootIncomplete;
        }

        function renderRootSync(root, lanes) {
          var prevExecutionContext = executionContext;
          executionContext |= RenderContext;
          var prevDispatcher = pushDispatcher(); // If the root or lanes have changed, throw out the existing stack
          // and prepare a fresh one. Otherwise we'll continue where we left off.

          if (workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes) {
            prepareFreshStack(root, lanes);
            startWorkOnPendingInteractions(root, lanes);
          }

          var prevInteractions = pushInteractions(root);

          do {
            try {
              workLoopSync();
              break;
            } catch (thrownValue) {
              handleError(root, thrownValue);
            }
          } while (true);

          resetContextDependencies();
          {
            popInteractions(prevInteractions);
          }
          executionContext = prevExecutionContext;
          popDispatcher(prevDispatcher);

          if (workInProgress !== null) {
            // This is a sync render, so we should have finished the whole tree.
            {
              {
                throw Error("Cannot commit an incomplete root. This error is likely caused by a bug in React. Please file an issue.");
              }
            }
          }

          workInProgressRoot = null;
          workInProgressRootRenderLanes = NoLanes;
          return workInProgressRootExitStatus;
        } // The work loop is an extremely hot path. Tell Closure not to inline it.

        /** @noinline */


        function workLoopSync() {
          // Already timed out, so perform work without checking if we need to yield.
          while (workInProgress !== null) {
            performUnitOfWork(workInProgress);
          }
        }

        function renderRootConcurrent(root, lanes) {
          var prevExecutionContext = executionContext;
          executionContext |= RenderContext;
          var prevDispatcher = pushDispatcher(); // If the root or lanes have changed, throw out the existing stack
          // and prepare a fresh one. Otherwise we'll continue where we left off.

          if (workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes) {
            resetRenderTimer();
            prepareFreshStack(root, lanes);
            startWorkOnPendingInteractions(root, lanes);
          }

          var prevInteractions = pushInteractions(root);

          do {
            try {
              workLoopConcurrent();
              break;
            } catch (thrownValue) {
              handleError(root, thrownValue);
            }
          } while (true);

          resetContextDependencies();
          {
            popInteractions(prevInteractions);
          }
          popDispatcher(prevDispatcher);
          executionContext = prevExecutionContext;

          if (workInProgress !== null) {
            return RootIncomplete;
          } else {
            workInProgressRoot = null;
            workInProgressRootRenderLanes = NoLanes; // Return the final exit status.

            return workInProgressRootExitStatus;
          }
        }
        /** @noinline */


        function workLoopConcurrent() {
          // Perform work until Scheduler asks us to yield
          while (workInProgress !== null && !shouldYield()) {
            performUnitOfWork(workInProgress);
          }
        }

        function performUnitOfWork(unitOfWork) {
          // The current, flushed, state of this fiber is the alternate. Ideally
          // nothing should rely on this, but relying on it here means that we don't
          // need an additional field on the work in progress.
          var current = unitOfWork.alternate;
          setCurrentFiber(unitOfWork);
          var next;

          if ((unitOfWork.mode & ProfileMode) !== NoMode) {
            startProfilerTimer(unitOfWork);
            next = beginWork$1(current, unitOfWork, subtreeRenderLanes);
            stopProfilerTimerIfRunningAndRecordDelta(unitOfWork, true);
          } else {
            next = beginWork$1(current, unitOfWork, subtreeRenderLanes);
          }

          resetCurrentFiber();
          unitOfWork.memoizedProps = unitOfWork.pendingProps;

          if (next === null) {
            // If this doesn't spawn new work, complete the current work.
            completeUnitOfWork(unitOfWork);
          } else {
            workInProgress = next;
          }

          ReactCurrentOwner$2.current = null;
        }

        function completeUnitOfWork(unitOfWork) {
          // Attempt to complete the current unit of work, then move to the next
          // sibling. If there are no more siblings, return to the parent fiber.
          var completedWork = unitOfWork;

          do {
            // The current, flushed, state of this fiber is the alternate. Ideally
            // nothing should rely on this, but relying on it here means that we don't
            // need an additional field on the work in progress.
            var current = completedWork.alternate;
            var returnFiber = completedWork.return; // Check if the work completed or if something threw.

            if ((completedWork.flags & Incomplete) === NoFlags) {
              setCurrentFiber(completedWork);
              var next = void 0;

              if ((completedWork.mode & ProfileMode) === NoMode) {
                next = completeWork(current, completedWork, subtreeRenderLanes);
              } else {
                startProfilerTimer(completedWork);
                next = completeWork(current, completedWork, subtreeRenderLanes); // Update render duration assuming we didn't error.

                stopProfilerTimerIfRunningAndRecordDelta(completedWork, false);
              }

              resetCurrentFiber();

              if (next !== null) {
                // Completing this fiber spawned new work. Work on that next.
                workInProgress = next;
                return;
              }

              resetChildLanes(completedWork);

              if (returnFiber !== null && // Do not append effects to parents if a sibling failed to complete
              (returnFiber.flags & Incomplete) === NoFlags) {
                // Append all the effects of the subtree and this fiber onto the effect
                // list of the parent. The completion order of the children affects the
                // side-effect order.
                if (returnFiber.firstEffect === null) {
                  returnFiber.firstEffect = completedWork.firstEffect;
                }

                if (completedWork.lastEffect !== null) {
                  if (returnFiber.lastEffect !== null) {
                    returnFiber.lastEffect.nextEffect = completedWork.firstEffect;
                  }

                  returnFiber.lastEffect = completedWork.lastEffect;
                } // If this fiber had side-effects, we append it AFTER the children's
                // side-effects. We can perform certain side-effects earlier if needed,
                // by doing multiple passes over the effect list. We don't want to
                // schedule our own side-effect on our own list because if end up
                // reusing children we'll schedule this effect onto itself since we're
                // at the end.


                var flags = completedWork.flags; // Skip both NoWork and PerformedWork tags when creating the effect
                // list. PerformedWork effect is read by React DevTools but shouldn't be
                // committed.

                if (flags > PerformedWork) {
                  if (returnFiber.lastEffect !== null) {
                    returnFiber.lastEffect.nextEffect = completedWork;
                  } else {
                    returnFiber.firstEffect = completedWork;
                  }

                  returnFiber.lastEffect = completedWork;
                }
              }
            } else {
              // This fiber did not complete because something threw. Pop values off
              // the stack without entering the complete phase. If this is a boundary,
              // capture values if possible.
              var _next = unwindWork(completedWork); // Because this fiber did not complete, don't reset its expiration time.


              if (_next !== null) {
                // If completing this work spawned new work, do that next. We'll come
                // back here again.
                // Since we're restarting, remove anything that is not a host effect
                // from the effect tag.
                _next.flags &= HostEffectMask;
                workInProgress = _next;
                return;
              }

              if ((completedWork.mode & ProfileMode) !== NoMode) {
                // Record the render duration for the fiber that errored.
                stopProfilerTimerIfRunningAndRecordDelta(completedWork, false); // Include the time spent working on failed children before continuing.

                var actualDuration = completedWork.actualDuration;
                var child = completedWork.child;

                while (child !== null) {
                  actualDuration += child.actualDuration;
                  child = child.sibling;
                }

                completedWork.actualDuration = actualDuration;
              }

              if (returnFiber !== null) {
                // Mark the parent fiber as incomplete and clear its effect list.
                returnFiber.firstEffect = returnFiber.lastEffect = null;
                returnFiber.flags |= Incomplete;
              }
            }

            var siblingFiber = completedWork.sibling;

            if (siblingFiber !== null) {
              // If there is more work to do in this returnFiber, do that next.
              workInProgress = siblingFiber;
              return;
            } // Otherwise, return to the parent


            completedWork = returnFiber; // Update the next thing we're working on in case something throws.

            workInProgress = completedWork;
          } while (completedWork !== null); // We've reached the root.


          if (workInProgressRootExitStatus === RootIncomplete) {
            workInProgressRootExitStatus = RootCompleted;
          }
        }

        function resetChildLanes(completedWork) {
          if ( // TODO: Move this check out of the hot path by moving `resetChildLanes`
          // to switch statement in `completeWork`.
          (completedWork.tag === LegacyHiddenComponent || completedWork.tag === OffscreenComponent) && completedWork.memoizedState !== null && !includesSomeLane(subtreeRenderLanes, OffscreenLane) && (completedWork.mode & ConcurrentMode) !== NoLanes) {
            // The children of this component are hidden. Don't bubble their
            // expiration times.
            return;
          }

          var newChildLanes = NoLanes; // Bubble up the earliest expiration time.

          if ((completedWork.mode & ProfileMode) !== NoMode) {
            // In profiling mode, resetChildExpirationTime is also used to reset
            // profiler durations.
            var actualDuration = completedWork.actualDuration;
            var treeBaseDuration = completedWork.selfBaseDuration; // When a fiber is cloned, its actualDuration is reset to 0. This value will
            // only be updated if work is done on the fiber (i.e. it doesn't bailout).
            // When work is done, it should bubble to the parent's actualDuration. If
            // the fiber has not been cloned though, (meaning no work was done), then
            // this value will reflect the amount of time spent working on a previous
            // render. In that case it should not bubble. We determine whether it was
            // cloned by comparing the child pointer.

            var shouldBubbleActualDurations = completedWork.alternate === null || completedWork.child !== completedWork.alternate.child;
            var child = completedWork.child;

            while (child !== null) {
              newChildLanes = mergeLanes(newChildLanes, mergeLanes(child.lanes, child.childLanes));

              if (shouldBubbleActualDurations) {
                actualDuration += child.actualDuration;
              }

              treeBaseDuration += child.treeBaseDuration;
              child = child.sibling;
            }

            var isTimedOutSuspense = completedWork.tag === SuspenseComponent && completedWork.memoizedState !== null;

            if (isTimedOutSuspense) {
              // Don't count time spent in a timed out Suspense subtree as part of the base duration.
              var primaryChildFragment = completedWork.child;

              if (primaryChildFragment !== null) {
                treeBaseDuration -= primaryChildFragment.treeBaseDuration;
              }
            }

            completedWork.actualDuration = actualDuration;
            completedWork.treeBaseDuration = treeBaseDuration;
          } else {
            var _child = completedWork.child;

            while (_child !== null) {
              newChildLanes = mergeLanes(newChildLanes, mergeLanes(_child.lanes, _child.childLanes));
              _child = _child.sibling;
            }
          }

          completedWork.childLanes = newChildLanes;
        }

        function commitRoot(root) {
          var renderPriorityLevel = getCurrentPriorityLevel();
          runWithPriority$1(ImmediatePriority$1, commitRootImpl.bind(null, root, renderPriorityLevel));
          return null;
        }

        function commitRootImpl(root, renderPriorityLevel) {
          do {
            // `flushPassiveEffects` will call `flushSyncUpdateQueue` at the end, which
            // means `flushPassiveEffects` will sometimes result in additional
            // passive effects. So we need to keep flushing in a loop until there are
            // no more pending effects.
            // TODO: Might be better if `flushPassiveEffects` did not automatically
            // flush synchronous work at the end, to avoid factoring hazards like this.
            flushPassiveEffects();
          } while (rootWithPendingPassiveEffects !== null);

          flushRenderPhaseStrictModeWarningsInDEV();

          if (!((executionContext & (RenderContext | CommitContext)) === NoContext)) {
            {
              throw Error("Should not already be working.");
            }
          }

          var finishedWork = root.finishedWork;
          var lanes = root.finishedLanes;

          if (finishedWork === null) {
            return null;
          }

          root.finishedWork = null;
          root.finishedLanes = NoLanes;

          if (!(finishedWork !== root.current)) {
            {
              throw Error("Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue.");
            }
          } // commitRoot never returns a continuation; it always finishes synchronously.
          // So we can clear these now to allow a new callback to be scheduled.


          root.callbackNode = null; // Update the first and last pending times on this root. The new first
          // pending time is whatever is left on the root fiber.

          var remainingLanes = mergeLanes(finishedWork.lanes, finishedWork.childLanes);
          markRootFinished(root, remainingLanes); // Clear already finished discrete updates in case that a later call of
          // `flushDiscreteUpdates` starts a useless render pass which may cancels
          // a scheduled timeout.

          if (rootsWithPendingDiscreteUpdates !== null) {
            if (!hasDiscreteLanes(remainingLanes) && rootsWithPendingDiscreteUpdates.has(root)) {
              rootsWithPendingDiscreteUpdates.delete(root);
            }
          }

          if (root === workInProgressRoot) {
            // We can reset these now that they are finished.
            workInProgressRoot = null;
            workInProgress = null;
            workInProgressRootRenderLanes = NoLanes;
          } // Get the list of effects.


          var firstEffect;

          if (finishedWork.flags > PerformedWork) {
            // A fiber's effect list consists only of its children, not itself. So if
            // the root has an effect, we need to add it to the end of the list. The
            // resulting list is the set that would belong to the root's parent, if it
            // had one; that is, all the effects in the tree including the root.
            if (finishedWork.lastEffect !== null) {
              finishedWork.lastEffect.nextEffect = finishedWork;
              firstEffect = finishedWork.firstEffect;
            } else {
              firstEffect = finishedWork;
            }
          } else {
            // There is no effect on the root.
            firstEffect = finishedWork.firstEffect;
          }

          if (firstEffect !== null) {
            var prevExecutionContext = executionContext;
            executionContext |= CommitContext;
            var prevInteractions = pushInteractions(root); // Reset this to null before calling lifecycles

            ReactCurrentOwner$2.current = null; // The commit phase is broken into several sub-phases. We do a separate pass
            // of the effect list for each phase: all mutation effects come before all
            // layout effects, and so on.
            // The first phase a "before mutation" phase. We use this phase to read the
            // state of the host tree right before we mutate it. This is where
            // getSnapshotBeforeUpdate is called.

            focusedInstanceHandle = prepareForCommit(root.containerInfo);
            shouldFireAfterActiveInstanceBlur = false;
            nextEffect = firstEffect;

            do {
              {
                invokeGuardedCallback(null, commitBeforeMutationEffects, null);

                if (hasCaughtError()) {
                  if (!(nextEffect !== null)) {
                    {
                      throw Error("Should be working on an effect.");
                    }
                  }

                  var error = clearCaughtError();
                  captureCommitPhaseError(nextEffect, error);
                  nextEffect = nextEffect.nextEffect;
                }
              }
            } while (nextEffect !== null); // We no longer need to track the active instance fiber


            focusedInstanceHandle = null;
            {
              // Mark the current commit time to be shared by all Profilers in this
              // batch. This enables them to be grouped later.
              recordCommitTime();
            } // The next phase is the mutation phase, where we mutate the host tree.

            nextEffect = firstEffect;

            do {
              {
                invokeGuardedCallback(null, commitMutationEffects, null, root, renderPriorityLevel);

                if (hasCaughtError()) {
                  if (!(nextEffect !== null)) {
                    {
                      throw Error("Should be working on an effect.");
                    }
                  }

                  var _error = clearCaughtError();

                  captureCommitPhaseError(nextEffect, _error);
                  nextEffect = nextEffect.nextEffect;
                }
              }
            } while (nextEffect !== null);

            resetAfterCommit(root.containerInfo); // The work-in-progress tree is now the current tree. This must come after
            // the mutation phase, so that the previous tree is still current during
            // componentWillUnmount, but before the layout phase, so that the finished
            // work is current during componentDidMount/Update.

            root.current = finishedWork; // The next phase is the layout phase, where we call effects that read
            // the host tree after it's been mutated. The idiomatic use case for this is
            // layout, but class component lifecycles also fire here for legacy reasons.

            nextEffect = firstEffect;

            do {
              {
                invokeGuardedCallback(null, commitLayoutEffects, null, root, lanes);

                if (hasCaughtError()) {
                  if (!(nextEffect !== null)) {
                    {
                      throw Error("Should be working on an effect.");
                    }
                  }

                  var _error2 = clearCaughtError();

                  captureCommitPhaseError(nextEffect, _error2);
                  nextEffect = nextEffect.nextEffect;
                }
              }
            } while (nextEffect !== null);

            nextEffect = null; // Tell Scheduler to yield at the end of the frame, so the browser has an
            // opportunity to paint.

            requestPaint();
            {
              popInteractions(prevInteractions);
            }
            executionContext = prevExecutionContext;
          } else {
            // No effects.
            root.current = finishedWork; // Measure these anyway so the flamegraph explicitly shows that there were
            // no effects.
            // TODO: Maybe there's a better way to report this.

            {
              recordCommitTime();
            }
          }

          var rootDidHavePassiveEffects = rootDoesHavePassiveEffects;

          if (rootDoesHavePassiveEffects) {
            // This commit has passive effects. Stash a reference to them. But don't
            // schedule a callback until after flushing layout work.
            rootDoesHavePassiveEffects = false;
            rootWithPendingPassiveEffects = root;
            pendingPassiveEffectsLanes = lanes;
            pendingPassiveEffectsRenderPriority = renderPriorityLevel;
          } else {
            // We are done with the effect chain at this point so let's clear the
            // nextEffect pointers to assist with GC. If we have passive effects, we'll
            // clear this in flushPassiveEffects.
            nextEffect = firstEffect;

            while (nextEffect !== null) {
              var nextNextEffect = nextEffect.nextEffect;
              nextEffect.nextEffect = null;

              if (nextEffect.flags & Deletion) {
                detachFiberAfterEffects(nextEffect);
              }

              nextEffect = nextNextEffect;
            }
          } // Read this again, since an effect might have updated it


          remainingLanes = root.pendingLanes; // Check if there's remaining work on this root

          if (remainingLanes !== NoLanes) {
            {
              if (spawnedWorkDuringRender !== null) {
                var expirationTimes = spawnedWorkDuringRender;
                spawnedWorkDuringRender = null;

                for (var i = 0; i < expirationTimes.length; i++) {
                  scheduleInteractions(root, expirationTimes[i], root.memoizedInteractions);
                }
              }

              schedulePendingInteractions(root, remainingLanes);
            }
          } else {
            // If there's no remaining work, we can clear the set of already failed
            // error boundaries.
            legacyErrorBoundariesThatAlreadyFailed = null;
          }

          {
            if (!rootDidHavePassiveEffects) {
              // If there are no passive effects, then we can complete the pending interactions.
              // Otherwise, we'll wait until after the passive effects are flushed.
              // Wait to do this until after remaining work has been scheduled,
              // so that we don't prematurely signal complete for interactions when there's e.g. hidden work.
              finishPendingInteractions(root, lanes);
            }
          }

          if (remainingLanes === SyncLane) {
            // Count the number of times the root synchronously re-renders without
            // finishing. If there are too many, it indicates an infinite update loop.
            if (root === rootWithNestedUpdates) {
              nestedUpdateCount++;
            } else {
              nestedUpdateCount = 0;
              rootWithNestedUpdates = root;
            }
          } else {
            nestedUpdateCount = 0;
          }

          onCommitRoot(finishedWork.stateNode, renderPriorityLevel);
          {
            onCommitRoot$1();
          } // Always call this before exiting `commitRoot`, to ensure that any
          // additional work on this root is scheduled.

          ensureRootIsScheduled(root, now());

          if (hasUncaughtError) {
            hasUncaughtError = false;
            var _error3 = firstUncaughtError;
            firstUncaughtError = null;
            throw _error3;
          }

          if ((executionContext & LegacyUnbatchedContext) !== NoContext) {
            // a ReactDOM.render-ed root inside of batchedUpdates. The commit fired
            // synchronously, but layout updates should be deferred until the end
            // of the batch.
            return null;
          } // If layout work was scheduled, flush it now.


          flushSyncCallbackQueue();
          return null;
        }

        function commitBeforeMutationEffects() {
          while (nextEffect !== null) {
            var current = nextEffect.alternate;

            if (!shouldFireAfterActiveInstanceBlur && focusedInstanceHandle !== null) {
              if ((nextEffect.flags & Deletion) !== NoFlags) {
                if (doesFiberContain(nextEffect, focusedInstanceHandle)) {
                  shouldFireAfterActiveInstanceBlur = true;
                }
              } else {
                // TODO: Move this out of the hot path using a dedicated effect tag.
                if (nextEffect.tag === SuspenseComponent && isSuspenseBoundaryBeingHidden(current, nextEffect) && doesFiberContain(nextEffect, focusedInstanceHandle)) {
                  shouldFireAfterActiveInstanceBlur = true;
                }
              }
            }

            var flags = nextEffect.flags;

            if ((flags & Snapshot) !== NoFlags) {
              setCurrentFiber(nextEffect);
              commitBeforeMutationLifeCycles(current, nextEffect);
              resetCurrentFiber();
            }

            if ((flags & Passive) !== NoFlags) {
              // If there are passive effects, schedule a callback to flush at
              // the earliest opportunity.
              if (!rootDoesHavePassiveEffects) {
                rootDoesHavePassiveEffects = true;
                scheduleCallback(NormalPriority$1, function () {
                  flushPassiveEffects();
                  return null;
                });
              }
            }

            nextEffect = nextEffect.nextEffect;
          }
        }

        function commitMutationEffects(root, renderPriorityLevel) {
          // TODO: Should probably move the bulk of this function to commitWork.
          while (nextEffect !== null) {
            setCurrentFiber(nextEffect);
            var flags = nextEffect.flags;

            if (flags & ContentReset) {
              commitResetTextContent(nextEffect);
            }

            if (flags & Ref) {
              var current = nextEffect.alternate;

              if (current !== null) {
                commitDetachRef(current);
              }
            } // The following switch statement is only concerned about placement,
            // updates, and deletions. To avoid needing to add a case for every possible
            // bitmap value, we remove the secondary effects from the effect tag and
            // switch on that value.


            var primaryFlags = flags & (Placement | Update | Deletion | Hydrating);

            switch (primaryFlags) {
              case Placement:
                {
                  commitPlacement(nextEffect); // Clear the "placement" from effect tag so that we know that this is
                  // inserted, before any life-cycles like componentDidMount gets called.
                  // TODO: findDOMNode doesn't rely on this any more but isMounted does
                  // and isMounted is deprecated anyway so we should be able to kill this.

                  nextEffect.flags &= ~Placement;
                  break;
                }

              case PlacementAndUpdate:
                {
                  // Placement
                  commitPlacement(nextEffect); // Clear the "placement" from effect tag so that we know that this is
                  // inserted, before any life-cycles like componentDidMount gets called.

                  nextEffect.flags &= ~Placement; // Update

                  var _current = nextEffect.alternate;
                  commitWork(_current, nextEffect);
                  break;
                }

              case Hydrating:
                {
                  nextEffect.flags &= ~Hydrating;
                  break;
                }

              case HydratingAndUpdate:
                {
                  nextEffect.flags &= ~Hydrating; // Update

                  var _current2 = nextEffect.alternate;
                  commitWork(_current2, nextEffect);
                  break;
                }

              case Update:
                {
                  var _current3 = nextEffect.alternate;
                  commitWork(_current3, nextEffect);
                  break;
                }

              case Deletion:
                {
                  commitDeletion(root, nextEffect);
                  break;
                }
            }

            resetCurrentFiber();
            nextEffect = nextEffect.nextEffect;
          }
        }

        function commitLayoutEffects(root, committedLanes) {
          while (nextEffect !== null) {
            setCurrentFiber(nextEffect);
            var flags = nextEffect.flags;

            if (flags & (Update | Callback)) {
              var current = nextEffect.alternate;
              commitLifeCycles(root, current, nextEffect);
            }

            {
              if (flags & Ref) {
                commitAttachRef(nextEffect);
              }
            }
            resetCurrentFiber();
            nextEffect = nextEffect.nextEffect;
          }
        }

        function flushPassiveEffects() {
          // Returns whether passive effects were flushed.
          if (pendingPassiveEffectsRenderPriority !== NoPriority$1) {
            var priorityLevel = pendingPassiveEffectsRenderPriority > NormalPriority$1 ? NormalPriority$1 : pendingPassiveEffectsRenderPriority;
            pendingPassiveEffectsRenderPriority = NoPriority$1;
            {
              return runWithPriority$1(priorityLevel, flushPassiveEffectsImpl);
            }
          }

          return false;
        }

        function enqueuePendingPassiveHookEffectMount(fiber, effect) {
          pendingPassiveHookEffectsMount.push(effect, fiber);

          if (!rootDoesHavePassiveEffects) {
            rootDoesHavePassiveEffects = true;
            scheduleCallback(NormalPriority$1, function () {
              flushPassiveEffects();
              return null;
            });
          }
        }

        function enqueuePendingPassiveHookEffectUnmount(fiber, effect) {
          pendingPassiveHookEffectsUnmount.push(effect, fiber);
          {
            fiber.flags |= PassiveUnmountPendingDev;
            var alternate = fiber.alternate;

            if (alternate !== null) {
              alternate.flags |= PassiveUnmountPendingDev;
            }
          }

          if (!rootDoesHavePassiveEffects) {
            rootDoesHavePassiveEffects = true;
            scheduleCallback(NormalPriority$1, function () {
              flushPassiveEffects();
              return null;
            });
          }
        }

        function invokePassiveEffectCreate(effect) {
          var create = effect.create;
          effect.destroy = create();
        }

        function flushPassiveEffectsImpl() {
          if (rootWithPendingPassiveEffects === null) {
            return false;
          }

          var root = rootWithPendingPassiveEffects;
          var lanes = pendingPassiveEffectsLanes;
          rootWithPendingPassiveEffects = null;
          pendingPassiveEffectsLanes = NoLanes;

          if (!((executionContext & (RenderContext | CommitContext)) === NoContext)) {
            {
              throw Error("Cannot flush passive effects while already rendering.");
            }
          }

          {
            isFlushingPassiveEffects = true;
          }
          var prevExecutionContext = executionContext;
          executionContext |= CommitContext;
          var prevInteractions = pushInteractions(root); // It's important that ALL pending passive effect destroy functions are called
          // before ANY passive effect create functions are called.
          // Otherwise effects in sibling components might interfere with each other.
          // e.g. a destroy function in one component may unintentionally override a ref
          // value set by a create function in another component.
          // Layout effects have the same constraint.
          // First pass: Destroy stale passive effects.

          var unmountEffects = pendingPassiveHookEffectsUnmount;
          pendingPassiveHookEffectsUnmount = [];

          for (var i = 0; i < unmountEffects.length; i += 2) {
            var _effect = unmountEffects[i];
            var fiber = unmountEffects[i + 1];
            var destroy = _effect.destroy;
            _effect.destroy = undefined;
            {
              fiber.flags &= ~PassiveUnmountPendingDev;
              var alternate = fiber.alternate;

              if (alternate !== null) {
                alternate.flags &= ~PassiveUnmountPendingDev;
              }
            }

            if (typeof destroy === 'function') {
              {
                setCurrentFiber(fiber);
                {
                  invokeGuardedCallback(null, destroy, null);
                }

                if (hasCaughtError()) {
                  if (!(fiber !== null)) {
                    {
                      throw Error("Should be working on an effect.");
                    }
                  }

                  var error = clearCaughtError();
                  captureCommitPhaseError(fiber, error);
                }

                resetCurrentFiber();
              }
            }
          } // Second pass: Create new passive effects.


          var mountEffects = pendingPassiveHookEffectsMount;
          pendingPassiveHookEffectsMount = [];

          for (var _i = 0; _i < mountEffects.length; _i += 2) {
            var _effect2 = mountEffects[_i];
            var _fiber = mountEffects[_i + 1];
            {
              setCurrentFiber(_fiber);
              {
                invokeGuardedCallback(null, invokePassiveEffectCreate, null, _effect2);
              }

              if (hasCaughtError()) {
                if (!(_fiber !== null)) {
                  {
                    throw Error("Should be working on an effect.");
                  }
                }

                var _error4 = clearCaughtError();

                captureCommitPhaseError(_fiber, _error4);
              }

              resetCurrentFiber();
            }
          } // Note: This currently assumes there are no passive effects on the root fiber
          // because the root is not part of its own effect list.
          // This could change in the future.


          var effect = root.current.firstEffect;

          while (effect !== null) {
            var nextNextEffect = effect.nextEffect; // Remove nextEffect pointer to assist GC

            effect.nextEffect = null;

            if (effect.flags & Deletion) {
              detachFiberAfterEffects(effect);
            }

            effect = nextNextEffect;
          }

          {
            popInteractions(prevInteractions);
            finishPendingInteractions(root, lanes);
          }
          {
            isFlushingPassiveEffects = false;
          }
          executionContext = prevExecutionContext;
          flushSyncCallbackQueue(); // If additional passive effects were scheduled, increment a counter. If this
          // exceeds the limit, we'll fire a warning.

          nestedPassiveUpdateCount = rootWithPendingPassiveEffects === null ? 0 : nestedPassiveUpdateCount + 1;
          return true;
        }

        function isAlreadyFailedLegacyErrorBoundary(instance) {
          return legacyErrorBoundariesThatAlreadyFailed !== null && legacyErrorBoundariesThatAlreadyFailed.has(instance);
        }

        function markLegacyErrorBoundaryAsFailed(instance) {
          if (legacyErrorBoundariesThatAlreadyFailed === null) {
            legacyErrorBoundariesThatAlreadyFailed = new Set([instance]);
          } else {
            legacyErrorBoundariesThatAlreadyFailed.add(instance);
          }
        }

        function prepareToThrowUncaughtError(error) {
          if (!hasUncaughtError) {
            hasUncaughtError = true;
            firstUncaughtError = error;
          }
        }

        var onUncaughtError = prepareToThrowUncaughtError;

        function captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
          var errorInfo = createCapturedValue(error, sourceFiber);
          var update = createRootErrorUpdate(rootFiber, errorInfo, SyncLane);
          enqueueUpdate(rootFiber, update);
          var eventTime = requestEventTime();
          var root = markUpdateLaneFromFiberToRoot(rootFiber, SyncLane);

          if (root !== null) {
            markRootUpdated(root, SyncLane, eventTime);
            ensureRootIsScheduled(root, eventTime);
            schedulePendingInteractions(root, SyncLane);
          }
        }

        function captureCommitPhaseError(sourceFiber, error) {
          if (sourceFiber.tag === HostRoot) {
            // Error was thrown at the root. There is no parent, so the root
            // itself should capture it.
            captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
            return;
          }

          var fiber = sourceFiber.return;

          while (fiber !== null) {
            if (fiber.tag === HostRoot) {
              captureCommitPhaseErrorOnRoot(fiber, sourceFiber, error);
              return;
            } else if (fiber.tag === ClassComponent) {
              var ctor = fiber.type;
              var instance = fiber.stateNode;

              if (typeof ctor.getDerivedStateFromError === 'function' || typeof instance.componentDidCatch === 'function' && !isAlreadyFailedLegacyErrorBoundary(instance)) {
                var errorInfo = createCapturedValue(error, sourceFiber);
                var update = createClassErrorUpdate(fiber, errorInfo, SyncLane);
                enqueueUpdate(fiber, update);
                var eventTime = requestEventTime();
                var root = markUpdateLaneFromFiberToRoot(fiber, SyncLane);

                if (root !== null) {
                  markRootUpdated(root, SyncLane, eventTime);
                  ensureRootIsScheduled(root, eventTime);
                  schedulePendingInteractions(root, SyncLane);
                } else {
                  // This component has already been unmounted.
                  // We can't schedule any follow up work for the root because the fiber is already unmounted,
                  // but we can still call the log-only boundary so the error isn't swallowed.
                  //
                  // TODO This is only a temporary bandaid for the old reconciler fork.
                  // We can delete this special case once the new fork is merged.
                  if (typeof instance.componentDidCatch === 'function' && !isAlreadyFailedLegacyErrorBoundary(instance)) {
                    try {
                      instance.componentDidCatch(error, errorInfo);
                    } catch (errorToIgnore) {// TODO Ignore this error? Rethrow it?
                      // This is kind of an edge case.
                    }
                  }
                }

                return;
              }
            }

            fiber = fiber.return;
          }
        }

        function pingSuspendedRoot(root, wakeable, pingedLanes) {
          var pingCache = root.pingCache;

          if (pingCache !== null) {
            // The wakeable resolved, so we no longer need to memoize, because it will
            // never be thrown again.
            pingCache.delete(wakeable);
          }

          var eventTime = requestEventTime();
          markRootPinged(root, pingedLanes);

          if (workInProgressRoot === root && isSubsetOfLanes(workInProgressRootRenderLanes, pingedLanes)) {
            // Received a ping at the same priority level at which we're currently
            // rendering. We might want to restart this render. This should mirror
            // the logic of whether or not a root suspends once it completes.
            // TODO: If we're rendering sync either due to Sync, Batched or expired,
            // we should probably never restart.
            // If we're suspended with delay, or if it's a retry, we'll always suspend
            // so we can always restart.
            if (workInProgressRootExitStatus === RootSuspendedWithDelay || workInProgressRootExitStatus === RootSuspended && includesOnlyRetries(workInProgressRootRenderLanes) && now() - globalMostRecentFallbackTime < FALLBACK_THROTTLE_MS) {
              // Restart from the root.
              prepareFreshStack(root, NoLanes);
            } else {
              // Even though we can't restart right now, we might get an
              // opportunity later. So we mark this render as having a ping.
              workInProgressRootPingedLanes = mergeLanes(workInProgressRootPingedLanes, pingedLanes);
            }
          }

          ensureRootIsScheduled(root, eventTime);
          schedulePendingInteractions(root, pingedLanes);
        }

        function retryTimedOutBoundary(boundaryFiber, retryLane) {
          // The boundary fiber (a Suspense component or SuspenseList component)
          // previously was rendered in its fallback state. One of the promises that
          // suspended it has resolved, which means at least part of the tree was
          // likely unblocked. Try rendering again, at a new expiration time.
          if (retryLane === NoLane) {
            retryLane = requestRetryLane(boundaryFiber);
          } // TODO: Special case idle priority?


          var eventTime = requestEventTime();
          var root = markUpdateLaneFromFiberToRoot(boundaryFiber, retryLane);

          if (root !== null) {
            markRootUpdated(root, retryLane, eventTime);
            ensureRootIsScheduled(root, eventTime);
            schedulePendingInteractions(root, retryLane);
          }
        }

        function resolveRetryWakeable(boundaryFiber, wakeable) {
          var retryLane = NoLane; // Default

          var retryCache;
          {
            retryCache = boundaryFiber.stateNode;
          }

          if (retryCache !== null) {
            // The wakeable resolved, so we no longer need to memoize, because it will
            // never be thrown again.
            retryCache.delete(wakeable);
          }

          retryTimedOutBoundary(boundaryFiber, retryLane);
        } // Computes the next Just Noticeable Difference (JND) boundary.
        // The theory is that a person can't tell the difference between small differences in time.
        // Therefore, if we wait a bit longer than necessary that won't translate to a noticeable
        // difference in the experience. However, waiting for longer might mean that we can avoid
        // showing an intermediate loading state. The longer we have already waited, the harder it
        // is to tell small differences in time. Therefore, the longer we've already waited,
        // the longer we can wait additionally. At some point we have to give up though.
        // We pick a train model where the next boundary commits at a consistent schedule.
        // These particular numbers are vague estimates. We expect to adjust them based on research.


        function jnd(timeElapsed) {
          return timeElapsed < 120 ? 120 : timeElapsed < 480 ? 480 : timeElapsed < 1080 ? 1080 : timeElapsed < 1920 ? 1920 : timeElapsed < 3000 ? 3000 : timeElapsed < 4320 ? 4320 : ceil(timeElapsed / 1960) * 1960;
        }

        function checkForNestedUpdates() {
          if (nestedUpdateCount > NESTED_UPDATE_LIMIT) {
            nestedUpdateCount = 0;
            rootWithNestedUpdates = null;
            {
              {
                throw Error("Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops.");
              }
            }
          }

          {
            if (nestedPassiveUpdateCount > NESTED_PASSIVE_UPDATE_LIMIT) {
              nestedPassiveUpdateCount = 0;
              error('Maximum update depth exceeded. This can happen when a component ' + "calls setState inside useEffect, but useEffect either doesn't " + 'have a dependency array, or one of the dependencies changes on ' + 'every render.');
            }
          }
        }

        function flushRenderPhaseStrictModeWarningsInDEV() {
          {
            ReactStrictModeWarnings.flushLegacyContextWarning();
            {
              ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings();
            }
          }
        }

        var didWarnStateUpdateForNotYetMountedComponent = null;

        function warnAboutUpdateOnNotYetMountedFiberInDEV(fiber) {
          {
            if ((executionContext & RenderContext) !== NoContext) {
              // We let the other warning about render phase updates deal with this one.
              return;
            }

            if (!(fiber.mode & (BlockingMode | ConcurrentMode))) {
              return;
            }

            var tag = fiber.tag;

            if (tag !== IndeterminateComponent && tag !== HostRoot && tag !== ClassComponent && tag !== FunctionComponent && tag !== ForwardRef && tag !== MemoComponent && tag !== SimpleMemoComponent && tag !== Block) {
              // Only warn for user-defined components, not internal ones like Suspense.
              return;
            } // We show the whole stack but dedupe on the top component's name because
            // the problematic code almost always lies inside that component.


            var componentName = getComponentName(fiber.type) || 'ReactComponent';

            if (didWarnStateUpdateForNotYetMountedComponent !== null) {
              if (didWarnStateUpdateForNotYetMountedComponent.has(componentName)) {
                return;
              }

              didWarnStateUpdateForNotYetMountedComponent.add(componentName);
            } else {
              didWarnStateUpdateForNotYetMountedComponent = new Set([componentName]);
            }

            var previousFiber = current;

            try {
              setCurrentFiber(fiber);
              error("Can't perform a React state update on a component that hasn't mounted yet. " + 'This indicates that you have a side-effect in your render function that ' + 'asynchronously later calls tries to update the component. Move this work to ' + 'useEffect instead.');
            } finally {
              if (previousFiber) {
                setCurrentFiber(fiber);
              } else {
                resetCurrentFiber();
              }
            }
          }
        }

        var didWarnStateUpdateForUnmountedComponent = null;

        function warnAboutUpdateOnUnmountedFiberInDEV(fiber) {
          {
            var tag = fiber.tag;

            if (tag !== HostRoot && tag !== ClassComponent && tag !== FunctionComponent && tag !== ForwardRef && tag !== MemoComponent && tag !== SimpleMemoComponent && tag !== Block) {
              // Only warn for user-defined components, not internal ones like Suspense.
              return;
            } // If there are pending passive effects unmounts for this Fiber,
            // we can assume that they would have prevented this update.


            if ((fiber.flags & PassiveUnmountPendingDev) !== NoFlags) {
              return;
            } // We show the whole stack but dedupe on the top component's name because
            // the problematic code almost always lies inside that component.


            var componentName = getComponentName(fiber.type) || 'ReactComponent';

            if (didWarnStateUpdateForUnmountedComponent !== null) {
              if (didWarnStateUpdateForUnmountedComponent.has(componentName)) {
                return;
              }

              didWarnStateUpdateForUnmountedComponent.add(componentName);
            } else {
              didWarnStateUpdateForUnmountedComponent = new Set([componentName]);
            }

            if (isFlushingPassiveEffects) ;else {
              var previousFiber = current;

              try {
                setCurrentFiber(fiber);
                error("Can't perform a React state update on an unmounted component. This " + 'is a no-op, but it indicates a memory leak in your application. To ' + 'fix, cancel all subscriptions and asynchronous tasks in %s.', tag === ClassComponent ? 'the componentWillUnmount method' : 'a useEffect cleanup function');
              } finally {
                if (previousFiber) {
                  setCurrentFiber(fiber);
                } else {
                  resetCurrentFiber();
                }
              }
            }
          }
        }

        var beginWork$1;
        {
          var dummyFiber = null;

          beginWork$1 = function beginWork$1(current, unitOfWork, lanes) {
            // If a component throws an error, we replay it again in a synchronously
            // dispatched event, so that the debugger will treat it as an uncaught
            // error See ReactErrorUtils for more information.
            // Before entering the begin phase, copy the work-in-progress onto a dummy
            // fiber. If beginWork throws, we'll use this to reset the state.
            var originalWorkInProgressCopy = assignFiberPropertiesInDEV(dummyFiber, unitOfWork);

            try {
              return beginWork(current, unitOfWork, lanes);
            } catch (originalError) {
              if (originalError !== null && typeof originalError === 'object' && typeof originalError.then === 'function') {
                // Don't replay promises. Treat everything else like an error.
                throw originalError;
              } // Keep this code in sync with handleError; any changes here must have
              // corresponding changes there.


              resetContextDependencies();
              resetHooksAfterThrow(); // Don't reset current debug fiber, since we're about to work on the
              // same fiber again.
              // Unwind the failed stack frame

              unwindInterruptedWork(unitOfWork); // Restore the original properties of the fiber.

              assignFiberPropertiesInDEV(unitOfWork, originalWorkInProgressCopy);

              if (unitOfWork.mode & ProfileMode) {
                // Reset the profiler timer.
                startProfilerTimer(unitOfWork);
              } // Run beginWork again.


              invokeGuardedCallback(null, beginWork, null, current, unitOfWork, lanes);

              if (hasCaughtError()) {
                var replayError = clearCaughtError(); // `invokeGuardedCallback` sometimes sets an expando `_suppressLogging`.
                // Rethrow this error instead of the original one.

                throw replayError;
              } else {
                // This branch is reachable if the render phase is impure.
                throw originalError;
              }
            }
          };
        }
        var didWarnAboutUpdateInRender = false;
        var didWarnAboutUpdateInRenderForAnotherComponent;
        {
          didWarnAboutUpdateInRenderForAnotherComponent = new Set();
        }

        function warnAboutRenderPhaseUpdatesInDEV(fiber) {
          {
            if (isRendering && (executionContext & RenderContext) !== NoContext && !getIsUpdatingOpaqueValueInRenderPhaseInDEV()) {
              switch (fiber.tag) {
                case FunctionComponent:
                case ForwardRef:
                case SimpleMemoComponent:
                  {
                    var renderingComponentName = workInProgress && getComponentName(workInProgress.type) || 'Unknown'; // Dedupe by the rendering component because it's the one that needs to be fixed.

                    var dedupeKey = renderingComponentName;

                    if (!didWarnAboutUpdateInRenderForAnotherComponent.has(dedupeKey)) {
                      didWarnAboutUpdateInRenderForAnotherComponent.add(dedupeKey);
                      var setStateComponentName = getComponentName(fiber.type) || 'Unknown';
                      error('Cannot update a component (`%s`) while rendering a ' + 'different component (`%s`). To locate the bad setState() call inside `%s`, ' + 'follow the stack trace as described in https://reactjs.org/link/setstate-in-render', setStateComponentName, renderingComponentName, renderingComponentName);
                    }

                    break;
                  }

                case ClassComponent:
                  {
                    if (!didWarnAboutUpdateInRender) {
                      error('Cannot update during an existing state transition (such as ' + 'within `render`). Render methods should be a pure ' + 'function of props and state.');
                      didWarnAboutUpdateInRender = true;
                    }

                    break;
                  }
              }
            }
          }
        } // a 'shared' variable that changes when act() opens/closes in tests.


        var IsThisRendererActing = {
          current: false
        };

        function warnIfNotScopedWithMatchingAct(fiber) {
          {
            if (IsSomeRendererActing.current === true && IsThisRendererActing.current !== true) {
              var previousFiber = current;

              try {
                setCurrentFiber(fiber);
                error("It looks like you're using the wrong act() around your test interactions.\n" + 'Be sure to use the matching version of act() corresponding to your renderer:\n\n' + '// for react-dom:\n' + // Break up imports to avoid accidentally parsing them as dependencies.
                'import {act} fr' + "om 'react-dom/test-utils';\n" + '// ...\n' + 'act(() => ...);\n\n' + '// for react-test-renderer:\n' + // Break up imports to avoid accidentally parsing them as dependencies.
                'import TestRenderer fr' + "om react-test-renderer';\n" + 'const {act} = TestRenderer;\n' + '// ...\n' + 'act(() => ...);');
              } finally {
                if (previousFiber) {
                  setCurrentFiber(fiber);
                } else {
                  resetCurrentFiber();
                }
              }
            }
          }
        }

        function warnIfNotCurrentlyActingEffectsInDEV(fiber) {
          {
            if ((fiber.mode & StrictMode) !== NoMode && IsSomeRendererActing.current === false && IsThisRendererActing.current === false) {
              error('An update to %s ran an effect, but was not wrapped in act(...).\n\n' + 'When testing, code that causes React state updates should be ' + 'wrapped into act(...):\n\n' + 'act(() => {\n' + '  /* fire events that update state */\n' + '});\n' + '/* assert on the output */\n\n' + "This ensures that you're testing the behavior the user would see " + 'in the browser.' + ' Learn more at https://reactjs.org/link/wrap-tests-with-act', getComponentName(fiber.type));
            }
          }
        }

        function warnIfNotCurrentlyActingUpdatesInDEV(fiber) {
          {
            if (executionContext === NoContext && IsSomeRendererActing.current === false && IsThisRendererActing.current === false) {
              var previousFiber = current;

              try {
                setCurrentFiber(fiber);
                error('An update to %s inside a test was not wrapped in act(...).\n\n' + 'When testing, code that causes React state updates should be ' + 'wrapped into act(...):\n\n' + 'act(() => {\n' + '  /* fire events that update state */\n' + '});\n' + '/* assert on the output */\n\n' + "This ensures that you're testing the behavior the user would see " + 'in the browser.' + ' Learn more at https://reactjs.org/link/wrap-tests-with-act', getComponentName(fiber.type));
              } finally {
                if (previousFiber) {
                  setCurrentFiber(fiber);
                } else {
                  resetCurrentFiber();
                }
              }
            }
          }
        }

        var warnIfNotCurrentlyActingUpdatesInDev = warnIfNotCurrentlyActingUpdatesInDEV; // In tests, we want to enforce a mocked scheduler.

        var didWarnAboutUnmockedScheduler = false; // TODO Before we release concurrent mode, revisit this and decide whether a mocked
        // scheduler is the actual recommendation. The alternative could be a testing build,
        // a new lib, or whatever; we dunno just yet. This message is for early adopters
        // to get their tests right.

        function warnIfUnmockedScheduler(fiber) {
          {
            if (didWarnAboutUnmockedScheduler === false && Scheduler.unstable_flushAllWithoutAsserting === undefined) {
              if (fiber.mode & BlockingMode || fiber.mode & ConcurrentMode) {
                didWarnAboutUnmockedScheduler = true;
                error('In Concurrent or Sync modes, the "scheduler" module needs to be mocked ' + 'to guarantee consistent behaviour across tests and browsers. ' + 'For example, with jest: \n' + // Break up requires to avoid accidentally parsing them as dependencies.
                "jest.mock('scheduler', () => require" + "('scheduler/unstable_mock'));\n\n" + 'For more info, visit https://reactjs.org/link/mock-scheduler');
              }
            }
          }
        }

        function computeThreadID(root, lane) {
          // Interaction threads are unique per root and expiration time.
          // NOTE: Intentionally unsound cast. All that matters is that it's a number
          // and it represents a batch of work. Could make a helper function instead,
          // but meh this is fine for now.
          return lane * 1000 + root.interactionThreadID;
        }

        function markSpawnedWork(lane) {
          if (spawnedWorkDuringRender === null) {
            spawnedWorkDuringRender = [lane];
          } else {
            spawnedWorkDuringRender.push(lane);
          }
        }

        function scheduleInteractions(root, lane, interactions) {
          if (interactions.size > 0) {
            var pendingInteractionMap = root.pendingInteractionMap;
            var pendingInteractions = pendingInteractionMap.get(lane);

            if (pendingInteractions != null) {
              interactions.forEach(function (interaction) {
                if (!pendingInteractions.has(interaction)) {
                  // Update the pending async work count for previously unscheduled interaction.
                  interaction.__count++;
                }

                pendingInteractions.add(interaction);
              });
            } else {
              pendingInteractionMap.set(lane, new Set(interactions)); // Update the pending async work count for the current interactions.

              interactions.forEach(function (interaction) {
                interaction.__count++;
              });
            }

            var subscriber = tracing.__subscriberRef.current;

            if (subscriber !== null) {
              var threadID = computeThreadID(root, lane);
              subscriber.onWorkScheduled(interactions, threadID);
            }
          }
        }

        function schedulePendingInteractions(root, lane) {
          scheduleInteractions(root, lane, tracing.__interactionsRef.current);
        }

        function startWorkOnPendingInteractions(root, lanes) {
          // we can accurately attribute time spent working on it, And so that cascading
          // work triggered during the render phase will be associated with it.
          var interactions = new Set();
          root.pendingInteractionMap.forEach(function (scheduledInteractions, scheduledLane) {
            if (includesSomeLane(lanes, scheduledLane)) {
              scheduledInteractions.forEach(function (interaction) {
                return interactions.add(interaction);
              });
            }
          }); // Store the current set of interactions on the FiberRoot for a few reasons:
          // We can re-use it in hot functions like performConcurrentWorkOnRoot()
          // without having to recalculate it. We will also use it in commitWork() to
          // pass to any Profiler onRender() hooks. This also provides DevTools with a
          // way to access it when the onCommitRoot() hook is called.

          root.memoizedInteractions = interactions;

          if (interactions.size > 0) {
            var subscriber = tracing.__subscriberRef.current;

            if (subscriber !== null) {
              var threadID = computeThreadID(root, lanes);

              try {
                subscriber.onWorkStarted(interactions, threadID);
              } catch (error) {
                // If the subscriber throws, rethrow it in a separate task
                scheduleCallback(ImmediatePriority$1, function () {
                  throw error;
                });
              }
            }
          }
        }

        function finishPendingInteractions(root, committedLanes) {
          var remainingLanesAfterCommit = root.pendingLanes;
          var subscriber;

          try {
            subscriber = tracing.__subscriberRef.current;

            if (subscriber !== null && root.memoizedInteractions.size > 0) {
              // FIXME: More than one lane can finish in a single commit.
              var threadID = computeThreadID(root, committedLanes);
              subscriber.onWorkStopped(root.memoizedInteractions, threadID);
            }
          } catch (error) {
            // If the subscriber throws, rethrow it in a separate task
            scheduleCallback(ImmediatePriority$1, function () {
              throw error;
            });
          } finally {
            // Clear completed interactions from the pending Map.
            // Unless the render was suspended or cascading work was scheduled,
            // In which case– leave pending interactions until the subsequent render.
            var pendingInteractionMap = root.pendingInteractionMap;
            pendingInteractionMap.forEach(function (scheduledInteractions, lane) {
              // Only decrement the pending interaction count if we're done.
              // If there's still work at the current priority,
              // That indicates that we are waiting for suspense data.
              if (!includesSomeLane(remainingLanesAfterCommit, lane)) {
                pendingInteractionMap.delete(lane);
                scheduledInteractions.forEach(function (interaction) {
                  interaction.__count--;

                  if (subscriber !== null && interaction.__count === 0) {
                    try {
                      subscriber.onInteractionScheduledWorkCompleted(interaction);
                    } catch (error) {
                      // If the subscriber throws, rethrow it in a separate task
                      scheduleCallback(ImmediatePriority$1, function () {
                        throw error;
                      });
                    }
                  }
                });
              }
            });
          }
        } // `act` testing API


        function shouldForceFlushFallbacksInDEV() {
          // Never force flush in production. This function should get stripped out.
          return actingUpdatesScopeDepth > 0;
        } // so we can tell if any async act() calls try to run in parallel.


        var actingUpdatesScopeDepth = 0;

        function detachFiberAfterEffects(fiber) {
          fiber.sibling = null;
          fiber.stateNode = null;
        }

        var resolveFamily = null; // $FlowFixMe Flow gets confused by a WeakSet feature check below.

        var failedBoundaries = null;

        var setRefreshHandler = function setRefreshHandler(handler) {
          {
            resolveFamily = handler;
          }
        };

        function resolveFunctionForHotReloading(type) {
          {
            if (resolveFamily === null) {
              // Hot reloading is disabled.
              return type;
            }

            var family = resolveFamily(type);

            if (family === undefined) {
              return type;
            } // Use the latest known implementation.


            return family.current;
          }
        }

        function resolveClassForHotReloading(type) {
          // No implementation differences.
          return resolveFunctionForHotReloading(type);
        }

        function resolveForwardRefForHotReloading(type) {
          {
            if (resolveFamily === null) {
              // Hot reloading is disabled.
              return type;
            }

            var family = resolveFamily(type);

            if (family === undefined) {
              // Check if we're dealing with a real forwardRef. Don't want to crash early.
              if (type !== null && type !== undefined && typeof type.render === 'function') {
                // ForwardRef is special because its resolved .type is an object,
                // but it's possible that we only have its inner render function in the map.
                // If that inner render function is different, we'll build a new forwardRef type.
                var currentRender = resolveFunctionForHotReloading(type.render);

                if (type.render !== currentRender) {
                  var syntheticType = {
                    $$typeof: REACT_FORWARD_REF_TYPE,
                    render: currentRender
                  };

                  if (type.displayName !== undefined) {
                    syntheticType.displayName = type.displayName;
                  }

                  return syntheticType;
                }
              }

              return type;
            } // Use the latest known implementation.


            return family.current;
          }
        }

        function isCompatibleFamilyForHotReloading(fiber, element) {
          {
            if (resolveFamily === null) {
              // Hot reloading is disabled.
              return false;
            }

            var prevType = fiber.elementType;
            var nextType = element.type; // If we got here, we know types aren't === equal.

            var needsCompareFamilies = false;
            var $$typeofNextType = typeof nextType === 'object' && nextType !== null ? nextType.$$typeof : null;

            switch (fiber.tag) {
              case ClassComponent:
                {
                  if (typeof nextType === 'function') {
                    needsCompareFamilies = true;
                  }

                  break;
                }

              case FunctionComponent:
                {
                  if (typeof nextType === 'function') {
                    needsCompareFamilies = true;
                  } else if ($$typeofNextType === REACT_LAZY_TYPE) {
                    // We don't know the inner type yet.
                    // We're going to assume that the lazy inner type is stable,
                    // and so it is sufficient to avoid reconciling it away.
                    // We're not going to unwrap or actually use the new lazy type.
                    needsCompareFamilies = true;
                  }

                  break;
                }

              case ForwardRef:
                {
                  if ($$typeofNextType === REACT_FORWARD_REF_TYPE) {
                    needsCompareFamilies = true;
                  } else if ($$typeofNextType === REACT_LAZY_TYPE) {
                    needsCompareFamilies = true;
                  }

                  break;
                }

              case MemoComponent:
              case SimpleMemoComponent:
                {
                  if ($$typeofNextType === REACT_MEMO_TYPE) {
                    // TODO: if it was but can no longer be simple,
                    // we shouldn't set this.
                    needsCompareFamilies = true;
                  } else if ($$typeofNextType === REACT_LAZY_TYPE) {
                    needsCompareFamilies = true;
                  }

                  break;
                }

              default:
                return false;
            } // Check if both types have a family and it's the same one.


            if (needsCompareFamilies) {
              // Note: memo() and forwardRef() we'll compare outer rather than inner type.
              // This means both of them need to be registered to preserve state.
              // If we unwrapped and compared the inner types for wrappers instead,
              // then we would risk falsely saying two separate memo(Foo)
              // calls are equivalent because they wrap the same Foo function.
              var prevFamily = resolveFamily(prevType);

              if (prevFamily !== undefined && prevFamily === resolveFamily(nextType)) {
                return true;
              }
            }

            return false;
          }
        }

        function markFailedErrorBoundaryForHotReloading(fiber) {
          {
            if (resolveFamily === null) {
              // Hot reloading is disabled.
              return;
            }

            if (typeof WeakSet !== 'function') {
              return;
            }

            if (failedBoundaries === null) {
              failedBoundaries = new WeakSet();
            }

            failedBoundaries.add(fiber);
          }
        }

        var scheduleRefresh = function scheduleRefresh(root, update) {
          {
            if (resolveFamily === null) {
              // Hot reloading is disabled.
              return;
            }

            var staleFamilies = update.staleFamilies,
                updatedFamilies = update.updatedFamilies;
            flushPassiveEffects();
            flushSync(function () {
              scheduleFibersWithFamiliesRecursively(root.current, updatedFamilies, staleFamilies);
            });
          }
        };

        var scheduleRoot = function scheduleRoot(root, element) {
          {
            if (root.context !== emptyContextObject) {
              // Super edge case: root has a legacy _renderSubtree context
              // but we don't know the parentComponent so we can't pass it.
              // Just ignore. We'll delete this with _renderSubtree code path later.
              return;
            }

            flushPassiveEffects();
            flushSync(function () {
              updateContainer(element, root, null, null);
            });
          }
        };

        function scheduleFibersWithFamiliesRecursively(fiber, updatedFamilies, staleFamilies) {
          {
            var alternate = fiber.alternate,
                child = fiber.child,
                sibling = fiber.sibling,
                tag = fiber.tag,
                type = fiber.type;
            var candidateType = null;

            switch (tag) {
              case FunctionComponent:
              case SimpleMemoComponent:
              case ClassComponent:
                candidateType = type;
                break;

              case ForwardRef:
                candidateType = type.render;
                break;
            }

            if (resolveFamily === null) {
              throw new Error('Expected resolveFamily to be set during hot reload.');
            }

            var needsRender = false;
            var needsRemount = false;

            if (candidateType !== null) {
              var family = resolveFamily(candidateType);

              if (family !== undefined) {
                if (staleFamilies.has(family)) {
                  needsRemount = true;
                } else if (updatedFamilies.has(family)) {
                  if (tag === ClassComponent) {
                    needsRemount = true;
                  } else {
                    needsRender = true;
                  }
                }
              }
            }

            if (failedBoundaries !== null) {
              if (failedBoundaries.has(fiber) || alternate !== null && failedBoundaries.has(alternate)) {
                needsRemount = true;
              }
            }

            if (needsRemount) {
              fiber._debugNeedsRemount = true;
            }

            if (needsRemount || needsRender) {
              scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
            }

            if (child !== null && !needsRemount) {
              scheduleFibersWithFamiliesRecursively(child, updatedFamilies, staleFamilies);
            }

            if (sibling !== null) {
              scheduleFibersWithFamiliesRecursively(sibling, updatedFamilies, staleFamilies);
            }
          }
        }

        var findHostInstancesForRefresh = function findHostInstancesForRefresh(root, families) {
          {
            var hostInstances = new Set();
            var types = new Set(families.map(function (family) {
              return family.current;
            }));
            findHostInstancesForMatchingFibersRecursively(root.current, types, hostInstances);
            return hostInstances;
          }
        };

        function findHostInstancesForMatchingFibersRecursively(fiber, types, hostInstances) {
          {
            var child = fiber.child,
                sibling = fiber.sibling,
                tag = fiber.tag,
                type = fiber.type;
            var candidateType = null;

            switch (tag) {
              case FunctionComponent:
              case SimpleMemoComponent:
              case ClassComponent:
                candidateType = type;
                break;

              case ForwardRef:
                candidateType = type.render;
                break;
            }

            var didMatch = false;

            if (candidateType !== null) {
              if (types.has(candidateType)) {
                didMatch = true;
              }
            }

            if (didMatch) {
              // We have a match. This only drills down to the closest host components.
              // There's no need to search deeper because for the purpose of giving
              // visual feedback, "flashing" outermost parent rectangles is sufficient.
              findHostInstancesForFiberShallowly(fiber, hostInstances);
            } else {
              // If there's no match, maybe there will be one further down in the child tree.
              if (child !== null) {
                findHostInstancesForMatchingFibersRecursively(child, types, hostInstances);
              }
            }

            if (sibling !== null) {
              findHostInstancesForMatchingFibersRecursively(sibling, types, hostInstances);
            }
          }
        }

        function findHostInstancesForFiberShallowly(fiber, hostInstances) {
          {
            var foundHostInstances = findChildHostInstancesForFiberShallowly(fiber, hostInstances);

            if (foundHostInstances) {
              return;
            } // If we didn't find any host children, fallback to closest host parent.


            var node = fiber;

            while (true) {
              switch (node.tag) {
                case HostComponent:
                  hostInstances.add(node.stateNode);
                  return;

                case HostPortal:
                  hostInstances.add(node.stateNode.containerInfo);
                  return;

                case HostRoot:
                  hostInstances.add(node.stateNode.containerInfo);
                  return;
              }

              if (node.return === null) {
                throw new Error('Expected to reach root first.');
              }

              node = node.return;
            }
          }
        }

        function findChildHostInstancesForFiberShallowly(fiber, hostInstances) {
          {
            var node = fiber;
            var foundHostInstances = false;

            while (true) {
              if (node.tag === HostComponent) {
                // We got a match.
                foundHostInstances = true;
                hostInstances.add(node.stateNode); // There may still be more, so keep searching.
              } else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
              }

              if (node === fiber) {
                return foundHostInstances;
              }

              while (node.sibling === null) {
                if (node.return === null || node.return === fiber) {
                  return foundHostInstances;
                }

                node = node.return;
              }

              node.sibling.return = node.return;
              node = node.sibling;
            }
          }
          return false;
        }

        var hasBadMapPolyfill;
        {
          hasBadMapPolyfill = false;

          try {
            var nonExtensibleObject = Object.preventExtensions({});
            /* eslint-disable no-new */

            new Map([[nonExtensibleObject, null]]);
            new Set([nonExtensibleObject]);
            /* eslint-enable no-new */
          } catch (e) {
            // TODO: Consider warning about bad polyfills
            hasBadMapPolyfill = true;
          }
        }
        var debugCounter = 1;

        function FiberNode(tag, pendingProps, key, mode) {
          // Instance
          this.tag = tag;
          this.key = key;
          this.elementType = null;
          this.type = null;
          this.stateNode = null; // Fiber

          this.return = null;
          this.child = null;
          this.sibling = null;
          this.index = 0;
          this.ref = null;
          this.pendingProps = pendingProps;
          this.memoizedProps = null;
          this.updateQueue = null;
          this.memoizedState = null;
          this.dependencies = null;
          this.mode = mode; // Effects

          this.flags = NoFlags;
          this.nextEffect = null;
          this.firstEffect = null;
          this.lastEffect = null;
          this.lanes = NoLanes;
          this.childLanes = NoLanes;
          this.alternate = null;
          {
            // Note: The following is done to avoid a v8 performance cliff.
            //
            // Initializing the fields below to smis and later updating them with
            // double values will cause Fibers to end up having separate shapes.
            // This behavior/bug has something to do with Object.preventExtension().
            // Fortunately this only impacts DEV builds.
            // Unfortunately it makes React unusably slow for some applications.
            // To work around this, initialize the fields below with doubles.
            //
            // Learn more about this here:
            // https://github.com/facebook/react/issues/14365
            // https://bugs.chromium.org/p/v8/issues/detail?id=8538
            this.actualDuration = Number.NaN;
            this.actualStartTime = Number.NaN;
            this.selfBaseDuration = Number.NaN;
            this.treeBaseDuration = Number.NaN; // It's okay to replace the initial doubles with smis after initialization.
            // This won't trigger the performance cliff mentioned above,
            // and it simplifies other profiler code (including DevTools).

            this.actualDuration = 0;
            this.actualStartTime = -1;
            this.selfBaseDuration = 0;
            this.treeBaseDuration = 0;
          }
          {
            // This isn't directly used but is handy for debugging internals:
            this._debugID = debugCounter++;
            this._debugSource = null;
            this._debugOwner = null;
            this._debugNeedsRemount = false;
            this._debugHookTypes = null;

            if (!hasBadMapPolyfill && typeof Object.preventExtensions === 'function') {
              Object.preventExtensions(this);
            }
          }
        } // This is a constructor function, rather than a POJO constructor, still
        // please ensure we do the following:
        // 1) Nobody should add any instance methods on this. Instance methods can be
        //    more difficult to predict when they get optimized and they are almost
        //    never inlined properly in static compilers.
        // 2) Nobody should rely on `instanceof Fiber` for type testing. We should
        //    always know when it is a fiber.
        // 3) We might want to experiment with using numeric keys since they are easier
        //    to optimize in a non-JIT environment.
        // 4) We can easily go from a constructor to a createFiber object literal if that
        //    is faster.
        // 5) It should be easy to port this to a C struct and keep a C implementation
        //    compatible.


        var createFiber = function createFiber(tag, pendingProps, key, mode) {
          // $FlowFixMe: the shapes are exact here but Flow doesn't like constructors
          return new FiberNode(tag, pendingProps, key, mode);
        };

        function shouldConstruct$1(Component) {
          var prototype = Component.prototype;
          return !!(prototype && prototype.isReactComponent);
        }

        function isSimpleFunctionComponent(type) {
          return typeof type === 'function' && !shouldConstruct$1(type) && type.defaultProps === undefined;
        }

        function resolveLazyComponentTag(Component) {
          if (typeof Component === 'function') {
            return shouldConstruct$1(Component) ? ClassComponent : FunctionComponent;
          } else if (Component !== undefined && Component !== null) {
            var $$typeof = Component.$$typeof;

            if ($$typeof === REACT_FORWARD_REF_TYPE) {
              return ForwardRef;
            }

            if ($$typeof === REACT_MEMO_TYPE) {
              return MemoComponent;
            }
          }

          return IndeterminateComponent;
        } // This is used to create an alternate fiber to do work on.


        function createWorkInProgress(current, pendingProps) {
          var workInProgress = current.alternate;

          if (workInProgress === null) {
            // We use a double buffering pooling technique because we know that we'll
            // only ever need at most two versions of a tree. We pool the "other" unused
            // node that we're free to reuse. This is lazily created to avoid allocating
            // extra objects for things that are never updated. It also allow us to
            // reclaim the extra memory if needed.
            workInProgress = createFiber(current.tag, pendingProps, current.key, current.mode);
            workInProgress.elementType = current.elementType;
            workInProgress.type = current.type;
            workInProgress.stateNode = current.stateNode;
            {
              // DEV-only fields
              workInProgress._debugID = current._debugID;
              workInProgress._debugSource = current._debugSource;
              workInProgress._debugOwner = current._debugOwner;
              workInProgress._debugHookTypes = current._debugHookTypes;
            }
            workInProgress.alternate = current;
            current.alternate = workInProgress;
          } else {
            workInProgress.pendingProps = pendingProps; // Needed because Blocks store data on type.

            workInProgress.type = current.type; // We already have an alternate.
            // Reset the effect tag.

            workInProgress.flags = NoFlags; // The effect list is no longer valid.

            workInProgress.nextEffect = null;
            workInProgress.firstEffect = null;
            workInProgress.lastEffect = null;
            {
              // We intentionally reset, rather than copy, actualDuration & actualStartTime.
              // This prevents time from endlessly accumulating in new commits.
              // This has the downside of resetting values for different priority renders,
              // But works for yielding (the common case) and should support resuming.
              workInProgress.actualDuration = 0;
              workInProgress.actualStartTime = -1;
            }
          }

          workInProgress.childLanes = current.childLanes;
          workInProgress.lanes = current.lanes;
          workInProgress.child = current.child;
          workInProgress.memoizedProps = current.memoizedProps;
          workInProgress.memoizedState = current.memoizedState;
          workInProgress.updateQueue = current.updateQueue; // Clone the dependencies object. This is mutated during the render phase, so
          // it cannot be shared with the current fiber.

          var currentDependencies = current.dependencies;
          workInProgress.dependencies = currentDependencies === null ? null : {
            lanes: currentDependencies.lanes,
            firstContext: currentDependencies.firstContext
          }; // These will be overridden during the parent's reconciliation

          workInProgress.sibling = current.sibling;
          workInProgress.index = current.index;
          workInProgress.ref = current.ref;
          {
            workInProgress.selfBaseDuration = current.selfBaseDuration;
            workInProgress.treeBaseDuration = current.treeBaseDuration;
          }
          {
            workInProgress._debugNeedsRemount = current._debugNeedsRemount;

            switch (workInProgress.tag) {
              case IndeterminateComponent:
              case FunctionComponent:
              case SimpleMemoComponent:
                workInProgress.type = resolveFunctionForHotReloading(current.type);
                break;

              case ClassComponent:
                workInProgress.type = resolveClassForHotReloading(current.type);
                break;

              case ForwardRef:
                workInProgress.type = resolveForwardRefForHotReloading(current.type);
                break;
            }
          }
          return workInProgress;
        } // Used to reuse a Fiber for a second pass.


        function resetWorkInProgress(workInProgress, renderLanes) {
          // This resets the Fiber to what createFiber or createWorkInProgress would
          // have set the values to before during the first pass. Ideally this wouldn't
          // be necessary but unfortunately many code paths reads from the workInProgress
          // when they should be reading from current and writing to workInProgress.
          // We assume pendingProps, index, key, ref, return are still untouched to
          // avoid doing another reconciliation.
          // Reset the effect tag but keep any Placement tags, since that's something
          // that child fiber is setting, not the reconciliation.
          workInProgress.flags &= Placement; // The effect list is no longer valid.

          workInProgress.nextEffect = null;
          workInProgress.firstEffect = null;
          workInProgress.lastEffect = null;
          var current = workInProgress.alternate;

          if (current === null) {
            // Reset to createFiber's initial values.
            workInProgress.childLanes = NoLanes;
            workInProgress.lanes = renderLanes;
            workInProgress.child = null;
            workInProgress.memoizedProps = null;
            workInProgress.memoizedState = null;
            workInProgress.updateQueue = null;
            workInProgress.dependencies = null;
            workInProgress.stateNode = null;
            {
              // Note: We don't reset the actualTime counts. It's useful to accumulate
              // actual time across multiple render passes.
              workInProgress.selfBaseDuration = 0;
              workInProgress.treeBaseDuration = 0;
            }
          } else {
            // Reset to the cloned values that createWorkInProgress would've.
            workInProgress.childLanes = current.childLanes;
            workInProgress.lanes = current.lanes;
            workInProgress.child = current.child;
            workInProgress.memoizedProps = current.memoizedProps;
            workInProgress.memoizedState = current.memoizedState;
            workInProgress.updateQueue = current.updateQueue; // Needed because Blocks store data on type.

            workInProgress.type = current.type; // Clone the dependencies object. This is mutated during the render phase, so
            // it cannot be shared with the current fiber.

            var currentDependencies = current.dependencies;
            workInProgress.dependencies = currentDependencies === null ? null : {
              lanes: currentDependencies.lanes,
              firstContext: currentDependencies.firstContext
            };
            {
              // Note: We don't reset the actualTime counts. It's useful to accumulate
              // actual time across multiple render passes.
              workInProgress.selfBaseDuration = current.selfBaseDuration;
              workInProgress.treeBaseDuration = current.treeBaseDuration;
            }
          }

          return workInProgress;
        }

        function createHostRootFiber(tag) {
          var mode;

          if (tag === ConcurrentRoot) {
            mode = ConcurrentMode | BlockingMode | StrictMode;
          } else if (tag === BlockingRoot) {
            mode = BlockingMode | StrictMode;
          } else {
            mode = NoMode;
          }

          if (isDevToolsPresent) {
            // Always collect profile timings when DevTools are present.
            // This enables DevTools to start capturing timing at any point–
            // Without some nodes in the tree having empty base times.
            mode |= ProfileMode;
          }

          return createFiber(HostRoot, null, null, mode);
        }

        function createFiberFromTypeAndProps(type, // React$ElementType
        key, pendingProps, owner, mode, lanes) {
          var fiberTag = IndeterminateComponent; // The resolved type is set if we know what the final type will be. I.e. it's not lazy.

          var resolvedType = type;

          if (typeof type === 'function') {
            if (shouldConstruct$1(type)) {
              fiberTag = ClassComponent;
              {
                resolvedType = resolveClassForHotReloading(resolvedType);
              }
            } else {
              {
                resolvedType = resolveFunctionForHotReloading(resolvedType);
              }
            }
          } else if (typeof type === 'string') {
            fiberTag = HostComponent;
          } else {
            getTag: switch (type) {
              case REACT_FRAGMENT_TYPE:
                return createFiberFromFragment(pendingProps.children, mode, lanes, key);

              case REACT_DEBUG_TRACING_MODE_TYPE:
                fiberTag = Mode;
                mode |= DebugTracingMode;
                break;

              case REACT_STRICT_MODE_TYPE:
                fiberTag = Mode;
                mode |= StrictMode;
                break;

              case REACT_PROFILER_TYPE:
                return createFiberFromProfiler(pendingProps, mode, lanes, key);

              case REACT_SUSPENSE_TYPE:
                return createFiberFromSuspense(pendingProps, mode, lanes, key);

              case REACT_SUSPENSE_LIST_TYPE:
                return createFiberFromSuspenseList(pendingProps, mode, lanes, key);

              case REACT_OFFSCREEN_TYPE:
                return createFiberFromOffscreen(pendingProps, mode, lanes, key);

              case REACT_LEGACY_HIDDEN_TYPE:
                return createFiberFromLegacyHidden(pendingProps, mode, lanes, key);

              case REACT_SCOPE_TYPE: // eslint-disable-next-line no-fallthrough

              default:
                {
                  if (typeof type === 'object' && type !== null) {
                    switch (type.$$typeof) {
                      case REACT_PROVIDER_TYPE:
                        fiberTag = ContextProvider;
                        break getTag;

                      case REACT_CONTEXT_TYPE:
                        // This is a consumer
                        fiberTag = ContextConsumer;
                        break getTag;

                      case REACT_FORWARD_REF_TYPE:
                        fiberTag = ForwardRef;
                        {
                          resolvedType = resolveForwardRefForHotReloading(resolvedType);
                        }
                        break getTag;

                      case REACT_MEMO_TYPE:
                        fiberTag = MemoComponent;
                        break getTag;

                      case REACT_LAZY_TYPE:
                        fiberTag = LazyComponent;
                        resolvedType = null;
                        break getTag;

                      case REACT_BLOCK_TYPE:
                        fiberTag = Block;
                        break getTag;
                    }
                  }

                  var info = '';
                  {
                    if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
                      info += ' You likely forgot to export your component from the file ' + "it's defined in, or you might have mixed up default and " + 'named imports.';
                    }

                    var ownerName = owner ? getComponentName(owner.type) : null;

                    if (ownerName) {
                      info += '\n\nCheck the render method of `' + ownerName + '`.';
                    }
                  }
                  {
                    {
                      throw Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: " + (type == null ? type : typeof type) + "." + info);
                    }
                  }
                }
            }
          }

          var fiber = createFiber(fiberTag, pendingProps, key, mode);
          fiber.elementType = type;
          fiber.type = resolvedType;
          fiber.lanes = lanes;
          {
            fiber._debugOwner = owner;
          }
          return fiber;
        }

        function createFiberFromElement(element, mode, lanes) {
          var owner = null;
          {
            owner = element._owner;
          }
          var type = element.type;
          var key = element.key;
          var pendingProps = element.props;
          var fiber = createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes);
          {
            fiber._debugSource = element._source;
            fiber._debugOwner = element._owner;
          }
          return fiber;
        }

        function createFiberFromFragment(elements, mode, lanes, key) {
          var fiber = createFiber(Fragment, elements, key, mode);
          fiber.lanes = lanes;
          return fiber;
        }

        function createFiberFromProfiler(pendingProps, mode, lanes, key) {
          {
            if (typeof pendingProps.id !== 'string') {
              error('Profiler must specify an "id" as a prop');
            }
          }
          var fiber = createFiber(Profiler, pendingProps, key, mode | ProfileMode); // TODO: The Profiler fiber shouldn't have a type. It has a tag.

          fiber.elementType = REACT_PROFILER_TYPE;
          fiber.type = REACT_PROFILER_TYPE;
          fiber.lanes = lanes;
          {
            fiber.stateNode = {
              effectDuration: 0,
              passiveEffectDuration: 0
            };
          }
          return fiber;
        }

        function createFiberFromSuspense(pendingProps, mode, lanes, key) {
          var fiber = createFiber(SuspenseComponent, pendingProps, key, mode); // TODO: The SuspenseComponent fiber shouldn't have a type. It has a tag.
          // This needs to be fixed in getComponentName so that it relies on the tag
          // instead.

          fiber.type = REACT_SUSPENSE_TYPE;
          fiber.elementType = REACT_SUSPENSE_TYPE;
          fiber.lanes = lanes;
          return fiber;
        }

        function createFiberFromSuspenseList(pendingProps, mode, lanes, key) {
          var fiber = createFiber(SuspenseListComponent, pendingProps, key, mode);
          {
            // TODO: The SuspenseListComponent fiber shouldn't have a type. It has a tag.
            // This needs to be fixed in getComponentName so that it relies on the tag
            // instead.
            fiber.type = REACT_SUSPENSE_LIST_TYPE;
          }
          fiber.elementType = REACT_SUSPENSE_LIST_TYPE;
          fiber.lanes = lanes;
          return fiber;
        }

        function createFiberFromOffscreen(pendingProps, mode, lanes, key) {
          var fiber = createFiber(OffscreenComponent, pendingProps, key, mode); // TODO: The OffscreenComponent fiber shouldn't have a type. It has a tag.
          // This needs to be fixed in getComponentName so that it relies on the tag
          // instead.

          {
            fiber.type = REACT_OFFSCREEN_TYPE;
          }
          fiber.elementType = REACT_OFFSCREEN_TYPE;
          fiber.lanes = lanes;
          return fiber;
        }

        function createFiberFromLegacyHidden(pendingProps, mode, lanes, key) {
          var fiber = createFiber(LegacyHiddenComponent, pendingProps, key, mode); // TODO: The LegacyHidden fiber shouldn't have a type. It has a tag.
          // This needs to be fixed in getComponentName so that it relies on the tag
          // instead.

          {
            fiber.type = REACT_LEGACY_HIDDEN_TYPE;
          }
          fiber.elementType = REACT_LEGACY_HIDDEN_TYPE;
          fiber.lanes = lanes;
          return fiber;
        }

        function createFiberFromText(content, mode, lanes) {
          var fiber = createFiber(HostText, content, null, mode);
          fiber.lanes = lanes;
          return fiber;
        }

        function createFiberFromHostInstanceForDeletion() {
          var fiber = createFiber(HostComponent, null, null, NoMode); // TODO: These should not need a type.

          fiber.elementType = 'DELETED';
          fiber.type = 'DELETED';
          return fiber;
        }

        function createFiberFromPortal(portal, mode, lanes) {
          var pendingProps = portal.children !== null ? portal.children : [];
          var fiber = createFiber(HostPortal, pendingProps, portal.key, mode);
          fiber.lanes = lanes;
          fiber.stateNode = {
            containerInfo: portal.containerInfo,
            pendingChildren: null,
            // Used by persistent updates
            implementation: portal.implementation
          };
          return fiber;
        } // Used for stashing WIP properties to replay failed work in DEV.


        function assignFiberPropertiesInDEV(target, source) {
          if (target === null) {
            // This Fiber's initial properties will always be overwritten.
            // We only use a Fiber to ensure the same hidden class so DEV isn't slow.
            target = createFiber(IndeterminateComponent, null, null, NoMode);
          } // This is intentionally written as a list of all properties.
          // We tried to use Object.assign() instead but this is called in
          // the hottest path, and Object.assign() was too slow:
          // https://github.com/facebook/react/issues/12502
          // This code is DEV-only so size is not a concern.


          target.tag = source.tag;
          target.key = source.key;
          target.elementType = source.elementType;
          target.type = source.type;
          target.stateNode = source.stateNode;
          target.return = source.return;
          target.child = source.child;
          target.sibling = source.sibling;
          target.index = source.index;
          target.ref = source.ref;
          target.pendingProps = source.pendingProps;
          target.memoizedProps = source.memoizedProps;
          target.updateQueue = source.updateQueue;
          target.memoizedState = source.memoizedState;
          target.dependencies = source.dependencies;
          target.mode = source.mode;
          target.flags = source.flags;
          target.nextEffect = source.nextEffect;
          target.firstEffect = source.firstEffect;
          target.lastEffect = source.lastEffect;
          target.lanes = source.lanes;
          target.childLanes = source.childLanes;
          target.alternate = source.alternate;
          {
            target.actualDuration = source.actualDuration;
            target.actualStartTime = source.actualStartTime;
            target.selfBaseDuration = source.selfBaseDuration;
            target.treeBaseDuration = source.treeBaseDuration;
          }
          target._debugID = source._debugID;
          target._debugSource = source._debugSource;
          target._debugOwner = source._debugOwner;
          target._debugNeedsRemount = source._debugNeedsRemount;
          target._debugHookTypes = source._debugHookTypes;
          return target;
        }

        function FiberRootNode(containerInfo, tag, hydrate) {
          this.tag = tag;
          this.containerInfo = containerInfo;
          this.pendingChildren = null;
          this.current = null;
          this.pingCache = null;
          this.finishedWork = null;
          this.timeoutHandle = noTimeout;
          this.context = null;
          this.pendingContext = null;
          this.hydrate = hydrate;
          this.callbackNode = null;
          this.callbackPriority = NoLanePriority;
          this.eventTimes = createLaneMap(NoLanes);
          this.expirationTimes = createLaneMap(NoTimestamp);
          this.pendingLanes = NoLanes;
          this.suspendedLanes = NoLanes;
          this.pingedLanes = NoLanes;
          this.expiredLanes = NoLanes;
          this.mutableReadLanes = NoLanes;
          this.finishedLanes = NoLanes;
          this.entangledLanes = NoLanes;
          this.entanglements = createLaneMap(NoLanes);
          {
            this.mutableSourceEagerHydrationData = null;
          }
          {
            this.interactionThreadID = tracing.unstable_getThreadID();
            this.memoizedInteractions = new Set();
            this.pendingInteractionMap = new Map();
          }
          {
            switch (tag) {
              case BlockingRoot:
                this._debugRootType = 'createBlockingRoot()';
                break;

              case ConcurrentRoot:
                this._debugRootType = 'createRoot()';
                break;

              case LegacyRoot:
                this._debugRootType = 'createLegacyRoot()';
                break;
            }
          }
        }

        function createFiberRoot(containerInfo, tag, hydrate, hydrationCallbacks) {
          var root = new FiberRootNode(containerInfo, tag, hydrate); // stateNode is any.

          var uninitializedFiber = createHostRootFiber(tag);
          root.current = uninitializedFiber;
          uninitializedFiber.stateNode = root;
          initializeUpdateQueue(uninitializedFiber);
          return root;
        } // This ensures that the version used for server rendering matches the one
        // that is eventually read during hydration.
        // If they don't match there's a potential tear and a full deopt render is required.


        function registerMutableSourceForHydration(root, mutableSource) {
          var getVersion = mutableSource._getVersion;
          var version = getVersion(mutableSource._source); // TODO Clear this data once all pending hydration work is finished.
          // Retaining it forever may interfere with GC.

          if (root.mutableSourceEagerHydrationData == null) {
            root.mutableSourceEagerHydrationData = [mutableSource, version];
          } else {
            root.mutableSourceEagerHydrationData.push(mutableSource, version);
          }
        }

        function createPortal(children, containerInfo, // TODO: figure out the API for cross-renderer implementation.
        implementation) {
          var key = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
          return {
            // This tag allow us to uniquely identify this as a React Portal
            $$typeof: REACT_PORTAL_TYPE,
            key: key == null ? null : '' + key,
            children: children,
            containerInfo: containerInfo,
            implementation: implementation
          };
        }

        var didWarnAboutNestedUpdates;
        var didWarnAboutFindNodeInStrictMode;
        {
          didWarnAboutNestedUpdates = false;
          didWarnAboutFindNodeInStrictMode = {};
        }

        function getContextForSubtree(parentComponent) {
          if (!parentComponent) {
            return emptyContextObject;
          }

          var fiber = get(parentComponent);
          var parentContext = findCurrentUnmaskedContext(fiber);

          if (fiber.tag === ClassComponent) {
            var Component = fiber.type;

            if (isContextProvider(Component)) {
              return processChildContext(fiber, Component, parentContext);
            }
          }

          return parentContext;
        }

        function findHostInstanceWithWarning(component, methodName) {
          {
            var fiber = get(component);

            if (fiber === undefined) {
              if (typeof component.render === 'function') {
                {
                  {
                    throw Error("Unable to find node on an unmounted component.");
                  }
                }
              } else {
                {
                  {
                    throw Error("Argument appears to not be a ReactComponent. Keys: " + Object.keys(component));
                  }
                }
              }
            }

            var hostFiber = findCurrentHostFiber(fiber);

            if (hostFiber === null) {
              return null;
            }

            if (hostFiber.mode & StrictMode) {
              var componentName = getComponentName(fiber.type) || 'Component';

              if (!didWarnAboutFindNodeInStrictMode[componentName]) {
                didWarnAboutFindNodeInStrictMode[componentName] = true;
                var previousFiber = current;

                try {
                  setCurrentFiber(hostFiber);

                  if (fiber.mode & StrictMode) {
                    error('%s is deprecated in StrictMode. ' + '%s was passed an instance of %s which is inside StrictMode. ' + 'Instead, add a ref directly to the element you want to reference. ' + 'Learn more about using refs safely here: ' + 'https://reactjs.org/link/strict-mode-find-node', methodName, methodName, componentName);
                  } else {
                    error('%s is deprecated in StrictMode. ' + '%s was passed an instance of %s which renders StrictMode children. ' + 'Instead, add a ref directly to the element you want to reference. ' + 'Learn more about using refs safely here: ' + 'https://reactjs.org/link/strict-mode-find-node', methodName, methodName, componentName);
                  }
                } finally {
                  // Ideally this should reset to previous but this shouldn't be called in
                  // render and there's another warning for that anyway.
                  if (previousFiber) {
                    setCurrentFiber(previousFiber);
                  } else {
                    resetCurrentFiber();
                  }
                }
              }
            }

            return hostFiber.stateNode;
          }
        }

        function createContainer(containerInfo, tag, hydrate, hydrationCallbacks) {
          return createFiberRoot(containerInfo, tag, hydrate);
        }

        function updateContainer(element, container, parentComponent, callback) {
          {
            onScheduleRoot(container, element);
          }
          var current$1 = container.current;
          var eventTime = requestEventTime();
          {
            // $FlowExpectedError - jest isn't a global, and isn't recognized outside of tests
            if ('undefined' !== typeof jest) {
              warnIfUnmockedScheduler(current$1);
              warnIfNotScopedWithMatchingAct(current$1);
            }
          }
          var lane = requestUpdateLane(current$1);
          var context = getContextForSubtree(parentComponent);

          if (container.context === null) {
            container.context = context;
          } else {
            container.pendingContext = context;
          }

          {
            if (isRendering && current !== null && !didWarnAboutNestedUpdates) {
              didWarnAboutNestedUpdates = true;
              error('Render methods should be a pure function of props and state; ' + 'triggering nested component updates from render is not allowed. ' + 'If necessary, trigger nested updates in componentDidUpdate.\n\n' + 'Check the render method of %s.', getComponentName(current.type) || 'Unknown');
            }
          }
          var update = createUpdate(eventTime, lane); // Caution: React DevTools currently depends on this property
          // being called "element".

          update.payload = {
            element: element
          };
          callback = callback === undefined ? null : callback;

          if (callback !== null) {
            {
              if (typeof callback !== 'function') {
                error('render(...): Expected the last optional `callback` argument to be a ' + 'function. Instead received: %s.', callback);
              }
            }
            update.callback = callback;
          }

          enqueueUpdate(current$1, update);
          scheduleUpdateOnFiber(current$1, lane, eventTime);
          return lane;
        }

        function getPublicRootInstance(container) {
          var containerFiber = container.current;

          if (!containerFiber.child) {
            return null;
          }

          switch (containerFiber.child.tag) {
            case HostComponent:
              return getPublicInstance(containerFiber.child.stateNode);

            default:
              return containerFiber.child.stateNode;
          }
        }

        function markRetryLaneImpl(fiber, retryLane) {
          var suspenseState = fiber.memoizedState;

          if (suspenseState !== null && suspenseState.dehydrated !== null) {
            suspenseState.retryLane = higherPriorityLane(suspenseState.retryLane, retryLane);
          }
        } // Increases the priority of thennables when they resolve within this boundary.


        function markRetryLaneIfNotHydrated(fiber, retryLane) {
          markRetryLaneImpl(fiber, retryLane);
          var alternate = fiber.alternate;

          if (alternate) {
            markRetryLaneImpl(alternate, retryLane);
          }
        }

        function attemptUserBlockingHydration$1(fiber) {
          if (fiber.tag !== SuspenseComponent) {
            // We ignore HostRoots here because we can't increase
            // their priority and they should not suspend on I/O,
            // since you have to wrap anything that might suspend in
            // Suspense.
            return;
          }

          var eventTime = requestEventTime();
          var lane = InputDiscreteHydrationLane;
          scheduleUpdateOnFiber(fiber, lane, eventTime);
          markRetryLaneIfNotHydrated(fiber, lane);
        }

        function attemptContinuousHydration$1(fiber) {
          if (fiber.tag !== SuspenseComponent) {
            // We ignore HostRoots here because we can't increase
            // their priority and they should not suspend on I/O,
            // since you have to wrap anything that might suspend in
            // Suspense.
            return;
          }

          var eventTime = requestEventTime();
          var lane = SelectiveHydrationLane;
          scheduleUpdateOnFiber(fiber, lane, eventTime);
          markRetryLaneIfNotHydrated(fiber, lane);
        }

        function attemptHydrationAtCurrentPriority$1(fiber) {
          if (fiber.tag !== SuspenseComponent) {
            // We ignore HostRoots here because we can't increase
            // their priority other than synchronously flush it.
            return;
          }

          var eventTime = requestEventTime();
          var lane = requestUpdateLane(fiber);
          scheduleUpdateOnFiber(fiber, lane, eventTime);
          markRetryLaneIfNotHydrated(fiber, lane);
        }

        function runWithPriority$2(priority, fn) {
          try {
            setCurrentUpdateLanePriority(priority);
            return fn();
          } finally {}
        }

        function findHostInstanceWithNoPortals(fiber) {
          var hostFiber = findCurrentHostFiberWithNoPortals(fiber);

          if (hostFiber === null) {
            return null;
          }

          if (hostFiber.tag === FundamentalComponent) {
            return hostFiber.stateNode.instance;
          }

          return hostFiber.stateNode;
        }

        var shouldSuspendImpl = function shouldSuspendImpl(fiber) {
          return false;
        };

        function shouldSuspend(fiber) {
          return shouldSuspendImpl(fiber);
        }

        var overrideHookState = null;
        var overrideHookStateDeletePath = null;
        var overrideHookStateRenamePath = null;
        var overrideProps = null;
        var overridePropsDeletePath = null;
        var overridePropsRenamePath = null;
        var scheduleUpdate = null;
        var setSuspenseHandler = null;
        {
          var copyWithDeleteImpl = function copyWithDeleteImpl(obj, path, index) {
            var key = path[index];
            var updated = Array.isArray(obj) ? obj.slice() : _assign({}, obj);

            if (index + 1 === path.length) {
              if (Array.isArray(updated)) {
                updated.splice(key, 1);
              } else {
                delete updated[key];
              }

              return updated;
            } // $FlowFixMe number or string is fine here


            updated[key] = copyWithDeleteImpl(obj[key], path, index + 1);
            return updated;
          };

          var copyWithDelete = function copyWithDelete(obj, path) {
            return copyWithDeleteImpl(obj, path, 0);
          };

          var copyWithRenameImpl = function copyWithRenameImpl(obj, oldPath, newPath, index) {
            var oldKey = oldPath[index];
            var updated = Array.isArray(obj) ? obj.slice() : _assign({}, obj);

            if (index + 1 === oldPath.length) {
              var newKey = newPath[index]; // $FlowFixMe number or string is fine here

              updated[newKey] = updated[oldKey];

              if (Array.isArray(updated)) {
                updated.splice(oldKey, 1);
              } else {
                delete updated[oldKey];
              }
            } else {
              // $FlowFixMe number or string is fine here
              updated[oldKey] = copyWithRenameImpl( // $FlowFixMe number or string is fine here
              obj[oldKey], oldPath, newPath, index + 1);
            }

            return updated;
          };

          var copyWithRename = function copyWithRename(obj, oldPath, newPath) {
            if (oldPath.length !== newPath.length) {
              warn('copyWithRename() expects paths of the same length');
              return;
            } else {
              for (var i = 0; i < newPath.length - 1; i++) {
                if (oldPath[i] !== newPath[i]) {
                  warn('copyWithRename() expects paths to be the same except for the deepest key');
                  return;
                }
              }
            }

            return copyWithRenameImpl(obj, oldPath, newPath, 0);
          };

          var copyWithSetImpl = function copyWithSetImpl(obj, path, index, value) {
            if (index >= path.length) {
              return value;
            }

            var key = path[index];
            var updated = Array.isArray(obj) ? obj.slice() : _assign({}, obj); // $FlowFixMe number or string is fine here

            updated[key] = copyWithSetImpl(obj[key], path, index + 1, value);
            return updated;
          };

          var copyWithSet = function copyWithSet(obj, path, value) {
            return copyWithSetImpl(obj, path, 0, value);
          };

          var findHook = function findHook(fiber, id) {
            // For now, the "id" of stateful hooks is just the stateful hook index.
            // This may change in the future with e.g. nested hooks.
            var currentHook = fiber.memoizedState;

            while (currentHook !== null && id > 0) {
              currentHook = currentHook.next;
              id--;
            }

            return currentHook;
          }; // Support DevTools editable values for useState and useReducer.


          overrideHookState = function overrideHookState(fiber, id, path, value) {
            var hook = findHook(fiber, id);

            if (hook !== null) {
              var newState = copyWithSet(hook.memoizedState, path, value);
              hook.memoizedState = newState;
              hook.baseState = newState; // We aren't actually adding an update to the queue,
              // because there is no update we can add for useReducer hooks that won't trigger an error.
              // (There's no appropriate action type for DevTools overrides.)
              // As a result though, React will see the scheduled update as a noop and bailout.
              // Shallow cloning props works as a workaround for now to bypass the bailout check.

              fiber.memoizedProps = _assign({}, fiber.memoizedProps);
              scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
            }
          };

          overrideHookStateDeletePath = function overrideHookStateDeletePath(fiber, id, path) {
            var hook = findHook(fiber, id);

            if (hook !== null) {
              var newState = copyWithDelete(hook.memoizedState, path);
              hook.memoizedState = newState;
              hook.baseState = newState; // We aren't actually adding an update to the queue,
              // because there is no update we can add for useReducer hooks that won't trigger an error.
              // (There's no appropriate action type for DevTools overrides.)
              // As a result though, React will see the scheduled update as a noop and bailout.
              // Shallow cloning props works as a workaround for now to bypass the bailout check.

              fiber.memoizedProps = _assign({}, fiber.memoizedProps);
              scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
            }
          };

          overrideHookStateRenamePath = function overrideHookStateRenamePath(fiber, id, oldPath, newPath) {
            var hook = findHook(fiber, id);

            if (hook !== null) {
              var newState = copyWithRename(hook.memoizedState, oldPath, newPath);
              hook.memoizedState = newState;
              hook.baseState = newState; // We aren't actually adding an update to the queue,
              // because there is no update we can add for useReducer hooks that won't trigger an error.
              // (There's no appropriate action type for DevTools overrides.)
              // As a result though, React will see the scheduled update as a noop and bailout.
              // Shallow cloning props works as a workaround for now to bypass the bailout check.

              fiber.memoizedProps = _assign({}, fiber.memoizedProps);
              scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
            }
          }; // Support DevTools props for function components, forwardRef, memo, host components, etc.


          overrideProps = function overrideProps(fiber, path, value) {
            fiber.pendingProps = copyWithSet(fiber.memoizedProps, path, value);

            if (fiber.alternate) {
              fiber.alternate.pendingProps = fiber.pendingProps;
            }

            scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
          };

          overridePropsDeletePath = function overridePropsDeletePath(fiber, path) {
            fiber.pendingProps = copyWithDelete(fiber.memoizedProps, path);

            if (fiber.alternate) {
              fiber.alternate.pendingProps = fiber.pendingProps;
            }

            scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
          };

          overridePropsRenamePath = function overridePropsRenamePath(fiber, oldPath, newPath) {
            fiber.pendingProps = copyWithRename(fiber.memoizedProps, oldPath, newPath);

            if (fiber.alternate) {
              fiber.alternate.pendingProps = fiber.pendingProps;
            }

            scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
          };

          scheduleUpdate = function scheduleUpdate(fiber) {
            scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
          };

          setSuspenseHandler = function setSuspenseHandler(newShouldSuspendImpl) {
            shouldSuspendImpl = newShouldSuspendImpl;
          };
        }

        function findHostInstanceByFiber(fiber) {
          var hostFiber = findCurrentHostFiber(fiber);

          if (hostFiber === null) {
            return null;
          }

          return hostFiber.stateNode;
        }

        function emptyFindFiberByHostInstance(instance) {
          return null;
        }

        function getCurrentFiberForDevTools() {
          return current;
        }

        function injectIntoDevTools(devToolsConfig) {
          var findFiberByHostInstance = devToolsConfig.findFiberByHostInstance;
          var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
          return injectInternals({
            bundleType: devToolsConfig.bundleType,
            version: devToolsConfig.version,
            rendererPackageName: devToolsConfig.rendererPackageName,
            rendererConfig: devToolsConfig.rendererConfig,
            overrideHookState: overrideHookState,
            overrideHookStateDeletePath: overrideHookStateDeletePath,
            overrideHookStateRenamePath: overrideHookStateRenamePath,
            overrideProps: overrideProps,
            overridePropsDeletePath: overridePropsDeletePath,
            overridePropsRenamePath: overridePropsRenamePath,
            setSuspenseHandler: setSuspenseHandler,
            scheduleUpdate: scheduleUpdate,
            currentDispatcherRef: ReactCurrentDispatcher,
            findHostInstanceByFiber: findHostInstanceByFiber,
            findFiberByHostInstance: findFiberByHostInstance || emptyFindFiberByHostInstance,
            // React Refresh
            findHostInstancesForRefresh: findHostInstancesForRefresh,
            scheduleRefresh: scheduleRefresh,
            scheduleRoot: scheduleRoot,
            setRefreshHandler: setRefreshHandler,
            // Enables DevTools to append owner stacks to error messages in DEV mode.
            getCurrentFiber: getCurrentFiberForDevTools
          });
        }

        function ReactDOMRoot(container, options) {
          this._internalRoot = createRootImpl(container, ConcurrentRoot, options);
        }

        function ReactDOMBlockingRoot(container, tag, options) {
          this._internalRoot = createRootImpl(container, tag, options);
        }

        ReactDOMRoot.prototype.render = ReactDOMBlockingRoot.prototype.render = function (children) {
          var root = this._internalRoot;
          {
            if (typeof arguments[1] === 'function') {
              error('render(...): does not support the second callback argument. ' + 'To execute a side effect after rendering, declare it in a component body with useEffect().');
            }

            var container = root.containerInfo;

            if (container.nodeType !== COMMENT_NODE) {
              var hostInstance = findHostInstanceWithNoPortals(root.current);

              if (hostInstance) {
                if (hostInstance.parentNode !== container) {
                  error('render(...): It looks like the React-rendered content of the ' + 'root container was removed without using React. This is not ' + 'supported and will cause errors. Instead, call ' + "root.unmount() to empty a root's container.");
                }
              }
            }
          }
          updateContainer(children, root, null, null);
        };

        ReactDOMRoot.prototype.unmount = ReactDOMBlockingRoot.prototype.unmount = function () {
          {
            if (typeof arguments[0] === 'function') {
              error('unmount(...): does not support a callback argument. ' + 'To execute a side effect after rendering, declare it in a component body with useEffect().');
            }
          }
          var root = this._internalRoot;
          var container = root.containerInfo;
          updateContainer(null, root, null, function () {
            unmarkContainerAsRoot(container);
          });
        };

        function createRootImpl(container, tag, options) {
          // Tag is either LegacyRoot or Concurrent Root
          var hydrate = options != null && options.hydrate === true;
          var hydrationCallbacks = options != null && options.hydrationOptions || null;
          var mutableSources = options != null && options.hydrationOptions != null && options.hydrationOptions.mutableSources || null;
          var root = createContainer(container, tag, hydrate);
          markContainerAsRoot(root.current, container);
          var containerNodeType = container.nodeType;
          {
            var rootContainerElement = container.nodeType === COMMENT_NODE ? container.parentNode : container;
            listenToAllSupportedEvents(rootContainerElement);
          }

          if (mutableSources) {
            for (var i = 0; i < mutableSources.length; i++) {
              var mutableSource = mutableSources[i];
              registerMutableSourceForHydration(root, mutableSource);
            }
          }

          return root;
        }

        function createLegacyRoot(container, options) {
          return new ReactDOMBlockingRoot(container, LegacyRoot, options);
        }

        function isValidContainer(node) {
          return !!(node && (node.nodeType === ELEMENT_NODE || node.nodeType === DOCUMENT_NODE || node.nodeType === DOCUMENT_FRAGMENT_NODE || node.nodeType === COMMENT_NODE && node.nodeValue === ' react-mount-point-unstable '));
        }

        var ReactCurrentOwner$3 = ReactSharedInternals.ReactCurrentOwner;
        var topLevelUpdateWarnings;
        var warnedAboutHydrateAPI = false;
        {
          topLevelUpdateWarnings = function topLevelUpdateWarnings(container) {
            if (container._reactRootContainer && container.nodeType !== COMMENT_NODE) {
              var hostInstance = findHostInstanceWithNoPortals(container._reactRootContainer._internalRoot.current);

              if (hostInstance) {
                if (hostInstance.parentNode !== container) {
                  error('render(...): It looks like the React-rendered content of this ' + 'container was removed without using React. This is not ' + 'supported and will cause errors. Instead, call ' + 'ReactDOM.unmountComponentAtNode to empty a container.');
                }
              }
            }

            var isRootRenderedBySomeReact = !!container._reactRootContainer;
            var rootEl = getReactRootElementInContainer(container);
            var hasNonRootReactChild = !!(rootEl && getInstanceFromNode(rootEl));

            if (hasNonRootReactChild && !isRootRenderedBySomeReact) {
              error('render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.');
            }

            if (container.nodeType === ELEMENT_NODE && container.tagName && container.tagName.toUpperCase() === 'BODY') {
              error('render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.');
            }
          };
        }

        function getReactRootElementInContainer(container) {
          if (!container) {
            return null;
          }

          if (container.nodeType === DOCUMENT_NODE) {
            return container.documentElement;
          } else {
            return container.firstChild;
          }
        }

        function shouldHydrateDueToLegacyHeuristic(container) {
          var rootElement = getReactRootElementInContainer(container);
          return !!(rootElement && rootElement.nodeType === ELEMENT_NODE && rootElement.hasAttribute(ROOT_ATTRIBUTE_NAME));
        }

        function legacyCreateRootFromDOMContainer(container, forceHydrate) {
          var shouldHydrate = forceHydrate || shouldHydrateDueToLegacyHeuristic(container); // First clear any existing content.

          if (!shouldHydrate) {
            var warned = false;
            var rootSibling;

            while (rootSibling = container.lastChild) {
              {
                if (!warned && rootSibling.nodeType === ELEMENT_NODE && rootSibling.hasAttribute(ROOT_ATTRIBUTE_NAME)) {
                  warned = true;
                  error('render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.');
                }
              }
              container.removeChild(rootSibling);
            }
          }

          {
            if (shouldHydrate && !forceHydrate && !warnedAboutHydrateAPI) {
              warnedAboutHydrateAPI = true;
              warn('render(): Calling ReactDOM.render() to hydrate server-rendered markup ' + 'will stop working in React v18. Replace the ReactDOM.render() call ' + 'with ReactDOM.hydrate() if you want React to attach to the server HTML.');
            }
          }
          return createLegacyRoot(container, shouldHydrate ? {
            hydrate: true
          } : undefined);
        }

        function warnOnInvalidCallback$1(callback, callerName) {
          {
            if (callback !== null && typeof callback !== 'function') {
              error('%s(...): Expected the last optional `callback` argument to be a ' + 'function. Instead received: %s.', callerName, callback);
            }
          }
        }

        function legacyRenderSubtreeIntoContainer(parentComponent, children, container, forceHydrate, callback) {
          {
            topLevelUpdateWarnings(container);
            warnOnInvalidCallback$1(callback === undefined ? null : callback, 'render');
          } // TODO: Without `any` type, Flow says "Property cannot be accessed on any
          // member of intersection type." Whyyyyyy.

          var root = container._reactRootContainer;
          var fiberRoot;

          if (!root) {
            // Initial mount
            root = container._reactRootContainer = legacyCreateRootFromDOMContainer(container, forceHydrate);
            fiberRoot = root._internalRoot;

            if (typeof callback === 'function') {
              var originalCallback = callback;

              callback = function callback() {
                var instance = getPublicRootInstance(fiberRoot);
                originalCallback.call(instance);
              };
            } // Initial mount should not be batched.


            unbatchedUpdates(function () {
              updateContainer(children, fiberRoot, parentComponent, callback);
            });
          } else {
            fiberRoot = root._internalRoot;

            if (typeof callback === 'function') {
              var _originalCallback = callback;

              callback = function callback() {
                var instance = getPublicRootInstance(fiberRoot);

                _originalCallback.call(instance);
              };
            } // Update


            updateContainer(children, fiberRoot, parentComponent, callback);
          }

          return getPublicRootInstance(fiberRoot);
        }

        function findDOMNode(componentOrElement) {
          {
            var owner = ReactCurrentOwner$3.current;

            if (owner !== null && owner.stateNode !== null) {
              var warnedAboutRefsInRender = owner.stateNode._warnedAboutRefsInRender;

              if (!warnedAboutRefsInRender) {
                error('%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', getComponentName(owner.type) || 'A component');
              }

              owner.stateNode._warnedAboutRefsInRender = true;
            }
          }

          if (componentOrElement == null) {
            return null;
          }

          if (componentOrElement.nodeType === ELEMENT_NODE) {
            return componentOrElement;
          }

          {
            return findHostInstanceWithWarning(componentOrElement, 'findDOMNode');
          }
        }

        function hydrate(element, container, callback) {
          if (!isValidContainer(container)) {
            {
              throw Error("Target container is not a DOM element.");
            }
          }

          {
            var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;

            if (isModernRoot) {
              error('You are calling ReactDOM.hydrate() on a container that was previously ' + 'passed to ReactDOM.createRoot(). This is not supported. ' + 'Did you mean to call createRoot(container, {hydrate: true}).render(element)?');
            }
          } // TODO: throw or warn if we couldn't hydrate?

          return legacyRenderSubtreeIntoContainer(null, element, container, true, callback);
        }

        function render(element, container, callback) {
          if (!isValidContainer(container)) {
            {
              throw Error("Target container is not a DOM element.");
            }
          }

          {
            var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;

            if (isModernRoot) {
              error('You are calling ReactDOM.render() on a container that was previously ' + 'passed to ReactDOM.createRoot(). This is not supported. ' + 'Did you mean to call root.render(element)?');
            }
          }
          return legacyRenderSubtreeIntoContainer(null, element, container, false, callback);
        }

        function unstable_renderSubtreeIntoContainer(parentComponent, element, containerNode, callback) {
          if (!isValidContainer(containerNode)) {
            {
              throw Error("Target container is not a DOM element.");
            }
          }

          if (!(parentComponent != null && has(parentComponent))) {
            {
              throw Error("parentComponent must be a valid React Component");
            }
          }

          return legacyRenderSubtreeIntoContainer(parentComponent, element, containerNode, false, callback);
        }

        function unmountComponentAtNode(container) {
          if (!isValidContainer(container)) {
            {
              throw Error("unmountComponentAtNode(...): Target container is not a DOM element.");
            }
          }

          {
            var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;

            if (isModernRoot) {
              error('You are calling ReactDOM.unmountComponentAtNode() on a container that was previously ' + 'passed to ReactDOM.createRoot(). This is not supported. Did you mean to call root.unmount()?');
            }
          }

          if (container._reactRootContainer) {
            {
              var rootEl = getReactRootElementInContainer(container);
              var renderedByDifferentReact = rootEl && !getInstanceFromNode(rootEl);

              if (renderedByDifferentReact) {
                error("unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.');
              }
            } // Unmount should not be batched.

            unbatchedUpdates(function () {
              legacyRenderSubtreeIntoContainer(null, null, container, false, function () {
                // $FlowFixMe This should probably use `delete container._reactRootContainer`
                container._reactRootContainer = null;
                unmarkContainerAsRoot(container);
              });
            }); // If you call unmountComponentAtNode twice in quick succession, you'll
            // get `true` twice. That's probably fine?

            return true;
          } else {
            {
              var _rootEl = getReactRootElementInContainer(container);

              var hasNonRootReactChild = !!(_rootEl && getInstanceFromNode(_rootEl)); // Check if the container itself is a React root node.

              var isContainerReactRoot = container.nodeType === ELEMENT_NODE && isValidContainer(container.parentNode) && !!container.parentNode._reactRootContainer;

              if (hasNonRootReactChild) {
                error("unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.');
              }
            }
            return false;
          }
        }

        setAttemptUserBlockingHydration(attemptUserBlockingHydration$1);
        setAttemptContinuousHydration(attemptContinuousHydration$1);
        setAttemptHydrationAtCurrentPriority(attemptHydrationAtCurrentPriority$1);
        setAttemptHydrationAtPriority(runWithPriority$2);
        var didWarnAboutUnstableCreatePortal = false;
        {
          if (typeof Map !== 'function' || // $FlowIssue Flow incorrectly thinks Map has no prototype
          Map.prototype == null || typeof Map.prototype.forEach !== 'function' || typeof Set !== 'function' || // $FlowIssue Flow incorrectly thinks Set has no prototype
          Set.prototype == null || typeof Set.prototype.clear !== 'function' || typeof Set.prototype.forEach !== 'function') {
            error('React depends on Map and Set built-in types. Make sure that you load a ' + 'polyfill in older browsers. https://reactjs.org/link/react-polyfills');
          }
        }
        setRestoreImplementation(restoreControlledState$3);
        setBatchingImplementation(batchedUpdates$1, discreteUpdates$1, flushDiscreteUpdates, batchedEventUpdates$1);

        function createPortal$1(children, container) {
          var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

          if (!isValidContainer(container)) {
            {
              throw Error("Target container is not a DOM element.");
            }
          } // TODO: pass ReactDOM portal implementation as third argument
          // $FlowFixMe The Flow type is opaque but there's no way to actually create it.


          return createPortal(children, container, null, key);
        }

        function renderSubtreeIntoContainer(parentComponent, element, containerNode, callback) {
          return unstable_renderSubtreeIntoContainer(parentComponent, element, containerNode, callback);
        }

        function unstable_createPortal(children, container) {
          var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
          {
            if (!didWarnAboutUnstableCreatePortal) {
              didWarnAboutUnstableCreatePortal = true;
              warn('The ReactDOM.unstable_createPortal() alias has been deprecated, ' + 'and will be removed in React 18+. Update your code to use ' + 'ReactDOM.createPortal() instead. It has the exact same API, ' + 'but without the "unstable_" prefix.');
            }
          }
          return createPortal$1(children, container, key);
        }

        var Internals = {
          // Keep in sync with ReactTestUtils.js, and ReactTestUtilsAct.js.
          // This is an array for better minification.
          Events: [getInstanceFromNode, getNodeFromInstance, getFiberCurrentPropsFromNode, enqueueStateRestore, restoreStateIfNeeded, flushPassiveEffects, // TODO: This is related to `act`, not events. Move to separate key?
          IsThisRendererActing]
        };
        var foundDevTools = injectIntoDevTools({
          findFiberByHostInstance: getClosestInstanceFromNode,
          bundleType: 1,
          version: ReactVersion,
          rendererPackageName: 'react-dom'
        });
        {
          if (!foundDevTools && canUseDOM && window.top === window.self) {
            // If we're in Chrome or Firefox, provide a download link if not installed.
            if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
              var protocol = window.location.protocol; // Don't warn in exotic cases like chrome-extension://.

              if (/^(https?|file):$/.test(protocol)) {
                // eslint-disable-next-line react-internal/no-production-logging
                console.info('%cDownload the React DevTools ' + 'for a better development experience: ' + 'https://reactjs.org/link/react-devtools' + (protocol === 'file:' ? '\nYou might need to use a local HTTP server (instead of file://): ' + 'https://reactjs.org/link/react-devtools-faq' : ''), 'font-weight:bold');
              }
            }
          }
        }
        exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = Internals;
        exports.createPortal = createPortal$1;
        exports.findDOMNode = findDOMNode;
        exports.flushSync = flushSync;
        exports.hydrate = hydrate;
        exports.render = render;
        exports.unmountComponentAtNode = unmountComponentAtNode;
        exports.unstable_batchedUpdates = batchedUpdates$1;
        exports.unstable_createPortal = unstable_createPortal;
        exports.unstable_renderSubtreeIntoContainer = renderSubtreeIntoContainer;
        exports.version = ReactVersion;
      })();
    }
    /* WEBPACK VAR INJECTION */

  }).call(exports, __webpack_require__(25));
  /***/
},
/* 599 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /** @license React v17.0.1
   * react-dom.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  /*
   Modernizr 3.0.0pre (Custom Build) | MIT
  */

  var aa = __webpack_require__(4),
      m = __webpack_require__(172),
      r = __webpack_require__(246);

  function y(a) {
    for (var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++) {
      b += "&args[]=" + encodeURIComponent(arguments[c]);
    }

    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }

  if (!aa) throw Error(y(227));
  var ba = new Set(),
      ca = {};

  function da(a, b) {
    ea(a, b);
    ea(a + "Capture", b);
  }

  function ea(a, b) {
    ca[a] = b;

    for (a = 0; a < b.length; a++) {
      ba.add(b[a]);
    }
  }

  var fa = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement),
      ha = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,
      ia = Object.prototype.hasOwnProperty,
      ja = {},
      ka = {};

  function la(a) {
    if (ia.call(ka, a)) return !0;
    if (ia.call(ja, a)) return !1;
    if (ha.test(a)) return ka[a] = !0;
    ja[a] = !0;
    return !1;
  }

  function ma(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;

    switch (typeof b) {
      case "function":
      case "symbol":
        return !0;

      case "boolean":
        if (d) return !1;
        if (null !== c) return !c.acceptsBooleans;
        a = a.toLowerCase().slice(0, 5);
        return "data-" !== a && "aria-" !== a;

      default:
        return !1;
    }
  }

  function na(a, b, c, d) {
    if (null === b || "undefined" === typeof b || ma(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch (c.type) {
      case 3:
        return !b;

      case 4:
        return !1 === b;

      case 5:
        return isNaN(b);

      case 6:
        return isNaN(b) || 1 > b;
    }
    return !1;
  }

  function B(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
  }

  var D = {};
  "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function (a) {
    D[a] = new B(a, 0, !1, a, null, !1, !1);
  });
  [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function (a) {
    var b = a[0];
    D[b] = new B(b, 1, !1, a[1], null, !1, !1);
  });
  ["contentEditable", "draggable", "spellCheck", "value"].forEach(function (a) {
    D[a] = new B(a, 2, !1, a.toLowerCase(), null, !1, !1);
  });
  ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function (a) {
    D[a] = new B(a, 2, !1, a, null, !1, !1);
  });
  "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function (a) {
    D[a] = new B(a, 3, !1, a.toLowerCase(), null, !1, !1);
  });
  ["checked", "multiple", "muted", "selected"].forEach(function (a) {
    D[a] = new B(a, 3, !0, a, null, !1, !1);
  });
  ["capture", "download"].forEach(function (a) {
    D[a] = new B(a, 4, !1, a, null, !1, !1);
  });
  ["cols", "rows", "size", "span"].forEach(function (a) {
    D[a] = new B(a, 6, !1, a, null, !1, !1);
  });
  ["rowSpan", "start"].forEach(function (a) {
    D[a] = new B(a, 5, !1, a.toLowerCase(), null, !1, !1);
  });
  var oa = /[\-:]([a-z])/g;

  function pa(a) {
    return a[1].toUpperCase();
  }

  "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function (a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, null, !1, !1);
  });
  "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function (a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
  });
  ["xml:base", "xml:lang", "xml:space"].forEach(function (a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
  });
  ["tabIndex", "crossOrigin"].forEach(function (a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !1, !1);
  });
  D.xlinkHref = new B("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
  ["src", "href", "action", "formAction"].forEach(function (a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !0, !0);
  });

  function qa(a, b, c, d) {
    var e = D.hasOwnProperty(b) ? D[b] : null;
    var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;
    f || (na(b, c, e, d) && (c = null), d || null === e ? la(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
  }

  var ra = aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,
      sa = 60103,
      ta = 60106,
      ua = 60107,
      wa = 60108,
      xa = 60114,
      ya = 60109,
      za = 60110,
      Aa = 60112,
      Ba = 60113,
      Ca = 60120,
      Da = 60115,
      Ea = 60116,
      Fa = 60121,
      Ga = 60128,
      Ha = 60129,
      Ia = 60130,
      Ja = 60131;

  if ("function" === typeof Symbol && Symbol.for) {
    var E = Symbol.for;
    sa = E("react.element");
    ta = E("react.portal");
    ua = E("react.fragment");
    wa = E("react.strict_mode");
    xa = E("react.profiler");
    ya = E("react.provider");
    za = E("react.context");
    Aa = E("react.forward_ref");
    Ba = E("react.suspense");
    Ca = E("react.suspense_list");
    Da = E("react.memo");
    Ea = E("react.lazy");
    Fa = E("react.block");
    E("react.scope");
    Ga = E("react.opaque.id");
    Ha = E("react.debug_trace_mode");
    Ia = E("react.offscreen");
    Ja = E("react.legacy_hidden");
  }

  var Ka = "function" === typeof Symbol && Symbol.iterator;

  function La(a) {
    if (null === a || "object" !== typeof a) return null;
    a = Ka && a[Ka] || a["@@iterator"];
    return "function" === typeof a ? a : null;
  }

  var Ma;

  function Na(a) {
    if (void 0 === Ma) try {
      throw Error();
    } catch (c) {
      var b = c.stack.trim().match(/\n( *(at )?)/);
      Ma = b && b[1] || "";
    }
    return "\n" + Ma + a;
  }

  var Oa = !1;

  function Pa(a, b) {
    if (!a || Oa) return "";
    Oa = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;

    try {
      if (b) {
        if (b = function b() {
          throw Error();
        }, Object.defineProperty(b.prototype, "props", {
          set: function set() {
            throw Error();
          }
        }), "object" === typeof Reflect && Reflect.construct) {
          try {
            Reflect.construct(b, []);
          } catch (k) {
            var d = k;
          }

          Reflect.construct(a, [], b);
        } else {
          try {
            b.call();
          } catch (k) {
            d = k;
          }

          a.call(b.prototype);
        }
      } else {
        try {
          throw Error();
        } catch (k) {
          d = k;
        }

        a();
      }
    } catch (k) {
      if (k && d && "string" === typeof k.stack) {
        for (var e = k.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];) {
          h--;
        }

        for (; 1 <= g && 0 <= h; g--, h--) {
          if (e[g] !== f[h]) {
            if (1 !== g || 1 !== h) {
              do {
                if (g--, h--, 0 > h || e[g] !== f[h]) return "\n" + e[g].replace(" at new ", " at ");
              } while (1 <= g && 0 <= h);
            }

            break;
          }
        }
      }
    } finally {
      Oa = !1, Error.prepareStackTrace = c;
    }

    return (a = a ? a.displayName || a.name : "") ? Na(a) : "";
  }

  function Qa(a) {
    switch (a.tag) {
      case 5:
        return Na(a.type);

      case 16:
        return Na("Lazy");

      case 13:
        return Na("Suspense");

      case 19:
        return Na("SuspenseList");

      case 0:
      case 2:
      case 15:
        return a = Pa(a.type, !1), a;

      case 11:
        return a = Pa(a.type.render, !1), a;

      case 22:
        return a = Pa(a.type._render, !1), a;

      case 1:
        return a = Pa(a.type, !0), a;

      default:
        return "";
    }
  }

  function Ra(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;

    switch (a) {
      case ua:
        return "Fragment";

      case ta:
        return "Portal";

      case xa:
        return "Profiler";

      case wa:
        return "StrictMode";

      case Ba:
        return "Suspense";

      case Ca:
        return "SuspenseList";
    }

    if ("object" === typeof a) switch (a.$$typeof) {
      case za:
        return (a.displayName || "Context") + ".Consumer";

      case ya:
        return (a._context.displayName || "Context") + ".Provider";

      case Aa:
        var b = a.render;
        b = b.displayName || b.name || "";
        return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");

      case Da:
        return Ra(a.type);

      case Fa:
        return Ra(a._render);

      case Ea:
        b = a._payload;
        a = a._init;

        try {
          return Ra(a(b));
        } catch (c) {}

    }
    return null;
  }

  function Sa(a) {
    switch (typeof a) {
      case "boolean":
      case "number":
      case "object":
      case "string":
      case "undefined":
        return a;

      default:
        return "";
    }
  }

  function Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
  }

  function Ua(a) {
    var b = Ta(a) ? "checked" : "value",
        c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b),
        d = "" + a[b];

    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
      var e = c.get,
          f = c.set;
      Object.defineProperty(a, b, {
        configurable: !0,
        get: function get() {
          return e.call(this);
        },
        set: function set(a) {
          d = "" + a;
          f.call(this, a);
        }
      });
      Object.defineProperty(a, b, {
        enumerable: c.enumerable
      });
      return {
        getValue: function getValue() {
          return d;
        },
        setValue: function setValue(a) {
          d = "" + a;
        },
        stopTracking: function stopTracking() {
          a._valueTracker = null;
          delete a[b];
        }
      };
    }
  }

  function Va(a) {
    a._valueTracker || (a._valueTracker = Ua(a));
  }

  function Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
  }

  function Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;

    try {
      return a.activeElement || a.body;
    } catch (b) {
      return a.body;
    }
  }

  function Ya(a, b) {
    var c = b.checked;
    return m({}, b, {
      defaultChecked: void 0,
      defaultValue: void 0,
      value: void 0,
      checked: null != c ? c : a._wrapperState.initialChecked
    });
  }

  function Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue,
        d = null != b.checked ? b.checked : b.defaultChecked;
    c = Sa(null != b.value ? b.value : c);
    a._wrapperState = {
      initialChecked: d,
      initialValue: c,
      controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
  }

  function $a(a, b) {
    b = b.checked;
    null != b && qa(a, "checked", b, !1);
  }

  function ab(a, b) {
    $a(a, b);
    var c = Sa(b.value),
        d = b.type;
    if (null != c) {
      if ("number" === d) {
        if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
      } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
      a.removeAttribute("value");
      return;
    }
    b.hasOwnProperty("value") ? bb(a, b.type, c) : b.hasOwnProperty("defaultValue") && bb(a, b.type, Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
  }

  function cb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
      var d = b.type;
      if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
      b = "" + a._wrapperState.initialValue;
      c || b === a.value || (a.value = b);
      a.defaultValue = b;
    }

    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
  }

  function bb(a, b, c) {
    if ("number" !== b || Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
  }

  function db(a) {
    var b = "";
    aa.Children.forEach(a, function (a) {
      null != a && (b += a);
    });
    return b;
  }

  function eb(a, b) {
    a = m({
      children: void 0
    }, b);
    if (b = db(b.children)) a.children = b;
    return a;
  }

  function fb(a, b, c, d) {
    a = a.options;

    if (b) {
      b = {};

      for (var e = 0; e < c.length; e++) {
        b["$" + c[e]] = !0;
      }

      for (c = 0; c < a.length; c++) {
        e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
      }
    } else {
      c = "" + Sa(c);
      b = null;

      for (e = 0; e < a.length; e++) {
        if (a[e].value === c) {
          a[e].selected = !0;
          d && (a[e].defaultSelected = !0);
          return;
        }

        null !== b || a[e].disabled || (b = a[e]);
      }

      null !== b && (b.selected = !0);
    }
  }

  function gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(y(91));
    return m({}, b, {
      value: void 0,
      defaultValue: void 0,
      children: "" + a._wrapperState.initialValue
    });
  }

  function hb(a, b) {
    var c = b.value;

    if (null == c) {
      c = b.children;
      b = b.defaultValue;

      if (null != c) {
        if (null != b) throw Error(y(92));

        if (Array.isArray(c)) {
          if (!(1 >= c.length)) throw Error(y(93));
          c = c[0];
        }

        b = c;
      }

      null == b && (b = "");
      c = b;
    }

    a._wrapperState = {
      initialValue: Sa(c)
    };
  }

  function ib(a, b) {
    var c = Sa(b.value),
        d = Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
  }

  function jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
  }

  var kb = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
  };

  function lb(a) {
    switch (a) {
      case "svg":
        return "http://www.w3.org/2000/svg";

      case "math":
        return "http://www.w3.org/1998/Math/MathML";

      default:
        return "http://www.w3.org/1999/xhtml";
    }
  }

  function mb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? lb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
  }

  var nb,
      ob = function (a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function (b, c, d, e) {
      MSApp.execUnsafeLocalFunction(function () {
        return a(b, c, d, e);
      });
    } : a;
  }(function (a, b) {
    if (a.namespaceURI !== kb.svg || "innerHTML" in a) a.innerHTML = b;else {
      nb = nb || document.createElement("div");
      nb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";

      for (b = nb.firstChild; a.firstChild;) {
        a.removeChild(a.firstChild);
      }

      for (; b.firstChild;) {
        a.appendChild(b.firstChild);
      }
    }
  });

  function pb(a, b) {
    if (b) {
      var c = a.firstChild;

      if (c && c === a.lastChild && 3 === c.nodeType) {
        c.nodeValue = b;
        return;
      }
    }

    a.textContent = b;
  }

  var qb = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
  },
      rb = ["Webkit", "ms", "Moz", "O"];
  Object.keys(qb).forEach(function (a) {
    rb.forEach(function (b) {
      b = b + a.charAt(0).toUpperCase() + a.substring(1);
      qb[b] = qb[a];
    });
  });

  function sb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || qb.hasOwnProperty(a) && qb[a] ? ("" + b).trim() : b + "px";
  }

  function tb(a, b) {
    a = a.style;

    for (var c in b) {
      if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"),
            e = sb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
      }
    }
  }

  var ub = m({
    menuitem: !0
  }, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
  });

  function vb(a, b) {
    if (b) {
      if (ub[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(y(137, a));

      if (null != b.dangerouslySetInnerHTML) {
        if (null != b.children) throw Error(y(60));
        if (!("object" === typeof b.dangerouslySetInnerHTML && "__html" in b.dangerouslySetInnerHTML)) throw Error(y(61));
      }

      if (null != b.style && "object" !== typeof b.style) throw Error(y(62));
    }
  }

  function wb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;

    switch (a) {
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return !1;

      default:
        return !0;
    }
  }

  function xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
  }

  var yb = null,
      zb = null,
      Ab = null;

  function Bb(a) {
    if (a = Cb(a)) {
      if ("function" !== typeof yb) throw Error(y(280));
      var b = a.stateNode;
      b && (b = Db(b), yb(a.stateNode, a.type, b));
    }
  }

  function Eb(a) {
    zb ? Ab ? Ab.push(a) : Ab = [a] : zb = a;
  }

  function Fb() {
    if (zb) {
      var a = zb,
          b = Ab;
      Ab = zb = null;
      Bb(a);
      if (b) for (a = 0; a < b.length; a++) {
        Bb(b[a]);
      }
    }
  }

  function Gb(a, b) {
    return a(b);
  }

  function Hb(a, b, c, d, e) {
    return a(b, c, d, e);
  }

  function Ib() {}

  var Jb = Gb,
      Kb = !1,
      Lb = !1;

  function Mb() {
    if (null !== zb || null !== Ab) Ib(), Fb();
  }

  function Nb(a, b, c) {
    if (Lb) return a(b, c);
    Lb = !0;

    try {
      return Jb(a, b, c);
    } finally {
      Lb = !1, Mb();
    }
  }

  function Ob(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = Db(c);
    if (null === d) return null;
    c = d[b];

    a: switch (b) {
      case "onClick":
      case "onClickCapture":
      case "onDoubleClick":
      case "onDoubleClickCapture":
      case "onMouseDown":
      case "onMouseDownCapture":
      case "onMouseMove":
      case "onMouseMoveCapture":
      case "onMouseUp":
      case "onMouseUpCapture":
      case "onMouseEnter":
        (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
        a = !d;
        break a;

      default:
        a = !1;
    }

    if (a) return null;
    if (c && "function" !== typeof c) throw Error(y(231, b, typeof c));
    return c;
  }

  var Pb = !1;
  if (fa) try {
    var Qb = {};
    Object.defineProperty(Qb, "passive", {
      get: function get() {
        Pb = !0;
      }
    });
    window.addEventListener("test", Qb, Qb);
    window.removeEventListener("test", Qb, Qb);
  } catch (a) {
    Pb = !1;
  }

  function Rb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);

    try {
      b.apply(c, l);
    } catch (n) {
      this.onError(n);
    }
  }

  var Sb = !1,
      Tb = null,
      Ub = !1,
      Vb = null,
      Wb = {
    onError: function onError(a) {
      Sb = !0;
      Tb = a;
    }
  };

  function Xb(a, b, c, d, e, f, g, h, k) {
    Sb = !1;
    Tb = null;
    Rb.apply(Wb, arguments);
  }

  function Yb(a, b, c, d, e, f, g, h, k) {
    Xb.apply(this, arguments);

    if (Sb) {
      if (Sb) {
        var l = Tb;
        Sb = !1;
        Tb = null;
      } else throw Error(y(198));

      Ub || (Ub = !0, Vb = l);
    }
  }

  function Zb(a) {
    var b = a,
        c = a;
    if (a.alternate) for (; b.return;) {
      b = b.return;
    } else {
      a = b;

      do {
        b = a, 0 !== (b.flags & 1026) && (c = b.return), a = b.return;
      } while (a);
    }
    return 3 === b.tag ? c : null;
  }

  function $b(a) {
    if (13 === a.tag) {
      var b = a.memoizedState;
      null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
      if (null !== b) return b.dehydrated;
    }

    return null;
  }

  function ac(a) {
    if (Zb(a) !== a) throw Error(y(188));
  }

  function bc(a) {
    var b = a.alternate;

    if (!b) {
      b = Zb(a);
      if (null === b) throw Error(y(188));
      return b !== a ? null : a;
    }

    for (var c = a, d = b;;) {
      var e = c.return;
      if (null === e) break;
      var f = e.alternate;

      if (null === f) {
        d = e.return;

        if (null !== d) {
          c = d;
          continue;
        }

        break;
      }

      if (e.child === f.child) {
        for (f = e.child; f;) {
          if (f === c) return ac(e), a;
          if (f === d) return ac(e), b;
          f = f.sibling;
        }

        throw Error(y(188));
      }

      if (c.return !== d.return) c = e, d = f;else {
        for (var g = !1, h = e.child; h;) {
          if (h === c) {
            g = !0;
            c = e;
            d = f;
            break;
          }

          if (h === d) {
            g = !0;
            d = e;
            c = f;
            break;
          }

          h = h.sibling;
        }

        if (!g) {
          for (h = f.child; h;) {
            if (h === c) {
              g = !0;
              c = f;
              d = e;
              break;
            }

            if (h === d) {
              g = !0;
              d = f;
              c = e;
              break;
            }

            h = h.sibling;
          }

          if (!g) throw Error(y(189));
        }
      }
      if (c.alternate !== d) throw Error(y(190));
    }

    if (3 !== c.tag) throw Error(y(188));
    return c.stateNode.current === c ? a : b;
  }

  function cc(a) {
    a = bc(a);
    if (!a) return null;

    for (var b = a;;) {
      if (5 === b.tag || 6 === b.tag) return b;
      if (b.child) b.child.return = b, b = b.child;else {
        if (b === a) break;

        for (; !b.sibling;) {
          if (!b.return || b.return === a) return null;
          b = b.return;
        }

        b.sibling.return = b.return;
        b = b.sibling;
      }
    }

    return null;
  }

  function dc(a, b) {
    for (var c = a.alternate; null !== b;) {
      if (b === a || b === c) return !0;
      b = b.return;
    }

    return !1;
  }

  var ec,
      fc,
      gc,
      hc,
      ic = !1,
      jc = [],
      kc = null,
      lc = null,
      mc = null,
      nc = new Map(),
      oc = new Map(),
      pc = [],
      qc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");

  function rc(a, b, c, d, e) {
    return {
      blockedOn: a,
      domEventName: b,
      eventSystemFlags: c | 16,
      nativeEvent: e,
      targetContainers: [d]
    };
  }

  function sc(a, b) {
    switch (a) {
      case "focusin":
      case "focusout":
        kc = null;
        break;

      case "dragenter":
      case "dragleave":
        lc = null;
        break;

      case "mouseover":
      case "mouseout":
        mc = null;
        break;

      case "pointerover":
      case "pointerout":
        nc.delete(b.pointerId);
        break;

      case "gotpointercapture":
      case "lostpointercapture":
        oc.delete(b.pointerId);
    }
  }

  function tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = rc(b, c, d, e, f), null !== b && (b = Cb(b), null !== b && fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
  }

  function uc(a, b, c, d, e) {
    switch (b) {
      case "focusin":
        return kc = tc(kc, a, b, c, d, e), !0;

      case "dragenter":
        return lc = tc(lc, a, b, c, d, e), !0;

      case "mouseover":
        return mc = tc(mc, a, b, c, d, e), !0;

      case "pointerover":
        var f = e.pointerId;
        nc.set(f, tc(nc.get(f) || null, a, b, c, d, e));
        return !0;

      case "gotpointercapture":
        return f = e.pointerId, oc.set(f, tc(oc.get(f) || null, a, b, c, d, e)), !0;
    }

    return !1;
  }

  function vc(a) {
    var b = wc(a.target);

    if (null !== b) {
      var c = Zb(b);
      if (null !== c) if (b = c.tag, 13 === b) {
        if (b = $b(c), null !== b) {
          a.blockedOn = b;
          hc(a.lanePriority, function () {
            r.unstable_runWithPriority(a.priority, function () {
              gc(c);
            });
          });
          return;
        }
      } else if (3 === b && c.stateNode.hydrate) {
        a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
        return;
      }
    }

    a.blockedOn = null;
  }

  function xc(a) {
    if (null !== a.blockedOn) return !1;

    for (var b = a.targetContainers; 0 < b.length;) {
      var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
      if (null !== c) return b = Cb(c), null !== b && fc(b), a.blockedOn = c, !1;
      b.shift();
    }

    return !0;
  }

  function zc(a, b, c) {
    xc(a) && c.delete(b);
  }

  function Ac() {
    for (ic = !1; 0 < jc.length;) {
      var a = jc[0];

      if (null !== a.blockedOn) {
        a = Cb(a.blockedOn);
        null !== a && ec(a);
        break;
      }

      for (var b = a.targetContainers; 0 < b.length;) {
        var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);

        if (null !== c) {
          a.blockedOn = c;
          break;
        }

        b.shift();
      }

      null === a.blockedOn && jc.shift();
    }

    null !== kc && xc(kc) && (kc = null);
    null !== lc && xc(lc) && (lc = null);
    null !== mc && xc(mc) && (mc = null);
    nc.forEach(zc);
    oc.forEach(zc);
  }

  function Bc(a, b) {
    a.blockedOn === b && (a.blockedOn = null, ic || (ic = !0, r.unstable_scheduleCallback(r.unstable_NormalPriority, Ac)));
  }

  function Cc(a) {
    function b(b) {
      return Bc(b, a);
    }

    if (0 < jc.length) {
      Bc(jc[0], a);

      for (var c = 1; c < jc.length; c++) {
        var d = jc[c];
        d.blockedOn === a && (d.blockedOn = null);
      }
    }

    null !== kc && Bc(kc, a);
    null !== lc && Bc(lc, a);
    null !== mc && Bc(mc, a);
    nc.forEach(b);
    oc.forEach(b);

    for (c = 0; c < pc.length; c++) {
      d = pc[c], d.blockedOn === a && (d.blockedOn = null);
    }

    for (; 0 < pc.length && (c = pc[0], null === c.blockedOn);) {
      vc(c), null === c.blockedOn && pc.shift();
    }
  }

  function Dc(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
  }

  var Ec = {
    animationend: Dc("Animation", "AnimationEnd"),
    animationiteration: Dc("Animation", "AnimationIteration"),
    animationstart: Dc("Animation", "AnimationStart"),
    transitionend: Dc("Transition", "TransitionEnd")
  },
      Fc = {},
      Gc = {};
  fa && (Gc = document.createElement("div").style, "AnimationEvent" in window || (delete Ec.animationend.animation, delete Ec.animationiteration.animation, delete Ec.animationstart.animation), "TransitionEvent" in window || delete Ec.transitionend.transition);

  function Hc(a) {
    if (Fc[a]) return Fc[a];
    if (!Ec[a]) return a;
    var b = Ec[a],
        c;

    for (c in b) {
      if (b.hasOwnProperty(c) && c in Gc) return Fc[a] = b[c];
    }

    return a;
  }

  var Ic = Hc("animationend"),
      Jc = Hc("animationiteration"),
      Kc = Hc("animationstart"),
      Lc = Hc("transitionend"),
      Mc = new Map(),
      Nc = new Map(),
      Oc = ["abort", "abort", Ic, "animationEnd", Jc, "animationIteration", Kc, "animationStart", "canplay", "canPlay", "canplaythrough", "canPlayThrough", "durationchange", "durationChange", "emptied", "emptied", "encrypted", "encrypted", "ended", "ended", "error", "error", "gotpointercapture", "gotPointerCapture", "load", "load", "loadeddata", "loadedData", "loadedmetadata", "loadedMetadata", "loadstart", "loadStart", "lostpointercapture", "lostPointerCapture", "playing", "playing", "progress", "progress", "seeking", "seeking", "stalled", "stalled", "suspend", "suspend", "timeupdate", "timeUpdate", Lc, "transitionEnd", "waiting", "waiting"];

  function Pc(a, b) {
    for (var c = 0; c < a.length; c += 2) {
      var d = a[c],
          e = a[c + 1];
      e = "on" + (e[0].toUpperCase() + e.slice(1));
      Nc.set(d, b);
      Mc.set(d, e);
      da(e, [d]);
    }
  }

  var Qc = r.unstable_now;
  Qc();
  var F = 8;

  function Rc(a) {
    if (0 !== (1 & a)) return F = 15, 1;
    if (0 !== (2 & a)) return F = 14, 2;
    if (0 !== (4 & a)) return F = 13, 4;
    var b = 24 & a;
    if (0 !== b) return F = 12, b;
    if (0 !== (a & 32)) return F = 11, 32;
    b = 192 & a;
    if (0 !== b) return F = 10, b;
    if (0 !== (a & 256)) return F = 9, 256;
    b = 3584 & a;
    if (0 !== b) return F = 8, b;
    if (0 !== (a & 4096)) return F = 7, 4096;
    b = 4186112 & a;
    if (0 !== b) return F = 6, b;
    b = 62914560 & a;
    if (0 !== b) return F = 5, b;
    if (a & 67108864) return F = 4, 67108864;
    if (0 !== (a & 134217728)) return F = 3, 134217728;
    b = 805306368 & a;
    if (0 !== b) return F = 2, b;
    if (0 !== (1073741824 & a)) return F = 1, 1073741824;
    F = 8;
    return a;
  }

  function Sc(a) {
    switch (a) {
      case 99:
        return 15;

      case 98:
        return 10;

      case 97:
      case 96:
        return 8;

      case 95:
        return 2;

      default:
        return 0;
    }
  }

  function Tc(a) {
    switch (a) {
      case 15:
      case 14:
        return 99;

      case 13:
      case 12:
      case 11:
      case 10:
        return 98;

      case 9:
      case 8:
      case 7:
      case 6:
      case 4:
      case 5:
        return 97;

      case 3:
      case 2:
      case 1:
        return 95;

      case 0:
        return 90;

      default:
        throw Error(y(358, a));
    }
  }

  function Uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return F = 0;
    var d = 0,
        e = 0,
        f = a.expiredLanes,
        g = a.suspendedLanes,
        h = a.pingedLanes;
    if (0 !== f) d = f, e = F = 15;else if (f = c & 134217727, 0 !== f) {
      var k = f & ~g;
      0 !== k ? (d = Rc(k), e = F) : (h &= f, 0 !== h && (d = Rc(h), e = F));
    } else f = c & ~g, 0 !== f ? (d = Rc(f), e = F) : 0 !== h && (d = Rc(h), e = F);
    if (0 === d) return 0;
    d = 31 - Vc(d);
    d = c & ((0 > d ? 0 : 1 << d) << 1) - 1;

    if (0 !== b && b !== d && 0 === (b & g)) {
      Rc(b);
      if (e <= F) return b;
      F = e;
    }

    b = a.entangledLanes;
    if (0 !== b) for (a = a.entanglements, b &= d; 0 < b;) {
      c = 31 - Vc(b), e = 1 << c, d |= a[c], b &= ~e;
    }
    return d;
  }

  function Wc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
  }

  function Xc(a, b) {
    switch (a) {
      case 15:
        return 1;

      case 14:
        return 2;

      case 12:
        return a = Yc(24 & ~b), 0 === a ? Xc(10, b) : a;

      case 10:
        return a = Yc(192 & ~b), 0 === a ? Xc(8, b) : a;

      case 8:
        return a = Yc(3584 & ~b), 0 === a && (a = Yc(4186112 & ~b), 0 === a && (a = 512)), a;

      case 2:
        return b = Yc(805306368 & ~b), 0 === b && (b = 268435456), b;
    }

    throw Error(y(358, a));
  }

  function Yc(a) {
    return a & -a;
  }

  function Zc(a) {
    for (var b = [], c = 0; 31 > c; c++) {
      b.push(a);
    }

    return b;
  }

  function $c(a, b, c) {
    a.pendingLanes |= b;
    var d = b - 1;
    a.suspendedLanes &= d;
    a.pingedLanes &= d;
    a = a.eventTimes;
    b = 31 - Vc(b);
    a[b] = c;
  }

  var Vc = Math.clz32 ? Math.clz32 : ad,
      bd = Math.log,
      cd = Math.LN2;

  function ad(a) {
    return 0 === a ? 32 : 31 - (bd(a) / cd | 0) | 0;
  }

  var dd = r.unstable_UserBlockingPriority,
      ed = r.unstable_runWithPriority,
      fd = !0;

  function gd(a, b, c, d) {
    Kb || Ib();
    var e = hd,
        f = Kb;
    Kb = !0;

    try {
      Hb(e, a, b, c, d);
    } finally {
      (Kb = f) || Mb();
    }
  }

  function id(a, b, c, d) {
    ed(dd, hd.bind(null, a, b, c, d));
  }

  function hd(a, b, c, d) {
    if (fd) {
      var e;
      if ((e = 0 === (b & 4)) && 0 < jc.length && -1 < qc.indexOf(a)) a = rc(null, a, b, c, d), jc.push(a);else {
        var f = yc(a, b, c, d);
        if (null === f) e && sc(a, d);else {
          if (e) {
            if (-1 < qc.indexOf(a)) {
              a = rc(f, a, b, c, d);
              jc.push(a);
              return;
            }

            if (uc(f, a, b, c, d)) return;
            sc(a, d);
          }

          jd(a, b, d, null, c);
        }
      }
    }
  }

  function yc(a, b, c, d) {
    var e = xb(d);
    e = wc(e);

    if (null !== e) {
      var f = Zb(e);
      if (null === f) e = null;else {
        var g = f.tag;

        if (13 === g) {
          e = $b(f);
          if (null !== e) return e;
          e = null;
        } else if (3 === g) {
          if (f.stateNode.hydrate) return 3 === f.tag ? f.stateNode.containerInfo : null;
          e = null;
        } else f !== e && (e = null);
      }
    }

    jd(a, b, d, e, c);
    return null;
  }

  var kd = null,
      ld = null,
      md = null;

  function nd() {
    if (md) return md;
    var a,
        b = ld,
        c = b.length,
        d,
        e = "value" in kd ? kd.value : kd.textContent,
        f = e.length;

    for (a = 0; a < c && b[a] === e[a]; a++) {
      ;
    }

    var g = c - a;

    for (d = 1; d <= g && b[c - d] === e[f - d]; d++) {
      ;
    }

    return md = e.slice(a, 1 < d ? 1 - d : void 0);
  }

  function od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
  }

  function pd() {
    return !0;
  }

  function qd() {
    return !1;
  }

  function rd(a) {
    function b(b, d, e, f, g) {
      this._reactName = b;
      this._targetInst = e;
      this.type = d;
      this.nativeEvent = f;
      this.target = g;
      this.currentTarget = null;

      for (var c in a) {
        a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
      }

      this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? pd : qd;
      this.isPropagationStopped = qd;
      return this;
    }

    m(b.prototype, {
      preventDefault: function preventDefault() {
        this.defaultPrevented = !0;
        var a = this.nativeEvent;
        a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = pd);
      },
      stopPropagation: function stopPropagation() {
        var a = this.nativeEvent;
        a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = pd);
      },
      persist: function persist() {},
      isPersistent: pd
    });
    return b;
  }

  var sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function timeStamp(a) {
      return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
  },
      td = rd(sd),
      ud = m({}, sd, {
    view: 0,
    detail: 0
  }),
      vd = rd(ud),
      wd,
      xd,
      yd,
      Ad = m({}, ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: zd,
    button: 0,
    buttons: 0,
    relatedTarget: function relatedTarget(a) {
      return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function movementX(a) {
      if ("movementX" in a) return a.movementX;
      a !== yd && (yd && "mousemove" === a.type ? (wd = a.screenX - yd.screenX, xd = a.screenY - yd.screenY) : xd = wd = 0, yd = a);
      return wd;
    },
    movementY: function movementY(a) {
      return "movementY" in a ? a.movementY : xd;
    }
  }),
      Bd = rd(Ad),
      Cd = m({}, Ad, {
    dataTransfer: 0
  }),
      Dd = rd(Cd),
      Ed = m({}, ud, {
    relatedTarget: 0
  }),
      Fd = rd(Ed),
      Gd = m({}, sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
  }),
      Hd = rd(Gd),
      Id = m({}, sd, {
    clipboardData: function clipboardData(a) {
      return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
  }),
      Jd = rd(Id),
      Kd = m({}, sd, {
    data: 0
  }),
      Ld = rd(Kd),
      Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
  },
      Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
  },
      Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
  };

  function Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Od[a]) ? !!b[a] : !1;
  }

  function zd() {
    return Pd;
  }

  var Qd = m({}, ud, {
    key: function key(a) {
      if (a.key) {
        var b = Md[a.key] || a.key;
        if ("Unidentified" !== b) return b;
      }

      return "keypress" === a.type ? (a = od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: zd,
    charCode: function charCode(a) {
      return "keypress" === a.type ? od(a) : 0;
    },
    keyCode: function keyCode(a) {
      return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function which(a) {
      return "keypress" === a.type ? od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
  }),
      Rd = rd(Qd),
      Sd = m({}, Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
  }),
      Td = rd(Sd),
      Ud = m({}, ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: zd
  }),
      Vd = rd(Ud),
      Wd = m({}, sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
  }),
      Xd = rd(Wd),
      Yd = m({}, Ad, {
    deltaX: function deltaX(a) {
      return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function deltaY(a) {
      return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
  }),
      Zd = rd(Yd),
      $d = [9, 13, 27, 32],
      ae = fa && "CompositionEvent" in window,
      be = null;
  fa && "documentMode" in document && (be = document.documentMode);
  var ce = fa && "TextEvent" in window && !be,
      de = fa && (!ae || be && 8 < be && 11 >= be),
      ee = String.fromCharCode(32),
      fe = !1;

  function ge(a, b) {
    switch (a) {
      case "keyup":
        return -1 !== $d.indexOf(b.keyCode);

      case "keydown":
        return 229 !== b.keyCode;

      case "keypress":
      case "mousedown":
      case "focusout":
        return !0;

      default:
        return !1;
    }
  }

  function he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
  }

  var ie = !1;

  function je(a, b) {
    switch (a) {
      case "compositionend":
        return he(b);

      case "keypress":
        if (32 !== b.which) return null;
        fe = !0;
        return ee;

      case "textInput":
        return a = b.data, a === ee && fe ? null : a;

      default:
        return null;
    }
  }

  function ke(a, b) {
    if (ie) return "compositionend" === a || !ae && ge(a, b) ? (a = nd(), md = ld = kd = null, ie = !1, a) : null;

    switch (a) {
      case "paste":
        return null;

      case "keypress":
        if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
          if (b.char && 1 < b.char.length) return b.char;
          if (b.which) return String.fromCharCode(b.which);
        }

        return null;

      case "compositionend":
        return de && "ko" !== b.locale ? null : b.data;

      default:
        return null;
    }
  }

  var le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
  };

  function me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!le[a.type] : "textarea" === b ? !0 : !1;
  }

  function ne(a, b, c, d) {
    Eb(d);
    b = oe(b, "onChange");
    0 < b.length && (c = new td("onChange", "change", null, c, d), a.push({
      event: c,
      listeners: b
    }));
  }

  var pe = null,
      qe = null;

  function re(a) {
    se(a, 0);
  }

  function te(a) {
    var b = ue(a);
    if (Wa(b)) return a;
  }

  function ve(a, b) {
    if ("change" === a) return b;
  }

  var we = !1;

  if (fa) {
    var xe;

    if (fa) {
      var ye = ("oninput" in document);

      if (!ye) {
        var ze = document.createElement("div");
        ze.setAttribute("oninput", "return;");
        ye = "function" === typeof ze.oninput;
      }

      xe = ye;
    } else xe = !1;

    we = xe && (!document.documentMode || 9 < document.documentMode);
  }

  function Ae() {
    pe && (pe.detachEvent("onpropertychange", Be), qe = pe = null);
  }

  function Be(a) {
    if ("value" === a.propertyName && te(qe)) {
      var b = [];
      ne(b, qe, a, xb(a));
      a = re;
      if (Kb) a(b);else {
        Kb = !0;

        try {
          Gb(a, b);
        } finally {
          Kb = !1, Mb();
        }
      }
    }
  }

  function Ce(a, b, c) {
    "focusin" === a ? (Ae(), pe = b, qe = c, pe.attachEvent("onpropertychange", Be)) : "focusout" === a && Ae();
  }

  function De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return te(qe);
  }

  function Ee(a, b) {
    if ("click" === a) return te(b);
  }

  function Fe(a, b) {
    if ("input" === a || "change" === a) return te(b);
  }

  function Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
  }

  var He = "function" === typeof Object.is ? Object.is : Ge,
      Ie = Object.prototype.hasOwnProperty;

  function Je(a, b) {
    if (He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a),
        d = Object.keys(b);
    if (c.length !== d.length) return !1;

    for (d = 0; d < c.length; d++) {
      if (!Ie.call(b, c[d]) || !He(a[c[d]], b[c[d]])) return !1;
    }

    return !0;
  }

  function Ke(a) {
    for (; a && a.firstChild;) {
      a = a.firstChild;
    }

    return a;
  }

  function Le(a, b) {
    var c = Ke(a);
    a = 0;

    for (var d; c;) {
      if (3 === c.nodeType) {
        d = a + c.textContent.length;
        if (a <= b && d >= b) return {
          node: c,
          offset: b - a
        };
        a = d;
      }

      a: {
        for (; c;) {
          if (c.nextSibling) {
            c = c.nextSibling;
            break a;
          }

          c = c.parentNode;
        }

        c = void 0;
      }

      c = Ke(c);
    }
  }

  function Me(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? Me(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
  }

  function Ne() {
    for (var a = window, b = Xa(); b instanceof a.HTMLIFrameElement;) {
      try {
        var c = "string" === typeof b.contentWindow.location.href;
      } catch (d) {
        c = !1;
      }

      if (c) a = b.contentWindow;else break;
      b = Xa(a.document);
    }

    return b;
  }

  function Oe(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
  }

  var Pe = fa && "documentMode" in document && 11 >= document.documentMode,
      Qe = null,
      Re = null,
      Se = null,
      Te = !1;

  function Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    Te || null == Qe || Qe !== Xa(d) || (d = Qe, "selectionStart" in d && Oe(d) ? d = {
      start: d.selectionStart,
      end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
      anchorNode: d.anchorNode,
      anchorOffset: d.anchorOffset,
      focusNode: d.focusNode,
      focusOffset: d.focusOffset
    }), Se && Je(Se, d) || (Se = d, d = oe(Re, "onSelect"), 0 < d.length && (b = new td("onSelect", "select", null, b, c), a.push({
      event: b,
      listeners: d
    }), b.target = Qe)));
  }

  Pc("cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focusin focus focusout blur input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0);
  Pc("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1);
  Pc(Oc, 2);

  for (var Ve = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), We = 0; We < Ve.length; We++) {
    Nc.set(Ve[We], 0);
  }

  ea("onMouseEnter", ["mouseout", "mouseover"]);
  ea("onMouseLeave", ["mouseout", "mouseover"]);
  ea("onPointerEnter", ["pointerout", "pointerover"]);
  ea("onPointerLeave", ["pointerout", "pointerover"]);
  da("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
  da("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
  da("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]);
  da("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
  da("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
  da("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
  var Xe = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),
      Ye = new Set("cancel close invalid load scroll toggle".split(" ").concat(Xe));

  function Ze(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    Yb(d, b, void 0, a);
    a.currentTarget = null;
  }

  function se(a, b) {
    b = 0 !== (b & 4);

    for (var c = 0; c < a.length; c++) {
      var d = a[c],
          e = d.event;
      d = d.listeners;

      a: {
        var f = void 0;
        if (b) for (var g = d.length - 1; 0 <= g; g--) {
          var h = d[g],
              k = h.instance,
              l = h.currentTarget;
          h = h.listener;
          if (k !== f && e.isPropagationStopped()) break a;
          Ze(e, h, l);
          f = k;
        } else for (g = 0; g < d.length; g++) {
          h = d[g];
          k = h.instance;
          l = h.currentTarget;
          h = h.listener;
          if (k !== f && e.isPropagationStopped()) break a;
          Ze(e, h, l);
          f = k;
        }
      }
    }

    if (Ub) throw a = Vb, Ub = !1, Vb = null, a;
  }

  function G(a, b) {
    var c = $e(b),
        d = a + "__bubble";
    c.has(d) || (af(b, a, 2, !1), c.add(d));
  }

  var bf = "_reactListening" + Math.random().toString(36).slice(2);

  function cf(a) {
    a[bf] || (a[bf] = !0, ba.forEach(function (b) {
      Ye.has(b) || df(b, !1, a, null);
      df(b, !0, a, null);
    }));
  }

  function df(a, b, c, d) {
    var e = 4 < arguments.length && void 0 !== arguments[4] ? arguments[4] : 0,
        f = c;
    "selectionchange" === a && 9 !== c.nodeType && (f = c.ownerDocument);

    if (null !== d && !b && Ye.has(a)) {
      if ("scroll" !== a) return;
      e |= 2;
      f = d;
    }

    var g = $e(f),
        h = a + "__" + (b ? "capture" : "bubble");
    g.has(h) || (b && (e |= 4), af(f, a, e, b), g.add(h));
  }

  function af(a, b, c, d) {
    var e = Nc.get(b);

    switch (void 0 === e ? 2 : e) {
      case 0:
        e = gd;
        break;

      case 1:
        e = id;
        break;

      default:
        e = hd;
    }

    c = e.bind(null, b, c, a);
    e = void 0;
    !Pb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
      capture: !0,
      passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
      passive: e
    }) : a.addEventListener(b, c, !1);
  }

  function jd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for (;;) {
      if (null === d) return;
      var g = d.tag;

      if (3 === g || 4 === g) {
        var h = d.stateNode.containerInfo;
        if (h === e || 8 === h.nodeType && h.parentNode === e) break;
        if (4 === g) for (g = d.return; null !== g;) {
          var k = g.tag;
          if (3 === k || 4 === k) if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
          g = g.return;
        }

        for (; null !== h;) {
          g = wc(h);
          if (null === g) return;
          k = g.tag;

          if (5 === k || 6 === k) {
            d = f = g;
            continue a;
          }

          h = h.parentNode;
        }
      }

      d = d.return;
    }
    Nb(function () {
      var d = f,
          e = xb(c),
          g = [];

      a: {
        var h = Mc.get(a);

        if (void 0 !== h) {
          var k = td,
              x = a;

          switch (a) {
            case "keypress":
              if (0 === od(c)) break a;

            case "keydown":
            case "keyup":
              k = Rd;
              break;

            case "focusin":
              x = "focus";
              k = Fd;
              break;

            case "focusout":
              x = "blur";
              k = Fd;
              break;

            case "beforeblur":
            case "afterblur":
              k = Fd;
              break;

            case "click":
              if (2 === c.button) break a;

            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
              k = Bd;
              break;

            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
              k = Dd;
              break;

            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
              k = Vd;
              break;

            case Ic:
            case Jc:
            case Kc:
              k = Hd;
              break;

            case Lc:
              k = Xd;
              break;

            case "scroll":
              k = vd;
              break;

            case "wheel":
              k = Zd;
              break;

            case "copy":
            case "cut":
            case "paste":
              k = Jd;
              break;

            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
              k = Td;
          }

          var w = 0 !== (b & 4),
              z = !w && "scroll" === a,
              u = w ? null !== h ? h + "Capture" : null : h;
          w = [];

          for (var t = d, q; null !== t;) {
            q = t;
            var v = q.stateNode;
            5 === q.tag && null !== v && (q = v, null !== u && (v = Ob(t, u), null != v && w.push(ef(t, v, q))));
            if (z) break;
            t = t.return;
          }

          0 < w.length && (h = new k(h, x, null, c, e), g.push({
            event: h,
            listeners: w
          }));
        }
      }

      if (0 === (b & 7)) {
        a: {
          h = "mouseover" === a || "pointerover" === a;
          k = "mouseout" === a || "pointerout" === a;
          if (h && 0 === (b & 16) && (x = c.relatedTarget || c.fromElement) && (wc(x) || x[ff])) break a;

          if (k || h) {
            h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;

            if (k) {
              if (x = c.relatedTarget || c.toElement, k = d, x = x ? wc(x) : null, null !== x && (z = Zb(x), x !== z || 5 !== x.tag && 6 !== x.tag)) x = null;
            } else k = null, x = d;

            if (k !== x) {
              w = Bd;
              v = "onMouseLeave";
              u = "onMouseEnter";
              t = "mouse";
              if ("pointerout" === a || "pointerover" === a) w = Td, v = "onPointerLeave", u = "onPointerEnter", t = "pointer";
              z = null == k ? h : ue(k);
              q = null == x ? h : ue(x);
              h = new w(v, t + "leave", k, c, e);
              h.target = z;
              h.relatedTarget = q;
              v = null;
              wc(e) === d && (w = new w(u, t + "enter", x, c, e), w.target = q, w.relatedTarget = z, v = w);
              z = v;
              if (k && x) b: {
                w = k;
                u = x;
                t = 0;

                for (q = w; q; q = gf(q)) {
                  t++;
                }

                q = 0;

                for (v = u; v; v = gf(v)) {
                  q++;
                }

                for (; 0 < t - q;) {
                  w = gf(w), t--;
                }

                for (; 0 < q - t;) {
                  u = gf(u), q--;
                }

                for (; t--;) {
                  if (w === u || null !== u && w === u.alternate) break b;
                  w = gf(w);
                  u = gf(u);
                }

                w = null;
              } else w = null;
              null !== k && hf(g, h, k, w, !1);
              null !== x && null !== z && hf(g, z, x, w, !0);
            }
          }
        }

        a: {
          h = d ? ue(d) : window;
          k = h.nodeName && h.nodeName.toLowerCase();
          if ("select" === k || "input" === k && "file" === h.type) var J = ve;else if (me(h)) {
            if (we) J = Fe;else {
              J = De;
              var K = Ce;
            }
          } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (J = Ee);

          if (J && (J = J(a, d))) {
            ne(g, J, c, e);
            break a;
          }

          K && K(a, h, d);
          "focusout" === a && (K = h._wrapperState) && K.controlled && "number" === h.type && bb(h, "number", h.value);
        }

        K = d ? ue(d) : window;

        switch (a) {
          case "focusin":
            if (me(K) || "true" === K.contentEditable) Qe = K, Re = d, Se = null;
            break;

          case "focusout":
            Se = Re = Qe = null;
            break;

          case "mousedown":
            Te = !0;
            break;

          case "contextmenu":
          case "mouseup":
          case "dragend":
            Te = !1;
            Ue(g, c, e);
            break;

          case "selectionchange":
            if (Pe) break;

          case "keydown":
          case "keyup":
            Ue(g, c, e);
        }

        var Q;
        if (ae) b: {
          switch (a) {
            case "compositionstart":
              var L = "onCompositionStart";
              break b;

            case "compositionend":
              L = "onCompositionEnd";
              break b;

            case "compositionupdate":
              L = "onCompositionUpdate";
              break b;
          }

          L = void 0;
        } else ie ? ge(a, c) && (L = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (L = "onCompositionStart");
        L && (de && "ko" !== c.locale && (ie || "onCompositionStart" !== L ? "onCompositionEnd" === L && ie && (Q = nd()) : (kd = e, ld = "value" in kd ? kd.value : kd.textContent, ie = !0)), K = oe(d, L), 0 < K.length && (L = new Ld(L, a, null, c, e), g.push({
          event: L,
          listeners: K
        }), Q ? L.data = Q : (Q = he(c), null !== Q && (L.data = Q))));
        if (Q = ce ? je(a, c) : ke(a, c)) d = oe(d, "onBeforeInput"), 0 < d.length && (e = new Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
          event: e,
          listeners: d
        }), e.data = Q);
      }

      se(g, b);
    });
  }

  function ef(a, b, c) {
    return {
      instance: a,
      listener: b,
      currentTarget: c
    };
  }

  function oe(a, b) {
    for (var c = b + "Capture", d = []; null !== a;) {
      var e = a,
          f = e.stateNode;
      5 === e.tag && null !== f && (e = f, f = Ob(a, c), null != f && d.unshift(ef(a, f, e)), f = Ob(a, b), null != f && d.push(ef(a, f, e)));
      a = a.return;
    }

    return d;
  }

  function gf(a) {
    if (null === a) return null;

    do {
      a = a.return;
    } while (a && 5 !== a.tag);

    return a ? a : null;
  }

  function hf(a, b, c, d, e) {
    for (var f = b._reactName, g = []; null !== c && c !== d;) {
      var h = c,
          k = h.alternate,
          l = h.stateNode;
      if (null !== k && k === d) break;
      5 === h.tag && null !== l && (h = l, e ? (k = Ob(c, f), null != k && g.unshift(ef(c, k, h))) : e || (k = Ob(c, f), null != k && g.push(ef(c, k, h))));
      c = c.return;
    }

    0 !== g.length && a.push({
      event: b,
      listeners: g
    });
  }

  function jf() {}

  var kf = null,
      lf = null;

  function mf(a, b) {
    switch (a) {
      case "button":
      case "input":
      case "select":
      case "textarea":
        return !!b.autoFocus;
    }

    return !1;
  }

  function nf(a, b) {
    return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
  }

  var of = "function" === typeof setTimeout ? setTimeout : void 0,
      pf = "function" === typeof clearTimeout ? clearTimeout : void 0;

  function qf(a) {
    1 === a.nodeType ? a.textContent = "" : 9 === a.nodeType && (a = a.body, null != a && (a.textContent = ""));
  }

  function rf(a) {
    for (; null != a; a = a.nextSibling) {
      var b = a.nodeType;
      if (1 === b || 3 === b) break;
    }

    return a;
  }

  function sf(a) {
    a = a.previousSibling;

    for (var b = 0; a;) {
      if (8 === a.nodeType) {
        var c = a.data;

        if ("$" === c || "$!" === c || "$?" === c) {
          if (0 === b) return a;
          b--;
        } else "/$" === c && b++;
      }

      a = a.previousSibling;
    }

    return null;
  }

  var tf = 0;

  function uf(a) {
    return {
      $$typeof: Ga,
      toString: a,
      valueOf: a
    };
  }

  var vf = Math.random().toString(36).slice(2),
      wf = "__reactFiber$" + vf,
      xf = "__reactProps$" + vf,
      ff = "__reactContainer$" + vf,
      yf = "__reactEvents$" + vf;

  function wc(a) {
    var b = a[wf];
    if (b) return b;

    for (var c = a.parentNode; c;) {
      if (b = c[ff] || c[wf]) {
        c = b.alternate;
        if (null !== b.child || null !== c && null !== c.child) for (a = sf(a); null !== a;) {
          if (c = a[wf]) return c;
          a = sf(a);
        }
        return b;
      }

      a = c;
      c = a.parentNode;
    }

    return null;
  }

  function Cb(a) {
    a = a[wf] || a[ff];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
  }

  function ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(y(33));
  }

  function Db(a) {
    return a[xf] || null;
  }

  function $e(a) {
    var b = a[yf];
    void 0 === b && (b = a[yf] = new Set());
    return b;
  }

  var zf = [],
      Af = -1;

  function Bf(a) {
    return {
      current: a
    };
  }

  function H(a) {
    0 > Af || (a.current = zf[Af], zf[Af] = null, Af--);
  }

  function I(a, b) {
    Af++;
    zf[Af] = a.current;
    a.current = b;
  }

  var Cf = {},
      M = Bf(Cf),
      N = Bf(!1),
      Df = Cf;

  function Ef(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Cf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {},
        f;

    for (f in c) {
      e[f] = b[f];
    }

    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
  }

  function Ff(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
  }

  function Gf() {
    H(N);
    H(M);
  }

  function Hf(a, b, c) {
    if (M.current !== Cf) throw Error(y(168));
    I(M, b);
    I(N, c);
  }

  function If(a, b, c) {
    var d = a.stateNode;
    a = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();

    for (var e in d) {
      if (!(e in a)) throw Error(y(108, Ra(b) || "Unknown", e));
    }

    return m({}, c, d);
  }

  function Jf(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Cf;
    Df = M.current;
    I(M, a);
    I(N, N.current);
    return !0;
  }

  function Kf(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(y(169));
    c ? (a = If(a, b, Df), d.__reactInternalMemoizedMergedChildContext = a, H(N), H(M), I(M, a)) : H(N);
    I(N, c);
  }

  var Lf = null,
      Mf = null,
      Nf = r.unstable_runWithPriority,
      Of = r.unstable_scheduleCallback,
      Pf = r.unstable_cancelCallback,
      Qf = r.unstable_shouldYield,
      Rf = r.unstable_requestPaint,
      Sf = r.unstable_now,
      Tf = r.unstable_getCurrentPriorityLevel,
      Uf = r.unstable_ImmediatePriority,
      Vf = r.unstable_UserBlockingPriority,
      Wf = r.unstable_NormalPriority,
      Xf = r.unstable_LowPriority,
      Yf = r.unstable_IdlePriority,
      Zf = {},
      $f = void 0 !== Rf ? Rf : function () {},
      ag = null,
      bg = null,
      cg = !1,
      dg = Sf(),
      O = 1E4 > dg ? Sf : function () {
    return Sf() - dg;
  };

  function eg() {
    switch (Tf()) {
      case Uf:
        return 99;

      case Vf:
        return 98;

      case Wf:
        return 97;

      case Xf:
        return 96;

      case Yf:
        return 95;

      default:
        throw Error(y(332));
    }
  }

  function fg(a) {
    switch (a) {
      case 99:
        return Uf;

      case 98:
        return Vf;

      case 97:
        return Wf;

      case 96:
        return Xf;

      case 95:
        return Yf;

      default:
        throw Error(y(332));
    }
  }

  function gg(a, b) {
    a = fg(a);
    return Nf(a, b);
  }

  function hg(a, b, c) {
    a = fg(a);
    return Of(a, b, c);
  }

  function ig() {
    if (null !== bg) {
      var a = bg;
      bg = null;
      Pf(a);
    }

    jg();
  }

  function jg() {
    if (!cg && null !== ag) {
      cg = !0;
      var a = 0;

      try {
        var b = ag;
        gg(99, function () {
          for (; a < b.length; a++) {
            var c = b[a];

            do {
              c = c(!0);
            } while (null !== c);
          }
        });
        ag = null;
      } catch (c) {
        throw null !== ag && (ag = ag.slice(a + 1)), Of(Uf, ig), c;
      } finally {
        cg = !1;
      }
    }
  }

  var kg = ra.ReactCurrentBatchConfig;

  function lg(a, b) {
    if (a && a.defaultProps) {
      b = m({}, b);
      a = a.defaultProps;

      for (var c in a) {
        void 0 === b[c] && (b[c] = a[c]);
      }

      return b;
    }

    return b;
  }

  var mg = Bf(null),
      ng = null,
      og = null,
      pg = null;

  function qg() {
    pg = og = ng = null;
  }

  function rg(a) {
    var b = mg.current;
    H(mg);
    a.type._context._currentValue = b;
  }

  function sg(a, b) {
    for (; null !== a;) {
      var c = a.alternate;
      if ((a.childLanes & b) === b) {
        if (null === c || (c.childLanes & b) === b) break;else c.childLanes |= b;
      } else a.childLanes |= b, null !== c && (c.childLanes |= b);
      a = a.return;
    }
  }

  function tg(a, b) {
    ng = a;
    pg = og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (ug = !0), a.firstContext = null);
  }

  function vg(a, b) {
    if (pg !== a && !1 !== b && 0 !== b) {
      if ("number" !== typeof b || 1073741823 === b) pg = a, b = 1073741823;
      b = {
        context: a,
        observedBits: b,
        next: null
      };

      if (null === og) {
        if (null === ng) throw Error(y(308));
        og = b;
        ng.dependencies = {
          lanes: 0,
          firstContext: b,
          responders: null
        };
      } else og = og.next = b;
    }

    return a._currentValue;
  }

  var wg = !1;

  function xg(a) {
    a.updateQueue = {
      baseState: a.memoizedState,
      firstBaseUpdate: null,
      lastBaseUpdate: null,
      shared: {
        pending: null
      },
      effects: null
    };
  }

  function yg(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
      baseState: a.baseState,
      firstBaseUpdate: a.firstBaseUpdate,
      lastBaseUpdate: a.lastBaseUpdate,
      shared: a.shared,
      effects: a.effects
    });
  }

  function zg(a, b) {
    return {
      eventTime: a,
      lane: b,
      tag: 0,
      payload: null,
      callback: null,
      next: null
    };
  }

  function Ag(a, b) {
    a = a.updateQueue;

    if (null !== a) {
      a = a.shared;
      var c = a.pending;
      null === c ? b.next = b : (b.next = c.next, c.next = b);
      a.pending = b;
    }
  }

  function Bg(a, b) {
    var c = a.updateQueue,
        d = a.alternate;

    if (null !== d && (d = d.updateQueue, c === d)) {
      var e = null,
          f = null;
      c = c.firstBaseUpdate;

      if (null !== c) {
        do {
          var g = {
            eventTime: c.eventTime,
            lane: c.lane,
            tag: c.tag,
            payload: c.payload,
            callback: c.callback,
            next: null
          };
          null === f ? e = f = g : f = f.next = g;
          c = c.next;
        } while (null !== c);

        null === f ? e = f = b : f = f.next = b;
      } else e = f = b;

      c = {
        baseState: d.baseState,
        firstBaseUpdate: e,
        lastBaseUpdate: f,
        shared: d.shared,
        effects: d.effects
      };
      a.updateQueue = c;
      return;
    }

    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
  }

  function Cg(a, b, c, d) {
    var e = a.updateQueue;
    wg = !1;
    var f = e.firstBaseUpdate,
        g = e.lastBaseUpdate,
        h = e.shared.pending;

    if (null !== h) {
      e.shared.pending = null;
      var k = h,
          l = k.next;
      k.next = null;
      null === g ? f = l : g.next = l;
      g = k;
      var n = a.alternate;

      if (null !== n) {
        n = n.updateQueue;
        var A = n.lastBaseUpdate;
        A !== g && (null === A ? n.firstBaseUpdate = l : A.next = l, n.lastBaseUpdate = k);
      }
    }

    if (null !== f) {
      A = e.baseState;
      g = 0;
      n = l = k = null;

      do {
        h = f.lane;
        var p = f.eventTime;

        if ((d & h) === h) {
          null !== n && (n = n.next = {
            eventTime: p,
            lane: 0,
            tag: f.tag,
            payload: f.payload,
            callback: f.callback,
            next: null
          });

          a: {
            var C = a,
                x = f;
            h = b;
            p = c;

            switch (x.tag) {
              case 1:
                C = x.payload;

                if ("function" === typeof C) {
                  A = C.call(p, A, h);
                  break a;
                }

                A = C;
                break a;

              case 3:
                C.flags = C.flags & -4097 | 64;

              case 0:
                C = x.payload;
                h = "function" === typeof C ? C.call(p, A, h) : C;
                if (null === h || void 0 === h) break a;
                A = m({}, A, h);
                break a;

              case 2:
                wg = !0;
            }
          }

          null !== f.callback && (a.flags |= 32, h = e.effects, null === h ? e.effects = [f] : h.push(f));
        } else p = {
          eventTime: p,
          lane: h,
          tag: f.tag,
          payload: f.payload,
          callback: f.callback,
          next: null
        }, null === n ? (l = n = p, k = A) : n = n.next = p, g |= h;

        f = f.next;
        if (null === f) if (h = e.shared.pending, null === h) break;else f = h.next, h.next = null, e.lastBaseUpdate = h, e.shared.pending = null;
      } while (1);

      null === n && (k = A);
      e.baseState = k;
      e.firstBaseUpdate = l;
      e.lastBaseUpdate = n;
      Dg |= g;
      a.lanes = g;
      a.memoizedState = A;
    }
  }

  function Eg(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for (b = 0; b < a.length; b++) {
      var d = a[b],
          e = d.callback;

      if (null !== e) {
        d.callback = null;
        d = c;
        if ("function" !== typeof e) throw Error(y(191, e));
        e.call(d);
      }
    }
  }

  var Fg = new aa.Component().refs;

  function Gg(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : m({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
  }

  var Kg = {
    isMounted: function isMounted(a) {
      return (a = a._reactInternals) ? Zb(a) === a : !1;
    },
    enqueueSetState: function enqueueSetState(a, b, c) {
      a = a._reactInternals;
      var d = Hg(),
          e = Ig(a),
          f = zg(d, e);
      f.payload = b;
      void 0 !== c && null !== c && (f.callback = c);
      Ag(a, f);
      Jg(a, e, d);
    },
    enqueueReplaceState: function enqueueReplaceState(a, b, c) {
      a = a._reactInternals;
      var d = Hg(),
          e = Ig(a),
          f = zg(d, e);
      f.tag = 1;
      f.payload = b;
      void 0 !== c && null !== c && (f.callback = c);
      Ag(a, f);
      Jg(a, e, d);
    },
    enqueueForceUpdate: function enqueueForceUpdate(a, b) {
      a = a._reactInternals;
      var c = Hg(),
          d = Ig(a),
          e = zg(c, d);
      e.tag = 2;
      void 0 !== b && null !== b && (e.callback = b);
      Ag(a, e);
      Jg(a, d, c);
    }
  };

  function Lg(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !Je(c, d) || !Je(e, f) : !0;
  }

  function Mg(a, b, c) {
    var d = !1,
        e = Cf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = vg(f) : (e = Ff(b) ? Df : M.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Ef(a, e) : Cf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Kg;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
  }

  function Ng(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Kg.enqueueReplaceState(b, b.state, null);
  }

  function Og(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = Fg;
    xg(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = vg(f) : (f = Ff(b) ? Df : M.current, e.context = Ef(a, f));
    Cg(a, c, e, d);
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Gg(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Kg.enqueueReplaceState(e, e.state, null), Cg(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4);
  }

  var Pg = Array.isArray;

  function Qg(a, b, c) {
    a = c.ref;

    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
      if (c._owner) {
        c = c._owner;

        if (c) {
          if (1 !== c.tag) throw Error(y(309));
          var d = c.stateNode;
        }

        if (!d) throw Error(y(147, a));
        var e = "" + a;
        if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;

        b = function b(a) {
          var b = d.refs;
          b === Fg && (b = d.refs = {});
          null === a ? delete b[e] : b[e] = a;
        };

        b._stringRef = e;
        return b;
      }

      if ("string" !== typeof a) throw Error(y(284));
      if (!c._owner) throw Error(y(290, a));
    }

    return a;
  }

  function Rg(a, b) {
    if ("textarea" !== a.type) throw Error(y(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b));
  }

  function Sg(a) {
    function b(b, c) {
      if (a) {
        var d = b.lastEffect;
        null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
        c.nextEffect = null;
        c.flags = 8;
      }
    }

    function c(c, d) {
      if (!a) return null;

      for (; null !== d;) {
        b(c, d), d = d.sibling;
      }

      return null;
    }

    function d(a, b) {
      for (a = new Map(); null !== b;) {
        null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
      }

      return a;
    }

    function e(a, b) {
      a = Tg(a, b);
      a.index = 0;
      a.sibling = null;
      return a;
    }

    function f(b, c, d) {
      b.index = d;
      if (!a) return c;
      d = b.alternate;
      if (null !== d) return d = d.index, d < c ? (b.flags = 2, c) : d;
      b.flags = 2;
      return c;
    }

    function g(b) {
      a && null === b.alternate && (b.flags = 2);
      return b;
    }

    function h(a, b, c, d) {
      if (null === b || 6 !== b.tag) return b = Ug(c, a.mode, d), b.return = a, b;
      b = e(b, c);
      b.return = a;
      return b;
    }

    function k(a, b, c, d) {
      if (null !== b && b.elementType === c.type) return d = e(b, c.props), d.ref = Qg(a, b, c), d.return = a, d;
      d = Vg(c.type, c.key, c.props, null, a.mode, d);
      d.ref = Qg(a, b, c);
      d.return = a;
      return d;
    }

    function l(a, b, c, d) {
      if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Wg(c, a.mode, d), b.return = a, b;
      b = e(b, c.children || []);
      b.return = a;
      return b;
    }

    function n(a, b, c, d, f) {
      if (null === b || 7 !== b.tag) return b = Xg(c, a.mode, d, f), b.return = a, b;
      b = e(b, c);
      b.return = a;
      return b;
    }

    function A(a, b, c) {
      if ("string" === typeof b || "number" === typeof b) return b = Ug("" + b, a.mode, c), b.return = a, b;

      if ("object" === typeof b && null !== b) {
        switch (b.$$typeof) {
          case sa:
            return c = Vg(b.type, b.key, b.props, null, a.mode, c), c.ref = Qg(a, null, b), c.return = a, c;

          case ta:
            return b = Wg(b, a.mode, c), b.return = a, b;
        }

        if (Pg(b) || La(b)) return b = Xg(b, a.mode, c, null), b.return = a, b;
        Rg(a, b);
      }

      return null;
    }

    function p(a, b, c, d) {
      var e = null !== b ? b.key : null;
      if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);

      if ("object" === typeof c && null !== c) {
        switch (c.$$typeof) {
          case sa:
            return c.key === e ? c.type === ua ? n(a, b, c.props.children, d, e) : k(a, b, c, d) : null;

          case ta:
            return c.key === e ? l(a, b, c, d) : null;
        }

        if (Pg(c) || La(c)) return null !== e ? null : n(a, b, c, d, null);
        Rg(a, c);
      }

      return null;
    }

    function C(a, b, c, d, e) {
      if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);

      if ("object" === typeof d && null !== d) {
        switch (d.$$typeof) {
          case sa:
            return a = a.get(null === d.key ? c : d.key) || null, d.type === ua ? n(b, a, d.props.children, e, d.key) : k(b, a, d, e);

          case ta:
            return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
        }

        if (Pg(d) || La(d)) return a = a.get(c) || null, n(b, a, d, e, null);
        Rg(b, d);
      }

      return null;
    }

    function x(e, g, h, k) {
      for (var l = null, t = null, u = g, z = g = 0, q = null; null !== u && z < h.length; z++) {
        u.index > z ? (q = u, u = null) : q = u.sibling;
        var n = p(e, u, h[z], k);

        if (null === n) {
          null === u && (u = q);
          break;
        }

        a && u && null === n.alternate && b(e, u);
        g = f(n, g, z);
        null === t ? l = n : t.sibling = n;
        t = n;
        u = q;
      }

      if (z === h.length) return c(e, u), l;

      if (null === u) {
        for (; z < h.length; z++) {
          u = A(e, h[z], k), null !== u && (g = f(u, g, z), null === t ? l = u : t.sibling = u, t = u);
        }

        return l;
      }

      for (u = d(e, u); z < h.length; z++) {
        q = C(u, e, z, h[z], k), null !== q && (a && null !== q.alternate && u.delete(null === q.key ? z : q.key), g = f(q, g, z), null === t ? l = q : t.sibling = q, t = q);
      }

      a && u.forEach(function (a) {
        return b(e, a);
      });
      return l;
    }

    function w(e, g, h, k) {
      var l = La(h);
      if ("function" !== typeof l) throw Error(y(150));
      h = l.call(h);
      if (null == h) throw Error(y(151));

      for (var t = l = null, u = g, z = g = 0, q = null, n = h.next(); null !== u && !n.done; z++, n = h.next()) {
        u.index > z ? (q = u, u = null) : q = u.sibling;
        var w = p(e, u, n.value, k);

        if (null === w) {
          null === u && (u = q);
          break;
        }

        a && u && null === w.alternate && b(e, u);
        g = f(w, g, z);
        null === t ? l = w : t.sibling = w;
        t = w;
        u = q;
      }

      if (n.done) return c(e, u), l;

      if (null === u) {
        for (; !n.done; z++, n = h.next()) {
          n = A(e, n.value, k), null !== n && (g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
        }

        return l;
      }

      for (u = d(e, u); !n.done; z++, n = h.next()) {
        n = C(u, e, z, n.value, k), null !== n && (a && null !== n.alternate && u.delete(null === n.key ? z : n.key), g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
      }

      a && u.forEach(function (a) {
        return b(e, a);
      });
      return l;
    }

    return function (a, d, f, h) {
      var k = "object" === typeof f && null !== f && f.type === ua && null === f.key;
      k && (f = f.props.children);
      var l = "object" === typeof f && null !== f;
      if (l) switch (f.$$typeof) {
        case sa:
          a: {
            l = f.key;

            for (k = d; null !== k;) {
              if (k.key === l) {
                switch (k.tag) {
                  case 7:
                    if (f.type === ua) {
                      c(a, k.sibling);
                      d = e(k, f.props.children);
                      d.return = a;
                      a = d;
                      break a;
                    }

                    break;

                  default:
                    if (k.elementType === f.type) {
                      c(a, k.sibling);
                      d = e(k, f.props);
                      d.ref = Qg(a, k, f);
                      d.return = a;
                      a = d;
                      break a;
                    }

                }

                c(a, k);
                break;
              } else b(a, k);

              k = k.sibling;
            }

            f.type === ua ? (d = Xg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Vg(f.type, f.key, f.props, null, a.mode, h), h.ref = Qg(a, d, f), h.return = a, a = h);
          }

          return g(a);

        case ta:
          a: {
            for (k = f.key; null !== d;) {
              if (d.key === k) {
                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                  c(a, d.sibling);
                  d = e(d, f.children || []);
                  d.return = a;
                  a = d;
                  break a;
                } else {
                  c(a, d);
                  break;
                }
              } else b(a, d);
              d = d.sibling;
            }

            d = Wg(f, a.mode, h);
            d.return = a;
            a = d;
          }

          return g(a);
      }
      if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Ug(f, a.mode, h), d.return = a, a = d), g(a);
      if (Pg(f)) return x(a, d, f, h);
      if (La(f)) return w(a, d, f, h);
      l && Rg(a, f);
      if ("undefined" === typeof f && !k) switch (a.tag) {
        case 1:
        case 22:
        case 0:
        case 11:
        case 15:
          throw Error(y(152, Ra(a.type) || "Component"));
      }
      return c(a, d);
    };
  }

  var Yg = Sg(!0),
      Zg = Sg(!1),
      $g = {},
      ah = Bf($g),
      bh = Bf($g),
      ch = Bf($g);

  function dh(a) {
    if (a === $g) throw Error(y(174));
    return a;
  }

  function eh(a, b) {
    I(ch, b);
    I(bh, a);
    I(ah, $g);
    a = b.nodeType;

    switch (a) {
      case 9:
      case 11:
        b = (b = b.documentElement) ? b.namespaceURI : mb(null, "");
        break;

      default:
        a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = mb(b, a);
    }

    H(ah);
    I(ah, b);
  }

  function fh() {
    H(ah);
    H(bh);
    H(ch);
  }

  function gh(a) {
    dh(ch.current);
    var b = dh(ah.current);
    var c = mb(b, a.type);
    b !== c && (I(bh, a), I(ah, c));
  }

  function hh(a) {
    bh.current === a && (H(ah), H(bh));
  }

  var P = Bf(0);

  function ih(a) {
    for (var b = a; null !== b;) {
      if (13 === b.tag) {
        var c = b.memoizedState;
        if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
      } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
        if (0 !== (b.flags & 64)) return b;
      } else if (null !== b.child) {
        b.child.return = b;
        b = b.child;
        continue;
      }

      if (b === a) break;

      for (; null === b.sibling;) {
        if (null === b.return || b.return === a) return null;
        b = b.return;
      }

      b.sibling.return = b.return;
      b = b.sibling;
    }

    return null;
  }

  var jh = null,
      kh = null,
      lh = !1;

  function mh(a, b) {
    var c = nh(5, null, null, 0);
    c.elementType = "DELETED";
    c.type = "DELETED";
    c.stateNode = b;
    c.return = a;
    c.flags = 8;
    null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
  }

  function oh(a, b) {
    switch (a.tag) {
      case 5:
        var c = a.type;
        b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
        return null !== b ? (a.stateNode = b, !0) : !1;

      case 6:
        return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;

      case 13:
        return !1;

      default:
        return !1;
    }
  }

  function ph(a) {
    if (lh) {
      var b = kh;

      if (b) {
        var c = b;

        if (!oh(a, b)) {
          b = rf(c.nextSibling);

          if (!b || !oh(a, b)) {
            a.flags = a.flags & -1025 | 2;
            lh = !1;
            jh = a;
            return;
          }

          mh(jh, c);
        }

        jh = a;
        kh = rf(b.firstChild);
      } else a.flags = a.flags & -1025 | 2, lh = !1, jh = a;
    }
  }

  function qh(a) {
    for (a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;) {
      a = a.return;
    }

    jh = a;
  }

  function rh(a) {
    if (a !== jh) return !1;
    if (!lh) return qh(a), lh = !0, !1;
    var b = a.type;
    if (5 !== a.tag || "head" !== b && "body" !== b && !nf(b, a.memoizedProps)) for (b = kh; b;) {
      mh(a, b), b = rf(b.nextSibling);
    }
    qh(a);

    if (13 === a.tag) {
      a = a.memoizedState;
      a = null !== a ? a.dehydrated : null;
      if (!a) throw Error(y(317));

      a: {
        a = a.nextSibling;

        for (b = 0; a;) {
          if (8 === a.nodeType) {
            var c = a.data;

            if ("/$" === c) {
              if (0 === b) {
                kh = rf(a.nextSibling);
                break a;
              }

              b--;
            } else "$" !== c && "$!" !== c && "$?" !== c || b++;
          }

          a = a.nextSibling;
        }

        kh = null;
      }
    } else kh = jh ? rf(a.stateNode.nextSibling) : null;

    return !0;
  }

  function sh() {
    kh = jh = null;
    lh = !1;
  }

  var th = [];

  function uh() {
    for (var a = 0; a < th.length; a++) {
      th[a]._workInProgressVersionPrimary = null;
    }

    th.length = 0;
  }

  var vh = ra.ReactCurrentDispatcher,
      wh = ra.ReactCurrentBatchConfig,
      xh = 0,
      R = null,
      S = null,
      T = null,
      yh = !1,
      zh = !1;

  function Ah() {
    throw Error(y(321));
  }

  function Bh(a, b) {
    if (null === b) return !1;

    for (var c = 0; c < b.length && c < a.length; c++) {
      if (!He(a[c], b[c])) return !1;
    }

    return !0;
  }

  function Ch(a, b, c, d, e, f) {
    xh = f;
    R = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    vh.current = null === a || null === a.memoizedState ? Dh : Eh;
    a = c(d, e);

    if (zh) {
      f = 0;

      do {
        zh = !1;
        if (!(25 > f)) throw Error(y(301));
        f += 1;
        T = S = null;
        b.updateQueue = null;
        vh.current = Fh;
        a = c(d, e);
      } while (zh);
    }

    vh.current = Gh;
    b = null !== S && null !== S.next;
    xh = 0;
    T = S = R = null;
    yh = !1;
    if (b) throw Error(y(300));
    return a;
  }

  function Hh() {
    var a = {
      memoizedState: null,
      baseState: null,
      baseQueue: null,
      queue: null,
      next: null
    };
    null === T ? R.memoizedState = T = a : T = T.next = a;
    return T;
  }

  function Ih() {
    if (null === S) {
      var a = R.alternate;
      a = null !== a ? a.memoizedState : null;
    } else a = S.next;

    var b = null === T ? R.memoizedState : T.next;
    if (null !== b) T = b, S = a;else {
      if (null === a) throw Error(y(310));
      S = a;
      a = {
        memoizedState: S.memoizedState,
        baseState: S.baseState,
        baseQueue: S.baseQueue,
        queue: S.queue,
        next: null
      };
      null === T ? R.memoizedState = T = a : T = T.next = a;
    }
    return T;
  }

  function Jh(a, b) {
    return "function" === typeof b ? b(a) : b;
  }

  function Kh(a) {
    var b = Ih(),
        c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = S,
        e = d.baseQueue,
        f = c.pending;

    if (null !== f) {
      if (null !== e) {
        var g = e.next;
        e.next = f.next;
        f.next = g;
      }

      d.baseQueue = e = f;
      c.pending = null;
    }

    if (null !== e) {
      e = e.next;
      d = d.baseState;
      var h = g = f = null,
          k = e;

      do {
        var l = k.lane;
        if ((xh & l) === l) null !== h && (h = h.next = {
          lane: 0,
          action: k.action,
          eagerReducer: k.eagerReducer,
          eagerState: k.eagerState,
          next: null
        }), d = k.eagerReducer === a ? k.eagerState : a(d, k.action);else {
          var n = {
            lane: l,
            action: k.action,
            eagerReducer: k.eagerReducer,
            eagerState: k.eagerState,
            next: null
          };
          null === h ? (g = h = n, f = d) : h = h.next = n;
          R.lanes |= l;
          Dg |= l;
        }
        k = k.next;
      } while (null !== k && k !== e);

      null === h ? f = d : h.next = g;
      He(d, b.memoizedState) || (ug = !0);
      b.memoizedState = d;
      b.baseState = f;
      b.baseQueue = h;
      c.lastRenderedState = d;
    }

    return [b.memoizedState, c.dispatch];
  }

  function Lh(a) {
    var b = Ih(),
        c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch,
        e = c.pending,
        f = b.memoizedState;

    if (null !== e) {
      c.pending = null;
      var g = e = e.next;

      do {
        f = a(f, g.action), g = g.next;
      } while (g !== e);

      He(f, b.memoizedState) || (ug = !0);
      b.memoizedState = f;
      null === b.baseQueue && (b.baseState = f);
      c.lastRenderedState = f;
    }

    return [f, d];
  }

  function Mh(a, b, c) {
    var d = b._getVersion;
    d = d(b._source);
    var e = b._workInProgressVersionPrimary;
    if (null !== e) a = e === d;else if (a = a.mutableReadLanes, a = (xh & a) === a) b._workInProgressVersionPrimary = d, th.push(b);
    if (a) return c(b._source);
    th.push(b);
    throw Error(y(350));
  }

  function Nh(a, b, c, d) {
    var e = U;
    if (null === e) throw Error(y(349));
    var f = b._getVersion,
        g = f(b._source),
        h = vh.current,
        k = h.useState(function () {
      return Mh(e, b, c);
    }),
        l = k[1],
        n = k[0];
    k = T;
    var A = a.memoizedState,
        p = A.refs,
        C = p.getSnapshot,
        x = A.source;
    A = A.subscribe;
    var w = R;
    a.memoizedState = {
      refs: p,
      source: b,
      subscribe: d
    };
    h.useEffect(function () {
      p.getSnapshot = c;
      p.setSnapshot = l;
      var a = f(b._source);

      if (!He(g, a)) {
        a = c(b._source);
        He(n, a) || (l(a), a = Ig(w), e.mutableReadLanes |= a & e.pendingLanes);
        a = e.mutableReadLanes;
        e.entangledLanes |= a;

        for (var d = e.entanglements, h = a; 0 < h;) {
          var k = 31 - Vc(h),
              v = 1 << k;
          d[k] |= a;
          h &= ~v;
        }
      }
    }, [c, b, d]);
    h.useEffect(function () {
      return d(b._source, function () {
        var a = p.getSnapshot,
            c = p.setSnapshot;

        try {
          c(a(b._source));
          var d = Ig(w);
          e.mutableReadLanes |= d & e.pendingLanes;
        } catch (q) {
          c(function () {
            throw q;
          });
        }
      });
    }, [b, d]);
    He(C, c) && He(x, b) && He(A, d) || (a = {
      pending: null,
      dispatch: null,
      lastRenderedReducer: Jh,
      lastRenderedState: n
    }, a.dispatch = l = Oh.bind(null, R, a), k.queue = a, k.baseQueue = null, n = Mh(e, b, c), k.memoizedState = k.baseState = n);
    return n;
  }

  function Ph(a, b, c) {
    var d = Ih();
    return Nh(d, a, b, c);
  }

  function Qh(a) {
    var b = Hh();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = b.queue = {
      pending: null,
      dispatch: null,
      lastRenderedReducer: Jh,
      lastRenderedState: a
    };
    a = a.dispatch = Oh.bind(null, R, a);
    return [b.memoizedState, a];
  }

  function Rh(a, b, c, d) {
    a = {
      tag: a,
      create: b,
      destroy: c,
      deps: d,
      next: null
    };
    b = R.updateQueue;
    null === b ? (b = {
      lastEffect: null
    }, R.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
  }

  function Sh(a) {
    var b = Hh();
    a = {
      current: a
    };
    return b.memoizedState = a;
  }

  function Th() {
    return Ih().memoizedState;
  }

  function Uh(a, b, c, d) {
    var e = Hh();
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, void 0, void 0 === d ? null : d);
  }

  function Vh(a, b, c, d) {
    var e = Ih();
    d = void 0 === d ? null : d;
    var f = void 0;

    if (null !== S) {
      var g = S.memoizedState;
      f = g.destroy;

      if (null !== d && Bh(d, g.deps)) {
        Rh(b, c, f, d);
        return;
      }
    }

    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, f, d);
  }

  function Wh(a, b) {
    return Uh(516, 4, a, b);
  }

  function Xh(a, b) {
    return Vh(516, 4, a, b);
  }

  function Yh(a, b) {
    return Vh(4, 2, a, b);
  }

  function Zh(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function () {
      b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function () {
      b.current = null;
    };
  }

  function $h(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([a]) : null;
    return Vh(4, 2, Zh.bind(null, b, a), c);
  }

  function ai() {}

  function bi(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    c.memoizedState = [a, b];
    return a;
  }

  function ci(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [a, b];
    return a;
  }

  function di(a, b) {
    var c = eg();
    gg(98 > c ? 98 : c, function () {
      a(!0);
    });
    gg(97 < c ? 97 : c, function () {
      var c = wh.transition;
      wh.transition = 1;

      try {
        a(!1), b();
      } finally {
        wh.transition = c;
      }
    });
  }

  function Oh(a, b, c) {
    var d = Hg(),
        e = Ig(a),
        f = {
      lane: e,
      action: c,
      eagerReducer: null,
      eagerState: null,
      next: null
    },
        g = b.pending;
    null === g ? f.next = f : (f.next = g.next, g.next = f);
    b.pending = f;
    g = a.alternate;
    if (a === R || null !== g && g === R) zh = yh = !0;else {
      if (0 === a.lanes && (null === g || 0 === g.lanes) && (g = b.lastRenderedReducer, null !== g)) try {
        var h = b.lastRenderedState,
            k = g(h, c);
        f.eagerReducer = g;
        f.eagerState = k;
        if (He(k, h)) return;
      } catch (l) {} finally {}
      Jg(a, e, d);
    }
  }

  var Gh = {
    readContext: vg,
    useCallback: Ah,
    useContext: Ah,
    useEffect: Ah,
    useImperativeHandle: Ah,
    useLayoutEffect: Ah,
    useMemo: Ah,
    useReducer: Ah,
    useRef: Ah,
    useState: Ah,
    useDebugValue: Ah,
    useDeferredValue: Ah,
    useTransition: Ah,
    useMutableSource: Ah,
    useOpaqueIdentifier: Ah,
    unstable_isNewReconciler: !1
  },
      Dh = {
    readContext: vg,
    useCallback: function useCallback(a, b) {
      Hh().memoizedState = [a, void 0 === b ? null : b];
      return a;
    },
    useContext: vg,
    useEffect: Wh,
    useImperativeHandle: function useImperativeHandle(a, b, c) {
      c = null !== c && void 0 !== c ? c.concat([a]) : null;
      return Uh(4, 2, Zh.bind(null, b, a), c);
    },
    useLayoutEffect: function useLayoutEffect(a, b) {
      return Uh(4, 2, a, b);
    },
    useMemo: function useMemo(a, b) {
      var c = Hh();
      b = void 0 === b ? null : b;
      a = a();
      c.memoizedState = [a, b];
      return a;
    },
    useReducer: function useReducer(a, b, c) {
      var d = Hh();
      b = void 0 !== c ? c(b) : b;
      d.memoizedState = d.baseState = b;
      a = d.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: a,
        lastRenderedState: b
      };
      a = a.dispatch = Oh.bind(null, R, a);
      return [d.memoizedState, a];
    },
    useRef: Sh,
    useState: Qh,
    useDebugValue: ai,
    useDeferredValue: function useDeferredValue(a) {
      var b = Qh(a),
          c = b[0],
          d = b[1];
      Wh(function () {
        var b = wh.transition;
        wh.transition = 1;

        try {
          d(a);
        } finally {
          wh.transition = b;
        }
      }, [a]);
      return c;
    },
    useTransition: function useTransition() {
      var a = Qh(!1),
          b = a[0];
      a = di.bind(null, a[1]);
      Sh(a);
      return [a, b];
    },
    useMutableSource: function useMutableSource(a, b, c) {
      var d = Hh();
      d.memoizedState = {
        refs: {
          getSnapshot: b,
          setSnapshot: null
        },
        source: a,
        subscribe: c
      };
      return Nh(d, a, b, c);
    },
    useOpaqueIdentifier: function useOpaqueIdentifier() {
      if (lh) {
        var a = !1,
            b = uf(function () {
          a || (a = !0, c("r:" + (tf++).toString(36)));
          throw Error(y(355));
        }),
            c = Qh(b)[1];
        0 === (R.mode & 2) && (R.flags |= 516, Rh(5, function () {
          c("r:" + (tf++).toString(36));
        }, void 0, null));
        return b;
      }

      b = "r:" + (tf++).toString(36);
      Qh(b);
      return b;
    },
    unstable_isNewReconciler: !1
  },
      Eh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Kh,
    useRef: Th,
    useState: function useState() {
      return Kh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function useDeferredValue(a) {
      var b = Kh(Jh),
          c = b[0],
          d = b[1];
      Xh(function () {
        var b = wh.transition;
        wh.transition = 1;

        try {
          d(a);
        } finally {
          wh.transition = b;
        }
      }, [a]);
      return c;
    },
    useTransition: function useTransition() {
      var a = Kh(Jh)[0];
      return [Th().current, a];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function useOpaqueIdentifier() {
      return Kh(Jh)[0];
    },
    unstable_isNewReconciler: !1
  },
      Fh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Lh,
    useRef: Th,
    useState: function useState() {
      return Lh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function useDeferredValue(a) {
      var b = Lh(Jh),
          c = b[0],
          d = b[1];
      Xh(function () {
        var b = wh.transition;
        wh.transition = 1;

        try {
          d(a);
        } finally {
          wh.transition = b;
        }
      }, [a]);
      return c;
    },
    useTransition: function useTransition() {
      var a = Lh(Jh)[0];
      return [Th().current, a];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function useOpaqueIdentifier() {
      return Lh(Jh)[0];
    },
    unstable_isNewReconciler: !1
  },
      ei = ra.ReactCurrentOwner,
      ug = !1;

  function fi(a, b, c, d) {
    b.child = null === a ? Zg(b, null, c, d) : Yg(b, a.child, c, d);
  }

  function gi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    tg(b, e);
    d = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, d, e);
    return b.child;
  }

  function ii(a, b, c, d, e, f) {
    if (null === a) {
      var g = c.type;
      if ("function" === typeof g && !ji(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, ki(a, b, g, d, e, f);
      a = Vg(c.type, null, d, b, b.mode, f);
      a.ref = b.ref;
      a.return = b;
      return b.child = a;
    }

    g = a.child;
    if (0 === (e & f) && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : Je, c(e, d) && a.ref === b.ref)) return hi(a, b, f);
    b.flags |= 1;
    a = Tg(g, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
  }

  function ki(a, b, c, d, e, f) {
    if (null !== a && Je(a.memoizedProps, d) && a.ref === b.ref) if (ug = !1, 0 !== (f & e)) 0 !== (a.flags & 16384) && (ug = !0);else return b.lanes = a.lanes, hi(a, b, f);
    return li(a, b, c, d, f);
  }

  function mi(a, b, c) {
    var d = b.pendingProps,
        e = d.children,
        f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode || "unstable-defer-without-hiding" === d.mode) {
      if (0 === (b.mode & 4)) b.memoizedState = {
        baseLanes: 0
      }, ni(b, c);else if (0 !== (c & 1073741824)) b.memoizedState = {
        baseLanes: 0
      }, ni(b, null !== f ? f.baseLanes : c);else return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
        baseLanes: a
      }, ni(b, a), null;
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, ni(b, d);
    fi(a, b, e, c);
    return b.child;
  }

  function oi(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 128;
  }

  function li(a, b, c, d, e) {
    var f = Ff(c) ? Df : M.current;
    f = Ef(b, f);
    tg(b, e);
    c = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, c, e);
    return b.child;
  }

  function pi(a, b, c, d, e) {
    if (Ff(c)) {
      var f = !0;
      Jf(b);
    } else f = !1;

    tg(b, e);
    if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), Mg(b, c, d), Og(b, c, d, e), d = !0;else if (null === a) {
      var g = b.stateNode,
          h = b.memoizedProps;
      g.props = h;
      var k = g.context,
          l = c.contextType;
      "object" === typeof l && null !== l ? l = vg(l) : (l = Ff(c) ? Df : M.current, l = Ef(b, l));
      var n = c.getDerivedStateFromProps,
          A = "function" === typeof n || "function" === typeof g.getSnapshotBeforeUpdate;
      A || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Ng(b, g, d, l);
      wg = !1;
      var p = b.memoizedState;
      g.state = p;
      Cg(b, d, g, e);
      k = b.memoizedState;
      h !== d || p !== k || N.current || wg ? ("function" === typeof n && (Gg(b, c, n, d), k = b.memoizedState), (h = wg || Lg(b, c, h, d, p, k, l)) ? (A || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4)) : ("function" === typeof g.componentDidMount && (b.flags |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4), d = !1);
    } else {
      g = b.stateNode;
      yg(a, b);
      h = b.memoizedProps;
      l = b.type === b.elementType ? h : lg(b.type, h);
      g.props = l;
      A = b.pendingProps;
      p = g.context;
      k = c.contextType;
      "object" === typeof k && null !== k ? k = vg(k) : (k = Ff(c) ? Df : M.current, k = Ef(b, k));
      var C = c.getDerivedStateFromProps;
      (n = "function" === typeof C || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== A || p !== k) && Ng(b, g, d, k);
      wg = !1;
      p = b.memoizedState;
      g.state = p;
      Cg(b, d, g, e);
      var x = b.memoizedState;
      h !== A || p !== x || N.current || wg ? ("function" === typeof C && (Gg(b, c, C, d), x = b.memoizedState), (l = wg || Lg(b, c, l, d, p, x, k)) ? (n || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), d = !1);
    }
    return qi(a, b, c, d, f, e);
  }

  function qi(a, b, c, d, e, f) {
    oi(a, b);
    var g = 0 !== (b.flags & 64);
    if (!d && !g) return e && Kf(b, c, !1), hi(a, b, f);
    d = b.stateNode;
    ei.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = Yg(b, a.child, null, f), b.child = Yg(b, null, h, f)) : fi(a, b, h, f);
    b.memoizedState = d.state;
    e && Kf(b, c, !0);
    return b.child;
  }

  function ri(a) {
    var b = a.stateNode;
    b.pendingContext ? Hf(a, b.pendingContext, b.pendingContext !== b.context) : b.context && Hf(a, b.context, !1);
    eh(a, b.containerInfo);
  }

  var si = {
    dehydrated: null,
    retryLane: 0
  };

  function ti(a, b, c) {
    var d = b.pendingProps,
        e = P.current,
        f = !1,
        g;
    (g = 0 !== (b.flags & 64)) || (g = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    g ? (f = !0, b.flags &= -65) : null !== a && null === a.memoizedState || void 0 === d.fallback || !0 === d.unstable_avoidThisFallback || (e |= 1);
    I(P, e & 1);

    if (null === a) {
      void 0 !== d.fallback && ph(b);
      a = d.children;
      e = d.fallback;
      if (f) return a = ui(b, a, e, c), b.child.memoizedState = {
        baseLanes: c
      }, b.memoizedState = si, a;
      if ("number" === typeof d.unstable_expectedLoadTime) return a = ui(b, a, e, c), b.child.memoizedState = {
        baseLanes: c
      }, b.memoizedState = si, b.lanes = 33554432, a;
      c = vi({
        mode: "visible",
        children: a
      }, b.mode, c, null);
      c.return = b;
      return b.child = c;
    }

    if (null !== a.memoizedState) {
      if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
        baseLanes: c
      } : {
        baseLanes: e.baseLanes | c
      }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
      c = xi(a, b, d.children, c);
      b.memoizedState = null;
      return c;
    }

    if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
      baseLanes: c
    } : {
      baseLanes: e.baseLanes | c
    }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
    c = xi(a, b, d.children, c);
    b.memoizedState = null;
    return c;
  }

  function ui(a, b, c, d) {
    var e = a.mode,
        f = a.child;
    b = {
      mode: "hidden",
      children: b
    };
    0 === (e & 2) && null !== f ? (f.childLanes = 0, f.pendingProps = b) : f = vi(b, e, 0, null);
    c = Xg(c, e, d, null);
    f.return = a;
    c.return = a;
    f.sibling = c;
    a.child = f;
    return c;
  }

  function xi(a, b, c, d) {
    var e = a.child;
    a = e.sibling;
    c = Tg(e, {
      mode: "visible",
      children: c
    });
    0 === (b.mode & 2) && (c.lanes = d);
    c.return = b;
    c.sibling = null;
    null !== a && (a.nextEffect = null, a.flags = 8, b.firstEffect = b.lastEffect = a);
    return b.child = c;
  }

  function wi(a, b, c, d, e) {
    var f = b.mode,
        g = a.child;
    a = g.sibling;
    var h = {
      mode: "hidden",
      children: c
    };
    0 === (f & 2) && b.child !== g ? (c = b.child, c.childLanes = 0, c.pendingProps = h, g = c.lastEffect, null !== g ? (b.firstEffect = c.firstEffect, b.lastEffect = g, g.nextEffect = null) : b.firstEffect = b.lastEffect = null) : c = Tg(g, h);
    null !== a ? d = Tg(a, d) : (d = Xg(d, f, e, null), d.flags |= 2);
    d.return = b;
    c.return = b;
    c.sibling = d;
    b.child = c;
    return d;
  }

  function yi(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    sg(a.return, b);
  }

  function zi(a, b, c, d, e, f) {
    var g = a.memoizedState;
    null === g ? a.memoizedState = {
      isBackwards: b,
      rendering: null,
      renderingStartTime: 0,
      last: d,
      tail: c,
      tailMode: e,
      lastEffect: f
    } : (g.isBackwards = b, g.rendering = null, g.renderingStartTime = 0, g.last = d, g.tail = c, g.tailMode = e, g.lastEffect = f);
  }

  function Ai(a, b, c) {
    var d = b.pendingProps,
        e = d.revealOrder,
        f = d.tail;
    fi(a, b, d.children, c);
    d = P.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 64;else {
      if (null !== a && 0 !== (a.flags & 64)) a: for (a = b.child; null !== a;) {
        if (13 === a.tag) null !== a.memoizedState && yi(a, c);else if (19 === a.tag) yi(a, c);else if (null !== a.child) {
          a.child.return = a;
          a = a.child;
          continue;
        }
        if (a === b) break a;

        for (; null === a.sibling;) {
          if (null === a.return || a.return === b) break a;
          a = a.return;
        }

        a.sibling.return = a.return;
        a = a.sibling;
      }
      d &= 1;
    }
    I(P, d);
    if (0 === (b.mode & 2)) b.memoizedState = null;else switch (e) {
      case "forwards":
        c = b.child;

        for (e = null; null !== c;) {
          a = c.alternate, null !== a && null === ih(a) && (e = c), c = c.sibling;
        }

        c = e;
        null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
        zi(b, !1, e, c, f, b.lastEffect);
        break;

      case "backwards":
        c = null;
        e = b.child;

        for (b.child = null; null !== e;) {
          a = e.alternate;

          if (null !== a && null === ih(a)) {
            b.child = e;
            break;
          }

          a = e.sibling;
          e.sibling = c;
          c = e;
          e = a;
        }

        zi(b, !0, c, null, f, b.lastEffect);
        break;

      case "together":
        zi(b, !1, null, null, void 0, b.lastEffect);
        break;

      default:
        b.memoizedState = null;
    }
    return b.child;
  }

  function hi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    Dg |= b.lanes;

    if (0 !== (c & b.childLanes)) {
      if (null !== a && b.child !== a.child) throw Error(y(153));

      if (null !== b.child) {
        a = b.child;
        c = Tg(a, a.pendingProps);
        b.child = c;

        for (c.return = b; null !== a.sibling;) {
          a = a.sibling, c = c.sibling = Tg(a, a.pendingProps), c.return = b;
        }

        c.sibling = null;
      }

      return b.child;
    }

    return null;
  }

  var Bi, Ci, Di, Ei;

  Bi = function Bi(a, b) {
    for (var c = b.child; null !== c;) {
      if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);else if (4 !== c.tag && null !== c.child) {
        c.child.return = c;
        c = c.child;
        continue;
      }
      if (c === b) break;

      for (; null === c.sibling;) {
        if (null === c.return || c.return === b) return;
        c = c.return;
      }

      c.sibling.return = c.return;
      c = c.sibling;
    }
  };

  Ci = function Ci() {};

  Di = function Di(a, b, c, d) {
    var e = a.memoizedProps;

    if (e !== d) {
      a = b.stateNode;
      dh(ah.current);
      var f = null;

      switch (c) {
        case "input":
          e = Ya(a, e);
          d = Ya(a, d);
          f = [];
          break;

        case "option":
          e = eb(a, e);
          d = eb(a, d);
          f = [];
          break;

        case "select":
          e = m({}, e, {
            value: void 0
          });
          d = m({}, d, {
            value: void 0
          });
          f = [];
          break;

        case "textarea":
          e = gb(a, e);
          d = gb(a, d);
          f = [];
          break;

        default:
          "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = jf);
      }

      vb(c, d);
      var g;
      c = null;

      for (l in e) {
        if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) if ("style" === l) {
          var h = e[l];

          for (g in h) {
            h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
          }
        } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && (ca.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
      }

      for (l in d) {
        var k = d[l];
        h = null != e ? e[l] : void 0;
        if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) if ("style" === l) {
          if (h) {
            for (g in h) {
              !h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
            }

            for (g in k) {
              k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
            }
          } else c || (f || (f = []), f.push(l, c)), c = k;
        } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && (ca.hasOwnProperty(l) ? (null != k && "onScroll" === l && G("scroll", a), f || h === k || (f = [])) : "object" === typeof k && null !== k && k.$$typeof === Ga ? k.toString() : (f = f || []).push(l, k));
      }

      c && (f = f || []).push("style", c);
      var l = f;
      if (b.updateQueue = l) b.flags |= 4;
    }
  };

  Ei = function Ei(a, b, c, d) {
    c !== d && (b.flags |= 4);
  };

  function Fi(a, b) {
    if (!lh) switch (a.tailMode) {
      case "hidden":
        b = a.tail;

        for (var c = null; null !== b;) {
          null !== b.alternate && (c = b), b = b.sibling;
        }

        null === c ? a.tail = null : c.sibling = null;
        break;

      case "collapsed":
        c = a.tail;

        for (var d = null; null !== c;) {
          null !== c.alternate && (d = c), c = c.sibling;
        }

        null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
  }

  function Gi(a, b, c) {
    var d = b.pendingProps;

    switch (b.tag) {
      case 2:
      case 16:
      case 15:
      case 0:
      case 11:
      case 7:
      case 8:
      case 12:
      case 9:
      case 14:
        return null;

      case 1:
        return Ff(b.type) && Gf(), null;

      case 3:
        fh();
        H(N);
        H(M);
        uh();
        d = b.stateNode;
        d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
        if (null === a || null === a.child) rh(b) ? b.flags |= 4 : d.hydrate || (b.flags |= 256);
        Ci(b);
        return null;

      case 5:
        hh(b);
        var e = dh(ch.current);
        c = b.type;
        if (null !== a && null != b.stateNode) Di(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 128);else {
          if (!d) {
            if (null === b.stateNode) throw Error(y(166));
            return null;
          }

          a = dh(ah.current);

          if (rh(b)) {
            d = b.stateNode;
            c = b.type;
            var f = b.memoizedProps;
            d[wf] = b;
            d[xf] = f;

            switch (c) {
              case "dialog":
                G("cancel", d);
                G("close", d);
                break;

              case "iframe":
              case "object":
              case "embed":
                G("load", d);
                break;

              case "video":
              case "audio":
                for (a = 0; a < Xe.length; a++) {
                  G(Xe[a], d);
                }

                break;

              case "source":
                G("error", d);
                break;

              case "img":
              case "image":
              case "link":
                G("error", d);
                G("load", d);
                break;

              case "details":
                G("toggle", d);
                break;

              case "input":
                Za(d, f);
                G("invalid", d);
                break;

              case "select":
                d._wrapperState = {
                  wasMultiple: !!f.multiple
                };
                G("invalid", d);
                break;

              case "textarea":
                hb(d, f), G("invalid", d);
            }

            vb(c, f);
            a = null;

            for (var g in f) {
              f.hasOwnProperty(g) && (e = f[g], "children" === g ? "string" === typeof e ? d.textContent !== e && (a = ["children", e]) : "number" === typeof e && d.textContent !== "" + e && (a = ["children", "" + e]) : ca.hasOwnProperty(g) && null != e && "onScroll" === g && G("scroll", d));
            }

            switch (c) {
              case "input":
                Va(d);
                cb(d, f, !0);
                break;

              case "textarea":
                Va(d);
                jb(d);
                break;

              case "select":
              case "option":
                break;

              default:
                "function" === typeof f.onClick && (d.onclick = jf);
            }

            d = a;
            b.updateQueue = d;
            null !== d && (b.flags |= 4);
          } else {
            g = 9 === e.nodeType ? e : e.ownerDocument;
            a === kb.html && (a = lb(c));
            a === kb.html ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
              is: d.is
            }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
            a[wf] = b;
            a[xf] = d;
            Bi(a, b, !1, !1);
            b.stateNode = a;
            g = wb(c, d);

            switch (c) {
              case "dialog":
                G("cancel", a);
                G("close", a);
                e = d;
                break;

              case "iframe":
              case "object":
              case "embed":
                G("load", a);
                e = d;
                break;

              case "video":
              case "audio":
                for (e = 0; e < Xe.length; e++) {
                  G(Xe[e], a);
                }

                e = d;
                break;

              case "source":
                G("error", a);
                e = d;
                break;

              case "img":
              case "image":
              case "link":
                G("error", a);
                G("load", a);
                e = d;
                break;

              case "details":
                G("toggle", a);
                e = d;
                break;

              case "input":
                Za(a, d);
                e = Ya(a, d);
                G("invalid", a);
                break;

              case "option":
                e = eb(a, d);
                break;

              case "select":
                a._wrapperState = {
                  wasMultiple: !!d.multiple
                };
                e = m({}, d, {
                  value: void 0
                });
                G("invalid", a);
                break;

              case "textarea":
                hb(a, d);
                e = gb(a, d);
                G("invalid", a);
                break;

              default:
                e = d;
            }

            vb(c, e);
            var h = e;

            for (f in h) {
              if (h.hasOwnProperty(f)) {
                var k = h[f];
                "style" === f ? tb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && ob(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && pb(a, k) : "number" === typeof k && pb(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (ca.hasOwnProperty(f) ? null != k && "onScroll" === f && G("scroll", a) : null != k && qa(a, f, k, g));
              }
            }

            switch (c) {
              case "input":
                Va(a);
                cb(a, d, !1);
                break;

              case "textarea":
                Va(a);
                jb(a);
                break;

              case "option":
                null != d.value && a.setAttribute("value", "" + Sa(d.value));
                break;

              case "select":
                a.multiple = !!d.multiple;
                f = d.value;
                null != f ? fb(a, !!d.multiple, f, !1) : null != d.defaultValue && fb(a, !!d.multiple, d.defaultValue, !0);
                break;

              default:
                "function" === typeof e.onClick && (a.onclick = jf);
            }

            mf(c, d) && (b.flags |= 4);
          }

          null !== b.ref && (b.flags |= 128);
        }
        return null;

      case 6:
        if (a && null != b.stateNode) Ei(a, b, a.memoizedProps, d);else {
          if ("string" !== typeof d && null === b.stateNode) throw Error(y(166));
          c = dh(ch.current);
          dh(ah.current);
          rh(b) ? (d = b.stateNode, c = b.memoizedProps, d[wf] = b, d.nodeValue !== c && (b.flags |= 4)) : (d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[wf] = b, b.stateNode = d);
        }
        return null;

      case 13:
        H(P);
        d = b.memoizedState;
        if (0 !== (b.flags & 64)) return b.lanes = c, b;
        d = null !== d;
        c = !1;
        null === a ? void 0 !== b.memoizedProps.fallback && rh(b) : c = null !== a.memoizedState;
        if (d && !c && 0 !== (b.mode & 2)) if (null === a && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== (P.current & 1)) 0 === V && (V = 3);else {
          if (0 === V || 3 === V) V = 4;
          null === U || 0 === (Dg & 134217727) && 0 === (Hi & 134217727) || Ii(U, W);
        }
        if (d || c) b.flags |= 4;
        return null;

      case 4:
        return fh(), Ci(b), null === a && cf(b.stateNode.containerInfo), null;

      case 10:
        return rg(b), null;

      case 17:
        return Ff(b.type) && Gf(), null;

      case 19:
        H(P);
        d = b.memoizedState;
        if (null === d) return null;
        f = 0 !== (b.flags & 64);
        g = d.rendering;
        if (null === g) {
          if (f) Fi(d, !1);else {
            if (0 !== V || null !== a && 0 !== (a.flags & 64)) for (a = b.child; null !== a;) {
              g = ih(a);

              if (null !== g) {
                b.flags |= 64;
                Fi(d, !1);
                f = g.updateQueue;
                null !== f && (b.updateQueue = f, b.flags |= 4);
                null === d.lastEffect && (b.firstEffect = null);
                b.lastEffect = d.lastEffect;
                d = c;

                for (c = b.child; null !== c;) {
                  f = c, a = d, f.flags &= 2, f.nextEffect = null, f.firstEffect = null, f.lastEffect = null, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                    lanes: a.lanes,
                    firstContext: a.firstContext
                  }), c = c.sibling;
                }

                I(P, P.current & 1 | 2);
                return b.child;
              }

              a = a.sibling;
            }
            null !== d.tail && O() > Ji && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
          }
        } else {
          if (!f) if (a = ih(g), null !== a) {
            if (b.flags |= 64, f = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), Fi(d, !0), null === d.tail && "hidden" === d.tailMode && !g.alternate && !lh) return b = b.lastEffect = d.lastEffect, null !== b && (b.nextEffect = null), null;
          } else 2 * O() - d.renderingStartTime > Ji && 1073741824 !== c && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
          d.isBackwards ? (g.sibling = b.child, b.child = g) : (c = d.last, null !== c ? c.sibling = g : b.child = g, d.last = g);
        }
        return null !== d.tail ? (c = d.tail, d.rendering = c, d.tail = c.sibling, d.lastEffect = b.lastEffect, d.renderingStartTime = O(), c.sibling = null, b = P.current, I(P, f ? b & 1 | 2 : b & 1), c) : null;

      case 23:
      case 24:
        return Ki(), null !== a && null !== a.memoizedState !== (null !== b.memoizedState) && "unstable-defer-without-hiding" !== d.mode && (b.flags |= 4), null;
    }

    throw Error(y(156, b.tag));
  }

  function Li(a) {
    switch (a.tag) {
      case 1:
        Ff(a.type) && Gf();
        var b = a.flags;
        return b & 4096 ? (a.flags = b & -4097 | 64, a) : null;

      case 3:
        fh();
        H(N);
        H(M);
        uh();
        b = a.flags;
        if (0 !== (b & 64)) throw Error(y(285));
        a.flags = b & -4097 | 64;
        return a;

      case 5:
        return hh(a), null;

      case 13:
        return H(P), b = a.flags, b & 4096 ? (a.flags = b & -4097 | 64, a) : null;

      case 19:
        return H(P), null;

      case 4:
        return fh(), null;

      case 10:
        return rg(a), null;

      case 23:
      case 24:
        return Ki(), null;

      default:
        return null;
    }
  }

  function Mi(a, b) {
    try {
      var c = "",
          d = b;

      do {
        c += Qa(d), d = d.return;
      } while (d);

      var e = c;
    } catch (f) {
      e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }

    return {
      value: a,
      source: b,
      stack: e
    };
  }

  function Ni(a, b) {
    try {
      console.error(b.value);
    } catch (c) {
      setTimeout(function () {
        throw c;
      });
    }
  }

  var Oi = "function" === typeof WeakMap ? WeakMap : Map;

  function Pi(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    c.payload = {
      element: null
    };
    var d = b.value;

    c.callback = function () {
      Qi || (Qi = !0, Ri = d);
      Ni(a, b);
    };

    return c;
  }

  function Si(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;

    if ("function" === typeof d) {
      var e = b.value;

      c.payload = function () {
        Ni(a, b);
        return d(e);
      };
    }

    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function () {
      "function" !== typeof d && (null === Ti ? Ti = new Set([this]) : Ti.add(this), Ni(a, b));
      var c = b.stack;
      this.componentDidCatch(b.value, {
        componentStack: null !== c ? c : ""
      });
    });
    return c;
  }

  var Ui = "function" === typeof WeakSet ? WeakSet : Set;

  function Vi(a) {
    var b = a.ref;
    if (null !== b) if ("function" === typeof b) try {
      b(null);
    } catch (c) {
      Wi(a, c);
    } else b.current = null;
  }

  function Xi(a, b) {
    switch (b.tag) {
      case 0:
      case 11:
      case 15:
      case 22:
        return;

      case 1:
        if (b.flags & 256 && null !== a) {
          var c = a.memoizedProps,
              d = a.memoizedState;
          a = b.stateNode;
          b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : lg(b.type, c), d);
          a.__reactInternalSnapshotBeforeUpdate = b;
        }

        return;

      case 3:
        b.flags & 256 && qf(b.stateNode.containerInfo);
        return;

      case 5:
      case 6:
      case 4:
      case 17:
        return;
    }

    throw Error(y(163));
  }

  function Yi(a, b, c) {
    switch (c.tag) {
      case 0:
      case 11:
      case 15:
      case 22:
        b = c.updateQueue;
        b = null !== b ? b.lastEffect : null;

        if (null !== b) {
          a = b = b.next;

          do {
            if (3 === (a.tag & 3)) {
              var d = a.create;
              a.destroy = d();
            }

            a = a.next;
          } while (a !== b);
        }

        b = c.updateQueue;
        b = null !== b ? b.lastEffect : null;

        if (null !== b) {
          a = b = b.next;

          do {
            var e = a;
            d = e.next;
            e = e.tag;
            0 !== (e & 4) && 0 !== (e & 1) && (Zi(c, a), $i(c, a));
            a = d;
          } while (a !== b);
        }

        return;

      case 1:
        a = c.stateNode;
        c.flags & 4 && (null === b ? a.componentDidMount() : (d = c.elementType === c.type ? b.memoizedProps : lg(c.type, b.memoizedProps), a.componentDidUpdate(d, b.memoizedState, a.__reactInternalSnapshotBeforeUpdate)));
        b = c.updateQueue;
        null !== b && Eg(c, b, a);
        return;

      case 3:
        b = c.updateQueue;

        if (null !== b) {
          a = null;
          if (null !== c.child) switch (c.child.tag) {
            case 5:
              a = c.child.stateNode;
              break;

            case 1:
              a = c.child.stateNode;
          }
          Eg(c, b, a);
        }

        return;

      case 5:
        a = c.stateNode;
        null === b && c.flags & 4 && mf(c.type, c.memoizedProps) && a.focus();
        return;

      case 6:
        return;

      case 4:
        return;

      case 12:
        return;

      case 13:
        null === c.memoizedState && (c = c.alternate, null !== c && (c = c.memoizedState, null !== c && (c = c.dehydrated, null !== c && Cc(c))));
        return;

      case 19:
      case 17:
      case 20:
      case 21:
      case 23:
      case 24:
        return;
    }

    throw Error(y(163));
  }

  function aj(a, b) {
    for (var c = a;;) {
      if (5 === c.tag) {
        var d = c.stateNode;
        if (b) d = d.style, "function" === typeof d.setProperty ? d.setProperty("display", "none", "important") : d.display = "none";else {
          d = c.stateNode;
          var e = c.memoizedProps.style;
          e = void 0 !== e && null !== e && e.hasOwnProperty("display") ? e.display : null;
          d.style.display = sb("display", e);
        }
      } else if (6 === c.tag) c.stateNode.nodeValue = b ? "" : c.memoizedProps;else if ((23 !== c.tag && 24 !== c.tag || null === c.memoizedState || c === a) && null !== c.child) {
        c.child.return = c;
        c = c.child;
        continue;
      }

      if (c === a) break;

      for (; null === c.sibling;) {
        if (null === c.return || c.return === a) return;
        c = c.return;
      }

      c.sibling.return = c.return;
      c = c.sibling;
    }
  }

  function bj(a, b) {
    if (Mf && "function" === typeof Mf.onCommitFiberUnmount) try {
      Mf.onCommitFiberUnmount(Lf, b);
    } catch (f) {}

    switch (b.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
      case 22:
        a = b.updateQueue;

        if (null !== a && (a = a.lastEffect, null !== a)) {
          var c = a = a.next;

          do {
            var d = c,
                e = d.destroy;
            d = d.tag;
            if (void 0 !== e) if (0 !== (d & 4)) Zi(b, c);else {
              d = b;

              try {
                e();
              } catch (f) {
                Wi(d, f);
              }
            }
            c = c.next;
          } while (c !== a);
        }

        break;

      case 1:
        Vi(b);
        a = b.stateNode;
        if ("function" === typeof a.componentWillUnmount) try {
          a.props = b.memoizedProps, a.state = b.memoizedState, a.componentWillUnmount();
        } catch (f) {
          Wi(b, f);
        }
        break;

      case 5:
        Vi(b);
        break;

      case 4:
        cj(a, b);
    }
  }

  function dj(a) {
    a.alternate = null;
    a.child = null;
    a.dependencies = null;
    a.firstEffect = null;
    a.lastEffect = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.return = null;
    a.updateQueue = null;
  }

  function ej(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
  }

  function fj(a) {
    a: {
      for (var b = a.return; null !== b;) {
        if (ej(b)) break a;
        b = b.return;
      }

      throw Error(y(160));
    }

    var c = b;
    b = c.stateNode;

    switch (c.tag) {
      case 5:
        var d = !1;
        break;

      case 3:
        b = b.containerInfo;
        d = !0;
        break;

      case 4:
        b = b.containerInfo;
        d = !0;
        break;

      default:
        throw Error(y(161));
    }

    c.flags & 16 && (pb(b, ""), c.flags &= -17);

    a: b: for (c = a;;) {
      for (; null === c.sibling;) {
        if (null === c.return || ej(c.return)) {
          c = null;
          break a;
        }

        c = c.return;
      }

      c.sibling.return = c.return;

      for (c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;) {
        if (c.flags & 2) continue b;
        if (null === c.child || 4 === c.tag) continue b;else c.child.return = c, c = c.child;
      }

      if (!(c.flags & 2)) {
        c = c.stateNode;
        break a;
      }
    }

    d ? gj(a, c, b) : hj(a, c, b);
  }

  function gj(a, b, c) {
    var d = a.tag,
        e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = jf));else if (4 !== d && (a = a.child, null !== a)) for (gj(a, b, c), a = a.sibling; null !== a;) {
      gj(a, b, c), a = a.sibling;
    }
  }

  function hj(a, b, c) {
    var d = a.tag,
        e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? c.insertBefore(a, b) : c.appendChild(a);else if (4 !== d && (a = a.child, null !== a)) for (hj(a, b, c), a = a.sibling; null !== a;) {
      hj(a, b, c), a = a.sibling;
    }
  }

  function cj(a, b) {
    for (var c = b, d = !1, e, f;;) {
      if (!d) {
        d = c.return;

        a: for (;;) {
          if (null === d) throw Error(y(160));
          e = d.stateNode;

          switch (d.tag) {
            case 5:
              f = !1;
              break a;

            case 3:
              e = e.containerInfo;
              f = !0;
              break a;

            case 4:
              e = e.containerInfo;
              f = !0;
              break a;
          }

          d = d.return;
        }

        d = !0;
      }

      if (5 === c.tag || 6 === c.tag) {
        a: for (var g = a, h = c, k = h;;) {
          if (bj(g, k), null !== k.child && 4 !== k.tag) k.child.return = k, k = k.child;else {
            if (k === h) break a;

            for (; null === k.sibling;) {
              if (null === k.return || k.return === h) break a;
              k = k.return;
            }

            k.sibling.return = k.return;
            k = k.sibling;
          }
        }

        f ? (g = e, h = c.stateNode, 8 === g.nodeType ? g.parentNode.removeChild(h) : g.removeChild(h)) : e.removeChild(c.stateNode);
      } else if (4 === c.tag) {
        if (null !== c.child) {
          e = c.stateNode.containerInfo;
          f = !0;
          c.child.return = c;
          c = c.child;
          continue;
        }
      } else if (bj(a, c), null !== c.child) {
        c.child.return = c;
        c = c.child;
        continue;
      }

      if (c === b) break;

      for (; null === c.sibling;) {
        if (null === c.return || c.return === b) return;
        c = c.return;
        4 === c.tag && (d = !1);
      }

      c.sibling.return = c.return;
      c = c.sibling;
    }
  }

  function ij(a, b) {
    switch (b.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
      case 22:
        var c = b.updateQueue;
        c = null !== c ? c.lastEffect : null;

        if (null !== c) {
          var d = c = c.next;

          do {
            3 === (d.tag & 3) && (a = d.destroy, d.destroy = void 0, void 0 !== a && a()), d = d.next;
          } while (d !== c);
        }

        return;

      case 1:
        return;

      case 5:
        c = b.stateNode;

        if (null != c) {
          d = b.memoizedProps;
          var e = null !== a ? a.memoizedProps : d;
          a = b.type;
          var f = b.updateQueue;
          b.updateQueue = null;

          if (null !== f) {
            c[xf] = d;
            "input" === a && "radio" === d.type && null != d.name && $a(c, d);
            wb(a, e);
            b = wb(a, d);

            for (e = 0; e < f.length; e += 2) {
              var g = f[e],
                  h = f[e + 1];
              "style" === g ? tb(c, h) : "dangerouslySetInnerHTML" === g ? ob(c, h) : "children" === g ? pb(c, h) : qa(c, g, h, b);
            }

            switch (a) {
              case "input":
                ab(c, d);
                break;

              case "textarea":
                ib(c, d);
                break;

              case "select":
                a = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, f = d.value, null != f ? fb(c, !!d.multiple, f, !1) : a !== !!d.multiple && (null != d.defaultValue ? fb(c, !!d.multiple, d.defaultValue, !0) : fb(c, !!d.multiple, d.multiple ? [] : "", !1));
            }
          }
        }

        return;

      case 6:
        if (null === b.stateNode) throw Error(y(162));
        b.stateNode.nodeValue = b.memoizedProps;
        return;

      case 3:
        c = b.stateNode;
        c.hydrate && (c.hydrate = !1, Cc(c.containerInfo));
        return;

      case 12:
        return;

      case 13:
        null !== b.memoizedState && (jj = O(), aj(b.child, !0));
        kj(b);
        return;

      case 19:
        kj(b);
        return;

      case 17:
        return;

      case 23:
      case 24:
        aj(b, null !== b.memoizedState);
        return;
    }

    throw Error(y(163));
  }

  function kj(a) {
    var b = a.updateQueue;

    if (null !== b) {
      a.updateQueue = null;
      var c = a.stateNode;
      null === c && (c = a.stateNode = new Ui());
      b.forEach(function (b) {
        var d = lj.bind(null, a, b);
        c.has(b) || (c.add(b), b.then(d, d));
      });
    }
  }

  function mj(a, b) {
    return null !== a && (a = a.memoizedState, null === a || null !== a.dehydrated) ? (b = b.memoizedState, null !== b && null === b.dehydrated) : !1;
  }

  var nj = Math.ceil,
      oj = ra.ReactCurrentDispatcher,
      pj = ra.ReactCurrentOwner,
      X = 0,
      U = null,
      Y = null,
      W = 0,
      qj = 0,
      rj = Bf(0),
      V = 0,
      sj = null,
      tj = 0,
      Dg = 0,
      Hi = 0,
      uj = 0,
      vj = null,
      jj = 0,
      Ji = Infinity;

  function wj() {
    Ji = O() + 500;
  }

  var Z = null,
      Qi = !1,
      Ri = null,
      Ti = null,
      xj = !1,
      yj = null,
      zj = 90,
      Aj = [],
      Bj = [],
      Cj = null,
      Dj = 0,
      Ej = null,
      Fj = -1,
      Gj = 0,
      Hj = 0,
      Ij = null,
      Jj = !1;

  function Hg() {
    return 0 !== (X & 48) ? O() : -1 !== Fj ? Fj : Fj = O();
  }

  function Ig(a) {
    a = a.mode;
    if (0 === (a & 2)) return 1;
    if (0 === (a & 4)) return 99 === eg() ? 1 : 2;
    0 === Gj && (Gj = tj);

    if (0 !== kg.transition) {
      0 !== Hj && (Hj = null !== vj ? vj.pendingLanes : 0);
      a = Gj;
      var b = 4186112 & ~Hj;
      b &= -b;
      0 === b && (a = 4186112 & ~a, b = a & -a, 0 === b && (b = 8192));
      return b;
    }

    a = eg();
    0 !== (X & 4) && 98 === a ? a = Xc(12, Gj) : (a = Sc(a), a = Xc(a, Gj));
    return a;
  }

  function Jg(a, b, c) {
    if (50 < Dj) throw Dj = 0, Ej = null, Error(y(185));
    a = Kj(a, b);
    if (null === a) return null;
    $c(a, b, c);
    a === U && (Hi |= b, 4 === V && Ii(a, W));
    var d = eg();
    1 === b ? 0 !== (X & 8) && 0 === (X & 48) ? Lj(a) : (Mj(a, c), 0 === X && (wj(), ig())) : (0 === (X & 4) || 98 !== d && 99 !== d || (null === Cj ? Cj = new Set([a]) : Cj.add(a)), Mj(a, c));
    vj = a;
  }

  function Kj(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;

    for (a = a.return; null !== a;) {
      a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    }

    return 3 === c.tag ? c.stateNode : null;
  }

  function Mj(a, b) {
    for (var c = a.callbackNode, d = a.suspendedLanes, e = a.pingedLanes, f = a.expirationTimes, g = a.pendingLanes; 0 < g;) {
      var h = 31 - Vc(g),
          k = 1 << h,
          l = f[h];

      if (-1 === l) {
        if (0 === (k & d) || 0 !== (k & e)) {
          l = b;
          Rc(k);
          var n = F;
          f[h] = 10 <= n ? l + 250 : 6 <= n ? l + 5E3 : -1;
        }
      } else l <= b && (a.expiredLanes |= k);

      g &= ~k;
    }

    d = Uc(a, a === U ? W : 0);
    b = F;
    if (0 === d) null !== c && (c !== Zf && Pf(c), a.callbackNode = null, a.callbackPriority = 0);else {
      if (null !== c) {
        if (a.callbackPriority === b) return;
        c !== Zf && Pf(c);
      }

      15 === b ? (c = Lj.bind(null, a), null === ag ? (ag = [c], bg = Of(Uf, jg)) : ag.push(c), c = Zf) : 14 === b ? c = hg(99, Lj.bind(null, a)) : (c = Tc(b), c = hg(c, Nj.bind(null, a)));
      a.callbackPriority = b;
      a.callbackNode = c;
    }
  }

  function Nj(a) {
    Fj = -1;
    Hj = Gj = 0;
    if (0 !== (X & 48)) throw Error(y(327));
    var b = a.callbackNode;
    if (Oj() && a.callbackNode !== b) return null;
    var c = Uc(a, a === U ? W : 0);
    if (0 === c) return null;
    var d = c;
    var e = X;
    X |= 16;
    var f = Pj();
    if (U !== a || W !== d) wj(), Qj(a, d);

    do {
      try {
        Rj();
        break;
      } catch (h) {
        Sj(a, h);
      }
    } while (1);

    qg();
    oj.current = f;
    X = e;
    null !== Y ? d = 0 : (U = null, W = 0, d = V);
    if (0 !== (tj & Hi)) Qj(a, 0);else if (0 !== d) {
      2 === d && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), c = Wc(a), 0 !== c && (d = Tj(a, c)));
      if (1 === d) throw b = sj, Qj(a, 0), Ii(a, c), Mj(a, O()), b;
      a.finishedWork = a.current.alternate;
      a.finishedLanes = c;

      switch (d) {
        case 0:
        case 1:
          throw Error(y(345));

        case 2:
          Uj(a);
          break;

        case 3:
          Ii(a, c);

          if ((c & 62914560) === c && (d = jj + 500 - O(), 10 < d)) {
            if (0 !== Uc(a, 0)) break;
            e = a.suspendedLanes;

            if ((e & c) !== c) {
              Hg();
              a.pingedLanes |= a.suspendedLanes & e;
              break;
            }

            a.timeoutHandle = of(Uj.bind(null, a), d);
            break;
          }

          Uj(a);
          break;

        case 4:
          Ii(a, c);
          if ((c & 4186112) === c) break;
          d = a.eventTimes;

          for (e = -1; 0 < c;) {
            var g = 31 - Vc(c);
            f = 1 << g;
            g = d[g];
            g > e && (e = g);
            c &= ~f;
          }

          c = e;
          c = O() - c;
          c = (120 > c ? 120 : 480 > c ? 480 : 1080 > c ? 1080 : 1920 > c ? 1920 : 3E3 > c ? 3E3 : 4320 > c ? 4320 : 1960 * nj(c / 1960)) - c;

          if (10 < c) {
            a.timeoutHandle = of(Uj.bind(null, a), c);
            break;
          }

          Uj(a);
          break;

        case 5:
          Uj(a);
          break;

        default:
          throw Error(y(329));
      }
    }
    Mj(a, O());
    return a.callbackNode === b ? Nj.bind(null, a) : null;
  }

  function Ii(a, b) {
    b &= ~uj;
    b &= ~Hi;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;

    for (a = a.expirationTimes; 0 < b;) {
      var c = 31 - Vc(b),
          d = 1 << c;
      a[c] = -1;
      b &= ~d;
    }
  }

  function Lj(a) {
    if (0 !== (X & 48)) throw Error(y(327));
    Oj();

    if (a === U && 0 !== (a.expiredLanes & W)) {
      var b = W;
      var c = Tj(a, b);
      0 !== (tj & Hi) && (b = Uc(a, b), c = Tj(a, b));
    } else b = Uc(a, 0), c = Tj(a, b);

    0 !== a.tag && 2 === c && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), b = Wc(a), 0 !== b && (c = Tj(a, b)));
    if (1 === c) throw c = sj, Qj(a, 0), Ii(a, b), Mj(a, O()), c;
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    Uj(a);
    Mj(a, O());
    return null;
  }

  function Vj() {
    if (null !== Cj) {
      var a = Cj;
      Cj = null;
      a.forEach(function (a) {
        a.expiredLanes |= 24 & a.pendingLanes;
        Mj(a, O());
      });
    }

    ig();
  }

  function Wj(a, b) {
    var c = X;
    X |= 1;

    try {
      return a(b);
    } finally {
      X = c, 0 === X && (wj(), ig());
    }
  }

  function Xj(a, b) {
    var c = X;
    X &= -2;
    X |= 8;

    try {
      return a(b);
    } finally {
      X = c, 0 === X && (wj(), ig());
    }
  }

  function ni(a, b) {
    I(rj, qj);
    qj |= b;
    tj |= b;
  }

  function Ki() {
    qj = rj.current;
    H(rj);
  }

  function Qj(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, pf(c));
    if (null !== Y) for (c = Y.return; null !== c;) {
      var d = c;

      switch (d.tag) {
        case 1:
          d = d.type.childContextTypes;
          null !== d && void 0 !== d && Gf();
          break;

        case 3:
          fh();
          H(N);
          H(M);
          uh();
          break;

        case 5:
          hh(d);
          break;

        case 4:
          fh();
          break;

        case 13:
          H(P);
          break;

        case 19:
          H(P);
          break;

        case 10:
          rg(d);
          break;

        case 23:
        case 24:
          Ki();
      }

      c = c.return;
    }
    U = a;
    Y = Tg(a.current, null);
    W = qj = tj = b;
    V = 0;
    sj = null;
    uj = Hi = Dg = 0;
  }

  function Sj(a, b) {
    do {
      var c = Y;

      try {
        qg();
        vh.current = Gh;

        if (yh) {
          for (var d = R.memoizedState; null !== d;) {
            var e = d.queue;
            null !== e && (e.pending = null);
            d = d.next;
          }

          yh = !1;
        }

        xh = 0;
        T = S = R = null;
        zh = !1;
        pj.current = null;

        if (null === c || null === c.return) {
          V = 1;
          sj = b;
          Y = null;
          break;
        }

        a: {
          var f = a,
              g = c.return,
              h = c,
              k = b;
          b = W;
          h.flags |= 2048;
          h.firstEffect = h.lastEffect = null;

          if (null !== k && "object" === typeof k && "function" === typeof k.then) {
            var l = k;

            if (0 === (h.mode & 2)) {
              var n = h.alternate;
              n ? (h.updateQueue = n.updateQueue, h.memoizedState = n.memoizedState, h.lanes = n.lanes) : (h.updateQueue = null, h.memoizedState = null);
            }

            var A = 0 !== (P.current & 1),
                p = g;

            do {
              var C;

              if (C = 13 === p.tag) {
                var x = p.memoizedState;
                if (null !== x) C = null !== x.dehydrated ? !0 : !1;else {
                  var w = p.memoizedProps;
                  C = void 0 === w.fallback ? !1 : !0 !== w.unstable_avoidThisFallback ? !0 : A ? !1 : !0;
                }
              }

              if (C) {
                var z = p.updateQueue;

                if (null === z) {
                  var u = new Set();
                  u.add(l);
                  p.updateQueue = u;
                } else z.add(l);

                if (0 === (p.mode & 2)) {
                  p.flags |= 64;
                  h.flags |= 16384;
                  h.flags &= -2981;
                  if (1 === h.tag) if (null === h.alternate) h.tag = 17;else {
                    var t = zg(-1, 1);
                    t.tag = 2;
                    Ag(h, t);
                  }
                  h.lanes |= 1;
                  break a;
                }

                k = void 0;
                h = b;
                var q = f.pingCache;
                null === q ? (q = f.pingCache = new Oi(), k = new Set(), q.set(l, k)) : (k = q.get(l), void 0 === k && (k = new Set(), q.set(l, k)));

                if (!k.has(h)) {
                  k.add(h);
                  var v = Yj.bind(null, f, l, h);
                  l.then(v, v);
                }

                p.flags |= 4096;
                p.lanes = b;
                break a;
              }

              p = p.return;
            } while (null !== p);

            k = Error((Ra(h.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.");
          }

          5 !== V && (V = 2);
          k = Mi(k, h);
          p = g;

          do {
            switch (p.tag) {
              case 3:
                f = k;
                p.flags |= 4096;
                b &= -b;
                p.lanes |= b;
                var J = Pi(p, f, b);
                Bg(p, J);
                break a;

              case 1:
                f = k;
                var K = p.type,
                    Q = p.stateNode;

                if (0 === (p.flags & 64) && ("function" === typeof K.getDerivedStateFromError || null !== Q && "function" === typeof Q.componentDidCatch && (null === Ti || !Ti.has(Q)))) {
                  p.flags |= 4096;
                  b &= -b;
                  p.lanes |= b;
                  var L = Si(p, f, b);
                  Bg(p, L);
                  break a;
                }

            }

            p = p.return;
          } while (null !== p);
        }

        Zj(c);
      } catch (va) {
        b = va;
        Y === c && null !== c && (Y = c = c.return);
        continue;
      }

      break;
    } while (1);
  }

  function Pj() {
    var a = oj.current;
    oj.current = Gh;
    return null === a ? Gh : a;
  }

  function Tj(a, b) {
    var c = X;
    X |= 16;
    var d = Pj();
    U === a && W === b || Qj(a, b);

    do {
      try {
        ak();
        break;
      } catch (e) {
        Sj(a, e);
      }
    } while (1);

    qg();
    X = c;
    oj.current = d;
    if (null !== Y) throw Error(y(261));
    U = null;
    W = 0;
    return V;
  }

  function ak() {
    for (; null !== Y;) {
      bk(Y);
    }
  }

  function Rj() {
    for (; null !== Y && !Qf();) {
      bk(Y);
    }
  }

  function bk(a) {
    var b = ck(a.alternate, a, qj);
    a.memoizedProps = a.pendingProps;
    null === b ? Zj(a) : Y = b;
    pj.current = null;
  }

  function Zj(a) {
    var b = a;

    do {
      var c = b.alternate;
      a = b.return;

      if (0 === (b.flags & 2048)) {
        c = Gi(c, b, qj);

        if (null !== c) {
          Y = c;
          return;
        }

        c = b;

        if (24 !== c.tag && 23 !== c.tag || null === c.memoizedState || 0 !== (qj & 1073741824) || 0 === (c.mode & 4)) {
          for (var d = 0, e = c.child; null !== e;) {
            d |= e.lanes | e.childLanes, e = e.sibling;
          }

          c.childLanes = d;
        }

        null !== a && 0 === (a.flags & 2048) && (null === a.firstEffect && (a.firstEffect = b.firstEffect), null !== b.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = b.firstEffect), a.lastEffect = b.lastEffect), 1 < b.flags && (null !== a.lastEffect ? a.lastEffect.nextEffect = b : a.firstEffect = b, a.lastEffect = b));
      } else {
        c = Li(b);

        if (null !== c) {
          c.flags &= 2047;
          Y = c;
          return;
        }

        null !== a && (a.firstEffect = a.lastEffect = null, a.flags |= 2048);
      }

      b = b.sibling;

      if (null !== b) {
        Y = b;
        return;
      }

      Y = b = a;
    } while (null !== b);

    0 === V && (V = 5);
  }

  function Uj(a) {
    var b = eg();
    gg(99, dk.bind(null, a, b));
    return null;
  }

  function dk(a, b) {
    do {
      Oj();
    } while (null !== yj);

    if (0 !== (X & 48)) throw Error(y(327));
    var c = a.finishedWork;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error(y(177));
    a.callbackNode = null;
    var d = c.lanes | c.childLanes,
        e = d,
        f = a.pendingLanes & ~e;
    a.pendingLanes = e;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= e;
    a.mutableReadLanes &= e;
    a.entangledLanes &= e;
    e = a.entanglements;

    for (var g = a.eventTimes, h = a.expirationTimes; 0 < f;) {
      var k = 31 - Vc(f),
          l = 1 << k;
      e[k] = 0;
      g[k] = -1;
      h[k] = -1;
      f &= ~l;
    }

    null !== Cj && 0 === (d & 24) && Cj.has(a) && Cj.delete(a);
    a === U && (Y = U = null, W = 0);
    1 < c.flags ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, d = c.firstEffect) : d = c : d = c.firstEffect;

    if (null !== d) {
      e = X;
      X |= 32;
      pj.current = null;
      kf = fd;
      g = Ne();

      if (Oe(g)) {
        if ("selectionStart" in g) h = {
          start: g.selectionStart,
          end: g.selectionEnd
        };else a: if (h = (h = g.ownerDocument) && h.defaultView || window, (l = h.getSelection && h.getSelection()) && 0 !== l.rangeCount) {
          h = l.anchorNode;
          f = l.anchorOffset;
          k = l.focusNode;
          l = l.focusOffset;

          try {
            h.nodeType, k.nodeType;
          } catch (va) {
            h = null;
            break a;
          }

          var n = 0,
              A = -1,
              p = -1,
              C = 0,
              x = 0,
              w = g,
              z = null;

          b: for (;;) {
            for (var u;;) {
              w !== h || 0 !== f && 3 !== w.nodeType || (A = n + f);
              w !== k || 0 !== l && 3 !== w.nodeType || (p = n + l);
              3 === w.nodeType && (n += w.nodeValue.length);
              if (null === (u = w.firstChild)) break;
              z = w;
              w = u;
            }

            for (;;) {
              if (w === g) break b;
              z === h && ++C === f && (A = n);
              z === k && ++x === l && (p = n);
              if (null !== (u = w.nextSibling)) break;
              w = z;
              z = w.parentNode;
            }

            w = u;
          }

          h = -1 === A || -1 === p ? null : {
            start: A,
            end: p
          };
        } else h = null;
        h = h || {
          start: 0,
          end: 0
        };
      } else h = null;

      lf = {
        focusedElem: g,
        selectionRange: h
      };
      fd = !1;
      Ij = null;
      Jj = !1;
      Z = d;

      do {
        try {
          ek();
        } catch (va) {
          if (null === Z) throw Error(y(330));
          Wi(Z, va);
          Z = Z.nextEffect;
        }
      } while (null !== Z);

      Ij = null;
      Z = d;

      do {
        try {
          for (g = a; null !== Z;) {
            var t = Z.flags;
            t & 16 && pb(Z.stateNode, "");

            if (t & 128) {
              var q = Z.alternate;

              if (null !== q) {
                var v = q.ref;
                null !== v && ("function" === typeof v ? v(null) : v.current = null);
              }
            }

            switch (t & 1038) {
              case 2:
                fj(Z);
                Z.flags &= -3;
                break;

              case 6:
                fj(Z);
                Z.flags &= -3;
                ij(Z.alternate, Z);
                break;

              case 1024:
                Z.flags &= -1025;
                break;

              case 1028:
                Z.flags &= -1025;
                ij(Z.alternate, Z);
                break;

              case 4:
                ij(Z.alternate, Z);
                break;

              case 8:
                h = Z;
                cj(g, h);
                var J = h.alternate;
                dj(h);
                null !== J && dj(J);
            }

            Z = Z.nextEffect;
          }
        } catch (va) {
          if (null === Z) throw Error(y(330));
          Wi(Z, va);
          Z = Z.nextEffect;
        }
      } while (null !== Z);

      v = lf;
      q = Ne();
      t = v.focusedElem;
      g = v.selectionRange;

      if (q !== t && t && t.ownerDocument && Me(t.ownerDocument.documentElement, t)) {
        null !== g && Oe(t) && (q = g.start, v = g.end, void 0 === v && (v = q), "selectionStart" in t ? (t.selectionStart = q, t.selectionEnd = Math.min(v, t.value.length)) : (v = (q = t.ownerDocument || document) && q.defaultView || window, v.getSelection && (v = v.getSelection(), h = t.textContent.length, J = Math.min(g.start, h), g = void 0 === g.end ? J : Math.min(g.end, h), !v.extend && J > g && (h = g, g = J, J = h), h = Le(t, J), f = Le(t, g), h && f && (1 !== v.rangeCount || v.anchorNode !== h.node || v.anchorOffset !== h.offset || v.focusNode !== f.node || v.focusOffset !== f.offset) && (q = q.createRange(), q.setStart(h.node, h.offset), v.removeAllRanges(), J > g ? (v.addRange(q), v.extend(f.node, f.offset)) : (q.setEnd(f.node, f.offset), v.addRange(q))))));
        q = [];

        for (v = t; v = v.parentNode;) {
          1 === v.nodeType && q.push({
            element: v,
            left: v.scrollLeft,
            top: v.scrollTop
          });
        }

        "function" === typeof t.focus && t.focus();

        for (t = 0; t < q.length; t++) {
          v = q[t], v.element.scrollLeft = v.left, v.element.scrollTop = v.top;
        }
      }

      fd = !!kf;
      lf = kf = null;
      a.current = c;
      Z = d;

      do {
        try {
          for (t = a; null !== Z;) {
            var K = Z.flags;
            K & 36 && Yi(t, Z.alternate, Z);

            if (K & 128) {
              q = void 0;
              var Q = Z.ref;

              if (null !== Q) {
                var L = Z.stateNode;

                switch (Z.tag) {
                  case 5:
                    q = L;
                    break;

                  default:
                    q = L;
                }

                "function" === typeof Q ? Q(q) : Q.current = q;
              }
            }

            Z = Z.nextEffect;
          }
        } catch (va) {
          if (null === Z) throw Error(y(330));
          Wi(Z, va);
          Z = Z.nextEffect;
        }
      } while (null !== Z);

      Z = null;
      $f();
      X = e;
    } else a.current = c;

    if (xj) xj = !1, yj = a, zj = b;else for (Z = d; null !== Z;) {
      b = Z.nextEffect, Z.nextEffect = null, Z.flags & 8 && (K = Z, K.sibling = null, K.stateNode = null), Z = b;
    }
    d = a.pendingLanes;
    0 === d && (Ti = null);
    1 === d ? a === Ej ? Dj++ : (Dj = 0, Ej = a) : Dj = 0;
    c = c.stateNode;
    if (Mf && "function" === typeof Mf.onCommitFiberRoot) try {
      Mf.onCommitFiberRoot(Lf, c, void 0, 64 === (c.current.flags & 64));
    } catch (va) {}
    Mj(a, O());
    if (Qi) throw Qi = !1, a = Ri, Ri = null, a;
    if (0 !== (X & 8)) return null;
    ig();
    return null;
  }

  function ek() {
    for (; null !== Z;) {
      var a = Z.alternate;
      Jj || null === Ij || (0 !== (Z.flags & 8) ? dc(Z, Ij) && (Jj = !0) : 13 === Z.tag && mj(a, Z) && dc(Z, Ij) && (Jj = !0));
      var b = Z.flags;
      0 !== (b & 256) && Xi(a, Z);
      0 === (b & 512) || xj || (xj = !0, hg(97, function () {
        Oj();
        return null;
      }));
      Z = Z.nextEffect;
    }
  }

  function Oj() {
    if (90 !== zj) {
      var a = 97 < zj ? 97 : zj;
      zj = 90;
      return gg(a, fk);
    }

    return !1;
  }

  function $i(a, b) {
    Aj.push(b, a);
    xj || (xj = !0, hg(97, function () {
      Oj();
      return null;
    }));
  }

  function Zi(a, b) {
    Bj.push(b, a);
    xj || (xj = !0, hg(97, function () {
      Oj();
      return null;
    }));
  }

  function fk() {
    if (null === yj) return !1;
    var a = yj;
    yj = null;
    if (0 !== (X & 48)) throw Error(y(331));
    var b = X;
    X |= 32;
    var c = Bj;
    Bj = [];

    for (var d = 0; d < c.length; d += 2) {
      var e = c[d],
          f = c[d + 1],
          g = e.destroy;
      e.destroy = void 0;
      if ("function" === typeof g) try {
        g();
      } catch (k) {
        if (null === f) throw Error(y(330));
        Wi(f, k);
      }
    }

    c = Aj;
    Aj = [];

    for (d = 0; d < c.length; d += 2) {
      e = c[d];
      f = c[d + 1];

      try {
        var h = e.create;
        e.destroy = h();
      } catch (k) {
        if (null === f) throw Error(y(330));
        Wi(f, k);
      }
    }

    for (h = a.current.firstEffect; null !== h;) {
      a = h.nextEffect, h.nextEffect = null, h.flags & 8 && (h.sibling = null, h.stateNode = null), h = a;
    }

    X = b;
    ig();
    return !0;
  }

  function gk(a, b, c) {
    b = Mi(c, b);
    b = Pi(a, b, 1);
    Ag(a, b);
    b = Hg();
    a = Kj(a, 1);
    null !== a && ($c(a, 1, b), Mj(a, b));
  }

  function Wi(a, b) {
    if (3 === a.tag) gk(a, a, b);else for (var c = a.return; null !== c;) {
      if (3 === c.tag) {
        gk(c, a, b);
        break;
      } else if (1 === c.tag) {
        var d = c.stateNode;

        if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) {
          a = Mi(b, a);
          var e = Si(c, a, 1);
          Ag(c, e);
          e = Hg();
          c = Kj(c, 1);
          if (null !== c) $c(c, 1, e), Mj(c, e);else if ("function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) try {
            d.componentDidCatch(b, a);
          } catch (f) {}
          break;
        }
      }

      c = c.return;
    }
  }

  function Yj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = Hg();
    a.pingedLanes |= a.suspendedLanes & c;
    U === a && (W & c) === c && (4 === V || 3 === V && (W & 62914560) === W && 500 > O() - jj ? Qj(a, 0) : uj |= c);
    Mj(a, b);
  }

  function lj(a, b) {
    var c = a.stateNode;
    null !== c && c.delete(b);
    b = 0;
    0 === b && (b = a.mode, 0 === (b & 2) ? b = 1 : 0 === (b & 4) ? b = 99 === eg() ? 1 : 2 : (0 === Gj && (Gj = tj), b = Yc(62914560 & ~Gj), 0 === b && (b = 4194304)));
    c = Hg();
    a = Kj(a, b);
    null !== a && ($c(a, b, c), Mj(a, c));
  }

  var ck;

  ck = function ck(a, b, c) {
    var d = b.lanes;
    if (null !== a) {
      if (a.memoizedProps !== b.pendingProps || N.current) ug = !0;else if (0 !== (c & d)) ug = 0 !== (a.flags & 16384) ? !0 : !1;else {
        ug = !1;

        switch (b.tag) {
          case 3:
            ri(b);
            sh();
            break;

          case 5:
            gh(b);
            break;

          case 1:
            Ff(b.type) && Jf(b);
            break;

          case 4:
            eh(b, b.stateNode.containerInfo);
            break;

          case 10:
            d = b.memoizedProps.value;
            var e = b.type._context;
            I(mg, e._currentValue);
            e._currentValue = d;
            break;

          case 13:
            if (null !== b.memoizedState) {
              if (0 !== (c & b.child.childLanes)) return ti(a, b, c);
              I(P, P.current & 1);
              b = hi(a, b, c);
              return null !== b ? b.sibling : null;
            }

            I(P, P.current & 1);
            break;

          case 19:
            d = 0 !== (c & b.childLanes);

            if (0 !== (a.flags & 64)) {
              if (d) return Ai(a, b, c);
              b.flags |= 64;
            }

            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            I(P, P.current);
            if (d) break;else return null;

          case 23:
          case 24:
            return b.lanes = 0, mi(a, b, c);
        }

        return hi(a, b, c);
      }
    } else ug = !1;
    b.lanes = 0;

    switch (b.tag) {
      case 2:
        d = b.type;
        null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
        a = b.pendingProps;
        e = Ef(b, M.current);
        tg(b, c);
        e = Ch(null, b, d, a, e, c);
        b.flags |= 1;

        if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
          b.tag = 1;
          b.memoizedState = null;
          b.updateQueue = null;

          if (Ff(d)) {
            var f = !0;
            Jf(b);
          } else f = !1;

          b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
          xg(b);
          var g = d.getDerivedStateFromProps;
          "function" === typeof g && Gg(b, d, g, a);
          e.updater = Kg;
          b.stateNode = e;
          e._reactInternals = b;
          Og(b, d, a, c);
          b = qi(null, b, d, !0, f, c);
        } else b.tag = 0, fi(null, b, e, c), b = b.child;

        return b;

      case 16:
        e = b.elementType;

        a: {
          null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
          a = b.pendingProps;
          f = e._init;
          e = f(e._payload);
          b.type = e;
          f = b.tag = hk(e);
          a = lg(e, a);

          switch (f) {
            case 0:
              b = li(null, b, e, a, c);
              break a;

            case 1:
              b = pi(null, b, e, a, c);
              break a;

            case 11:
              b = gi(null, b, e, a, c);
              break a;

            case 14:
              b = ii(null, b, e, lg(e.type, a), d, c);
              break a;
          }

          throw Error(y(306, e, ""));
        }

        return b;

      case 0:
        return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), li(a, b, d, e, c);

      case 1:
        return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), pi(a, b, d, e, c);

      case 3:
        ri(b);
        d = b.updateQueue;
        if (null === a || null === d) throw Error(y(282));
        d = b.pendingProps;
        e = b.memoizedState;
        e = null !== e ? e.element : null;
        yg(a, b);
        Cg(b, d, null, c);
        d = b.memoizedState.element;
        if (d === e) sh(), b = hi(a, b, c);else {
          e = b.stateNode;
          if (f = e.hydrate) kh = rf(b.stateNode.containerInfo.firstChild), jh = b, f = lh = !0;

          if (f) {
            a = e.mutableSourceEagerHydrationData;
            if (null != a) for (e = 0; e < a.length; e += 2) {
              f = a[e], f._workInProgressVersionPrimary = a[e + 1], th.push(f);
            }
            c = Zg(b, null, d, c);

            for (b.child = c; c;) {
              c.flags = c.flags & -3 | 1024, c = c.sibling;
            }
          } else fi(a, b, d, c), sh();

          b = b.child;
        }
        return b;

      case 5:
        return gh(b), null === a && ph(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, nf(d, e) ? g = null : null !== f && nf(d, f) && (b.flags |= 16), oi(a, b), fi(a, b, g, c), b.child;

      case 6:
        return null === a && ph(b), null;

      case 13:
        return ti(a, b, c);

      case 4:
        return eh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Yg(b, null, d, c) : fi(a, b, d, c), b.child;

      case 11:
        return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), gi(a, b, d, e, c);

      case 7:
        return fi(a, b, b.pendingProps, c), b.child;

      case 8:
        return fi(a, b, b.pendingProps.children, c), b.child;

      case 12:
        return fi(a, b, b.pendingProps.children, c), b.child;

      case 10:
        a: {
          d = b.type._context;
          e = b.pendingProps;
          g = b.memoizedProps;
          f = e.value;
          var h = b.type._context;
          I(mg, h._currentValue);
          h._currentValue = f;
          if (null !== g) if (h = g.value, f = He(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0, 0 === f) {
            if (g.children === e.children && !N.current) {
              b = hi(a, b, c);
              break a;
            }
          } else for (h = b.child, null !== h && (h.return = b); null !== h;) {
            var k = h.dependencies;

            if (null !== k) {
              g = h.child;

              for (var l = k.firstContext; null !== l;) {
                if (l.context === d && 0 !== (l.observedBits & f)) {
                  1 === h.tag && (l = zg(-1, c & -c), l.tag = 2, Ag(h, l));
                  h.lanes |= c;
                  l = h.alternate;
                  null !== l && (l.lanes |= c);
                  sg(h.return, c);
                  k.lanes |= c;
                  break;
                }

                l = l.next;
              }
            } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;

            if (null !== g) g.return = h;else for (g = h; null !== g;) {
              if (g === b) {
                g = null;
                break;
              }

              h = g.sibling;

              if (null !== h) {
                h.return = g.return;
                g = h;
                break;
              }

              g = g.return;
            }
            h = g;
          }
          fi(a, b, e.children, c);
          b = b.child;
        }

        return b;

      case 9:
        return e = b.type, f = b.pendingProps, d = f.children, tg(b, c), e = vg(e, f.unstable_observedBits), d = d(e), b.flags |= 1, fi(a, b, d, c), b.child;

      case 14:
        return e = b.type, f = lg(e, b.pendingProps), f = lg(e.type, f), ii(a, b, e, f, d, c);

      case 15:
        return ki(a, b, b.type, b.pendingProps, d, c);

      case 17:
        return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), b.tag = 1, Ff(d) ? (a = !0, Jf(b)) : a = !1, tg(b, c), Mg(b, d, e), Og(b, d, e, c), qi(null, b, d, !0, a, c);

      case 19:
        return Ai(a, b, c);

      case 23:
        return mi(a, b, c);

      case 24:
        return mi(a, b, c);
    }

    throw Error(y(156, b.tag));
  };

  function ik(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.flags = 0;
    this.lastEffect = this.firstEffect = this.nextEffect = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
  }

  function nh(a, b, c, d) {
    return new ik(a, b, c, d);
  }

  function ji(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
  }

  function hk(a) {
    if ("function" === typeof a) return ji(a) ? 1 : 0;

    if (void 0 !== a && null !== a) {
      a = a.$$typeof;
      if (a === Aa) return 11;
      if (a === Da) return 14;
    }

    return 2;
  }

  function Tg(a, b) {
    var c = a.alternate;
    null === c ? (c = nh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
      lanes: b.lanes,
      firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
  }

  function Vg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) ji(a) && (g = 1);else if ("string" === typeof a) g = 5;else a: switch (a) {
      case ua:
        return Xg(c.children, e, f, b);

      case Ha:
        g = 8;
        e |= 16;
        break;

      case wa:
        g = 8;
        e |= 1;
        break;

      case xa:
        return a = nh(12, c, b, e | 8), a.elementType = xa, a.type = xa, a.lanes = f, a;

      case Ba:
        return a = nh(13, c, b, e), a.type = Ba, a.elementType = Ba, a.lanes = f, a;

      case Ca:
        return a = nh(19, c, b, e), a.elementType = Ca, a.lanes = f, a;

      case Ia:
        return vi(c, e, f, b);

      case Ja:
        return a = nh(24, c, b, e), a.elementType = Ja, a.lanes = f, a;

      default:
        if ("object" === typeof a && null !== a) switch (a.$$typeof) {
          case ya:
            g = 10;
            break a;

          case za:
            g = 9;
            break a;

          case Aa:
            g = 11;
            break a;

          case Da:
            g = 14;
            break a;

          case Ea:
            g = 16;
            d = null;
            break a;

          case Fa:
            g = 22;
            break a;
        }
        throw Error(y(130, null == a ? a : typeof a, ""));
    }
    b = nh(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
  }

  function Xg(a, b, c, d) {
    a = nh(7, a, d, b);
    a.lanes = c;
    return a;
  }

  function vi(a, b, c, d) {
    a = nh(23, a, d, b);
    a.elementType = Ia;
    a.lanes = c;
    return a;
  }

  function Ug(a, b, c) {
    a = nh(6, a, null, b);
    a.lanes = c;
    return a;
  }

  function Wg(a, b, c) {
    b = nh(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
      containerInfo: a.containerInfo,
      pendingChildren: null,
      implementation: a.implementation
    };
    return b;
  }

  function jk(a, b, c) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.pendingContext = this.context = null;
    this.hydrate = c;
    this.callbackNode = null;
    this.callbackPriority = 0;
    this.eventTimes = Zc(0);
    this.expirationTimes = Zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = Zc(0);
    this.mutableSourceEagerHydrationData = null;
  }

  function kk(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
      $$typeof: ta,
      key: null == d ? null : "" + d,
      children: a,
      containerInfo: b,
      implementation: c
    };
  }

  function lk(a, b, c, d) {
    var e = b.current,
        f = Hg(),
        g = Ig(e);

    a: if (c) {
      c = c._reactInternals;

      b: {
        if (Zb(c) !== c || 1 !== c.tag) throw Error(y(170));
        var h = c;

        do {
          switch (h.tag) {
            case 3:
              h = h.stateNode.context;
              break b;

            case 1:
              if (Ff(h.type)) {
                h = h.stateNode.__reactInternalMemoizedMergedChildContext;
                break b;
              }

          }

          h = h.return;
        } while (null !== h);

        throw Error(y(171));
      }

      if (1 === c.tag) {
        var k = c.type;

        if (Ff(k)) {
          c = If(c, k, h);
          break a;
        }
      }

      c = h;
    } else c = Cf;

    null === b.context ? b.context = c : b.pendingContext = c;
    b = zg(f, g);
    b.payload = {
      element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    Ag(e, b);
    Jg(e, g, f);
    return g;
  }

  function mk(a) {
    a = a.current;
    if (!a.child) return null;

    switch (a.child.tag) {
      case 5:
        return a.child.stateNode;

      default:
        return a.child.stateNode;
    }
  }

  function nk(a, b) {
    a = a.memoizedState;

    if (null !== a && null !== a.dehydrated) {
      var c = a.retryLane;
      a.retryLane = 0 !== c && c < b ? c : b;
    }
  }

  function ok(a, b) {
    nk(a, b);
    (a = a.alternate) && nk(a, b);
  }

  function pk() {
    return null;
  }

  function qk(a, b, c) {
    var d = null != c && null != c.hydrationOptions && c.hydrationOptions.mutableSources || null;
    c = new jk(a, b, null != c && !0 === c.hydrate);
    b = nh(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
    c.current = b;
    b.stateNode = c;
    xg(b);
    a[ff] = c.current;
    cf(8 === a.nodeType ? a.parentNode : a);
    if (d) for (a = 0; a < d.length; a++) {
      b = d[a];
      var e = b._getVersion;
      e = e(b._source);
      null == c.mutableSourceEagerHydrationData ? c.mutableSourceEagerHydrationData = [b, e] : c.mutableSourceEagerHydrationData.push(b, e);
    }
    this._internalRoot = c;
  }

  qk.prototype.render = function (a) {
    lk(a, this._internalRoot, null, null);
  };

  qk.prototype.unmount = function () {
    var a = this._internalRoot,
        b = a.containerInfo;
    lk(null, a, null, function () {
      b[ff] = null;
    });
  };

  function rk(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
  }

  function sk(a, b) {
    b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
    if (!b) for (var c; c = a.lastChild;) {
      a.removeChild(c);
    }
    return new qk(a, 0, b ? {
      hydrate: !0
    } : void 0);
  }

  function tk(a, b, c, d, e) {
    var f = c._reactRootContainer;

    if (f) {
      var g = f._internalRoot;

      if ("function" === typeof e) {
        var h = e;

        e = function e() {
          var a = mk(g);
          h.call(a);
        };
      }

      lk(b, g, a, e);
    } else {
      f = c._reactRootContainer = sk(c, d);
      g = f._internalRoot;

      if ("function" === typeof e) {
        var k = e;

        e = function e() {
          var a = mk(g);
          k.call(a);
        };
      }

      Xj(function () {
        lk(b, g, a, e);
      });
    }

    return mk(g);
  }

  ec = function ec(a) {
    if (13 === a.tag) {
      var b = Hg();
      Jg(a, 4, b);
      ok(a, 4);
    }
  };

  fc = function fc(a) {
    if (13 === a.tag) {
      var b = Hg();
      Jg(a, 67108864, b);
      ok(a, 67108864);
    }
  };

  gc = function gc(a) {
    if (13 === a.tag) {
      var b = Hg(),
          c = Ig(a);
      Jg(a, c, b);
      ok(a, c);
    }
  };

  hc = function hc(a, b) {
    return b();
  };

  yb = function yb(a, b, c) {
    switch (b) {
      case "input":
        ab(a, c);
        b = c.name;

        if ("radio" === c.type && null != b) {
          for (c = a; c.parentNode;) {
            c = c.parentNode;
          }

          c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');

          for (b = 0; b < c.length; b++) {
            var d = c[b];

            if (d !== a && d.form === a.form) {
              var e = Db(d);
              if (!e) throw Error(y(90));
              Wa(d);
              ab(d, e);
            }
          }
        }

        break;

      case "textarea":
        ib(a, c);
        break;

      case "select":
        b = c.value, null != b && fb(a, !!c.multiple, b, !1);
    }
  };

  Gb = Wj;

  Hb = function Hb(a, b, c, d, e) {
    var f = X;
    X |= 4;

    try {
      return gg(98, a.bind(null, b, c, d, e));
    } finally {
      X = f, 0 === X && (wj(), ig());
    }
  };

  Ib = function Ib() {
    0 === (X & 49) && (Vj(), Oj());
  };

  Jb = function Jb(a, b) {
    var c = X;
    X |= 2;

    try {
      return a(b);
    } finally {
      X = c, 0 === X && (wj(), ig());
    }
  };

  function uk(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!rk(b)) throw Error(y(200));
    return kk(a, b, null, c);
  }

  var vk = {
    Events: [Cb, ue, Db, Eb, Fb, Oj, {
      current: !1
    }]
  },
      wk = {
    findFiberByHostInstance: wc,
    bundleType: 0,
    version: "17.0.1",
    rendererPackageName: "react-dom"
  };
  var xk = {
    bundleType: wk.bundleType,
    version: wk.version,
    rendererPackageName: wk.rendererPackageName,
    rendererConfig: wk.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: ra.ReactCurrentDispatcher,
    findHostInstanceByFiber: function findHostInstanceByFiber(a) {
      a = cc(a);
      return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: wk.findFiberByHostInstance || pk,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null
  };

  if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var yk = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!yk.isDisabled && yk.supportsFiber) try {
      Lf = yk.inject(xk), Mf = yk;
    } catch (a) {}
  }

  exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = vk;
  exports.createPortal = uk;

  exports.findDOMNode = function (a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;

    if (void 0 === b) {
      if ("function" === typeof a.render) throw Error(y(188));
      throw Error(y(268, Object.keys(a)));
    }

    a = cc(b);
    a = null === a ? null : a.stateNode;
    return a;
  };

  exports.flushSync = function (a, b) {
    var c = X;
    if (0 !== (c & 48)) return a(b);
    X |= 1;

    try {
      if (a) return gg(99, a.bind(null, b));
    } finally {
      X = c, ig();
    }
  };

  exports.hydrate = function (a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !0, c);
  };

  exports.render = function (a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !1, c);
  };

  exports.unmountComponentAtNode = function (a) {
    if (!rk(a)) throw Error(y(40));
    return a._reactRootContainer ? (Xj(function () {
      tk(null, null, a, !1, function () {
        a._reactRootContainer = null;
        a[ff] = null;
      });
    }), !0) : !1;
  };

  exports.unstable_batchedUpdates = Wj;

  exports.unstable_createPortal = function (a, b) {
    return uk(a, b, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
  };

  exports.unstable_renderSubtreeIntoContainer = function (a, b, c, d) {
    if (!rk(c)) throw Error(y(200));
    if (null == a || void 0 === a._reactInternals) throw Error(y(38));
    return tk(a, b, c, !1, d);
  };

  exports.version = "17.0.1";
  /***/
},
/* 600 */

/***/
function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */
  (function (process) {
    /* eslint-disable import/no-unresolved */
    if (process.env.NODE_ENV === "production") {
      module.exports = __webpack_require__(602);
    } else {
      module.exports = __webpack_require__(601);
    }
    /* WEBPACK VAR INJECTION */

  }).call(exports, __webpack_require__(25));
  /***/
},
/* 601 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (process) {
    function _interopDefault(ex) {
      return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
    }

    var React = __webpack_require__(4);

    var React__default = _interopDefault(React);

    var reactDom = __webpack_require__(244);

    var PropTypes = _interopDefault(__webpack_require__(243));

    var invariant = _interopDefault(__webpack_require__(242));

    var warning = _interopDefault(__webpack_require__(247));

    function _defaults2(obj, defaults) {
      var keys = Object.getOwnPropertyNames(defaults);

      for (var i = 0; i < keys.length; i++) {
        var key = keys[i];
        var value = Object.getOwnPropertyDescriptor(defaults, key);

        if (value && value.configurable && obj[key] === undefined) {
          Object.defineProperty(obj, key, value);
        }
      }

      return obj;
    }

    function _extends() {
      _extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];

          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }

        return target;
      };

      return _extends.apply(this, arguments);
    }

    function _inheritsLoose(subClass, superClass) {
      subClass.prototype = Object.create(superClass.prototype);
      subClass.prototype.constructor = subClass;

      _defaults2(subClass, superClass);
    }

    function _objectWithoutPropertiesLoose(source, excluded) {
      if (source == null) return {};
      var target = {};
      var sourceKeys = Object.keys(source);
      var key, i;

      for (i = 0; i < sourceKeys.length; i++) {
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
      }

      return target;
    }

    function defer(fn) {
      return requestAnimationFrame(fn);
    }

    function cancelDefer(deferId) {
      cancelAnimationFrame(deferId);
    }

    function setInputSelection(input, start, end) {
      if (end === undefined) {
        end = start;
      }

      input.setSelectionRange(start, end);
    }

    function getInputSelection(input) {
      var start = input.selectionStart;
      var end = input.selectionEnd;
      return {
        start: start,
        end: end,
        length: end - start
      };
    }

    function isInputFocused(input) {
      var inputDocument = input.ownerDocument;
      return inputDocument.hasFocus() && inputDocument.activeElement === input;
    } // Element's window may differ from the one within React instance
    // if element rendered within iframe.
    // See https://github.com/sanniassin/react-input-mask/issues/182


    function getElementDocument(element) {
      return element == null ? void 0 : element.ownerDocument;
    }

    function getElementWindow(element) {
      var _getElementDocument;

      return (_getElementDocument = getElementDocument(element)) == null ? void 0 : _getElementDocument.defaultView;
    }

    function isDOMElement(element) {
      var elementWindow = getElementWindow(element);
      return !!elementWindow && element instanceof elementWindow.HTMLElement;
    }

    function isFunction(value) {
      return typeof value === "function";
    }

    function findLastIndex(array, predicate) {
      for (var i = array.length - 1; i >= 0; i--) {
        var x = array[i];

        if (predicate(x, i)) {
          return i;
        }
      }

      return -1;
    }

    function repeat(string, n) {
      if (n === void 0) {
        n = 1;
      }

      var result = "";

      for (var i = 0; i < n; i++) {
        result += string;
      }

      return result;
    }

    function toString(value) {
      return "" + value;
    }

    function useInputElement(inputRef) {
      return React.useCallback(function () {
        var input = inputRef.current;
        var isDOMNode = typeof window !== "undefined" && isDOMElement(input); // workaround for react-test-renderer
        // https://github.com/sanniassin/react-input-mask/issues/147

        if (!input || !isDOMNode) {
          return null;
        }

        if (input.nodeName !== "INPUT") {
          input = input.querySelector("input");
        }

        if (!input) {
          throw new Error("react-input-mask: inputComponent doesn't contain input node");
        }

        return input;
      }, [inputRef]);
    }

    function useDeferLoop(callback) {
      var deferIdRef = React.useRef(null);
      var runLoop = React.useCallback(function () {
        // If there are simulated focus events, runLoop could be
        // called multiple times without blur or re-render
        if (deferIdRef.current !== null) {
          return;
        }

        function loop() {
          callback();
          deferIdRef.current = defer(loop);
        }

        loop();
      }, [callback]);
      var stopLoop = React.useCallback(function () {
        cancelDefer(deferIdRef.current);
        deferIdRef.current = null;
      }, []);
      React.useEffect(function () {
        if (deferIdRef.current) {
          stopLoop();
          runLoop();
        }
      }, [runLoop, stopLoop]);
      React.useEffect(cancelDefer, []);
      return [runLoop, stopLoop];
    }

    function useSelection(inputRef, isMasked) {
      var selectionRef = React.useRef({
        start: null,
        end: null
      });
      var getInputElement = useInputElement(inputRef);
      var getSelection = React.useCallback(function () {
        var input = getInputElement();
        return getInputSelection(input);
      }, [getInputElement]);
      var getLastSelection = React.useCallback(function () {
        return selectionRef.current;
      }, []);
      var setSelection = React.useCallback(function (selection) {
        var input = getInputElement(); // Don't change selection on unfocused input
        // because Safari sets focus on selection change (#154)

        if (!input || !isInputFocused(input)) {
          return;
        }

        setInputSelection(input, selection.start, selection.end); // Use actual selection in case the requested one was out of range

        selectionRef.current = getSelection();
      }, [getInputElement, getSelection]);
      var selectionLoop = React.useCallback(function () {
        selectionRef.current = getSelection();
      }, [getSelection]);

      var _useDeferLoop = useDeferLoop(selectionLoop),
          runSelectionLoop = _useDeferLoop[0],
          stopSelectionLoop = _useDeferLoop[1];

      React.useLayoutEffect(function () {
        if (!isMasked) {
          return;
        }

        var input = getInputElement();
        input.addEventListener("focus", runSelectionLoop);
        input.addEventListener("blur", stopSelectionLoop);

        if (isInputFocused(input)) {
          runSelectionLoop();
        }

        return function () {
          input.removeEventListener("focus", runSelectionLoop);
          input.removeEventListener("blur", stopSelectionLoop);
          stopSelectionLoop();
        };
      });
      return {
        getSelection: getSelection,
        getLastSelection: getLastSelection,
        setSelection: setSelection
      };
    }

    function useValue(inputRef, initialValue) {
      var getInputElement = useInputElement(inputRef);
      var valueRef = React.useRef(initialValue);
      var getValue = React.useCallback(function () {
        var input = getInputElement();
        return input.value;
      }, [getInputElement]);
      var getLastValue = React.useCallback(function () {
        return valueRef.current;
      }, []);
      var setValue = React.useCallback(function (newValue) {
        valueRef.current = newValue;
        var input = getInputElement();

        if (input) {
          input.value = newValue;
        }
      }, [getInputElement]);
      return {
        getValue: getValue,
        getLastValue: getLastValue,
        setValue: setValue
      };
    }

    function useInputState(initialValue, isMasked) {
      var inputRef = React.useRef();

      var _useSelection = useSelection(inputRef, isMasked),
          getSelection = _useSelection.getSelection,
          getLastSelection = _useSelection.getLastSelection,
          setSelection = _useSelection.setSelection;

      var _useValue = useValue(inputRef, initialValue),
          getValue = _useValue.getValue,
          getLastValue = _useValue.getLastValue,
          setValue = _useValue.setValue;

      function getLastInputState() {
        return {
          value: getLastValue(),
          selection: getLastSelection()
        };
      }

      function getInputState() {
        return {
          value: getValue(),
          selection: getSelection()
        };
      }

      function setInputState(_ref) {
        var value = _ref.value,
            selection = _ref.selection;
        setValue(value);
        setSelection(selection);
      }

      return {
        inputRef: inputRef,
        getInputState: getInputState,
        getLastInputState: getLastInputState,
        setInputState: setInputState
      };
    }

    function usePrevious(value) {
      var ref = React.useRef();
      React.useEffect(function () {
        ref.current = value;
      });
      return ref.current;
    }

    var CONTROLLED_PROPS = ["disabled", "onBlur", "onChange", "onFocus", "onMouseDown", "readOnly", "value"];
    var defaultFormatChars = {
      "9": /[0-9]/,
      a: /[A-Za-z]/,
      "*": /[A-Za-z0-9]/
    };

    function validateMaxLength(props) {
      process.env.NODE_ENV !== "production" ? warning(!props.maxLength || !props.mask, "react-input-mask: maxLength property shouldn't be passed to the masked input. It breaks masking and unnecessary because length is limited by the mask length.") : void 0;
    }

    function validateMaskPlaceholder(props) {
      var mask = props.mask,
          maskPlaceholder = props.maskPlaceholder;
      !(!mask || !maskPlaceholder || maskPlaceholder.length === 1 || maskPlaceholder.length === mask.length) ? process.env.NODE_ENV !== "production" ? invariant(false, "react-input-mask: maskPlaceholder should either be a single character or have the same length as the mask:\n" + ("mask: " + mask + "\n") + ("maskPlaceholder: " + maskPlaceholder)) : invariant(false) : void 0;
    }

    function validateChildren(props, inputElement) {
      var conflictProps = CONTROLLED_PROPS.filter(function (propId) {
        return inputElement.props[propId] != null && inputElement.props[propId] !== props[propId];
      });
      !!conflictProps.length ? process.env.NODE_ENV !== "production" ? invariant(false, "react-input-mask: the following props should be passed to the InputMask component, not to children: " + conflictProps.join(",")) : invariant(false) : void 0;
    }

    function parseMask(_ref) {
      var mask = _ref.mask,
          maskPlaceholder = _ref.maskPlaceholder;
      var permanents = [];

      if (!mask) {
        return {
          maskPlaceholder: null,
          mask: null,
          prefix: null,
          lastEditablePosition: null,
          permanents: []
        };
      }

      if (typeof mask === "string") {
        var isPermanent = false;
        var parsedMaskString = "";
        mask.split("").forEach(function (character) {
          if (!isPermanent && character === "\\") {
            isPermanent = true;
          } else {
            if (isPermanent || !defaultFormatChars[character]) {
              permanents.push(parsedMaskString.length);
            }

            parsedMaskString += character;
            isPermanent = false;
          }
        });
        mask = parsedMaskString.split("").map(function (character, index) {
          if (permanents.indexOf(index) === -1) {
            return defaultFormatChars[character];
          }

          return character;
        });
      } else {
        mask.forEach(function (character, index) {
          if (typeof character === "string") {
            permanents.push(index);
          }
        });
      }

      if (maskPlaceholder) {
        if (maskPlaceholder.length === 1) {
          maskPlaceholder = mask.map(function (character, index) {
            if (permanents.indexOf(index) !== -1) {
              return character;
            }

            return maskPlaceholder;
          });
        } else {
          maskPlaceholder = maskPlaceholder.split("");
        }

        permanents.forEach(function (position) {
          maskPlaceholder[position] = mask[position];
        });
        maskPlaceholder = maskPlaceholder.join("");
      }

      var prefix = permanents.filter(function (position, index) {
        return position === index;
      }).map(function (position) {
        return mask[position];
      }).join("");
      var lastEditablePosition = mask.length - 1;

      while (permanents.indexOf(lastEditablePosition) !== -1) {
        lastEditablePosition--;
      }

      return {
        maskPlaceholder: maskPlaceholder,
        prefix: prefix,
        mask: mask,
        lastEditablePosition: lastEditablePosition,
        permanents: permanents
      };
    }
    /* eslint no-use-before-define: ["error", { functions: false }] */


    var MaskUtils = function MaskUtils(options) {
      var _this = this;

      this.isCharacterAllowedAtPosition = function (character, position) {
        var maskPlaceholder = _this.maskOptions.maskPlaceholder;

        if (_this.isCharacterFillingPosition(character, position)) {
          return true;
        }

        if (!maskPlaceholder) {
          return false;
        }

        return maskPlaceholder[position] === character;
      };

      this.isCharacterFillingPosition = function (character, position) {
        var mask = _this.maskOptions.mask;

        if (!character || position >= mask.length) {
          return false;
        }

        if (!_this.isPositionEditable(position)) {
          return mask[position] === character;
        }

        var charRule = mask[position];
        return new RegExp(charRule).test(character);
      };

      this.isPositionEditable = function (position) {
        var _this$maskOptions = _this.maskOptions,
            mask = _this$maskOptions.mask,
            permanents = _this$maskOptions.permanents;
        return position < mask.length && permanents.indexOf(position) === -1;
      };

      this.isValueEmpty = function (value) {
        return value.split("").every(function (character, position) {
          return !_this.isPositionEditable(position) || !_this.isCharacterFillingPosition(character, position);
        });
      };

      this.isValueFilled = function (value) {
        return _this.getFilledLength(value) === _this.maskOptions.lastEditablePosition + 1;
      };

      this.getDefaultSelectionForValue = function (value) {
        var filledLength = _this.getFilledLength(value);

        var cursorPosition = _this.getRightEditablePosition(filledLength);

        return {
          start: cursorPosition,
          end: cursorPosition
        };
      };

      this.getFilledLength = function (value) {
        var characters = value.split("");
        var lastFilledIndex = findLastIndex(characters, function (character, position) {
          return _this.isPositionEditable(position) && _this.isCharacterFillingPosition(character, position);
        });
        return lastFilledIndex + 1;
      };

      this.getStringFillingLengthAtPosition = function (string, position) {
        var characters = string.split("");
        var insertedValue = characters.reduce(function (value, character) {
          return _this.insertCharacterAtPosition(value, character, value.length);
        }, repeat(" ", position));
        return insertedValue.length - position;
      };

      this.getLeftEditablePosition = function (position) {
        for (var i = position; i >= 0; i--) {
          if (_this.isPositionEditable(i)) {
            return i;
          }
        }

        return null;
      };

      this.getRightEditablePosition = function (position) {
        var mask = _this.maskOptions.mask;

        for (var i = position; i < mask.length; i++) {
          if (_this.isPositionEditable(i)) {
            return i;
          }
        }

        return null;
      };

      this.formatValue = function (value) {
        var _this$maskOptions2 = _this.maskOptions,
            maskPlaceholder = _this$maskOptions2.maskPlaceholder,
            mask = _this$maskOptions2.mask;

        if (!maskPlaceholder) {
          value = _this.insertStringAtPosition("", value, 0);

          while (value.length < mask.length && !_this.isPositionEditable(value.length)) {
            value += mask[value.length];
          }

          return value;
        }

        return _this.insertStringAtPosition(maskPlaceholder, value, 0);
      };

      this.clearRange = function (value, start, len) {
        if (!len) {
          return value;
        }

        var end = start + len;
        var _this$maskOptions3 = _this.maskOptions,
            maskPlaceholder = _this$maskOptions3.maskPlaceholder,
            mask = _this$maskOptions3.mask;
        var clearedValue = value.split("").map(function (character, i) {
          var isEditable = _this.isPositionEditable(i);

          if (!maskPlaceholder && i >= end && !isEditable) {
            return "";
          }

          if (i < start || i >= end) {
            return character;
          }

          if (!isEditable) {
            return mask[i];
          }

          if (maskPlaceholder) {
            return maskPlaceholder[i];
          }

          return "";
        }).join("");
        return _this.formatValue(clearedValue);
      };

      this.insertCharacterAtPosition = function (value, character, position) {
        var _this$maskOptions4 = _this.maskOptions,
            mask = _this$maskOptions4.mask,
            maskPlaceholder = _this$maskOptions4.maskPlaceholder;

        if (position >= mask.length) {
          return value;
        }

        var isAllowed = _this.isCharacterAllowedAtPosition(character, position);

        var isEditable = _this.isPositionEditable(position);

        var nextEditablePosition = _this.getRightEditablePosition(position);

        var isNextPlaceholder = maskPlaceholder && nextEditablePosition ? character === maskPlaceholder[nextEditablePosition] : null;
        var valueBefore = value.slice(0, position);

        if (isAllowed || !isEditable) {
          var insertedCharacter = isAllowed ? character : mask[position];
          value = valueBefore + insertedCharacter;
        }

        if (!isAllowed && !isEditable && !isNextPlaceholder) {
          value = _this.insertCharacterAtPosition(value, character, position + 1);
        }

        return value;
      };

      this.insertStringAtPosition = function (value, string, position) {
        var _this$maskOptions5 = _this.maskOptions,
            mask = _this$maskOptions5.mask,
            maskPlaceholder = _this$maskOptions5.maskPlaceholder;

        if (!string || position >= mask.length) {
          return value;
        }

        var characters = string.split("");
        var isFixedLength = _this.isValueFilled(value) || !!maskPlaceholder;
        var valueAfter = value.slice(position);
        value = characters.reduce(function (value, character) {
          return _this.insertCharacterAtPosition(value, character, value.length);
        }, value.slice(0, position));

        if (isFixedLength) {
          value += valueAfter.slice(value.length - position);
        } else if (_this.isValueFilled(value)) {
          value += mask.slice(value.length).join("");
        } else {
          var editableCharactersAfter = valueAfter.split("").filter(function (character, i) {
            return _this.isPositionEditable(position + i);
          });
          value = editableCharactersAfter.reduce(function (value, character) {
            var nextEditablePosition = _this.getRightEditablePosition(value.length);

            if (nextEditablePosition === null) {
              return value;
            }

            if (!_this.isPositionEditable(value.length)) {
              value += mask.slice(value.length, nextEditablePosition).join("");
            }

            return _this.insertCharacterAtPosition(value, character, value.length);
          }, value);
        }

        return value;
      };

      this.processChange = function (currentState, previousState) {
        var _this$maskOptions6 = _this.maskOptions,
            mask = _this$maskOptions6.mask,
            prefix = _this$maskOptions6.prefix,
            lastEditablePosition = _this$maskOptions6.lastEditablePosition;
        var value = currentState.value,
            selection = currentState.selection;
        var previousValue = previousState.value;
        var previousSelection = previousState.selection;
        var newValue = value;
        var enteredString = "";
        var formattedEnteredStringLength = 0;
        var removedLength = 0;
        var cursorPosition = Math.min(previousSelection.start, selection.start);

        if (selection.end > previousSelection.start) {
          enteredString = newValue.slice(previousSelection.start, selection.end);
          formattedEnteredStringLength = _this.getStringFillingLengthAtPosition(enteredString, cursorPosition);

          if (!formattedEnteredStringLength) {
            removedLength = 0;
          } else {
            removedLength = previousSelection.length;
          }
        } else if (newValue.length < previousValue.length) {
          removedLength = previousValue.length - newValue.length;
        }

        newValue = previousValue;

        if (removedLength) {
          if (removedLength === 1 && !previousSelection.length) {
            var deleteFromRight = previousSelection.start === selection.start;
            cursorPosition = deleteFromRight ? _this.getRightEditablePosition(selection.start) : _this.getLeftEditablePosition(selection.start);
          }

          newValue = _this.clearRange(newValue, cursorPosition, removedLength);
        }

        newValue = _this.insertStringAtPosition(newValue, enteredString, cursorPosition);
        cursorPosition += formattedEnteredStringLength;

        if (cursorPosition >= mask.length) {
          cursorPosition = mask.length;
        } else if (cursorPosition < prefix.length && !formattedEnteredStringLength) {
          cursorPosition = prefix.length;
        } else if (cursorPosition >= prefix.length && cursorPosition < lastEditablePosition && formattedEnteredStringLength) {
          cursorPosition = _this.getRightEditablePosition(cursorPosition);
        }

        newValue = _this.formatValue(newValue);
        return {
          value: newValue,
          enteredString: enteredString,
          selection: {
            start: cursorPosition,
            end: cursorPosition
          }
        };
      };

      this.maskOptions = parseMask(options);
    };

    var InputMaskChildrenWrapper = /*#__PURE__*/function (_React$Component) {
      _inheritsLoose(InputMaskChildrenWrapper, _React$Component);

      function InputMaskChildrenWrapper() {
        return _React$Component.apply(this, arguments) || this;
      }

      var _proto = InputMaskChildrenWrapper.prototype;

      _proto.render = function render() {
        // eslint-disable-next-line react/prop-types
        var _this$props = this.props,
            children = _this$props.children,
            props = _objectWithoutPropertiesLoose(_this$props, ["children"]);

        return React__default.cloneElement(children, props);
      };

      return InputMaskChildrenWrapper;
    }(React__default.Component);

    var InputMask = React.forwardRef(function InputMask(props, forwardedRef) {
      var alwaysShowMask = props.alwaysShowMask,
          children = props.children,
          mask = props.mask,
          maskPlaceholder = props.maskPlaceholder,
          beforeMaskedStateChange = props.beforeMaskedStateChange,
          restProps = _objectWithoutPropertiesLoose(props, ["alwaysShowMask", "children", "mask", "maskPlaceholder", "beforeMaskedStateChange"]);

      validateMaxLength(props);
      validateMaskPlaceholder(props);
      var maskUtils = new MaskUtils({
        mask: mask,
        maskPlaceholder: maskPlaceholder
      });
      var isMasked = !!mask;
      var isEditable = !restProps.disabled && !restProps.readOnly;
      var isControlled = props.value !== null && props.value !== undefined;
      var previousIsMasked = usePrevious(isMasked);
      var initialValue = toString((isControlled ? props.value : props.defaultValue) || "");

      var _useInputState = useInputState(initialValue, isMasked),
          inputRef = _useInputState.inputRef,
          getInputState = _useInputState.getInputState,
          setInputState = _useInputState.setInputState,
          getLastInputState = _useInputState.getLastInputState;

      var getInputElement = useInputElement(inputRef);

      function onChange(event) {
        var currentState = getInputState();
        var previousState = getLastInputState();
        var newInputState = maskUtils.processChange(currentState, previousState);

        if (beforeMaskedStateChange) {
          newInputState = beforeMaskedStateChange({
            currentState: currentState,
            previousState: previousState,
            nextState: newInputState
          });
        }

        setInputState(newInputState);

        if (props.onChange) {
          props.onChange(event);
        }
      }

      function onFocus(event) {
        // If autoFocus property is set, focus event fires before the ref handler gets called
        inputRef.current = event.target;
        var currentValue = getInputState().value;

        if (isMasked && !maskUtils.isValueFilled(currentValue)) {
          var newValue = maskUtils.formatValue(currentValue);
          var newSelection = maskUtils.getDefaultSelectionForValue(newValue);
          var newInputState = {
            value: newValue,
            selection: newSelection
          };

          if (beforeMaskedStateChange) {
            newInputState = beforeMaskedStateChange({
              currentState: getInputState(),
              nextState: newInputState
            });
            newValue = newInputState.value;
            newSelection = newInputState.selection;
          }

          setInputState(newInputState);

          if (newValue !== currentValue && props.onChange) {
            props.onChange(event);
          } // Chrome resets selection after focus event,
          // so we want to restore it later


          defer(function () {
            setInputState(getLastInputState());
          });
        }

        if (props.onFocus) {
          props.onFocus(event);
        }
      }

      function onBlur(event) {
        var currentValue = getInputState().value;
        var lastValue = getLastInputState().value;

        if (isMasked && !alwaysShowMask && maskUtils.isValueEmpty(lastValue)) {
          var newValue = "";
          var newInputState = {
            value: newValue,
            selection: {
              start: null,
              end: null
            }
          };

          if (beforeMaskedStateChange) {
            newInputState = beforeMaskedStateChange({
              currentState: getInputState(),
              nextState: newInputState
            });
            newValue = newInputState.value;
          }

          setInputState(newInputState);

          if (newValue !== currentValue && props.onChange) {
            props.onChange(event);
          }
        }

        if (props.onBlur) {
          props.onBlur(event);
        }
      } // Tiny unintentional mouse movements can break cursor
      // position on focus, so we have to restore it in that case
      //
      // https://github.com/sanniassin/react-input-mask/issues/108


      function onMouseDown(event) {
        var input = getInputElement();

        var _getInputState = getInputState(),
            value = _getInputState.value;

        var inputDocument = getElementDocument(input);

        if (!isInputFocused(input) && !maskUtils.isValueFilled(value)) {
          var mouseDownX = event.clientX;
          var mouseDownY = event.clientY;
          var mouseDownTime = new Date().getTime();

          var mouseUpHandler = function mouseUpHandler(mouseUpEvent) {
            inputDocument.removeEventListener("mouseup", mouseUpHandler);

            if (!isInputFocused(input)) {
              return;
            }

            var deltaX = Math.abs(mouseUpEvent.clientX - mouseDownX);
            var deltaY = Math.abs(mouseUpEvent.clientY - mouseDownY);
            var axisDelta = Math.max(deltaX, deltaY);
            var timeDelta = new Date().getTime() - mouseDownTime;

            if (axisDelta <= 10 && timeDelta <= 200 || axisDelta <= 5 && timeDelta <= 300) {
              var _lastState = getLastInputState();

              var newSelection = maskUtils.getDefaultSelectionForValue(_lastState.value);

              var newState = _extends({}, _lastState, {
                selection: newSelection
              });

              setInputState(newState);
            }
          };

          inputDocument.addEventListener("mouseup", mouseUpHandler);
        }

        if (props.onMouseDown) {
          props.onMouseDown(event);
        }
      } // For controlled inputs we want to provide properly formatted
      // value prop


      if (isMasked && isControlled) {
        var input = getInputElement();
        var isFocused = input && isInputFocused(input);
        var newValue = isFocused || alwaysShowMask || props.value ? maskUtils.formatValue(props.value) : props.value;

        if (beforeMaskedStateChange) {
          newValue = beforeMaskedStateChange({
            nextState: {
              value: newValue,
              selection: {
                start: null,
                end: null
              }
            }
          }).value;
        }

        setInputState(_extends({}, getLastInputState(), {
          value: newValue
        }));
      }

      var lastState = getLastInputState();
      var lastSelection = lastState.selection;
      var lastValue = lastState.value;
      React.useLayoutEffect(function () {
        if (!isMasked) {
          return;
        }

        var input = getInputElement();
        var isFocused = isInputFocused(input);
        var previousSelection = lastSelection;
        var currentState = getInputState();

        var newInputState = _extends({}, currentState); // Update value for uncontrolled inputs to make sure
        // it's always in sync with mask props


        if (!isControlled) {
          var currentValue = currentState.value;
          var formattedValue = maskUtils.formatValue(currentValue);
          var isValueEmpty = maskUtils.isValueEmpty(formattedValue);
          var shouldFormatValue = !isValueEmpty || isFocused || alwaysShowMask;

          if (shouldFormatValue) {
            newInputState.value = formattedValue;
          } else if (isValueEmpty && !isFocused) {
            newInputState.value = "";
          }
        }

        if (isFocused && !previousIsMasked) {
          // Adjust selection if input got masked while being focused
          newInputState.selection = maskUtils.getDefaultSelectionForValue(newInputState.value);
        } else if (isControlled && isFocused && previousSelection) {
          // Restore cursor position if value has changed outside change event
          if (previousSelection.start !== null && previousSelection.end !== null) {
            newInputState.selection = previousSelection;
          }
        }

        if (beforeMaskedStateChange) {
          newInputState = beforeMaskedStateChange({
            currentState: currentState,
            nextState: newInputState
          });
        }

        setInputState(newInputState);
      });

      var inputProps = _extends({}, restProps, {
        onFocus: onFocus,
        onBlur: onBlur,
        onChange: isMasked && isEditable ? onChange : props.onChange,
        onMouseDown: isMasked && isEditable ? onMouseDown : props.onMouseDown,
        ref: function ref(_ref) {
          inputRef.current = reactDom.findDOMNode(_ref);

          if (isFunction(forwardedRef)) {
            forwardedRef(_ref);
          } else if (forwardedRef !== null && typeof forwardedRef === "object") {
            forwardedRef.current = _ref;
          }
        },
        value: isMasked && isControlled ? lastValue : props.value
      });

      if (children) {
        validateChildren(props, children); // We wrap children into a class component to be able to find
        // their input element using findDOMNode

        return React__default.createElement(InputMaskChildrenWrapper, inputProps, children);
      }

      return React__default.createElement("input", inputProps);
    });
    InputMask.displayName = "InputMask";
    InputMask.defaultProps = {
      alwaysShowMask: false,
      maskPlaceholder: "_"
    };
    InputMask.propTypes = {
      alwaysShowMask: PropTypes.bool,
      beforeMaskedStateChange: PropTypes.func,
      children: PropTypes.element,
      mask: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(RegExp)]))]),
      maskPlaceholder: PropTypes.string,
      onFocus: PropTypes.func,
      onBlur: PropTypes.func,
      onChange: PropTypes.func,
      onMouseDown: PropTypes.func
    };
    module.exports = InputMask;
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(25));
  /***/
},
/* 602 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  function t(t) {
    return t && "object" == typeof t && "default" in t ? t.default : t;
  }

  var e = __webpack_require__(4),
      n = t(e),
      i = __webpack_require__(244);

  __webpack_require__(243);

  var r = t(__webpack_require__(242));

  function a() {
    return (a = Object.assign || function (t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = arguments[e];

        for (var i in n) {
          Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
        }
      }

      return t;
    }).apply(this, arguments);
  }

  function o(t, e) {
    t.prototype = Object.create(e.prototype), t.prototype.constructor = t, function (t, e) {
      for (var n = Object.getOwnPropertyNames(e), i = 0; i < n.length; i++) {
        var r = n[i],
            a = Object.getOwnPropertyDescriptor(e, r);
        a && a.configurable && void 0 === t[r] && Object.defineProperty(t, r, a);
      }
    }(t, e);
  }

  function l(t, e) {
    if (null == t) return {};
    var n,
        i,
        r = {},
        a = Object.keys(t);

    for (i = 0; i < a.length; i++) {
      n = a[i], e.indexOf(n) >= 0 || (r[n] = t[n]);
    }

    return r;
  }

  function u(t) {
    return requestAnimationFrame(t);
  }

  function s(t) {
    cancelAnimationFrame(t);
  }

  function c(t) {
    var e = t.ownerDocument;
    return e.hasFocus() && e.activeElement === t;
  }

  function f(t) {
    return null == t ? void 0 : t.ownerDocument;
  }

  function h(t) {
    var e = function (t) {
      var e;
      return null == (e = f(t)) ? void 0 : e.defaultView;
    }(t);

    return !!e && t instanceof e.HTMLElement;
  }

  function g(t) {
    return e.useCallback(function () {
      var e = t.current,
          n = "undefined" != typeof window && h(e);
      if (!e || !n) return null;
      if ("INPUT" !== e.nodeName && (e = e.querySelector("input")), !e) throw new Error("react-input-mask: inputComponent doesn't contain input node");
      return e;
    }, [t]);
  }

  function v(t, n) {
    var i,
        r,
        a,
        o,
        l = e.useRef({
      start: null,
      end: null
    }),
        f = g(t),
        h = e.useCallback(function () {
      return function (t) {
        var e = t.selectionStart,
            n = t.selectionEnd;
        return {
          start: e,
          end: n,
          length: n - e
        };
      }(f());
    }, [f]),
        v = e.useCallback(function () {
      return l.current;
    }, []),
        d = e.useCallback(function (t) {
      var e = f();
      e && c(e) && (!function (t, e, n) {
        void 0 === n && (n = e), t.setSelectionRange(e, n);
      }(e, t.start, t.end), l.current = h());
    }, [f, h]),
        p = e.useCallback(function () {
      l.current = h();
    }, [h]),
        m = (i = p, r = e.useRef(null), a = e.useCallback(function () {
      null === r.current && function t() {
        i(), r.current = u(t);
      }();
    }, [i]), o = e.useCallback(function () {
      s(r.current), r.current = null;
    }, []), e.useEffect(function () {
      r.current && (o(), a());
    }, [a, o]), e.useEffect(s, []), [a, o]),
        P = m[0],
        k = m[1];
    return e.useLayoutEffect(function () {
      if (n) {
        var t = f();
        return t.addEventListener("focus", P), t.addEventListener("blur", k), c(t) && P(), function () {
          t.removeEventListener("focus", P), t.removeEventListener("blur", k), k();
        };
      }
    }), {
      getSelection: h,
      getLastSelection: v,
      setSelection: d
    };
  }

  function d(t, n) {
    var i = e.useRef(),
        r = v(i, n),
        a = r.getSelection,
        o = r.getLastSelection,
        l = r.setSelection,
        u = function (t, n) {
      var i = g(t),
          r = e.useRef(n);
      return {
        getValue: e.useCallback(function () {
          return i().value;
        }, [i]),
        getLastValue: e.useCallback(function () {
          return r.current;
        }, []),
        setValue: e.useCallback(function (t) {
          r.current = t;
          var e = i();
          e && (e.value = t);
        }, [i])
      };
    }(i, t),
        s = u.getValue,
        c = u.getLastValue,
        f = u.setValue;

    return {
      inputRef: i,
      getInputState: function getInputState() {
        return {
          value: s(),
          selection: a()
        };
      },
      getLastInputState: function getLastInputState() {
        return {
          value: c(),
          selection: o()
        };
      },
      setInputState: function setInputState(t) {
        var e = t.value,
            n = t.selection;
        f(e), l(n);
      }
    };
  }

  __webpack_require__(247);

  var p = ["disabled", "onBlur", "onChange", "onFocus", "onMouseDown", "readOnly", "value"],
      m = {
    9: /[0-9]/,
    a: /[A-Za-z]/,
    "*": /[A-Za-z0-9]/
  };

  var P = function P(t) {
    var e = this;
    this.isCharacterAllowedAtPosition = function (t, n) {
      var i = e.maskOptions.maskPlaceholder;
      return !!e.isCharacterFillingPosition(t, n) || !!i && i[n] === t;
    }, this.isCharacterFillingPosition = function (t, n) {
      var i = e.maskOptions.mask;
      if (!t || n >= i.length) return !1;
      if (!e.isPositionEditable(n)) return i[n] === t;
      var r = i[n];
      return new RegExp(r).test(t);
    }, this.isPositionEditable = function (t) {
      var n = e.maskOptions,
          i = n.mask,
          r = n.permanents;
      return t < i.length && -1 === r.indexOf(t);
    }, this.isValueEmpty = function (t) {
      return t.split("").every(function (t, n) {
        return !e.isPositionEditable(n) || !e.isCharacterFillingPosition(t, n);
      });
    }, this.isValueFilled = function (t) {
      return e.getFilledLength(t) === e.maskOptions.lastEditablePosition + 1;
    }, this.getDefaultSelectionForValue = function (t) {
      var n = e.getFilledLength(t),
          i = e.getRightEditablePosition(n);
      return {
        start: i,
        end: i
      };
    }, this.getFilledLength = function (t) {
      return function (t, e) {
        for (var n = t.length - 1; n >= 0; n--) {
          if (e(t[n], n)) return n;
        }

        return -1;
      }(t.split(""), function (t, n) {
        return e.isPositionEditable(n) && e.isCharacterFillingPosition(t, n);
      }) + 1;
    }, this.getStringFillingLengthAtPosition = function (t, n) {
      return t.split("").reduce(function (t, n) {
        return e.insertCharacterAtPosition(t, n, t.length);
      }, function (t, e) {
        void 0 === e && (e = 1);

        for (var n = "", i = 0; i < e; i++) {
          n += t;
        }

        return n;
      }(" ", n)).length - n;
    }, this.getLeftEditablePosition = function (t) {
      for (var n = t; n >= 0; n--) {
        if (e.isPositionEditable(n)) return n;
      }

      return null;
    }, this.getRightEditablePosition = function (t) {
      for (var n = e.maskOptions.mask, i = t; i < n.length; i++) {
        if (e.isPositionEditable(i)) return i;
      }

      return null;
    }, this.formatValue = function (t) {
      var n = e.maskOptions,
          i = n.maskPlaceholder,
          r = n.mask;

      if (!i) {
        for (t = e.insertStringAtPosition("", t, 0); t.length < r.length && !e.isPositionEditable(t.length);) {
          t += r[t.length];
        }

        return t;
      }

      return e.insertStringAtPosition(i, t, 0);
    }, this.clearRange = function (t, n, i) {
      if (!i) return t;
      var r = n + i,
          a = e.maskOptions,
          o = a.maskPlaceholder,
          l = a.mask,
          u = t.split("").map(function (t, i) {
        var a = e.isPositionEditable(i);
        return !o && i >= r && !a ? "" : i < n || i >= r ? t : a ? o ? o[i] : "" : l[i];
      }).join("");
      return e.formatValue(u);
    }, this.insertCharacterAtPosition = function (t, n, i) {
      var r = e.maskOptions,
          a = r.mask,
          o = r.maskPlaceholder;
      if (i >= a.length) return t;
      var l = e.isCharacterAllowedAtPosition(n, i),
          u = e.isPositionEditable(i),
          s = e.getRightEditablePosition(i),
          c = o && s ? n === o[s] : null,
          f = t.slice(0, i);
      !l && u || (t = f + (l ? n : a[i]));
      return l || u || c || (t = e.insertCharacterAtPosition(t, n, i + 1)), t;
    }, this.insertStringAtPosition = function (t, n, i) {
      var r = e.maskOptions,
          a = r.mask,
          o = r.maskPlaceholder;
      if (!n || i >= a.length) return t;
      var l = n.split(""),
          u = e.isValueFilled(t) || !!o,
          s = t.slice(i);
      if (t = l.reduce(function (t, n) {
        return e.insertCharacterAtPosition(t, n, t.length);
      }, t.slice(0, i)), u) t += s.slice(t.length - i);else if (e.isValueFilled(t)) t += a.slice(t.length).join("");else {
        t = s.split("").filter(function (t, n) {
          return e.isPositionEditable(i + n);
        }).reduce(function (t, n) {
          var i = e.getRightEditablePosition(t.length);
          return null === i ? t : (e.isPositionEditable(t.length) || (t += a.slice(t.length, i).join("")), e.insertCharacterAtPosition(t, n, t.length));
        }, t);
      }
      return t;
    }, this.processChange = function (t, n) {
      var i = e.maskOptions,
          r = i.mask,
          a = i.prefix,
          o = i.lastEditablePosition,
          l = t.value,
          u = t.selection,
          s = n.value,
          c = n.selection,
          f = l,
          h = "",
          g = 0,
          v = 0,
          d = Math.min(c.start, u.start);

      if (u.end > c.start ? (h = f.slice(c.start, u.end), v = (g = e.getStringFillingLengthAtPosition(h, d)) ? c.length : 0) : f.length < s.length && (v = s.length - f.length), f = s, v) {
        if (1 === v && !c.length) d = c.start === u.start ? e.getRightEditablePosition(u.start) : e.getLeftEditablePosition(u.start);
        f = e.clearRange(f, d, v);
      }

      return f = e.insertStringAtPosition(f, h, d), (d += g) >= r.length ? d = r.length : d < a.length && !g ? d = a.length : d >= a.length && d < o && g && (d = e.getRightEditablePosition(d)), {
        value: f = e.formatValue(f),
        enteredString: h,
        selection: {
          start: d,
          end: d
        }
      };
    }, this.maskOptions = function (t) {
      var e = t.mask,
          n = t.maskPlaceholder,
          i = [];
      if (!e) return {
        maskPlaceholder: null,
        mask: null,
        prefix: null,
        lastEditablePosition: null,
        permanents: []
      };

      if ("string" == typeof e) {
        var r = !1,
            a = "";
        e.split("").forEach(function (t) {
          r || "\\" !== t ? (!r && m[t] || i.push(a.length), a += t, r = !1) : r = !0;
        }), e = a.split("").map(function (t, e) {
          return -1 === i.indexOf(e) ? m[t] : t;
        });
      } else e.forEach(function (t, e) {
        "string" == typeof t && i.push(e);
      });

      n && (n = 1 === n.length ? e.map(function (t, e) {
        return -1 !== i.indexOf(e) ? t : n;
      }) : n.split(""), i.forEach(function (t) {
        n[t] = e[t];
      }), n = n.join(""));

      for (var o = i.filter(function (t, e) {
        return t === e;
      }).map(function (t) {
        return e[t];
      }).join(""), l = e.length - 1; -1 !== i.indexOf(l);) {
        l--;
      }

      return {
        maskPlaceholder: n,
        prefix: o,
        mask: e,
        lastEditablePosition: l,
        permanents: i
      };
    }(t);
  },
      k = function (t) {
    function e() {
      return t.apply(this, arguments) || this;
    }

    return o(e, t), e.prototype.render = function () {
      var t = this.props,
          e = t.children,
          i = l(t, ["children"]);
      return n.cloneElement(e, i);
    }, e;
  }(n.Component),
      b = e.forwardRef(function (t, o) {
    var s = t.alwaysShowMask,
        h = t.children,
        v = t.mask,
        m = t.maskPlaceholder,
        b = t.beforeMaskedStateChange,
        E = l(t, ["alwaysShowMask", "children", "mask", "maskPlaceholder", "beforeMaskedStateChange"]);
    !function (t) {
      var e = t.mask,
          n = t.maskPlaceholder;
      e && n && 1 !== n.length && n.length !== e.length && r(!1);
    }(t);
    var S,
        C,
        y = new P({
      mask: v,
      maskPlaceholder: m
    }),
        w = !!v,
        O = !E.disabled && !E.readOnly,
        V = null !== t.value && void 0 !== t.value,
        F = (S = w, C = e.useRef(), e.useEffect(function () {
      C.current = S;
    }), C.current),
        L = d(function (t) {
      return "" + t;
    }((V ? t.value : t.defaultValue) || ""), w),
        A = L.inputRef,
        R = L.getInputState,
        M = L.setInputState,
        x = L.getLastInputState,
        D = g(A);

    if (w && V) {
      var j = D(),
          I = j && c(j) || s || t.value ? y.formatValue(t.value) : t.value;
      b && (I = b({
        nextState: {
          value: I,
          selection: {
            start: null,
            end: null
          }
        }
      }).value), M(a({}, x(), {
        value: I
      }));
    }

    var q = x(),
        N = q.selection,
        B = q.value;
    e.useLayoutEffect(function () {
      if (w) {
        var t = c(D()),
            e = N,
            n = R(),
            i = a({}, n);

        if (!V) {
          var r = n.value,
              o = y.formatValue(r),
              l = y.isValueEmpty(o);
          !l || t || s ? i.value = o : l && !t && (i.value = "");
        }

        t && !F ? i.selection = y.getDefaultSelectionForValue(i.value) : V && t && e && null !== e.start && null !== e.end && (i.selection = e), b && (i = b({
          currentState: n,
          nextState: i
        })), M(i);
      }
    });
    var T = a({}, E, {
      onFocus: function onFocus(e) {
        A.current = e.target;
        var n = R().value;

        if (w && !y.isValueFilled(n)) {
          var i = y.formatValue(n),
              r = y.getDefaultSelectionForValue(i),
              a = {
            value: i,
            selection: r
          };
          b && (i = (a = b({
            currentState: R(),
            nextState: a
          })).value, r = a.selection), M(a), i !== n && t.onChange && t.onChange(e), u(function () {
            M(x());
          });
        }

        t.onFocus && t.onFocus(e);
      },
      onBlur: function onBlur(e) {
        var n = R().value,
            i = x().value;

        if (w && !s && y.isValueEmpty(i)) {
          var r = "",
              a = {
            value: r,
            selection: {
              start: null,
              end: null
            }
          };
          b && (r = (a = b({
            currentState: R(),
            nextState: a
          })).value), M(a), r !== n && t.onChange && t.onChange(e);
        }

        t.onBlur && t.onBlur(e);
      },
      onChange: w && O ? function (e) {
        var n = R(),
            i = x(),
            r = y.processChange(n, i);
        b && (r = b({
          currentState: n,
          previousState: i,
          nextState: r
        })), M(r), t.onChange && t.onChange(e);
      } : t.onChange,
      onMouseDown: w && O ? function (e) {
        var n = D(),
            i = R().value,
            r = f(n);

        if (!c(n) && !y.isValueFilled(i)) {
          var o = e.clientX,
              l = e.clientY,
              u = new Date().getTime();
          r.addEventListener("mouseup", function t(e) {
            if (r.removeEventListener("mouseup", t), c(n)) {
              var i = Math.abs(e.clientX - o),
                  s = Math.abs(e.clientY - l),
                  f = Math.max(i, s),
                  h = new Date().getTime() - u;

              if (f <= 10 && h <= 200 || f <= 5 && h <= 300) {
                var g = x(),
                    v = a({}, g, {
                  selection: y.getDefaultSelectionForValue(g.value)
                });
                M(v);
              }
            }
          });
        }

        t.onMouseDown && t.onMouseDown(e);
      } : t.onMouseDown,
      ref: function ref(t) {
        A.current = i.findDOMNode(t), !function (t) {
          return "function" == typeof t;
        }(o) ? null !== o && "object" == typeof o && (o.current = t) : o(t);
      },
      value: w && V ? B : t.value
    });
    return h ? (function (t, e) {
      p.filter(function (n) {
        return null != e.props[n] && e.props[n] !== t[n];
      }).length && r(!1);
    }(t, h), n.createElement(k, T, h)) : n.createElement("input", T);
  });

  b.displayName = "InputMask", b.defaultProps = {
    alwaysShowMask: !1,
    maskPlaceholder: "_"
  }, module.exports = b;
  /***/
},
/* 603 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (process) {
    /** @license React v16.13.1
    * react-is.development.js
    *
    * Copyright (c) Facebook, Inc. and its affiliates.
    *
    * This source code is licensed under the MIT license found in the
    * LICENSE file in the root directory of this source tree.
    */
    if (process.env.NODE_ENV !== "production") {
      (function () {
        'use strict'; // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
        // nor polyfill, then a plain number is used for performance.

        var hasSymbol = typeof Symbol === 'function' && Symbol.for;
        var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
        var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
        var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
        var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
        var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
        var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
        var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
        // (unstable) APIs that have been removed. Can we remove the symbols?

        var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
        var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
        var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
        var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
        var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
        var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
        var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
        var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
        var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
        var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
        var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

        function isValidElementType(type) {
          return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
          type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
        }

        function typeOf(object) {
          if (typeof object === 'object' && object !== null) {
            var $$typeof = object.$$typeof;

            switch ($$typeof) {
              case REACT_ELEMENT_TYPE:
                var type = object.type;

                switch (type) {
                  case REACT_ASYNC_MODE_TYPE:
                  case REACT_CONCURRENT_MODE_TYPE:
                  case REACT_FRAGMENT_TYPE:
                  case REACT_PROFILER_TYPE:
                  case REACT_STRICT_MODE_TYPE:
                  case REACT_SUSPENSE_TYPE:
                    return type;

                  default:
                    var $$typeofType = type && type.$$typeof;

                    switch ($$typeofType) {
                      case REACT_CONTEXT_TYPE:
                      case REACT_FORWARD_REF_TYPE:
                      case REACT_LAZY_TYPE:
                      case REACT_MEMO_TYPE:
                      case REACT_PROVIDER_TYPE:
                        return $$typeofType;

                      default:
                        return $$typeof;
                    }

                }

              case REACT_PORTAL_TYPE:
                return $$typeof;
            }
          }

          return undefined;
        } // AsyncMode is deprecated along with isAsyncMode


        var AsyncMode = REACT_ASYNC_MODE_TYPE;
        var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
        var ContextConsumer = REACT_CONTEXT_TYPE;
        var ContextProvider = REACT_PROVIDER_TYPE;
        var Element = REACT_ELEMENT_TYPE;
        var ForwardRef = REACT_FORWARD_REF_TYPE;
        var Fragment = REACT_FRAGMENT_TYPE;
        var Lazy = REACT_LAZY_TYPE;
        var Memo = REACT_MEMO_TYPE;
        var Portal = REACT_PORTAL_TYPE;
        var Profiler = REACT_PROFILER_TYPE;
        var StrictMode = REACT_STRICT_MODE_TYPE;
        var Suspense = REACT_SUSPENSE_TYPE;
        var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

        function isAsyncMode(object) {
          {
            if (!hasWarnedAboutDeprecatedIsAsyncMode) {
              hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

              console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
            }
          }
          return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
        }

        function isConcurrentMode(object) {
          return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
        }

        function isContextConsumer(object) {
          return typeOf(object) === REACT_CONTEXT_TYPE;
        }

        function isContextProvider(object) {
          return typeOf(object) === REACT_PROVIDER_TYPE;
        }

        function isElement(object) {
          return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
        }

        function isForwardRef(object) {
          return typeOf(object) === REACT_FORWARD_REF_TYPE;
        }

        function isFragment(object) {
          return typeOf(object) === REACT_FRAGMENT_TYPE;
        }

        function isLazy(object) {
          return typeOf(object) === REACT_LAZY_TYPE;
        }

        function isMemo(object) {
          return typeOf(object) === REACT_MEMO_TYPE;
        }

        function isPortal(object) {
          return typeOf(object) === REACT_PORTAL_TYPE;
        }

        function isProfiler(object) {
          return typeOf(object) === REACT_PROFILER_TYPE;
        }

        function isStrictMode(object) {
          return typeOf(object) === REACT_STRICT_MODE_TYPE;
        }

        function isSuspense(object) {
          return typeOf(object) === REACT_SUSPENSE_TYPE;
        }

        exports.AsyncMode = AsyncMode;
        exports.ConcurrentMode = ConcurrentMode;
        exports.ContextConsumer = ContextConsumer;
        exports.ContextProvider = ContextProvider;
        exports.Element = Element;
        exports.ForwardRef = ForwardRef;
        exports.Fragment = Fragment;
        exports.Lazy = Lazy;
        exports.Memo = Memo;
        exports.Portal = Portal;
        exports.Profiler = Profiler;
        exports.StrictMode = StrictMode;
        exports.Suspense = Suspense;
        exports.isAsyncMode = isAsyncMode;
        exports.isConcurrentMode = isConcurrentMode;
        exports.isContextConsumer = isContextConsumer;
        exports.isContextProvider = isContextProvider;
        exports.isElement = isElement;
        exports.isForwardRef = isForwardRef;
        exports.isFragment = isFragment;
        exports.isLazy = isLazy;
        exports.isMemo = isMemo;
        exports.isPortal = isPortal;
        exports.isProfiler = isProfiler;
        exports.isStrictMode = isStrictMode;
        exports.isSuspense = isSuspense;
        exports.isValidElementType = isValidElementType;
        exports.typeOf = typeOf;
      })();
    }
    /* WEBPACK VAR INJECTION */

  }).call(exports, __webpack_require__(25));
  /***/
},
/* 604 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /** @license React v16.13.1
   * react-is.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  var b = "function" === typeof Symbol && Symbol.for,
      c = b ? Symbol.for("react.element") : 60103,
      d = b ? Symbol.for("react.portal") : 60106,
      e = b ? Symbol.for("react.fragment") : 60107,
      f = b ? Symbol.for("react.strict_mode") : 60108,
      g = b ? Symbol.for("react.profiler") : 60114,
      h = b ? Symbol.for("react.provider") : 60109,
      k = b ? Symbol.for("react.context") : 60110,
      l = b ? Symbol.for("react.async_mode") : 60111,
      m = b ? Symbol.for("react.concurrent_mode") : 60111,
      n = b ? Symbol.for("react.forward_ref") : 60112,
      p = b ? Symbol.for("react.suspense") : 60113,
      q = b ? Symbol.for("react.suspense_list") : 60120,
      r = b ? Symbol.for("react.memo") : 60115,
      t = b ? Symbol.for("react.lazy") : 60116,
      v = b ? Symbol.for("react.block") : 60121,
      w = b ? Symbol.for("react.fundamental") : 60117,
      x = b ? Symbol.for("react.responder") : 60118,
      y = b ? Symbol.for("react.scope") : 60119;

  function z(a) {
    if ("object" === typeof a && null !== a) {
      var u = a.$$typeof;

      switch (u) {
        case c:
          switch (a = a.type, a) {
            case l:
            case m:
            case e:
            case g:
            case f:
            case p:
              return a;

            default:
              switch (a = a && a.$$typeof, a) {
                case k:
                case n:
                case t:
                case r:
                case h:
                  return a;

                default:
                  return u;
              }

          }

        case d:
          return u;
      }
    }
  }

  function A(a) {
    return z(a) === m;
  }

  exports.AsyncMode = l;
  exports.ConcurrentMode = m;
  exports.ContextConsumer = k;
  exports.ContextProvider = h;
  exports.Element = c;
  exports.ForwardRef = n;
  exports.Fragment = e;
  exports.Lazy = t;
  exports.Memo = r;
  exports.Portal = d;
  exports.Profiler = g;
  exports.StrictMode = f;
  exports.Suspense = p;

  exports.isAsyncMode = function (a) {
    return A(a) || z(a) === l;
  };

  exports.isConcurrentMode = A;

  exports.isContextConsumer = function (a) {
    return z(a) === k;
  };

  exports.isContextProvider = function (a) {
    return z(a) === h;
  };

  exports.isElement = function (a) {
    return "object" === typeof a && null !== a && a.$$typeof === c;
  };

  exports.isForwardRef = function (a) {
    return z(a) === n;
  };

  exports.isFragment = function (a) {
    return z(a) === e;
  };

  exports.isLazy = function (a) {
    return z(a) === t;
  };

  exports.isMemo = function (a) {
    return z(a) === r;
  };

  exports.isPortal = function (a) {
    return z(a) === d;
  };

  exports.isProfiler = function (a) {
    return z(a) === g;
  };

  exports.isStrictMode = function (a) {
    return z(a) === f;
  };

  exports.isSuspense = function (a) {
    return z(a) === p;
  };

  exports.isValidElementType = function (a) {
    return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
  };

  exports.typeOf = z;
  /***/
},
/* 605 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (process) {
    /** @license React v0.20.2
    * scheduler-tracing.development.js
    *
    * Copyright (c) Facebook, Inc. and its affiliates.
    *
    * This source code is licensed under the MIT license found in the
    * LICENSE file in the root directory of this source tree.
    */
    if (process.env.NODE_ENV !== "production") {
      (function () {
        'use strict';

        var DEFAULT_THREAD_ID = 0; // Counters used to generate unique IDs.

        var interactionIDCounter = 0;
        var threadIDCounter = 0; // Set of currently traced interactions.
        // Interactions "stack"–
        // Meaning that newly traced interactions are appended to the previously active set.
        // When an interaction goes out of scope, the previous set (if any) is restored.

        exports.__interactionsRef = null; // Listener(s) to notify when interactions begin and end.

        exports.__subscriberRef = null;
        {
          exports.__interactionsRef = {
            current: new Set()
          };
          exports.__subscriberRef = {
            current: null
          };
        }

        function unstable_clear(callback) {
          var prevInteractions = exports.__interactionsRef.current;
          exports.__interactionsRef.current = new Set();

          try {
            return callback();
          } finally {
            exports.__interactionsRef.current = prevInteractions;
          }
        }

        function unstable_getCurrent() {
          {
            return exports.__interactionsRef.current;
          }
        }

        function unstable_getThreadID() {
          return ++threadIDCounter;
        }

        function unstable_trace(name, timestamp, callback) {
          var threadID = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : DEFAULT_THREAD_ID;
          var interaction = {
            __count: 1,
            id: interactionIDCounter++,
            name: name,
            timestamp: timestamp
          };
          var prevInteractions = exports.__interactionsRef.current; // Traced interactions should stack/accumulate.
          // To do that, clone the current interactions.
          // The previous set will be restored upon completion.

          var interactions = new Set(prevInteractions);
          interactions.add(interaction);
          exports.__interactionsRef.current = interactions;
          var subscriber = exports.__subscriberRef.current;
          var returnValue;

          try {
            if (subscriber !== null) {
              subscriber.onInteractionTraced(interaction);
            }
          } finally {
            try {
              if (subscriber !== null) {
                subscriber.onWorkStarted(interactions, threadID);
              }
            } finally {
              try {
                returnValue = callback();
              } finally {
                exports.__interactionsRef.current = prevInteractions;

                try {
                  if (subscriber !== null) {
                    subscriber.onWorkStopped(interactions, threadID);
                  }
                } finally {
                  interaction.__count--; // If no async work was scheduled for this interaction,
                  // Notify subscribers that it's completed.

                  if (subscriber !== null && interaction.__count === 0) {
                    subscriber.onInteractionScheduledWorkCompleted(interaction);
                  }
                }
              }
            }
          }

          return returnValue;
        }

        function unstable_wrap(callback) {
          var threadID = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_THREAD_ID;
          var wrappedInteractions = exports.__interactionsRef.current;
          var subscriber = exports.__subscriberRef.current;

          if (subscriber !== null) {
            subscriber.onWorkScheduled(wrappedInteractions, threadID);
          } // Update the pending async work count for the current interactions.
          // Update after calling subscribers in case of error.


          wrappedInteractions.forEach(function (interaction) {
            interaction.__count++;
          });
          var hasRun = false;

          function wrapped() {
            var prevInteractions = exports.__interactionsRef.current;
            exports.__interactionsRef.current = wrappedInteractions;
            subscriber = exports.__subscriberRef.current;

            try {
              var returnValue;

              try {
                if (subscriber !== null) {
                  subscriber.onWorkStarted(wrappedInteractions, threadID);
                }
              } finally {
                try {
                  returnValue = callback.apply(undefined, arguments);
                } finally {
                  exports.__interactionsRef.current = prevInteractions;

                  if (subscriber !== null) {
                    subscriber.onWorkStopped(wrappedInteractions, threadID);
                  }
                }
              }

              return returnValue;
            } finally {
              if (!hasRun) {
                // We only expect a wrapped function to be executed once,
                // But in the event that it's executed more than once–
                // Only decrement the outstanding interaction counts once.
                hasRun = true; // Update pending async counts for all wrapped interactions.
                // If this was the last scheduled async work for any of them,
                // Mark them as completed.

                wrappedInteractions.forEach(function (interaction) {
                  interaction.__count--;

                  if (subscriber !== null && interaction.__count === 0) {
                    subscriber.onInteractionScheduledWorkCompleted(interaction);
                  }
                });
              }
            }
          }

          wrapped.cancel = function cancel() {
            subscriber = exports.__subscriberRef.current;

            try {
              if (subscriber !== null) {
                subscriber.onWorkCanceled(wrappedInteractions, threadID);
              }
            } finally {
              // Update pending async counts for all wrapped interactions.
              // If this was the last scheduled async work for any of them,
              // Mark them as completed.
              wrappedInteractions.forEach(function (interaction) {
                interaction.__count--;

                if (subscriber && interaction.__count === 0) {
                  subscriber.onInteractionScheduledWorkCompleted(interaction);
                }
              });
            }
          };

          return wrapped;
        }

        var subscribers = null;
        {
          subscribers = new Set();
        }

        function unstable_subscribe(subscriber) {
          {
            subscribers.add(subscriber);

            if (subscribers.size === 1) {
              exports.__subscriberRef.current = {
                onInteractionScheduledWorkCompleted: onInteractionScheduledWorkCompleted,
                onInteractionTraced: onInteractionTraced,
                onWorkCanceled: onWorkCanceled,
                onWorkScheduled: onWorkScheduled,
                onWorkStarted: onWorkStarted,
                onWorkStopped: onWorkStopped
              };
            }
          }
        }

        function unstable_unsubscribe(subscriber) {
          {
            subscribers.delete(subscriber);

            if (subscribers.size === 0) {
              exports.__subscriberRef.current = null;
            }
          }
        }

        function onInteractionTraced(interaction) {
          var didCatchError = false;
          var caughtError = null;
          subscribers.forEach(function (subscriber) {
            try {
              subscriber.onInteractionTraced(interaction);
            } catch (error) {
              if (!didCatchError) {
                didCatchError = true;
                caughtError = error;
              }
            }
          });

          if (didCatchError) {
            throw caughtError;
          }
        }

        function onInteractionScheduledWorkCompleted(interaction) {
          var didCatchError = false;
          var caughtError = null;
          subscribers.forEach(function (subscriber) {
            try {
              subscriber.onInteractionScheduledWorkCompleted(interaction);
            } catch (error) {
              if (!didCatchError) {
                didCatchError = true;
                caughtError = error;
              }
            }
          });

          if (didCatchError) {
            throw caughtError;
          }
        }

        function onWorkScheduled(interactions, threadID) {
          var didCatchError = false;
          var caughtError = null;
          subscribers.forEach(function (subscriber) {
            try {
              subscriber.onWorkScheduled(interactions, threadID);
            } catch (error) {
              if (!didCatchError) {
                didCatchError = true;
                caughtError = error;
              }
            }
          });

          if (didCatchError) {
            throw caughtError;
          }
        }

        function onWorkStarted(interactions, threadID) {
          var didCatchError = false;
          var caughtError = null;
          subscribers.forEach(function (subscriber) {
            try {
              subscriber.onWorkStarted(interactions, threadID);
            } catch (error) {
              if (!didCatchError) {
                didCatchError = true;
                caughtError = error;
              }
            }
          });

          if (didCatchError) {
            throw caughtError;
          }
        }

        function onWorkStopped(interactions, threadID) {
          var didCatchError = false;
          var caughtError = null;
          subscribers.forEach(function (subscriber) {
            try {
              subscriber.onWorkStopped(interactions, threadID);
            } catch (error) {
              if (!didCatchError) {
                didCatchError = true;
                caughtError = error;
              }
            }
          });

          if (didCatchError) {
            throw caughtError;
          }
        }

        function onWorkCanceled(interactions, threadID) {
          var didCatchError = false;
          var caughtError = null;
          subscribers.forEach(function (subscriber) {
            try {
              subscriber.onWorkCanceled(interactions, threadID);
            } catch (error) {
              if (!didCatchError) {
                didCatchError = true;
                caughtError = error;
              }
            }
          });

          if (didCatchError) {
            throw caughtError;
          }
        }

        exports.unstable_clear = unstable_clear;
        exports.unstable_getCurrent = unstable_getCurrent;
        exports.unstable_getThreadID = unstable_getThreadID;
        exports.unstable_subscribe = unstable_subscribe;
        exports.unstable_trace = unstable_trace;
        exports.unstable_unsubscribe = unstable_unsubscribe;
        exports.unstable_wrap = unstable_wrap;
      })();
    }
    /* WEBPACK VAR INJECTION */

  }).call(exports, __webpack_require__(25));
  /***/
},
/* 606 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /** @license React v0.20.2
   * scheduler-tracing.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  var b = 0;
  exports.__interactionsRef = null;
  exports.__subscriberRef = null;

  exports.unstable_clear = function (a) {
    return a();
  };

  exports.unstable_getCurrent = function () {
    return null;
  };

  exports.unstable_getThreadID = function () {
    return ++b;
  };

  exports.unstable_subscribe = function () {};

  exports.unstable_trace = function (a, d, c) {
    return c();
  };

  exports.unstable_unsubscribe = function () {};

  exports.unstable_wrap = function (a) {
    return a;
  };
  /***/

},
/* 607 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (process) {
    /** @license React v0.20.2
    * scheduler.development.js
    *
    * Copyright (c) Facebook, Inc. and its affiliates.
    *
    * This source code is licensed under the MIT license found in the
    * LICENSE file in the root directory of this source tree.
    */
    if (process.env.NODE_ENV !== "production") {
      (function () {
        'use strict';

        var enableSchedulerDebugging = false;
        var enableProfiling = false;

        var _requestHostCallback;

        var requestHostTimeout;
        var cancelHostTimeout;
        var requestPaint;
        var hasPerformanceNow = typeof performance === 'object' && typeof performance.now === 'function';

        if (hasPerformanceNow) {
          var localPerformance = performance;

          exports.unstable_now = function () {
            return localPerformance.now();
          };
        } else {
          var localDate = Date;
          var initialTime = localDate.now();

          exports.unstable_now = function () {
            return localDate.now() - initialTime;
          };
        }

        if ( // If Scheduler runs in a non-DOM environment, it falls back to a naive
        // implementation using setTimeout.
        typeof window === 'undefined' || // Check if MessageChannel is supported, too.
        typeof MessageChannel !== 'function') {
          // If this accidentally gets imported in a non-browser environment, e.g. JavaScriptCore,
          // fallback to a naive implementation.
          var _callback = null;
          var _timeoutID = null;

          var _flushCallback = function _flushCallback() {
            if (_callback !== null) {
              try {
                var currentTime = exports.unstable_now();
                var hasRemainingTime = true;

                _callback(hasRemainingTime, currentTime);

                _callback = null;
              } catch (e) {
                setTimeout(_flushCallback, 0);
                throw e;
              }
            }
          };

          _requestHostCallback = function requestHostCallback(cb) {
            if (_callback !== null) {
              // Protect against re-entrancy.
              setTimeout(_requestHostCallback, 0, cb);
            } else {
              _callback = cb;
              setTimeout(_flushCallback, 0);
            }
          };

          requestHostTimeout = function requestHostTimeout(cb, ms) {
            _timeoutID = setTimeout(cb, ms);
          };

          cancelHostTimeout = function cancelHostTimeout() {
            clearTimeout(_timeoutID);
          };

          exports.unstable_shouldYield = function () {
            return false;
          };

          requestPaint = exports.unstable_forceFrameRate = function () {};
        } else {
          // Capture local references to native APIs, in case a polyfill overrides them.
          var _setTimeout = window.setTimeout;
          var _clearTimeout = window.clearTimeout;

          if (typeof console !== 'undefined') {
            // TODO: Scheduler no longer requires these methods to be polyfilled. But
            // maybe we want to continue warning if they don't exist, to preserve the
            // option to rely on it in the future?
            var requestAnimationFrame = window.requestAnimationFrame;
            var cancelAnimationFrame = window.cancelAnimationFrame;

            if (typeof requestAnimationFrame !== 'function') {
              // Using console['error'] to evade Babel and ESLint
              console['error']("This browser doesn't support requestAnimationFrame. " + 'Make sure that you load a ' + 'polyfill in older browsers. https://reactjs.org/link/react-polyfills');
            }

            if (typeof cancelAnimationFrame !== 'function') {
              // Using console['error'] to evade Babel and ESLint
              console['error']("This browser doesn't support cancelAnimationFrame. " + 'Make sure that you load a ' + 'polyfill in older browsers. https://reactjs.org/link/react-polyfills');
            }
          }

          var isMessageLoopRunning = false;
          var scheduledHostCallback = null;
          var taskTimeoutID = -1; // Scheduler periodically yields in case there is other work on the main
          // thread, like user events. By default, it yields multiple times per frame.
          // It does not attempt to align with frame boundaries, since most tasks don't
          // need to be frame aligned; for those that do, use requestAnimationFrame.

          var yieldInterval = 5;
          var deadline = 0; // TODO: Make this configurable

          {
            // `isInputPending` is not available. Since we have no way of knowing if
            // there's pending input, always yield at the end of the frame.
            exports.unstable_shouldYield = function () {
              return exports.unstable_now() >= deadline;
            }; // Since we yield every frame regardless, `requestPaint` has no effect.


            requestPaint = function requestPaint() {};
          }

          exports.unstable_forceFrameRate = function (fps) {
            if (fps < 0 || fps > 125) {
              // Using console['error'] to evade Babel and ESLint
              console['error']('forceFrameRate takes a positive int between 0 and 125, ' + 'forcing frame rates higher than 125 fps is not supported');
              return;
            }

            if (fps > 0) {
              yieldInterval = Math.floor(1000 / fps);
            } else {
              // reset the framerate
              yieldInterval = 5;
            }
          };

          var performWorkUntilDeadline = function performWorkUntilDeadline() {
            if (scheduledHostCallback !== null) {
              var currentTime = exports.unstable_now(); // Yield after `yieldInterval` ms, regardless of where we are in the vsync
              // cycle. This means there's always time remaining at the beginning of
              // the message event.

              deadline = currentTime + yieldInterval;
              var hasTimeRemaining = true;

              try {
                var hasMoreWork = scheduledHostCallback(hasTimeRemaining, currentTime);

                if (!hasMoreWork) {
                  isMessageLoopRunning = false;
                  scheduledHostCallback = null;
                } else {
                  // If there's more work, schedule the next message event at the end
                  // of the preceding one.
                  port.postMessage(null);
                }
              } catch (error) {
                // If a scheduler task throws, exit the current browser task so the
                // error can be observed.
                port.postMessage(null);
                throw error;
              }
            } else {
              isMessageLoopRunning = false;
            } // Yielding to the browser will give it a chance to paint, so we can

          };

          var channel = new MessageChannel();
          var port = channel.port2;
          channel.port1.onmessage = performWorkUntilDeadline;

          _requestHostCallback = function _requestHostCallback(callback) {
            scheduledHostCallback = callback;

            if (!isMessageLoopRunning) {
              isMessageLoopRunning = true;
              port.postMessage(null);
            }
          };

          requestHostTimeout = function requestHostTimeout(callback, ms) {
            taskTimeoutID = _setTimeout(function () {
              callback(exports.unstable_now());
            }, ms);
          };

          cancelHostTimeout = function cancelHostTimeout() {
            _clearTimeout(taskTimeoutID);

            taskTimeoutID = -1;
          };
        }

        function push(heap, node) {
          var index = heap.length;
          heap.push(node);
          siftUp(heap, node, index);
        }

        function peek(heap) {
          var first = heap[0];
          return first === undefined ? null : first;
        }

        function pop(heap) {
          var first = heap[0];

          if (first !== undefined) {
            var last = heap.pop();

            if (last !== first) {
              heap[0] = last;
              siftDown(heap, last, 0);
            }

            return first;
          } else {
            return null;
          }
        }

        function siftUp(heap, node, i) {
          var index = i;

          while (true) {
            var parentIndex = index - 1 >>> 1;
            var parent = heap[parentIndex];

            if (parent !== undefined && compare(parent, node) > 0) {
              // The parent is larger. Swap positions.
              heap[parentIndex] = node;
              heap[index] = parent;
              index = parentIndex;
            } else {
              // The parent is smaller. Exit.
              return;
            }
          }
        }

        function siftDown(heap, node, i) {
          var index = i;
          var length = heap.length;

          while (index < length) {
            var leftIndex = (index + 1) * 2 - 1;
            var left = heap[leftIndex];
            var rightIndex = leftIndex + 1;
            var right = heap[rightIndex]; // If the left or right node is smaller, swap with the smaller of those.

            if (left !== undefined && compare(left, node) < 0) {
              if (right !== undefined && compare(right, left) < 0) {
                heap[index] = right;
                heap[rightIndex] = node;
                index = rightIndex;
              } else {
                heap[index] = left;
                heap[leftIndex] = node;
                index = leftIndex;
              }
            } else if (right !== undefined && compare(right, node) < 0) {
              heap[index] = right;
              heap[rightIndex] = node;
              index = rightIndex;
            } else {
              // Neither child is smaller. Exit.
              return;
            }
          }
        }

        function compare(a, b) {
          // Compare sort index first, then task id.
          var diff = a.sortIndex - b.sortIndex;
          return diff !== 0 ? diff : a.id - b.id;
        } // TODO: Use symbols?


        var ImmediatePriority = 1;
        var UserBlockingPriority = 2;
        var NormalPriority = 3;
        var LowPriority = 4;
        var IdlePriority = 5;

        function markTaskErrored(task, ms) {}
        /* eslint-disable no-var */
        // Math.pow(2, 30) - 1
        // 0b111111111111111111111111111111


        var maxSigned31BitInt = 1073741823; // Times out immediately

        var IMMEDIATE_PRIORITY_TIMEOUT = -1; // Eventually times out

        var USER_BLOCKING_PRIORITY_TIMEOUT = 250;
        var NORMAL_PRIORITY_TIMEOUT = 5000;
        var LOW_PRIORITY_TIMEOUT = 10000; // Never times out

        var IDLE_PRIORITY_TIMEOUT = maxSigned31BitInt; // Tasks are stored on a min heap

        var taskQueue = [];
        var timerQueue = []; // Incrementing id counter. Used to maintain insertion order.

        var taskIdCounter = 1; // Pausing the scheduler is useful for debugging.

        var currentTask = null;
        var currentPriorityLevel = NormalPriority; // This is set while performing work, to prevent re-entrancy.

        var isPerformingWork = false;
        var isHostCallbackScheduled = false;
        var isHostTimeoutScheduled = false;

        function advanceTimers(currentTime) {
          // Check for tasks that are no longer delayed and add them to the queue.
          var timer = peek(timerQueue);

          while (timer !== null) {
            if (timer.callback === null) {
              // Timer was cancelled.
              pop(timerQueue);
            } else if (timer.startTime <= currentTime) {
              // Timer fired. Transfer to the task queue.
              pop(timerQueue);
              timer.sortIndex = timer.expirationTime;
              push(taskQueue, timer);
            } else {
              // Remaining timers are pending.
              return;
            }

            timer = peek(timerQueue);
          }
        }

        function handleTimeout(currentTime) {
          isHostTimeoutScheduled = false;
          advanceTimers(currentTime);

          if (!isHostCallbackScheduled) {
            if (peek(taskQueue) !== null) {
              isHostCallbackScheduled = true;

              _requestHostCallback(flushWork);
            } else {
              var firstTimer = peek(timerQueue);

              if (firstTimer !== null) {
                requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
              }
            }
          }
        }

        function flushWork(hasTimeRemaining, initialTime) {
          isHostCallbackScheduled = false;

          if (isHostTimeoutScheduled) {
            // We scheduled a timeout but it's no longer needed. Cancel it.
            isHostTimeoutScheduled = false;
            cancelHostTimeout();
          }

          isPerformingWork = true;
          var previousPriorityLevel = currentPriorityLevel;

          try {
            if (enableProfiling) {
              try {
                return workLoop(hasTimeRemaining, initialTime);
              } catch (error) {
                if (currentTask !== null) {
                  var currentTime = exports.unstable_now();
                  markTaskErrored(currentTask, currentTime);
                  currentTask.isQueued = false;
                }

                throw error;
              }
            } else {
              // No catch in prod code path.
              return workLoop(hasTimeRemaining, initialTime);
            }
          } finally {
            currentTask = null;
            currentPriorityLevel = previousPriorityLevel;
            isPerformingWork = false;
          }
        }

        function workLoop(hasTimeRemaining, initialTime) {
          var currentTime = initialTime;
          advanceTimers(currentTime);
          currentTask = peek(taskQueue);

          while (currentTask !== null && !enableSchedulerDebugging) {
            if (currentTask.expirationTime > currentTime && (!hasTimeRemaining || exports.unstable_shouldYield())) {
              // This currentTask hasn't expired, and we've reached the deadline.
              break;
            }

            var callback = currentTask.callback;

            if (typeof callback === 'function') {
              currentTask.callback = null;
              currentPriorityLevel = currentTask.priorityLevel;
              var didUserCallbackTimeout = currentTask.expirationTime <= currentTime;
              var continuationCallback = callback(didUserCallbackTimeout);
              currentTime = exports.unstable_now();

              if (typeof continuationCallback === 'function') {
                currentTask.callback = continuationCallback;
              } else {
                if (currentTask === peek(taskQueue)) {
                  pop(taskQueue);
                }
              }

              advanceTimers(currentTime);
            } else {
              pop(taskQueue);
            }

            currentTask = peek(taskQueue);
          } // Return whether there's additional work


          if (currentTask !== null) {
            return true;
          } else {
            var firstTimer = peek(timerQueue);

            if (firstTimer !== null) {
              requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
            }

            return false;
          }
        }

        function unstable_runWithPriority(priorityLevel, eventHandler) {
          switch (priorityLevel) {
            case ImmediatePriority:
            case UserBlockingPriority:
            case NormalPriority:
            case LowPriority:
            case IdlePriority:
              break;

            default:
              priorityLevel = NormalPriority;
          }

          var previousPriorityLevel = currentPriorityLevel;
          currentPriorityLevel = priorityLevel;

          try {
            return eventHandler();
          } finally {
            currentPriorityLevel = previousPriorityLevel;
          }
        }

        function unstable_next(eventHandler) {
          var priorityLevel;

          switch (currentPriorityLevel) {
            case ImmediatePriority:
            case UserBlockingPriority:
            case NormalPriority:
              // Shift down to normal priority
              priorityLevel = NormalPriority;
              break;

            default:
              // Anything lower than normal priority should remain at the current level.
              priorityLevel = currentPriorityLevel;
              break;
          }

          var previousPriorityLevel = currentPriorityLevel;
          currentPriorityLevel = priorityLevel;

          try {
            return eventHandler();
          } finally {
            currentPriorityLevel = previousPriorityLevel;
          }
        }

        function unstable_wrapCallback(callback) {
          var parentPriorityLevel = currentPriorityLevel;
          return function () {
            // This is a fork of runWithPriority, inlined for performance.
            var previousPriorityLevel = currentPriorityLevel;
            currentPriorityLevel = parentPriorityLevel;

            try {
              return callback.apply(this, arguments);
            } finally {
              currentPriorityLevel = previousPriorityLevel;
            }
          };
        }

        function unstable_scheduleCallback(priorityLevel, callback, options) {
          var currentTime = exports.unstable_now();
          var startTime;

          if (typeof options === 'object' && options !== null) {
            var delay = options.delay;

            if (typeof delay === 'number' && delay > 0) {
              startTime = currentTime + delay;
            } else {
              startTime = currentTime;
            }
          } else {
            startTime = currentTime;
          }

          var timeout;

          switch (priorityLevel) {
            case ImmediatePriority:
              timeout = IMMEDIATE_PRIORITY_TIMEOUT;
              break;

            case UserBlockingPriority:
              timeout = USER_BLOCKING_PRIORITY_TIMEOUT;
              break;

            case IdlePriority:
              timeout = IDLE_PRIORITY_TIMEOUT;
              break;

            case LowPriority:
              timeout = LOW_PRIORITY_TIMEOUT;
              break;

            case NormalPriority:
            default:
              timeout = NORMAL_PRIORITY_TIMEOUT;
              break;
          }

          var expirationTime = startTime + timeout;
          var newTask = {
            id: taskIdCounter++,
            callback: callback,
            priorityLevel: priorityLevel,
            startTime: startTime,
            expirationTime: expirationTime,
            sortIndex: -1
          };

          if (startTime > currentTime) {
            // This is a delayed task.
            newTask.sortIndex = startTime;
            push(timerQueue, newTask);

            if (peek(taskQueue) === null && newTask === peek(timerQueue)) {
              // All tasks are delayed, and this is the task with the earliest delay.
              if (isHostTimeoutScheduled) {
                // Cancel an existing timeout.
                cancelHostTimeout();
              } else {
                isHostTimeoutScheduled = true;
              } // Schedule a timeout.


              requestHostTimeout(handleTimeout, startTime - currentTime);
            }
          } else {
            newTask.sortIndex = expirationTime;
            push(taskQueue, newTask); // wait until the next time we yield.

            if (!isHostCallbackScheduled && !isPerformingWork) {
              isHostCallbackScheduled = true;

              _requestHostCallback(flushWork);
            }
          }

          return newTask;
        }

        function unstable_pauseExecution() {}

        function unstable_continueExecution() {
          if (!isHostCallbackScheduled && !isPerformingWork) {
            isHostCallbackScheduled = true;

            _requestHostCallback(flushWork);
          }
        }

        function unstable_getFirstCallbackNode() {
          return peek(taskQueue);
        }

        function unstable_cancelCallback(task) {
          // remove from the queue because you can't remove arbitrary nodes from an
          // array based heap, only the first one.)
          task.callback = null;
        }

        function unstable_getCurrentPriorityLevel() {
          return currentPriorityLevel;
        }

        var unstable_requestPaint = requestPaint;
        var unstable_Profiling = null;
        exports.unstable_IdlePriority = IdlePriority;
        exports.unstable_ImmediatePriority = ImmediatePriority;
        exports.unstable_LowPriority = LowPriority;
        exports.unstable_NormalPriority = NormalPriority;
        exports.unstable_Profiling = unstable_Profiling;
        exports.unstable_UserBlockingPriority = UserBlockingPriority;
        exports.unstable_cancelCallback = unstable_cancelCallback;
        exports.unstable_continueExecution = unstable_continueExecution;
        exports.unstable_getCurrentPriorityLevel = unstable_getCurrentPriorityLevel;
        exports.unstable_getFirstCallbackNode = unstable_getFirstCallbackNode;
        exports.unstable_next = unstable_next;
        exports.unstable_pauseExecution = unstable_pauseExecution;
        exports.unstable_requestPaint = unstable_requestPaint;
        exports.unstable_runWithPriority = unstable_runWithPriority;
        exports.unstable_scheduleCallback = unstable_scheduleCallback;
        exports.unstable_wrapCallback = unstable_wrapCallback;
      })();
    }
    /* WEBPACK VAR INJECTION */

  }).call(exports, __webpack_require__(25));
  /***/
},
/* 608 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /** @license React v0.20.2
   * scheduler.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  var _f, g, h, k;

  if ("object" === typeof performance && "function" === typeof performance.now) {
    var l = performance;

    exports.unstable_now = function () {
      return l.now();
    };
  } else {
    var p = Date,
        q = p.now();

    exports.unstable_now = function () {
      return p.now() - q;
    };
  }

  if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var t = null,
        u = null,
        w = function w() {
      if (null !== t) try {
        var a = exports.unstable_now();
        t(!0, a);
        t = null;
      } catch (b) {
        throw setTimeout(w, 0), b;
      }
    };

    _f = function f(a) {
      null !== t ? setTimeout(_f, 0, a) : (t = a, setTimeout(w, 0));
    };

    g = function g(a, b) {
      u = setTimeout(a, b);
    };

    h = function h() {
      clearTimeout(u);
    };

    exports.unstable_shouldYield = function () {
      return !1;
    };

    k = exports.unstable_forceFrameRate = function () {};
  } else {
    var x = window.setTimeout,
        y = window.clearTimeout;

    if ("undefined" !== typeof console) {
      var z = window.cancelAnimationFrame;
      "function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
      "function" !== typeof z && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
    }

    var A = !1,
        B = null,
        C = -1,
        D = 5,
        E = 0;

    exports.unstable_shouldYield = function () {
      return exports.unstable_now() >= E;
    };

    k = function k() {};

    exports.unstable_forceFrameRate = function (a) {
      0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : D = 0 < a ? Math.floor(1E3 / a) : 5;
    };

    var F = new MessageChannel(),
        G = F.port2;

    F.port1.onmessage = function () {
      if (null !== B) {
        var a = exports.unstable_now();
        E = a + D;

        try {
          B(!0, a) ? G.postMessage(null) : (A = !1, B = null);
        } catch (b) {
          throw G.postMessage(null), b;
        }
      } else A = !1;
    };

    _f = function _f(a) {
      B = a;
      A || (A = !0, G.postMessage(null));
    };

    g = function g(a, b) {
      C = x(function () {
        a(exports.unstable_now());
      }, b);
    };

    h = function h() {
      y(C);
      C = -1;
    };
  }

  function H(a, b) {
    var c = a.length;
    a.push(b);

    a: for (;;) {
      var d = c - 1 >>> 1,
          e = a[d];
      if (void 0 !== e && 0 < I(e, b)) a[d] = b, a[c] = e, c = d;else break a;
    }
  }

  function J(a) {
    a = a[0];
    return void 0 === a ? null : a;
  }

  function K(a) {
    var b = a[0];

    if (void 0 !== b) {
      var c = a.pop();

      if (c !== b) {
        a[0] = c;

        a: for (var d = 0, e = a.length; d < e;) {
          var m = 2 * (d + 1) - 1,
              n = a[m],
              v = m + 1,
              r = a[v];
          if (void 0 !== n && 0 > I(n, c)) void 0 !== r && 0 > I(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);else if (void 0 !== r && 0 > I(r, c)) a[d] = r, a[v] = c, d = v;else break a;
        }
      }

      return b;
    }

    return null;
  }

  function I(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
  }

  var L = [],
      M = [],
      N = 1,
      O = null,
      P = 3,
      Q = !1,
      R = !1,
      S = !1;

  function T(a) {
    for (var b = J(M); null !== b;) {
      if (null === b.callback) K(M);else if (b.startTime <= a) K(M), b.sortIndex = b.expirationTime, H(L, b);else break;
      b = J(M);
    }
  }

  function U(a) {
    S = !1;
    T(a);
    if (!R) if (null !== J(L)) R = !0, _f(V);else {
      var b = J(M);
      null !== b && g(U, b.startTime - a);
    }
  }

  function V(a, b) {
    R = !1;
    S && (S = !1, h());
    Q = !0;
    var c = P;

    try {
      T(b);

      for (O = J(L); null !== O && (!(O.expirationTime > b) || a && !exports.unstable_shouldYield());) {
        var d = O.callback;

        if ("function" === typeof d) {
          O.callback = null;
          P = O.priorityLevel;
          var e = d(O.expirationTime <= b);
          b = exports.unstable_now();
          "function" === typeof e ? O.callback = e : O === J(L) && K(L);
          T(b);
        } else K(L);

        O = J(L);
      }

      if (null !== O) var m = !0;else {
        var n = J(M);
        null !== n && g(U, n.startTime - b);
        m = !1;
      }
      return m;
    } finally {
      O = null, P = c, Q = !1;
    }
  }

  var W = k;
  exports.unstable_IdlePriority = 5;
  exports.unstable_ImmediatePriority = 1;
  exports.unstable_LowPriority = 4;
  exports.unstable_NormalPriority = 3;
  exports.unstable_Profiling = null;
  exports.unstable_UserBlockingPriority = 2;

  exports.unstable_cancelCallback = function (a) {
    a.callback = null;
  };

  exports.unstable_continueExecution = function () {
    R || Q || (R = !0, _f(V));
  };

  exports.unstable_getCurrentPriorityLevel = function () {
    return P;
  };

  exports.unstable_getFirstCallbackNode = function () {
    return J(L);
  };

  exports.unstable_next = function (a) {
    switch (P) {
      case 1:
      case 2:
      case 3:
        var b = 3;
        break;

      default:
        b = P;
    }

    var c = P;
    P = b;

    try {
      return a();
    } finally {
      P = c;
    }
  };

  exports.unstable_pauseExecution = function () {};

  exports.unstable_requestPaint = W;

  exports.unstable_runWithPriority = function (a, b) {
    switch (a) {
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
        break;

      default:
        a = 3;
    }

    var c = P;
    P = a;

    try {
      return b();
    } finally {
      P = c;
    }
  };

  exports.unstable_scheduleCallback = function (a, b, c) {
    var d = exports.unstable_now();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;

    switch (a) {
      case 1:
        var e = -1;
        break;

      case 2:
        e = 250;
        break;

      case 5:
        e = 1073741823;
        break;

      case 4:
        e = 1E4;
        break;

      default:
        e = 5E3;
    }

    e = c + e;
    a = {
      id: N++,
      callback: b,
      priorityLevel: a,
      startTime: c,
      expirationTime: e,
      sortIndex: -1
    };
    c > d ? (a.sortIndex = c, H(M, a), null === J(L) && a === J(M) && (S ? h() : S = !0, g(U, c - d))) : (a.sortIndex = e, H(L, a), R || Q || (R = !0, _f(V)));
    return a;
  };

  exports.unstable_wrapCallback = function (a) {
    var b = P;
    return function () {
      var c = P;
      P = b;

      try {
        return a.apply(this, arguments);
      } finally {
        P = c;
      }
    };
  };
  /***/

},
/* 609 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (process) {
    if (process.env.NODE_ENV === 'production') {
      module.exports = __webpack_require__(606);
    } else {
      module.exports = __webpack_require__(605);
    }
    /* WEBPACK VAR INJECTION */

  }).call(exports, __webpack_require__(25));
  /***/
},
/* 610 */

/***/
function (module, exports) {
  module.exports = require("debounce");
  /***/
},
/* 611 */

/***/
function (module, exports) {
  module.exports = require("react-router-dom");
  /***/
}
/******/
]);